var activationEmails = [
    {
    "email":"planet@plansol.it",
    "url di attivazione":"https://verdissima.it/account/activate/8419108716825/319f20d04944a35a1886d947ad656e88-1730301118"
  },
  {
    "email":"e.luppi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194323322/67f88486f0e6a4e85f70d9dc35ef9b38-1730301118"
  },
  {
    "email":"g.galesi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194290554/330a1e051c43ad09ff77f97a4ac4ad11-1730301118"
  },
  {
    "email":"testcli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/8419281535257/997a4215f4470c5a01e8b0d16e288fbd-1730301118"
  },
  {
    "email":"monica.gori@pfizer.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194356090/854d206652b48c47c0d5240fe4458639-1730301118"
  },
  {
    "email":"elena.ferrari133@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194421626/7db0408217de47cbcad0738e2365bea7-1730301118"
  },
  {
    "email":"am.battista@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194388858/a293292c95ad8265995d696d8f7bfd19-1730301118"
  },
  {
    "email":"cinziauzzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194454394/fbfcde1b6c8096e6cb7ea66ecc88f710-1730301118"
  },
  {
    "email":"edy.baldi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194552698/d9f127bb9c1665eb49975bda52e7f8d7-1730301118"
  },
  {
    "email":"bertisilvia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194585466/0d5c3cfbd9d95bc97a4d6cc6716ac489-1730301118"
  },
  {
    "email":"francesca.greco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194487162/86edbc7c3541bad28c6604b36d557c7e-1730301118"
  },
  {
    "email":"alessandraantonelli21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194683770/94a405f8c2f5a06007585b4cbd5a4a75-1730301119"
  },
  {
    "email":"alice.online@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194651002/66d6a9eb56e52671083b6818751e3f62-1730301119"
  },
  {
    "email":"katia.gamba@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194716538/97f4836c786ad6598ea0eace237f2b9d-1730301119"
  },
  {
    "email":"sandra.marinucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194618234/46361ded2ff3fb6cb6f96133bf3d3c98-1730301119"
  },
  {
    "email":"emanuela.nizzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194814842/9e70ef19b727aae793ce7c845ba5af71-1730301119"
  },
  {
    "email":"sonia.scarpetti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194847610/92cabf722ea700e4d651d77b68ece761-1730301119"
  },
  {
    "email":"filli.pagano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194782074/42b1d60c18fe884ddc9f3dad02fff7c9-1730301119"
  },
  {
    "email":"annaberna02@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723194880378/5db4bf4925b59ddef4cfcab16bed54dc-1730301119"
  },
  {
    "email":"bg67vi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194749306/e6d6d455b968c773f42ac253c22e5ba7-1730301119"
  },
  {
    "email":"pamela_1982@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195076986/72bf4b64a29b964b425ff7beeaccb833-1730301119"
  },
  {
    "email":"sara.garbugli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723194913146/89908b17d7fbbeaea997eba16d0ccd6f-1730301119"
  },
  {
    "email":"carlo.benzo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195109754/20386bf90177a347b898f2ce01238b88-1730301119"
  },
  {
    "email":"dicintiomariaantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195142522/d286a6ea2b0353c492ff4ac8a6392a00-1730301119"
  },
  {
    "email":"valeryold@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195175290/19bd7eddcd9a5afd53c344081a660817-1730301120"
  },
  {
    "email":"vania.tella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195208058/133071688ea474f83a34dbef7998cd49-1730301120"
  },
  {
    "email":"michela_millo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195273594/50c3922d02e6a0be446a080ac2f38fdb-1730301120"
  },
  {
    "email":"newgeneration77@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195240826/0a345b074b322c4cf4f24ea00ded9a32-1730301120"
  },
  {
    "email":"ramona.tonozzi9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195306362/3d31206c6f2122f6018201484d78f987-1730301120"
  },
  {
    "email":"falconel@illy.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195371898/d48ff0ce1b93ea469f4dd15a1818d168-1730301120"
  },
  {
    "email":"raffaella.pink@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195470202/1634aaa78104d1fe2af505194ddf1d32-1730301120"
  },
  {
    "email":"piera.taverna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195535738/a3dff623b6795154fe70ea7bf4668d26-1730301120"
  },
  {
    "email":"mabel55@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195502970/0cfccdf27a4114eea43755304af97959-1730301120"
  },
  {
    "email":"elenaponzetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195568506/fbd489db00addfde5834049172775eb1-1730301121"
  },
  {
    "email":"mtpetrarulo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195634042/cad4cb77781f692f19f6df5f764113bb-1730301121"
  },
  {
    "email":"sandra.brescancin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195699578/c1a38ff05ed23f7b2f141f9169e90a66-1730301121"
  },
  {
    "email":"spillo.bc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195666810/95b235f5fedfb33f7d618732137165d0-1730301121"
  },
  {
    "email":"ale.bonanni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195797882/bb026ceedb4fa6fe6dedaf4b734f3850-1730301121"
  },
  {
    "email":"patrizia.tombini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195830650/6773a570cf28a88f0570b90898908a17-1730301121"
  },
  {
    "email":"birgit.fuehres@dekotrend.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195765114/2bc0eb6a971395ee531c386576c06aed-1730301121"
  },
  {
    "email":"ele.perno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195863418/48da1dcc839a1c99b16e4dd2dbc100ec-1730301121"
  },
  {
    "email":"s.calosso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195928954/565241370472f9ab9dbbe3d4026c173d-1730301121"
  },
  {
    "email":"motina.sm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723195896186/4158fc16a13d7a56a12b27b84e6d2e08-1730301121"
  },
  {
    "email":"l.luconi@technores.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196060026/2668496ed59fb88309765303220c318c-1730301122"
  },
  {
    "email":"levchina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196092794/9d8de7ffb3d12d784374be0686970382-1730301122"
  },
  {
    "email":"esposito.mrosaria@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195994490/73189be0a0195d183dcd3b8ac6aa2084-1730301122"
  },
  {
    "email":"ilaria.ott@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196125562/b0c2981ed09aa9bbd6c0053eaad6c2eb-1730301122"
  },
  {
    "email":"fionamar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723195961722/4898a3f29b903e506e7d0ea130f36f30-1730301122"
  },
  {
    "email":"amministrazione@sinkronia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196158330/8a49a980ccdca25b868524573e6b3afa-1730301122"
  },
  {
    "email":"ssg.silvietta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196289402/cf0d89becd6109ceb263a0a12c3e60cd-1730301122"
  },
  {
    "email":"fragallorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196354938/43831a2bb806ae59717d31beed255520-1730301122"
  },
  {
    "email":"donatella.conte198@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196387706/3ef80aad569821514e5fba4fff78140f-1730301122"
  },
  {
    "email":"almapar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196191098/cb914a06cb7d5874c31f7543016fa6b3-1730301122"
  },
  {
    "email":"miniativa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196453242/66da6452f9536a5d1446ddd50f93fb52-1730301123"
  },
  {
    "email":"fraschito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196584314/da54bd9ca5d1dab28f904f31738adc00-1730301123"
  },
  {
    "email":"rominazanotti8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196486010/a099f015d281674f042c9d509450960b-1730301123"
  },
  {
    "email":"stefaniacarinibettola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196617082/f8002ca2330ed79d14309e6c4daf5da7-1730301123"
  },
  {
    "email":"jessy704@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196649850/0a23dcf66a9aacb0343a9e0eb987e890-1730301123"
  },
  {
    "email":"sala.erika@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196518778/9d8989d8a9356ac5eb923d4faf55f178-1730301123"
  },
  {
    "email":"giovyalfry@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196682618/fbb45bdb1f99f20d3d33c74267adf52b-1730301123"
  },
  {
    "email":"bortolottimass@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196715386/d2d79527d7261bcd5348cbd696dd8ea2-1730301123"
  },
  {
    "email":"dania3.p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196780922/9dd6a1fc2d24d36f0943d4a138c83873-1730301123"
  },
  {
    "email":"mara.mesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196813690/d88bf2be8784771dd66c28a97b16a6c6-1730301123"
  },
  {
    "email":"olga31.vn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196846458/c8378a7237c1552091dc69edc971d907-1730301123"
  },
  {
    "email":"giulia1494@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197010298/a6e4bedd965857b3162c65b14a5514ed-1730301124"
  },
  {
    "email":"marilia.liotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196977530/08f730171e79139120fb7a8433c110c0-1730301124"
  },
  {
    "email":"rossella83dbr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723196944762/e6a4cf6ff5864f85cf379e5dfca30944-1730301124"
  },
  {
    "email":"evkant2005@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723196911994/12735d5f3ba7a00ce6f2f365da6de46e-1730301124"
  },
  {
    "email":"freespirit.925@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197043066/36ea48433015b1cc4bdfa08008ca2f9e-1730301124"
  },
  {
    "email":"test4@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197075834/5f356679533fb29c8e3d5e3c9ebca40d-1730301124"
  },
  {
    "email":"marty.mp88@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197174138/58931b3e5203abd720a758d3406fbd68-1730301124"
  },
  {
    "email":"giorgialbertasilva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197239674/76091efa1ee8496f405998297a43c3b2-1730301124"
  },
  {
    "email":"test2@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197108602/8de0662c11a5ed9c17ce1828fdd14496-1730301125"
  },
  {
    "email":"enlu.lucy@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197206906/c53af55b290d12fed229177564c23fea-1730301125"
  },
  {
    "email":"dimensioneestetica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197305210/a25b1c7dfbe525f2dd1aef6c03a13c0a-1730301125"
  },
  {
    "email":"sergiodil@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197337978/03179e71382d30d0c81245d0ee1157b3-1730301125"
  },
  {
    "email":"perlatisara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197272442/e47e28d2cccc916f5c5f156cb56e6a07-1730301125"
  },
  {
    "email":"salvatori.chiara08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197403514/2b3300306b8c8dbbb620b02693a624ca-1730301125"
  },
  {
    "email":"francescabuglione@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197370746/45b55038cf4767ea4b4baeb856939813-1730301125"
  },
  {
    "email":"katieminu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197436282/ed47399299f84287700888332fa51f8d-1730301125"
  },
  {
    "email":"valentinasarchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197567354/fdeab097ca9895ca8b27b0654c4d9021-1730301125"
  },
  {
    "email":"cobianchi71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197600122/f7e36f10c605578de461e16caf60548e-1730301125"
  },
  {
    "email":"chiara.gianstefani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197632890/bc0c5826f80d0bb0480f8d95d61f97e3-1730301126"
  },
  {
    "email":"panificiobedeschi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197534586/fdd3f1428ce8d649439fc3a7d053d550-1730301126"
  },
  {
    "email":"samantaturini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197665658/d687d7f7f5a0d860d5f95739f8aaf005-1730301126"
  },
  {
    "email":"pepistolina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197698426/f7b9dc0ad954a4d47b3103b2e485fc02-1730301126"
  },
  {
    "email":"pettinicchiopaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197731194/1d2c102ea4a030b9ce88d7f0a59d504c-1730301126"
  },
  {
    "email":"annalisabonavigo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197763962/6ff9376207e0592182a62b975f894709-1730301126"
  },
  {
    "email":"kiky2004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197829498/ef413d6b372f4788b3c9bf61acc39892-1730301126"
  },
  {
    "email":"daniela@petino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723197862266/92be8d172f8b20eddc172e93db00fa25-1730301126"
  },
  {
    "email":"tanchaz@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723197796730/5e299dc87e11530c7b06154a940e9cfb-1730301126"
  },
  {
    "email":"melanie.marschall@hotmail.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723197895034/b5b40808a89a8b07835664bd3f1f6ad8-1730301126"
  },
  {
    "email":"simona.pernici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723197927802/845702d8ba188fc71b305c20d7d53cec-1730301126"
  },
  {
    "email":"francesca_zuliani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198026106/b563f519ff32035000dc9e56ad64ee59-1730301126"
  },
  {
    "email":"melicos@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198091642/90e1534b2d6e1a72775ecd58ec7d43ff-1730301127"
  },
  {
    "email":"annare21@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198124410/9691aff5742cb33313988f476ab82805-1730301127"
  },
  {
    "email":"stefanianegri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198255482/b15b2109fe6e9fc87a8ff39ecf6de7cd-1730301127"
  },
  {
    "email":"katiapupacchiotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198222714/3966d695a0235f103d2b010893737464-1730301127"
  },
  {
    "email":"loredanamorazzano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198321018/a8e3677f127c2d99b7f98f1e61dccc85-1730301127"
  },
  {
    "email":"betty1986@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198288250/0a3772f7460ee557dc3e9a680b94e93d-1730301127"
  },
  {
    "email":"irenepisani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198484858/fa49daa3e630434ea9749b82b439175c-1730301127"
  },
  {
    "email":"dott.vanni@studiocanalepetrucci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198386554/adb6cfef5b8b4016ed2dfdc40663b8ca-1730301128"
  },
  {
    "email":"elenac.delcarlo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198452090/121c7f5b85599f2c43a58ce83e69dfec-1730301128"
  },
  {
    "email":"alunni.cinzia18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198419322/1d77b95269c59dce1672cdc22cf4d546-1730301128"
  },
  {
    "email":"rita.castronovo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198583162/6d33f7b74c643967e0ddbc421b2a33b1-1730301128"
  },
  {
    "email":"michela.gallina@elcomleno.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198550394/714803705031e25aa00d2e1af41df1ba-1730301128"
  },
  {
    "email":"alf1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198615930/131df6a4369d25580cee1c1fb3f39f21-1730301128"
  },
  {
    "email":"barbara.rita.gaudio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198648698/69d6fa1479d63333c16411c7bb00db0e-1730301128"
  },
  {
    "email":"neapolisara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198714234/a50ad51f5feab7232d716fb92d22816f-1730301128"
  },
  {
    "email":"coralbadegiorgi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198747002/270a3db1d9c1afb3cb0794752f5d47be-1730301128"
  },
  {
    "email":"s_potenziani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198779770/8128ca56bcc2d815e55646810ed36ad8-1730301129"
  },
  {
    "email":"brichettigiulia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198878074/bdbd73c83fc326943624593b4672cacd-1730301129"
  },
  {
    "email":"illary.t@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198910842/4f53315c8079e48db7cf8d9291067a83-1730301129"
  },
  {
    "email":"xvaleriasassux@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198812538/25f22061b6eaa63d472da2408897d7f9-1730301129"
  },
  {
    "email":"stefy.stocco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723198943610/1d0d73e77c313cd070e6a4dd81247e89-1730301129"
  },
  {
    "email":"priv.barbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199009146/8fcd3344aa503e4837ac8fb36012748b-1730301131"
  },
  {
    "email":"aidni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723198976378/a77f6c9633991c3f793427c2caddb1f1-1730301131"
  },
  {
    "email":"fedecaselli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199074682/37d9ff0f44b763773975d497fd1efbec-1730301131"
  },
  {
    "email":"trillyna_88@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199041914/427bee95ebc40510df24431c9478e5af-1730301131"
  },
  {
    "email":"nivesamu01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199172986/085d423c6d2e110f0dba5fbcf504a5cb-1730301131"
  },
  {
    "email":"milena.dazio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199107450/17b3808d7d29714fea257c56584ed938-1730301131"
  },
  {
    "email":"francesca.bonizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199140218/a7070c027594a2b1608d6c5e5017021e-1730301131"
  },
  {
    "email":"sgoretti.sg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199304058/04948df1a9e08dce380774e14059d49e-1730301131"
  },
  {
    "email":"cecilia.devoto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199271290/9e63d9f002fd21de08385f2abe3962db-1730301131"
  },
  {
    "email":"brunacarbellano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199205754/0811b88d5d1b657b6429b50e3466c295-1730301131"
  },
  {
    "email":"paoladigio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199369594/6e2389dbfd4cde9816678cfe0c0c8dff-1730301132"
  },
  {
    "email":"barbara.rubele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199402362/5267b0f42f25f11445a01f2376805c3c-1730301132"
  },
  {
    "email":"federica.carletti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199435130/c8acb3cd010ede661483a3724c616865-1730301132"
  },
  {
    "email":"claudialov_86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199467898/b267befbacd782362f9f6c6f5ad13c52-1730301132"
  },
  {
    "email":"loredananardini@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199500666/a4a4b1a1665d1f2fd0eb1aa43c06c98a-1730301132"
  },
  {
    "email":"annalisa.bernardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199533434/f62f429916e4a350e2ea4504abc369da-1730301132"
  },
  {
    "email":"lorenza.vacchetto@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199336826/19ca0ffe44ebd3d83a077b22f53b7bc2-1730301132"
  },
  {
    "email":"francesca.bolzonetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199631738/983a12cee9f98b205b88207645c0cca2-1730301132"
  },
  {
    "email":"caterina.b78@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199566202/773ae97de7f8671122cb38d5188025df-1730301132"
  },
  {
    "email":"elena.inama@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199664506/79bf0ae59dc3cef49270001474717f54-1730301132"
  },
  {
    "email":"gretavignoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199730042/51d9c50bb0f268ceb03b9f6e666dd348-1730301132"
  },
  {
    "email":"spaltini.f@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199762810/7db46ef94184333727b2fcd75237f780-1730301132"
  },
  {
    "email":"lbagioni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199697274/26efc8b76e677b90d079c81ade7ea56a-1730301133"
  },
  {
    "email":"mariascigliano90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199828346/36a42457ecafeb4cbc887a9765ff074d-1730301133"
  },
  {
    "email":"cecy.cipri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199795578/2fbc1a550663757c06828e5175b3f449-1730301133"
  },
  {
    "email":"birgit.busse@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199893882/37c5be6babccc262b0becbd2afe603f7-1730301133"
  },
  {
    "email":"coffeedj@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199861114/864137f3f41354ff797a55f7d41aaca1-1730301133"
  },
  {
    "email":"samantha.lavigna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199926650/4bd4fd9f9ea7621ba2ad787599f124db-1730301133"
  },
  {
    "email":"livia.benelli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723199959418/2b4927eafa90ec743457691c8ef167b5-1730301133"
  },
  {
    "email":"elena.sciarretta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200057722/36da4eb51dbe446a7b29878631171a1a-1730301133"
  },
  {
    "email":"d.bozzella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200090490/2cafb2717d7682b5a0ba3d67e975d0e2-1730301134"
  },
  {
    "email":"graziellagrignaschi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200024954/2efb3c66e96254c1ccdd00073d923426-1730301134"
  },
  {
    "email":"vittoavanzini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200123258/0418ec2eeea108adde79775d90635982-1730301134"
  },
  {
    "email":"marineruno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723199992186/a9d76634718640f830ebb99b1370371d-1730301134"
  },
  {
    "email":"cristiangrandolini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200156026/daf62e0c17759bcaf87867c9aad2d933-1730301134"
  },
  {
    "email":"catepeccianti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200188794/cb39df3b00d23b647ced9f989fed2999-1730301134"
  },
  {
    "email":"francoanna@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200221562/8d02a8e8d375753a050f00e3d1786289-1730301134"
  },
  {
    "email":"chiarugani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200254330/e467915f5e79bde8933cf10829fa6e8f-1730301134"
  },
  {
    "email":"annadalcanto@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200319866/b502b07d30cb807eedabf488ac7e6015-1730301134"
  },
  {
    "email":"almabiferi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200287098/46359ff0f041c4fa998a3603a833e218-1730301134"
  },
  {
    "email":"tzilibu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200385402/5f7cbc6dffb69b3200d30be3cdbd7f50-1730301134"
  },
  {
    "email":"carmen.signorelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200450938/20fd3e914e26c45bec83fa0b4cef8dff-1730301134"
  },
  {
    "email":"danila_2008@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200418170/22745a7c653e1ace3eea9deb2828d65d-1730301134"
  },
  {
    "email":"vianuova28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200483706/4605eb1a6acfc998cfbd3e0828a59d64-1730301135"
  },
  {
    "email":"bettoni.fra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200549242/bd56b52058b583e0d8d7dcf055687d6c-1730301135"
  },
  {
    "email":"mely.vio.gio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200647546/f085fb4a0240cc320770a724e792eb45-1730301135"
  },
  {
    "email":"nadia.nuovo83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723200680314/a1d44b2b5360594daf6d9ba5d7b581ed-1730301135"
  },
  {
    "email":"okkiverdi2002@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200614778/630ab7a4016d72fb54608fc446db3d94-1730301135"
  },
  {
    "email":"crisgrando@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200582010/a1181bf11d742543a7203a52def35b40-1730301135"
  },
  {
    "email":"mocy93@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200713082/a8ce4684548591395d7a2532dd03f42d-1730301135"
  },
  {
    "email":"ramona.morini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200745850/6d606333ad7c50b1821c8c3fd9616f34-1730301135"
  },
  {
    "email":"elisabetta.rossini@naturwaren.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200811386/4e0f646a8ac8e9dc0ebf130c32408458-1730301136"
  },
  {
    "email":"simona@sidansrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200844154/a7e2291f4b4d14a79cc99d7a521c64b9-1730301136"
  },
  {
    "email":"aledispilimbergo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200876922/493cde7d11860a237607d9d7598195b0-1730301136"
  },
  {
    "email":"l.piotti@studioservicesrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201040762/af219de40ce08b089156869ad2a22b49-1730301136"
  },
  {
    "email":"emy1974@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200909690/fb301b55edc20f40d5768776ffd5c0ea-1730301136"
  },
  {
    "email":"detomi.sandra@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723200778618/f2521c58047033a7e521005e9d77a09f-1730301136"
  },
  {
    "email":"tiziana_simeone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201073530/03117c55d913ff7a71b4b67758a08527-1730301136"
  },
  {
    "email":"isabella.val@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201139066/8b508bada0bcd2e0d767751c616712e9-1730301136"
  },
  {
    "email":"fedetinagli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201171834/82443a4916c16eb36712325d29d7560a-1730301136"
  },
  {
    "email":"gabrypucca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201237370/57b3647103bafe953bfb8b2120498962-1730301136"
  },
  {
    "email":"ltanzel@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201270138/ac789e71d5254c46b0a9a7650186b2ad-1730301136"
  },
  {
    "email":"dani.bertol84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201335674/d55ff3b78898c355b9f2f6c72087729e-1730301136"
  },
  {
    "email":"valery.saibene@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201302906/e1fc1065ee50eb42ccc074b43e1f8aae-1730301136"
  },
  {
    "email":"avv.mcristinafloris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201532282/7d472808fbfa95c124b538723b01f30b-1730301137"
  },
  {
    "email":"archvillari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201433978/4f54624b33f59fcbc99b9e75b6aa8b76-1730301137"
  },
  {
    "email":"katiuscia.rossetti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201630586/8defb5756f845bf7a4ebe646108718d8-1730301137"
  },
  {
    "email":"martapinci@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201499514/10ab28beb44e53168907c648ee314dcc-1730301137"
  },
  {
    "email":"francesca.brusa93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201401210/42a0b530e719dd45b6adb0540cf03493-1730301137"
  },
  {
    "email":"carlaorlandini77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201696122/bae408eebf60c63a24c57119d5625d8f-1730301137"
  },
  {
    "email":"giulia.nini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201728890/8fc54d7138418349af2c336a1a534916-1730301137"
  },
  {
    "email":"cinzia.tesi85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201761658/1ad2a527eaa62278f226ebc6f0654f31-1730301137"
  },
  {
    "email":"romanelli.laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201827194/b69dc80481f47500cc3888a2d0ee53b2-1730301138"
  },
  {
    "email":"maggiandrea57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201794426/e5422bf8f3105e02d82631fd5c69a85a-1730301138"
  },
  {
    "email":"lullogerarda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201892730/8b05ae40a308be2d5ea2b329f435c07d-1730301138"
  },
  {
    "email":"allievilaura@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201991034/8cfebb556193e68a9c4ece895e7e6617-1730301138"
  },
  {
    "email":"gabrielladipietro@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723201859962/8339bd3d9ec30d8933fe1637e5bee35e-1730301138"
  },
  {
    "email":"enzo.giu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202023802/9b17c0feb975d316e81707d660bc5830-1730301138"
  },
  {
    "email":"elisabetta.maranzana@ocmcomunicazioni.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723201925498/6c0d3effb5c7cca7ec249a25082a8021-1730301138"
  },
  {
    "email":"marhja@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202089338/c8a11306b48d16c1a170ff45fcecbc91-1730301138"
  },
  {
    "email":"emg.mail@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202056570/4117ad0394336d184eaefb64021203e8-1730301138"
  },
  {
    "email":"raffapuggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202154874/32fefa95d01bad79e48be297ad56e487-1730301138"
  },
  {
    "email":"f.m.maggi@ut.ee",
    "url di attivazione":"https://verdissima.it/account/activate/22723202122106/5b6eec479cbeab887314cc9b8ada5dc5-1730301138"
  },
  {
    "email":"gabriella.polese@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202187642/196413b0351a492eaa790907a9c42481-1730301138"
  },
  {
    "email":"stefaniamarasco@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202220410/72c34d92aa285d538e4e5dca5c86e3bf-1730301139"
  },
  {
    "email":"intimooertediagatab@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202253178/0fbd1f3179cc7192ebe0dd3c3b325326-1730301139"
  },
  {
    "email":"stefanohd@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202318714/f3e1c10ae5fcb53b697ed630113d152e-1730301139"
  },
  {
    "email":"elena_marzola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202384250/b42971b6dbfdeb29ff2b8dc3268d0081-1730301139"
  },
  {
    "email":"alessia.mascia@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202449786/e9ca9ef7c150ed2d6d7193eb0af23e65-1730301139"
  },
  {
    "email":"cosetta.gaudenzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202285946/a15c1fe69143c1accf0e741dccd63c49-1730301139"
  },
  {
    "email":"nicoletta.tansini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202351482/e1a7abe647039b9caeaeb7387b6486da-1730301139"
  },
  {
    "email":"vidottostefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202548090/9d1eeccdc60a49ab81008ef155294568-1730301139"
  },
  {
    "email":"estetista2011@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202580858/780fc876223dc00dd4a953ac20750891-1730301139"
  },
  {
    "email":"sabrina.landi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202515322/930bb18b74f5c486fab24d09e042ea19-1730301139"
  },
  {
    "email":"elena.delledonne87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202679162/e9f88a4b834c02e0108daeef1a922254-1730301140"
  },
  {
    "email":"elisa_tome@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202646394/5f7001e0f37166e2c43580a7b4fc5b23-1730301140"
  },
  {
    "email":"adri.abbate@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202744698/ec2a7db25003ce0e3edf00b78ca521fa-1730301140"
  },
  {
    "email":"ludovicalaudadio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202711930/f02647283096feeda36f3f15b1a583d7-1730301140"
  },
  {
    "email":"199367@tiscal.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202777466/6125edbbc94f788ef8444e3fa243d7c5-1730301140"
  },
  {
    "email":"donatellarista@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202843002/f7ddec59bf32c8a2e7e399846f477cd9-1730301140"
  },
  {
    "email":"antonellacarrabs67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202875770/5dc42185a7831720cb4b2e2d840f0d4a-1730301140"
  },
  {
    "email":"tanta.danylyuque@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723202810234/1d0afaa6408b15b5ffc8f7c48387be9e-1730301140"
  },
  {
    "email":"katia.parenti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202908538/657ebf3a43d62250d56717b2cfcd034c-1730301140"
  },
  {
    "email":"fra.rog@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202941306/6cc108009ecb2dba1cbafc8614a67cb8-1730301140"
  },
  {
    "email":"raffaellaalberti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203006842/761ed1baaadd6e0028136a0a4ffa8bae-1730301140"
  },
  {
    "email":"lollybell@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723202974074/14129914dfab6570c145b75486556544-1730301140"
  },
  {
    "email":"massimiliano-mariano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203039610/fa53f55eab42df78bcd7c3519b54bb91-1730301141"
  },
  {
    "email":"lastrega46@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203105146/06f50014e8e64c7852d3aa89e1be2930-1730301141"
  },
  {
    "email":"amalia.auriemma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203170682/d61e35a06d26ebebf20deab2d9210ea0-1730301141"
  },
  {
    "email":"rosyfont17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203137914/66aa8be10ac64029404f11beb82c5f76-1730301141"
  },
  {
    "email":"consuelo74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203203450/436e2c53f6dc5e62bc984bc727aa0b9f-1730301141"
  },
  {
    "email":"elisabettab.72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203072378/3d4213555d926e397e710378878c13bb-1730301141"
  },
  {
    "email":"robertopibiri@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203301754/e9cfc61e1d8349e2cec84aa3106efdd2-1730301141"
  },
  {
    "email":"roberta.zanardi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203334522/bf1e153d3ff01aae0f83a35146eb7bd7-1730301141"
  },
  {
    "email":"clarissa.v@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203367290/256d5c28c3f19672c09244d5f4435c9d-1730301141"
  },
  {
    "email":"elisa.donzelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203432826/7d69b6e74c2b19b86c67c5468275c124-1730301141"
  },
  {
    "email":"emmatti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203236218/bc74826360c7707f54e7c95ba6f5735f-1730301142"
  },
  {
    "email":"aricciardulli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203498362/05ae4dbbfbcf18f0e015e4459d2ac564-1730301142"
  },
  {
    "email":"adaadam@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203465594/373860830c59480012630caa2c9a706c-1730301142"
  },
  {
    "email":"mgrazia@pestelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203596666/52b59d4dd171d9b308bcc2586f952fdb-1730301142"
  },
  {
    "email":"verulegge@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203662202/feaafcad1246e340c5cea4bbecba2129-1730301144"
  },
  {
    "email":"roberta.giannoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203694970/1b2c55b1fae8596517d18363078cbd3b-1730301144"
  },
  {
    "email":"cmazzini59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203629434/41308a1fae4de69096293e8ac9c04cf6-1730301144"
  },
  {
    "email":"g_ida@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203727738/ead6e12af6de4168bcb4b6203c228db2-1730301144"
  },
  {
    "email":"g.daddea@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203826042/7285d4506c7f673d70bc87dc70f5025b-1730301144"
  },
  {
    "email":"199367@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203760506/7c5fef0c252c3f0cc19d6e550e8b31b0-1730301144"
  },
  {
    "email":"superrossa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203793274/cd9111287dcfb0abb7d923b3b37b6f07-1730301144"
  },
  {
    "email":"rosannastoico72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203858810/1f48971e4e525fa4bd01b8bb6caf771c-1730301144"
  },
  {
    "email":"sandra@caramoripiante.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203891578/587d20778db4b18bcf3863462dfd02df-1730301144"
  },
  {
    "email":"nannipierisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203924346/950837f3101de2e164caf8a45b41f555-1730301144"
  },
  {
    "email":"sandr@caramoripiante.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723203957114/1d1e9279dd6263eed7826428c7000b95-1730301144"
  },
  {
    "email":"eleonora.moretticpti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723203989882/725f1d6c76ca3ce486a8794868c4f22f-1730301144"
  },
  {
    "email":"mary197710@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204055418/4d308ec5d81c8aafedb921a87d023be6-1730301144"
  },
  {
    "email":"elisabettadentice@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204022650/bb65c7a430afc2de15b8c874a55a3d18-1730301145"
  },
  {
    "email":"papiro.adriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204120954/a062ba607c90de2acc054aded0336072-1730301145"
  },
  {
    "email":"simonarisocaro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204088186/7a9417d17d97b5fea899f12f7c16debc-1730301145"
  },
  {
    "email":"ls.luciasegreto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204186490/f75901d25e7bb73981227cc2be999798-1730301145"
  },
  {
    "email":"francesca.fiorito@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204153722/2a15a55cf06a0d048b57314c031369de-1730301145"
  },
  {
    "email":"gmara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204219258/0aac46bca3e8be02d638d0f53d62aae5-1730301145"
  },
  {
    "email":"roberto@moko.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204252026/577f1868142cf442a3f4a5e22f33f7dd-1730301145"
  },
  {
    "email":"rossin.isabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204383098/f9aaac7e6266301bd419252f718e2946-1730301145"
  },
  {
    "email":"t.francesca71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204415866/691af855e37b4436fef1d35c8d67724b-1730301145"
  },
  {
    "email":"laura@dellaglio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204514170/65b368cb30d22768adb15bd8bdcd91b6-1730301145"
  },
  {
    "email":"carlaingrosso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204448634/0b5ba5de14380e1e4219a63ff6e54ee5-1730301145"
  },
  {
    "email":"arch.bandinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204546938/0898de95de05b483ba2e1d240d2276ec-1730301145"
  },
  {
    "email":"federica.gaetani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204645242/5d3bdbfeab3210a6949ddefeab2bc3ec-1730301146"
  },
  {
    "email":"federica.gaetani@hotamail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204579706/3bd66435f7338d0666d773afbebfd3de-1730301146"
  },
  {
    "email":"andreastefani4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204678010/0ef1a9b7c09a36fbec2ad1f02f1cecfc-1730301146"
  },
  {
    "email":"giusyciampini@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204710778/6f332838d6b210864609ac080ef4acee-1730301146"
  },
  {
    "email":"snigroarch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204776314/38e1a72495642796539b36edeea4422e-1730301146"
  },
  {
    "email":"mirjana.ranchanov@diatecgroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204874618/bf39ab34e4fe1a260f63fc4930507bff-1730301146"
  },
  {
    "email":"smnmno69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204841850/40182b610260694783564c165e8dab44-1730301146"
  },
  {
    "email":"laurademasib@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204907386/bec5142bc2a3c4c59ef74e2dd4f6379a-1730301146"
  },
  {
    "email":"tumistufimarta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723204972922/8b3fe2884891e506746444b94451f86d-1730301147"
  },
  {
    "email":"rosaria722009@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205071226/26698426e16b0a2775eb4af9a05f53a2-1730301147"
  },
  {
    "email":"tatiasciu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205103994/7755fa3a84099d25d887812b3ebde175-1730301147"
  },
  {
    "email":"alidaligioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723204940154/2b2b3506e85003a729c8eda980ba8dc2-1730301147"
  },
  {
    "email":"lauraarati@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205169530/409033e57607ee8d8abc7fb081420a3e-1730301147"
  },
  {
    "email":"cugnettoangela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205136762/336960ee5b0483eb2ee6ab71d933b9d4-1730301147"
  },
  {
    "email":"clericipietro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205202298/b2d8b078be24ad28c10e1a96c1af59c1-1730301147"
  },
  {
    "email":"amministrazione@axchemitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205235066/e14b51e3c22ff5ea81d01277ccd06dc1-1730301147"
  },
  {
    "email":"volpiniemidio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205300602/e924d56bf5c34e141e3e3eee6ee3d008-1730301147"
  },
  {
    "email":"tiziana.pipicella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205366138/0f21eb190695162f3dd2f863526c4248-1730301147"
  },
  {
    "email":"silviasbrogio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205333370/29cd6d622fc4ad829e976caf079c6dd5-1730301147"
  },
  {
    "email":"eleonorik@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205398906/3fd653aa6961abbc500e71b911ccbe42-1730301148"
  },
  {
    "email":"e.flaccavento@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205267834/5eb96e6cf88a84e09d31e101b0231eb0-1730301148"
  },
  {
    "email":"c.guadagnin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205464442/565a6ba8a354ef075e9b27f2bcf1b6ac-1730301148"
  },
  {
    "email":"fabio.abis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205529978/70a4becc68bef0afccf447ab3f554653-1730301148"
  },
  {
    "email":"info@francescaparini.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205595514/6d7fcd79d704c7101f854a46d57499a1-1730301148"
  },
  {
    "email":"cathy77@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205628282/1e41028fabdf05d501e34928a8ac038d-1730301148"
  },
  {
    "email":"trimbolim@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205562746/502cdd9dff449b623930eccb4919b895-1730301148"
  },
  {
    "email":"elettrapugliese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205661050/f614fab74dfe8c52fd8989df370f9121-1730301148"
  },
  {
    "email":"ceciliaschianchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205726586/d80c8608f5e38ddc3005793aa97c67dd-1730301148"
  },
  {
    "email":"pmariarita@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205824890/520d410c5e574910514a6ffb730512a6-1730301149"
  },
  {
    "email":"alessandra.i@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205890426/6ec52aeee2878d5e520a040b8520af50-1730301149"
  },
  {
    "email":"saragoniannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205693818/f7c3d2e5c506e21d7c68763d0a223735-1730301149"
  },
  {
    "email":"deborabranchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205955962/f4bce89e9f5f8c3f4ebdf86870244584-1730301149"
  },
  {
    "email":"simonetta2.roma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723205988730/e7ce9b661159f74755926f8d049d3dcc-1730301149"
  },
  {
    "email":"fortunata.condemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206021498/b08eae8b739c8330b801b595cbf51af0-1730301149"
  },
  {
    "email":"famigliaranieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206087034/de2b0f66a2d9d8dbba5f732e064cb8b4-1730301149"
  },
  {
    "email":"michela.quartu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206054266/011eeffd3e64a60288dd865761eae71e-1730301149"
  },
  {
    "email":"ale@fassi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723205923194/354580214abc7e86f0d22f6873716c21-1730301149"
  },
  {
    "email":"chiara@agriturismobellavista.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206119802/a1ab8a805d89ed95f4dcefc40660c286-1730301149"
  },
  {
    "email":"postaletizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206218106/a78b2d1747ce5825bafd3388b878b86c-1730301149"
  },
  {
    "email":"gioguiotto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206316410/dd929db9a2c75457c7d5c3479de08d1a-1730301150"
  },
  {
    "email":"matte.marini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206283642/17152239cd609f096e76ce16ebe2019c-1730301150"
  },
  {
    "email":"giulialotti79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206349178/585a9cd5ca25ba8568ea7456ec4517da-1730301150"
  },
  {
    "email":"gioguiott@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206185338/ec765d42c05765819042d434e758c6a1-1730301150"
  },
  {
    "email":"ing.emiliabarba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206381946/fcc447e36b807f128f52bdf7fe200864-1730301150"
  },
  {
    "email":"s.bottoni75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206414714/01cbba2d34d443f62d6efa3bc58d4185-1730301150"
  },
  {
    "email":"alessiasimeone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206480250/1d94ebe02bb13f2bf14fd536609719ce-1730301150"
  },
  {
    "email":"donatella.ga75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206447482/bec920c8e787deb25aa6566176db3fc5-1730301150"
  },
  {
    "email":"agapepi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206545786/27cbdf567049d531ef6a7d86a1f4603b-1730301150"
  },
  {
    "email":"darma.waldner@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206644090/bdd82b7b5f065284ebd6f4b7d181ddf9-1730301151"
  },
  {
    "email":"rita_ponzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206513018/550bab29700a2c0ceec849691b91049b-1730301151"
  },
  {
    "email":"maddiebacarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206676858/fb0e63f34448f2b78ba246358f53b7e4-1730301151"
  },
  {
    "email":"gigliolafeliziani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206709626/02cf034848d2dbbc99d590c5f5f04b09-1730301151"
  },
  {
    "email":"lelepap2005@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206807930/4c819688448f1ed769d594f6ad733dfd-1730301151"
  },
  {
    "email":"glory.hutch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206742394/5df9280e3150f85be9cb3bce09e78591-1730301151"
  },
  {
    "email":"laura.crc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206873466/30ed6deebcbce67dae938796014e1058-1730301151"
  },
  {
    "email":"nunzia99@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206906234/7660775dd005d90e69e0dae30fa5ceec-1730301151"
  },
  {
    "email":"daniela1710@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206939002/1323d60b014ce3b4b953b968018c07e0-1730301151"
  },
  {
    "email":"pirisimo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723206971770/82cd676dd483466282bc27c35d661c8e-1730301151"
  },
  {
    "email":"caterinaiannucci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207070074/6310e258b743f01769a96acb77c88dbe-1730301152"
  },
  {
    "email":"feder_chicca@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723206840698/bc686b65affe85f8a456e91c625d4366-1730301152"
  },
  {
    "email":"m.silvia84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207037306/b286c74937dd02c432e49901d37b4a4f-1730301152"
  },
  {
    "email":"asiacri2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207004538/170b77d522790b3a85ecfe707af2d9fe-1730301152"
  },
  {
    "email":"lol.cd@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207102842/27973ca8d39b74141064962a1c38c2e5-1730301152"
  },
  {
    "email":"annanais@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207201146/e6225cbf6647a779001846b930e1217c-1730301152"
  },
  {
    "email":"delisirob@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207135610/7a6574a5c63a30381ea75125fcd0be77-1730301152"
  },
  {
    "email":"cristina.damato75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207168378/118d7d8bddbd79ac7883474b132ab354-1730301152"
  },
  {
    "email":"francesca.click@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207233914/eb0036f6a2d41c8bc1f5b6137eb240c4-1730301153"
  },
  {
    "email":"melchiondadaniela79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207299450/6cc1abc4183a5639431cda66eb3c2590-1730301153"
  },
  {
    "email":"t.margheritatripodi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207266682/aa7a6625e1a901fa73303680e1e6d1b7-1730301153"
  },
  {
    "email":"teresa.uccello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207364986/608e1d4ca95c028094350f92b1313e8f-1730301153"
  },
  {
    "email":"tivals@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207397754/bf064f9dc14f0f7b81145ab2dc5a4601-1730301153"
  },
  {
    "email":"barbarauberti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207332218/8da409973cb847ab6da68a237fcb1c02-1730301153"
  },
  {
    "email":"cabisalvina@riscaldamento.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207496058/62f565a92d435cae4a2da94abdddf206-1730301153"
  },
  {
    "email":"gianninademartis@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207561594/62024a46627c6c1a7fe2dea14bc05f26-1730301153"
  },
  {
    "email":"c.scatassi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207463290/06b78787428a4201acfed198be72ba18-1730301153"
  },
  {
    "email":"amministrazione@taurussages.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207528826/323732aa8f604cfdff9930f60390056b-1730301153"
  },
  {
    "email":"roberto1nunziata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207594362/b978968661a8be752cbb743c29f3b7b4-1730301153"
  },
  {
    "email":"adelem78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207627130/734539545a7d860f8546fbcea9f5234d-1730301153"
  },
  {
    "email":"spiller81@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207659898/c7d378473713dbe53ad002a7381e184e-1730301153"
  },
  {
    "email":"ap84@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207758202/7752c14bc21ba7d6ef11b80ab168a05b-1730301154"
  },
  {
    "email":"giovanni13.speranza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207790970/4ba44a07782b02b570b64f6fbe034930-1730301154"
  },
  {
    "email":"katia.scaglia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207823738/368afebd463b1fb7e4fe315791b16b83-1730301154"
  },
  {
    "email":"erikamarty82@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207692666/9e55178d53d54056f806da824c94b04e-1730301154"
  },
  {
    "email":"chisio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207856506/7eedad294e61e248bfd1b9bdce3962b3-1730301154"
  },
  {
    "email":"apassarini@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723207889274/f4e8f1db595ebef6d0f9f1acf1095d5f-1730301154"
  },
  {
    "email":"cicalinienza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207922042/8c02c004ce53e05bbd02dc15ea450400-1730301154"
  },
  {
    "email":"giulia.morans@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723207954810/31b93430bc76e0bd22ecfd18d9e0e05e-1730301154"
  },
  {
    "email":"enricaleocata@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208085882/8b222b1351d57cd6da2b915bf994a71c-1730301154"
  },
  {
    "email":"manumodest@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208151418/673a569f6aa7fc4ec06a068be74ed843-1730301154"
  },
  {
    "email":"cristina.damato@unipolsai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208118650/1dbfc0f63faad08c1eafe1c121c6f6f5-1730301155"
  },
  {
    "email":"mlior042004@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208020346/ad375794d3c7ef0ecd9151d6aac0cf09-1730301155"
  },
  {
    "email":"lotito.sofia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208216954/e2347b93d107ba06a62564d75ef6e178-1730301155"
  },
  {
    "email":"chiara.cottonaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208315258/0bb0eb37f16b48f97841ebbaccd43df6-1730301155"
  },
  {
    "email":"marzio.canobbio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208282490/8fedb329c87ab93589cf41b0c72bc4c9-1730301155"
  },
  {
    "email":"francescazannoli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208380794/092f274f469bee38cd8717f68c91b983-1730301157"
  },
  {
    "email":"francescamalizia1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208479098/c293438ba6ccdae4856a4a061d34c737-1730301157"
  },
  {
    "email":"naty.malagutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208446330/d9a960b28bd4adf7f8b174059f71cb2f-1730301157"
  },
  {
    "email":"corivlas@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208511866/545fc47aa8a1668ecac60693cb5ead38-1730301157"
  },
  {
    "email":"natoant@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208544634/b88f23b4e1a3e049c34caa644307224a-1730301157"
  },
  {
    "email":"maridastella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208348026/30918a871ab60a97e787caa18a7f0cb0-1730301157"
  },
  {
    "email":"sara.zanchiello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208741242/be14c0d098167694c8b6accf727ed86a-1730301157"
  },
  {
    "email":"lucchese60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208577402/36b776f468fbce06c70a9c79aceb9c7f-1730301157"
  },
  {
    "email":"monica.allemandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208642938/da73d74ee3dbf1e9c0603ada0ba13891-1730301157"
  },
  {
    "email":"info@agriturismobellavista.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208675706/06458bb43e9c941cea75ba7f566a5b61-1730301157"
  },
  {
    "email":"savymary@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208970618/d79c0e84d737a04afe5a7e8ba240fc56-1730301158"
  },
  {
    "email":"barbaraoteri@archme.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723208872314/5de638de084946fda4e2221dfff7fdaa-1730301158"
  },
  {
    "email":"chiara.simonot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208905082/dbc2807adcad24e275604d1f4768c499-1730301158"
  },
  {
    "email":"saramonforte@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209003386/c89f5e55fc394126ba45f875c3bda625-1730301158"
  },
  {
    "email":"letizia2476@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723208774010/a91fdb2ce45dd16d88c74629ed631791-1730301158"
  },
  {
    "email":"soniaiommetti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209036154/9647c6a457c77320ad517f139c49c6fc-1730301158"
  },
  {
    "email":"giulia.bighi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209068922/e1d99fc0c281c85492c329371da7879e-1730301158"
  },
  {
    "email":"vera.mammolivera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209134458/a5c67924a376af351e26ae5c02215011-1730301158"
  },
  {
    "email":"silvia.basso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209232762/fed23e65d6244042cc8ef8a326319efb-1730301158"
  },
  {
    "email":"ferro.claudia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209265530/deb05267febb961b61e9ff59f02ba088-1730301158"
  },
  {
    "email":"azzuzainali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209101690/53095e633e402486978373555250b850-1730301159"
  },
  {
    "email":"petrojonida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209199994/5b4410966e6b9b075d67000e41bd3f6a-1730301159"
  },
  {
    "email":"raimondo.sgambato69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209331066/9b5521e81d899466828e00872927f6b3-1730301159"
  },
  {
    "email":"alessandraiannicelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209363834/458e24dcdd01827a93a1d62b57f9e4de-1730301159"
  },
  {
    "email":"a.albertini@immobiliaremagia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209494906/6a05102840162194b52d64c0848bc02a-1730301159"
  },
  {
    "email":"corona.anita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209527674/1a0baef11f187cafd84359deb9b6c765-1730301159"
  },
  {
    "email":"giusydefalco@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209429370/139c5664fdca465860d3c64a5249a3e8-1730301159"
  },
  {
    "email":"vittomoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209396602/05119a32457009d191f1d5116847c60e-1730301159"
  },
  {
    "email":"ariannadelbaldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209593210/c6c5accb06aae97a1b740b57a10dd6a7-1730301159"
  },
  {
    "email":"rizzo_barbara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209560442/cabc66efff3d229e38869add5b7f66df-1730301160"
  },
  {
    "email":"n.danila@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209625978/3037f84854b4b6a7b4544422f87ca04c-1730301160"
  },
  {
    "email":"michelaca.mc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209691514/aef58033be3d607657f9e0a49a95836b-1730301160"
  },
  {
    "email":"clarissa.rav@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209658746/2b91dbd586f230078d54bcbbe8769298-1730301160"
  },
  {
    "email":"f.falcone@casadelbullone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209724282/6dd8c40a36e3a970d1ebdf98f58826fc-1730301160"
  },
  {
    "email":"vaniglia.pistacchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209888122/4f488e6d1bf7aad8a2b029895480204c-1730301160"
  },
  {
    "email":"alexia.molino75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209855354/b28a28408c7b422b33a8146a6a6eb797-1730301160"
  },
  {
    "email":"giuliacarli1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209822586/7e15e1c662d84990169b722bb13d453e-1730301160"
  },
  {
    "email":"stefanyst@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209757050/087b6a3a69fea34dba3160e4faca7dff-1730301160"
  },
  {
    "email":"marcella.roselli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723209953658/f06e3bfa386a9b8ac049f33a6ab9be19-1730301160"
  },
  {
    "email":"grassonadia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210019194/b499fb756e34d7a3c6c6fe56e37ba367-1730301160"
  },
  {
    "email":"giorgia.maccaferri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210084730/51aa03e9e399175fc698de26bb0fd2e5-1730301161"
  },
  {
    "email":"raiti.nella@dasanto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210117498/8d93dca45db045cf6c13150ff0a83f63-1730301161"
  },
  {
    "email":"lorenzo.bellitto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210150266/2e8bedec5093a4a77eac8adab8578427-1730301161"
  },
  {
    "email":"d.foresto@danielaforesto.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723209986426/b1cf18e1f5efab4f222d775de6be88b8-1730301161"
  },
  {
    "email":"micramia@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210248570/a8c0a8ae9a74f73859c0ad06c05fb1fb-1730301161"
  },
  {
    "email":"kelan@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210281338/d40a9c6cbd340f20562ba564046106c5-1730301161"
  },
  {
    "email":"quaggiosara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210215802/1bd4ecf0c369e480e458a9672610e783-1730301161"
  },
  {
    "email":"abassu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210183034/9f153dfd939fcde9a860cf84c7dde823-1730301161"
  },
  {
    "email":"marco797@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210314106/11dd18c03fce42ea0e3d0affcbeb053b-1730301161"
  },
  {
    "email":"fedina_g88@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210412410/964876a1675d5886e481208939074934-1730301162"
  },
  {
    "email":"ingrid_ego@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210379642/8e0914864c20c271c20c1b3b970edf36-1730301162"
  },
  {
    "email":"orny.brt@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210477946/5414e1e1fe4014e1fc3116ce6135cbe1-1730301162"
  },
  {
    "email":"anna.gisario@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210510714/2c1073664c16dda6f4c308fac3141c23-1730301162"
  },
  {
    "email":"antonio.misasi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210576250/2160ee85a0074d01283f8f3bac131759-1730301162"
  },
  {
    "email":"deborahvalente@valentour.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210445178/524a6f7d8006ed03b51ca07fc4a2e142-1730301162"
  },
  {
    "email":"carenaf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210543482/7cc249e158a5ba089f5372b59599a6a3-1730301162"
  },
  {
    "email":"sara.bertacchini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210641786/9c4bebbc631c512e82e1c35fbf6ef415-1730301162"
  },
  {
    "email":"vitellic@posteitaliane.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210609018/ab813102a720baf5fe645f6d7254e8be-1730301162"
  },
  {
    "email":"geopatrizia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210674554/9e1d7574f1dd8284c76b2ee6b39fd2c2-1730301163"
  },
  {
    "email":"sandri78@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210805626/2ff1ca66fb0696a390eec27ef3c2ebd5-1730301163"
  },
  {
    "email":"epanizzolo@aslto.piemonte.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210740090/925ca2024ac638d003f08ed4de8e318a-1730301163"
  },
  {
    "email":"martina_f86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210838394/50e8e039f27efe51a6990081a686557e-1730301163"
  },
  {
    "email":"nicol.cam@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723210903930/9e8cc7e335dcb128e04e72219bc6fd0e-1730301163"
  },
  {
    "email":"silvia.grizzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210707322/7b22a3fd64c66253f6e0dfee28d778ea-1730301163"
  },
  {
    "email":"lillina82@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210969466/8dda7cd27de0b57b736b0c896a6f8453-1730301163"
  },
  {
    "email":"ciuffo.katia15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723210871162/3c72a69392be606f229e4e400342a53f-1730301163"
  },
  {
    "email":"sa.ri-79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211002234/f067198e3351365ced3be9f0ee8634d9-1730301163"
  },
  {
    "email":"elenamorri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211067770/9b0510636ea019dd369d194fbc773451-1730301163"
  },
  {
    "email":"sandradc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211035002/6acb01ab8e345949ae2e651f70f90858-1730301163"
  },
  {
    "email":"linellabomboniere17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211100538/83ba1518bd93c2173173d03b080afd93-1730301164"
  },
  {
    "email":"laurora07@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211133306/97859ace72eb366566bc037a367f2e5f-1730301164"
  },
  {
    "email":"paola.marranzano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211231610/e163a20843a193046c491d5d4c15057e-1730301164"
  },
  {
    "email":"elisabettamulas79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211198842/bcd32c9ca59503ee15740884941a9732-1730301164"
  },
  {
    "email":"rosi_87@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211329914/ed43b7732439557e18c21fbb3be31b14-1730301164"
  },
  {
    "email":"ma.fra1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211297146/dcdeaebaeb5e321d0dd873d1a8fb3934-1730301164"
  },
  {
    "email":"greta@corodipieve.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211526522/25a9aba47d19896da7208cc5993a6bec-1730301164"
  },
  {
    "email":"hm.ke@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211395450/9580e5abecd4002f7bff388c8ae31ab9-1730301164"
  },
  {
    "email":"lquattrini88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211624826/2f3cbf7dd0421177638908c41704d962-1730301165"
  },
  {
    "email":"agnieszkakrol@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211362682/8650d46daab791f575fbb7a251bd5e65-1730301165"
  },
  {
    "email":"nadia.scanga8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211592058/afd81b6dcc2a0e38ec1a1c21df2c248d-1730301165"
  },
  {
    "email":"avv.derossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211460986/b33f5c2488b101b71ad43b60a7783920-1730301165"
  },
  {
    "email":"francescatino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211788666/d6ff72d0b53a163904247f67c6bd2f48-1730301165"
  },
  {
    "email":"patriziatomasini25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211755898/20dcca678cc724d747f1133547336ba2-1730301165"
  },
  {
    "email":"ale.perlini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723211854202/1d6aabcd090d6f11cf24371e6df0b1f6-1730301165"
  },
  {
    "email":"bettola80@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211919738/e0afb8649ac6454f2e13472afad5d7cb-1730301165"
  },
  {
    "email":"s.sandra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723211985274/fa39ab73f9561768d2d14671a7b85f35-1730301165"
  },
  {
    "email":"barbaraberti67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212050810/5647fa135556c865dbf4140ccc2ea4a7-1730301165"
  },
  {
    "email":"tizianasoia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212116346/2af950cbb2963a731362b71211b225a8-1730301165"
  },
  {
    "email":"angela_77_t@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212149114/07c2d9891bc123a5a46924a40874d980-1730301166"
  },
  {
    "email":"ele_house@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212181882/9998f1768ebd9d25bf9424c628c9d65f-1730301166"
  },
  {
    "email":"pulce.23.ale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212083578/f1c369ef8cc4540e4deb1ccef307cf0a-1730301166"
  },
  {
    "email":"rizzi.giulia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212214650/e6241340e46043037e51998786b91a96-1730301166"
  },
  {
    "email":"agosimo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212247418/c445c5b628728aabb96faaf5dc98d5cb-1730301166"
  },
  {
    "email":"www.francy187@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212280186/413105bca87f2ef127c4341158c0e560-1730301166"
  },
  {
    "email":"valeria.merola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212312954/811f08e92eed2f5b9a9addfb0cf69759-1730301166"
  },
  {
    "email":"loriana.vitale@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212378490/8a0af58f32729c1ca0f8cd87d5bf7c1e-1730301166"
  },
  {
    "email":"gdg.digirolamo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212411258/df181dcc5ea22149ad269caa4611bdb7-1730301166"
  },
  {
    "email":"biuz90@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212444026/6bf4505bc813d1358af738b3af4e1385-1730301166"
  },
  {
    "email":"cippi.ciop@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212476794/96b636f7f7f8ae66e6c60c91ad8992a3-1730301166"
  },
  {
    "email":"savinab@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212542330/862cced450dc9e24b5b162cd6d5ec091-1730301166"
  },
  {
    "email":"scintupaola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212509562/8277927017d6a550ef9a87ba6ee5ed3b-1730301167"
  },
  {
    "email":"grassiaangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212706170/5e0ba54b9105160542a709a1810fce28-1730301167"
  },
  {
    "email":"monica.lopresti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212575098/3bf791bbf17578c6710ac992cd56e49f-1730301167"
  },
  {
    "email":"samuela_mosca@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212771706/e61ea8c432b3d431cb84f9f40f01f22d-1730301167"
  },
  {
    "email":"joy.77@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212804474/4355345c01557ee26d5d511fd9c5d24d-1730301167"
  },
  {
    "email":"valentina_ragazzo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212870010/1189f3e4f9c5389971acc19ba929d0bf-1730301167"
  },
  {
    "email":"rozza.cristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212738938/005418cfd8d69d14bbf4db2ef3c7d11d-1730301167"
  },
  {
    "email":"tosofederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723212902778/bea9b86d19a4fc5368f05a90855de14d-1730301167"
  },
  {
    "email":"thorg@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212935546/c249a597bd045014656ec45c6af78a20-1730301167"
  },
  {
    "email":"criss1977@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723212968314/4b371cf15b2bd4a0c374436e53cf6ae9-1730301168"
  },
  {
    "email":"luxarcangel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213066618/a83e689b86f9e8c27c696377a869762a-1730301168"
  },
  {
    "email":"paola.scapicchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213099386/72825d7fd7689313f820a4e93713ed4c-1730301168"
  },
  {
    "email":"antyo79@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213001082/ddb9865c7a6f8ba9fea2a61f6b9cd5fb-1730301168"
  },
  {
    "email":"flavia.gaia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213033850/82e7d87fdc834149df3dce67c2f016a3-1730301168"
  },
  {
    "email":"giovannanastasi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213132154/60850f3eb24575ce196cc852bbaf012a-1730301168"
  },
  {
    "email":"climapuk@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213164922/fe635cd62b749b3154e033968a09f673-1730301168"
  },
  {
    "email":"ccolef@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213263226/632115d033f3072a9d8274429ca17066-1730301168"
  },
  {
    "email":"previa64@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213295994/3debdbac633186c66259d62ee74cfaf8-1730301168"
  },
  {
    "email":"maghinipaolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213197690/f055bdfb9424f7d269cb23f11e4c3c72-1730301169"
  },
  {
    "email":"ellem99@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213427066/e651538ac2cbea0567be1590ec24a971-1730301170"
  },
  {
    "email":"duesseufficio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213328762/6ae30ae529edb09d0d41d92981a26fa6-1730301170"
  },
  {
    "email":"chanelzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213361530/e4db18e03c80a60cb481c49c22eb6140-1730301170"
  },
  {
    "email":"benedetta.p74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213492602/811799fbbdd8b89b7877ffd78eeebdf2-1730301171"
  },
  {
    "email":"corti.veronica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213459834/b05c75698e8b82e5ee143be0802d1505-1730301171"
  },
  {
    "email":"nunzia.pasquariello@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213525370/5f4f84a6b7da3eec77a3d30f416cd655-1730301171"
  },
  {
    "email":"mariantoniettavargiu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213394298/f49f1998f2cd1833427c792aef4d8649-1730301171"
  },
  {
    "email":"latini.alessandra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213623674/836eca25f0c43398d0689aeadcdc6aa4-1730301171"
  },
  {
    "email":"chiara.tamiazzo@centounoviaggi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213590906/3df4397e8e598c20b9509379679e98e3-1730301171"
  },
  {
    "email":"angela.bonu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213656442/81dd134074340741908197bd3bf6961a-1730301171"
  },
  {
    "email":"razem.b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213689210/82fb1603e4e31cb345a9a94bbaafcd63-1730301171"
  },
  {
    "email":"giuliam_90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213754746/0ce004c0dd3bae8364f5e602adc65bb5-1730301171"
  },
  {
    "email":"vittoriaenaarchitetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213721978/afeeabb211781dca8b094e61920ac3cb-1730301171"
  },
  {
    "email":"valeriarebonato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213787514/fad869d2d7066545694861807c7dc1d9-1730301171"
  },
  {
    "email":"grazia.diliddo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213853050/8349a670e10542321322eb8cb706460e-1730301172"
  },
  {
    "email":"mariafigaia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213885818/34ff6aa58a388d5ddb7504129a1a11d0-1730301172"
  },
  {
    "email":"elimarconi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213820282/6b2f037da9a30296f168e38b8f0e309f-1730301172"
  },
  {
    "email":"knop@kirche.tv",
    "url di attivazione":"https://verdissima.it/account/activate/22723213918586/82cd188df25dcb3b24547311c5422ceb-1730301172"
  },
  {
    "email":"baby_s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723213951354/f7fe01747f322d766d4d35a339109b3f-1730301172"
  },
  {
    "email":"silvia.malny@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723213984122/8345550f8a766be4ada2a34586bf73b0-1730301172"
  },
  {
    "email":"armientoangela@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214016890/6a5e279b7eeaa2874025e7f1115ec90e-1730301172"
  },
  {
    "email":"goccedirugiada85@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214049658/f61ca7cb98ea93171d39d05dc86e690e-1730301172"
  },
  {
    "email":"giada.bicelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214082426/0618599a2a62d517d42feba3ae6a7510-1730301172"
  },
  {
    "email":"tana1977@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214115194/ef3c9f9b36ab4143be1fd3eb4526cf00-1730301172"
  },
  {
    "email":"assunta.wind@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214147962/c8208698d4d126375ab08abb3ee0f459-1730301172"
  },
  {
    "email":"barbara.raspanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214246266/133c18645a11f21c91c2e04b3c5518b6-1730301172"
  },
  {
    "email":"paola@piccolofabrizio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214180730/180b64eecd0a0241ae83ea021d44552b-1730301173"
  },
  {
    "email":"stefania.onida78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214213498/9e96a33eb4250622722e368f2e508cea-1730301173"
  },
  {
    "email":"viktoriya.leo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214279034/3629c188109e07927f1cc97fcfe2810b-1730301173"
  },
  {
    "email":"melissaricca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214344570/8e04bb9568eb873db2fd120088f3915d-1730301173"
  },
  {
    "email":"carloravazzini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214311802/90698697625e9a3f836d4e57b71888aa-1730301173"
  },
  {
    "email":"katja.morjni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214410106/7ef39cb65854ec4a7fafd746b86f2156-1730301173"
  },
  {
    "email":"federicasali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214541178/f6de81d4701e1d5dfc9d7a26f4b26dfb-1730301173"
  },
  {
    "email":"roccodan07@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214377338/ab0714204cce32b7fe17e6447398a975-1730301173"
  },
  {
    "email":"terrykianese@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214475642/b3c2a0a907133324e9a6c6e1ce074854-1730301173"
  },
  {
    "email":"tullia_bucco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214606714/5a6680da2803241ed09f64c5206b4969-1730301173"
  },
  {
    "email":"jm.spengler@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214573946/3b9d3f07c3345ae1e19d3f4d8e30143a-1730301173"
  },
  {
    "email":"elisab_89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214705018/453ce72002e535833b2dba0f3030f164-1730301174"
  },
  {
    "email":"simonadellavilla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214672250/b89b324ea5269fb7f23655007566094a-1730301174"
  },
  {
    "email":"chiaramantarano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214770554/4d4fc0975f6b2e1521136807914144f3-1730301174"
  },
  {
    "email":"niketta202001@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214737786/f4e066c2bffc5e9f36115c19bc64dba6-1730301174"
  },
  {
    "email":"rederlechnerangelika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723214868858/46eb18d1e18c0d787361d127fa0e5ffd-1730301174"
  },
  {
    "email":"dott.cristinaam@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214836090/5d8c4b571d4785cc5e11705867f39d79-1730301174"
  },
  {
    "email":"m.marrazzo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214967162/64843948a8f2de5f68e17312c50e653c-1730301174"
  },
  {
    "email":"nvalentina@paypal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215065466/4a8acfb16d82668feb983a5795ddae91-1730301174"
  },
  {
    "email":"annachiara.colella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215032698/23055a568592f6325d8b40b321e4d4a4-1730301174"
  },
  {
    "email":"maria1708@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723214934394/6883b00cb01fe6bd398986b99a294745-1730301174"
  },
  {
    "email":"rosadeldeserto98@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215098234/30384b157fe2e02f0587be94b9ae1ec8-1730301174"
  },
  {
    "email":"correnti.mariarita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215131002/efc331b0ce542123da158f7ef00453e9-1730301174"
  },
  {
    "email":"pucca.1990@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215196538/e3a6191def6c47e87149bae4f552b21b-1730301175"
  },
  {
    "email":"paku.bepy@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215229306/48582bb8b8f5ddff4443ab3f9c7e5bca-1730301175"
  },
  {
    "email":"ghellere.marilena@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215163770/815e7454e896f0e5d0bc2412032675f6-1730301175"
  },
  {
    "email":"cry7puddu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215262074/f3b6b13be28c4c0f1f7415fc68792d59-1730301175"
  },
  {
    "email":"info@hotelgiuliettaeromeo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215294842/7ee5f27e6b48554b9d14247f93d01336-1730301175"
  },
  {
    "email":"ogliari.rachele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215360378/3624c22edf7e7c41147fa4b9b3e73165-1730301175"
  },
  {
    "email":"alpo@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215393146/136411344882d0c756217f85071bebdd-1730301175"
  },
  {
    "email":"chiara@bergaminiassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215458682/291b0d5c562416eeeb74c82a4279b185-1730301175"
  },
  {
    "email":"emilia.bencivenni@studio.unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215425914/97924a7967e470273e92a65837fb353b-1730301175"
  },
  {
    "email":"filippo.flori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215327610/0cccb296b015f904bf6f38b5ff18eaaf-1730301176"
  },
  {
    "email":"autoscuolatano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215556986/5ea05c1b83f6c956c4a237d3157576b3-1730301176"
  },
  {
    "email":"mara.bertan@bertan.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215589754/83c197eac404e42adcfbff0c7dbb1e77-1730301176"
  },
  {
    "email":"jeymemy@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215622522/efe4ed73a56fa552659f9f35e04cbe3c-1730301176"
  },
  {
    "email":"magno.eleonora@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215524218/b4d3bc40c5d0dbd8a447d90d89dc7e3d-1730301176"
  },
  {
    "email":"gvnngenco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215688058/d6f07e981b5255ea294d255bb89d45a1-1730301176"
  },
  {
    "email":"alessandra@portorossi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215720826/955350c3eae8913f47016b534338211d-1730301176"
  },
  {
    "email":"ally4791@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215753594/8cfe432e974ba4caae8db3204a219dbb-1730301176"
  },
  {
    "email":"mariagiacomoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215655290/cfa646ad86dfa17fa5db1597e86e9395-1730301176"
  },
  {
    "email":"giadanda@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215851898/6b1fe56d4377f4c3770414aa326923d5-1730301176"
  },
  {
    "email":"ezio@portorossi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215786362/1a37e8946fd87075d6cd14d0a5de73e8-1730301176"
  },
  {
    "email":"michelalipa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723215917434/a2bb016cf417b6ed5bb599b892381dca-1730301177"
  },
  {
    "email":"mattabene@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215950202/aecc84a684cdeddc877595569bfd8d94-1730301177"
  },
  {
    "email":"pacio5@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215982970/98aafd441bd45ab2778f2e256457432c-1730301177"
  },
  {
    "email":"ecletticafg.66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216048506/6eafafee4b5572eae8a8fb6478e411b6-1730301177"
  },
  {
    "email":"luigiavb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723215884666/dadaf101a5420ab35952fb642f5f7bfc-1730301177"
  },
  {
    "email":"c.licastro93@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216114042/cf58ba1620ce850d302b0553e9e3374d-1730301177"
  },
  {
    "email":"iroalo2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216081274/fb8e6b323ff73d532d0adc9e7eece279-1730301177"
  },
  {
    "email":"simogua677@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216179578/7f180a3ff238e4fae44992a9925a7fbf-1730301177"
  },
  {
    "email":"elena.sgarbi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216245114/30f10217fbe152acc2ed681a12b952e3-1730301177"
  },
  {
    "email":"sara.giorgetta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216212346/6e0aa70c2e748841792503842d8b6042-1730301177"
  },
  {
    "email":"ale.angel@45strada.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216408954/f87fb84ab136ef065420216acb71f8e6-1730301177"
  },
  {
    "email":"labatpat18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216441722/4d885fc591a283385cc2f5990f4606fa-1730301178"
  },
  {
    "email":"jackdags@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216343418/7fd11aa5263031d799e9df3544131d88-1730301178"
  },
  {
    "email":"riccardoienci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216474490/3c366f9d42a57b1f6c0316b072a4ed16-1730301178"
  },
  {
    "email":"chiarablonde@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216507258/1ece60576f35772463cde5b86dda13cc-1730301178"
  },
  {
    "email":"annapettinicchio2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216671098/07b36529b639cc393d8cbb9f0f5ef7fd-1730301178"
  },
  {
    "email":"zambon52@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216638330/0ac4e12c70d893fdb88ce7ed99f4842f-1730301178"
  },
  {
    "email":"giocarlisi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216572794/97c6cf967caf0047acd8822bef4ab381-1730301178"
  },
  {
    "email":"muneratto.stefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216605562/f0c7697d31e939e0dc12157849089970-1730301178"
  },
  {
    "email":"sara.ricca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216703866/d93be79ab95f7b5d3fb8efe894b3f0d5-1730301178"
  },
  {
    "email":"loscal@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216802170/f6a11370ce36cb030c2125a6348493a5-1730301178"
  },
  {
    "email":"012bra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216834938/fb0f6f1819ea787a24eabf1bdc321385-1730301179"
  },
  {
    "email":"teobirba@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216900474/d6e405e3d47cf0a825c220eeea23d34d-1730301179"
  },
  {
    "email":"marinasantucci4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216769402/bade909ae798db8695866e82d99112b0-1730301179"
  },
  {
    "email":"diamanteluna_@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217031546/0593a30a5e3aa22492beeac1ebadda69-1730301179"
  },
  {
    "email":"amministrazione@gaitrasporti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216966010/c6d09cff67142a8a154568c9d0fc90f5-1730301179"
  },
  {
    "email":"balboni@mclink.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723216933242/eae0359a03f40e92d4ffe47ed1f97f15-1730301179"
  },
  {
    "email":"pikycolombo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217064314/72825ebf9723280a9a96d0edc857805d-1730301179"
  },
  {
    "email":"carlottarossisordina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723216998778/401f7be8e22248d4d7163c09e31715d9-1730301179"
  },
  {
    "email":"gigdebby@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217129850/c9a71f92fb68f25cfcb1e315fc1195c0-1730301179"
  },
  {
    "email":"g.pigini@studiolegalerossini.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723217162618/8f959329a5489cadcb0d66a11d46ac90-1730301179"
  },
  {
    "email":"renato.turconi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217260922/43f65673b820e2ec22335886af851be3-1730301180"
  },
  {
    "email":"mancinimnl@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217326458/5ff4f00fa7410a08284ab296b37769d7-1730301180"
  },
  {
    "email":"mariagrazia@luwisch.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217359226/a16527918c44c4c31abfa6f478c8393f-1730301180"
  },
  {
    "email":"ivamiha@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217293690/edfa0cd83f69819c308f6b905ef95866-1730301180"
  },
  {
    "email":"elisacri08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217391994/7bd4e3adcd7bb179d8254c4890634c76-1730301180"
  },
  {
    "email":"marco.figura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217457530/b91aeee3a4375746efbe00f7e6ea0984-1730301180"
  },
  {
    "email":"beatrice.gualandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217523066/869a8acee1a28e4c99f51e5890ef74e2-1730301180"
  },
  {
    "email":"russdami@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217588602/f526f07bfc850f7da5321406e47030cf-1730301180"
  },
  {
    "email":"daniela.blardone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217555834/6540628fa1c83de54352519d6cf1f4b1-1730301180"
  },
  {
    "email":"letizia10@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217621370/bc29dfd2b0bbf1a9764d67d65924bdaf-1730301181"
  },
  {
    "email":"bobsa20@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217424762/e3cae80ac54d3be336af1bde8bf3caf4-1730301181"
  },
  {
    "email":"maxi.ludy@hotmsil.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217719674/40889d492cf58fdd5c178362e350ea01-1730301181"
  },
  {
    "email":"giulia_galbiati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217850746/953bd79fabc2eef41ccd1eac3a1c150f-1730301181"
  },
  {
    "email":"info@palaceresidence.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217785210/1b4c9faeafc72dfabca33ead43231ef4-1730301181"
  },
  {
    "email":"oanceamihaela68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217949050/c27da72f18bf789ffd67adb5b63b6232-1730301181"
  },
  {
    "email":"angelarovatti@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723217817978/eb68b13e207552742f944d1212deb3c2-1730301181"
  },
  {
    "email":"paris8821@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723217916282/a429f97ce85d10aec94a23eb17015f89-1730301181"
  },
  {
    "email":"p.stroppa0509@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218145658/d1710dd0e44b30ac5c5733783d2bee69-1730301183"
  },
  {
    "email":"nellino57@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218047354/860c25292a002d6f24800b32cee275f8-1730301183"
  },
  {
    "email":"campeggimoira@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218014586/2d99eaa7a4559aad9ecbd2b7cabaa509-1730301183"
  },
  {
    "email":"manuelafrasson@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218112890/5cff1d0ab2096d0208c97951b6960303-1730301184"
  },
  {
    "email":"centrocopiegabrielli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218276730/15e5f4db143d3091b1fca1003bdfe1cf-1730301184"
  },
  {
    "email":"simonettasaveri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218211194/411b05ccbbf07cb497fc2f29399ed736-1730301184"
  },
  {
    "email":"alessandraangeli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218178426/8eb45b05851fdfdb2b51b7c365f7b04f-1730301184"
  },
  {
    "email":"paola.baudinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218243962/2e35c75cf9d5bc835e7f70a3bca2be50-1730301184"
  },
  {
    "email":"simona.maccherini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218342266/9319a0c14f1e850bb593a6255d482db4-1730301184"
  },
  {
    "email":"giovanna.dirienzo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218375034/3a245d31c8103ab7d750ad1f46c4ef3c-1730301184"
  },
  {
    "email":"v.carulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218407802/10a7539809d8fab6db63396ceb9dd48c-1730301184"
  },
  {
    "email":"stefania_didomenico@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218440570/7f8c98e42e01a0bea4ccdf7d5fcc91e7-1730301184"
  },
  {
    "email":"manuelapedrini28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218506106/df4d594c757dd92b82a540fb82f47c43-1730301184"
  },
  {
    "email":"melaludo@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218538874/2584165ad50048fb2f4eee014df19bd1-1730301184"
  },
  {
    "email":"cinzia.cugnetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218571642/d5206d3c0b2ae1478fefb6eaa6f42234-1730301185"
  },
  {
    "email":"enrico.nali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218637178/3bc24b888520f7618a7acebbefe46bcf-1730301185"
  },
  {
    "email":"francesca.orioli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218473338/ddea0f5b1cd3a19a36abc9c636391651-1730301185"
  },
  {
    "email":"pamelagatta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218702714/4c8faddb57b096779d9a6443255d36c3-1730301185"
  },
  {
    "email":"discardi.martina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218735482/52ec168dedc77449bf81e15a13cc4ecf-1730301185"
  },
  {
    "email":"lnrdaronco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218768250/a49c1135d4e12a58d5901259dc294592-1730301185"
  },
  {
    "email":"violapii@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218669946/ff12260f92da3d6183e7790f3a844cbb-1730301185"
  },
  {
    "email":"sonia.prifti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218866554/4d0d46433e912de89e4a616628359845-1730301185"
  },
  {
    "email":"cnati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723218899322/08579c3c0a45f97e0283189f250c4dc2-1730301185"
  },
  {
    "email":"amanda.barazzuoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218997626/bc8722a9a8eff1e9e3ddc2d93921ce95-1730301185"
  },
  {
    "email":"caterinabranone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723218833786/15379ea16e9e8d13cfbc61bc179ed07f-1730301186"
  },
  {
    "email":"v.vicario@deborahgroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219030394/1514b138c835782b3ff28b3aa759ac4a-1730301186"
  },
  {
    "email":"frpi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219063162/9a492dd567caf7d886de637a98712fe2-1730301186"
  },
  {
    "email":"shopping.lulu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219128698/18919529cfdf849e4f4799c7313628e8-1730301186"
  },
  {
    "email":"giuliabacelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219161466/95dea773578268f837feaa33ec3b2761-1730301186"
  },
  {
    "email":"frosinaclaudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219194234/1577979df8817c2f5c4af17bf077b611-1730301186"
  },
  {
    "email":"elisa.alb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219227002/b1b800ed49eea1f41af1936c41f1a0e7-1730301186"
  },
  {
    "email":"lunadoretti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219259770/bfc59c94b316887ea2a8fb53a59b0c12-1730301186"
  },
  {
    "email":"stefyviriglio@gilber.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219358074/a8541f343e90c80feaed572ea125c486-1730301186"
  },
  {
    "email":"marciab@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219325306/9fa69e05c48e939e1cb8fcc4a062e452-1730301186"
  },
  {
    "email":"federicapollini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219423610/b5f95b7007e2220407271ae65d1180ab-1730301186"
  },
  {
    "email":"barbara.cascino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219456378/156d4dcf03acd208f3b30b10109b4f39-1730301187"
  },
  {
    "email":"claudia_frontori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219521914/64690d119f56b3d2c6abe4b02e5ee1c2-1730301187"
  },
  {
    "email":"annette.weng@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219489146/6b332a49eeb515478b4e357ae1c81119-1730301187"
  },
  {
    "email":"liana.ecca@nordicjones.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219390842/bacdecf524781caaf2fe36f8b7b52e40-1730301187"
  },
  {
    "email":"enrico.massaron@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219554682/85f2a5687ba824150f97421ad1970d30-1730301187"
  },
  {
    "email":"st.fusaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219652986/6065da7fbcaf09aeacfad5e3e251dc4d-1730301187"
  },
  {
    "email":"rinaldi.ciak@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219587450/15f4fc501ed4c95a0d5ca4f3312c47de-1730301187"
  },
  {
    "email":"vale110290@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219620218/78db65f13136710d0ec3ec67bb86e9fe-1730301187"
  },
  {
    "email":"andrea.napoli01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219685754/07a8e26c2c107cb4aaab0d02608d1fdd-1730301187"
  },
  {
    "email":"alessia_bertone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219784058/70a7eeef71129ddd2a296d091a4d6b90-1730301187"
  },
  {
    "email":"marina.pand@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219751290/87e7d2e972915314e268482f00ab9996-1730301187"
  },
  {
    "email":"famiglia.gillibiz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219718522/abd3547cbbf9a8862cbfc8fba9844740-1730301187"
  },
  {
    "email":"bagni.elisa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723219816826/9d4736d456da19caba53283a65e130ee-1730301187"
  },
  {
    "email":"crimorra@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219980666/66912efd0c15b959202a7beae806b278-1730301188"
  },
  {
    "email":"sara_perosa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220013434/26478a9f39bd611b1180028a954ffedf-1730301188"
  },
  {
    "email":"mariagiulia.musardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219947898/82bc5d07ccf7662d8f86a8e6b92fc228-1730301188"
  },
  {
    "email":"cleliav22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723219915130/9687dfc20d76863efd5debbb45becdb7-1730301188"
  },
  {
    "email":"robertamichetti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220144506/c34556777314e99886a4179b0b9cb006-1730301188"
  },
  {
    "email":"scarletclyde@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220046202/b675c3bcbb15ad634b931f824bf8ce5a-1730301188"
  },
  {
    "email":"stefania.limongi86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220111738/a27395e77cc1f6c9cbec9d55b72eec37-1730301188"
  },
  {
    "email":"fede21@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220078970/5ddc0553536f1f57ba1fc835533bb25d-1730301188"
  },
  {
    "email":"cataldi@soundiva.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220210042/39c099241271719382d768e65b66222b-1730301188"
  },
  {
    "email":"valemerzi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220242810/564ef782fa845e0c5a02fabc5502e91b-1730301188"
  },
  {
    "email":"silviastefani@esse2srl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220177274/e6317513132bedfda2073a649cff5379-1730301188"
  },
  {
    "email":"laragabbi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220275578/494887d7e4194b65619a7142ee5b98ba-1730301188"
  },
  {
    "email":"giulia.viva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220341114/7a8ae4e9c4533dc3b0bfaff8fef85aa4-1730301189"
  },
  {
    "email":"mmmonia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220373882/f678790068dec03f6d0a7bebe7c0ef9e-1730301189"
  },
  {
    "email":"nataliakasperov@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220406650/086d23cf6198dcb9fc8b357f2a7e819e-1730301189"
  },
  {
    "email":"liviserr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220439418/58f8c960a6a58df1adb678994dcb53a7-1730301189"
  },
  {
    "email":"a.pelletier@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220504954/05fb548d47f0bf39712b354ca0146f92-1730301189"
  },
  {
    "email":"tilde_79@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220308346/35b8e44f315922c66e4fbbd508109282-1730301189"
  },
  {
    "email":"guadagninielisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220537722/58991405ef18821098b87ab0d531515c-1730301189"
  },
  {
    "email":"stefy2007@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220472186/ab1d2137f64f5080eaaf5642eb78d4df-1730301189"
  },
  {
    "email":"jonata@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220570490/c160b46edf5097cf85a0f40f88544020-1730301189"
  },
  {
    "email":"danieladonato.dd@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220701562/119358f75017a462d638e79fd126f350-1730301190"
  },
  {
    "email":"lipparini.valentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220668794/7ff71235be3fe082dbe12efde710175f-1730301190"
  },
  {
    "email":"camilla.pini@carcano.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220603258/f17e75ea9d4645c6c43670898f07170d-1730301190"
  },
  {
    "email":"manudilu72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220767098/f238d4b161a80a04321479ef2c92c699-1730301190"
  },
  {
    "email":"noncicredolisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220832634/6866d9850753e3a1993edbcabea71cb8-1730301190"
  },
  {
    "email":"roby_delisi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220734330/c80192f4e47e6c709b6c7337c5874626-1730301190"
  },
  {
    "email":"natina23@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220898170/7cc2b674683fac22127ee7768c6fd2f9-1730301190"
  },
  {
    "email":"russoantonia70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723220865402/5d87e53fef2641ccbdad6e00002f601b-1730301190"
  },
  {
    "email":"antonella_cicoria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220930938/3d1941146f3cdf5cd2005c0c88716442-1730301190"
  },
  {
    "email":"sonia.bersanetti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220963706/49bfc92fb5b3b59ad7b6263664665a42-1730301190"
  },
  {
    "email":"erikaenzo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221029242/c3c0323b6d781d5f6b30a572e983d44a-1730301190"
  },
  {
    "email":"chiarap4@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723220996474/b95f506820a7204b6ffa0f5dea09127a-1730301191"
  },
  {
    "email":"kiaraporcu94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221160314/6fbc3d4cc3f20d663bb255d00750bfe8-1730301191"
  },
  {
    "email":"erifrl@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221094778/4200cf23b421eddae6d3d07cf830e29b-1730301191"
  },
  {
    "email":"p.abis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221193082/78db306446ca2a6b918123bcf2afe588-1730301191"
  },
  {
    "email":"simonettascarpa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221062010/e251472a698bc2b7414e6a2623cf9d6d-1730301191"
  },
  {
    "email":"agnese.scarpellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221225850/9766d045afa89c350df48c98b6c81855-1730301191"
  },
  {
    "email":"defranceschichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221291386/2688f2fb781274440c6d49f2c566a07a-1730301191"
  },
  {
    "email":"bernasconi.nadia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221356922/529d45a400b354abebe417a2b738a254-1730301191"
  },
  {
    "email":"tizirouge@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221324154/39e94c6a85f9c01128ed5eaadf867bda-1730301191"
  },
  {
    "email":"michela.zeme@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221520762/5bd984f3cc6cbf82beee58595c68af6e-1730301191"
  },
  {
    "email":"s.cagnato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221455226/ca44ae17839d58c54196d45875e6fa6b-1730301192"
  },
  {
    "email":"djste.p1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221586298/7f8d4cd45573df47e62955918cc3cc2c-1730301192"
  },
  {
    "email":"laraslalom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221651834/b4233640250257042a63080a2ee8800b-1730301192"
  },
  {
    "email":"criaddress@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221684602/c1d19b8432fe19fc231bea4056f79352-1730301192"
  },
  {
    "email":"virginiameucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221815674/4680c94bf4a456feaa226f72f548804e-1730301192"
  },
  {
    "email":"monica.mancini16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221717370/af58c3376c1aff23e98c0179b6916881-1730301192"
  },
  {
    "email":"tania.palermo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221881210/998816da82400b00320558c70c213923-1730301192"
  },
  {
    "email":"luisa.pigoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221848442/45a85bead7c61836eff89193ba4c6479-1730301192"
  },
  {
    "email":"irena.aneri991@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221782906/3e1a513e1b2504b32f6ca0d05cbc800c-1730301192"
  },
  {
    "email":"sandrapuccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221946746/0bd1e74a163ee84c8377439759ff4da5-1730301193"
  },
  {
    "email":"fm.federica.mori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723221979514/337534262c29f4f8112c2d7a0d94837e-1730301193"
  },
  {
    "email":"federica-monaci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723221913978/695fc141dd854f4b809ee0af4b34cee2-1730301193"
  },
  {
    "email":"laurigo57@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222045050/e98532732b6e3f20cbf495ed1fdd4d56-1730301193"
  },
  {
    "email":"cloralio1975@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222274426/a0ace98cb79a60081d9bc21453e98f52-1730301193"
  },
  {
    "email":"n.vanna.nv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222077818/14ea92885b34810c6b9a9364691498b8-1730301193"
  },
  {
    "email":"ele.viola1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222143354/d1d1265b5090ed61e0b5be4d26de4852-1730301193"
  },
  {
    "email":"paolatalladira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222339962/e5c52253911f0f6015c6393e35547188-1730301194"
  },
  {
    "email":"elisamascheri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222372730/08967d1c28ae4b27c850cbfb8264c678-1730301194"
  },
  {
    "email":"elenatrux@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222307194/1808c262d6302d77b125de671dd496e9-1730301194"
  },
  {
    "email":"passobrasa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222110586/ce56c58f9e1a06488474b545583d6670-1730301194"
  },
  {
    "email":"skausen@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222471034/e5d6242e6fc2ce89196ff05c9a8a54b7-1730301194"
  },
  {
    "email":"orsolaalias@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222438266/ea7687090f036b04aaf34564e7bc5ad1-1730301194"
  },
  {
    "email":"rossylongo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222569338/a3440149c2a4553d1f64d9dabf1a8f22-1730301194"
  },
  {
    "email":"lilianasabatino@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222536570/d2cb19ab104dc13340468594f99d6ea2-1730301194"
  },
  {
    "email":"francescaprinzivalli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222634874/239bb22f915d99a0d7234eabfd352afb-1730301194"
  },
  {
    "email":"terrimoretti31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222667642/1f8cad138bf4959af38a8abffd2074dd-1730301194"
  },
  {
    "email":"danielemartino4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222733178/56d21971ccce75066c33698d75ce0e7a-1730301194"
  },
  {
    "email":"clementina.n@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222700410/ef38dd33696435de1ea1d5386dff7bd7-1730301194"
  },
  {
    "email":"rasett@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222831482/23a9ee6306d34603f5478839ec37b814-1730301194"
  },
  {
    "email":"cmutini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223028090/de5a264f5677f75327b5bb97287377ec-1730301196"
  },
  {
    "email":"maryanndelcurto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222995322/0d5db0150e2f5e081837d0963c9b0208-1730301196"
  },
  {
    "email":"soniaalamia.sa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723222962554/0f14e43f3ce4d90cfa2f51535a0dd108-1730301196"
  },
  {
    "email":"martinamedri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223060858/3c5755a7f4c770127c51e8748fb26231-1730301197"
  },
  {
    "email":"cazacusfontane@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223093626/8db1b4457ead84bd34388f4056bea192-1730301197"
  },
  {
    "email":"matil.mattozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723222929786/e0c40eb149419578e8df09d4a47024b8-1730301197"
  },
  {
    "email":"federica.marino93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223126394/7d7e01765ec3037d1fd848b5f20ffb7d-1730301197"
  },
  {
    "email":"giovi_r@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223224698/618177aed197e199b9dccd04fb1c360b-1730301197"
  },
  {
    "email":"agostinisabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223290234/327931e85f09359cb6d7e7d3d7bf33d0-1730301197"
  },
  {
    "email":"deangelis.simona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223323002/01407f1b0c3d3e1d4828d353be720c49-1730301197"
  },
  {
    "email":"rominacate@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223159162/301f7391898efe0f2926a6dbb36724f2-1730301197"
  },
  {
    "email":"simo.garbarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223257466/26ee7be701bc9abd48af001a7600761f-1730301198"
  },
  {
    "email":"demichelis.daniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223355770/19016864e1655513818f9607e890a96c-1730301198"
  },
  {
    "email":"palandrir92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223421306/17458110c038da86711a6c7713f79136-1730301198"
  },
  {
    "email":"giulia.allasio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223388538/0e8115d5542a3a41df6851f8bf9b6bb1-1730301198"
  },
  {
    "email":"silvia.zampini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223454074/59d626a1039fffd56fbc17ef2b8bb2df-1730301198"
  },
  {
    "email":"simona.bellatreccia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223486842/e85a55e60cf59a92c45670345cb5e86a-1730301198"
  },
  {
    "email":"sgarbarinofkt@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223650682/4c902ca0913f91de5369adffb277c18a-1730301198"
  },
  {
    "email":"solareas76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223683450/a307c1656ba755c6ccae518df7a06cf0-1730301198"
  },
  {
    "email":"m.accorroni@studiolegaleosimo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223617914/665e3f38f4bd525e18b3b30374d12ae2-1730301198"
  },
  {
    "email":"franco.concetta77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223814522/eb9c0ba4c0bf5bdbda17f647e6bfe9eb-1730301199"
  },
  {
    "email":"rosannapas@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223716218/066313c30d634a3e08b6cf1d4ed628f0-1730301199"
  },
  {
    "email":"carlapilon@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223781754/7b97af4751fa5f5fbe767c0db34f273d-1730301199"
  },
  {
    "email":"zaccaro.maddalena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223880058/45337fdb3997fe5f396caa995adb3915-1730301199"
  },
  {
    "email":"fotomoniacasale@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223945594/bc9f5c254ae45ed5ab282786f2d2d157-1730301199"
  },
  {
    "email":"rossib73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723223847290/67f7f157f6f4dc8606cc75df4b1e8103-1730301199"
  },
  {
    "email":"spridy90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223748986/afd4c977a5849b107bbf88b6711cfc7e-1730301199"
  },
  {
    "email":"catia@dynamic-mind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224011130/93741cf64fdbaa188c8edfce97ad36a0-1730301199"
  },
  {
    "email":"anna.cenacchi1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224043898/c32ac13b1024b11d2c23e5dcbb6933bb-1730301199"
  },
  {
    "email":"simonagallo.genova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723223978362/e0d807f1ad35b63db81ace1b41368d44-1730301199"
  },
  {
    "email":"bebe19mic@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224142202/02546a5115f1b220adc8dbe94cc34074-1730301200"
  },
  {
    "email":"andrea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224109434/2708a73335a79abca7f73708254a52dd-1730301200"
  },
  {
    "email":"egeria@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224174970/8ddaa0e86887ff4dddfa23ab50ecc4ee-1730301200"
  },
  {
    "email":"chia.f@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224076666/6b00766e598b0d2af02801162b415d4e-1730301200"
  },
  {
    "email":"p.lanzeni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224207738/cfd7dfb6e20514f5718f762d65fdef07-1730301200"
  },
  {
    "email":"davefede@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224273274/ea2d0266f0424401a1ae539bd92fbf08-1730301200"
  },
  {
    "email":"daniela.pavarini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224338810/23a26b733cf2909a18416384318cc314-1730301200"
  },
  {
    "email":"natascia.cim73@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224371578/271242a765bbfb68a5404304e30302a9-1730301200"
  },
  {
    "email":"federico.durbano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224437114/be8650ddc03dedfe2b1df8c7a7c9e602-1730301200"
  },
  {
    "email":"luciapingelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224469882/cb4649a406e01ca6e005d0a655352a4f-1730301200"
  },
  {
    "email":"molinaro@ifc.cnr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224306042/bb9e27c9781e1ee6cdf6c7f10d9b63f1-1730301201"
  },
  {
    "email":"chiaravane73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224404346/54902eff3971c27795366c59007fc541-1730301201"
  },
  {
    "email":"rosdib73@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224568186/44e94b69f7b75c6f72bafc7d7676fa93-1730301201"
  },
  {
    "email":"rossib73@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224600954/1340d97718a3721014a7434bbae156aa-1730301201"
  },
  {
    "email":"stella.lina@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224502650/0b8527a2ce0e6346153b48177c59ff94-1730301201"
  },
  {
    "email":"silvia.gioso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723224535418/f5e38015a54edfc44c963dcf02219f8d-1730301201"
  },
  {
    "email":"adriana.tricotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224633722/3c44b399ee6a6ba19c21c50ca8ce784b-1730301201"
  },
  {
    "email":"ottavia.desimoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224764794/613ff7d5ff93e782921880d966f2c0c4-1730301201"
  },
  {
    "email":"luciano.gervaso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224863098/2fbc3fe9c39e1a535b82ab6526700365-1730301201"
  },
  {
    "email":"elisabetta.frigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224797562/cbe59f0d1a26849be884be8205778f38-1730301201"
  },
  {
    "email":"fabrizia.senofonte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224895866/23ab6195465009e61571cb5be51de168-1730301201"
  },
  {
    "email":"fantinmariarosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723224994170/8d89748df893c90e414ab3c2079dcbb0-1730301201"
  },
  {
    "email":"evelina.begnini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225026938/367b4f860c057d6a7c445b97f3c9a1f5-1730301202"
  },
  {
    "email":"g.zanetti.mail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225059706/f697ac69d7e0ee0973ad4954165c0582-1730301202"
  },
  {
    "email":"strambo84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225158010/0fcf3cbcdc95b3de175cb12f9427bf72-1730301202"
  },
  {
    "email":"and.toschi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225190778/aa30aa6662053c5e1cec41fdbbd189f9-1730301202"
  },
  {
    "email":"antopirovano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225125242/2b29b0bc8dbd53d73530729eb32e627d-1730301202"
  },
  {
    "email":"serepass@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225223546/530ec12ecf38a4c4634179af01645c3f-1730301202"
  },
  {
    "email":"a.giannelli68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225092474/29c62bd64d66ca4bfa0da18c71ad3189-1730301202"
  },
  {
    "email":"veronicafisco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225289082/827ec1c9330a50a0557cefdf58b103d0-1730301203"
  },
  {
    "email":"diletta.zanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225321850/2f712299b0b22ceffc322fc99ce40c13-1730301203"
  },
  {
    "email":"sacchini.benedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225354618/0a18f55d47e3043e3a6b1aed08e44b00-1730301203"
  },
  {
    "email":"serena.livori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225256314/7d314ff4d357cace6abc6b306a97fd9b-1730301203"
  },
  {
    "email":"aspide83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225518458/4a77ec94966358f396e42abd7b5777a0-1730301203"
  },
  {
    "email":"carmen.airi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225420154/23c776a51cc7996f8a665fe478e5a134-1730301203"
  },
  {
    "email":"info@studioelleerre.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225551226/fcf502d8ea54c97115225acddfba8afb-1730301203"
  },
  {
    "email":"francesca.mode@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225387386/242af302bde73aa963de29cb2118c69a-1730301203"
  },
  {
    "email":"mariangela.balducci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225485690/266a204d7afccbc480aa38563e94e12a-1730301204"
  },
  {
    "email":"elenapoli80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225583994/74b6f1a11a229fc126c6aca0c343516b-1730301204"
  },
  {
    "email":"simonaimperiale@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225649530/f1f6c8afed33f5a330daaf8883969f8f-1730301204"
  },
  {
    "email":"elisa529@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225682298/ecb65b4b63ff5202be1ce62a8251772b-1730301204"
  },
  {
    "email":"manuela.cernusco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225715066/d19231479c6a2c831482668a4b763192-1730301204"
  },
  {
    "email":"bsparnaci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225616762/977886b8f26d3063a509e2a8d9fc2105-1730301204"
  },
  {
    "email":"veronica.giubaldo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225780602/4ea867a53c7d6f1ab4c55fce49673b9c-1730301204"
  },
  {
    "email":"lisabaccellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225747834/559b31a1a02fcd0ff8db35b6a348b0c4-1730301204"
  },
  {
    "email":"orietta.negri@virgilio.itnegri",
    "url di attivazione":"https://verdissima.it/account/activate/22723225813370/f1a06d6f18c74e4fffb2743f48a2c70a-1730301204"
  },
  {
    "email":"mrt.dallabona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225878906/939a8e7330e695d87f471bbe9622585e-1730301204"
  },
  {
    "email":"antonellabuonardi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723225846138/8cba2462f405f11a6d8f3d16b3e4b3c7-1730301204"
  },
  {
    "email":"alpavia@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225944442/04a319c842644b1362f929a2a63e5ab8-1730301205"
  },
  {
    "email":"myrialou@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723225977210/deb009cb80f70e5ca55a6bb3169e4b7b-1730301205"
  },
  {
    "email":"franzosi.massimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226042746/cd791975c30c6b9fc7429898924010cc-1730301205"
  },
  {
    "email":"senzatettostabile@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226173818/8ee7b3ce93e013b4c1f863d4b369235d-1730301205"
  },
  {
    "email":"valentinaulmi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226206586/9bdca66e7848ac271bd827e289c0fd07-1730301205"
  },
  {
    "email":"saki32@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226239354/d778ec8ea99f58b0f817f69a27b02522-1730301205"
  },
  {
    "email":"valeria.gardini@peopleresearch.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226141050/9d0f13bf2679566f5e646569873990de-1730301205"
  },
  {
    "email":"selvaggiadeltredici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226272122/c5e37f5814b8f25a4b832d847593aedc-1730301205"
  },
  {
    "email":"chiara-ori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226337658/c850e607709def31df9936f0214b3065-1730301205"
  },
  {
    "email":"benedetti-f@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226501498/b07a06fe739f92a7ec4081e967420120-1730301205"
  },
  {
    "email":"ale_p79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226468730/8bdfac3d53ea6ce2f11df08cb55552f0-1730301205"
  },
  {
    "email":"stefania1176@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226534266/5176c36d02202e4e0bc2add8dde72091-1730301205"
  },
  {
    "email":"dott.scarpa@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226567034/cd69eacaf0d332209a547062f6cd8cf7-1730301206"
  },
  {
    "email":"monica.giudy@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226599802/de0090aa71bb3452f14a59625bf6deb4-1730301206"
  },
  {
    "email":"enrica.denicola70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226632570/5423d6d405d0d4076c1905b0d62c3fab-1730301206"
  },
  {
    "email":"sele.patamia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226730874/875761e75c8cd9715feb93cacd0331f2-1730301206"
  },
  {
    "email":"anna2002@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226698106/e75204331bd5d8c6a6c937ca4378d816-1730301206"
  },
  {
    "email":"danielabortoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226796410/55d0517ce8309cad8819e79b334ecaf4-1730301206"
  },
  {
    "email":"manuelacarcano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226829178/173b376bd3bd835caa303dbca636d2ff-1730301206"
  },
  {
    "email":"benedetta.barbieri@alitalia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723226894714/8df017957c90f98f2317b4b606a4408e-1730301206"
  },
  {
    "email":"paolascandola@amministracasa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226927482/5bb840185c06d5b6b244539fe923538f-1730301206"
  },
  {
    "email":"milenasolimeno3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226993018/45d1afc093314ab5f62aff614640edb0-1730301206"
  },
  {
    "email":"vallevalli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226861946/0d9788929c78ea8df9db03b1f2cfea32-1730301206"
  },
  {
    "email":"danielamaniglia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723226960250/1f58fcb4dbeb37913195dac7b99638ff-1730301207"
  },
  {
    "email":"milli62@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227058554/856e42166c4fa92700f8cf2ce5918f4d-1730301207"
  },
  {
    "email":"rosida.zotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227124090/9731c05e53281eddcc7f9192c238af73-1730301207"
  },
  {
    "email":"sabrinarosati@tagetik.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227189626/1b5020e082d3d6d655aaf55c8ad55b5c-1730301207"
  },
  {
    "email":"giuliacorsi88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227091322/b6b1fec07458fbdf222658d172c2c0ee-1730301207"
  },
  {
    "email":"silvialombardini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227156858/c6d8de945046688eab2ba39eefa5511e-1730301207"
  },
  {
    "email":"nilde.re@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227222394/f59119844b3cf537f02b11443e9d9bb0-1730301207"
  },
  {
    "email":"valemac11@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227320698/602fa46f6dffc67ddb6a9c14d27ac241-1730301207"
  },
  {
    "email":"gaia.s@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227419002/a22a8511fd749e64328c05149e2cef49-1730301207"
  },
  {
    "email":"zetaci.cobianchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227353466/e8975bab4138342e4d572fff06d62709-1730301208"
  },
  {
    "email":"cbrachettiperetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227484538/7e05cf5406584b013b07ebe93d7effb1-1730301208"
  },
  {
    "email":"sfagioli71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227517306/6c3beb7953fac05ff6600ceaa070fbd2-1730301208"
  },
  {
    "email":"gloria.banzi21@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227582842/0482ea7402f1a1edcf9f60dc8eedddcc-1730301208"
  },
  {
    "email":"ele.fornari07@vitgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227615610/a7c70c80a7dff5b74d83f27079772635-1730301208"
  },
  {
    "email":"daniel@valentour.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227648378/f77fc22dcb512e427475bf3f31c03e06-1730301208"
  },
  {
    "email":"danijel_veznaver@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227550074/a841d6887b24f9a1efdf89a30ec7c817-1730301208"
  },
  {
    "email":"apollonia70.mb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227681146/613c85a31e08ba2c5dacdf87c7793aec-1730301208"
  },
  {
    "email":"patriziaciuffarella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227746682/91f57633e1b7b2d8247b5b4bf2a3b3c5-1730301208"
  },
  {
    "email":"p.chanel@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723227812218/c5520c3da9238c615125e0aa24c7a6cc-1730301208"
  },
  {
    "email":"massimo.franceschini76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227844986/f95574110976ba4ca35a13ba09e0f393-1730301209"
  },
  {
    "email":"jfharris@sky.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227877754/baa7e124704b80b8d496303cb5542b30-1730301210"
  },
  {
    "email":"tiziana.becchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227943290/4c719902af3d00f2e00b82461e0fb016-1730301210"
  },
  {
    "email":"marziabancomina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227976058/f55e185843c3fb1c04a13ac2aeb2744f-1730301210"
  },
  {
    "email":"s.raffaelli@adriaticamobili.com",
    "url di attivazione":""
  },
  {
    "email":"irina_kekelidze@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723227910522/898c905cd74c076704197edd76455d65-1730301210"
  },
  {
    "email":"castellisiena77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228074362/e599f281fe9416ed0e36ab66b83692d2-1730301210"
  },
  {
    "email":"francescadechiara84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228008826/e39ba9011b0173cf26899133f0fdaeb9-1730301210"
  },
  {
    "email":"insomma@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228172666/6206f2010b74e6953f139992e7890d80-1730301210"
  },
  {
    "email":"joegiulia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228238202/23e11c3f2fc61d17c1e61e1d40f5699f-1730301211"
  },
  {
    "email":"dany2006@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228205434/c9763cbe3b05775d736177f9b5100bee-1730301211"
  },
  {
    "email":"info@posturare.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228270970/6aa582d4d7d0c24e7bec733b620db256-1730301211"
  },
  {
    "email":"dianella.roncagalle@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228336506/9ac61a7d367a37ce45ed2992449b36ea-1730301211"
  },
  {
    "email":"martinapeveri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228369274/9c9f6e8988ea660196b6a6fc77693c9d-1730301211"
  },
  {
    "email":"abbruzzese.michela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228598650/b87bb0ae612b4a5577a4405cbc41eff2-1730301211"
  },
  {
    "email":"vchiais@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228500346/c9f1652da3d5b2a13daf7bc17930a596-1730301211"
  },
  {
    "email":"elena.cappellini72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228631418/51f2f819a1791299c5276246d9b301ee-1730301211"
  },
  {
    "email":"kdallavalentina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228664186/3740fe79365c2ccda91f9885ff565072-1730301211"
  },
  {
    "email":"ele.olly@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228762490/e210d52362aa4b38316ee6295f98d965-1730301212"
  },
  {
    "email":"info@villahedy.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228696954/3f8045e456daaf499296bfa0cf8fd1b9-1730301212"
  },
  {
    "email":"samatagiribuola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228729722/6ea5929043cede84a0ded6efc6fc6092-1730301212"
  },
  {
    "email":"midasnack@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228565882/28408ce0fbed5fbfe90a682b533b4844-1730301212"
  },
  {
    "email":"nicholas.cancilleri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228893562/42264a1ed438b51b3e34ef293b488c76-1730301212"
  },
  {
    "email":"ci_80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228828026/7c52d2804bf59f5e59c8c977c8e55c78-1730301212"
  },
  {
    "email":"lauras.graphic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723228860794/468e82f8aa1c9f9afb0815f6d3c2d6a9-1730301212"
  },
  {
    "email":"m.giro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228926330/49c1c2f3c1f6181dc0911376b19ab7f3-1730301212"
  },
  {
    "email":"marina9188@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723228991866/79bdab0e424eb6cb400cb2f94ce24b5f-1730301212"
  },
  {
    "email":"michela.sarlo@unipd.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229057402/eedc70d557edd06d11a0ba2bc4343a03-1730301212"
  },
  {
    "email":"francescamollica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229024634/404dc5c83551b82cf25911688097ce45-1730301212"
  },
  {
    "email":"segreteria.roveglia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229188474/6e988f842a57e8e7c8b2b8a0860ddddc-1730301213"
  },
  {
    "email":"scarsi.abis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229090170/41d3d003c91ad0acb2d77657b1a83a35-1730301213"
  },
  {
    "email":"pallina1504@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229122938/fccb32f79d67433041cd8ef20d122c44-1730301213"
  },
  {
    "email":"kitty71c@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229286778/5e86d96cbd69ea72782222f978f9515e-1730301213"
  },
  {
    "email":"antoabramo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229155706/57dbd53bc7cc7c81ef6c5461c0aa5fbf-1730301213"
  },
  {
    "email":"chiara.albarello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229254010/a37a362d58ef7e148ad116786dfeb109-1730301213"
  },
  {
    "email":"lalla.67@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229319546/5bc5eff74b1602b9ec530f58215eab34-1730301213"
  },
  {
    "email":"giadaperotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229385082/65fedb6f31f71f0873a777d8034affe2-1730301213"
  },
  {
    "email":"tanya.danylyuque@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229221242/809535c7cc263716540a56583e5e3bd2-1730301213"
  },
  {
    "email":"zeliani.laura@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229450618/63b4f1ad284f5483b2697d811e9300fd-1730301213"
  },
  {
    "email":"veliscek.andrea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229483386/92a76913c0078b3cee8cd91e92f7bfdb-1730301213"
  },
  {
    "email":"laura@moncatini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229614458/25e8b6d6ab1f7c0bbd79fe2ecfe70b04-1730301214"
  },
  {
    "email":"elisalder@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229548922/10083ca01b0d7e3ecddfd9a4951cccf6-1730301214"
  },
  {
    "email":"masi@istat.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229581690/7c1027f03fd367908fbd56884d3407f4-1730301214"
  },
  {
    "email":"paola67_ap@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229745530/234c9d554cf7265485965139026eb2c6-1730301214"
  },
  {
    "email":"gambini.alessia26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229778298/7a7099869c523983a2085b99cdbc7e6c-1730301214"
  },
  {
    "email":"claudiarinaldi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229647226/ba69026f202c933f3bf6e675d2aaa715-1730301214"
  },
  {
    "email":"v.destefani@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229811066/f82a3c4f706e0a4e2eabd61f9e18ff67-1730301214"
  },
  {
    "email":"accattoli.c@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723229843834/49bc4eb84a9f5f604d6aaf9c5e457b20-1730301214"
  },
  {
    "email":"angelapernice@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229876602/051126f4c1b673fe97559c49043b1175-1730301215"
  },
  {
    "email":"v73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229679994/71b9e7ba16d9152c9f03deaca5382237-1730301215"
  },
  {
    "email":"chiara8916@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229909370/96f738a710d46c447a367caa0cbe08b3-1730301215"
  },
  {
    "email":"holzner.christine@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723229942138/09ed13538016546fcf38943e276d393f-1730301215"
  },
  {
    "email":"barbara.francone@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723229974906/c552beabdb01f244b82811ca2447e22b-1730301215"
  },
  {
    "email":"peluso.anna@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230073210/60ae650b4da42df769242b8b3b019754-1730301215"
  },
  {
    "email":"soniagiaco11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230040442/7c49784a929cacc496595bd30d85d856-1730301215"
  },
  {
    "email":"denise.ross@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230105978/95392c6cbfc34565390c6ca722280367-1730301215"
  },
  {
    "email":"barbaraporlezza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230138746/fef9e537768cc98c6879ce1509088bb7-1730301215"
  },
  {
    "email":"r.loi@lamaddalenapark.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723230171514/d2b4571726d2ab6c8aab9c43c4a01815-1730301215"
  },
  {
    "email":"sonimat@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230204282/19f3dd927d1351fa54d1075799e296d6-1730301215"
  },
  {
    "email":"verduchisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230237050/16824bc94eec6e53c5c705d178425942-1730301216"
  },
  {
    "email":"silvia.buratto@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230269818/cf192453f1701c7a129c282186c79102-1730301216"
  },
  {
    "email":"caterina.valentini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230302586/9c0b1159620a716855f275f4e3c65a1f-1730301216"
  },
  {
    "email":"carletta.dr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230335354/0ad0cac7d2e29979a937c70fe1464605-1730301216"
  },
  {
    "email":"pavin.stefania@icscittadella.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230400890/31f363b94a542db146249881190c4818-1730301216"
  },
  {
    "email":"segreteria.roveglia@lbero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230368122/89f6171f19e18311b2c141aa26b83dad-1730301216"
  },
  {
    "email":"sandragalliano.74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230007674/98796ebbd22cbcbcba933fe986683d57-1730301216"
  },
  {
    "email":"drgennai1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230433658/c03591435bc0553533fb2334c1352ad1-1730301216"
  },
  {
    "email":"piemmegi80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230499194/9924c7ba70bcaae254807167929ce198-1730301216"
  },
  {
    "email":"lilianab83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230466426/bcc56b0d9cf372b3020855e3962ffa23-1730301216"
  },
  {
    "email":"mrfilice@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230531962/d051f4397dd93555887de5e300045974-1730301217"
  },
  {
    "email":"claudiabugnano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230794106/041013b01cd5b2b60b5b9462ada3b03a-1730301217"
  },
  {
    "email":"ararozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230663034/00369ff399ee35f3d0b79495dd16523c-1730301217"
  },
  {
    "email":"petrawaldner@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723230597498/c8d28b8d18d64ff2dff2074a7e26f0ac-1730301217"
  },
  {
    "email":"c.astaldi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230859642/9ce3334692c1d950f3b73dd6bcb296ad-1730301217"
  },
  {
    "email":"lauretta280910@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230925178/270db775a636f0161f1511621e889ae8-1730301217"
  },
  {
    "email":"federica.longhin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723230892410/731f6b6141e467bcf9e2540b4d06f9c0-1730301217"
  },
  {
    "email":"melina.rosato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230957946/eee4a649ad5cad0b84dd79d6045c823c-1730301217"
  },
  {
    "email":"giada.zanotti89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231056250/af459c7eb037775b53ee7343e1852b6a-1730301217"
  },
  {
    "email":"simonamaggiolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231023482/f2a1b5f7e10d895c8b50250ea0f1a3bd-1730301217"
  },
  {
    "email":"mapirrone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723230826874/3368e10e192a381f747c1562a1376e7d-1730301217"
  },
  {
    "email":"raffygua79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231089018/5620b748df9a70a8b4ce12921946656e-1730301218"
  },
  {
    "email":"bpatrizia1962@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231121786/e7d9eda39800c16e618f5ea639acb870-1730301218"
  },
  {
    "email":"silvanafaraci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231187322/092f09dda31a587143fe46c9e0e60755-1730301218"
  },
  {
    "email":"d.bonci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231220090/f2c31cba873b115680ab8fa833b5e45c-1730301218"
  },
  {
    "email":"paola.cortesiarbusti@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231285626/42ecc607d282f40cebd08fed675b93a4-1730301218"
  },
  {
    "email":"azzonig@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231318394/b6058cabdfd457c770b5171ebe0d7ea5-1730301218"
  },
  {
    "email":"mariajose.pugliese@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231383930/7c2a22bcd9e62e0a2e6e61a7738fe500-1730301218"
  },
  {
    "email":"p.eirene@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231449466/26e7d63fe9b90a7249a259b0d02cd8dc-1730301218"
  },
  {
    "email":"amministrazione@rossiniservice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231416698/7511d62189dcb27fe8f49dd4afa4df58-1730301218"
  },
  {
    "email":"vanhelsing1967@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231515002/ce28d34b0c635b4912160ccac3472607-1730301218"
  },
  {
    "email":"chiarina2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231482234/5aba94e19d3ffe9360c218f95b7a5578-1730301218"
  },
  {
    "email":"alexadiste@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231580538/e1b2cce2094edf555c64bb40c083fe38-1730301218"
  },
  {
    "email":"katia.riminucci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231646074/61f00820984ccf52bda3b247f142112b-1730301219"
  },
  {
    "email":"francesca.tredici@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231547770/70e127de5784086005e146d6f29f5adf-1730301219"
  },
  {
    "email":"chiarahilary@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231711610/4d44e796fb134007449683df1997a81b-1730301219"
  },
  {
    "email":"merigio82@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231678842/e57070bd5fa937c1f5deefac4b64e931-1730301219"
  },
  {
    "email":"gmmazzei@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231744378/c42408615eaa8b5f02452fbf27b59ae4-1730301219"
  },
  {
    "email":"seveli2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231777146/2ea388e5243dd3aeb7a0ee44d4c1245b-1730301219"
  },
  {
    "email":"purple87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231809914/ce5511513852809f6f1049e9ddb14d21-1730301219"
  },
  {
    "email":"c.maddy@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231875450/27d835415f9fae67e5402e8e4ac6979d-1730301219"
  },
  {
    "email":"stefania_sarti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231908218/fcade847c1d8a650c2685b2ad2ff696a-1730301219"
  },
  {
    "email":"robertaacqua@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231940986/470dcd01340d9d87310bb3a28a6094fa-1730301219"
  },
  {
    "email":"francescasantoro@fratellilabufala.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723231973754/c6f76d54cd4229cd102238decd9524b3-1730301220"
  },
  {
    "email":"monikannen@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232072058/95b5db06d09ec310a8b940d3303b4ba9-1730301220"
  },
  {
    "email":"djcinci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232104826/01c9c961087e08cad9c4c74bf89fe44c-1730301220"
  },
  {
    "email":"focaccina.bis@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723231842682/28296faea5a5cf267a4d351392259ef7-1730301220"
  },
  {
    "email":"studio@massimorosaarchitetto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232137594/7bf7a280dde17a6e7e9e94f9599df56b-1730301220"
  },
  {
    "email":"stefaniamarchini07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232203130/c65724e23c62ffe8c1f5e90889605133-1730301220"
  },
  {
    "email":"francescapaleari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232170362/bc42d0b9fad9d0fb85811bc69f2da3ab-1730301220"
  },
  {
    "email":"rompinade@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232235898/1c72ea3315d07aa0a600cf5ff14e5eee-1730301220"
  },
  {
    "email":"mariaritabarbaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232268666/7caf158af3fb06cdfdf568880e93bef0-1730301220"
  },
  {
    "email":"michelaceschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232366970/2cb8a5d77011392eebe53125e2018611-1730301220"
  },
  {
    "email":"manipura21@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232334202/d105103eb7bf1ba56e245566967583d9-1730301221"
  },
  {
    "email":"eleonora.scarpetta@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232432506/f59f0e8da95fae2a168c918ce3bcbd91-1730301221"
  },
  {
    "email":"eliparducci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232465274/f89f84cd67d2cdabb3c646ef882dcf90-1730301221"
  },
  {
    "email":"fedeasti_caviglia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232498042/28330480dfc66c8b34d76197fcd8505d-1730301221"
  },
  {
    "email":"lella.d@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232399738/5aaf3f6194d14fc189770763adfe6b68-1730301221"
  },
  {
    "email":"e.serena81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232563578/215c0b0de47befd6784b6f0b08230ead-1730301221"
  },
  {
    "email":"sutera.grazia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232530810/e1f2527aa10404a054b133f9d3aabb1d-1730301221"
  },
  {
    "email":"nesli.sulejmani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232694650/72bdf35a0ea5e8ac6e947418506943e7-1730301221"
  },
  {
    "email":"claudio.guerra@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232661882/1a2c0bebd41aefa264d54d0d26410e04-1730301222"
  },
  {
    "email":"fra83for@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232629114/c0ccbf5f99edea6aa1eb3b309db3f14f-1730301222"
  },
  {
    "email":"arigrassi1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232760186/f01d84880769ba70b378db28137cc309-1730301223"
  },
  {
    "email":"garage.auser@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232792954/9119dee187dea9224fcaaff5a87e3639-1730301223"
  },
  {
    "email":"sara.giuseppini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232727418/88c58b36e2b0d46c3a5e5cea7a727768-1730301223"
  },
  {
    "email":"rpetronela81@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232858490/0c930160d3c137e39c440def41ffd2c4-1730301224"
  },
  {
    "email":"lisacecchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232891258/01f58e406d7a61260f25dd71645a151e-1730301224"
  },
  {
    "email":"estetica.luisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232956794/f2ea609de72d47a8db0e3c129b77aea9-1730301224"
  },
  {
    "email":"cantoni.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232825722/9d3263a7d6c5155f64fdd075f2d8b53e-1730301224"
  },
  {
    "email":"angelifrutta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723232989562/ee59dee8052211e5a0c62a1280065f85-1730301224"
  },
  {
    "email":"max.mezzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233055098/14a549998c44e316f983faaa1e152bb4-1730301224"
  },
  {
    "email":"paolameta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233022330/10e06224e30e36c222c9e524939e0771-1730301224"
  },
  {
    "email":"martarebellato.84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723232924026/d5b9070c459e4862e31786f2a1f9a40d-1730301224"
  },
  {
    "email":"elibui@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233087866/0865e2338fe9ad281eebd55e44045b4c-1730301224"
  },
  {
    "email":"silviamazzanti83@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233153402/b526ea78eb08d3b384feebf1ad954c78-1730301224"
  },
  {
    "email":"paolacardiello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233251706/9caf96a6ac8b81f879e5189293017e2c-1730301225"
  },
  {
    "email":"arienilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233186170/82b792286f95470550596b82611fc5fa-1730301225"
  },
  {
    "email":"berbecvica1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233284474/7129e38935d6674061d7ca98ea6e9407-1730301225"
  },
  {
    "email":"lucia.fiorino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233317242/edbe61e382b62810f456af20e39b9208-1730301225"
  },
  {
    "email":"earmature@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233350010/f43f4bae262677c0b86a92abfb7c2d68-1730301225"
  },
  {
    "email":"claudia@geanet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233382778/b2d8b8c8beefed9655c852e36ccf8ba8-1730301225"
  },
  {
    "email":"nicastro.ba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233120634/19cff91130d76382a29edf4771fe6c7d-1730301225"
  },
  {
    "email":"valentina.mangone@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233546618/3e079265c6e72c04fd023abeb8c80fe0-1730301225"
  },
  {
    "email":"eri.cocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233579386/c4dfcc582074a075f552f1965380d619-1730301225"
  },
  {
    "email":"barbaracurti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233448314/dc362b0580c2678acc89d1ee37591dbe-1730301226"
  },
  {
    "email":"lisidj@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233710458/561c69954ab14493e9b632e38c565ce4-1730301226"
  },
  {
    "email":"sary80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233415546/aabe941f41c9782b15aa814016062421-1730301226"
  },
  {
    "email":"francescacorvina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233644922/cd546daf951b6d3666756eb19530dfe6-1730301226"
  },
  {
    "email":"baldassarri@invalid.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233677690/ec5dda6d7c7113fd452bf7d6738b01f3-1730301226"
  },
  {
    "email":"marilisa_casolari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723233907066/1f50a8887b8765684da654ecad3b52bb-1730301226"
  },
  {
    "email":"pieste68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233841530/7542e5aca09313a726e0751d191574ce-1730301226"
  },
  {
    "email":"fantastica201069@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233775994/316009916a025598263396d24cf0ecb7-1730301226"
  },
  {
    "email":"b_peyron@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723233939834/d04bb04728bc7dc1d2f6aa532e260a4b-1730301226"
  },
  {
    "email":"kiara24180@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234103674/6b6926a0fed07ea61344a5e0cc3fc58e-1730301226"
  },
  {
    "email":"giovi.gualtieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234070906/0af63f7b3062e53119c36b343209636e-1730301226"
  },
  {
    "email":"s.monitillo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234038138/1f1343b634e56a1ba041acb7e55a9f70-1730301227"
  },
  {
    "email":"valenova94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234136442/22be51cd91a6ce440a65ed772e84b240-1730301227"
  },
  {
    "email":"luzioelisa84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234201978/8e4ed1104b51e3dbdb1cf07da0e91b2f-1730301227"
  },
  {
    "email":"chicca_castagnola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234234746/e7a3455c9e82cd40b69b32f772f693b2-1730301227"
  },
  {
    "email":"edyd72@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234267514/69ed0e66fcc06a3c059c25e2b2b8d6f4-1730301227"
  },
  {
    "email":"raffapier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234333050/902eecb1ad80b34c1ddd3fdf299309d6-1730301227"
  },
  {
    "email":"mg.tinelli@mariagraziatinelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234365818/0bcf8a5b030abb429f0baf7ba4891f7c-1730301227"
  },
  {
    "email":"manue.ga@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234398586/046b6f10432ac593f7b28dd8276270ca-1730301227"
  },
  {
    "email":"andrea.fosio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234300282/a1688fa8b569b27b3557034621a10034-1730301227"
  },
  {
    "email":"sara.bisol@ogilvy.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234431354/a2b65c97b9370af833f3e2c9c6244a4e-1730301227"
  },
  {
    "email":"barbara.lampariello@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234529658/9616fa574419142a7fa11aaf052e0e7d-1730301228"
  },
  {
    "email":"stellalast2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234562426/116d17e59e4be583ffd75b27f2254195-1730301228"
  },
  {
    "email":"sharon.guidastri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234496890/824309bb0fd770d4f19516e82aa729d7-1730301228"
  },
  {
    "email":"giuliap91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234464122/7d625995e9277be1cbcb7f2856d71e41-1730301228"
  },
  {
    "email":"sere8120.sb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234595194/e7a1e86301ac892bdb7dc15defc839c6-1730301228"
  },
  {
    "email":"patricia_modesti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234627962/d45a1903b498862826db6ca34850734b-1730301228"
  },
  {
    "email":"sabrina.pasolini@alice.sm",
    "url di attivazione":"https://verdissima.it/account/activate/22723234726266/87699db4a367ec5dafa7d088e518743b-1730301228"
  },
  {
    "email":"angelacafaro76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234791802/78fc3ef2a620101d22f395e6784bd077-1730301228"
  },
  {
    "email":"f.cappelletti@itacomnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723234922874/46ba1f18cd316545b9c7cfe8cd2ad5fa-1730301228"
  },
  {
    "email":"marilenaalbanese73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234693498/1df775d7e3e5a1afa73f60b0de713a2f-1730301228"
  },
  {
    "email":"giusydemaio04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235086714/5497b120bb2cd89113959eee59d3658c-1730301229"
  },
  {
    "email":"raffy.ricci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235053946/e4750ca7b551a851d00256cb965738a0-1730301229"
  },
  {
    "email":"anna.bassanetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235021178/43e3f2bfdadbc35a680a34fd9a8cffc6-1730301229"
  },
  {
    "email":"trnsde@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235152250/160b9138324bd14b4e05c3cf25a0c66f-1730301229"
  },
  {
    "email":"landrico@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235119482/422d59ac10b4a457a52c9660461aa42c-1730301229"
  },
  {
    "email":"elisafarinetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235185018/ad22f131c18f4c32e634dcfdda3d7c81-1730301229"
  },
  {
    "email":"emanuelaferri10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723234955642/636c3b5ed2159717d44a864aaec0eb39-1730301229"
  },
  {
    "email":"rositagiurato@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235217786/a6c9c332f3b67ed60b5942807e06125f-1730301229"
  },
  {
    "email":"barbara.miscetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235250554/1590a9b4bc2acda5cc89a916f42964bd-1730301229"
  },
  {
    "email":"francesca_leone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235316090/4245d63db6fcaf6212cf0fba999ae11e-1730301229"
  },
  {
    "email":"katrin.barbara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235348858/181b167b1f18d21d29826eb3cf182139-1730301230"
  },
  {
    "email":"ilaria.benetti@bfgsrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235414394/3246808a1e290b585d445795c548be90-1730301230"
  },
  {
    "email":"arecin@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235447162/3320387c9bd03adf7950f320a9939958-1730301230"
  },
  {
    "email":"rosicalienni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235479930/ec41e9363f222de1259ad94c44d51210-1730301230"
  },
  {
    "email":"rosella.modaintima@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235381626/4ebf9910503fd9d062447db63ff01172-1730301230"
  },
  {
    "email":"terryespo76@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235545466/9a2ead6aff0334829df8a7b8c4e919a3-1730301230"
  },
  {
    "email":"cristinatrab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235578234/88351cb8e0c0c7833521ca760de8a177-1730301230"
  },
  {
    "email":"federica.trombetta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235611002/4d754eda46cfaf1696c546898ce07cf4-1730301230"
  },
  {
    "email":"germana.beha@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235709306/36d526b101a718c4ada7264a9524cc15-1730301230"
  },
  {
    "email":"anna.to53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235643770/b2465baa3d0f62331474e437034a13ff-1730301230"
  },
  {
    "email":"antonella09d1996@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235676538/ba4f65f9e757e5f500e95b035b5b1174-1730301230"
  },
  {
    "email":"eleonora.simone@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235742074/71f436145c7ce99e86300059a34bbbc6-1730301231"
  },
  {
    "email":"patpinn@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235774842/a0935723c8f63de015974c81b2265bb8-1730301231"
  },
  {
    "email":"claudia.cicognani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235807610/fb76cf2a1c837da92256d58483f51d49-1730301231"
  },
  {
    "email":"mhdecandia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235840378/4d7c483c7962bead17b5d62366d1c000-1730301231"
  },
  {
    "email":"cristinachine@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723235905914/3c84ec60508fc1d5640a10ea0e202a7d-1730301231"
  },
  {
    "email":"rt.robirobi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723235971450/68ee4a928a3c96997afacdcd99342cf4-1730301231"
  },
  {
    "email":"kismalidya@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236036986/2d3de3b95fe846812e0ec2c9f4522e09-1730301231"
  },
  {
    "email":"barbara.cimatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236004218/cb73db9c3075c95fa4514d2a3be49063-1730301231"
  },
  {
    "email":"deboracroia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236069754/0b0e33ec70927a75a683114ddf3bd4d0-1730301231"
  },
  {
    "email":"aacima2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236102522/d26d83fb5da5a457a3b36e4ffd28f011-1730301231"
  },
  {
    "email":"vlrulian76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236233594/857340cb8cf82ddc73204509c851201a-1730301231"
  },
  {
    "email":"francescamarozzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236200826/6c86a25ec0503ed4cd007cc033ef3238-1730301231"
  },
  {
    "email":"marphy_mel@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236299130/57cee5ee62ed3cb86466d311978d946d-1730301231"
  },
  {
    "email":"mrlais@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236397434/927ca7eb726aa77517d086b93bc4f976-1730301232"
  },
  {
    "email":"alicebrianza98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236331898/58b4427dffc8a25efe0f89e4ad8fb5af-1730301232"
  },
  {
    "email":"ghioni.enrica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236430202/5b8785c4b1280626dda8e269e68c04aa-1730301232"
  },
  {
    "email":"elaconsonni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236462970/212b7ec2bdb64847e62a2d76e3d826c1-1730301232"
  },
  {
    "email":"dani.tbb@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236495738/2e25b4f8b4afebef9e1c028e3f2125d2-1730301232"
  },
  {
    "email":"evemelis87@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236528506/518f4d1ba89066b8f0200ebb6c4b585f-1730301232"
  },
  {
    "email":"emanuelac80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236561274/1e4aca1635b6b30114e338cf58777434-1730301232"
  },
  {
    "email":"gionovembre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236626810/9f774e4c4c2eb7bd867262ceb89e1887-1730301232"
  },
  {
    "email":"rossella.ale@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236594042/b95beba3250fe0493abac3a992d73a03-1730301232"
  },
  {
    "email":"mariagraziabarili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236725114/93fd8351f8f6e34d1b44cc37302bbfa2-1730301232"
  },
  {
    "email":"fedemaiols@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236692346/ff9d90a89d96fae461c391cb30d542fe-1730301232"
  },
  {
    "email":"celestesarno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236856186/9f5f6fb1a5b80aa0afd7c963e854b3bd-1730301233"
  },
  {
    "email":"marzal@mac.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236823418/a03ab65ae509c3db307ee13b6ad7f11c-1730301233"
  },
  {
    "email":"ninnirom@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236757882/e21c8266bd04f7256b3b1cfec4443797-1730301233"
  },
  {
    "email":"alessiac@mclunk.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236888954/da4c54f24c1b40d2014919f9ed4c0e40-1730301233"
  },
  {
    "email":"cla1980@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236790650/0ed6c5618d56bb682c63de116a2a500e-1730301233"
  },
  {
    "email":"moira.momola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236921722/126ba8b1afab242c14a994b3298bc2f7-1730301233"
  },
  {
    "email":"raffariccaepino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723236954490/5a051c7daa65d1ae098e7d655926a2c6-1730301233"
  },
  {
    "email":"fabriziabroglia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237020026/30dd79e77aab1a9b4ce02658823e4838-1730301233"
  },
  {
    "email":"noris.malagoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237052794/92acdef54e8962bcbd72ecc0022d7821-1730301233"
  },
  {
    "email":"federicaquadrini23@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723236987258/685cb20d70d6f469ddde0a24a80a6c77-1730301234"
  },
  {
    "email":"claudiagraziani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237118330/d72b4ec2a73e57dbad363a4c4174e852-1730301234"
  },
  {
    "email":"isabellaspinelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237151098/468ef67e7e4fa1f13c935b33c8af3d7f-1730301234"
  },
  {
    "email":"simo.brandas@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237183866/c40723282e3b2887ff744b29f742b9f5-1730301234"
  },
  {
    "email":"stefi_bio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237216634/0459d128aec4f18d17f889bc4f00554a-1730301234"
  },
  {
    "email":"v.pimazzoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237282170/e4beca47161ddb7db4004d250fcc1bce-1730301234"
  },
  {
    "email":"giulia@giemmegas.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237347706/ad37d0b8540dff96becb091e0586956a-1730301234"
  },
  {
    "email":"lopace@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237314938/8490f41fc62a558035870f59267d7944-1730301234"
  },
  {
    "email":"palmste@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237249402/b26b954d4c9f5dfae7fe11b6bf0c056f-1730301234"
  },
  {
    "email":"laurailari74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237380474/b6b55b6a4e99668a4e4f5ac39305d6d6-1730301235"
  },
  {
    "email":"avv.rosalieto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237413242/2bd374d6740f3d7de9ab741c033d080c-1730301235"
  },
  {
    "email":"cristina-bianco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237446010/416a0bb4e48a717022122d25cbc95f12-1730301235"
  },
  {
    "email":"agenzia537@groupama.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237609850/3ec50ef4af7748f5680ccb3aecd66fd7-1730301236"
  },
  {
    "email":"eleonora.mazzoni2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237642618/53cd510a418ac033dd78bc4dcebecbf6-1730301236"
  },
  {
    "email":"raffaela.piras@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237675386/8c5edbed0c525a1c33217b61b9c4d659-1730301237"
  },
  {
    "email":"robs.moretto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237708154/64abdf3f295abedea0749a4165a16518-1730301237"
  },
  {
    "email":"piratizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237577082/147eed1a24f37cdde150aad2ed52797e-1730301237"
  },
  {
    "email":"amatulli.isabella@fruttattiva.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237544314/428cae0685dbe576fabd0bd36ee79326-1730301237"
  },
  {
    "email":"wondervero78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237773690/552295ceb2b66a2087c1288c636d4b19-1730301237"
  },
  {
    "email":"segreteria@protoxide.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237740922/949db33b62103302c1f3c97b0fe7e54b-1730301237"
  },
  {
    "email":"martina.badii@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237839226/5ac662ed25a4122acde61c97961877b5-1730301237"
  },
  {
    "email":"francifont@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237904762/9a2a55bd70e0e63a38c8c0d693c69d05-1730301237"
  },
  {
    "email":"patriziat64@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723237806458/49afa101d0b8600544451cb88997fde6-1730301237"
  },
  {
    "email":"b.biasella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237871994/672f661388baefb4d8d3220a173f6061-1730301238"
  },
  {
    "email":"felicita.c@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237937530/7bff21a91d34bf892e772f2f8c1054ad-1730301238"
  },
  {
    "email":"valeriasaladino@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723237970298/e922b48779aebf3cb2cda6f43d2cf160-1730301238"
  },
  {
    "email":"marta.alderighi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238035834/7f23b490989c69d8536f81e2c94d1647-1730301238"
  },
  {
    "email":"buralli_elisa007@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238068602/1e51592908a6265a5c22ee2730a18212-1730301238"
  },
  {
    "email":"unequivocallystar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238101370/60f374f68146edd7f6dca0b1ecac30e3-1730301238"
  },
  {
    "email":"bea63bea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238265210/150a0854bf2458934d8413f360198801-1730301238"
  },
  {
    "email":"monica@spaziomariani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238297978/d6ddb291bdd49b3a31c76f676f9a2edb-1730301238"
  },
  {
    "email":"elisa.pannella1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238134138/9078a2f0bd144621b02640821065f86e-1730301238"
  },
  {
    "email":"stefaniafortuna@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238363514/a0c7bb791ee417453cadbeaac5caa4e3-1730301238"
  },
  {
    "email":"sabry.tadde@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238396282/5dc210a743de3a0a2a51f61769a66b07-1730301238"
  },
  {
    "email":"zerinetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238330746/9d267fc4c418df5f239dc5001df69f2d-1730301238"
  },
  {
    "email":"macora73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238429050/58f25e1ec9ece0bcff200e4c312032bf-1730301239"
  },
  {
    "email":"tizy@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238461818/0d72c1089055413e83b6fef29bc8a1b4-1730301239"
  },
  {
    "email":"simfalk82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238527354/762b80be5b15326a657075be40efa870-1730301239"
  },
  {
    "email":"guido_9@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238494586/a17384e9272299806d72ae2280234a82-1730301239"
  },
  {
    "email":"laurariboni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238658426/5401f2318ae0c110ec7675bcbdef7b46-1730301239"
  },
  {
    "email":"f.bellonedegrecis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238822266/705d338ac3ca7c3fd903c6022e6ac0d0-1730301239"
  },
  {
    "email":"mici020579@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238723962/a41bf8adc367bdb15a3a20cac0cc061f-1730301239"
  },
  {
    "email":"rosamariacristini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238691194/dd7bbc0876c4a75ab1813a3d16347a79-1730301239"
  },
  {
    "email":"alinghi_90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238920570/96e3433bfbe0bafe3998cfaf5fcb4839-1730301239"
  },
  {
    "email":"gianattimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238887802/fc724a57365bc414accce884cb0228e6-1730301239"
  },
  {
    "email":"antoschiappacasse@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723238953338/3b7972f20254458fddecdb072a19c41f-1730301239"
  },
  {
    "email":"iride.fantoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238855034/b313b133e45766eec553c37c30d41872-1730301239"
  },
  {
    "email":"dimensecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723238986106/947a38ad4ab271a8e7781fb20d0fb0f3-1730301240"
  },
  {
    "email":"martino.barba@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239117178/c8028c0d666625df13cb3086d918dd89-1730301240"
  },
  {
    "email":"letiziastaff@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239182714/edbf7ae1958ec980f94fcaae0485cf65-1730301240"
  },
  {
    "email":"paolodecostanzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239018874/7a4b365427fe56d6d429b53e5b53ac02-1730301240"
  },
  {
    "email":"mauriperri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239281018/8d6725c74ec70aedbedf1ed781660183-1730301240"
  },
  {
    "email":"edoardotroiani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239084410/22ae3cce3b5c6b974d1be180d654392b-1730301240"
  },
  {
    "email":"saraiacchetti7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239313786/7cc09a3e15338f3531d1e93f5203f2d0-1730301240"
  },
  {
    "email":"martinasanavio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239346554/ed6227b4306865bdd0235ce545dfa193-1730301240"
  },
  {
    "email":"alipiras@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239412090/ee8f357ddf527b000e9c179d084f9cd5-1730301240"
  },
  {
    "email":"giuseppe.materni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239510394/091ae428260c66540598cce1f09dc3e1-1730301241"
  },
  {
    "email":"favali_claudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239477626/8ad1ab1ca4c0e4c273c7ab5e8dd6cbc9-1730301241"
  },
  {
    "email":"babyargo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239444858/1857b3e3b104a5dcecc953b3dd76ec1b-1730301241"
  },
  {
    "email":"danielemurra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239608698/1180dad50e81866b56ab1a0e894357fd-1730301241"
  },
  {
    "email":"heidi34@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239674234/61192e6f9cfe643975f19cebadedb0fa-1730301241"
  },
  {
    "email":"anna.maria.mercuri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239641466/be17d2d9acc2c8a70852e76145a358c5-1730301241"
  },
  {
    "email":"jessica.ru@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239575930/172e7be1d5693d928f79ed1977c82714-1730301241"
  },
  {
    "email":"cvinante@trivellato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239707002/575418611a76dc72b055a49336d4b732-1730301241"
  },
  {
    "email":"paolapellegrini86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239772538/13e635513f4a6717c55a507f19c0e11c-1730301241"
  },
  {
    "email":"linrad@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239805306/c0c4af688766207e994790b68e4fda65-1730301242"
  },
  {
    "email":"raucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239739770/69212fce1e87308e4bdf6a4c9ad03ae2-1730301242"
  },
  {
    "email":"giosa95@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239870842/0b0110bf6b350ca5ca9f2d9bd104ebe1-1730301242"
  },
  {
    "email":"lorena.collu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239838074/fdbcc1ea6cf2f774448e063e38e774d6-1730301242"
  },
  {
    "email":"toretta80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239936378/ee98bff6fe1d676c5170407fe6105cab-1730301242"
  },
  {
    "email":"martuccia.72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240034682/1b0541810288fa739c78ae3c1015edf9-1730301242"
  },
  {
    "email":"gianluca.sogus@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723239969146/a49c430bc4138d1452faa30f8dafba50-1730301243"
  },
  {
    "email":"lorenzo.patrizia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723239903610/a1f6486b62176e72ebbcf037bb50e958-1730301243"
  },
  {
    "email":"gloria.bimba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240067450/4a4edb123afd8343293d91d04027fad6-1730301243"
  },
  {
    "email":"elisabetta.polese@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240001914/d56814fd84a412dfaef4c23f3df9fb13-1730301243"
  },
  {
    "email":"lisave80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240198522/7105e65cb267fdb2cc20888bbc2dc3d0-1730301243"
  },
  {
    "email":"manuela.gatta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240264058/48ce8655bf99b24cb64312bba0a03f10-1730301243"
  },
  {
    "email":"azanelli@comecer.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240231290/28950a9ccb8ac106fef33a9d6f50703d-1730301243"
  },
  {
    "email":"paolacamilleri76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240427898/e0bec86679cfbb59c436a98668a12fd1-1730301243"
  },
  {
    "email":"chiaramuracchioli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240493434/631813ed2c1bf6442aa9f3ab306301a1-1730301243"
  },
  {
    "email":"vadeco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240591738/6ba352c8df7efc7ca709089f2d743831-1730301244"
  },
  {
    "email":"didomenicomimi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240526202/9e0104b4716e11cf66f088213d5fbffe-1730301244"
  },
  {
    "email":"stefania.maio1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240460666/4f2dc2271c8db8bf63058ffef5bf5202-1730301244"
  },
  {
    "email":"silvia-pisani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240558970/cd2691e3b82eb5c2a12f1b16723c08ac-1730301244"
  },
  {
    "email":"parise.stefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240624506/dd96d416d44d16136174392f01261ca8-1730301244"
  },
  {
    "email":"serena.frullini@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240690042/2b69173981ca35f51a93b379da139a15-1730301244"
  },
  {
    "email":"debora.coppola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240722810/7ce2fb02d6308883454963e9838a29e3-1730301244"
  },
  {
    "email":"rodriguez.borra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240755578/7588689ee8474c6b02b8b91436baa1ac-1730301244"
  },
  {
    "email":"maddalenaspeziali@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240788346/2da5cc0f01643615089cb4212383f4ee-1730301244"
  },
  {
    "email":"ba.zannini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240657274/33f6e9d35036f8fd80bafd7862ca9dee-1730301244"
  },
  {
    "email":"vivaieffe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723240919418/fe5425841c6932c20ce7b7d046171a0b-1730301244"
  },
  {
    "email":"erikamarasco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240821114/8a92c0c7d300cdd0d34735d6dbb6975b-1730301244"
  },
  {
    "email":"delucamariangela@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240853882/7679cf02f292b5dcd5410f2ed3686c57-1730301245"
  },
  {
    "email":"showroom27@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240984954/f5e244a8c2e7dae0e9aa49058774260d-1730301245"
  },
  {
    "email":"illaryanselmi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723240952186/98a455f9e880ba67a67f501934170ac2-1730301245"
  },
  {
    "email":"caterina.camillo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241017722/07a6dc580f22463ff315e8ba92b255dc-1730301245"
  },
  {
    "email":"vaniamanzi2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241050490/539cf238a2daaf09b11deb58b3b9b4c0-1730301245"
  },
  {
    "email":"a.loprere85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241083258/1ffb2db3e627bb10309c73c17216a3e3-1730301245"
  },
  {
    "email":"pierangelavicoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241181562/519c09d2889793084bb9d50bc0ff92bd-1730301245"
  },
  {
    "email":"renata@calvicugge.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241214330/9b2ce0051714bc7b6a4aa0db3ea6cb64-1730301245"
  },
  {
    "email":"dimensioneimpresa@pec.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241148794/a253ed0d785f4fc01b2a27d225d2cc9d-1730301245"
  },
  {
    "email":"elisalucchesi@aruba.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241279866/fa73d98a4cdfca400dc4278b982da919-1730301245"
  },
  {
    "email":"angy81_9@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241312634/f11eeb49a0841e4a24a50cbdf3b85180-1730301246"
  },
  {
    "email":"chiccatesta@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241345402/9438e84ec968560d73aeedbb19683a68-1730301246"
  },
  {
    "email":"monica@immobiliarealmulino.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241247098/b85a25354e447f7d01033fe1236e422d-1730301246"
  },
  {
    "email":"simonafirrincieli77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241378170/b4300636166eaa169f88030b722cb344-1730301246"
  },
  {
    "email":"olivia.sacchi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241476474/48d5bc6afe04694463309018a49959ba-1730301246"
  },
  {
    "email":"fabiotettamanzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241443706/4d22b9a727fbb86948ebea22499486ea-1730301246"
  },
  {
    "email":"ary-iaia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241509242/c9e9ad3aff176b9581caa21eae0e6a4a-1730301246"
  },
  {
    "email":"agata.tandoi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241542010/18172c6a77bc38360984fa3c38bd28e8-1730301246"
  },
  {
    "email":"martamorlacchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241607546/ab22ffcf46ac76c7ee80518fcd94736f-1730301246"
  },
  {
    "email":"valentinaabate@3-a.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241574778/f294483f0552d7c29dd53dc6b3b41705-1730301246"
  },
  {
    "email":"roberta.pugiotto1964@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241705850/016b218de6020882fd7080e749bea918-1730301247"
  },
  {
    "email":"danielaperrotta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241640314/1e0514f9b8d55866ab9d3657ef2edbcc-1730301247"
  },
  {
    "email":"depaolaelisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241738618/6ff1b516aed60ee5f983bfce2e82c845-1730301247"
  },
  {
    "email":"maristellaporetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241804154/d83d5d777b1cba5a601e292d6c5f9666-1730301247"
  },
  {
    "email":"info@hotelfiorellasirmione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241836922/c626213a24ccaecaf2bcf5ac13b5c296-1730301247"
  },
  {
    "email":"mila.barbarotto@roedl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723241902458/0842f82cbae46fa939b9da344cf1c59d-1730301247"
  },
  {
    "email":"annacolacchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241673082/0aa2d8d59748cbb0ec9e6b17357088f5-1730301247"
  },
  {
    "email":"argentinatedesco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241935226/3b35d1474bf3dead818f5edf9de94acb-1730301247"
  },
  {
    "email":"tardivosilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723241967994/2d3cbf343c6437b73a6c23680c5f06d4-1730301247"
  },
  {
    "email":"juliana@ecantone.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242000762/b2d5c91a3698e8306472b9c2b9d8bbd3-1730301247"
  },
  {
    "email":"alessiavava@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242099066/577f48d86c3c00e19d95618f3a2993ba-1730301247"
  },
  {
    "email":"mr.saltari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242066298/791e2a0368e2bbbb92f79c05d072359c-1730301247"
  },
  {
    "email":"di_bari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242164602/8077773e8d46d3181cad0605d093f96c-1730301248"
  },
  {
    "email":"donatellaspiga@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242131834/dead62510eb72e093f4037b1b99464bd-1730301248"
  },
  {
    "email":"lindola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242230138/8c4506c28e3108d1fcc230e6e3bf1de3-1730301248"
  },
  {
    "email":"luisasica5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242295674/68524165ce536ce0de91ebbe26dca476-1730301248"
  },
  {
    "email":"tamara@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242361210/e7bbf2e1794f58c56af885bf14bb311d-1730301248"
  },
  {
    "email":"robertaippoliti6391@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242393978/cae58e3a85c46be2ced9265669a8e1f2-1730301248"
  },
  {
    "email":"silmea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242262906/0e40e921366fc0a4f9bb962b484e3259-1730301248"
  },
  {
    "email":"marilena.falco@eurocreamerchant.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242426746/4e18f9d7f8a71ac2fc7c69f22a42e51a-1730301248"
  },
  {
    "email":"marisa.casciani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242525050/8fa7a986a449a4c09ab2a7fe72a88f70-1730301248"
  },
  {
    "email":"annacicirello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242459514/512ef3a2b73519682187ffe828f48c10-1730301249"
  },
  {
    "email":"emy1984@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242492282/0f0a6ab86a1f55409b8768ff1375a3ed-1730301249"
  },
  {
    "email":"coach04@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242557818/c40f3b07410c3c01d0094fcfeeb962ae-1730301249"
  },
  {
    "email":"occoffer.elisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242688890/aba3fe001b94096479cd8b14bf1f016f-1730301250"
  },
  {
    "email":"marti.naa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242721658/4b9e26064c393f5faef73e658aba0d26-1730301250"
  },
  {
    "email":"simonettaodella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242852730/6355cef12cd26a33a33f4332bbbec612-1730301250"
  },
  {
    "email":"gio.gu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242656122/bbfa0cf088aa51fa60eb391b60afa872-1730301250"
  },
  {
    "email":"federagazzi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243016570/cc427c56308ace1bdc832d1039a43031-1730301251"
  },
  {
    "email":"elisamardegan@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723242885498/0a8c9d5629201dacf174428f7f09a3ad-1730301251"
  },
  {
    "email":"alessandra.mancia.am@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242918266/892ac6810d037e21eb3596165a23eed9-1730301251"
  },
  {
    "email":"denisetatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723242983802/f85a847ac10ed55e88d12eeae511a81f-1730301251"
  },
  {
    "email":"acodin@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243082106/9fe14df1b02a012ce7353c594e63ab67-1730301251"
  },
  {
    "email":"anna.cogno73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243114874/804400626212690bc32096e365becb6a-1730301251"
  },
  {
    "email":"simonetame@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243213178/1484abe261d3a6f9bcb313c57bb1782e-1730301251"
  },
  {
    "email":"alicemalaspina123@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243147642/624bfddb0510598819f730768779085b-1730301251"
  },
  {
    "email":"raffabon77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243278714/d22f35cc1d264c3dd4c5d26e15ac3295-1730301251"
  },
  {
    "email":"miedo7476@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243245946/e365c9524e408c6b2860f74792468c49-1730301251"
  },
  {
    "email":"chiaraechiara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243344250/30d63302e71ab351e21ddebe68345d36-1730301251"
  },
  {
    "email":"sonia35011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243409786/10330ef3f724c223255106ea4e87b299-1730301251"
  },
  {
    "email":"fiorellabianchi4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243442554/6f8f51de58bf7be5c28137e23c7e69c1-1730301252"
  },
  {
    "email":"antonietta889@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243475322/b0fe07819507fdf7a551d20c35e53a83-1730301252"
  },
  {
    "email":"plvcaffetrucillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243540858/71268a9837d5d7d7b8d5a227a15e91b1-1730301252"
  },
  {
    "email":"annalisaisa@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243508090/07f1959c8ab2f2f831b91cb98d8fd77f-1730301252"
  },
  {
    "email":"carsessa@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243573626/0a76a884e6d5083cd044ac7240784936-1730301252"
  },
  {
    "email":"lorena.maria@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243606394/bf6c18dba38e5cf032a017930e638647-1730301252"
  },
  {
    "email":"merifantinel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243639162/2e0f595f5bd15dae8de1535a6e75a94b-1730301252"
  },
  {
    "email":"silviagasperini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243737466/65a9c0d04a0f015cb951a44ea6e81d4f-1730301252"
  },
  {
    "email":"chiaragabry1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723243671930/da509b41b006801ee2298d8e4168803b-1730301252"
  },
  {
    "email":"ilaria.rocchi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243803002/2ed69d4dee012830581429b0d2e1f663-1730301253"
  },
  {
    "email":"roxana.rossoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243835770/6af4580de25e35ed5503ead9b19f5b21-1730301253"
  },
  {
    "email":"barbara.destefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243901306/dc331ff0ef75e8b20a05a136edf91876-1730301253"
  },
  {
    "email":"luisamicillo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243704698/faba19db6469bfc51c9d0e784f8eb0c1-1730301253"
  },
  {
    "email":"schiappacasse21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723243966842/0c5993d8ef95c18988a08f50a0d301b6-1730301253"
  },
  {
    "email":"elvira.gigante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244032378/6bfa8dda5c473c96d1ec1a560e3062d3-1730301253"
  },
  {
    "email":"robertabenni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244065146/2d8142904a61cc9ddfb8531389c47b61-1730301253"
  },
  {
    "email":"valeria_lenzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244130682/c0036d0ae61d780d262cc74b85a51a57-1730301253"
  },
  {
    "email":"sarta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244097914/d2db6c9a6c1ac5752a0ca2b4833f0810-1730301253"
  },
  {
    "email":"giulianapascucci1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244163450/c71ebd972c12188f6c2e54df6d2f9c30-1730301253"
  },
  {
    "email":"cristina.delpinto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244228986/76ed750765bd3d9b96972aef6a25a5f6-1730301253"
  },
  {
    "email":"mariaboschetti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244196218/506bb660e168b17d2eb7d5e79b124c6b-1730301253"
  },
  {
    "email":"samanthazanaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244294522/6655de61a3f75ead1cbc5901ddf91199-1730301254"
  },
  {
    "email":"renzigroupservice@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723244327290/534c67eedc763a14288128f0fbffa425-1730301254"
  },
  {
    "email":"lauragiammanco79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244392826/f7b89708a49d1c7baf8db283f1d264e8-1730301254"
  },
  {
    "email":"alessia.bullentini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244360058/99eb9f9b1ecc90997d35e4efa26c236f-1730301254"
  },
  {
    "email":"sara.vettorato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244491130/a6620a54245b168c9557aa91844c0078-1730301254"
  },
  {
    "email":"pennacchia78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244523898/85564cb326a008bcb8c5117169d929d7-1730301254"
  },
  {
    "email":"rinaldimariagrazia8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244425594/acffc84368bb4cfbd757e1d6228541b4-1730301254"
  },
  {
    "email":"a.cellesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244556666/d062d50940be9398b16b8087d69c3205-1730301254"
  },
  {
    "email":"fabriz73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244622202/1bb4e19b3d040e8f9bbc6f8b91feaf50-1730301254"
  },
  {
    "email":"afilippi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244687738/cacea85e33291c511b86248725addabb-1730301254"
  },
  {
    "email":"valentinapetru@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244589434/5070bf54314572ebe3a251e2beb25c84-1730301254"
  },
  {
    "email":"alepaperina@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244786042/4bb3f2a7e08f96755642b8b9d9df376f-1730301255"
  },
  {
    "email":"cinzia.ridori@greenutility.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723244654970/7b8a7e48a5735dffb7232624f869cf4e-1730301255"
  },
  {
    "email":"chycorr@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723244851578/042fe01b21d0447d7074a692f7fa042d-1730301255"
  },
  {
    "email":"martamase@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244720506/be40a1ef5b6c8982670a7b36b3e01fff-1730301255"
  },
  {
    "email":"camillazanella85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244949882/befbf6481d1671a3bc16e1462b827458-1730301255"
  },
  {
    "email":"katiascarciglia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245113722/a21e046865dfe2b4d9d729627dd7d40b-1730301255"
  },
  {
    "email":"ceciliaminenna@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245048186/cd054d2af96d3766358b735d4783dfc1-1730301255"
  },
  {
    "email":"clagiolor70@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245179258/3641999de8773a4371c3987dfad70be1-1730301256"
  },
  {
    "email":"crisdegiorgio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723244818810/8d6d833f4a24cbec1eafd96053831b9a-1730301256"
  },
  {
    "email":"soniaseverino361@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245015418/50bdea4207f5cf6c094975ae9ddfc1e7-1730301256"
  },
  {
    "email":"matenistico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245212026/4d5c5565878f8a6db5e132c95feb32ed-1730301256"
  },
  {
    "email":"fanellitiziana83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245244794/b77e1f03aef9224fbfcfe73b9448c91f-1730301256"
  },
  {
    "email":"lauradisarra87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245277562/890f110f6655e69cecca92b93845828b-1730301256"
  },
  {
    "email":"alexandra.74@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245343098/57bd921c4dc4e141938dcdcf6ce16768-1730301256"
  },
  {
    "email":"pessinagiulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245375866/25ba951cfd23bc72eaeb47858e97c774-1730301256"
  },
  {
    "email":"giusipi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245310330/84837d8eb1767ea27d1524928408aff6-1730301256"
  },
  {
    "email":"giuliadeg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245408634/5366038dfba60fa7bd6d461e1f151b89-1730301256"
  },
  {
    "email":"sandranenci1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245506938/51f3d03188f6d0558c4fab249fddf7f1-1730301257"
  },
  {
    "email":"moniaitalia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245441402/89f263fa2d75f5e3e3d583185019e81a-1730301257"
  },
  {
    "email":"giuliafratesi4288@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245539706/935a7455a163d87025afd328388e3974-1730301257"
  },
  {
    "email":"larafagiolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245474170/90ca3fe8147f572fa7dbf360d416e392-1730301257"
  },
  {
    "email":"valevaleric@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245572474/61cd6ac63fdcb7d9a6dd2b4af74c6349-1730301257"
  },
  {
    "email":"michela.maccarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245605242/f44c0f4911f5301b402b0f861903b040-1730301257"
  },
  {
    "email":"bambulella86@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245638010/69fa17810b1fb51417c3c2c08e502541-1730301257"
  },
  {
    "email":"maria.camiolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245670778/047174d95ee85b27d65c5883daca0a09-1730301257"
  },
  {
    "email":"tiziana.maccani@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245769082/15f4f90240d49ef83455888caa579273-1730301257"
  },
  {
    "email":"wielleich@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245801850/b0a4bc4bc63c5c8f773d95771e1b8ac3-1730301257"
  },
  {
    "email":"antonella.studiocenni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245834618/5be3658cc82bbd7b0b2dc85d2513c0e4-1730301257"
  },
  {
    "email":"rafner@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245867386/088f853f1346fc31704088a01e33fac6-1730301257"
  },
  {
    "email":"graziella.anesin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723245932922/c4232ea459fc120cc2fa0e0717b07068-1730301257"
  },
  {
    "email":"gabelene@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245965690/6e68e6d715e5f4813bfbdec1b6214f6b-1730301258"
  },
  {
    "email":"dirceadeiana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723245998458/be78a1762a5868cf1d3efb84b743c51e-1730301258"
  },
  {
    "email":"valeriamoroni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246129530/0dcb3fe92a319855ead15e08ffff55d2-1730301258"
  },
  {
    "email":"ziaica2010@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246096762/b77e3ae6eac6b5f56467007d3e966eee-1730301258"
  },
  {
    "email":"vanessa.maggio@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246162298/1ef4ab15aaa51522e66b7c6bb6fe310b-1730301258"
  },
  {
    "email":"e.mambrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246227834/903976fc3427362ff20d933f8bd07ea0-1730301258"
  },
  {
    "email":"filippelli.daniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246195066/7513033d17887901b487347713f7448c-1730301258"
  },
  {
    "email":"livia_montanari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246293370/27e6920af161f3798abde7f8ee6ccdea-1730301258"
  },
  {
    "email":"michelapanelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246391674/3afb40a0164aa64a415dcef433a136c2-1730301258"
  },
  {
    "email":"laugag1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246326138/bc548def1406821cb4bf9ad5f3134f29-1730301258"
  },
  {
    "email":"simona.copat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246260602/bbdaeef1939820f1757fa6a3e6036b4b-1730301258"
  },
  {
    "email":"cinzia.dipaolo1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246424442/633ed9dfc4ea6662a439f1d06936d677-1730301259"
  },
  {
    "email":"ottaviaoss@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246522746/18a3613059ea790180ea13382dfb4a5c-1730301259"
  },
  {
    "email":"luisapisicch@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246489978/1be00e526f10f353d2dc6470900d74e3-1730301259"
  },
  {
    "email":"gabriele.gabrieli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246457210/1cae698cb8fdeec61b5ae081de6b0b8e-1730301259"
  },
  {
    "email":"lorenarighetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246621050/be35f6a3e349451f6384c7f57a410cb7-1730301259"
  },
  {
    "email":"dlombardo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246588282/06e16e7185ecba4c42284d65315ce275-1730301259"
  },
  {
    "email":"blondy_girl_79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246686586/b19fd124f97a2e8c944f2160d9267f0b-1730301259"
  },
  {
    "email":"curlyeli@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246784890/701196996ee00a1b37175b1dbb0df0e8-1730301259"
  },
  {
    "email":"elena.putti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246752122/cdbdce2658ea483a280991ea96ad92c2-1730301259"
  },
  {
    "email":"alessiagiovanella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246817658/0fcad216a145bc165b397265991b8186-1730301259"
  },
  {
    "email":"sissylovely@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246850426/3048dee36b24d5009fba6a570f8bbac9-1730301260"
  },
  {
    "email":"martaroncalli@ied.edu",
    "url di attivazione":"https://verdissima.it/account/activate/22723246883194/186f62864eb739d6b09d57c6d14b9415-1730301260"
  },
  {
    "email":"virginiario@plasticaltosele.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723246981498/7ba59fc009a06ac5fb965e240c86c801-1730301260"
  },
  {
    "email":"paolamosini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723246719354/888b66ae2673625786bf6643bbf30b5d-1730301260"
  },
  {
    "email":"donata.maggi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247047034/bdab75d6e8f17010e70ee9b271c3bb6d-1730301260"
  },
  {
    "email":"info@bagnisas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247079802/0e59ceb5f10770da952a3781f3fcbc71-1730301260"
  },
  {
    "email":"rossana@pocai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247145338/6a9ad78e072b0b23a9d60d4a927042a3-1730301260"
  },
  {
    "email":"lorenza.picco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247178106/4fa8110777f2bc29dd5dafb338437bbc-1730301260"
  },
  {
    "email":"lisasoleluna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247014266/41539ccc0c9f9afbefadd2246bcecb48-1730301260"
  },
  {
    "email":"giancarlofavali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247210874/9e06337596a9818ab472260dfe697b14-1730301260"
  },
  {
    "email":"makiki@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247243642/fbf75de003fbea36bb46e21bc275ed48-1730301260"
  },
  {
    "email":"info@hotelgiardinobibbiena.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247374714/f8a8871658804d5ffd8fb0b212ca16d7-1730301261"
  },
  {
    "email":"atamar@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247341946/ba75801f570722a55652bebbe38ae591-1730301261"
  },
  {
    "email":"morelli.ilaria@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247309178/3cb79a8f3b79ac3d64768187620ecc85-1730301261"
  },
  {
    "email":"pikycolombo@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247538554/2a3e53120b6c040943f684f914fe692c-1730301261"
  },
  {
    "email":"superbova@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247473018/f0bd7be2cab7b9538eba82e67b700641-1730301261"
  },
  {
    "email":"giovanna.sibourvianello@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247407482/2ae88f57e37197eb23f2733a6edeb1f2-1730301261"
  },
  {
    "email":"giovannibruzzone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247571322/89c1671c31c09b5299637c7aa9e0f675-1730301261"
  },
  {
    "email":"biondi.caterina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247505786/8a96ab17c0afa2edc92692af69c41893-1730301262"
  },
  {
    "email":"boselli.chiara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247604090/0a67a6b8081b8dabf677341e7bca3773-1730301263"
  },
  {
    "email":"danielamarinoni73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247636858/563cb400e6a357e620b5406171d89aa0-1730301263"
  },
  {
    "email":"spancrazi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247702394/ecfda1394ea5d787696be79bbbf3926f-1730301263"
  },
  {
    "email":"valsusaporte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247669626/281d5c3ae0e8d583b198e508548116a1-1730301263"
  },
  {
    "email":"silvia.mordonini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247767930/b9a5e8ab49ef97d980ea30c7f1cc0bc3-1730301263"
  },
  {
    "email":"teresa.fiume@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247800698/1f155c6d4e5335bd742fe41c21fdc542-1730301263"
  },
  {
    "email":"saramarte96@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247833466/60bc60ba04bc1f9c80e184779ae5ca19-1730301263"
  },
  {
    "email":"elisamini69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247866234/f5e0f111eef842219509dc74bfe868ff-1730301264"
  },
  {
    "email":"michela.zattoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247899002/0bcb8dff70da79f0513094f9afff7d15-1730301264"
  },
  {
    "email":"helenia.capuano@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247931770/0909ac4a165b0ae9e9f8241222964dcb-1730301264"
  },
  {
    "email":"uoweme20bucks@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248030074/612b9192f46cdafc471c091116e09180-1730301264"
  },
  {
    "email":"gretabosio87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723247997306/5571bc72bb06943b2786f2fc78bd6974-1730301264"
  },
  {
    "email":"eleonora.tognetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248062842/098679fab7d982fdb30c627903116889-1730301264"
  },
  {
    "email":"pe.82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723247964538/2318ef293de0c50e7bfbca9a8799ddd7-1730301264"
  },
  {
    "email":"sbangiola@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"lisa.giorlando@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248128378/235f3bd227364b18ea1885ece4415934-1730301264"
  },
  {
    "email":"mravaioli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248193914/11b4966b33898b040769c9a21e72c95d-1730301264"
  },
  {
    "email":"giusycapasso90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248226682/0cfc8e774c2c96bcae3edd86ca7d5477-1730301264"
  },
  {
    "email":"patriroby@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248095610/0b847fb46556cb58762c1b40959cdc3f-1730301265"
  },
  {
    "email":"ferrante.laura@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248259450/fdc7f94fba7189e06f76a6099b99186e-1730301265"
  },
  {
    "email":"donnavita84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248292218/09e106d9113a2242b1e14e1565dd32dc-1730301265"
  },
  {
    "email":"lillywunsch@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248324986/56c1d0fe04e7fa8a19607726fbbc704b-1730301265"
  },
  {
    "email":"ericalaversa@siazsrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248357754/fba8e9e37f9e41bd81a71ec5696ca51c-1730301265"
  },
  {
    "email":"simovik90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248390522/f0397a40349675f77444c82a552f446e-1730301265"
  },
  {
    "email":"lisa.baldini89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248423290/93d6dd1ffc54ed624d35e0dea1db0147-1730301265"
  },
  {
    "email":"denise.moranda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248488826/65e5c98dc7229678937845fa3deb2b56-1730301265"
  },
  {
    "email":"ilaria.codeca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248521594/408caedcb92338551fd0949d67766072-1730301265"
  },
  {
    "email":"nannielisa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248554362/167dbeca159d261b91c845e9d53de989-1730301265"
  },
  {
    "email":"davide.dellopreite@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248456058/ea31d39486ac1eec79b68f4baf1835a9-1730301265"
  },
  {
    "email":"cbrambillasca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248652666/62bb56e903d6f408bbae687c87549403-1730301266"
  },
  {
    "email":"paolamontanaro26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248718202/607be3e33a0050b409f7d853c65ae214-1730301266"
  },
  {
    "email":"clau.80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248750970/99f354986c421e81ba6b22b3296fd64a-1730301266"
  },
  {
    "email":"robertarimessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248587130/8cff0d2ef92a77a267b7be63f56a2704-1730301266"
  },
  {
    "email":"s.incaviglia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248619898/0c9c40629da1d19b6033b6e015225bbc-1730301266"
  },
  {
    "email":"doriana.forti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248783738/272cdf0fa99056e5d643bb9b86762953-1730301266"
  },
  {
    "email":"paoladiasiago@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248882042/b571409a657a3a439ff3d93c5c92c372-1730301266"
  },
  {
    "email":"nica78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248816506/88badfab4d90f4852846f127fda9a70b-1730301266"
  },
  {
    "email":"aneta.gardzisz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723248914810/5f6b9e81371e1b5b56c6c011a19e4edf-1730301266"
  },
  {
    "email":"stellina160773@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723248980346/fa326b5ffe836ccfc8289b02ae29b22e-1730301266"
  },
  {
    "email":"valentinadiana7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249013114/c3b27df9e928431f881446a6cc6d26e9-1730301266"
  },
  {
    "email":"luciaferla@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249111418/91f1a54e21cfcf32d0dccbabb14258e1-1730301267"
  },
  {
    "email":"aletta76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249176954/4a4c10709e63539af98cfe54d71446ad-1730301267"
  },
  {
    "email":"stefanopioppi77@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249242490/91551d9779df33c92b2e1f7c6de26a20-1730301267"
  },
  {
    "email":"deboram997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249209722/173e3052851e4e5b618627b825b1e3b3-1730301267"
  },
  {
    "email":"andreadiasiago@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249144186/b2ce03e01e641701ab49c0539ae7d0c8-1730301267"
  },
  {
    "email":"melaniaduraturo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249275258/ad66e3ed7022afaf8a2274b2530bef20-1730301267"
  },
  {
    "email":"mgioport@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"andrealanzi1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249308026/75e3f8c4509be513d9ab0e172f0da41a-1730301267"
  },
  {
    "email":"antonellacangelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249340794/b2695b77293b03744f06ae43a50b98c8-1730301267"
  },
  {
    "email":"francesca@pocai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249439098/15b28625c9ec36ef33bb07d48c1b4b14-1730301267"
  },
  {
    "email":"day84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249570170/9c2157606e1b93f8561325d89039b0d2-1730301267"
  },
  {
    "email":"nadia.biffi@gruppomg.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249537402/43b7f1d957e17b056b36480251b15d32-1730301267"
  },
  {
    "email":"mariellaerre80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249602938/34b4beb99660a47fa2759a9ebc5812b4-1730301267"
  },
  {
    "email":"borges.susana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249668474/b74d64ad9bd1a43d8365f0f39bee44e6-1730301268"
  },
  {
    "email":"vbargigli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249504634/18aa11f6aa46d5fd9731c59f1d948ece-1730301268"
  },
  {
    "email":"isabella.capriotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249635706/9845c56155ab1db0dee9728d045f1154-1730301268"
  },
  {
    "email":"annase@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249701242/a4cd02dc70eaf466cdf04e55e73e5523-1730301268"
  },
  {
    "email":"alias58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723249865082/5192d90c575e4f512d7961e0c0d35088-1730301268"
  },
  {
    "email":"gaiotto.silvia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249766778/3871000d71a5e746e2188ac03d47849c-1730301268"
  },
  {
    "email":"raffaella.vergara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249832314/13d340156197063c030900a88e1b4026-1730301268"
  },
  {
    "email":"katia.casalgrandi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249897850/cc3cdef81867bd7a12cd3e33a9e1fd3c-1730301268"
  },
  {
    "email":"patriziabalducci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249963386/9910ffe5c143a09019e85d9c3a8d9480-1730301268"
  },
  {
    "email":"reika72@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723249930618/c49c6d2f5e9d7b6a067b90c5b2e5f628-1730301268"
  },
  {
    "email":"simonacocolin@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250127226/5ed7a5c38c0a1666cd5f128f1ded3924-1730301269"
  },
  {
    "email":"satomasi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250159994/cc78db0b334ac2a9db9d473bf5fd82a3-1730301269"
  },
  {
    "email":"martina.mattioli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250192762/4ab2b4dd196fc3abde795f61712fec5d-1730301269"
  },
  {
    "email":"rosaelisa06@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250225530/ac1b47972cc9381cbf8a3392a8f6356f-1730301269"
  },
  {
    "email":"bistoletticri@comsod.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250291066/d90249765a52cd7a7174d71ee749bd42-1730301269"
  },
  {
    "email":"pietrocenci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250258298/e963073dc52422d98aa029803375e7a8-1730301269"
  },
  {
    "email":"the_dancer88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250356602/6449f9bc8781fad617d4d12725c0cd96-1730301269"
  },
  {
    "email":"maxlisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250422138/aa977e2d9d0ad3d50f377a52ebc10725-1730301269"
  },
  {
    "email":"luanadomanti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250323834/4442bf14192478851c1fe8d8253cbffa-1730301269"
  },
  {
    "email":"laura.giusti3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250487674/5e590c6ce709db485ba45b335e0330e0-1730301269"
  },
  {
    "email":"gaetanacongiu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250553210/d698aefd22ae29c249fe52ff3b35d3cb-1730301269"
  },
  {
    "email":"fedepandolfi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250520442/ccddc7bab30cf4a39c57fd83e882e1e3-1730301269"
  },
  {
    "email":"barbara.pellandino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250389370/23faac1b435f268a1f14751e6a0d6ee3-1730301269"
  },
  {
    "email":"rossana.84@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250717050/f48d733e41d9fd8631355a8be1e5786e-1730301270"
  },
  {
    "email":"valeruffin@antoninoparaggi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250651514/dbf5f8f838fb924a75f4d00a24e7e304-1730301270"
  },
  {
    "email":"filomena_epifani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250684282/1ed1f70b9dc2a0b3a5bde657efc8d3ef-1730301270"
  },
  {
    "email":"miky.m88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250585978/bacebb8fed292b626eab28088e620bad-1730301270"
  },
  {
    "email":"angelacoppolino@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250749818/2e154b819851c95672e384492da6944b-1730301270"
  },
  {
    "email":"olimpiamauriello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250913658/07c92930d71c27643d5d2184e9cb7d56-1730301270"
  },
  {
    "email":"claudia@giannicarboni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250815354/ca68c92a267943a2e036f897e7d74849-1730301270"
  },
  {
    "email":"da.porta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723250979194/01e9e33695d32468be5ed321792f6196-1730301270"
  },
  {
    "email":"saradalprato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251044730/619c649f83fc9762144b7046725725e6-1730301270"
  },
  {
    "email":"simonapasseri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723250782586/5359e1318b69a8b4b1b0c602c719d220-1730301270"
  },
  {
    "email":"serena.robello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251077498/327300dbff517357c5e73e7ed5a50a51-1730301271"
  },
  {
    "email":"marilena.franchini78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251110266/93a321486d493f93c5a2f0caf507a0a0-1730301271"
  },
  {
    "email":"francescaconticelli@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251011962/7b3c6c90c065aaae7c184d7044471fcd-1730301271"
  },
  {
    "email":"lcristofani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251208570/27c7def2d9736d2b3c849aec013443f1-1730301271"
  },
  {
    "email":"sabrina276@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251143034/ad055a6e2f4db89be5ef4f7e65cc9431-1730301271"
  },
  {
    "email":"mariacristina.operti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251175802/53f05c1abb53dcc329768b49a60983ef-1730301271"
  },
  {
    "email":"janguar8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251372410/b7edfa6680840dbee7551218992dacc3-1730301271"
  },
  {
    "email":"bevegnil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251241338/7d0dc7776f5c3cab55c06121cf9d9286-1730301271"
  },
  {
    "email":"greta.mazzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251274106/babe1bc1f2800c1a849478f7a7ea81a0-1730301271"
  },
  {
    "email":"darioannalisa79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251437946/eb25cc846f48e229ea59837d8d4cab0e-1730301272"
  },
  {
    "email":"bnoe@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251405178/520ad2672567372497500b4f05ece8b1-1730301272"
  },
  {
    "email":"francesca.bosia@unito.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251306874/71cd58b75b7f57214c5b709df1768c3d-1730301271"
  },
  {
    "email":"angelicadestefanis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251536250/644ce63b0babf0aa38f2cdcd2fb8358a-1730301272"
  },
  {
    "email":"manuela.roli@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251503482/a25cb908fed3c2a545fcc1e50c14c073-1730301272"
  },
  {
    "email":"guy-telle@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251634554/d9ddaa643a3ebc5e495271c1bb82bc38-1730301272"
  },
  {
    "email":"vittoria.kartash@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251667322/e1a9dd00bd4604786f23db6a2460d67d-1730301272"
  },
  {
    "email":"liliana.bonanno@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251470714/b3ac2935ebeb8b8dcf079f90492fa6f8-1730301272"
  },
  {
    "email":"galimbertisarah@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251601786/35ca083b3afbfbdfa8b0a4e15c9c94f3-1730301272"
  },
  {
    "email":"francesca@moodsrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251732858/0916c5ec45f4f29dc6f2fce7df12392f-1730301273"
  },
  {
    "email":"elenap.e@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251765626/67b6e7093d8f858c69c02e220fd0a957-1730301273"
  },
  {
    "email":"r.baccari@gruppobaccari.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251700090/c89bc15eba7dbb5e77b6f59c16b8ac7f-1730301273"
  },
  {
    "email":"federicablu.barbieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251798394/95a8d8af9e570719f2962e17bc3ce2de-1730301273"
  },
  {
    "email":"giorgia.falconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251831162/89da7ae1109be6102548a6a09fb21f74-1730301273"
  },
  {
    "email":"silvia.stevanato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251863930/6d6cea34ce748eba677c798ef4e3c509-1730301273"
  },
  {
    "email":"enzamariaciraolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251929466/f6d5bf04c33bcf536452e5c050d3c4ad-1730301273"
  },
  {
    "email":"m.paternoster@roma.bcc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251962234/7f4197bd702ab2e153102a1740a4e242-1730301273"
  },
  {
    "email":"giannattasioveronica91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252060538/139465abc7a351a9d555f9fac116cc9d-1730301273"
  },
  {
    "email":"v.lanfranco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723251896698/b258514fdd91733430e8c56731376555-1730301273"
  },
  {
    "email":"gattadimarmo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723251995002/f15d4d267a629671676f959a6927ce2d-1730301273"
  },
  {
    "email":"vannabaraldi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252126074/e31659f8fce2e35e6ca15196242ec04d-1730301273"
  },
  {
    "email":"alessandra.ciuffardi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252224378/d5110c4eac976320dac95ca365f975df-1730301274"
  },
  {
    "email":"macinabarbara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252257146/c756d54e4dd3bbb329ade087cd8f032c-1730301274"
  },
  {
    "email":"aleboyd@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252158842/c16e898e1ed1b045c51ef7ad19f05383-1730301274"
  },
  {
    "email":"elisabettaverderio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252322682/e728b2eccc034b2e92a160598ecabf5e-1730301274"
  },
  {
    "email":"antonellatedeschi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252355450/8c66e16d601f17ecb67d505c309be926-1730301274"
  },
  {
    "email":"alessandrasarti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252289914/c8543d644cd36cf212fcb95564219de0-1730301274"
  },
  {
    "email":"daniela_favaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252519290/903a693c9518e485321dcdf11baf47ba-1730301276"
  },
  {
    "email":"federica.biggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252420986/a3f28a44c96cdcabd7fc482f81c1172f-1730301276"
  },
  {
    "email":"elenabadino78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252453754/7f3cb17920181a8e5a8ec011e252cf06-1730301276"
  },
  {
    "email":"antonella.costa.6720@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252552058/23d1fe2c112350fd45bad5b2d3a5c9aa-1730301276"
  },
  {
    "email":"giusypiazza72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252388218/16fee2d06aa679ecc5dee354c6a12a53-1730301276"
  },
  {
    "email":"lallessia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252617594/31dfdc46d21d072eb0e5c886bea1b4cd-1730301276"
  },
  {
    "email":"bdg251@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252584826/34d0a5dc39f1044c56d5fd521a89f2b3-1730301277"
  },
  {
    "email":"mirella.massetti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252650362/75db5a1a08c71cde3d581ff6557bedb0-1730301277"
  },
  {
    "email":"info@deluciaricami.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252683130/6ef38f3f5f935d972a3fc626c76d795d-1730301277"
  },
  {
    "email":"bonaita.valeria@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252715898/d03749bf0d6007edbdfe2a1d4e1f4568-1730301277"
  },
  {
    "email":"vulpius22@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252781434/7612957864f1b0c4e8ad514241275a7f-1730301277"
  },
  {
    "email":"rollymodugno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252846970/c2a0900cee25306bd2d8603613c1b69a-1730301277"
  },
  {
    "email":"fra.degiovanni76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252912506/5c5ba23f018f79fdb4eaaad451b812e1-1730301277"
  },
  {
    "email":"mariolina.bognanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723252945274/598fe95b611589d2dbb875947be82532-1730301277"
  },
  {
    "email":"paola_storai@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252978042/cc5382b0cb0fc0abd7243ee896e535fd-1730301277"
  },
  {
    "email":"castalia82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252879738/31575cda8aeeba28e5ef1a77cee213f3-1730301278"
  },
  {
    "email":"luigia.gentile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253010810/b1961b3f78e6f034b1d02171317b0034-1730301278"
  },
  {
    "email":"cettinalarocca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723252814202/a2a1c98c500622b1ba642ed888007355-1730301278"
  },
  {
    "email":"cat72cad@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253043578/fb74b1f144b6c77157d355269df5986e-1730301278"
  },
  {
    "email":"aryfusco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253076346/85f668e66878ae4ba3e9830e11d94a43-1730301278"
  },
  {
    "email":"rosapolichetti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253174650/dd40d643faa6117541179207637b7022-1730301278"
  },
  {
    "email":"mr.macchiarella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253109114/7062f154a996e0fbd3dedfb6b83b2b40-1730301278"
  },
  {
    "email":"elisa-emergency@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253207418/a6abcefe4b5f0a78e662069f5cd79a6b-1730301278"
  },
  {
    "email":"sedagi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253141882/b883250bb9cf9d3318723f8c449efda7-1730301278"
  },
  {
    "email":"aemmegi51@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253240186/10731439d70c206be917983c3497559d-1730301278"
  },
  {
    "email":"cristina.bisson7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253338490/834686abbebcabad4c85ba7bf5bf06d3-1730301278"
  },
  {
    "email":"lauravb@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253404026/42d90b6b8f889e6fa7e1b180b1d93083-1730301278"
  },
  {
    "email":"barbaraboccardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253371258/181df33b3e5a664dfb225e5f3f4b4350-1730301279"
  },
  {
    "email":"toro96@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253436794/941983d4638703deb7875569305015f8-1730301279"
  },
  {
    "email":"marcoantoniomauro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253502330/fdd84682adbd7671bc728f3697b8f04e-1730301279"
  },
  {
    "email":"simoneeangie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253567866/ffb0913242aa31e8647acaefd26680b2-1730301279"
  },
  {
    "email":"fabrizia.grossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253633402/8ded7175c83af2925c5ffc97c744a4fb-1730301279"
  },
  {
    "email":"vera.germano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253600634/ad5b424a04a62f648f409d405dadb79f-1730301279"
  },
  {
    "email":"maxsarri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253666170/9f244338562c9a81e62e12ecd67d81a4-1730301279"
  },
  {
    "email":"giugie23@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253535098/6911157448cd797ae5b6a6c57309a986-1730301279"
  },
  {
    "email":"francesca.brasi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253797242/f331b80b44b238a8710ac0ff5f6425af-1730301279"
  },
  {
    "email":"riva.silvia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253862778/3fa1f9790c4db2f1b0a7872c10dec0e3-1730301279"
  },
  {
    "email":"mattylm7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253895546/5889c13ba80210ffc6dede94b248ea1e-1730301280"
  },
  {
    "email":"stefaniasabatini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723253830010/7139edad1fe59045b21aa3fa9e9c2fdb-1730301280"
  },
  {
    "email":"azzurraemmolo7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253961082/0d4a035ddf1b4c0d0126b6eb9e95b838-1730301280"
  },
  {
    "email":"lupinelliandrea98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723253928314/e098d4f454400c37e0124bde2932493e-1730301280"
  },
  {
    "email":"flavia.frisone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254059386/80e4d479ccfca5eee58a569ffd261cd6-1730301280"
  },
  {
    "email":"stefano89_1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254092154/d704cfe78df16e55175b084d32f97bbe-1730301280"
  },
  {
    "email":"elisa.cuman@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254124922/76d5a76f8ed906316d953bb1f4c163a2-1730301280"
  },
  {
    "email":"barbara_lugli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254190458/a8793256ad5523f16f0d1be3d2a211fd-1730301280"
  },
  {
    "email":"flaviana61@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254223226/bc75ea7fbc3bbbb72e7103d778ac7494-1730301280"
  },
  {
    "email":"giulianigiusy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254157690/72f1916c9dc9b5c285bf9efbdcc5208e-1730301280"
  },
  {
    "email":"donagent71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254321530/017cacd833ecf0f6812d0790eee3cd0a-1730301280"
  },
  {
    "email":"r.pungetti@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254288762/d23bca4133006fe4c851a7d34cd0f3bd-1730301280"
  },
  {
    "email":"rosaliapinardi66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254255994/bab8f847ceb12997541f016c1439f5b8-1730301280"
  },
  {
    "email":"elena.paglini@email.it",
    "url di attivazione":""
  },
  {
    "email":"bastianamurgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254419834/b4b2196a1466fe347b41811aa36b325f-1730301281"
  },
  {
    "email":"lilianasartorio.ls@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254485370/7991d7669f0702339d441eecb88f2045-1730301281"
  },
  {
    "email":"saratravaglione@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254518138/016b2ca17bb123a1e8bee3aee76b63b3-1730301281"
  },
  {
    "email":"robertadalmagro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254354298/e0391be2ed85201816f583c07004611b-1730301281"
  },
  {
    "email":"elena.fr26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254583674/b738f973b993c3240ab5ca3f2e0a7e25-1730301281"
  },
  {
    "email":"a.fazzio@gioma.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723254550906/c32406bd510924fefd107dc5ca4fba99-1730301281"
  },
  {
    "email":"lorenzaferrillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254649210/ba412135a2acb7dcbf1db0275b3db2c7-1730301281"
  },
  {
    "email":"cecchini.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254681978/92ab9946ab1fee4986a0132f256352ef-1730301281"
  },
  {
    "email":"pinera22@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254714746/66925e5ac4bb4197c89aee7ed47c625c-1730301281"
  },
  {
    "email":"vanillasky80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254747514/5333040069707df13b90cacd16c48561-1730301281"
  },
  {
    "email":"claramori0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254616442/60c5b3fb83fe703880858cec0cbb5c59-1730301282"
  },
  {
    "email":"giulytugly@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254911354/461d92f0cd0cfa2a95339ace4bcd3318-1730301282"
  },
  {
    "email":"barbied@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254845818/4f64a1231f323c3da94225f301f2cdce-1730301282"
  },
  {
    "email":"sciascia.mr@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254813050/4bb9954bfefd374b1793257438367122-1730301282"
  },
  {
    "email":"francescaradini80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723254944122/d72ab4833a7b63e1af06c2745dac0cb5-1730301282"
  },
  {
    "email":"ubertilaura@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254780282/3c63c886b4d5f891aa681a9386ec1524-1730301282"
  },
  {
    "email":"pbozzao@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723254976890/db6556261abef1d1bf9d6cdeee7e9b72-1730301282"
  },
  {
    "email":"cori19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255009658/ff2b2956430a719957ff4975cb833c5f-1730301283"
  },
  {
    "email":"rscarnati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255140730/4b21cd90046e8ed6f558be1fba889dbe-1730301283"
  },
  {
    "email":"albertadeffenu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255042426/fd4f03a96a975839011894b60aaf1375-1730301283"
  },
  {
    "email":"fratelli_montini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255173498/af6cecf30d5e86a29036b375c08c5740-1730301283"
  },
  {
    "email":"annarita.ricci@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255206266/fa57a97d11e0f4799515eb2804328c67-1730301283"
  },
  {
    "email":"marisaminarelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255107962/dd8e459ddffd90cbec0e6da856ad18d3-1730301283"
  },
  {
    "email":"sabrycaposc@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255239034/396633df2b054a1b7dda16ae963fd18c-1730301283"
  },
  {
    "email":"anichinisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255337338/eafb0104cef78b0c84ac905f4a012030-1730301283"
  },
  {
    "email":"olgadim51@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255271802/18e5f0397d19f0e0f22e53c6092e6a82-1730301283"
  },
  {
    "email":"angeladsga@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255435642/63c3b1397e63a8b059dd2000f10cb46c-1730301284"
  },
  {
    "email":"enzo.cipo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255468410/d7bf60a2f9939fcb9996fb12fd6f467a-1730301284"
  },
  {
    "email":"paola.bo@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255501178/67d6d76fe4ff7705649da87eef1cae1a-1730301284"
  },
  {
    "email":"mazzi.serena@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255533946/2049ca9deb45419ea405d966f5b47564-1730301284"
  },
  {
    "email":"s.sieni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255599482/6b3d381c6f58347bd64365e23679cbd4-1730301284"
  },
  {
    "email":"valentinimichela@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255370106/3f973136302c187a5e107be5e64d35f3-1730301284"
  },
  {
    "email":"betta.carbone@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255566714/48650b6afc742c74341c13851d98e634-1730301284"
  },
  {
    "email":"marianna.moccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255632250/0760d880c7a0f19e2908fc37cfafaa9c-1730301284"
  },
  {
    "email":"leggiob@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255665018/a83769c5d6fd9b3c66f63185d7216356-1730301284"
  },
  {
    "email":"sara.biolchini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255763322/4914e22c5eef66098fc3ea2b4a2af75f-1730301284"
  },
  {
    "email":"rita.barzanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255796090/8de5e05f8f2e160b13e08afcbdada18b-1730301284"
  },
  {
    "email":"danigueri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255861626/58724ba91c38bc5a34c5071199605ec8-1730301285"
  },
  {
    "email":"moon.blue@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723255697786/2594c0162ec57f5c9bdf099c4346d877-1730301285"
  },
  {
    "email":"rosacip23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255828858/bb8b8e93d3ffe750dc1bb77f0fc16415-1730301285"
  },
  {
    "email":"chiara.colbe@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255959930/6e4e5b90e29b7a8734f0c2953257e4a6-1730301285"
  },
  {
    "email":"giorgiagiacone83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255992698/9600d3e7797603c48fca53d897293221-1730301285"
  },
  {
    "email":"tavazzaniviola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723255927162/6b0e902afdece780e37014d85023f540-1730301285"
  },
  {
    "email":"michelacaccia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256058234/832310db261431ed324fd5375880ff8f-1730301285"
  },
  {
    "email":"claudiabaronchelli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256156538/88d8f369c6d25d7de76d2ce0e1b5d2da-1730301285"
  },
  {
    "email":"larifas66@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256189306/a577f6359a6dae130f03c4b43863a179-1730301285"
  },
  {
    "email":"patriziaottoveggio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256123770/c229c17e535731de9ba6da15c7fd98fe-1730301285"
  },
  {
    "email":"mariella0401@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256287610/67ae54b6363f5d3ced9e76b51448c82d-1730301285"
  },
  {
    "email":"barbara.dose.bd@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256320378/350972236a9bbe7117698ef17b9a2f64-1730301285"
  },
  {
    "email":"r.sara77@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256353146/bfb1769fa0d5025a5684b9fc12bc7a7a-1730301286"
  },
  {
    "email":"domenicomaria.sanesi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256222074/bcb97582f864b732f0edf623d7106d34-1730301286"
  },
  {
    "email":"amministrazione@prefabbricatibarili.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256451450/925e36a13ae43654a1cd8e36a673198a-1730301286"
  },
  {
    "email":"bonacini_cristina66@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256418682/8e7450d136806e9227cf28e22b0033f0-1730301286"
  },
  {
    "email":"francesca.sironi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256484218/d6b7a32c2e078a1c63402f14a4032f47-1730301286"
  },
  {
    "email":"stefaniagiacomelli1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256582522/0b81ffe34ea46a844a3d70e346333b85-1730301286"
  },
  {
    "email":"francescavalenti2001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256516986/bab3d1e21fc1dbbd8e52ff68cde1db79-1730301286"
  },
  {
    "email":"valescarpy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256615290/8ce6dabf51863ae3008fa04f5d9a94a2-1730301286"
  },
  {
    "email":"taty008@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256648058/a2a21da930c499d4631019251741c3ac-1730301286"
  },
  {
    "email":"deborah.airaudo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256680826/283015e5f02a495373dabcfa652b6a6c-1730301286"
  },
  {
    "email":"valeriagallo49@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256549754/3356461467979d96ceb15a31e4e8a54e-1730301287"
  },
  {
    "email":"ele.soncin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256779130/9418754bd6b210823bbebd3a7013ffd7-1730301287"
  },
  {
    "email":"carbonicris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256877434/a09cd6d929e3916dd74c308828edcaa3-1730301287"
  },
  {
    "email":"claudia.franzaroli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256713594/20c28829391d6cd5d2a2cd2832595943-1730301287"
  },
  {
    "email":"mbristot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256844666/56e564c1bc8c96ed37927689aa503feb-1730301287"
  },
  {
    "email":"clacli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256910202/32f7293b327869b57d48cf8f2683245b-1730301287"
  },
  {
    "email":"pratsacevedo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723256811898/3ce982708fd58ca8be6d982fd4a6b9d2-1730301287"
  },
  {
    "email":"manuela.scoglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257008506/6c76db75159f4472fa3fdbc1910d6889-1730301287"
  },
  {
    "email":"trigiu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257041274/d19570756deaf21603244ec38645c13d-1730301288"
  },
  {
    "email":"pochi11@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723256975738/adfa8e515e37be5cc53402193eb34fb3-1730301288"
  },
  {
    "email":"robi10-89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257106810/86c3334e3cfa07a2d1b2f031ea2def83-1730301288"
  },
  {
    "email":"marcella.cervetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257172346/feef2c039c91a02d3b156ed70ce98e79-1730301288"
  },
  {
    "email":"vabono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257139578/9c7746efbaa77f3ce97f82577352e348-1730301288"
  },
  {
    "email":"vania.toccafondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257270650/313e5d9da397bd12386cf86491ad9bd5-1730301290"
  },
  {
    "email":"giov.manicone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257237882/cbca41d264bf0037967b75c4bd76a18d-1730301290"
  },
  {
    "email":"avv.marinagiuffrida@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257303418/d8651f6a3f752b2d738458a524cc0af2-1730301290"
  },
  {
    "email":"francesca.ferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257401722/9f58ab59a027239f56779bc80cf2c217-1730301290"
  },
  {
    "email":"miladiviesti90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257336186/ffe8b3d176a65d04b0a5daab7b995afc-1730301290"
  },
  {
    "email":"daniela.manca1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257205114/54054c0db4427fc547f15aaf1fbdd7ea-1730301290"
  },
  {
    "email":"sericappa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257598330/816c8079a0025bcf36ca230cc8da3f39-1730301290"
  },
  {
    "email":"giusi.damore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257631098/2e3876fab27af98f41ab03b7633f926e-1730301290"
  },
  {
    "email":"marferrari3@ausl.pr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257467258/fc6d78f10bbb46d8686618c69a93e8f6-1730301290"
  },
  {
    "email":"velia.lelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257663866/0c52c880756c39407a725ed9766345a0-1730301290"
  },
  {
    "email":"cuculimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723257696634/ad220b47856b102d5d2d0a303acd1ebc-1730301291"
  },
  {
    "email":"cita_tv@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257762170/fd8a276f86a550c58ce8188c95ed131f-1730301291"
  },
  {
    "email":"monica.7777@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257860474/741c78d4511b2253a6759f22e8f2c182-1730301291"
  },
  {
    "email":"silvamalisardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257991546/1b4e920246ed8ae1874722453e91e52e-1730301291"
  },
  {
    "email":"agnese.montagna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257794938/6bcf9ff16796095df2d0be9ba1ecf3e9-1730301291"
  },
  {
    "email":"samanthadesimone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723257827706/82192de342979e30f60519aa4501c860-1730301291"
  },
  {
    "email":"alessandra.giorlando@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258089850/d8793eb3af5a6a64d4bd858ce378b3c9-1730301291"
  },
  {
    "email":"samuelamontani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258057082/df7fb1a01393ea1dc9df98aec6945ab7-1730301291"
  },
  {
    "email":"andrea.bernardo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258155386/6df521c8543cdf359533fa0a461d72bf-1730301291"
  },
  {
    "email":"raffaella.ventrone@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258024314/8a52ce5f4384ab45647f5406cf954b41-1730301292"
  },
  {
    "email":"vpigatto82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258188154/eda2538f842c93932af2a1c5b172f5e5-1730301292"
  },
  {
    "email":"tizianabottalico@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258220922/e732b95d6179239870aeb4cc8b09e24d-1730301292"
  },
  {
    "email":"francesca.piccinin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258253690/8c956cb3b66db132e479c027afd4fe08-1730301292"
  },
  {
    "email":"ritaenry@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258351994/2f06d28e46fdfb722230d6941f4034db-1730301292"
  },
  {
    "email":"fede960@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258286458/6137cd825d54254e5fa8d1cccbea6d71-1730301292"
  },
  {
    "email":"marta.nofori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258384762/52d00823b76b89663960393e7ef95d8b-1730301292"
  },
  {
    "email":"fedrizzisara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258548602/6c47a8f24400373670422313168ad470-1730301292"
  },
  {
    "email":"pscuteri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258515834/a1f2de42ec93817ef271596130dbcde6-1730301292"
  },
  {
    "email":"brus_74@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258417530/73f3c21afaaec2aaa78127f3e4477f1c-1730301292"
  },
  {
    "email":"maurizietta.masini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258679674/828ecdc7ae6f4500356e094a59bb4437-1730301293"
  },
  {
    "email":"anfiteatro101@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258646906/b4189d4c9eed068f9956e4105d405b96-1730301293"
  },
  {
    "email":"marzia.troi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258450298/efc1fcf23ce4b01eb93b71d86a1893a1-1730301293"
  },
  {
    "email":"rositalatorraca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258581370/22b41a2ae45989888f1d3d29754840a4-1730301293"
  },
  {
    "email":"simonebaldinisassuolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258712442/458749ab46d4b53abcf07cf5aee34331-1730301293"
  },
  {
    "email":"elisa.casagrande.78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258745210/800a1963b5167926fb44e0795f99d0c5-1730301293"
  },
  {
    "email":"monica.lcq@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258777978/83281dcf75b6853b99ae42b827c714e7-1730301293"
  },
  {
    "email":"lorettacintio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258810746/e86ce6f766279ad38fbe5791094d7d4e-1730301293"
  },
  {
    "email":"cegidio@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258843514/172ed562bbb78b6152edc46c18bd832c-1730301293"
  },
  {
    "email":"malumamoda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723258876282/f36ff0ac3e05127c249a5575b4672ba7-1730301293"
  },
  {
    "email":"albertellastefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258909050/89a5c95edb21235f0a3c3a67a24e3f8a-1730301294"
  },
  {
    "email":"laurabrggn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258941818/426be5cbdf8616db455a402d991b3cf5-1730301294"
  },
  {
    "email":"brusuttid90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723258974586/505d693e9195369fc2d24418fa7855b7-1730301294"
  },
  {
    "email":"rossella.nisco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259007354/f999dc674bdcfa66ca662a9af2e7ad76-1730301294"
  },
  {
    "email":"valentinascuffi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259105658/03b7326d0cd310b3e7f56e19153af76c-1730301294"
  },
  {
    "email":"sabi--70@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259072890/8777c43c6a728edc50aa2944b7dbad24-1730301294"
  },
  {
    "email":"ivylazzarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259171194/92e83309c2c5ba6015a743d9ffe27930-1730301294"
  },
  {
    "email":"luisabandini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259040122/a9f62895446f6f40affd0e6f59e7e389-1730301294"
  },
  {
    "email":"olgadebruno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259236730/72a55221da3f34ba782d64d8ff461e6e-1730301294"
  },
  {
    "email":"teresa.de.bellis2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259302266/407f1c5d1134afdbdcd4a085cc91771d-1730301294"
  },
  {
    "email":"concettaelle@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259269498/241ba86fe03a9c0a725b9baeb8442a54-1730301294"
  },
  {
    "email":"marco.dibattista@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259400570/3931a671ff4e776ce04d6557726f14d7-1730301295"
  },
  {
    "email":"sposito.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259335034/8ecbdd24f853d8996e3d95ee6b6ea4af-1730301295"
  },
  {
    "email":"auri66@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259367802/bc61cee2aaba28907ffe2b373c995f5c-1730301295"
  },
  {
    "email":"carminadefeo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259498874/04734e753f3267afee5af95b73c6c161-1730301295"
  },
  {
    "email":"adelimar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259433338/89577e7042df22e185b2039f52f8e874-1730301295"
  },
  {
    "email":"annaluciamereu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259531642/7d7ba68967eb6a6fd0e4c80076ee7507-1730301295"
  },
  {
    "email":"nicole.moreale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259466106/7dd20b7bcbde754bb11346297c5bd7dc-1730301295"
  },
  {
    "email":"carlabri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259564410/2d1c2941ce8672e165992f2394e25803-1730301295"
  },
  {
    "email":"mcmanus.annemarie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259597178/e201ac66af38ff0deeff44bddf9b3284-1730301295"
  },
  {
    "email":"lattuada.elena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259629946/03c3124fa17688d25723a009f64da10a-1730301295"
  },
  {
    "email":"aragozzino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259695482/baeef8597246b1bf3dd87ec41b7c0673-1730301296"
  },
  {
    "email":"giobru69@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259728250/8d5ccba61c44cdebd13b36a42105ad1f-1730301296"
  },
  {
    "email":"andreapiana@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259662714/be7175b5310acebcbc8b55cf269fdf68-1730301296"
  },
  {
    "email":"reginato06@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259793786/aa8bd61746101e408b326e2e8ced4c4d-1730301296"
  },
  {
    "email":"silviarucco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259892090/a7a71082a8c88faa1dd0ba81fbdcaf85-1730301296"
  },
  {
    "email":"alice.ternelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259859322/1be23f06bb2a5f0e64ed8b44c6e31451-1730301296"
  },
  {
    "email":"klaudia80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259924858/3f4a4cac67d5039d60e2a4be69cddd50-1730301296"
  },
  {
    "email":"yrlissa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259826554/7b941208cac0d4f65a31e66f1c46feb7-1730301296"
  },
  {
    "email":"spankitto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260055930/6da9331416378c21f420a45dc94c717d-1730301296"
  },
  {
    "email":"marinafrancesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260088698/8c6e89efe9a61bea09b5f334fe126082-1730301297"
  },
  {
    "email":"volta62@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723259990394/9c1ef3b1fd4485f9afe47b74d72c0eb1-1730301297"
  },
  {
    "email":"chiara.molly96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723259957626/688d28f277c21939633b23300029e4e4-1730301297"
  },
  {
    "email":"marco.dalponte.2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723260154234/818ff79fa45e95ef2fa2cfe0738c1754-1730301297"
  },
  {
    "email":"alessio_matteini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260219770/bd90d9be99a13e85b08696e85906619e-1730301297"
  },
  {
    "email":"lozziroby123@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723260187002/890d7e234a7aa2489278c7ad92153c55-1730301297"
  },
  {
    "email":"ssandrol@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260318074/e11d926831a3a34a00269d9e2cbea215-1730301297"
  },
  {
    "email":"roberto.rocca1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260285306/1083fc76f7f3059506e32f2510e82917-1730301297"
  },
  {
    "email":"grenae@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260252538/8cb3bcdfbc11ef73a2ebb9d9d659d209-1730301297"
  },
  {
    "email":"francesco-donati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260350842/9137f5da8af3fe98036eaa6e2f429fc4-1730301297"
  },
  {
    "email":"giulia.rocca@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260383610/6689d03c462b1561e26e6a6c988d2b15-1730301297"
  },
  {
    "email":"paola.viva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260580218/2ea55b3460f636fdaa531390de7945dc-1730301298"
  },
  {
    "email":"massarofrancesca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260612986/a5e9da44a285bbe6acddc828f43da972-1730301298"
  },
  {
    "email":"maricorte2013@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260481914/0b7897b3ac2283d99502e4b0e4014f68-1730301298"
  },
  {
    "email":"benedetta.boccaccino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723260645754/b5841ae2fce79ae1dab6b49778b249f4-1730301298"
  },
  {
    "email":"amg71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260678522/504e76caecc070acd9102ba2c904d223-1730301298"
  },
  {
    "email":"fabiano.pugolotti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260514682/6af38ada90d68c871986dd22e03d01be-1730301298"
  },
  {
    "email":"manliomandalari73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723260776826/bbcb7e0385acd449f14817c76389fd02-1730301298"
  },
  {
    "email":"rosamaria.ghislandi.988@istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723260875130/3169ee1931a6b632a51b535efc39b291-1730301298"
  },
  {
    "email":"zap@temac.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723260842362/57720d0cfd68e15abd33ce2c8230f7b9-1730301298"
  },
  {
    "email":"sato_j@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723260744058/6baa4745be446b93033d6ca7eeeeaf09-1730301298"
  },
  {
    "email":"elviradevilla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261006202/dc95ed1356881c350fd46e455cb4e1cb-1730301298"
  },
  {
    "email":"kwpamb@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261071738/657ee8564386887806cc14443aa9626b-1730301299"
  },
  {
    "email":"gianluca.gennari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261038970/b3428ac493af95b2b4c3d87a74c6d6b8-1730301299"
  },
  {
    "email":"gabrielevargiu@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261137274/fb86a423d63002f64ea6967f640526db-1730301299"
  },
  {
    "email":"anselmi.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261104506/a85dc493e52791926f2a48b0679dee88-1730301299"
  },
  {
    "email":"giovanna.athena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261235578/a705d347359edfedaf6fffd8550b1f87-1730301299"
  },
  {
    "email":"erika.assirelli@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"g.campana75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261268346/e25d0ee5278159231a75d30d14315e8f-1730301299"
  },
  {
    "email":"elenageria@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261333882/9ce7986571affc7e946d17b5c3dd4b88-1730301299"
  },
  {
    "email":"ida.mallardo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261170042/bd2d6b803093708fb4dd74d18696c87e-1730301299"
  },
  {
    "email":"chiarezza23@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261432186/652ac7439b930b64d8e6670caa4a05cc-1730301300"
  },
  {
    "email":"claudia.spirei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261464954/ea2f67f5c22e5a3112a64afb0119310f-1730301300"
  },
  {
    "email":"ligeia123@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261399418/329dff4f6127c82373d8c3aaa00cbec3-1730301300"
  },
  {
    "email":"irene.soncin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261563258/42f9f9c428e148ed08988fb2fe179f90-1730301300"
  },
  {
    "email":"antonellamartelli76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261530490/63ce971e29eb5d174fc5d85a577b9759-1730301300"
  },
  {
    "email":"carlotta.matteucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261661562/ad83e56bf83bfe6a2ee30e3444bfeb55-1730301300"
  },
  {
    "email":"nicomuratore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261727098/c9f10eddb361a1fda6c25b0106cfe471-1730301300"
  },
  {
    "email":"manliomannella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261759866/0528aeb63766e746230a9bb0dc6de9e5-1730301300"
  },
  {
    "email":"lariceangelica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261596026/9b85ec944e705a85cdef3a11b248c2c5-1730301300"
  },
  {
    "email":"alessandra.cassisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261825402/c4600f934e7633b743314c3e744d114d-1730301300"
  },
  {
    "email":"vale.mal91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261694330/3e1c987c8fc24a65b0ff14fdeead4e75-1730301301"
  },
  {
    "email":"grassiserena@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261890938/bb2ba4d6d52fa957e04a315abc1641f8-1730301301"
  },
  {
    "email":"amri94@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261956474/5b034f4d59815605e802c405db6e9219-1730301301"
  },
  {
    "email":"grazysulis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723261858170/239a3874f82b8aa7f299556292d4c010-1730301301"
  },
  {
    "email":"bibisi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723261989242/c0288a382bf09a5ea3af29f65960c2d0-1730301301"
  },
  {
    "email":"marlene.kammerer@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262054778/eabd5b11142e8cf7e4fcd770feb836c4-1730301301"
  },
  {
    "email":"cielita@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262087546/b7e10163e602eba6df51af2b43c7efb2-1730301301"
  },
  {
    "email":"deianava@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262120314/6874efb9246016ece23f086cf60ce552-1730301301"
  },
  {
    "email":"fabrizia.fantini@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262153082/1413e1e28e1a65a3d47a11cd1004c633-1730301301"
  },
  {
    "email":"diana.esse@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262185850/837d39bb41a0c286406b4ad160147f22-1730301301"
  },
  {
    "email":"ludovica.aiello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262382458/dd8e6a2714bf0011d621365683c6e9c8-1730301303"
  },
  {
    "email":"955simone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262316922/774afa83f4c6b1520c43df0fb3c444d6-1730301303"
  },
  {
    "email":"naturalbestetica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262284154/233b5910b4cb70b8e6566529bfb875f3-1730301303"
  },
  {
    "email":"dadasan@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262513530/45a400168441004cdf5b137e50e1c33f-1730301303"
  },
  {
    "email":"nicolettaarezzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262447994/c96b610cbfd471d43433c64808bcb6ea-1730301303"
  },
  {
    "email":"cinziaoro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262349690/ab81412d4b041d2dd37c09ab4a479e49-1730301303"
  },
  {
    "email":"antonella_goffredo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262677370/de2920beb5e2bbb8b18979ca3ca49030-1730301304"
  },
  {
    "email":"arima_80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262644602/8faf8c67971907b995d5f1ba2613673b-1730301304"
  },
  {
    "email":"antonellacasula72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262579066/31a7aed012d3548a8794020857ba05a7-1730301304"
  },
  {
    "email":"gigante.daniela@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262546298/ebd31cf5e5a190f5b585a3f1feca3f20-1730301304"
  },
  {
    "email":"dazzan.elisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262710138/37b0e242f66b76fab816a65e15cb35d0-1730301304"
  },
  {
    "email":"sb.silviabergamini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262808442/80e3fe632303c061a66e02b0ab88779b-1730301304"
  },
  {
    "email":"mazzettimele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262742906/cd665182a619d80911dc9fac51f60d06-1730301304"
  },
  {
    "email":"danieladante@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262873978/cbaf1f8572e2ead7965014749cafea08-1730301304"
  },
  {
    "email":"laura3conte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723262775674/44748d0b0f8ad8cc96c116949c831ee3-1730301304"
  },
  {
    "email":"caterina_valentini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262906746/46451bd7f294568efe13d7e4f0f00c62-1730301304"
  },
  {
    "email":"lauralanzi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262939514/d10fb0f48fd21ec1125219bca3739f4c-1730301304"
  },
  {
    "email":"peri92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723262972282/244e9cabfaf0327102d088089f9430ea-1730301305"
  },
  {
    "email":"nataliastellino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263037818/710e4f8ecda55a56003041c7c3c95ffd-1730301305"
  },
  {
    "email":"vincetelesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263070586/799d7a3e1c457dc15184dfd19b52340b-1730301305"
  },
  {
    "email":"giulia.rizzi.1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263136122/645f9eaa2a72e5ef0d63658fa6e8523a-1730301305"
  },
  {
    "email":"zocchi.s@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263168890/41914a535547ab1b4a9136a0bcb516a7-1730301305"
  },
  {
    "email":"marval2008@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263267194/8598c92f2c8d5bd8eb5bb5d878c4f182-1730301305"
  },
  {
    "email":"costy7@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263201658/100d363b599f8111a1922e65efc8ff6e-1730301305"
  },
  {
    "email":"supoettu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263234426/d007ada8dc3527d614e4c1994fcd6ed4-1730301305"
  },
  {
    "email":"linda_clash@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263299962/43dc58c3c2d44203c073c6dd87348f29-1730301305"
  },
  {
    "email":"sabfinaz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263365498/71c38bf4810a487201de66962581accb-1730301305"
  },
  {
    "email":"vpelizzoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263332730/026f46905a37ca88cd4c742a2e3dd5fd-1730301306"
  },
  {
    "email":"tempratov@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263431034/18701960722af61cecf37897a6f5b51a-1730301306"
  },
  {
    "email":"gallettifrancesca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263398266/9c410edc27a3dcce90816e1cecdadb1c-1730301306"
  },
  {
    "email":"peppinopapa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263463802/16564e91ed5f2b89d6e40c4caa0ab114-1730301306"
  },
  {
    "email":"marcelledubin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263594874/2d9ad854dfb3f6ed4896486302d61eaa-1730301306"
  },
  {
    "email":"valentina.paradisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263496570/b69549e761bec9dcb43165c30020f5a5-1730301306"
  },
  {
    "email":"barbara.lucianoostiglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263529338/bac65582af83e785e44c61a643958ca8-1730301306"
  },
  {
    "email":"simonaambiveri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263627642/aba6d8677b82895d5d78c71eeadad86c-1730301306"
  },
  {
    "email":"danieladipaola2@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263660410/d5341dd72eabd51a29f408488a2eec2d-1730301306"
  },
  {
    "email":"ravagliasilvia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263758714/f9c21085c3ad6d7225612f0aff966922-1730301306"
  },
  {
    "email":"g.brusati@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263791482/eabe22b98d6676e019dd43d4dd4afe45-1730301306"
  },
  {
    "email":"3laure82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263824250/38ce4c31a624b5c6002d0deac1194282-1730301306"
  },
  {
    "email":"simonettafanucchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263857018/2fc6c2091558d81dfc645663924f22f4-1730301307"
  },
  {
    "email":"info@miribunghof.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723263889786/d923d17e32209831dd3cc0efd28b62b2-1730301307"
  },
  {
    "email":"micol.magnani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263725946/0838057f77955d9ad3ca9eff1a358d82-1730301307"
  },
  {
    "email":"cinziapannella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263955322/5bf75823b0c20c307340f56e808bc2fa-1730301307"
  },
  {
    "email":"michelaperla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263922554/67922d9f5fd29ad1d370a4f009d635cf-1730301307"
  },
  {
    "email":"federicads81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723263988090/2b7f313264463adba452cf89015574b2-1730301307"
  },
  {
    "email":"jolinette@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264053626/54d0f6fce17109d08222a50a88c8b1e1-1730301307"
  },
  {
    "email":"silviafufluns@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264086394/de7f71c0eabd5d3aa3fd1abfa9035ef5-1730301307"
  },
  {
    "email":"bisimona75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264020858/568110058d1972dc17dd078861d8bbb9-1730301307"
  },
  {
    "email":"teresarosariaverde@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264151930/72b22d8c9a4da97da98767b3194c38be-1730301307"
  },
  {
    "email":"r.cappetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264184698/ffb63edb1472cf03eca4ad85132f3625-1730301308"
  },
  {
    "email":"despinakaragianni@yahoo.gr",
    "url di attivazione":"https://verdissima.it/account/activate/22723264250234/76d8c83fb1d90f12aeb83e72cc9771e6-1730301308"
  },
  {
    "email":"c.carlimoretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264348538/97743320657c3eb33f785fe2d943ae5f-1730301308"
  },
  {
    "email":"mariangela.mazzone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264381306/11a04c3908dc20873f3cf136811065ed-1730301308"
  },
  {
    "email":"cerusicip@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264217466/64bf7b3e778742c6a855938fa318be8d-1730301308"
  },
  {
    "email":"lorenzo.migliozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264479610/3b1a2f72e880d2bdbdde92c60051dd90-1730301308"
  },
  {
    "email":"sdigaetano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264315770/44bb9f3e69bd896151082b31e81c52b7-1730301308"
  },
  {
    "email":"saramalusardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264446842/93a430d5bcc66a86b092d70503216867-1730301308"
  },
  {
    "email":"daconte62@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"annalisa.berto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264414074/a81533ff27338b0d97f872cb5590a62b-1730301308"
  },
  {
    "email":"elenaprovvedi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264643450/01298f9429590a9c5d5352076fb0cec0-1730301309"
  },
  {
    "email":"aridivine@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264708986/058cf03cbbf15a41eddb682aaaaa2c31-1730301309"
  },
  {
    "email":"giemi99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264741754/659083281a134af1f4fd5fe2e8ff8f03-1730301309"
  },
  {
    "email":"alias79@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264512378/6c90aae1dd440fb963b9c17f301697d1-1730301309"
  },
  {
    "email":"noemikebede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264840058/c0f586f91c391069c424c1aad4dec348-1730301309"
  },
  {
    "email":"valeperotti7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723264938362/22f8b72ec0040b987aabab0acd1c641a-1730301309"
  },
  {
    "email":"kritty90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723264971130/62f7f90e9e0e894c72ae3567d5ac4166-1730301309"
  },
  {
    "email":"n.weber@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265003898/08c64b8d6655c519247faf5391b0a07a-1730301309"
  },
  {
    "email":"ermocrate1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265069434/cc75c57183f468545a5bb9df63202d1b-1730301309"
  },
  {
    "email":"barbara.santovito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265102202/5142c2bc997a20d58bcc1f617d1386f4-1730301309"
  },
  {
    "email":"serenacapucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265134970/b5c5baa43f2016bf731cf14cfea5d431-1730301310"
  },
  {
    "email":"simona.fanucchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265233274/7a11bc97ea7f6746a2efc4d00f6fe6a7-1730301310"
  },
  {
    "email":"jessicagrassi4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265266042/01eef4bbd5e219e108ca936f47e87540-1730301310"
  },
  {
    "email":"anna.moramarco_am@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265036666/b45d5c2e7224d6a8058eb4809fe645aa-1730301310"
  },
  {
    "email":"odescalchim@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265298810/8a309ede90d1d0525ca3eb3f111e9d6f-1730301310"
  },
  {
    "email":"monica.provvidenti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265200506/3fe1e97d2f3ada739b0448b23cd6311a-1730301310"
  },
  {
    "email":"mbbruno@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265364346/4f4b5e5fc530b6c465a1945cbe51a924-1730301310"
  },
  {
    "email":"malevich@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265331578/9cddf7d0b1b0f19e5ac4144321dcf6a1-1730301310"
  },
  {
    "email":"giuliabrretta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265397114/23c759f38ae36b89c28393748663ee65-1730301310"
  },
  {
    "email":"vito.dejaco@bb44.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265462650/70c8366511579267f8ff9acec6db4415-1730301310"
  },
  {
    "email":"eologiavita@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265560954/edfdd8e5caf41bf45517e93ad2c80fbb-1730301310"
  },
  {
    "email":"annalisacarenzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265495418/281d8e1905b930b84ddb05a34eed7c64-1730301310"
  },
  {
    "email":"giorgiorotini@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265593722/a64ffb1e4ca1c7b430011acf98d6b72a-1730301311"
  },
  {
    "email":"valeria.cernuschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265659258/b6c40ec2ecc91da348f042ba292cdc1b-1730301311"
  },
  {
    "email":"merydb85@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265626490/4d667ad417ca8b9cdd24e6e5d4ab50cc-1730301311"
  },
  {
    "email":"veronica.operato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265724794/c0924909a4495fc62490b6fa2245baad-1730301311"
  },
  {
    "email":"kingsat2002@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265692026/b66c883f55ef0e427545b72640b6f094-1730301311"
  },
  {
    "email":"eliana.scimone@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265790330/cbbeff838a57785d512aa8c43811ecac-1730301311"
  },
  {
    "email":"mariannix74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265823098/990f9008ccf4b2d7cf15bc8014c0548d-1730301311"
  },
  {
    "email":"silvia.pezzola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265921402/4754844558f9e81f15e4c6c2cd75bf80-1730301311"
  },
  {
    "email":"lauro.bolondi@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265855866/93d55df55bc22a3571fdadac8b2b8d0c-1730301311"
  },
  {
    "email":"barbara-giannotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723265888634/481c44919923f479891550231fba42c4-1730301311"
  },
  {
    "email":"sechisilvia790@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723265986938/55dd9ab55f7002eb6d5d7e7827d5dcc1-1730301312"
  },
  {
    "email":"mihaela.oancea01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266019706/fce003f8ddc3139f5fee04e193489294-1730301312"
  },
  {
    "email":"serenasoricetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266118010/011c446947cbebbb01ab9bc949226fe1-1730301312"
  },
  {
    "email":"milena.fruciano@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266150778/e61f6bdf2176dd805344f0f5a6d9bf8a-1730301312"
  },
  {
    "email":"arianna.schiavolin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266216314/f11bdc8c8dff1b65fb50c4b5fbaed7be-1730301312"
  },
  {
    "email":"cristina.gheza@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266281850/eb7826cb5bee909a12fea28bd3ff5632-1730301312"
  },
  {
    "email":"raffaella.magri66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266314618/ae50a238c3568f78380cf98101285325-1730301312"
  },
  {
    "email":"serenads1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266085242/cd96322008e87b57f220e69854bdb895-1730301312"
  },
  {
    "email":"giuseppe.brosco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266380154/a3183fa88adf8622eced724cf88b120c-1730301312"
  },
  {
    "email":"ilariasalviato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266511226/102e74d0626f18ae9a81a1d3c915112d-1730301312"
  },
  {
    "email":"angelaitaliano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266609530/14f64b41bf02585ac88f28e5433b64d6-1730301313"
  },
  {
    "email":"serena.aquino88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266543994/a833c856d43b483ef742027f628a5aed-1730301313"
  },
  {
    "email":"minicafilippone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266445690/f578c37cf8d9c57baba5e0e6a8c60fbf-1730301313"
  },
  {
    "email":"martinatomatis@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266642298/878c444952faa4d8d6d6266b64e6ee71-1730301313"
  },
  {
    "email":"andrea.zuccherelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266675066/1d7d0fc71addebbed7023ce58db4c800-1730301313"
  },
  {
    "email":"cau_margherita@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266707834/d3d57473822128bdb1919c7d9bf724ab-1730301313"
  },
  {
    "email":"pietrinasenes@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266773370/56e28b7a6cbc45523b4d903b94d7688e-1730301313"
  },
  {
    "email":"mirkasimo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266838906/acb8ed7608740c5ddfa40ec6ed4d96bb-1730301313"
  },
  {
    "email":"la_cea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266806138/224e87a86ac14aad8eaa5afbff75fad1-1730301313"
  },
  {
    "email":"a.nesler@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266740602/f0c29b72adce7efe4b9f22fca55e4f77-1730301313"
  },
  {
    "email":"claudiariccone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266904442/d472461d4cf4ce7e25636fc23aeff113-1730301313"
  },
  {
    "email":"katex64@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723266969978/8b73818c2fbaa65b48fbddc7d211305c-1730301313"
  },
  {
    "email":"ffrancesca90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723266937210/15b0dbda14fb6dd87eda041020cbca6c-1730301313"
  },
  {
    "email":"loretta.ventrucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267002746/790edf762f87136e7ce101a48f0cbce2-1730301314"
  },
  {
    "email":"annalisa.godina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267035514/7630ebb3057c76bf1ed88c70753e84c6-1730301314"
  },
  {
    "email":"tollis1864@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267068282/10435004b2664a3124c6d992bd496710-1730301314"
  },
  {
    "email":"annatitacorradini2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267101050/21e32a7cfd66deef3b5f231e43d97efb-1730301314"
  },
  {
    "email":"daniela.dalri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267133818/411258797087d969079b3297de6a9351-1730301314"
  },
  {
    "email":"maizitel@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267232122/54ffc3c5a16ededa7cbc0924e84828d0-1730301316"
  },
  {
    "email":"adrianameucci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267297658/188a855fdabf896a9fb4a242262a58c5-1730301316"
  },
  {
    "email":"valeriaciliberti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267264890/6e8fd552b8610ff4b7f4d07a95d07a4f-1730301316"
  },
  {
    "email":"casiglia@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267363194/a1117b3fb857b53556cc4916b1cd4e18-1730301317"
  },
  {
    "email":"chiara.ubaldi@ubibanca.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267330426/5528ca0fed4b38f063198d9ad92307f8-1730301317"
  },
  {
    "email":"evita2004@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267395962/059b25c3182a0845c00082914dc7d273-1730301317"
  },
  {
    "email":"emmedime@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267527034/5af40648270df6e79b5b73bfca3df9e3-1730301317"
  },
  {
    "email":"marcobarbieri1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267166586/982450e0170db73532572b22c63bf52f-1730301317"
  },
  {
    "email":"emmatripodi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267461498/3729f597fd8e8a9c00ae5b51c6373537-1730301317"
  },
  {
    "email":"oksanachernobabina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267494266/3f29731e828ca79a1416b72abad97f5c-1730301317"
  },
  {
    "email":"mluisaconchieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267625338/9f56867e0e5eb4b971e36f5308827da6-1730301317"
  },
  {
    "email":"danielastrambelli79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267723642/0dc2ec06b718561fc6b9d74812a9ba91-1730301317"
  },
  {
    "email":"francescaguarrera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267592570/9ee930cb8c6276a2ef711914290ea764-1730301317"
  },
  {
    "email":"antonietta.barrella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267756410/cd7f9fed592c289ea8d9b74ddeade615-1730301318"
  },
  {
    "email":"elenaalbanese@ctacalflex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267789178/5368ed42949d0dd2bed7afb25cdc9763-1730301318"
  },
  {
    "email":"lubikare@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723267920250/7181a09259a2ee02a80b3b5da8943d06-1730301318"
  },
  {
    "email":"crespilaura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267854714/b0fcad28693cd2000e2790c378902d62-1730301318"
  },
  {
    "email":"valeriabertozzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723267985786/6e040dc3ca7d61b60c856f575a29eac6-1730301319"
  },
  {
    "email":"monica78mc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268051322/28470ea4f0ebc8663cdab63a99bf3047-1730301319"
  },
  {
    "email":"amadori.alessia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268084090/f7785f0a5638aa77fe8f0fef15322236-1730301319"
  },
  {
    "email":"barbara81lombardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268149626/7053b4b92f6a87a9cec39cdb507aeeb4-1730301319"
  },
  {
    "email":"anticas_licanzias@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268182394/9c94377d825044e56b3e25d06dff7240-1730301319"
  },
  {
    "email":"martasiotto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268280698/7740e4985cd492a4abe662025998d2c4-1730301319"
  },
  {
    "email":"patr.landi@vitgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268313466/592d4f55a576936da90d9d841ffd2b54-1730301319"
  },
  {
    "email":"mati25860@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268346234/a2123d4ca256ec966c08accaaef091e4-1730301319"
  },
  {
    "email":"kettydipietro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268444538/a9e3f5cfcf0ecce9928540135a60f110-1730301319"
  },
  {
    "email":"marinoseppi58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268247930/c8b68ac6f8b640a3c38907429f994ae9-1730301319"
  },
  {
    "email":"santa.spinnato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268379002/22db6a2acb8d367ca0435674da00c4ad-1730301320"
  },
  {
    "email":"kojuharova.e@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268411770/1e8b2456afaeebede069a6f50accea5c-1730301320"
  },
  {
    "email":"vanessa.magi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268510074/a1bbd933c6b4f72f10edc4ac6901bd38-1730301320"
  },
  {
    "email":"annamariaformini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268542842/6c1d950e0cea961e675bb22ff3f382c3-1730301320"
  },
  {
    "email":"paol.ferranti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268608378/ff3e8ff0a49de385076381ed2f9c0930-1730301320"
  },
  {
    "email":"marta_21892@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268641146/2c07005f6462ba9baf6952b4c7a073b1-1730301320"
  },
  {
    "email":"giosimi82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268477306/2bd946c78f663d2d7ef0f93b97fd305e-1730301320"
  },
  {
    "email":"pezzoli.cinzia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268575610/d58c06b81588c8b84020f885d18fb198-1730301320"
  },
  {
    "email":"ilariapacini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268706682/c6c33fa4664b87c7f6197a0eda35a83c-1730301320"
  },
  {
    "email":"alessiafalugi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268739450/d92e2bb25dbc161168a41776b9a34b71-1730301320"
  },
  {
    "email":"luisabagcal@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723268673914/4fafe5c883f0ecbec1f95023cfeaeab1-1730301321"
  },
  {
    "email":"alesomm77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268772218/4ec360a82ee2caf680a13efc3e23ad00-1730301321"
  },
  {
    "email":"torelli393@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268903290/e6bd88a52f070638e5319f225adfbce2-1730301321"
  },
  {
    "email":"dipalmarosalba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268837754/0001c9ce55548f35c01800f50b9463b3-1730301321"
  },
  {
    "email":"valeriamasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269001594/f9e7e483506fa5c158989dfc4b19698e-1730301321"
  },
  {
    "email":"daniela.ranni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269034362/78fe7059150bd4c8cc4f10425851336d-1730301321"
  },
  {
    "email":"matilde.giuliani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269099898/51a45d5ce99f049a4afb276c445644ac-1730301321"
  },
  {
    "email":"alessiagiovanelli82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723268936058/320b754c99e04b12eabc01457a771085-1730301321"
  },
  {
    "email":"giuseppemarchese0103@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269067130/bc478aa5a25bffd896fd0d7220128f73-1730301321"
  },
  {
    "email":"bonfi_lisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269165434/e633ea2c0cb50854e562ebe62cc27a6b-1730301322"
  },
  {
    "email":"corrias.lorenza@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269198202/0c9e0f3eea0cb5db14af60a42d4ccd09-1730301322"
  },
  {
    "email":"lauraiannaccone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269296506/616512adf8f480351747e12b25fdc1a5-1730301322"
  },
  {
    "email":"alessandra@studiolegaltuffanelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269427578/9d266e8a095f8f4ffbac2a49b1243147-1730301322"
  },
  {
    "email":"avv.etamburini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269460346/8e3b7b8b6ee2c80a53387849e206e818-1730301322"
  },
  {
    "email":"stino73.sc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269394810/9721fd0817864250bde42e732183b989-1730301322"
  },
  {
    "email":"morimichela5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269525882/f248b00574190e68bfa6d0703acea5f4-1730301322"
  },
  {
    "email":"silvia.corradetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269493114/635429e178330da87895c7cda0d02ea1-1730301322"
  },
  {
    "email":"patro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269624186/fe6a2a3b11d46c10ee8ea1eb7bc7f1e9-1730301322"
  },
  {
    "email":"info@ferrnti.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723269591418/ff5cc88f223da29b81746aa05c160437-1730301322"
  },
  {
    "email":"manucrist@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269689722/1804345406df8ebee4b114c574517297-1730301323"
  },
  {
    "email":"giuliabongiovanni82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269722490/bd2293f0566e6cbcb0e130c73dbc51d0-1730301323"
  },
  {
    "email":"simona.zibecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269820794/2a4947f93210ea3b65706a3843a69b3a-1730301323"
  },
  {
    "email":"rriccobono@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269853562/93abd3525db6cbb27e5ae88993e2c2b8-1730301323"
  },
  {
    "email":"marital88@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269886330/36db01d7cf9e224228af075eea0f95d3-1730301323"
  },
  {
    "email":"petri.daniele76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269919098/69c56c3db66c947af42ecb0fe3ba206f-1730301323"
  },
  {
    "email":"maschi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723269755258/d50c555ee832c4eabb661d73f58fc8dd-1730301323"
  },
  {
    "email":"02maggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269951866/2e94f1cf30e476a32d34affbfaea294e-1730301323"
  },
  {
    "email":"cristinacaterino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270017402/e650e4e09529a6ba68e20c604b35b794-1730301323"
  },
  {
    "email":"sonia.traversa5@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723269984634/59e56511fb68e6e020333ce8ca36023d-1730301323"
  },
  {
    "email":"cfenile77@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270115706/2384fee025761c82945a99499ad0daf1-1730301324"
  },
  {
    "email":"diana_cazacu2003@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270082938/b5f20f8a6e587f885386b7b27c958c47-1730301324"
  },
  {
    "email":"dibuono81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270148474/b41de533bd844a6cc5e7366e9e6475d6-1730301324"
  },
  {
    "email":"manu-mi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270050170/c2b6d0788b42278c792b1a8c789ef967-1730301324"
  },
  {
    "email":"l.scampini@btsr.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270181242/825b4e0f778bab30dba464fa0c435076-1730301324"
  },
  {
    "email":"annaghisolfi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270246778/3f4c3a8b70bc5dd9951f2cde3cee077e-1730301324"
  },
  {
    "email":"audiomedicalsoluzioniudito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270279546/3c09dff9b0386d657ed41950f0291c22-1730301324"
  },
  {
    "email":"infowonderland@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270312314/1c90dd7287fd955cf4ead830aef815ee-1730301324"
  },
  {
    "email":"veronicadeleo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270345082/fb8f99263b78cbe52d1e7231a9a5ab05-1730301324"
  },
  {
    "email":"silvanavaltorta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270476154/baaa7be86e2d94ff54d094d14da2d834-1730301324"
  },
  {
    "email":"cristinamonni73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270443386/cfe91c1628395f14e74522bdbd282410-1730301324"
  },
  {
    "email":"mariarosamagnano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270377850/4c8c63948d499ee26a84be79804ec0cb-1730301325"
  },
  {
    "email":"barbaralis70@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270607226/7554e9c65da9ec8bd2be779c89fc14ae-1730301325"
  },
  {
    "email":"paolamemo2001@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270541690/54f9b064477957974640e919b314a54b-1730301325"
  },
  {
    "email":"avinogiuseppina74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270574458/471b7e064aae1e68c1ac13f2807028ba-1730301325"
  },
  {
    "email":"tisi.s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270672762/ee33efe03ee5c556a05bdf2cc4c2f6f3-1730301325"
  },
  {
    "email":"bar.fanton@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270771066/c6b88247b217a3d40b3a12d688a28426-1730301325"
  },
  {
    "email":"stelegie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270803834/addb38059ff71d08aa471f47e30dcfd1-1730301325"
  },
  {
    "email":"vincenza.concilio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270836602/aa374e43c34e0570f8e6444fc8810cf1-1730301325"
  },
  {
    "email":"ste_la@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270869370/9296927cf490791b21fc2167f1c8e9db-1730301325"
  },
  {
    "email":"ninitell.p@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270902138/a09e8ebd7f11ee8549283d5d6d2019ea-1730301325"
  },
  {
    "email":"kalivalentini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723270705530/72d974f07686451fbb9c3ece6c541827-1730301325"
  },
  {
    "email":"mariella.colombo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270934906/cda2db3d143ba96840f15b473e1df092-1730301326"
  },
  {
    "email":"alice.rondinini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271065978/5065e65a34d5e64237760d11cd45cb8c-1730301326"
  },
  {
    "email":"silvia@condominisiena.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271000442/b804f84cd02254d2761f396e540b035a-1730301326"
  },
  {
    "email":"valentina.amoia@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723270967674/09eaa15ce9b25ad0f87877deaffb1933-1730301326"
  },
  {
    "email":"momiji_89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271164282/6c1fc0a79e039ca5ed29b3884f465d14-1730301326"
  },
  {
    "email":"hailinvives@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271197050/fee5416e3dd47e40109a687c941700f9-1730301326"
  },
  {
    "email":"francesca.piccioni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271131514/365f4222acfdd1e47f268890dbd18bc0-1730301326"
  },
  {
    "email":"annamaria.pellegrini@studiolegaletului.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271229818/c039ba10464b53804b1498c57fbef880-1730301326"
  },
  {
    "email":"cesscasa@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271262586/c52b9e51c5a77b3b6a556fff9729fd12-1730301326"
  },
  {
    "email":"vgioiafufy@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271098746/43220dfcc07eb598387d0e1d3c096aa1-1730301326"
  },
  {
    "email":"bauinait@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271295354/11325e89909df2bc12c18720c58282bf-1730301326"
  },
  {
    "email":"monika.thomaser@albatros.bz.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271328122/566708b1af2617aa8c3527a91eaa322b-1730301327"
  },
  {
    "email":"rinierisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271360890/4c42777693c7f759a9ab8a9836465cc6-1730301327"
  },
  {
    "email":"beaneglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271393658/499f398007b595c6791d0eab09fae3ed-1730301327"
  },
  {
    "email":"mariottialessandra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271491962/8917e870ba24a5e1aba40c942d5512d9-1730301327"
  },
  {
    "email":"serravallegabriella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271459194/8763fe86920299b5f6cd056cb716c627-1730301327"
  },
  {
    "email":"vincenza.morra18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271524730/6a62fbfac9205615a93844eb3ca27269-1730301327"
  },
  {
    "email":"elena@pirtiolirappresentanze.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271426426/955bf6c995213e7aef6c330bb5eb53c5-1730301327"
  },
  {
    "email":"s.feliziani@ibssi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271590266/b203488a5b5acf8c200f2805c17cc0fb-1730301328"
  },
  {
    "email":"stefania.verdesca@studiotosetto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271655802/3fcf8dff19810a3d13689bed1512bffb-1730301328"
  },
  {
    "email":"robyp86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271557498/d09cf2e32951f5d8bb89953564778f43-1730301328"
  },
  {
    "email":"corinne.zaghet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271688570/4e6021ae47ac7b0f2ac6018854bfe1e5-1730301328"
  },
  {
    "email":"adorigo76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271786874/d7201f39fdedf5810233f295e6fc701e-1730301328"
  },
  {
    "email":"cri17carlino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271852410/d022983f36cb70ddb6a5a691f45bcce8-1730301328"
  },
  {
    "email":"massaglia66@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271754106/1385dac8c2a8d476ef186f361b9b6fcb-1730301328"
  },
  {
    "email":"frari80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271885178/aa891105ab92ca654b96ad460223caae-1730301328"
  },
  {
    "email":"barbara_toffolo@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723271721338/3379c26ceb478f74207eaa2e87702f88-1730301329"
  },
  {
    "email":"margherita_la.cava@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272049018/84c14465ea0bc6d050d8d706cf7c0beb-1730301331"
  },
  {
    "email":"paola13.nicolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271950714/2397e850eeb59cc021c759985957c979-1730301331"
  },
  {
    "email":"vittyscande9898@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723271983482/7fa16c509b26a91d233544e431404e77-1730301331"
  },
  {
    "email":"moni.casirghi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272147322/5e9324eec36eab76a1fa3925f3f269a0-1730301332"
  },
  {
    "email":"beatrice.moni68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272114554/e2ed9e539b29b28f8890761acd10e740-1730301332"
  },
  {
    "email":"marialaera@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272016250/545c3b386f57cd591222d6b5ab8219a8-1730301332"
  },
  {
    "email":"tamara23@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272278394/08cc84c89f44fdfe915139bb35b3cefa-1730301332"
  },
  {
    "email":"monica@merani.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723272180090/ea912d6e8e8bf0ecfd9663d1fa252ff1-1730301332"
  },
  {
    "email":"fabio.covra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272212858/a546f2225d5209f7591a86eea47ce26c-1730301332"
  },
  {
    "email":"ele1982@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272081786/8e73d6d3bbd80b9888f997e11cdbce86-1730301332"
  },
  {
    "email":"angelika.nicolosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272343930/6084449f6ce6d2d538e5d24615b3a515-1730301332"
  },
  {
    "email":"marcella50@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272376698/e63d76c9a3270d8574e75e47d2bbc8c4-1730301332"
  },
  {
    "email":"marco.mosaici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272475002/112f2761afa4c2a261b2173b2373c10c-1730301333"
  },
  {
    "email":"rdipasquali@finsea.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272540538/b97e9e78280e33d6db23ec1a89f5e751-1730301333"
  },
  {
    "email":"casagrandecristina70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272507770/08e7208edbb44892c903379d712dded1-1730301333"
  },
  {
    "email":"ily108086@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272573306/2da8cc343cc7182238e38692e25e21db-1730301333"
  },
  {
    "email":"silvy.lomby@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272606074/141d6e0801ce5742f5bacf09113c3222-1730301333"
  },
  {
    "email":"noahananogah@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272671610/b8301611c7f8789b07f4b3f43f80fa18-1730301333"
  },
  {
    "email":"loribergam@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272442234/26e6716df4bdce685a50ef3a892336bd-1730301333"
  },
  {
    "email":"elenac@omoleodinamica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272638842/465d4da51795d9f0580d7c30166424e5-1730301333"
  },
  {
    "email":"titoli@confartigianatona.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272737146/60a07e717825662fc3ad2f1e5779538d-1730301333"
  },
  {
    "email":"silvia.picheca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272769914/201f279f3bcc1beb2bc1ab90281cec94-1730301333"
  },
  {
    "email":"giuseppina.carrozzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272868218/4efd54e268d7f3b3f63a34229f2ca675-1730301334"
  },
  {
    "email":"anly_g78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272704378/ec55974040d34a1a6d2055b94bbd922f-1730301334"
  },
  {
    "email":"nicoletta.rizzo@studioaasociatorizzo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272802682/2eb73430a4a1616ed8a170ccdda7bcf9-1730301334"
  },
  {
    "email":"anna.erculiani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272966522/1f24739591563c2d221288b720128153-1730301334"
  },
  {
    "email":"giovanna.guercia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723272933754/bb8cde2a304fe047ca1a29c49ffc9615-1730301334"
  },
  {
    "email":"rama@rama-web.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723272900986/dd7f356b75396d735d6941568986ad19-1730301334"
  },
  {
    "email":"marvit11@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273032058/07e9679414d1d2709e961dbdee1d1466-1730301334"
  },
  {
    "email":"pirronesabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273064826/5274766c05242d84bbfeabdd38e32ca1-1730301335"
  },
  {
    "email":"antonellamunzio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273195898/336931582be0fbc6e99b3ae41fad6136-1730301334"
  },
  {
    "email":"daniela_saglieri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273228666/2ec571cd7f6f8dc67bc29079caf4bab2-1730301335"
  },
  {
    "email":"romina.toniolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273294202/9d673710f0c611a899ddc80dd6d28fcd-1730301335"
  },
  {
    "email":"bagni.elena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273392506/ded7c978710c8e3693ac26fa0ada0354-1730301335"
  },
  {
    "email":"chicca.h@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273326970/20ad84e84aaf6ed547fb3a13b31859b8-1730301335"
  },
  {
    "email":"capitaniste@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273425274/169b5e5f45ffb24def76d7a95c83f06a-1730301335"
  },
  {
    "email":"sami.ped@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273523578/6dd3c543a5f2e5bcf69afba69fd67779-1730301335"
  },
  {
    "email":"zaraffa73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273490810/98557a6b33b8f95ebb18d9094947dc20-1730301335"
  },
  {
    "email":"v.coletto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273458042/c05c6a025aa38abe5aed6ff04690e192-1730301335"
  },
  {
    "email":"stefano.sassi0@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273621882/bf8f52565cdb5107154264434c8c2499-1730301335"
  },
  {
    "email":"steffl@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273556346/6fc7e048b77dc29ac8a72ea57784301d-1730301335"
  },
  {
    "email":"lindapisani71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273654650/5df957bbfe439977e79e2b5494286a43-1730301336"
  },
  {
    "email":"svitullo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273687418/d831c6ac2e70125a813f27eb97faba69-1730301336"
  },
  {
    "email":"carolagiudice@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273589114/1d3f29d867db9658f555cc3dc06e4ba7-1730301336"
  },
  {
    "email":"clelia.panizza90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273785722/e00039735ae3cc47234dc9a90741e57a-1730301336"
  },
  {
    "email":"francescastedile79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273720186/e2084de5f0113def32eb9c251ca344d8-1730301336"
  },
  {
    "email":"silviaansaloni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273818490/2c0ab2a5afa7452032728891c94fd3af-1730301336"
  },
  {
    "email":"danielasolaia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273851258/b5571da4005620547e19865360c0bde5-1730301336"
  },
  {
    "email":"stefaniacostarelli80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273884026/26c802afcc29600c7f4eb332560ff661-1730301336"
  },
  {
    "email":"maricabisetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273916794/1c5f74716568f4081a21f85e3e49097c-1730301336"
  },
  {
    "email":"alicemicheletti25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273982330/c5a4111da0fbfcc2794f45fa5b0ce04c-1730301337"
  },
  {
    "email":"stefaniadima@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723273752954/7d94694b6f08bf67a97cdf2b9275315d-1730301337"
  },
  {
    "email":"pezfrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723273949562/bc9dfe69787d37c5680bf15c5f7c8714-1730301337"
  },
  {
    "email":"betty76p@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274080634/47e6cf3421c20f5ecfb9d40e96c22296-1730301337"
  },
  {
    "email":"simonetta61@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274113402/e0f535053d0848e53de075b42b3a9f1a-1730301337"
  },
  {
    "email":"alessia79@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274015098/79750b7184dbdf133905086ef4a726d6-1730301337"
  },
  {
    "email":"silviapit23@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274047866/fed4ac213a052ff6899323aa1d18ddb8-1730301337"
  },
  {
    "email":"belena1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274146170/1fb6313ccfac2044637d86d9532b3700-1730301337"
  },
  {
    "email":"laralucchi28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274178938/d421b2365d692fe09887298fc1deb596-1730301337"
  },
  {
    "email":"fede.borsato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274277242/66154ef9bf6f4a90146d25e147cc3d99-1730301338"
  },
  {
    "email":"tatyge@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274244474/7637a9e63dd168114b90df146c9a1694-1730301338"
  },
  {
    "email":"avvporta@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274408314/0a727aeecef6da7adefbea39eec07f49-1730301338"
  },
  {
    "email":"francesca_dima@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274375546/3410c94ccac0a2ef1f598e0ffa50fa82-1730301338"
  },
  {
    "email":"b.casolla@porto.napoli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274310010/9c69c7d55d31c4ec5cfcdbf392fa42fc-1730301338"
  },
  {
    "email":"peppeddu7@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274473850/41568182be8487015a2249b62c4cec62-1730301338"
  },
  {
    "email":"lnuvoloni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274441082/e5ee6a8fc41aecfa78064946c0c5327e-1730301338"
  },
  {
    "email":"ferribattuti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274506618/0219da48510daeea59d251ea79cc5fbd-1730301338"
  },
  {
    "email":"simonetta@maggimassimo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274539386/75f4f12e14acfd0f3dacc73818c6c1b1-1730301338"
  },
  {
    "email":"dani.celestini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274572154/f617922fc7b74e91db967b104b4140f8-1730301339"
  },
  {
    "email":"pizzo.francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274670458/cafb5821ef41fec86db22b95869c750f-1730301339"
  },
  {
    "email":"nicotera77@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274637690/b2e5c183c76121fd023d3ca0062adbc2-1730301339"
  },
  {
    "email":"simona@studiovalentiiacoponi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274703226/aa7f1fbc43da480aa97d8391aaf686c3-1730301339"
  },
  {
    "email":"stefania.bato@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274834298/99d064b76e01693bbf2dffb3dd3cd02f-1730301339"
  },
  {
    "email":"chiara.barbazza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274735994/778f65e64e7c70c3e0abe7807162a740-1730301339"
  },
  {
    "email":"alebocus@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274801530/094a06a944dc710256747f0e1aee9bce-1730301339"
  },
  {
    "email":"cciboldi@its.jnj.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274867066/5a4e07879633b2d4fbd1003218cb999b-1730301340"
  },
  {
    "email":"kohleranja@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723274965370/f8a17698412b621cbbe38ebb808f696d-1730301340"
  },
  {
    "email":"noemi07@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274899834/1bebcb56ecc7dd942d109bfd3c217d46-1730301340"
  },
  {
    "email":"pollini.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723274998138/a2a11eadb159ca81659337911356d042-1730301340"
  },
  {
    "email":"cristian_fava@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723274932602/9cc39001661008b7890fd03bebfa2da4-1730301340"
  },
  {
    "email":"elisa.nardi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275129210/bc642b45de7f99b0d5a7a6dfcfc038d2-1730301340"
  },
  {
    "email":"mcristina.nucera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275161978/9795d537b89d0a380a4139aad3b20eaa-1730301340"
  },
  {
    "email":"chatia.castellan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275194746/0c17c5718dc0749e93de2fa2cb46ef7a-1730301340"
  },
  {
    "email":"l_annette@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275293050/980c2724992b91df2ce7c4b49588eac7-1730301341"
  },
  {
    "email":"crudelia78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275030906/b2886a3be4f1963af76091313332b012-1730301341"
  },
  {
    "email":"marchetticarmela77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275227514/867ffc8f74b6e161718326620b330891-1730301341"
  },
  {
    "email":"hal.gorg.1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275260282/f6888accdd60e7566cf39488e8fa2fac-1730301341"
  },
  {
    "email":"anna.delorenzo73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275325818/1c1344fd5524f9fc8baaa645f6a65fbf-1730301341"
  },
  {
    "email":"raiti.paolo@dasanto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275358586/9d67c27318a99f9965802c3a61b6be52-1730301341"
  },
  {
    "email":"antonella_defalco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275391354/46237fe1710ec9061c23a42e20025ffe-1730301341"
  },
  {
    "email":"eleonora.valent2013@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275456890/7fbd9f0509e37108ff0396993b2c8bac-1730301341"
  },
  {
    "email":"katia.grazzini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275424122/65c3a0ccaae64607cd723f12fbb25e42-1730301341"
  },
  {
    "email":"mirta.redoglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275587962/dc4f9a2c92915be32c223b60e2008984-1730301342"
  },
  {
    "email":"imeneschincheri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275555194/31871214f75fb4b13666266b2de63568-1730301342"
  },
  {
    "email":"manca99@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275489658/c5fd621687ee9b101f8da29fe5cd72ae-1730301342"
  },
  {
    "email":"dott.luisadelia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275522426/54b8b75a154c9cca83daf9babd16e014-1730301342"
  },
  {
    "email":"lamarcavenusia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275653498/d390ea7e0fe96c62a3ef53c28a76cfe5-1730301342"
  },
  {
    "email":"alexandra.herinean@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275719034/2612f5a10228d92afb95964f02969710-1730301342"
  },
  {
    "email":"fede.vecia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275751802/7398b9ee4f30341d9d3399c32cd57d6b-1730301342"
  },
  {
    "email":"tatiasciu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275686266/6db28748ea3eeae22a10fff593d5de8f-1730301342"
  },
  {
    "email":"zazza05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275784570/fdc5655f7fdc6beb40a1df38277a764a-1730301342"
  },
  {
    "email":"aparisotto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275817338/53ddecffa50b9e9ec7693b1086da3f50-1730301342"
  },
  {
    "email":"marica.asperges@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275915642/c3edfe5ddbf0184033911e3cec123d31-1730301343"
  },
  {
    "email":"gabrydatri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275981178/39afc1b097a7cb7269005437bacbe27e-1730301343"
  },
  {
    "email":"cla.ghezzi08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723275882874/5252b25088140470f1130994c14173d3-1730301343"
  },
  {
    "email":"capitaniglara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275850106/48fa53ff866441ad63e64068aa184d0c-1730301343"
  },
  {
    "email":"lorymanci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723275948410/f7f0a3761915373281d3124d69f6614c-1730301343"
  },
  {
    "email":"patriziapavan.tv@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276013946/dfbadd4b442d1c385ac4fafae274f8b5-1730301343"
  },
  {
    "email":"cpt_green_eyes@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276046714/5e41c1d77abdf1538b69b6465acd4376-1730301343"
  },
  {
    "email":"silvia.almerigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276112250/8158f9d4a1f73517fe986f8550669efc-1730301343"
  },
  {
    "email":"marvi.w@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276079482/269633b4fe2a3fa38aa577aa6541832c-1730301343"
  },
  {
    "email":"gspadacini@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276210554/153e78b5e2cceb6a8be15b4bcbdaf5fb-1730301344"
  },
  {
    "email":"federica.maranzana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276145018/9268a0246c534a7ead35e18aa62c31a3-1730301344"
  },
  {
    "email":"giuliana.dinatale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276243322/3ee56b5080f7267638d264719c2014db-1730301344"
  },
  {
    "email":"aghitom@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276276090/73877f0c1d945eb245722850b0185b06-1730301344"
  },
  {
    "email":"virbom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276308858/1cde1c6ac7326bed781f29f810bb494b-1730301344"
  },
  {
    "email":"robyfur30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276407162/0e5303f46294d42a2de31a6a89d154ce-1730301344"
  },
  {
    "email":"ermasi@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276341626/1f1aadce81398eb33359d3ac6015627d-1730301344"
  },
  {
    "email":"raffa.dimauro.rdm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276472698/55a41077e90c78943437bae8f87a76e0-1730301344"
  },
  {
    "email":"desyree10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276439930/3e755d9d7b13b1cea026331c6eebfe99-1730301345"
  },
  {
    "email":"melimarcella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276505466/49277bcf2b907d96ed9fd66b5c13f2fe-1730301345"
  },
  {
    "email":"fcasavola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276538234/e49eee16e618d3e48658ea6ddbbdbbbc-1730301346"
  },
  {
    "email":"greghiggeri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276571002/f289c6fdefaf31ce0011fb894c9cd354-1730301346"
  },
  {
    "email":"veronicaparis@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276603770/4980513045780625b3ce5435fa49a830-1730301346"
  },
  {
    "email":"fragolinag@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276669306/a99c5b5c0403d9f32bbfc26115c5c107-1730301346"
  },
  {
    "email":"tabesalimbeni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276833146/bcd366bd6352cb12c3ac9903ca1d28f5-1730301346"
  },
  {
    "email":"mina.mottola@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276800378/4df4c3e5c8cc23711df14b5740135153-1730301346"
  },
  {
    "email":"mila.rovesti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276734842/280fec805fa84099012d9b77cf39c5ed-1730301346"
  },
  {
    "email":"info@erikahotel.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723276865914/9f005d4bdb719c8920f55e9e51d11590-1730301347"
  },
  {
    "email":"samantha.gambato@filoblu.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276898682/42c4758b0a3c1be1ebf2ca5b5e4e19c8-1730301347"
  },
  {
    "email":"alessia.polifroni@ap-legal.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276931450/3cdd24637fec7ad0c673b9d34c0c005a-1730301347"
  },
  {
    "email":"orietta.borsi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723276767610/6eca562963192ba2f7fc5ad75e726eec-1730301347"
  },
  {
    "email":"ferdy77@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276996986/5f3aba5544d17a9e959646cec9c03013-1730301347"
  },
  {
    "email":"stefania.rabia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723276964218/6a59a36726871dee5d6966827c1acbe4-1730301347"
  },
  {
    "email":"cristinacassanta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277062522/23867505a05bef19277e07b038cbd331-1730301347"
  },
  {
    "email":"giada_giorgi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277095290/8d02cbae488fdca3c7d4f6bb351c636e-1730301347"
  },
  {
    "email":"ilabarbato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277029754/062325c43a52857635e89b690de3e99c-1730301347"
  },
  {
    "email":"picchionidaniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277160826/9939f5d124f5285011b8d4eb2eaea7e7-1730301348"
  },
  {
    "email":"barbaranto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277128058/4273b93d085bc6b12210c668e40455da-1730301348"
  },
  {
    "email":"isabellabalzano56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277226362/f0c1589c8225aecc63de604c5734a409-1730301348"
  },
  {
    "email":"marika.trozzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277259130/83d276446f8fecd3f4483621186e97d0-1730301348"
  },
  {
    "email":"barby150775@g.mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277193594/0405c64b84541f0596fcacf07150425c-1730301348"
  },
  {
    "email":"fedegiak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277390202/28c0eb102136d991043687b17781ecb0-1730301348"
  },
  {
    "email":"filianna@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277291898/658bf1d099358559bdb62287fb6de235-1730301348"
  },
  {
    "email":"simona.mazzoli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277324666/971d28d1828ff2b08bb3cdeb5f32671f-1730301348"
  },
  {
    "email":"valeriazenobio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277488506/f052c80088f453646cbce0ce4f89c42e-1730301349"
  },
  {
    "email":"lisa.web@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277521274/abe181e0c5cb215f0ac1cafdec01160a-1730301349"
  },
  {
    "email":"marialarocca1985@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277554042/a40f726b1cccac671dfca3c37723aae5-1730301349"
  },
  {
    "email":"pavinlegnosas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277357434/e0e83f0f8a6fd0cdeb22e1eccf79011e-1730301349"
  },
  {
    "email":"gudrunpatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277586810/4417ff6dc328984e549da27a63b7748b-1730301349"
  },
  {
    "email":"gbernac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277619578/591a2151836b6fc5b483c448691a11e1-1730301349"
  },
  {
    "email":"saraleon@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277750650/9a64217f47b907d98e71e96393f6b477-1730301349"
  },
  {
    "email":"gabriella85_m@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277652346/fa0bd862389432f300e665a4b0c16329-1730301349"
  },
  {
    "email":"manueladilella@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277783418/0e8a175d387b3e326b431b69c1592ee2-1730301349"
  },
  {
    "email":"sarapironi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277848954/5ab4f0d1b78d8e704d96b705c45a0a7e-1730301349"
  },
  {
    "email":"elena.bussolati0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277816186/dee7dd16a4bf3b0db1f0cbd5550967f0-1730301349"
  },
  {
    "email":"claudiafava1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723277914490/701bc7eec34cf4d2f05d2d4c98e94270-1730301349"
  },
  {
    "email":"fornello.sabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277947258/778aa19b74ab6def1dbf89a0fbe3ae93-1730301350"
  },
  {
    "email":"francescapallavicino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723277980026/51536189d2114bf6d441cc0c69eaacd3-1730301350"
  },
  {
    "email":"raffaella.furlanetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278045562/b37f5bb8c0498da3ed9ee33358a3c82d-1730301350"
  },
  {
    "email":"bergonzini.carla@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278078330/b7caa4060d7e12f1d8777f04af795588-1730301350"
  },
  {
    "email":"lindalelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278012794/2e809d4629e9c8e22907515eb8cac7d6-1730301350"
  },
  {
    "email":"ferdinando@ferdinandogeraci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278143866/16dcaec2fdf8a45cccca392d57ed2a1f-1730301350"
  },
  {
    "email":"quitadamogiovanna70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278176634/2a144c7574478e6cf9afc86565427fa1-1730301350"
  },
  {
    "email":"manuela.sabbatini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278111098/b98cb722f3548303067d5b1b1689ca94-1730301350"
  },
  {
    "email":"stefania.barattolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278242170/094929ed5371aa781ed1646956462b13-1730301350"
  },
  {
    "email":"manco.p@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278373242/c158bbb81c184f55cf54c285980d0c6c-1730301351"
  },
  {
    "email":"roberta.direnzo1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278274938/76b6687b3d2b44d7f8c2bad138e24587-1730301351"
  },
  {
    "email":"sanavio.giulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278307706/c425e93dc11f40f188b155855bb5755d-1730301351"
  },
  {
    "email":"saradagostini1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278406010/0fded4343f9756b7c29901b9d4fe5a87-1730301351"
  },
  {
    "email":"ccarmen@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278471546/85ad4d79463e40bd50200c77a262176a-1730301351"
  },
  {
    "email":"francescadb2003@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278602618/2241335dfe606d7f26996e838ee25339-1730301351"
  },
  {
    "email":"laura.gerry@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278569850/09616dc7daf5b0e97f377cee51e2a9df-1730301351"
  },
  {
    "email":"katia@ceramvetro.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278635386/5c34222d407a438c32ee0f5b7a6e4251-1730301351"
  },
  {
    "email":"bolisfrancesca@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278668154/37a31641aadd0b272acbf323053629be-1730301351"
  },
  {
    "email":"eldusgi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278438778/112de4ec53b76963fd790b738a7e700e-1730301351"
  },
  {
    "email":"annalisa.annalisak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278700922/3f3da9d944707a3449dad91c1d2b7a13-1730301352"
  },
  {
    "email":"paolaa763@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278733690/522f01d9c21ffe55662c9d9c89ebf4d4-1730301352"
  },
  {
    "email":"elisabetta@franchinisrl.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723278799226/6383e866c3bb92f5c8a3860bf365757f-1730301352"
  },
  {
    "email":"tiziba73@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278766458/af076272be506ce3e614467186a07623-1730301352"
  },
  {
    "email":"robi.menghini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278897530/1596fe3f3412c9b515c4146d9b94db47-1730301352"
  },
  {
    "email":"alebuccioni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723278930298/bc9613c08734d7de287bdbb891c4d0aa-1730301352"
  },
  {
    "email":"seabbra@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278831994/990c5b8c84f87f75073f93898456cd62-1730301352"
  },
  {
    "email":"cinziaderosa.cdr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278864762/ac546937f50d259028446ed6da6ccc43-1730301352"
  },
  {
    "email":"gian.det@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279028602/70acab2067aa3a9da239426c02d8065e-1730301352"
  },
  {
    "email":"samsgarbossa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723278995834/e92a306e7f3b827d2e6232a382c992b3-1730301352"
  },
  {
    "email":"sara.simeoni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279094138/d89cb8a434c346086f6399832456c827-1730301353"
  },
  {
    "email":"fede.cornale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279192442/e6bf0a244f33414f92542b36f53998e4-1730301353"
  },
  {
    "email":"luana76e@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279126906/a34f2e138a4468dd08cffdff7813db89-1730301353"
  },
  {
    "email":"mp.brienza@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279159674/86f91191044ba31b9cfc7b22f7ab42d3-1730301353"
  },
  {
    "email":"elenapatrono@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279225210/0c9d1bb2b9a7363e3e62e6fb5225c448-1730301353"
  },
  {
    "email":"milenatroiano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279389050/086dd648a59b8f5db264b6a71e73d190-1730301353"
  },
  {
    "email":"simona-novelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279257978/15e7fd4238d5d5174361bd1066e8340a-1730301353"
  },
  {
    "email":"barbara.forleo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279356282/5f1f6f699dd24687c8791943a772ffaa-1730301353"
  },
  {
    "email":"chiara-nembrini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279421818/8e4e2e49ad734b8da2507c137b6e3dbd-1730301353"
  },
  {
    "email":"chiccaug2001@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279487354/0592cd45d6114b6d2f428a4dd3464c15-1730301353"
  },
  {
    "email":"valentinasallustio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279454586/74c0f6e8e6315c68ce446a51197c1c1a-1730301353"
  },
  {
    "email":"daiana95@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279716730/844e802488d07e23207825548900e50f-1730301354"
  },
  {
    "email":"simona.caldera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279520122/566bdccf523ca7319a427998268155d6-1730301354"
  },
  {
    "email":"donata.c@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279651194/fc4fed69057dce3ca86a446eccc17403-1730301354"
  },
  {
    "email":"lorenzo.carollo@kurita.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723279782266/0bd581dfa7a33c18cc0950ca705b7e91-1730301354"
  },
  {
    "email":"sonia.mattioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279552890/7f41384a7ed890fe26371c7f33548eb9-1730301354"
  },
  {
    "email":"glop1979@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279913338/1a0df89f0b3135e863276bdf7788480e-1730301354"
  },
  {
    "email":"simona.gery@alice.itq",
    "url di attivazione":"https://verdissima.it/account/activate/22723279946106/2658ac3699f42c6eb92f6f4714a36262-1730301354"
  },
  {
    "email":"camilladacrema@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280044410/614e499626877b4ff8fc0d3945a6978e-1730301355"
  },
  {
    "email":"michela_ricca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723279978874/b90d61c00faa199cd0cb56e2dd49bc74-1730301355"
  },
  {
    "email":"claudia.patelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723279880570/659411cd95e32caf13fddef1bf6f259c-1730301355"
  },
  {
    "email":"desenzano@bluvacanze.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280077178/0e4cc8a33d8f9e6ebb3c7179b37639e1-1730301355"
  },
  {
    "email":"rosanna.petrucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280175482/973cbf12c9735a3345ffec302740cbf6-1730301355"
  },
  {
    "email":"beagyal@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280142714/0c5a2e385276e96970b5d81d8e0a9fb4-1730301355"
  },
  {
    "email":"roberta.garzon1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280241018/8d9e34fc8feb84b7f9c861cc6604fade-1730301355"
  },
  {
    "email":"anitamastrullo@infinito.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280208250/f9d2d8626e873ba27b1c336a72993baf-1730301355"
  },
  {
    "email":"avvlauralaterza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280372090/1d0133cd04b747534d2171aacd8a494a-1730301355"
  },
  {
    "email":"lunasabri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280306554/0aa753f6d2deb5768672602ebe3c65bc-1730301355"
  },
  {
    "email":"sandra.moroni1@mps.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280273786/3d31a997921c083c0861e343cd246639-1730301355"
  },
  {
    "email":"chiabram@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280404858/1edf59c7be615587041d7a54295d272a-1730301355"
  },
  {
    "email":"valeria.bonetti@stud.unifi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280470394/4b768282cb947ee8d0f2b4c4239a0398-1730301356"
  },
  {
    "email":"pescas76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280437626/b1961d0e8f375f2e0c93455793d56d86-1730301356"
  },
  {
    "email":"mara.ved1977@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280503162/e16655c1e435ce05207eaaafd56b54e7-1730301356"
  },
  {
    "email":"aneliramit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280535930/c14293aeddc53e057b8fae857fad5538-1730301356"
  },
  {
    "email":"micaelademarchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280667002/48172e82c0efd9fa22c83b8c41749313-1730301356"
  },
  {
    "email":"pimpinelli.anna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280601466/f7904b7a9afbffb54f3ec361fb9e9a82-1730301356"
  },
  {
    "email":"cervelleraada@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280634234/5de0d0488fc3b16efbf7e906105182ec-1730301356"
  },
  {
    "email":"saratre1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280699770/ed50b8c992947a878ffaedef0e9b5633-1730301356"
  },
  {
    "email":"silnovecento@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280830842/04ced026e3e0660f711dbf5b18a0e3ef-1730301356"
  },
  {
    "email":"jessica.diforte@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280765306/e3a93f25bfc5ca49d6196f273e0a2f5b-1730301356"
  },
  {
    "email":"rossanaraspanti@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280798074/7d19c3d2d39ff2b59941230c282a538d-1730301356"
  },
  {
    "email":"katia.micheletti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280863610/a39ad4276b1be67341e40416ca49fd22-1730301356"
  },
  {
    "email":"manula.sestili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280929146/7b41122e81a963c4ff8af10a8e1c113c-1730301356"
  },
  {
    "email":"simona.castiglione@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280961914/fe52da7de2e75012a9ce0f3e26b6ed61-1730301357"
  },
  {
    "email":"a.romani2116@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723280994682/b0c4e23c4b20e4f7d75229898f6834de-1730301357"
  },
  {
    "email":"fmoonlight09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723280896378/43b1cac69575789e49e5cb5152fd298b-1730301357"
  },
  {
    "email":"stefysant1983@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281027450/52fba31ba16329e8b93c36eb4499e9d9-1730301357"
  },
  {
    "email":"a.criniti@studiocriniti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281060218/300f37f7e03e3abcddc59aa265a4c8e5-1730301357"
  },
  {
    "email":"mariarosa.stefani@epitech.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281092986/c9c9b3df802ccaf42ff1afffcd7204a6-1730301357"
  },
  {
    "email":"pmrdamico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281125754/9a244a172a69fdb82f4c76ab1cfd3ad1-1730301357"
  },
  {
    "email":"ac.lupetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281322362/fa8f64bc96af77f5c96aac4231e8a3e4-1730301357"
  },
  {
    "email":"eugeniasiciliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281355130/f18fb290212c2d53a249a66845b0a2fe-1730301357"
  },
  {
    "email":"dsannino@invitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281158522/382cbfa7b0c928d25220fe1bebc7e4b7-1730301357"
  },
  {
    "email":"valeria.lucidi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281224058/e2b6b96bad099aa255aee41f919f4c41-1730301358"
  },
  {
    "email":"manuelarollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281387898/d09783faa0b96ca0c5c6bae3e90007c3-1730301358"
  },
  {
    "email":"dada2008@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281453434/7068ea729501e61d2c3af8945a67f614-1730301358"
  },
  {
    "email":"annamagaldi68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281486202/d741c056f3e4f54f3d7fa1ad075ae1c4-1730301358"
  },
  {
    "email":"vozzati@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281617274/490309d0ab72314110ffea50f6dfc299-1730301360"
  },
  {
    "email":"donatellabalini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281584506/d19f77a9ca36e4460995c0a7ccd30a63-1730301360"
  },
  {
    "email":"saragiu78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281682810/ca7590b2bf8ee9db0db840eb933adacb-1730301360"
  },
  {
    "email":"piscopo_francesco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281715578/61fa075722ad2abc00df9204d792fe50-1730301360"
  },
  {
    "email":"francesca.rategni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281518970/3b4805ee87ca69f593cb296d8e13acc3-1730301360"
  },
  {
    "email":"ornellascordo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281551738/b52ba4fc62b8825ded2d399904b54f8d-1730301360"
  },
  {
    "email":"reginaportelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281781114/96971609fba873ac82e347d80695d706-1730301360"
  },
  {
    "email":"claudia.patelli@lombardamotori.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281846650/bbdac319a91d8cae34f67f0bcbc39410-1730301360"
  },
  {
    "email":"barbara.baratin@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281879418/e2480c163d4927849bcd4c6e81a69cf2-1730301360"
  },
  {
    "email":"sz@scatolificiopozzi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281813882/95a924c02c9881869c457e7d7c82bc25-1730301360"
  },
  {
    "email":"stefania_buzzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281748346/3585c5e8a4e3bd646c455b886a1dd4e7-1730301361"
  },
  {
    "email":"iacopobuddolo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281912186/7ed801566ac08eb78a258a6edea45159-1730301361"
  },
  {
    "email":"raffaellabot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723281977722/b7bf315b8f202d4945acd98f0f4afb7e-1730301361"
  },
  {
    "email":"alessiagiometti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282010490/7c8503ac25cfafca8b72b034465e6c1e-1730301361"
  },
  {
    "email":"mauriziofanuli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282043258/bd9aa9fadbcc9470030318b1a7113718-1730301361"
  },
  {
    "email":"sabrinagraziano_2011@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723281944954/d6dcd3ef6774b6d397f59ab3c7ec8920-1730301361"
  },
  {
    "email":"tiziana.marangoni@polito.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282108794/ec01f3cd669d6645b7547fe56dfba429-1730301361"
  },
  {
    "email":"amandapirovano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282174330/57556936fff41885476e8ead2edcbe63-1730301361"
  },
  {
    "email":"barbaralavazza1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282207098/cb9c60917be398b1a964e106405de1ad-1730301361"
  },
  {
    "email":"chiara-corbara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282141562/2b1599e18e082f573add4652fd8304d3-1730301361"
  },
  {
    "email":"michela.culos@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282305402/96e976704cd4dde37f3fd3f828d0a412-1730301362"
  },
  {
    "email":"collins.co@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282239866/931532636719043448742e289f1e97ad-1730301362"
  },
  {
    "email":"crescenza1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282370938/359374f9c8b39399a267af5168ee4b29-1730301362"
  },
  {
    "email":"niccomat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282338170/c0e441bcec8c497809a27245f4d95e09-1730301362"
  },
  {
    "email":"iradieffe@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282436474/12c53b87d826692644621618dbeb0be0-1730301362"
  },
  {
    "email":"stefaniameirone@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282403706/ea60285300ac6bc3930adabc713f9eab-1730301362"
  },
  {
    "email":"marisadegregoriomdg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282567546/78b31b1839470f7c9c6e3f81a1fb5d5e-1730301362"
  },
  {
    "email":"monikafazio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282534778/264d3bd3a8292b5ceb2161b0e5c896dd-1730301362"
  },
  {
    "email":"coccia.guido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282469242/f4e6d9a5707f5b7cb0b886e6b79846a1-1730301363"
  },
  {
    "email":"elisabetta.barbaro71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282633082/48ddbb58f2b0c004bad137879e466ed7-1730301363"
  },
  {
    "email":"r.valeria@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282665850/06f568a4cab42be13d1aabee8492f648-1730301363"
  },
  {
    "email":"zanzurinogiuseope@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282502010/1760b48782a5799841a202d953f04b56-1730301363"
  },
  {
    "email":"stop.loss@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282829690/8937542d37d1407b4983e21c38a0298d-1730301363"
  },
  {
    "email":"antoniaastronio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282796922/6104bad4c70ffaaf523b0587600fc9d4-1730301363"
  },
  {
    "email":"simoerri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282862458/11a23eb29109baf700ffdf12b384aae5-1730301363"
  },
  {
    "email":"dott_astrid@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282731386/e421a11b5e8ef1484ceb3711bea57272-1730301363"
  },
  {
    "email":"monica.armeni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282895226/06478a19973e4d71d6caa7acddc39603-1730301363"
  },
  {
    "email":"alessandra.girotto.1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282764154/be199f96f2e59dff9a967b11b29b591d-1730301363"
  },
  {
    "email":"danaynreyes@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723282993530/9b721fe1abab081d71aab2e6fa85174d-1730301364"
  },
  {
    "email":"silvia.frattale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282927994/1e346e88de51d224b28e3e0ee9ab22cd-1730301364"
  },
  {
    "email":"mpibiri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723282960762/425861cb47a402c069a65a60f479af11-1730301364"
  },
  {
    "email":"cristina.nencini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283026298/1a27bcb6419b6fb6bd0a66a25f56a6a8-1730301364"
  },
  {
    "email":"anna81e@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283091834/d225d287a4732445ea8cd155616c44cd-1730301364"
  },
  {
    "email":"claudia74.giorgi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283190138/fd3236eb54bd78b316b68154b62bd900-1730301364"
  },
  {
    "email":"manca99@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283059066/663f08a7dec479e2239121804961bc56-1730301364"
  },
  {
    "email":"dpolesel@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283288442/29fba6928f2fb0a51c5fb5ac147729eb-1730301364"
  },
  {
    "email":"sabina@sicurasrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283124602/fd6e17e77d406d61048dedd0dc9d621d-1730301364"
  },
  {
    "email":"elena.soncin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283222906/74945e3ac2700255cf7c639548f0da18-1730301364"
  },
  {
    "email":"camagni.francesca@creval.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283452282/c78bc5af7e1ab6cccd25eeb85954b773-1730301365"
  },
  {
    "email":"elisa.mala@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283255674/2977b38946098c4ddbe8b957e1521173-1730301365"
  },
  {
    "email":"ninamaria.fecht@sodalisgroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283353978/db0a9040da52a5cae41aa4d9b444980c-1730301365"
  },
  {
    "email":"monicadriussi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283386746/b909a91bd17acfc31febe388975d7339-1730301365"
  },
  {
    "email":"barbarabignotti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283517818/48d722ad1dc2f3ef3095b17ee15c96a9-1730301365"
  },
  {
    "email":"silviavannucci74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283583354/08b446efed2505794338dc8c3db07b71-1730301365"
  },
  {
    "email":"gege.983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283648890/5d9cd8320e5e0603b02b25d78b6288ca-1730301365"
  },
  {
    "email":"gaiaanna.bellomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283714426/1247e44a5308d06fd0db1f06f3b28499-1730301365"
  },
  {
    "email":"madalina.iuliana03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283779962/f009a6793bc9e6fb7208ff8774782005-1730301365"
  },
  {
    "email":"francescoingrosso96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283550586/42e192caa0e23d08bc9d5c57a3a71a93-1730301366"
  },
  {
    "email":"dott.antoniogarcea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283845498/b88255c0f485cdf2df134963d18071cb-1730301366"
  },
  {
    "email":"slv.liceotco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723283747194/dc663434abdcc410dbc1d9062479f2e8-1730301366"
  },
  {
    "email":"francesca_costarelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283878266/9ddfb5eb1944846cb9ca17616bc67241-1730301366"
  },
  {
    "email":"sabryfree1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283812730/5e1565b0e18290b314116134ddcddd65-1730301366"
  },
  {
    "email":"palmieri.ilaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283911034/165b9991bf4e375fb49042151291e931-1730301366"
  },
  {
    "email":"avv.antoprimizia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723283976570/b2f94ca4c0c827410969a8a5318338bc-1730301366"
  },
  {
    "email":"s.fra979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284009338/26b4bacdd0743664ae2d199c8ca28960-1730301366"
  },
  {
    "email":"lauracurti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284074874/3a8082e3b4a052b3cec4fb5135672653-1730301366"
  },
  {
    "email":"architetto.cortesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284107642/b02f44e592c7f4a357e06e7235e8295d-1730301366"
  },
  {
    "email":"alblaura@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284173178/7a9b33a2f3effc3386ac11e3544d2a24-1730301366"
  },
  {
    "email":"clagau82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284140410/800cf5e8b8bf88568320e63c2db7672b-1730301367"
  },
  {
    "email":"zacco.simona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284238714/108da1c4fa5b3de4153e1083e6706474-1730301367"
  },
  {
    "email":"magabi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284337018/028213408234680f9eaca9700a469e5e-1730301367"
  },
  {
    "email":"nicky66@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284271482/e18adbe2fa9810c6c190d181968eb481-1730301367"
  },
  {
    "email":"giovannadicocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284369786/65e47d9ead049b95872929c5dacd49a7-1730301367"
  },
  {
    "email":"manuela.sestili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284402554/e85f56797546d7e25bc1fe8f043fe1bf-1730301367"
  },
  {
    "email":"carmen.carvelli75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284435322/73308cd9ab77d4d24c9db765dc93c707-1730301367"
  },
  {
    "email":"elettrabr@uahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284566394/91db91e138a441c87ef88c5a55587a04-1730301367"
  },
  {
    "email":"santucci1967@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284533626/ee1108571ce2a159ab2566e4e060e25b-1730301367"
  },
  {
    "email":"lisa-reccanello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284500858/a19006cc24b50b05bca84a5cb9358e4b-1730301367"
  },
  {
    "email":"giada.dalcortivo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284730234/f3016d50aec9bd22d2b250884d4d61cb-1730301367"
  },
  {
    "email":"chiaracarsaniga@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284697466/0384a40e9868e75655ea80cf7442e1fa-1730301367"
  },
  {
    "email":"comeben@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284664698/6d00936fbe89fb38a7a9c2545a70218c-1730301367"
  },
  {
    "email":"marika.campana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284599162/f3f1503605ae5a3f8da50b404e1ce0dc-1730301368"
  },
  {
    "email":"gabriella.gnocchi12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284763002/097aa98dda65d34074c5a07a52e86d3f-1730301368"
  },
  {
    "email":"elenaneviani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284795770/a6c09372dd9bcfeccd0f43a1ed2ffedc-1730301368"
  },
  {
    "email":"aliceamendolia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285025146/2ea87529088a7c125f076902a53eac34-1730301368"
  },
  {
    "email":"silvia.luz@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723284959610/d68e56b9c548761b2af68c393ee0d436-1730301368"
  },
  {
    "email":"pinu.giamma@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285057914/e7fde346839d655b98500a8d12d42f1d-1730301368"
  },
  {
    "email":"sz.pozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723284828538/4c09d28582960e1ab0d38a03e7c51722-1730301368"
  },
  {
    "email":"michelagrilli74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285090682/2d9d354ff6fe697ba51e4550a42d01aa-1730301368"
  },
  {
    "email":"carlamarrani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285123450/9b8823c4524440e12d720a2a6468824b-1730301368"
  },
  {
    "email":"adamiale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285254522/16c42ef2586f51a8a4ea7a0855164056-1730301368"
  },
  {
    "email":"scotti.greta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285221754/637a74b3ce821183d4163adb990a23a5-1730301369"
  },
  {
    "email":"and.martinelli83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285320058/dad46aabb78a2f2a5f5e9526fdc4d9a4-1730301369"
  },
  {
    "email":"piccinnia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285385594/c39d734fe4536ba12f5f7bc574445e94-1730301369"
  },
  {
    "email":"chiara.cipria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285418362/c5c7eae91f51eb5f2da5b37ec11a1e79-1730301369"
  },
  {
    "email":"marinella.ingletti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285352826/364f43cc7ff77ff00d5e8a5a1f6da653-1730301369"
  },
  {
    "email":"marialuisa.lopane@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285287290/91b58ae6a83115fc6874a3f38916ebe6-1730301369"
  },
  {
    "email":"emanuelalombardi1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285451130/65a8bcf7c182aa5f99d5b6e52216af4a-1730301369"
  },
  {
    "email":"luisaboatto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285483898/4098a56e876aae2a4f5c9acc12b06dda-1730301369"
  },
  {
    "email":"c.liumbruno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285582202/ced2850332e737865da4c94cf9541696-1730301369"
  },
  {
    "email":"pazzaglia.marcelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285549434/27af3ecf0bf6a661eef318a97a202add-1730301369"
  },
  {
    "email":"stefania.truciolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285516666/70e217dd1c0215993caa58afc210d02b-1730301370"
  },
  {
    "email":"filomenamonaco21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723285680506/0dd6f783debc58b0513e423a57d9921e-1730301370"
  },
  {
    "email":"robyvaletti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285746042/28e33743918f9b96721b7f9d3f0004b5-1730301370"
  },
  {
    "email":"alberto@vailati.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723285713274/b6787e3d70533790ebbe8b94f87e837e-1730301370"
  },
  {
    "email":"vero.santini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285778810/669b383a349d3cc41dcc3379602373a0-1730301370"
  },
  {
    "email":"giorgia.cip@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285811578/db038302d284bb2799f0d6b237813658-1730301370"
  },
  {
    "email":"rosalba.adornetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285909882/962788e233614d94b5b6d382b46e1112-1730301370"
  },
  {
    "email":"sabrinariva@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285975418/1317e1d835698beb0c783d3aac31cdf8-1730301370"
  },
  {
    "email":"fabiola.rachele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723285942650/07cabda3ed96989d83cd661dd2d9bcdf-1730301370"
  },
  {
    "email":"pvnanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286008186/145d890a8fc95fb1dbb610c5fe395076-1730301370"
  },
  {
    "email":"ppaola7@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286040954/0b83e549251282c5048a79177254a211-1730301370"
  },
  {
    "email":"marozzigiuliana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286073722/713180850c449c51821bc2dd2b163824-1730301371"
  },
  {
    "email":"modulo1974@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286172026/7b62c25ecdddf30de7fec49b7bd63bfa-1730301371"
  },
  {
    "email":"manieri.michele@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286204794/8c23103ec87f1f594ec78a39c0acf92c-1730301371"
  },
  {
    "email":"s_mazzotta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286237562/20fb5c53c4515cb487025fe8ab6568b2-1730301371"
  },
  {
    "email":"bresciadue@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286106490/70854b256eb8932a675e7235db764d76-1730301371"
  },
  {
    "email":"alisanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286303098/d86a6cf0958b36e77da6a81954110902-1730301371"
  },
  {
    "email":"ilaxy@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286270330/5fea1b3ef751a7a13e9cc9d379d97554-1730301371"
  },
  {
    "email":"davide.mesca@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286335866/3cfeed3655e494ef52912f787ff46403-1730301371"
  },
  {
    "email":"mircosoffiatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286368634/78b960d6fab8ae99fdf47065d315eb1c-1730301371"
  },
  {
    "email":"ascanian@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286434170/35b57f8b3b01e45307dfe6ae2fcf1d58-1730301371"
  },
  {
    "email":"ghezza.michele@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286401402/6faf20e829fc9b9ccd05130506e25fe8-1730301372"
  },
  {
    "email":"magda.maria.d@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286565242/f30a60fc7819eadd73efb16d66912166-1730301373"
  },
  {
    "email":"rossellabrancolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286499706/f6fa4707078bf5d9350454dc6e4b096c-1730301373"
  },
  {
    "email":"patriziadalbis@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286466938/b9403ff7d040d46ce872a5cb850f2c9a-1730301373"
  },
  {
    "email":"sebastianabonfiglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286532474/bbea6d4b560de7f78e113fd4f95e9fcc-1730301374"
  },
  {
    "email":"noalmara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286598010/b245b143b670aa6f81ff740bbecfe2d5-1730301374"
  },
  {
    "email":"pamelik82@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286794618/8c5cd45332628891b5facafd0e480bc0-1730301374"
  },
  {
    "email":"barbara.favaro@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286663546/d2bc5e257059db2d714c78f51a42d396-1730301374"
  },
  {
    "email":"moirafarronato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286827386/11b73cfd214e1f1816c94c7a25f471e2-1730301374"
  },
  {
    "email":"ax8062@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286630778/f00688042fd7ffe550c0d21e38e66a14-1730301374"
  },
  {
    "email":"michaelabaur@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286892922/4905010c54f70fea81bb1bd0276fb7b8-1730301374"
  },
  {
    "email":"ileniarossetti@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286925690/2a610ba6c0141b6788bb39a1a4dbc6c1-1730301374"
  },
  {
    "email":"elisa.zoina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723286958458/1c4ea73e2a8c80a5deae6cf5e7b98a6e-1730301374"
  },
  {
    "email":"silviafacchettimail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286860154/3ea5fd992946f8cf279f408092f2e350-1730301374"
  },
  {
    "email":"silmabof@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723286991226/9a2b8367f31fcf8b9430316c94aee861-1730301374"
  },
  {
    "email":"gabriellamannella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287056762/f5ac5c36543e226c0735a52a7587041b-1730301375"
  },
  {
    "email":"cadenottivalentina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287122298/b57744fde8af303b8e6d7dc544bca4bf-1730301375"
  },
  {
    "email":"ale.grazioli0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287155066/15e6196ff76d900ce2f4235b85dc21ec-1730301375"
  },
  {
    "email":"kati.salvetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287187834/c68893c0eaae81fbc57df17b9a33a2e0-1730301375"
  },
  {
    "email":"silvia.tibaldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287286138/65887580d7a4925365b47c7a958e5084-1730301375"
  },
  {
    "email":"immapirozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287220602/2b1481ab031191b1a71af801ad237473-1730301375"
  },
  {
    "email":"basileluisella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287351674/6a6396e7e169c4fd1fd11796b406509b-1730301375"
  },
  {
    "email":"sophiebgy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287384442/1b2071df3da80c517e39c1462b89eb10-1730301375"
  },
  {
    "email":"ballivalentina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287417210/12edb3232ab7b07cf152e3c1947c8bbe-1730301375"
  },
  {
    "email":"pavier71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287515514/6c49b188b1755985d9c15f309a9f3d03-1730301375"
  },
  {
    "email":"cristina.rovis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287548282/d011ebd9bd35bb656e4d7e062c97969c-1730301376"
  },
  {
    "email":"eleonorsacco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287318906/a4e8de4c4cc0cf46d1498251b7e2cdb1-1730301376"
  },
  {
    "email":"sabrinac.siciliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287581050/071de1709b12ddc83dee3d9217ba0fd4-1730301376"
  },
  {
    "email":"elisaspin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287613818/fd95342524904c4a4defd42d0064562c-1730301376"
  },
  {
    "email":"francesco.nadia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287679354/7cc53e24ff18355e3f5d913d00b023f5-1730301376"
  },
  {
    "email":"lety@marcdegrazia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287712122/5005c7fdb9b64f3cc2d7cb888cecc343-1730301376"
  },
  {
    "email":"alicerottoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287744890/03c4f60f5d21f99cffd112ffef25cc39-1730301376"
  },
  {
    "email":"carenaemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287810426/7ded4d304bea98800df731c425587c7e-1730301376"
  },
  {
    "email":"nadia.ambrosini1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287646586/dba9f3b61dd0021ccef288fb0e6884be-1730301376"
  },
  {
    "email":"sarasibilio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287875962/740ae109ce046c3ffda1dba2935bf8ba-1730301377"
  },
  {
    "email":"erikathebest72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723287843194/111f86b0f8719699f66f2cf475f58827-1730301377"
  },
  {
    "email":"donatellaferlenghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723287974266/6982e1c75c6efe9d183ac0c80b234dd5-1730301377"
  },
  {
    "email":"esalpetre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288039802/22e4ba599b7bc726aa4455f6178d52b4-1730301377"
  },
  {
    "email":"lucia@artusogroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288072570/cc6e83d03c79946a80f820b7f34d06b9-1730301377"
  },
  {
    "email":"romina.pavinlegno@gmsil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288138106/b4a34dd0850ca0e973363c18f626f9fb-1730301377"
  },
  {
    "email":"valeriapaganini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288203642/08badb4b8cb3bb67af37e96fb7905715-1730301377"
  },
  {
    "email":"rosizop@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288170874/9fe08d7833d51e8b383cc13d51d9126a-1730301377"
  },
  {
    "email":"lauramaggi.fi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288236410/87d35e458134cf6e814d49c4dcb2cc5e-1730301377"
  },
  {
    "email":"ombryt71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288105338/7a3ef61d661a24f6b95e62edb63cee83-1730301377"
  },
  {
    "email":"megalchic@megalchic.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288269178/5d11fdd8873accbc3754033152aac17c-1730301377"
  },
  {
    "email":"eli.snow@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288334714/9c5e2998c22e991f6d4bfe915812a61f-1730301378"
  },
  {
    "email":"mauriziorizzello75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288367482/c09b58af22c7993c8259bc0024e58914-1730301378"
  },
  {
    "email":"luciaviero.tv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288433018/fb4dfd36df60248fc8eae59dad5a1726-1730301378"
  },
  {
    "email":"laurab10@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288400250/a907d5fd3c1ef8366824a8319da67a65-1730301378"
  },
  {
    "email":"flavia.grassidonio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288301946/00111347923b414542363c775e2bba95-1730301378"
  },
  {
    "email":"l.cucci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288596858/36ddb1511238648475c7829f4687cda2-1730301378"
  },
  {
    "email":"coccacristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288695162/89aa09d72642127da46ac8c072cd2968-1730301378"
  },
  {
    "email":"elenamasier68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288465786/3f20a35bcf392d1f1cb90717944e159e-1730301378"
  },
  {
    "email":"elisabetta.pogliani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288727930/fbf158c8edea2eb91183ac361296c739-1730301378"
  },
  {
    "email":"verenapippi@gmx.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723288826234/9bcaffe206792239bd646690bfa13e23-1730301378"
  },
  {
    "email":"emiliacordi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288793466/867c218863fec6db91b18d829516e1b6-1730301378"
  },
  {
    "email":"anna_colaccino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723288859002/58a2753fb3171bb61c87a138da38f0be-1730301378"
  },
  {
    "email":"sisanisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288891770/8b015e3c1df1f473f571f12e3425e3a8-1730301379"
  },
  {
    "email":"cristina.lombardi117@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288924538/35efbe078df00b271d13300f841f0774-1730301379"
  },
  {
    "email":"enricaguarena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288957306/9e2177f41272d25d0ff1fe15df321a94-1730301379"
  },
  {
    "email":"elisa.felici79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723288990074/5d7b29cc53c773e9b7c2bb67838238c8-1730301379"
  },
  {
    "email":"rcaravaggi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289055610/3d76e7cef6adaddebf576e40e0a047f6-1730301379"
  },
  {
    "email":"maryfru@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289121146/134e8c0cbe42a05840547d6c11caf5e1-1730301379"
  },
  {
    "email":"barbarachiodoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289088378/f8784724882c1efcbcee948b6864cd38-1730301379"
  },
  {
    "email":"francybonetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289219450/90723d13b5678cfe395f362222237150-1730301379"
  },
  {
    "email":"anto74f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289252218/a46505ce7eabad9fcf59e447f6be1e84-1730301379"
  },
  {
    "email":"enribittolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289284986/4b79f344ab0d10644a6e9b492763c7ce-1730301379"
  },
  {
    "email":"laubono@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289317754/6572fab3099ab49f46f4bf8c21fe930a-1730301380"
  },
  {
    "email":"valegem@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289153914/c455b6b9d72155d4be0166c0d8b4d3dd-1730301380"
  },
  {
    "email":"sabrina.gioli72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289383290/0f4619a093f0f7ebcd26a88f93956ecb-1730301380"
  },
  {
    "email":"marianna.calabrese1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289350522/fdee3f5bf3d3bdd8da54d2db3abd5579-1730301380"
  },
  {
    "email":"nwatkins.robino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289416058/51d3edcadd9576e3c6c70d9e33c91c6b-1730301380"
  },
  {
    "email":"pacefrattale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289448826/366600a6323fa2906ee2524ac8983267-1730301380"
  },
  {
    "email":"maccioniarreda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289514362/b3948a7bc40af488b56fc5879ebb666b-1730301380"
  },
  {
    "email":"simone.nannicini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289547130/d86886afd47941bc2f01a551be198022-1730301380"
  },
  {
    "email":"io.tomasin@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289481594/f7243a15b8080155ad0c7d6c44299108-1730301380"
  },
  {
    "email":"cristi.bellotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289678202/6a3c480f14124c50239de990fcf43741-1730301381"
  },
  {
    "email":"carlafelice.83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289579898/830374a5a116258238cb95dfa5601f74-1730301381"
  },
  {
    "email":"cecchinato.f@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289612666/f87bce925e5b4cb477facc82baa60f1f-1730301381"
  },
  {
    "email":"chiariprima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289645434/522f7110ee0c7ba51020629703f8b578-1730301381"
  },
  {
    "email":"valentina_martino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289743738/0c68820950524bd96e427e0784f50350-1730301381"
  },
  {
    "email":"chiaracippitelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289710970/43e0a7c9d6cad2b81171c431424709cd-1730301381"
  },
  {
    "email":"ale.ve78@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289776506/51a2a1665939ef83afff7598a9a0d9c2-1730301381"
  },
  {
    "email":"laura.pigotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289809274/3dff7067427f42d069b329551407bc00-1730301381"
  },
  {
    "email":"romineis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289842042/fbf7231f2945af5e8dcd4661cba5536b-1730301381"
  },
  {
    "email":"rcesiano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289874810/7793b7d04234b14c0d1a553316381f18-1730301381"
  },
  {
    "email":"marih2o@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723289907578/b6b26ba10f4e4d7ee313a59db428647d-1730301381"
  },
  {
    "email":"ros.gem@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289940346/eb2d9a5c03e465a2f04ad372f0e9f7c5-1730301381"
  },
  {
    "email":"mcolleo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290038650/e8cfda8221c37fd1474431e0bef81259-1730301382"
  },
  {
    "email":"giada.ameli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290005882/f1de8ca5076385e75c354aa08766a6a6-1730301382"
  },
  {
    "email":"manuela.gomez@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723289973114/dafd153f180c0479e4d4a1f951f22f9f-1730301382"
  },
  {
    "email":"serenafighera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290169722/414db991231ef1b584d92b2b0226b329-1730301382"
  },
  {
    "email":"ilaria.serra72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290104186/e39940283fa2ac1e5e40fb71e9adda66-1730301382"
  },
  {
    "email":"chiriaccristina@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290202490/22ba404395ef62974fdc63d19cb6d07f-1730301382"
  },
  {
    "email":"lilly.paglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290071418/04273150385c04134d50218f653158d3-1730301382"
  },
  {
    "email":"annalisa.scaringi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290235258/8fbe9538e1f042fcdf9802a2eb7520b1-1730301382"
  },
  {
    "email":"elenatre80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290300794/310fff49b0ab0cf5184fee4add02172f-1730301382"
  },
  {
    "email":"barbara.spada@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290366330/0b65f52ac1b2199a0e74641b7220eb0f-1730301382"
  },
  {
    "email":"pamifi06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290268026/0af99501e9a6a2dd0ba7df293cdfbb40-1730301382"
  },
  {
    "email":"anna@gambatocaffe.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290431866/e83cf048138491c057318e30e45790b0-1730301382"
  },
  {
    "email":"coolocean83@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290464634/625345032377ebe2b91dce241e81dc4c-1730301383"
  },
  {
    "email":"miriampizzuti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290530170/a9650fdfd89e119ffeba93b628b8d5b9-1730301383"
  },
  {
    "email":"gabbianost@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290562938/77f0f9b764ce8adbcfb0bf9a1bf6a89b-1730301383"
  },
  {
    "email":"rossella.collavizza1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290595706/f3362749bb79578e8ef8ec8e47fe7ef3-1730301383"
  },
  {
    "email":"peppunzolo7@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290628474/42ce371abdc4f99ff14ae403321c3fd8-1730301383"
  },
  {
    "email":"mafanchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290694010/f5d329914360ee2677b6269b7aeb3284-1730301383"
  },
  {
    "email":"daniela.pizzuti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290857850/bb9fcdf38da9b1a3b36645b3803e9027-1730301383"
  },
  {
    "email":"giuliabalducci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290890618/1f2f619e8ad7ad7127199ca3c2371fdd-1730301383"
  },
  {
    "email":"paolafantato64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290923386/1922fbf553d64e86eca845927eb067d4-1730301383"
  },
  {
    "email":"alessiapanfilo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723290956154/29b288990fa832b01f2f0619a038a622-1730301383"
  },
  {
    "email":"chiara.marazzina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291054458/f7d98a42f1bab00452b62cb2070058fd-1730301384"
  },
  {
    "email":"amministrazione@g70.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291087226/18b649caa07427890e460003711dbce7-1730301384"
  },
  {
    "email":"mariannaromano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291021690/9478bde999c536bf4a0d92e179a45f83-1730301384"
  },
  {
    "email":"ginetta106@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291152762/96551635ba28316446c62b3c6961525c-1730301384"
  },
  {
    "email":"ellen.meneguzzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723290825082/aa157b364b34c708e4e7dc74958243c4-1730301384"
  },
  {
    "email":"blagomarsini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291119994/821671d788dd4a479ea58a82f4c376a2-1730301384"
  },
  {
    "email":"ra.viola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291185530/2b2b4dd28b2b0317baf0bd2a9b6559f9-1730301384"
  },
  {
    "email":"staff@fustelmeccanica.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291283834/0a1f0aad5f5f17dc329281217942741c-1730301386"
  },
  {
    "email":"roccofabiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291349370/8ceee80a249e6bd6f01a36331a197dac-1730301386"
  },
  {
    "email":"serrymendy@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291251066/51a14b50d7f999a84874a7b70480ae29-1730301386"
  },
  {
    "email":"tmqmil@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291414906/6d60327321b081d4ab1a19dfaec785cf-1730301386"
  },
  {
    "email":"danielam00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291382138/71f166c3e07bc39fc0bf4ed32b5ec9d1-1730301387"
  },
  {
    "email":"sara.linfatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291447674/5da422e43141ae9b6e85b1738f3b897c-1730301387"
  },
  {
    "email":"daniel2211@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291218298/32f7e0c4f675e4b885ca694e1c9c5a8b-1730301387"
  },
  {
    "email":"santuccimax@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291480442/65d1729dd78c85be7f5eb75e46386382-1730301387"
  },
  {
    "email":"mari_cent@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291545978/1a8e86edd967c34f23e5a4717cf73e1f-1730301387"
  },
  {
    "email":"susanna.tancini@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291513210/2c371332874013796a683d5b2f842ec6-1730301387"
  },
  {
    "email":"martinigh@cloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291611514/c824afd933848602a038c649ec99595c-1730301387"
  },
  {
    "email":"ale.biondi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291644282/238872f061d0083fc58a92f0c64a63ab-1730301387"
  },
  {
    "email":"maria82.ciliberti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291578746/0f27e08f43edec4fbba05d02556df402-1730301387"
  },
  {
    "email":"debby75.ds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291677050/c1f70be34cd9be4d1535c78e92ae66df-1730301387"
  },
  {
    "email":"blentz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291709818/a3910608d54279be9aedb5d833e2eca9-1730301387"
  },
  {
    "email":"1975bar@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291742586/c6cd9698ce0b23fb07e346cf2f9b4c5c-1730301387"
  },
  {
    "email":"chiara.santamariamaurizio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291775354/d3affc660550963035992f3643335439-1730301387"
  },
  {
    "email":"catiap1306@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291808122/0225a16e7127916a7c512455658f4439-1730301388"
  },
  {
    "email":"enrico.carmenini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723291840890/f586044716fd23eafa93f054673a203f-1730301388"
  },
  {
    "email":"barbaradelia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291873658/bce60657c2aa3954dc2abb25a0619239-1730301388"
  },
  {
    "email":"andrea.alfano1@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723291939194/757c896e373c030a54c1dabd4c151c23-1730301388"
  },
  {
    "email":"patriciarod2011@yahoo.com.br",
    "url di attivazione":"https://verdissima.it/account/activate/22723292004730/176bc1f2ff8a5091c5ede97f6359c746-1730301388"
  },
  {
    "email":"sedola.mkt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292037498/98b564b0b22ce1d7506127acfb574f77-1730301388"
  },
  {
    "email":"butigiulia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292070266/c43f4ef09c878e1665316b4745cedca4-1730301388"
  },
  {
    "email":"antolini.lucia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292103034/87f6b33e127fd23258d7380fe609534e-1730301388"
  },
  {
    "email":"larabrusutti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292201338/95944f14979014db18992d2e11b4e58e-1730301388"
  },
  {
    "email":"fgheza88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292299642/0097a271b3f33f9a309479bbe345164d-1730301388"
  },
  {
    "email":"goldenga@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292168570/b47aba8887a5102f54afc8dfbe82a966-1730301388"
  },
  {
    "email":"robertabetti.rb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292397946/e39b6b0b9b6ffb1fbfb49534d2a7a69f-1730301389"
  },
  {
    "email":"silvia.remondini@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292266874/d9e343c6e7c4061d44b1601f847c5234-1730301389"
  },
  {
    "email":"claudia.giovagnoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292365178/01dfacfd2cb79c051890e4c5070bd737-1730301389"
  },
  {
    "email":"marty74.lamberti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292463482/9be75572e7e3e79bf7d99b85d193cb9c-1730301389"
  },
  {
    "email":"patrizia.antonio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292430714/44904cb46e0d83bb36c61ac4f066c012-1730301389"
  },
  {
    "email":"annaluongo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292529018/ba32d253336b4b5cc1142eca524a116b-1730301389"
  },
  {
    "email":"sarina.gulla@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292496250/8375642f6452fae79c53db32b7b0efff-1730301389"
  },
  {
    "email":"cristina@prosider.ra.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292692858/94be03e67d09e484436c19b57539979d-1730301389"
  },
  {
    "email":"fpancot@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292725626/ea3bf6214566eb74d46e879959ce2181-1730301389"
  },
  {
    "email":"pattycal@aliceposta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292660090/99501665f2542cb26a8f3ea56a908895-1730301389"
  },
  {
    "email":"sbettarini2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292594554/e81ef4264c8c2b82663363d74e5e11bb-1730301390"
  },
  {
    "email":"ferrua.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292758394/0c00f0477a5a8048a1e2a5a2ee7248cb-1730301390"
  },
  {
    "email":"alicemarc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292823930/cefbf1563c1a8882a04d5f5cb977b8f4-1730301390"
  },
  {
    "email":"vivianj@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292889466/8bba129c90801a87b2f1f75e006a4414-1730301390"
  },
  {
    "email":"enricalipari@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723292791162/5b4db12d345cf9605fdc521d419ac511-1730301390"
  },
  {
    "email":"nzoli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292922234/730db66c9b368a12a507aec69d633111-1730301390"
  },
  {
    "email":"mastrolonardo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292987770/fa63d73fdf0fe34437cf39fc6eaa4fe1-1730301390"
  },
  {
    "email":"anita.pizzaballa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293086074/769e98a6c8b7ab299a51963d2ede860f-1730301390"
  },
  {
    "email":"sirfinpa.bardelle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723292856698/40941f6b04a7e32c4323c28921af2da2-1730301390"
  },
  {
    "email":"gbouzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293053306/a0470c1cd4a2f1853ccc5e92817f997b-1730301390"
  },
  {
    "email":"marzia.gregoris@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293282682/485192f6a7b44f2348e833b773986efd-1730301391"
  },
  {
    "email":"antoniettagrimaldi66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293315450/c2ebd0da5d5945192a239b1ecce7be72-1730301391"
  },
  {
    "email":"oriana.tubia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293348218/3c016c5a107d350ca0e1adfad988784e-1730301391"
  },
  {
    "email":"nunziacaporale24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293118842/a3fcefbfa4e49da2d9d818d94c8a8549-1730301391"
  },
  {
    "email":"paola1967paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293151610/7e6080b72d37f8858ba630d7aca60875-1730301391"
  },
  {
    "email":"centroverdegarden@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293413754/9bf83e2f49196ce522046f59870666f9-1730301391"
  },
  {
    "email":"smartas84@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293446522/65a37d1aeec546888d57ab18b960c4f3-1730301391"
  },
  {
    "email":"scipionisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293512058/dcc4015cc22974e5d3d92cd27f5e9bf5-1730301391"
  },
  {
    "email":"ale.casarin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293479290/ea06034326521510ea8f228370892f2b-1730301392"
  },
  {
    "email":"rosmary77@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293643130/93773b742b9fb097ca9d834774a47b3f-1730301392"
  },
  {
    "email":"silviabonini.76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293544826/a1114b661b3b9a42bb2d1c2e64af447e-1730301392"
  },
  {
    "email":"ilaria_sartor@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293577594/2c822acaf87821021a8ef9978990099f-1730301392"
  },
  {
    "email":"va.cavalieri.08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293675898/9ed5fd437c4aec0e48d557912b10d65c-1730301392"
  },
  {
    "email":"m.carmen.villa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293708666/40bcd661151b31f667d7b5fc14a40606-1730301392"
  },
  {
    "email":"matoula.tal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293741434/ea9fa2b66675b6f6f8b4539e0b921561-1730301392"
  },
  {
    "email":"sabrinam74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293839738/116cbbabb2d13487b774e021deac9b47-1730301392"
  },
  {
    "email":"giulia.brunori89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723293905274/66405d7d799ebb235b50839b48e6ccee-1730301392"
  },
  {
    "email":"l.marinotto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293806970/eb3b0c447e20d54adbd16a19a63c0081-1730301392"
  },
  {
    "email":"mickysol@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293872506/78ac720c4135b6c547e21f26bd8eb4c4-1730301392"
  },
  {
    "email":"chanty94.msnit@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293938042/429d7592333e033077f8fffbef61fbe5-1730301392"
  },
  {
    "email":"silghiz81@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294003578/418d0ed914d372f282f82ddcf2747b36-1730301393"
  },
  {
    "email":"damfabio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294101882/cc33b68244958fa8eabdc1c987fabb40-1730301393"
  },
  {
    "email":"emy.manca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723293970810/19e7dad23fcee54a4a175d93ff7c4d01-1730301393"
  },
  {
    "email":"melamelina@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294069114/63b34165e22ce12debf0e04247f6eff3-1730301393"
  },
  {
    "email":"d.lavoro@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294134650/3a80021e1d108622a05e806a4ea6655b-1730301393"
  },
  {
    "email":"alesasa79@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294167418/e5e5cbd96027ddad7f0257441353c024-1730301393"
  },
  {
    "email":"mariellapcr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294200186/533b5f2b4cfad46f0bcb2931beee4ac9-1730301393"
  },
  {
    "email":"danielalepre55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294232954/12a2fe728903da03c5867ca760c75b11-1730301393"
  },
  {
    "email":"valeria.vallelonga@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294298490/022923bd63516cfb36613ebc106fdca7-1730301393"
  },
  {
    "email":"lauratrilly@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294364026/e67b6236ffe0d3bb921d5fa3ee854966-1730301393"
  },
  {
    "email":"simonetta.pieracci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294331258/ca82952a6e0d89c617e82df9048cadc1-1730301393"
  },
  {
    "email":"dani1996@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294396794/d534633b61795a7d7850b3e1668eb99a-1730301394"
  },
  {
    "email":"irene.gardini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294265722/fd7950af7518ea0567506b4f702bbfd6-1730301394"
  },
  {
    "email":"tricesimogondi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294462330/d7260d43661c11958ada24fa9fddbf70-1730301394"
  },
  {
    "email":"silgar78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294429562/aad39837e896f209d5919b247ac8752e-1730301394"
  },
  {
    "email":"eli_moni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294527866/40b124f6b6ecf2128678de8ce0f65ea6-1730301394"
  },
  {
    "email":"pinadigiuseppe@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294495098/a16b4d8ee1ff782826188525a5318c1c-1730301394"
  },
  {
    "email":"giuliaburali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294560634/f25320185c174f0cd7ae268daf0132c8-1730301394"
  },
  {
    "email":"fiorellalocatelli11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294626170/badc5a3af4d3c169769bdca6f8761204-1730301394"
  },
  {
    "email":"federica.ghidini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294757242/c616f43d7a61c7393eafa26ea23eaf40-1730301394"
  },
  {
    "email":"cristiana842009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723294724474/bd684a9326a87f759d67cd5163f60d6e-1730301394"
  },
  {
    "email":"barbarabonifazi7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294658938/1bb1341d692a19686da206023cf8182e-1730301395"
  },
  {
    "email":"ilaria.parolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294790010/f5510e8f266f9cda4d77eae53f010bb5-1730301395"
  },
  {
    "email":"newsilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294691706/0398d50d2053c18eef930acb172116d9-1730301395"
  },
  {
    "email":"vaniamitelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294822778/ec568943759df1df86cf33f2ff471b1f-1730301395"
  },
  {
    "email":"laura.dispe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294888314/0f6ddbec0690c9bb8c4764d869967f3e-1730301395"
  },
  {
    "email":"mariaelena.chinellato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294953850/957fa01b812daffa6bba273856cb52cf-1730301395"
  },
  {
    "email":"oliva.zugliani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294986618/b842c1e9839a418540fca2d3eda7c483-1730301395"
  },
  {
    "email":"sixin76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295052154/c2725fd4b1487cad5b7914b767eaa428-1730301395"
  },
  {
    "email":"margheritaballo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723294855546/e6e2d5069141d04cb278d8af55e13568-1730301395"
  },
  {
    "email":"gianni.687@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295215994/2623942c83c01c967f5a81617f39cefa-1730301396"
  },
  {
    "email":"marcylong74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295183226/e3dd2c02e03900575b344a019697c18b-1730301396"
  },
  {
    "email":"veronica.pecci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295117690/5891daffed906603f269069e37a0ac79-1730301396"
  },
  {
    "email":"minnye2@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295150458/00ccb83d85231c749d5cc5701fe771d9-1730301396"
  },
  {
    "email":"amtalarico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295248762/efd9f2756557cb286df4e619cfb75686-1730301396"
  },
  {
    "email":"ottaviana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295347066/b1aa7fc14898b928c07ecc3ef1607dac-1730301396"
  },
  {
    "email":"francescalamela@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295314298/45403bdb6df07bccbad87456dc9f81f0-1730301396"
  },
  {
    "email":"silviabonibaldoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295281530/faec4eec5eb39c9f9643846e90615589-1730301396"
  },
  {
    "email":"avv.panicucci@pontlex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295412602/885b7af903ad1b33362459e3ebec3026-1730301396"
  },
  {
    "email":"leti_1978@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295576442/97aa41324fa8b61d90aa0a9712cb1067-1730301396"
  },
  {
    "email":"lamaggiore72@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295543674/a2d9d148b97b478f62f4a196b8868fd5-1730301396"
  },
  {
    "email":"dianadiaconuro@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295510906/0c3f7afcd024786da4c8d76e09ac6151-1730301397"
  },
  {
    "email":"rosso.laura77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295445370/8f2b8b26d6d54f0cb56fc3ca5cda4a72-1730301397"
  },
  {
    "email":"alicesavini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295740282/0e1a87edf76929e8fdb13b44d681fa43-1730301397"
  },
  {
    "email":"pattysaba@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295773050/5f7c54efe954da0d57f6065192ecacb0-1730301397"
  },
  {
    "email":"ppernici67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295641978/55e105b14dfd2f2393e41da0f7969079-1730301397"
  },
  {
    "email":"giulialucherini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295609210/d763408c4a4ad1b4eb5ff61bca47a1c4-1730301397"
  },
  {
    "email":"giorgiamusto41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295936890/d0e657519003e753279de328d848f87c-1730301398"
  },
  {
    "email":"rriboni@amaga.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723295805818/2726c353532061779e855da57dc62f5e-1730301398"
  },
  {
    "email":"amber.dott@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295838586/cf6bea4905ddae07c780d8882bee93b3-1730301398"
  },
  {
    "email":"valeria.iovino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295871354/6189dcb54db18b1f37911bbda7cfd0aa-1730301398"
  },
  {
    "email":"paolagerali73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723295969658/64a195abbfc2d3d0bf82ef9c70086436-1730301398"
  },
  {
    "email":"pigi21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296002426/b5861595d1554470646cc6dc864907cc-1730301398"
  },
  {
    "email":"antdxt@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296035194/506a39970fbf05e9fe76cee130526b77-1730301398"
  },
  {
    "email":"roberta.dincecco4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296100730/55296231dd8aaf63213f86eeb0e9426b-1730301400"
  },
  {
    "email":"nadia.consolini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296166266/67e469481b8c6f5abb2675b34b6db5e4-1730301400"
  },
  {
    "email":"luciacalia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296199034/05cba44a0631fd095097b35a081ec6da-1730301400"
  },
  {
    "email":"cancypassy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296133498/11685bb558e7fa18db353851a368e19b-1730301400"
  },
  {
    "email":"barbara.archgentili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296297338/e8b50c57cfeb15c40fc8a6454f024d36-1730301400"
  },
  {
    "email":"francescamoscardini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296330106/421a9d19dcf4b8105597888d3f777e00-1730301400"
  },
  {
    "email":"mariknutsen@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296264570/7adac0384970537f513a4d47eedc5586-1730301401"
  },
  {
    "email":"squizzato.patrizia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296231802/23e25f9e8778c6f701447cc7871d1ae8-1730301401"
  },
  {
    "email":"alessandra.atzei@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296362874/2cb0f84ffb5c9ea9ece61095c6299f46-1730301401"
  },
  {
    "email":"erika1980@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296395642/d0f3f98f236b8c66c86f940391c4d43c-1730301401"
  },
  {
    "email":"jessica.morganti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296428410/8a5bf2bb1384399e239a26f277f5c1ec-1730301401"
  },
  {
    "email":"stefaniacattaneo@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296526714/f484ccd0cf99c47ed001a306c292f0c9-1730301401"
  },
  {
    "email":"miriam.bussolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296461178/964fe662a7f1c16e0c49880b6664491b-1730301401"
  },
  {
    "email":"annamoroni72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296559482/94b901ad98ddead8dd8e90002755a457-1730301401"
  },
  {
    "email":"raffaella.fedele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296690554/24e3aeb488aef6c7450fdc39630484f2-1730301401"
  },
  {
    "email":"cindavgemini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296657786/b85faa551185365c2b2c06b651094455-1730301401"
  },
  {
    "email":"piras.nna@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296625018/5771a5c3cefd440b9244c1228509a9e2-1730301401"
  },
  {
    "email":"marziapizzini70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296723322/0d17447c13ec0e053f5ea8b5017e3d8d-1730301401"
  },
  {
    "email":"farmacianci@farmacianci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296756090/a5986fc72d09857daafe2bbba87b32e6-1730301402"
  },
  {
    "email":"laportamichela29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296788858/b4d8e5aad3e9ab1e5891b6cc6da24fc9-1730301402"
  },
  {
    "email":"grillo275@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296821626/6c194ceb41fe786748323226cc0aae61-1730301402"
  },
  {
    "email":"barbara.bighorses@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296887162/cba918308454b9d8901919cd3b23c2fd-1730301402"
  },
  {
    "email":"giovanni_grande@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296952698/d9b65764d0bbd7711e8ba02ab898a877-1730301402"
  },
  {
    "email":"annamontanari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723296919930/b16d75071defcffe264f90b97dd56f66-1730301402"
  },
  {
    "email":"d_bencivenga@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723296985466/cfce1bb83a45b3910418e0e6a11ce19c-1730301402"
  },
  {
    "email":"elenabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297083770/8d57b13261e6c500e3a866b8151205a7-1730301402"
  },
  {
    "email":"p.valsecchi09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297149306/1faca152e62970dc8c5a30f98f10c8ee-1730301402"
  },
  {
    "email":"sommaclaudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297116538/363002836169024df973d547ebf7c250-1730301402"
  },
  {
    "email":"chimicalboy@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297214842/0f024afc1872acc70849715df0b7bf50-1730301402"
  },
  {
    "email":"chiarinapi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297280378/3da2bce0c372275d515a585ba026d085-1730301403"
  },
  {
    "email":"nappa.rossella60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297345914/4e298e0f9ec0c2d09da538a3f8a4a6f2-1730301403"
  },
  {
    "email":"cristina.bozzetto75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297444218/8ce521a4d5da4e4d8a325d838a7c177c-1730301403"
  },
  {
    "email":"robby.bruno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297313146/fc4ff57bef78f02eba8c1b21f5f9f289-1730301403"
  },
  {
    "email":"guerra@spaggiari.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723297509754/be8b0be4e173008905beed201e61cb5a-1730301403"
  },
  {
    "email":"ramymol@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297542522/aef192ec0e71d483a00127214f8f4acc-1730301403"
  },
  {
    "email":"anna.muffato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297640826/ba961f5114bbdd01a9a6ece993820e9e-1730301403"
  },
  {
    "email":"studiolegale.antonellaferri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297608058/f2f39e50f868571b45cc112d2f603769-1730301403"
  },
  {
    "email":"sanse1968@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297673594/8fedff24e352c7d3b0a778d7d200c1fb-1730301403"
  },
  {
    "email":"arianna.11@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297476986/ff6fc0be4ba796f43271f72d317e9226-1730301403"
  },
  {
    "email":"simo.forn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297771898/14dc1a228992c7f94b0141ffa1e705c8-1730301403"
  },
  {
    "email":"patrizia_pisano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297706362/de89375b8f0866843fa6c3f3ef50e0d0-1730301403"
  },
  {
    "email":"020prins@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297837434/6f026755b0f366346198ff17de440c0c-1730301404"
  },
  {
    "email":"molly118@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297870202/8cdea652850c46ab664344105b8393df-1730301404"
  },
  {
    "email":"domenica.stilo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297935738/0c01959543ad73ea3c3649dde71a6d5c-1730301404"
  },
  {
    "email":"s.cicolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723297804666/5c88c10e534d1878379ca7f14bda511c-1730301404"
  },
  {
    "email":"c.vecchi@gbvabo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297902970/252f91d9bbf5775e4b952c9cb87a5fb2-1730301404"
  },
  {
    "email":"pucci62paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723297968506/73264aea810d3ecca0947524f2532ac9-1730301404"
  },
  {
    "email":"mteresapuccio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298066810/7f5a9828f1ab14b471646f9e27ace504-1730301404"
  },
  {
    "email":"mariaelena.perla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298001274/4d4941a35a78560e1a7ef930328dd579-1730301404"
  },
  {
    "email":"angela.mesfarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298132346/25c7f5d408ea4a76059938bc2829ca45-1730301404"
  },
  {
    "email":"alessandrapancot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298099578/e0bc894a9b25e5415402add1baf68d2b-1730301404"
  },
  {
    "email":"cateronzola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298230650/3d26e326f3bc2a80a12312be0433c3e2-1730301405"
  },
  {
    "email":"paola.ravarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298263418/79e64e0fb11771784e0efd121d174839-1730301405"
  },
  {
    "email":"maddalena.vichi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298165114/83d78b9a9f70260c55a9d86174e3d62e-1730301405"
  },
  {
    "email":"silviomichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298328954/f38d3461107176f7eeb5c5ad6a87d1f6-1730301405"
  },
  {
    "email":"sarabaldi78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298296186/ba0620d670aa5ba96cd2ce2ffcc42021-1730301405"
  },
  {
    "email":"annamico73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298361722/8051b427e8d12cef0fa0faee7e4c989f-1730301405"
  },
  {
    "email":"vincemar78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298460026/01627c53198cb23eb78984d0f0a4204f-1730301405"
  },
  {
    "email":"valentina_abbiati@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298525562/3d59975e61a0129cbfea1ce0d903aea4-1730301405"
  },
  {
    "email":"paolazella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298394490/8071e416f6fed7f16c2070e0ddc49f8a-1730301405"
  },
  {
    "email":"gorla.alex@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298492794/90c3584a811856105b70fa2e9bcd37db-1730301405"
  },
  {
    "email":"roberta.raiti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298591098/be729e208d54ad55c99b56de4fc96cc7-1730301405"
  },
  {
    "email":"giperri1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298722170/3858e4562c0f85ac290922117806041f-1730301406"
  },
  {
    "email":"damoresa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298656634/5ff114740a1e7f9d952daad4c6c9818c-1730301406"
  },
  {
    "email":"lucapin71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298754938/93b9d956bf0824d98877026dfa857786-1730301406"
  },
  {
    "email":"marta_camilla@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298623866/a2170470cc029c8f6299170212ba2431-1730301406"
  },
  {
    "email":"melimarianna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298787706/673075940f9e336226c751b899e958e8-1730301406"
  },
  {
    "email":"mbonomi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298886010/0733fb80884d2f67f01dac5eb9abeb87-1730301406"
  },
  {
    "email":"vanessa.ghizzani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298951546/4c235a0613d1c17aa6b17ae7384c9c5d-1730301406"
  },
  {
    "email":"francescoscarpaci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723298984314/0de65f60d63b5cf5dac7e62ab3febd82-1730301406"
  },
  {
    "email":"miagiampa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723298918778/eeb7ceded6a946af967b5abf6b8c2362-1730301406"
  },
  {
    "email":"rasoangela74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299049850/bde832474498f7a303caad6a73795ff4-1730301406"
  },
  {
    "email":"kappaborg@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299082618/576b50e7f1259deda46a5f95b90420f1-1730301407"
  },
  {
    "email":"sabrina.invernizzi1997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299115386/c4719e50804f40feddf6f147fbea2cda-1730301407"
  },
  {
    "email":"alejonathan27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299180922/941acefd114bcd564120504edde26235-1730301407"
  },
  {
    "email":"palladino-dany@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299017082/dff81c445bf07877bf3a980facffdefb-1730301407"
  },
  {
    "email":"roberta.pezzini67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299213690/842ae52956571bc50b0ec6de28035f51-1730301407"
  },
  {
    "email":"francescadipasquale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299148154/ca0ff43299dff3e5d2ecdb71c6233a20-1730301407"
  },
  {
    "email":"roselyn.marangon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299246458/37d2c5bbf9d918682f87dcd1ad5c55d9-1730301407"
  },
  {
    "email":"nimarches@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299311994/b8b32ff04d2f89dd61d67084f3c19dfb-1730301407"
  },
  {
    "email":"alicepaffarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299377530/54b448650c8ccc5b8ad145f7ed1a7a7e-1730301408"
  },
  {
    "email":"valentinalutri@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299475834/93df92833282c929eddf7a91fd976067-1730301408"
  },
  {
    "email":"gamvin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299574138/f6dc8fb8e1b62d0ea46d1bfc12919177-1730301408"
  },
  {
    "email":"alessiacrispo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299606906/28e064ba2746ffab734ec229ccc794b5-1730301408"
  },
  {
    "email":"elena.bracchitta@grupporeda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299508602/bd537107b3cd16adccbfdbb93cbbb555-1730301408"
  },
  {
    "email":"girasolelba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299344762/6515ec0e254dbe7605bfedba0838444c-1730301408"
  },
  {
    "email":"nf36@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299705210/c9c62816d5744288ec67c3842a28b0e8-1730301408"
  },
  {
    "email":"mahureva72@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299639674/a86faf5ee1041edba4311ea0efe61cdb-1730301408"
  },
  {
    "email":"venturi.marinella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299672442/dac15d8bbbdb73ade7f9f3c0f5436d99-1730301408"
  },
  {
    "email":"cinzia.rorato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299737978/bc1c89bdeda789deb3a43eec505aa2e1-1730301408"
  },
  {
    "email":"rosbruni1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299803514/8964152e4236d01408e186fd231de020-1730301408"
  },
  {
    "email":"leameoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299836282/82e0fcc0dad6810b26e32f819ba4e618-1730301409"
  },
  {
    "email":"federica.ferrando@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299869050/dab1f126de4695b4b098f69cabfdb081-1730301409"
  },
  {
    "email":"dany.daia74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723299901818/418cb9442822d845dc3c4ac0ac1cf8da-1730301409"
  },
  {
    "email":"ritagjini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299934586/a01ea5c4c8f16c215aa2c8c3b70c8210-1730301409"
  },
  {
    "email":"elenacogo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299770746/de73daca94bc59a4f245e42ec2c96c52-1730301409"
  },
  {
    "email":"stefania-niero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723299967354/0db7ff289cacc4d9297079073739548c-1730301409"
  },
  {
    "email":"giumenegatti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300032890/2964a2da95a155d3eea931de3209d3d7-1730301409"
  },
  {
    "email":"isa13779@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300065658/d832dbd7384bafb2a716aebb2b0dcaad-1730301409"
  },
  {
    "email":"cami_zampieri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300000122/8a30fa8dd282468a52fd3c0e277bb2e6-1730301409"
  },
  {
    "email":"omar.coccoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300098426/ac5bef3b12b8bb29a4196ea4a0b6034f-1730301409"
  },
  {
    "email":"anna.cogno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300229498/d6bbc2cb0b14825cd482539d2a35347a-1730301409"
  },
  {
    "email":"helgabartolotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300131194/047a07de15ad3d4d228582d865edf375-1730301409"
  },
  {
    "email":"barbara.corna71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300262266/a78c20ba0f20a600430186dc467d30f3-1730301409"
  },
  {
    "email":"sdelzotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300295034/62c22846a5f92395a15b29c30934705f-1730301410"
  },
  {
    "email":"milemarianimb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300327802/de5e58b1cacb7951a80347a0aa73f68b-1730301410"
  },
  {
    "email":"marta.storti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300426106/da67afddea24653f600fd9fbb0187832-1730301410"
  },
  {
    "email":"info@fergal.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300360570/eb8cd9d3c94538fc12bbd04856715832-1730301410"
  },
  {
    "email":"mariu.fusco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300458874/435e2564977a01e7283958a30ff7d1a6-1730301410"
  },
  {
    "email":"simona125@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300622714/3356a7ba33f9d506031166a7672b403a-1730301410"
  },
  {
    "email":"francesca.desantis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300655482/29818c3a1c7fb3c9fb49881617f9db91-1730301410"
  },
  {
    "email":"mariangela.sandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300393338/ad9cc05772253c2182d4e3781c91510c-1730301410"
  },
  {
    "email":"sophias@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300721018/fde1a1da0f577194292d5c53c5cdf914-1730301410"
  },
  {
    "email":"francesca.cali88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300753786/0f7063581a1024023448eb6b4187f985-1730301410"
  },
  {
    "email":"sorolaura14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300786554/e0bc7318673e3264c7a3ff291fc796c7-1730301410"
  },
  {
    "email":"paolafly@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300852090/e73fdb85aacb4fc648dd9fd7a1af5adf-1730301411"
  },
  {
    "email":"loretta.pratesi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300917626/c5e421cd347f9e4cf56366539d64946e-1730301411"
  },
  {
    "email":"steff.cicco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301114234/28d9b3359fc01051dc24e179351713dd-1730301412"
  },
  {
    "email":"federikatraetta93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723300950394/3a89e97452013fd19c49f62b62f3731b-1730301412"
  },
  {
    "email":"pina79@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301015930/2088ca41af580c126b072600a08716c5-1730301412"
  },
  {
    "email":"pescemaori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723300983162/bd2213a462679bb3b0bcb7f9f10c7b3f-1730301412"
  },
  {
    "email":"concetta.rizzo2014@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301179770/4ea6eb2db83f0e05187c4bb04702fafe-1730301413"
  },
  {
    "email":"martalich@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301212538/28a173aa9ad1f91200c628447f8607f9-1730301413"
  },
  {
    "email":"agar87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301245306/eb4b0024e2c1bac25de054c2164c08f8-1730301413"
  },
  {
    "email":"monia.manni@unicredit.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723301147002/62ac9230b8ddfcf2714ef984bfd61061-1730301413"
  },
  {
    "email":"giovi.calandrini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301310842/e8199aaa7a4ad763a37304ce1b98d418-1730301413"
  },
  {
    "email":"cossurita64@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301343610/3786cca59bbd8af6c88a689dd00da24a-1730301413"
  },
  {
    "email":"danielapujia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301376378/d93406c3009af9c39d22911cd1ccc389-1730301413"
  },
  {
    "email":"mritamiceli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301409146/c47e0df1d5b56c3307df3a18d52447a1-1730301413"
  },
  {
    "email":"dofrapa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301278074/3174b1cd3f046956fb537d03ef9c3386-1730301413"
  },
  {
    "email":"spinomicio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301441914/6ff6aad194d22e154a590951832f0a79-1730301413"
  },
  {
    "email":"tittigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301474682/d17b4050ebe3f647764df90b79de7183-1730301413"
  },
  {
    "email":"martina.assirelli.1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301572986/258cf813852b799fd5bbaf632a286593-1730301413"
  },
  {
    "email":"vittoriafronteddu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301540218/4dd1cc70d07aad002ae5eee19d380786-1730301413"
  },
  {
    "email":"luisella.dinatale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301605754/0ff6a0957f5dca1958dda6f219d23bb9-1730301414"
  },
  {
    "email":"barcoa@bpn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301704058/ce425bcb20c84fc5a43e615292b6f5e5-1730301414"
  },
  {
    "email":"aglehit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301638522/81ca00c785abd05aa3243a6d309e8973-1730301414"
  },
  {
    "email":"stella.rossella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301736826/25d927364574e3ac77fd362739803bfd-1730301414"
  },
  {
    "email":"cormorud63@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723301769594/aceffaa93192c83140a73b41b9c32b6e-1730301414"
  },
  {
    "email":"falleamargherita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301802362/c135d650215c63f1afaa5244b2f5f6c2-1730301414"
  },
  {
    "email":"paola.route64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301671290/4de2700c9feeb9589354213a3c206941-1730301414"
  },
  {
    "email":"m.calabretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301835130/f964ecf19b60c0b09d622712871f9b02-1730301414"
  },
  {
    "email":"francescomarconi17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301900666/e60760fa81c11a123dc0c92a06aebcc6-1730301414"
  },
  {
    "email":"goldiesugar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301867898/64854db59786c93bc8c11ec4e99bb718-1730301415"
  },
  {
    "email":"luciagioiosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301933434/f1ab817c45831767e2955df5195f23ca-1730301415"
  },
  {
    "email":"dany.dagostino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301998970/5ae3946b51cc19d9dab8fcfe3e6015be-1730301415"
  },
  {
    "email":"maura.traverso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723301966202/7255ca9ae92d51143a7ad99897a1e61f-1730301415"
  },
  {
    "email":"anna.carbonaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302031738/ce3c0f829babed1cd9cde6e55fad21f4-1730301415"
  },
  {
    "email":"r.sgrambiglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302130042/25e49b0144884d25253300680c4ab745-1730301415"
  },
  {
    "email":"susanna.panzavolta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302162810/861926f9b30dc9f46093159dcfaa44d4-1730301415"
  },
  {
    "email":"tizianapetrelli2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302097274/aa1c9506df551ac3a80937880c5db114-1730301415"
  },
  {
    "email":"liberaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302228346/bb957dcc1bfff22320918a7d4fab4121-1730301415"
  },
  {
    "email":"giorgia.cristofori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302293882/49a46c60fa83d6effaf19567d4698e45-1730301416"
  },
  {
    "email":"mariaveronica@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302359418/870f84563d766ff324e2271e30414c7e-1730301416"
  },
  {
    "email":"fabiana.tau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302064506/00bf1b8ab5c06bc2a39c31bcc83a3ddd-1730301416"
  },
  {
    "email":"sabribardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302261114/df2b2ed0f37188d938e514e9eb0017f9-1730301416"
  },
  {
    "email":"silviaborla.lapo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302392186/e32aafc05bff3dcd934be9007f9b3d98-1730301416"
  },
  {
    "email":"angelamiedico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302424954/0f650a4bc7740f9e05b517abc0a4c993-1730301416"
  },
  {
    "email":"sofy_1989@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302490490/3b4f07dfa315b298107b8010cca87635-1730301416"
  },
  {
    "email":"chiara.caputo124@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302621562/abfd68e65ee1f6691418f3016e02188a-1730301416"
  },
  {
    "email":"egerta.sota@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302588794/1fdb1acad7b7c8aef5b25588d3de83ac-1730301416"
  },
  {
    "email":"serenatanghetti73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302687098/d08696c88a34fbbc45c7f15193e18029-1730301417"
  },
  {
    "email":"gianmel.mg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302654330/267998b006df359f6945e4c96c1d16cd-1730301417"
  },
  {
    "email":"paolascandellari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302719866/9013c34d617af965fe3dde61a4a4e37a-1730301417"
  },
  {
    "email":"81smorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302556026/402422282af17b46b4f27d7135f16e09-1730301417"
  },
  {
    "email":"rossanoroncucci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302752634/cafab8eb60ba268adf366a07fe5e78b9-1730301417"
  },
  {
    "email":"mg.montemurro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302785402/f3e83565b67685b1a974fdae80786e9e-1730301417"
  },
  {
    "email":"astori.cima.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302818170/15127ea376849062d14d4d22bd0d6525-1730301417"
  },
  {
    "email":"manuela.cuomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302850938/19496d3e093b199c5d2366bdf4e145e0-1730301417"
  },
  {
    "email":"gornati.chiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723302883706/3b3f463730420450ac3f5fb5b1f72faa-1730301417"
  },
  {
    "email":"gabri.corvasce@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302916474/676bf15347331746094ef39b9ceda729-1730301417"
  },
  {
    "email":"virginia.dicrisci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302982010/0cb874c6a6edb0df17fe2aede77e545c-1730301417"
  },
  {
    "email":"michelafalvo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303047546/b0decd8686e0a80b0dbfec622fdfcfc1-1730301418"
  },
  {
    "email":"lucia.poggiali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303080314/68ccbdfbf83a2baeed130eb0feb71507-1730301418"
  },
  {
    "email":"robertarssttt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303113082/647bf685a3ffe1b8277fe307275486b2-1730301418"
  },
  {
    "email":"annalisaduonnolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303178618/8f9dea522946e347cc7fd16112c728d2-1730301418"
  },
  {
    "email":"dernaty2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303211386/924b95f5dee9d855f5ebbac304814098-1730301418"
  },
  {
    "email":"cirillodmg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723302949242/968c1d5b9f5230d1d5c45c1a6906acd7-1730301418"
  },
  {
    "email":"eleonora.seppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303244154/49c80d3e019e6cb5cc6906729eecdfde-1730301418"
  },
  {
    "email":"pizzico19@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303342458/4cfb9bd1d896a0fb11659ef8b7724366-1730301418"
  },
  {
    "email":"santoroveronica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303276922/d8ff5cc0185cecf4d5ab4923e5ca2bb8-1730301418"
  },
  {
    "email":"nadia71@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303440762/fedcd1220ebd68bff1df81b1297ecc5f-1730301418"
  },
  {
    "email":"alessandrini.bianchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303539066/1ee3c014e5d40e80939c2714d3e968cb-1730301418"
  },
  {
    "email":"alemere155@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303571834/82323f3be077716dcda0c246a4b66728-1730301419"
  },
  {
    "email":"drisuleo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303375226/8b163abd550e1dd9cdcb563060c567a9-1730301419"
  },
  {
    "email":"g.griffo@studiolancia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303604602/406b2234eb4ac093401d901a95ebafa9-1730301419"
  },
  {
    "email":"carrarafrance@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303670138/de2ba5d2775a793a71b04d4f32ffbd9d-1730301419"
  },
  {
    "email":"v_81_v81@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303702906/3bebe870e13a78051d890df7956f0e0b-1730301419"
  },
  {
    "email":"ilfilodianna01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303735674/8a4d086256fb21d9bcae361373021a5b-1730301419"
  },
  {
    "email":"caliendo.rosanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303768442/bba7b255c6a1dd6e9fd6ea2989040e5d-1730301419"
  },
  {
    "email":"mtmaragliano@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303637370/f3f3e85751a4e4d050c914d2795c9f06-1730301419"
  },
  {
    "email":"sarafrancesca87@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303833978/5e6d5c9809aa549b14c6240bae93f957-1730301419"
  },
  {
    "email":"elevinci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723303866746/0a4aec1684d38545e5e14fbc555d272f-1730301419"
  },
  {
    "email":"mara.nic@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723303899514/93c2947372a4899a085735d371947cdd-1730301419"
  },
  {
    "email":"melania.eva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304063354/569c43f09c98f415e6924a0bc7979ee2-1730301420"
  },
  {
    "email":"manucorso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304030586/cd50117e609faaa95e85fea15682b1f2-1730301420"
  },
  {
    "email":"fratellidiego@hotmail.il",
    "url di attivazione":"https://verdissima.it/account/activate/22723303965050/49775e2577246f474298991a7a2dc48b-1730301420"
  },
  {
    "email":"rosa.iandolo@airitaly.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304096122/4a902b8932fe69d890ec43bc8bc15bc1-1730301420"
  },
  {
    "email":"paola.boglioni2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304161658/a700f7bd93fb6da8e55c58ed5e8090da-1730301420"
  },
  {
    "email":"elisabetta.bls@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304227194/e05c851572950c75279d43b914b2125a-1730301420"
  },
  {
    "email":"manuela.letizia66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304259962/3999f7f02959364445419b081e3b0796-1730301420"
  },
  {
    "email":"annazambelli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304325498/1c45ff8377147c31f3cc668041ff26f3-1730301420"
  },
  {
    "email":"dstincheddu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304391034/48ea2c7e1c5fb6d1fea75a5df46800a4-1730301420"
  },
  {
    "email":"rickylegno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304292730/11bbe07ec63246d06af65b4a83684bf8-1730301420"
  },
  {
    "email":"vivminaudo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304489338/73de9590ecd32104387f81acdc995bf5-1730301421"
  },
  {
    "email":"cristinavicarelli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304423802/0310e08c660fa06565e7b11400491c37-1730301421"
  },
  {
    "email":"tentoribarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304620410/adc01668869adcf94d0a932cf19c2f6f-1730301421"
  },
  {
    "email":"antonellaavesani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304456570/83a4fc4fec0d39d9785f520e7d5ba217-1730301421"
  },
  {
    "email":"tpilli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304685946/e44cec30bfa4960b8e0350bf11ce78e9-1730301421"
  },
  {
    "email":"giuliagiovannini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304653178/571012abfdfc6ac3de7efe3772405b44-1730301421"
  },
  {
    "email":"info@robertabacarelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304751482/12f833aa706a8ccebc6844405de473fd-1730301421"
  },
  {
    "email":"nicolettaottanta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304784250/b3ff3a8518a8e629d351bf0ca465caeb-1730301421"
  },
  {
    "email":"serenagallina77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304817018/a7aee174aea37c78f365d3961dfdb6fb-1730301421"
  },
  {
    "email":"farmacia.cristini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304718714/99a3b812d074f23bcd86531d49778978-1730301421"
  },
  {
    "email":"adelezito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304915322/72d213f27b8cfbe6e3f5a82b1589721c-1730301421"
  },
  {
    "email":"almerindaforte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723304849786/ad2a9c9a5488719462a49c7d20063381-1730301422"
  },
  {
    "email":"caterina.conti@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305013626/eeec557caea80b02d163af5a0266e6e6-1730301422"
  },
  {
    "email":"stradiottistefania@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304980858/83f1203f23d8896b7495424d74c4fddd-1730301422"
  },
  {
    "email":"francescagiombi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723304948090/51495cd640da69d70c2c490e59b069d4-1730301422"
  },
  {
    "email":"stefanialarosa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305144698/335c8ccb26691ddcda5deed92e4762ab-1730301422"
  },
  {
    "email":"silurimara68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305177466/e5f60ff94f69a8c531c23717bce2477e-1730301422"
  },
  {
    "email":"cristina.84bruni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305243002/db4a5598920b5669d2687abb38940ef2-1730301422"
  },
  {
    "email":"silviacler78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305341306/cca4179235e584edacf94e9409e24d07-1730301422"
  },
  {
    "email":"raffaellabasile@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305308538/bdf1a341d1c196e41dc91a4fc85fadea-1730301423"
  },
  {
    "email":"s.vigiani@vigianipistoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305406842/abfbcce51a4fb8693b4d32e18b071f61-1730301423"
  },
  {
    "email":"oro23srl@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305210234/b0415f10b1a0d2a59bbe7e96c6d6c9fd-1730301423"
  },
  {
    "email":"mariannapazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305374074/83245409a88f956377284f114dd6690f-1730301423"
  },
  {
    "email":"laura.sampellegrini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305472378/5fb0d789cfd92f76a791e775a2a9184d-1730301423"
  },
  {
    "email":"simone.cola@gruppoitas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305537914/9c13dd484325ede3e5181ba6a99668e8-1730301423"
  },
  {
    "email":"reginaesse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305505146/54699fab4ad80953b2e5bccd47a6fb6e-1730301423"
  },
  {
    "email":"irene.di@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305636218/f86179f301e6ac5dbe0b7c31524f10d7-1730301423"
  },
  {
    "email":"map7003@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305668986/c1739771abc78cb765c0f0ebd0c05f33-1730301423"
  },
  {
    "email":"tbruschi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305734522/4fc7aad4bee9927631271bed920209e6-1730301423"
  },
  {
    "email":"patty.26471@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305767290/56d89b4041dbf0d7990f86c10744fa13-1730301423"
  },
  {
    "email":"annalisacasson@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723305800058/8d80c048aaac0ed43b6c7b658e3dab5d-1730301424"
  },
  {
    "email":"elena.pizzagalli@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305832826/a7a02547c31fb355b042753d78102fc6-1730301424"
  },
  {
    "email":"siminore75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305865594/23c63e4f37145823d126daed0f835268-1730301424"
  },
  {
    "email":"l.bartoli@volterraio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305701754/80392f346ba66b207cb074aaa5cc54e6-1730301424"
  },
  {
    "email":"andretoro78@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305963898/11654b32922fa002fa75cb6bfae35fcf-1730301424"
  },
  {
    "email":"barbara.zago@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305931130/681b87efa7e9125cfcea6635ec0ba801-1730301424"
  },
  {
    "email":"marziatam@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723305996666/2aeb944210e36ed9a5d670bc9c24e321-1730301426"
  },
  {
    "email":"mezza.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306094970/67db3ccd83d4366aaa871c2f957a2047-1730301426"
  },
  {
    "email":"cristina@viglietta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306062202/f476bc5097a8a75c0c664c0dafc6a8ed-1730301426"
  },
  {
    "email":"zeudisantandrea@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306029434/c4656d4c051795b33c7b757b2cb6878a-1730301426"
  },
  {
    "email":"cavalloangelicaclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306127738/4fa0a8a7ff77fec0bbe289d7a9719640-1730301426"
  },
  {
    "email":"silvia.soci87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306258810/cff5fc6217b6a140c8f8fb448ccd809e-1730301426"
  },
  {
    "email":"aventura@coveme.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306422650/1e2dae9b7a4f65b4814f479e09ed41a3-1730301426"
  },
  {
    "email":"federicaparison@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306357114/1cf48113614f4b53df0442217f6f4d5a-1730301426"
  },
  {
    "email":"stefania.vesentini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306291578/26cf162aada9412874085cdb77678ce8-1730301426"
  },
  {
    "email":"grazia883@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306324346/40adcc7dd4e17be721a34b2f26869613-1730301426"
  },
  {
    "email":"racca.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306488186/88a5d2b16e9a09f71380e02f85e378aa-1730301426"
  },
  {
    "email":"silvia_scolari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306455418/006bf5a7dc6b856d88970dac29c3f992-1730301426"
  },
  {
    "email":"monniferrari64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306717562/8e29ec59e59d8d160599adf5c6bccede-1730301427"
  },
  {
    "email":"lucplaza@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306652026/fb8c4b062362da1e638e91382782dbb4-1730301427"
  },
  {
    "email":"torosani.luca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306520954/fb4a4563fab5ea843096a619aef9b915-1730301427"
  },
  {
    "email":"anna.heymann79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306848634/c5961fcb53212bff4273759f3f161f54-1730301427"
  },
  {
    "email":"stedelogu2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306553722/4c442b0db6e4bdf2db7482345f3789bc-1730301427"
  },
  {
    "email":"sabrinaventurini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306783098/1cbda6f492bcaf54fa66d8ed2be8785b-1730301427"
  },
  {
    "email":"ele68nora@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306979706/ad640359dd82a191560f7df5cd6dfc6d-1730301428"
  },
  {
    "email":"ste.romanelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307012474/93dae00ea3e5cd4a11db45c7816574fb-1730301428"
  },
  {
    "email":"napidemaria@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723306881402/63732fc4e3a78be50393b6fd79bb9a3b-1730301428"
  },
  {
    "email":"info@lecantinedelpalazzo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723306815866/ed7f61344b0f7b1df6919a882facac8c-1730301428"
  },
  {
    "email":"delia.manuela@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307110778/065c7c41e53dce40c718192ae262c23d-1730301428"
  },
  {
    "email":"w.mari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307176314/4086c9a4635a5f622dc55de92cee7e86-1730301428"
  },
  {
    "email":"ufficio2ca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307143546/2bae5e6a3c6c133a617ec80b5be1a77c-1730301428"
  },
  {
    "email":"katia_cevoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307045242/bcc72edc3967dd604a8c4e0da6b1cb4d-1730301428"
  },
  {
    "email":"valeria.tutinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307307386/16438f2081b0dfc4706bc1fa33eb4f6f-1730301428"
  },
  {
    "email":"maria.trapani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307274618/24e3deb405ed0616433affc4fafc88b8-1730301428"
  },
  {
    "email":"paolagilardi.63@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307209082/3f1e1e1e8d86abeba0cd43d546407c45-1730301428"
  },
  {
    "email":"sara.campioli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307340154/a689da8a94e69bf708c8e1ee45ef9d2e-1730301429"
  },
  {
    "email":"lu.sa2003@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307405690/2995a3cfc6656d980d45e4119a59cdca-1730301429"
  },
  {
    "email":"fiorellapalmieri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307503994/558e96c6ccb8c7b74e550092fd02738d-1730301429"
  },
  {
    "email":"janasline@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307536762/0dfe59b9e79a245b6bbd87e15a71c726-1730301429"
  },
  {
    "email":"elisapiace@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307569530/a2fe3bb3880f98e53e19583911bf62cc-1730301429"
  },
  {
    "email":"katiagallizioli31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307438458/5a05a131f7e5ebbdbab98c6d9a697ac9-1730301429"
  },
  {
    "email":"nuciforo.a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307733370/e1ab8a20491faa6cd42f1fbc73be3cc2-1730301429"
  },
  {
    "email":"info@studiosettipani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307766138/3cada4f0c18f4b8c7976deb550342350-1730301429"
  },
  {
    "email":"heidirm75@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307700602/8772b3358ec4065d53c7b739c0e5edba-1730301429"
  },
  {
    "email":"fracance77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307667834/d410d05a63053d80b8d828c3c20b7dfd-1730301429"
  },
  {
    "email":"info.nadia10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307864442/e03436adee150de01257ef99a002cf5d-1730301429"
  },
  {
    "email":"alepegollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307798906/74838043da9e711b1029fe7752b4e4b3-1730301430"
  },
  {
    "email":"matiagiovannag@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307897210/ccbb15defea62418559d52747993c70a-1730301430"
  },
  {
    "email":"gisella.cafiero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723307962746/c1f41b33d11883f82aec0c20cc57ed97-1730301430"
  },
  {
    "email":"aleottantacinque@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307831674/35f347f2293e9a0073b53a1c19b8d5c7-1730301430"
  },
  {
    "email":"karim_alolidi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307929978/a76d7a600f587b3cac09aac0d9cd8779-1730301430"
  },
  {
    "email":"rame72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723307995514/1cc42ac504829611307e7cf82fa6d686-1730301430"
  },
  {
    "email":"nadiagiacomuzzi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308028282/6d0fa6611252a2b1efff03b6e1adf514-1730301430"
  },
  {
    "email":"raffaella.bonvini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308061050/a0b88468efcffed138a48481b6083921-1730301430"
  },
  {
    "email":"chiara.carusillo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308159354/a269d7f2c468c783008420b2d12b8fb5-1730301430"
  },
  {
    "email":"palaur@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308192122/0725ccf23e4d770655ff9ee979748902-1730301430"
  },
  {
    "email":"valenosei82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308224890/d2bea8e39fd3e790465b3527dfe366fd-1730301431"
  },
  {
    "email":"anna.contardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308093818/3085dc2856b2507db4e48c69c8574904-1730301431"
  },
  {
    "email":"antonellaorio73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308323194/025ae9ee539bd52196065b480477907a-1730301431"
  },
  {
    "email":"rosyd@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308355962/c6f2e76f818628b86a30956237d3ee74-1730301431"
  },
  {
    "email":"elenamiola81@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308257658/e5859c93275bf16aa195a06b155e3850-1730301431"
  },
  {
    "email":"lamanuuu@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308126586/33d73aa8521084f6b945f2579868ccd0-1730301431"
  },
  {
    "email":"mavignone@pfcredem.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308421498/008187fcd4d8f50e7964018604987192-1730301431"
  },
  {
    "email":"paolagir8@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308487034/d86f041eef17f6f78e7885e1febb87c0-1730301431"
  },
  {
    "email":"francyco76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308519802/6655a9f570c1bb317658693a794620d9-1730301431"
  },
  {
    "email":"g.gasperini@afsservice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308552570/ccc815278cad648adb6a4e62f61b1791-1730301432"
  },
  {
    "email":"chiara.linati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308585338/bbcde736dc4b432d8ae6951923cb2b7e-1730301432"
  },
  {
    "email":"bellardinellimarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308618106/35e37a95ee20a5203eeffbeae9ced6c6-1730301432"
  },
  {
    "email":"lalliross22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308454266/3283bc041a4506abe33cc6d6b444022f-1730301432"
  },
  {
    "email":"aleferroni1974@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308650874/5ac99d7cbf2d5b24a1a0ab37a043abd6-1730301432"
  },
  {
    "email":"alealex36@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308749178/bbbac48f2746f89e631312b9cfd1fb83-1730301432"
  },
  {
    "email":"saraciufoli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308716410/a3411111f703a331ba2b7f8889002d68-1730301432"
  },
  {
    "email":"r.nava@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308781946/300833c715d886afa0a56ed97d4040aa-1730301432"
  },
  {
    "email":"eleonora.cannella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308814714/ada33af836c60aa13a77e8bf5199856f-1730301432"
  },
  {
    "email":"mariangela.genna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723308978554/c57e3d352b05e8ba03a67783ec2b00de-1730301432"
  },
  {
    "email":"avv.melissafontana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309011322/25ee27b56a5ad2fd89ffb25f96d1e681-1730301432"
  },
  {
    "email":"bademarchi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309044090/7578b187416ccbc0840d521a75246dbf-1730301433"
  },
  {
    "email":"rosannabicocchi55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309142394/9c263dc83f07fa97a59dd88e10c7590b-1730301433"
  },
  {
    "email":"ivanasampaolesi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723308847482/134bfadd212f2541bb439f5b11b45180-1730301433"
  },
  {
    "email":"tobiamagia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309175162/01b6ea1a816f3c6b087b5ca04ea6cf07-1730301433"
  },
  {
    "email":"mamita_patrizia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309207930/60dd9d4c8591f4fa49f64f623ace770c-1730301433"
  },
  {
    "email":"sirla5@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309306234/ad894a9c334c179b52ea7e3983a5b990-1730301433"
  },
  {
    "email":"migliavaccasilvia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309273466/cf15b77d670ad819a8aad766eb358a40-1730301433"
  },
  {
    "email":"lavanderianuova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309339002/733d59231359d5d97c697f1e30674fbe-1730301433"
  },
  {
    "email":"caccof@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309371770/6000777ca7e10bf0813bd37c9faa6d5b-1730301433"
  },
  {
    "email":"legale.vallese@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309470074/a445a9b78688d52bc43b2a09f2fb2998-1730301433"
  },
  {
    "email":"emanuela.solmonese@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309437306/e957b754fb8a105e86585af9db902b71-1730301433"
  },
  {
    "email":"impedovo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309502842/30a00d249f0f25cc3dca339d57a55a90-1730301434"
  },
  {
    "email":"st.piscopo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309568378/3ca9bf25f91172136bc33ac76ba13c5a-1730301434"
  },
  {
    "email":"annaantonia.clementelli@bancaditalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723309601146/c6f92dbc5e1d0fa883fee869b65bfe73-1730301434"
  },
  {
    "email":"ftommasin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309404538/702f8de48ea0c539a5eea3d228e7f2af-1730301434"
  },
  {
    "email":"massimiliano.bono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309633914/bf3518de35d07255b21d2a56784d235b-1730301434"
  },
  {
    "email":"adrianuzza88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309666682/3c8c7265490a9aacc0a62f6e3db1f104-1730301434"
  },
  {
    "email":"pamela.donnini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309699450/1aa4821505f84401308fd627d82d4e67-1730301434"
  },
  {
    "email":"mauriziopesavento3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309830522/b536c5fb70eb526866814aaf3eca788a-1730301434"
  },
  {
    "email":"rositadivita1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309797754/4583fe867648fcae0903f8906f5d036b-1730301434"
  },
  {
    "email":"marina.mussi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310027130/eca2c99d345da4f89b02df9a4916be68-1730301434"
  },
  {
    "email":"liviana.toffali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309961594/213a2ac363d72d49439119687b341b49-1730301435"
  },
  {
    "email":"ima.michela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723309863290/f0de77657fbb2d64ae00ab1b72817609-1730301435"
  },
  {
    "email":"fonte.g18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310092666/7de5eb7e54c7a89bff01421ce816014f-1730301435"
  },
  {
    "email":"sere140484@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310125434/ff72c4cdbc23eba716544be08e98600e-1730301435"
  },
  {
    "email":"rampager2008@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310158202/ed4ea7ae6b1e53b538d741989af95530-1730301435"
  },
  {
    "email":"barbara.perbellini@bancobpm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310190970/bd92781d1c86af0912f7af02ef02f006-1730301435"
  },
  {
    "email":"elena.frasson2610@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310059898/b63a148cdbef660c15a7a2bdcc796a1f-1730301435"
  },
  {
    "email":"genz75@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310223738/4bfc7810d36d2bfc68251633a2abc130-1730301435"
  },
  {
    "email":"mariagraziabordonali71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310289274/87f3c5de95e3ac277070f41c345dec8c-1730301435"
  },
  {
    "email":"francesca.castellari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310322042/f3595e3c2a7f40ad4f6c7704911069a7-1730301435"
  },
  {
    "email":"fcolucci06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310354810/bc537477c3103361aaa0c75a37f35e57-1730301435"
  },
  {
    "email":"ale.casale81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310387578/f86aa84b8f4ca6fdd074a8aa41293fdb-1730301436"
  },
  {
    "email":"simona.commegno@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310485882/fa364ec36f624fc31a1c4d1a037f2676-1730301436"
  },
  {
    "email":"paolaminelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310518650/cadd7c44f563e6d29bb2ce67380d54bf-1730301436"
  },
  {
    "email":"amalia.sagliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310584186/5f288160c8f0994585bad8bf329d1cea-1730301436"
  },
  {
    "email":"nalli.emanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310616954/b564eb2fcf5dc7bd982f6d0834d21aa9-1730301436"
  },
  {
    "email":"mcristinaconti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310551418/d253143b9081761105cc80ade78c09db-1730301436"
  },
  {
    "email":"beautifulline@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310649722/6a8182bf5516abe260d2b5212954e52b-1730301436"
  },
  {
    "email":"donatelladoni2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310682490/c1d823ce2b9e9aad17a561ef5c587d7e-1730301436"
  },
  {
    "email":"silviabartolotti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310715258/1509601de226bd6831711308a071657c-1730301436"
  },
  {
    "email":"lorenzka@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310748026/33a4fc7b6707e323a494a3d9e9845a19-1730301436"
  },
  {
    "email":"hannafolyush@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310813562/e389017b87e5f71efe4f253b81f2c4cd-1730301436"
  },
  {
    "email":"luigi.guidi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310879098/f3aa16a8c5eb5ff5703f2a6baac03bb8-1730301437"
  },
  {
    "email":"ari.colle@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311075706/7725bf4d1e852bf6aa9abe86c093b85f-1730301437"
  },
  {
    "email":"mayla.giraudo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311108474/d5111f89eaab3fa5e897d818722f709d-1730301437"
  },
  {
    "email":"vendittit78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723310846330/c151606126d2a3bdb4dbf0c6b701aae2-1730301437"
  },
  {
    "email":"barbaradaldoss@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723310977402/97234d8253f881231a0438840b0ec2ae-1730301437"
  },
  {
    "email":"sarad9570@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311239546/7a4072868a60116be747291eacfe3cfd-1730301439"
  },
  {
    "email":"annalaurenti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311141242/7ebf8d2b7c912c6c6b9833500b19adcf-1730301439"
  },
  {
    "email":"katiadamiano68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311272314/e830d5f5ffbb921eee7327a8f5924996-1730301439"
  },
  {
    "email":"jastin1998@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311305082/c52e20e0ac22fba0fecda4e0d10eff0d-1730301439"
  },
  {
    "email":"erikaganapini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311337850/f0ca27852c50e709de50f2ce7d1459b8-1730301439"
  },
  {
    "email":"achille.bau@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311370618/35e134d2ffd556f1c469cdc2ba50475f-1730301439"
  },
  {
    "email":"eli_911@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311206778/12203503b2578d072f544be6cc58ef81-1730301439"
  },
  {
    "email":"francescasommariva@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311436154/bf5354abd38c4d8925ab30c143c595d1-1730301439"
  },
  {
    "email":"puppy1985@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311403386/33259f514cb87d98b0cbd4a620af7b11-1730301439"
  },
  {
    "email":"danielalionetti1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311534458/59b90dea99a0376484e8f087d0ef759b-1730301439"
  },
  {
    "email":"farmacia.donetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311468922/46c75564400a8bc0532939860a815065-1730301440"
  },
  {
    "email":"sabrina.deluca1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311599994/bcb0b642f48b77e0eb2ce2191e821be7-1730301440"
  },
  {
    "email":"therese.gab@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311567226/d4f507fa362cddd972f13e5871c79167-1730301440"
  },
  {
    "email":"emanuela_guglielmi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311698298/4ef11ad391bfb0bb620768092c8a960e-1730301440"
  },
  {
    "email":"claudiaruuu@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311731066/ad91cc0839cebc14c38fca7a62a5309f-1730301440"
  },
  {
    "email":"moniget@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311632762/127455d4ebc5ff7ef2cd4265736683d3-1730301440"
  },
  {
    "email":"smile_mandy@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311796602/139b1ae3a93587a767252f9d05b464b5-1730301440"
  },
  {
    "email":"zerbibeatrice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311829370/9fff7521a2ba89f08ba9b525fe16db78-1730301440"
  },
  {
    "email":"pierabonavita@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311763834/12e8409f8392920158b0794783c31d03-1730301440"
  },
  {
    "email":"ghibl.simeo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311927674/e0664cd761a32ebe014c817caae38401-1730301440"
  },
  {
    "email":"silvyvincis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311894906/20fcd78a973d110b61d54092dd6cfe37-1730301440"
  },
  {
    "email":"piscipishow@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723311862138/9b2973f3ddc6f681acc4e09f7995dcc3-1730301440"
  },
  {
    "email":"michy.scap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312058746/6f1cd11c39ad419898085658a9cc8903-1730301441"
  },
  {
    "email":"michela.secod@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312091514/1772bbc949afefc6b6e4ab6e66758b46-1730301441"
  },
  {
    "email":"ciro_sco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311993210/b151cce7acf5a73cc7e682ee41aec2b9-1730301441"
  },
  {
    "email":"ange82x@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723311960442/89831c07e0a69e4e803248cf4daf2ebc-1730301441"
  },
  {
    "email":"skryccia29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312157050/c92859b047b68d0396f1373b1a710ee5-1730301441"
  },
  {
    "email":"annamaria-mazzoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312189818/ad01cf31c6c46c7b4e5cb9808b93dfbf-1730301441"
  },
  {
    "email":"vetmeli1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312222586/d03b9eceb2f3de7057f709f024cea20e-1730301441"
  },
  {
    "email":"federicadorno@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312255354/9579024d86fbd34f90c8db7afb28133b-1730301441"
  },
  {
    "email":"a.esca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312386426/e7b9b14f306ab5e338b93e6858add335-1730301441"
  },
  {
    "email":"c.espen28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312320890/b4ddc9b85986802ab32c43e84eac1ffa-1730301441"
  },
  {
    "email":"galaxyletizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312353658/7f04302e3171e620ded6340eee8f4fd6-1730301441"
  },
  {
    "email":"laragobbin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312484730/f946debbc23b66b9e2f8d4ae7a7a3af8-1730301442"
  },
  {
    "email":"piera.selmo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312583034/3656d32bbe6b1b1020ad88187ca15b36-1730301442"
  },
  {
    "email":"claudia.francioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312550266/7de0add5a2f1eff96437f7849c59f9b6-1730301442"
  },
  {
    "email":"melissavalentina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312615802/2e46c76401471d126eac6a7688f7b18b-1730301442"
  },
  {
    "email":"massironta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312714106/ca584b24c3503aa301197a0eb4d8e0bd-1730301442"
  },
  {
    "email":"dostri74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312681338/1e9f5c69a0c73936ed1083ae86ce8553-1730301442"
  },
  {
    "email":"catia_gasbarri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312451962/ab6ef0c581bc68d467205ec6ba3b5463-1730301442"
  },
  {
    "email":"carmelo_crimi953@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312779642/79cf2828288d8fb707493c8535ea2b1a-1730301442"
  },
  {
    "email":"mindy.amadio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312746874/51ae57b81def4253fd5982ff025ea2ca-1730301442"
  },
  {
    "email":"sarabi.lo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312812410/78eb0d4edac15b52b2b175b4d4b4f487-1730301442"
  },
  {
    "email":"rosariavierti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723312845178/1b1a4098a8aac577d29c375032ff5574-1730301442"
  },
  {
    "email":"alessandratuzza92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312877946/31fd6e3accab82849116cab3efe323e2-1730301443"
  },
  {
    "email":"nadia.zannier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312910714/cd46e5a3c613eeb5698606535678d70d-1730301443"
  },
  {
    "email":"patrizia.campesan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312976250/565b074699695d8f255624fe3fadf95d-1730301443"
  },
  {
    "email":"lauralandriani@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723312943482/3381493fcac13f7c4aac3d10a2e93977-1730301443"
  },
  {
    "email":"e.mari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313041786/c12d499c154486cc870bd8c20430b787-1730301443"
  },
  {
    "email":"irene.castellana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313140090/a81c49635130d0257e4634684cda37a6-1730301443"
  },
  {
    "email":"aleilardi02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313107322/0a87df09400e3253400dc343711297ec-1730301443"
  },
  {
    "email":"disatnoilenia@iclou.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313172858/74910102ae3d4198752fced1fad913bc-1730301443"
  },
  {
    "email":"lavinia.pasqua@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313074554/d1062ad10ca48503fdc532e9d720e441-1730301443"
  },
  {
    "email":"iiritanostefania@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313238394/afebb1e956d0cbdf785b4213aaff94ef-1730301443"
  },
  {
    "email":"antonella.cappiello@unipi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313205626/6bdd4e7fa493bc00268780919c5654e6-1730301443"
  },
  {
    "email":"margheritacca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313303930/ebf74178587c368c59c13a121a5afb8f-1730301444"
  },
  {
    "email":"f.speghini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313271162/1eece43a2cf3408430744d9c6299c734-1730301444"
  },
  {
    "email":"s.gregori@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313402234/606c7f8dec7dfa05c327645e1a140509-1730301444"
  },
  {
    "email":"gina.labriola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313369466/44859c2b7e08f7c77755bff82fc831c6-1730301444"
  },
  {
    "email":"elyiellici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313467770/19aea0449c00e3704139c51f594e482f-1730301444"
  },
  {
    "email":"maria.elena_montagna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313500538/395641ef3853e5314dcaa3c7f7761117-1730301444"
  },
  {
    "email":"enrica.bianchi63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313435002/517895a79f774b28b5905869c20a8ba7-1730301444"
  },
  {
    "email":"savinunu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313533306/f23355f795ae201cfbbe44f608c01000-1730301444"
  },
  {
    "email":"alcirotto@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313566074/69424d7893a74db19213c19de3e57e9d-1730301444"
  },
  {
    "email":"mrp.micieli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313631610/53b57aa23c6f5065a923661f732a3112-1730301444"
  },
  {
    "email":"giuliadeprato.gdp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313664378/519d50be24e58e7f443435762cd54fc6-1730301444"
  },
  {
    "email":"dmolbalas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313697146/d38ef2c2fd2f8f68dd79bd45971029e9-1730301445"
  },
  {
    "email":"petkava74@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723313729914/3151c3afd42d3b6fa4026932dd3ce010-1730301445"
  },
  {
    "email":"ffrancese1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313828218/7dbf09c4055506f658f4904b89bdf31d-1730301445"
  },
  {
    "email":"mariarosaria35@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313762682/4bcf09a3300932041fadf6fb4d469610-1730301445"
  },
  {
    "email":"d.cupiccia@roma.bcc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313860986/900107692cf2153b94ef8806e1d77650-1730301445"
  },
  {
    "email":"hetreo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313926522/c7644eaee265c60f0e967a7815b64f1d-1730301445"
  },
  {
    "email":"chiara.romano75@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723313959290/5ef8c644c6a5190e81d8f4950e7b70cc-1730301445"
  },
  {
    "email":"colognesi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313795450/fad0f9d26369671b201b0039324ed8cd-1730301445"
  },
  {
    "email":"selena.benedetti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314057594/d86c15b800afcc864e03c90ca2667d96-1730301446"
  },
  {
    "email":"raffi671@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723313992058/a7d654910b6d24cf353af0a36094a823-1730301446"
  },
  {
    "email":"tassan.vanessa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314024826/c991f8124dcf3ede36f1332f1d6afd65-1730301446"
  },
  {
    "email":"luisa.montarese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314155898/58493d82530424e14b7689adaae9dfd3-1730301446"
  },
  {
    "email":"dangeloesse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314188666/4ba26f8080e67f4d576e5bf6dcac5b90-1730301446"
  },
  {
    "email":"luciamaggiano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314123130/be738c847b4eeda6f7f1f43af2921ee7-1730301446"
  },
  {
    "email":"v86pette@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314221434/6f8298cc19f472820a9a5b99a0adb71f-1730301446"
  },
  {
    "email":"sabrinaoppo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314319738/9f3dd29c621a9aaec100fa6bb73adf85-1730301446"
  },
  {
    "email":"laura.buci@gin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314352506/3e9edaf2b91009376640501acb0bcd00-1730301446"
  },
  {
    "email":"francesca.campisi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314385274/889aae9da8ecd7416e1b63e6d506abb7-1730301446"
  },
  {
    "email":"mirtillamao@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314549114/f64efd77a217bd99699e0910e40815fe-1730301447"
  },
  {
    "email":"michelafly@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314581882/64853c5e14e93c47fcd16f8f0941ade2-1730301447"
  },
  {
    "email":"lucia.guanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314286970/3024fccda32be278128ff95e58d2caef-1730301447"
  },
  {
    "email":"cerrutigrazia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314483578/98f6b628f214a35ac8248c57bfb9153d-1730301447"
  },
  {
    "email":"feridani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314647418/df472ebcb11f026ee65c129c4140c4bc-1730301447"
  },
  {
    "email":"mattiolac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314712954/4c6bbf97f626ea57fbd35a0303a2b48e-1730301447"
  },
  {
    "email":"giuliana.deluca@del-tek.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314680186/6d61a96c931b7c1581ddc943b97d67d6-1730301447"
  },
  {
    "email":"cristiana.biasiotto@fossmarai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314745722/55444b921067832bc2d486fb326be8f2-1730301447"
  },
  {
    "email":"federica.busi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723314778490/9c7572db97bd95f8c69eb89cd4a2be19-1730301447"
  },
  {
    "email":"c.carmen@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314811258/17658ee70f702531d449f7f66e7b82f9-1730301447"
  },
  {
    "email":"vecchi.valentina82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314844026/a95ca5060a2a94268eaae7038ebb354f-1730301447"
  },
  {
    "email":"cairati63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314909562/e2eb5b39404757f42ae8d571f849c96e-1730301447"
  },
  {
    "email":"giocoter@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315007866/9a04c11590f2765107f2ea4ffc571bae-1730301448"
  },
  {
    "email":"tritti82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315040634/77f6d1a5acd19caf80978c3e423d30ab-1730301448"
  },
  {
    "email":"pinellascandura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723314876794/c491bf23643c14a99fcfeb079b9c90da-1730301448"
  },
  {
    "email":"natayura2005@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315171706/6e31b4e909f5ca41dfc0270953e8ad97-1730301448"
  },
  {
    "email":"veraveramente@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315138938/954e534215e2e54794a4b4151d7b1e16-1730301448"
  },
  {
    "email":"gbrangelica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315204474/d504e874deaa50a3ead1c4307c3d21a9-1730301448"
  },
  {
    "email":"alessiamantovani198319@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315270010/5857fa3862ea30f194758d9fd729e771-1730301448"
  },
  {
    "email":"elisalabanti71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315335546/8662d6e74f56b04dfe3b67c27c1f1b5b-1730301448"
  },
  {
    "email":"casamastella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315302778/093e0ca995a066c94f857cf6ef40a873-1730301448"
  },
  {
    "email":"annalisamaroglio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315106170/904c6c9fa7d334e1b2c51ddce1568c0d-1730301448"
  },
  {
    "email":"dany.schisano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315368314/c3401e9b09a24a582c390d0c30943c10-1730301448"
  },
  {
    "email":"ula.b@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315401082/b9bb25c7a1f0651047094374aff5aa86-1730301449"
  },
  {
    "email":"francesca.lissidini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315466618/11fffb7f498a72622d2fc27b90002090-1730301449"
  },
  {
    "email":"massimocristel@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315499386/0f0b847abcf6a3a75da32f7cb35f362d-1730301449"
  },
  {
    "email":"olallalopez@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315532154/77a0e7c20ea6a086e28353ac6077b9b3-1730301449"
  },
  {
    "email":"federica.parrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315564922/fab450f544732227537268a06f348da9-1730301449"
  },
  {
    "email":"raggi.daniela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315597690/a4d3ea47be6c0e2bfb52635dc4b95a43-1730301449"
  },
  {
    "email":"paola.bertola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315433850/be2d0d5fdd6de63f91ee78b064a984e3-1730301449"
  },
  {
    "email":"linda.montagna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315728762/656e3d8e48a9e220a4376d1dac094895-1730301449"
  },
  {
    "email":"naomi80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315794298/bcf731c868df8e86ca021dcb13944419-1730301450"
  },
  {
    "email":"francy7354@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315630458/55f41d4086a2af7e9967d23deabbe529-1730301450"
  },
  {
    "email":"manu.vo@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315827066/655f4cf6f93d10527d53c685d80fc08c-1730301450"
  },
  {
    "email":"oneval09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315663226/fd945e2cf15f05ff8fbba92868b0b4ed-1730301450"
  },
  {
    "email":"elena.siska@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315859834/0d73b6e01166ffa5d02bad818ef41d72-1730301450"
  },
  {
    "email":"manuelamenichelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723315958138/0bc1c81f1aa7be9aebf43fb925c6e016-1730301450"
  },
  {
    "email":"dallavallesar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315892602/88c47af4198415d7c9454890821fdb97-1730301450"
  },
  {
    "email":"elisapaganelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316023674/11574663d846a539510c1ca6f2fa4364-1730301452"
  },
  {
    "email":"bodosca.stefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316154746/16175f8e8bf5b5ccded03d50e770a843-1730301452"
  },
  {
    "email":"valeria.annoni@vamaitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316121978/b2abb891364c8e8a6edaeb862db5347f-1730301452"
  },
  {
    "email":"maffeo.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723315990906/db3186f1260890b170f30cd8398276ab-1730301452"
  },
  {
    "email":"vaja@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316187514/a66eff5954bfcc47e7255ba675b12969-1730301452"
  },
  {
    "email":"evabernardis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316220282/040a11459be4f09d39058e6749e9a078-1730301452"
  },
  {
    "email":"silvestrini.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316285818/135a9428796786bea835ad79b9490d7d-1730301452"
  },
  {
    "email":"ingsandramenapace@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316253050/f3b7f773cfca66a6e27fa1c7c6fc20e2-1730301452"
  },
  {
    "email":"mema2975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316449658/0e973e993961ebca2014fed5a253a396-1730301452"
  },
  {
    "email":"alessia.apostoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316416890/b9e66a6f7cbc4ba5cd4a7b85c3d5950b-1730301452"
  },
  {
    "email":"aghetto77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316384122/e5212680073d0d70e500fad95a188786-1730301452"
  },
  {
    "email":"elisa.bertogli@bertoglilex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316482426/5e8196df030bd1771b48850bf17a28d0-1730301452"
  },
  {
    "email":"viale.elena@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316515194/97528878168383440fcc1b691de4073d-1730301453"
  },
  {
    "email":"silviabreddo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316580730/e80d3b66825d472b354799f4d5b855ef-1730301453"
  },
  {
    "email":"giuliav1971@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316613498/713e05a98c383b5e2db6ece0b05a305c-1730301453"
  },
  {
    "email":"carlatilio65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316679034/0cdcd40a1afb057d94b09e78f1c77469-1730301453"
  },
  {
    "email":"roberto.rigotto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316744570/63a5741d70a787d3602757bc276e794b-1730301453"
  },
  {
    "email":"s.defazi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723316711802/ad9e588d1947e8590976dd08674291cf-1730301453"
  },
  {
    "email":"anna.beneggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316777338/3648c9e1eee4640c9961699f9937215a-1730301453"
  },
  {
    "email":"laura.buciz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316875642/89ca4be6532843e0c7bc322a80d883cb-1730301453"
  },
  {
    "email":"sabrybai72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316842874/494ec60d09cf13fd96680cafb8fe6c27-1730301453"
  },
  {
    "email":"alla.dandali2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316973946/001d89d590961023f6fe375e2a3fd2a6-1730301453"
  },
  {
    "email":"rosangelacantalupo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723316941178/6adafff5351a2b2ad2e42dea1fb02138-1730301453"
  },
  {
    "email":"torresfederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317039482/b545b4f5c4020387069804b996d74f75-1730301454"
  },
  {
    "email":"mg.meloni98@libero.ir",
    "url di attivazione":"https://verdissima.it/account/activate/22723316908410/cb5dc8d8baa7f156b045a1e2c33aca5a-1730301454"
  },
  {
    "email":"giulia.zampieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317137786/7d9d63dd15823ea788cb05d8c6f88c15-1730301454"
  },
  {
    "email":"patrizia.deiana@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317170554/0a8e71c703f5a7a56935e25ee381f15b-1730301454"
  },
  {
    "email":"calaia467@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317203322/a9a1e510a04d53682f2439da35623912-1730301454"
  },
  {
    "email":"wallet73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317334394/be430069f6a7955677262370778f8de5-1730301454"
  },
  {
    "email":"fra.t-96@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317236090/7b4d983a1459ce539b2fe5e0e45b1e3b-1730301454"
  },
  {
    "email":"elenaspinelli85@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317367162/ee40ad609738cd2224cf49a93c05367d-1730301454"
  },
  {
    "email":"alexvin47@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317301626/9302bdcd0bd7750969540f8d27878a38-1730301454"
  },
  {
    "email":"emanuelalbertoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317399930/c241c1db5b90a0cbc739a73fc6586999-1730301454"
  },
  {
    "email":"michela.brajato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317432698/cdfe6e9b01a36c8a54be14a965b05588-1730301455"
  },
  {
    "email":"donatella512@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317465466/3e87971f30f39a7ae9955f75f82acd1f-1730301454"
  },
  {
    "email":"rpoggioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317531002/b6936345e985602a30d561f1b76b0b6d-1730301455"
  },
  {
    "email":"alessadelu@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317498234/51d443e3c764cfdbe0822e150315c170-1730301455"
  },
  {
    "email":"monica.pn@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317596538/6550eeb8f9f4091a5c6bb3d3854c2d2f-1730301455"
  },
  {
    "email":"annacapob@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317662074/645d370e9da3c9a7dc44b9fe5ad54a53-1730301455"
  },
  {
    "email":"fursidia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317629306/ec7178f70b6deb3e9f2f2c659dd53c9d-1730301455"
  },
  {
    "email":"deianira.abate@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317563770/55cc0b9682c48583b414038291837ef8-1730301455"
  },
  {
    "email":"basilevaleria@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317694842/dd0ddd169a45449b7a71a16aad9f6703-1730301455"
  },
  {
    "email":"susibarbares@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317760378/e9d67589c03021177f4b4fd2f7e43ff4-1730301456"
  },
  {
    "email":"silvia.mingardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317825914/bd6794e96e5a210f6d34899786fca00c-1730301456"
  },
  {
    "email":"elisa.nardi1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317727610/bfbcd370b338f423bd36e741ab99c8a8-1730301456"
  },
  {
    "email":"ammaggiore63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317956986/b15b8227c6b42680c82853ce833ac81b-1730301456"
  },
  {
    "email":"roberta.picconi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317858682/a83a2c79aa0221c25b39d29195e1808d-1730301456"
  },
  {
    "email":"donatella.spinaci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317924218/27daddef675ced5a88b8e23f52513c65-1730301456"
  },
  {
    "email":"loredanaguardia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723317989754/dd12cf3008e2dd2d5dbcc7d6fc3188f2-1730301456"
  },
  {
    "email":"malexa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318022522/1ded1448113361b2f5c2a1db61b760df-1730301456"
  },
  {
    "email":"r.natalia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723317891450/98b891186868534c52803eea2074f386-1730301456"
  },
  {
    "email":"justcla84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318120826/6686aa3a41928f8f837a6d630258075c-1730301456"
  },
  {
    "email":"federica_mandetta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318219130/67a1f28980d6cee1c9f28b664cdcf80c-1730301456"
  },
  {
    "email":"alex.guendy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318153594/7533c64ed2aa12724b228282c9d359b4-1730301456"
  },
  {
    "email":"racfal@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318251898/82cdbf0d4658033eca36ca0c2683de51-1730301457"
  },
  {
    "email":"elisa.borghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318186362/e5833afbed46d397d4c42738d6b1b248-1730301457"
  },
  {
    "email":"nunzia.torelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318350202/692b1d19dea24f91c4b34ed530595beb-1730301457"
  },
  {
    "email":"joraldamatarangasi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318284666/12f16fdb62a69c75a86d19abcb9a688b-1730301457"
  },
  {
    "email":"lottomargerita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318382970/2b1b3280241fde9c7d71f338b8395503-1730301457"
  },
  {
    "email":"adamoisab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318448506/3378f2d4d98332cf2cd8de528db76155-1730301457"
  },
  {
    "email":"laura.giacomassi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318514042/bcd525adb97ff672f551cede0e664cff-1730301457"
  },
  {
    "email":"giovanna.agnoletto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318415738/4503c2d16475a5561187e31ec09363ce-1730301457"
  },
  {
    "email":"gabriellanoferi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318546810/4dfd5d98f2055794869ee78c53d7ef63-1730301457"
  },
  {
    "email":"fabio.capano.41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318579578/d49d267631540829cb1f3430912979f4-1730301457"
  },
  {
    "email":"massaiandcla@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318710650/4b7eccd5fa24468ab80241a1288b0982-1730301458"
  },
  {
    "email":"luca.perrot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318612346/cb8d8aedee84c37d27be549db67c71d8-1730301458"
  },
  {
    "email":"da.tomasi76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318776186/37b41b8f77873718c46adb262777c475-1730301458"
  },
  {
    "email":"evancc@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318481274/75881ce2fc6e0b1275a1f64d60aa1a51-1730301458"
  },
  {
    "email":"fbelforti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318841722/ff71a26c8014a2a8b43c28fe3ebbe5e4-1730301458"
  },
  {
    "email":"cla.molinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318808954/45d18476f7f84000c3f8af739bc9be0d-1730301458"
  },
  {
    "email":"nadiafrancesconi23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318972794/6b81bf75e6b9fc88e2eeef221ec55db7-1730301458"
  },
  {
    "email":"fabrizia.gandolfo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723318907258/4ebd7bcca663f1123f14d1d60dbfa4fc-1730301458"
  },
  {
    "email":"nathalie1henry@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319005562/2880d316ba0a6e72b24ac8a7b99b6d05-1730301458"
  },
  {
    "email":"ammiraglio01@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723318940026/438a2dcca4d3cb4358715ca747b4501a-1730301458"
  },
  {
    "email":"marinarossi03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319103866/aec79233e9d8692e84319f162540614b-1730301459"
  },
  {
    "email":"chiara.stv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319136634/cc1d358867f06b14a3033586bbacc000-1730301459"
  },
  {
    "email":"saskia.h.wagner@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319267706/07dbc212a86584a1adf66d7c77eda9a8-1730301459"
  },
  {
    "email":"muratori.elena76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319071098/daedd5ed568244eb55e67fc567178737-1730301459"
  },
  {
    "email":"mcm@bellilegalmanagers.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319333242/89a4856d21af902896184513eddd8095-1730301459"
  },
  {
    "email":"fiorella_riboldi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319202170/72901a8a4a7db0e48bc1f58bb5c1cd14-1730301459"
  },
  {
    "email":"anna.grasso@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319398778/42949613121829150fba38f4d32e2f9a-1730301459"
  },
  {
    "email":"cavalli21@interfree.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319431546/c052e872a0d2bbad2aa39d976c1e8450-1730301459"
  },
  {
    "email":"zoccatelli.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319595386/856de10abef80dec91668694bd5a653b-1730301460"
  },
  {
    "email":"beatricesignori@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319529850/88640f70ca83f9db4bdef8293b764365-1730301460"
  },
  {
    "email":"maggianicm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319628154/827625f32db90e33fdf2108557f28267-1730301460"
  },
  {
    "email":"bi.sco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319464314/ba47f8b38ead5ee51140c199fc105e64-1730301460"
  },
  {
    "email":"nunappo@unina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319562618/f1b3a0e642e4b785a791896986708d94-1730301460"
  },
  {
    "email":"mg.meloni98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319726458/a824d63f4eb81034ce6e175c285124a9-1730301460"
  },
  {
    "email":"cristinadipaola3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319693690/f22e6c18388a900313f573b79436d09b-1730301460"
  },
  {
    "email":"angpap@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319660922/70caca0d9977b8807029960cc6b5c294-1730301460"
  },
  {
    "email":"chiocciolina_l@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319791994/fb2acb66cc388d204fbdd95ed3c00a16-1730301460"
  },
  {
    "email":"giorgiavecchiotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319759226/7936627340a32dc3409a91385985b2d0-1730301461"
  },
  {
    "email":"gabriellabuttafoco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319923066/0f5973ed628600f6885e5157b191be6a-1730301461"
  },
  {
    "email":"info@intimolafemme.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723319955834/352f5ddc8b3537026f0b26c1ace37f1a-1730301461"
  },
  {
    "email":"paola_confy83@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320119674/bb97403922c8e6064d388eabbd32d716-1730301461"
  },
  {
    "email":"dellalba.vincenza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319857530/42b5cece79d3f7b941a297789f62cb22-1730301461"
  },
  {
    "email":"dallacqua@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320185210/debabde600e76219ed7a76b5f20ec24f-1730301461"
  },
  {
    "email":"rebecca.graber@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320217978/3ebb9ec379c54f8be220de9da03bf564-1730301461"
  },
  {
    "email":"info@adamopasqualino.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723319988602/0fd9aa1b9096ef428df1d03cdefd99cf-1730301461"
  },
  {
    "email":"leonella75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320152442/e2bfc5ecefdd3b62ad0b3d552d240ba3-1730301462"
  },
  {
    "email":"piccolo.mara2006@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320250746/a0506f126307d4a688fe08baa18e2c6f-1730301462"
  },
  {
    "email":"cinzia.rocchi@unipolsai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320316282/e48802ec66768d8839f205c76fa17e41-1730301462"
  },
  {
    "email":"francisca.tapia@rcs.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320283514/b0eeaa658b327174e36517690aa55aca-1730301462"
  },
  {
    "email":"danielapaganini01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320447354/3886e6d979624cecb4ed5de0a5656b0c-1730301462"
  },
  {
    "email":"lele.dany2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320349050/4ba52321172c52f7cf734c0f8c2c5906-1730301462"
  },
  {
    "email":"luisa.noceroni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320480122/86513165d2c02a7029b33669abed5bee-1730301462"
  },
  {
    "email":"francescariva2002@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320381818/0e40b2d354a8451c294d43608756b792-1730301462"
  },
  {
    "email":"michela.raschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320414586/92b38ce3cf993284dd6bc0b6633a647f-1730301462"
  },
  {
    "email":"francesca@bullmoose.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320611194/41a499f2ad86ff4d7996075e80289142-1730301462"
  },
  {
    "email":"reggimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320643962/4d22456e66890ac38e2dc62bdd34b6d8-1730301463"
  },
  {
    "email":"ebenannei@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320676730/7f3a79388f0cba6d7db7795ec95d0fd7-1730301463"
  },
  {
    "email":"michela.pieraccioli72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320578426/f949e463f42e0e3c5faec57c565fb2a1-1730301463"
  },
  {
    "email":"cguicciardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320775034/ebc6b8fcb3bd42a91373f3b9fe3d92fd-1730301463"
  },
  {
    "email":"cavazzutielena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320873338/ae460b1cee9a9aaf3adf18a2e26702a3-1730301463"
  },
  {
    "email":"mariaiula@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320840570/b4ab89787d72bd43c110f942aa5f1ec5-1730301463"
  },
  {
    "email":"lory.olla@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320709498/e4100fca3b3a85a543c364ff8c7b7603-1730301463"
  },
  {
    "email":"r.laghetto@cartotecnicavittoria.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320938874/a2c812d07ef80e51af361d33ce2090d0-1730301463"
  },
  {
    "email":"longoit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723320906106/2c6fbbc3e4d97304415b7625e62a52d6-1730301464"
  },
  {
    "email":"chesquita86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321037178/6f61d71e0cbd07396f3a63e96a97dcc6-1730301465"
  },
  {
    "email":"saravitale141274@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723320971642/35773f6a892e8869a688f94cf3fc502c-1730301465"
  },
  {
    "email":"francesca.galassi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321135482/2dacb75bd848546ce13e4d3dc4e38404-1730301465"
  },
  {
    "email":"marcy_pizza@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321168250/22f89fb9a48f8f73d32daf879d5bf271-1730301465"
  },
  {
    "email":"sorgentone@sorgentone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321233786/a25f5189ecafad2f921a5a6f2539fcce-1730301465"
  },
  {
    "email":"chiarasegala90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321004410/dbb81ee94af1aa54219a3409ca03b177-1730301465"
  },
  {
    "email":"rosalbacesareo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321266554/433426f519e8a65d20c707b5a45b1bb5-1730301465"
  },
  {
    "email":"aliottaclaudia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321299322/75a43fea7f91bf8996a48a3e1f6818b9-1730301465"
  },
  {
    "email":"digiacomofrancesca@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321364858/e859059d4da055cf096d1973567ed666-1730301466"
  },
  {
    "email":"giulia.fabiani60@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321397626/b6a3f1d3823bb128509dfe40aad17c6f-1730301466"
  },
  {
    "email":"giorgiascarrone1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321332090/1f640c8977eca8003bfec7cf9442586d-1730301466"
  },
  {
    "email":"gabtorrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321201018/267fae37910bdff1cbd55c0a65ac3c4c-1730301466"
  },
  {
    "email":"katia.varano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321430394/7045ffe0240eeafe6855b29dcb17b5a0-1730301466"
  },
  {
    "email":"graziabosco71@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321561466/cb8271ce94c3f49016136d66c05d49eb-1730301466"
  },
  {
    "email":"m.salvaderi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321627002/b5a0f622c1d691061dbdd41a6dfaf17a-1730301466"
  },
  {
    "email":"antonella_pieraccioli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321528698/cb1942b5332ee114d69d96e2e76742c7-1730301466"
  },
  {
    "email":"ksrp@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321725306/d9ec61021fae8a5b3fbf5d1629b56463-1730301466"
  },
  {
    "email":"barbarabell@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321659770/5b71fba0a5c9b844641b618ad498e2d1-1730301466"
  },
  {
    "email":"dott.napoli.tiziana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321692538/18e205a75f1e47fbc86f512ecc067757-1730301466"
  },
  {
    "email":"winfried.moser@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321856378/6aa9384a36cf6ccfdead078d8eb2b43b-1730301467"
  },
  {
    "email":"bonsai88@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321823610/b5ab39d0f099431fa21d39888c4e946b-1730301467"
  },
  {
    "email":"claudiocasali70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723321758074/003403afa24d00dc2ca8f72b8b1a7ec1-1730301467"
  },
  {
    "email":"maddalenazaccaro@zoho.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723321954682/17cc5fecce7d854e72551f358dd26335-1730301467"
  },
  {
    "email":"roberta.forcucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322020218/5a9a53200ea99d63cd9f9e236f6d7a4c-1730301467"
  },
  {
    "email":"rominasoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723321921914/b721a413e07d7ce8d54107f73d58e242-1730301467"
  },
  {
    "email":"bernardisimone84@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723322151290/8c9539c50ab22c1c7e3babd83836fe63-1730301467"
  },
  {
    "email":"rosselladimauro79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322085754/59e1bb8970f64843733dc1455fe28d82-1730301467"
  },
  {
    "email":"carola_sa23@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723322052986/d9b0b8a03001de0d48efaec1ff9e9810-1730301467"
  },
  {
    "email":"luisellabentivoglio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322118522/35ad22b7e50e1545fc4d5b5662686396-1730301468"
  },
  {
    "email":"ioriofefe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322184058/414f5b2baa67d3b9390d162fc0872370-1730301468"
  },
  {
    "email":"spal.guenda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322282362/bab1bbc0e97fdb2c39bc4c596f7783c8-1730301468"
  },
  {
    "email":"tulliabregantini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723322216826/045af3d7a58542415c9d19c9f03d4883-1730301468"
  },
  {
    "email":"francescodamiani2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322347898/702163f2350f4f120ecd6098da78f367-1730301468"
  },
  {
    "email":"silferrari82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322380666/e62d795efd6374fc70d187e6a7a18245-1730301468"
  },
  {
    "email":"ariannaborgotti98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322315130/14ac550e545fa4d97947a91221919df4-1730301468"
  },
  {
    "email":"cassiano.bottallo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723322413434/90cd29dd29f0917eba361b82571fbe01-1730301468"
  },
  {
    "email":"frin.colla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322511738/5e4c707bd57a64759ca03de456be6609-1730301468"
  },
  {
    "email":"simonalia71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322544506/f78285758d836c924d9a034a823e6c2f-1730301468"
  },
  {
    "email":"francesca.gabriele318@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322577274/a4d212c31af641a7c86a154fa08faeb8-1730301469"
  },
  {
    "email":"patrizia6915@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322610042/72566b2b4ad3a68cd96509d3749bddff-1730301469"
  },
  {
    "email":"katerynabogdanova12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322642810/d99acd7b0b9bcd3ae0f511f58ac2c05b-1730301469"
  },
  {
    "email":"davidecremonini55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322708346/45bb27b79ac594cc1c2664db393b4597-1730301469"
  },
  {
    "email":"lisazardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322675578/a95ae4fefec50f9b8a542c3e1de3348e-1730301469"
  },
  {
    "email":"frataniele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322839418/86ae8ff2fbd057e294c4e6a364a11c72-1730301469"
  },
  {
    "email":"lglore10@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322904954/ae0afa96f725f2c8ba7ec7b0060c98e4-1730301469"
  },
  {
    "email":"chaton229@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322872186/791d4d2950939c07c75791ff8fad67ab-1730301469"
  },
  {
    "email":"drlucaditommaso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322937722/ac5b319ae353a8c094e552dacd496f29-1730301469"
  },
  {
    "email":"elenadivincenzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723322806650/ae9bd253f97a53dbfb10924a141f3054-1730301469"
  },
  {
    "email":"adrianotrapanese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323003258/d39fa17542b70d56bd73f86e3219df28-1730301469"
  },
  {
    "email":"fabi-etta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323036026/2ec860301aaa349845d6da134ae03a71-1730301470"
  },
  {
    "email":"veronicabertoni79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323068794/57c954263c340b9de677683ed1803c85-1730301470"
  },
  {
    "email":"loretta.perini2018@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323134330/bdd214c86e6e2a8424d5fe4c76b99886-1730301470"
  },
  {
    "email":"taniascrima@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323167098/218b13b0777ebaaa352c26ddee76fc6d-1730301470"
  },
  {
    "email":"laura.bianchetti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723322970490/df911d4cc0589c9e2ebb55ace83ac4ff-1730301470"
  },
  {
    "email":"moiraspaccapaniccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323101562/34a966a9c68e0d3ced50dcd8ba9c21dc-1730301470"
  },
  {
    "email":"u052038@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323199866/9cd472b7bdb8369d51c05a8339fc28aa-1730301470"
  },
  {
    "email":"mra.delorenzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323232634/cf0d10488843e96d4a47d22837901598-1730301470"
  },
  {
    "email":"soniacirrincione@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323298170/583627e2f212c4985033eb6c96f2653d-1730301470"
  },
  {
    "email":"annalisa.difabio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323265402/dbd01a89a285d00f7f71defa1fb65c36-1730301471"
  },
  {
    "email":"romina.pavinlegno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323363706/ddfd22dbda8c7125ce10bd974528363c-1730301471"
  },
  {
    "email":"clauia.calzati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323527546/140a2af555467d7b0c4b42b6e3f7cf20-1730301471"
  },
  {
    "email":"denise.dolfi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323593082/17212a182a86b6d8dafa28575da8e951-1730301471"
  },
  {
    "email":"amorositagabi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323560314/5f3aaf91b0199f02492e5c60bf2c8ad1-1730301471"
  },
  {
    "email":"ilgirasole2010@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323625850/e74789c34bae84b6df4718906484922e-1730301471"
  },
  {
    "email":"ari1976@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323658618/fad64816700964b7409ff9e5f7a66913-1730301471"
  },
  {
    "email":"novaroc@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323691386/b0fe186a8406dc37cb96e588925ec455-1730301471"
  },
  {
    "email":"l@lla.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323396474/fca56b35e6f446f863f07dae87a88e75-1730301471"
  },
  {
    "email":"robyfavarolo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323724154/89a0d35518425f3ecbe1810f252622b4-1730301471"
  },
  {
    "email":"cinzia_rossi_@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323756922/438921cc5cd630fcd19d9d0578dc59a3-1730301472"
  },
  {
    "email":"chiccanardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323822458/f2487ff8bd472a3bcd94e24f24754699-1730301472"
  },
  {
    "email":"marina@mozzone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323855226/95d3744c553cfed0de934047a5fbb547-1730301472"
  },
  {
    "email":"marabianchini.14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323887994/e7ae92e5ba8d852b56ce688d8c84f66b-1730301472"
  },
  {
    "email":"elimanzoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323920762/795e5f0564a35c07d4e124e8a6b9b8c3-1730301472"
  },
  {
    "email":"valentinacolaiori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723323953530/d57d66d8d150ee7b5afa2b2b990a3588-1730301472"
  },
  {
    "email":"sottomarino6@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723323986298/42738fe014a1b918caa19af134312f8b-1730301472"
  },
  {
    "email":"gattomatto971@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324051834/c3f5ad7f9cf8cb617b9470c4ea8573d7-1730301472"
  },
  {
    "email":"sdominici63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324117370/f1c86ac439e91b17c790ed706be0c765-1730301472"
  },
  {
    "email":"flaviaghilotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324019066/42e56fc2477c55d78100fc8c3712dd79-1730301472"
  },
  {
    "email":"silvia.borghetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324084602/377d7859b4d336c537f822c4585e249e-1730301473"
  },
  {
    "email":"maxdeppa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324215674/2f8594ce3eca703484837f0554d4d55d-1730301473"
  },
  {
    "email":"cinzia.strappaveccia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324346746/9ff79f051ccd182a66e93a23859eb272-1730301473"
  },
  {
    "email":"pennina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324182906/74ea6a970b822e8c87ac10c9c822d585-1730301473"
  },
  {
    "email":"alessandraaliberti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324379514/5171f97fa2e9baebd6b2c8f178d85c88-1730301473"
  },
  {
    "email":"ottorino.p@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324543354/3bbfecdeff19cc9b77d4467439327379-1730301473"
  },
  {
    "email":"anna.favruzzo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324412282/72498e68eb17ea18799efb66e2f36be0-1730301473"
  },
  {
    "email":"valig52@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324576122/411e0d1c1133ab3f0b27154feaed5e07-1730301473"
  },
  {
    "email":"scotti.roberta2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324248442/f5409a1a8f2be07d9802e273a8e74a04-1730301473"
  },
  {
    "email":"tahanimohsen@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324641658/377e906e67ce2465dfc5a1328a24a659-1730301474"
  },
  {
    "email":"flaviomed@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324707194/13675e81d20d6a8aed32ed6c693c348f-1730301474"
  },
  {
    "email":"casalemanu@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324608890/0d3d7960b4e541a52520c733e9a086d1-1730301474"
  },
  {
    "email":"yih.chern@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324805498/7cbbddbccae5579b72475e74f10fa127-1730301474"
  },
  {
    "email":"carolinagirasole63@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324772730/27f598ef87b52eae12e3852d5976fd24-1730301474"
  },
  {
    "email":"simonapiano21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324838266/7092564f7a146ad38dba1d26c9dbf0b9-1730301474"
  },
  {
    "email":"silvia_galeotti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723324871034/8ff7288705c68d089a086f9af54c2bdc-1730301474"
  },
  {
    "email":"eleonora.tamantini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324674426/98cc47cf6f5c0d23eb5e9d3c8c194b79-1730301474"
  },
  {
    "email":"valecipolatg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325034874/d89d335cb16f896da29251880f182a01-1730301474"
  },
  {
    "email":"david.cinti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723324969338/80e1da0be2bc67d434fce70deb6d7203-1730301474"
  },
  {
    "email":"fbilotto80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325165946/49e5a9941bf1ba869b0ded0a7c794b4d-1730301475"
  },
  {
    "email":"luisa.giuliani@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325067642/3febeeedf93cf7cdaa7c5c59301b0b8b-1730301475"
  },
  {
    "email":"daniela.agirelli@studiovegaservizi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325100410/87ede443c3e38a8e40c364107300cfea-1730301475"
  },
  {
    "email":"deangelis.cecilia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325198714/8cd867cf9cfbe6fa279fce82c92b92d7-1730301475"
  },
  {
    "email":"cristinagaio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325264250/ddd5bbb26e297ab29354294a4b16ee55-1730301475"
  },
  {
    "email":"manuelita3001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325297018/2a54b0f5196f4b0cb7d3bdea6cae3ce5-1730301475"
  },
  {
    "email":"domenico.saia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325362554/314a84be4e1d8191cefb03d4cf7ee39d-1730301475"
  },
  {
    "email":"poseranas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325460858/fda6dd46ced23fb6c4990bbe5c1f5ea6-1730301475"
  },
  {
    "email":"milano.parcel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325231482/04b4a23cc34a55ee5e3db3477710f56e-1730301475"
  },
  {
    "email":"sofy.molla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325428090/4301e1f5f65d9d6de8ab6780578cb104-1730301476"
  },
  {
    "email":"barbara.faconti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325395322/b37fe2512256cb1dd4f42b083ded69b7-1730301475"
  },
  {
    "email":"claudiaerbi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325493626/cbec2c214a04980904ae8985da625d92-1730301476"
  },
  {
    "email":"sarix.88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325624698/df2a63cbad411082af91a7ad72d7701e-1730301476"
  },
  {
    "email":"ele.russo1952@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325559162/f50940d9ad59a9bd96aaf32475836063-1730301476"
  },
  {
    "email":"elisa.milani@sap-freelance.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325690234/6c0c5ab278bea68a3a6fbf3682f493c2-1730301476"
  },
  {
    "email":"sandra.cioni77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325657466/e40c7610ab07b838743c2bea7223f9f7-1730301476"
  },
  {
    "email":"chiara.biz26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325526394/90d8a6e128bf13a4b32127a08e5c0b69-1730301476"
  },
  {
    "email":"cla.pisa61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325788538/0bd5478c42c5c843f920a7e8bc64d49a-1730301476"
  },
  {
    "email":"xrita66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325723002/c7005cf495be7e7677918257beb04d2f-1730301476"
  },
  {
    "email":"cecilia.loreto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325886842/dc547ffc4e6d6d15740186006fe509d5-1730301477"
  },
  {
    "email":"s_rosy58@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723325952378/7e9a185ebb62e3ddb91760a7ba854e30-1730301478"
  },
  {
    "email":"giulia.giraldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325919610/760faff28638cea2c9298ef2b7cdc40b-1730301478"
  },
  {
    "email":"ale.galli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326017914/1a6d4426f5049ee7d03a68ca1be8cfc4-1730301478"
  },
  {
    "email":"raffa.marocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326050682/34a5437d4e03a5b0c28b43e9c924552b-1730301478"
  },
  {
    "email":"claudia.ponzio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326116218/f83d0808a896a25d1825af4be0bc9f3a-1730301478"
  },
  {
    "email":"fercam1994@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723325985146/b65dd580a86b9b211196fc22ed263940-1730301478"
  },
  {
    "email":"linda.ruffo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326083450/19a9e35b36a443eabb533507641b41cb-1730301478"
  },
  {
    "email":"chiarazurlo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326181754/3cd9699642d9b2fa13d82d6dbd087003-1730301479"
  },
  {
    "email":"manuela2009@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326214522/22aec4d4baee62fa7c291c6d4d28049e-1730301479"
  },
  {
    "email":"titty.sclero72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326280058/2cde4acd291525e781231dec338d82f8-1730301479"
  },
  {
    "email":"nicolacamer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326247290/21ec73437167de609baa0f997539eb8d-1730301479"
  },
  {
    "email":"moni.casiraghi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326411130/cb6d03e518b45df7a5fcaf482dca6f31-1730301479"
  },
  {
    "email":"mfrace71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326312826/433e1b450eb364327abcbbd577ad2ae7-1730301479"
  },
  {
    "email":"guidomariaguidi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326345594/94b4082de50530e06ae7c077c6bc1028-1730301479"
  },
  {
    "email":"kekkodalzot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326378362/a3782ce9023309df17c6b90dfa129061-1730301479"
  },
  {
    "email":"mail@paolofrega.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326476666/16cec688696cac30e412aeac17076d69-1730301479"
  },
  {
    "email":"monica.moretti1972@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326574970/3434656cf59c99fa52e70097e7de805a-1730301480"
  },
  {
    "email":"barbara.greco71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326640506/5dbe59c424698e3006cbc44359e2afe7-1730301480"
  },
  {
    "email":"vittoriocaiazza46@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326542202/e1f7bc58b2c4a7fcdb006932dfc3c05f-1730301480"
  },
  {
    "email":"lingyun0968@163.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326706042/e8a04737a4572c7d88ee691e27c12483-1730301480"
  },
  {
    "email":"massispola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326509434/d000939a1c2b972f745bf194406c62c5-1730301480"
  },
  {
    "email":"beatrice.mantese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326804346/6646a12dc6d726ed456d1ab16b524006-1730301480"
  },
  {
    "email":"paola.pusterla@laviteria.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326673274/ab67a197d0a2b4d824c37960d198d083-1730301480"
  },
  {
    "email":"puocciangela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326902650/66f6f2ef89bbf444d1a8633561461d5a-1730301480"
  },
  {
    "email":"ieloelisa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723326738810/38eefea7c4777384f4ad3af201102de4-1730301481"
  },
  {
    "email":"willypooh82@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326935418/02840a77b8938543b85ddca5b608e319-1730301481"
  },
  {
    "email":"elisamazzoleni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327000954/7633f70b95388bfd8270a70ad20f09af-1730301481"
  },
  {
    "email":"osa.abaribbi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327033722/5517be82b35e20d2ca8971b8343e9ca0-1730301481"
  },
  {
    "email":"aloigi.valentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723326968186/2b90297874b6ddec6c1fa1eb861e9131-1730301481"
  },
  {
    "email":"melania.merola@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327066490/1559beec6f66ab1faaaaf0946b754098-1730301481"
  },
  {
    "email":"angela.ambrosio77@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723327197562/a6d116ea069c64cdaa5e3b83677822d2-1730301481"
  },
  {
    "email":"dettagliunderwear@pec.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327295866/09bb97431abe91bfd0fd21210d918a0c-1730301481"
  },
  {
    "email":"morgue85@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327230330/81256c508e0ec48083a97975910cdf3e-1730301481"
  },
  {
    "email":"li84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327132026/c8b84f33a6451a2ef53ba46982ed195c-1730301481"
  },
  {
    "email":"bfbonanomi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327328634/dc895dba1b8abd8bede911ce971a7d2b-1730301481"
  },
  {
    "email":"da.pietrunti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327394170/d5cc646c83be60716ce2ee277db57967-1730301482"
  },
  {
    "email":"valeria_bruno@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327361402/e6fbceb4dc764b740f9527402186b5db-1730301482"
  },
  {
    "email":"annalisa.zucca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327459706/f0ff485e19861627020355df89be841d-1730301482"
  },
  {
    "email":"chiaramazzei26@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327525242/6267990f477fdbaf8cc2bcb980bfe6fc-1730301482"
  },
  {
    "email":"bradaschia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327558010/5428ee09c8a412a016f6a1ea3886e897-1730301482"
  },
  {
    "email":"trivisonno.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327590778/4b096cd4fdfa730b3a170c3031a60136-1730301482"
  },
  {
    "email":"b.avi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327689082/a96bf2de1fc9bb12288996e582e492b4-1730301482"
  },
  {
    "email":"cri.bosi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327721850/6174aa832ae8d07d8718c2be1ac8f2e0-1730301482"
  },
  {
    "email":"alessia.muriana@hotmsil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327754618/43a7ca84f344841b94545b19b5652e5b-1730301482"
  },
  {
    "email":"marialuciarosaleuci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327787386/7ab35601495cc3858196f13c94c0939e-1730301482"
  },
  {
    "email":"adrmap@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327820154/f99fafbc82bf81e7f1971844458ad7ff-1730301482"
  },
  {
    "email":"oneiratos2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327885690/23c13c8727ccf98c07b34a721576aeec-1730301483"
  },
  {
    "email":"stefaniapasqualini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723327918458/cb005eb3c557b8e2c3675f26eb8937d5-1730301483"
  },
  {
    "email":"ritasusovsky@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327852922/29969d8b8d36973dd7223705e8c7f55c-1730301483"
  },
  {
    "email":"svetochka-sobina@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723327951226/7601ed5371f6574d5e81f8fa19194ad4-1730301483"
  },
  {
    "email":"giustinis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328016762/cb076243197349e4b699e8b478ec112c-1730301483"
  },
  {
    "email":"gabriella.barocci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328049530/067da8ad290777f90f0235aa2639d899-1730301483"
  },
  {
    "email":"avv.lucarossi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723327983994/92c3ae5d4bbfcb41dda73c89b71b3671-1730301483"
  },
  {
    "email":"300470@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328115066/6dfd1cca7691e5c7704b654d00c8ef69-1730301483"
  },
  {
    "email":"simona_vig@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328180602/5ec23eac9cb1d51a86821b09149fe66a-1730301483"
  },
  {
    "email":"cris_cris1990@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328147834/32885264c5928e3601f108540c7e9150-1730301483"
  },
  {
    "email":"simona.dicerbo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328213370/0adef4473ea163ccba141477bf24a326-1730301484"
  },
  {
    "email":"valentinabettin.legale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328082298/e103cc7554a25c91b3f5bbfb6b68d3ae-1730301484"
  },
  {
    "email":"caterinatarlazzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328377210/b1de10be588c5d016fb4bb8893d04c91-1730301484"
  },
  {
    "email":"ariannaritascuderi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328246138/63103f12c02decb9256184f2716fa094-1730301484"
  },
  {
    "email":"tarquini.monica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328442746/3a80325084573f1b26cbddf70e23153b-1730301484"
  },
  {
    "email":"donatella.bazzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328508282/68aab301399956f544974228f5919a2c-1730301484"
  },
  {
    "email":"donnicisalvatore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328573818/367adfd59eebc09b439842037a28c88c-1730301484"
  },
  {
    "email":"elisabettaina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328541050/27779c1c589beeac9310fb33f51548d1-1730301484"
  },
  {
    "email":"merendifrancesca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328606586/f26d5c6bcf765b1ebc6187da0e26b42f-1730301484"
  },
  {
    "email":"debora0908@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328639354/621e5cf6b3c0359628028af36944ed7a-1730301484"
  },
  {
    "email":"lazzarolara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328672122/6d14b9ccfe05de67561a621a59dd4245-1730301484"
  },
  {
    "email":"pierpaolo.bordoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328704890/74057499a3ecff47d515100c9c399385-1730301484"
  },
  {
    "email":"raffa.cola62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328803194/989a0349b28291067da8fcf7aaa7fa82-1730301485"
  },
  {
    "email":"mari.raciti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328770426/8364c997302957d9dc37f0e873f06e80-1730301485"
  },
  {
    "email":"mpoddigue@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328868730/055a076b0ca05321f67d1ff84a36de04-1730301485"
  },
  {
    "email":"francescadefazio1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328901498/ee1d9eef70613886400e78af677bd1e4-1730301485"
  },
  {
    "email":"e.mugnai@gestigroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328835962/77aecd4e4de67da52057937f1bf16de2-1730301485"
  },
  {
    "email":"mariateresa.genchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328967034/7d811111f2894885e140e24895207ee6-1730301485"
  },
  {
    "email":"elena.bozzetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723328999802/2c58a67c07a25b68f8d89c01979d36c2-1730301485"
  },
  {
    "email":"monim@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329032570/c746784ba7079212c619738a2a72c9d5-1730301485"
  },
  {
    "email":"puly19694@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723328934266/e0457c75ee87c50e43dd467dc22bdbbb-1730301485"
  },
  {
    "email":"lallavivi23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329065338/b4c4c8ffe8312d30c24e95665822b148-1730301485"
  },
  {
    "email":"bresciani.claudia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329098106/c48f80e29425f82b02f99c53d96ab327-1730301486"
  },
  {
    "email":"alessandracalcaterra@alice.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329163642/1d05c58f2b484d4110700c3ca2e03962-1730301486"
  },
  {
    "email":"regina.turci88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329196410/775e97123578c686f763b7bd4fae2e2f-1730301486"
  },
  {
    "email":"nicoletta.mugnai@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329229178/1ced705dfe2b58e6ad01f8472569e5b2-1730301486"
  },
  {
    "email":"emanuela.catapano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329261946/f808a88ad1c6b76be1b1e7252bd8c199-1730301486"
  },
  {
    "email":"casalebelforte@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329360250/c01649f313dc9150077ae9f5b336f6e3-1730301486"
  },
  {
    "email":"antoneferr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329327482/914e69ca3e56c7fd096f6311861be80b-1730301486"
  },
  {
    "email":"ilenia.marafante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329491322/b1f4042361122f1ff4de8458b75fd3f9-1730301486"
  },
  {
    "email":"florentinaradu71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329589626/3b3ede104d0e18166c9187d58062d01b-1730301486"
  },
  {
    "email":"roberta.verlicchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329524090/1d197b5083201e5551e69b4dc15f0f3c-1730301486"
  },
  {
    "email":"mariadee@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329393018/6f891d62c91f0516179cdd7f86b5a415-1730301486"
  },
  {
    "email":"madia.simeone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329622394/35f370311439574249bbbb2c5fdbf1a8-1730301487"
  },
  {
    "email":"lisoantonella2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329655162/de96e1700fcb5b312736528b040ee14d-1730301487"
  },
  {
    "email":"ritasia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723329884538/032b8547e460fc3191a030eceef8e3f4-1730301487"
  },
  {
    "email":"aleghirardelli01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329917306/f85e77733dc7e0bbc5265787454d24f0-1730301487"
  },
  {
    "email":"b.brighel@brighel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329982842/954222414779b94986e61ac142e1da3f-1730301487"
  },
  {
    "email":"barbaracocchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723329687930/356d431eae36cd4ae241a73091a2a4ae-1730301487"
  },
  {
    "email":"carlottabati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330048378/746ad74075c71f3f8d5f11c71acd4792-1730301487"
  },
  {
    "email":"vzmarina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330015610/5d5c5388c3772bc517d08e46f136c2a4-1730301487"
  },
  {
    "email":"giangi_tennis@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330081146/7156b523154139e6792382241e982f9f-1730301487"
  },
  {
    "email":"antonella.previdi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330179450/0818018a579db19ca4c2c7bbd79e0bb9-1730301487"
  },
  {
    "email":"luciacole@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330212218/cb5c59c995d5b167c09d380716011427-1730301488"
  },
  {
    "email":"claudialughi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330244986/3fefd75c79289daac257ca56a92d1be7-1730301488"
  },
  {
    "email":"katedemmy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330113914/700506ff659046146eea31a37b2d6e69-1730301488"
  },
  {
    "email":"eleonora.foglio83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330277754/02af36e4c4af24738080cba3012c23df-1730301488"
  },
  {
    "email":"susannamarcocci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330310522/7daaade2f4a079fb5547d63be0a76902-1730301488"
  },
  {
    "email":"dony86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330343290/4f71861ab11101b17862d36df4a0c87a-1730301488"
  },
  {
    "email":"piasentin.lisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330376058/9825ed2d0725264ba41792403a32d725-1730301488"
  },
  {
    "email":"enzamirra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330441594/50c29cc1ddd764080ce4b169645d8f0d-1730301488"
  },
  {
    "email":"thomas.deguio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330539898/ea83c77496214231ea6bc310fc1d3582-1730301488"
  },
  {
    "email":"lidiagasparetto1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330474362/a150a55b331bc9ddce379cde2ffb4efb-1730301488"
  },
  {
    "email":"scalvini.elisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330572666/7f279d923ff355e27d61ceb5450902ea-1730301488"
  },
  {
    "email":"angiolamem@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330638202/beca1853eb27ca61d34f1922f47df190-1730301488"
  },
  {
    "email":"monicamidena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330703738/f65c1637f29ac14bed4787a710580412-1730301488"
  },
  {
    "email":"sorrentifra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330834810/82bbb060f4ea9c24ad73572a6815e692-1730301489"
  },
  {
    "email":"wiese24@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330736506/42cb07dd9496763d8562ba47b122a31d-1730301489"
  },
  {
    "email":"riccardokriscjak@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330802042/dec26a04cbbbd158c9070b37d0c733bc-1730301489"
  },
  {
    "email":"annadelucia7@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330867578/662e7cddb2fbfd43d685a046c26bc8a2-1730301489"
  },
  {
    "email":"valericci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330769274/e6a08d00ab5a7d864bcc57c4b478db98-1730301489"
  },
  {
    "email":"cribyte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330965882/98d7dca4b518870d227fbdfaa2f600cc-1730301489"
  },
  {
    "email":"mailaeuropa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331031418/07160ef7e12d1073a5866354086a7b7e-1730301489"
  },
  {
    "email":"nadiabianco@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723330900346/192a859f7cc4acde01c6edfb4d6a7440-1730301489"
  },
  {
    "email":"eleonorabigagli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723330998650/8c10df510b6305ea5166ac2b4d05734b-1730301490"
  },
  {
    "email":"betta.bertalot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331162490/38337ab5179862fb7ae76f7b30979317-1730301491"
  },
  {
    "email":"filippiele82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331096954/85a147bb49838715765b2928640f8798-1730301491"
  },
  {
    "email":"sheila_beatty@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331195258/49bde9ec9628e6bc6a94250db3e66eff-1730301491"
  },
  {
    "email":"evalogreco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331064186/8fc0ca02eb6ba759c9b160e5eb377694-1730301491"
  },
  {
    "email":"lorellaghiberti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331228026/23a334e70e13d703c560ce4cee5ceb79-1730301491"
  },
  {
    "email":"lungacoda1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331260794/e41d7019e598e6f4a746d82257631009-1730301491"
  },
  {
    "email":"papispapis81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331326330/1c0382702b7b69016cb717a548e4bc1c-1730301492"
  },
  {
    "email":"marcomila8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331391866/1ae8ec977d0780cf83c59ad07b5d7e4b-1730301492"
  },
  {
    "email":"vilma.poloniato@studiobordin.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331359098/f38010a9f7c9ebeef5ba000cfcb84a22-1730301492"
  },
  {
    "email":"claretta29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331424634/ac05984db33d48db91fad8c1b8c1bbf3-1730301492"
  },
  {
    "email":"jisander@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331293562/1903d22ace2901993f41fed0fb443629-1730301492"
  },
  {
    "email":"fontana.f81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331490170/a5169c2562da7df7e1c00e399e25060e-1730301492"
  },
  {
    "email":"alba.belloli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331457402/73eebbe3773fecb73c1b321252d6f0cf-1730301492"
  },
  {
    "email":"bozzoliluciana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331522938/3f03365a7dd575f9b1ab1d4470e2f3ee-1730301492"
  },
  {
    "email":"pinzia23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331621242/5efa5c3b78752e26ff99c68213af1ae2-1730301492"
  },
  {
    "email":"letiziamancuso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331555706/45754936090db3fd68500af8811c6890-1730301492"
  },
  {
    "email":"patrizia.cima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331654010/66a5fc203ae391ced57047345f0a731a-1730301493"
  },
  {
    "email":"paolarosanova@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331686778/162f732dbec1d8c25b40ebdb34dfc128-1730301493"
  },
  {
    "email":"chiara.nobile78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331588474/53f70fd8ce835347368c6ff1a796a911-1730301493"
  },
  {
    "email":"giuliachiarini93@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331719546/a3776fbee637a18c06dacb92af391b6b-1730301493"
  },
  {
    "email":"valeria.carrara@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331850618/7fd6cb41cb918cd1c38199c6b9612446-1730301493"
  },
  {
    "email":"valentina.cercone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331785082/2f10116098c5157629968e1977352bd8-1730301493"
  },
  {
    "email":"elypepe83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331817850/eaea590d2a4e591c9ff5e55b32f8eb25-1730301493"
  },
  {
    "email":"f_franca@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723331883386/489a86486bf73003086f31cf62e48fbb-1730301493"
  },
  {
    "email":"sara7s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723331948922/f878df28b7ecfc162115547d7abb3e3a-1730301493"
  },
  {
    "email":"valbonabuna@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332079994/2316fd9ad4e71d5d6826a38ff307e441-1730301493"
  },
  {
    "email":"giobuti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332112762/dfb2db1d160f35c6f0bf1f4945f95fdd-1730301493"
  },
  {
    "email":"m.martina82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332211066/b451cd43a444e6acd808de057ac8b8d9-1730301494"
  },
  {
    "email":"scrignoli.micol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332145530/af971ac7e114dc5cdb6c8174d77ec1b8-1730301494"
  },
  {
    "email":"cristina.casucci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332243834/b24e29e9b19e1c80bae4fb6164cf5618-1730301494"
  },
  {
    "email":"serena.serinelli@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332276602/6131ae7579ec88ce246e8d7f7ad79f3f-1730301494"
  },
  {
    "email":"claudia_ravaglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332047226/7ffb39f7e71fbd78c61caef789ae3245-1730301494"
  },
  {
    "email":"karmencomparetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332374906/061a10bc3856b5588f68e32f78b12ede-1730301494"
  },
  {
    "email":"pita_72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332440442/fbf32c1ddd939880df32f816e0dddfda-1730301494"
  },
  {
    "email":"cinzia.zanotti60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332505978/e49262c5e2a737c86f0a74af04f2c93a-1730301494"
  },
  {
    "email":"epascali393@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332571514/5e6759c42497797634a067971ccd1242-1730301495"
  },
  {
    "email":"angelina.bagnoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332473210/bfe9b98996ad25a153bc16046e650f64-1730301495"
  },
  {
    "email":"alessandro.conti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332637050/85088bf4143d812b07e61ffa12842312-1730301495"
  },
  {
    "email":"n.dileonardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332407674/d498b520f35676deabea6e49a51a5078-1730301495"
  },
  {
    "email":"chiarachiti5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332604282/ce444ff05f5bddc9129da70d8e70040e-1730301495"
  },
  {
    "email":"sbardella.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332669818/2544589879def4ed89c0b7b522033b98-1730301495"
  },
  {
    "email":"gabriella.laratro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332735354/d957e7a15770f6e9d21be1acef3bb8a0-1730301495"
  },
  {
    "email":"cristina.pellegrini80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332768122/88e805e8404c1350ba9d50dda2fcf85b-1730301495"
  },
  {
    "email":"rominadream@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332702586/83f5542a363c6d74a6c67ea03fe455ac-1730301496"
  },
  {
    "email":"giulites@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332833658/951e1f4c51488f6e8bb4318fc0a1e257-1730301496"
  },
  {
    "email":"petrucci.raffaella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332899194/a1d06db7a34d73547ca1d9947e486164-1730301496"
  },
  {
    "email":"massimo.rxo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723332931962/c25de5b75dd1bf1277c0ddfdcedff8b9-1730301496"
  },
  {
    "email":"giuliamonducci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332866426/686d8a2781f8948003d9c4b37d28f16d-1730301496"
  },
  {
    "email":"marta.mari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333063034/134c3056f7afafc3009549657e1a3500-1730301496"
  },
  {
    "email":"smonteleone578@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333030266/11c5d8a9a6099918c91de648dd7943f9-1730301496"
  },
  {
    "email":"lauretta.1991@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723332964730/35b5d3b3cc51f8afc6f5c4cc3150fc22-1730301496"
  },
  {
    "email":"lilly.marotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333095802/826c41ef10cf369839175badfeba5332-1730301496"
  },
  {
    "email":"rossella841@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333194106/3f2e3fcd6f9e6043fa8a54224c4b8ce7-1730301496"
  },
  {
    "email":"ilariatigli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333226874/f9a647b76f05d438600d4cbdc620e482-1730301496"
  },
  {
    "email":"felimarco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333259642/d74ee1027d6d036ec0e85aadd5b8d025-1730301496"
  },
  {
    "email":"annafrancesca.scolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333161338/e23e07363f6b39b6c72e8348135687ec-1730301497"
  },
  {
    "email":"paolomelotto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333325178/41e14d7fe3cd8ba938a7bed45053a350-1730301497"
  },
  {
    "email":"titti237@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333390714/e94c0da30cc2b91f94f50d9b7fc970c2-1730301497"
  },
  {
    "email":"valerica.maris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333357946/348d022c5bc9ec8b41079123279cdc54-1730301497"
  },
  {
    "email":"chiaragiannibio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333489018/d1d9983fac55e9fc7c0007f2fbb2550b-1730301497"
  },
  {
    "email":"monicabonifazi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333456250/dd17a4b1ec9c09caeb77ef0db806e54e-1730301497"
  },
  {
    "email":"guerrinisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333521786/8cd99988f71000979084062c43d4fef9-1730301497"
  },
  {
    "email":"mimii369@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333423482/865a0c9b8961f5953c8860ceddca770e-1730301497"
  },
  {
    "email":"amministrazione@cmstudio.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723333587322/e09681666a0635182b309fd5c40bdc94-1730301497"
  },
  {
    "email":"barbararossi76@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333652858/637018f6cd1357d9f83bff5cccaa51b5-1730301497"
  },
  {
    "email":"elena.svri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333554554/8af3ec8564e49d2b266e4035d7fe7384-1730301498"
  },
  {
    "email":"rosalba.vitrano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333685626/20b7d0e244310d2f640366f641d056da-1730301498"
  },
  {
    "email":"facoetti4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333620090/28f7976ad196de81c5e7b24036cac2d2-1730301498"
  },
  {
    "email":"elipoh@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333751162/940c1e283829142175e8850c6193e7af-1730301498"
  },
  {
    "email":"nicolvib@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333718394/042ec95769d2bdf46a3470fc7cd3bf52-1730301498"
  },
  {
    "email":"silviasca85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333783930/f5d300dc539c1a9e4ee9dcaddecec9ac-1730301498"
  },
  {
    "email":"niccolo.bagnai@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333849466/0d1b39e691aad50690b1bd0e5c937636-1730301498"
  },
  {
    "email":"ilarialottini@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333882234/df790b7302f6a6a42860b974f966a20e-1730301498"
  },
  {
    "email":"anna@studiodallera.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333947770/99c779c5c3789fb92c27cf4833e0d2e6-1730301498"
  },
  {
    "email":"vinpan91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723333915002/1a42f8b7dfb289c363780cf34d5572d0-1730301498"
  },
  {
    "email":"rossella3@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723333980538/fec98e72110091db5a56b07baa42604a-1730301498"
  },
  {
    "email":"aurorapohar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334013306/42473628ea61b69a784cefe728d9ad6a-1730301499"
  },
  {
    "email":"alessia.77d@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334078842/ca4a4bdc40a4b2d50deaaa8c205b86a2-1730301499"
  },
  {
    "email":"gallifera@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334046074/0f4c95ad2a5ada9102fac177e93cff57-1730301499"
  },
  {
    "email":"taende@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334177146/a5e62b6e265e261f7d47381955daa653-1730301499"
  },
  {
    "email":"silviascapin@aim.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334242682/f38724313d6b922aaf6166e2a13422c7-1730301499"
  },
  {
    "email":"irenepcat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334111610/907e4ce7620c58e1bac89144d5a62b98-1730301499"
  },
  {
    "email":"daniela.zelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334373754/e59c8dd2dcc39c96e3f596c70c0e09bb-1730301499"
  },
  {
    "email":"l.muggioli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334275450/4d86a4064e42eee85f9560279c5c24bb-1730301499"
  },
  {
    "email":"valentina.righini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334209914/16d1dedb6414a4ce181d0dd21e0d9585-1730301499"
  },
  {
    "email":"laura81ls@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334406522/d22008153edb01a2122e5719bf4f79f4-1730301500"
  },
  {
    "email":"lorena_deluca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334472058/7667a180166e8a9a99e72b2815ed50d1-1730301500"
  },
  {
    "email":"samanthamarchesin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334504826/81310375d4a4a3b9a7be672eed7df03b-1730301500"
  },
  {
    "email":"damiano.valsecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334439290/719629529efc3d68efa61e2e864dfb88-1730301500"
  },
  {
    "email":"miche.mazzei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334603130/dd9c8b973dde6ab0bcc0a202bf2d619d-1730301500"
  },
  {
    "email":"michaela.neumair@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334570362/f11a083a688a46371700c94ea0f5c261-1730301500"
  },
  {
    "email":"littidecarli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334668666/1fc1b611f041117553f7b2eccc557be5-1730301500"
  },
  {
    "email":"lauramuzio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334799738/803208cc4672999ad26137083ac36b1f-1730301500"
  },
  {
    "email":"marziadevecchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723334832506/c106415ea05c650db3e9aa1d9dd32d4d-1730301501"
  },
  {
    "email":"niccolonnelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334701434/e4563b364f0fa4f1641c59c26b226fdf-1730301501"
  },
  {
    "email":"morlaccomarika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334930810/f289a4a104235ca335b437430682479c-1730301501"
  },
  {
    "email":"robi.tateo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334963578/b90ef7c6cf8a2c5635ae8095c1e3298f-1730301501"
  },
  {
    "email":"aleszap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723334996346/68c609b6336f1f77f1c0d13f24015f0a-1730301501"
  },
  {
    "email":"ferrigabriele@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335061882/8e9c15410e99a183034c15976171d1c0-1730301501"
  },
  {
    "email":"paolabiaggioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335029114/297a8e5be6c89a7fc76a1385137efc54-1730301501"
  },
  {
    "email":"rosannamon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335094650/20927e2b83b0907e2b545499aa95d45e-1730301501"
  },
  {
    "email":"pieramaganapane@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335160186/e02df79028d75a06e75e438ac2d58b8e-1730301501"
  },
  {
    "email":"dora.abbigliamento@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335127418/1855a970d6d542fe6456e82d3eab5013-1730301501"
  },
  {
    "email":"simonabeduschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335225722/fb101e899f7ce1d4c4db8f6582beba54-1730301501"
  },
  {
    "email":"info@sorrentorivoli.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335258490/0fe5a668bf7cac3eab95269b28b95cbb-1730301502"
  },
  {
    "email":"cantafiograzia@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335356794/f5c8879f3c8a2a8b1f521992e78470d6-1730301502"
  },
  {
    "email":"ilaria.vicini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335389562/397a98c69864efb744cb10d3a091e771-1730301502"
  },
  {
    "email":"giovanna_perrina@it.ibm.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335291258/d81bc94c8568b66e77ea54219ec175f0-1730301502"
  },
  {
    "email":"camigio.cg@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335422330/686a49abd387e991b484b96767f1ef13-1730301502"
  },
  {
    "email":"eleonora.montaruli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335487866/e601e47a1a45a44249f60ee0b5239bdd-1730301502"
  },
  {
    "email":"c.ferrara2@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335553402/3ccd0ceb1043794a0d292e1b225d5c64-1730301502"
  },
  {
    "email":"durbanokids@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335618938/776965496c9a4680378e98ee03179cbc-1730301502"
  },
  {
    "email":"marina.dimarino@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335586170/68c5c66d12f59395212a91b6081dcae0-1730301502"
  },
  {
    "email":"elianatoscani73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335651706/bcda2133cfc54c2f675250f2a22b2b63-1730301502"
  },
  {
    "email":"mesimo77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335520634/ed841eb136ea15ba36a49b44fa0c26db-1730301503"
  },
  {
    "email":"info@opticus-taufers.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335782778/83d94b7feb85e550c5a30a82c955a747-1730301503"
  },
  {
    "email":"amalia75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335717242/a7ec5f5e975d05fb6c8b800f196b0dba-1730301503"
  },
  {
    "email":"zordanmaurizio58@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335815546/d5a149680a82329f6a8b7f1ae2c2f3f8-1730301503"
  },
  {
    "email":"marziapadoan@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335750010/ab0ea3fe0b47287369d29b47214d6662-1730301503"
  },
  {
    "email":"nadata@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723335881082/64d78f2f7832b41e664945f29f3c163d-1730301503"
  },
  {
    "email":"silvia.seccafieno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335979386/0cbbc83ef42cde7569c04112cdf5e7ec-1730301503"
  },
  {
    "email":"stefania.accarisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335946618/20f48e0eb37ddb93ae2fe2c90ca17fd5-1730301503"
  },
  {
    "email":"jampyg.photo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723335913850/8b55e944867cacbea013929a7cb13025-1730301504"
  },
  {
    "email":"patrizia.andreoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336077690/7ec2314e3e23d4d9f62cffde0191e7d5-1730301505"
  },
  {
    "email":"sonia.toninelli@green-car.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336143226/5b73d564875c974e3a2016176450e44d-1730301505"
  },
  {
    "email":"mobuttarelli@ccdp.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336208762/4f558b0777b9a64cd2ab814740a12721-1730301505"
  },
  {
    "email":"angelaschisano86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336110458/99770e27fb5dbd4016eb8dacdb4127ae-1730301505"
  },
  {
    "email":"elena.licci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336044922/75070344a7519750fb78bef8ce78e311-1730301505"
  },
  {
    "email":"trizzya@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336175994/d059f4037dec6b724ab35ce45ad7a361-1730301505"
  },
  {
    "email":"casteldemilli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336307066/4a1e1726524637eb877bbedc6817d384-1730301506"
  },
  {
    "email":"dinella@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336241530/fba937b23599735da5703036411a0b8e-1730301506"
  },
  {
    "email":"lisasara12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336274298/92b31d940ebe0689f165579dc8e6fd3a-1730301506"
  },
  {
    "email":"elisa.brogi1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336339834/8df04ff1e76a903fa4596632eb2c5004-1730301506"
  },
  {
    "email":"marianna.capo@unina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336405370/191e29562c40932793fb5a9b9315cd95-1730301506"
  },
  {
    "email":"cencherlegiada@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336470906/f3d13091dd03ad0c11e2d5464f43752a-1730301506"
  },
  {
    "email":"gaiettapiai@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336372602/1b436acd5828d7c80761f1725fc632c7-1730301506"
  },
  {
    "email":"lazziespilli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336438138/bd1b3f461c85118e74533575ab3e0edc-1730301506"
  },
  {
    "email":"luca.giachetti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336536442/eca5eef2fd44301a6a8583fd1dc024b2-1730301506"
  },
  {
    "email":"mauramastria5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336667514/b8de771807695c85cedb4af47061b9b1-1730301507"
  },
  {
    "email":"giovanna.varavallo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336634746/eb034e0aacc67dc2055985c611538228-1730301507"
  },
  {
    "email":"raffaellapeschechera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336569210/caba103637e8370751a597f06710bfd6-1730301507"
  },
  {
    "email":"tait.gio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336700282/ae4b3c61e583c8f014f6a7f9e0caa41b-1730301507"
  },
  {
    "email":"marie-jeanne@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336733050/3d1dd3c2c59c4f82b3221e44a67cc56b-1730301507"
  },
  {
    "email":"andrea.fantinati74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336765818/ae9d00157a014091798f06d4cd24ca83-1730301507"
  },
  {
    "email":"glomare7210@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336831354/43018445e453bda0faa261593e39cc94-1730301507"
  },
  {
    "email":"fede6757@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336962426/d360c25bbf441f6297ba74e40e9f5cf5-1730301507"
  },
  {
    "email":"taniadelmonte77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336798586/f79df8c8e1222ac70482dfa5a97052f7-1730301507"
  },
  {
    "email":"disc123@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336896890/d6f989cf693e6d784a8e7e0f4e7392cd-1730301507"
  },
  {
    "email":"troyan.anna84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723336864122/19f29a673bde8052f966ed7dc392243a-1730301507"
  },
  {
    "email":"sunika@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723336995194/d7afaa99927a279f3e4c8bf151a63585-1730301508"
  },
  {
    "email":"smarcol73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337027962/57d0e657ddfb1c6cf36d946ba290f0d0-1730301508"
  },
  {
    "email":"margherita70.anselmi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337060730/a2b75df953de5370025ed7cb3c0a6efd-1730301508"
  },
  {
    "email":"mailafederico81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337191802/f196ae495e36881b8960ffa6c5b9c190-1730301508"
  },
  {
    "email":"mpapadopoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337290106/e3d581564d00a9e44045e2481176e497-1730301508"
  },
  {
    "email":"adriana.altobelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337224570/9bfb217ba9bcd6f309617912bb8c9ec4-1730301508"
  },
  {
    "email":"lecasediromi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337355642/223b81fdbca91dd39f0e6c1816486ead-1730301508"
  },
  {
    "email":"erika_lancini@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337421178/cab07394b047fb577ce70380a17981d4-1730301508"
  },
  {
    "email":"laurasgaravizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337486714/d7578ad8e9632671dc7bc0f418d8df74-1730301508"
  },
  {
    "email":"cancuen@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337552250/e8a9195d054ba7a67daa0ca4cbf4be35-1730301508"
  },
  {
    "email":"deborahbrandoli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337519482/a8f3143d83c979b536cdc05adff974d1-1730301508"
  },
  {
    "email":"maddi37@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337617786/1f1211134c3be45cad5157d8f030f1a5-1730301508"
  },
  {
    "email":"serenabattaglia@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337650554/4ff247d57795fd78aa6d03964e98538d-1730301508"
  },
  {
    "email":"geramato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337683322/533208fbeffc4df43bed7b4964d0a95e-1730301509"
  },
  {
    "email":"eva.gardin82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337716090/57f9304b3f2803b4289b259d447f8a19-1730301509"
  },
  {
    "email":"tmqmil@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337781626/1bb42c0ccfc6e30bfa0d019fc2fbffbf-1730301509"
  },
  {
    "email":"noro.ornella@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337814394/6cce0a7599239a953ef621da5d00e663-1730301509"
  },
  {
    "email":"martissima84@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337912698/a8f5ac67ebc90f2170cdf4a17505a3b9-1730301509"
  },
  {
    "email":"caranunzia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723337879930/7e61170960f4e05067f1a00874c9a2c9-1730301509"
  },
  {
    "email":"masini.donatella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337945466/e2f06217f6ef35414f54a8367ac97257-1730301509"
  },
  {
    "email":"stefania.tozzola@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723337978234/66e6b8893d11e6c9dbf22ba32ccf5787-1730301509"
  },
  {
    "email":"cendypat60@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338011002/7583365b8b5ef2266a1561224526d7b2-1730301509"
  },
  {
    "email":"cendypat60@uahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338207610/17c005d6fa029ff39487ed048abad08e-1730301509"
  },
  {
    "email":"giulia.sudzinko@sanmarcobioenergie.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338240378/933002cdfa4f4f57d9bdc588234af78d-1730301510"
  },
  {
    "email":"maura.morini@manara.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723338043770/64b96235aca751da236590f40efecbdc-1730301510"
  },
  {
    "email":"saxfamilypesaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338174842/246eb8274a501e89d146a30b0b33d6bd-1730301510"
  },
  {
    "email":"saratozza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338404218/562b1755878b4e217072c4970496f4bd-1730301510"
  },
  {
    "email":"monika.egger@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723338436986/dffcb7735f9fc6d59397f7ae138d4aba-1730301510"
  },
  {
    "email":"mariagiulia11@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338338682/8035e0a048df0c61f362a831ec421f48-1730301510"
  },
  {
    "email":"robby-s73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338469754/482dcc918c543077a586dfcef6a71779-1730301510"
  },
  {
    "email":"calimero76.da@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338502522/406613976917ed601b9aa910ee7ef652-1730301510"
  },
  {
    "email":"ilaria252000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338371450/53482a91f2033f6d9f267c10bc37a308-1730301511"
  },
  {
    "email":"parasassi23@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338600826/af774054200a71f14cb8d7b65ea4c044-1730301511"
  },
  {
    "email":"terragnolipaola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338568058/0d8af8d1eef32d48d5551fd0366ed5e6-1730301511"
  },
  {
    "email":"luciana.santagati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338699130/d571cc1dc413a303be947ef33b42b67b-1730301511"
  },
  {
    "email":"lucygiordano77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338633594/bdb6b0afcf309f2b4abeb55269f05d5d-1730301511"
  },
  {
    "email":"iampul@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338666362/ce1f95d9eedcc14c9d9f6ee529956570-1730301511"
  },
  {
    "email":"manugregis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338535290/5f2676b15260ea28d712b8b277c7a19d-1730301511"
  },
  {
    "email":"paoladesinano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338797434/2044a0be4b9372290e266bced298898a-1730301511"
  },
  {
    "email":"mariateresa.cenni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338764666/0451e83e97a81dd0b4a5ce3dc3c788d1-1730301511"
  },
  {
    "email":"manuela@studiogibertoni.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338731898/45b7393cd54fd104e7f618b7f074b1d3-1730301511"
  },
  {
    "email":"mistica.fabi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338928506/bd5f74a892bb9f5fd3fde18158492c4e-1730301512"
  },
  {
    "email":"giusi.convertini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338895738/07e8377db5cbdd23e8e9820ea4800ebe-1730301512"
  },
  {
    "email":"raffaellacestari72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338830202/cd26953b9a6eb65cb76f5e0c089c4787-1730301512"
  },
  {
    "email":"giusi.convertini@verificaspa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723338961274/730753076f094cb1413058a7e20fd469-1730301512"
  },
  {
    "email":"erika.vinciguerra@hpe.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723338862970/ba67b065a6a5c7d6633b2ec84a1a03bb-1730301512"
  },
  {
    "email":"e.bonvini79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339092346/552746c261e03ff4e959f58f777f59f0-1730301512"
  },
  {
    "email":"francesca.mafucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339157882/af189c1e5a6deccfe38dfabb4878f3fc-1730301512"
  },
  {
    "email":"silvia.fornea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339059578/ebf663caca4520b2934fb9eeed739a54-1730301512"
  },
  {
    "email":"barsanadela@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339125114/feabc3fbde94fc85712f865f1619ffcf-1730301512"
  },
  {
    "email":"massimo.porcu-1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339190650/d579625c7b479ec34366c160eae63109-1730301512"
  },
  {
    "email":"luciamaoloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339223418/a5e01a623949787f200af643f334f376-1730301512"
  },
  {
    "email":"marilopi13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339321722/f9a5ecea3357d2c696f4c9566237bcb0-1730301513"
  },
  {
    "email":"vlaino03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339354490/672b4ec9612f3b3ff15df72676c7aa20-1730301513"
  },
  {
    "email":"anna-mancinelli2011@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339288954/c260782b459297ff83494c0189e487a1-1730301513"
  },
  {
    "email":"donatella.pulcini.dp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339387258/28c8aa6090cee2a43355e6845a950522-1730301513"
  },
  {
    "email":"spinardisaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339256186/13c7a3cd96b5219146b956b882bcce18-1730301513"
  },
  {
    "email":"michytorella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339420026/6a6636755f16bdfe4b15cd8b5d23e404-1730301513"
  },
  {
    "email":"modellatosilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339452794/e750f716a1e81dda878ed6bce7eb95f8-1730301513"
  },
  {
    "email":"grillogroupsrls@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339485562/b3920c7fc408f00ce29bc3a45c926ee5-1730301513"
  },
  {
    "email":"fabiopontillo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339682170/250811dbf5ceae92bd5f5c4cb5f55512-1730301513"
  },
  {
    "email":"infvery@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339583866/7b47916397de271c16e9ce353f69beff-1730301513"
  },
  {
    "email":"annarosgiu@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339846010/6bd47f5fe0bec143fd48c603d9810fa4-1730301514"
  },
  {
    "email":"monicamatani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339780474/7deaf7f7a09dd83d955165d103c06c96-1730301514"
  },
  {
    "email":"ela1976@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339714938/076a2b31d03e484fc397790676bc3e0b-1730301514"
  },
  {
    "email":"vinco@vincoasti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339747706/f804b4970f7b53346d0f510e521768dc-1730301514"
  },
  {
    "email":"moreno.ceccherini@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339977082/c7365d23a2044371710cabf90f6d7bfe-1730301514"
  },
  {
    "email":"ivana.giganti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723339911546/e050fc82b18cd921ab10b58c3cf565ea-1730301514"
  },
  {
    "email":"ilaria.davanzo@luxuryfashion.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723339878778/8c5a2852de4f4f9473929b6a0f68da41-1730301514"
  },
  {
    "email":"harei88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340108154/2002a31576c128a28d773545257acbea-1730301514"
  },
  {
    "email":"adelesofia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340075386/02a29f5000b5011f76e6a58d084494e2-1730301514"
  },
  {
    "email":"beasalvetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340239226/27fa3ab0836c4ca54a8eba4187efb4a2-1730301515"
  },
  {
    "email":"vanygrillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340206458/b4900d74c8c9681b5eb7848fc0100c2c-1730301515"
  },
  {
    "email":"lucamarcella17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340140922/f412740274cf5176cbfb26fde402977f-1730301515"
  },
  {
    "email":"amaliagori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340403066/9e5d1fb52acec0e91f51344b78b73f00-1730301515"
  },
  {
    "email":"giumajeans@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340435834/a226cff158fd59acaea6b899b6cec518-1730301515"
  },
  {
    "email":"elitac5@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340534138/100e51a477f14c8568559d6ab098299b-1730301515"
  },
  {
    "email":"andina.michela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340468602/efcaa45b4e9cc575918ff179e19e702c-1730301515"
  },
  {
    "email":"emisavoca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340566906/445639d8c683cd6b1c4fabe634ac129b-1730301515"
  },
  {
    "email":"barbara.cenedella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340501370/ea8c631137c6652d87de42ce8b3338e3-1730301515"
  },
  {
    "email":"cgiuntelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340599674/32da2aa0a320881aade341dced9a5b8e-1730301515"
  },
  {
    "email":"candolo.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340730746/4eacb7f35f234d138864d30e1b6c7063-1730301516"
  },
  {
    "email":"ale.sandramonti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340697978/f72fd402a82557be8dffb5e65fd081ec-1730301516"
  },
  {
    "email":"cacciagiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340632442/cdaea1fbf1653d101488381d39fd78cb-1730301516"
  },
  {
    "email":"annalisa.sponticcia@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340665210/3f7f4458df61fc15d99ad1c5e5ea5556-1730301516"
  },
  {
    "email":"luisita.canovi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340861818/5fff7d34d9fae4a6b58b021466125d41-1730301516"
  },
  {
    "email":"ibashukulli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723340927354/0a026dfb828f15b7cfa93df18bd0bcbd-1730301516"
  },
  {
    "email":"grazia.novelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340763514/ca420136ebb1971faffc8b2456b1a5be-1730301516"
  },
  {
    "email":"robisgandurra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340992890/20464400425393288c2fa9126c5ee1da-1730301516"
  },
  {
    "email":"patrizia@tezzaautotrasporti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341025658/dffc35bff8452b78f9ee63e70b975043-1730301517"
  },
  {
    "email":"rossella1983@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341058426/044932e1b583e805dee52736f62dcbba-1730301517"
  },
  {
    "email":"alidacristofani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723340960122/04da108d79750b0ccc5dcfd2eed8d2f6-1730301517"
  },
  {
    "email":"margherita.massoli@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341091194/88eacad7203bb20936da49f2600d2922-1730301517"
  },
  {
    "email":"cri.neri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341123962/db6f32cfeed0827e5dbfbae620816a47-1730301517"
  },
  {
    "email":"benedetta.caletti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341156730/e8e414d67d4dbcd7c4d2482fd16498c0-1730301517"
  },
  {
    "email":"algierisusana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341189498/862982b740b6a6d86cc371e53d57306b-1730301517"
  },
  {
    "email":"roberta.pirola71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341255034/186b65a585bd8b302a4d14924636df7a-1730301519"
  },
  {
    "email":"sara.lucano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341353338/f29bac3984593e73600ba801bd51d448-1730301519"
  },
  {
    "email":"frarom85@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341320570/9d4ee22f177cb5f0612e44d84c891681-1730301519"
  },
  {
    "email":"troduledda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341418874/095e2f23a673b453ea61c343d80d6ad4-1730301519"
  },
  {
    "email":"silvia.re.70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341287802/65385b99ad5a77f2326b7b3ac3b5612c-1730301519"
  },
  {
    "email":"mp.monicapretto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341386106/c153ea8af8d07b6c528393ba292c0cd9-1730301519"
  },
  {
    "email":"lorenzafumagalli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341549946/f66454790bdb75782aeb07c95a255d6b-1730301519"
  },
  {
    "email":"sabrina.schiavon.tv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341582714/c39e255632c76dee195ce4ad888e1763-1730301520"
  },
  {
    "email":"malandrinoadriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341517178/87274c631dad0ed2a3cdd8a971136a4c-1730301519"
  },
  {
    "email":"carol_cc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341615482/8b28cd73a5442719c5fcbf8751c15ee3-1730301520"
  },
  {
    "email":"didi270@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341648250/17e64dfed2110c3b8e23c710df4c46ae-1730301520"
  },
  {
    "email":"aniaba@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341681018/c4e094716cf91f6d567c7fc203894699-1730301520"
  },
  {
    "email":"monicacosta00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723341746554/8fc1cb65f1fbe96fc77ea90dfc97cc6a-1730301520"
  },
  {
    "email":"farmaciadellasalute@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341844858/b6a80ab404085613848be84f546f525e-1730301520"
  },
  {
    "email":"m.tiziano72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341713786/1bde611c2d7751f935fd3068b1bc242f-1730301520"
  },
  {
    "email":"clegnanicaai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341812090/20c6a0f9f22fa0e753bbf7655bb11832-1730301520"
  },
  {
    "email":"ilaria343@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341877626/03e826241d5181fefd1e5f8460de6ee9-1730301520"
  },
  {
    "email":"silviafornara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341975930/6e86958fee6845091b1ef3917e354616-1730301520"
  },
  {
    "email":"fastrunner111@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342008698/0b78d0c4dd5f6d4e21c84aafe6debda2-1730301521"
  },
  {
    "email":"lbartalozzi@mb36.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342041466/709e133e9730670196e61f1975efc020-1730301521"
  },
  {
    "email":"simonamazzanti2017@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341910394/add3a8ed2e386daf889c4039644136e3-1730301521"
  },
  {
    "email":"giulconte@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723341943162/06a35f30f8a11c2a6532caab0f3f15f4-1730301521"
  },
  {
    "email":"patrizia.vaccino@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342074234/24c16b6f128a71726921036bab66a14e-1730301521"
  },
  {
    "email":"alessia.aiselli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342205306/d1ff3f66f9916bbab2b83b60fa9f80df-1730301521"
  },
  {
    "email":"bianchini.serena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342107002/e5442959727be40e56cc1ef76708e2bb-1730301521"
  },
  {
    "email":"elena.baschieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342238074/01bb39289ba54ec17ce3132f0acdfda9-1730301521"
  },
  {
    "email":"s.santarelli.ss@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342270842/972c83a805ea2ba439da9a0cdbb34c8e-1730301521"
  },
  {
    "email":"monica.corradini28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342303610/3b6b8ad5106d2e34b1d971145d1c13f0-1730301521"
  },
  {
    "email":"cestari.s@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342336378/5298b41168c167caa22641d8efba3600-1730301521"
  },
  {
    "email":"lolatin.ll@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342434682/fe6ee6468efbcf87b038328f7978c86d-1730301521"
  },
  {
    "email":"violante.v@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342467450/cfbd690649f702193decf0a0172ae39c-1730301522"
  },
  {
    "email":"mavi.gaitan@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342500218/1825d98113c360be3fddf62208a01aba-1730301522"
  },
  {
    "email":"paola.bistulfi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342532986/7d901795c1204bafa9e60eb332f5608c-1730301522"
  },
  {
    "email":"cremaluca72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342369146/da647f5065aca1e6f7ce63f90169b392-1730301522"
  },
  {
    "email":"vero.niky@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342598522/75819a618b8f794ff3164a38a7560335-1730301522"
  },
  {
    "email":"ilenia.albanese98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342565754/98a3196093abe7aa83983248585f69d5-1730301522"
  },
  {
    "email":"francesca_faccini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342827898/96b16e4668894fc79a325d58c09c458e-1730301522"
  },
  {
    "email":"cuordileone987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342860666/1f1172953f941130b847da93f11431dc-1730301522"
  },
  {
    "email":"giovanna109@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342664058/f919e3129503e8589ef4ea5e5047976e-1730301522"
  },
  {
    "email":"rosi.ceci@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342631290/bcf1c266a4823d531b0eac232e9bbad5-1730301522"
  },
  {
    "email":"katbor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723342991738/7874d3ed24596312125e230f82706c3e-1730301523"
  },
  {
    "email":"kandia67@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342893434/250675c9de681a8fac9d7fbd48c3adad-1730301523"
  },
  {
    "email":"natasciamennini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723342926202/14b7a4171335ed276ad4ff6b325161e4-1730301523"
  },
  {
    "email":"daniela.nicolini973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343090042/b2405b7c03f0fa29af3bfad2e9ba0da4-1730301523"
  },
  {
    "email":"ines.castellari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343122810/d1dc91ad49b94145c1423bbd3c5118ce-1730301523"
  },
  {
    "email":"stefano-margutti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343188346/36f31477c04b16b2cb81848e74938cb4-1730301523"
  },
  {
    "email":"francescacastaldo2628@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343155578/de21f53f42b6a64665c0571b54235383-1730301523"
  },
  {
    "email":"carmencamerlengo7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343253882/83dea7c2e105cc4224c9b56867de592e-1730301523"
  },
  {
    "email":"elisabeth.forer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343221114/56903e642fa397111ebb31a9bce57f01-1730301523"
  },
  {
    "email":"laugia260796@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343286650/3b4783314a54e794f29a101feaf3dd35-1730301524"
  },
  {
    "email":"simona@patteracostruzioni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343417722/463050f88f984cecfa7dded5e432056d-1730301524"
  },
  {
    "email":"marti110477@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343352186/7c5893655db0ece048f572447057ec0d-1730301524"
  },
  {
    "email":"eleonora.carminati2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343483258/96a10a31dddec49f0e78a63dc9dc6d58-1730301524"
  },
  {
    "email":"xodosilvia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343450490/1617fcf89e004385c83fb024c086924e-1730301524"
  },
  {
    "email":"giovy.jeans@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343548794/1386d2ba0144f47b37588e3dd84001d0-1730301524"
  },
  {
    "email":"sandra.rinaldo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343516026/58a8ce31d9fea02ae609d3c6e28f0315-1730301525"
  },
  {
    "email":"caterinamonti72@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343647098/4f73a0f4264773b4749a8ea283cdaa1b-1730301525"
  },
  {
    "email":"sabrinatraetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343614330/fe029e12798fd2479ca93237e7816ca4-1730301525"
  },
  {
    "email":"ilariao1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343679866/171cff8add6f2f876bd382873f3a35ae-1730301525"
  },
  {
    "email":"azzurra66142@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343581562/377751d51a8d50f4665898e1aec5ad8c-1730301525"
  },
  {
    "email":"elisagranger@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343712634/0e22b9c5beab0ebef9944421677f07b2-1730301525"
  },
  {
    "email":"arcangeli.p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343745402/6271a8989de8665af7050a702d64d1ef-1730301525"
  },
  {
    "email":"ely_ale80@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723343843706/2dcdd47560e81d64076e70bc57a57ad2-1730301525"
  },
  {
    "email":"aleferrari72@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343876474/92c6b58c28fd00028c49f9bcaa88f65c-1730301525"
  },
  {
    "email":"rosanna.gilardoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343909242/adba861ff38639d46247cc47ed9024c8-1730301525"
  },
  {
    "email":"ferraro.d@selmi-group.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343778170/bc0788192be33ef87b464388874a581a-1730301525"
  },
  {
    "email":"dire.straits@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344007546/68d2ac50ca0f66173061b44fd8ee5a70-1730301526"
  },
  {
    "email":"francesca.capotorti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343942010/d7ac66b2e12bb10e198abf5f0a69fd9a-1730301526"
  },
  {
    "email":"graziagermani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344105850/dd16e0f1eade8272a2bfdbd9385f6397-1730301526"
  },
  {
    "email":"marcodanilo.e@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344040314/2d5cf20070c8a3ebd388563f6ad0e744-1730301526"
  },
  {
    "email":"laura_mosca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344138618/1040d7b2002bcdf31b9669a79f697b5e-1730301526"
  },
  {
    "email":"prmail@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723343974778/652d28bfc04525fbb20020eee5cc22c1-1730301526"
  },
  {
    "email":"evamaria.hey@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344073082/867029c2fe9ef9d84de004e2d6988517-1730301526"
  },
  {
    "email":"angelarossi326@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344204154/570210c53c4c95d4a72d613f768781d1-1730301527"
  },
  {
    "email":"delseppiaines@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344236922/0e92fa6badba295300550621dafd8d12-1730301527"
  },
  {
    "email":"vi.molteni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344269690/5d3fa10cf863839e72f8e33374c6b835-1730301527"
  },
  {
    "email":"emilimaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344335226/da02baacfcdd9482bad3b0c5dc088534-1730301527"
  },
  {
    "email":"meryciampoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344400762/cbb1e5bc7dbf201581c7abc64d4529dc-1730301527"
  },
  {
    "email":"cinzia.bassoli@innova1872.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344171386/06f89696a5b68489614a980f6e91001e-1730301527"
  },
  {
    "email":"s.biavati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344433530/ced912d626b4bce9b91190dfffac0f5b-1730301527"
  },
  {
    "email":"ilaila22@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344531834/773f1a591decdd997e0d65f5f2da27e3-1730301527"
  },
  {
    "email":"viceconte.mariateresa5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344499066/b3cc31eb3e05422d1c23ad9e3bf7a5eb-1730301527"
  },
  {
    "email":"fastrunner000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344466298/b78356e4a0477a2d6e869648f09e3a19-1730301528"
  },
  {
    "email":"rizzetto.sofia@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"cbacchin@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344597370/2e3b318e295c30d316c2cb1aa25a48cf-1730301527"
  },
  {
    "email":"barbara.baffoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344662906/1b4d8fe145548fbf2a8674e0206d1b84-1730301528"
  },
  {
    "email":"alessandrarossi@finross.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344761210/82332992bb06d7a572fa8ab34bafc078-1730301528"
  },
  {
    "email":"luanapallanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723344695674/606baa9a6cb087ea94243964d0132224-1730301528"
  },
  {
    "email":"dejuli-giovanni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344892282/31dfe7df527ffc8c5785b12132409eec-1730301528"
  },
  {
    "email":"lauraguinasso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344826746/59e8d451bfd1e6d12bba8e447576e8c5-1730301528"
  },
  {
    "email":"cristina_ranaldi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344925050/788bc2a8c8fcc157fbb037414bbf9e3a-1730301528"
  },
  {
    "email":"teresa.speciale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344793978/294533239221c8c75cbbd8d8a5299b1f-1730301528"
  },
  {
    "email":"anzianix@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345056122/4432b274c3bbfb3ce5d3cf21b08e9354-1730301529"
  },
  {
    "email":"ceccatelli@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345121658/7d0e477e7ea5f21ec0871e34cf02119b-1730301529"
  },
  {
    "email":"fraste@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344990586/c00af70e902fa58cdfc37dec26df6114-1730301529"
  },
  {
    "email":"silviama79@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345088890/bba67f253e82818e8433881fb089e377-1730301529"
  },
  {
    "email":"dddlandi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723344957818/e585b25cd0915a073e51edacddb50cdd-1730301529"
  },
  {
    "email":"angela.borile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345187194/08c2b3eaaac795cd7cdf6aea1586b54c-1730301529"
  },
  {
    "email":"silvia67@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345252730/57150b47c76914dd18af0064e8aa5f93-1730301529"
  },
  {
    "email":"erica.cantaroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345219962/d2aeb434a1f7b0693a6347e15e85b68e-1730301529"
  },
  {
    "email":"gonariadina.spacocci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345285498/eb61602fd6cf9c33f7599f525b62cba9-1730301529"
  },
  {
    "email":"vale.gallo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345351034/855d9f239884ebcf8b0810b6e561c59a-1730301529"
  },
  {
    "email":"artico-luca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345383802/42aa298c796ce42ef9ffd03e2699cc5c-1730301530"
  },
  {
    "email":"martacosta1105@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345416570/6d3462cdd795c659411c4182aa8c55d0-1730301530"
  },
  {
    "email":"sama2@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345449338/8b5d13fc4400a3e2ccde4d1c6f0cb6a5-1730301530"
  },
  {
    "email":"tamboneantonella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345482106/3b7e3a1d79c12282dfff06df1d64a3d4-1730301530"
  },
  {
    "email":"eubucci89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345613178/c0fe7ad73c007ec32aaa7796df51cae0-1730301530"
  },
  {
    "email":"ferraris.morena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345711482/1090dabd8f983a317f8b464d05725a34-1730301530"
  },
  {
    "email":"jsssrabbit@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345514874/c8acd99ca8cac40e73bddbdaa16f68a9-1730301530"
  },
  {
    "email":"lory.olla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345645946/ff6c4d7d1c65673facefd86bd2b7dcfe-1730301530"
  },
  {
    "email":"papagnilia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345744250/6382d8d1f35bafa87bf213de2b3b91eb-1730301530"
  },
  {
    "email":"chiara.mondini71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345875322/4c435accbdac85f06bd45233790fd5af-1730301530"
  },
  {
    "email":"glamourbyveronica@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345809786/74ba58f551a7a100188f4351e2d94f33-1730301530"
  },
  {
    "email":"nghezzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345908090/8ddbaab10de86c252a03b2c1b87994fa-1730301531"
  },
  {
    "email":"silvia.panesiti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723345777018/297ad6b37b60e2e522f00e16c1446eb1-1730301531"
  },
  {
    "email":"valeria_garelli@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345973626/135a826ddc1ce32c502b8b28272b4b9b-1730301531"
  },
  {
    "email":"pamy.p@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723345940858/027c64585f0de43921a44a0e8f130d1c-1730301531"
  },
  {
    "email":"consiglialanza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346006394/8961444b7e7b394461c26ea09c5a4b97-1730301531"
  },
  {
    "email":"elisagastaldi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346039162/cc32395aa13a2498cc10b1afcdf8c31f-1730301531"
  },
  {
    "email":"celestina.bongiovanni18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346071930/afe53acb5b28f33b6801f224a4ea9f53-1730301531"
  },
  {
    "email":"manuela.grattoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346104698/0c992016e343e2cea4eb7999911b2439-1730301531"
  },
  {
    "email":"sandra_zannetti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346235770/cf8470f053745bcf26559644cf7e1ec1-1730301532"
  },
  {
    "email":"me.pacifici@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346170234/b936d96bf7b80b58f60acd8b6286ea5c-1730301532"
  },
  {
    "email":"luciana.colli43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346268538/b1b092102daad100020f37fc2f2f1206-1730301532"
  },
  {
    "email":"tpuggioni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346301306/c5fb5e82720059b39a5bad2980b8f3b7-1730301534"
  },
  {
    "email":"parkolor@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346399610/530f63b8f9a7ddb4e1eefab5c9a80881-1730301534"
  },
  {
    "email":"monicadesideri70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346432378/a794bbaf2b2fafa6d7dd01a5f0dacaa2-1730301534"
  },
  {
    "email":"michele.svanosio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346366842/b3e7ce67c3afbaf502d595b9ba7b0aec-1730301534"
  },
  {
    "email":"patriciapisano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346530682/65660b02ae38c2eaee168bb6308ba4ea-1730301534"
  },
  {
    "email":"reformhaus.lia.losi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346465146/8a697a04e9d7e81545e890349b632a1d-1730301534"
  },
  {
    "email":"loryyyyy88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346497914/1907ac35bd1e451160882d81d82f51d7-1730301534"
  },
  {
    "email":"rosalba.canistro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346596218/7324380e5939a97ad37b44c91d16286f-1730301535"
  },
  {
    "email":"licia.smalci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346628986/3b644b01dad9f1e9e100c0d0cd0f1f8c-1730301535"
  },
  {
    "email":"bherdova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346563450/b9690a587a8ba11a4aaa0f6f59f838b3-1730301535"
  },
  {
    "email":"mimmo.lapenns@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346661754/dd27b86fd43c700f26e002506a8593df-1730301535"
  },
  {
    "email":"saragrassi.fi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346792826/81f5aac9c3707be029b15d18f3e587cb-1730301535"
  },
  {
    "email":"clelia.gessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346760058/b64561fc8f0ebfff8a2b2ecfd395daf3-1730301535"
  },
  {
    "email":"silvia.bazzini01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346694522/9956eb7c882fa1dcffc5c2f10d139421-1730301535"
  },
  {
    "email":"katiaemassy06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346825594/e9a85793b552297c4dc3a9f0f7833d4d-1730301535"
  },
  {
    "email":"giovaena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346891130/82b2bfd9a989522b65bf40a9efd9abf3-1730301535"
  },
  {
    "email":"alfredosinopoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346923898/bf911783bd8be88b0b5c5d0c2254c254-1730301536"
  },
  {
    "email":"fulvia.tosetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346858362/7308426e6c89435661c7158ce5bc1bbe-1730301536"
  },
  {
    "email":"sabrinaredolfitezzat@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723346989434/1d941f3ec091e9435c92952dd616d327-1730301536"
  },
  {
    "email":"lallaconc89@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723346956666/b6cd1bf4358e9d1419e9e0ca42db7b64-1730301536"
  },
  {
    "email":"westillcanfindaaway@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347022202/1ad8fb8befce7fd412141da19b61240c-1730301536"
  },
  {
    "email":"nella.giorgio2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347054970/50e7872f989052983da75977479a0ac4-1730301536"
  },
  {
    "email":"emiliozziriccarda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347087738/c9b7f5b8371d3ae527cdac8d7c859d8e-1730301536"
  },
  {
    "email":"criss.setzu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347153274/f85cc635b8ba16bdffcd7a410f58b5f3-1730301536"
  },
  {
    "email":"elisa75tesoriero@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347120506/f059e28b68bc43d9897a218bf149f0de-1730301536"
  },
  {
    "email":"caterina0908@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347186042/a6ad8e5907de62642e12ea4f247bbbe4-1730301536"
  },
  {
    "email":"severini.barbara72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347251578/b04c40a4b0cc2d506617a281497bc3b8-1730301536"
  },
  {
    "email":"ginetute68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347317114/1f350a9cc72179893861a97447832878-1730301536"
  },
  {
    "email":"nina.voric@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347284346/891e50f3e60d8fa5804f6ce905c36afd-1730301536"
  },
  {
    "email":"gabry84.s@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347382650/3f5219210044e27271131eecd9193468-1730301537"
  },
  {
    "email":"cristina.pavin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347415418/3484d3428317cc6234e5053155bf76eb-1730301537"
  },
  {
    "email":"simonaroselli73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347448186/c9a2bd8e2a1cdaa3fa8c98b71bd6de88-1730301537"
  },
  {
    "email":"info@borgoetneo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347349882/849806a4ac904e5160b7b1dc153a6d30-1730301537"
  },
  {
    "email":"casazannin@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347513722/cffbb677e636e626a262c2174bc80c83-1730301537"
  },
  {
    "email":"daniela.delserra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347546490/169d1559f7e10471d6f175e5b8eaad0b-1730301537"
  },
  {
    "email":"fratellidiego@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347612026/7d7078eb859ad1042bd3e193414b86f5-1730301537"
  },
  {
    "email":"marcolaura.h@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347579258/f626c49bc52921e50631cf2a6f0cd5fe-1730301537"
  },
  {
    "email":"alessandra.tubiolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347644794/12ca35c0b42b8eaad33473ad6add86a3-1730301537"
  },
  {
    "email":"ilaria.moroncini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347677562/95a293a527d1d86012e01ca1facd33a7-1730301537"
  },
  {
    "email":"maila.severini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347710330/2bf0523b7b5bd8cbbdcba96ba14e87d5-1730301537"
  },
  {
    "email":"elisa.darra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347743098/483695f9583cdeb13a5afd431fcbf53d-1730301537"
  },
  {
    "email":"emanzati@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347775866/70ac2cd5bbd384758b8a243716545361-1730301538"
  },
  {
    "email":"lidiamaialettilm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347808634/17a77646f555a40828223c3ef8303f07-1730301538"
  },
  {
    "email":"info@patteracostruzioni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723347906938/f6714a3cdd9988dce60f7ae273fbdff4-1730301538"
  },
  {
    "email":"dallagrassa.ari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723347972474/65851438c310a3d843d9751dcd3a3fad-1730301538"
  },
  {
    "email":"giuliacomisso2504@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348038010/b3b04e3ec4808e5034606adc77868876-1730301538"
  },
  {
    "email":"euforia.novara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348070778/8530d222b71d6932fa4f368b2b2e8d30-1730301538"
  },
  {
    "email":"marisa.baricalla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348169082/daff9ff7b7b11f189c6ef325d26fe30b-1730301538"
  },
  {
    "email":"soniadonati73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348201850/d2c5d098daeda2e33045f0cd0f0aa02c-1730301538"
  },
  {
    "email":"fra_gra88@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348136314/cec93df10057b84cdfb119199c9529e4-1730301538"
  },
  {
    "email":"danicogni77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348234618/19ead9bd0be798b846f2f9560cb47182-1730301538"
  },
  {
    "email":"vmarini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348300154/5eaec8e27c815b94af7af202685600b4-1730301538"
  },
  {
    "email":"maria.masuzzo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348332922/114ef62dc965e7d0a86b64371430d9d9-1730301538"
  },
  {
    "email":"alessiacorini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348431226/bc93e77add5dfaaf9ddf7b9179908521-1730301539"
  },
  {
    "email":"fgiusti@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348496762/c2831a7f19b546fdcf0693245da907dc-1730301539"
  },
  {
    "email":"angelo.mela66@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348365690/d6d26dce40e345ad5a14b506e29f7bbd-1730301539"
  },
  {
    "email":"gio70.vn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348529530/22ed2ae8fb75b6c3fd4f6718fa5d456c-1730301539"
  },
  {
    "email":"giugre77g@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348595066/d90e3a3777b57c0a4fadd659ce9699ba-1730301539"
  },
  {
    "email":"peterlenadia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348463994/4cf8cd8a038b54fe282ff755ba0ac268-1730301539"
  },
  {
    "email":"fabianafrancia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348660602/09393d056f1a44a80b3508ed65facd41-1730301539"
  },
  {
    "email":"k_maghe@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348693370/7dc12e5475197941d1aa0ddc169ea998-1730301539"
  },
  {
    "email":"elisabetta.sbraci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348758906/6ad56b61f8017c11c44dc59b964d8297-1730301539"
  },
  {
    "email":"cinziamartinelli1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348726138/5237b512dae1d7aff77a19d5e8d627bb-1730301539"
  },
  {
    "email":"vascotortelli@icloud.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348824442/b51c430c7492e1e8c2e9ee313f96d283-1730301539"
  },
  {
    "email":"edilromana_2004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348857210/1f4cbf0231a75fa5cdfa250c10a78033-1730301540"
  },
  {
    "email":"veronica.toia.78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348889978/901c3bbf139b9a9e5e1be231faefcbac-1730301540"
  },
  {
    "email":"salemariaelena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348955514/712e04eb2897ee75d06d7e563c42b3b2-1730301540"
  },
  {
    "email":"studiodforno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723348791674/2ae26fd691a1dc83b5fe477e5cfcd527-1730301540"
  },
  {
    "email":"stefania.corsini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349021050/614c61968c217d4b7ef6cf3b8171df88-1730301540"
  },
  {
    "email":"danielamaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723348988282/b495e4d19d900cb117d863509ac22d0f-1730301540"
  },
  {
    "email":"federicacesio8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349086586/0b3f8d12b6b0f76a548a60abca4fbedd-1730301540"
  },
  {
    "email":"nahiannacecilia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349184890/4d1d29b823340ef82873ca1114f9a1af-1730301540"
  },
  {
    "email":"rosaliagarbujo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349250426/8591c5ac632656e1a0ab74399081004d-1730301540"
  },
  {
    "email":"giusi.livigni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349152122/008af0c65e6037539d6240d7bbcf0179-1730301540"
  },
  {
    "email":"cristina@arredamentipanciroli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349283194/cde1427df50fb979ad27f87612ee28e7-1730301540"
  },
  {
    "email":"anna@studiolegaleponzio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349381498/a5cfc62616e94ddbb213dbd718fe0ef8-1730301541"
  },
  {
    "email":"s.ebner@icon.bz.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349315962/a9c916250a47236056bf4f52ea5bad02-1730301541"
  },
  {
    "email":"max_marchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349348730/366d9133eefab0c7fd130c7ceee24970-1730301541"
  },
  {
    "email":"virgilioemilia.1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349545338/05527ece39f6279a84385ccf0b8cf627-1730301541"
  },
  {
    "email":"irene.assini@tirrenopower.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349512570/a7950275db98410d17acc7745bec3cb0-1730301541"
  },
  {
    "email":"vitto.benelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349447034/fb0047ccd9b7943753ca057f4b18078f-1730301541"
  },
  {
    "email":"slistrani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349578106/2b505e59f9dfb0f834775be8968aa01e-1730301541"
  },
  {
    "email":"experience78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349610874/90c56ee6bfe35a325de0c0861522ac0c-1730301541"
  },
  {
    "email":"margheritasantini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349643642/1a0d085100b6c61b6bce5ba8f21db24b-1730301541"
  },
  {
    "email":"spinning2@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349479802/c6544a7a97f96d3efec97896b7ecaacb-1730301541"
  },
  {
    "email":"pacio.1993@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349709178/50005b45bbd1e3b9acc668c1d94b5f7a-1730301542"
  },
  {
    "email":"choppinannapaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349774714/90b4662beef6d5f8513f0a09822f70c7-1730301542"
  },
  {
    "email":"valentinaconti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723349807482/499912a926ef11511ba945a268a97742-1730301542"
  },
  {
    "email":"cynzia_nardiello@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349840250/4734488790892f89cc94b8c6a2832e27-1730301542"
  },
  {
    "email":"flavia.groppo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349676410/3277c88e54e1097d7409870b8ff1ccc7-1730301542"
  },
  {
    "email":"sara.ragazzi81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349873018/7d44b7e515307bd34f42b838799ab5b5-1730301542"
  },
  {
    "email":"maggioreroberta66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349938554/e54c519d792a03f0707473f146388f21-1730301542"
  },
  {
    "email":"simona.cucinella71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723349971322/0e873893b716da40f607306ee757a1c6-1730301542"
  },
  {
    "email":"tiziana.bernucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350102394/5dffeaa2bcbb02db7e8811f9c54753fb-1730301542"
  },
  {
    "email":"tralli.elisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350036858/fbc055dbcdb7f37e6b745a9d995793b9-1730301542"
  },
  {
    "email":"katiapisani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350004090/5c69e5e81f70a05521ac12cab9037f57-1730301542"
  },
  {
    "email":"clara.zane@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350069626/a12989cf8f4184977b0df4ccc6ab410e-1730301542"
  },
  {
    "email":"saracosentino79@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350200698/6207abf49f2e6a31105f68f7f3f6fc65-1730301543"
  },
  {
    "email":"a.ambrosio@therocks.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350135162/3bb163fcb4ea4b190b2b3afb5edfc6d9-1730301543"
  },
  {
    "email":"christina.mancini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350167930/0de514fbb72f35c28cbc9687925a6c25-1730301543"
  },
  {
    "email":"elenacoldani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350299002/5f978b9efeb2be09bcf295cdf8e36870-1730301543"
  },
  {
    "email":"f.sperlecchi@soremaferroviaria.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350364538/c09a7cf22539ff99b50dc723b2150b87-1730301543"
  },
  {
    "email":"beatricefracassini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350430074/07996be5a5ea59a59cf9535a66993176-1730301543"
  },
  {
    "email":"andrea-betti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350397306/cb9eb3f7ea1d6da665b517bfe66f802a-1730301543"
  },
  {
    "email":"kimstone77@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350462842/b6708aa929ab525b0764a14579ee0044-1730301543"
  },
  {
    "email":"tina.giannetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350528378/ac5735bc1c9af55f8b0ab2a707ce8f83-1730301543"
  },
  {
    "email":"danylanza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350495610/edbd741d917e9fbf70ec318682780377-1730301543"
  },
  {
    "email":"homebarbara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350561146/9db14178cd2ff6b44f5db48e46a99b1f-1730301543"
  },
  {
    "email":"federica_barbagallo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350593914/461727c5208617a8232ef5549c0df8b9-1730301543"
  },
  {
    "email":"gabriellapidal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350692218/02f25e886256c33eb389603104ead4fd-1730301544"
  },
  {
    "email":"rosa.claretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350626682/1683ef2da042b52ed7813d64f86059ae-1730301544"
  },
  {
    "email":"alejadipietro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723350856058/b98b2740e95cfc7179bcef48c3b0ae24-1730301544"
  },
  {
    "email":"grapeggiamichela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350790522/649055c63f41742cc1d6a83a57fdf18c-1730301544"
  },
  {
    "email":"lisadelsarto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350921594/19ec76baf27131a95f0465050f58baed-1730301544"
  },
  {
    "email":"info@ecomec.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350954362/a39d51bcdde5bb44f8cc9061c05c44b0-1730301544"
  },
  {
    "email":"roma.praga@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351019898/692155a52ff3bd0f3a23e349cf0f829c-1730301544"
  },
  {
    "email":"noemina17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351118202/99dcfc510969e7eadf12f016eea59c59-1730301544"
  },
  {
    "email":"perrybeby@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351150970/e1e86573135bbc65a8179313c97a4a07-1730301544"
  },
  {
    "email":"lauraannunziata@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351183738/7946f0b8dc4b5ed45cfbc4c1bf24cead-1730301544"
  },
  {
    "email":"stefani_sm@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723350987130/602a8d8b424be8d4c3c4003fee7137d6-1730301545"
  },
  {
    "email":"francescadellapina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351314810/13e72ad52e17fdfc746094772f3e62b9-1730301547"
  },
  {
    "email":"charlingpunk@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351282042/da586e1063563a1614397d8ebc1a0181-1730301547"
  },
  {
    "email":"mirabile.cinzia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351347578/5d232b6c1b62fa18adbcf49b32e7cb0c-1730301547"
  },
  {
    "email":"claudio@pierantoni48.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351249274/7ad2b4b5dfbc6b90ca01672c57256340-1730301547"
  },
  {
    "email":"reginalostriss@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351380346/d9751fe54666d793bad42186dbb67db6-1730301547"
  },
  {
    "email":"pinadgl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351413114/68af3fed1ec555be2c92590612fcf246-1730301547"
  },
  {
    "email":"dibiasio.alessandra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351445882/7752c464bce0a1f4100c18495ef5a5ff-1730301547"
  },
  {
    "email":"anna.giacomazzi88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351511418/b2dacb0e208bb9c0b4145354696587d4-1730301547"
  },
  {
    "email":"gabribanti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351478650/ed6e7c66b704dcd400ca8d7e31ca26c5-1730301548"
  },
  {
    "email":"lolivi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351609722/17bdbdfeb7201258eeb089cc2f37e921-1730301548"
  },
  {
    "email":"sara_89_ro@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351675258/e96e73c6e60f00f646b2b28e8e8d306f-1730301548"
  },
  {
    "email":"campe77@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351708026/c2fa83cab728b35925c5826849b5a6bb-1730301548"
  },
  {
    "email":"francescachizzola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351544186/18286163a741b6207fd90b15231405ea-1730301548"
  },
  {
    "email":"chiara.truzzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351642490/877e0a34f1baa248bb2e6e3217bf7cd2-1730301548"
  },
  {
    "email":"silviacarrera8@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351773562/a067f0664f37ba20da5b0a354957258e-1730301548"
  },
  {
    "email":"aziendaviscanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351806330/36b7bccd81fc42cae5935adbb6fcdbc8-1730301548"
  },
  {
    "email":"cristina.piscaglia@studiopiscaglia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351871866/3614bffc2ff0aa97319311602b3d5eb5-1730301548"
  },
  {
    "email":"sararuaro4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351839098/07130de565dcdbe615e70e2f07abb707-1730301548"
  },
  {
    "email":"barbyori@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351937402/97194eb4f69bb799255972f804b93540-1730301549"
  },
  {
    "email":"barbara.cimarra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723351970170/6ec16188564e357ec62b489cc68d60c7-1730301549"
  },
  {
    "email":"a.polara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352002938/53f86b9e735a184504bf61f076ceb1fb-1730301549"
  },
  {
    "email":"csangalli1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723351904634/39ae416233908724649c276b65cba4f6-1730301549"
  },
  {
    "email":"renato.bernicchi@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352035706/89028964d1c0ba3b409b62efb70a33b0-1730301549"
  },
  {
    "email":"roberta.franzetti@arcares.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352068474/9bdd5191ee829cc6721955e3686105d1-1730301549"
  },
  {
    "email":"daniela.dovico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352199546/6b77a766fca391539621d0858a92569f-1730301549"
  },
  {
    "email":"evprudenzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352101242/a64fa2980d6e570aadaa660017712bc8-1730301549"
  },
  {
    "email":"maramattioli.id@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352134010/d1f6a1a118ea5b6d064169d436d5778e-1730301549"
  },
  {
    "email":"ste.oni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352166778/48f6c6fd06a7c1c873745b5a97a3b9c1-1730301549"
  },
  {
    "email":"jinnyglo78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352232314/ba382f76b9c0f473c435781baa5405c0-1730301550"
  },
  {
    "email":"r.carnevale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352265082/1452c6c2abda0a2c25121503d18f6caf-1730301550"
  },
  {
    "email":"80nicolettalaudi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352363386/ffe56099a4410002b26453379d1390a4-1730301550"
  },
  {
    "email":"samanta.billi@vodafone.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352330618/0e9f17b8bc992004bb0a292a61416adf-1730301550"
  },
  {
    "email":"alemolg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352396154/a46ebec722bdbf724db6b89857369c13-1730301550"
  },
  {
    "email":"ev13bg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352428922/61b9c5e9c64c4593d0c4b2d051ca1942-1730301550"
  },
  {
    "email":"tweety.cdm@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352494458/3d55e17a45b25ec7ad44e973e40a8e91-1730301550"
  },
  {
    "email":"emanuellasantovito84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352527226/9e18abb6350cc56d42cc82a9e9cbd146-1730301550"
  },
  {
    "email":"danielacs@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352461690/3cf3d592e054d7e408577ef2dfc7839d-1730301550"
  },
  {
    "email":"m.sassella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352592762/687c67113d5235c1a0d84cf60c334762-1730301550"
  },
  {
    "email":"claraspada@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352625530/0f7bbb67742dcf4db6f4acc9bbab0608-1730301550"
  },
  {
    "email":"fabiola.rivieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352691066/ac33489e84ad207594a7f51043d5f031-1730301550"
  },
  {
    "email":"s.nardo@comune.noale.ve.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352723834/060efc9bc5bf4839913bc61540002c7b-1730301551"
  },
  {
    "email":"lema.zekrya@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352789370/f658a067a86f519ecfb2f7d8e1f05157-1730301551"
  },
  {
    "email":"danielaforasassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352822138/401e1a329fd96490d1682bd77f6b1859-1730301551"
  },
  {
    "email":"marcolanzarini1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352887674/e8453a6b0b415e1862b063c8052b8f64-1730301551"
  },
  {
    "email":"elenastellari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352854906/eea888b363d86f965a7fa4a81800d827-1730301551"
  },
  {
    "email":"tigro.68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723352920442/9c4b6d9488de0008ce6711a7631636e9-1730301551"
  },
  {
    "email":"valeriaolocco80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352953210/b049705c5efbb1c9527aa27f3ce3bcb9-1730301551"
  },
  {
    "email":"frasera71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723352985978/ee5038412dba2da490ff18bea8be7109-1730301551"
  },
  {
    "email":"latinigiuseppina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353018746/5bcb74120a5f9777d9afbd564c4ca1dd-1730301551"
  },
  {
    "email":"camillalragni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353051514/ff2b12b24f9c8474dc83a4bcfcb04b6f-1730301551"
  },
  {
    "email":"alessandraperovich@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353084282/87afbbd64eed4050b43c68621509079d-1730301551"
  },
  {
    "email":"assunta.manfredi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353149818/54d45340b8e028fd4c7634d3245c4a8e-1730301551"
  },
  {
    "email":"giovannaguerri.22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353280890/6a512734bbe8fb6be31c9e0bb874331f-1730301552"
  },
  {
    "email":"lilisala479@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353313658/496a563da0c24bda664a7318a5343a85-1730301552"
  },
  {
    "email":"marinellaperin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353346426/b40f35076b6ede2439a581658be96472-1730301552"
  },
  {
    "email":"info@impresazanaletti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353182586/9f8132ee0aec4a57d2ff59ba507ec625-1730301552"
  },
  {
    "email":"maelad@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353444730/8627b9d2fb7b1cbf502423b89f53cc56-1730301552"
  },
  {
    "email":"monicainusa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353477498/1d8c25d24036ef258b5633b167cac31e-1730301552"
  },
  {
    "email":"r.raganella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353543034/95ac2ce88be235635bf5e0ace69e8da1-1730301552"
  },
  {
    "email":"sam.acquario@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353510266/64f51f35f6360a4b6b9cd08f63f2b89b-1730301552"
  },
  {
    "email":"daniela.luppi@piscinecastiglione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353641338/2cdea3567e38335f20a62fc8659d3f04-1730301552"
  },
  {
    "email":"margimira@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353674106/be318c3058f763cab47ea197af0d7a1e-1730301552"
  },
  {
    "email":"studiolegalemariaferrara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353608570/a3aa4e29acf6bda695ad9f5c20a80d99-1730301552"
  },
  {
    "email":"anna.begnis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353706874/4fdaeb99636471eba1739fa92178e410-1730301553"
  },
  {
    "email":"attibif@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353739642/957bc710f40b8ddd5a825b7dd1045e84-1730301553"
  },
  {
    "email":"lorettacavalletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353772410/4866e9bb1c1bcf108bdc5d80b5f3c696-1730301553"
  },
  {
    "email":"inzanisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353805178/535cd3eae55a9ccb0a42913b718bae53-1730301553"
  },
  {
    "email":"cecilia@repettisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353837946/057fc6dbde9b70bf50c6dab35286f251-1730301553"
  },
  {
    "email":"lori78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353870714/e53b5c7404de219e882d1a0c487b6342-1730301553"
  },
  {
    "email":"lola.simpa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353936250/c35da0c2f54d688dac3107e2081d6533-1730301553"
  },
  {
    "email":"bertocchi.discount@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723353969018/035c6cf5363198d24943a88c56a3734c-1730301553"
  },
  {
    "email":"iorosa76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723353903482/63f0aef139c2fa59264af7f145d905c3-1730301553"
  },
  {
    "email":"susanna@ferrarilasi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354001786/f9ada23f8cabba613f7de7d116a3bf37-1730301553"
  },
  {
    "email":"paoloznadia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354132858/bedead2c89d5eeac76cb7eb21efabab4-1730301553"
  },
  {
    "email":"agarino@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354165626/ed5fc0b5f15040a95a1c5cc2fae695bc-1730301553"
  },
  {
    "email":"laurabarberi84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354067322/8b8c5f7765c1c3c6306ebb9cc0dd7f11-1730301553"
  },
  {
    "email":"rburbassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354329466/97a127cfc0dfd980733494286983a991-1730301554"
  },
  {
    "email":"cbadini68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354198394/f69686016f389f3033e3ad0aeeb45905-1730301554"
  },
  {
    "email":"amministrazione@alfer.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354362234/105f95c5bc34a6d6ac4efe75e94839db-1730301554"
  },
  {
    "email":"mariofavaro44@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354395002/db58ecbf08510d07d69bdbefbd1e07a3-1730301554"
  },
  {
    "email":"epsyblue@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354263930/bc415f00e693edbfeaf1aa47ff1b41ae-1730301554"
  },
  {
    "email":"marikacesaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354427770/56e40f27752dce8988052c86eb1e1da4-1730301554"
  },
  {
    "email":"daria.schifone@gre.generali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354460538/e1b3de064abed8795db9d55def3f7115-1730301555"
  },
  {
    "email":"elisa.parenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354558842/1097482b832f7c120506fe85186540b8-1730301555"
  },
  {
    "email":"cristinanicolini@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354493306/c7d590523a0961b4f62ea214740353e7-1730301555"
  },
  {
    "email":"cecchivanessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354526074/a274b98a61f08086d2d283fc301dd1dc-1730301555"
  },
  {
    "email":"saraferrero@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354591610/9015fdb01abc0e3b57375a8f2d805f45-1730301555"
  },
  {
    "email":"marcolinigiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354624378/31b955733c8402b6be72e162bbf32a75-1730301555"
  },
  {
    "email":"sara.digiuseppe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354689914/aff197ce37e9b8a230027179fd28d2bd-1730301555"
  },
  {
    "email":"danielatriolo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354657146/00dbaf9948a41fc792df1de0733e7211-1730301556"
  },
  {
    "email":"pandamaggiore2005@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354788218/dabf00fe953addc6b5c3529a32c659e1-1730301556"
  },
  {
    "email":"gensini.patrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354755450/51787416f82d673dda6aeaf273b9e14d-1730301556"
  },
  {
    "email":"oroje76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354722682/7c2f3d86af22fc1ab5168d19eef9204b-1730301556"
  },
  {
    "email":"nicolettapallotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354853754/afc98a483e80417c7155bdffa8e36186-1730301556"
  },
  {
    "email":"p.p.forteleoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354886522/a76a6c2cc7c999f44ef76c63fe5da0ba-1730301556"
  },
  {
    "email":"nakupenda.mn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723354919290/74f01322ce727f4ae67e8c8600435f7d-1730301556"
  },
  {
    "email":"monicaquadrella@aol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354952058/3a465c21416fa906f6a1de6823963aee-1730301556"
  },
  {
    "email":"d.mellone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723354984826/d71d88a137d6e666e0a86ae1a9d04423-1730301556"
  },
  {
    "email":"p.raffaella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355148666/a210a93e10e0ebafa0645334a902fa83-1730301556"
  },
  {
    "email":"mariaenza81@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355181434/9a8551e6495a8cae62fc7da637608a70-1730301557"
  },
  {
    "email":"m.assuntafauciello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355017594/ab5ddb94b403d284d4e2685a79debbb2-1730301557"
  },
  {
    "email":"fiori@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723355083130/9a6e2f7d5013a8102565ccf0fce63e0f-1730301557"
  },
  {
    "email":"gaia.gelmetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355214202/e9e87da0f9f00756860a64b628bcbbe0-1730301557"
  },
  {
    "email":"cometasassoscritto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355246970/7ec3ce543dfc68ca2813eae6f8efc519-1730301557"
  },
  {
    "email":"ravazzoloelena@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355312506/64fc16a7b4f9cf2f45317b41db78ce4a-1730301557"
  },
  {
    "email":"mariagraziastango@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355279738/3681e822990f139b5f94d0ce84c94d91-1730301557"
  },
  {
    "email":"lindafrank2002@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355476346/aff113906ffa7c3ca02cf5da8f733531-1730301557"
  },
  {
    "email":"pclarizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355378042/f4a0d5034078eb98f56417520bb8e05a-1730301557"
  },
  {
    "email":"vittoria3010@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355345274/c0ea7f42240516cdbbcc92bae4d25333-1730301557"
  },
  {
    "email":"sabrina.bozzini@polimi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355541882/8a73f262264f447b5c31f767d9d9c694-1730301557"
  },
  {
    "email":"iotuch@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355410810/d57454fb0d5549707eb7726851fa4e4a-1730301557"
  },
  {
    "email":"1978my@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355574650/9f8a3a502deaaa23674b8851f538a354-1730301558"
  },
  {
    "email":"valeria.pintus@atssardegna.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355607418/134cd6db6581ae5a480f3ea7cdccdda8-1730301558"
  },
  {
    "email":"gisella.giorgioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355509114/648453e257433e5bb91ed745176f32fe-1730301558"
  },
  {
    "email":"r.mangotommy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355640186/2461c89050d3c4d0f5509c1c4ca46f4f-1730301558"
  },
  {
    "email":"anela.b@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355738490/b4884bc088ce06173a38dbf06487b850-1730301558"
  },
  {
    "email":"pbpaolabarb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355771258/67edbabb5c59dad997d470401cd69295-1730301558"
  },
  {
    "email":"p.cappiello68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355902330/be11666523c3284a93ea9ce6736a1aa4-1730301558"
  },
  {
    "email":"mandisirina8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723355836794/9da98fc19f4ae61838e891913e59d887-1730301558"
  },
  {
    "email":"darkforever95@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355804026/76eec76c3cb919fb12e2c4ff763ad555-1730301559"
  },
  {
    "email":"paola.guglielmini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356000634/02281b7a114ae967a903eae1139059c4-1730301559"
  },
  {
    "email":"simo2772@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723355967866/d27a53da1f7212354f842518c698b314-1730301559"
  },
  {
    "email":"carolina.kugler@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723355935098/081e3f0069dfe38e952de031a77a81dd-1730301559"
  },
  {
    "email":"antonia.fanchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356033402/db7d487f5903a2f8f98c78a38160f6ce-1730301559"
  },
  {
    "email":"lidia.94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356131706/aab2b3b3a7bb3d6755b5f9c67fd9f389-1730301560"
  },
  {
    "email":"maiorana.melania83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356098938/a40884d106391967fb62d7da98555111-1730301560"
  },
  {
    "email":"tsalvatore@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356230010/fb5e29f227142e9091994a76a569968a-1730301560"
  },
  {
    "email":"graziecas@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356066170/9fa15440c1768531070dd3982c358acf-1730301561"
  },
  {
    "email":"c.baldo.unina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356262778/721b86266245cda1b2f822cc97ac06b5-1730301561"
  },
  {
    "email":"lisasofiachiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356328314/23d2d1690637040e068aa6780d4c1fa9-1730301561"
  },
  {
    "email":"giuse.67@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356295546/8269f9d9f7e12711f56aa0892014d093-1730301561"
  },
  {
    "email":"fbergamini71@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356393850/5f20e8677ec24a4cda128c599149ad69-1730301561"
  },
  {
    "email":"sc.71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356557690/34205e2d06207036814c18cb413dfad2-1730301561"
  },
  {
    "email":"ele.puccirocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356524922/ea9bcf0984d3f58a30497b602ad8d0da-1730301561"
  },
  {
    "email":"sserloni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356623226/8daeea028ec3636a4ff43f59007a4544-1730301561"
  },
  {
    "email":"smaggiaele@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356688762/bf198a05d57f5d9100daaaebfb41cbf1-1730301561"
  },
  {
    "email":"specialegg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356721530/9fa177770fea7ae7bb06fc8d10c9f27c-1730301561"
  },
  {
    "email":"cristiana.mulas@pirelli.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356787066/84a79dbc07648636ae0c24ff60e8cd9c-1730301561"
  },
  {
    "email":"cettolocristy@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356819834/1a02aca285bbc9ae99eed80762e483e2-1730301562"
  },
  {
    "email":"sessasimo6772@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356754298/0740f69a8f855374f52fa7c2d9ed01e4-1730301562"
  },
  {
    "email":"catumazza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356918138/0d1a1a4b92dc5e1032248fcd3a58c4db-1730301562"
  },
  {
    "email":"maila.amadei@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356852602/451b64a8f4e88c1c9d6e1753ad31888d-1730301562"
  },
  {
    "email":"elenesica2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356950906/80195e9a607e932d7111a95de6f80d80-1730301562"
  },
  {
    "email":"giupy1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723356885370/46e267ff1298e588122fc96cc654e3c9-1730301562"
  },
  {
    "email":"nicoletta.boidi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357049210/0055e284d55505a54d1cdcb246f5f90c-1730301562"
  },
  {
    "email":"alex.montorfi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723356983674/426971796c7dd46e02fb097ea9e73f80-1730301562"
  },
  {
    "email":"aurniafrancesca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357081978/721f051b81ad0c37ed2a211152d29224-1730301562"
  },
  {
    "email":"asia782004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357114746/80475c71c1c27c6a44176eb9cc0b4376-1730301562"
  },
  {
    "email":"barbaracarne12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357180282/0e572b6d49b12393db674813025af090-1730301562"
  },
  {
    "email":"davideleri@virgiio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357016442/5af2165ad1538c5f86052357aa7e9313-1730301562"
  },
  {
    "email":"olga.torre@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357213050/a8cd4ea0267a383f0d7588bba469e21a-1730301563"
  },
  {
    "email":"simba_ibby@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357245818/32a9ce99893b70da5d3a59359be30079-1730301563"
  },
  {
    "email":"saretz@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357278586/0eb6596f5470d2d31e84f2430b9a1709-1730301563"
  },
  {
    "email":"raffa348@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357344122/b91f8730e69a84d9b4aa76deadd2c604-1730301563"
  },
  {
    "email":"menelle.giada@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357409658/7fd6783669fe4e7ecf7c44eaa754d149-1730301563"
  },
  {
    "email":"giomaur@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357311354/6fa79e1029822f52c3cae351aab918a2-1730301563"
  },
  {
    "email":"spinamorris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357376890/e7d68c7665b4d023c36ef8987430b455-1730301563"
  },
  {
    "email":"mgt79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357507962/872f7cc0167f5ace4ff5a98e064f2f36-1730301563"
  },
  {
    "email":"nsalerno@jaggaer.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357475194/7130e49044f33abf070469335bba8c74-1730301564"
  },
  {
    "email":"tiziana.bra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357540730/0ce1fe88c01d3f16e598c5d8a3673911-1730301564"
  },
  {
    "email":"michelabertolani76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357606266/464c39713b828c867f6d934fcc9b6870-1730301564"
  },
  {
    "email":"michele.laragione09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357573498/db1182fca699d6423325c1811cb2e733-1730301564"
  },
  {
    "email":"chiara.cinelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357442426/e44d727276af614ad7a22c283aebf961-1730301564"
  },
  {
    "email":"kiaranellospazio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357639034/6bff0719fbbc36a6acde231a054c3b8b-1730301564"
  },
  {
    "email":"melissa_lega@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357704570/27364c7be7660f080f3f91231e8c234a-1730301564"
  },
  {
    "email":"barbara217b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357802874/c0706548476c9f381c9334ae043c6091-1730301564"
  },
  {
    "email":"pratina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357933946/685a48685f6758dda30b5447d8291f7f-1730301564"
  },
  {
    "email":"l.alongi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357770106/16f0fe9dffb7531dd9a5aa9eedd9fec9-1730301564"
  },
  {
    "email":"diego.dalcero80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357835642/4a8206fa125e8b90dc8e59d355e0bbb7-1730301564"
  },
  {
    "email":"mie_ase@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723357966714/40997ee86ca4571758a9edd29474c337-1730301565"
  },
  {
    "email":"simona.poggio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723357999482/f809a31a1d2f8f28dd46eea3795fafa3-1730301565"
  },
  {
    "email":"daniela.lao74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358065018/88512b9fa1c31b117278e7da6bdef8f3-1730301565"
  },
  {
    "email":"durcinea.mochi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358032250/a7fc344110ee547ba98a963c6112e369-1730301565"
  },
  {
    "email":"annalisa.cicognani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358130554/4879c3afb6417d384c598b93276ff4dd-1730301565"
  },
  {
    "email":"giuliabeltramo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358097786/b9e9432556e73fdaeb9191f74a2d86bf-1730301565"
  },
  {
    "email":"geosilvano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358163322/0c7257ca9419b05ffe24f9681339c09f-1730301565"
  },
  {
    "email":"michela.castagnari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358196090/781cc497d073c5669f15eca7304d39bc-1730301565"
  },
  {
    "email":"zaballadauna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358228858/876cfebe50188b58cd180bd4f7f613a7-1730301565"
  },
  {
    "email":"egidiot83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358327162/2d66a5812c11d832b9758110d0d71c2f-1730301565"
  },
  {
    "email":"laura.moino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358359930/d35193822cada979d8a16fbca966a0bd-1730301565"
  },
  {
    "email":"elena.minnie73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358261626/5bb98f8faa3f8879f2e26a7bb8f8fa00-1730301566"
  },
  {
    "email":"margherossi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358392698/9a3b2eab8ff28308837c2177ecb24a0d-1730301566"
  },
  {
    "email":"laragiuffrida@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358425466/e22f65a3aac61982dc99fd53a76de01b-1730301566"
  },
  {
    "email":"guya.cianci@studiofrojo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358491002/7c7b7993295dd9c037b74d8311feabe5-1730301566"
  },
  {
    "email":"chiara.rainone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358458234/7a8ab4108890116be72561ae3a3e6d23-1730301566"
  },
  {
    "email":"sandradomenici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358589306/87d7d1b45122309f69783b554c972ff5-1730301566"
  },
  {
    "email":"artonici@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358523770/f1c3aaf9eb6e196e1e7e2d902d763b49-1730301566"
  },
  {
    "email":"costanzaliparulo4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358622074/91637560738c41e33ae9ad622b15eda4-1730301566"
  },
  {
    "email":"mirelina7979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358687610/237aa15e69dff8a70a7969f0f87d375b-1730301566"
  },
  {
    "email":"info@crismodapositano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358720378/c62cdce41b3735f0c3b55b6930097c5f-1730301566"
  },
  {
    "email":"geaangilella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358753146/a000effd602bca8dc5c888787192c626-1730301566"
  },
  {
    "email":"galia.todorova@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723358818682/7a392ddcf5bb2f36141a2b228f7207b7-1730301566"
  },
  {
    "email":"marilisa.p@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723358916986/df3764a16f67196b54b213a9021281f9-1730301566"
  },
  {
    "email":"ivi_ale@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359015290/1530aa3ec6da60b7a7e60500a2d1ae46-1730301567"
  },
  {
    "email":"versinigastaldo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359113594/59a28e4b8582c9f8b94cf0b2b215bcf0-1730301567"
  },
  {
    "email":"silvia_redaelli@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359048058/472a03a681551c8515db28938da6693f-1730301567"
  },
  {
    "email":"isi.isi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359080826/dede84f1ad7432b3aff6d46394bcd10c-1730301567"
  },
  {
    "email":"viacicerone7@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359211898/0c0618f9deae35e8781abff30a6752ee-1730301567"
  },
  {
    "email":"sofi.cc@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359179130/2c6094e7db3fe4f0f12526412fb7c0bc-1730301567"
  },
  {
    "email":"83.antonellasurace@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359146362/06aacac3b7d82b5f76841ce7461c0503-1730301567"
  },
  {
    "email":"basile.pa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359277434/3bee210a3f0992245f79ee7b51a69b48-1730301567"
  },
  {
    "email":"patrizia.anzillotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359310202/e5cb265f2eb04fe9739fa60d15e6937f-1730301567"
  },
  {
    "email":"giusy7193@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359244666/dc6fc43a4ba84a59101eeb07284fefaf-1730301568"
  },
  {
    "email":"zacchi.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359342970/bdf3570d234232b28872a84a30d8d45f-1730301568"
  },
  {
    "email":"girolami.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359441274/fadbf16aaeb19a8ba91890628b8045e7-1730301568"
  },
  {
    "email":"barbara93br@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359506810/4b522123b23c9318b1baa2513b37f8b8-1730301568"
  },
  {
    "email":"cortesireti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359474042/5452023c5279dcdde22310115b908bf1-1730301568"
  },
  {
    "email":"alfonso.lucia29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359375738/1ece00189270ece4493e5d30eff551da-1730301568"
  },
  {
    "email":"quiqua62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359637882/f7842ffd698b527eb7124c4a1c2c1d06-1730301568"
  },
  {
    "email":"maura.fiorin74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359670650/63d69dbcde0ef25f3f0565a452f97a12-1730301568"
  },
  {
    "email":"cristilli.marco@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359539578/7a3181718084f4f29e253622ec95d44a-1730301568"
  },
  {
    "email":"chiarac83@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359703418/833519587de049ab89c0de295ed018b2-1730301569"
  },
  {
    "email":"lara.fantin.71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359867258/e6b52aa8ba93cbc54a1cd3cbdf5018c6-1730301569"
  },
  {
    "email":"bettina.kirchmaier@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723359900026/edd0e619f866178c35df41334975f14b-1730301569"
  },
  {
    "email":"rosariasparano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359736186/6ac308e72db871100d746c70823db650-1730301569"
  },
  {
    "email":"manupanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723359932794/d1d86fb695c54c7caffc78fc0b5dbc88-1730301569"
  },
  {
    "email":"elisabet.locatelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359998330/51966992978be8d8eb9e79246d51e9d0-1730301569"
  },
  {
    "email":"soniaserrani76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723359768954/a0009d0d80bf269bc3154aa858270107-1730301569"
  },
  {
    "email":"clalepo76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360063866/9a6bc5b0d35b29ba3820ab00f1063190-1730301569"
  },
  {
    "email":"stefy83n@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360031098/177d46f5212103491266a1d7614987c6-1730301569"
  },
  {
    "email":"serenadbella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360129402/1225fdbbd99ba5040e5a434658ba040b-1730301569"
  },
  {
    "email":"alessandra.rutili@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360096634/75471763f81c33c8c5431eadf3b8f87a-1730301570"
  },
  {
    "email":"cinzia.fassina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360194938/9cbc4c738c7526b046f901a2bf8f0c85-1730301570"
  },
  {
    "email":"patrizia.biagini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360293242/ee516a2b22061b619d87ea4f71dc1293-1730301570"
  },
  {
    "email":"pinpizz@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360260474/5e3a88b20b429f345e6979dbd1beb301-1730301570"
  },
  {
    "email":"meryj1967@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360227706/9c78ebb853a7187aea3b61e69b0b49d6-1730301570"
  },
  {
    "email":"ponzio.chiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360162170/53d7c2a168f54c6316d31012d249de36-1730301570"
  },
  {
    "email":"cmstampe@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360424314/efb381b41900cf1c078b01aca4026fd3-1730301571"
  },
  {
    "email":"rimini1966p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360391546/592a35c371419673298aa6dcac6477eb-1730301571"
  },
  {
    "email":"isabella.mauramati@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360326010/1c196a6995c297f855e1f25d1743ab47-1730301571"
  },
  {
    "email":"manulic@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360489850/92cab8dbd9f748bb460ae542d3acd14f-1730301571"
  },
  {
    "email":"sofiamilano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360555386/b9877329bde0518e7cb94f9b12b1915f-1730301571"
  },
  {
    "email":"antonella1114@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360588154/cfe5cbcc1fad2c3d1cd58ea76c036c21-1730301571"
  },
  {
    "email":"ceccasollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360522618/f8244fa6912eac93d8d56081c0cd5cf2-1730301571"
  },
  {
    "email":"emil.gentili@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360620922/9ab14da0e3522238f37845118f2230f4-1730301571"
  },
  {
    "email":"wandarullo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360457082/5530437fe23dd329ff41c27c9009d9b7-1730301571"
  },
  {
    "email":"ccorradini.cc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360686458/5ebc610ef134f739172d65a95f7a1fa4-1730301571"
  },
  {
    "email":"claudia2078@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360719226/754c0665223dc1f222b1c7fa27293488-1730301571"
  },
  {
    "email":"sebastianoponzio59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360653690/8784ec60521b953df727c63687879285-1730301571"
  },
  {
    "email":"silvinabeg@yahoo.com.ar",
    "url di attivazione":"https://verdissima.it/account/activate/22723360751994/cf07f9a12233d5959b0bb6759ed00b48-1730301572"
  },
  {
    "email":"sara.paterni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360883066/2eecf4913a916513a2dd20cd2a114dc7-1730301572"
  },
  {
    "email":"gabriella.torchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360850298/17cc674a6718f20c71dc1e69527662d6-1730301572"
  },
  {
    "email":"mgf4504@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360784762/0fbdfeaebd6728bbdcede1951cfa306a-1730301572"
  },
  {
    "email":"ofeliuccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723360948602/a0e9d6ee9fff5980bfa465a6e20a413f-1730301572"
  },
  {
    "email":"cincilletta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360915834/9ffa28a3d2d616230bd823277690183e-1730301572"
  },
  {
    "email":"elenap0511@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361177978/8020b545e1536389a6d5dcd2ce41f9fc-1730301574"
  },
  {
    "email":"ginevra75@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361112442/6c5a70a8f5ba4cf86eb5b24caddbaf6f-1730301574"
  },
  {
    "email":"annaacca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723360981370/fc2389564a17aded4659dacf73afa97e-1730301574"
  },
  {
    "email":"ilariagilberti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361276282/1c84001ad1297f1c452ab8db43d6c18f-1730301575"
  },
  {
    "email":"fabbi.f@diffusionetessile.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361243514/c392450b3e2843f1714b74ea990ebdd1-1730301575"
  },
  {
    "email":"rmandolesi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361046906/24ef164aae129a812e8f35e95bdda6da-1730301575"
  },
  {
    "email":"eleo87@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361309050/18597eef85bca176d75f9a41509a8e15-1730301575"
  },
  {
    "email":"carmi.genco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361440122/7f28d2c8d068e7602680ea763fa1fedb-1730301575"
  },
  {
    "email":"christian.bonafini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361472890/3cd7214d72a56b5d7a9d832f9fc704d7-1730301575"
  },
  {
    "email":"ionival77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361407354/a24702079ec0ccf4a434c354f5620dd1-1730301575"
  },
  {
    "email":"silviaallois@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361505658/805982b43440cc650cdd60bf117f7d29-1730301575"
  },
  {
    "email":"nicolettavicenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361571194/91055ac5cd49808459ee0ead596e15a5-1730301575"
  },
  {
    "email":"montanarimg9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361538426/ad1adf35050de1706c7320123dd8deb9-1730301576"
  },
  {
    "email":"gabriella.bor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361603962/46daaa17eaf7e6c513eab80f72294009-1730301576"
  },
  {
    "email":"simonettadg@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361636730/afbd686cb54444189f768c92c98d17f0-1730301576"
  },
  {
    "email":"s.battaglioli@centrodottcomm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361735034/2eba71c64c8b378755d6ac5b0545b465-1730301576"
  },
  {
    "email":"paola_zacchini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361767802/cb74e013b35db71122c2090c63501923-1730301576"
  },
  {
    "email":"patgro75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361702266/f0f67aae7b9e4586657e5e25ca280571-1730301576"
  },
  {
    "email":"silvy_rob@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723361800570/736eff403e0f1a50af9acd0b8812bf86-1730301576"
  },
  {
    "email":"murgasfanny@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361964410/a5c4a89b9705fdefadb772ba7a4dde2c-1730301576"
  },
  {
    "email":"teresacafazzo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361866106/df23ad281b6e3113fab82046609cb9b6-1730301576"
  },
  {
    "email":"raffaella.samarini@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361931642/8e2e53f6bd2271017cfeb2511b613e75-1730301576"
  },
  {
    "email":"cami.cesari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723361997178/a28cdaa42ac8c56017707dd573a21777-1730301577"
  },
  {
    "email":"claudiasch73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362095482/08d5117fb24f69a812612d78dc170074-1730301577"
  },
  {
    "email":"zucchielena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362062714/b472517ed26655dea4798b3c540b5bd9-1730301577"
  },
  {
    "email":"ame.martinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362128250/d9d6cb522d7300718b7bb402079479b0-1730301577"
  },
  {
    "email":"silviacalloni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362226554/9ddbd505742953c12939049bb6cd9721-1730301577"
  },
  {
    "email":"sicoloaimona@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362193786/93104f5dd10c3b421c369871e7fab0bc-1730301577"
  },
  {
    "email":"anpes68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362259322/beab1d93b1afe4b0d60640eb04aabc0e-1730301577"
  },
  {
    "email":"riottielisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362292090/9b97aeaf74e3c831570b7471ff8edfbb-1730301577"
  },
  {
    "email":"elettra.ronchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362324858/f36b59b24966af3008110609bb093fa0-1730301577"
  },
  {
    "email":"mariapaola.campisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362357626/546a6753cafcd92ae092729b2b95c30e-1730301577"
  },
  {
    "email":"chiaradivi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362423162/96ea3d35e66ae6d23701570f62902484-1730301577"
  },
  {
    "email":"ventoban@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362488698/3990cb2d1f86ef37da9d32c0be16ea18-1730301578"
  },
  {
    "email":"bbnatucci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362390394/04dcbfb3df4033aab0e2dc9d71c6ef4b-1730301578"
  },
  {
    "email":"elena91.scaranaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362619770/9511a3b533b5efc1fd8a0e5177915cd9-1730301578"
  },
  {
    "email":"sonia_facco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362455930/8988cd929c0bd32001192e2571895b91-1730301578"
  },
  {
    "email":"pedronimobili@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362652538/ee36a67c0fb010c21ee1bb18b6e2d589-1730301578"
  },
  {
    "email":"lorenzonarbona@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362718074/ed8e4829aedd4d63946d216a65bf1374-1730301578"
  },
  {
    "email":"m.teresa.gordini@studiocavina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362750842/b9990c82fc81a52edc666b407a72d0e1-1730301578"
  },
  {
    "email":"cribal77@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362783610/77f9c6c0948636f5c73ba87326122ffe-1730301578"
  },
  {
    "email":"oratina2019@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362849146/5ce5054e87ca4dcfa82004aa8ef4d911-1730301579"
  },
  {
    "email":"giusetti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362685306/4bc19bda7a2a82641b2e8d04329a5341-1730301579"
  },
  {
    "email":"laurin78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723362881914/21fc315ca0363c416c1651c4ff017189-1730301579"
  },
  {
    "email":"francy.lacava1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362816378/6af04d9a99ca95edfc49ccfe0b1b95a8-1730301579"
  },
  {
    "email":"valefrongia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362980218/48679cdaf73157bfd20c08828bae033a-1730301579"
  },
  {
    "email":"font75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723362914682/6da064d266acc202fb3f1a479d1ba247-1730301579"
  },
  {
    "email":"cinziarocco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363045754/f0e22398798311f02d7de0a6a6cb74be-1730301579"
  },
  {
    "email":"ivana.delillo@aliservicegold.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363012986/dff97cf7f1c66d222a24f3045231c3b4-1730301579"
  },
  {
    "email":"b.lazzeri@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363078522/9579d31ecec743eeffb246285103984f-1730301579"
  },
  {
    "email":"mn039@delegazioni.aci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363176826/4dee51657358e47f52c5aac220017650-1730301579"
  },
  {
    "email":"lauram.leone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363111290/45588778e3e8fe6b67501c2f20584454-1730301579"
  },
  {
    "email":"faccinirita@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363209594/0553f06d18586ce8ac6c8e11cda6441d-1730301579"
  },
  {
    "email":"revesilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363144058/b72f7621268602396082edd8e3c3fc3e-1730301580"
  },
  {
    "email":"ornfasanella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363275130/3ac87c820cd1f1e1255a2cdc12a06b41-1730301580"
  },
  {
    "email":"roberta@sarobyviaggi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363307898/0ed08ec374faf7dfbb69dd3b0c7c9658-1730301580"
  },
  {
    "email":"anastascia64@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363242362/841b6bb867b0e7c6bd8ab3db25b27ffa-1730301580"
  },
  {
    "email":"mel2011@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363373434/1303b40638ea7b9ac67aeaf98357727c-1730301580"
  },
  {
    "email":"stefimasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363406202/c0dc7046c997dc20b353c308a0aefa11-1730301580"
  },
  {
    "email":"cri.capodanno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363438970/0f233e29e2d3649d404b60af3c62a6d9-1730301580"
  },
  {
    "email":"giannelli.alex@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363471738/f1c4ce3d9d4b8200a536dcf282c236ae-1730301580"
  },
  {
    "email":"giusibarresi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363504506/d4fad6394c82c56015813e05c6d0fddc-1730301580"
  },
  {
    "email":"mariapaola.dettori@beniculturali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363340666/27cc273001ade339904f92f84dcf7e3c-1730301580"
  },
  {
    "email":"samantha@lazzariesamaritani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363570042/164b75ec236ae6d46bb30ade9c2f662c-1730301581"
  },
  {
    "email":"riccardopelati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363537274/588da87a72051d0ed3fe713c36eeda4a-1730301581"
  },
  {
    "email":"boricua71@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363701114/65ef6898250eafc2f0850227d7be343e-1730301581"
  },
  {
    "email":"rickyp1987@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363602810/b3f530c512d3ebf1e415ff8210433ad7-1730301581"
  },
  {
    "email":"vercevi-01@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363733882/617b4b091be8e3a006802828eb9911f7-1730301581"
  },
  {
    "email":"antonio.vatrella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363668346/a456b987fb6d9d3814f7fd792a1d03df-1730301581"
  },
  {
    "email":"ricciarda@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363799418/bc208bfa8d527432533c08ffeaa00cd1-1730301581"
  },
  {
    "email":"vercevi-02@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363766650/11ee2f922da991b226d8b19ceae54435-1730301581"
  },
  {
    "email":"riccardo.pelati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363832186/1a1d13974f1561ce7ffab193c0d1b948-1730301581"
  },
  {
    "email":"morena.talleri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363864954/b73e6ced374a316b1736d1ab6550ff8a-1730301581"
  },
  {
    "email":"sabrina.colombo@artsana.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723363897722/e680558f04ed88ba249842267b4d9050-1730301581"
  },
  {
    "email":"fiori_simona@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363963258/a72f3b853ed9a19ae3f9482cf54951d0-1730301581"
  },
  {
    "email":"paolasommavilla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364028794/12d3fd1f0e8f5c0adefe2c2bc165e68c-1730301582"
  },
  {
    "email":"patrizia.foschiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364061562/2377b5de5e06a210129324c30a02140a-1730301582"
  },
  {
    "email":"melaneg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364094330/a198d9dcd19cdd72294395cbc6d7a280-1730301582"
  },
  {
    "email":"sele19pf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364127098/73a74c669f1dafe3b0bffd6c4a7e8a31-1730301582"
  },
  {
    "email":"cinzia.casarini@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723363996026/d9a15ec5b54a5189a4df258b3a50add1-1730301582"
  },
  {
    "email":"s.anselmi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364192634/7d7a44ebc56072670f08edaf944c404a-1730301582"
  },
  {
    "email":"zinaidalupu8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364159866/f632591445cf1e4fb5043b53c95cafe8-1730301582"
  },
  {
    "email":"marcella.grillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364225402/03e796bc5d76fe75675e41a450f51180-1730301582"
  },
  {
    "email":"clelisqu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364258170/2dae337107031953a290376e903fac35-1730301582"
  },
  {
    "email":"santisa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364290938/7401b4db7de0bf0a8855d29190e53b72-1730301582"
  },
  {
    "email":"mportesine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364454778/e659c3a83a50b0a4be85dee44bf92d3f-1730301583"
  },
  {
    "email":"sb.boscolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364487546/12172b4a300de76bce153a278598140a-1730301583"
  },
  {
    "email":"jana.mary01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364389242/9ce766fb3c48d78df66af44499ec9c60-1730301583"
  },
  {
    "email":"leperaa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364520314/d9d1ce995b9bcdc554575d9fa22f41a3-1730301583"
  },
  {
    "email":"francy3277@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364618618/abe07878f31ada5a9600037538a95775-1730301583"
  },
  {
    "email":"patrizia.sala1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364651386/2141f713acb24da177da59ee125d479d-1730301583"
  },
  {
    "email":"monica.ghetti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364684154/5d95f8da55f97eed228417df9b60cafb-1730301583"
  },
  {
    "email":"nadiaangelo80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364716922/e25e52fac1cecd737a3cc03805a2a95a-1730301583"
  },
  {
    "email":"scalandrellimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364749690/97faf7c7913953c59c1c9985d9c89b14-1730301583"
  },
  {
    "email":"biagini.tiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364782458/173b6cddd72e89a48a3667787fdf9a93-1730301583"
  },
  {
    "email":"francescapanicini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364815226/398a4b22374db184cf30985add0ec107-1730301583"
  },
  {
    "email":"antonella.cassola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364880762/d42d417a379ea56d5267826a11ae7a62-1730301583"
  },
  {
    "email":"angelica.m@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364847994/ea4fe1f1568bc64e7719143dcb9360e2-1730301583"
  },
  {
    "email":"pkderamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364946298/d6b22f6ef2209b99f72e09fcbcabee19-1730301584"
  },
  {
    "email":"gltassara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723364913530/010628c7270392cd25c1abf6ff0e18a0-1730301584"
  },
  {
    "email":"gabric65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723364979066/b9e427db7b957057b9c0093cd7c05090-1730301584"
  },
  {
    "email":"martytagliatti@icloud.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365011834/fedf7074098c0e125d11c20f2743eeeb-1730301584"
  },
  {
    "email":"karenf@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365142906/59e6162ef4fa282ea1f0843180265c6a-1730301584"
  },
  {
    "email":"achiropita.lepera@pec.uniba.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365175674/79c39fc97ea31e8d26daa03fd9ed3408-1730301584"
  },
  {
    "email":"jessica-98@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365044602/70b363ec873c7d6de4e60224b7b3a226-1730301584"
  },
  {
    "email":"fedek90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365208442/bf8883f40f10437b27f23042ac17d2d0-1730301584"
  },
  {
    "email":"mariantonietta679@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365241210/1a2dc4254fde346e059b6db1b2cbc8eb-1730301584"
  },
  {
    "email":"info@aliservicegold.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365273978/5d1539f5fddf63e1cbd6e49e9a4f9b9b-1730301584"
  },
  {
    "email":"andreaago04@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365306746/b969ac259f2207741bd2d0d71405f316-1730301584"
  },
  {
    "email":"claudia.bonamici@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365339514/3fb14737b0ba7fdfa802d8cf533d81f7-1730301584"
  },
  {
    "email":"teresa.uccello@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365372282/1eb6e33a5d185f5393cb95b989ae6963-1730301585"
  },
  {
    "email":"adamo1maria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365470586/33d108b4781edbe9c9ca8988f0ca34a1-1730301585"
  },
  {
    "email":"v.cobianchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365405050/f5c90c77e6be9eddb115a0a60d1a6d4f-1730301585"
  },
  {
    "email":"liliana.manenti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365503354/54b6afdbebe63255232b2aed5303c1ca-1730301585"
  },
  {
    "email":"giada1@moko.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365536122/276ce1421372174d4533d678b2eb40b1-1730301585"
  },
  {
    "email":"giada@moko.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365601658/d26bf367abe01a098d8783651d8b96f9-1730301585"
  },
  {
    "email":"v.cobianchi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365699962/e88c2aac19d62ddc4f017b8c24e1ebad-1730301585"
  },
  {
    "email":"cirebe@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365667194/751a65b97ed19d978d757c2ab07d351d-1730301585"
  },
  {
    "email":"antocaffy@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365732730/6622ebf9032d5e00d46083d46095d26b-1730301585"
  },
  {
    "email":"anna_giardini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365765498/fbe4aa8dcaa2d4474cab613b1739739e-1730301585"
  },
  {
    "email":"ester.eckert@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723365798266/f017c46a9c4c2a2a479b47009b82cfb6-1730301585"
  },
  {
    "email":"laurettamorroni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365896570/3aab19a8c42a2c424486f910c8570eb2-1730301586"
  },
  {
    "email":"romina0171@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365863802/45aeea5e64b352efc7774bcbae199762-1730301586"
  },
  {
    "email":"carlottagiora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723365929338/51693ee1b8475c6e235195b053a9c134-1730301588"
  },
  {
    "email":"mariachiara_91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365994874/49945aee3f81f1df4ea3a15565498ed5-1730301588"
  },
  {
    "email":"patrizia.nari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366027642/cc2ed8252c8b48008926af9132d6581a-1730301588"
  },
  {
    "email":"barbara.vidale@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723365962106/dd64538fb3d26d687472142776b62ccc-1730301588"
  },
  {
    "email":"angela.spadafora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366158714/bc0a8b7aaaa9916e5d1b9de30a2904f1-1730301588"
  },
  {
    "email":"elvira_pastore@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366093178/2eb9c926c8656031336c89736321b8a2-1730301588"
  },
  {
    "email":"m-leopardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366060410/aa29131eef07e97c9d2eec74b4897ce0-1730301588"
  },
  {
    "email":"aliziacarrozzo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366224250/da77e9c95f88d6dbc043016798a5f9eb-1730301588"
  },
  {
    "email":"katja.calandrini@pfafineco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366322554/b3b304738dcf92051933dd3c34a0ff21-1730301588"
  },
  {
    "email":"chiara.maina@giustizia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366355322/3fcd38e1dd6ea029cdb6227b20f96af3-1730301588"
  },
  {
    "email":"ritasimoncini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366388090/eafef3cf47daf904febab00bcfbdd95d-1730301588"
  },
  {
    "email":"nicolaardito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366257018/420f303aa0dbc60577dbbdad90134eec-1730301588"
  },
  {
    "email":"luciaiocco68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366486394/743553fba91ddf594e13965c4108cda1-1730301589"
  },
  {
    "email":"mellanovalentina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366420858/2af1787b7f6af746af231707a5b2672d-1730301589"
  },
  {
    "email":"giorgia.stefanedil@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366519162/b466183dec9cb974a9c9102041f28080-1730301589"
  },
  {
    "email":"robertafranchioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366551930/4e44be2b88d6f91b3f5fc6c2f5909fe2-1730301589"
  },
  {
    "email":"fossati.antonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366683002/71f0adfb38b2a6ea2f253a21bf268e4d-1730301589"
  },
  {
    "email":"r.brunelli@notaiopinardi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366650234/52410a8a795cdef68c93b56b6a309a46-1730301589"
  },
  {
    "email":"lauramagnani@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366453626/78439dba1eb5fa4caf6e8648da11f6cb-1730301590"
  },
  {
    "email":"gnaselli1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366584698/cb6756c48e1466bff4809fe9004e8623-1730301590"
  },
  {
    "email":"mariellafalanga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366781306/6e724cd66b82e4c9a06f39840d0276d8-1730301590"
  },
  {
    "email":"i.anna@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366814074/0188211e4d79429ef418e9ca1ff83c39-1730301590"
  },
  {
    "email":"emilia.bucciarelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366846842/47c57cde82f1e7945477ef11e6b1e85e-1730301590"
  },
  {
    "email":"bottarellilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723366945146/49f8658412625f3cf8a7ef7f844bb7b2-1730301590"
  },
  {
    "email":"f.pizzuti@ing-pizzuti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366977914/89f6f2ec1a3b1c9ea2a8f83226cd3bb9-1730301590"
  },
  {
    "email":"bentivogli@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367076218/c349cd868bd08bab7ede1241708b8ef8-1730301590"
  },
  {
    "email":"irenescrivo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367141754/7c41a731d9c9ae76af39cfda0cc61045-1730301590"
  },
  {
    "email":"katiavizza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723366879610/37bdb8aa27101ccb24b7a35f57014594-1730301590"
  },
  {
    "email":"ritamg090277@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367174522/b14834237a31abfe0050999eb566e7b9-1730301590"
  },
  {
    "email":"chiara.c80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367207290/7264f097fee832557b82e3a46d2e0cc9-1730301590"
  },
  {
    "email":"vero.cavalloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367240058/374d3f3443d2950e963b9f428c1a6c51-1730301591"
  },
  {
    "email":"laurab_73@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367371130/6b1d9832802b8c6d2c79079f94706963-1730301591"
  },
  {
    "email":"a.dalete@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367436666/ff595acd5a10a6f0e225282589beb395-1730301591"
  },
  {
    "email":"lamicky1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367469434/3c55ab3aa319cf8ac8d61e0c433c5e38-1730301591"
  },
  {
    "email":"versalliclaudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367338362/3ef3c416a6e32623a15e2b3152e77f16-1730301591"
  },
  {
    "email":"ornella.3@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367403898/3af51c89fb17be831232ab8fcd52d550-1730301591"
  },
  {
    "email":"nadiabalduzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367502202/b4e1944f0e0418d9153b1f30f6c99a36-1730301591"
  },
  {
    "email":"elisabettaquattrocchi6767@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367633274/a9ff2420df0b35f606133afedfb864e7-1730301591"
  },
  {
    "email":"angelagreco75@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367534970/10fefb343c729873a582135e40fa03bd-1730301591"
  },
  {
    "email":"elymargon72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367600506/7295b4d34c820ddd7e02a749e3c58bf5-1730301591"
  },
  {
    "email":"valeria.antonietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367698810/c949212be6960fa9c652faa0c2165817-1730301592"
  },
  {
    "email":"mbruno1951@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367764346/488f7347a4d5274198d260f26f996818-1730301592"
  },
  {
    "email":"daniela.sibiri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367666042/dd326e4757e1d66009fcda4be2cfff62-1730301592"
  },
  {
    "email":"oriettagarassino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367731578/6b298b51f08a22dca6f2f701970fdc5d-1730301592"
  },
  {
    "email":"enza.simonte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367829882/389d53f736273a26ea502006eb52bdb5-1730301592"
  },
  {
    "email":"esiddiscuola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723367862650/edf3e81c4fc5a5bfb798a2051c4e487b-1730301592"
  },
  {
    "email":"brunabalducci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367928186/c5b5f69cc2a13a3cebf3d135277aee78-1730301592"
  },
  {
    "email":"terry.ambrosio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367960954/15beb72ac1e01782641a2ffc0076cbf5-1730301592"
  },
  {
    "email":"durdenlaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368026490/2c8e90c3a87ddb10a0e12a2460c65832-1730301592"
  },
  {
    "email":"cassanogiu@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368059258/5f8ed1873544d1fc109bf48e386f2e5f-1730301593"
  },
  {
    "email":"ingrid.scaramuzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723367797114/25ed2189decccd9eac0494922df11754-1730301593"
  },
  {
    "email":"daniela.gravina68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368190330/ce5eacc2f91e2407f378f012bbec3dd8-1730301593"
  },
  {
    "email":"vigoannina@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368092026/a3ac22c38f78a0d05692bb243ca551de-1730301593"
  },
  {
    "email":"annamariacasaburi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368255866/73619e98fcea68ea85eaf20226b84cbe-1730301593"
  },
  {
    "email":"moira.bigiarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368223098/31f1319aebe29ba5c79a6f045eb9bd65-1730301593"
  },
  {
    "email":"claudiaeffe@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368124794/3bcd8cd27640743887d4e2c5f885c27c-1730301593"
  },
  {
    "email":"eleo.vannini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368321402/0ed00e7493c6e377e87c56916832c5d5-1730301593"
  },
  {
    "email":"olga.trukhanova@uniroma1.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368354170/1441a91c76bb5386a5b7ddd2025c54ff-1730301593"
  },
  {
    "email":"r.acconcia@ecomap.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368452474/dccfc3df9d2c806217d29c220f15baeb-1730301594"
  },
  {
    "email":"lorenzoricci3178@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368485242/5775fae9e56f5cb9782c00419ef9fb82-1730301594"
  },
  {
    "email":"gioelepavani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368386938/1575892d45bb7888a206afb9daef74ed-1730301594"
  },
  {
    "email":"r.gamberi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368616314/24b2696c062c3084f4e91b4747398144-1730301594"
  },
  {
    "email":"giovi.catalano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368550778/0c88930453e0e8a3e88c5c2e2b95d731-1730301594"
  },
  {
    "email":"elenaennati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368518010/771f9236b155409e8afe725c06b3ab95-1730301594"
  },
  {
    "email":"beatricenenc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368714618/cfb1fef2b1f04cf7f7d5021acefc1104-1730301594"
  },
  {
    "email":"soniaparisi1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368747386/0d6ec1a78d66168676e8cdde3e7adae7-1730301594"
  },
  {
    "email":"vale3112@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368681850/7de7cb475180847105579efe1cab000c-1730301594"
  },
  {
    "email":"sandrabonso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368649082/933aad1e3738f7a2cf820744971c6285-1730301595"
  },
  {
    "email":"vincenzabaffo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368845690/52df101bb10ae14c04218f26a208631d-1730301595"
  },
  {
    "email":"albertascaglione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368878458/b8f18c8f0ce21d979dbe4a70ba9b7404-1730301595"
  },
  {
    "email":"pamela@mode.srl",
    "url di attivazione":"https://verdissima.it/account/activate/22723368812922/8638bf38c48b684a5b34bae10cdc78bb-1730301595"
  },
  {
    "email":"antoniettamauro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368780154/ec28ddb6ed2838af9b24fbcbea67a52d-1730301595"
  },
  {
    "email":"stefania.l@eiko.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723368911226/f28da76ae3119235d0f01d5297ef16c3-1730301595"
  },
  {
    "email":"venturieritatiana@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369042298/b2b334edbdf0becca140aaec89dbce1d-1730301595"
  },
  {
    "email":"fabiolapavia46@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368943994/153b18e7eec0616251936f25be9ffa34-1730301595"
  },
  {
    "email":"beatrixdelmastro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723368976762/f096c8cddf0130e9ecc7c8724322ebb2-1730301596"
  },
  {
    "email":"idanassa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369075066/2a1b5b30e47e029e6611529ece549dd7-1730301596"
  },
  {
    "email":"mariarosaria.grazioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369107834/aff139886a538246b412c26f1af68db8-1730301596"
  },
  {
    "email":"fortinispini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369140602/5b1aff137633fe3724bed1b5a4db052e-1730301596"
  },
  {
    "email":"eva78311@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369206138/21044bb386494608e84b8a44e72fd700-1730301596"
  },
  {
    "email":"silviagiunti69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369271674/7fef409aa6194d713176acb7ea102903-1730301596"
  },
  {
    "email":"barbarafilosa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369238906/2e328b192ee98743b9f768ed317263c9-1730301596"
  },
  {
    "email":"cecimaio126@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369369978/7100773e815380cccbd7e05462c4a565-1730301596"
  },
  {
    "email":"cassanigiovanni70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369402746/2055ea3932b0f4fa7fecf862016fc921-1730301596"
  },
  {
    "email":"claudiagolub@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369435514/cffb8307254912d5237ffb6f7057c3e4-1730301596"
  },
  {
    "email":"paotel6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369468282/2c3355fc0fad1beee3a18d4f7da3f14d-1730301596"
  },
  {
    "email":"luana.tattesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369304442/c0ff1a4b096e95a5097a15d69b7b083d-1730301597"
  },
  {
    "email":"mariabruna80@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369501050/da4f883ef2e692cebc6121b4e9b284ba-1730301597"
  },
  {
    "email":"farmob@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369632122/67b783e04a471a010107dec241c88308-1730301597"
  },
  {
    "email":"ladybarby70@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369664890/588f0ab6eeda0df1efd33349bfff4de3-1730301597"
  },
  {
    "email":"ariaottoveggio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369730426/51d04098fb9ece5034b821fd877f141f-1730301597"
  },
  {
    "email":"prettyjea@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369533818/aaddc4b3122c1e4dda64fb97b76ea7f3-1730301597"
  },
  {
    "email":"martina.sabbioni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369763194/5557412514178cb98cab8c992acf2f1f-1730301597"
  },
  {
    "email":"guida.greta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369795962/584f0ebc4d5be1079fc35f2d1dd3b3db-1730301597"
  },
  {
    "email":"valentina_mancini_mi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723369828730/4aba1c24089b3ae6b77f0dfdcb2dc705-1730301597"
  },
  {
    "email":"francyvanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370025338/410b2e7428eb880acdb01126b2faf080-1730301598"
  },
  {
    "email":"cinzia.zorzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369992570/340c3ca093a46395cbe59b7735913cb3-1730301598"
  },
  {
    "email":"massimo.rella@slfreddo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723369927034/c259d5275e66aa2723d2e9c01b714c18-1730301598"
  },
  {
    "email":"ponchiettiale@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370123642/6586808104d551b14596ed0d6919288a-1730301598"
  },
  {
    "email":"pl.antonioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370090874/f0f3f03a4eab6fce1e1183612618dff1-1730301598"
  },
  {
    "email":"manuela.alessio1719@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370156410/5f18bbc316ca70c543a6704a013151fc-1730301598"
  },
  {
    "email":"margheritamat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370287482/e1decf22f05a7fcbd86e7aee3b0d40fd-1730301598"
  },
  {
    "email":"alessandra.gandolfo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370058106/abe0eff131c7e743513c016004a9e8f4-1730301598"
  },
  {
    "email":"prenluna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370254714/e79956e97155df9b1ba72d92fcfe4198-1730301598"
  },
  {
    "email":"robertagaligani@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370353018/160b3ed81b7ea412e5ebe1fc4dac6068-1730301598"
  },
  {
    "email":"emanuela.loi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370320250/0ccb5583e916ff7bf7838ebb0a2f8618-1730301599"
  },
  {
    "email":"katiakelly9210katia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370418554/b7af20b5ab22af884f50a4c00ae42e7b-1730301599"
  },
  {
    "email":"sangiovanni.t@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370385786/3372fb809a3c54a6d5d35bab69fb041b-1730301599"
  },
  {
    "email":"ad@legist.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370451322/8e0091713e6eb00cd77de594590d94ef-1730301599"
  },
  {
    "email":"silvia.derose@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370484090/94c3965e30938d45b7f65485d910dc82-1730301599"
  },
  {
    "email":"avv.veronica.castellano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370582394/e8df0cf161008e2d2ffc840e9813cb21-1730301599"
  },
  {
    "email":"poharelisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370516858/498e2e078a2b68b6959ce7de8a8ec268-1730301599"
  },
  {
    "email":"genius.alessandropoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370647930/ebd7a81318e367ea2b4c0ab7c7e0a81e-1730301599"
  },
  {
    "email":"belinda.p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370713466/10a7e653d9fb191197dcf7abff455d8b-1730301599"
  },
  {
    "email":"stefania.bergamaschi@bancagenerali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370811770/6022ce0abfeffca478c9a65897c9af64-1730301600"
  },
  {
    "email":"carolinebossut@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370615162/23894a22288ec63d241bf58fdeb1bf7a-1730301600"
  },
  {
    "email":"sonialuzzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370779002/f2d36b91c09afdc14a9be5c39501fcf6-1730301600"
  },
  {
    "email":"luisacerea@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370680698/9e89ffbb02b2fdc493893d06e7456355-1730301600"
  },
  {
    "email":"cristinatei70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370844538/ea7c3e2d1d1fa97194013b42dfc6d4da-1730301600"
  },
  {
    "email":"paolaf030764@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723370877306/23dce2006706268b7134d7616ee11f21-1730301601"
  },
  {
    "email":"micael.mic@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370910074/e6264596f3f1e711ead12823a5673688-1730301601"
  },
  {
    "email":"mony_710@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370942842/59dfd87120191e312869a4d08a1a11da-1730301602"
  },
  {
    "email":"paolorusso1986@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723370975610/4dbb19eccdec177e4f5146c500a78ece-1730301602"
  },
  {
    "email":"deborasanti1404@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371008378/78e20eef668e489957c8479924ca527e-1730301602"
  },
  {
    "email":"laurasibi67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371041146/2659d4f5126a74e5db6b083ebdb5bb9f-1730301602"
  },
  {
    "email":"giusmala73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371139450/c84a87604b90f7619bcbd163aa3fbbbc-1730301602"
  },
  {
    "email":"straka@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371073914/b8d21edd79f6a74ec45fd051e8ba2047-1730301602"
  },
  {
    "email":"babihofmann@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371204986/8f8af53ff08054022c0b2edbc62d8439-1730301602"
  },
  {
    "email":"mikysin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371303290/d28a67deccf7a36808f7e01553d66c2b-1730301602"
  },
  {
    "email":"r.pic@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371172218/67b11a3427a72ff51a104f602776ca19-1730301602"
  },
  {
    "email":"luisa.dellatorre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371270522/f83e1d25f04e082a32eb6f510c035bf4-1730301602"
  },
  {
    "email":"edo.cunsolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371336058/b57ba1413ece38686cba75c1d224c858-1730301602"
  },
  {
    "email":"roberta.ghibaudi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371434362/4e1a860818d842ca0bcd29997dacdfe5-1730301603"
  },
  {
    "email":"apascucci@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371467130/737c7902c83a8eb39dae69badda90060-1730301603"
  },
  {
    "email":"castigliafrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371368826/281382968339c4306fb743ccbf4c1a88-1730301603"
  },
  {
    "email":"daniela.ruocco@tecnicafrigor.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371532666/a7bc874a7f25bb2680f2c44fcdbc6ea5-1730301603"
  },
  {
    "email":"elviracafasso73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371401594/aa8a1555d89c03fa4dcecd0085cfe19d-1730301603"
  },
  {
    "email":"teresa.morardo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371598202/05dac2531669a12401f404d1cd8909be-1730301603"
  },
  {
    "email":"mcborgogno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371630970/f44671e9b8e696b794288ba87cd233e2-1730301603"
  },
  {
    "email":"vannamica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723371663738/d360d637ca5025607c36f2041ed1aa9d-1730301603"
  },
  {
    "email":"laurapallone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371696506/436d3adbb37b2a00b184be9c25a12ae9-1730301603"
  },
  {
    "email":"carmen.cuzzupe@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371860346/a644f6846f7d5960f2f95afcddbbf7de-1730301603"
  },
  {
    "email":"alepuce@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371729274/c1e3a188cd529cc3e04bc205998eff77-1730301603"
  },
  {
    "email":"chiarabarlusconi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723371991418/a677e31c1c5da97b8fd937a0ead0d2ba-1730301604"
  },
  {
    "email":"s.bartolini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372056954/c653c80c4e1c1e3a39a675c9d8b1e2da-1730301604"
  },
  {
    "email":"francysollai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372122490/40705986f356061b315efbd0fafbd64e-1730301604"
  },
  {
    "email":"fracri1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372089722/306752c4892be9ccf698b298d8780d88-1730301604"
  },
  {
    "email":"alma.degattis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372024186/6f21a81dbf9da055b7ddebf3b6364727-1730301604"
  },
  {
    "email":"ale.13.mancini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372155258/1410b5452e9ccb46a2c6f62acd75a32e-1730301604"
  },
  {
    "email":"elenavanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372253562/20e7534af2aa896082ff6d56a8f1a8e6-1730301604"
  },
  {
    "email":"alessandra.toffoloni@studiotoffoloni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372286330/b7a0d51322f66a6b271e0fb5e25916e2-1730301604"
  },
  {
    "email":"antopinto64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372220794/f6c384a43c82023e83fe0f2abb53daa5-1730301604"
  },
  {
    "email":"chiara.franchi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372351866/55c6de5bb1fa61b0799f58faa82c824c-1730301604"
  },
  {
    "email":"mbonistalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372450170/7e55442b72585511ea1f925724e3229c-1730301604"
  },
  {
    "email":"rominagregorace@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372417402/5caffcc801e1a7b6353f4c6659f26d20-1730301605"
  },
  {
    "email":"piugrazia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372482938/33b460be490c774cbb81db05003242b0-1730301605"
  },
  {
    "email":"hermes30680@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372614010/803e93186d0041e66aa9f1fe8794230c-1730301605"
  },
  {
    "email":"elisabetta81@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372581242/4566219800bb90cf6b46f116c41fe15b-1730301605"
  },
  {
    "email":"morenazane@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372679546/e7481faf5314aedf037df2c61f74394e-1730301605"
  },
  {
    "email":"giorgia214@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372745082/4b3fee0deabbf5ddeb15f58bbaf3ae66-1730301605"
  },
  {
    "email":"rossella.dauria.maa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372384634/0986f48f19126bf0f4fbd3574afae8f5-1730301605"
  },
  {
    "email":"monachino.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372646778/bb04e667197bf9d2daa4a41fd484d948-1730301605"
  },
  {
    "email":"daniela.salin@znr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372908922/053eb58738208bcc1e9317269a87c31d-1730301605"
  },
  {
    "email":"barbara.brion@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372843386/9e70677d278d72f54a5bed5bea4389e1-1730301605"
  },
  {
    "email":"filomena.colonna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723372810618/8ab6cc586ef1428c1c62d4a99c784ccd-1730301605"
  },
  {
    "email":"jaqueline.gramigni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372941690/d2d4ead9e9ba57e673e6a48ad96c3c6b-1730301606"
  },
  {
    "email":"gior.mgg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373138298/e5beea5a36c64f459fd26a197bf033ba-1730301606"
  },
  {
    "email":"cenni.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723372974458/66a7c96efb4e1291fa1577749c51c047-1730301606"
  },
  {
    "email":"volleyanto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373236602/ac502dccf85f37d4409f774bead82ce4-1730301606"
  },
  {
    "email":"szenucchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373007226/c02d9d1b91a13228caf9ad054d780c29-1730301606"
  },
  {
    "email":"chiara.delevati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373302138/ed42974d0c9055b839ee83fc2f6c08e1-1730301606"
  },
  {
    "email":"orie.cico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373203834/af3c5b853d9eb599e7be8b9904359f66-1730301606"
  },
  {
    "email":"focafra75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373334906/fafbd11073f40d6bc96501055c9ff118-1730301607"
  },
  {
    "email":"francesca.babini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373269370/a9173b2824fd57cf62f3f34f3e0fc88d-1730301607"
  },
  {
    "email":"gialema.1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373367674/6353e37f39c0fbbf2875488289614ff5-1730301607"
  },
  {
    "email":"androx08@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373400442/3ac31a9c0cc0cae5f125eba997eee443-1730301607"
  },
  {
    "email":"antox_g@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373465978/bed091969271d4a9485702492c269236-1730301607"
  },
  {
    "email":"paola0603@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373564282/7b0f9e84fd4638b0bbbdccdef7c5f322-1730301607"
  },
  {
    "email":"salvatori.sabrina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373531514/9b745e0b6b6c4068474214df99d0624d-1730301607"
  },
  {
    "email":"simonaguasco02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373498746/ea65ce3e73b1681accdf430c970d2695-1730301607"
  },
  {
    "email":"giusy.emmolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373662586/5d7601da2eaaacbc503cd074c73f87a6-1730301607"
  },
  {
    "email":"alessia.stiz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373629818/8496dbb0c3bbfd0183c07a3738029c79-1730301607"
  },
  {
    "email":"dilocar77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373695354/555eee954e42fd7e915cff4331dd9d99-1730301607"
  },
  {
    "email":"criortolano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373597050/4c45c365d08107e0f5255427dc4dcc6c-1730301608"
  },
  {
    "email":"daminosara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373728122/175a8b981feea4144df94ca0721f0ac3-1730301608"
  },
  {
    "email":"rossellabelsito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373859194/33bc56f8dce334b2bd1818119752cf75-1730301608"
  },
  {
    "email":"daniotti82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373891962/a0c7fda9a9c9b74dfcb983c4d78f7fcc-1730301608"
  },
  {
    "email":"chiara.badavelli@premispa.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373760890/4a0561bfdb082605f2cfbab73407d61d-1730301608"
  },
  {
    "email":"lotesoriereantonella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373826426/fa29e95b30d60f4fa68b9db87246346b-1730301608"
  },
  {
    "email":"angela.lotito@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373924730/54f970a308df01f5e3f0fd40c79a46d0-1730301608"
  },
  {
    "email":"ilaria.prato76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374023034/fc80dac7979aa811726b04e53959f384-1730301608"
  },
  {
    "email":"sunny3@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723373990266/79d95b7ad89f59ef17c0516c04841a1d-1730301608"
  },
  {
    "email":"marikabs47@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374055802/a9f8e4aea18d42446c01a4da919e3e19-1730301609"
  },
  {
    "email":"heidi.klara.strobl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723373957498/94e20b3042fd0795b030a0afdf4b0e7c-1730301609"
  },
  {
    "email":"gughesia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374088570/62abb1c4302fbeee4df67db648c4fa5c-1730301609"
  },
  {
    "email":"p.chiap@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374154106/2ccd87f9b8609428ee28ee50d61f7d9b-1730301609"
  },
  {
    "email":"precisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374186874/c252ccc043e72ece832b94c27dc36b29-1730301609"
  },
  {
    "email":"calymelis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374121338/9ad4f32c337057e27c857f08839a064c-1730301609"
  },
  {
    "email":"barbarafichera57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374219642/1d1c0b8a66785300402b5732f9ab3a9a-1730301609"
  },
  {
    "email":"albaguglielminetti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374317946/11b1397a05789de1a57051be8771f02d-1730301609"
  },
  {
    "email":"marina.oliva@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374285178/a2710e3b87eba97ab919aa5266663732-1730301609"
  },
  {
    "email":"gangalemf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374252410/32f0a6b6a4a8fbd8b8b40af1ee4ad868-1730301610"
  },
  {
    "email":"marialanotte@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374383482/e60b81f1d0f5a8cf1e2be1f6c556da7f-1730301610"
  },
  {
    "email":"domiminniti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374416250/4baa435a8f18800dc6a7c45e0b0b6db6-1730301610"
  },
  {
    "email":"celesteprof11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374449018/f347db5d6d1de9478b0b4625378e2738-1730301610"
  },
  {
    "email":"zanchetta.elisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374350714/e55a8279e42cccee5c53310104e9c527-1730301610"
  },
  {
    "email":"eleonora.ricci@atlantide.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723374481786/147c9c959643668dd770e64da3e9a848-1730301610"
  },
  {
    "email":"francescaprone85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374514554/515cb81cb292727b4f4585f481283d41-1730301610"
  },
  {
    "email":"nicolavernici@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374547322/c131d2901ddbe13d255ece7c3517a99b-1730301610"
  },
  {
    "email":"antiloanna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374580090/74c8bcf3acb6b36290cd37bd4ef464ad-1730301610"
  },
  {
    "email":"s.murdocca@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374645626/9877e5c5593f0d512883b8796b95457d-1730301610"
  },
  {
    "email":"corinne.s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374612858/74fde7cf7a809eed6db17598908217f7-1730301611"
  },
  {
    "email":"studio.vecchiotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374776698/f39194d2258e416c42ca4753f9401268-1730301611"
  },
  {
    "email":"stefania.zuccarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374678394/98daa1303dc9617b090c8afe418d5f3c-1730301611"
  },
  {
    "email":"marghe.me@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374743930/9b8d376257765c56e4208a8692376ee6-1730301611"
  },
  {
    "email":"antonellabianchi4@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374809466/78d64e8c1f806c65dd12efb4c0425391-1730301611"
  },
  {
    "email":"elisa.basso@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374875002/df01dfff1ec036866934addc89887f68-1730301611"
  },
  {
    "email":"sarahmantovani79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374842234/f73317848c869acd00f93b6ede711957-1730301611"
  },
  {
    "email":"linda.dl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723374907770/1fe9df09c0eccb09ed3dcc11cb01617c-1730301611"
  },
  {
    "email":"laura.fonzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375006074/7a71ae8d61462990f001e32c08cdb06e-1730301611"
  },
  {
    "email":"elena.elenabre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723374940538/f7581c7aeb9225903fd8543b0e71be9e-1730301611"
  },
  {
    "email":"erikazona@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375235450/45e7915d355013a221d0357f164ef9ba-1730301612"
  },
  {
    "email":"frattini.roberta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375071610/dac40fe6f2372ca0c034895765756bc3-1730301612"
  },
  {
    "email":"rossi-viviana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375366522/f2858ecc2e8acd1aaade35450f254165-1730301612"
  },
  {
    "email":"lilianagianti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375104378/2712b14088ccef23b74ba08f28c31fdb-1730301612"
  },
  {
    "email":"annamaria.eli68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375038842/80ae9cd18738051f731739e6aa9c45b5-1730301612"
  },
  {
    "email":"filly.torino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375432058/b14c30dd4e7a5316ca1685318741a162-1730301612"
  },
  {
    "email":"simomatte7@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375563130/5de5ebf983b934e04f48d99a08433554-1730301612"
  },
  {
    "email":"lauravinerba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375595898/cad0e85d2826276cbdf05902cc071055-1730301612"
  },
  {
    "email":"marfili.cioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375399290/4c168baaf0bad91a57985c07f083c276-1730301613"
  },
  {
    "email":"giusipilu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375530362/c27c93f9eace6da4d9b2695f3bdf0354-1730301613"
  },
  {
    "email":"d.carpino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375726970/efe6a3be8f0829448a2938a90407d2dd-1730301613"
  },
  {
    "email":"laura.dangelo1988@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375628666/d2d24992c7c18a7f6e5526402c5e824e-1730301613"
  },
  {
    "email":"cspate@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375759738/44044bf3e981ee15fcd8964ca0f4ff36-1730301613"
  },
  {
    "email":"sofia.marinelli@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723375694202/70b94aa91dfbf735659d67eb5cd3aa61-1730301613"
  },
  {
    "email":"filomenacolleo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375858042/3853e16ce4753c974d393858fcce2b5d-1730301613"
  },
  {
    "email":"ideexlatesta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375890810/e9efb290d42fccc883fc2c7eb7d74884-1730301613"
  },
  {
    "email":"ale_34@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375825274/0c6625c518c465ec79b2778af37b35d7-1730301613"
  },
  {
    "email":"agostamarta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375956346/728ef795cfcb7fd44aa3ecdcc3cf5ab3-1730301614"
  },
  {
    "email":"clara.ducoli@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723375923578/281962411d607b7cdab53b9fb2d4095f-1730301614"
  },
  {
    "email":"laura.stella@studiomotta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376021882/ba6083c8e909f21ba128d231f5fe98fe-1730301616"
  },
  {
    "email":"elisaferry82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376054650/1418081288750ca3efb443614ae16682-1730301616"
  },
  {
    "email":"vanessa.sperati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376087418/f64c7cd53927e63d202cd9b6250f69fe-1730301616"
  },
  {
    "email":"domi.dubuis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376152954/28edff39fdd02c9fac1aa2e601612ddf-1730301616"
  },
  {
    "email":"martanicoletti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376218490/0d441fcd1779fabb057a735fd9e8605f-1730301616"
  },
  {
    "email":"martacrivello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376185722/5458a217e26a1a84aa2df94c4af8817e-1730301616"
  },
  {
    "email":"angela.plaitano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376284026/842ab00300f414c811e92be819533c2a-1730301616"
  },
  {
    "email":"concettamangini83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376316794/87fe1755147c2c2d84a27b71a0195930-1730301616"
  },
  {
    "email":"arch.angelabasile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376382330/90bd6b664042d23bab7d9463fc60eb56-1730301616"
  },
  {
    "email":"mail.sara.bianchi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376349562/ed7a52551073b0fadfd387acacf8a559-1730301616"
  },
  {
    "email":"viti.erika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376447866/5a0f657bab3f7ffee452dc8d5f669cfa-1730301616"
  },
  {
    "email":"sammy.fiocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376513402/380f32d948b00c315ef811fee9a19c3f-1730301616"
  },
  {
    "email":"cabisalvina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376611706/7742729e32da2d4dd48bfb132e411cd0-1730301616"
  },
  {
    "email":"robi.ale@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376644474/2a157dfcd20085c6aeceec34432dbdc1-1730301617"
  },
  {
    "email":"bandreini@globalblue.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376710010/0c473ef3fa1d1d41c60ae8c3be9a8faa-1730301617"
  },
  {
    "email":"delorenzo.manu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376578938/4aad6a3e60af07f1d2c643bb381a260a-1730301617"
  },
  {
    "email":"ilaria_parata@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376808314/005798cda5f8739c4ee883daaabff032-1730301617"
  },
  {
    "email":"bonardi.maria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376841082/cfb43e510da946b1be79c76dc9b6155c-1730301617"
  },
  {
    "email":"marina.mogni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723376906618/03feaee9e38eb09e702cc063d4dd26a3-1730301617"
  },
  {
    "email":"arianna_mussolin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376939386/8e0c6b1c9d6ec59289eafece45a5e328-1730301617"
  },
  {
    "email":"annarita.cacciurri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723376972154/e195ae469689d489c567da8d60b8d60d-1730301617"
  },
  {
    "email":"marco.giuseppe.tamburella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377103226/94e1b5b434a767b12d549c3004e45ac9-1730301617"
  },
  {
    "email":"62vanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377070458/8a2e815091c4f702e1186b6b5ea2cc7d-1730301617"
  },
  {
    "email":"sandra72.vannini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377135994/6000c89de5f4235cf3c77c7eff7d68c4-1730301617"
  },
  {
    "email":"claudiacavallini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377168762/269e37a97c0effe5522afc6367f7effe-1730301618"
  },
  {
    "email":"martini_laura96@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377234298/e5e647ee47c5bbd21f75b98acf265df7-1730301618"
  },
  {
    "email":"simo.gorla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377299834/8c56dda129fa96a86a4b66f5bb90a711-1730301618"
  },
  {
    "email":"marycaroso@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377004922/8b7c87d6edbe32aa69298db0cc9161ea-1730301618"
  },
  {
    "email":"zaninottoketty@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377332602/17a6f05e1af636c51dd85202d7bdf8b3-1730301618"
  },
  {
    "email":"carlottasandon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377267066/fb56f5655d2d30e2256512e0c9d5886f-1730301618"
  },
  {
    "email":"de.maio.elena91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377398138/a73f58638d286a7911c1fdc4957e130d-1730301618"
  },
  {
    "email":"viviana.camozzato1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377430906/e9d09f9298da16090f27275d44ac9cb0-1730301618"
  },
  {
    "email":"melany1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377463674/68a1a879c54f28b80bf8052f12dee639-1730301618"
  },
  {
    "email":"rodima@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377496442/1bdf288488c66eda6100a1d8420b245c-1730301619"
  },
  {
    "email":"giova.bartoli22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377561978/4e8f6c56af95e97626e4f6a91b398df9-1730301619"
  },
  {
    "email":"donatella.depaoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377627514/1ad0ed891213c23551b0e0a95d821ed1-1730301619"
  },
  {
    "email":"caiellasonia66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377594746/9869bac4000ce5168f44c986f6d72868-1730301619"
  },
  {
    "email":"ilariagalloro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377529210/cc02a6cae4aa6ba192a528ff21d5d7f0-1730301619"
  },
  {
    "email":"pilli_smart@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377693050/aebfec0bc5a7f7bd4e1fcfe539f21c6c-1730301619"
  },
  {
    "email":"dariatango@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377758586/b16c0cd2809c31ba32f5a2fabe87695f-1730301619"
  },
  {
    "email":"borghi@liquidflora.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377791354/d037cf8001a4c7350a7c59a81b89f6b7-1730301619"
  },
  {
    "email":"andreabrocco@proiaepartners.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377725818/661617086fc93c5b216d4f5ef11f9ab0-1730301619"
  },
  {
    "email":"teresa.geminale@exprivia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377824122/a363ba94669458b25e35a1aa1aed25d0-1730301619"
  },
  {
    "email":"giubea2002@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377856890/1a93d60a646b3f985cc68374b033070d-1730301620"
  },
  {
    "email":"m.rosarias@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723377955194/241d36118cf6de877d4fd09723a615a4-1730301620"
  },
  {
    "email":"benedettapestelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377922426/8690f2d4b80f7cf886388e2ad040130d-1730301620"
  },
  {
    "email":"molinari.acconciature@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377889658/4522c4e3b2db7ea5b89c99ae031d248b-1730301620"
  },
  {
    "email":"dorihandmade@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378020730/292793862b06d66a6ac8a789961571de-1730301620"
  },
  {
    "email":"dani.tvb07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378086266/5315af60eecb4fee2f5c464100dacab9-1730301620"
  },
  {
    "email":"franci25franci25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723377987962/7b73fe2e596708029b7d95b805105523-1730301620"
  },
  {
    "email":"laurita76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378151802/7edd1e0af14d60704c4f85c348f5a71a-1730301620"
  },
  {
    "email":"michelaperino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378119034/2034534c5255260491b7b50c53fdf8bd-1730301620"
  },
  {
    "email":"monica.canossa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378250106/8cd163619ec9059ff8d23d79f4ccd1de-1730301620"
  },
  {
    "email":"erna.fink@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378184570/08e7d3b86c40bd78a01f5431e2747f65-1730301620"
  },
  {
    "email":"silviapbruno21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378282874/6d32026f4dd44a8a15c3f1f25f076e23-1730301621"
  },
  {
    "email":"lorideluca76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378315642/58f7a52e8b7a610f72dd41845d909d97-1730301621"
  },
  {
    "email":"blancogrigio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378348410/74cad85933a46a53d32de13444e806c9-1730301621"
  },
  {
    "email":"filomenacinque@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378413946/3b4b21564c61c3e81b898f52c141b74f-1730301621"
  },
  {
    "email":"larapezzolato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378479482/1a96b554bc7d60c950fe8c4656ef63c5-1730301621"
  },
  {
    "email":"rzoppitelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378446714/063a617e215bddfe0089ea7a12f36ed1-1730301621"
  },
  {
    "email":"lisa_co79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378577786/3c218feabe991c36478b7df9cfbe0e0e-1730301621"
  },
  {
    "email":"mario.grespi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378381178/743e90792a2449cb189b9500d261015d-1730301621"
  },
  {
    "email":"ferroccif@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378610554/86d471b13396f1df3cb41d26e5244629-1730301621"
  },
  {
    "email":"cristallina1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378545018/b11f05b1ac8b85cba19bc41cee85d80a-1730301621"
  },
  {
    "email":"monica.dellomo@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378643322/5314ecbeb46a835fdd2107d1685c6302-1730301622"
  },
  {
    "email":"simona.delutiis@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378741626/19647681b13c185ca584780ce8eddec7-1730301622"
  },
  {
    "email":"larafalcinelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378708858/ee636318b846d3d41ed7be12b27eb5ca-1730301622"
  },
  {
    "email":"ecapozzoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723378774394/44a1dbb81d0c10847ef3f079e60b4458-1730301622"
  },
  {
    "email":"pm.pasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378676090/37b27c065057e9f2abc479d07c9b4a2f-1730301622"
  },
  {
    "email":"angelainverso73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378807162/2a0f9a348de4ca392924e38118861016-1730301622"
  },
  {
    "email":"beatriceboglio81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378839930/ebe4b18b18f0555b0a354e56f5f5ee62-1730301622"
  },
  {
    "email":"bar.boccon.divino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378971002/dfd61f572e2ad3a4af9ef7557a5e8816-1730301623"
  },
  {
    "email":"rosanna_craba@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723378938234/57ed2ea07e96e646090fbc78061f0985-1730301623"
  },
  {
    "email":"simona@logicaprogetti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378872698/79763b0524edaeef66dbc9412f49fcb6-1730301623"
  },
  {
    "email":"aronaccetturo@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723378905466/29a1966cd61132e522427447219c6b26-1730301623"
  },
  {
    "email":"nadianardini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379036538/d64ea791016af6a135e9c82a46a4455f-1730301623"
  },
  {
    "email":"berardi.el@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379167610/13286e187b025909994e8b60e1617f2a-1730301623"
  },
  {
    "email":"info@ilbaronedelmare.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379200378/079aea22a06103a20681a038ce0da836-1730301623"
  },
  {
    "email":"amata.elisa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379003770/d2322a8ae0c2d9af210c58b796a018b4-1730301623"
  },
  {
    "email":"guglielmiky@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379233146/10c41df96583f46a3b9bf7f938450b2d-1730301623"
  },
  {
    "email":"lorenzacanedoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379265914/4d5c07750c5126185593ac8dad484f69-1730301623"
  },
  {
    "email":"martaperoni.vl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379364218/9c588fa281d0f37be03e86a7f5a09f2b-1730301623"
  },
  {
    "email":"fedy68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379396986/dcac2b073f2ad7f09fed008da8dd098b-1730301624"
  },
  {
    "email":"roberta.lusardi@enel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379429754/73aeae30e88723670c4a31d628225be9-1730301624"
  },
  {
    "email":"luigi.deluca1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379462522/ed69d295384ee76ae463a5c0660d20c1-1730301624"
  },
  {
    "email":"zazzirenata@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379298682/54ddb5522d75c030bd33826745210a9a-1730301624"
  },
  {
    "email":"antonellabartoli0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379593594/ccd92d62e0d77a6c8876a48a0b372085-1730301624"
  },
  {
    "email":"silvanan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379495290/2ccb28512d6a131a070c7d1e59fcacb3-1730301624"
  },
  {
    "email":"benedettapaulesu@libeto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379659130/440dabb2ee024d80a49a24cc7241ee7d-1730301624"
  },
  {
    "email":"lorybeth@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379626362/92d4644ed71519300e1dd021bf4d12c8-1730301624"
  },
  {
    "email":"lbarsanti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379757434/b6a3aea3dad93c840d75e05f05cd8af6-1730301624"
  },
  {
    "email":"csibilano@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379790202/1b6de554238768150d29025b82a908ba-1730301624"
  },
  {
    "email":"tecnico02@promac.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723379822970/f8858deadf4a61adf2e1cac27f42fff7-1730301624"
  },
  {
    "email":"tiziana.audino.to@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379691898/e9a974fb6bb46d185ba757a9e49603fb-1730301625"
  },
  {
    "email":"cm.tina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379888506/89b0a51053eefb5456d114e5c4c21c3c-1730301625"
  },
  {
    "email":"mrindaco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379921274/8d5c0a7d40345da1cd921804c20014db-1730301625"
  },
  {
    "email":"giulia.de.rossi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723379855738/ac9e495f74338b0b00e1dd82860c7d46-1730301625"
  },
  {
    "email":"francesco.armeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379954042/1842ad87c8af5276f29bd4157b66b694-1730301625"
  },
  {
    "email":"silvia.ricci75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380150650/5df9d8021f03587139207b5fd3882d61-1730301625"
  },
  {
    "email":"pajata@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380117882/ae44ed02a2c166832caa695d46719c3a-1730301625"
  },
  {
    "email":"defrancesco.nives@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723379986810/8dfb8b0eb14307cf89decb462e9efad9-1730301625"
  },
  {
    "email":"bonnie73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380183418/34119d4aeb7eee90e76e998b95338367-1730301625"
  },
  {
    "email":"m.dibon80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380248954/fafc9a5d0a5bb58e3eb555a109db8c1b-1730301626"
  },
  {
    "email":"chiara.guella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380216186/6086486ae7aa60a3d2bb802aaace49b1-1730301626"
  },
  {
    "email":"c.lacrisalide@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380281722/30f82b8fc730bb2b3e951198b0da5ffa-1730301626"
  },
  {
    "email":"rosselladiroma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380314490/2c1720e8ac72fbd90ab420b063be4ffd-1730301626"
  },
  {
    "email":"valentinarenieri.1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380347258/05ea9067f85367ca3ae01ee09cf6223c-1730301626"
  },
  {
    "email":"mariano.bonaccorso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380380026/654f60607a3dc433d2cb36eed1018352-1730301626"
  },
  {
    "email":"angelo.sabry80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380412794/c102ce13fcd40dddb3579e24df0e21c0-1730301626"
  },
  {
    "email":"bianquz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380543866/a6ac40bc1f861b2a190479b33d9ea545-1730301626"
  },
  {
    "email":"caterinaantonella.pacileo@giustizia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380511098/55dd3f62c52da04208d9d8595edcadb1-1730301626"
  },
  {
    "email":"valentina-appetito@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380576634/5cd01b587641cc132c5132e8c83cdf1a-1730301626"
  },
  {
    "email":"oriettavo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380642170/51ef2a300d86f2b452698eaf2fdf30e4-1730301626"
  },
  {
    "email":"marialuce_colleluori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380707706/1b7b0fb8e7c20ab6f6ee4dc967990ccf-1730301627"
  },
  {
    "email":"sara.musardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380609402/35f81083a88fd119ced661cf6ee03fd2-1730301627"
  },
  {
    "email":"matilde.crevar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380773242/35799eb3d56ef27e262cf75571ba1217-1730301627"
  },
  {
    "email":"sara.tonlazzerini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380740474/208737eb557cf8e1547f740c1acc862b-1730301627"
  },
  {
    "email":"fynvolalehunteward@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380478330/8111bd59fc24e6b7c5675082cf56e3d3-1730301627"
  },
  {
    "email":"eugenia1.mc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380838778/b772780d90c2e68723e83972162ae2a2-1730301627"
  },
  {
    "email":"cangianovaleria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380871546/1f95ef73ff4b45652dc0a5302f453d8c-1730301627"
  },
  {
    "email":"alessia.ceol75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723380937082/e3e2d748f8b51a50ed8d49753c11d6ec-1730301627"
  },
  {
    "email":"vale.fedenri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723380904314/4c0ca010d5bc36bb1904ea1ab7426f36-1730301627"
  },
  {
    "email":"cinzia.radin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381002618/72d5c6d704c49e3017d7195c026ed22b-1730301628"
  },
  {
    "email":"manuelacz@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381199226/66af2e73eb2de2577e633418a38c556d-1730301629"
  },
  {
    "email":"mea.sole@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381133690/c97d81f34aec7ea481f5ef12d8fafec1-1730301629"
  },
  {
    "email":"francescamcdm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381068154/d7a2e0d9393dd833385b2864ee60d634-1730301629"
  },
  {
    "email":"raffaella@duesserappresenanze.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381395834/150f35e25077c13642c925a739b22c96-1730301630"
  },
  {
    "email":"sabrinagraziano2019@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381428602/beef2a31f66a0a8452ff1edb4024524a-1730301630"
  },
  {
    "email":"letyveneziano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381166458/e420fe91e31b6746121ce56a9809078c-1730301630"
  },
  {
    "email":"elisa_varani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381363066/8be91632180eae86a5ffdb59a703b005-1730301630"
  },
  {
    "email":"maristella.agostinacchio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381494138/9125422ae933af26b5a31b1475df142f-1730301630"
  },
  {
    "email":"ilariatesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381526906/369e91f903f829a50b7965414b4a4d40-1730301630"
  },
  {
    "email":"nicoletta.dallara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381559674/bae219dd4e3acf9dd65def97f41980a8-1730301630"
  },
  {
    "email":"selenescafi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381657978/56a50c7e609137a9a0cd341ae6210f91-1730301630"
  },
  {
    "email":"marta.meregalli@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381690746/fbead342942d6bc5a2cdef9efb68511f-1730301630"
  },
  {
    "email":"elena.mory@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381625210/3c0ad9ecb3a98a6ab588add41524bfae-1730301631"
  },
  {
    "email":"giusi.cim@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381723514/36457a7cb0bb7a712490bde73aba567b-1730301631"
  },
  {
    "email":"fiorenza.cavada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381854586/ee8995968d38c1e38267e86b890e5be8-1730301631"
  },
  {
    "email":"rosa.bandini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381821818/7e9ec9574105f017e29827e986255292-1730301631"
  },
  {
    "email":"galleryhairstyle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381920122/0765656741c80548437a4b817d07efb9-1730301631"
  },
  {
    "email":"antonellamaio1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723381789050/5468684717e606c015acb513fc0ad506-1730301631"
  },
  {
    "email":"campori.irene@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723381985658/5fd27fa6b39597f068a4007ce3bf3d8d-1730301631"
  },
  {
    "email":"saradibari.88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382083962/194c8b528f1f33eb013270f03550ca79-1730301631"
  },
  {
    "email":"anna.vignone@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382018426/9a7fcf02da7209e124a2beef4f7b6428-1730301631"
  },
  {
    "email":"leander_gogele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382149498/6ffb577cf96e1ab305c6ab768b221ec6-1730301631"
  },
  {
    "email":"forte.filomena74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382116730/641cb6cfa34e9c9c7fb103484495b3e2-1730301631"
  },
  {
    "email":"crippi.1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382215034/01660d3cb362f2757a6f21f5a3bba588-1730301632"
  },
  {
    "email":"tiziana@sumasrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382182266/3029c2edc1a26fdfafeefbc988c2acb0-1730301632"
  },
  {
    "email":"sonia.ricciardi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382280570/503332dc4ffc91ccd2194e3efa2cd86c-1730301632"
  },
  {
    "email":"fileziale@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382313338/ffa4db9e4a1c6fbc23808b330fc1d14e-1730301632"
  },
  {
    "email":"silviapasqualini7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382477178/90cc3bc30d66e223b16c9ebfc6fb1097-1730301632"
  },
  {
    "email":"daniela@bellon.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382378874/4e6237c05efdc838b8e3986c4fa1fa3e-1730301632"
  },
  {
    "email":"cristina.digianvito@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382608250/e115cf58b9835caa5b562ece70c88326-1730301632"
  },
  {
    "email":"viscom@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382247802/dd51556116f1d4a5f1fa687b447b1baf-1730301633"
  },
  {
    "email":"patrizia.clo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382641018/c9dc03c1b4798af8020bf7ef5220bf1d-1730301633"
  },
  {
    "email":"sabrinangeloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382509946/6d4fca83f0c380304f3b353a95b91812-1730301633"
  },
  {
    "email":"carantonella78@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382739322/682ef7b0b4aa240e88ad24318b532371-1730301633"
  },
  {
    "email":"app@elisapapini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382706554/01c995a63290c62636b09265ec8950b3-1730301633"
  },
  {
    "email":"claudiaf_9@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723382870394/853c9433da79584219da00364f692776-1730301633"
  },
  {
    "email":"n.freschi@rtsfreschi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383001466/29ba32f01d37094ed0bec6a0c861d373-1730301633"
  },
  {
    "email":"claudiabarbieri71@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382935930/ddfc3921c720eb6d685b110706177402-1730301633"
  },
  {
    "email":"studioimperosas@legalmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723382804858/5e8890a95a356b736fd990a6cb51f814-1730301633"
  },
  {
    "email":"raff3003@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383067002/bacb6713879fc55ea6f7be998078e3f9-1730301633"
  },
  {
    "email":"spezia.vito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383132538/6e9de7236e1564cf513b20ac6539fd39-1730301633"
  },
  {
    "email":"frizser@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383099770/464d7dce5724eb203e61b424357edfb4-1730301633"
  },
  {
    "email":"stefaniamaurutto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383165306/ccf0010bed4f90744c2f26fedbcfdf7b-1730301633"
  },
  {
    "email":"bebrbu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383263610/da4224d38cddcd5411d01876c30db0f4-1730301634"
  },
  {
    "email":"nicolettaughetti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383198074/166ef345df0e94d2eef6f556ada55f05-1730301634"
  },
  {
    "email":"danyreolon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383394682/86cc8c0a683ada174a2fe38590c02d0e-1730301634"
  },
  {
    "email":"simonetta1968@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383329146/72ce080c83f2a647c290fed5e5d36cd0-1730301634"
  },
  {
    "email":"barbara.martinis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383361914/3709180d1c64a8e7e095139352a68cba-1730301634"
  },
  {
    "email":"chiara.corvaro77@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383427450/3c3af3ba43261af43066b0c9e82f238d-1730301634"
  },
  {
    "email":"mihaela7947@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383460218/68327d0e1c42e6a20d5ffae556792ea8-1730301634"
  },
  {
    "email":"valemily@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383492986/d63359c91f241e44e5dc373cc082875b-1730301634"
  },
  {
    "email":"dottoressa.chessa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383525754/327b71e1343f05e89d9c882115931ac8-1730301634"
  },
  {
    "email":"g.mamone@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383656826/1f1d64197c38b25e631285bc0cc31858-1730301635"
  },
  {
    "email":"paolabassani@moobygioielli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383624058/a61ae2e5484ae1df794d55015b7511b4-1730301635"
  },
  {
    "email":"benetazzo.tiziana@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383689594/c602ae4a94b46ab6c4c67f57fad6607c-1730301635"
  },
  {
    "email":"nadiagned@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383591290/c054df5c271797b16c7ff78b989a21fc-1730301635"
  },
  {
    "email":"curziatortorella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383853434/6ed791138e5c30bb34efeb4a6fe4d642-1730301635"
  },
  {
    "email":"ale_zoppas@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723383820666/bebd3e383f1d910d82f70aaa1cbe0826-1730301635"
  },
  {
    "email":"francesca.u77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383787898/8b8bda2948e1f4db0f8642cfaee6b1ee-1730301635"
  },
  {
    "email":"serena.natale89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383886202/2695830fb88e0187d75d44d492828d54-1730301635"
  },
  {
    "email":"crinamarginean@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383984506/62575ab8d8503776ab2d51f1fe727434-1730301635"
  },
  {
    "email":"elena.paradisi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723383951738/798d021fce47f51980f642b629e51d34-1730301635"
  },
  {
    "email":"sandrannibale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384050042/a9e200da5e65eca82d2ad1dd06b3fb3c-1730301636"
  },
  {
    "email":"katiamadori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384017274/663c59652b62d6e57fe98cd4da914400-1730301636"
  },
  {
    "email":"sbrisciaroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384082810/92436c0641502fa29ea345cbbb96a6cb-1730301636"
  },
  {
    "email":"natoli.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384181114/d9987a631db63da6c4811c564329ea30-1730301636"
  },
  {
    "email":"angymary73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384115578/99e27ddf705d29b417e87fd56d95b619-1730301636"
  },
  {
    "email":"famed@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384148346/c113dd3c497548d5ab722ce30cd7e081-1730301636"
  },
  {
    "email":"s.scerch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384246650/e053f94ff5b5af17eef0297b6e141f85-1730301636"
  },
  {
    "email":"ale.gelichi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384279418/1b0b3f627213a1ea4297da4f1b65f83b-1730301637"
  },
  {
    "email":"serenapennisi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384312186/523a74937317c2fb2500c435f1161581-1730301637"
  },
  {
    "email":"cantinasanbiagiovecchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384377722/8014005b68140472db1e371bde655559-1730301637"
  },
  {
    "email":"kika@fivers.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384344954/32eb378e209da47b06a7894693f23cec-1730301637"
  },
  {
    "email":"aniagreco2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384476026/7a5fd2583f959d7585e8dbf513544633-1730301637"
  },
  {
    "email":"free.vivi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384541562/45b5e1445324d063c3e5990b8588f429-1730301637"
  },
  {
    "email":"stefytoriello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384574330/00ea4c6b59ca2b634f94d97978fbdbc5-1730301637"
  },
  {
    "email":"anjmanci@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384508794/5aa16739eca3984a65da6b68a6992435-1730301637"
  },
  {
    "email":"s.zugheri@findomestic.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384639866/3a18ed40d31f84999e5642e94a8bf63f-1730301638"
  },
  {
    "email":"serena.franceschi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384443258/b460726e4badc4427b8a1dc26c0272b1-1730301638"
  },
  {
    "email":"patriziamorganti@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384607098/bdd1d3c49f36453b62231f3874f383d6-1730301638"
  },
  {
    "email":"martachi94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384672634/5453d6b41fd00035c470341b16854774-1730301638"
  },
  {
    "email":"robertasacchella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384705402/2df2e4e0f52fe7b908003382fddcc094-1730301638"
  },
  {
    "email":"cristiana.tenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384803706/69219486bc80d7470c782a20001bd023-1730301638"
  },
  {
    "email":"muibiencica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384738170/1b48d88f96f7cb4834be11f7efb66755-1730301638"
  },
  {
    "email":"emilia.strada62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384836474/78a28fe5c10328dc713ddbcb35c81cfb-1730301638"
  },
  {
    "email":"michelecittadini8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384770938/f9c1712a0e685cfaa81fb434d8929c19-1730301638"
  },
  {
    "email":"antonella.nocentini@kemon.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384934778/f4869a26ea4194266ca18da5b3fe3908-1730301638"
  },
  {
    "email":"danielacorbo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723384869242/8339293c388782cdb6f8685a99476c98-1730301638"
  },
  {
    "email":"bisognigrazia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384967546/1bef01c62116825879c952f0a5c953f1-1730301639"
  },
  {
    "email":"nergi90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385065850/5c9b832ef8a5eacddc4c52af279e186b-1730301639"
  },
  {
    "email":"ppattj71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385098618/0316d213273854f15708700ae60a364d-1730301639"
  },
  {
    "email":"leoncina772012@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723384902010/96b3a5daf01b715604e8e5c6e3bc6ef9-1730301639"
  },
  {
    "email":"momeneo@progesoftware.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385131386/92914b8f56009051700ff43b554aa7e6-1730301639"
  },
  {
    "email":"mariarosaprato92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385196922/bdf2f27dedc631c740bfad488326a53b-1730301639"
  },
  {
    "email":"baratti.michela@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385262458/6b7cc35ff7604f12677d18fe503d4bab-1730301639"
  },
  {
    "email":"mariagrazia@pratichouse.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385229690/515f3a9484d41bde518fa984852e4f59-1730301639"
  },
  {
    "email":"bracalenteanita@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385295226/3eae75139d45f24f291eb5bec43c0f10-1730301639"
  },
  {
    "email":"cristinadebiasi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385164154/7ab7c3976b7b5c9683f69da2ee1b7a07-1730301639"
  },
  {
    "email":"mmartinabalestri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385360762/c1e8321ac0b9f85f6e48fca3a034d011-1730301640"
  },
  {
    "email":"vitale5@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385426298/426d734960caa2b5e0e5bbc8c99e6412-1730301640"
  },
  {
    "email":"marilela@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385491834/071d1704f7d6b1cc33e9e3318496c77a-1730301640"
  },
  {
    "email":"alleluiafratello@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385524602/493f48e1585205e8bc17ee5bb92fed82-1730301640"
  },
  {
    "email":"zanetti.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385557370/4fe65a7c77c5980d61c59ef7dfd6ff13-1730301640"
  },
  {
    "email":"maramic74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385393530/b2610ff37fdebb06381cc395d41f05e2-1730301640"
  },
  {
    "email":"tizianaspinosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385590138/df209344edbfe60e015c83efc5aa2c84-1730301640"
  },
  {
    "email":"lauralucchesi776@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385688442/f3b09ca89b467f7765292a1ad276025a-1730301640"
  },
  {
    "email":"giovannamenna@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385753978/473e1305f3e2fa2a6e7906d2a6ec85ee-1730301640"
  },
  {
    "email":"delduca.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385721210/e7e78d756c4401ec117672e16379c326-1730301640"
  },
  {
    "email":"enricoromeo43@gmasil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385819514/eba8600d503ccc8ec9aec6135e416ce1-1730301641"
  },
  {
    "email":"marinafantinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385786746/0a6c75fc1394515f8679a4b4fce6ea4e-1730301641"
  },
  {
    "email":"giovanna.pelu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723385852282/6db093be3afbdd776d58eb2d253cde12-1730301641"
  },
  {
    "email":"elena.lazzeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385622906/d468dc21c4223b9c3147494929d15acb-1730301641"
  },
  {
    "email":"alessia.antonelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386081658/0444ebd08b2ef9168b8db1ffcb9e357b-1730301641"
  },
  {
    "email":"lara.bentivogli72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385983354/4ea0f719b4eb37121fbd73c09afa132b-1730301641"
  },
  {
    "email":"mgiovannac@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386048890/00fe77fed0c8acbbbb29b0c4e509a2a7-1730301641"
  },
  {
    "email":"annasemeraro71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723385885050/451dc765c83c64201bbdf5ce3a5fdde5-1730301641"
  },
  {
    "email":"aromano_2000@yahoo.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22723386147194/7fbdd451c01aef67e06881e68a257a5f-1730301641"
  },
  {
    "email":"raffaellabulegato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386179962/0da79af45a31cda3b35aabaef48c9460-1730301641"
  },
  {
    "email":"amministrazione@cesarisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386212730/cb26edaac2afafda862ab15a20217e46-1730301642"
  },
  {
    "email":"pattygordiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386245498/299afdb2d5041f0857a7f4fcb84a45d4-1730301642"
  },
  {
    "email":"claudia.duregon@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386278266/41b314c4747242b5c5f53d5812c8d5f7-1730301642"
  },
  {
    "email":"grillo.damour@free.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22723386114426/061b3633010e45f7deb4235ce1d7356c-1730301642"
  },
  {
    "email":"fiorella2000it@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386409338/7b69a00f6f5b5036978db59c551ea8a0-1730301644"
  },
  {
    "email":"deboraputzu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386376570/aa853782f7cf26c9775578cf48e72f61-1730301644"
  },
  {
    "email":"laura.bertini@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386442106/f285a2b9e2a98435fc2f5f76ca7ccbcb-1730301644"
  },
  {
    "email":"fauziaemarco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386507642/51b3e87b4124e2df43281eb88286ee5d-1730301644"
  },
  {
    "email":"cf@blacksheep.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386343802/b728fbbe428850ad6dd64ef75a6e031f-1730301644"
  },
  {
    "email":"silvic@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386573178/8aa0624484c5f0c7e688c8ab04fa2e4e-1730301644"
  },
  {
    "email":"katidago@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386540410/6487bd076fe56e28ca78b8e5be0bad5f-1730301645"
  },
  {
    "email":"amelioantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386474874/b1ddcc6944f8d61214dc2c39269287e5-1730301645"
  },
  {
    "email":"elena.agostoni@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386671482/6c4d0dcc2802c83c8caa4841c398f5c6-1730301645"
  },
  {
    "email":"albertinib70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386638714/9ffbac53d0e58cd0499104908b310f84-1730301645"
  },
  {
    "email":"furlani.alessandra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386737018/a55b284ce882191bf8d7776e7615c99d-1730301645"
  },
  {
    "email":"sabrinarosellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386835322/3f0cb4d85e626eb3b58853643dbd899a-1730301645"
  },
  {
    "email":"bigapa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386900858/6baee132e34bbac310fb5f872d572be3-1730301645"
  },
  {
    "email":"anna_eletto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386933626/63984379d0d51b5e0b83f899b75bdf44-1730301645"
  },
  {
    "email":"jessievitali@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386769786/e310079e3b07cb1a969e9be6861d3c36-1730301645"
  },
  {
    "email":"valentina1986_vs@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723386966394/649c058322d43b82c3afceda72e4e05c-1730301645"
  },
  {
    "email":"tangya79@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723386999162/87c7b01e265f157e7e7c7ba349478a7b-1730301645"
  },
  {
    "email":"biellesas@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387163002/78f11de76c041e95fb493e44d0e96574-1730301646"
  },
  {
    "email":"dmb_demarchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387228538/61b0b72a9d744012f0e35cfc31ef585a-1730301646"
  },
  {
    "email":"valerialfini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387195770/b2e94c3755ebaf92cc3ebe417363876c-1730301646"
  },
  {
    "email":"lauro.benatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387261306/244a52b3308ecc791ab7b332b31d64b6-1730301646"
  },
  {
    "email":"cartacri72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387294074/d3c3cdb89aa61068e875262f88ec571d-1730301646"
  },
  {
    "email":"danielepasqua@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387064698/2846da7135edffdf77ebc0685dfbc795-1730301646"
  },
  {
    "email":"patrocla65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387326842/fa65bf5a6653c0e623cff900c3f459a7-1730301646"
  },
  {
    "email":"patriziabarletta1234@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387425146/16af0325ff0e496ca48c212d1ba1ea3b-1730301646"
  },
  {
    "email":"cap.cri@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387457914/53a8cf9dfb9f149fd86ec000790e5f25-1730301646"
  },
  {
    "email":"chiannalisa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387392378/9c84f1a72f8ad4e4e5c7824177fb7edd-1730301647"
  },
  {
    "email":"robbina.c@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387490682/ae247c23d0c29f8d3e1d0d5534f93d53-1730301647"
  },
  {
    "email":"marialbanese1983@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387359610/7793662e967f94fd731f38ba99d448e9-1730301647"
  },
  {
    "email":"elisa.santi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387556218/86353d006a67dd22fca7f65bc2a302d3-1730301647"
  },
  {
    "email":"martfag73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387654522/fa98cd755bde19dd17cbfab32c4575bf-1730301647"
  },
  {
    "email":"soniapellistri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387621754/10103c50a87ef046ee6d5a1d15ecb2e4-1730301647"
  },
  {
    "email":"martinadesanctis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387687290/df2d9a4bbd7860c3d2976dfdfcd904c3-1730301647"
  },
  {
    "email":"zagor16@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387588986/f8a5f1cab9f705ed058b0cb8d65b4d2b-1730301647"
  },
  {
    "email":"leanlan0305@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387818362/59e2c9baa9f0f9151163ed613f72467c-1730301647"
  },
  {
    "email":"info@bignottiefiglisnc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387785594/00259e3e7d4ad51d4ec4f07ad38a8358-1730301647"
  },
  {
    "email":"mariaveradalesio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387851130/2e7d54dbf6c0f6aa0083293008a737ce-1730301648"
  },
  {
    "email":"martamerico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723387752826/b403b16e783776edfdd62b256a93637b-1730301648"
  },
  {
    "email":"railaura70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387916666/5527f479450695abeb3e242f5441bb48-1730301648"
  },
  {
    "email":"r.stefix@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387949434/d7d2e0445fb41583ead5143adb65a7e5-1730301648"
  },
  {
    "email":"cristinaangeloni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387883898/346f45c26a376c45f4fd60258eadede1-1730301648"
  },
  {
    "email":"ino.domenico.70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388047738/8eb609a39936db0c33719c6564199976-1730301648"
  },
  {
    "email":"francesca.fulvia.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723387982202/c010561b84a457a69ebf8b2d34e53a3f-1730301648"
  },
  {
    "email":"anitasmart72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388014970/ec5ecb44face9eff2b441feb80d4f35c-1730301648"
  },
  {
    "email":"alice.como@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388080506/d20877ba923cafe1181714bba5c2569c-1730301648"
  },
  {
    "email":"barbara.piampiani@adhr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388113274/8c44f8509f23b8ad41ef16dd77cb3481-1730301648"
  },
  {
    "email":"alice.ferrari.istr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388146042/001ca455ef3b258cb7efc07cc666107a-1730301648"
  },
  {
    "email":"bosamichela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388178810/45825ab454195b03e5192cb2334a9a65-1730301648"
  },
  {
    "email":"belfioreantonio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388211578/fb9ff42efddc6abc0062b93bed415265-1730301648"
  },
  {
    "email":"vicogiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388309882/42e3213e47ed0f871f4275b58d55a2f0-1730301649"
  },
  {
    "email":"anna.cabras84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388244346/da25bbec74dc021f43faef9c315476b0-1730301649"
  },
  {
    "email":"dani.valotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388342650/d4f1d9ef0145b3b63eecdd81782718a4-1730301649"
  },
  {
    "email":"desiree.za983@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388473722/5ecf5f5e04835b344881cd51e3512c7f-1730301649"
  },
  {
    "email":"rosi.sambuco@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388506490/e7b652ae1893c2943a816c605f884705-1730301649"
  },
  {
    "email":"dolores.bessegato@ng-travel.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388277114/b4452bd93b87c0e181d812d02b345a68-1730301649"
  },
  {
    "email":"laurarossatti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388375418/7e9e6fb4183aff5e2659f228665ac635-1730301649"
  },
  {
    "email":"fedemuffolini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388572026/c04b96a666cbbfd1b685025c97798e0f-1730301649"
  },
  {
    "email":"roberta@tessituravalli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388539258/b7ddf519077a0096e7df55d3a165518b-1730301650"
  },
  {
    "email":"gabaniniclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388703098/4824088435e66391b2e328e293139da7-1730301650"
  },
  {
    "email":"chiara.plata@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388637562/d84d2d2c34bef6c8a8a8a8887523d37c-1730301650"
  },
  {
    "email":"valemaur@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388834170/684e99f8ec6b40eca60a93758cd238f7-1730301650"
  },
  {
    "email":"chiaramarcon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723388735866/fb3e4093ae6b58dbb0223d7c590ae5b1-1730301650"
  },
  {
    "email":"marchinirudi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388866938/fb22bb4e60028d7037786703e54dc8fa-1730301650"
  },
  {
    "email":"aloap.p@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388899706/fc8fc337030158dfcfc92089c5512d19-1730301650"
  },
  {
    "email":"maddalena.generoso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388768634/66a0e2b976073d2ab4013e19eabc6cc9-1730301650"
  },
  {
    "email":"ivanadiliberto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388932474/cc2642fe3f57202323a5ba30ef835385-1730301650"
  },
  {
    "email":"valentinasionis@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388801402/4bc6dcd1aba713044a4c0220fe28f4fb-1730301651"
  },
  {
    "email":"elena_parini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388965242/399a4ab6fe7d65d932ba6bf4a85605d5-1730301651"
  },
  {
    "email":"danielaglo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723388998010/8b1722d4e48c1db700e877a29188bf56-1730301651"
  },
  {
    "email":"federica.assuigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389063546/e8010a6ffde76fc865470685e0e91fbe-1730301651"
  },
  {
    "email":"paolaquadri1972@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389030778/752c198b3b711683a7042199c32ed856-1730301651"
  },
  {
    "email":"simona.tomaselli1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389096314/372b8f4503aa812d185bbd31dd763626-1730301651"
  },
  {
    "email":"laralam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389227386/fad74e36029a65d55d6c9cf31ee26f15-1730301651"
  },
  {
    "email":"info@calzoleriadelcorso.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389194618/ef36faa9fcb76cde673926af4d75b8f9-1730301651"
  },
  {
    "email":"ursula.giuliani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389129082/5923c43edca6ff3c4f43658da8c6731f-1730301651"
  },
  {
    "email":"vboehm@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389325690/93a7054a6f10eb6cca8ad99cd755434e-1730301651"
  },
  {
    "email":"marilenapischedda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389292922/a7f4fe14d47e218e71867fb9de006e05-1730301652"
  },
  {
    "email":"a.ponzi@zerouno6.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723389423994/ac8916ad6c386ad91ddf121d4c7d7b81-1730301652"
  },
  {
    "email":"fmarco1984@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389456762/a793faf8b23eb4de70a67f313a061a3e-1730301652"
  },
  {
    "email":"eddadefranceschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389522298/d068fafcd91a524fde473d461e9eb3e1-1730301652"
  },
  {
    "email":"laura.polotti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389587834/a8a2cfbb4d831ad9c0a06fc7d6b347bf-1730301652"
  },
  {
    "email":"go369@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389358458/2bb6294f9785c0c3ab77998edf42391b-1730301652"
  },
  {
    "email":"lucafantini1966@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389653370/5077d33bbe2f66cddfdc8f0f9b418fd7-1730301652"
  },
  {
    "email":"federica.giacomet@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389555066/fd6921a167b4ca9dbbcc164b9317897f-1730301652"
  },
  {
    "email":"serenadibi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389784442/37af47fb402e7abfb1394d693c3cb9ef-1730301652"
  },
  {
    "email":"anna_gallo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389817210/e3c8a98d9fd035036d1ca10459b355a4-1730301652"
  },
  {
    "email":"salt72@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389849978/66e9a2ec41c3b74adc75bb4eadf82f5b-1730301653"
  },
  {
    "email":"giovanni.mes@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389882746/c6639b6c0111be2f8fbcf67eea50b449-1730301653"
  },
  {
    "email":"patrycorrente75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389686138/a9a06983e008eded9a1019cecba96d25-1730301653"
  },
  {
    "email":"michelay@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723389948282/fca324d4f91dd7cc03a6ca45c3891c00-1730301653"
  },
  {
    "email":"patnovara11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723389915514/4f245684d9071abaa5e026081d521dd9-1730301653"
  },
  {
    "email":"fedebo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390046586/a90dc18b73f232d3bcc2edeaeb6041a6-1730301653"
  },
  {
    "email":"vent1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390013818/fbabc9c57cfc0fb8f91ffd137744cf52-1730301653"
  },
  {
    "email":"disarnoilaria82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390112122/8a19ddfbd43e91ac47e8063b33abe402-1730301653"
  },
  {
    "email":"bertolotti.angela@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390144890/46aafda0aec0d79784afe6a4a5ed04a9-1730301653"
  },
  {
    "email":"kicca.1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390210426/b23cf34d70fb81d65da347a590f17ddb-1730301653"
  },
  {
    "email":"macchion@avvocatomacchion.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390243194/f9914bffaab25632f907082fd682ef14-1730301654"
  },
  {
    "email":"annagraziatria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390308730/7eca4925518256d3a9a41b56edc9c85a-1730301654"
  },
  {
    "email":"salima75@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390374266/3e4425c2d8cb01ba88c7bdbe63ac738e-1730301654"
  },
  {
    "email":"laura.piccolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390275962/17dc010c6aad4d923d72d82ab038404b-1730301654"
  },
  {
    "email":"negromari@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390472570/877056120827fa4c430e1f02a15a453c-1730301654"
  },
  {
    "email":"beppeneri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390407034/9e0a53d8c8d01d14b71458bf9b23c1d7-1730301654"
  },
  {
    "email":"roberto.battistoni@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390505338/b73caf049435b99ec5e6be0f5cb268be-1730301654"
  },
  {
    "email":"bartaluccigianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390538106/1a7eceb68c7b6957fcbe87c56d182679-1730301654"
  },
  {
    "email":"ragnoli.v@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390570874/390820605886cbbfd89cac725a7f32e0-1730301654"
  },
  {
    "email":"norahd@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390734714/3c2b473a21bc0ad530df172bf34e49fd-1730301654"
  },
  {
    "email":"asmc@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390767482/b98d9872cb983afaf1b0c48e3d885344-1730301654"
  },
  {
    "email":"valentina.marcattilj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390800250/f3ec2b4a02b802060059ffba7663ddbd-1730301654"
  },
  {
    "email":"marianapizzuto18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390865786/3d03bcee3e064451c3e23905ada36381-1730301655"
  },
  {
    "email":"laura.calatroni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390898554/f802cfe5ab878aff0abb7ba8993e3792-1730301655"
  },
  {
    "email":"loredana.rota@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391029626/ff8ce0968f8e4cea4640907f1cd93578-1730301655"
  },
  {
    "email":"erica.agosto@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723390669178/e2d7afa410e683957914897be1b41dcc-1730301655"
  },
  {
    "email":"cinzia.brogioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391062394/e71c9949af1d5bfaa970b379e6d15930-1730301655"
  },
  {
    "email":"loribella.lv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391127930/9165cf3c1eefaf33a8dece5c1d68a63d-1730301655"
  },
  {
    "email":"barattin.michela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391095162/cb0221db0105fd3001129166f78a018e-1730301655"
  },
  {
    "email":"sonia.paoli0203@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391259002/7745283b6f4576ee8184c82757b09e7a-1730301656"
  },
  {
    "email":"federica.nattino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391226234/b79ad350c18ab573c3714b541811254a-1730301656"
  },
  {
    "email":"veronik.81@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723390931322/e4cc9b65dbab3bf4972219f23044103e-1730301656"
  },
  {
    "email":"iulia.sss@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391291770/bb5f7b0e6be8eea93694bf690518820c-1730301656"
  },
  {
    "email":"fralinda07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391324538/55f172d8db7c835ffe42220a96d4f19e-1730301656"
  },
  {
    "email":"rossellapolesinanti@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391390074/ff4ffd7e2200f1e5f9b7b7323d300b3b-1730301656"
  },
  {
    "email":"marafranciulli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391422842/aeb529db513acee63a25657d72766f29-1730301658"
  },
  {
    "email":"boni.vera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391455610/69b36a9a0cf828a987117396b2460384-1730301658"
  },
  {
    "email":"f.mauro82@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391521146/600476bfe48181c258d9598e98f401b6-1730301658"
  },
  {
    "email":"silviabraccio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391488378/221a4c1caa628b9977f89ae9a7aa8c62-1730301658"
  },
  {
    "email":"monia.isoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391652218/e0505908bc50c3bd786cbe59fdc4670a-1730301658"
  },
  {
    "email":"damico.cinzia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391553914/3bcb5682ac922d6c771f404fcfafe0a9-1730301658"
  },
  {
    "email":"gu.gi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391586682/48e9b5b9a3bd554b0a172a93986cef68-1730301658"
  },
  {
    "email":"maureeshaw@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391783290/4793d35f1a3e3ee6f02eabae651cae69-1730301658"
  },
  {
    "email":"arcangelo.libutti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391717754/afb0ecd0ada7bd02daf615972f3ce5af-1730301658"
  },
  {
    "email":"stefania.sartor@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723391619450/0523baca174bdfbd44854eb015bb44bf-1730301658"
  },
  {
    "email":"isabelbrs76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391750522/4dd6b348ccd3e39086dc74a757a35da2-1730301658"
  },
  {
    "email":"vania.lippini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391914362/c20d0f328b1ce6cdc6e92db25ea826a2-1730301659"
  },
  {
    "email":"facchi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391947130/b71ae08c81dacbc7f915697cff7aa630-1730301659"
  },
  {
    "email":"mary.duiliomg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391881594/704a7b7500bb73a9b252b0695581d00c-1730301659"
  },
  {
    "email":"tiziana82@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723391979898/0e9167c13de5d0dd4ef928a9131deba3-1730301659"
  },
  {
    "email":"federicageraci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392012666/3eacae05fb33d3bfff632ce0a8c90081-1730301659"
  },
  {
    "email":"m.bombagli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392078202/8fa61ac3c37aa90bdf76dd16825214aa-1730301659"
  },
  {
    "email":"stefania@lostudiosrl.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723392110970/2a5c20505d3d6badcbd4790bff28beb0-1730301659"
  },
  {
    "email":"laura.ongaretto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392045434/29251472ad0961831157517c6e59efa4-1730301659"
  },
  {
    "email":"musme62@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392143738/210313cd61602bba8f879b05ee44098d-1730301659"
  },
  {
    "email":"annagiacchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392176506/d06d5b95d04cde1dcfc15506fefb277b-1730301659"
  },
  {
    "email":"farris.anna@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392209274/49f24441c467864e1dd270677d08e80e-1730301659"
  },
  {
    "email":"chiari.margherita@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392242042/e9f2baabb5dc412c6cad73f478c1b2b5-1730301660"
  },
  {
    "email":"sanchionisandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392274810/09daaa81887f376c6dbb81388baad374-1730301660"
  },
  {
    "email":"pierangela.ritelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392307578/2ea2eaa604fe87ed9a3e4cea3dfe9c4b-1730301660"
  },
  {
    "email":"claudia.agazzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392340346/7d272f796dab17e54c21fe865a70cb3b-1730301660"
  },
  {
    "email":"fedebondanini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392438650/9b94640e6395d31dc68757b4c2a01094-1730301660"
  },
  {
    "email":"annalisa.galli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392373114/6fa812bc32dfd7ba149b154c4e328c41-1730301660"
  },
  {
    "email":"luisa.coltri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392602490/eb309784957172616ecfb240331b4461-1730301660"
  },
  {
    "email":"donna-s14@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392569722/cf5691c6c29dfebc3b984dfca67ea48d-1730301660"
  },
  {
    "email":"katiusciadimaio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392635258/09a10c79d04a36d4c979e77b364aa8a5-1730301660"
  },
  {
    "email":"luisanna.pasini@studioeverest.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392766330/b4c943ab45fc283df676e7c3ee5042de-1730301660"
  },
  {
    "email":"chiarfe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392733562/1a7314d79af9f25165c0530b23e52bb0-1730301660"
  },
  {
    "email":"chiara.t78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392799098/b5d0dc6374a31d9b3596a313d2c1d915-1730301660"
  },
  {
    "email":"chiluc@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392668026/5b0d3b9938a8600cb873f30aba2cae46-1730301661"
  },
  {
    "email":"albina.ajena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392831866/e3d03b3ac24d8e2ee7a680160fff63eb-1730301661"
  },
  {
    "email":"france.destito18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392897402/38101b0f08cb19497fd30b1d560ec111-1730301661"
  },
  {
    "email":"mariarosabonomi4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392864634/fc326197062143a7be198174173835d0-1730301661"
  },
  {
    "email":"mour_saba@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392962938/3fa72a4884b9d09b0d817c4a2fb9ed42-1730301661"
  },
  {
    "email":"raffaella.quitadamo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723392995706/397554b9374830779583cab2430cba48-1730301661"
  },
  {
    "email":"corinnapierri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393028474/09986421a87951a6f9cbcc3fa2950f0a-1730301661"
  },
  {
    "email":"felice.valentina73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723392930170/0eea60bba71b709d6180995ed8182c6d-1730301661"
  },
  {
    "email":"soniaciavatti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393094010/7caf870c250862e0650dccf9695d46e3-1730301661"
  },
  {
    "email":"stalde@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393061242/d9989fae608063633ad0a702faf55d28-1730301662"
  },
  {
    "email":"fabiolarossi68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393192314/7f60f6cb298024d62cf751716635f24d-1730301662"
  },
  {
    "email":"info@farmaciapriamo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393126778/24a42e335c2edcba694540e6a298e972-1730301662"
  },
  {
    "email":"susanna.biotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393159546/b9d6a3b2aa851017f8639f443547c031-1730301662"
  },
  {
    "email":"marilena.merico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393257850/c6c90744fd3d1a5cd3130e4c12077242-1730301662"
  },
  {
    "email":"marella@burza.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393323386/47930885f31aee301df35b39f66adf8c-1730301662"
  },
  {
    "email":"asboarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393356154/b2c8fc80d8b15f9ab692aac70e232051-1730301662"
  },
  {
    "email":"xefora@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393421690/3152ff7921deb540acb05931eb913542-1730301662"
  },
  {
    "email":"annagym@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393225082/2ddc6edbb289a1b9bba4f5121a1be96c-1730301662"
  },
  {
    "email":"b.griffo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393290618/eb12cbac02955975bd6c86d263645eb6-1730301662"
  },
  {
    "email":"aq.annamaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393454458/99ac85504ff56c5148e92f6033488796-1730301663"
  },
  {
    "email":"atizamboni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393487226/0e642c50e1a9eb0ad65e93ddff7a1491-1730301663"
  },
  {
    "email":"daniela_busin@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393552762/ea9e4142768fc13f04ff7398741ce6d8-1730301663"
  },
  {
    "email":"alinasimona_2000@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393519994/8493415108043350d4b28e734fe1da28-1730301663"
  },
  {
    "email":"simo.simo1972@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393585530/0c34a078cd7bc45290beab686c47011c-1730301663"
  },
  {
    "email":"paola.scapicchio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393618298/3d9abc8904ab5ac0e1c4098d9e6118c0-1730301663"
  },
  {
    "email":"raffaella.caprari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393651066/6c9726b77aff8d6fc874ff71db11f44e-1730301663"
  },
  {
    "email":"siminafongoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393782138/dd1ac2ee43888aa23990f971032c30c4-1730301663"
  },
  {
    "email":"patrizia.tagliabue@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393749370/7bca73de570cc8932c2f7d6317643bef-1730301663"
  },
  {
    "email":"zoecrema@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393683834/b157286c02c05489ec7ccb4c09ab82d6-1730301664"
  },
  {
    "email":"manu1976@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393716602/681e992df96f559204816686312738ca-1730301664"
  },
  {
    "email":"ramonag@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393814906/903cee438ac5022e8bb561428324ffb8-1730301664"
  },
  {
    "email":"morinilaura@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393880442/c4a69b202959816e741badfb839307eb-1730301664"
  },
  {
    "email":"ecemanuelacosta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393945978/cf9b2b7b3158a11ee0b5d87a4da3cddd-1730301664"
  },
  {
    "email":"mmerli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723393913210/bada6d808d711a1b40fe5b1f546c45f9-1730301664"
  },
  {
    "email":"linafoglio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393847674/51f69b44696d966e253819b63f07fa25-1730301664"
  },
  {
    "email":"ritacallari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723393978746/49e02b4bf231c0685a7580bb89fcb6f7-1730301664"
  },
  {
    "email":"francescaferraro55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394011514/0ea461b6ede3dc1f7bee32194fcb8511-1730301664"
  },
  {
    "email":"giulia.amstici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394109818/1fd42a7600cca64f9aaa60f5f5054150-1730301664"
  },
  {
    "email":"agata.longhitanoal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394142586/6d1f7cf2cb098258b6b1fcf72385e760-1730301665"
  },
  {
    "email":"laura.ferrero@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394077050/1202636848e01a3333badf00c703cb6a-1730301665"
  },
  {
    "email":"tatianapollicino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394044282/291d0f219200bf0f7e0d5d12617c38e3-1730301665"
  },
  {
    "email":"annamariaminguzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394175354/245f3946523e280863fffd5e40c7402a-1730301665"
  },
  {
    "email":"patriziodegiacomo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394208122/d3831e9de09aaf774cf7f460272bea5e-1730301665"
  },
  {
    "email":"fliegendefranz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394306426/f19e34dd307e78ae32b045ea0cfcea4f-1730301665"
  },
  {
    "email":"nunziatina.natoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394339194/63c960bcd0e09fea546d7b46886856a1-1730301665"
  },
  {
    "email":"masi.barbara68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394371962/0b7d3bce7af685d13d37b3fb28a4a7db-1730301665"
  },
  {
    "email":"alanis74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394404730/f1c1085f6451bbda106da55bee93aa07-1730301665"
  },
  {
    "email":"letiziavergari71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394470266/503f0dc371654bd851a533898ea3313f-1730301665"
  },
  {
    "email":"gagiuli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394601338/bb004d0809759f5cf8bda11dd200e4bb-1730301665"
  },
  {
    "email":"coreotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394273658/9cf9effa31f1511cce4fec6e1070d517-1730301665"
  },
  {
    "email":"scavagnero65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394634106/afd3272dbc1a66933e7790ef715b5ab3-1730301666"
  },
  {
    "email":"comparato.emi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394666874/11e3a5b437225e9ddfff09e0b33a9f5e-1730301666"
  },
  {
    "email":"raffaellalibutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394765178/2ffe4ce46ab2b61d346516ae4810ac5b-1730301666"
  },
  {
    "email":"giannabartoli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394797946/784ed05a8308a9899490bd1a70583c31-1730301666"
  },
  {
    "email":"gabiwi57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394830714/859f16b6089b74f7e41b2b38a13e9543-1730301666"
  },
  {
    "email":"annalisa.banzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394863482/424ee1aded4c624fe8e24940336f92b8-1730301666"
  },
  {
    "email":"pischedda.ilenia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394699642/13c8f9fa3cc67da3b0a6dc38824d125e-1730301666"
  },
  {
    "email":"bellini.rossella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723394896250/683e376ba27d93d141fe99e5cda374d6-1730301666"
  },
  {
    "email":"francesco.messina@octubus.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723394929018/3ea943f5685816a3cdba14c48f178e88-1730301666"
  },
  {
    "email":"susybettineschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394961786/0e6193c4374829200ea84edf7130b162-1730301666"
  },
  {
    "email":"ginevragabellieri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395060090/19645e839ed2c91ef3f6e2707d05506c-1730301666"
  },
  {
    "email":"valentina.cerbino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723394994554/cc9b9500a505c41b3c68296d47b97050-1730301667"
  },
  {
    "email":"maria.gatto4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395092858/e436f560561c1f942f17e2c212e9835d-1730301667"
  },
  {
    "email":"nadiamicu77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395256698/20933bb92961e0a7685f6c196e35654d-1730301667"
  },
  {
    "email":"adrs.infor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395223930/8e44447c8c445ffb25cce540a6398fc3-1730301667"
  },
  {
    "email":"donatella.zannettino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395125626/c91a46f8ee8c9aa233885db35ce27bea-1730301667"
  },
  {
    "email":"daniela.iannotta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395158394/81d30c39447219ba666ba30b2c2d2c58-1730301667"
  },
  {
    "email":"daniela_pallone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395355002/93f6e8bb3c61c4c96726c782cff9006d-1730301667"
  },
  {
    "email":"alex_fabio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395289466/249c50a710eb3ddeefd7bfed345888ef-1730301667"
  },
  {
    "email":"giusy.lionetto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395453306/c53f01da5a9c2db27c0f42bd05b645cd-1730301667"
  },
  {
    "email":"giorgiacaristi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395518842/ed2ff2b1ad7f14f4c9702afa97756acc-1730301667"
  },
  {
    "email":"denisevenanzi1277@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395584378/f67c5bc5b36c7f983cf3e61ec80c17c6-1730301667"
  },
  {
    "email":"jetmirashquti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395617146/6f4cfbed8fc20fd9a88ceb1a8079982e-1730301668"
  },
  {
    "email":"monicatinacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395649914/f7d37dda972843bec21ecb83a3fe035b-1730301668"
  },
  {
    "email":"michela.galuppi.69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395682682/d6ed4993a86fb938cb739ea891f34386-1730301668"
  },
  {
    "email":"francyfrancyit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395715450/8e80b8a2cca9eb12256e907d8dd61c63-1730301668"
  },
  {
    "email":"concettalisciandra@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395486074/ea3c867acbf9342f0eb6af65d238bacb-1730301668"
  },
  {
    "email":"ariannasegat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395748218/0b2bb017dbdc0085399ff088d4bbb6d3-1730301668"
  },
  {
    "email":"evenceslai@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395813754/47c06878c5103bd33833a9a1869aa22c-1730301668"
  },
  {
    "email":"irene.volonghi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723395912058/dd7394668906b2d933ee2edaf5c8b55c-1730301668"
  },
  {
    "email":"sara.rinalducci@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395780986/d202b69abe5c003c5b05bc8c22551665-1730301668"
  },
  {
    "email":"benedetta.bernardi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395977594/614f9cbc45e2ddcc27eb6c94f64c7f9a-1730301668"
  },
  {
    "email":"bidoggiam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396010362/4c01b3ee314a80ae913b3acb30997483-1730301669"
  },
  {
    "email":"federica.villani7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396043130/00c252770452f7521cf96c0ff9a9de4b-1730301669"
  },
  {
    "email":"laura.romeo73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396075898/ad5fa0ea2aee536544d75117e493f823-1730301669"
  },
  {
    "email":"azzurrina78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723395944826/ea187d877301033e8d2d75c7385b9e4c-1730301669"
  },
  {
    "email":"dmarinita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396108666/c3ba82e3baa31f119b4bab6b9ffa23ba-1730301669"
  },
  {
    "email":"antonellafiumara37@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396174202/0ac43fa453e770c7c41de013ebbdb09d-1730301669"
  },
  {
    "email":"astoneangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396141434/93ca87711344512577c92a89d32c2b43-1730301669"
  },
  {
    "email":"robertachiara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396239738/1bd92dc917a9701977305fea5ed13a37-1730301671"
  },
  {
    "email":"maradalena71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396305274/ddde34e82309bc23841223c0c78300a3-1730301671"
  },
  {
    "email":"stefania@assoprof.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396206970/d9356df73208ddf1efc8bdf354439a90-1730301671"
  },
  {
    "email":"alessa.paoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396272506/cddbc35a327068745839acd20bc014fb-1730301671"
  },
  {
    "email":"e.belloni76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396370810/44d597d4397fb1e15e0ce717a1936a98-1730301672"
  },
  {
    "email":"paola.giordo@amistade.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723396403578/38c4024a6299b43c11c3e4fb587e25cb-1730301672"
  },
  {
    "email":"pleadi7@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396338042/1c86f8d40c1c4c89ff5c58f2eaf0b5ab-1730301672"
  },
  {
    "email":"marika_95@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396469114/bba07e22c3033f44d4cdd37b2b49c975-1730301672"
  },
  {
    "email":"pilliu@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396534650/da80a93d115aa59901567fa627e65dfe-1730301672"
  },
  {
    "email":"gaia.barbarossa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396567418/40f07f04d95c47acae8d3922187720ac-1730301672"
  },
  {
    "email":"facondini.ester@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396436346/ce6a7f14ab61d39095f8943f83c7046c-1730301672"
  },
  {
    "email":"margherita.panico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396600186/d6a2f27ad776862138f23b690484dcd5-1730301672"
  },
  {
    "email":"parizia.barichello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396632954/187658c491432135c96b752a9ae214bd-1730301672"
  },
  {
    "email":"simona.romano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396665722/5d961c8ab6532c158b1885f3e7258966-1730301672"
  },
  {
    "email":"rosyale84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396698490/8b50fe3c72f0ce2167fd4d4a57f25357-1730301672"
  },
  {
    "email":"safilo13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396764026/528e908f1eb59d2a6ffb491cff26007d-1730301672"
  },
  {
    "email":"leonidalm7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396796794/e246cbb732b3a01c3ca3f7d3588cdd55-1730301673"
  },
  {
    "email":"miksimo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396960634/b2fe52ae1d0ed335c50230d1c59b794f-1730301673"
  },
  {
    "email":"spiantoni663@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723396829562/ef4f7703edcd0d68e49fe38920897962-1730301673"
  },
  {
    "email":"mmartu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396862330/1ab5b20015d7e52c6b5bd669fa36f2bf-1730301673"
  },
  {
    "email":"patrizia_gfader@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397058938/3ac9c22a04bf59a267afa8401145c274-1730301673"
  },
  {
    "email":"s_leonini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396993402/74a0f4daf78aa3ec3543809212339e7b-1730301673"
  },
  {
    "email":"luz25443@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723396927866/a82d9a9c5e4543a7578de563779b8bd8-1730301673"
  },
  {
    "email":"tamara.tirindelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397091706/c5d84c6c2918724525a35866fe6199e9-1730301674"
  },
  {
    "email":"music_a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397026170/55ee8a44d44d8e7bcf59f04685c475c1-1730301674"
  },
  {
    "email":"vloffreda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397124474/27289be481fbe9c9d90dceccb1dda31d-1730301674"
  },
  {
    "email":"marianna.inserra1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397157242/4096b3ce503c1446c2ddb0528d8afea1-1730301674"
  },
  {
    "email":"barbara.viamin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397190010/7e8aabc7bedd0bf22c09629651cf11e4-1730301674"
  },
  {
    "email":"dania.bonardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397255546/bbc6bb92de51f37dc762616f0babcddf-1730301674"
  },
  {
    "email":"ferrarese.miriam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397222778/6100b54a0da8a6eb8295db21f3055bc9-1730301674"
  },
  {
    "email":"elena.menetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397386618/a0d8fff75081158338da321448f3e8b2-1730301674"
  },
  {
    "email":"francescalavezzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397419386/d01f031218dcaf8457c3e838f58582b1-1730301674"
  },
  {
    "email":"fly_ely@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397452154/bc9c7c06cde6b1c9f1f3a5c675f19c27-1730301674"
  },
  {
    "email":"carradori.miky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397288314/f83c09ee1a7cb1adedeaab640961f726-1730301674"
  },
  {
    "email":"valentina-digiovanni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397550458/56e7ef43c8f0a51ea6c1ccf172db05fb-1730301675"
  },
  {
    "email":"carlo.raffaelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397583226/6f5be80c16fa77ebe63bd37d461278cc-1730301675"
  },
  {
    "email":"federica.broggi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397615994/f664d9f5d91189ba10d60756fb1dba0a-1730301675"
  },
  {
    "email":"miriamgatti.mg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397878138/ea32276ddc87f82d536a497587458253-1730301675"
  },
  {
    "email":"domenica.alfonzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397648762/dccc153e675722f6a58e3117b73fa924-1730301675"
  },
  {
    "email":"monica.laporta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397517690/aa15c550975f097f262999384ea7aeb9-1730301675"
  },
  {
    "email":"mariangelarizzo77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723397943674/8d5a092b2e90ac4db35206cc7e2fe249-1730301675"
  },
  {
    "email":"marina.paone@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397910906/29136115b248bf641b57ff1bf29b041d-1730301675"
  },
  {
    "email":"tommasosemeraro@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397976442/d117ba7938feb9f4651bb7ae2e8191a2-1730301675"
  },
  {
    "email":"maria.caragliano@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723397845370/319fb60fb8cd72452c46c645b3c691b4-1730301675"
  },
  {
    "email":"ettore379@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398041978/94c0e605d3533ce081c09aacf5942760-1730301676"
  },
  {
    "email":"claudiaagnoloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398074746/0ee73807526c2406d4e0afb82d7b5f28-1730301676"
  },
  {
    "email":"sabinasanti.sm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398173050/53b0d558b3a1bbfd3170350c9e3a8cb9-1730301676"
  },
  {
    "email":"labello2006@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398140282/1e816d0429db6c78b1513b0917eaf1b3-1730301676"
  },
  {
    "email":"francy.tosti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398205818/5c7c36511dd13fb962b44388a02d1b98-1730301676"
  },
  {
    "email":"marinamontanucci26@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723398271354/167ecf1bd7e8ca999363479f9877372a-1730301676"
  },
  {
    "email":"luisa.raviscioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398304122/2291e07cb9084faf56213db9a1b54364-1730301676"
  },
  {
    "email":"villamaria2008@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398238586/d9ca110715c849815f94b9876b595c57-1730301676"
  },
  {
    "email":"oriana.cerutti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398336890/299b5cb403fae029501b50b8ecc94482-1730301676"
  },
  {
    "email":"ba.zannini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398369658/8e6275ebef835f49d2e83db5fe695cb6-1730301676"
  },
  {
    "email":"susy@gcgemelli.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398467962/1eaee3b0f5291a47b915447fdfc78808-1730301676"
  },
  {
    "email":"pandinialberto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398533498/184dc1857f1d9bec0b6559f30562ee6f-1730301677"
  },
  {
    "email":"teveretime.fiumicino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398500730/ca87d7bbfab37c5f9d608981c49a8fc9-1730301677"
  },
  {
    "email":"elisabrachino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398599034/8cd2b514541e269957b9888d34dcff6a-1730301677"
  },
  {
    "email":"anna.sima2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398631802/49b5d9acd71f80264c1cc5726ddbc65c-1730301677"
  },
  {
    "email":"melinagregori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398730106/8fe47afe906fed9708eb72d4a485dbc6-1730301677"
  },
  {
    "email":"cri.franza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398861178/7167fb950633dfdf7a2b5e248fceb570-1730301677"
  },
  {
    "email":"stefano.broglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398828410/0ad18dcc4d17f4fa45ae28efb55b4762-1730301677"
  },
  {
    "email":"giulianagalletti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398959482/6f8cdca5e282c2ec06b42f2d13285044-1730301677"
  },
  {
    "email":"laura.vincentelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398926714/795c75dfee2206708c613d9701c9dea9-1730301677"
  },
  {
    "email":"alina-85@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723398762874/9ea495bb75f9b844921f2d564ffc4949-1730301677"
  },
  {
    "email":"brooke.e.bartley@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398893946/39962bbaf00344d2a32f9a83b50a5c9b-1730301677"
  },
  {
    "email":"cucsil73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399057786/9cb80ea8bc6fcc322169a4fdb89a21d1-1730301678"
  },
  {
    "email":"chiara.toscano2000@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723398992250/70fb3d32b93449a988cafd77f9067c25-1730301678"
  },
  {
    "email":"daniela.aceti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399123322/b8621680e8226cfa7ca48d3f17d74432-1730301678"
  },
  {
    "email":"tatonzolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399025018/052e7b793de470cb58319161f91614a1-1730301678"
  },
  {
    "email":"danibarbagli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399254394/02251cc0688036d1cf0b082720e8c320-1730301678"
  },
  {
    "email":"lorenzocoseano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399287162/09686cc37b0add15ba4a775edac5b7a5-1730301678"
  },
  {
    "email":"p.fungone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399188858/448e227e7609321539bc2a2553431a04-1730301678"
  },
  {
    "email":"n.bergamini@cgiar.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723399156090/b6fd231038debb3fe78f8c3a8ebd5eb4-1730301678"
  },
  {
    "email":"francescaspadamail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399385466/001cabe6355c2cfe2dcc32e8ff69bc8c-1730301678"
  },
  {
    "email":"vaniazanet@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399319930/14aefdce62dddca634577739ce8522a4-1730301678"
  },
  {
    "email":"vcontinibali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399418234/82825ab81e53458bb008b768623b7632-1730301678"
  },
  {
    "email":"ilariabecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399352698/48a485f288187722c569cf82a7e485cb-1730301678"
  },
  {
    "email":"chiara.schiarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399451002/1a0e39b2446a39b7fdf2a163ccc684e4-1730301679"
  },
  {
    "email":"cristinaarnoldi1@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399582074/0c1025ead78cea04e1f3905b61b6cacb-1730301679"
  },
  {
    "email":"mancinelli.cristina@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399516538/83b43b3cb734e54f85ae387854f92d3a-1730301679"
  },
  {
    "email":"sam_atraction@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399483770/660bf9c28ec709821c121f77e4119f9c-1730301679"
  },
  {
    "email":"dolceflauto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399614842/e69cb10da43e43660600d784ce97bd38-1730301679"
  },
  {
    "email":"agnesesciuto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399680378/bbb486540fe642d7d5b31630bd51a093-1730301679"
  },
  {
    "email":"marco@messori.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723399778682/187cce257f74223d46cf10b1c9e6ba7d-1730301679"
  },
  {
    "email":"valentina.gerbi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399811450/8aadc47aaa9832e0d7e6eaef71e80c70-1730301679"
  },
  {
    "email":"cladeb76@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399713146/91457cce8709b1c78b66bfde25b1c441-1730301679"
  },
  {
    "email":"edengap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399844218/831aeee627f984b0b6963d8b89e1a0fd-1730301680"
  },
  {
    "email":"fra.lamanna81@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399876986/d366ad6eee4b35f06c727a5e567f35ab-1730301680"
  },
  {
    "email":"b.caltabiano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723399745914/e6cc9cbfd9ec69d4f7cc98d6dc47b4f7-1730301680"
  },
  {
    "email":"barbarascrb70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399942522/abfe19e55c3f1a47d0acfbb56cc5eae0-1730301680"
  },
  {
    "email":"danielapansini1611@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400008058/494006e0181cc94325c18579b1922041-1730301680"
  },
  {
    "email":"cri.nervi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399909754/3ec4d25fce2a07dcf3a0df995d231d9e-1730301680"
  },
  {
    "email":"cristinagattesco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400040826/664657de0780ce4c01362f43022490e2-1730301680"
  },
  {
    "email":"isabella.baronchelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723399975290/428ab6487168dad217a246401a17af78-1730301680"
  },
  {
    "email":"monica.avallone.ri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400171898/e7503d6b37ea4ba64eee7fca46995f92-1730301680"
  },
  {
    "email":"monica.giulia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400106362/ecdb07c4a868c013faefb6461a6247b9-1730301680"
  },
  {
    "email":"giuntinia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400204666/29a4729670655c8eaab6150b158a937a-1730301681"
  },
  {
    "email":"emy.melfi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400270202/25ecbd0b8ad343f2a6ffd3ae72973018-1730301681"
  },
  {
    "email":"mcontessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400302970/a4afb45d36690db4d9f13884a9ace870-1730301681"
  },
  {
    "email":"rinaldi.anto2006@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400237434/548f82152df77dbec0c597a46b135cc7-1730301681"
  },
  {
    "email":"dandamesh@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400368506/6358a8307ef18e17af98c0e8808407b2-1730301681"
  },
  {
    "email":"mattolinisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400335738/95921fdffff14a9d46160dbccb3572d6-1730301681"
  },
  {
    "email":"b.mancy@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400466810/183831125422e43603f0de4f3fac46c6-1730301682"
  },
  {
    "email":"vellagrazia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400401274/665258d1c1527f3237c4a2ebc442c717-1730301682"
  },
  {
    "email":"romana.bernardoni@eagroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400073594/62d3c21f210f19a47974276c71b25642-1730301682"
  },
  {
    "email":"benedetta.sargentoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400499578/31f429a98e3af68c92d9ab023b78c880-1730301682"
  },
  {
    "email":"sylviawulff@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400597882/a77116f55c433c3dc1a217495e253799-1730301682"
  },
  {
    "email":"id469ohn@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400532346/4a31b29fb99819450f6fa803f5df3605-1730301682"
  },
  {
    "email":"johndldj1993@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400565114/afbdd6be11ff40e55c1dda18ebe72c1a-1730301682"
  },
  {
    "email":"barbarascamozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400630650/217e12bf4c94076156c0738710ad0749-1730301682"
  },
  {
    "email":"ritacatalano.rc70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400794490/69acb2ff18da1b08b7e902c9c787c6e2-1730301682"
  },
  {
    "email":"digiemme70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400728954/69bf8de2a58b97f03b745604a6b3ecad-1730301682"
  },
  {
    "email":"mariangela.frasca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400827258/32fc2cf3cc67c86c9a20585a6a11f1b6-1730301682"
  },
  {
    "email":"liviat@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400892794/cb5797fca397831e2442c1b45dbf5192-1730301683"
  },
  {
    "email":"francesca_dibernardo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400860026/a5c002f532fe615401530294aeaec7d7-1730301683"
  },
  {
    "email":"antoniabrancaforte@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400696186/601cec604e88be3afc8a5267e445387e-1730301683"
  },
  {
    "email":"giostefard@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400991098/992a1a2a3c919980146ee034d898d4c2-1730301683"
  },
  {
    "email":"sandraferraris45@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723400925562/3cd35963985c6a725325ebc1b288fd24-1730301683"
  },
  {
    "email":"lucianaimpedovo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401023866/042e0fc6ea8cb18cf9b94537f954c1b0-1730301683"
  },
  {
    "email":"cioci.terry@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401089402/b493d4b1834dfaa515a2503c95d6a889-1730301683"
  },
  {
    "email":"rossimeroni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723400958330/e6aecf9bc8ef7ab6958b0f397f107af0-1730301684"
  },
  {
    "email":"folli.gabriele70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401220474/acafae352bb17b4e3910470512f10ec2-1730301685"
  },
  {
    "email":"jakobdettmar@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401253242/cce6f2ac40208045ca5e5433d8bfedda-1730301685"
  },
  {
    "email":"eugeniacerchiari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401187706/e8c5502a12e9b68b4ae52895a3ce6e67-1730301685"
  },
  {
    "email":"linn20@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401286010/416e3eb8747b6a00b5fcb80f4f842a76-1730301685"
  },
  {
    "email":"poisab13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401318778/a07eb3ab34fbf4deee3c415ecb47b40b-1730301685"
  },
  {
    "email":"lellag.curzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401351546/b2813f21b3d07ea1f20153980a1a4825-1730301685"
  },
  {
    "email":"merygb77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401122170/7422153ec9813044cad0f7cc26a77b87-1730301685"
  },
  {
    "email":"mara.dioguardi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401449850/8c5c84eedabdbba64db03bbdc61596ab-1730301685"
  },
  {
    "email":"jajabo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401482618/f5806cff6862e377ac87c10ef5c97514-1730301686"
  },
  {
    "email":"fas65@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401548154/fb074c57dfe8de8cc4f9058fa0f8e290-1730301686"
  },
  {
    "email":"cecilia.cattaneo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401580922/a5e0f51bc45e4d5a93186872d24988c1-1730301686"
  },
  {
    "email":"silviabfontana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401744762/00acff32258e7410d560e07baa289468-1730301686"
  },
  {
    "email":"dany.co83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401646458/2239887c412e8bbe18a0f45e5dd508d9-1730301686"
  },
  {
    "email":"silypas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401679226/0b4791ee1d6558f908f6c2132de163d9-1730301686"
  },
  {
    "email":"sabri.rss@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401417082/5d5ae9b962d05bce0d55a79a0639fe0a-1730301686"
  },
  {
    "email":"morbileti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723401843066/30e09f71a9740fe782313edb55b215bf-1730301686"
  },
  {
    "email":"coca.cola.2007@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401777530/e0f5a5111d1e76a86117f73320248ac3-1730301686"
  },
  {
    "email":"taniamarotta@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401875834/f1c7a96082d43a3319b8cfcfa46114b9-1730301687"
  },
  {
    "email":"francescastranda@ied.edu",
    "url di attivazione":"https://verdissima.it/account/activate/22723401941370/bb57786b0648f48176d59c265909241f-1730301687"
  },
  {
    "email":"stemor64@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401908602/085fa542638bde065f25e1090dde6189-1730301687"
  },
  {
    "email":"piccolofiore14@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401810298/9e4e7d8d65d5d4a54872673ee6fa308a-1730301687"
  },
  {
    "email":"elisabetta.bolis@zigales.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723401974138/5077aaad4c11d9846f2b70e43d64de77-1730301687"
  },
  {
    "email":"roberta.miotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402006906/336987e8b4a58cb3d921d5d3c61c5182-1730301687"
  },
  {
    "email":"eferrero@studiolegalefe.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723402039674/4e2a1821415d6b5542900a17e8b6b1fa-1730301687"
  },
  {
    "email":"poggi.serena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402072442/3c62f7f66350c46db7d5297c04afe5d4-1730301687"
  },
  {
    "email":"alessandra.tablo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402105210/82c23f9f6a68fc4ed7e680bbdf5c95fc-1730301687"
  },
  {
    "email":"evelina.aloia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402301818/66e16f7e665cf00d7f43d50e2a084516-1730301687"
  },
  {
    "email":"marialuisa.marino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402269050/0bf60ba5a699cb67745ae6d036bd8b7c-1730301687"
  },
  {
    "email":"paola_gobbi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402203514/72509ea9127ffad7b3ffbbeccb543a23-1730301688"
  },
  {
    "email":"trasfo1961@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402236282/b51ade23003e23506900f8bc9c515954-1730301688"
  },
  {
    "email":"fiorentinogiulia19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402334586/f270a8f55fd060baf3fa209fd40f0276-1730301688"
  },
  {
    "email":"eleonora.prestini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402432890/185c231950326c1e9fce84d840638069-1730301688"
  },
  {
    "email":"samimarco97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402400122/b24649608b8721f861800fb28df8587d-1730301688"
  },
  {
    "email":"turrinialbert@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402498426/4bd7c0f53685228acb3752b4d5ce5911-1730301688"
  },
  {
    "email":"laura.renga@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402531194/a0679467bf3c391bf2648ea76e7da333-1730301688"
  },
  {
    "email":"nicole.spinelli.55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402695034/1832090fdd372dfc2384fe9422508573-1730301688"
  },
  {
    "email":"melani.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402596730/4d7b7ff2750f137c972fd61636e3c9d9-1730301688"
  },
  {
    "email":"sarditedeschi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402727802/138616d95b00ebe740a8c0cc9cc3a348-1730301688"
  },
  {
    "email":"emmagrandi@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402858874/d68e4ccd3466cffd23a8214e141718e1-1730301689"
  },
  {
    "email":"s.pantella@comtelweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402563962/acf63e976350842d2c502819aef9e0e9-1730301689"
  },
  {
    "email":"enricabrunialdi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402793338/ede250e9f93cf760654d07c1c3355d91-1730301689"
  },
  {
    "email":"serecesari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402989946/c8b1670d054f3bf4c49850745a706f45-1730301689"
  },
  {
    "email":"lafrassa75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402924410/b3067f3bee85227a6c35da8fcad21d9b-1730301689"
  },
  {
    "email":"mggarri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723402957178/f6f07181d3b3deb35d45858beab31054-1730301689"
  },
  {
    "email":"pegasus.sb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403219322/bbdb2b1897bd5a37067116612e9745c9-1730301689"
  },
  {
    "email":"sabrina.2000arredamenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403022714/6351cad437b3dd4aa8d8cbdb0e611d9d-1730301689"
  },
  {
    "email":"alessandradm83@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403055482/069fb763ed9702c951f0275e0d799133-1730301689"
  },
  {
    "email":"valentinacinalli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723402760570/ceb6bd836487470067853f416ad82de3-1730301690"
  },
  {
    "email":"irenze68zornio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403383162/378f1b274c6711b37948ba75c5cf5566-1730301690"
  },
  {
    "email":"dierre1946@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403481466/3ee9782cee7ba821bce778bbb167e559-1730301690"
  },
  {
    "email":"ale.alessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403514234/220b561f783d2703c05e2dee22bcd935-1730301690"
  },
  {
    "email":"a.scialappa73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403317626/0e513d18e0b3e8bd09fd712f6c2c4f7c-1730301690"
  },
  {
    "email":"antonellacerini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403579770/d8368c41c859e93cb7fd048ba731713f-1730301690"
  },
  {
    "email":"rombai.riccardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403612538/b2fa85f0c209a4b80e53d581c5fdad83-1730301690"
  },
  {
    "email":"richiecri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403415930/cc47a3ec9fb12c31ce1b28efbd3f2f94-1730301690"
  },
  {
    "email":"tiziana_serafini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403645306/1608b0c6a7a964af823a7ce2a5798066-1730301690"
  },
  {
    "email":"stef_ventisette@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403743610/c770f54958b448a095f0f4e4c964258d-1730301690"
  },
  {
    "email":"alessandra.borgia.it@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403678074/6dd6d3b7cb864fbfe227165322822c33-1730301691"
  },
  {
    "email":"elenadolly0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403809146/a8a3de9b4af4fc3b90615f17bcd24d9e-1730301691"
  },
  {
    "email":"claudia-losito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403841914/ea841c6c6dbcd78e4ac845bc6b7e5ba6-1730301691"
  },
  {
    "email":"lu.albertini00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403776378/c647c3f004a09b5ed963f02fe254ef16-1730301691"
  },
  {
    "email":"e.montorfano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723403972986/d301b45885b7b3e86e465bd8ca8d399e-1730301691"
  },
  {
    "email":"marco.delgrosso66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723403940218/aee0ab432d965b350a1c65d4046053b9-1730301691"
  },
  {
    "email":"danielarondinelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404071290/468ca34e3247b9471da3381d71a843c2-1730301691"
  },
  {
    "email":"franci.martino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404104058/81059f1a1594265cd04b79b64d6e2f4f-1730301691"
  },
  {
    "email":"on@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404136826/496a203814741be813a3db4922b4c4e4-1730301691"
  },
  {
    "email":"loriana.zicchittu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404169594/9f7790db726503f6a7bf7b282166581f-1730301691"
  },
  {
    "email":"igortarta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404202362/6c68edf451da2e726011953ad38c5b26-1730301691"
  },
  {
    "email":"ms.vesilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404235130/96bd0af01f67bf344be22908069e25f4-1730301692"
  },
  {
    "email":"yvonnecrudeli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404300666/091407c5d9b9ee50504326d88c71aed0-1730301692"
  },
  {
    "email":"dalila.cecchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404333434/79b6f292e6fe2fb2ec79687bb7356dbb-1730301692"
  },
  {
    "email":"cristina7cidronali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404595578/7505e54b2a5d45509a3de30bed0dc119-1730301692"
  },
  {
    "email":"federica.zaccarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404366202/bacd898b8a7a0dce84cd733c8ac79da2-1730301692"
  },
  {
    "email":"manueladinato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404530042/886b91683539ca18d0bb9e244f7b06b2-1730301692"
  },
  {
    "email":"nistico62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404398970/afcf87df1ccc1e566701c242aa993801-1730301692"
  },
  {
    "email":"isola1984@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404628346/39f9709092acb40e23e356cb814652c6-1730301692"
  },
  {
    "email":"saratalenti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404693882/10a4040460d9c137c49032d4e29788a1-1730301692"
  },
  {
    "email":"framafa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404726650/b6776d43d896e4283c644e67d56d9e67-1730301692"
  },
  {
    "email":"lhele_84@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404661114/5b6989bee1011691f2e0f07c9d2a6c62-1730301692"
  },
  {
    "email":"lorenzo.brussolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404857722/6382b8445261fd97b496f40691df0225-1730301693"
  },
  {
    "email":"helgaangelini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404890490/659589118c3169f04cd7fbaf2f39b59c-1730301693"
  },
  {
    "email":"sdallasta@tardini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723404956026/0103638c6bc9dc6bfae0a303e1538be3-1730301693"
  },
  {
    "email":"by.66@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404824954/9c49cad21479efa6f0a2d779c221ddb4-1730301693"
  },
  {
    "email":"aleppia17@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405021562/181573d7622eb7c9c6aeb36f4259a0da-1730301693"
  },
  {
    "email":"fedepapagni94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405185402/e0697f1c0824fd75e87e33446b78f9ca-1730301693"
  },
  {
    "email":"marina.piovera@spinvest.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723404988794/5cb657696776a81cc65f47277b48c699-1730301693"
  },
  {
    "email":"markeis77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405218170/1cba89b883a604fb32683952f6366520-1730301694"
  },
  {
    "email":"sonia.sinibaldi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405119866/d0a3dbebea851124b5ce3e9ffdf66a2f-1730301694"
  },
  {
    "email":"info@meraviglieinoasta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405250938/d46376170182a9706c3a37761f6a824d-1730301694"
  },
  {
    "email":"chiarahsavoia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405349242/ee11ac2943b0cb96ed1d6e1bcb042fd2-1730301694"
  },
  {
    "email":"noos.sergio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405414778/4b0c379cd39d567a52fcc0d7dcf252e8-1730301694"
  },
  {
    "email":"elianafratnito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405382010/ebcdf71f634cfe47d3e0ce170e612d22-1730301694"
  },
  {
    "email":"stefania.magnani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405447546/31c4a60116a4ae59482937b2f973270e-1730301694"
  },
  {
    "email":"facconti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405480314/5185087f5668348b0543290c659115bb-1730301694"
  },
  {
    "email":"robertacervato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405513082/abf8e1df2d67521bf05f12a1a4041b01-1730301694"
  },
  {
    "email":"ladido@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405545850/4db8faba18703e87f421651d09071851-1730301694"
  },
  {
    "email":"bertoni_alessia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405644154/7943a245ec93321cdab1cadd5e2f7dd3-1730301694"
  },
  {
    "email":"comazzettopamela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405676922/65ae65f8e823ebc4411c77c03c0e35d3-1730301694"
  },
  {
    "email":"sweet_taste@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405775226/943e7bcc90ab3ab6877171f87c1964e0-1730301695"
  },
  {
    "email":"l.luisella.77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405807994/7db9668c952adc7161eb9e8c65002777-1730301695"
  },
  {
    "email":"eleonora.valmaggi7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405578618/b782269deccc953ce0bf809eda920a09-1730301695"
  },
  {
    "email":"mikimanugiada@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405840762/165d0c2a1bf914c1238f104da078c00e-1730301695"
  },
  {
    "email":"eleoresta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405742458/10a8e86e7d7a7781977a77e742f0774b-1730301695"
  },
  {
    "email":"acastrav@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405971834/c0313e17961e33f0d025e22d947207ec-1730301695"
  },
  {
    "email":"emanuele.strano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723405939066/70f2e1f7ad6e48959013fd12c963fdb3-1730301695"
  },
  {
    "email":"ramona_purdelerl@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723405873530/403088ccc7948ff7156bd43ab32605c9-1730301695"
  },
  {
    "email":"mrado5@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406070138/02d49ef50487adfba2838289d7bb40e7-1730301695"
  },
  {
    "email":"margheritacongiu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406004602/fe96a8f94b44ae990aaaa4eb8239966c-1730301695"
  },
  {
    "email":"martignon82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723405906298/8c3ccdf183a1a337bd310835e8740461-1730301695"
  },
  {
    "email":"lucamoran@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406168442/3eb0729171d17734fed8fee5c80804de-1730301696"
  },
  {
    "email":"takib62@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406233978/6b7d2d61b69b6e8ea3a60b36cbd9d36b-1730301696"
  },
  {
    "email":"lauspine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406266746/8ada955de2892a4739e1181be9128005-1730301696"
  },
  {
    "email":"silviatagliacozzo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406299514/1710f5a01f79e1d7574ccdc71f7fcf4c-1730301696"
  },
  {
    "email":"mariateresaridolfi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406332282/c4a584d94ad46e325ae401fdb844d511-1730301696"
  },
  {
    "email":"milena.naso@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406397818/f08a65bc8cb6f5f25283b9aa2a8bbab3-1730301696"
  },
  {
    "email":"daniela@naturaliasalerno.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406365050/352d04c644e1a138fbee89ef882df63a-1730301696"
  },
  {
    "email":"fardy82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406463354/b2367e25d30787686a6272df5f070398-1730301696"
  },
  {
    "email":"carolina.pierdica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406528890/41113e1a58b8cdd38d3bf309c832c04c-1730301696"
  },
  {
    "email":"simon71.cri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406561658/436491e9775cee56b4c0f8ccdf902bec-1730301698"
  },
  {
    "email":"luciabandi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406692730/0c05c3c4b73dd16365e98751b8ac0951-1730301698"
  },
  {
    "email":"antonella.noberini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406627194/a6d1906556d1187d2e0d8a523dc784c0-1730301698"
  },
  {
    "email":"fantuzzi_francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406594426/4972b2c9137df900eae863ee49531586-1730301698"
  },
  {
    "email":"elvira_allocati@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406758266/7ed8c8baf2eb14b3f33a3af12251492e-1730301699"
  },
  {
    "email":"mauro.guerini@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406791034/9006eb0da71789dc7bbc87c5a7fec9ec-1730301699"
  },
  {
    "email":"pink89.sdb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406725498/83597acea7530d62cff83f26ba46bae5-1730301699"
  },
  {
    "email":"postaeleonora@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406823802/866170a43f1f899641bbf01f57181e80-1730301699"
  },
  {
    "email":"avv.gaiagalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406856570/c9564d083654a86b4f19c87fd3bc1e95-1730301699"
  },
  {
    "email":"simona.stac77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406889338/f56c1aa2c16268e57ecf74eca4f33d74-1730301699"
  },
  {
    "email":"v.loschi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723406922106/ba7a475c3d4513ae9f4f53076dfd46fa-1730301699"
  },
  {
    "email":"michela.boscarato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406954874/d44f1cea06e6477b0e6f7bebfc6c2d2e-1730301699"
  },
  {
    "email":"fbianchi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723406987642/54a41c5139ea3c107ce6c1de8015439f-1730301699"
  },
  {
    "email":"simona.severini1@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407085946/af59e6305217dcbe9dc941be171b4a1c-1730301699"
  },
  {
    "email":"mayelin.perez@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407020410/215bdf4fcbbbc10dafd0f205d8328f79-1730301699"
  },
  {
    "email":"elena.peruffo@poliziadistato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407151482/1eb8f48cd9e765fd21522cb2c1db0691-1730301699"
  },
  {
    "email":"beautycenter.lisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407282554/a764912d0ac3f536dd803219a3e7445c-1730301699"
  },
  {
    "email":"el.venturi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407184250/ee8852adb0a98c4b25ecc38c09223a9d-1730301700"
  },
  {
    "email":"lara.benacchio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407348090/7bfe836bdbc2adcf6155a026f381e6bd-1730301700"
  },
  {
    "email":"monise67@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407217018/157713d6747662a324e5d70b7158de5f-1730301700"
  },
  {
    "email":"royalbedandbreakfastroma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407479162/6b58e2547dee65d3ca9e517c8f698ff4-1730301700"
  },
  {
    "email":"ra_rizzo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407446394/7ab977eb084c91fcf7ac0c67853bfa45-1730301700"
  },
  {
    "email":"silvia.bottero1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407675770/947010b9c9a83c3cdb94a1408c0b4941-1730301700"
  },
  {
    "email":"giuli84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407643002/0337ff34b43827cabafc28969e872cc6-1730301700"
  },
  {
    "email":"cpaliotta69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407708538/3c961d557aed92eba699aed7abab3808-1730301700"
  },
  {
    "email":"nmanfreda1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407511930/69988ad716862a5a0fa073c05666f994-1730301700"
  },
  {
    "email":"emilia.ranieri89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407774074/5328e730342b4b06c77624810d1d2d61-1730301701"
  },
  {
    "email":"jessyapple@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407806842/1ad33c5b8f26654631a8214127471bee-1730301701"
  },
  {
    "email":"ottavia.folladore@horsa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407872378/83c0bba2fdb5ed1b64a60b92c46c0e26-1730301701"
  },
  {
    "email":"francadelcotto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407741306/194441f42dda53954a4f700949d84d04-1730301701"
  },
  {
    "email":"nadiapittolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407839610/c6f1dcfc928022e07791c132bced9b71-1730301701"
  },
  {
    "email":"daniela@bedettipozzato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407905146/cd6080957c6e310bef518f349d397bce-1730301701"
  },
  {
    "email":"fpiccin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723407970682/69be57ed7efe6e8537410bbbeefc7bdc-1730301701"
  },
  {
    "email":"anna.barletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723407937914/5c1c85120b0b4f666133813a7ae89f37-1730301701"
  },
  {
    "email":"anna.sustersic1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408003450/c7a1337f2e5842ce2a2c3bdc92ba5308-1730301701"
  },
  {
    "email":"sarazampirolo97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408036218/64fd0590c4dd604f4acf54840b9d638e-1730301701"
  },
  {
    "email":"rossanoc76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408134522/49a869bf428e6c97f7acb41c1a7bb039-1730301702"
  },
  {
    "email":"simo.bose@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408167290/7336e9040b91838d75b460b349b305f5-1730301702"
  },
  {
    "email":"ariaparis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408232826/e359fdca00c5bd70c20bcf2fa9cfdd0b-1730301702"
  },
  {
    "email":"cviolante73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408265594/0089fc2205e2ecd309a599748b53ab14-1730301702"
  },
  {
    "email":"barby9271@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408101754/c0993a2602bbe879fc7a4f65fed7b2fb-1730301702"
  },
  {
    "email":"francy.lavia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408331130/1e0e0db8cc49e6e8412c92c90bcfac0b-1730301702"
  },
  {
    "email":"l.provenzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408396666/065402feff2980ba3e93511327eda81e-1730301702"
  },
  {
    "email":"inescarini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408363898/cb8b996e28e7f19b355c2ca334ef6ae9-1730301702"
  },
  {
    "email":"d.golles74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408462202/5ebb09c5bc811fd20de990a2b6194bfc-1730301702"
  },
  {
    "email":"annavola@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408298362/0337356f7c5e76dbb461a65d264154f9-1730301702"
  },
  {
    "email":"vere_p@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408527738/2d78059f9370b3b9b98386421862a024-1730301703"
  },
  {
    "email":"claudia.bosi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408593274/f484e132c4f58f816abd86e915b39576-1730301703"
  },
  {
    "email":"kikaponti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408626042/ea62094f553ce1e35c17cb0d1c03c2a1-1730301703"
  },
  {
    "email":"giulia.mik@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408658810/e8df9f85c81247f717f27b90e978d0cd-1730301703"
  },
  {
    "email":"dolcevitagiuliana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408494970/729b8b9cb0c081b81bebe2b8509d6cf6-1730301703"
  },
  {
    "email":"smastrone@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408691578/eda9fbcf1654aabe9365967c3b227ad8-1730301703"
  },
  {
    "email":"carmen.libardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408724346/c9c18c646f4f4c1f2e8f344e2c845a80-1730301703"
  },
  {
    "email":"roberta.rasera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723408757114/0272517808c6f91eaa7dc6e20234e9f3-1730301703"
  },
  {
    "email":"tulliabonfanti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408822650/4a3d79920a1acced2a7cccd501792c97-1730301703"
  },
  {
    "email":"alessandraruggeri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408789882/e1ccccd49879bfda4e640e24cf8fc55e-1730301703"
  },
  {
    "email":"tiziana@paralleloweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408986490/be23433f4d81a004280bb1555fa4e16b-1730301704"
  },
  {
    "email":"semionovm@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723408855418/c271d2b7bf83d62f64d5017f8abbd588-1730301704"
  },
  {
    "email":"ago.ferri.62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409019258/3000aeab436298f3e92fce3e0164587a-1730301704"
  },
  {
    "email":"lucianobarone.lb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409084794/2a4c996b38a0a41fa455101bb74315c6-1730301704"
  },
  {
    "email":"sileziacouti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409117562/066daf4ad14c84da1dd99371a640b47c-1730301704"
  },
  {
    "email":"elena.albrieux@leonardocompany.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409052026/3409b3708d201f9d5f0dae8f8cb0bf4f-1730301704"
  },
  {
    "email":"manuelitamanu.1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409150330/9a8760bd91122983f6fe8f6806f1622c-1730301704"
  },
  {
    "email":"sabrinalumia76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409346938/13cb8f9d6fe48786a6c49988dc5eeb70-1730301704"
  },
  {
    "email":"mariaalessandra.bertini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409379706/65ed7b12406a23809c12dad7f8244629-1730301704"
  },
  {
    "email":"valentina.meroni86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409412474/afa13dd1307b399dd07750fbb71b8351-1730301705"
  },
  {
    "email":"chiara.reali@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409445242/f828a92b7d573c81637b0793877c6884-1730301705"
  },
  {
    "email":"barbarasella.vi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409183098/63a7513f1a33b2408002569fc9368a30-1730301705"
  },
  {
    "email":"a.mancioli@covercolor.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409478010/e512a12232ba9e6ec4c7c0f71a48c9c3-1730301705"
  },
  {
    "email":"orkydhea@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409543546/6bc2d4121fb4f797fed7d4152d426e39-1730301705"
  },
  {
    "email":"chiaramontanari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409576314/eac17adb06800fbf145e1a41478ab1cc-1730301705"
  },
  {
    "email":"h.palu75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409641850/fb7934d758b647c574e253a365804992-1730301705"
  },
  {
    "email":"denise.lussana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409510778/91534f3011b6c94b0f3a1086c3375496-1730301705"
  },
  {
    "email":"paola.clou@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409674618/630300a92d306970549c47f70a871003-1730301705"
  },
  {
    "email":"emanuela.cricri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409772922/c9155215399a4a0609778b7cb85ffc60-1730301706"
  },
  {
    "email":"maranolinda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409805690/883b8579f03f94a226cc1ceebd0816f9-1730301706"
  },
  {
    "email":"barbara.rota69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409903994/4142937fa36350389f184338df337bfa-1730301706"
  },
  {
    "email":"simo.guccissima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409707386/6646fa1ce7615a2b15bc3ccdb7927dd0-1730301706"
  },
  {
    "email":"marchifabio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409740154/ef7a1012c9ce19044a23093d1a152db4-1730301706"
  },
  {
    "email":"alessiabonanno87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409969530/5df745f034a0cd31a2fe3e92f4a263fc-1730301706"
  },
  {
    "email":"giulianatomadini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723409936762/bbb58fc0e7e85c7bb2b688d33d40579f-1730301706"
  },
  {
    "email":"fragalaxynote@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723409871226/43c816727570b97cd7a016e3aafee612-1730301706"
  },
  {
    "email":"cutroneelvira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410002298/42b6a466ef53b8adb5275cad480d435d-1730301706"
  },
  {
    "email":"gianluca.lattanzio73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410133370/51a15175e84137fad5d6799863872fd9-1730301707"
  },
  {
    "email":"cchiosi16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410035066/cffb8c6c33402e7dfb75567a6be2a649-1730301707"
  },
  {
    "email":"mfabrizia2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410100602/e00b31a88f7c1834ad76c91083220388-1730301707"
  },
  {
    "email":"giannadander@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410166138/b5f6ea31018a867aec20f6c77a88879f-1730301707"
  },
  {
    "email":"samuele.verdecchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410198906/5b817e95577b6334eebe7e2845f78267-1730301707"
  },
  {
    "email":"chaosmt233@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410297210/ba98836ae83bf24ba6f7f5f0cc0bd9bb-1730301707"
  },
  {
    "email":"pbassi282@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410362746/06153ce35140f335e305ca44a0a11f7c-1730301707"
  },
  {
    "email":"moniaazzalini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410395514/2f6155bbe040afe268117eac74e10a75-1730301707"
  },
  {
    "email":"annariccia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410264442/4ab3b13b67343327fdcc7d6e0f2ef732-1730301707"
  },
  {
    "email":"carla-bruni2012@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410329978/2485b9c85f2a54516c772c8099c69e58-1730301707"
  },
  {
    "email":"soniastrassera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410526586/9fde5ec044589df3148b44e3ef8269fd-1730301708"
  },
  {
    "email":"sylviarungger@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410559354/a9959f2086c32336a56849f1d2e553e9-1730301708"
  },
  {
    "email":"loredana.marte@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410493818/48d6d9f659a516d8066341b81aa2dc0f-1730301708"
  },
  {
    "email":"andreakimbo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410428282/bbaf8c48dd71134a87ed1aa04e050d51-1730301708"
  },
  {
    "email":"mariangelamarcoleoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410624890/aca77a7e04af44d6e405c6b77b7d08b2-1730301708"
  },
  {
    "email":"laura_carta74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410657658/a9ec04c23153fe61564f736082519181-1730301708"
  },
  {
    "email":"giorgiabertola21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410690426/e19cc27185fb102873f47d00c7d76817-1730301708"
  },
  {
    "email":"sara.rizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410723194/20315f993168e0fbdbcb4b9bdbfdf732-1730301708"
  },
  {
    "email":"t.cardillo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410592122/d0ad04c4ff38b969f1a5dc3fd45065ca-1730301708"
  },
  {
    "email":"fede.2793@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723410755962/8ed8bdfbce320dae7dc987ab67fe821d-1730301708"
  },
  {
    "email":"tinacioffi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410854266/a673d6e82be88aedab02432adbe91e4a-1730301709"
  },
  {
    "email":"flo1971@hotmail.ir",
    "url di attivazione":"https://verdissima.it/account/activate/22723410821498/e7366e2b718e4f70bac4189c5d359b8c-1730301709"
  },
  {
    "email":"alessandraparlato88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410919802/ae913416d22cec9f9c281ecf9dc87fae-1730301709"
  },
  {
    "email":"lorenaescamilla4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410985338/137722f0ff9a4cec5e380da4f9fd9157-1730301709"
  },
  {
    "email":"laradalforno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411018106/a34454c49a4a62424e5689ba52ce04bf-1730301709"
  },
  {
    "email":"tesorovenice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723410887034/ef2624638521aff879b3297bff0dcd2d-1730301709"
  },
  {
    "email":"liukic81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411050874/69b1dfee61b2b332cab983443b9b8fec-1730301709"
  },
  {
    "email":"sabrina-martinis@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411116410/7d8c665151c1089350d666d79de0f367-1730301710"
  },
  {
    "email":"annadignani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411149178/8937c5fee3cc79684f034cab894ab031-1730301710"
  },
  {
    "email":"serena.dangeli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411214714/79591c09a98b35cc1fa60b17f6e9ee93-1730301710"
  },
  {
    "email":"efelicissimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411181946/4c1878d43e49a155aa65ad87de7a1d04-1730301710"
  },
  {
    "email":"susannaci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411280250/54bf8dfd0f0024a485eadbc273c42460-1730301710"
  },
  {
    "email":"carmensuriano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411313018/30f307fde26c3b826caec1353504b7e3-1730301710"
  },
  {
    "email":"ruffanello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411345786/eeb27364ac0ccfa02c4cb7f6ef26a134-1730301710"
  },
  {
    "email":"anna.rosito21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411247482/b8250e33f40d42d3ad6c69ba7a077d87-1730301710"
  },
  {
    "email":"elisabettarosi66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411411322/9785fca32dd25e86d0939dc7306316d3-1730301710"
  },
  {
    "email":"pina513@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411378554/3244f84c3599031dfd44d21b1996bc4a-1730301710"
  },
  {
    "email":"antotinny93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411444090/9ac3daa7e175f2eb572327bba0f1be9e-1730301710"
  },
  {
    "email":"valery-80-roma@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411476858/113ab6f59256787fbfff75738cdeea94-1730301711"
  },
  {
    "email":"mirabellamargherita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411575162/ba48422d78113e16e0c7579dc2745d2c-1730301712"
  },
  {
    "email":"marcoferro@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411542394/aa67ef0f865098613987461fe82ca5ec-1730301712"
  },
  {
    "email":"sere.alberti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411509626/6abb250a12271652d579e9d52b59b50d-1730301712"
  },
  {
    "email":"sara.pedretti@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411640698/905778be33a5564f7e2b820cccf4e2bb-1730301712"
  },
  {
    "email":"pamelab@bacciottini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411706234/a35073933fbe07f2d471aa5f339bce2f-1730301712"
  },
  {
    "email":"andrea.gribaudo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411607930/b4128d7cf1f9368d05a0ed440809c03d-1730301713"
  },
  {
    "email":"carmen89-a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411771770/9769681c1df7bcca402ffc6bd6f8286d-1730301713"
  },
  {
    "email":"santinar@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411837306/d68bbe2ee3d02ea66d0a33729b828cb7-1730301713"
  },
  {
    "email":"ludovicovaloroso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411870074/b32944ae84352db82838b7706ba5b3d1-1730301713"
  },
  {
    "email":"alessandra.dercole@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723411935610/7f008bd0bff326f832a7700192db9b4d-1730301713"
  },
  {
    "email":"eleonora.colombo87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411739002/a1b84dfeeead66c25e21ea429744000e-1730301713"
  },
  {
    "email":"annamaria.bagnasco68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412033914/a777a49913ef77a56fa087825f6f141b-1730301713"
  },
  {
    "email":"giocher61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723411968378/088d210b251fd525c08afe63114bba45-1730301713"
  },
  {
    "email":"vbjanco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412001146/4d93ee6887bddf779231179fe7a5e02d-1730301713"
  },
  {
    "email":"zedda.efisio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412066682/d521c72ed0fee71048753f49a6665334-1730301713"
  },
  {
    "email":"manzileonardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412164986/fbc3926fd8ad7b40e48a9914695f8349-1730301714"
  },
  {
    "email":"micaelapivamerli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412197754/489bfdf00538de7a14120c7e294f9e87-1730301714"
  },
  {
    "email":"ellypeg@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412099450/7d6887f44867006f44fd9794c0a57e2b-1730301714"
  },
  {
    "email":"ivomannubouche@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412263290/02f14a55b710c4af99a03d4662078466-1730301714"
  },
  {
    "email":"nokin0023d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412230522/d71599280e467c3026be7d313d29c6d3-1730301714"
  },
  {
    "email":"chiara_gna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412296058/be36f5dda1c7b9be450ffd79d594fdc9-1730301714"
  },
  {
    "email":"f.morelli93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412328826/822b3158ef6146cda03b5dfd9784a244-1730301714"
  },
  {
    "email":"fulgenzif@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412394362/c281faf6e02c38d06c0fb5b0fa69edbf-1730301714"
  },
  {
    "email":"alfonsinamanzilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412361594/69e4d901489c9f58cf162d0c24324cc5-1730301715"
  },
  {
    "email":"alessia.murrau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412459898/dce5617c2f7bc6265398d9f7f1121139-1730301715"
  },
  {
    "email":"rossellafabbri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412590970/b7de064a1ebd435cb0e0da8cb611ac17-1730301715"
  },
  {
    "email":"estetica_nadia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412558202/8f26098b30fef75006a72d1838b1cbb6-1730301715"
  },
  {
    "email":"rebecca.marzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412623738/9618a6061093945b91a4c3812fd44111-1730301715"
  },
  {
    "email":"oliveroolivero.carla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412656506/61fdf727499a168ec000fa473e6e9e64-1730301715"
  },
  {
    "email":"teresad80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412722042/bc941004ce6ae7f7dceb7bea626c0305-1730301715"
  },
  {
    "email":"monari.barbara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412820346/369e9a1fc77255eedbc580ae42bd8d84-1730301715"
  },
  {
    "email":"mariachiarapicchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412853114/380d8009f3581a23fa70d11daad4b641-1730301715"
  },
  {
    "email":"rotella2005@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723412689274/ba3bfbcb70fe3c2e712852ad45445f09-1730301715"
  },
  {
    "email":"paolabolognesi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412885882/1af9f15621e1cd5242ea7d1454a2ee87-1730301716"
  },
  {
    "email":"astrattisonia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412951418/db279ece7a3fafd2e53d46d49e81b745-1730301716"
  },
  {
    "email":"saraferrettiweb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412787578/081e545a737c1832cd6083b025481c44-1730301716"
  },
  {
    "email":"elenagiuliani105@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413016954/c8714dd29e7c22db678cfa191e31c045-1730301716"
  },
  {
    "email":"chiaragobbi.mn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413049722/c218befb2d1593ee7211759adea82b7f-1730301716"
  },
  {
    "email":"alberto75@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413082490/80327e4607787bd91c1a468c5fcaddb2-1730301716"
  },
  {
    "email":"serena.conte@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723412984186/0fede2981d7bc5fc9aef7ceb37d7cdd5-1730301716"
  },
  {
    "email":"martina.vestri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413148026/ccfee5d15ad9f350154340ca63eb44d0-1730301716"
  },
  {
    "email":"tamandi.gabriella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413213562/e5e74583e7a0cb86ef8a38af935d5e70-1730301717"
  },
  {
    "email":"monica.favaretto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413311866/bd77c0661623d4d3db6758c1fe5a24fb-1730301717"
  },
  {
    "email":"carlottaperuzzini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413180794/cb4d121c74e163a939773f5a6dbeb915-1730301717"
  },
  {
    "email":"stefania.lombardo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413279098/4e3f630c1cbf4d158273dff024313b65-1730301717"
  },
  {
    "email":"giuliatan91@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413377402/2eee856680b65bd9bf54cdd22c074f98-1730301717"
  },
  {
    "email":"stefania.giuliani1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413442938/f5619a811d4c4bebb9f6b18940fc3344-1730301717"
  },
  {
    "email":"irenepadovani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413508474/5bbca4ae6f691956318e9d0380ab7916-1730301717"
  },
  {
    "email":"michela.brunetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413574010/852318fc619c2008946eed81da008dec-1730301717"
  },
  {
    "email":"paolettasg@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413344634/ca08d90239df8980e01debc7a85fb908-1730301717"
  },
  {
    "email":"giorgino1724@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413639546/7e5fd54c104be1c1dd938e262afe4642-1730301717"
  },
  {
    "email":"franca.marsilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413606778/8e2af1c598e188dd95034897d37945a5-1730301717"
  },
  {
    "email":"info@rinaldiarreda.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413737850/78afa9b42f23d8da9585162a0c000618-1730301718"
  },
  {
    "email":"frat84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413836154/df844d23cc4ae1c9b930e8c3d84d1637-1730301718"
  },
  {
    "email":"alessandra.gallo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413868922/5fe771d5f3b34b63df659f9d21d3c4b5-1730301718"
  },
  {
    "email":"russoangela.teresa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413672314/962081edd2ea8ca94fd3b5191fc2ef4f-1730301718"
  },
  {
    "email":"affanninicoletta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413967226/074d30a10a31ca7b2dd4020d2ef4411d-1730301718"
  },
  {
    "email":"pitzisntimanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723413999994/a1aeab40476b96530e376aa2d740cfde-1730301718"
  },
  {
    "email":"rosannavitelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723413901690/12c3643089b00ef0973ac778bd867b0a-1730301718"
  },
  {
    "email":"valerio.pozzati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414131066/e27440eacb7194f1274e34353a595904-1730301718"
  },
  {
    "email":"nientediniente0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414196602/ba37391d058b8d95db3de765081115b1-1730301718"
  },
  {
    "email":"danielamanfredini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414163834/504f6e764f6ee554657d2c748be53144-1730301718"
  },
  {
    "email":"chiara_baroni@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414065530/c481deec251953d63e967409f42a6289-1730301719"
  },
  {
    "email":"borgese_m@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414262138/efa9915aaf17d72dba52a7dda39228d9-1730301719"
  },
  {
    "email":"engi1996@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414360442/875c962a1386dea42be7a376d97ff3fe-1730301719"
  },
  {
    "email":"tisot67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414458746/d22e576fc44dab144a56d6bbce94ce7c-1730301719"
  },
  {
    "email":"mimottibarbara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414425978/1b5605d801be7d1efd839c4b594f14c4-1730301719"
  },
  {
    "email":"layir25892@2go-mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414393210/6f76a9f95fea0408e5012a68ac4903ad-1730301719"
  },
  {
    "email":"vglaura74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414491514/0eeef2ad1fe49d13d62f9b0cc635f1ca-1730301719"
  },
  {
    "email":"espose0@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414524282/ed820edbbe7bc6d438825f03650f71a6-1730301719"
  },
  {
    "email":"info@gadar.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414557050/e3870abe9262f41de8697055e2ec118a-1730301719"
  },
  {
    "email":"monica@ghira.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723414655354/0f163e78134fd9a95da2b6e81a68eeca-1730301719"
  },
  {
    "email":"sorita2009@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414688122/b1cdfe81498f1917469a1422b05cb4b5-1730301719"
  },
  {
    "email":"stucchi.barbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414720890/71757774216f7b95db1f768e631ec353-1730301720"
  },
  {
    "email":"missgioia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414851962/5316fe4ccbfb5bbee0be14c5669609ce-1730301720"
  },
  {
    "email":"ftampieri75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414884730/3c1bbb19cc8f7e5e985028a08dacb814-1730301720"
  },
  {
    "email":"delia.roselli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414819194/133a5fb693b1ebe73e521bc53f788d6a-1730301720"
  },
  {
    "email":"ivana.sportelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414753658/4c3e7c2c4bba56e1462f43b56c9033b6-1730301720"
  },
  {
    "email":"luisella.zani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723414917498/b9fef6384791efe3e4e82f8f01448386-1730301720"
  },
  {
    "email":"lena.minutiello73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415015802/5f3b75ca7c6bf721c00a56e4ebd8ffea-1730301720"
  },
  {
    "email":"roberta.raggi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723414983034/6e41d658432b0adb2db25d1ff389fb39-1730301720"
  },
  {
    "email":"gilligiorgia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415081338/a8b6ca2c9db6d6d952c95bec596da037-1730301720"
  },
  {
    "email":"salvati.donata@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415048570/8673b6a49bdb621b43088a0f045af0b1-1730301721"
  },
  {
    "email":"michela.vian@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415114106/094f06630453323e95613f5004f1dd65-1730301721"
  },
  {
    "email":"ferri.massi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415146874/91eb2c012c397998093a338f99e390b0-1730301721"
  },
  {
    "email":"c-i-s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415179642/c813f79b060e1902f9ae149c1e8df7dc-1730301721"
  },
  {
    "email":"el_black_cat@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415212410/1b17264b64ea974e5d0902e6cd508a21-1730301721"
  },
  {
    "email":"morena.clb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415310714/491dcd29e37e2a419a8780c1b3495747-1730301721"
  },
  {
    "email":"srgg00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415343482/e950e536e1e8416349a186a6d56cda40-1730301721"
  },
  {
    "email":"marialandolfi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415376250/7232e1cf1d582deae30c0b8a75c05fa5-1730301721"
  },
  {
    "email":"stef.balla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415441786/8c66c9604ea61f3517be977c277a5005-1730301722"
  },
  {
    "email":"cascio.paola@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415507322/6de19d354bde52dce48731e69a5f24ef-1730301722"
  },
  {
    "email":"maurizio.scolari59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415474554/00452f75f71c82eb8f9e9797d7ddb235-1730301722"
  },
  {
    "email":"mguglielmo@labosuisse.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415540090/8a37c08af553ddac3155b1caf406e143-1730301722"
  },
  {
    "email":"civetta753@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415605626/ff744533e9adb6d1d322142498854790-1730301722"
  },
  {
    "email":"silvia.ramonda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415409018/a3eaa4dedb020268916edf5e99297f65-1730301722"
  },
  {
    "email":"cri.fabrizio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415638394/465198927de761c96fb0cae71871264d-1730301722"
  },
  {
    "email":"valeneiro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415671162/6eae391b9088c8dac21b9edb980edfec-1730301722"
  },
  {
    "email":"gdagostini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415572858/24826f2b3761b0fd81df68448856048c-1730301722"
  },
  {
    "email":"crcollev@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415769466/1930caabcaea547f2d908618cbe7a707-1730301722"
  },
  {
    "email":"vanessa.olivari85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415835002/097abb626712f811a8c5e4ae3b163bbd-1730301722"
  },
  {
    "email":"laura_detoni@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415802234/2d418be4e06156c83e336c2d4076dec0-1730301723"
  },
  {
    "email":"caterina.andreini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415736698/7984720cb3a96ee2f88d5d6fd7335ad1-1730301723"
  },
  {
    "email":"supercencia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415933306/73525363497e2a347947f8c622044da5-1730301723"
  },
  {
    "email":"mariangelapanto@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415900538/914b3beba90fbb03e00bf0a20e618e52-1730301723"
  },
  {
    "email":"a.loiacono88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723415998842/64f4ffb123fea1744710c6c34e5b5d1b-1730301723"
  },
  {
    "email":"annamariasarlo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723415966074/0ab09d57d8a43200365932ccea41c76c-1730301723"
  },
  {
    "email":"lucia.bientinesi@glv.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416064378/8c42f3f320ccccc349ddbdab54da8df7-1730301723"
  },
  {
    "email":"silviarch81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416162682/dfbd7849fc0ed153e7356cbc492b1a9f-1730301723"
  },
  {
    "email":"dorella.comaschi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416031610/a5b8b01aff5078ed94744b694d01b5f1-1730301723"
  },
  {
    "email":"lunablu.sb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416195450/f20743df4d7ce69902d0604e25d2b3e5-1730301724"
  },
  {
    "email":"yackdags@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416359290/9dea2326f9dc7dc3f1ff30e61f0bc5f9-1730301724"
  },
  {
    "email":"rachele.parodi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416260986/fe31134149f2dc7176e25f15d3042091-1730301724"
  },
  {
    "email":"agnese@trinorappresentanze.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416293754/dbd85097a52507903f8af4db13f47d25-1730301724"
  },
  {
    "email":"margherita.ferrandino@rai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416457594/9e12358d9090b403feb60f6939a29837-1730301724"
  },
  {
    "email":"ilena.pagnozzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416490362/bb148f1fe876546cc28955e2f7a29c2d-1730301724"
  },
  {
    "email":"perini.lucia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416555898/c9c2e4e390ac676e4e34d62fc1953582-1730301724"
  },
  {
    "email":"letizia.diana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416392058/331c1a3a4b098b945847dfd3662562f9-1730301724"
  },
  {
    "email":"ferrariosilvia23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416588666/a379ff4231605669c404cee8b5a27806-1730301725"
  },
  {
    "email":"eldorrio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416719738/479265f81ef362e50734dea998e3c234-1730301726"
  },
  {
    "email":"nicsilvy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416621434/c7045334a5174a25211b25229ede3582-1730301726"
  },
  {
    "email":"amarchetti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416686970/5340f13e31ea6f4d8adf14d3d531e4d0-1730301727"
  },
  {
    "email":"elisa0303@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416785274/7ba553a889f8c2f888d5e0ab67af2d04-1730301727"
  },
  {
    "email":"francescacosti62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416654202/da8fe7c3e0043f2d8ec9b429ed8cd28d-1730301727"
  },
  {
    "email":"rosanna.favero07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416818042/fabff0fd3fb5a9f80324518bae47d74c-1730301727"
  },
  {
    "email":"marta.tortora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416850810/1b1d4cbd76fbb691580eb86aa0247417-1730301727"
  },
  {
    "email":"silvia.rossi@socgen.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723416752506/0b673c680bd9fa4e14a34e1293e6f74d-1730301727"
  },
  {
    "email":"paolavalse@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416949114/b911782b52d384af51f82ba9a0113325-1730301727"
  },
  {
    "email":"cristianapracchia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723416916346/54b89d33c87596a322fa141bb69222e6-1730301727"
  },
  {
    "email":"rnllbernardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417014650/d9cf8f1c32829c0cb40e40f0828b6dac-1730301727"
  },
  {
    "email":"brunellagallino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417047418/d7edfc097d27f339a3bf65eafffcd382-1730301727"
  },
  {
    "email":"vale68ao.c@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417145722/92f938f4cefdbd674cce9f2aac823c88-1730301728"
  },
  {
    "email":"susanna.basso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417080186/77417873b4f91599fc2fe8a1cdde7bc1-1730301728"
  },
  {
    "email":"c.bazzola@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417211258/5a58d6e36d871ac7756c5cc43081e094-1730301728"
  },
  {
    "email":"simonacarlini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417276794/69d26b91903b23858c7d0725c37dabd4-1730301728"
  },
  {
    "email":"cascio.nunzio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417375098/ba2710babfdfa4f34b4b7dd4d2676088-1730301728"
  },
  {
    "email":"mantov28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417407866/7a4d137b888ef91e89255e5153176903-1730301728"
  },
  {
    "email":"santelli@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417473402/63181cd44c38ca2617b12d35ce686d04-1730301728"
  },
  {
    "email":"borghesani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417538938/0597ccdaf767df8257c0dc726f5e20d5-1730301728"
  },
  {
    "email":"darosvanessa49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417440634/950ee07a93536aa9058a26daa67741ba-1730301728"
  },
  {
    "email":"carrarofiorenza@yhaoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417506170/f07eb61155163b4f820711be1fe3a483-1730301728"
  },
  {
    "email":"guiabaroncelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417604474/d91d478fcfd03a22284182feaf49b876-1730301729"
  },
  {
    "email":"ambrapiccolo90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417637242/a7283142bec93b5be987c9cc27083df5-1730301729"
  },
  {
    "email":"lucia.gianfelici@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417702778/01284ac6008d1712ab67f390dca9f031-1730301729"
  },
  {
    "email":"giubruno@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417571706/9e8c07b87c3a325aa295ddaa4ce53683-1730301729"
  },
  {
    "email":"patrizia@bergaminiassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417735546/022d7a7f033bd291d914b7a3da5939e6-1730301729"
  },
  {
    "email":"cromobi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417670010/656cd9cb0e77b3828850b3fc2fc53201-1730301729"
  },
  {
    "email":"claudiapicciarelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723417801082/36ed701d62bbc6a6b14e98b3e43ee41b-1730301729"
  },
  {
    "email":"elisabettav.giusti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417833850/40e7af7c86747a35de7a7546d3ecb3ba-1730301729"
  },
  {
    "email":"elenascarabelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417932154/5cc7cd4f4058c8ed9ae7046f12f1742b-1730301729"
  },
  {
    "email":"maryysol99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723417866618/d925a0360fc700df9171c0fcd2060449-1730301729"
  },
  {
    "email":"mondini.agnese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418030458/149359538f12d40927e2b126a6ccc7ad-1730301730"
  },
  {
    "email":"aafederix66@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418063226/338d59bf5b489d9cc50a48d8c7395c14-1730301730"
  },
  {
    "email":"ranzanisabrina@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418128762/0cd9e350e153a0bf08ffdfb78a206e6d-1730301730"
  },
  {
    "email":"vale.nanni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418194298/04fc1a7f7579ce5208a39435baf08533-1730301730"
  },
  {
    "email":"carlinibea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418095994/3d18eb48219d94eb69aa6faae0341868-1730301730"
  },
  {
    "email":"marilena.colucci78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418161530/163fae8f5a4c256bfa014b19b6d7e2cd-1730301730"
  },
  {
    "email":"frviggiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418227066/91947cc735f120cd4f7fa743adb1189b-1730301730"
  },
  {
    "email":"lcaliperti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418325370/4bbc683851fe168bc572b1ff10551b57-1730301730"
  },
  {
    "email":"arch.locatelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418358138/124185ec23dba1fae96f4851c6c4f86c-1730301730"
  },
  {
    "email":"sarapaterni90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418390906/f582ceabc6e1953f1e82e3a7ce56cf31-1730301730"
  },
  {
    "email":"thomas.beghelli@ams.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418489210/3947aab99be9a5ba7526aeba60d8f1db-1730301730"
  },
  {
    "email":"francescacolombetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418423674/1f98aba9d80d11e1211c0a8e3f77f371-1730301731"
  },
  {
    "email":"annalisacetarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418554746/451ed019e59b0105d9007cd24e38a26c-1730301731"
  },
  {
    "email":"francescagriffo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418587514/a1da4adfe290eb04554da23ad399ac71-1730301731"
  },
  {
    "email":"catiapalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418718586/20dcdd7fab2b7228fa23273dc177c0df-1730301731"
  },
  {
    "email":"paolomarcon63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418751354/d3cd723329a1f6f95b21e393acb28a4c-1730301731"
  },
  {
    "email":"elenaponzio77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418816890/f2e34c91a0eab4ed9ace730549bc0200-1730301731"
  },
  {
    "email":"alessandragirotto1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418849658/7388ee1d166c036f853ab492d2942d4b-1730301731"
  },
  {
    "email":"e.pollini@mediacenter.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418915194/570e7d48803ace304ba581aeec55f8c9-1730301731"
  },
  {
    "email":"waldrand@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723418980730/c6fefa60fd8cea40b9e80eee1b9b809b-1730301731"
  },
  {
    "email":"lorenzobarabuglini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723418784122/ed21dbc1c9a97171fd867fb51bfbc487-1730301731"
  },
  {
    "email":"mdescalzo@mare20.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723418947962/bfce80cb6f7260ff7d821cdbca788d0f-1730301731"
  },
  {
    "email":"alexandraspath@hotmail.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723419079034/88307b137163f98d3e8eea1547d32b13-1730301732"
  },
  {
    "email":"stp.perego@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419046266/52899a48f06c7bdfbb574b835f0e5d3d-1730301732"
  },
  {
    "email":"anna@moko.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723419111802/ba5624faa3a924bdede886c9dbf975b8-1730301732"
  },
  {
    "email":"rosanna.candiotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419013498/988f1069151f8a2cf6263618d3f66e8a-1730301732"
  },
  {
    "email":"simona.caldani66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419144570/7f6c6bef34c3085c1c796eb31c899c58-1730301732"
  },
  {
    "email":"cordarapaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419210106/42778049632a2439287ca98ca5a0e541-1730301732"
  },
  {
    "email":"pedroni.cristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419177338/c5d0f67e9510a71b12131a4530d9a9b5-1730301732"
  },
  {
    "email":"a.cadonici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419275642/d0fdb801b460e5114b4e9ba545206fa1-1730301732"
  },
  {
    "email":"gabriella.dc76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419308410/1271bc6ea2885705e6f7146e23b39477-1730301732"
  },
  {
    "email":"vale.masciopinto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419242874/96c8fdc830b95a7d4b1261bb4c0b9fa5-1730301732"
  },
  {
    "email":"annamariaspeltra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419373946/b49794369b117453f1b70b566e735385-1730301733"
  },
  {
    "email":"msanelli80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419406714/7d0f5c83a4b5f6b464e655217663585e-1730301733"
  },
  {
    "email":"claudiafragale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723419341178/09aba711d6f2907c9cc5384916493560-1730301733"
  },
  {
    "email":"danielecilli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419439482/e14612415b56c45fa5fab8a060df4041-1730301733"
  },
  {
    "email":"avv.gaeta@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723419472250/ae4e95d0db57049e40223c9d7b68a1fc-1730301733"
  },
  {
    "email":"acome@payplug.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419537786/1a802b0f65307dfe852d7311f116fcd8-1730301733"
  },
  {
    "email":"edit.palotas74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419570554/1d533b7b97ac4c0a594da9ccca9d1b58-1730301733"
  },
  {
    "email":"sattarosy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419603322/906923b49afc529e9ab3f4d2927c8013-1730301733"
  },
  {
    "email":"peruzzomirko@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419734394/943de47bbe04f0fe2d490dfe276f2303-1730301733"
  },
  {
    "email":"elisabetta.malacarne@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419799930/646199d08266fcde47fae7c8464ffea5-1730301733"
  },
  {
    "email":"raffaellatorrini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723419668858/4686f92d35235d47b418b9fbfb5ae12a-1730301734"
  },
  {
    "email":"rossella@rosselladeberti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419767162/00bbfdd5d12adbf572843b2dfef7ebec-1730301734"
  },
  {
    "email":"licia.vadilonga56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419832698/84358d09c990079336c9a7a38b6b0507-1730301734"
  },
  {
    "email":"sama1975@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723419865466/b3f8dfe4ce7da89de28ba7501f30d8e4-1730301734"
  },
  {
    "email":"mondinifranca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419963770/f5c62c9605402aef40d3d9588ca2c3d1-1730301734"
  },
  {
    "email":"chiariotti.maria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419931002/40e4f8e465aa929d6b7aa679ea726c04-1730301734"
  },
  {
    "email":"spiri72@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419996538/da8d71fffa942fb86324ff911cfcce54-1730301734"
  },
  {
    "email":"yenia@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420225914/1876832181bb13500f75a23132be7d2c-1730301735"
  },
  {
    "email":"barbara.furbetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723419898234/ef84f8e6482646752a066c0af55a39f0-1730301735"
  },
  {
    "email":"annamarinagos@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420193146/907dc48e8950ce4b449d8b830034097f-1730301735"
  },
  {
    "email":"paolabuttini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420062074/705eefb06f8793419c8748a1b7c5422b-1730301735"
  },
  {
    "email":"sandrini.p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420258682/891741c06af8f2dee2625c41b5271447-1730301735"
  },
  {
    "email":"lisapetrin74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420291450/4968a0786023ba928cec179346fc0679-1730301735"
  },
  {
    "email":"veronica.ferrari76.ferrari76.vf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420356986/ffc614660592ab41ef5ee5997ca8357c-1730301735"
  },
  {
    "email":"carminadefeo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420389754/918087371e5ed6bfb2841a70a4c5633b-1730301735"
  },
  {
    "email":"lucialepri.2203@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420422522/b591e6060dbb2180804f441e79ca7acb-1730301735"
  },
  {
    "email":"roberta.scassillo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420488058/e4f3b03efe49bec5285ea4a5e7f124d8-1730301735"
  },
  {
    "email":"venturielisa8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420455290/a41b1b57b97eb64412ba9a1f5c5100af-1730301736"
  },
  {
    "email":"luisacortese57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420553594/8fea78a723819e380fa13c7f6461f0c5-1730301736"
  },
  {
    "email":"a.patricelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420586362/cd625bafb7cf12c96f6f62a2f126497e-1730301736"
  },
  {
    "email":"enrica.nai@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420324218/04ea21a4f283fad5f2eb940432a400c2-1730301736"
  },
  {
    "email":"stefaniacavallo344@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420619130/edda849389c5ce2276d453ef1b6fb7d9-1730301736"
  },
  {
    "email":"arapajelona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420651898/82a37e45e0128a56f1c7f40f8afdcfd3-1730301736"
  },
  {
    "email":"claudia.cambria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420684666/3ce3aaff16a63621e0cf457b117f475c-1730301736"
  },
  {
    "email":"margherita.chiari77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420750202/461ec8fdbcc0832979d4354c09324516-1730301736"
  },
  {
    "email":"margheritapalladino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723420782970/6238c1bb67c84471e4344fd4f91e12ec-1730301736"
  },
  {
    "email":"barbaratoscano8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420848506/7a89e3396528420e0a82852fdd6c767f-1730301736"
  },
  {
    "email":"foschisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420717434/46c28d240b3a3607f35d8999eae74fac-1730301736"
  },
  {
    "email":"graziafas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420914042/ac886b30d3c26d95fcdfd76997660033-1730301737"
  },
  {
    "email":"natasciachiandotto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723420881274/47b26add4a0b65e6fbda7e62bf399ef7-1730301737"
  },
  {
    "email":"dabonfiglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421012346/8df0cb28fcb2e87e0fc390cb81396def-1730301737"
  },
  {
    "email":"pinkqueen84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421143418/fda1e2d18247d1b720b1700a5ee32b00-1730301737"
  },
  {
    "email":"francescab76@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421045114/f31172887e8a8bd2628ce1a4f40ef720-1730301737"
  },
  {
    "email":"pratticoannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421077882/1ca0d6f7b0795f6766121b4a8b36d45f-1730301737"
  },
  {
    "email":"fiorellacampanale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421208954/e74c58b1d2aa95ced9743e2fd21e2b92-1730301737"
  },
  {
    "email":"irenezedda1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421241722/a30a7a073c0863e9fe32fb52e9372a02-1730301737"
  },
  {
    "email":"stefanialucarini81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421307258/996133559aaa229443c6eec20fca12df-1730301737"
  },
  {
    "email":"elena.pupa11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421340026/258d6f7134d8fc19d90d89daad50a5b9-1730301737"
  },
  {
    "email":"silviacorti66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421372794/dc82a6999e5891a1640862fb2f477c19-1730301737"
  },
  {
    "email":"untaru_carmen@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421405562/48d80d12a97b15eaf43c01c530a2e1dd-1730301737"
  },
  {
    "email":"perrucci_emanuela@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421471098/1a09cec585eadcecca5b6f4e9f8aa5b6-1730301737"
  },
  {
    "email":"sfrau1401@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421438330/35a52989ee9fbc5ec2f66cef12f6e18a-1730301737"
  },
  {
    "email":"cis_2015@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421536634/e73c1b0b75a455a5102d6247a3b8ffd7-1730301738"
  },
  {
    "email":"silvyang@virgilio.it",
    "url di attivazione":""
  },
  {
    "email":"celestinachessari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421700474/48fe7c8742b59759b116bd57413d9d3c-1730301740"
  },
  {
    "email":"c.formica@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421634938/8b3f0cb21cdbb78881190e0a05e46b4f-1730301740"
  },
  {
    "email":"greta.corani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421831546/4f8b4401e40a1e4abf6d7fb51e15e23c-1730301740"
  },
  {
    "email":"valemac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421667706/095ce0bca5098a48d1ea163c8d0b4ae9-1730301740"
  },
  {
    "email":"martinabran00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421897082/54081f8fa7e0ca0bfaffcf44374e17ec-1730301740"
  },
  {
    "email":"picanela62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421929850/2e65bb92ec12b7efad9f94d67585f55a-1730301740"
  },
  {
    "email":"zemoto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723421995386/4a73913c34b859c954aaa7db4a00e7fe-1730301740"
  },
  {
    "email":"topcasa@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422028154/724339deff0ad294c3eff325d72ed1f5-1730301740"
  },
  {
    "email":"elisabetta.toma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422093690/afdba12b5c11a8918d1f476a697b77cd-1730301740"
  },
  {
    "email":"f-novelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422126458/2f302ab8ba349dbb95cfedc4416fddbd-1730301741"
  },
  {
    "email":"mignosa13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723421962618/87b6df589e74d0be1b8b5587a69e06da-1730301741"
  },
  {
    "email":"zeddavirginia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422224762/346e294c77f9e2f520b06ef72141f443-1730301741"
  },
  {
    "email":"paola.giordo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422290298/96cdff41f5dce1c533e87af45f933faa-1730301741"
  },
  {
    "email":"carolinascalas33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422191994/578549cb29ca3193cacdc97a3f9ecdb8-1730301741"
  },
  {
    "email":"senzapensieri135@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422388602/eca6e7eda80e0ed7b175e725bc2a6d2d-1730301741"
  },
  {
    "email":"dunia.orsini@hlag.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422454138/ec66290ae987b39e5d101289378fde16-1730301741"
  },
  {
    "email":"elisa.moressa@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422519674/a26da490112496169c0a73785baa6df7-1730301741"
  },
  {
    "email":"oriana.pipino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422486906/b3e89b3c972ac9b8946fea0c9b29f07f-1730301741"
  },
  {
    "email":"rita.loiacono81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422552442/47ab70b2bbdb064b9f525a31eb0ee91a-1730301741"
  },
  {
    "email":"chiaraborella@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422585210/8dc197b2b8ade4c60c16f39f854c2350-1730301741"
  },
  {
    "email":"gcmarone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422683514/c04ad9b8f5e6482af99a6d73d666c51f-1730301741"
  },
  {
    "email":"francesca.messina@unimi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422617978/adcf9ea8f2a6674827ca34211e85999c-1730301741"
  },
  {
    "email":"santillifamily@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422781818/2182d21261cac9ff63f393aa38505676-1730301742"
  },
  {
    "email":"ugo.cobelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723422814586/84ddfb10010706503108c0358fcaa7b9-1730301742"
  },
  {
    "email":"gcmarone4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422749050/181473081b9564baac663f16d091307e-1730301742"
  },
  {
    "email":"sbiffoli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422912890/e03169f128eff595fc9fccfd7e17fd66-1730301742"
  },
  {
    "email":"bonafrancesca962@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422847354/3bb68c41092b591a1898fbf13f87865e-1730301742"
  },
  {
    "email":"saraneruda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422945658/3fb9b0861f41a28dd8f58d80e114379b-1730301742"
  },
  {
    "email":"fabiomorsiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422880122/412ef03f9402d3a3d77adf3b8a4a9012-1730301742"
  },
  {
    "email":"ilianoguarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423043962/67c918de779e8ac641bd58b724627c57-1730301742"
  },
  {
    "email":"francesca.lucchi@italiana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423011194/eccb2d104df2b8f069d0f23d3aed3d2e-1730301742"
  },
  {
    "email":"sandrina.benvenuti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423076730/a09c9036fd3d9d143bf740539d4dc23d-1730301743"
  },
  {
    "email":"trira@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423240570/22a5fb27f26d1d62451096c0e9f6702f-1730301743"
  },
  {
    "email":"stellavarani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423273338/4e53f3c1f45cf6f04dd504d5b05c63e4-1730301743"
  },
  {
    "email":"lety.guaita.lg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423109498/2af7c0ebb56332fd24f2aa65ef42dd9b-1730301743"
  },
  {
    "email":"aleama96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723422978426/73675e4928e50b164c1883a36c228558-1730301743"
  },
  {
    "email":"adelearmenia50@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423338874/ce394ecadacdb38babf9144387118692-1730301743"
  },
  {
    "email":"sciallotte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423371642/32f40dd486c1d094aa9cb4b5a3adf71a-1730301743"
  },
  {
    "email":"baldinicristina70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423404410/32f8d883c5daeab2fbf11aff21fb3ae0-1730301743"
  },
  {
    "email":"gigante.valeria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423469946/2e2c529a0c15c56356b556d4666fa24c-1730301743"
  },
  {
    "email":"cate.more4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423502714/9f1798b1e70b116c7b09b4500ddd9529-1730301743"
  },
  {
    "email":"diana.foltran@elettromadel.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423306106/fe07af3e272d8671a8b21560fe0ec3f9-1730301743"
  },
  {
    "email":"ileniaceccoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423535482/90ce3d903096503d5c900b90e7cd7855-1730301744"
  },
  {
    "email":"maryzack@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423568250/579fca446fd288537804fec59be08d62-1730301744"
  },
  {
    "email":"monicameneveri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423601018/24063064104243beecee6dc73cf85839-1730301744"
  },
  {
    "email":"stemang64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423666554/ad9b146515838a83beca234fd7aedf93-1730301744"
  },
  {
    "email":"stefanotesti64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423699322/f9f6281752203d53bab7083bbe8b886a-1730301744"
  },
  {
    "email":"alessia.gazzillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423797626/9e943af1de304dc75f31704e501d6397-1730301744"
  },
  {
    "email":"paola@studiodrpepe.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423863162/487c1ec01dca57948d0e5b36872157e0-1730301744"
  },
  {
    "email":"mareblu.lerici@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423732090/0530f13c21f8afa61b9fecaef58f4657-1730301744"
  },
  {
    "email":"ambragiovanazzi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423830394/27435d8a85ef57f25592b8674623071c-1730301744"
  },
  {
    "email":"nancyzampaglione@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723423764858/4a5782d81d2baa37471910c43926677c-1730301745"
  },
  {
    "email":"amelandri80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423895930/989ebd7d7f0636786c804b7c5902bd7d-1730301745"
  },
  {
    "email":"alessdipaolo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423928698/b1ff9a65a82809fbc7ee6792b3364727-1730301745"
  },
  {
    "email":"prof.denise.riccardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423994234/c39861f60c0da88f447175daac7c50c7-1730301745"
  },
  {
    "email":"tizij74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424027002/2fc23c31fdd299c610548ac52caf9acc-1730301745"
  },
  {
    "email":"mella.claudia2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424059770/fce0f9f42420ecf3ec8343bd686dd45f-1730301745"
  },
  {
    "email":"arch.annaliccardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723423961466/d354dab65e608a7a4b131f30b57293b0-1730301745"
  },
  {
    "email":"ffazzito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424092538/1aed93fe5266d117b540ca1f3d7f284c-1730301745"
  },
  {
    "email":"raimondo.marilena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424125306/a3df3ebc9a0c162155935d54ab6e0e0b-1730301745"
  },
  {
    "email":"secondi.luisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424158074/6299956f9e9df02e5676f8f272115304-1730301745"
  },
  {
    "email":"donatella.tornaghi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424190842/d42fcdece1a82521e84ca9614098646f-1730301745"
  },
  {
    "email":"matteovaccani@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424223610/8276d33bff221aed11678d9a8b4b7a2c-1730301745"
  },
  {
    "email":"eleonora.soggiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424256378/a70612eb7e9f0b050712fb038b28c473-1730301746"
  },
  {
    "email":"flavia@besozzi.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723424289146/5c1ac82b4c55888e8ef0eab1e74e8e3d-1730301746"
  },
  {
    "email":"chiara-martini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424321914/0f67cb088b2c29b6539ce8121b2b2a0e-1730301746"
  },
  {
    "email":"farfalla1972@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424354682/56fae2061c3e45df599c5b3d1a9bd499-1730301746"
  },
  {
    "email":"marco@one-company.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424420218/53d169acda2920012074057b1adf265e-1730301746"
  },
  {
    "email":"scattis67@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424518522/cd9c5830ea06d2ebb6ae1b0546eccb43-1730301746"
  },
  {
    "email":"avv.mcgiordano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424485754/6d088bbb9a670954baede94b7cbac110-1730301746"
  },
  {
    "email":"raffaellacugia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424682362/05ef47be73ceaa850102e03ac35dec7f-1730301746"
  },
  {
    "email":"m.masti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424747898/ca5e30224675ccbaf4980239875a3c49-1730301746"
  },
  {
    "email":"cristinabaldini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424649594/badbd8e0c94dbfa50f8bef70c709bf40-1730301746"
  },
  {
    "email":"marycamposeo83@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424878970/cb6581c32ea7f8b2ba11ad8f5d478c38-1730301747"
  },
  {
    "email":"elebianchi68@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723424977274/52030d6c502bb15f509213b4e5c2eaa9-1730301747"
  },
  {
    "email":"loris.paternolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425075578/064e54d0ab8ae968d4fe482f5acaaa0e-1730301747"
  },
  {
    "email":"renatoercculiani@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425108346/cfb4e1203eb87ca5b7b70693a7c75713-1730301747"
  },
  {
    "email":"cokimail@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425173882/18cec2a90c974823f62cbdcce8d3cf71-1730301747"
  },
  {
    "email":"alessandra.velo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425206650/308b9e832c70a3bc8cae87d0e0c6546b-1730301747"
  },
  {
    "email":"giancarlo.cicone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723424944506/a871c8a5db9d5c2c5e242d76b6e3173e-1730301747"
  },
  {
    "email":"glogiudice79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425337722/a1ac479a1e133afbe81f684c4db089ed-1730301747"
  },
  {
    "email":"gloria.gianferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425403258/81a0bb4c417a51797d892cdeb0e753bc-1730301748"
  },
  {
    "email":"dianamestriner@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425141114/74ce362b19efb5d5b535b1ae7a6d57cd-1730301748"
  },
  {
    "email":"boukadirchlef02300@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425304954/d195efe3147486aba2f7ceb61f2ca9a7-1730301748"
  },
  {
    "email":"danielatesti88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425468794/e5792d4aeff7c226685735390531bab2-1730301748"
  },
  {
    "email":"cragliatania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425501562/26003e21afb5a1f1fb88c861815c2135-1730301748"
  },
  {
    "email":"laura.mazzei75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425436026/f9c38879f4c20529e2e939e95563f1ea-1730301748"
  },
  {
    "email":"mail.cristinabaldazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425567098/f35601d1a88c0a53e9c294763af4600b-1730301748"
  },
  {
    "email":"c_cara_2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425599866/240f6a5840ed28c63841c9f108417de4-1730301748"
  },
  {
    "email":"carolina.genoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425632634/35141097a8cb8fbd1af43841a51d2a02-1730301748"
  },
  {
    "email":"isabellaruggibo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425665402/3339070ee6d33a90ebe286fd86e4b124-1730301748"
  },
  {
    "email":"sterepair3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425698170/54bee37967595cbd47efd6ccb838e66f-1730301748"
  },
  {
    "email":"martina.buffoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425796474/9800958ec6947b7f5cfa5da8008ded32-1730301749"
  },
  {
    "email":"maurizio.vaglica@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425894778/aff05534d0048fd460cb84c0efece907-1730301749"
  },
  {
    "email":"ariannamarchelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425829242/afb5ccfecd47fad597c839f9eb75e639-1730301749"
  },
  {
    "email":"andrea.turati@fieldfisher.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425763706/3e1ffa9eb8e46a29193cad5a04095050-1730301749"
  },
  {
    "email":"maxvivan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723425960314/d840f95a8d7c124f37bc159f7ac85bda-1730301749"
  },
  {
    "email":"simona.benassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425993082/c32e5c2fae540a0cec8b5e7fe9be1bfa-1730301749"
  },
  {
    "email":"dott.sirolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723425927546/1a460cb50bd133aafde0f1bf8360415e-1730301749"
  },
  {
    "email":"francesca.matteacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426025850/3a5fd659f86e352c668f649628225539-1730301749"
  },
  {
    "email":"silvia.figliozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426124154/e0f2c3601a6cf6afd59e64baa26c8c9b-1730301749"
  },
  {
    "email":"aledelvecchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426156922/73a56c5d3d987e6ad27fb5e09b2703a4-1730301750"
  },
  {
    "email":"simona83@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426091386/b1ab73abee1cfd796abb967661f22bab-1730301750"
  },
  {
    "email":"paola.tizzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426058618/f5311281d7765f9212bf4fd2c270a07a-1730301750"
  },
  {
    "email":"mg.proietti1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426320762/dd77da8288a8311141c379a4a4f17c1d-1730301750"
  },
  {
    "email":"gabriellamastromarco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426386298/5e3e6751a9cbb27a24006c3fd9272f42-1730301750"
  },
  {
    "email":"lorena@spottisergio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426353530/f6eff3746f4ded9bd7b08a72749f393f-1730301750"
  },
  {
    "email":"martinafonda1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426189690/a2b9150c3291d7bd219e8afd062b8efb-1730301750"
  },
  {
    "email":"vispat2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426451834/879dc4e3ed34f7beed7aedc152fca91d-1730301750"
  },
  {
    "email":"fede.checcucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426484602/b30f5d1880b39cf3f09786fd3f2023c0-1730301750"
  },
  {
    "email":"dolici@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426419066/e2ea6a4951b5240a3c1f96cb098678c0-1730301750"
  },
  {
    "email":"roberta.lana@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426550138/45155a5abd960f6677e93545575cce58-1730301751"
  },
  {
    "email":"adelaideprofico@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426582906/cc18f38c32f263588acae28630de5f48-1730301751"
  },
  {
    "email":"lauraoberti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426517370/55ccb5e23e843b21008c49ff4ac5d4fa-1730301751"
  },
  {
    "email":"mariateresadandrea61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426615674/0e1af809480b6c7c4a4145e0bfeb2e19-1730301751"
  },
  {
    "email":"pickrossi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426681210/d7c8b69d6e586c54b71b9e1897d0fe45-1730301751"
  },
  {
    "email":"tanialepore@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426746746/4efc553e21fdeedd712489abede42755-1730301751"
  },
  {
    "email":"cinziafedi29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426713978/476ba55726d1aba3736b1b308320ad9a-1730301751"
  },
  {
    "email":"kathrinkuen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426845050/2cb58d56c59c90c76d4c21b5f6398fa7-1730301753"
  },
  {
    "email":"marzia.marone@maroneluigi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426910586/a84562ec5aff818a0738edb8e3f3997c-1730301753"
  },
  {
    "email":"paoladib60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426877818/8ba0396c6caea5dc2bd5855ea040fd43-1730301753"
  },
  {
    "email":"s.marateia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427008890/d8594ccd35b351b9f6b7f11b2e583e48-1730301753"
  },
  {
    "email":"gestciniepassaponti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723426779514/f266fe97ce8e58eec78662a2f7281ee1-1730301753"
  },
  {
    "email":"assiamanica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723426943354/b06c2d5e070760bc92d70b34cb823abb-1730301753"
  },
  {
    "email":"princessgiraffe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427041658/b0d0001a4100d50623c244e979babc94-1730301753"
  },
  {
    "email":"quintilichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427074426/005c663f972666aeb1587dfee798c945-1730301753"
  },
  {
    "email":"l.bonamici@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427172730/2c7f03696514a127b447bdd49f6ba2f4-1730301753"
  },
  {
    "email":"liliana.giampietro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427139962/39ad08324ea5ba7571edc04e003dc3ba-1730301754"
  },
  {
    "email":"elisabetta.giovenali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427107194/58811b6ea37d56fc24d993c4a8867f3b-1730301754"
  },
  {
    "email":"elena.musso@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427271034/285ba245cb485b9c13e81dac5569378e-1730301754"
  },
  {
    "email":"daniforti@impresaleoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427205498/9e5524b82e17d0545d750d255b96f07b-1730301754"
  },
  {
    "email":"aurora.bogovic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427336570/fbeabdd068a4691ad1fa79c16caf77e9-1730301754"
  },
  {
    "email":"renate.decarli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427369338/44f60f6284cabf1cb6767ef85756eb29-1730301754"
  },
  {
    "email":"sabinaferro@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427467642/d718c15b69f46c782300ff9f769a7004-1730301754"
  },
  {
    "email":"ledebi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427500410/184f2a12401f184c9f790060f73988d8-1730301754"
  },
  {
    "email":"daniela.giambi@studiocommercialegiambi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427533178/cccb7ccb250390316b320a81bbbf194b-1730301754"
  },
  {
    "email":"laura.cavaliere@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427729786/7f872fba77d83a9abba214566b196a1a-1730301754"
  },
  {
    "email":"laurasorbini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427664250/03d1d3e5517adacbba76d362cf068493-1730301754"
  },
  {
    "email":"aliceferrero9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723427598714/eabc52fb122ae6c4ca25759a698e624f-1730301754"
  },
  {
    "email":"larisa.mili@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427631482/417b9acd884227e7b7750d23ce7acc86-1730301755"
  },
  {
    "email":"dalzelisa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427828090/1758b6ba7c49c0f666206ff7b136db2f-1730301755"
  },
  {
    "email":"susi.belli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427893626/a7d8f3e0ceb12be3fc6330fc7328760c-1730301755"
  },
  {
    "email":"francesca@ciferrisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427959162/f30bee03f9a59eb22023196be93fc6f2-1730301755"
  },
  {
    "email":"cri_valentini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427991930/2a6c50f34b95d93534a36527321524db-1730301755"
  },
  {
    "email":"claranappa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723427795322/7ce7adafb5ac2f6ad447742b30e1e90d-1730301755"
  },
  {
    "email":"morar_anamaria@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428057466/d55b98521c1d171b820ae7ce1f015868-1730301755"
  },
  {
    "email":"portopina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428090234/7dcbce31a18a9a336f428715493eb5ce-1730301755"
  },
  {
    "email":"bimbli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428123002/fdc38a777685afe9c396f2f2d3b43f65-1730301755"
  },
  {
    "email":"annamaria.agnes@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428221306/b6532253ab50edf40e561dc67330933a-1730301756"
  },
  {
    "email":"j.murro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428024698/efe230bbf67e89c61e53481212421fd4-1730301756"
  },
  {
    "email":"rosannacoffrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428155770/2e968e57aa3ff8df0e06f178c4db89e0-1730301756"
  },
  {
    "email":"lumar201167@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428286842/cc9b7dd8753b1a7215d311121ae56607-1730301756"
  },
  {
    "email":"bertonatisim.avv@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428188538/08adf6dbd4f43be27f75350f32334931-1730301756"
  },
  {
    "email":"valentina.bonacina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428254074/d64e653bd7f685c6c842c2c990dc2dcb-1730301756"
  },
  {
    "email":"bellinghieribarbara1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428548986/cf2d44c47ac545e351554c3957e32f25-1730301757"
  },
  {
    "email":"leonardo.carrer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428417914/33837328088c2b459f7aaeb086ab475f-1730301757"
  },
  {
    "email":"camarotto.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428581754/f11a1b9ff0b2f5af90631bf1fe372ba4-1730301757"
  },
  {
    "email":"monicagarattoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428483450/f04f0983917772a591541c0abda285f1-1730301757"
  },
  {
    "email":"giulia.piacentino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428614522/942a7c1258ed56b2ddde047bf0992ac3-1730301757"
  },
  {
    "email":"bjesari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428450682/6f0fae686c4271453604e6b9237742c0-1730301757"
  },
  {
    "email":"griseldatiz@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428680058/49b99adf9ba0255bfade398ed77779d5-1730301757"
  },
  {
    "email":"rafgiu378@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428712826/2f59b9420844c19425a069e9cdbe225c-1730301757"
  },
  {
    "email":"anna.terenzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428778362/c0ebd232d21eb7d1320286770ca0dfa3-1730301757"
  },
  {
    "email":"lidia.df@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428647290/ec8e7afd8908ac2b1dab6c1f1cbdfe1b-1730301757"
  },
  {
    "email":"melaniadipa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428811130/2d0df41c945d7f0e8014370121fa61a3-1730301757"
  },
  {
    "email":"chiara.muti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428876666/64e7118ff6fb01c937a466a3b9fac55a-1730301758"
  },
  {
    "email":"elinamina1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428843898/208737428b67bc6c56dd585b85992abe-1730301758"
  },
  {
    "email":"franca.quinzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428942202/74ebb7d6cbd8cbd280086fd2a99068fd-1730301758"
  },
  {
    "email":"barbaraborasca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723428974970/4dfe914d7cfdb987e470786c4c82d851-1730301758"
  },
  {
    "email":"camayr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429007738/b3c2ae4723df5e10e12fa66a36d1225a-1730301758"
  },
  {
    "email":"chiara.leopoldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429040506/5959c50901e1ef614ff2e4271682f9b3-1730301758"
  },
  {
    "email":"isabella.santicchia75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429073274/c12546a9a394322cfb88c211657277f6-1730301758"
  },
  {
    "email":"bettamassa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723428909434/8c00c498e665d3c99168e6d2f5f79348-1730301758"
  },
  {
    "email":"g.prato@pszlex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429106042/e46ef2613f53d78a169f2b7ef1d1f77e-1730301758"
  },
  {
    "email":"vassallosergio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429171578/4306416270f507572b2c4c7b2bc17259-1730301758"
  },
  {
    "email":"federica.sciamanna19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429204346/80ca0125074b0df6fb24ab5da857869b-1730301758"
  },
  {
    "email":"bianla79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429237114/59ac70b37659c51cef46bbde318194ea-1730301759"
  },
  {
    "email":"marinaparolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429269882/2d1e05f258877107e2414d0ae6c72e06-1730301759"
  },
  {
    "email":"majla.costantini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429368186/1ab4905f464228dca6ee13ba9528e444-1730301759"
  },
  {
    "email":"fpalfa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429138810/fdab72fbf2397797e4e4b6d963254ec4-1730301759"
  },
  {
    "email":"roberto.fur@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429433722/ccf80c5066c9e877b1f9b2675f7aaf91-1730301759"
  },
  {
    "email":"marcomontagnini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429302650/e887eb230da1ce2e690140e2c76eced9-1730301759"
  },
  {
    "email":"naturfede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429466490/67387eeae8b1e961493289ea6531f1ee-1730301759"
  },
  {
    "email":"patrizia.chillotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429532026/99eeeedb8a9ba9f825c9d70630a0b94a-1730301759"
  },
  {
    "email":"antoniettaderosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429564794/a90ddc9cf413afe8557bd7d78da915ca-1730301759"
  },
  {
    "email":"anna.bianchi@eredibianchi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429663098/77befc03d6fdf50e4f116dca0ee4433f-1730301759"
  },
  {
    "email":"alesanna72@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429794170/63e5c8362666f57d465ae3daff8e445d-1730301760"
  },
  {
    "email":"glorianabbatiello@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429597562/c904e24cbb8e1e5d530b03c76f2b1bbb-1730301760"
  },
  {
    "email":"bernareggi.a@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429826938/7392c2ac8441e1d64ac5854211a5a075-1730301760"
  },
  {
    "email":"luisa.perenthaler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429859706/b6cd418aa046c3477b3cfc14362feb7e-1730301760"
  },
  {
    "email":"arianna.maggioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429925242/4cae7962069cb7deaa1851430a6b60a9-1730301760"
  },
  {
    "email":"gargiulochiara66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429728634/8588b6a9b1ce2e3dfe293bb90fc341b0-1730301760"
  },
  {
    "email":"andrea.castellani78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429958010/8dc948a9c86c7af75305fff8a8434e62-1730301760"
  },
  {
    "email":"chiara@villoresialvaro.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723429892474/542562ee5eb82263972a05e6083ab758-1730301760"
  },
  {
    "email":"violetlady@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723429990778/ad542048e32ebf3d7a5ba283ccb211bb-1730301760"
  },
  {
    "email":"a.barontinidl48@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430089082/08c379c2176dc7301b65c8f0557a5e94-1730301761"
  },
  {
    "email":"simona.vaisicca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430023546/ed92464af8b69f7f9ca3b84f71bf59be-1730301761"
  },
  {
    "email":"lorenzapedron02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430121850/26a6a5109719f5ea1429aad64b8410e7-1730301761"
  },
  {
    "email":"stefaniasteno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430154618/61b0a6e3fa032fdce10b0d6413dd6e61-1730301761"
  },
  {
    "email":"profbuonocore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430187386/85cbbe27a528697b185d1d13ff238b17-1730301761"
  },
  {
    "email":"silvia.orsini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430220154/fa0139049bead91fdc86d565f92c2c3e-1730301761"
  },
  {
    "email":"stefyplacebo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430252922/439f3c384857ca6712c68aa55bd7c702-1730301761"
  },
  {
    "email":"avvpaolamazzei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430285690/a92067cce6397c66fe0d3a5e63a5fff8-1730301761"
  },
  {
    "email":"sissicar@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430318458/e156c83456a3c884f6572ada98bad020-1730301761"
  },
  {
    "email":"cristinaluisasantucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430449530/cb42b5218ca91f628e1f6ea9bae93ad1-1730301761"
  },
  {
    "email":"donatella.schiavi61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430383994/c598c5e27aa7505d995cfbe06a945361-1730301761"
  },
  {
    "email":"adele81.conti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430351226/d311cddcebf726815714f512c73a5d71-1730301761"
  },
  {
    "email":"max52caccia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430547834/37082af01d9dbf6eee39b2f1e3587950-1730301761"
  },
  {
    "email":"annapreite61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430711674/f89c129c864b7a6198849ed9e4651a1c-1730301762"
  },
  {
    "email":"silvanamassenza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430678906/ee763baa523465e6887c1c82fce56ce4-1730301762"
  },
  {
    "email":"kiccadove@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430744442/87eef9133e70d3133c77ed2ceea7f9e4-1730301762"
  },
  {
    "email":"bertucciolilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430875514/e5e25bc0cb77a491cabac859562b8626-1730301762"
  },
  {
    "email":"stellab2003@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430777210/3ac23cccfb106f374a920612bacd2529-1730301762"
  },
  {
    "email":"m.bellotto@barabino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430908282/433930c6d117e4569625fedcd0b1db25-1730301762"
  },
  {
    "email":"superdory@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430842746/20291c506510eed972b02cae8fe9ace9-1730301762"
  },
  {
    "email":"vittoriavaloriani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723430941050/c8e44d52c38724c77371819e32e9435e-1730301762"
  },
  {
    "email":"roby_rama@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431039354/7fb46c4e98e985e7541382d5e71931d4-1730301763"
  },
  {
    "email":"gianluca.camp65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723430973818/6fdc40ba7c85d55eadc7ad5e62544e83-1730301763"
  },
  {
    "email":"antea1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431006586/bc183a8ca7f50a9c6c0bc3a4d2b29e14-1730301763"
  },
  {
    "email":"matilde05@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431170426/796a01e95daaef1e63059fdea84d90a4-1730301763"
  },
  {
    "email":"venturiniele@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431072122/aa53ede2d0261c75f0a7a502044b2cff-1730301763"
  },
  {
    "email":"elisapardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431104890/bff8418938f13a881e1e30b1a247ee8e-1730301763"
  },
  {
    "email":"elisasava@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431203194/c94650c659fec05f33ab533e8ccf97c0-1730301763"
  },
  {
    "email":"archila@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431301498/bae970ad779c2f8cedff7d6536bff228-1730301763"
  },
  {
    "email":"lucia.dagradi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431137658/0b69e86f56410847ad1fcf998fe25cc5-1730301764"
  },
  {
    "email":"rcozzolino@isa.cnr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431235962/21377d276589e994f44b45671d5819dd-1730301764"
  },
  {
    "email":"ar.produzione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431334266/b683daf308fa3977d384cfc5bbc8d7c8-1730301764"
  },
  {
    "email":"furianiraffarlla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431432570/dc96a82c02e62ecc345a73442da59e31-1730301764"
  },
  {
    "email":"marilisaca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431530874/8a6c2e975c99f9a5f443fb51858b6668-1730301764"
  },
  {
    "email":"elisabettag1982@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431465338/b839652901a16f04238f9772c0b9233c-1730301764"
  },
  {
    "email":"floraperrone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431563642/d104e67c9a0731456d13703bc3bb1a83-1730301764"
  },
  {
    "email":"riccimorena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431399802/1ef086c4bd48d04aea9b54c98786b622-1730301764"
  },
  {
    "email":"rosalba.piazzolla@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431727482/803d785af79132013f90470eeeeb0d8b-1730301764"
  },
  {
    "email":"amgrixoni@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431629178/b34b60ef104971f084877d3089c70299-1730301764"
  },
  {
    "email":"teresitaerre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431760250/7a676ff95066172d78fd748c8fd8f81b-1730301765"
  },
  {
    "email":"monica.dati82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431596410/1ae8cc6fad0cb43eba86325fabd56605-1730301765"
  },
  {
    "email":"bonaiuto.sabina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431793018/a4b3b7456d21fb1a1ff9a897bd87c96e-1730301765"
  },
  {
    "email":"mariasfancelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431858554/50c4f273636405d96ab3aaa5db2bd7d7-1730301765"
  },
  {
    "email":"loredaman@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723431956858/6c6d5c6dc4fa1b39b714ba5a7a19a55e-1730301765"
  },
  {
    "email":"giulia.caferri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431891322/faae9d2958836a22ba01387dc26d85c0-1730301765"
  },
  {
    "email":"monica.medici95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431924090/396071f68e702f2e76a87895208ffc2c-1730301765"
  },
  {
    "email":"pagano79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431825786/02b5bca4016c23cb8c184f7402f6043f-1730301765"
  },
  {
    "email":"daniela.cub74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723431989626/6ae2faa83449c20cb76432b76f70e4f9-1730301767"
  },
  {
    "email":"donatella.tuzi@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432022394/44cce58f7e3cd8b8d174f0f84d621e8e-1730301767"
  },
  {
    "email":"vittoria_io@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432087930/369b37c35675e384e51c115476d2724d-1730301767"
  },
  {
    "email":"dilorenzom@libeto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723432055162/7912765ed9042a6ef35faa276c64759a-1730301767"
  },
  {
    "email":"francesca.devescovi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432153466/25d32c998ab0086ecd628e147c5dd237-1730301767"
  },
  {
    "email":"sara.matteo.piatti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723432120698/2d542ffdfa9a11e1b1bc010d8e6b32e6-1730301767"
  },
  {
    "email":"salvea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723432284538/41b13d1360aa8acbedc7bf3d89bf6ab6-1730301768"
  },
  {
    "email":"saminew333@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432350074/ebf3976c2376b706d6c127a49fbe2465-1730301768"
  },
  {
    "email":"rossemarti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432186234/37e881dc62a1a284c6ce856360588c75-1730301768"
  },
  {
    "email":"serenapuccinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432382842/2c5c51389550342c304a3cbb82fbbc2e-1730301768"
  },
  {
    "email":"butto@biemmeelettronica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432317306/8827671e1f5eb13c3d85cbf01c3d6cac-1730301768"
  },
  {
    "email":"buonocorevincenzo30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432415610/fa2863ed558777268175c65320b98fd3-1730301768"
  },
  {
    "email":"grazia.bondioli@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432448378/d77f5f56ed961e00e4a1b38b8cc25475-1730301768"
  },
  {
    "email":"ellenika@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723432579450/a518b6845a40d87d4a5dad0188582d72-1730301768"
  },
  {
    "email":"francjy67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432546682/39dd74b5e33d1bb5d0a33222820aacb4-1730301768"
  },
  {
    "email":"paolatisca12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432612218/e22d722f60415ab301636ca9025bcd13-1730301769"
  },
  {
    "email":"p.tavecchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432481146/e9f0b39f61780c671e9703a4fba2551b-1730301769"
  },
  {
    "email":"ciarmelak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432644986/5a797ec4817255a80e6eeaa362c3af07-1730301769"
  },
  {
    "email":"marisa.malegori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432841594/de215f1611c5bfd76c2ccdfc56693c66-1730301769"
  },
  {
    "email":"rubbichi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432776058/5448c7615289a9df2dfcfe1179f27922-1730301769"
  },
  {
    "email":"giorgiachergia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432972666/074f1ddf7d483b7415af46b30ed0b039-1730301769"
  },
  {
    "email":"capitanidaniela@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723432939898/efc9aa13bd9cb2baa3a8a68588adad07-1730301769"
  },
  {
    "email":"trasporti.pezzini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433005434/1e8e376b7067a8edc051a3ea82687550-1730301769"
  },
  {
    "email":"lauragatti1702@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723432874362/61a6bf2115adfcc8e582a8beb29640f7-1730301769"
  },
  {
    "email":"morosinistefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433038202/e86114e39e184e09fbe5550e27cf14c0-1730301770"
  },
  {
    "email":"berardi.arianna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433169274/c2ae66b74381e763a5061779fc3d8021-1730301770"
  },
  {
    "email":"mingioneserena77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433202042/18de2d960592c11cfd992474eaada759-1730301770"
  },
  {
    "email":"giorgia_tonazzolli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433103738/f4689ecfde6ec3d77b015984fff70148-1730301770"
  },
  {
    "email":"studiomuscolino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433234810/822ab8febb389a71c4795a4a50f6e89e-1730301770"
  },
  {
    "email":"cipollotta2@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433300346/dabbddbb33c79a2f17972f8d77c449b8-1730301770"
  },
  {
    "email":"silvia.bencardino@iulm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433464186/9ef773b635fd883893eb6a2fc031be53-1730301770"
  },
  {
    "email":"roberta.nalin@unibrokers.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433529722/50bfab370abb1967c2ddcf5bc6f334cd-1730301770"
  },
  {
    "email":"alchimia.83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433562490/c54d7fdbde0f7e9aa40e37be4dadef22-1730301770"
  },
  {
    "email":"cmilana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433628026/dfaa8cbbe12b7b9ea9cf574e5736bbe4-1730301770"
  },
  {
    "email":"alessiaverdecchia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433496954/82dd1441a0e5902800235b632521929e-1730301770"
  },
  {
    "email":"giuliatavone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433595258/b79c4da671bbdcf522a991d46712ed70-1730301771"
  },
  {
    "email":"commerciale@mtsrl.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723433660794/20ec887c478baa80904fd31590bc3459-1730301771"
  },
  {
    "email":"pmondillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433759098/4db2e3d3271337dd2feb1c29b3522498-1730301771"
  },
  {
    "email":"annamaria.marielli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433726330/e14cbac987f0a9b66d322f8097e6db9a-1730301771"
  },
  {
    "email":"marcellabernardo74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433791866/fca614875fd81d95fb10645dc25898b7-1730301771"
  },
  {
    "email":"simona.vairo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433922938/a9682899a9d34a619c5900c54a6abf97-1730301771"
  },
  {
    "email":"alessandro.dinia@hcl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433824634/713bbe3231b6c9afc3ef19e80f226618-1730301771"
  },
  {
    "email":"manuelanorcia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723433955706/c6a2ab7bbbd70e7bfb104eeb85fca28e-1730301771"
  },
  {
    "email":"65frog@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723433988474/9d93bea9584665d556e0eb917626ee3d-1730301771"
  },
  {
    "email":"polito.rosaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434021242/780b0aed56843f49402a6d98ac6e03ee-1730301772"
  },
  {
    "email":"nancyraimond@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434086778/acd23e10003aae19b035d408cb6da131-1730301772"
  },
  {
    "email":"paolo.stabellini@edilteco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434119546/12a39fd9e44711cca684952c7cadfc1c-1730301772"
  },
  {
    "email":"patrizia@bicicchisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434152314/4b3515533635404cf4b6ef600dbb4108-1730301772"
  },
  {
    "email":"monica.lucchini1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434185082/16e8db48037be45f3e03792f9ce6bb1c-1730301772"
  },
  {
    "email":"antonella.bosotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434348922/118da855fca58ec48fe05f5c507e6768-1730301772"
  },
  {
    "email":"ampapini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434250618/8778c1d00187efc7989311c9236aaf54-1730301772"
  },
  {
    "email":"roberta.montaini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434381690/8bafc69ebc039b78205d1003c8b1f227-1730301772"
  },
  {
    "email":"guido.giuda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434316154/9c45dfce11438d794a2fba0cc5c7efea-1730301772"
  },
  {
    "email":"chiara.antetomaso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434414458/eeecd25ebb2ad12c6c6bdce750762ada-1730301772"
  },
  {
    "email":"lenzicinzia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434545530/9ff3ee141b16d866347c017452ac2de0-1730301772"
  },
  {
    "email":"gnlcsst@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434611066/5c8365c51ebda50c9ae9e98861d7a1ae-1730301773"
  },
  {
    "email":"mariopinci2@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434447226/4e3ab5438c27fbefe55aac953d491a5f-1730301773"
  },
  {
    "email":"michela.carcano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434643834/134dfb53ea4679be4290063c59cb2736-1730301773"
  },
  {
    "email":"marivile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434578298/e4ab92c6861e63af92f48102f4ff4597-1730301773"
  },
  {
    "email":"alonzi_roberto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434676602/2293b0201401f51b100ae8feff8fdfdc-1730301773"
  },
  {
    "email":"margieok@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434709370/c8144426766029354c80ba2750ca9657-1730301773"
  },
  {
    "email":"alesgasbarri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434840442/165731c9c812d1491544fea85c69be34-1730301773"
  },
  {
    "email":"cristinaconti.74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434774906/8833ad054c7159139b0bb4f598632369-1730301773"
  },
  {
    "email":"sonia.lilli@asst-santipaolocarlo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434873210/4c1ad8c08c126a3b51daec0ac23534e5-1730301773"
  },
  {
    "email":"sibilla.gherardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434807674/d0224b3872494cae22f571bf4e5202e0-1730301774"
  },
  {
    "email":"lorenzadini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723434905978/2458b7778790a72190d2001f2bdbef9b-1730301774"
  },
  {
    "email":"s.stracquadaneo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723434971514/745d5ce4a2b00a8caf580a629d6139a3-1730301774"
  },
  {
    "email":"francy.giove@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435004282/157b0b404b641ce95e2713423b1f086b-1730301774"
  },
  {
    "email":"elipa.1984@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435037050/a28575f3186fe42100914df4e933a72f-1730301774"
  },
  {
    "email":"ginex1989@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435200890/ce0a8bb5322d4bd352982cb0a9ada628-1730301774"
  },
  {
    "email":"giusi.inzinna@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435135354/d93916c9739b333467cd3719d52c37b4-1730301774"
  },
  {
    "email":"filomena-chiocca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435299194/a15669dd32732b2c16bac1e694c3993e-1730301774"
  },
  {
    "email":"annatotaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435331962/4d2ea9c15cec6f89a502a8269bb6fc4a-1730301774"
  },
  {
    "email":"alessiaderrico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435233658/556b6f5a1574c09f156aa6bc6f9c410e-1730301774"
  },
  {
    "email":"frencycrespi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435266426/4554c055dd6de6f25a99fe4c2c01c353-1730301774"
  },
  {
    "email":"g.zavalloni64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435463034/bde57526d1f1cdb5adb89483d3da5603-1730301775"
  },
  {
    "email":"lucacadamagnani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435364730/d9fffc87cedee9e987de0732e4664b85-1730301775"
  },
  {
    "email":"ele090378@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435430266/27ef91f409faa03f9b1c4024f393abd5-1730301775"
  },
  {
    "email":"farmacia.bagnuoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435397498/98d4a25a4316ddee1fd6449326cc2a88-1730301775"
  },
  {
    "email":"patricia_pla@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435495802/ad6ccb1d0e376d3d0559f623a47e4111-1730301775"
  },
  {
    "email":"lavibox@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435594106/db1a13d05275c1d099fd027949d3cbac-1730301775"
  },
  {
    "email":"lisa.cantu.vis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435659642/953986f8cde99bd697fc1f373ecc8146-1730301776"
  },
  {
    "email":"sim_plattner@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723435725178/0d76b6d1c1e4eac7bc5fed563230de8b-1730301776"
  },
  {
    "email":"massimo.siciliano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435561338/a902566a6a411304d77dd3aadd94af13-1730301776"
  },
  {
    "email":"fiory2964@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435757946/2be306274ade402937eb7b32d62d681e-1730301776"
  },
  {
    "email":"g.merizzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435823482/7f89f246c4ba538cfebd2ace0ff24186-1730301776"
  },
  {
    "email":"lallacrepapelle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435626874/13556b7bc4473b8a4ad6561b2d8b246f-1730301776"
  },
  {
    "email":"epartemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435790714/5d6a19e1dfd27ee2043df272f8732022-1730301776"
  },
  {
    "email":"robicucci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435856250/cff433fefd26fd1282a7ef7045459c2f-1730301777"
  },
  {
    "email":"betottantacinque@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436052858/f821f582722e860539cfa31ec4899ec1-1730301777"
  },
  {
    "email":"sonia@comassociati.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723435921786/6b708c98c7eb36317652e8f58ffc2296-1730301777"
  },
  {
    "email":"lindawh2o@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723435987322/57c6dc26aecf87cae4ac551fbb2431d0-1730301777"
  },
  {
    "email":"giulia.cntn47@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436151162/02bfc9a61f6772070471c3c3c48c6157-1730301777"
  },
  {
    "email":"annareda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436183930/548b89218dfbf32d70ee12265759c0b3-1730301777"
  },
  {
    "email":"giovanni.grande@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436347770/e3524178e9984e790c1160c7cda69c96-1730301777"
  },
  {
    "email":"lisapetrucci77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436216698/e7ed03ab49fcc07f6ace883487d4dc2f-1730301777"
  },
  {
    "email":"chiaraluna73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436249466/aa97294e380bdc5d940258165171d615-1730301777"
  },
  {
    "email":"samanta.mes.1502@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436478842/d8b34ad10fd8eff96ce08406cbd80b72-1730301777"
  },
  {
    "email":"benedettomp@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436511610/1813e114d2d9795d2348b782ee7cc544-1730301777"
  },
  {
    "email":"fjacopo968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436642682/9ece3a7c49f5b6eed85e0d26bfc89912-1730301777"
  },
  {
    "email":"maristellanassi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436577146/076d4787dbabcaf6c910ab5d298990db-1730301778"
  },
  {
    "email":"debora.romani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436740986/9072e27d838672d4a683c502d2267b17-1730301778"
  },
  {
    "email":"alessia.dalmoro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436544378/abad27a2118c9b125a8bf35f90d38192-1730301778"
  },
  {
    "email":"valentina.merico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436675450/eed0eb40169b5bed69e1466a95d321a5-1730301778"
  },
  {
    "email":"enricasalvati@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436806522/45e6a36422c767322a2e2a64e951d6d4-1730301778"
  },
  {
    "email":"fedchiac@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436773754/13b306d0ff5a14a33db1e0f58780678b-1730301778"
  },
  {
    "email":"francy.ferraresi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436872058/6765e819a11c810884f844c5baa7f0db-1730301778"
  },
  {
    "email":"sara.andreani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723436839290/ee8d28a0f6785bb45bcfdaff0ac70646-1730301778"
  },
  {
    "email":"valeriamastronardi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436937594/ad439ce8939c60522ed250db5753c050-1730301778"
  },
  {
    "email":"cristina.secchi@fieramilano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436904826/84ecacf4daf313ea84d339a695d5071e-1730301778"
  },
  {
    "email":"dnldm18@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723436970362/bfa4e17b8468ff39b7ffe8bedad14d06-1730301779"
  },
  {
    "email":"raffaele.bonjour2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437134202/4bcfb4ac35f350a39dc7b21441faa48d-1730301779"
  },
  {
    "email":"masomenos@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437003130/61ab7f6dd6aca1ec1fb530d111e50663-1730301779"
  },
  {
    "email":"mircomoretti609@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437232506/b87b6f5634a725b96f1ca9e4f7d71e48-1730301779"
  },
  {
    "email":"mokkia8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437199738/ed2f27ca5bc98ac0e83e57a558a5fc1c-1730301779"
  },
  {
    "email":"info@ilparadisodifrancesca.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437265274/bc7f0c43014913c3fb495c40450d7422-1730301779"
  },
  {
    "email":"albertopaganin@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437330810/52ce5efc16b4077f10d5d669d63f8a6b-1730301779"
  },
  {
    "email":"g.valmorbida@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437363578/786c964949739b45c09cd010c0372713-1730301779"
  },
  {
    "email":"s.silvanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437461882/399bc9bbeaf0b28ccc714f24220048da-1730301779"
  },
  {
    "email":"cecilia.bonfante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437494650/cbc413de11edb40d564f343f8cb07401-1730301779"
  },
  {
    "email":"enzalipari2@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437527418/74fa662863718cb11a724a5982883332-1730301779"
  },
  {
    "email":"magda.rezzonico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437396346/e9ae6f65ccf87c68ecd914a68d7c0603-1730301780"
  },
  {
    "email":"sabrina.tambellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437592954/0a874c6b9bd1a073c37a76114c6394e2-1730301782"
  },
  {
    "email":"dituttounpo83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437625722/cb9c1956df2418fb1be0b19b711e2230-1730301782"
  },
  {
    "email":"danielaorru80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437560186/d3a217f0f52f923467fb04a677a1443e-1730301782"
  },
  {
    "email":"nicoletta.bordogna@comune.seriate.bg.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437789562/a42443c2ad6536f47fe86e1e7041759a-1730301782"
  },
  {
    "email":"chiara02fabbri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437658490/c45174d11b020d5cfa28d8ecbb2d287f-1730301782"
  },
  {
    "email":"adria.diva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437691258/bc198191b90a56bb91d599baa311f351-1730301782"
  },
  {
    "email":"antob67@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437822330/3bba0c2a945300d9464f0f2d1ffa656c-1730301782"
  },
  {
    "email":"roberta@rebecchiasfalti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437855098/cc57feb0c91a6910fb2d040e16f5445d-1730301782"
  },
  {
    "email":"maela.donadello@cdk.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723437756794/396e9b35e9deb4608f994a1617617523-1730301782"
  },
  {
    "email":"katiamariavolpi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438018938/23a2567382cf111fcd26b65fa2eaef51-1730301783"
  },
  {
    "email":"donatella.traversone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437920634/217599a6a931b2880c2eda370a08d0ab-1730301783"
  },
  {
    "email":"mercedes74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438051706/a6e79c4e12bcca74db7dc5816d1fae87-1730301783"
  },
  {
    "email":"prittola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438150010/50fa81b2e8c92cecbc2433cdb25cb46f-1730301783"
  },
  {
    "email":"somma_carlo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438084474/7dbaa35f13b06e5450c5cfc9637ff111-1730301783"
  },
  {
    "email":"chiaralanzone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723437887866/e355fe514d91d81d4d39307464d98bab-1730301783"
  },
  {
    "email":"lidiamolinari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438117242/8c3c4f1a6602786dbd06ef7071af2376-1730301783"
  },
  {
    "email":"eduardo.ottaiano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438182778/50af176628de791bd638174bf05adc72-1730301783"
  },
  {
    "email":"letizia.forsoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438248314/393d56ea8d859cc2c5fb9afc3c58c8d7-1730301783"
  },
  {
    "email":"fmaggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438313850/e20cad09a643fdb47c78d679931fe42d-1730301783"
  },
  {
    "email":"tiziana.reginelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438346618/9be4c91517e598cbf7b5eb837cf00f56-1730301783"
  },
  {
    "email":"morenadelloso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438379386/a0e0cca1835e02999d09e53adf72e544-1730301784"
  },
  {
    "email":"boscoloraffaella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438510458/747d8a5f2115a1bf5f4292b35664c2ea-1730301784"
  },
  {
    "email":"robertabuffon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438412154/8f14e006b63e30be50397417951e0fcd-1730301784"
  },
  {
    "email":"elenaramalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438543226/1f6d79fa1a7ee0eee56d5f0fbf30bae0-1730301784"
  },
  {
    "email":"alerizzo@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438477690/d5069ad0176c014ffd4578d7717fb9a9-1730301784"
  },
  {
    "email":"cristinadallacorte67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438575994/d6477c5b889f888ae1ec5149335f613d-1730301784"
  },
  {
    "email":"lucalong75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438608762/125e505a3119542f5861dd38889a7927-1730301784"
  },
  {
    "email":"donatella.galfre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438674298/8d7bff36643b702d59022f78d8d60aa2-1730301784"
  },
  {
    "email":"elisa.riva@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438641530/c78ae0cfcdf160c39209d72edb613d12-1730301784"
  },
  {
    "email":"m.sturniolo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438772602/8f1e52652d389bb9f40ce0845d3092f3-1730301785"
  },
  {
    "email":"chiccalze@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438739834/02f5095c983364f39fa9ebfc9ed2f79a-1730301785"
  },
  {
    "email":"annamariafalasca@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438870906/2b4a11b5866e4d21b87c7569ee8f0a4c-1730301785"
  },
  {
    "email":"elena2610@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438903674/9681b8af33b6b66bd24a8313f17924a0-1730301785"
  },
  {
    "email":"rosadematteo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723438838138/172161997533c6a55204c324921817d6-1730301785"
  },
  {
    "email":"normapinna@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438936442/5a946c35da92f978c73e00e51d95c999-1730301785"
  },
  {
    "email":"riccardo.gessa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723438969210/ce00d56d4c41e4ffbc7e5ddb25f3ddf9-1730301785"
  },
  {
    "email":"mm.mariani71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439231354/9086c2c8e72b16d348b6955206fc5f5d-1730301785"
  },
  {
    "email":"daniela.campostrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439264122/734c28180e1dbf5674a983216454acf2-1730301785"
  },
  {
    "email":"sanjarevic@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439427962/5e7774b4f7c4212ea97bcb782732ba3b-1730301785"
  },
  {
    "email":"ludovica.bernardo6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439296890/83f49b448b036aab8a0d10851eee0e27-1730301785"
  },
  {
    "email":"mara.pinelli70@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439526266/cc08bef20a6038f7fae00129856a0845-1730301786"
  },
  {
    "email":"mazzonetiziana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439559034/d0692e0b8d30b268bf04018014c48b79-1730301786"
  },
  {
    "email":"ste75.sc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439690106/5fed81f9a61ccc453fda55cd9a630522-1730301786"
  },
  {
    "email":"missdany@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439493498/f0a6973e33aa246b959d9cdda4de2e42-1730301786"
  },
  {
    "email":"sonia_belforte@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439722874/90d87b4d6dd011f8bd1a9e6f6b37a067-1730301786"
  },
  {
    "email":"amaliamanfuso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439657338/39b2b32ddedfa5eec027d43baae86b8b-1730301786"
  },
  {
    "email":"patriziagrazia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439755642/27f63a38a36dfb42938ca98b74a201b2-1730301786"
  },
  {
    "email":"chiarafratini86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439853946/ba9cd738b040359a97b099ea7248a3f3-1730301786"
  },
  {
    "email":"mtdigiorgio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439886714/c147c3f0d5f99576069bc0b08e0b4982-1730301786"
  },
  {
    "email":"ale.dellorusso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439788410/4f4f58343388deb75395dfaca61bb56d-1730301787"
  },
  {
    "email":"carolinadalessandria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439919482/dd82fc6ff0807ba70717fe80e11374d7-1730301787"
  },
  {
    "email":"chimala@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439821178/6d446dea4dea8848ea4f1ee9e1aa30da-1730301787"
  },
  {
    "email":"giusiporta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723439985018/13c92b5542e1287427e81020b9b4ad9b-1730301787"
  },
  {
    "email":"elisasb@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723439952250/017b6b7aa8c34e3a25045ded337961a8-1730301787"
  },
  {
    "email":"p.scarano@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440017786/adf7d043b127aaeac663d141b22f0fab-1730301787"
  },
  {
    "email":"drealeri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440050554/71c260cfd1f5c1a1a34a92455894f734-1730301787"
  },
  {
    "email":"patrizia.zanatta76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440116090/c82c627f0a040deaea5b805607ddb136-1730301787"
  },
  {
    "email":"simona.piola@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440148858/aeb67f2840319da3b4ae88b8d4f3796b-1730301787"
  },
  {
    "email":"pinocchiochio69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440181626/7988b70ceeab6d8e4025596c2e281a79-1730301787"
  },
  {
    "email":"eferro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440214394/80d9b189170188ae397d462e34995a53-1730301787"
  },
  {
    "email":"lomba2001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440247162/b1c6659f117b75a42d795e4e16a2369d-1730301787"
  },
  {
    "email":"frc.mnt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440279930/271e9e9727519a928fe2efd2981fe85e-1730301788"
  },
  {
    "email":"fabiolam1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440411002/3fafcfc30a055201275002f0ea3538c2-1730301788"
  },
  {
    "email":"anitadm1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440345466/aade0b874f16d3a69fb2ce2d7005db87-1730301788"
  },
  {
    "email":"fronte.lu1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440312698/1cd8ec66f7fe3c62f5327f9df926f25d-1730301788"
  },
  {
    "email":"katherine_94@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440443770/6eecdcc90cdd656e23bbeb92e52b2c8d-1730301788"
  },
  {
    "email":"valiko115@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440509306/e549fe6dd0c9d687b4e8d545c718db61-1730301788"
  },
  {
    "email":"raffaella.giustini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440542074/f5ac19bf6da6a4fc36c4b99b40093613-1730301788"
  },
  {
    "email":"chicca_90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440476538/4c2c480bc353c94867b43113422691c3-1730301788"
  },
  {
    "email":"mariadgv@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440574842/7c5f00af12614ef6cb6ce92c44dc31a5-1730301788"
  },
  {
    "email":"lucillamatassini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440607610/df8f9cfc89f10940683dd5874fa75196-1730301788"
  },
  {
    "email":"vincenzacalabrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440738682/6fd10518eb0cc418cf85767dea1283ef-1730301788"
  },
  {
    "email":"susanna.salernolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440673146/6fd3a21641125ce1b668266a52e1d77a-1730301789"
  },
  {
    "email":"cinziapuglisi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440836986/3b301af07e745a6b8c13cad811ce16ab-1730301789"
  },
  {
    "email":"francesca.celoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723440804218/89888af5c007c3ea96bd44d69d077c17-1730301789"
  },
  {
    "email":"supervipera@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440902522/11bd81ca95dc3420c9faf1810505179e-1730301789"
  },
  {
    "email":"serena.todiere@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440935290/36f73e6371bab510970a410d5da34478-1730301789"
  },
  {
    "email":"muller_thurgau@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441000826/d9495e5f34d260f93950fe60e64ed0cc-1730301789"
  },
  {
    "email":"mariasandra2004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723440968058/d639e378e99e8d8f47bdc5953c111a9d-1730301789"
  },
  {
    "email":"lorettamoretti68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441066362/8e9483ecff45e379bccd31bdcf467f64-1730301789"
  },
  {
    "email":"mariamartinelli.mmb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441099130/2042c5d0b16b6236f83c31e2fbf6c2a5-1730301789"
  },
  {
    "email":"salcasanga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441197434/dc86eb678c38406a651a8410b4a9f5cb-1730301789"
  },
  {
    "email":"paola.paglietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441230202/ae6e4f7a59ded182d13f1a87b3cf63dc-1730301789"
  },
  {
    "email":"emanuela792003@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723441361274/3a2cb3f357ebc6af01a1c6cbfb0600d4-1730301789"
  },
  {
    "email":"giuscirillo81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441295738/0cf3ab59f8ac4d12c30d0fb95f767cf6-1730301790"
  },
  {
    "email":"lauramausoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723441426810/532831a2ea4760439f20e27c94cc2bf9-1730301790"
  },
  {
    "email":"simylis79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441394042/ad461cf9f660ac19e457e30982dcc351-1730301790"
  },
  {
    "email":"simona.laurora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723441492346/ade04e5f73bc5c4116c937b2ff14c5b1-1730301790"
  },
  {
    "email":"cristinaderienzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441557882/c82c695c25fd60ada7d13f940a346564-1730301790"
  },
  {
    "email":"claudiacastorina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441656186/f680ecf3feedb8363abfcf0ea44ac49b-1730301790"
  },
  {
    "email":"luciavigliotta54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441688954/b30afc23ea15f0a885a09fe499bf8a49-1730301790"
  },
  {
    "email":"giulianamerenda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441525114/1a33e11ed3a0a8699b3ad626319d207a-1730301790"
  },
  {
    "email":"silvia.elio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723441754490/c995d7d0b8f1c35ef3ceb000bd4991f7-1730301790"
  },
  {
    "email":"pistis.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441721722/a333707dd021a33831c8cb7311b947bb-1730301790"
  },
  {
    "email":"cristina.frigo@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441885562/67dace896e60fcf00cc6fe59af735f6e-1730301791"
  },
  {
    "email":"simonecricri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441787258/49e2083dbdda933243c3dbe414d89566-1730301791"
  },
  {
    "email":"francescabesozzi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441852794/d31746e269b251abfa808b0de0c2981e-1730301791"
  },
  {
    "email":"tania.tornani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441820026/c0ce5f48ed2e3bbb03a35a27180596ee-1730301791"
  },
  {
    "email":"antonellaorfello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442114938/b96bd6873230f530b9f077f9aa76af52-1730301791"
  },
  {
    "email":"anna.delnegro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723441918330/c3146287b7f6ac3f0614ae66b00618a6-1730301791"
  },
  {
    "email":"info@zuplun.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723441983866/a59dad342b2631f1094ea1633d229df1-1730301791"
  },
  {
    "email":"danielamnr7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442016634/c9e182e0de67d98f54757cbcef73d431-1730301791"
  },
  {
    "email":"alessandracortese@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442180474/e1bb9bb2bb9aeacc83e2d28506562b76-1730301791"
  },
  {
    "email":"dorella.c@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442147706/43e1011174726f0684b67445e8cf21ff-1730301791"
  },
  {
    "email":"simonaberta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442344314/0072971efe76682de492a405a281666b-1730301792"
  },
  {
    "email":"monica.pianoforte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442311546/5cfcec7aaefbd15a7aa677f89986b2e9-1730301792"
  },
  {
    "email":"claudiacappelletti.idw@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442213242/05363df0f1b63a04572ceb71d833bea0-1730301792"
  },
  {
    "email":"cate.galloppa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442246010/5f0863f96e51664316cd5a89accdc8b9-1730301792"
  },
  {
    "email":"silviaruscillo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442377082/84fec37587240ba3cb4171e4214c4a48-1730301792"
  },
  {
    "email":"ulli.mair@die-freiheitlichen.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442409850/b28b5e4bc93870e43d4195ebf3b44852-1730301792"
  },
  {
    "email":"luisa.pinciroli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442508154/cd88d81662239454ce800ba5c39fde40-1730301792"
  },
  {
    "email":"esteticabenesserebio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442606458/60af19eb9278ace015c5a26d7208610e-1730301792"
  },
  {
    "email":"martaproperzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442540922/18d7f0c87cab72ed35b70fcff564a34c-1730301792"
  },
  {
    "email":"alessandra.onorati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442475386/f598713ce3eb36ffae5a3a1efa06e52c-1730301792"
  },
  {
    "email":"l.campana@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442704762/6081680c567a425d32f30a884c9ef011-1730301792"
  },
  {
    "email":"mcafarelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442671994/55ed81ccaf4f92e29efa29ea90c2ea0f-1730301792"
  },
  {
    "email":"gronchielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442737530/8af66199fdd569488a882f8bde5c2152-1730301793"
  },
  {
    "email":"concettarizza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442770298/10e2abcbd497a4b14a05fad7867f80b8-1730301793"
  },
  {
    "email":"rossella.galli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442803066/3e9b9b8edbeed2e9e0299f473028f4c2-1730301793"
  },
  {
    "email":"simona.verducci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723442639226/c5deb13291ff84ea6da15295d2418cfa-1730301793"
  },
  {
    "email":"studiomonicafabbrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442835834/11d74fe059bb3cf8a98934154dbefcac-1730301793"
  },
  {
    "email":"raffaellabalducci@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442901370/07421305f701c5189dfd4a04b6201023-1730301793"
  },
  {
    "email":"mycossu@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443065210/75df31830e3f5061f8b9b97636ae7272-1730301795"
  },
  {
    "email":"b.maiolini44@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723442999674/aae83e5e3f585dd414d29937776c6c10-1730301795"
  },
  {
    "email":"mchiste@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443032442/b29ef4eefd811c24d66806faa2644b27-1730301795"
  },
  {
    "email":"monicamatt11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443097978/639880dcd530c1387ddb73168d5f385b-1730301795"
  },
  {
    "email":"rosetta.barbagallo@aluce.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443196282/9920a7a2b224d482788fff2ad920f219-1730301795"
  },
  {
    "email":"sartori.ilaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443163514/ef7db9544b60037d8612ffb23dafe217-1730301795"
  },
  {
    "email":"fedo4@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443130746/3b30e8e099dbd7014370c357255495a0-1730301795"
  },
  {
    "email":"sara.mina9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443229050/34e1ba49897673d555c4f2276befe652-1730301795"
  },
  {
    "email":"fbartolini3@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443261818/d75bd590477b4635373cc83dc700a1d9-1730301796"
  },
  {
    "email":"fedes.86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443294586/5535d94171adfaa2dbf374b0400b6e5e-1730301795"
  },
  {
    "email":"e.benati@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443327354/c7b376cee9663f8d287d7fb1ad98e53b-1730301796"
  },
  {
    "email":"laugent@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443360122/a85ae88de4ca36d64fd5d4b8c4d64a44-1730301796"
  },
  {
    "email":"heribert@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443392890/952ee3db204d7f59b9c908e32ca31436-1730301796"
  },
  {
    "email":"claudiam.maggi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443425658/1672a3b5961d8674efa9c0ecee900a08-1730301796"
  },
  {
    "email":"sa.angela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443491194/d989d9cf3e3bd34946fdba8eadb2e3f1-1730301796"
  },
  {
    "email":"bitty.cotroneo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443458426/71fa045bce7ec59ae50bca5e9c412667-1730301796"
  },
  {
    "email":"italiano_gina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443556730/b520a331420cd56c261c78de41a26ad0-1730301796"
  },
  {
    "email":"dapolito.dani76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443622266/b36cb4221b78dc64db2d439f77669b3f-1730301796"
  },
  {
    "email":"e.guerrieri75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443523962/4fc413469dbf226beeaed4e0de80d22e-1730301796"
  },
  {
    "email":"vivi.dom@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443655034/1f17c73e033d539fdd1f8303e643634b-1730301796"
  },
  {
    "email":"thisismerobi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443687802/b026dbe77518d1122f02ed63b0458ff4-1730301796"
  },
  {
    "email":"marghe_conti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443720570/7a1c63cf5332ec2c119c6bed52229036-1730301797"
  },
  {
    "email":"gpiersanti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443753338/804b1d0e5de596bbe17f690a6526e4c8-1730301797"
  },
  {
    "email":"tiziana.luchetti58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443884410/02aae226fbff589837aa04cc68fc20c6-1730301797"
  },
  {
    "email":"pa.lancioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443851642/7d185db81a26bf6175ffa1a8ac935660-1730301797"
  },
  {
    "email":"elinataurisano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443917178/2901c6391753cc92cf37b012a3d4fd06-1730301797"
  },
  {
    "email":"simonabassi446@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443818874/0c8950ab51afa26477cd38bb13d5aaca-1730301797"
  },
  {
    "email":"astridprosch196@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723443949946/df6fd9053249d57a51b4cb7961ec8107-1730301797"
  },
  {
    "email":"valeria.tobbia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723443982714/c5a0a2b78c9f5e0c69127611dfae0fe2-1730301797"
  },
  {
    "email":"cardiochirurgia@centrocuore.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444015482/d2ce7f3ca6e53291ceeab808a524e788-1730301797"
  },
  {
    "email":"elena.lib@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444048250/665fafbcd63a0470a688e506bd879026-1730301797"
  },
  {
    "email":"castiglia.daniela83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444113786/65b38c6196ad70f93111e10ecda636ed-1730301797"
  },
  {
    "email":"ilaria.valle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444081018/3a168d59110d53bab43baf8958dc5e66-1730301798"
  },
  {
    "email":"tromanini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444179322/02b7ae67f9308870cd0b3dd48f61d056-1730301798"
  },
  {
    "email":"didiciv@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444212090/fe666585f458a7455a55564c4fa9f84b-1730301798"
  },
  {
    "email":"l.pannunzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444146554/7940ea8e7bc625506e4dd2a3e1f5e25d-1730301798"
  },
  {
    "email":"simona.nasti73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444277626/0260e3a1e087f2b163ae346ca65a93ed-1730301798"
  },
  {
    "email":"bbosello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444343162/bcacb1bf607c2971395f630e22353d47-1730301798"
  },
  {
    "email":"marcella.iacono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444375930/df4ba342dfd2010f7b376d01823fb4a3-1730301798"
  },
  {
    "email":"itigo83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444474234/7e83a5f196b5e8535734ffd3eae64007-1730301798"
  },
  {
    "email":"elisa.truffelli@unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444572538/935e49f97ded90f9a4afbe042768d21a-1730301799"
  },
  {
    "email":"lucatede91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444244858/86c2dd01802bdb90a7a019a351392c84-1730301799"
  },
  {
    "email":"mlucia60@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444441466/7a7ef7b0cfdbdb50f369a610e4d34ae8-1730301799"
  },
  {
    "email":"vale_cavi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444670842/647792197d188dd95b197a93b3076633-1730301799"
  },
  {
    "email":"federica@madesani1913.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444605306/6ef5fddc31f408213c998d1d5fe12195-1730301799"
  },
  {
    "email":"lara.cimatti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444703610/91ea72053d1487d027ba9d0b8a007560-1730301799"
  },
  {
    "email":"mosciattif@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444736378/aa1d46d3f56c7a9c8d98187293406eb7-1730301799"
  },
  {
    "email":"carlamasidoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444801914/24a307236f524ab2907725d7fd6c5394-1730301799"
  },
  {
    "email":"claudiacosenza96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444769146/f4f4d9e38cfa38b6709653a205be9fcf-1730301799"
  },
  {
    "email":"tiziana.carrer@amministraresas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444867450/7299400010df3d4bc7a30debb2dd2ca1-1730301800"
  },
  {
    "email":"martaproperzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444834682/62633411d2e02a86f6afb3d28afb337f-1730301800"
  },
  {
    "email":"catiuscia.giordano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444539770/24fb1de7e6c57a61e0364c500b0e0edf-1730301800"
  },
  {
    "email":"mariannafoscardi92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445031290/954e67955f40c9f41cad55bd6f537491-1730301800"
  },
  {
    "email":"delia.conte76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723444900218/7fcc82e27fb67700feee5c86215a2f4a-1730301800"
  },
  {
    "email":"flaviatedeschi.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445227898/01ced1c42d2818f281335f1fcdd19c94-1730301800"
  },
  {
    "email":"annapaolaf5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445260666/3057fd35e22633c7dc69410fe7431df5-1730301800"
  },
  {
    "email":"luca.bot83@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723444965754/15854d748bc1656a329765859c4b35a6-1730301800"
  },
  {
    "email":"federica.sega@sensisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445326202/af33483b76e6b9785dca1d1d2d960fcb-1730301800"
  },
  {
    "email":"lauradebei@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445293434/abd2b0d3b9b2b7c9b6443b291f65710d-1730301801"
  },
  {
    "email":"bottacini.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445358970/c262e19ec25f940de9caf1a84d1f207b-1730301801"
  },
  {
    "email":"stefano.monica71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445391738/9a70c5e36540c5491a025add8c21c4b3-1730301801"
  },
  {
    "email":"poli2007f@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445457274/d26f20931cfc4c3eb389071a48876281-1730301801"
  },
  {
    "email":"frabi79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445555578/44c7974816c2097fe35501c9738d44f6-1730301801"
  },
  {
    "email":"giada.carniato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445686650/37b9a56bbc50555d71074c7fad4049ef-1730301801"
  },
  {
    "email":"f.derobertis@turismopuglia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445621114/f9a81ca195b372cb9986d9ec1bf14e0b-1730301801"
  },
  {
    "email":"cinziarogora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445490042/d6d04f0984d2ab3ce011fbc9044e2e4e-1730301801"
  },
  {
    "email":"vescovoclaudio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445719418/25af1bd88fa2983eb8c49daf5606127c-1730301801"
  },
  {
    "email":"elecarretti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445784954/b7b42d3e5cb793047f2f799c128bd6de-1730301801"
  },
  {
    "email":"ciardi3@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445752186/8e33c7eae888a1591e48ea6e524baac4-1730301801"
  },
  {
    "email":"monicanuci76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445850490/00c4a439a577b7fd3d143793c88f0490-1730301802"
  },
  {
    "email":"lindamuscio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445817722/3444cc6e232e366eb8414ec11c4e01ce-1730301802"
  },
  {
    "email":"francescalupi14@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723445883258/e3afe2e4eeb8ee7044f563ba8612883f-1730301802"
  },
  {
    "email":"crotti.claudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445916026/81e5a289e22df5a581cfdb3260351dfc-1730301802"
  },
  {
    "email":"giovifasani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445948794/cdba97b5f5af172fcd4162ad195ba929-1730301802"
  },
  {
    "email":"silvia_redaelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723445981562/bfbc4f92ff4d64199feec1e4fab556a5-1730301802"
  },
  {
    "email":"info@anticaghiacceretta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446047098/dd57b7a5e2650cb0dcdf934391b9bc6d-1730301802"
  },
  {
    "email":"melaniavalente77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446079866/38637187ddc21510dd76663b7379d343-1730301802"
  },
  {
    "email":"roberta.badoglio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446112634/102d3332db5a41bbe3cf9f3ff67175fc-1730301802"
  },
  {
    "email":"marinacaprioni1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446014330/6f7e262c469d465ab98e79bd8e09d1bb-1730301802"
  },
  {
    "email":"giuliaorlando22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446178170/7abbd49bb128fcad15282a44e7cdb520-1730301802"
  },
  {
    "email":"anelli.lorella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446145402/24001c019530e3577cbab3b71c9b23b7-1730301803"
  },
  {
    "email":"fagotto.eliana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446309242/bc971e99b0804f10cbc234574f70c772-1730301803"
  },
  {
    "email":"fanignia2@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446342010/688c1ae600d61729bf1225cfd115b0b1-1730301803"
  },
  {
    "email":"nazzi.vale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446276474/977b37aa481206b09f90363b31126206-1730301803"
  },
  {
    "email":"hantonella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446210938/d54c6825186d5e405ad38fb22cb32145-1730301803"
  },
  {
    "email":"bacchini.raffi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446407546/49eed4e964c6d81854a2db59b2492405-1730301803"
  },
  {
    "email":"silviapreziosi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446505850/7027f5404fe773ada42b411597bee08e-1730301803"
  },
  {
    "email":"robertagiordano66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446538618/a93b7232d04a19528b51b4ace5781dc2-1730301803"
  },
  {
    "email":"ylionor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446440314/487d765b0b0bd82d4710ba19c8e3e54d-1730301803"
  },
  {
    "email":"donatella_panna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446473082/03201d767ab32f23dff9946e715ec8e3-1730301804"
  },
  {
    "email":"cimini@studioborroni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446604154/bc866ceb1d9ee1f4d11f0975e8183884-1730301804"
  },
  {
    "email":"mikistarck@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446636922/6792c59d03fc3de70280f03efa2465c9-1730301804"
  },
  {
    "email":"saradebortoli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446669690/353bbd0740b21e16cf76d43199f6d2be-1730301804"
  },
  {
    "email":"chiarasalvalai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446571386/bc6b27682f0022b6f6ed8120e5e375d3-1730301804"
  },
  {
    "email":"eledippy85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446735226/8d1a1fd32e69128520f843b58d915379-1730301804"
  },
  {
    "email":"o.medori@parif.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446702458/b6c7e084fefcf30779c9277f7e4c1808-1730301804"
  },
  {
    "email":"rossellamarsella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446767994/1eeb28634f2c3c375e943a09166686f6-1730301804"
  },
  {
    "email":"elenacastiglione84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446800762/510259e57b99c5e05c22830bfbba6df2-1730301804"
  },
  {
    "email":"anna.alimonti@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446833530/b28fbd837a494f5b0a3d895ba1031403-1730301804"
  },
  {
    "email":"sabinabiancuzzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446899066/2fa41b66bfcdf4155263d5ba9128a4f1-1730301804"
  },
  {
    "email":"davide.vaglica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446931834/b7726084dc55172f1ea43757d0bffefd-1730301805"
  },
  {
    "email":"martinapievani11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446866298/431a169136d74331e0702c8bb3622fe4-1730301805"
  },
  {
    "email":"daniela.testa1509@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723446964602/6f1ade92e45216ce318aa1f083c2f769-1730301805"
  },
  {
    "email":"elisabetta.dugnani@becaitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723446997370/be1f62e2d6be3737643b47ff9a0f8cdf-1730301805"
  },
  {
    "email":"nava.betti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447030138/5a6f52e61c52c9a35b01db77f49d679c-1730301805"
  },
  {
    "email":"maura.cannella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447062906/116099f70abc200836a48eeef1e1e370-1730301805"
  },
  {
    "email":"cristina.camilleri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447095674/5b9f212e99473a330b27b3c17e696856-1730301805"
  },
  {
    "email":"marinm@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447128442/8a2aa4527406b6ab1285c86aa98a37fb-1730301805"
  },
  {
    "email":"stefaniabriscoli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447161210/f82a071f2a0c29c2e9dcef6b6068cf6e-1730301805"
  },
  {
    "email":"candidabondi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447292282/96476811245bae8d22834bfa2e9d33fe-1730301805"
  },
  {
    "email":"ste.digre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447357818/e3e0dd4d577deb54173eb7d4e8d2e92a-1730301805"
  },
  {
    "email":"f.france82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447193978/ab21250992793b581c7cdef35a05141d-1730301805"
  },
  {
    "email":"chiabertone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447390586/8b2c1e3e0bb70a9c5e6804faac86c0a1-1730301805"
  },
  {
    "email":"morena.guadagnin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447488890/93da326b559a003fce05e30c5a6d2804-1730301806"
  },
  {
    "email":"erikabonfiglioli77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447456122/b3597717e70896ebac617fd87ddc8954-1730301806"
  },
  {
    "email":"larapippo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447587194/072b570fb162bc3d372f6f838c28693b-1730301806"
  },
  {
    "email":"roberta.dedominicis66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447521658/ac4ead1e9366170713b02d163a9ef2f6-1730301806"
  },
  {
    "email":"paolarch5@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447619962/6e1884e5ffd10bffd25b4314468c6f99-1730301806"
  },
  {
    "email":"barbara.galante@generali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447652730/4c7b05b9d1532a22403bdfe038275083-1730301806"
  },
  {
    "email":"vellone.manuela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447685498/ce1bf63345665882e016437bee1579e9-1730301806"
  },
  {
    "email":"mariahab80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447554426/785074f40858a5a570e5a8aa6ea12a2a-1730301806"
  },
  {
    "email":"giulianamazzi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447751034/6259bf60bcf2f71ad2f1cddf5f185dac-1730301807"
  },
  {
    "email":"serecagn@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447783802/ab178c66fe75a5095a11a26bca125fa4-1730301807"
  },
  {
    "email":"nene2@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723447849338/4737beaee6fe0aa31fe01e659e461251-1730301809"
  },
  {
    "email":"silvia.sciolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447914874/adeda7a5a60ee771b19e9f81dd82ec12-1730301809"
  },
  {
    "email":"fabrizia.scortecci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447947642/ef70e93072a935e29d4bc94567f8e857-1730301809"
  },
  {
    "email":"gabriele.facciorusso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723447980410/250e42670ef8149d7e20b0e5c3b72107-1730301809"
  },
  {
    "email":"monicarucco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448013178/a719aae03584ff565be3aac7281693bc-1730301809"
  },
  {
    "email":"raoul.lecca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448045946/83c2ad499bc8b3240fb450ce71fc6fa8-1730301809"
  },
  {
    "email":"nicoletta.caravita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448111482/a006f4dc19b12dcbf3f27843785333ec-1730301809"
  },
  {
    "email":"naikalocci82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448144250/d6a06131ed2078fcfa709a4542e4268e-1730301809"
  },
  {
    "email":"giuseppina2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448275322/cf61ec6432a3ec09af52ad9575a9733c-1730301810"
  },
  {
    "email":"meli1104@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448242554/71b787e06228b796c51ea7c93804b4e8-1730301810"
  },
  {
    "email":"natascia.venturi.nv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448308090/87fe2f9ab94814129d03200412460014-1730301810"
  },
  {
    "email":"frabri@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448177018/9b7f546fcc1c5d71638ab6432f3a0a4e-1730301810"
  },
  {
    "email":"donato.debora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448340858/d210747ff1d003162147e70cba0548a3-1730301810"
  },
  {
    "email":"cvs593@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448406394/072ffad9e300c35ebb1e56da3fe4535d-1730301810"
  },
  {
    "email":"tizianovincenti@ibero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448570234/0ddee58022eb3c02c72f8dc702a49d65-1730301810"
  },
  {
    "email":"carta.paola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448603002/a331ebf52818c9a6ad6ea47e931b0e1d-1730301810"
  },
  {
    "email":"guidaterry93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448635770/29267718d6277a6dd54a645e7772856c-1730301811"
  },
  {
    "email":"veronica.losa77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448373626/3460c56554e0e8e1fa4910e41b77f0eb-1730301811"
  },
  {
    "email":"valentinabaldini@supereva.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448504698/e77dadc2a0d3833b51e2c514e6cff6df-1730301811"
  },
  {
    "email":"mariagaudiano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448766842/94962b722060a76b138d894e944133cc-1730301811"
  },
  {
    "email":"piky.fassina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448701306/1ea7a12ca9c36babf69e926894b85f77-1730301811"
  },
  {
    "email":"manuelajo3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448832378/45173897715f4c829d5c945740e0e0d7-1730301811"
  },
  {
    "email":"eri81ka@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723448996218/3e3eca8ea080d5a6d26f6c04ed94859e-1730301811"
  },
  {
    "email":"biancapanico1965@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723448799610/7a0cd6d5a4e52a4ea8f59ab3ac23aa45-1730301811"
  },
  {
    "email":"ing.giuliarombai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449028986/77a28d6d80a72c0c825961d98c09acac-1730301811"
  },
  {
    "email":"alessia.colla2003@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449094522/5a72ca6f8fa8018a5547df7f63f36134-1730301812"
  },
  {
    "email":"olga.derosa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449127290/b4f3c25a697ecf9e36cdf52c825bce5f-1730301812"
  },
  {
    "email":"serenadangelo1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449061754/0ebb91a83323921bf0811bea3267bc7d-1730301812"
  },
  {
    "email":"anita.sannini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449192826/d48221569b216a43ef7e1d5f1a9195c5-1730301812"
  },
  {
    "email":"cipria84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449160058/ecc8b96b7e4b3f8a51f91e787adc9efe-1730301812"
  },
  {
    "email":"claudiascrocca@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449258362/ca76b59871d5a20e66ddd9848d46098c-1730301812"
  },
  {
    "email":"simo.montilla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449356666/a835f29b510e96b5168bb7289d9ef78b-1730301812"
  },
  {
    "email":"r.giusta@ferrarospa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449291130/d41572dfa0a9121c8f3ea4d2a0e24a52-1730301812"
  },
  {
    "email":"federica.macaluso04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449389434/9cbc6ad72e5b3447377dbde0f2258d24-1730301812"
  },
  {
    "email":"cri.fed.ric@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449323898/fda709f0af8001bd1d3258cc2ea21fe6-1730301813"
  },
  {
    "email":"kristina.koval@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449422202/9285ae3819250b1248327511a64ca8b8-1730301813"
  },
  {
    "email":"leonardo.iachini91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449454970/f5a40ca37b63f277bcb01998df3a1d6b-1730301813"
  },
  {
    "email":"gabrielebrivio@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449487738/0d136d61de37d797e17c50963801fba6-1730301813"
  },
  {
    "email":"frollanoanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449553274/ccfb92f9916cd2bc9d9b0e53d1893098-1730301813"
  },
  {
    "email":"graziabil@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449520506/0ef77554d8823aa9c21ae126f5e37e8e-1730301813"
  },
  {
    "email":"roberta.testolin@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449586042/123c6ad11e080fef8115f5ae28199354-1730301813"
  },
  {
    "email":"mannellisara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449684346/c6fb778e6aaf364e52abb74f4aae9179-1730301813"
  },
  {
    "email":"tonniroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449651578/2b20862724ebb77863b7f5b92e3fc329-1730301813"
  },
  {
    "email":"adriana.mosconi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449848186/cc4260c6a27627dbc3606445d7dea496-1730301813"
  },
  {
    "email":"laurettacorea@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449880954/a86fab78abadc801a50391c1701a8df8-1730301814"
  },
  {
    "email":"michela.pierdo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449717114/bb3c6b31178b03fa1d2ab24f34dff6d6-1730301814"
  },
  {
    "email":"bina.ragazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723449749882/10ba6c3bb5744ef211c8bc80252ad458-1730301814"
  },
  {
    "email":"giandi60@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450012026/60b16b2269a70b6ecd98f651fc615702-1730301814"
  },
  {
    "email":"filomena.spina75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450044794/8993dfef31140f20c94a1224360cda99-1730301814"
  },
  {
    "email":"bottimarchetto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723449946490/3b9655859a7a4c3c3e95d933e8a11211-1730301814"
  },
  {
    "email":"j.hristova@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450110330/4250bd41934e550cdee03eca3cdb5a36-1730301814"
  },
  {
    "email":"valentinachini.88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450143098/6cff3e5e7cdfe936ff32fa01017a4a4d-1730301814"
  },
  {
    "email":"yvovero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450175866/65b2ae9ffafda7464dfb5f2637505683-1730301814"
  },
  {
    "email":"milenatanese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450208634/79a564a3760daa54af8aafa535c2814a-1730301814"
  },
  {
    "email":"mspado@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450241402/3dc8e48edc36431854954cf34dab95c4-1730301814"
  },
  {
    "email":"alessio.gerosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450274170/92fb86aade21ebb8841c3fe470d95705-1730301814"
  },
  {
    "email":"lucianapacifico3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450372474/3b0faeb2e732bb30acb03a96cf35dc15-1730301815"
  },
  {
    "email":"my.folletto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450405242/75f91d1050281af341b1a95f9ffa5830-1730301815"
  },
  {
    "email":"fede198328@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450339706/426f1f6cce854d4137d7ca942b1a8c56-1730301815"
  },
  {
    "email":"kandur8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450438010/433fc663a3cbd90b110dd3310f1d35e8-1730301815"
  },
  {
    "email":"cristina.penco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450470778/0320d3d2881aff04def96a3457a0afba-1730301815"
  },
  {
    "email":"giuessey@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450503546/78caa43fefc5027ac53af7796e573ccf-1730301815"
  },
  {
    "email":"bettini.lau@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450667386/91750e37b5e21e729023364b43bcd3d1-1730301815"
  },
  {
    "email":"fmerico6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450732922/e2d01ecb9c6c735ceb42375f1bc489fc-1730301815"
  },
  {
    "email":"manuela.indraccolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450765690/b7e138c932d6578c770d5fb69bf31096-1730301815"
  },
  {
    "email":"irenebiro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450863994/48ff0d576e2c9dd3e2d83b4bc450cd93-1730301815"
  },
  {
    "email":"giggia74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450896762/c5ae93a7bd317c1d21a8fee69dca2c90-1730301816"
  },
  {
    "email":"francesca-dario@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450536314/99403a5fdc1b42160a8e2342da64ef59-1730301816"
  },
  {
    "email":"carolina.zerbo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450929530/a7efa8b4377e1c5c470e889248ec97b6-1730301816"
  },
  {
    "email":"borronib@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723450962298/36309cbd061fecfca6b0ef3f567e1d49-1730301816"
  },
  {
    "email":"mari.corillo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723450995066/b127da212ba0a99138f0bd02d5bbbcb4-1730301816"
  },
  {
    "email":"sara.monti70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451060602/982ab68271701ab001005815f477a345-1730301816"
  },
  {
    "email":"paoloturchi1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451027834/a60a5d4c3fb11d65b2e73c66024e6081-1730301816"
  },
  {
    "email":"benna.laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451126138/45c04c9e3fad59d1b40151c7d32c3662-1730301816"
  },
  {
    "email":"famitommasi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451191674/726841d6df4620c15ba7e89138daf09e-1730301816"
  },
  {
    "email":"lisadallarosa676@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451158906/55757f4e4c317cf8fd152bf227089faf-1730301816"
  },
  {
    "email":"silvanalorenzi169@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451093370/3bf4fe157aeff9c9b8476c7436cef434-1730301816"
  },
  {
    "email":"eliana.ffff@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451322746/26da73e647b3f15c7070cbdd74908e35-1730301817"
  },
  {
    "email":"serena.zambon2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451257210/d29b687c4b868369311d9dedb0fe8128-1730301817"
  },
  {
    "email":"tofonil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451224442/cc66ca420f75bbc6aaffea07da2d588a-1730301817"
  },
  {
    "email":"marinadattila@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451421050/3caaf5fab9ee1b513faed523e550122a-1730301817"
  },
  {
    "email":"laurabacci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451486586/2411c3930b7fa931b3130075a97cb304-1730301817"
  },
  {
    "email":"francesca.aieta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451388282/cfd514ea2502ab9d66a4bccc3088c1cc-1730301817"
  },
  {
    "email":"serena.brugali@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451453818/ea3f151acb6bef732e33d03a74115456-1730301817"
  },
  {
    "email":"monia18@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451617658/1e7d50b90988bf386c54c300eee21c8c-1730301817"
  },
  {
    "email":"laura_gabrielli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451650426/22c7f35548b3d7823725e8b9f29b256e-1730301818"
  },
  {
    "email":"barbara.castaldini.calzolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451748730/8cfa5519633ed7a9b1ce3a1db7aa854e-1730301818"
  },
  {
    "email":"castellani_anna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451552122/d7dd14dec7b452d08c3ec03510184f25-1730301818"
  },
  {
    "email":"marginiteloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451519354/051cec9ce6396c9ee2b9219c60959047-1730301818"
  },
  {
    "email":"alessioalexis22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451912570/6fdeb7282611929ffcc6aba681af9a69-1730301818"
  },
  {
    "email":"giovanna.fri@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723451978106/3c311c452b6919f0d7ff5c760a53aa74-1730301818"
  },
  {
    "email":"monicacarota1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451879802/21eaf2501eba45c44060921316c8272b-1730301818"
  },
  {
    "email":"lucia.iacobi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723451945338/b9f03028db3d649b9a0902a9c97e5b56-1730301818"
  },
  {
    "email":"lorena2063@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452043642/8420a88678c7bda39f736b77d7f60693-1730301818"
  },
  {
    "email":"franceschi.melissa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452010874/3770509beae0478998ca17e1a696108a-1730301818"
  },
  {
    "email":"luca86cattaneo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452109178/28ce390d479f94d1215ffa8fe3bd6d4b-1730301818"
  },
  {
    "email":"cristinapestelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452141946/c6ed791f44eff96ef885c07a020a4010-1730301819"
  },
  {
    "email":"amoriconi@italtorniti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452174714/61eb87db55d4b3de636a2c15e836e74a-1730301819"
  },
  {
    "email":"serenere2006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452076410/3406c6c3ac7e61e2efe73e47922ace26-1730301819"
  },
  {
    "email":"maria.aversa@telematicoaccise.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452207482/083c35f250149e27bdd5311aeb2b8a16-1730301819"
  },
  {
    "email":"croci.giovanni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452240250/29ec28866e8c25e3d26f3ee15c9b8aa6-1730301819"
  },
  {
    "email":"carola.friziero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452338554/e8337be78a7f015e0169562c5bf3964d-1730301819"
  },
  {
    "email":"nicoartale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452371322/ab06c9f5c0f3f90698858e99a83516dd-1730301819"
  },
  {
    "email":"ottonimartina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452469626/b766c4bd32294942e625cf094d01c0c4-1730301819"
  },
  {
    "email":"ivodimario@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452436858/ea0575e59ad44fda0df5f3ad1d09a72e-1730301819"
  },
  {
    "email":"r.bovier@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452404090/5481925940bfae8f7b21d4720fb2253a-1730301819"
  },
  {
    "email":"francescamontazzoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452502394/cef57d855b954644d1bad00de653adeb-1730301820"
  },
  {
    "email":"laura.marini1996@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452567930/d7954f00fd2a07924e3332ef6b426c5b-1730301820"
  },
  {
    "email":"danielaballan69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452305786/684085b8e47387655cdc93bcc815a14a-1730301820"
  },
  {
    "email":"uappala66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452600698/4258d6c8e42569dd31b157228c02bbd0-1730301820"
  },
  {
    "email":"chiararupi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452535162/854005e514cab4d625f06e8b93699670-1730301820"
  },
  {
    "email":"mennitielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452699002/cc2e2a5eee2a35b6f140bf78fb1d3cde-1730301820"
  },
  {
    "email":"alessia.serano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452633466/a34b7bbc00ea13b7682c55c35262dc59-1730301820"
  },
  {
    "email":"paolettavig@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452764538/44cfcdf0bfeffc9e623a84ae4a36777c-1730301820"
  },
  {
    "email":"mimeren@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452797306/662a6234d6b40599ba865dc91d01914d-1730301820"
  },
  {
    "email":"miceli.pina76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452830074/5c890f2490ac57881f19237c1adb1a3f-1730301820"
  },
  {
    "email":"andrea-gh@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452862842/090c032a619fcf34a2eae44a3f04571a-1730301820"
  },
  {
    "email":"sofia.serafini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452928378/7d781f76c3d8e6be0df6958dbd7a44a7-1730301820"
  },
  {
    "email":"giuliana.simonetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723452961146/2e1e8729d122dcaa991aa3ff90a180ff-1730301821"
  },
  {
    "email":"caterinaluddeni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723452993914/7215bbbb73969a56f621d76e60af768b-1730301821"
  },
  {
    "email":"redagiuseppina2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453026682/b25f81adafb5c3b19a7b1dfef8391531-1730301821"
  },
  {
    "email":"valinavalina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453124986/f48c7b203d94375b1e3948650e862324-1730301823"
  },
  {
    "email":"donatella.frizzera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453157754/5e79fdc1e0352ab40b31619df9bfb978-1730301823"
  },
  {
    "email":"sabinadomenic69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453059450/c66fe75bfb0cca6e91ed34650ec2f3be-1730301823"
  },
  {
    "email":"elenina016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453092218/6dd86d27b571bb6ad5b7a3482b7f0aba-1730301823"
  },
  {
    "email":"michela.fiandaca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453190522/39cf6a0f8ce835707556ee2f5f3ad04b-1730301823"
  },
  {
    "email":"azammuto71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453223290/9de609ac98b10f756e550fdd6669c131-1730301823"
  },
  {
    "email":"scisli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453256058/024e12da113054c0acb856a79b776ef8-1730301823"
  },
  {
    "email":"cecilia_bellagamba@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453354362/9d07dff9cb8761228766d86ae623e9fd-1730301823"
  },
  {
    "email":"mazzuccolau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453288826/2c2cf8f2c20f41b1c40c0699ad94d078-1730301823"
  },
  {
    "email":"neriser@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453321594/76a00d66648d075ea9b544cc3e34fb7b-1730301823"
  },
  {
    "email":"vivianasafina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453387130/9870c42637c5b1d94c3f28ad4435fd1c-1730301823"
  },
  {
    "email":"daniela.memmo@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453452666/f35dde701399cc4e74bfbbbc74c3a5c6-1730301824"
  },
  {
    "email":"eli.bertocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453485434/d9e8f93d762a00f91547b2b0fe6f3473-1730301824"
  },
  {
    "email":"anna.giannotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453518202/33032c0251c165f41d37f65fd157b436-1730301824"
  },
  {
    "email":"silviaberna@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453747578/6184f17b3a2426f03686ea7571b0f3a2-1730301824"
  },
  {
    "email":"s.lagostena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453813114/a1b4731a053533b768ebd917a873c0b6-1730301824"
  },
  {
    "email":"emanuelasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453845882/215462d3a35327eccf1bec53d3e46cbb-1730301824"
  },
  {
    "email":"farfallinaelhaiss@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453550970/d7f4ad0e801498f96bae1857f4224426-1730301824"
  },
  {
    "email":"laura.vitali63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453714810/85a8c4b19e0efa5c8b37e7f593247f59-1730301824"
  },
  {
    "email":"dawndelynne@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453878650/47b0268c8ed6a1fa9c69d4c82b39186c-1730301824"
  },
  {
    "email":"marisa.pastore13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723453976954/8c9b8e3ad075e499077e625774610414-1730301824"
  },
  {
    "email":"gianilaceccherini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453944186/8687bceb97b3e52f78bc54ea50495341-1730301824"
  },
  {
    "email":"elena-bertolini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723453911418/7008d5d29d25da0f90af56f03ca64716-1730301825"
  },
  {
    "email":"mcc15@mac.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454009722/fa093f73de5c0049068fe0323da2a2af-1730301825"
  },
  {
    "email":"micaela.bellu@unitn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454075258/9d9e03e95d33460750d5cf6ee1024e46-1730301825"
  },
  {
    "email":"alebichi60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454140794/09a3543a6f664c744894b1c5ac7d6671-1730301825"
  },
  {
    "email":"laura.pagnotta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454042490/84d71533fb6bb0d87f0f954446797246-1730301825"
  },
  {
    "email":"mgrancoita@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454173562/a06567fea2ccd0b0fac7cbdd1d4ea523-1730301825"
  },
  {
    "email":"erika.altimari@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454239098/f59b329f33a772fadbcee11dc123b305-1730301825"
  },
  {
    "email":"bubi2002ba@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454108026/cf26e922b794510661fd4ea7258e6577-1730301826"
  },
  {
    "email":"berlinanna267@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454271866/50340541864bea9a416248ce2d33b6cd-1730301826"
  },
  {
    "email":"stleonetti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454304634/08c83b8cdf18a3a15f59050f63690321-1730301826"
  },
  {
    "email":"barbara.mastropietro@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454337402/52a1be6f46f94144c5312682ddae8f67-1730301826"
  },
  {
    "email":"cacciafilo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454370170/4f2b7efdf9c00212cd23267794fcd0f6-1730301826"
  },
  {
    "email":"cate1403@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454501242/32ecbc20f1abd93c456684d5f2d242ab-1730301826"
  },
  {
    "email":"lfuimeni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454206330/bbcc9bb0a5735aee9c663ef82f9aa152-1730301826"
  },
  {
    "email":"tizianacorsi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454566778/c2a76300ea4d469f83d084508bd3de36-1730301826"
  },
  {
    "email":"fpancraz@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454599546/1f8d244c96fdedf21ba9707527d5141a-1730301826"
  },
  {
    "email":"rosakcascio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454665082/ab6311ecffa337bc0643aa301a8f8c21-1730301827"
  },
  {
    "email":"cristianofigorilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454534010/fdcc6c439fd5d25cb1d33e96530ad0d5-1730301827"
  },
  {
    "email":"lperini68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454697850/265dd79901bf710784dd61f2bb98f615-1730301827"
  },
  {
    "email":"lecce.sar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454632314/3dd5e022fdfb0154383b275d97fe9339-1730301827"
  },
  {
    "email":"fivano@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454730618/7fdcfa45d0a506f6e29d81ad4cd0b6fd-1730301827"
  },
  {
    "email":"dinazattin@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454796154/799e5423296e9fd4206a6e0be22358ac-1730301827"
  },
  {
    "email":"mariachiaramariani65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454763386/c33237fee490db68d70a91d7b1d8b220-1730301827"
  },
  {
    "email":"infomatedichampagne@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454861690/6daf26cc1b9b7f9c431197e74919c8d9-1730301827"
  },
  {
    "email":"margheritaramundo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454828922/0af643b93b16f760cd89fdeb50b6e290-1730301827"
  },
  {
    "email":"phor4n@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454894458/cd879051860eac7c5a8612b1468f0b09-1730301827"
  },
  {
    "email":"gaiapellegrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454927226/f53884b1c104fdca3228b7b14cae6db1-1730301827"
  },
  {
    "email":"lecce.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723454959994/01926cc1d8175b79e5580842c90c5561-1730301827"
  },
  {
    "email":"valeria.palazzetti@enav.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723454992762/ba082e5af3242d1d67d42eb29d491f30-1730301828"
  },
  {
    "email":"morena.tietto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455058298/37a45730233733c76289543e1f6140ff-1730301828"
  },
  {
    "email":"annadelor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455025530/f79cc9835a1ff3536e1ae61cafa6706b-1730301828"
  },
  {
    "email":"christian.carucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455123834/6e18e4c874aec842b6fd6fde4075df19-1730301828"
  },
  {
    "email":"danipijon@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455156602/7f566467474f2327ba28abc8e8003c4a-1730301828"
  },
  {
    "email":"giorgia@pavani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455091066/39ed671c180a5068169907c6d4ab2066-1730301828"
  },
  {
    "email":"francescaserra1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455222138/87ee3df1ba83b46e730fb5f70491b236-1730301828"
  },
  {
    "email":"piccione.veronica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455287674/c2daa7fbc983e759631007cdafb10322-1730301828"
  },
  {
    "email":"rucola83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455385978/cb2e59b2093808433f9b029e2f31b5bc-1730301828"
  },
  {
    "email":"and.bottaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455353210/4145b5b63c63cdcf72d53e0ca255649d-1730301828"
  },
  {
    "email":"billerisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455418746/86f9fe4c7297c4910ca00e9337126286-1730301829"
  },
  {
    "email":"salviettistudio@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455254906/04c155b9e6f5cd26020f3930d6d87953-1730301829"
  },
  {
    "email":"carlottaderosa1993@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455517050/5da79c416116bf56cc90b5620a5a5c1c-1730301829"
  },
  {
    "email":"polapagni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455549818/00fbc9a93cff2c0d965713c3925a9af6-1730301829"
  },
  {
    "email":"marika.sperduti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455582586/218fad5e981568c386af2542228ca65f-1730301829"
  },
  {
    "email":"ragazziniclara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455451514/3dbd62ebd5cad30255c7c63bba956a8b-1730301829"
  },
  {
    "email":"alison_renault@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455615354/ef814a33c1a0418a8be8810dfd3f3a78-1730301829"
  },
  {
    "email":"slauretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455648122/eb5d8dc85a9b577d26edd9d8305ac1fe-1730301829"
  },
  {
    "email":"marziarampi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455746426/57f46581302a22a621d83314c30a29ec-1730301829"
  },
  {
    "email":"federica.manunta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455713658/e157423a663b4e5baed7d9e262143269-1730301829"
  },
  {
    "email":"vaccaap@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455779194/2d2fe64954e21088134d10f09d1e3863-1730301829"
  },
  {
    "email":"c.criscione@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455811962/9411808d8d0a49e34345d8823cf91c9b-1730301829"
  },
  {
    "email":"leogentile2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455877498/68e373a0c89c0276c9b435576432f535-1730301830"
  },
  {
    "email":"lodocat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723455910266/2afcd34ac1a803f4f4b4e52c4f772440-1730301830"
  },
  {
    "email":"fedetanf@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455943034/f6ed7b33c4e69b7b775e49740cf4e9ed-1730301830"
  },
  {
    "email":"annamariaopramolla@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455844730/0597bbab9554525552e293878bf55455-1730301830"
  },
  {
    "email":"magliano.elisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723455975802/7686fb96086bc6321745b1a315681be9-1730301830"
  },
  {
    "email":"mail@giudittagangemi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456074106/7beb5f5c9c24290d9e5bbc0a5468da40-1730301830"
  },
  {
    "email":"riccipetitoniclaudia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456172410/5beb1ab2fc390d26d85e8fedb3f5bca9-1730301830"
  },
  {
    "email":"michela.angeli73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456205178/aa0602756d02b6617bc0b5bd1337eddb-1730301830"
  },
  {
    "email":"laura_uni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456237946/adbd86a17fa9efb3d5e42472fca1be43-1730301830"
  },
  {
    "email":"claudiapacini63@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456369018/add0f995c6237fa1984337da5f35f9b6-1730301830"
  },
  {
    "email":"alis80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456434554/e1265247a0d283995e62ff166a80a860-1730301831"
  },
  {
    "email":"valeganadu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456303482/c5c2bd9abbfb793e1dce3dc24476ef93-1730301830"
  },
  {
    "email":"martydon@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456467322/9000c8cc8371f920093a9460a087b2a6-1730301831"
  },
  {
    "email":"stefania.vincenzi18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456500090/2862f0a4b03628b8e49f95ff3fe46ff6-1730301831"
  },
  {
    "email":"stefaniapiras12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456336250/98f5bf3d27e8f0d74a0bbb79fe5d1f88-1730301831"
  },
  {
    "email":"tania.scartabelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456532858/c6f902592ea5364f57c299d5821b3d09-1730301831"
  },
  {
    "email":"manunovati@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456565626/cd3da8316d6984ecd6e3d3c2c784b5bc-1730301831"
  },
  {
    "email":"antonellagarofalo67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456598394/25406c5e65372dcccda94bcedf62f724-1730301831"
  },
  {
    "email":"egidia83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456631162/6c174898e0fd728da2ec2d167d17e2ad-1730301831"
  },
  {
    "email":"infodonne@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456663930/be2f1cee41063e133a7ee09e67dc6577-1730301831"
  },
  {
    "email":"marina.celoria@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456729466/7a73da30c567d53c11943dd3c609b5a8-1730301831"
  },
  {
    "email":"saraghisellini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456762234/7148b4626ea28622b19a3f52e73e5c12-1730301831"
  },
  {
    "email":"guerrieropaolap@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456696698/cc32412372acaf3c114fcb7f51f73d95-1730301831"
  },
  {
    "email":"letizia.bianchini66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456795002/9e3bd50519d9f93720e869d8a2a0c9ed-1730301832"
  },
  {
    "email":"gabry.brau@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456893306/c12b0441621b3f3e6b6b5b19e7be0051-1730301832"
  },
  {
    "email":"barbara.rossino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456827770/b3f1af313869dc3d4d1d9b3ca59e10fb-1730301832"
  },
  {
    "email":"celeste.claudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456860538/68f5da2ea66c08fa2c1a4c0b141f57a7-1730301832"
  },
  {
    "email":"normanzalone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456926074/dd73ac5dd8eefdaca007edab5d59aa6a-1730301832"
  },
  {
    "email":"carmendelg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457024378/7dc2b886d49433619abf66b243770d84-1730301832"
  },
  {
    "email":"polverarifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723456958842/21fb068edff73c05cd84a05db250d299-1730301832"
  },
  {
    "email":"paolacerana67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457089914/d6c6a326653969cf84e6f6ded1bbd806-1730301832"
  },
  {
    "email":"distintesito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723456991610/73d87c0fdb8ddd77afde99a7fe4338f3-1730301832"
  },
  {
    "email":"giusy.distefano2013@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457155450/3aa0d7a417b805f04017273211a0c232-1730301833"
  },
  {
    "email":"monicacapecchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457188218/2ecb56821786672127100c36fca7c9c6-1730301833"
  },
  {
    "email":"enricaricciola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457253754/e9002d0d60a439fee5a4c57f9a52b99e-1730301833"
  },
  {
    "email":"eledasc@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457122682/82adfcfe91f9b818b66a40713fa5cfaa-1730301833"
  },
  {
    "email":"mariaffinita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457384826/c9c4fa4c3f361e15aeb06de2decbf174-1730301833"
  },
  {
    "email":"topchiara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457220986/b5b87ef6754fa179c8b95de454c612e4-1730301833"
  },
  {
    "email":"castoldiettore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457319290/250e73a3279222da24924f3b81e16326-1730301833"
  },
  {
    "email":"karimaforyou@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457450362/01807d039b74f4f2b8105d1382560d8c-1730301833"
  },
  {
    "email":"pamela.manenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457483130/d89eb3fadd2c3824410f0157e141ccf6-1730301833"
  },
  {
    "email":"nucciadanaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457417594/1e6be10dda323ca7c492207b2bc2fbbd-1730301834"
  },
  {
    "email":"monia.falini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457548666/e6a44e3a3a19201ac8b73b370c803ef5-1730301834"
  },
  {
    "email":"jappolloni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457679738/2cad77d344382a42dd26ff3bef392e07-1730301834"
  },
  {
    "email":"aladina7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457614202/c6dade63a547e18c05d1c07b3d4ce2f5-1730301834"
  },
  {
    "email":"patriarchi.emanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457778042/b9fdcba9a95d2a1f55f118a5d02b6a92-1730301834"
  },
  {
    "email":"frenci77f@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457712506/4d7c8a6010348d1beef09d1494dcd2c2-1730301834"
  },
  {
    "email":"marragiovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457810810/7dd0ec15d3e82b2d48f8258c93d6a03c-1730301834"
  },
  {
    "email":"patriziabozzola79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457843578/59971ffbef4ba652832d9428732c170e-1730301835"
  },
  {
    "email":"valenteangela73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457909114/cabd03722b104ed6c1a19950a0ea8d2d-1730301835"
  },
  {
    "email":"elvimezezi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457745274/85a2936854f6394feb5f5d73f76018b5-1730301835"
  },
  {
    "email":"caracris@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723457941882/fbe7e06f93a9a6b7141b5b353b7f801e-1730301837"
  },
  {
    "email":"gerlinisas@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458105722/e6dd4b3cddf96a8c6dc9abfa874960b0-1730301837"
  },
  {
    "email":"frdm@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458040186/ce12245560469988d8e0eb2528ac5e32-1730301837"
  },
  {
    "email":"mg.crescini@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458171258/7a62cb476896650725edb653772ed104-1730301837"
  },
  {
    "email":"jessica19861@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458138490/27a3bcdcbc2ded73bbce1e8f7ec6d1d9-1730301837"
  },
  {
    "email":"elelucaceci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723457974650/092f76812c85d5f314c27d34976d2c5e-1730301837"
  },
  {
    "email":"marina.giacalone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458204026/2c95b1ca43be40f16bbcd230e946862d-1730301837"
  },
  {
    "email":"giordana77@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458269562/0e2878b126530acd17a7c53cd1a5d7ab-1730301837"
  },
  {
    "email":"elviravona20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458236794/9de396012df87499d7be2f3f9650ed82-1730301838"
  },
  {
    "email":"michela.rossi@hitachirail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458302330/f6e976f5265709ccada0857efe6525fb-1730301838"
  },
  {
    "email":"alessandra.ghergia@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458400634/69b4770129024b48901b603e1451c0cf-1730301838"
  },
  {
    "email":"annangelici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458433402/9da3cee2a89bc10b539c099e7d88e697-1730301838"
  },
  {
    "email":"giusi.suraci@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458335098/edfde2073c0601340fcb36c9528073b9-1730301838"
  },
  {
    "email":"mariagiribaldi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458466170/453739313aa4647b67b241e5c842be43-1730301838"
  },
  {
    "email":"maristella.baldassar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458597242/3a73d862692463ce38a87202c62ed0ad-1730301838"
  },
  {
    "email":"rominagregorace@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458498938/adf9efa10d02686b6f34aae011d8b6e5-1730301838"
  },
  {
    "email":"alerollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458662778/fc6ca336899c3ee4ce3f0213ddebe0b6-1730301839"
  },
  {
    "email":"eufemia.pezzutto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458564474/0e69a2d56df911c3bfdb9142f4afc23f-1730301839"
  },
  {
    "email":"alixir78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458695546/ebb3c5108cdf2f94232d0a1bfaae49d3-1730301839"
  },
  {
    "email":"francesca.spinazzola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458630010/aef6ec6d79eb05e60453d13c7d6813b2-1730301839"
  },
  {
    "email":"andterzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458728314/c58bec95bbc24268d7edca8ba2775551-1730301839"
  },
  {
    "email":"fabiana_consorti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458892154/74ee6c85e8f2bc4769200c58df361a1e-1730301839"
  },
  {
    "email":"nicolemorresiadv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458924922/f00d1cefeff372932dc7f8297328905b-1730301839"
  },
  {
    "email":"roby.andy@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458957690/1d21e51d5186815c10ba4a31ad5b4eb3-1730301839"
  },
  {
    "email":"vivianadamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723458793850/aa6f67a60bd47e9740858d4d9fcc5e48-1730301839"
  },
  {
    "email":"maria@pubblicitaestampa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723458990458/34d0e6ec40a081376eefb71afa21c957-1730301839"
  },
  {
    "email":"tiziana.lison@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459088762/8ea2713eed6da0ced6e4dafdfb3d03f3-1730301839"
  },
  {
    "email":"carmen6767@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459121530/ef3174a07a1372f106884f324d5521c9-1730301840"
  },
  {
    "email":"fdilucca2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459055994/198cd6160d67fa3ce114c369e44711f0-1730301840"
  },
  {
    "email":"info@lacartotecnica.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459154298/12a6caaa92dc5cd6c20396208779e73d-1730301840"
  },
  {
    "email":"maria.antonietta.adamo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459219834/0aff22769ee5749dfc2571f7095de9cd-1730301840"
  },
  {
    "email":"martina.cavalli01@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459252602/8321df55598921e385515715a94fc012-1730301840"
  },
  {
    "email":"martagalbiati160184@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459187066/b7eec0623435fcb59956736de1eebf24-1730301840"
  },
  {
    "email":"chiara70@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459350906/ae048b4e84d394bcc414082d3dc1c890-1730301840"
  },
  {
    "email":"verdeania74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459416442/27f40da8c21bb09f765c8e6e98d530d3-1730301840"
  },
  {
    "email":"alessandracut@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459449210/31a4172d26f5ed196f2661102c67ece5-1730301840"
  },
  {
    "email":"ely1076@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459285370/06555795bef51fa0a3a99ba87d60748c-1730301840"
  },
  {
    "email":"simonamassoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459481978/7dcb76d2d5a3809ab075dc955f88e1d8-1730301841"
  },
  {
    "email":"torrisi75.at@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459514746/1da378eb37e98c11bcbbd286fa44b9fc-1730301841"
  },
  {
    "email":"social@profumeriapatrizia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459580282/6dd405d1f06fbc39d69f876f76452923-1730301841"
  },
  {
    "email":"zampatina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459547514/3c7fe93be204ecf5593c38db3c18173a-1730301841"
  },
  {
    "email":"patriziavecellio10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459645818/25cac3fb76d0e59dd81bdc1f2729fc3d-1730301841"
  },
  {
    "email":"enzacardio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459613050/73a00da238f77c098a83cd0c7f29613a-1730301841"
  },
  {
    "email":"biondifrancesca@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459678586/456472feab414254c560085f5f1ae03e-1730301841"
  },
  {
    "email":"garbillo.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459711354/21b037a04a04c4e0d60458b81b11da6a-1730301841"
  },
  {
    "email":"gabriella.valentinotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459776890/e7743a8c28bf6f6c2b59d8c64f6baa53-1730301841"
  },
  {
    "email":"marifata@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459842426/8e6193f8423e923bbc21e2d72e9b111a-1730301841"
  },
  {
    "email":"russostefania20@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459809658/dd41b7808d5d9a297a0902d8ab4e6aed-1730301841"
  },
  {
    "email":"fiorenzadav@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459940730/cf83ae355f5cc59ccdf8bc9d184ae7c2-1730301842"
  },
  {
    "email":"leonerosanna21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723459875194/759ce992bcf1652db7cd220e369edf35-1730301842"
  },
  {
    "email":"m.eg@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723459973498/5b3e5a57f1957dd10c558f6ee936ad22-1730301842"
  },
  {
    "email":"simona.visentini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460006266/6a5a03d43865d742f3237e0cf1e3820a-1730301842"
  },
  {
    "email":"info@pelletteriafly.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460071802/ab31dddec40e9b97d852428d6bba7923-1730301842"
  },
  {
    "email":"f.nigro85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460104570/a6eb7e0870b7eec5f335c055b2a8e8b4-1730301842"
  },
  {
    "email":"sabri.filosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460170106/b4f59faa775f799fdc90f2673b7dff75-1730301842"
  },
  {
    "email":"chiaracolombo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460039034/228bc05232d08264f1f56c9274ebbf9a-1730301842"
  },
  {
    "email":"fede.buttiglione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460301178/731e69d4963dda1d7b10913eab5dcf83-1730301842"
  },
  {
    "email":"mon.desimone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460333946/195560dfc8beda0c71b84097f34127ab-1730301842"
  },
  {
    "email":"delfiandraclaudia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460235642/ae967838e60d83dbc10b1491971d9c12-1730301842"
  },
  {
    "email":"elena.giana@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460366714/5656bb520968428c12765d7d74b7652a-1730301843"
  },
  {
    "email":"garby.ale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460399482/5e85316e5e3c612551f2e26c28e91890-1730301843"
  },
  {
    "email":"marco.spezzaferri@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460432250/6aed3fc8746a50dbd4816ba453306293-1730301843"
  },
  {
    "email":"m_cirocco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460268410/c758831cdc2ea64cdb806f7046edafd6-1730301843"
  },
  {
    "email":"bianca.savagnone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460563322/68c1d18a25620481fe074496f17ecdf0-1730301843"
  },
  {
    "email":"aleierse@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460465018/2637bc4ea0afa9c88933a7d7814bf532-1730301843"
  },
  {
    "email":"gunsen67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460530554/dc3b70ae94b852e1cad02540da305a6a-1730301843"
  },
  {
    "email":"ingridilie1997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460596090/c71c1a2f87bd64f5aa6eac36c7de9af5-1730301843"
  },
  {
    "email":"bacchi@agx.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460727162/4182fc243438b6db374504c759dd6d8a-1730301844"
  },
  {
    "email":"eli.manenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460628858/c87cb2172ff6eba955eb80432af0ded0-1730301844"
  },
  {
    "email":"arch.verga74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460661626/8ee6e3e6f80daff6a473573c464abda5-1730301844"
  },
  {
    "email":"giulia.lomi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460792698/54e3768f66ea27589494a7a96a120cc3-1730301844"
  },
  {
    "email":"dariastella.pv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460759930/448b34b606b0a64fcc553e6b1d382d2a-1730301844"
  },
  {
    "email":"massimo.natale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460858234/a5c4f8f224412ed9d9de62d1879ec7e9-1730301844"
  },
  {
    "email":"nestoladavide@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460694394/93549d24f1c9cf517ed5e2d38d77fa7f-1730301844"
  },
  {
    "email":"giudittagangemi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460891002/e10d86b346c6ae2e083b80715f709b53-1730301844"
  },
  {
    "email":"otticaripamonti.otticari@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460825466/a8fe6b052bc46ebd13ff821f638fa52d-1730301844"
  },
  {
    "email":"romina.rossetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460989306/f894c9c9bb12cd614ef970c46af1d25f-1730301845"
  },
  {
    "email":"aledfe77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461022074/d3b780e834c964c1f4912f56efe12cce-1730301845"
  },
  {
    "email":"annatassara1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723460923770/a8845828d494133ae13bedb0b5f5c6ff-1730301845"
  },
  {
    "email":"anna.surano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723460956538/98cd7c6f86ed36048237a1773edb4047-1730301845"
  },
  {
    "email":"vania.galaverna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461054842/7246f2b30d0d02e662534bbd877aa23f-1730301845"
  },
  {
    "email":"rosyzanibelli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461185914/d4f18807cf261e73b39698788e0651f1-1730301845"
  },
  {
    "email":"v.bombace@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461218682/a97c64d14ddad0622854cec532a918fa-1730301845"
  },
  {
    "email":"luciano.reibaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461087610/c69775d1329c5f1d87be43464c2aff23-1730301845"
  },
  {
    "email":"marikadepalma@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461153146/1e7906749742bc374503f558876007e6-1730301845"
  },
  {
    "email":"carmelita.previti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461316986/99ea5f6dbf5727cc26f73d19380c2d6b-1730301846"
  },
  {
    "email":"orizzonti135@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461284218/a8df0c4b398009b72d43eece74449f19-1730301846"
  },
  {
    "email":"milla63@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461382522/cbde664b382fb3d761d398f75579ffca-1730301846"
  },
  {
    "email":"alice197513@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461415290/e46e008694edfddc7b785e306cc02b8e-1730301846"
  },
  {
    "email":"giulialta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461349754/116668c656558b3a4455783bf2d37ae7-1730301846"
  },
  {
    "email":"enzatavaglione@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461448058/79b388607eaca2b78eb9a6ee701d24d4-1730301846"
  },
  {
    "email":"ale.liguori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461513594/895ee7124f877036b769ec4249dc3d6e-1730301846"
  },
  {
    "email":"gianlu.foschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461579130/d4527ea88224f7966052effc403285c1-1730301846"
  },
  {
    "email":"elenalu22@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461644666/f790ccfac0213c19cf1c99b35703cde3-1730301846"
  },
  {
    "email":"simonsimoncino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461677434/d4401a7019435b36296f391f3d39061d-1730301846"
  },
  {
    "email":"c.santarelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461742970/28d798bb7b0acd485c821f121d4b0585-1730301846"
  },
  {
    "email":"spery78.ss@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461775738/7fc3e533621abbff6431134a70125975-1730301846"
  },
  {
    "email":"scarato.agnese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461808506/fe2ceeeb26abfde9568166540235b9ba-1730301846"
  },
  {
    "email":"claudiamuggiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461874042/08260dd9be60955e027471b6d92da3f8-1730301847"
  },
  {
    "email":"c.bag@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462005114/eac6aa4c0ebe82721ec7a440905037ba-1730301847"
  },
  {
    "email":"claudia.dimarino16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723461939578/6b76525de463de105fff3170bb22d9e0-1730301847"
  },
  {
    "email":"alessandra_carozzi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723461906810/ef8b6cc15647a164d032334f5db14919-1730301847"
  },
  {
    "email":"nico.gorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462037882/8389ba77d3667b68966b306916aeeda3-1730301847"
  },
  {
    "email":"francescapastorino@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462070650/631afaeef4d8491ec081e891121c0c84-1730301847"
  },
  {
    "email":"marta.mischiatti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462103418/10b1b09c628f7636a6e5dd4d2e0bd9ea-1730301847"
  },
  {
    "email":"moriveronica9@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462201722/d80f8ac8b5b3d7a478c36f28eae64c85-1730301847"
  },
  {
    "email":"luciamusardo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462136186/0e47ece0e58b8e6c437176a76c9a2717-1730301847"
  },
  {
    "email":"loredanamariacupaioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462234490/c6de6ab505217eb688106082a3f5f1e5-1730301847"
  },
  {
    "email":"giovanna.manfroni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462168954/a8d6ee19fdfe3591e3e6ef2a4c1f58fd-1730301848"
  },
  {
    "email":"luatti.ileana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462332794/0b6bdf139929f2357e1a1179cc6dcf8a-1730301848"
  },
  {
    "email":"maraglinotiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462300026/f1851843f583cd9cea1a5139ff87184a-1730301848"
  },
  {
    "email":"didavitarellidida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462398330/2e6a768ca78cd07c06564f423999238d-1730301848"
  },
  {
    "email":"veronica.pazzaglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462431098/0ae5885ab9fa67509773b92ef441fa20-1730301848"
  },
  {
    "email":"miriambondesan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462365562/78175785c3b6571618d9dc22ba659c68-1730301848"
  },
  {
    "email":"romina.pidutti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462463866/eded9276d00e9a7b8cb4b50838fe42cc-1730301848"
  },
  {
    "email":"chiara@newsafil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462496634/60c574fe587c641a18135eed88e834d9-1730301848"
  },
  {
    "email":"cristinaborghetti11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462562170/90dde447622b5935eeb7c7dfcc6a6e72-1730301848"
  },
  {
    "email":"masciotii.agro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462594938/a5e455cfb5cda9967ab4233ffb07cb64-1730301849"
  },
  {
    "email":"lisalapucci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462660474/e2c1e455904345ccd70ae44ca87bac6d-1730301849"
  },
  {
    "email":"karolina.baranowska@stud.unifi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462529402/f2020cb7d47484aaf94fd63ebe9845d0-1730301849"
  },
  {
    "email":"piovanmarika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462627706/98f067cafc22b4db3895db7ca0f080c9-1730301849"
  },
  {
    "email":"olivia1978@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723462726010/420a955ec0cd35927ff3feea1060e757-1730301851"
  },
  {
    "email":"sabrinamartini79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462791546/e7d95964f6a1445f1ab4904ed9723bf8-1730301851"
  },
  {
    "email":"placidacostantino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462693242/8e4cfa8b189ae665f2e761fcf427d24d-1730301851"
  },
  {
    "email":"maja.rancanov@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462758778/deca56752ac79cf9e6880124bae6520e-1730301851"
  },
  {
    "email":"pasamantha1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462889850/16cd60c966497bcb8c241f7055145445-1730301851"
  },
  {
    "email":"saraceleste77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462988154/58322501dc5609e1a08bb0863b9c233f-1730301851"
  },
  {
    "email":"francesca.bruzz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462955386/e1a3c52f38111149983863cb3bd3d62c-1730301851"
  },
  {
    "email":"commerciale@ci-effe.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463053690/1a071d8b37328e2a168d11547ec5dca1-1730301851"
  },
  {
    "email":"cribon03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723462824314/f1ba36ce61759b6a8f42badd8d0da5c7-1730301851"
  },
  {
    "email":"pinna.fede@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463020922/2e67fdb5fccc8bc7be64ae4710391c85-1730301851"
  },
  {
    "email":"amajor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463086458/2b94fe6249a824429f9baa11129f60c2-1730301851"
  },
  {
    "email":"paolac71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463119226/d51bb0a932e5d7f5b0aceb78b94468cd-1730301852"
  },
  {
    "email":"tartayunior@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463151994/7deff96530f4ef54f01ea013075c4063-1730301852"
  },
  {
    "email":"pasqualeprocino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463217530/5208eabb9695dacb7669631125b5ee03-1730301852"
  },
  {
    "email":"eleonora.falu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463381370/0537ab10046e8e82aec41dd92ebed3e4-1730301852"
  },
  {
    "email":"anitamastrullo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463283066/ae53f1898361622968bbd13a8f642be8-1730301852"
  },
  {
    "email":"raffaello.lamura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463446906/e0056655e84cdba7c703e73635d148ea-1730301852"
  },
  {
    "email":"elisalazzarin79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463315834/d789b2f463f682fa0e2669d79508967b-1730301852"
  },
  {
    "email":"vittoria.surace74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463414138/f0ebb6783fc87a20b90b6dd19098673a-1730301852"
  },
  {
    "email":"pamela.vetreriacalasso@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463545210/3b8ea41e373c0fa2ccd84011a85364c8-1730301853"
  },
  {
    "email":"filomenatalento@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463512442/72ea7e90114a309e93cae733e2445d1b-1730301853"
  },
  {
    "email":"maddalenamyoko@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463610746/bb3a81914789361662b359b62e376521-1730301853"
  },
  {
    "email":"tiziana-isaia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463643514/348928064f9f29623fbd6c937b9f6ff3-1730301853"
  },
  {
    "email":"tempo.claudio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463676282/96e4ade5e386fb597f82bc96303cdfe4-1730301853"
  },
  {
    "email":"pappy73@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463709050/32e7df842330818f3c97fdca27a481f5-1730301853"
  },
  {
    "email":"manuelalongo81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463577978/e1efeaefc158cbeb51a3a7de29b23cc2-1730301853"
  },
  {
    "email":"fedelia9801@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463741818/84f86f4fb41b31d88b32c321d5b93125-1730301853"
  },
  {
    "email":"rocsanda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463840122/a53d661e0db82a27ee85deb97821c586-1730301853"
  },
  {
    "email":"grace.z@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463774586/56b07f460b98ec6c294e3167c18ca2e7-1730301854"
  },
  {
    "email":"annamele.am@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463872890/0f02188dea9ed0e72263eec6ee32e74d-1730301854"
  },
  {
    "email":"dory_milano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463807354/475a7a50a5204dada3afdc5e71a9320b-1730301854"
  },
  {
    "email":"mikela989@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723463905658/12e7c84c0b051bab12fb0ac19b114e0f-1730301854"
  },
  {
    "email":"rosa.car@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463938426/394cb513b8236077576c092fbd3fb26a-1730301854"
  },
  {
    "email":"f.polidori@poligrafsrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464069498/3e76eaa4b6e169012c1eb8249d6347a0-1730301854"
  },
  {
    "email":"elisabetta@olivieroimmobiliare.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464036730/598bf95084760678bfdb696b6d7bfd27-1730301854"
  },
  {
    "email":"parisicarmela@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464102266/bfaa82ab985b97a8f12fb51e5e86c6e9-1730301854"
  },
  {
    "email":"edipeg60@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723463971194/140bc677befe08fce42c3fcee2be90aa-1730301854"
  },
  {
    "email":"marigaigher@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464135034/9fd615acf563b4ea98d039d8d5e465f2-1730301855"
  },
  {
    "email":"pdurin@detas.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464200570/a72b4b25945f07ae3235737c52356adb-1730301855"
  },
  {
    "email":"antonellocandelieri@pec.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464233338/7135987a4d108cac7c89686ae30b65be-1730301855"
  },
  {
    "email":"alessandra.zanetti1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464364410/396d6851560ae570bd3840bbc45477e3-1730301855"
  },
  {
    "email":"melettadl@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464167802/2c3fa6e69ba6d59fa42aab559bb4de10-1730301855"
  },
  {
    "email":"ele.zoc00@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464429946/085410632714b9e94afd7a23e8bb3402-1730301855"
  },
  {
    "email":"prue2007@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464298874/c6012829cfe522441e42911179dbce16-1730301855"
  },
  {
    "email":"claudia.perugini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464528250/b76d8a86e04bd42b111d4440196f9b51-1730301855"
  },
  {
    "email":"patlaruccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464561018/dbf2d6eefbf0fefeda1f7c4c8a9235fa-1730301855"
  },
  {
    "email":"frasil7081@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464462714/4c6603aa2c384b0039357f9840fd1a72-1730301855"
  },
  {
    "email":"bolacri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464659322/8da9b36908caa1ecfee6c46c19241700-1730301856"
  },
  {
    "email":"sololinda82@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464626554/97f097fec6b19c196d605397b2e02a53-1730301856"
  },
  {
    "email":"anna_salerno@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464495482/0c534d7aafb7f7f8cd3c604693b6cf53-1730301856"
  },
  {
    "email":"laura.mazzola.dott@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464692090/94660bbaaeb5bb9f2efd1fe9da596c53-1730301856"
  },
  {
    "email":"mencarellimariaantonietta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464724858/e6a4fc1b7bd7e5cb0366462f06bda5f1-1730301856"
  },
  {
    "email":"federica.bergo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464790394/987133888e1b2f86405c4af42d9b903c-1730301856"
  },
  {
    "email":"danielepenzo1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464855930/8016e1f7cbd68a34b5c1a7de4b7b331e-1730301856"
  },
  {
    "email":"nunziapappalardo@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464888698/4ac3577ff9158303d067d620fcea7a7a-1730301856"
  },
  {
    "email":"hollypo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464593786/22ab7d81bc50e1a5d827e404e602998a-1730301856"
  },
  {
    "email":"mariantonietta.guacci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723464921466/f38e90932cc9308995e8f441413474ee-1730301857"
  },
  {
    "email":"monicaraeli79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464987002/7f23fc235fa8ed80fd511a5d77b8e8f3-1730301857"
  },
  {
    "email":"alessandra.accorsi19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465019770/42df69edfbfff6628b860e5e609c3a50-1730301857"
  },
  {
    "email":"rosannasolinas@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465118074/8c204e465ff97400368d5a599cc05ae4-1730301857"
  },
  {
    "email":"clasich@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465150842/3354b67bf5adbbb9947e9ec3aa7055aa-1730301857"
  },
  {
    "email":"gianoglio.giorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465052538/bcb596d5e4800f6520f9ff5900ae5f22-1730301857"
  },
  {
    "email":"garbiletizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723464954234/593852eedc98ab96e45c79541c359f0f-1730301857"
  },
  {
    "email":"tartisa2470@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465281914/3afc80243243e0e2aadafdc97319c208-1730301857"
  },
  {
    "email":"chiara.19@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465314682/710fb2a8f502b0ef30cc1d076846c411-1730301857"
  },
  {
    "email":"vanessa0277@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465249146/babdaf3fe3b49f92da02a13279f06ff5-1730301858"
  },
  {
    "email":"silvana.marras1965@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465183610/b96a703a54bf29221d829b89921610d5-1730301858"
  },
  {
    "email":"pat.iacovacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465347450/d86d58b782584268d1cbfe136ce4acef-1730301858"
  },
  {
    "email":"annamaria.cassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465445754/4e802b2ca37468d5b2f8c4ff92b9ed18-1730301858"
  },
  {
    "email":"v.gallio74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465412986/a553b6d881cdf0cb0752500088023b5b-1730301858"
  },
  {
    "email":"annanyky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465380218/d7a9b65ce6cb4279eb9d0bcaa6d5b1a6-1730301858"
  },
  {
    "email":"titopia70@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465544058/ec9263c5de20ff8be0c42069a2b6ffbc-1730301858"
  },
  {
    "email":"deliamaderna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465511290/3237cf2af22cc9fd916d5f73d4a649fb-1730301858"
  },
  {
    "email":"alle.poggi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465478522/2ab0f591ec6d620722f89d0f36e230f5-1730301858"
  },
  {
    "email":"rosa.rantucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465675130/eeb721c7ecc6c55eb13b1e89dc66a41d-1730301858"
  },
  {
    "email":"francescagerace73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465609594/fdbbff6844819689d990f25227b2d484-1730301858"
  },
  {
    "email":"fabiola-mancini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465576826/9c1bfd46d13402252b9d7cf067c2072a-1730301859"
  },
  {
    "email":"vecchi_valeria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465740666/239dd15569734655bc637e06062f8715-1730301859"
  },
  {
    "email":"simona.perna74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465707898/9be12ceef146bb251995f251b6f1dd1d-1730301859"
  },
  {
    "email":"chiarapenzo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465773434/126d96b166383771c23898694ef00fd2-1730301859"
  },
  {
    "email":"fede.mafucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465806202/b487e97e6d8d93d73b91cc2f231de7fe-1730301859"
  },
  {
    "email":"manuela.pattaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465904506/9979cd506afb0ee0d14654a3eb50cfac-1730301859"
  },
  {
    "email":"avv.chiararossi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465838970/48e537842005f47afd914adf27e6772b-1730301859"
  },
  {
    "email":"anna_quinto@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723465970042/c81b736f496d6a3033deccc0ef3bd13d-1730301859"
  },
  {
    "email":"caplela@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723465937274/c37738061913e73bc7125014880ce6b2-1730301859"
  },
  {
    "email":"veronica3004@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466002810/97e22393d6153e4d055fedb3a92f76e7-1730301859"
  },
  {
    "email":"carlilisa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466068346/af8d3b719a66ca92c1937dec17cbad3e-1730301859"
  },
  {
    "email":"vale.porro@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466101114/7c819d9acb81b8a5d0488c86dc543d50-1730301860"
  },
  {
    "email":"stefaniapomona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466133882/eb088abfc10507df32397f6561ff5949-1730301860"
  },
  {
    "email":"mariannaparazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466199418/0d31d275626b2653700381264d5a1072-1730301860"
  },
  {
    "email":"eri.faccioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466166650/e295ee9098a8e7082bcb9a6d15f6bd24-1730301860"
  },
  {
    "email":"michi.emme77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466297722/61b96c6a9af9bdb341757f6c6cb66189-1730301860"
  },
  {
    "email":"annalisacutolo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466264954/aba5b3e6896cb2a406caf378093f09dc-1730301860"
  },
  {
    "email":"valentina.crescenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466232186/477c436ad18fdcbb3e88abea7e5e5f03-1730301860"
  },
  {
    "email":"raffaellabarbato@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466428794/ad1b307011cc1716a426b0c9213db348-1730301861"
  },
  {
    "email":"claudiamenichelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466396026/99cd48bf2b3a3bf442e3fe1c854d9418-1730301861"
  },
  {
    "email":"fannype@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466330490/22fd67a7f2eb4fb0128c0ddefe0c4696-1730301861"
  },
  {
    "email":"fediba@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466363258/b58b904129558ca9bc50280f41b0a5cf-1730301861"
  },
  {
    "email":"laurabili69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466494330/2cf5b2ac452415bee412b2c6cc928be6-1730301861"
  },
  {
    "email":"deniszuccato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466527098/7c045203a042341a35f8864d5a0915bd-1730301861"
  },
  {
    "email":"lauragaldi@studiogaldi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466461562/052dc40a68dc541064990d4b4ee7e3b9-1730301861"
  },
  {
    "email":"sf1961@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466658170/8ac27253c3a5c09879f26df1a069f779-1730301861"
  },
  {
    "email":"annachiodi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466690938/46c171f0b4c8d6ca46996d9829a99b91-1730301862"
  },
  {
    "email":"silvia@corsovittorio.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466592634/2f82a71c9d0106fcf07a1626fab79d02-1730301862"
  },
  {
    "email":"cinziaerti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466723706/a436502309c27d9395ff6f807a0a02d3-1730301862"
  },
  {
    "email":"romi.mac72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466789242/98d953ec35a2e135aef88ac7e5fd0845-1730301862"
  },
  {
    "email":"leluci2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466953082/3131492c9354390522e53e474a5352bd-1730301862"
  },
  {
    "email":"danielavassallo2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466756474/b7c18c04533b555dd1fdeefb8389c9b7-1730301862"
  },
  {
    "email":"mcrubagotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723466887546/ccbc5a5641ef7c418ea30bac26828e50-1730301862"
  },
  {
    "email":"fede.giud@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723466854778/62c8267d98c2243b77a8dd3044736ed5-1730301862"
  },
  {
    "email":"tcomoretto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467149690/3783dde776558ac97cde76ed34f7dacf-1730301863"
  },
  {
    "email":"patrizia.frigeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467051386/c6228a54043193844395f7bba7d7872c-1730301863"
  },
  {
    "email":"gabriella.torre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467182458/42fb9a3dfedd9122f871d2a27b0c7e15-1730301863"
  },
  {
    "email":"laralindacelant@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467084154/1e5e510776026c923a2aa408f4ab567d-1730301863"
  },
  {
    "email":"paola@amandola.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467247994/6298fd97b60d70735812ef7120df0d5c-1730301863"
  },
  {
    "email":"mtommaso09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467313530/bcc265c6e92e9d49f1aa3a4566be104e-1730301863"
  },
  {
    "email":"giuligra@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467379066/7cfd2a5396636e22d0aba32a6f1a4628-1730301863"
  },
  {
    "email":"filo.macchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467280762/0bd683aa7c6765580ce051a90b0a682d-1730301863"
  },
  {
    "email":"kaira73@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467411834/5d20e91077c797c9bab6c323ea186407-1730301863"
  },
  {
    "email":"ireross@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467444602/c7dbbe9ffb1097c85ce03640fa9a5059-1730301863"
  },
  {
    "email":"eleinverni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467477370/eaa7ec225f37f38e54c7562afd99cc6c-1730301864"
  },
  {
    "email":"cinziat72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467542906/425226ebc9b837709e0322c2ed4754a8-1730301864"
  },
  {
    "email":"terdeligio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467510138/7fcab85c818d54566db8ce54b62741a1-1730301864"
  },
  {
    "email":"paolo.trucchi.xew6@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467673978/8533d0b60d83333772042d01f6efe350-1730301866"
  },
  {
    "email":"vale.moncini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467575674/15d00aef971b403a96e32b1bc750f6b3-1730301866"
  },
  {
    "email":"michiedo2812@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467608442/16fad0f8d0eef6b5ed1e3c8a6b3c0edf-1730301866"
  },
  {
    "email":"sarahbernardini79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467706746/f1ec9c05d4841173227538de65c9d022-1730301866"
  },
  {
    "email":"elemit@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467739514/d5772a2ed68266c189c9d13efbd5a181-1730301866"
  },
  {
    "email":"luca.roberti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467805050/fb5cfaf68587ca23b7f1ec2904b0198b-1730301866"
  },
  {
    "email":"claudialini@fedabo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467870586/ebd417956e3650d3bcfd8a4b7ed40e4d-1730301866"
  },
  {
    "email":"monica.geranzani@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467641210/ddb08fc6e4a5089f651cb1b04d972f78-1730301866"
  },
  {
    "email":"marchi.pepe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467903354/dc3b4e5e8e3cfe1a9d4ddd306464afce-1730301866"
  },
  {
    "email":"gioiaseveri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723467936122/dba7e80e5eaa9feacf73ad42f002e179-1730301867"
  },
  {
    "email":"laura.belardinelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723467968890/23a1db74d7d58b6ff4b6189dd7258858-1730301867"
  },
  {
    "email":"soniasalvestrini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468001658/0584e2d899c3b7baeba1cad052a83930-1730301867"
  },
  {
    "email":"lauramasiero81@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468067194/8aff674f930a231487ff7c12122d756e-1730301867"
  },
  {
    "email":"ari_dallafontana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468165498/8fcdb461fc0e7e9ab5f7bfd223d81820-1730301867"
  },
  {
    "email":"lauradegrandi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468198266/e244cada3e985fd0eb3951f17e9853bd-1730301867"
  },
  {
    "email":"alessandra.berardo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468034426/10d5f23a7e205373eb7b9e6387a0130b-1730301867"
  },
  {
    "email":"stellachiaray@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468231034/19157355d46896723c4951c6f43aeeef-1730301867"
  },
  {
    "email":"lorifrancinella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468263802/7c5e88dd2eb6732c003b068d8d7a7265-1730301867"
  },
  {
    "email":"luciacalello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468296570/5705b22596d03180dae664234dac08da-1730301867"
  },
  {
    "email":"giusfarini@gmil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468099962/4cd104878d767c055817383ddd71133a-1730301867"
  },
  {
    "email":"claudia.galigani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468329338/7834b26a60c5e6449a9043a18d0c64a8-1730301868"
  },
  {
    "email":"martinabeato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468362106/324b730359e0a4b7092002a92a32335e-1730301868"
  },
  {
    "email":"b3ll4_@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468394874/cb439bbe85467f3716c556f798199db8-1730301868"
  },
  {
    "email":"ferrini.benedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468525946/3ff480d7f3bdbc06df4427b91d6c556a-1730301868"
  },
  {
    "email":"ilaria.zucconi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468493178/ff8587abe84a96e08eb325bc71b5937c-1730301868"
  },
  {
    "email":"robertabarcella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468427642/df302910fc19d96b238c3e8b5edec449-1730301868"
  },
  {
    "email":"s.g.casa@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468558714/192bb342921e3e71b4aba76f5d12e9d4-1730301868"
  },
  {
    "email":"simona.saccardi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468591482/63b7bae6ccba77a49139bd41aa39b451-1730301868"
  },
  {
    "email":"mariatesta42@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468460410/9c351143eaaee84d0f1523793bba941b-1730301868"
  },
  {
    "email":"dorinaremiz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468624250/9b31a8ae6b7f4777a898180fcfe7fe59-1730301869"
  },
  {
    "email":"angelamariarubuano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468722554/7d9b4ebecacb72fffdaa8a8ab3421602-1730301869"
  },
  {
    "email":"francy2222@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468755322/00ce08331418954ae835090476bb9c28-1730301869"
  },
  {
    "email":"federica160379@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468657018/fb245ec9e127c2b1f649406fd9235177-1730301869"
  },
  {
    "email":"lovlinda14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468820858/cc09d4090f0dcb9319623f6c10ae28bf-1730301869"
  },
  {
    "email":"chernova.irina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468788090/0512271fbbfb41676cacf0f00aac7cac-1730301869"
  },
  {
    "email":"elisabettascopigno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468689786/a9ba013eac4abfff78e6124998e24d10-1730301869"
  },
  {
    "email":"tonydemu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468853626/2a053490da6ffd9493f3e4cd36f04690-1730301869"
  },
  {
    "email":"maradisabato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723468919162/3a6dad37bf9a58df8493f80d802b2471-1730301869"
  },
  {
    "email":"l.lucidi@lucidistudio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468886394/0d57fff6417aa4b745c2085af1f2523c-1730301870"
  },
  {
    "email":"verarosso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468951930/b35d0663d4fe2a8726e011de63896b95-1730301870"
  },
  {
    "email":"siro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723468984698/ba5ec070a3b3a9d06b65c8cecc708cee-1730301870"
  },
  {
    "email":"marialistro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469017466/ae600b4464dbf12f8deab2cdd63254df-1730301870"
  },
  {
    "email":"elisa.bresolin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469148538/b0411ee43cac3acac234932378d3952c-1730301870"
  },
  {
    "email":"mariangelamassa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469115770/26adf52c566aa4c423f05364de9f5e74-1730301870"
  },
  {
    "email":"sarrighi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469214074/54391d0153f676ec5ff717a9f0759275-1730301870"
  },
  {
    "email":"lazzaroelena78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469246842/cc37d1073eae928749aefa88a4fcfdd0-1730301870"
  },
  {
    "email":"marcella.turco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469279610/a7c8d0798cebb9d0b8480164027a2f52-1730301870"
  },
  {
    "email":"micheromi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469377914/ae1919c327406f9d0d6ecf3e98346bbb-1730301870"
  },
  {
    "email":"simo.luppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469312378/df06e284f83b7f0ce0b44aa5d13ce40e-1730301870"
  },
  {
    "email":"arturorizza75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469410682/542ec5f11bf8bd182b42a212b6a748fa-1730301871"
  },
  {
    "email":"sariglitter@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469345146/1ec869d2afa6f801d571614eff197db4-1730301871"
  },
  {
    "email":"laura84.a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469443450/3223bbe19670b2c29b6f6408821c7542-1730301871"
  },
  {
    "email":"tonia81@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469541754/e5f0044cdb810d360d7f77a65d34bbab-1730301871"
  },
  {
    "email":"silservadei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469574522/7a33c7a572cb5fb94a3b268e2ad9d65c-1730301871"
  },
  {
    "email":"contemilly76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469508986/a0611ce5ee85be06bd4cad9226afcb5c-1730301871"
  },
  {
    "email":"dcasillo6969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469607290/fbffa44aab807c3c83b4a05dd14e03c9-1730301871"
  },
  {
    "email":"info@fioreriacarantoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469672826/50caa0cae26b26d0332a8c6612358cdc-1730301871"
  },
  {
    "email":"ale.mammarella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469640058/8eeea86b1ad2317c4012b22d3a4019e8-1730301871"
  },
  {
    "email":"erminiaconvertini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469738362/1d84cf9734f03872fff6bdad99110ed3-1730301872"
  },
  {
    "email":"daninardella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469705594/fc1c891d9044c392a4508b81da06336b-1730301872"
  },
  {
    "email":"minorentilucia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469869434/63de9e5ade786759657a6c787dc383bc-1730301872"
  },
  {
    "email":"elisa.ghezzi@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723469934970/eb4fbb3bd2f4b56922c155dffe9bdb03-1730301872"
  },
  {
    "email":"ffulceri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469803898/ca16ec8a2e1b9fdb86fa69dfb7df8d35-1730301872"
  },
  {
    "email":"altea.mf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723469771130/380bf0f385fe3ef464f1e694b54f1b28-1730301872"
  },
  {
    "email":"giulia.biasin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470000506/ef20cc5c6e37dfdfb042665c7f29c803-1730301872"
  },
  {
    "email":"manu.luongo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470066042/fe4ca7aeb9074850b7c11854a5136846-1730301872"
  },
  {
    "email":"giuliafilippi8778@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470098810/b789223111e971ef714759adc0f2b915-1730301873"
  },
  {
    "email":"yuliahamar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470131578/024e1ef4fde8e429cc67e916ac901f6a-1730301873"
  },
  {
    "email":"giumi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470164346/7998e576412548919f709360f1f52ebd-1730301873"
  },
  {
    "email":"valemax11@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470033274/4e88f3df397d8161354b12715ab1bb6b-1730301873"
  },
  {
    "email":"caterinalov77@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470197114/a7ad3a474a8810880948820a9b91d804-1730301873"
  },
  {
    "email":"bigonifrancesca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470295418/80308520d15b5a18b52906d2051b6834-1730301873"
  },
  {
    "email":"manuelabruschi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470360954/63d5d85c20d40f2f00fc8059e29bbcfa-1730301873"
  },
  {
    "email":"bp.pontoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470262650/d2816764bd767be30faa8ea2a7d4208f-1730301874"
  },
  {
    "email":"antoniosabatini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470459258/9cd7dc9513eb31fff803e0386150a90e-1730301874"
  },
  {
    "email":"mattyto1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470229882/2c042f18bc90ab1e741454b74d8234cb-1730301874"
  },
  {
    "email":"c.burgio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470557562/9fd15ee2fbb7805c9b6c5318c98a66ba-1730301874"
  },
  {
    "email":"benedettaborgianni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470590330/366ca752467e8cdea362f9e3c9027cb9-1730301874"
  },
  {
    "email":"sabrina.p@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470492026/f4250ff110b46dda257bc547099ea9d1-1730301874"
  },
  {
    "email":"marianna.rando@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470655866/6d4fbb2a70854b20b833105e2ae2e63b-1730301874"
  },
  {
    "email":"saralusini78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470623098/e94fc95513610bc3d061072699fa3184-1730301874"
  },
  {
    "email":"lombardi_elena@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470524794/8e121b6d90105571a736bc5ff861ca09-1730301874"
  },
  {
    "email":"cristina.marini.31@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470754170/454e3fdac755521a8d83db931749fbdc-1730301874"
  },
  {
    "email":"fiorellamenozzi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470721402/b62e0e34206e2b0cb5c4a737204e2bdd-1730301874"
  },
  {
    "email":"federicagiusti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470852474/03ae689577c8dccf70b2484fac61fcce-1730301875"
  },
  {
    "email":"ele.turrisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470688634/99aba3172e840bcfb07659b18349e749-1730301875"
  },
  {
    "email":"fabbri.giulia01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470786938/21ebd81ab80d175786c7c80a5a5815a9-1730301875"
  },
  {
    "email":"agibrignetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470819706/fbde46180e40ec2f387b9f119ae41fd7-1730301875"
  },
  {
    "email":"rcapizzi80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470983546/fafe796bc7461a4a1c883d2183cd25a8-1730301875"
  },
  {
    "email":"silvialugli80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470885242/35fa181b841baacdd251a1472a0c2373-1730301875"
  },
  {
    "email":"studiodecorsrl@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723470918010/0af1ffe5b2dd37101baab4eee962876d-1730301875"
  },
  {
    "email":"paduano.melania@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471049082/b191f6340a8277460e067f7e9e15dd6f-1730301875"
  },
  {
    "email":"alessandrarizzo73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723470950778/9e228a585b3aa744e7f121f24688807f-1730301875"
  },
  {
    "email":"perpi85@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471016314/f7a99b3b47fefc203d73e6336ff25e8b-1730301876"
  },
  {
    "email":"katiamurdaca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471147386/bbfad0076e127f24cd598c389e4d8240-1730301876"
  },
  {
    "email":"annabonifacio66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471212922/b320fd8dbd2e6dbc29be90b09944b566-1730301876"
  },
  {
    "email":"nicoletta.paganelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471245690/2cfe975bc0e25886f1caeca1bb6d6e8c-1730301876"
  },
  {
    "email":"rominadifrancesco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471278458/81452a7398287db4d67913b7a3e7a0df-1730301876"
  },
  {
    "email":"salvatricelicata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471081850/cb81cce4a7e4cddb6eaad05221d4c529-1730301876"
  },
  {
    "email":"protanigiuliana@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471311226/d0c4992021d1f6d32f167a9730f99000-1730301876"
  },
  {
    "email":"silviavalbo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471114618/1026f4766d1600ca64f7c003674f468c-1730301877"
  },
  {
    "email":"ayse.eryorulmaz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471343994/42ef249e296724d803f65df68daafeaa-1730301877"
  },
  {
    "email":"giadacallegari04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471409530/13d61ae7633882553779f42ac4e9e30a-1730301877"
  },
  {
    "email":"cassonalice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471376762/b9489d3bc06482c3c6f321fee24281f3-1730301877"
  },
  {
    "email":"anna.hary@filaturaditrivero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471475066/f27b5ffcbcca4a133a7b3d496996d754-1730301877"
  },
  {
    "email":"francycoppa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471540602/71b4b8df0cf25fca65af9c405e5e01ce-1730301877"
  },
  {
    "email":"emanuela.carboni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471606138/de11a8bdbf33af57dea010853320c873-1730301877"
  },
  {
    "email":"barbara.vallieri@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471573370/3276994e4f9d7fa35edf9728f4b19af2-1730301877"
  },
  {
    "email":"vannozzid@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471671674/59407a2c04bb3095b42409ed1804d1f8-1730301877"
  },
  {
    "email":"cristina_zuliani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471704442/7d205be314609eeb87969bf8a2960ac0-1730301877"
  },
  {
    "email":"buffiorni60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471769978/fc4761e8b5f54cad91a8c7f789800703-1730301877"
  },
  {
    "email":"brunellafanucchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471868282/7eeea4086750b1b14cdb7340b8dbb12f-1730301878"
  },
  {
    "email":"pioli.d@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471638906/fae146144a8660fe6ddce64a62f5b8b7-1730301878"
  },
  {
    "email":"elenabusinaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471802746/1daab914f6f2fe6b600db3fa95fa5528-1730301878"
  },
  {
    "email":"francescaromana.cevolani@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723471901050/e31a851c255c25ea63ed0c73ba5cd1ab-1730301878"
  },
  {
    "email":"camilla.cristalli3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472195962/4573f0f7497b204f3c3aa90cabd681a0-1730301878"
  },
  {
    "email":"francescafornai00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471999354/39c4db414bec39ed42593f56f48417ec-1730301878"
  },
  {
    "email":"marymuscioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723471933818/d40240697ba2392e989fa08ebc2224f9-1730301878"
  },
  {
    "email":"cinzia.pascarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472163194/876a4496a999af7d83834bf5bf7f89ed-1730301878"
  },
  {
    "email":"peruffo.laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472294266/e14fe03703cb10495acda14b7fb6e856-1730301878"
  },
  {
    "email":"marika.chini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472228730/0c1be8ac9fdb8d89e16f77146a236d90-1730301878"
  },
  {
    "email":"etleva.pashaj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472359802/b37fce3d4128293a9a056e07e580b41d-1730301878"
  },
  {
    "email":"elviathan@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472523642/9b3d67573c4d5ed81ae35fcdf833c3d8-1730301880"
  },
  {
    "email":"valentinapettenati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472621946/5e199cfe7cf43201efba428a57ca4167-1730301880"
  },
  {
    "email":"marica.treccani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472556410/fb94e55598f43086954f1df350e6ce07-1730301880"
  },
  {
    "email":"paolasignaroldi-info@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472490874/60c329963645119111c5b124881cde8a-1730301880"
  },
  {
    "email":"barbara.poggi@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472654714/2d67586a7e41b66c49d7a57472454567-1730301880"
  },
  {
    "email":"fabiomattioli67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472720250/fdb2907ffec879442fa7e63fff948700-1730301880"
  },
  {
    "email":"frank_ebay@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472785786/1a69f71bc298106c2d6c66d5eee029c5-1730301881"
  },
  {
    "email":"paolettaiello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472753018/e92533cabb75e791695f6cf43800ecb0-1730301881"
  },
  {
    "email":"leonzilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472851322/68453b49f75e6988d4961498574401bf-1730301881"
  },
  {
    "email":"gabriella.delpidio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472818554/b83bdd8f618c949b5cb23d458780b675-1730301881"
  },
  {
    "email":"c.iovine@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723472884090/16648575a5ef9029ffbecf693d19c849-1730301881"
  },
  {
    "email":"francesca_codagl@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472916858/8cd10081ddb7388a9ccf92408443206b-1730301881"
  },
  {
    "email":"giusyolivo2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723472982394/332c1a697e976028364766bef3213789-1730301881"
  },
  {
    "email":"sconfalonieri8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473015162/2b262559c171550f29f44ba4298e4661-1730301881"
  },
  {
    "email":"kla24klasun@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473080698/50f928726848c1f56879fcdefcb7bb38-1730301881"
  },
  {
    "email":"alenardello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473113466/01bd4f2a26aaf1a818cfc105a8e06d97-1730301881"
  },
  {
    "email":"robertalovino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473047930/5843f5aca5ac860ee031370032f09510-1730301881"
  },
  {
    "email":"rossella.polce@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473146234/94b37caff335d850907a62fce08be1c8-1730301881"
  },
  {
    "email":"paola_gabrielli59@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473179002/b6159ddbe708b982435c35e3a3959274-1730301882"
  },
  {
    "email":"paolabotterofabien@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473277306/bd21a7ecfb78bd9ff57e1285812cd85a-1730301882"
  },
  {
    "email":"alessialbani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473310074/a1463159867e150f70f0912177d380c0-1730301882"
  },
  {
    "email":"michela.baravelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473211770/2b910e466a3245f3df8eb098deb88111-1730301882"
  },
  {
    "email":"francescadenuptiis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473342842/a010cc2810a5ebc677b82f0ef1381a11-1730301882"
  },
  {
    "email":"ccostarov@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473408378/fc1c1f9d9c317064cf482ac7a96af5fd-1730301882"
  },
  {
    "email":"gianni.zintu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473375610/fa8679491a62099032eed44662c02c6e-1730301882"
  },
  {
    "email":"ianesrita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473441146/0e1cd5c83cc119bda9fee6ab97f44f33-1730301882"
  },
  {
    "email":"ela.1964@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473473914/2b73a8447ad6a770f834f9dea6cf6b83-1730301882"
  },
  {
    "email":"robertatrinelli71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473506682/f2728ace5980684a86f81630f688db32-1730301882"
  },
  {
    "email":"mauri72pisa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473539450/37a82c0b148b84bfd41bde45cfcd92ef-1730301882"
  },
  {
    "email":"anto.tucci16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473604986/7b5933009307fdc8bd50bb8f287f5dd9-1730301882"
  },
  {
    "email":"ivanabonfigliomessina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473572218/5513433888d68da7e9e1e1d53b3bfea9-1730301882"
  },
  {
    "email":"martiz.2003@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473637754/e54fbf57b557746f35fc1ef336fc9a6f-1730301883"
  },
  {
    "email":"lancionifrancesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473703290/14a75e8743e623f11c966cac1c0cd139-1730301883"
  },
  {
    "email":"carla.colucci76@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473736058/53ace9e95c3de36a51564fc3321ca049-1730301883"
  },
  {
    "email":"ramona.gianluca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473768826/fc5ef621c8f67fdf35238c0fb2dc77f1-1730301883"
  },
  {
    "email":"marianna8015@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473801594/57f1985236724c0045104a641589590e-1730301883"
  },
  {
    "email":"simona.ing@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473867130/002691888d5558c311b429edd4a051ed-1730301883"
  },
  {
    "email":"stefania.pelucchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473932666/c8c23416d02ea787c3d1be0268eb467f-1730301883"
  },
  {
    "email":"daddaziodeborah@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723473965434/daa6520e96c3a473de07f134af85ce93-1730301883"
  },
  {
    "email":"giudittagangemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473998202/2a6f35c0b699ff0fbf3518180ab7f571-1730301883"
  },
  {
    "email":"elisa.guarino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474030970/b09f1c378ab32232debd8e5dc4e3abd2-1730301883"
  },
  {
    "email":"anastasiya.psareva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723473899898/c0d8d1767a759a638bb57bedb275d435-1730301883"
  },
  {
    "email":"stefania.mazzoni70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474063738/ec36c1e2e8f9fedbfd839edd54316bcf-1730301884"
  },
  {
    "email":"marinoalessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474096506/294ebb18aee317c5f406249136c9ce9e-1730301884"
  },
  {
    "email":"arianna.allais@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474162042/13f6d497a0dc8c8990ec08c82d93831b-1730301884"
  },
  {
    "email":"camilla1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474194810/58fd1fe69259048c53b54c298ce7ab22-1730301884"
  },
  {
    "email":"carolinapirri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474227578/0ceadf31655ee0d2638f1411a08c8da7-1730301884"
  },
  {
    "email":"robertina72a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474293114/77783856ef83ca4f1528bcb37b75a1d7-1730301884"
  },
  {
    "email":"fegorret@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474260346/38e45b88c4e6451b88a5b0deed23350e-1730301884"
  },
  {
    "email":"fabriziacerciello@gwntemusic.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474325882/a6f0035f2a2415f4f0f5184146680d17-1730301884"
  },
  {
    "email":"carmy.sant@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474391418/05ad7d7293f2262bac105980ce1cbe48-1730301884"
  },
  {
    "email":"moniabrescianini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474424186/596096ed8551bbf995c8648a3cddb1ff-1730301884"
  },
  {
    "email":"archelemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474456954/86dfd788b853b281a52a8e3b1664ed3b-1730301884"
  },
  {
    "email":"lisa.pavan@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474522490/6193c51039f3c285efd494f5e33b6002-1730301885"
  },
  {
    "email":"paola.torre@saras.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474588026/5ff896a2067a7224a775dceaf02cbc0f-1730301885"
  },
  {
    "email":"flavia_deangelis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474555258/136b936fc2a1027c1cc952a9ba968de8-1730301885"
  },
  {
    "email":"ddmiky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474620794/b9e70072a2d32a26a56d64f93fecf0cf-1730301885"
  },
  {
    "email":"mariadelre79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474489722/2c2f9118643622fc77f8ee1fd2fa1973-1730301885"
  },
  {
    "email":"giulia.bacini33@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474686330/a6e3be1018c34a766cf4ce7dcd501444-1730301885"
  },
  {
    "email":"inginis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474719098/a5f044c1d2f766efb56a42c8158b44ff-1730301885"
  },
  {
    "email":"angela.benvegnu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474784634/caee3b809ca7af24055c7e28872d3d83-1730301885"
  },
  {
    "email":"elefellin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474653562/d64c216d0d3057b843d553eafdfd31d3-1730301885"
  },
  {
    "email":"dragh83@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474817402/07d5b836016f32cc3e999a2e5adf64a3-1730301885"
  },
  {
    "email":"francescaberni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474850170/5a68e7cfb92896f186824b2bb41e08b0-1730301886"
  },
  {
    "email":"monica.giuf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474882938/904774805ff8e259669f53d2614000c5-1730301886"
  },
  {
    "email":"tizianin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723474948474/88a3f104ae6f6a58a8cf78f449961d34-1730301886"
  },
  {
    "email":"immamassaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474915706/3e6829337ff512815c0140f3c4470907-1730301886"
  },
  {
    "email":"max.barbarossa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723474981242/22710622c71368218b157700cfc4092c-1730301886"
  },
  {
    "email":"sarahkon_75@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475046778/e8264ebcd046801f4e70b7fe53461b59-1730301886"
  },
  {
    "email":"rosangelagranatiero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475079546/024a8394208f7a08c140081690463809-1730301886"
  },
  {
    "email":"sara.manfredotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475145082/f323f7c9da2112e3d46d0e6c6278af35-1730301886"
  },
  {
    "email":"joanna.istruzioneperi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475177850/d9904e201b524ca6840b041820684f90-1730301886"
  },
  {
    "email":"gspiaggi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475112314/0582b8f9c216e9abfdc3d121a61fb894-1730301886"
  },
  {
    "email":"rosanna.lantella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475276154/6acb46ce719d68e76ca667b1f72f4cec-1730301887"
  },
  {
    "email":"pallericarmen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475243386/4c5264a515cdfc4ba6fe18632c4940f1-1730301887"
  },
  {
    "email":"deppon@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475210618/a1780ce513c5e5200f4b1f37137cbdaf-1730301887"
  },
  {
    "email":"silvia.uccello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475341690/e5835338284463bd6b048db98dbd4a94-1730301887"
  },
  {
    "email":"aretusia@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475407226/cf34c75d74c18b04cbd4464ebaac339a-1730301887"
  },
  {
    "email":"elena_livi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475472762/3fb1b245e5691a87ef868023772b859a-1730301887"
  },
  {
    "email":"angela85nole@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475439994/295eb94062dc75323a6dd5d48e32c959-1730301887"
  },
  {
    "email":"ketyrizzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475571066/51cd4460c36796f5a627fb11727e756b-1730301887"
  },
  {
    "email":"giuseppeperruccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475505530/3e739b9c3ecfb62bef4f805a3d589ba7-1730301887"
  },
  {
    "email":"susanna@josu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475669370/865ea525cfe400000e78052f16cfa93f-1730301887"
  },
  {
    "email":"lorymarc77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475636602/b7375dbf664226dad36a07fb356327eb-1730301887"
  },
  {
    "email":"ssanti.1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475702138/132579308a0de58e179cbfe70ccb4d86-1730301888"
  },
  {
    "email":"piattolapiat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475538298/09544866041341d4a381d715197cee01-1730301888"
  },
  {
    "email":"alemolta73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475767674/c8d16451d9f2d5842c4654023531c837-1730301888"
  },
  {
    "email":"annadg08@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475800442/4cfcfd3c666bb4186e80041cd9670079-1730301888"
  },
  {
    "email":"carolina.target@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475734906/39c70f521ab3ab85cc8107eba5e78153-1730301888"
  },
  {
    "email":"melea2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475833210/519b5d215a7b7d64afd425abb3a6d664-1730301888"
  },
  {
    "email":"dicarluc@bmimdi.191.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475898746/2a29109796b17eb0211aec216da314c4-1730301888"
  },
  {
    "email":"silvia_slv7@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475964282/6b674b7196271d877779b91269e6412f-1730301888"
  },
  {
    "email":"cioffi.luisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723475865978/7072f7f2456491dd23219683780d3770-1730301888"
  },
  {
    "email":"elisa.baiguera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723475997050/410fc73ba64dd25fba672aa25eb7f129-1730301888"
  },
  {
    "email":"summatere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476062586/06b767520c85de3057a7cd63ee35575d-1730301889"
  },
  {
    "email":"manu12_10@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476029818/e9c20d001bb3f264d5b1f35ef1301c90-1730301889"
  },
  {
    "email":"laura.alonzo308@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476193658/0e151228068236e58e82982d65f7a06c-1730301889"
  },
  {
    "email":"failla378@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476095354/f5c7c40f5d0370c67d5c628411db360a-1730301889"
  },
  {
    "email":"valentinatrape@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476128122/b1905018d8acaafbddce62c8e4b6de45-1730301889"
  },
  {
    "email":"greta.meccoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476259194/0d965b506ad21e5327c40143457aabe3-1730301889"
  },
  {
    "email":"candida.lomonaco@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476160890/bdefc7a70711f3065b7f8424a11bff1d-1730301889"
  },
  {
    "email":"caterinaridi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476291962/84d01dc69b69ea8356cefd16df525291-1730301889"
  },
  {
    "email":"info@edilimm.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476357498/e97a708dc27aa774b5b8cdeece004173-1730301890"
  },
  {
    "email":"manuela.ciccione@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476390266/af54c2307636fa202e62a0fae7c92761-1730301890"
  },
  {
    "email":"alessandracasarin17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476226426/de20d5bf34172739bf4671e2091d39e3-1730301890"
  },
  {
    "email":"vi.zappia@gmail.com",
    "url di attivazione":""
  },
  {
    "email":"v.vinattieri@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476324730/06a0455f887cc543f8722c0a7168b3dd-1730301890"
  },
  {
    "email":"mariottinifabio75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476554106/402ab4ceb4504a428e7544377a5f80b5-1730301890"
  },
  {
    "email":"posa@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476652410/7cd22249b0a17e58a790f0d380162b03-1730301890"
  },
  {
    "email":"anna.a14@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476619642/a5772ac4472c5b2289373e27ff02e187-1730301890"
  },
  {
    "email":"francesca.miranda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476455802/9c43cf02427dbd6174140ca0b80bf059-1730301890"
  },
  {
    "email":"sapereaude1982@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476685178/aee7412cb21959d489c5bc0b2b8c75e8-1730301890"
  },
  {
    "email":"sabrina.sordi.492@posta.istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476750714/0e8ba0f729ad070093238a399ffa8cd5-1730301890"
  },
  {
    "email":"rositatidona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476717946/798f29aa09444555ad5f7265ee851cee-1730301890"
  },
  {
    "email":"maria.marino1976@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476783482/f16a1c9f09076859787ad3125f3c0cae-1730301890"
  },
  {
    "email":"roberta_5_@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476816250/3bde58faa5e413fa801eb4a0d1653de2-1730301891"
  },
  {
    "email":"lara_tl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476881786/0c4a8eba4bd228ec339bb6763dc80071-1730301891"
  },
  {
    "email":"arianna.binato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476914554/7db723250bff0c823dd7cdc07712300d-1730301891"
  },
  {
    "email":"t.tortora@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476849018/78b19794e79ed268119cb1020bdcaaf1-1730301891"
  },
  {
    "email":"stefania.mrg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723476947322/c8b53f48a3afc8cb28561e50205afe7f-1730301891"
  },
  {
    "email":"rosannamassari1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723476980090/65ae2dde950254ac74f531cd162922b9-1730301891"
  },
  {
    "email":"lipadusa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477012858/9b65d1f5e98a09270cb8a46692945f6e-1730301891"
  },
  {
    "email":"silviacanalia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477045626/ca8daac39b11cfdad0d6918e1a88b949-1730301891"
  },
  {
    "email":"paola.dipasquale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477078394/c981295df58047ae95d9ee70ab3829cf-1730301891"
  },
  {
    "email":"caramelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477111162/b424444b49c03b957ba378df76c59b1f-1730301892"
  },
  {
    "email":"debcongiu@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477176698/bbccb0054ced4210ab6d8b8ba7517108-1730301893"
  },
  {
    "email":"zanzaraaltruista@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477307770/3f75d614ccc80a1c9249e99b8a9b2a9b-1730301893"
  },
  {
    "email":"doriana55@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477275002/1a44402f37863e2123940a4487e50e7a-1730301893"
  },
  {
    "email":"m.vigliardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477373306/66279e5efbe549d5dc50b3fb78ebc070-1730301893"
  },
  {
    "email":"pamelacuriale1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477340538/68e5f7f46202f0c71ede9dc6d1038d7c-1730301893"
  },
  {
    "email":"giuliasau70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477471610/5957922e015f9c67fa413f7a7931e8c4-1730301893"
  },
  {
    "email":"danielamarocchi965@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477143930/812931b91520ca30dbb5b7ad1473125e-1730301894"
  },
  {
    "email":"palumboluc@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477635450/c209720c3e23fee491a98552997ddfd7-1730301894"
  },
  {
    "email":"emanuela.arduini@studio.le.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477668218/e4a81220e8458b3971be3c58d7470dc9-1730301894"
  },
  {
    "email":"amedea_berardo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477733754/8f2742471d8c1d653e145abf269d1316-1730301894"
  },
  {
    "email":"lovill70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723477504378/b1f35b4ae820de48dc3db27624c35c46-1730301894"
  },
  {
    "email":"eleonora.monaldi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477537146/abf3268e4c7800d04ccf58d394a9c145-1730301894"
  },
  {
    "email":"veronica.aparo_80@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477700986/f412a4a78437d3132ad67b86928395ee-1730301894"
  },
  {
    "email":"contirama@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477799290/c81151d59729e632c5b2618bb0ddef95-1730301895"
  },
  {
    "email":"jbonettini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477864826/c55fbb8d96a75f82cbad5ec28e73eb45-1730301895"
  },
  {
    "email":"serena@morgantiservice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477832058/aa58066c5e3174674fe15dd663986c28-1730301895"
  },
  {
    "email":"ketty77@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477897594/1aacd3d6d666d6e014f7ea3dece36fa9-1730301895"
  },
  {
    "email":"stefy19775@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477930362/78546497dc76e5877b4189ee6517f10c-1730301895"
  },
  {
    "email":"elisabettaalvisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477963130/ffe458c0db5f7ad00305432e987c85a7-1730301895"
  },
  {
    "email":"famigliameini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723477995898/8d79584efae61ed08a0d9d08449abb6a-1730301895"
  },
  {
    "email":"katiasacco70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478061434/7cd83dc2bf4a9fd37d954dce477dcf6a-1730301895"
  },
  {
    "email":"mariags.ventura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478126970/f1da9044b4e73f8371f2466eff9e2993-1730301895"
  },
  {
    "email":"flumicelli.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478094202/c537b2c14010eddb972fe060dda861d0-1730301895"
  },
  {
    "email":"boborkovic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478159738/4e4aacb1b9a731116be59e9e0d6db9f4-1730301895"
  },
  {
    "email":"lopes.cgilragusa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478192506/e20946a0d6dd69398f1a4c9ff0b3204b-1730301895"
  },
  {
    "email":"valentino.pagliaroli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478225274/1565b38fb965a44d702f9201e305fc69-1730301896"
  },
  {
    "email":"valerialeggio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478290810/286913295d221fdee6a1f9e438786496-1730301896"
  },
  {
    "email":"motezelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478356346/7c0a50a340924ddbda63215b2d4d31ae-1730301896"
  },
  {
    "email":"zuccaroemy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478323578/a1934cdb01a49c7215dc3fb6ab149f5c-1730301896"
  },
  {
    "email":"ilaria.zanella@student.unife.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478389114/706c1aef7024ef3fee739d6c645aad0f-1730301896"
  },
  {
    "email":"silviamad@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478454650/cbeb54636fbc42d1708fa9ac8f229266-1730301896"
  },
  {
    "email":"buro.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478520186/178f72560a0ea251360aa495be5e59be-1730301896"
  },
  {
    "email":"invernizzinacri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478552954/b19699bd2b5e9da720357b086187f7b3-1730301896"
  },
  {
    "email":"savina.cotic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478421882/4892e30ec7358acb3f67ed87427081de-1730301896"
  },
  {
    "email":"martinaturra53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478585722/e337f61d2f438ccab41b870adca73cf0-1730301897"
  },
  {
    "email":"marciruta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478618490/2270381fe9da897cc9e2956335463a71-1730301897"
  },
  {
    "email":"dorianapizzolorusso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478651258/1e4c72de4743f7f0d5e14d38eb9d93a7-1730301897"
  },
  {
    "email":"stefaniatheteacher@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478487418/b391ac6b30795db3d5aa3cc11cbac276-1730301897"
  },
  {
    "email":"dottis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478684026/386158ac9e8dbed77a5173e5d8dbbdcf-1730301897"
  },
  {
    "email":"guidocasoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478716794/3edaf484120ce8fffe1aaa4a9e550eef-1730301897"
  },
  {
    "email":"maya8119@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478749562/c02d88ae35e6daa8d3af4848b7fd5560-1730301897"
  },
  {
    "email":"barbara.zanchetta@calzedonia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478782330/f064146560944e4d552bce9d508dd7b8-1730301897"
  },
  {
    "email":"elisabettafois@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478815098/2f46de16daacaa4e30be9c0d594720a5-1730301897"
  },
  {
    "email":"michuli75@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723478847866/cda422d04f225281ccb1945fbd179a11-1730301897"
  },
  {
    "email":"a.petroccelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478913402/78dd08a72da9ae0fffaeda9a3f764503-1730301898"
  },
  {
    "email":"danieladb66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479011706/f2d2026854c8c67778ed2d30fa14d1b0-1730301898"
  },
  {
    "email":"mariasolegiamp@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478978938/824e2dbe01277e623b2a9b2d71da9ba3-1730301898"
  },
  {
    "email":"rosaria487@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479044474/563fca3fee98bd41a2a0ac9dd6328611-1730301898"
  },
  {
    "email":"estonia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479110010/17c0d1ebdc561fc4f10d1d1e9b472e60-1730301898"
  },
  {
    "email":"valentina.80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723478946170/be1d9ca591d12cfec1f2f9a990ca191b-1730301898"
  },
  {
    "email":"elenacolombo496@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479077242/08f5f4c06796add6ceaac51495092353-1730301898"
  },
  {
    "email":"hyclass2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479142778/1719c5412ebc0a405c62830870879877-1730301898"
  },
  {
    "email":"guapal1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479208314/522676ba0b5e8d6542cd85c4903afeac-1730301898"
  },
  {
    "email":"totaro.anna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479175546/e2240133ab78e74bd7c3a5378fa951cc-1730301898"
  },
  {
    "email":"saraliva81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479241082/32ee8e614fcacb4e56c7c3502f190af9-1730301898"
  },
  {
    "email":"marzar9@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479306618/e4ca44c1c9045fdc557c4c7f2125543e-1730301899"
  },
  {
    "email":"francescaprochilo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479372154/796750b10558d6ed405b0d60de1041ec-1730301899"
  },
  {
    "email":"simonacipri1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479404922/354ef56320ef18e9d023c04a57ed84da-1730301899"
  },
  {
    "email":"valeriacicalese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479470458/ffe1e7bc0769e6e7430d57a1d7c5195c-1730301899"
  },
  {
    "email":"elenapratali68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479503226/34a603d6d2476b5bfe1ba7295e5e5889-1730301899"
  },
  {
    "email":"stmoriz33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479339386/37dbe05ae8b03ede1e37698b89e96e22-1730301899"
  },
  {
    "email":"monica.cipolotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479601530/08f3d0c496c8aa11261994c5b1013de9-1730301899"
  },
  {
    "email":"fabriziacerciello@gentemusic.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479634298/4153351e7b830b32b75980ebb30334cc-1730301899"
  },
  {
    "email":"simona.stocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479535994/f006c610312861bbd87776f08e7e5e2f-1730301899"
  },
  {
    "email":"fbugia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479699834/fedbcfa56ca8f2c7176324c6bfe859b9-1730301899"
  },
  {
    "email":"laura.pasetto89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479667066/d9eaa367a08daa807fe490c05047a842-1730301899"
  },
  {
    "email":"ilagfflri@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723479732602/2dff9c6d1dc0cb7940fa65b9d6bb5d09-1730301900"
  },
  {
    "email":"danieladingeo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479798138/d18e6ffe0893981633bc3315fef4f133-1730301900"
  },
  {
    "email":"natalyaklimovaboscolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479961978/27654f7a99b2f37d26184d4fb36c919e-1730301900"
  },
  {
    "email":"alessiacuogo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479929210/e4705cc1809ce032e136e931ba6f66eb-1730301900"
  },
  {
    "email":"claudiaguarino012@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723479830906/fafe65f592d13cfbd93e81ae14855412-1730301900"
  },
  {
    "email":"lara.costardi1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480093050/4b911250e0c35fdfe8712ffaf795665c-1730301900"
  },
  {
    "email":"franca.zamprogna69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480158586/317e99d057e3acc24b0373e9dc911e0c-1730301900"
  },
  {
    "email":"fragolita78.sp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480060282/5fefea558cf8adbc300b080d9acb286e-1730301900"
  },
  {
    "email":"magliocchina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480027514/6944b941e293219a04918a490da0d945-1730301900"
  },
  {
    "email":"barbarabiraghi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480191354/c2d89d7cef100f5f3ef23a10fd672373-1730301900"
  },
  {
    "email":"giovannagiannursini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480256890/67099bec6c5bba255147cc04818e9e21-1730301901"
  },
  {
    "email":"gisalalta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480387962/95155b284c27b41ed8e266b8a3f033f5-1730301901"
  },
  {
    "email":"stefania.domenici@bnlmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480289658/9c1703bf4b0ffe7b6fa8980abb39dea9-1730301901"
  },
  {
    "email":"klodianagjokakolaveri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480224122/32bdff77b2686ee2525b63ccd603723d-1730301901"
  },
  {
    "email":"ila.piros@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480486266/8254f28af479ec2a739adceda793b078-1730301901"
  },
  {
    "email":"nportac@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480519034/fb2d978fce60376ee7e44b5d08e205cd-1730301901"
  },
  {
    "email":"francescarossignoli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480355194/b0d6bae1ae7367f83d91e5e048b03ec6-1730301901"
  },
  {
    "email":"ingegneriannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480453498/b44e33aa89c859418ec0eca13fea470e-1730301902"
  },
  {
    "email":"luci0909@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480551802/f6d98656474b681e23ca51b5beafd28c-1730301902"
  },
  {
    "email":"nadia108759@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480617338/e5756d435ce7cc7d9b118d5b2ceb0f27-1730301902"
  },
  {
    "email":"alessandrasaba76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480650106/de2c0ae5f84385b0f1e2e80497908182-1730301902"
  },
  {
    "email":"grazia.p83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480715642/896976fc476561a458324b86eb7ee081-1730301902"
  },
  {
    "email":"francina.80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480584570/fc61ae8a38a0345bb48866fb49843aae-1730301902"
  },
  {
    "email":"tiziana04.12@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480846714/57c8dac9e604fd0db56dd37a4086dc10-1730301902"
  },
  {
    "email":"danibert72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480748410/c9bf3f03ef0ccf9a3401ab0e64e0da32-1730301902"
  },
  {
    "email":"danilamazzarese78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723480813946/4195f5c9540a4ded32a2b719dd184cba-1730301903"
  },
  {
    "email":"bol.monica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480977786/d253606e5afd7736a0442a823900887f-1730301903"
  },
  {
    "email":"isabellelurci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723480912250/48cf4899c83d2f87b290cc12e9161e94-1730301903"
  },
  {
    "email":"sabrinarondoni@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723480879482/d33d3d265a1f1b46f85a7a5350209c1c-1730301903"
  },
  {
    "email":"mariangelasimone6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481043322/ca01efd4e2a1e58803413190b7875f3c-1730301903"
  },
  {
    "email":"papetti69@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481076090/3da4a3aa0c103efa897fae3018a6e6db-1730301903"
  },
  {
    "email":"laura.maria.tirelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481010554/e77174252fa774073b598e991cadeffb-1730301903"
  },
  {
    "email":"fortunata.iovino31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481239930/59443724136894f8576ebcce470ee831-1730301904"
  },
  {
    "email":"emanuelamecca35@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481108858/59ad2dd11960dd162ace192b8f4d1f71-1730301904"
  },
  {
    "email":"sprinter98@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481207162/efda1ff3665b718948facd4a6949e93b-1730301904"
  },
  {
    "email":"bonifazimarti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481272698/b345cf8d1c2c15cdb29293b889a10107-1730301904"
  },
  {
    "email":"l.giraldo68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481371002/53f5e9dfd57346f54cf3c410257cc8a2-1730301904"
  },
  {
    "email":"vera.pappa.062@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481338234/ed0868bf2058c53f0391f78ede0d6f0d-1730301904"
  },
  {
    "email":"fedewar74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481403770/b6518d6212b06cf5a7730e4626428212-1730301904"
  },
  {
    "email":"c.cianfrini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481469306/a302d5e0170418d814b4cb0854a4aca9-1730301904"
  },
  {
    "email":"nicpendenza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481305466/90f269bbb4f35f63b0966d4dc7c79aa3-1730301904"
  },
  {
    "email":"martaconti257@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481534842/6148e1370f4d5c5735a737f148b78d1d-1730301904"
  },
  {
    "email":"mariavaccaro105@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481633146/f1e408b1a154f4cee6c5fe215a4b8109-1730301905"
  },
  {
    "email":"danielagagliardi1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481436538/67f2283b6c86feb203226c287b7263fe-1730301905"
  },
  {
    "email":"v.denardis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481698682/d623b0d2156caddf9e6ef382cf6a527c-1730301905"
  },
  {
    "email":"monica.cavalca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481764218/8c269ecddb6dd4bf6eb2d10752b6fbd2-1730301905"
  },
  {
    "email":"mncnespoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481731450/85c0269832c850c290d3270982aa5a62-1730301905"
  },
  {
    "email":"urbinati.chiara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481567610/4166182d636f41a651d88d248b55f075-1730301905"
  },
  {
    "email":"serenaborbotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481829754/ed8c31294512e2efa22b15f4dfb8650e-1730301906"
  },
  {
    "email":"antonellapuggioni76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481796986/185770960371a2433133ef1df596515f-1730301906"
  },
  {
    "email":"giuliguerrera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481862522/bb9d618efba7d8b7a378580aa662786f-1730301906"
  },
  {
    "email":"rogani.adriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481895290/67e40b9d66f1d2466e5192e6a8498281-1730301906"
  },
  {
    "email":"mery.lucchesi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481928058/af41e76dbf28083da6853f986a304ebb-1730301906"
  },
  {
    "email":"luisacelesia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723481993594/2312e93197573411f3c35951773c6891-1730301906"
  },
  {
    "email":"bbelvedere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723481960826/43bab1bedec129103adffd960aca97b0-1730301906"
  },
  {
    "email":"r_delfrate@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482026362/16f806e556356d678813e9aae87f9636-1730301906"
  },
  {
    "email":"kcarboni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482124666/71cf381ae152437bc03bc4fde9970db1-1730301909"
  },
  {
    "email":"outwosandro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482157434/684eb2f149b32f0e08b95bd36d9b4700-1730301909"
  },
  {
    "email":"ercreazioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482222970/06257b91f0cc48036f143662a601d468-1730301909"
  },
  {
    "email":"prof.bernini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482190202/45d310352619a3632727f7a34917c557-1730301909"
  },
  {
    "email":"supervalina2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482288506/a7e0d53482886eb9af6245c3c74e9db5-1730301909"
  },
  {
    "email":"zyzinaelena76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482255738/05eb5dab71e86099810e013548d16196-1730301909"
  },
  {
    "email":"alessandrapedroni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482354042/d15bc38de349ec05165e944da5628b3f-1730301909"
  },
  {
    "email":"mariateresafalvo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482419578/1d76eb0432414d8dc46e1928c6ab1890-1730301909"
  },
  {
    "email":"stallograzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482321274/d1293b05b0406d03cdd8d7c756a67d55-1730301909"
  },
  {
    "email":"apoile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482452346/e603a04b9de51a1944dc7d51dc1ba9c0-1730301909"
  },
  {
    "email":"paolo-cinzia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482485114/6c6ff4945d8a4d5a4cf450a50ace9c30-1730301909"
  },
  {
    "email":"laura.barbieri.313@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482583418/e5a33617aa8bbd469ce3713c4d67a372-1730301909"
  },
  {
    "email":"rendaf@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482517882/890a422b5d7c8f55de9a2cac70d69ed9-1730301910"
  },
  {
    "email":"domy.1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482747258/e4f7e3765e18ee4e1842fc1419fc6ab4-1730301910"
  },
  {
    "email":"olivati76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482714490/85c6278a585f630a17476a4e3bd0c0f7-1730301910"
  },
  {
    "email":"claudiac.mazzola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482616186/6ba96c896ad869932c9cedc5a1ebab4e-1730301910"
  },
  {
    "email":"federica.ezio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482780026/218d362476e4816e16f73c757a7d877c-1730301910"
  },
  {
    "email":"mfmarisa64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723482878330/f3a2be83e9c53f852c3874453028cd1c-1730301910"
  },
  {
    "email":"marina@brognoli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482911098/133c253bbe90de33402f9351c8d7650a-1730301910"
  },
  {
    "email":"fatima.fiocca@tiscali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483009402/0b3ef0a59a5dca142f9d5643cb383d06-1730301910"
  },
  {
    "email":"malu27@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723482845562/959943dd07afd34715b2c1cceda3dd8b-1730301910"
  },
  {
    "email":"erika.ravalico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483074938/74eca660d2687c4a90b51acf2f0c5b23-1730301910"
  },
  {
    "email":"info@mickigruber.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483107706/8036847365c06dbf20012c0b2732f171-1730301910"
  },
  {
    "email":"eleonora-mail@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483042170/a89770bef40bcd83f99982001be60352-1730301911"
  },
  {
    "email":"laila.giorgione@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483173242/a0c5ce40594920f6d5aae071ae3bcc3b-1730301911"
  },
  {
    "email":"samanta.poletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483206010/e49fdb8824e3e1b16dd92f0d0be91599-1730301911"
  },
  {
    "email":"rikydesko@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483238778/6e4fdc90980cf271c07ce17dfedd7904-1730301911"
  },
  {
    "email":"bonati.ilaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483140474/6dec7727a7bf7c64147273291375df7e-1730301911"
  },
  {
    "email":"valeria.talevi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483271546/bd34ddb705c9cf68d7363258558a4879-1730301911"
  },
  {
    "email":"adrianoxt2@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483304314/1fb3fd14e782f87d0e2aaea4f2531b9f-1730301911"
  },
  {
    "email":"roberta.diluca@viagginuovaera.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483369850/0a741ddf44842ef043dd3822927e0e4b-1730301911"
  },
  {
    "email":"emontanino74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483468154/c6bab0b0f909d37c41d910b1731ed402-1730301912"
  },
  {
    "email":"jenniferpretto.pj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483337082/70b0ea1773d0d76cf93caa8ee8843bd6-1730301912"
  },
  {
    "email":"danielacapece@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483402618/f76e00cc16e9423925127bf7f7f5fcaf-1730301912"
  },
  {
    "email":"vicroby60@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483500922/6153e4c3864e5c69a3ccffbca32784fc-1730301912"
  },
  {
    "email":"mary.katty@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483533690/cc21e3f900348122a8dc5590c43181cd-1730301912"
  },
  {
    "email":"flory@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483566458/f0b1d2e8f00be117f9f0d7ede86acb1d-1730301912"
  },
  {
    "email":"michela.c76@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483631994/7fdd9f6e2b105499b64554c8a19986e4-1730301912"
  },
  {
    "email":"b.alfieri80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483435386/d02e9c2e89bafe37ee63a58ed4fb19c6-1730301912"
  },
  {
    "email":"debegi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483664762/f754764ea694070f0c5c34a3a5dc8138-1730301912"
  },
  {
    "email":"marisadonadel1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483763066/9c5fe9c94fdc4b307ca6fe5abf28d7e0-1730301912"
  },
  {
    "email":"giuseppinalanzilotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483730298/46ceed95c2dc46f50114246e921a789b-1730301913"
  },
  {
    "email":"lauralombardo66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483894138/0b3eb92caa20fbff068cd315d2ed9594-1730301913"
  },
  {
    "email":"marily.sarah@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483861370/64ce568ca71fa00fc989ed7380b21960-1730301913"
  },
  {
    "email":"ariannapileggi90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723483697530/ea59df78cc9e799a12cdd215fd40c522-1730301913"
  },
  {
    "email":"laura.a.rossignoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484025210/6a084c32f4966e141b4f0e6e58d24d04-1730301913"
  },
  {
    "email":"valeria.palazzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484090746/f404ccad337f9afa653612fbdeefcbe5-1730301913"
  },
  {
    "email":"cristiana.rovini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484123514/2497c16f71ea1e7d54a78506577c7233-1730301913"
  },
  {
    "email":"vescovigianluigi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723483926906/a5699220eaf4859ee2557ce1f975bad6-1730301913"
  },
  {
    "email":"b_jess@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484189050/1fec7fc7840393af3c4d0f7375c88d2e-1730301913"
  },
  {
    "email":"francesca.gamba.fg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484287354/bd1a7e2fa589be62e9b5905676ceeeca-1730301914"
  },
  {
    "email":"azoeggeler@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484156282/1ea8f6d20c70735db13cf79f63cba463-1730301914"
  },
  {
    "email":"patcar2904@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484320122/231a395fae591ce6e95e45ec76e210c2-1730301914"
  },
  {
    "email":"patrizia.visani@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484254586/80bfa6072ddccee4713e7308edef1660-1730301914"
  },
  {
    "email":"ritaoberleiter@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484451194/98ca088cd81edbeff6074d2308d260e0-1730301914"
  },
  {
    "email":"samyarwen71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484483962/a2a8975af49f91a6bc09e5e7441b8445-1730301914"
  },
  {
    "email":"alessandro.biamonte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484516730/02bd58b7d44f2d372ef7d1a21b9c4508-1730301914"
  },
  {
    "email":"ivanaberri58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484615034/8f089f7ac21fd1f3ed331d14b024e207-1730301914"
  },
  {
    "email":"francyroxy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484582266/b329597cf490c09109d09c59980d7e62-1730301914"
  },
  {
    "email":"pinazanotto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484385658/42efda25d214e765e277d980529f976e-1730301915"
  },
  {
    "email":"maxfrancygioga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484778874/98b57f22c77792dd496c2d07dcb6b822-1730301915"
  },
  {
    "email":"danyc1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484811642/60d98708617d39e294fe6eaafe4cbab8-1730301915"
  },
  {
    "email":"rosyespo1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484647802/1e09805842a27f1c9c1c2c3766b7c5e6-1730301915"
  },
  {
    "email":"patrizia.marini62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484844410/7b46fe21968cb6c2f547f87fcec735f3-1730301915"
  },
  {
    "email":"graziella.pulvirenti@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484713338/515687f1b5ee93964ebb28e44f168fcc-1730301915"
  },
  {
    "email":"chiara.nu9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484877178/ce01341adb019f0d00a492c8f4bd1984-1730301915"
  },
  {
    "email":"giuggiola12013@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723484942714/d06b6b1883cb7d35d3527d165ff928ca-1730301915"
  },
  {
    "email":"l.delise@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723484975482/a1c8459c01b2698bf6dd1a16b0752e3e-1730301915"
  },
  {
    "email":"tatydecol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485041018/cf202746721cbbaa71dfc660b2326561-1730301916"
  },
  {
    "email":"crescigno.d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485073786/889c540f960930f150bb314873f2b87b-1730301916"
  },
  {
    "email":"biggio.mar@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485106554/5d7a9e2700025c6c0a83100a715aff15-1730301916"
  },
  {
    "email":"racla2001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485008250/c35a3283fe17435c297cf85966166342-1730301916"
  },
  {
    "email":"mariapaola.chessa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485237626/73f05df8ad391c9afd8eea4578fb4505-1730301916"
  },
  {
    "email":"deannalupi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485139322/5b710a7aa04733fc8bc3beb85a0741b1-1730301916"
  },
  {
    "email":"federicapesce77@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485172090/3ceed5d8091cfb638b2ee070eaf7f7fe-1730301916"
  },
  {
    "email":"foarma@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485303162/081f0a9fc61c9a77ad034634e4092373-1730301916"
  },
  {
    "email":"pursi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485270394/55e889991383669edb35f69bc7413bf5-1730301916"
  },
  {
    "email":"eleonoraregoli87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485335930/73c51e246471b09117cd2e960b61c97c-1730301916"
  },
  {
    "email":"gfusari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485434234/c1e02f69d438cdc1b5a69294f23a7c3d-1730301917"
  },
  {
    "email":"milenacorsi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485401466/a0d71d5f1f258e54664ba639f82c1c63-1730301917"
  },
  {
    "email":"rominasucci@archipiu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485532538/b548e753d1ac832cd94005800c0d45cb-1730301917"
  },
  {
    "email":"e.napo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485598074/e3c6c361ed599db1f267c73888c83642-1730301917"
  },
  {
    "email":"68.whitestar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485467002/4487996b086fb3d341b0f0113dd01732-1730301917"
  },
  {
    "email":"falegnami.laura@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485630842/606c6193636d07d778163a05ad142b92-1730301917"
  },
  {
    "email":"catalano.tiziana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485565306/08aee6c5875adff96fb24a05e872d523-1730301917"
  },
  {
    "email":"angela.pacifici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485761914/1235e6b41d96bd3df474ca254799fe92-1730301917"
  },
  {
    "email":"romirast@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485729146/4b1270c2a095fdcf6f575d66bdf740ce-1730301918"
  },
  {
    "email":"simona.quattrone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485827450/1f3c805cf6640c96dfe2c3cb34e44f32-1730301918"
  },
  {
    "email":"i.borgonovi@lutech.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485860218/d5ac6d197389f2507a7cf15088b9cf99-1730301918"
  },
  {
    "email":"lepri.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723485794682/53a53b3a3602d82f085fd1a8824d15c7-1730301918"
  },
  {
    "email":"lardellifederica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485892986/3966cc398a1af79acae93449e41f9416-1730301918"
  },
  {
    "email":"patrizia.vacante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485958522/b51b0e0bfd9606f839660bc0caf24664-1730301918"
  },
  {
    "email":"ilariabottone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723485991290/bc1f119426ce4ee4e927c4a503a99e1c-1730301918"
  },
  {
    "email":"elena.bassoli@unimore.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486024058/6c4d29d2381e0fe237129c3d4de74338-1730301918"
  },
  {
    "email":"rafcec71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486056826/210c1b392d01ce4978dfb29315500744-1730301918"
  },
  {
    "email":"orlacchio.stefania@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486089594/3522991c3c8c5e28c67cbd0a41d7e5f3-1730301918"
  },
  {
    "email":"easylom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486155130/05403506c19186c094253eff5c158156-1730301918"
  },
  {
    "email":"m.bertani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486253434/bf91b6b51886e8f9398e4a80a303d177-1730301919"
  },
  {
    "email":"fuscia67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486220666/5ad6060017738897b3eb303fadf58ae7-1730301919"
  },
  {
    "email":"dm.moda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486286202/65bed02046dcc8eeb73dacbcbef6b76a-1730301919"
  },
  {
    "email":"abortolazzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486187898/f9000b6b61db04d95733c156347d66bc-1730301919"
  },
  {
    "email":"chiaratarghetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486351738/e612f06b5b8b42a0e31f0401b4b2579e-1730301919"
  },
  {
    "email":"fabiofondatori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486384506/f7e7d53f668fd982c1ee7ad408e2e5a0-1730301919"
  },
  {
    "email":"federicafabbrucci77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486515578/91a71003a28a72d86c673e442efab71c-1730301919"
  },
  {
    "email":"a.borchia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486417274/beb22415fcece33070c8514d79b19fa2-1730301919"
  },
  {
    "email":"mora.mila@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486318970/57b1dc3d62cd2f04a0061bdba7c39278-1730301919"
  },
  {
    "email":"marketing@gruppomati.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486450042/7d80c4a151c17823d255a6d6f847f721-1730301919"
  },
  {
    "email":"paola.nieddu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486646650/53e8c72a25aa6a37253c16dade0ba19a-1730301920"
  },
  {
    "email":"cortese.stefania23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486581114/e2f21cdf5e0170b2d5c70e6351f687d2-1730301920"
  },
  {
    "email":"ester@familywelcome.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723486613882/7a770b0c43584fa4c6514ada0be878ad-1730301920"
  },
  {
    "email":"photolinepv@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486679418/5828d0cd317882d14fc0faec62d312b0-1730301920"
  },
  {
    "email":"simonatonelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486744954/435baa9c16199d42c03b0be1c73a558c-1730301920"
  },
  {
    "email":"federicapitoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486712186/6a7564fae0907fcbbf39e9c11e51f6f5-1730301920"
  },
  {
    "email":"caterinaferri76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486777722/14b6674b92b2934c1737f293c4d45ff1-1730301920"
  },
  {
    "email":"baposti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486810490/4b01a283dc401aee5772d10d2312c429-1730301920"
  },
  {
    "email":"picchiotti.g@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486876026/97234ffbd6096c784c6690f91beaa40f-1730301920"
  },
  {
    "email":"hc.corrado@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486941562/1bd4080772f2c3ae7f2bb50f165dab5e-1730301920"
  },
  {
    "email":"laura.porreca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486843258/38c9335dd48c0cde8b4d94ace567f1ba-1730301921"
  },
  {
    "email":"groccasalva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723486974330/914d7fe7b7621f50e83138e88a4a106d-1730301921"
  },
  {
    "email":"cassa0409@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487105402/8c07ffc768c37a0f7961ad32f0905c8d-1730301921"
  },
  {
    "email":"s.rizzo8@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487072634/356b3046f53f66937f72b89958ce5848-1730301921"
  },
  {
    "email":"gabriele26id@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723486908794/9cfa27f864db6072c000b9412f54b9cd-1730301921"
  },
  {
    "email":"antoniadileo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487007098/912cd0a533c01011837182d7f8463e3b-1730301921"
  },
  {
    "email":"davide.sgara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487138170/1991c4d87ef3de8a896959b556d767e4-1730301921"
  },
  {
    "email":"camillamori83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487203706/fac6c97f1a4459d1d2bc2a7f3422ce24-1730301923"
  },
  {
    "email":"m.onica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487170938/3da3ef34e524a4ca94c6a785b21df7a8-1730301923"
  },
  {
    "email":"pidimu@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487269242/007fe1a21030d42f826a94f392194066-1730301923"
  },
  {
    "email":"v.a.dg7411@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487236474/1e7c050043a229bf0808fbef7a1996de-1730301923"
  },
  {
    "email":"michela.andreatta23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487367546/c653e392e177f323c94c3ac5cc3d3a92-1730301923"
  },
  {
    "email":"mariarosariacalderone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487498618/6c9f2ea498539e023571e4446888339c-1730301924"
  },
  {
    "email":"laurentstefania@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487334778/c983639445bf5aa5cecde4c522f04a45-1730301924"
  },
  {
    "email":"ceccato.daniela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487465850/8b092e519227205c650654edb21295a6-1730301924"
  },
  {
    "email":"francescadamico2016@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487433082/402da6a30f225ab5e3fe70ba40e2b823-1730301924"
  },
  {
    "email":"stelladimilia.3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487531386/c29798cab2825c6a3ddc8147ba8293f9-1730301924"
  },
  {
    "email":"angelina.911@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487596922/0c78792308b45c1f39827b39caa1edbf-1730301924"
  },
  {
    "email":"fellonijessica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487695226/be91c593facb245281eb4d35fb0a1ff9-1730301924"
  },
  {
    "email":"tiziana.maestri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487662458/fc5c76b07c9d1c6306a2c11d18d8176c-1730301924"
  },
  {
    "email":"tommasoros0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487629690/8a7a699a7e381acc521c1b454c894078-1730301924"
  },
  {
    "email":"cavadefi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487727994/edfd1c7a39cc4e589f80d8cd58779ad3-1730301925"
  },
  {
    "email":"fedetonelli84@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487826298/45f74cbd9a342aeb1f926b198fe325e3-1730301925"
  },
  {
    "email":"ermelindacatalano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487793530/b864ef8913acbaac305863c7290e979b-1730301925"
  },
  {
    "email":"valentina.tsili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487859066/51e69684bd82efdcc7ba82285775b4d9-1730301925"
  },
  {
    "email":"dolciotti.48@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487760762/cedcb7edca5366a3eb3b3ed7b8617288-1730301925"
  },
  {
    "email":"elisabettamaria.poli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487891834/03e7db220aba06d952a54b74bd85f54c-1730301925"
  },
  {
    "email":"giacinto.ciaccio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487924602/ec49fa01cdddc302f495076f16b53814-1730301925"
  },
  {
    "email":"elevenseven666@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723487957370/3210ba673e04d65235ac53a76098e580-1730301925"
  },
  {
    "email":"daniela.procopio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723487990138/10d667b85324f7ad2a34fb7ff0569bfe-1730301925"
  },
  {
    "email":"mariarita.melita@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488055674/b134d0019deed2bb361268048c1d6ca6-1730301925"
  },
  {
    "email":"danticat@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488088442/af077b6a58da83f591cbf4f2de03771e-1730301925"
  },
  {
    "email":"emanuelacrosta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488153978/d3af46f44f3f69e115d2455d0c5ccdd8-1730301926"
  },
  {
    "email":"rossnacci77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488022906/eb6fad15c9c7604dfa6b753237823625-1730301926"
  },
  {
    "email":"zanina2801@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488252282/6cc940153029b505b4574a58a729ea4b-1730301926"
  },
  {
    "email":"gemignani.fabbri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488317818/095980772be0fe0e2fc349d16655dd38-1730301926"
  },
  {
    "email":"pietronasorri@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488219514/e6de805d3526e92ff2c05809c06d7847-1730301926"
  },
  {
    "email":"sansoneromilda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488350586/05112fe69ef1991115a10a6d35fe3bb0-1730301926"
  },
  {
    "email":"federicaparlato@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488186746/523a85d38796821c3fca537a1c653f47-1730301926"
  },
  {
    "email":"raffaellariboldi59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488383354/1572ce25a78b63b8f47f30ea681fc493-1730301926"
  },
  {
    "email":"penzestim@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488416122/3e910beff37e5bf3bf1cde91c6ffbef2-1730301926"
  },
  {
    "email":"evelyn.watzka@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723488448890/0d03ff6ceb7cc4b4e561c0490ba4a60e-1730301926"
  },
  {
    "email":"info@bianchigiavotti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488547194/aeca6f96cefa0502aaec6527f4acd04b-1730301927"
  },
  {
    "email":"rossana.novati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488481658/8d6f87bc3fc4555c1098056dbac6d4f1-1730301927"
  },
  {
    "email":"barbi2giori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488711034/1908eba68442124c3e978b1a82b28b13-1730301927"
  },
  {
    "email":"hicari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488612730/7486a79221cafa7b702aac30ffe38c0a-1730301927"
  },
  {
    "email":"fparma@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488743802/4eb207d90d6526773e17265a88fd897d-1730301927"
  },
  {
    "email":"ranierigiovanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488776570/3481da6922b8c9ba7091b3c0c5ab4397-1730301927"
  },
  {
    "email":"elisa.lafranconi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488645498/eaddb7185cb44963c502f1eac23cb178-1730301927"
  },
  {
    "email":"ntinaspadaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488809338/289c0bf64bf8fa24f9cb49c4ff95292e-1730301927"
  },
  {
    "email":"cristina.faranda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488907642/e4c868bb06a3e54a32e198f6f3edb438-1730301928"
  },
  {
    "email":"luisa.stevanato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488874874/706331cb33e674768b869227018fa310-1730301928"
  },
  {
    "email":"marcydistefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488842106/873d46c53d254f200a7bfcb599fd1b68-1730301928"
  },
  {
    "email":"clberner@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723488940410/848331af9214ad05f66a1a34ac69bf38-1730301928"
  },
  {
    "email":"e.gazzr@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489071482/ce7a0f8d33b94e1624cf7927154a3dbc-1730301928"
  },
  {
    "email":"cinziapinello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489038714/5d49b5181ba47c0843d21974d3e45e6d-1730301928"
  },
  {
    "email":"graziellarassu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489104250/8eb55a1d2761b91d0e5a9118a391033a-1730301928"
  },
  {
    "email":"z.stefy@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489202554/2069fe706816f0e0e3fce8daf30e885f-1730301928"
  },
  {
    "email":"arita.deangelis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489137018/7a263c490db12d41d13de42676f76a87-1730301928"
  },
  {
    "email":"adriana.solzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723488973178/dced82576b093d885d54235535a45e26-1730301928"
  },
  {
    "email":"santa.natuzzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489333626/72ccf2a58f6a4698d0b5633d6d7156af-1730301928"
  },
  {
    "email":"ersilia1984@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489235322/d077beb2e341e5ac2837434fe095c9c8-1730301929"
  },
  {
    "email":"idizdari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489268090/25e58d98dfad14d5dec61a169eff949a-1730301929"
  },
  {
    "email":"d.nadia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489366394/03dfc48709b12cc48e61ababff4e84f7-1730301929"
  },
  {
    "email":"serena.maccherini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489399162/353b4ab16e9b0f1e0e72ac33623a3815-1730301929"
  },
  {
    "email":"orsi.barbara@slice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489431930/206c1fa4b2bbb501dbe291ac6d7c2943-1730301929"
  },
  {
    "email":"lorenzinabo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489464698/1d25977230cc6bfa18d3eac0bfd3fcb8-1730301929"
  },
  {
    "email":"doris.flo@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489300858/05f323ef42fee519fa6f3700973356be-1730301929"
  },
  {
    "email":"katya.franceschetto@fasalserramenti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489497466/bfd4fa4fc10395191f56011738583df3-1730301929"
  },
  {
    "email":"maquilanti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489530234/0910b9ad188f90315eaa66e56cf9afc2-1730301929"
  },
  {
    "email":"betti.laura83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489595770/c140243782f746f8d743e144ef319ab8-1730301929"
  },
  {
    "email":"maria.vergnano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489694074/7d8a9ef6eab9dbcf203fbae3990aa4f6-1730301930"
  },
  {
    "email":"saralandi.co@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489628538/73bceeb92af32967dfc2f853b25328e2-1730301930"
  },
  {
    "email":"alessandra.demasi290@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489563002/c2cdebae77fc673b52b8621aab68b4cd-1730301930"
  },
  {
    "email":"monicamarini.mm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489759610/190cb7e36ea7b22791c8146b0dbeafef-1730301930"
  },
  {
    "email":"vera@studiozingerle.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489825146/30d9671ff90e192644fa8bfe20f0c6f8-1730301930"
  },
  {
    "email":"v.boriani@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489792378/27fd3cbca13bd33ce3e1ca30130d23f0-1730301930"
  },
  {
    "email":"mirellamicelisopo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489857914/efd656239bcecdf59ad6f1394a23ec2e-1730301930"
  },
  {
    "email":"monicapirazzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489890682/d2736068967a60182af0c0914a4b7c92-1730301930"
  },
  {
    "email":"alpale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489923450/3decc6577dd5a2d792e782617bf8b9a9-1730301930"
  },
  {
    "email":"annaongaro@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489726842/869ca92e46fd91310e82b8f627002713-1730301930"
  },
  {
    "email":"aborsi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723489988986/cc4978c935cbd2e2379031081a54018e-1730301931"
  },
  {
    "email":"francescototti03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490021754/c85f11bb0685f5909430d1d8346c7b8b-1730301931"
  },
  {
    "email":"carla.digio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723489956218/410b93658d19ebead606cce56b8dbd94-1730301931"
  },
  {
    "email":"deflandreannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490054522/1fb70c75d212a55c939c7e85cb872c2a-1730301931"
  },
  {
    "email":"cinzia_toccafondi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490087290/146eda283d8720ee9c6d998b4700e038-1730301931"
  },
  {
    "email":"raponiantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490120058/fb9a05d6219dcc2732a625ea0587e6ab-1730301931"
  },
  {
    "email":"dr.paolaminetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490283898/7c5c6cc9f7e6bf1f3e54b945508bd763-1730301931"
  },
  {
    "email":"angelocamata39@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490251130/6bf5a21109f65cde945c9b84ef2458ac-1730301931"
  },
  {
    "email":"simona.logoteta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490218362/848d570acda4b3d54c53b766e88a56ab-1730301931"
  },
  {
    "email":"elena.monte@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490185594/854ef078ec726b9824d3e53be3134b16-1730301931"
  },
  {
    "email":"jingch3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490349434/8e53d16c6582e64237de2e0f4dca7b9a-1730301932"
  },
  {
    "email":"sabrina@chocoeventstravels.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490316666/e53d0d657a1164c0288075e607033804-1730301932"
  },
  {
    "email":"ceramaria@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490414970/59e26844e0a39a39bd43873a43746b04-1730301932"
  },
  {
    "email":"wcialu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490382202/6259916bf6f763adda76aea7d922de03-1730301932"
  },
  {
    "email":"giovannavalnegri66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490480506/87845e2defb92b4a837f89064b894120-1730301932"
  },
  {
    "email":"aldmar2226@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490513274/8b26907343f4c90a0cfaa521a96255f0-1730301932"
  },
  {
    "email":"amidiga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490611578/633c98bbd0e342dd18ccc25504b8e127-1730301932"
  },
  {
    "email":"susannafelicetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490578810/8dd847d54e2a7d2ca02e02aba0eefdc0-1730301932"
  },
  {
    "email":"lucia.gallo.lg45@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490447738/cb4f017ee62703ccc4a9abc12b75687c-1730301932"
  },
  {
    "email":"barbaraciani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490677114/68762b0f122e25dd954922a40cafc5b5-1730301933"
  },
  {
    "email":"gigliolamarani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490709882/62e83ba5ea90c140715dff041ed8b88d-1730301933"
  },
  {
    "email":"franca.batistini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490644346/c32fe701b8cdcd99fcf533fe997df083-1730301933"
  },
  {
    "email":"lagrandebellezza67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490742650/543d549a1cc42a343ecc59317cb9b912-1730301933"
  },
  {
    "email":"luisan@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490775418/bdba50b30873fb9f7d9539bd30f60eb7-1730301933"
  },
  {
    "email":"leandra.vindigni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490808186/8d22351ed62bbe7ac2d51b890ccb27a6-1730301933"
  },
  {
    "email":"elisabetta.gueli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490873722/bae2bd2599c466ffcda7e26d48d27ee9-1730301933"
  },
  {
    "email":"annafalabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490939258/1f314505d838eae836fbb1dd44a3f549-1730301933"
  },
  {
    "email":"francydifonzo72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723490906490/23dddd76bda290bfff2f8be2e8d4536e-1730301933"
  },
  {
    "email":"manuelaleo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723490972026/1b7534d88ebdac13cda0f9b73ba6be33-1730301933"
  },
  {
    "email":"elenabartolomeicorsi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491037562/a16ed0cbb8b12239554987589c750a01-1730301933"
  },
  {
    "email":"silvia.collestefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491070330/e23ec9543defc3510d127fc0f772e354-1730301934"
  },
  {
    "email":"lugano.claudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491168634/c025f0f56d1cec2693d2a8d2b09218a7-1730301934"
  },
  {
    "email":"babyospix@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491201402/e040f31858dc27314dee085aa46ed5f2-1730301934"
  },
  {
    "email":"r.bernacchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491004794/74d98468784ada7b959644109c2ec51d-1730301934"
  },
  {
    "email":"tamiazzo.daria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491103098/891076f13fb91a7a9a79eec44d834374-1730301934"
  },
  {
    "email":"paolafernicola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491332474/df01757715d8c8993ee8e141c39aab04-1730301934"
  },
  {
    "email":"stefania_dilorenzo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491234170/8e768925dbfc38f3780a4c43b145e52f-1730301934"
  },
  {
    "email":"cesca.fil@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491266938/19c9026581dcfa03e3e7df70cea8ba9e-1730301934"
  },
  {
    "email":"cima97@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491299706/8d900a3325f8f41d8341978003412d59-1730301935"
  },
  {
    "email":"tatianafantoni1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491365242/a2771ccc6be6ac269759a3b50d60f014-1730301935"
  },
  {
    "email":"paolobettio49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491463546/82ec877975a9abcaca4255b52de3a6fd-1730301935"
  },
  {
    "email":"alessandralorenzi86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491398010/3f5401a7b0644688af8f986ab1cb703c-1730301935"
  },
  {
    "email":"evegh75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491496314/2f3bd7ba669ec5252998868818aa1785-1730301935"
  },
  {
    "email":"martinacavallin@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491529082/d3f4f626af118962ec92a017a9acc523-1730301935"
  },
  {
    "email":"danielalbarone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491561850/9704dfdd5162dbf5e141787417feea33-1730301935"
  },
  {
    "email":"erika.eh70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491692922/5e771fccf12c39fc674922883b555bc9-1730301935"
  },
  {
    "email":"stefano.terragni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491856762/c999b0290ac5effbccee3afe1e9b33c6-1730301937"
  },
  {
    "email":"graziella_lenzo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491758458/6f119ee53263e02641072732598e6987-1730301937"
  },
  {
    "email":"maramaffei2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491823994/f1091ccc5e45bda4db936017e134c956-1730301937"
  },
  {
    "email":"cristina.branzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491725690/5dcbce427db2e0ff32f4a9a26d43c251-1730301937"
  },
  {
    "email":"limolliannamaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491922298/5c03a8362d288c536a5879de5f9cb663-1730301937"
  },
  {
    "email":"giuliananasti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723491955066/bbb9b29577219c5761e0074760996a3c-1730301937"
  },
  {
    "email":"autobrianza@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723491987834/e86fbe8cc11703b2e2e0f84be85dce59-1730301937"
  },
  {
    "email":"valentinabiondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492020602/d1f1280606acf02458d59a7e2ebb9f01-1730301937"
  },
  {
    "email":"elena.martinazzoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492053370/9eb02696879d7837f375904b6882eca5-1730301938"
  },
  {
    "email":"paola.mortarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492086138/97f5cb169731599b2f2b00a9b2ade78f-1730301938"
  },
  {
    "email":"paolabarbieri59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492151674/18a381a98c76263553fe493f6b61580f-1730301938"
  },
  {
    "email":"gal.gaetana@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492184442/6e39972eb3de44441a4a2bfe4a3ba00d-1730301938"
  },
  {
    "email":"russo.ambra05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492217210/9e4bf354a5cfebe7a139d924bfb04108-1730301938"
  },
  {
    "email":"peruzzi_cristina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492282746/158670f582c6c3f850a4a4e754136319-1730301938"
  },
  {
    "email":"stefaniarossotto498@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492315514/5bb83b83ae44cecd9d4f5d44354afea3-1730301938"
  },
  {
    "email":"frtcsr@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492249978/4d2e4d009a7edda1b2382fb97459159e-1730301938"
  },
  {
    "email":"stranomavero.ts@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492348282/28af6612a8438f08d909bb077b0c07f2-1730301938"
  },
  {
    "email":"raffaellatomasigh@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492381050/ece2208f8a5b7b13d83328d5c71cf1d2-1730301938"
  },
  {
    "email":"area.gatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492479354/4bfe4b7ef92cd8ca25ba67f882d9a374-1730301938"
  },
  {
    "email":"gelli.cris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492446586/197875ac9891c1f5a67b110d39343278-1730301938"
  },
  {
    "email":"supercabal@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492512122/f565b3eb2041096e9f3af4ff481c139b-1730301939"
  },
  {
    "email":"annafatarella4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492544890/6cda2fd7f350a82b80d989963f2caa9c-1730301939"
  },
  {
    "email":"gentilangela69@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492643194/1015b04e20656187f0fbe51aa5d50471-1730301939"
  },
  {
    "email":"office.mzangrossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492610426/8d91b1a6ccd019244d12204fd88c3289-1730301939"
  },
  {
    "email":"beatriceproperzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492675962/877dd2b27f30b6365dfba1f6292bca21-1730301939"
  },
  {
    "email":"moreno.di.dio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492807034/fea79bec2805c76bf67ccb9784f062e8-1730301939"
  },
  {
    "email":"gpomin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492839802/2ca26d3af66c4ed7a24376d255f89895-1730301939"
  },
  {
    "email":"bianca_lombardi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492872570/f2336b269f3435066c63dd17e3fc54f1-1730301939"
  },
  {
    "email":"gianna.bini.firenze@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723492708730/1fd63c241c68b395e4f938da345d74c9-1730301939"
  },
  {
    "email":"volpegiovi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492905338/33b969e875bb2a1146c73aef3503a0be-1730301939"
  },
  {
    "email":"rosangelacolucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492774266/08cbde74aa807db0f94315a1ffcf26d3-1730301940"
  },
  {
    "email":"beccari.venturi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723492938106/91ab23c6f09bd93219240f147bdb1d2d-1730301940"
  },
  {
    "email":"adriana.firenze@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493036410/cf7ab11e4871ea3989165b82265f9dd4-1730301940"
  },
  {
    "email":"tildegiacomelli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493069178/cc2122ef880c2239e59579ee6cbee72a-1730301940"
  },
  {
    "email":"marticeccolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493003642/2109a2dc69ccef51cde3a1246c49375a-1730301940"
  },
  {
    "email":"assuntabinati@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493101946/dbbdbec783aea47ced9736f7ca698b1d-1730301940"
  },
  {
    "email":"domenicacartolano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493167482/aff83366cb5069179dd3288811fb905a-1730301940"
  },
  {
    "email":"lauradilonardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493233018/ad1412ae0e72d73ee63312f12391dd6a-1730301940"
  },
  {
    "email":"l.leccese77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493134714/ad5539525011205e7b2ffb130e0d8881-1730301940"
  },
  {
    "email":"teresapochiero@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493200250/27671d86c776e864e1a5cf1fc9b69de9-1730301941"
  },
  {
    "email":"mandrapino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493265786/8f2f460bad81a3f9afebf385bb613e10-1730301941"
  },
  {
    "email":"mavibre@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493331322/06e596b6df262bec561929ae40c233f1-1730301941"
  },
  {
    "email":"danielafroda72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493298554/10f12450d30df585c86adfbc3633108a-1730301941"
  },
  {
    "email":"lauradallacqua3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493429626/448ff7682736bbfff35e4864bd61decf-1730301941"
  },
  {
    "email":"fbonin@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493396858/65206c86c2cea93147ad06b8ecdaddc9-1730301941"
  },
  {
    "email":"ari.dalmasso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493462394/4f68f64ca096956aa5c25fb621b15fd6-1730301941"
  },
  {
    "email":"bellotti.susanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493495162/ddc6dd475e75c7c2162298ae16aa7177-1730301941"
  },
  {
    "email":"annakosiba@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493560698/81547e33212deac4a041b5ec5a36dd0d-1730301941"
  },
  {
    "email":"dcontrafatto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493626234/72fc8c07d6b50016592b31b282fb713e-1730301941"
  },
  {
    "email":"kmelxhionne@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493659002/0f34ce4c6114184f480610b5326c2a89-1730301941"
  },
  {
    "email":"ducciapulcinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493691770/1222825e5211564ff7acab8b035e61c3-1730301941"
  },
  {
    "email":"prosek1036@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493757306/686e77ebda4a3f3c49cc041b85c736e7-1730301942"
  },
  {
    "email":"monia.zampineti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493724538/ab84b56a14925b4f234e1147f7d0bbb1-1730301942"
  },
  {
    "email":"giliberticristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493822842/e64446b6353b0216e86389aa2532f054-1730301942"
  },
  {
    "email":"perlanoir86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493790074/d0e5adfc9d2620f338f12cccc0a60b33-1730301942"
  },
  {
    "email":"cogo.roberta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493855610/88f1968990a2420bb41be23efb47dbe6-1730301942"
  },
  {
    "email":"elisagambalonga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493888378/af8e28fb04ce47f06eccce0a4c92b90c-1730301942"
  },
  {
    "email":"marta_mor1989@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723493986682/2f8599967e50298b48c0192145df94d5-1730301942"
  },
  {
    "email":"tiz.bellani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723493921146/e9d84e828668b147603488cf2b03f18a-1730301942"
  },
  {
    "email":"marta.tanzanu@studio.unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494052218/f59cce652d647f35d855231e127fc450-1730301942"
  },
  {
    "email":"fabioeannalisa9096@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494117754/3b8693ab510e8d13f3654236f11b8993-1730301942"
  },
  {
    "email":"robypaolo99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494084986/475021b726c4746ff6156a6a5b379e5d-1730301942"
  },
  {
    "email":"t.gioia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494019450/f86d77f1320a4fc510c0071549844dad-1730301943"
  },
  {
    "email":"patrizia.brazzale@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494314362/2fc6cc6658aebcb91c0099829dd4035b-1730301943"
  },
  {
    "email":"paola@immontecatini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494412666/b6ff11acee59fc60b12742ab1d312e65-1730301943"
  },
  {
    "email":"tellina72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494445434/45183c63a43233325403e6fb3159f081-1730301943"
  },
  {
    "email":"marina.bini1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494478202/9cc486b8b0e674cb99278a0ec1959e51-1730301943"
  },
  {
    "email":"silvia.nucini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494248826/486fe5889c3e05780ff572870ea5ded9-1730301943"
  },
  {
    "email":"clod717@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494510970/23e97025326950408513cbfdf8915ced-1730301943"
  },
  {
    "email":"mariateresaservidio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494183290/86df92cd6da6c2bbbda3ec3ab96cf5c0-1730301943"
  },
  {
    "email":"ilaria_veltri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494543738/859071e22b9de243b02e09754698a4dc-1730301943"
  },
  {
    "email":"ivana.bressanib@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494576506/6a328fe5f8526cfe5d6ad910a81d7d8c-1730301944"
  },
  {
    "email":"lidiablankiewicz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494707578/41ca68674a50937c65cdbc7a2471739f-1730301944"
  },
  {
    "email":"mapi75@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494740346/12c08fdb3ac90ebefcfca06fc2aee4af-1730301944"
  },
  {
    "email":"mariluberg@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494674810/0e558eb808756220900ad33c49d37d28-1730301944"
  },
  {
    "email":"lucialucarel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494838650/a8a6c9f724e7d93e0fa0717d1e22a282-1730301944"
  },
  {
    "email":"margherita.madonna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494609274/347002259a50043595c2cc1a6e69c874-1730301944"
  },
  {
    "email":"soattini.micol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494871418/0f6919c7736ca69c714ee785a08b13e2-1730301944"
  },
  {
    "email":"pkg81@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494904186/58c7faac7557d13c3d77bfac73696f24-1730301945"
  },
  {
    "email":"claudiaginnari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723494936954/aec71fc33dff2b0e32b956f51be01a50-1730301945"
  },
  {
    "email":"cosetta.marchionni@unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494773114/28e719e40c6bd2b311baa0e86d52ba90-1730301945"
  },
  {
    "email":"scalese@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723494969722/3bd3b1ff89da7f9389c8fed3db10ca40-1730301945"
  },
  {
    "email":"desdiana@unitus.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495035258/044d2e33d901d0e4f223cce79ad92f5f-1730301945"
  },
  {
    "email":"pergamena56@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495068026/2a78df58e05ae2f875cc76abd2a33c0b-1730301945"
  },
  {
    "email":"stefaniaceconi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495100794/48ae710978408b5a2ff972e5f3e32700-1730301945"
  },
  {
    "email":"defino.lui@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495133562/75ca371c812a728381d4ffa0964eb2aa-1730301945"
  },
  {
    "email":"barbarabonacini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495199098/bcb1d844c4fba47e4c556fe3d7d1ff5a-1730301945"
  },
  {
    "email":"valentinaracale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495002490/a3990bbbc5edbac92edaba485cbbac1e-1730301945"
  },
  {
    "email":"barililan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495264634/b4720f70a50aa826135a0b8abe44aa0b-1730301945"
  },
  {
    "email":"francescamartini965@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495297402/1dbd1e6ff21f54582d0fc1314988ed9d-1730301946"
  },
  {
    "email":"ariannabl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495231866/3cb1651f08aacff5eb7b269ea1b6f42a-1730301946"
  },
  {
    "email":"texdiletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495362938/46b75b09d45c8adb769e2c97e8f9dea3-1730301946"
  },
  {
    "email":"alitkic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495428474/5935237d4286df700c935323c2dfe6bd-1730301946"
  },
  {
    "email":"moni.graziano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495461242/6f853aea0c592262d948ea4677f949c9-1730301946"
  },
  {
    "email":"cinziasemprini3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495395706/a880c0e4a82c6d17bc41feca1748c2de-1730301946"
  },
  {
    "email":"valentina.fiorin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495494010/f9eff5d966da1623e94c4bf0dd109b42-1730301946"
  },
  {
    "email":"sabine.bertolotti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495657850/6d947cbc4f07acd66c9126ef8526d99b-1730301946"
  },
  {
    "email":"valentinabassi96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495625082/e41d7fca5baa968014c020057ae49809-1730301946"
  },
  {
    "email":"paolatondello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495723386/1936d24a9376a8c88601a8ea87d4cd59-1730301947"
  },
  {
    "email":"monicabale@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495690618/ccb9d6977a6cb8b16f4fd2f3e88089ba-1730301947"
  },
  {
    "email":"cecilia.imperio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495559546/524f21e0f076986ab9d7905a04b538d2-1730301947"
  },
  {
    "email":"myriamrusso@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495788922/6cc604f3d158440bf0dc29efb1d46e94-1730301947"
  },
  {
    "email":"architetto.lancia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495330170/20b30f20c2de1e03f887161018e95e39-1730301947"
  },
  {
    "email":"puppolorena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495821690/5ae441c994e030975237163174421b02-1730301947"
  },
  {
    "email":"tittacesareo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495854458/59d26935e50ad448d3f8d7e888b96094-1730301947"
  },
  {
    "email":"eboncompagni@aboca.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495919994/475990d4bbff33a4b1eae8dda7afc280-1730301947"
  },
  {
    "email":"bdiegx@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723495952762/c8614edb8cda9e82409cabf154a6753f-1730301948"
  },
  {
    "email":"antonella.corciulo83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495985530/3398bf646aae6b6811e42900624ef5be-1730301948"
  },
  {
    "email":"merlone.luca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496018298/310a594b5b943eae773e53f119b04015-1730301948"
  },
  {
    "email":"ina.juergenson@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723496182138/4521aac84e986a45175692d6dfe231ee-1730301948"
  },
  {
    "email":"marcellinacarattini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723495887226/c5c63fa33a89d3dba282c90a4e39ad73-1730301948"
  },
  {
    "email":"antonellacargnoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496149370/38a7135a3d54be7a37d484d045cb43f3-1730301948"
  },
  {
    "email":"mariachiaraberni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496247674/edf0dca1d72f6d8917165393850557d6-1730301948"
  },
  {
    "email":"katharinamichel3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496214906/398345bd1c088c6ac27ae22a48fe1fe6-1730301948"
  },
  {
    "email":"arch.antonellaguida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496378746/569c67b16b3e31612e8ca98b1afbcdcf-1730301949"
  },
  {
    "email":"r.dechiara@pianetaimpresa.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496444282/d4c7fade641672fbf7fd0ca1389e2a5e-1730301949"
  },
  {
    "email":"brunistefania.ps@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496280442/804744eccbb0c1e25570f15091cefd3f-1730301949"
  },
  {
    "email":"kety.luzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496542586/01c7b578e0a2e2fc02fc5ce4536e48d3-1730301949"
  },
  {
    "email":"bellussia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496509818/a68c2cb2a2ca28fb5aa061ce5ecf10a0-1730301949"
  },
  {
    "email":"simona.tomassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496477050/4c82539d9db354526a75913810241304-1730301949"
  },
  {
    "email":"vecchionevincenzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496345978/4ee02fcb5b556c9c130aeb7bc462df03-1730301949"
  },
  {
    "email":"adifabio08@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496640890/15e0505d63d6f9e5e1baa744f21fd72d-1730301950"
  },
  {
    "email":"paola_giuliani@it.ibm.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496706426/4d5688a5692d67820a01c761f982f2a3-1730301951"
  },
  {
    "email":"bellaisa.benedetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496771962/b891ad70f452d0ddc36be0aa59afdb74-1730301951"
  },
  {
    "email":"valeriapolla@yahoo.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22723496673658/19615af64290c88e8dfbf415c0875b58-1730301951"
  },
  {
    "email":"mari.attianese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496739194/82845d89d7d7afae9408caedfc969c5d-1730301951"
  },
  {
    "email":"lauracasciaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496804730/74518411ccb3d2ed66df2d4e4d11f3f0-1730301951"
  },
  {
    "email":"eufemiacampana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496903034/e90c17bc9f8fdd297070cab16306c1a0-1730301951"
  },
  {
    "email":"giovanna.bertazzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496870266/a99af53085dc70fd78c9a56ffb231aa7-1730301952"
  },
  {
    "email":"monicafrancardi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496935802/1368882c9c461b0dd53fcdd712a55c42-1730301952"
  },
  {
    "email":"denypitta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723496837498/06f4d2321fd6be3fa46bec5a2e651c98-1730301952"
  },
  {
    "email":"oronzopetr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497001338/0d6a6f21bb787d16cc8551dec20c5ff3-1730301952"
  },
  {
    "email":"saija@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723496968570/cb97205dbfd8be7bf41c68d23407c1b1-1730301952"
  },
  {
    "email":"francesca.evangelista1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497066874/d1aafcd99f790b875dd53c58845b2b48-1730301952"
  },
  {
    "email":"chicca6363@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497099642/63994510e1dc676e159a074d78442502-1730301952"
  },
  {
    "email":"libertyallen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497132410/e8dba8620cce317300a7b0f964a3c835-1730301952"
  },
  {
    "email":"federica@365giorni.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723497230714/bda56d1f9a5966520e05c6092887c451-1730301952"
  },
  {
    "email":"altieri.romina@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497165178/79fcfc00992e8fdbf21b37fabcaa5b8b-1730301953"
  },
  {
    "email":"caterina.3885@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497263482/aba64b766a4a3faca66edb91bb96996a-1730301953"
  },
  {
    "email":"chiara.consorti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497296250/180625a5248fb26275fa57128658226f-1730301953"
  },
  {
    "email":"lara.castellana1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497329018/dd67a9f15e0018402f7e56894b2d1cf1-1730301953"
  },
  {
    "email":"forcionemarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497394554/30b490dc4b6e0ddc2b1aae3aa8c7e1d1-1730301953"
  },
  {
    "email":"merivagnetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497427322/69fb592f24f72bcb3ebb5955cb5876d6-1730301953"
  },
  {
    "email":"stefanianzillotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497558394/39fdb158e2ac4f2c9065e88352d7100d-1730301953"
  },
  {
    "email":"paola15774@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497361786/d86989e8b62d04a1fdc9357c7b791dd7-1730301953"
  },
  {
    "email":"an.pastorella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497492858/2cc5e31ab6c142867adde8e541efc41f-1730301953"
  },
  {
    "email":"carloediana.it@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497525626/79225de43ed5663d05342b6cf37fcb9c-1730301954"
  },
  {
    "email":"aury201266@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497591162/d1f2d13c9ec503b6df5bb44a4365969f-1730301954"
  },
  {
    "email":"ale@campingdewijnstok.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497623930/9b8af752e73d2ad04e6abc755b1c01f0-1730301954"
  },
  {
    "email":"alice.tassini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497820538/bece7b8a60cc7c290d5c1de6e59bf636-1730301954"
  },
  {
    "email":"lauranive@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497787770/4c282692844672b0698584aec23e8ffe-1730301954"
  },
  {
    "email":"drubattino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497853306/1758269d534d68d532f289809e307b88-1730301954"
  },
  {
    "email":"perrottac@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723497722234/82a01ba5870c92048bb6ebecafbe6a1d-1730301954"
  },
  {
    "email":"gabrisca10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497886074/05844f5b85e2295eb779d553d21e5814-1730301954"
  },
  {
    "email":"nicoletta.ferramisco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497984378/422f20c6cade1217af42fa482beadf54-1730301954"
  },
  {
    "email":"tatiana.aldovardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498049914/7511523d3b4f279e5b2480bd0b0eee09-1730301955"
  },
  {
    "email":"orsetto_1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498017146/a464c76686c41dd651505ce3cb78b7d2-1730301955"
  },
  {
    "email":"cristina.bon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723497951610/901cb0995673dc8508aa52017e7fcd27-1730301955"
  },
  {
    "email":"faustber@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498115450/1f7f89d9177d65dbb5c0b854bad75fe4-1730301955"
  },
  {
    "email":"pirotta.lucio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498148218/c5e1128832424c24397e950da55f1995-1730301955"
  },
  {
    "email":"gabriele.manieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498312058/8ea282c9414aabb96c9e65b07a0b6fd3-1730301955"
  },
  {
    "email":"claudiabertocchi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498180986/7e4b2f5c1b81bdfc59455a5473f57c1c-1730301955"
  },
  {
    "email":"v.recalcati@optimizedgroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498344826/bb9ac5426e50cf37fe843e87f9feeaff-1730301955"
  },
  {
    "email":"antonellabertocchi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498246522/77d447600e25637b9c7a7503816068c2-1730301955"
  },
  {
    "email":"m.bounous@iusve.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498377594/9181a536f3b8a586dc1188322f404441-1730301955"
  },
  {
    "email":"caterina.stera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498475898/b8f85b50d4d650880e234a3e3d605e10-1730301956"
  },
  {
    "email":"elisamontali@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498410362/ac18d17b8dfb722310223866946b0e0c-1730301956"
  },
  {
    "email":"arianna.fioranelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498508666/117e91f2dcd3ee9574ecada754261bed-1730301956"
  },
  {
    "email":"sfalconetti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498541434/6258954548b3b3ec99b1f47be2c736b4-1730301956"
  },
  {
    "email":"giovanni.resta1801@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498705274/dd3faec5ca98339c418456ebd9f7aad6-1730301956"
  },
  {
    "email":"ilarimax@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498443130/015f28a72394e462e4dd5105067c77ce-1730301956"
  },
  {
    "email":"vittoriasantarelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498606970/88d8a8b700e0ae3e8a98bc95d8eb51f1-1730301956"
  },
  {
    "email":"annamariadilettera@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498738042/dffd4a8db6e33a9c255aa44c38cbdb6d-1730301956"
  },
  {
    "email":"saramoranda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498869114/78ca3dbf246f53be798403cdc8d72bba-1730301956"
  },
  {
    "email":"costanza.ferraris@pierremantoux.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498803578/7a044ac065a3378fdaf3f81830d6dd13-1730301956"
  },
  {
    "email":"paolo.carpita@fastweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723498901882/e8b66dd750b19461e10ea87e6a5ea5c7-1730301957"
  },
  {
    "email":"natvys@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498770810/71951eb8406b1dab8cfd61c49c2d4b66-1730301957"
  },
  {
    "email":"ro6@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499065722/e98864398416d7da25e735d84b7e8b8f-1730301957"
  },
  {
    "email":"grimaldifabiola1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499131258/1ed6257bf3d7a9495fddfbf2fd355a3a-1730301957"
  },
  {
    "email":"nicolai.lucia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499164026/60eed234823deb40e2e6cdbaf921b332-1730301957"
  },
  {
    "email":"loredana361@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499196794/f4dfc586e3f49964aba4419eb1d85600-1730301957"
  },
  {
    "email":"compenio2@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499229562/875320050403b552043f20aaed8fc45b-1730301957"
  },
  {
    "email":"maria.ferrari@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723498934650/fd4ec3aeb9050985d59ddfe16b925641-1730301957"
  },
  {
    "email":"lucatruco79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499262330/bc96cba36a9737f867b259102830f9c7-1730301957"
  },
  {
    "email":"lilianacoradello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499295098/18b4690809f19d43f1c3e648aa11310a-1730301958"
  },
  {
    "email":"sabrina_gh@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499393402/cd055d38b23e3341628162303493d793-1730301958"
  },
  {
    "email":"farmaciasantaelvira@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499458938/bea8dfa898ab7d083737ab70b35d93cd-1730301958"
  },
  {
    "email":"chiaratomei0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499426170/4700733c9adfd3ae675d4f6d34f2b04f-1730301958"
  },
  {
    "email":"pamelablescia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499590010/267e023f910da5be37c5b12c1e900fc8-1730301958"
  },
  {
    "email":"ddd@dkdk.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499557242/5ebada9ea4a70751a9fdc9994f3eaf11-1730301958"
  },
  {
    "email":"mjryam_90@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499524474/518dda0c3512578b485c814dcb6f57d5-1730301958"
  },
  {
    "email":"lancia.katy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499655546/09829def529e5c30795d178148c18235-1730301958"
  },
  {
    "email":"daniela.ferroni@finternazionale.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499688314/508860b6070c952cf35111e3b5101012-1730301958"
  },
  {
    "email":"marzia.puccianti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499622778/8cc7ea72d16a2e93e9fffbdf4baa409f-1730301958"
  },
  {
    "email":"stefania.borrelli.236@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499721082/6770edc5e2427dbc845451e070864503-1730301959"
  },
  {
    "email":"whitebibah@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499753850/5786239c2d1c7fa16359548e54facb85-1730301959"
  },
  {
    "email":"buffa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499786618/645ad379fff7aa613d263bb2a6feb87f-1730301959"
  },
  {
    "email":"ghettiannalisa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499819386/287bc15d064a2f737ca8d17d89e4e42f-1730301959"
  },
  {
    "email":"bellabonvo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723499852154/104b865d586f26027dc1aee599714587-1730301959"
  },
  {
    "email":"barbame@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723499917690/12a55978474c31228c57b15a494d66ca-1730301959"
  },
  {
    "email":"verabellettini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500015994/9d02b8b12e6e24d9bc239c54250e6bd7-1730301959"
  },
  {
    "email":"s.marenco@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500081530/65141e626bf27ab0fe73ff89ac35511b-1730301959"
  },
  {
    "email":"pierangela.dadda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500114298/c72b540d1765e51122ad7617541c03f8-1730301959"
  },
  {
    "email":"ciaogordon@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500147066/37b09e2efbc2fa4a4b0f84e92771eeaa-1730301959"
  },
  {
    "email":"mrti-milo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500212602/0299468e0742b6fa781fb3a64b3b1f61-1730301959"
  },
  {
    "email":"silvifrosali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500245370/6193eba5bd6c8ca4c44f648e0795e1f6-1730301960"
  },
  {
    "email":"katia.zuccotti80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500278138/b78401b799f4d0dea0b225a3f069daa9-1730301960"
  },
  {
    "email":"irenebande@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500310906/b1a28ae5cfc1408287379fe54176b30a-1730301960"
  },
  {
    "email":"raffy.perego@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500343674/e72251f603e7be7359c2a20a41741ae3-1730301960"
  },
  {
    "email":"gaia.salera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500179834/2ccd454c1cc91bbd940e1ca7f951eb63-1730301960"
  },
  {
    "email":"matteo929bs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500376442/b1265b17cc821a8ce5263317890f5394-1730301960"
  },
  {
    "email":"claudia.menini66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500441978/25773f197ffd50ffe9028bcbf28ff6bc-1730301960"
  },
  {
    "email":"ffranzon@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500507514/76ddcddfcea1b4260d575a8ff425b7ab-1730301960"
  },
  {
    "email":"cecilia.tedeschi1309@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500573050/1eb40cba452838b740978af8d5df78a5-1730301960"
  },
  {
    "email":"mariamilo37@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500409210/bc75dea598082a082fc97318336e75c1-1730301960"
  },
  {
    "email":"paolalunesu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500605818/60319f13fab2bf496ac9777a03120ff4-1730301961"
  },
  {
    "email":"mgiribaldi@ospedale.al.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500671354/d16db997dd5582081eb390171378c9a8-1730301961"
  },
  {
    "email":"checchettocristina56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500638586/20966071f9fde801299beffb5fdf1288-1730301961"
  },
  {
    "email":"r.turelli@gmx.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500540282/0c55dd30d6cb4854bbbb44e24aac6802-1730301961"
  },
  {
    "email":"consulenza.doc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500736890/a599e45e993f8a5fbb7c023d7bc5a19c-1730301961"
  },
  {
    "email":"ilaria.brandani@brandani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500769658/fc8cc8116063828d685c75537271642d-1730301961"
  },
  {
    "email":"ornella.pasella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500802426/da4da96157326186bc2b4dbd6a9e5c89-1730301961"
  },
  {
    "email":"barbarachecchetto1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500704122/4295d4b1850e5368808dabab9d53aff2-1730301961"
  },
  {
    "email":"mimargio1963@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500867962/a2a960c173b50be2b1432c1d44b98e80-1730301961"
  },
  {
    "email":"wsarettaw@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500900730/eed842a821ad4370392a99369507bee5-1730301961"
  },
  {
    "email":"paolagrassi.livorno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500999034/7cd90916200cda151c0ac6f19ad79998-1730301962"
  },
  {
    "email":"raff782004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501031802/6d3cf35a19a3d03ed6b5a6d5f124489b-1730301962"
  },
  {
    "email":"mvaltancoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723500966266/f1edeaa1b0e04ff726ca86a429349450-1730301962"
  },
  {
    "email":"mancini.maila@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723500933498/42914f54ce92aa5349f5a9cbcbbd0f65-1730301962"
  },
  {
    "email":"federicacucchi1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501064570/9d2feda7ac9e3573c584d438b99ba2d9-1730301962"
  },
  {
    "email":"stracciari.a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501162874/f4deb8443ab9ff8c9f93db9796173785-1730301962"
  },
  {
    "email":"eli.battisti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501097338/9502491c4dc032abecbc431dfc9b1925-1730301962"
  },
  {
    "email":"chiara.gasperini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501359482/2405d80ae75ff8d50f85476110afe3b1-1730301962"
  },
  {
    "email":"gallog71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501261178/892652d1425adc1c8b946917e0c63e53-1730301962"
  },
  {
    "email":"sabrinagiammarchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501392250/3f8b8fee855ebb0d34df063c064688a7-1730301962"
  },
  {
    "email":"giachino@unive.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501195642/46cdb07df5047320cdf10099071c947e-1730301962"
  },
  {
    "email":"avvchiaraventura@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501457786/b103e8969ef84fafff957963d84ed39e-1730301963"
  },
  {
    "email":"alyspallo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501556090/9d3b6c0c4926d749b38e46cc33bced3f-1730301963"
  },
  {
    "email":"mariapaolarizza@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501425018/8c9b8b882087938b4783fcf51d59e1b9-1730301963"
  },
  {
    "email":"luisabellettini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501490554/baba40fa9df703f42f1c5dec963d129b-1730301963"
  },
  {
    "email":"acasta@irf.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501523322/6fcbd416943ea3b922ae7ea5e6167d91-1730301963"
  },
  {
    "email":"martabozzola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501621626/9b9aea598db9bb6e3b83f1be12bf4526-1730301964"
  },
  {
    "email":"elenacarzana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501752698/f9625e7139ab91576d3cfdbb69afcc1f-1730301965"
  },
  {
    "email":"montanelli.marta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501654394/2f493d643ae1bebb5a25183691c02159-1730301965"
  },
  {
    "email":"beate.trojer@berofin.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723501719930/0be2db3655031d66af2ac0e20e6e9b99-1730301965"
  },
  {
    "email":"alessandraannetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501818234/54ccfebc87e5da3f05eb2a53efcfe8ff-1730301965"
  },
  {
    "email":"federicasilingardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501916538/fd471ba05c90daee6e6c67393754d229-1730301965"
  },
  {
    "email":"ilarimar@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501851002/a92f8f0c0ad105ee8e0b4df132c1441d-1730301965"
  },
  {
    "email":"niklasprovieri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723501687162/cddf242d469b0e6426c9a45b1780c300-1730301965"
  },
  {
    "email":"raffaellanapolitano79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501949306/5a40f32213b0a9fef3322d1d07d88b69-1730301965"
  },
  {
    "email":"gabriella.burchietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502113146/064c32f09b9fc25c89c67a57f78a6920-1730301965"
  },
  {
    "email":"jsfiorucci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502145914/07bbc6e99b4f236d54aee4e9c8bcc49f-1730301966"
  },
  {
    "email":"chiara.paviglianiti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723501982074/b645f8443ff30147f413165231dbfe75-1730301966"
  },
  {
    "email":"sara.mollea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502211450/107cf8a2a8693406f9901087df39839b-1730301966"
  },
  {
    "email":"giuliagiacomelli5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502178682/60fdc6056fe6d51f7c643140fc6d9fef-1730301966"
  },
  {
    "email":"biancasambusseti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502276986/59c116f0cc1c80a87c0bb05d5ace51c5-1730301966"
  },
  {
    "email":"francimazzini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502014842/dc8255149a5559f906db788dd5d98ded-1730301966"
  },
  {
    "email":"scm.daniela@scm-stampi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502342522/55b0988e08be32e379506faa5b44a340-1730301966"
  },
  {
    "email":"annadistefano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502408058/9e6e7a3553b3b323e0cb71fae83b5995-1730301966"
  },
  {
    "email":"stefa.lombardo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502309754/30a3847e9c20fc562a0810eaeb081ede-1730301966"
  },
  {
    "email":"a.chiriatti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502506362/54ae7756dd9951d1abf6a0d10b77524e-1730301967"
  },
  {
    "email":"avv.valentinamilan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502440826/fd3c8d9dd4d8f8e88c15fbed5a72378e-1730301967"
  },
  {
    "email":"pelagimilena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502539130/e4a1a41bb065d0dea865085258379655-1730301967"
  },
  {
    "email":"info@dentalmedsrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502571898/8f0eb36d4d58c494941221804810aec9-1730301967"
  },
  {
    "email":"bianca.alleva@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502670202/2cf796ef9a5d90ebf2712792c3d64c91-1730301967"
  },
  {
    "email":"ilaria.milanti@sdcinematografica.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502637434/a4d1731b60695e8fd3640ed3c441849f-1730301967"
  },
  {
    "email":"linaspignese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502702970/5d1cc467973da897c66dacbedc338e51-1730301967"
  },
  {
    "email":"francesca.emma.palandri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502604666/e9028402d47d274498c2c712879d5396-1730301967"
  },
  {
    "email":"giuliana.zagarella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502735738/7d4da12b500b29f9c212f82c88392d44-1730301967"
  },
  {
    "email":"susinavoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502801274/1bd112453c03af3b266ee463b92dff0b-1730301967"
  },
  {
    "email":"giovanna.pavi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502768506/57c05faca01cc7384674955892ae9e23-1730301967"
  },
  {
    "email":"alexie@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502932346/527b078ee0206d7ab2f4de866527192d-1730301968"
  },
  {
    "email":"cettinalibrizzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723503030650/9838fa9f8086b81865d9933d55361494-1730301968"
  },
  {
    "email":"luciadelsecco1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723502997882/603634d4d09355f44b9ca71dc620bc36-1730301968"
  },
  {
    "email":"silvia.cesana94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723502899578/a12b6feb1f5f725ce9f3221faa4a673b-1730301968"
  },
  {
    "email":"elena.pazzut@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503128954/aa9e887382a9163a69ff139fc4f5337c-1730301968"
  },
  {
    "email":"chiara.stefanucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503096186/d66f1e779df391b97ee135aa5ed2a5f8-1730301968"
  },
  {
    "email":"cinzia.ale14@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503063418/8e9c24ce54faf0e3c2baeb7343bc6264-1730301968"
  },
  {
    "email":"marta.ruggieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503161722/2d90d63ad721a2388ffc9e0b8170bb14-1730301968"
  },
  {
    "email":"kattakat@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503194490/587048e5e028da181dd5619d6895762b-1730301968"
  },
  {
    "email":"cecchinilorenza56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503260026/327010e4b66821f618595c3b110e8c26-1730301968"
  },
  {
    "email":"mantovanigiovanna1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503227258/f9a9d990c7a43758b09fdf92b005e715-1730301968"
  },
  {
    "email":"chicca.alb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503292794/0952cbbc3851e3af0ae08487cbf66118-1730301968"
  },
  {
    "email":"info@studiobraga.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503391098/6b0aafb2dd4e4aedf24aa0d5f7e75694-1730301969"
  },
  {
    "email":"rossafrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503423866/08bb23187b5a6a350524eab702fdcb65-1730301969"
  },
  {
    "email":"buba.alessio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503358330/d755db08c8860bae86d20ada27300552-1730301969"
  },
  {
    "email":"mz@businesslex.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723503325562/ea5dd27193d724d1ef12b688df97dc3c-1730301969"
  },
  {
    "email":"ricardo_salzillo@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723503456634/59f629cb8e77a81f219705e4633136da-1730301969"
  },
  {
    "email":"josianeungaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503489402/3a9627d9578aec6f06988ce5be95334d-1730301969"
  },
  {
    "email":"c.scarpi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723503522170/1085ee7b3f5b751fcda665dd02c1ca60-1730301969"
  },
  {
    "email":"cleliadesimone442@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503587706/8463e89dde443707d9ad5564c84f09f6-1730301969"
  },
  {
    "email":"patri.calabria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723503718778/3c7be9ca28cdce8a7b9bba7d71a5b49e-1730301969"
  },
  {
    "email":"aucieisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503554938/ac838bad55797306443c2fc09664c5d8-1730301970"
  },
  {
    "email":"tizianafalco68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503653242/e872caa28319fbb750a0c33cdcf7abf2-1730301970"
  },
  {
    "email":"stefania.barosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503751546/e7c00c5b8c0f36939fad9becee9e8148-1730301970"
  },
  {
    "email":"conceptlingerietiffany@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503784314/d583a854c002cd96060e45f7f7f16a43-1730301970"
  },
  {
    "email":"luanapigolotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503849850/d78432342ac9e385063b76bd9eac685b-1730301970"
  },
  {
    "email":"tienne.1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503882618/a36069a944a20745e13e76b2f5499eed-1730301970"
  },
  {
    "email":"annaricciardi99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503915386/362e3049d3d2ae328bd5ef39a54e759a-1730301970"
  },
  {
    "email":"sara74.b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503817082/dfc01a56c72823e5f2edd45d8127dab7-1730301970"
  },
  {
    "email":"marzia_bianco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504046458/cf5d07d433f1fc1e8beefed816614364-1730301970"
  },
  {
    "email":"mbergomi54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723503980922/634ee83a274f902b7611f769c69f5bb6-1730301970"
  },
  {
    "email":"marty.perazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504111994/db82e089c983702eb2cb190019f1fcf0-1730301971"
  },
  {
    "email":"bianca@lanificiotessilclub.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504210298/5bb9245242791f00b7843c3609e409e4-1730301971"
  },
  {
    "email":"marisa.grossi05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504275834/20de875a438fca1c722b9efb20bbfd1f-1730301971"
  },
  {
    "email":"giulia.bugna85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504079226/103b9769c8749f26439209e419845460-1730301971"
  },
  {
    "email":"silvia.coccoli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504144762/993c02adebd6f9af189b29cb7c17c573-1730301971"
  },
  {
    "email":"monica.alasonatti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504406906/70fb1462f71200f30eddaf6c871a1094-1730301971"
  },
  {
    "email":"news4lucylu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504374138/36b2c3d6ced5e15e7369a5aeaa54c166-1730301971"
  },
  {
    "email":"michela.volpini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504308602/0d17b0478c2ed8c83f421014d6e011de-1730301971"
  },
  {
    "email":"reda_981@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504472442/9ce3a96f2f711f39f31f29a4acf6122b-1730301972"
  },
  {
    "email":"idotta.s@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504505210/a5a53ef35c4facb1bb6d7b0ea7a0d6ba-1730301972"
  },
  {
    "email":"sabrina.veronica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504537978/15245639e54b200d3f57dc3e7e18f42c-1730301972"
  },
  {
    "email":"fogant@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504570746/51059c0cd135845b798c89baa536bd04-1730301972"
  },
  {
    "email":"vale1712@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504439674/9b9845625a3ce0e92ff8ecfa49ac5f26-1730301972"
  },
  {
    "email":"nicolettapalombelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504603514/dd73639a2e08f0f27a7932ee805f6af6-1730301972"
  },
  {
    "email":"fracottoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504734586/f548b8f2ca3c8c475cb0e07be53e9209-1730301972"
  },
  {
    "email":"federica.puck94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504767354/128314e6288a4829b68ce203a706735b-1730301972"
  },
  {
    "email":"ilabav68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504636282/d9632c9553dd52522752bbbf9e243d08-1730301972"
  },
  {
    "email":"santilli.gabriella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504832890/abf341f25fc7846408dda60dd240b89d-1730301972"
  },
  {
    "email":"soniadisimone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723504898426/9df9c5a5b6f45a9e15eae569eee51d0e-1730301973"
  },
  {
    "email":"corso.ottantuno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504931194/ebc2fc59f38630285b591639b6504336-1730301973"
  },
  {
    "email":"fedyfarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504996730/1b5072ab1973a28d3494b5b47f208189-1730301973"
  },
  {
    "email":"cauvaleria@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505062266/578e7eec78f0fcba7f63f6b72a105a45-1730301973"
  },
  {
    "email":"giorgialbertasilva@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723504800122/07c8e8c304743d36c9b266c430fa0de2-1730301973"
  },
  {
    "email":"cartolibreriagadgets@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505127802/b9d34fbced0d06371e6f3b78bd7714c8-1730301973"
  },
  {
    "email":"avv.gottero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505160570/65cc472d1d1fab8948bd6f495dcc9ca1-1730301973"
  },
  {
    "email":"sartori.mirco71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505226106/2a97a1cea82b7eae1e21aaa98987acfb-1730301973"
  },
  {
    "email":"r.cateni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505258874/2695380e1473bf2c65d2da9746af392f-1730301973"
  },
  {
    "email":"omniaprivato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505291642/18dd815bb99d1a5ea53737f5f0b4306e-1730301973"
  },
  {
    "email":"catiamasi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505389946/bc2e2bfbe85dcf35f57ba097270ea0b8-1730301973"
  },
  {
    "email":"valentinaa5@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505324410/40a3f23a4fea8b2b2d52e663889e7399-1730301973"
  },
  {
    "email":"picciolo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505422714/d6f7ef232d8cff3cf750d58d3f9c8f57-1730301974"
  },
  {
    "email":"costantina.d@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505455482/45adbb3a52e0f55727cc5ae0b0c7dd25-1730301974"
  },
  {
    "email":"michelameschini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505521018/3a3e070b5901ff59ec66bb51b3ba3917-1730301974"
  },
  {
    "email":"teresaadevito@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505488250/d31d816d1bee5821ba1ef013f380254f-1730301974"
  },
  {
    "email":"maramici@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505553786/ef79e8a71f50e8b6c08948d749274b19-1730301974"
  },
  {
    "email":"rosariafebraro05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505586554/452806f8296a6b36da50c0a58c4bde75-1730301974"
  },
  {
    "email":"patriziapiras@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505652090/f36269ebdb28cba4a97550d67c6b0421-1730301974"
  },
  {
    "email":"lulu899@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505750394/6633744875476cba8119cc2abfcfc2b9-1730301974"
  },
  {
    "email":"giuliaboffelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505783162/6caa0acce4c05ee4636d6b4f3b920881-1730301974"
  },
  {
    "email":"francesca.rossignoli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723505815930/f45b37bc71928db1bf37f993b86a8738-1730301974"
  },
  {
    "email":"palestra.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505914234/ef55a35ccd6dfdf6b0c5528d94f6e8be-1730301974"
  },
  {
    "email":"micciraffaele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506012538/417664deffdf86b5f35a9616502f4d9d-1730301975"
  },
  {
    "email":"giuliana.moro88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505947002/33fed0e88b2735afa7fbbb5549fb354e-1730301975"
  },
  {
    "email":"stefaninimariarita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506110842/40182b39b7cb9fa436184c3b4942ce84-1730301975"
  },
  {
    "email":"francesca.fagiolini74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723505881466/d6a33bc10d71775b2d0013c6282a96e9-1730301975"
  },
  {
    "email":"vanity-83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506143610/ca74bede58a24265be1cc019be14d513-1730301975"
  },
  {
    "email":"giraldingiulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506176378/a3b94ffcca1eb1e0afe1e6213573c513-1730301975"
  },
  {
    "email":"gfaletto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506209146/ca33c6c9f83664925f58d76542ef34bb-1730301975"
  },
  {
    "email":"robertaciampa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506078074/b3637b2bd51ac558ec0f6bb86e1b6fd1-1730301975"
  },
  {
    "email":"elenamagni15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506241914/a9005c29fe39dc6152a2c58a3be89bc6-1730301976"
  },
  {
    "email":"ele.bergomi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506372986/a030b603326508f5ba50211b9084291f-1730301976"
  },
  {
    "email":"annadistefano911@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506438522/9980c5783bc6b1a3d775d0887b62f6b5-1730301976"
  },
  {
    "email":"pasta2003@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506307450/a7582561daa6d2b477bbc60ed8313047-1730301976"
  },
  {
    "email":"roby.co@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506471290/ae8db54f06f6c5b23af1937cfe9aba73-1730301976"
  },
  {
    "email":"monicatabacchi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506504058/7fbb9ab2646fed9919a596aa634e94b9-1730301976"
  },
  {
    "email":"gerolaalessia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506340218/b9bed6b4318c55d8b990d9b59b2f94ba-1730301976"
  },
  {
    "email":"fedeqtt@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506569594/ede0f03eb2ba0c2adcbb51b970d6c3bd-1730301978"
  },
  {
    "email":"bvirzi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506602362/2de8ba428c7213c0d7c1fe8c1d309bfb-1730301978"
  },
  {
    "email":"laura.milano@a2a.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723506667898/6dcc98afca2f52c5f145f7402094bd27-1730301978"
  },
  {
    "email":"giulymak@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506536826/bf520f385312d7efe5a4b2fef070354c-1730301978"
  },
  {
    "email":"camillamariaacqua@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506700666/d8412df597608a1cd1a35112585374e8-1730301978"
  },
  {
    "email":"mistretta.flavio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506733434/b742a2f8bb7f5bdfed56471da00067f8-1730301978"
  },
  {
    "email":"g.delgrande@alteralex.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506831738/d24a56a18e10fa1a9c5f62e626d49567-1730301978"
  },
  {
    "email":"scattaglia@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506930042/fde6744c3ebe44cfd9b905fe0d586b3c-1730301979"
  },
  {
    "email":"c.velotto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506962810/5ee06563c2e94b6afa6e590fabc34d9b-1730301979"
  },
  {
    "email":"giuliafazzi92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723506766202/21bda2390382ad40bb083d9fc7f7989d-1730301979"
  },
  {
    "email":"daniela.baesi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506864506/05dfd9c114d662e9acce324210fb152e-1730301979"
  },
  {
    "email":"mcmunari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507061114/7fc6f5bc8ed6fe412a8f28e5c3428301-1730301979"
  },
  {
    "email":"v.raffo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507126650/1529ba6b3e98ecc1d6996c3453b7e9fd-1730301979"
  },
  {
    "email":"mariatortorelli@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507192186/dd878111168fd8ec9f4a31e5bdf89f19-1730301979"
  },
  {
    "email":"g.valli@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507028346/045cd672031f82a266f36e9a86aab1eb-1730301979"
  },
  {
    "email":"hmtre@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723506995578/75c08dfb8b4c2474735cf2e82c79d194-1730301979"
  },
  {
    "email":"bucci.ludovica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507257722/578a5a91dadd85eb7d4f749198313a29-1730301980"
  },
  {
    "email":"fr.montani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507290490/2cbd05c1e30aee10efa6279d0a56a9c3-1730301980"
  },
  {
    "email":"carlotta.castagnoli00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507159418/7139f53dda06275e1559898d6acc000c-1730301980"
  },
  {
    "email":"ruggero.dimiccoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507323258/1f85eb7b0f9f6b458171b0710df0ed8a-1730301980"
  },
  {
    "email":"colledavra@colledavra.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723507224954/7ce6145392d065b34fade34e19445115-1730301980"
  },
  {
    "email":"sergio.almerico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507356026/cba4aa0a5d928174b2b706f12bc21fcb-1730301980"
  },
  {
    "email":"lorenabordin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507388794/1e0cca2241311c12b86f437a671ffa69-1730301980"
  },
  {
    "email":"elisamarino74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507421562/8aae924d3db94a2e7b9c4e865b96c215-1730301980"
  },
  {
    "email":"annalisaf.85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507487098/4ca0e3dc6efbcbf7ec1d3bca0c087050-1730301980"
  },
  {
    "email":"silvia.cerbino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507454330/30fd5ab4d28f545562dd199c14aca60e-1730301980"
  },
  {
    "email":"ing.pulcini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507552634/4e04a791ffd0bcf29d50b2ad4054940a-1730301981"
  },
  {
    "email":"silvia.delmoro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507519866/0de4da43cfab49d9a18319f97e13c4f1-1730301981"
  },
  {
    "email":"rossella.coperchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507650938/dfefa84bcd16fc15ea652b5f6e8601d2-1730301981"
  },
  {
    "email":"veronicabolignano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507585402/5fbc4aa61cd74437c4a94e9ff87aa487-1730301981"
  },
  {
    "email":"stefanobellucci8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507618170/4c2d07e004afe7ad2d18869d55b77264-1730301981"
  },
  {
    "email":"paologiambertone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507716474/1dfac6be147b40aecd9f30ccc6fb2344-1730301981"
  },
  {
    "email":"info@paolaciminoavvocato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507683706/c5e60a2c3f4a1afd19780eceb6287938-1730301981"
  },
  {
    "email":"m.brizzolari@nastribrizzolari.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507814778/ba9daebe8bc51f31183dbaf2d43e9144-1730301981"
  },
  {
    "email":"federica2015@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507782010/dca95624ddd0b938bd65ebdbd0e0f09e-1730301981"
  },
  {
    "email":"silvana.barbacci@technet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507880314/7e723912f134814e5faf585c5f734b6b-1730301981"
  },
  {
    "email":"giulinabiker@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507847546/6477831069bae5e040021119a6cee7af-1730301981"
  },
  {
    "email":"gskggeri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507945850/8de299b53644b7d145595aa69ab56202-1730301982"
  },
  {
    "email":"stoyanconev@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723507913082/6f5fd4fc36e93ef6fcdf425bfbc7ce98-1730301982"
  },
  {
    "email":"giusydauria@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723507978618/c946a0251996b53407c03320acd7203c-1730301982"
  },
  {
    "email":"lorenabonetti.so@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508076922/962fb836f7dbc042b15198caf5e02f28-1730301982"
  },
  {
    "email":"daniela.ap@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508175226/e49f5e15c814fe31778bcb479f7d0c2b-1730301982"
  },
  {
    "email":"bellocchiseveri@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508207994/b1f6496ed6b2b1aabea410ea0ff37e8a-1730301982"
  },
  {
    "email":"iresechi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508011386/11b9987cd3d4e477198fcb31e6ed38a6-1730301983"
  },
  {
    "email":"manuelagiustiniani@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508240762/e6819311206f1e3f366a20f39c5e4a14-1730301983"
  },
  {
    "email":"elenamasolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508044154/228990c1310744b87a10b61137ae661f-1730301983"
  },
  {
    "email":"rozmarinka@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723508306298/9f8bd5dbf01e3702bca813ca0dec02e2-1730301983"
  },
  {
    "email":"m.ciarnelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508339066/4d9d27fc5c19d56c861413a883190402-1730301983"
  },
  {
    "email":"luca.strada1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508404602/822b2a7af885b324278540ee3200cc5d-1730301983"
  },
  {
    "email":"barbyl76@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508437370/36c64087b899eea1f5460d62025d0417-1730301983"
  },
  {
    "email":"avv.danielafalabella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508371834/380c0d7e8e59c48da57dbaa2d6f3087b-1730301983"
  },
  {
    "email":"luca.toso@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508470138/9c97302261519c70dbf8122f97736fe1-1730301983"
  },
  {
    "email":"saraboghetto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508601210/acfae10271cfd8a16ac482b984e24f56-1730301983"
  },
  {
    "email":"angelagallina00@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508633978/88b7672f444af821cf9ace2a2909e8c3-1730301983"
  },
  {
    "email":"mari.nella1905@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508699514/bf2baf3861c2339f95f83c9e54f5b232-1730301984"
  },
  {
    "email":"giostrero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508666746/3e892f5b1016d4f055d75a870ba3402d-1730301984"
  },
  {
    "email":"veraldivins81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508765050/e077c2eb5f3b78986fceff4bba5325fb-1730301984"
  },
  {
    "email":"escandale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508502906/20b1de9d43b219ca8c0c59e84ea18b7b-1730301984"
  },
  {
    "email":"fernianisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508830586/03f1683c4587715c063a85e8001afc16-1730301984"
  },
  {
    "email":"cinzia2796@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508863354/899c1f32ba30f643419dae2e1dbf8a1a-1730301984"
  },
  {
    "email":"lorella@nimarindustry.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508797818/69d263ca8001c0ce39b88b251433e49f-1730301984"
  },
  {
    "email":"valentinacairati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508896122/4b3b12784057390ad7df1ae793d97c03-1730301984"
  },
  {
    "email":"rossana.celentano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508928890/79a9227162dca12a9a15097fe2269e39-1730301984"
  },
  {
    "email":"michela5874@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723508994426/ac58208a9ab2a0bb4c8dc77781373da7-1730301984"
  },
  {
    "email":"silviadelmoro@hotelgiancarlo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723508961658/ddfa6623320c26046418344258ea3c20-1730301984"
  },
  {
    "email":"sobolevanatalya@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509027194/dac01b7af8d943f639ea6d164af28f02-1730301985"
  },
  {
    "email":"nereofaby@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509059962/c619321b53c8e894e902c93a1bc200fe-1730301985"
  },
  {
    "email":"coduttik75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509092730/7977d698d2dfa9efcea1dc69acfe885d-1730301985"
  },
  {
    "email":"pistoni.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509125498/0392df86f9b3a94ef92414f8cc9e6bd6-1730301985"
  },
  {
    "email":"giada_mim@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509158266/98bf3b70ec0e50b0641e622587d5feec-1730301985"
  },
  {
    "email":"auroragnoni89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509191034/1a3d75ecbe1e1068ebe833ba11762bb3-1730301985"
  },
  {
    "email":"frankoo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509223802/845ea3d5e756f80e3de0a37fd2582eb2-1730301985"
  },
  {
    "email":"pagani.nadia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509289338/bf0a146e1818f19cf16d6ae1a1b51839-1730301985"
  },
  {
    "email":"gianpiero.parente@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509322106/baebc2368554ae083ab1bcb0432dfbbf-1730301985"
  },
  {
    "email":"anelli.cristina@sicurezzapostale.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509354874/b1717121ca609477a6440b56e0c2f64b-1730301985"
  },
  {
    "email":"silvia.braga@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509420410/445d79d344df4310e06cd05e3a59d951-1730301985"
  },
  {
    "email":"stullo94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509387642/51bf084b8b6e792bebe0bb8d00ca7604-1730301985"
  },
  {
    "email":"maelamartin@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509485946/37a9499e11eb558e44651ef5533871c3-1730301985"
  },
  {
    "email":"enniolombardi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509453178/a8475e7bff5933b9a228fc7e83ff5336-1730301986"
  },
  {
    "email":"mastroianni.maria.grazia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509584250/6b6308fe1973a3c443e9af4af420839a-1730301986"
  },
  {
    "email":"stefania.lisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509518714/12d92fb45493278b443472a00a8e8796-1730301986"
  },
  {
    "email":"caputo.katia77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509649786/0c393b8a87b4c5e0c0ca8ba145d680b3-1730301986"
  },
  {
    "email":"saramolinari150@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509617018/a8824a37aad7d525f5cefbdf2dd0452e-1730301986"
  },
  {
    "email":"vittoria.sorrentino.87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509682554/96fb7920be59deb4344421e274fb3428-1730301986"
  },
  {
    "email":"palumbocarmela@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509715322/aaeb6c95e33d6dc67b9dc6d23ed4cb68-1730301986"
  },
  {
    "email":"angela.golinelli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509813626/c9855d0e3bac8250666a82b3bf045af6-1730301986"
  },
  {
    "email":"rapini.chiacchia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509780858/5588870a9a589a8f23a619732972e080-1730301986"
  },
  {
    "email":"luanariccio85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509911930/5661d9449bdf3c801f60f777bbb84151-1730301987"
  },
  {
    "email":"annaguag@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509846394/4feba47621fd4ede6c1b97be2b8fdde5-1730301987"
  },
  {
    "email":"michelazanca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509944698/2bc5d95da54c22f940eb5330377c5654-1730301987"
  },
  {
    "email":"federicabonetti02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723509879162/77bec1bd0ccc7279b5018d48fa32379a-1730301987"
  },
  {
    "email":"olgatortora96@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723509748090/7e201c8fd069aadf51ce00fbed31581e-1730301987"
  },
  {
    "email":"annacapoccia17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510043002/c3b5093c58ffacb707598768132a3a25-1730301987"
  },
  {
    "email":"assandrilorenzo4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510075770/2f36dbc46b720e90a6db289d6e9ca800-1730301987"
  },
  {
    "email":"barbara72.ub@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510010234/af4a9aab296c789cc9f4e696449c2ab7-1730301987"
  },
  {
    "email":"rossellanucci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510108538/a6c866343bd876ed572ce4b9e1cd06f8-1730301987"
  },
  {
    "email":"mgmliap@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510174074/847c0c7b4b11f371169aaf5fd70c5415-1730301988"
  },
  {
    "email":"marty070489@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510272378/acf36b5df882e64bdb5ba26fa60fad23-1730301988"
  },
  {
    "email":"mfilice28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510239610/2f234b7d4760c5184c370d7889e5f43e-1730301988"
  },
  {
    "email":"marika75b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510337914/250f3b7db0dfd26064d0c855678e174c-1730301988"
  },
  {
    "email":"albertacava@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510436218/7ca3ad2ebab03cdb89869cb5d29d6377-1730301988"
  },
  {
    "email":"steballa72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510141306/668fbb97c5e8f776955ad75ab9b47f8d-1730301988"
  },
  {
    "email":"falessandra1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510534522/de2b42825055442e4b793a73da126370-1730301988"
  },
  {
    "email":"angpalm68@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723510305146/aecd7590c51b351b0966e9634d07327d-1730301988"
  },
  {
    "email":"federicafonti@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510468986/81a9049f3c8bcad8c21170e7c8f031a7-1730301988"
  },
  {
    "email":"cguagneli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510501754/8f4e55bd310f453569677ef2410c8bbe-1730301989"
  },
  {
    "email":"macmati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510567290/f4a781bc7c96da1f98ff70698872f1ff-1730301989"
  },
  {
    "email":"enza3005@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510632826/8130007274a6fefa76f869f3092fbd81-1730301989"
  },
  {
    "email":"stefanocladi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510698362/1b29b683e5f6cb0f2916b916544d3826-1730301989"
  },
  {
    "email":"scoiattolo93@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510731130/0af3ede2e0055f75c5bee82b05863680-1730301989"
  },
  {
    "email":"cicca.anna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510796666/14637f03c5baa8b3e706632da5510bba-1730301989"
  },
  {
    "email":"caterinamarilenapollini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510829434/c21ed576cf0a9ee5f01c09516e376783-1730301989"
  },
  {
    "email":"ohanna8@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510665594/0f5d3652d8e6b7b183e7be34d0e52c08-1730301989"
  },
  {
    "email":"miriam.domeniconi@aruba.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510763898/b564bd0dacce665a0420a2aa839e3fc2-1730301989"
  },
  {
    "email":"fiocoll@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510862202/8e1f7eb0aa365e4a019b4141ef14b0b3-1730301989"
  },
  {
    "email":"danidsnt@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510927738/cabcfcde2b9ffb37af3cbf0df247ec35-1730301990"
  },
  {
    "email":"paolaballanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723510894970/f51afb86f5eea1c56df49dbdef18e62a-1730301990"
  },
  {
    "email":"manu.onnis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510960506/24ff47c84ae3ca75a415774665f57565-1730301990"
  },
  {
    "email":"casavirgili@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723510993274/c35143ecee7e8227f248d5117fcd53e2-1730301990"
  },
  {
    "email":"claudia.guarda3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511026042/b991a9c387150d1d58e408406bcbec24-1730301990"
  },
  {
    "email":"aschincaglia@confesercentiferrara.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511124346/385a764199ba1d1102144727c023cc73-1730301990"
  },
  {
    "email":"vittoria.sorrentino@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511091578/e69cecf7961005ce6e0f32501c41dfab-1730301990"
  },
  {
    "email":"spampatti.r@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511058810/e98752e229bb929c3505110ac051ce51-1730301990"
  },
  {
    "email":"ciano.maria8730@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511157114/77e3656c6d6904df1c837259dd7cca75-1730301990"
  },
  {
    "email":"mellini.francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511255418/c6c00c154f057c7387fad19c54b0edd5-1730301992"
  },
  {
    "email":"angpalm68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511288186/ed1f1ebcc69d490f0d1306945c27cb16-1730301992"
  },
  {
    "email":"cristi.acri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511320954/7734aabf991a699788c369ed3a450a1b-1730301993"
  },
  {
    "email":"dipietro.intimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511386490/af498f5d33c0ee43a2535f7ccbe1a353-1730301993"
  },
  {
    "email":"sivionica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511222650/7ebcf435ee8f1ceceba5103e7c4467a5-1730301993"
  },
  {
    "email":"catari76@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511353722/8fbc2877490c64a8c9b40c68bd6d6472-1730301993"
  },
  {
    "email":"violadanzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511419258/ff33912e2ed7360f045250e95028651a-1730301993"
  },
  {
    "email":"elisalorenzo11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511517562/b504fe82b70a91a4b3f48f28846c075f-1730301993"
  },
  {
    "email":"ro_rossi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511484794/444a8900944f11a3935fbb32b99040e8-1730301993"
  },
  {
    "email":"carlottaginevra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511583098/c4d62db8031f3f3a1c5a2a256b1673d0-1730301993"
  },
  {
    "email":"nadiaazzovedi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511648634/51d78aca41f01d978b52a35bdfc74977-1730301993"
  },
  {
    "email":"chinimattia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511615866/55dc51a9b70821cc9076a56a79f206e3-1730301993"
  },
  {
    "email":"irene.zoccali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511779706/f3f451f6500bfef118cf0c6e1d3ac33e-1730301994"
  },
  {
    "email":"angela.metta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511714170/013ac2a07640d1b94916508c23b588f4-1730301994"
  },
  {
    "email":"chiarav.paolof@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511550330/fc0ce05a589f0e479bfdd3539b7e31e4-1730301994"
  },
  {
    "email":"ilariapbernardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511681402/a3e2035f5b038fc9ac334ad79941acb5-1730301994"
  },
  {
    "email":"janaplev@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511845242/d18646de35b3359356a1952800abb8f6-1730301994"
  },
  {
    "email":"quaranta.simona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511910778/aca1d88519372552682cc9abab2f399f-1730301994"
  },
  {
    "email":"paola.gasparin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723511812474/78a8de375d9ca2eb3670aef1959b0399-1730301994"
  },
  {
    "email":"francesco.malara@fis.unical.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512041850/334d294873f229faa1c83a31220d6b8c-1730301994"
  },
  {
    "email":"elianabenvegna@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512009082/1ab52a0143a760bb3c983d3cab03cf3e-1730301994"
  },
  {
    "email":"alessia.clarioni92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723511976314/01e27096fe726a83e078c49ef0218cd0-1730301994"
  },
  {
    "email":"sheyla2231@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512074618/0476ec56d2b1176eb65366d852a24150-1730301994"
  },
  {
    "email":"eleonora.libralesso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512172922/085718d6bfa4fe3ae8dc74967c89914e-1730301995"
  },
  {
    "email":"laura_lagreca98@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512205690/34785cf326d9121411e688928b3d1a08-1730301995"
  },
  {
    "email":"benedetta.moracchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512238458/67b3a6a1109cbb3ae06940fe285df861-1730301995"
  },
  {
    "email":"cristinalussana1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512140154/76f479aa46bbdd9f59862aa8fd2df2ca-1730301995"
  },
  {
    "email":"d.sacca@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512303994/49b88517ebe174c46a42967c6db4ac0a-1730301995"
  },
  {
    "email":"mari.cattai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512435066/16abb1e7a8ea84869fc7e7fde0d86c96-1730301995"
  },
  {
    "email":"sabrydp74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512271226/00417da04fb56559e331e7dde89baf20-1730301995"
  },
  {
    "email":"cinzia.cresseri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512336762/4509e93f02c49031d79917548b7c7873-1730301995"
  },
  {
    "email":"chrislive63@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512467834/9b0d467e0a42fe5d1558b41e5c6dba0b-1730301995"
  },
  {
    "email":"freccetta1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512500602/de94306c8eb17cd5e9c2701ccea76c53-1730301995"
  },
  {
    "email":"donatellatasinato60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512598906/a5ca1a2a056bbf3b4d8a9a0fce9e12f8-1730301995"
  },
  {
    "email":"ritagahliardini@enovetro.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512631674/eba907372ff9280f571890b434160d0b-1730301995"
  },
  {
    "email":"sciumbatagervasio7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512697210/fb7f2843e393e15eeaa415075a36b592-1730301996"
  },
  {
    "email":"antoruss59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512729978/3652d7af674dbc0c66c1062f08f46080-1730301996"
  },
  {
    "email":"elisa.arianna.p@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512762746/edde8d6026c835b007dd10a2c71b1e24-1730301996"
  },
  {
    "email":"gingiva@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512795514/106a96444df40dba27c55f3349e15532-1730301996"
  },
  {
    "email":"clammb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512828282/a0698adfd1dae5bb7662872d87ad1a74-1730301996"
  },
  {
    "email":"sarafloriana.volpi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512959354/9f47ebc735e1947e4d476945d1f736cd-1730301996"
  },
  {
    "email":"maraberberini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723512861050/a381dcb294b6f6111d1d9b191e56e6db-1730301996"
  },
  {
    "email":"sari.g86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512926586/7de097692bb24ce48354097e2d72121a-1730301996"
  },
  {
    "email":"fabrizianavicello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513024890/508cbd240e05045099b437b0051a70e6-1730301996"
  },
  {
    "email":"roblucc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723512992122/544e07e4841dce6c7193331de4671d65-1730301996"
  },
  {
    "email":"antonellaspot@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513090426/dc341aa0761d2da674e3f7c92f450d4e-1730301997"
  },
  {
    "email":"gloriasgherri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513221498/7d5d0f265faeff12b1e76cfc6ba4b67a-1730301997"
  },
  {
    "email":"ilariachiarabini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513155962/c6660001383ec89b515e8a2122ca6120-1730301997"
  },
  {
    "email":"alessandra.nalon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513287034/5bdf1a7e94c90d866e7daff8e3186827-1730301997"
  },
  {
    "email":"monicatornieri_2007@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513254266/9580218ec164748d0c787fcb132c3f34-1730301997"
  },
  {
    "email":"valentina.poncemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513057658/dd97ad7cbdb689655e8838e6e0b425ec-1730301997"
  },
  {
    "email":"aerostello@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513352570/b35e71957249425a0a17ca199700e8b5-1730301997"
  },
  {
    "email":"chiara-paolucci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513385338/952b13c7b4990e7f08ff2c6cf926e06d-1730301997"
  },
  {
    "email":"penelopeia67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513418106/63887d83feca67f3e3a8f913a9c37caa-1730301997"
  },
  {
    "email":"clamarte@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513483642/aa897a59069724b37a80bd8ffa58dbf0-1730301998"
  },
  {
    "email":"micaelapreviati55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513516410/bede48b1aab3cea8b7add22cded14e67-1730301998"
  },
  {
    "email":"tiziana.baldrati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513450874/5a5bef8fd7cb30d7d86426181f91d6c6-1730301998"
  },
  {
    "email":"r.pollato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513647482/b9e464490e3fbcc355f9a3d5ee1648ec-1730301998"
  },
  {
    "email":"tinaccisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513614714/a5e5c2efa2395f14d0fe026a034e0517-1730301998"
  },
  {
    "email":"frava56@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513549178/546fe5bfc6e198027db615947697839c-1730301998"
  },
  {
    "email":"solinasbarbara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513745786/86ad7b87b42b1396019548ef020e8562-1730301998"
  },
  {
    "email":"germana.grasso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513713018/e3573393fab706856b664931350829ef-1730301998"
  },
  {
    "email":"francesco.gallo98@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513778554/a2c128f524b00f4714764bef191e8b22-1730301998"
  },
  {
    "email":"martina.fratacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513844090/4c0a8c0f279df154bb8a4e826d2b4133-1730301999"
  },
  {
    "email":"vania.piovan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513680250/c7d672619a9cf3c05caf8fd39894d4a9-1730301999"
  },
  {
    "email":"ldececco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513876858/a1696e206895b86231715a1a911c1853-1730301999"
  },
  {
    "email":"principedelghiaccio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513909626/ee4e5e333ad3e0fe2e725d444e46a520-1730301999"
  },
  {
    "email":"ing.carlottabullo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513942394/439878b5ed18073724ec7d2bbe79023d-1730301999"
  },
  {
    "email":"marco.tripodi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723513811322/aaac02a8f6cc387c3b20a6c5e77ea76f-1730301999"
  },
  {
    "email":"silfus72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723513975162/75087d59612d48f33eb220c9ff088b5b-1730301999"
  },
  {
    "email":"eleonoraramini66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514007930/28ac8b54373fd0199b9bfeded10a5018-1730301999"
  },
  {
    "email":"paragiovanni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514040698/b2fbf0cd5ce0565f16e13fcce87d7c37-1730301999"
  },
  {
    "email":"gaya.bagagli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514106234/5018b361d6853619bf494d9766ca8f2d-1730301999"
  },
  {
    "email":"luisa.bezzolato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514171770/616352d98736ea5a65d7ee55dcf1ca95-1730301999"
  },
  {
    "email":"volante69@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514237306/5f476ce947eb5aebae23f0de0135fd60-1730302000"
  },
  {
    "email":"sassi.giuli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514204538/aedf8a5e74f5e4150dfc711c6d875f8c-1730302000"
  },
  {
    "email":"pamelazechini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514270074/6dbfd374beb477c7a9670a51e04c2c92-1730302000"
  },
  {
    "email":"mariangela.malcangio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514139002/a2c3287e52fab4aff0d782d514bb8d01-1730302000"
  },
  {
    "email":"mazzuoliirene084@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514302842/7d8f05c97cabe7b88e6eb1d4db92cdea-1730302000"
  },
  {
    "email":"cgini@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514368378/60380e1db1a460c7081c1c847674e0ae-1730302000"
  },
  {
    "email":"pino.russi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514401146/04c7ffb16d67c6a20ceaa73c15bca3df-1730302000"
  },
  {
    "email":"antonella.lisio72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514466682/aed9b9793b91b906304ec2957621fb61-1730302000"
  },
  {
    "email":"eliseimichela77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514335610/79c070e02f55bb619d0d2e534c2495d1-1730302000"
  },
  {
    "email":"rachele.landi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514630522/95d0964bf428a912f16529be9afd7bb7-1730302001"
  },
  {
    "email":"laruz88@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514532218/a1e9374ab5f4b0e70358e6c1c344d2b8-1730302001"
  },
  {
    "email":"simsic@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514499450/846804cc64c03afc357107abedc0a89b-1730302001"
  },
  {
    "email":"gamannossimatilde@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514564986/b97af27a371ce9257737f12930742d5e-1730302001"
  },
  {
    "email":"silviamanuali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514696058/3248d4f6816310cb2311d12ccd6fa681-1730302001"
  },
  {
    "email":"elzivalentina2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514761594/906217d6163c052fdb9ecf826b38dbca-1730302001"
  },
  {
    "email":"giovannacicogna@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514728826/bdb3c4bc861c746d8571d5f7c5e5c761-1730302001"
  },
  {
    "email":"lisa.busatto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514892666/d5e46471a34ed47b8f9b39aac4b4ab1b-1730302001"
  },
  {
    "email":"martina.sommariva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723514925434/1a5d366e480628f68ff5bca25644e0f1-1730302001"
  },
  {
    "email":"mariadeadiiasio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515056506/9e9c5ac9a67fd0a2321d11983ee23f86-1730302001"
  },
  {
    "email":"tutuina.sp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723514958202/99513310e862c4022c00323b05d55141-1730302001"
  },
  {
    "email":"susy.chiavelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515154810/6417c8e6b65928de6b6303496f2dd6d5-1730302002"
  },
  {
    "email":"fridascarpa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515122042/a1a8ccc6a997dd05ad6f24438b0809f7-1730302002"
  },
  {
    "email":"cinziagiorato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515220346/4b954f801eca28c369a0a9e4c2a37879-1730302002"
  },
  {
    "email":"a.g.empiredressing@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515187578/77b908bae613aad89ab217f0f5c4ffcc-1730302002"
  },
  {
    "email":"elena.duana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515285882/0c91ee89e262df9b1e0cbc21858d1e1b-1730302002"
  },
  {
    "email":"silviagagliotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515253114/20afe94113419e73db66e8a7f79d5bd1-1730302002"
  },
  {
    "email":"teatomaiuoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515318650/cc418257c8aeb1635f79bdb38b7b81e0-1730302002"
  },
  {
    "email":"annarosafalcone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515351418/a6bf5e310c1d29bff491bb8816ac6c7e-1730302002"
  },
  {
    "email":"valedape@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515384186/423e7e6923ede300efe04e83afe2e611-1730302002"
  },
  {
    "email":"vernipatrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515548026/fa87da9b29baec04f6ed3d7ce67c5c08-1730302003"
  },
  {
    "email":"mosa.s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515416954/43a4fb8c845b04a2694f997f292eeb7e-1730302003"
  },
  {
    "email":"commerciale@calzeileana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515515258/bb84403d3f8d1a4679049c6d609921a3-1730302003"
  },
  {
    "email":"annalisa.quaresima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515482490/69fde2b340a2b7622aa36683bfbdedc0-1730302003"
  },
  {
    "email":"apatacca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515646330/622f48717670a6dc14cf69294071df66-1730302003"
  },
  {
    "email":"alessia.nebuloni@liveli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515613562/9be35e2de18129022d7cab1baf42c8e7-1730302003"
  },
  {
    "email":"martinicristina967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515580794/c99e300aa9778eabb5a6dffc36ce9309-1730302003"
  },
  {
    "email":"arianna@guin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515679098/3af5758af5c55f498e3fc87b437bc594-1730302003"
  },
  {
    "email":"mka.diadamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515711866/571e2690d794096996319952cb840e74-1730302003"
  },
  {
    "email":"roby.p.88@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515842938/179600164d2eecb8701f5a5d15948180-1730302003"
  },
  {
    "email":"cgironi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515744634/dfb880bac26ea34c989d277e872ba219-1730302003"
  },
  {
    "email":"alessandrarinaldi66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723515875706/2046a3a5dc4f583cd35c2c76980d1f6b-1730302003"
  },
  {
    "email":"claudietta.g@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515777402/0efedff660a5a4caae08414fc0484735-1730302004"
  },
  {
    "email":"n.nicolabarone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515908474/0bbdd4a91d4c3802ead7ec9d5ca20ebe-1730302004"
  },
  {
    "email":"nella.mortadella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515974010/06724a4521051f45080ff27f1dbfc8da-1730302004"
  },
  {
    "email":"annamirenzi2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723515941242/aa12a3637d446891a049866529604f2a-1730302004"
  },
  {
    "email":"fabiolastranieri@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516006778/f607929d9b8be52d4f79bf21ffa6c00a-1730302004"
  },
  {
    "email":"rominamilanese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516039546/989d6e6306a76cbd530da89de899f6a2-1730302004"
  },
  {
    "email":"valentinmoretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516072314/2169f1fa66d1007131731c35232ad533-1730302004"
  },
  {
    "email":"silleo71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516105082/5d01970c07988834ba2e99cb9dc90ed4-1730302004"
  },
  {
    "email":"lia.montemarani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516137850/a59492f22d0c18d82692b621a765ed1e-1730302006"
  },
  {
    "email":"katia.zanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516203386/ca6e61017bead5fdd75a047413b45e2c-1730302006"
  },
  {
    "email":"francescaarthemalle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516170618/931fff67c4b888732ce888fd6b99a990-1730302006"
  },
  {
    "email":"emanuela.fiumano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516236154/f247c2609a1f979754659732134cf3f4-1730302006"
  },
  {
    "email":"rosannacanafoglia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516301690/173a735a41316c1073255c90b000b139-1730302007"
  },
  {
    "email":"deborhallaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516367226/b72afdd1be7f34b17d73d84665fb5fa1-1730302007"
  },
  {
    "email":"fiore_ei@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516268922/ef533994e525c3082a6689204de6a809-1730302007"
  },
  {
    "email":"s.sordi@professionalepalestrina.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516334458/9e884fd6630e6425148b383c888904af-1730302007"
  },
  {
    "email":"tiziana.iorio1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516399994/2db678184e862a9e1b56599fe7275cdf-1730302007"
  },
  {
    "email":"sasy.tavella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516432762/bb3e76d29023aa8dd567e37c4c82b4d3-1730302007"
  },
  {
    "email":"jill.canavesio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516531066/62734f4b81816a73fa1f4634e5056ef4-1730302007"
  },
  {
    "email":"raffaellarambaldi18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516498298/c23d6bf0ed0b7d7ccbd29dd4c692edf8-1730302007"
  },
  {
    "email":"francesfoti.ff@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516596602/45e4158bf16db050fee5143ca027c8f7-1730302007"
  },
  {
    "email":"gennydegiorgi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516563834/3b0b3ae8921a12b2266968040110bd34-1730302007"
  },
  {
    "email":"federica.margini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516662138/2889cd299a29866bb38ade0547c366d8-1730302007"
  },
  {
    "email":"studio.garaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723516694906/ebea9ea4446ab15f7214f9d9cdbf66bc-1730302007"
  },
  {
    "email":"iveta70@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516793210/b0856bd1a2d2d3922a663291143cad75-1730302007"
  },
  {
    "email":"m.calvario@vincal.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516727674/99db51ecfe29c6a4c349ac0aac390fc8-1730302008"
  },
  {
    "email":"maria.gervasi67@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516924282/a0aea4398bcf5c9186bdc3ffa1e5978d-1730302008"
  },
  {
    "email":"sara.tiozzo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516858746/733f63dc023d576cb06bb05613af7a5d-1730302008"
  },
  {
    "email":"nata71@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517022586/448f3e01065b4e5af81fd13eedb1ddb6-1730302008"
  },
  {
    "email":"federicapiccioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723516957050/4be37d3bec0b90ace609fb596776b7c1-1730302008"
  },
  {
    "email":"cribigna1@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517088122/ca9319e5b2f10d557a2266f8eda4ec9a-1730302008"
  },
  {
    "email":"giber@usuelliautotrasporti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517219194/77f413457cd66c71fdd09d8850167e51-1730302008"
  },
  {
    "email":"rossella.ferretti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517120890/3fc890437c9e6ffcdef946fe471ff6fb-1730302008"
  },
  {
    "email":"seaotter3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517251962/f4d0c97dfc1d231dfd8cd97d2f921fdd-1730302008"
  },
  {
    "email":"deborahcala@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517055354/2c41b201cfd7bf6790a4a74fe2e7ad70-1730302008"
  },
  {
    "email":"mo.grispino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517350266/159cf19348ac47c3d10de274723807d5-1730302009"
  },
  {
    "email":"lupielena.88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517448570/c983d196b54096128575e1cea5ad9ea4-1730302009"
  },
  {
    "email":"paolablanchitourguide@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517514106/915f4312ec8bbc26c2ad2e08bcb83622-1730302009"
  },
  {
    "email":"gianna.perteghella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517284730/1eb7050547bcdb65cf6bcafccfec1827-1730302009"
  },
  {
    "email":"fumetty78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517546874/e6ef907a53d8f42b94e199d6f340386c-1730302009"
  },
  {
    "email":"cinzia.ceppatelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517579642/52700344017abff19f236ba295438394-1730302009"
  },
  {
    "email":"beba.califano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517677946/c79f46083cb310bb97f021721760154b-1730302009"
  },
  {
    "email":"bartoli.v@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517710714/3d77b0e1e07a422bc9a0264544628053-1730302009"
  },
  {
    "email":"c.giusi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723517743482/a10f8dd98fa0fb34cb244b41dd3a94a8-1730302009"
  },
  {
    "email":"simona.sardella1709@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517645178/e88cee77c46971332a8479053af5a1d7-1730302009"
  },
  {
    "email":"59821721@qq.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517874554/96c594b82126301cb05816eae1e27c2f-1730302009"
  },
  {
    "email":"ivana1968.id@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517940090/6dec63d21ea1c4caa8746c36dad0e07c-1730302010"
  },
  {
    "email":"giorgiadociu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517907322/7d4d00de6e5ebc4a41593003970915e1-1730302010"
  },
  {
    "email":"pluca1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723517972858/003e0115d6672610d5c82b5070242bac-1730302010"
  },
  {
    "email":"slviaturi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518005626/9de39330172074951aea4fbca18108ef-1730302010"
  },
  {
    "email":"barbara.cupido1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518071162/3412b8d6a0a1a678739e9c296736d97f-1730302010"
  },
  {
    "email":"ottimaidea2016@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518103930/127ef453cc8b639277a28d29e5b10b0a-1730302010"
  },
  {
    "email":"giovanna.salvador95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518038394/b87d385729c327cbc6d54a75b3bdce41-1730302010"
  },
  {
    "email":"angelaconte16@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518136698/21c2fe96b9c4bb327c32d2eea37473fd-1730302010"
  },
  {
    "email":"franpa81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518267770/8efc4ee696dae03d8c07b33ff5a05c31-1730302010"
  },
  {
    "email":"federica.bocca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518300538/e7d2366857fee3e0582cf472433f7d86-1730302010"
  },
  {
    "email":"dr.mirellamuffarotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518333306/ae1bda36c8c8aaa7a874c72ebe480689-1730302011"
  },
  {
    "email":"nadifrez@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518202234/985821d4e3cc52f88aa9755c52137a2c-1730302011"
  },
  {
    "email":"marcomarras8@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518169466/7ebc51585805efa5740e2935f0f21c03-1730302011"
  },
  {
    "email":"kiarapressy@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518366074/8d2ff12718f3a6a5a7f0a1855385514c-1730302011"
  },
  {
    "email":"pilarcitro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518497146/2af15c848f6625166a0e700333404d10-1730302011"
  },
  {
    "email":"stefy.girardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518431610/f8b52fe5baa880fb1d58a9ebbe352c49-1730302011"
  },
  {
    "email":"imbornone.orsola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518464378/a66aeb8743c62262db8e8ab61bf16018-1730302011"
  },
  {
    "email":"nicoletta.mattera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518529914/a49a6b9a870c0ed7fa88f50c723276d6-1730302011"
  },
  {
    "email":"claudiasegala72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518595450/3a3bf79f23e0890bd22de302325d6d1c-1730302011"
  },
  {
    "email":"bertini.tania@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518726522/93c362a7b2503b0f94852636647bf860-1730302011"
  },
  {
    "email":"kikina.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518628218/105caf493afca620ca321d1ad0810240-1730302011"
  },
  {
    "email":"paolasantoriello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518792058/119c8e041bee1ad1e261de6035346ab4-1730302012"
  },
  {
    "email":"giulia.micio1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518660986/14eb81aa30718527854204815310692e-1730302012"
  },
  {
    "email":"clara.azzolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518824826/130eeca0c1b1d9bdcf4b5b63e0bb9781-1730302012"
  },
  {
    "email":"antonella.paniati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518857594/4f7a014ea1fb5bcedd8a761ab9a6a565-1730302012"
  },
  {
    "email":"mchissale@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723518923130/42cff2deaf7a60fc1baecde6bd3b77e8-1730302012"
  },
  {
    "email":"vittoria.fabbian@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519021434/924bac77e594bae4c6a98b9f4c06f682-1730302012"
  },
  {
    "email":"mornellita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518955898/7c05a859e4ae94adcbff2c3685dc9970-1730302012"
  },
  {
    "email":"giulia.melli97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723518988666/fa7650575c9330f25c1228c03d3622a1-1730302012"
  },
  {
    "email":"kira_aso@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519086970/e11c72ddf654904830a404fd62bf020d-1730302012"
  },
  {
    "email":"emilia.basso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519152506/583063c57a8adab2169c9da850daca3f-1730302012"
  },
  {
    "email":"francesca.arrigoni1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519119738/5b72e71843ef6116b84625ced16043f5-1730302012"
  },
  {
    "email":"sabrina_bitteleri@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519185274/28a937d6e6142d868ef0177b8a38ba14-1730302012"
  },
  {
    "email":"sabato.paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519218042/79fe36fb971f4aa171e1d0cc9f3449cb-1730302012"
  },
  {
    "email":"ilaria-ch@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519283578/ce0137c21acd2fa459849fb8c40db217-1730302013"
  },
  {
    "email":"armaroli.erica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519316346/598458d5d03ade5a9566a727da8bd2eb-1730302013"
  },
  {
    "email":"stella6990@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519250810/987dd396214bddc86dd02233a66c40b6-1730302013"
  },
  {
    "email":"sabrinp@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519381882/c0c9d0d8ad74486a46a51fe071de5149-1730302013"
  },
  {
    "email":"katiuscia.detti@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519414650/82dcfce0e69bbc8d33d5d6da7afd9040-1730302013"
  },
  {
    "email":"caterina.mattivi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519480186/3e794c47a4d9fea145b9bbbc2d4a54ac-1730302013"
  },
  {
    "email":"marialucia.scarinzi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519545722/f51d670fde919ac0e0e989ea34959b99-1730302013"
  },
  {
    "email":"greta.rigamonti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519447418/6899372b2ca95e2d4a6cabeeadfe8014-1730302014"
  },
  {
    "email":"olga.cara@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519578490/78b6159eac63ad871e3633e469c1b745-1730302014"
  },
  {
    "email":"pao.cin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519512954/a408928a848d5169714f35976d1f4c3a-1730302014"
  },
  {
    "email":"claudia.barone85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519644026/d8e3116f2277936e41ef8093b00f9329-1730302014"
  },
  {
    "email":"ravaisabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519611258/11e19c062a4be872ef9e05037ad1cb13-1730302014"
  },
  {
    "email":"spocinzia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519676794/7b0eed77d7636cf55dc5925455695b9f-1730302014"
  },
  {
    "email":"rizzogiada10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519709562/b1a297cb1fc8a25e28e1640a5cffa59c-1730302014"
  },
  {
    "email":"stefania.giulietti@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723519775098/b16585deddfded6e1ac4e426869f0eba-1730302014"
  },
  {
    "email":"robertalunardi67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519840634/028e4015f601836c6dc2ab799fa150d9-1730302014"
  },
  {
    "email":"giorgia7gaia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519873402/9fde0ac57ad0509f26801e16c6f9de5d-1730302014"
  },
  {
    "email":"gabriele@mitto.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723519938938/cc86cf4d48915b3b4d72819c15598b97-1730302015"
  },
  {
    "email":"d.arcy@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520004474/ef58be26fa991402647f33daf0a2b801-1730302015"
  },
  {
    "email":"porciellorossella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520037242/3dd339f4e2fa5a14e78838353ff7b620-1730302015"
  },
  {
    "email":"abbaduto.deborah.marconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520102778/f21d8e9ab7f07ba2f756c4c27814f7ac-1730302015"
  },
  {
    "email":"pandorina12@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520070010/20567e3353c7bc746b61cb16717002c7-1730302015"
  },
  {
    "email":"cassandra200483@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520135546/2239f8d6ccba243686bd2585ac605ced-1730302015"
  },
  {
    "email":"simona.simoncelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723519906170/66ace12c71fb8ca15428c80ccff0be89-1730302015"
  },
  {
    "email":"p.musso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520233850/78dc75597b84c034a17976a2c9f83532-1730302015"
  },
  {
    "email":"caterina.bertolini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520201082/b228566dfc1136346bab350f760075ef-1730302015"
  },
  {
    "email":"sabrina4e@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520168314/539acc58fce7a855d9befc6671391f77-1730302015"
  },
  {
    "email":"ritagostini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520332154/c3ac30b677bf064a0179e08e2bcfcb73-1730302015"
  },
  {
    "email":"anna.bor@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520397690/546eb61f2f295364d28f34ab12d86e2f-1730302016"
  },
  {
    "email":"paolapirry@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520364922/71fd38229022590552e9baa6d9c9105b-1730302016"
  },
  {
    "email":"arfem93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520463226/e9c30c5dcedc405fe472e5b1ed2147cf-1730302016"
  },
  {
    "email":"gino@albano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520528762/f74a80165b13a91be8131f381e1e66a2-1730302016"
  },
  {
    "email":"papaemanuela1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520561530/77a2ad67b2e88665d977c080f3f8cdef-1730302016"
  },
  {
    "email":"vale.varlese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520594298/44ee98ad0c2bbb011323cb3825c7b9d9-1730302016"
  },
  {
    "email":"antony_pr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520692602/6b2f8a8ec5fb446efe8b85a0167a027b-1730302016"
  },
  {
    "email":"mrt75msc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520627066/186051f393cfd92e576a549736a0f40b-1730302016"
  },
  {
    "email":"dani.ace1908@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520725370/73220b975188180c354f16cb6e7cf897-1730302016"
  },
  {
    "email":"cinquettidiego@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520790906/480fc3c6de5a04c9ae878d05d9071914-1730302016"
  },
  {
    "email":"annaregge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520823674/7d9d7bffc1d695c96fdf582e6d801af0-1730302016"
  },
  {
    "email":"lotosetto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520889210/e393ad9d90f8c9dec622a08c7b6d35bc-1730302016"
  },
  {
    "email":"ladyfer@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520921978/3569f9652b375bafef6d93674c52b779-1730302017"
  },
  {
    "email":"d.colledani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723520954746/216534a78ec7f3f2ca1c0ae88330ef1a-1730302017"
  },
  {
    "email":"moky78m@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521020282/0e4c9d429633928ca81b0ea363c1084c-1730302017"
  },
  {
    "email":"ilaria.rosati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521085818/d3479f1a26da09b200e9cde7c80fc509-1730302017"
  },
  {
    "email":"jessicaferrari75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723520987514/5ef27d6fdab7f5b31b21a4390ae31507-1730302017"
  },
  {
    "email":"silvia.chioda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521053050/956e9a19a1dd1c76250ab73bd9677e62-1730302017"
  },
  {
    "email":"palumbo-giovanna@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521315194/195b0213c097cd6b0513c9c7e03f6e1d-1730302017"
  },
  {
    "email":"blinkyna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521249658/f32adae2fff33ac23dcc7e5072eafcfe-1730302017"
  },
  {
    "email":"a.cerulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521118586/e4af0a41705ff8bb8b6f0b6afd88316a-1730302017"
  },
  {
    "email":"rosjpapaleo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521216890/c89143870e85704c623bf0c6e9fab373-1730302018"
  },
  {
    "email":"monica.simona.guzzetti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521347962/8ac4970fca8afcc7308aa2d409a6859c-1730302018"
  },
  {
    "email":"alyphra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521413498/d867df2fbc989c88c1d29cfa15f8c68a-1730302018"
  },
  {
    "email":"donata.sasdelli@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521511802/8143f6b718a2fd82ff4f65fbe45ca2df-1730302020"
  },
  {
    "email":"chiarapaoletti2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521446266/ed636beedd17a96455bc9765bbc072f2-1730302020"
  },
  {
    "email":"rossiluigino.toroass@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521479034/02d6cf8df61de7c4ae91dec963249f91-1730302020"
  },
  {
    "email":"giorgiadocci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521544570/1309e9d1e40f7b244d2434cf51df8ecc-1730302020"
  },
  {
    "email":"stefanialepreti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521610106/8f88c70e54ea7b752e9d0944d4e9366f-1730302020"
  },
  {
    "email":"tortonesi.rita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521708410/bec88ec05653595bd270281ad2406f09-1730302020"
  },
  {
    "email":"fulviacolleoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521675642/a361658a4323ed8c97707debb876b1c2-1730302020"
  },
  {
    "email":"claudiad2010@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521577338/8664c37a543665f865c0d283056ec32b-1730302020"
  },
  {
    "email":"info@d-consult.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521773946/33b683a84d8c83f92c2cb3b0e1adfc45-1730302020"
  },
  {
    "email":"frenci73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521839482/9333dc5e45caaa6ba762097a5797cd4f-1730302020"
  },
  {
    "email":"nunzia.simo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521872250/96bf9db427102501f31654e35f267765-1730302020"
  },
  {
    "email":"coppari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521937786/84349e1069320c9f216adb4f396b4465-1730302020"
  },
  {
    "email":"niko2688@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723521970554/3f8ffb610f6ffe988421ae72473c78e4-1730302020"
  },
  {
    "email":"pelly_89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723521806714/9617aefa30cfc01cc18e2e13a70fc58f-1730302021"
  },
  {
    "email":"bracalenteanita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522068858/f2e0f60bbbd25c4044cada47dd6785d8-1730302021"
  },
  {
    "email":"marilenamarciano16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522003322/b2cc43035ec000e9757cbf96820c257f-1730302021"
  },
  {
    "email":"robertolodovicofg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522167162/2b257f321186b4eb338aaeb84668fad5-1730302021"
  },
  {
    "email":"antopa05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522134394/c92ba31fe640438999fe3cc4de6bcf54-1730302021"
  },
  {
    "email":"patfortuna@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522101626/580d7c5cfe7ffc7143047c8d39c0c872-1730302021"
  },
  {
    "email":"pongomg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522265466/060f5fff884e0e918c5dec777c1aa22c-1730302021"
  },
  {
    "email":"immacolata.la.rocca@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522298234/503cf84cc1815a07f332cee61c17708c-1730302021"
  },
  {
    "email":"simona.gonnella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522331002/eb8f00be469d672577aa8d118c4dc258-1730302021"
  },
  {
    "email":"matteorossini@studiolegaleaccordi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522232698/9526091848626f01af218201d2750716-1730302022"
  },
  {
    "email":"caprice69@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522363770/cb760ac81ad629d3272cade319949eac-1730302022"
  },
  {
    "email":"giuseppe.marchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522396538/39ad6d4ac152bbf5740b4f697fb123c2-1730302022"
  },
  {
    "email":"giada.tossini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522429306/90259524f851d5c171e8ce60a4f99edc-1730302022"
  },
  {
    "email":"anto.manoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522494842/f54a6d9ab153ad1d835a7b54639abe11-1730302022"
  },
  {
    "email":"bruno.palermo54@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522527610/b50e3a0fe5d4215e26b704f90c4332d8-1730302022"
  },
  {
    "email":"alice81.torre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522560378/f9056490eb89f5e728eab5e5812ae412-1730302022"
  },
  {
    "email":"leo1767@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522658682/5b027197d394a4950b81ea0bc1e8b1fe-1730302022"
  },
  {
    "email":"paola_odone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522593146/e38b8de9ec47608b8c518ef354b48812-1730302022"
  },
  {
    "email":"maria.galiero1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522691450/89d680c44c0c5f7fd28dcbe7e53dc1e0-1730302022"
  },
  {
    "email":"valeriamassera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522724218/87f7bba3a80c1850bb67dffd0a6696ea-1730302022"
  },
  {
    "email":"cristinapretini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522789754/d26797433891161c39501bfb89951f78-1730302023"
  },
  {
    "email":"simo.venturi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522822522/1c1d8b48740a86cfa197afbc444ef914-1730302023"
  },
  {
    "email":"silviapetrucci@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723522920826/1a3c849985aab84fcdfc4a1f17ab8fc0-1730302023"
  },
  {
    "email":"d.floriana79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522986362/ae50cbf84df51329568f07aa3e5fb1fb-1730302023"
  },
  {
    "email":"simoneperna2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522756986/a55fee0a9089ddeb01adf1ee80703f11-1730302023"
  },
  {
    "email":"marinorosanna1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523117434/27f35e93b8edde376b61e3f44877d336-1730302023"
  },
  {
    "email":"samela-11@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723522953594/15acc2b289aaac6be4855244cbf35a67-1730302023"
  },
  {
    "email":"simona.natali75@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723523051898/e3391bbadcc69fae318a2e76e0e18682-1730302023"
  },
  {
    "email":"mary11empa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523019130/40813d3e9f1adaa4789724dc72487fc9-1730302023"
  },
  {
    "email":"ika.guidetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523150202/4aac551fd241f98398ae4efe1b61d3eb-1730302024"
  },
  {
    "email":"xspuri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523182970/ffe132616479d2f201b4f145c0d75abf-1730302024"
  },
  {
    "email":"a.berdini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723523346810/ac26266beeb280ad0ed347391ae535f9-1730302024"
  },
  {
    "email":"thilly2007@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523379578/822ac3ab894de0d8b967e4d3df41abd5-1730302024"
  },
  {
    "email":"renatasabatini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523314042/87927909c2de5ef8092d5446c74c863b-1730302024"
  },
  {
    "email":"cristina.caronna.77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523477882/690cc1bfd5111f3718dfda688ec56c29-1730302024"
  },
  {
    "email":"irene.mori1221@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523412346/e938ca4a5cba774e7cb116cf7b79326c-1730302024"
  },
  {
    "email":"mercantisofia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523445114/912231e72e6867d8ae007095414148ce-1730302024"
  },
  {
    "email":"luanasirabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523543418/00d14eb0ccd302d87e198ab57d42358f-1730302025"
  },
  {
    "email":"rossellaventimiglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523772794/861415a87d4e02a9716cca9e13a0460f-1730302025"
  },
  {
    "email":"lilianabellini@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523805562/460a816b3f4b0063499167c5fa4956b3-1730302025"
  },
  {
    "email":"citticitti76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523510650/8e2553b15ddb5a3491e13ede79f62cef-1730302025"
  },
  {
    "email":"francescamarzolo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723523871098/c6f2763f3f5d3db52119e7d21e0852d4-1730302025"
  },
  {
    "email":"info@fisiokroma.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723523838330/e4d5b2fe380999859409b49fc9fc523f-1730302025"
  },
  {
    "email":"mery04@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723523936634/9b99c2cee6b03664d97872cd1a04bf9b-1730302025"
  },
  {
    "email":"cacciani@vesmaco.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524002170/310efc64878f82ae2aa0c5f7a27b2991-1730302025"
  },
  {
    "email":"cominibarbara@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524034938/f833493b821e0dcd28cc2bf72f7fdf38-1730302025"
  },
  {
    "email":"elena.zanini@edelweiss-energia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524100474/54b7837e2547a5ca26ee8bedd660b774-1730302026"
  },
  {
    "email":"anna.moi@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723523969402/d8019a6e24d1a293661f911ab375d55c-1730302026"
  },
  {
    "email":"erikaa19@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524067706/8bc0be074103e0a97ffeafc1401a6783-1730302026"
  },
  {
    "email":"antonel.fadda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524133242/80383a01bfc150063a489e5635516fd0-1730302026"
  },
  {
    "email":"sabrinaserafini16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524198778/8dec017c227460aaa2b9c4d791427da9-1730302026"
  },
  {
    "email":"fema71fm@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524166010/1b80ca101ed54031c94a4aaa3a21f43a-1730302026"
  },
  {
    "email":"agnes.beikircher@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524329850/e2f746829cfbac859bbadf31481a75ec-1730302026"
  },
  {
    "email":"fotinik2002@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524297082/41bac4d1094435fb4b6ade80bae29010-1730302026"
  },
  {
    "email":"rosalba.ieva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524264314/6b3511ed2901227d299812d11a748167-1730302026"
  },
  {
    "email":"mela13@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524428154/1f1b670dc4d7bf502acca47cb23a58fa-1730302026"
  },
  {
    "email":"amministrazione@sdsenergia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524395386/bf62d78fb7969a91a025e0e528444fc7-1730302026"
  },
  {
    "email":"paola.puviani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524362618/29a71178180272eb4d0bdc176f911431-1730302026"
  },
  {
    "email":"fatabruna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524460922/29dcdf25ac35f0a241873e4202a32832-1730302026"
  },
  {
    "email":"menelle.giada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524493690/50244016eb4fc4cfd2b537d86e0bd7b2-1730302027"
  },
  {
    "email":"amministrazione@allservice.tv",
    "url di attivazione":"https://verdissima.it/account/activate/22723524526458/5abba284063e939f17554c189e22e19e-1730302027"
  },
  {
    "email":"giulianachezzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524559226/8b05d516099b21b7926075c158fade5c-1730302027"
  },
  {
    "email":"piera.muzzi@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524723066/d816b764c45dedcc20bdc27fa2ed06a7-1730302027"
  },
  {
    "email":"ntdem@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524624762/38bf9b1693c4ba3254c30ef4009518b7-1730302027"
  },
  {
    "email":"puppy.80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524755834/fb9fb8ed93c4baa261a0734e6550c2d6-1730302027"
  },
  {
    "email":"apisterna01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524657530/4f8ee326cff9ed46859368b364709e6e-1730302027"
  },
  {
    "email":"stefania.mazzocca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524886906/0f30f6a5bcddc0ff2e6f2a76df978412-1730302027"
  },
  {
    "email":"federica.gallo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524854138/a77e3d0c7347e772b09cf4d65f6dc31d-1730302027"
  },
  {
    "email":"ricca1559@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723524919674/bda2cf4ece7d6ed323119c207cb30e9e-1730302028"
  },
  {
    "email":"antonellag.roma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524821370/46506db4d8d5c381077b8f10a4d29d80-1730302028"
  },
  {
    "email":"leonardowash@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524788602/03c1ee6ea8945e841d320021f8f7e6e5-1730302028"
  },
  {
    "email":"clery@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524952442/161b5929f1b56c9ddc7c4fa4aacef90e-1730302028"
  },
  {
    "email":"kristina.spetic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525017978/128a1a36bb4bf8dc6857b4b99e3c9b02-1730302028"
  },
  {
    "email":"d.pulvirenti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525083514/a0c57684b7fd21d908eb4a7a247937c9-1730302028"
  },
  {
    "email":"luigina.ambrosio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525050746/b1e1287b2bd55c18e52279486eaa8d40-1730302028"
  },
  {
    "email":"claudia.filippone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525149050/1b632198ea8a2709ebe80d7be61953cd-1730302028"
  },
  {
    "email":"linda.rullo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723524985210/4f438f512da49fb1f58546206f3ed8f6-1730302028"
  },
  {
    "email":"serena.riganti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525181818/28dac44ac1894be56a2fdc270557491d-1730302028"
  },
  {
    "email":"mbodei78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525214586/205e4d22bff2f69a0129e67501ab1402-1730302029"
  },
  {
    "email":"giulia.cappelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525280122/0e2ca373c22c8c793f6457ab4c1a078f-1730302029"
  },
  {
    "email":"elenina.lapi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525247354/e6735f6c0ed0b421e22adbe28acf305b-1730302029"
  },
  {
    "email":"c.micheli@asl.rieti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525312890/81198fb81063d802d9b8d65f83d6924c-1730302029"
  },
  {
    "email":"veronicarena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525345658/36ec18567994889d988e55092abbeee2-1730302029"
  },
  {
    "email":"elia.luisa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525378426/55bc563512a154de0777b48f685c5971-1730302029"
  },
  {
    "email":"info@villaagave.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723525476730/c5c33b807495855d189328d265dc15d4-1730302029"
  },
  {
    "email":"rossbacchilega@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525509498/41651397f472f87b7a2d5c33a74906c9-1730302029"
  },
  {
    "email":"doppiotaglio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525607802/f46a7335b5cbe15985efd02687d5188d-1730302029"
  },
  {
    "email":"marinello_ilaria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525443962/2c159a3a34a3d3fd632feb9df009e0e2-1730302029"
  },
  {
    "email":"frapai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525640570/21ea85f42e0188fb4e1f93653c8dc98f-1730302029"
  },
  {
    "email":"claudiamariani76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525673338/48cc24ebd26349c55742c1b7860ac4db-1730302029"
  },
  {
    "email":"lauramarsili71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525706106/9bab25bcde32d14460971f4c38579784-1730302030"
  },
  {
    "email":"boccia.elsa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525738874/99998d21e5cbe7300fa640413d05bc80-1730302030"
  },
  {
    "email":"anna.canneva@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525771642/424d2e35d0785d6e76d76ff26915a35b-1730302030"
  },
  {
    "email":"artusialessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525804410/c5bc7ad7c1c7d92a94eb1b97f383f533-1730302030"
  },
  {
    "email":"orietta.caneva@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525869946/75a9ddfc21da4bfe59d3e82f999ecfe3-1730302030"
  },
  {
    "email":"ranguilano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723525902714/8f9ccb48666bdb5e8520cc3631c10ac8-1730302030"
  },
  {
    "email":"gabridamata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525935482/0b9044ecb0622ff7014b6459677f8888-1730302030"
  },
  {
    "email":"clelia.manfredini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525968250/47e428ad10cb723caf2f1081d26867a6-1730302030"
  },
  {
    "email":"paolieri.sa67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723525837178/42d3cd4bbf207e5941f7b29400f0e48d-1730302030"
  },
  {
    "email":"s.marini89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526066554/da1a0892c67ecbe5cf5e6b8f0dbad7a0-1730302030"
  },
  {
    "email":"sabelli.giorgia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526099322/7e8f510eda0840d7bed37eee5b7bacd6-1730302030"
  },
  {
    "email":"caresanaelisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526164858/f6cd2dd76cfcc04df1923aa2932eaf7c-1730302030"
  },
  {
    "email":"a_orlandi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526263162/1395df3216407d317ede235c65b01eae-1730302031"
  },
  {
    "email":"stesamp83@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526197626/47e6d57d956a4b3b54950461de005b62-1730302031"
  },
  {
    "email":"barbaragallazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526295930/441952d9f058837578975ee9d6770774-1730302031"
  },
  {
    "email":"domeniconapoleoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526361466/c925837ebf85d81c7a958f8b28eb3288-1730302031"
  },
  {
    "email":"bice.recchia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526492538/82d4a534dd473caf09b7b5828b995c5d-1730302031"
  },
  {
    "email":"michelatomassoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526427002/14f5f5d7f2100711cea7147ce2c1c9aa-1730302031"
  },
  {
    "email":"bertonean@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526459770/6bf76c405e4b829cfabe178d4cfccd1d-1730302031"
  },
  {
    "email":"grazia.annese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526525306/17b98c7c470371b943f95c34852c7c1b-1730302031"
  },
  {
    "email":"mattbianco1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526328698/733728434c3b0eeeb7337fe2a22326e3-1730302031"
  },
  {
    "email":"l.fontanesi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526590842/e31b3d9b16f05edac9d0091a2fdb01e3-1730302033"
  },
  {
    "email":"claudianatoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526656378/2a1d471a91c7636f0acdcd2409fe57d3-1730302033"
  },
  {
    "email":"b_annamaria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526558074/4a946803524a1cdd2d3aec3c177e58a0-1730302033"
  },
  {
    "email":"katiusciamontini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526689146/e57116b865c38888a9bb17356a7f49fb-1730302033"
  },
  {
    "email":"ma02da06fa29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526623610/aa8319709e07bde68080a35d3a3daabb-1730302033"
  },
  {
    "email":"ambra1977@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526721914/6d3c8c1eabd0a1da85601e2c84d67152-1730302033"
  },
  {
    "email":"joanne.munnerley@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526787450/3f6f8b46464543940adf883d5bbf5d6c-1730302033"
  },
  {
    "email":"s.annovi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526820218/d2813dac96d26caefa03a9b6a09b1e92-1730302034"
  },
  {
    "email":"lucialorenzi@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526918522/00d7060fe9a107471e199ece106f016b-1730302034"
  },
  {
    "email":"saragiuntini.1970@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526951290/f271aed605a6fea47fb6406a3df07b82-1730302034"
  },
  {
    "email":"carladelpizzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723526885754/f61891d1f59c21e8d667114e257e7ee6-1730302034"
  },
  {
    "email":"patros700@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723526984058/6600002ba59c80b95650d5ef5e758da8-1730302034"
  },
  {
    "email":"massimomarta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527049594/54447845afa590d694004ccc345e643f-1730302034"
  },
  {
    "email":"silvia.musso@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527147898/6a3765e64c2e66df88c5e0b18b82ad74-1730302034"
  },
  {
    "email":"elena.v@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527115130/de4cb2cf672e2eca1d506e3efe137af8-1730302034"
  },
  {
    "email":"vimokia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527180666/84839e8abeafd4e2c963a13ecb7b693d-1730302034"
  },
  {
    "email":"parisanto60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527082362/04b1febbaee853e7182b31090bb39b81-1730302034"
  },
  {
    "email":"maria_pegoretti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527246202/9951a758284b2294eca1df14eb845081-1730302034"
  },
  {
    "email":"ortudaniela@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527278970/09a3dc0227761ccd250d4f9d280d1dff-1730302035"
  },
  {
    "email":"ligipaola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527311738/4b2e687d36b36bed923b94c71e5a58a2-1730302035"
  },
  {
    "email":"concy.allo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527442810/6f164910293f8694509b6d5707a8e023-1730302035"
  },
  {
    "email":"tinaranieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527410042/464d67f1cbc085ccef55fc5799dddadc-1730302035"
  },
  {
    "email":"info@dallamuraimpianti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527508346/3c8bbde94dca446ad3f9e144fd049d7b-1730302035"
  },
  {
    "email":"monica.todeschini68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527475578/a4aed55269bbc190a06496020db289ee-1730302035"
  },
  {
    "email":"adaranuccio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527639418/62ebd054958f124a7adafac6b72b33a4-1730302035"
  },
  {
    "email":"fanelliimmobiliare@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527606650/7778b85b55d162c95edd681f46c4500d-1730302035"
  },
  {
    "email":"loreta.borghero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527704954/b192acab3dc871fe65e0da579850c4db-1730302035"
  },
  {
    "email":"gaberit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527573882/3042d7f88688de9803824b088a0795f1-1730302036"
  },
  {
    "email":"silviahappy2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527803258/e4b5b03c0c3f783de67f068d6bf73098-1730302036"
  },
  {
    "email":"luisaviamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527737722/11a4bca0b75792e4b922d04b797fae7c-1730302036"
  },
  {
    "email":"dottfedele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527836026/3c781a461eacca5a74d0372d1ff4987d-1730302036"
  },
  {
    "email":"barbarazicaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527868794/ed0160f10544b0a9bcce0d5dde07ab40-1730302036"
  },
  {
    "email":"tirannoluciaanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723527999866/da648f39054cc825fb22baf0a89867d0-1730302036"
  },
  {
    "email":"caliolom.cristina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528032634/3edb24e823e84390cbd8e698c6c44483-1730302036"
  },
  {
    "email":"galli1970@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527770490/d2415cbb32c0ea0338d8ec0382165889-1730302036"
  },
  {
    "email":"laura.federici1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528065402/3735d148d483215643a93769382c1836-1730302037"
  },
  {
    "email":"elly.lenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528098170/9e1fbbe10a9d1527fa38f4b457371c10-1730302037"
  },
  {
    "email":"sara_dalpra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723527934330/015d8f47ab51eae81f7ab676279d0190-1730302037"
  },
  {
    "email":"annam.nazzaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528130938/384adf748314adb6a8b7419ae1fb22df-1730302037"
  },
  {
    "email":"nicolettabelussi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528196474/163a1d3001260dcde9b6019626e886c0-1730302037"
  },
  {
    "email":"emmarossi65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528294778/f11a7228ec057bc3451cf94e02085f94-1730302037"
  },
  {
    "email":"maricadc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528163706/9ffec627e6da06906e48abcc1f517d82-1730302037"
  },
  {
    "email":"circi74@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528425850/94118819386c5f8d0d4343feb7254930-1730302037"
  },
  {
    "email":"francesca.carollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528458618/28a84b8ecfa64f4da6cbe4a05dd8163f-1730302038"
  },
  {
    "email":"colettoelisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528229242/0bcdb89bc8bf3d64d2478c32b5c7950f-1730302038"
  },
  {
    "email":"todisco.margherita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528491386/3418d5db6677b8a644b2469c30cca81e-1730302038"
  },
  {
    "email":"bartolonilisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528524154/3150f9e32e814b9477e8d55ff9972c03-1730302038"
  },
  {
    "email":"savino.lara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528556922/898e8a6ccfa9197140166d6e72219e68-1730302038"
  },
  {
    "email":"rossi.pinella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528622458/6fc5ae91dc7b3fcce9c92dd58e34fdb2-1730302038"
  },
  {
    "email":"alicianna81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528655226/ee59711f3bf42a7c1591970e03c93624-1730302038"
  },
  {
    "email":"archblanco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528589690/75814f23ef1e4e4c4534b61f2139727d-1730302038"
  },
  {
    "email":"lavaredom49@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528393082/a9acdb1a799d7ef29a929da613f31ef3-1730302038"
  },
  {
    "email":"rossellacaminiti77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528687994/5a7b3efa1b2df978b9942fe9bbd7211d-1730302038"
  },
  {
    "email":"monica.riccim@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528753530/def082e7f0901e4ca6d8c4eac551deed-1730302039"
  },
  {
    "email":"s.morganti82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528720762/406db190d760a556aa513187ea702091-1730302039"
  },
  {
    "email":"patchouly@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528884602/999e2973066c0cd076e820121b1eb392-1730302039"
  },
  {
    "email":"castagnettimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528851834/2e91d5bba0cf56c6574f73df0c904d76-1730302039"
  },
  {
    "email":"ivanamarino77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528819066/c398864aeba92a653a94d08f5a925011-1730302039"
  },
  {
    "email":"giovanna.peg07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723528917370/63321c1283df3e76a0ce01b89f79fded-1730302039"
  },
  {
    "email":"lucydeb_78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723528982906/ac787557dacde0a33cfa6a964b29ce31-1730302039"
  },
  {
    "email":"tittykema@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529015674/3d685e4ee7b714bf1b3d56a467a88262-1730302039"
  },
  {
    "email":"lucagiorgi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529081210/0b81240f31ccc67890eb6901a2713fc7-1730302040"
  },
  {
    "email":"elenafontana4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529212282/e69fb8e4a5bf5a2ac5a7a8cb549886c9-1730302040"
  },
  {
    "email":"cecilia.quercioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529343354/a4f76cbd0a6edc9e49d367777c1c5191-1730302040"
  },
  {
    "email":"francesca_villani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529146746/3a93b54f7e6690de0dc156fa0a038cf6-1730302040"
  },
  {
    "email":"carmenlavecchia2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529376122/8b71ee4e278b521ea667c65565f89f16-1730302040"
  },
  {
    "email":"elenamichelucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529507194/9e176e0b69e54dc9884a115840e31be9-1730302040"
  },
  {
    "email":"adamelio1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529441658/f42f43ecac27d82c342d13f6bd294cc1-1730302040"
  },
  {
    "email":"bertolae@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529048442/9c2fe3bcfa444b84c7884a2c9b9e99ab-1730302041"
  },
  {
    "email":"patriziapilato.ag@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529572730/6bbbc9698a466fce48703c5c69438b99-1730302041"
  },
  {
    "email":"micaela.corio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529539962/9170a217be480ecdb62e12d484b3549a-1730302041"
  },
  {
    "email":"cristina_delle@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529474426/8c0d4ef70df25f3456585536ec1643af-1730302041"
  },
  {
    "email":"alessandracarlesso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529605498/b1a773be09a452f5158fa0a23e6462ee-1730302041"
  },
  {
    "email":"mari.baldisserotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529671034/8e04ce00704bd97022c5c1a333949641-1730302041"
  },
  {
    "email":"divialex@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529638266/91c1ecaddfaeb8ca6804bd98c3051db1-1730302041"
  },
  {
    "email":"agostinosessa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529703802/ab8557eab2f07a5ac51a73977c488992-1730302041"
  },
  {
    "email":"ilariaporchietto72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529769338/e28438297173367854adafe0dfafcb2f-1730302041"
  },
  {
    "email":"paglialex@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529802106/97326a896b38b10ea66164cfa9fc77b5-1730302041"
  },
  {
    "email":"simonabrunetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529900410/4422644a7abf83a26ef3d9874ae7f1c3-1730302041"
  },
  {
    "email":"filippimariacristina10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529933178/f9df3dedbd5153ad71753a1ff80d6fbd-1730302042"
  },
  {
    "email":"marinab1983@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723529834874/118eb1e13953afa431610e4e99389c51-1730302042"
  },
  {
    "email":"marina.degiovanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529998714/8142d03e41a3e3868e1e7d1587a5a9d3-1730302042"
  },
  {
    "email":"simona.tofani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530064250/a325e9c927d112e24043d8b189b0f9bc-1730302042"
  },
  {
    "email":"kikka7376@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530097018/e9999f1c7a55206b9268957a80a2e55e-1730302042"
  },
  {
    "email":"angelaimperati@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723529965946/e71491cc41d4e08b19b98e0980f42c9f-1730302042"
  },
  {
    "email":"robertamenegaz@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530129786/b19f99c9d772556873d0846145eda028-1730302042"
  },
  {
    "email":"a.zischg83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530195322/6d4d4902f535f33c632a7e41c33b443d-1730302042"
  },
  {
    "email":"marialetiziaciccarelli70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530162554/44420602f0c700bbb0caccb9391a4ee0-1730302042"
  },
  {
    "email":"giusealte@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530228090/62ec07e2dc917765882f8e7f3ddd7fff-1730302042"
  },
  {
    "email":"tiziana@lsgiusti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530326394/d11f1ebe366df0b7182034251e1feaa3-1730302042"
  },
  {
    "email":"paola@aservice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530260858/29b633c34e41b5d7dcbfdd4e3d37cff7-1730302042"
  },
  {
    "email":"elisasantini81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530391930/b336fc55c2822881c21e94cc536572b0-1730302043"
  },
  {
    "email":"giza.bt@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530457466/b91e07f965d5341094c90ac075de06ea-1730302043"
  },
  {
    "email":"nancy_00@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530523002/50b564eb24cf18b1592849b890623fe3-1730302043"
  },
  {
    "email":"b.bernardeschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530588538/8a61a5b1169ecce77f31ad4e74392d41-1730302043"
  },
  {
    "email":"luanabisci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530359162/802d5463fda144daf0670c8d649e9d37-1730302043"
  },
  {
    "email":"laura_villata@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530621306/179f9bf5442390c67851c101e90e93b9-1730302043"
  },
  {
    "email":"elena.st@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530654074/fe75dc390c04f99d01fda557065f9f90-1730302043"
  },
  {
    "email":"maresca.ferretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530719610/397c0bf9b89bddeaed37fbdec1ea0134-1730302043"
  },
  {
    "email":"agostinascata@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530785146/b0cd5ca6052a68c8c6337beb25c6cbf0-1730302043"
  },
  {
    "email":"loredana.scamardell@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530817914/346da792ffdfccce9b4bb8b9f0286aa7-1730302044"
  },
  {
    "email":"cinziamarta2004@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530883450/672a0e4ebcc951cbcdd7fdd7477d4176-1730302044"
  },
  {
    "email":"angela.fantini70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530850682/2da02ce69f409981c12d8552e4615c15-1730302044"
  },
  {
    "email":"elisapaoletti76@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723530686842/56fcecc03278ca01a7258268276d3c7a-1730302044"
  },
  {
    "email":"michela.perathoner@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530916218/ff512c079b968073835da631ac1405d9-1730302044"
  },
  {
    "email":"barbara.gardella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530981754/00b0ecee917957a7f82a341108c91552-1730302044"
  },
  {
    "email":"sandra.fatatis1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531080058/47680a4a4523d9c29d7a819f32629b6e-1730302044"
  },
  {
    "email":"barbara.rizzo1994@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531145594/11fc501642fc1e4f64a81970d5097b40-1730302044"
  },
  {
    "email":"giglioivana1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723530948986/37b5dcc78692a4c7e51ccc5bb9b776e7-1730302044"
  },
  {
    "email":"cristina.mazzilli@fondazione.uniroma1.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531112826/d68845078696edfc937950e18cccfbf4-1730302045"
  },
  {
    "email":"francescaprocaccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531211130/2cff1cf4a6461eb24a64205d85237c58-1730302045"
  },
  {
    "email":"stefania.tunesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531243898/73090398d235603f496c77e0b9c28d03-1730302045"
  },
  {
    "email":"xodogiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531276666/8227eb70120045d1da03163cfdc585a1-1730302045"
  },
  {
    "email":"maragiarrusso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531309434/694f30a4a8c264e9010869ba6416e411-1730302045"
  },
  {
    "email":"maria.digregorio1970@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531374970/b0c2b4efcc7fcef219b5b1cf80bf9032-1730302045"
  },
  {
    "email":"ritapicone2003@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531440506/4e0c5dafbe78b2d754cd98d9ee957e6b-1730302045"
  },
  {
    "email":"santicioli.b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531407738/4e45ecb5da15c90a41ca5b6afc4b5e8f-1730302045"
  },
  {
    "email":"angel_as@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531342202/f130e906955c18a75f57eb1141c0ddc6-1730302045"
  },
  {
    "email":"miranda_bibbo59@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531506042/ac7799896425cfb31532fc998cde991f-1730302045"
  },
  {
    "email":"mariekevanrooij68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531473274/7fa79bacd24d11ed89c7dc066c78c22b-1730302045"
  },
  {
    "email":"postatizianarossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531571578/edfad6a28a5aa53e87aa9a459e9749f4-1730302045"
  },
  {
    "email":"p_aricci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531604346/456e8891e598a56e5a10da8b0e154f14-1730302045"
  },
  {
    "email":"annaluisadellanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531669882/b4f993462e3d39832d9e1a831f8bf681-1730302047"
  },
  {
    "email":"stefaniacomis77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531768186/8e23001af838b393252c9a169cf68592-1730302047"
  },
  {
    "email":"raffaellabardeggia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531637114/058d67294b387b2784bbc94ae9b2cc87-1730302047"
  },
  {
    "email":"mariagerratana1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531702650/5ed020e09d21235096b1ebbee2039b99-1730302048"
  },
  {
    "email":"ermelinda99@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531800954/cdc28ec17a63f7c2bb486d5993e349aa-1730302048"
  },
  {
    "email":"davide.dacquino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531899258/5f08903f7253910f28be15fc0fd4ef42-1730302048"
  },
  {
    "email":"accafra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723531932026/38c4e5f7a6edb8cd2744fec89a45c615-1730302048"
  },
  {
    "email":"faslore2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531833722/b5c1cc6db662de3beefcec6e1499ae08-1730302048"
  },
  {
    "email":"chiara.tarletti88@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531964794/0a3e473d18364063705b092c5df4a1e7-1730302048"
  },
  {
    "email":"mter.massa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532095866/71b3ba7776a4f5cb54292160ebb96eab-1730302048"
  },
  {
    "email":"chiararacasi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532161402/c1f9c5d20fa615fae083adc4139d9839-1730302048"
  },
  {
    "email":"valeriapuntocosta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532128634/4e1d88fdb2d846e4f0ccde7c03a0e70b-1730302048"
  },
  {
    "email":"simoparmabologna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723531997562/9b1429d98a796802ba7c0880bbd7ecd6-1730302048"
  },
  {
    "email":"sabrina.richeldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532292474/ec0976ade6c5491140ab64693de9a67f-1730302049"
  },
  {
    "email":"marta_borsi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532226938/14f3107ea62be6cc2c83b92a3990a3d3-1730302049"
  },
  {
    "email":"barbara.mocci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532325242/62ac3033ae5e79afa525bbd6492be74f-1730302049"
  },
  {
    "email":"lorenzobetti92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532358010/d0f192917fd8a1a39ff11b0b1ae773c8-1730302049"
  },
  {
    "email":"andreasavi257@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532390778/b9265db56eb437d600073e6cfef7bcad-1730302049"
  },
  {
    "email":"lauravicini85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532423546/e5761c2e23675e11cd202982d374e310-1730302049"
  },
  {
    "email":"robytad68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532521850/8e939f221f81cde749f2e4ca4f605e4d-1730302049"
  },
  {
    "email":"simona.marinellia@homtail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532587386/069455c82ff30b0a7e3f01639128e5e3-1730302049"
  },
  {
    "email":"lea.talone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532554618/599046b545339e9ce4b816c60e80f43b-1730302049"
  },
  {
    "email":"rossella.fos@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532456314/424b6d2c928ceef1d043ccc3024eeef4-1730302049"
  },
  {
    "email":"juttagamper@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532652922/4f230b68a4eadf945b5201cec76f6a55-1730302049"
  },
  {
    "email":"erralucia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532685690/3316b95bf3d2ee66a2bcfe903c3484b8-1730302049"
  },
  {
    "email":"teresagiordano70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532718458/52e1594e0afff12f9a9bc7a09758d63b-1730302050"
  },
  {
    "email":"pilary72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532620154/92074d81decd8ce13e51b5da69f6b16e-1730302050"
  },
  {
    "email":"mfirrincieli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532751226/6247c463f4c45cfd1f0e4e9ce4989f23-1730302050"
  },
  {
    "email":"info@studiopettico.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532783994/71d9e5f49e7726bff0812017cb0ca984-1730302050"
  },
  {
    "email":"graziellar76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532849530/61b375cc44f6c778be98afae8afdc3e3-1730302050"
  },
  {
    "email":"piera.copponi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532915066/f93b8f5ff3f6c33daf74122e6b294853-1730302050"
  },
  {
    "email":"roseda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723532947834/e2ea6e43b76d10871750b6ead43099d3-1730302050"
  },
  {
    "email":"farmacia.nicolardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532882298/9167530626dfaeb8a57f135e5affcd1c-1730302050"
  },
  {
    "email":"serescia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723532980602/9f882248e19d46143b72b5c1dcb663e1-1730302050"
  },
  {
    "email":"avv.federicagambini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533078906/00f806df2781ccc93b15691f5335f41d-1730302050"
  },
  {
    "email":"selimmaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533111674/2b52d962a65df2a9f09a0bd78c9864c3-1730302050"
  },
  {
    "email":"gemelligiulia00@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533144442/f03e2daad438ef7db1d865aaede5c247-1730302051"
  },
  {
    "email":"c_zambutositra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533046138/13550e39028f1a7f36f11440b383ce50-1730302051"
  },
  {
    "email":"danieladelproposto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533209978/c6b44166f583f4c5f1f6eedede58a026-1730302051"
  },
  {
    "email":"gcotta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533275514/46a00e51cb72cbce44ab0ce365bbde8b-1730302051"
  },
  {
    "email":"paola_m_mare@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533308282/55d4eda69f71c46af51b0fa522741bac-1730302051"
  },
  {
    "email":"carla.montisci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533242746/b095393ad5a495a78a3edfd7e22d96b0-1730302051"
  },
  {
    "email":"mantoniettadituri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533406586/492dc54ad7c4a5f419c4ac1372e56ca4-1730302051"
  },
  {
    "email":"alesedoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533341050/f575075d9b654e92ad8927f31bed159d-1730302051"
  },
  {
    "email":"cpichichero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533439354/ea33db129dc034b7baacbfe50691d264-1730302051"
  },
  {
    "email":"erikapaletti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533537658/9470cc0a7ee7da7c500add6686305acc-1730302051"
  },
  {
    "email":"manuela.bossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533472122/3a3e0008620129b4e29c7e446ac8d90a-1730302051"
  },
  {
    "email":"eleonoralattanzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533603194/b9e13998bfe9ab6850df3fdd0e217d04-1730302051"
  },
  {
    "email":"allerota1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533635962/fe8f020d6d5ff0c781e2de8532e33ff1-1730302052"
  },
  {
    "email":"ancorailaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533734266/aca99e386a0296b33b14366b7e7d89e3-1730302052"
  },
  {
    "email":"cinzia_falk@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533668730/4602138b8fae73d10adb836ca7114107-1730302052"
  },
  {
    "email":"barb1981@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533701498/60e4eef2b0d97a31688337137ac8c8eb-1730302052"
  },
  {
    "email":"roby.ranzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533767034/c1d08eef0959e68327f8b51bdac18fb3-1730302052"
  },
  {
    "email":"manuela.moncada@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533865338/271fc0898cfc12350d097b5b9e7a67c7-1730302052"
  },
  {
    "email":"robertagoffi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723533898106/a147f9ae3a71113367ef2c7b5973baa1-1730302052"
  },
  {
    "email":"ludben69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533832570/825dfd98f97b01b44617178164a6587c-1730302052"
  },
  {
    "email":"avv.tucciemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534029178/09f2291aa7d088031d314a74f0d2775f-1730302052"
  },
  {
    "email":"liuzzidaniela6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533930874/3f42a0d19d33ae4434731b0f64ce6fbc-1730302052"
  },
  {
    "email":"arianna.turini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534127482/8a350fb5390a803fe88c00a9dc4ea642-1730302053"
  },
  {
    "email":"lorena.ragusa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723533996410/55d527cf61438018b7940f0befba875d-1730302053"
  },
  {
    "email":"persim@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534193018/8a3f613a8d3a65b16306e0dcf7b98c50-1730302053"
  },
  {
    "email":"sonjnadj@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534258554/9a9f5d53aa8f3be059addac2af9e2e07-1730302053"
  },
  {
    "email":"beatricepaolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534225786/2e2f3b11c658f9353388c3d9303747e3-1730302053"
  },
  {
    "email":"rinaldi.rossana1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534160250/a9106ab990511c8ed9305af58f9fbc4a-1730302053"
  },
  {
    "email":"silvana.rizzuto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534291322/abbf33fc87bc57b5f4c458e48f3e8f51-1730302053"
  },
  {
    "email":"marta.rizzardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534324090/1410b1dcd587520ff2fca67848adf4ea-1730302053"
  },
  {
    "email":"marilena.patalano1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534356858/94661ab2804746fec5b6ff39f9bc7534-1730302053"
  },
  {
    "email":"danielaceolin454@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534455162/75a80adb4c8247ea04b46d923523f553-1730302053"
  },
  {
    "email":"paolalasaracina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534520698/da76bc2e48a7546c5293bd98f13d31aa-1730302053"
  },
  {
    "email":"clelia.manganelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534487930/1a75b12e8f2baa57ac6c5a4b7d961177-1730302054"
  },
  {
    "email":"marta.rizzardo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534422394/561b56c6a4a7645d119d223652bf484b-1730302054"
  },
  {
    "email":"lorella82bs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534651770/af2701547175a0656a7e2de867ac8c68-1730302054"
  },
  {
    "email":"nicoblondie@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534684538/df3539fd99e4a3b7ae1c8cf0cc19859f-1730302054"
  },
  {
    "email":"ricci.cinzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534717306/11aaad1f5db1698564415330ab89ff5c-1730302054"
  },
  {
    "email":"eliporta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534750074/1338d6788b27c9bc35332d6f336ec7f2-1730302054"
  },
  {
    "email":"sara.fornasari1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534553466/8ab58b9760709523e010be292c1644d1-1730302054"
  },
  {
    "email":"t.cristal69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534782842/d5d648ead0f02e5077fc45f27a3a6b96-1730302054"
  },
  {
    "email":"chiara.ang@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534848378/39d8ee36fe763c2f9650ffdff36ba555-1730302055"
  },
  {
    "email":"amy68simone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534619002/36a1d2b2ded446420175200b38403331-1730302055"
  },
  {
    "email":"casavolag@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534815610/c93bf36269b30bb54279060a608387b7-1730302054"
  },
  {
    "email":"serramm@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723534913914/9b75dedf3f8d4529287447106eb48afd-1730302055"
  },
  {
    "email":"jen.tek.yp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535012218/7758994b5349ae051dcc1bf20b9f5d16-1730302055"
  },
  {
    "email":"laura_farinelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723534946682/7c825340b61eecc793c274fe93b30295-1730302055"
  },
  {
    "email":"serena.alibrandi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535077754/931e43cafdd9d1291153517c13b66285-1730302055"
  },
  {
    "email":"laffranchichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535110522/f28d5b048a611ba6a3ae4c71c9de3634-1730302055"
  },
  {
    "email":"manunebu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535176058/939669c064cac5d2396fcdde38ebebae-1730302055"
  },
  {
    "email":"leontinomargherita@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535044986/496dd458ba9fbff9edaf299cee27a7e7-1730302055"
  },
  {
    "email":"cagettilella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535143290/23a72e552ce8beedb618571d4ea4bebb-1730302056"
  },
  {
    "email":"giusi.zan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535208826/ac70d31e0dcc3144c668fd5b15f29e28-1730302056"
  },
  {
    "email":"federicafanucchi84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535241594/3ae8f0cf0fa8da7d5642e824ceb93a31-1730302056"
  },
  {
    "email":"silviajor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535274362/a2cc359dff98cb98e66cd71f69e668cf-1730302056"
  },
  {
    "email":"avv.darcangelorita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535339898/d4ed6dbd989351ffb610605e65225434-1730302056"
  },
  {
    "email":"fragirol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535372666/016a78c04d543367ccd6f7ff2dfadf66-1730302056"
  },
  {
    "email":"permanuel@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535405434/24762f83ea69ec603ac3ceac34840c6d-1730302056"
  },
  {
    "email":"crimed72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535307130/25f08160060ef7d3bd0c41ee0714daf1-1730302056"
  },
  {
    "email":"elenagirone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535438202/a02d68118df54691216a6688eef9fa4e-1730302056"
  },
  {
    "email":"avvveronicavella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535503738/643306d9dfdcc7d752b584e4082e003d-1730302056"
  },
  {
    "email":"danielka703@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535536506/fe0f0f2ddfa97ceaf87e9dbe8fef0348-1730302057"
  },
  {
    "email":"mar-mary@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535634810/3eff072440c77d6f3dfd58d225d98bde-1730302057"
  },
  {
    "email":"lazzarirobby@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535470970/54752e883660476bde3d0782a0498c18-1730302057"
  },
  {
    "email":"manuela.oggioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535700346/2fae2d949439f02ec8a9bd3bd49d0c26-1730302057"
  },
  {
    "email":"manuela.marchini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535765882/9c3a726193498d18b994a9da88adef90-1730302057"
  },
  {
    "email":"uranialagrasta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535667578/1aff5abcd67fa3acaa14dbab1162d9ab-1730302057"
  },
  {
    "email":"m.convertino1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535864186/f2eb406692447d5debcf44db868fae2a-1730302057"
  },
  {
    "email":"mariannagallery@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535831418/19c0db7086204dc2d5ddac8e961b4c1f-1730302057"
  },
  {
    "email":"leighgeissler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723535995258/6896604b53c9cef7a9afee04dbd55685-1730302057"
  },
  {
    "email":"martamanetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536093562/b1823f76e8971eb180871be2501cc697-1730302057"
  },
  {
    "email":"russomanuela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536028026/52d5a2f6949791a943b473fc240d58c5-1730302057"
  },
  {
    "email":"nunzialoc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723535929722/1a80e5f04179c7f61d8e2ad1e595a05d-1730302058"
  },
  {
    "email":"ivanabarreca@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536126330/b15b2c36112cff1ff12646ba6972f6e7-1730302058"
  },
  {
    "email":"a.verga@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536224634/f57c214e3ed9078bd4f8863fd213f7fc-1730302058"
  },
  {
    "email":"dot.pantalone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536257402/4e527e3ecfad2c91c170bd6f8e60e05d-1730302058"
  },
  {
    "email":"cristina_bua@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536290170/2129ab448ebc5838814f6a9fd3aee862-1730302058"
  },
  {
    "email":"paolazacco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536159098/c80660d287f3ffa148849b961c5fecf8-1730302058"
  },
  {
    "email":"scarfis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536355706/809a9d3fa24a920bae5fbd58b0c3b69e-1730302058"
  },
  {
    "email":"antonella.broca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536388474/f92db3870752e54c1327d80818d6f83b-1730302058"
  },
  {
    "email":"emmaclaro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536454010/ef009658c7d43dbb113ea2e9a3afe00d-1730302058"
  },
  {
    "email":"maisondieci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536486778/c5e8bfe6c83afc6c195f64e30c35762d-1730302058"
  },
  {
    "email":"ferraraidarosaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536519546/a168c606ce86ba423c84df4d1f165ccd-1730302058"
  },
  {
    "email":"perlapasquinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536421242/9dd548a7c418572e7525283adfbec23b-1730302059"
  },
  {
    "email":"napoli.pasq@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536552314/06193a4c504243c476745f93fa75c96a-1730302059"
  },
  {
    "email":"74cristiana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536585082/baff6d4ce11e51200af2a41e8b658f63-1730302059"
  },
  {
    "email":"stefaniarondini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536617850/bce0b71a9423edb5ee27d6eeddcc15bf-1730302059"
  },
  {
    "email":"ang.daniello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536650618/ab111e009a657646647c3055b1042b7c-1730302060"
  },
  {
    "email":"annalisa.trenchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536716154/006b36b4d64c435b720b279c7ac288f0-1730302060"
  },
  {
    "email":"s.nicole.1994@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536683386/60ec075277455606dca5f27913da6f01-1730302060"
  },
  {
    "email":"federicagambini13031969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536748922/d0dd258ad294fb0257971e42f01c7743-1730302060"
  },
  {
    "email":"rosella.valli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536912762/65aee2ab498f1d15eeb088530750da02-1730302061"
  },
  {
    "email":"proiajessica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536847226/9264509c10f13a07206fb1cdfee6130d-1730302061"
  },
  {
    "email":"kristal.july@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536814458/70f9abdc659b3064c9767ff754094318-1730302061"
  },
  {
    "email":"lisarozza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723536945530/8d9e623ec2f6a15fdf4b58d06fe0cb71-1730302061"
  },
  {
    "email":"spelloni15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536978298/533f17591b190d01719b599342c7c9f7-1730302061"
  },
  {
    "email":"annapotenza76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723536781690/8bb4a90ba85d375b2e7292133fe11719-1730302061"
  },
  {
    "email":"ivavo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537011066/0bda4db73708689f7b9860bafdf54923-1730302061"
  },
  {
    "email":"mile.d@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537109370/3a4b09b70bfa7a4d4e41cc602bb6bb03-1730302062"
  },
  {
    "email":"alexandra11.limosini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537076602/d0e1a59d4b14a8852642857cc3888d42-1730302062"
  },
  {
    "email":"lullyavitabile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537142138/83b6bd19ffa0c6e4ae3069c62450ce57-1730302062"
  },
  {
    "email":"ferrari.monica63@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537174906/124a58f4d0ded30d51bfbe50c8d1f446-1730302062"
  },
  {
    "email":"libertimariaelena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537338746/d62454a9157768e22e2545a80c40b9dc-1730302062"
  },
  {
    "email":"barbara.baraldi70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537371514/2efeb58f760fe5e04439c867fab71734-1730302062"
  },
  {
    "email":"elisamontorsi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537404282/07605f6c91d639893f9c980b99045158-1730302062"
  },
  {
    "email":"chiara.crescenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537437050/b1bf56330186ff11a565384df4053461-1730302062"
  },
  {
    "email":"manuela.piola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537469818/8cc38faa1cf007d4d8cb7a9b5b5ee2bd-1730302062"
  },
  {
    "email":"blauebeere@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537633658/23a29eaa28695a0f7447f1de93291276-1730302062"
  },
  {
    "email":"deborarosini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537666426/601e2e87f93fc1b06e002017ee526132-1730302062"
  },
  {
    "email":"jupitersplaceforhappiness@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537600890/0794c0b1c92ba022e162cbee44e9e596-1730302062"
  },
  {
    "email":"mariachiara.durio@diaverum.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537699194/b27610106ff3a4e33ec5a1af092b31fb-1730302062"
  },
  {
    "email":"manuelacampione69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537731962/9ef652270eb5a62d767fa395ff07fd11-1730302062"
  },
  {
    "email":"kiarist84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537764730/4f9c832c8e87f080af2de2d8d4c345ae-1730302063"
  },
  {
    "email":"titticavalli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723537863034/96805256df30b607b37970bf77b31193-1730302063"
  },
  {
    "email":"e.cappellesso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538092410/83c14ba4f1df6e12759a46fbf1635348-1730302063"
  },
  {
    "email":"pasquinellipaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723537797498/d51f2d92c38f5dce364f25390a7227e9-1730302063"
  },
  {
    "email":"barbara.caruccio@csmetalli.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538059642/bf264e74a4b336a168bd24541ead7d6d-1730302063"
  },
  {
    "email":"francesca.re09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538157946/4e05d788e3b7170fd17b75a897c6b45d-1730302063"
  },
  {
    "email":"madara.horsta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538256250/404322c216200b2d948d49b4fe3c26d2-1730302063"
  },
  {
    "email":"margheritammr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538125178/aee7f8b29fd0639185cb66eb4f3b0a7e-1730302064"
  },
  {
    "email":"zingasilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538321786/b2baa38686d40de5c7f6b3f897ae7b09-1730302064"
  },
  {
    "email":"desantis.rd@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538387322/2a1e5023eb7c4745eb7b162abab1432f-1730302064"
  },
  {
    "email":"francepulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538354554/b455ad1bcbd471e2e82774a0c1b3d336-1730302064"
  },
  {
    "email":"marilena.castelnuovo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538190714/c3919ded1def501fe5eef6b74c8364b3-1730302064"
  },
  {
    "email":"r.barbie@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538452858/e61d2e54f3672226006f387d6370b587-1730302064"
  },
  {
    "email":"gaiacris@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538485626/0cf96e6559c4eeaef501d9377bfbfe07-1730302064"
  },
  {
    "email":"brunamarialotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538518394/09835b1a6c9b8e064e6a55cdee4cb80f-1730302064"
  },
  {
    "email":"rseccia976183@vodafone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538420090/615bbc5818e0f0c61ea3b227c394ddd7-1730302064"
  },
  {
    "email":"stella.caden1964@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538551162/86f2108091fc6b285ff1a0a0e1118847-1730302064"
  },
  {
    "email":"torespanu10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538583930/74fff73d6f4e63e97d23ba247bfdaa32-1730302064"
  },
  {
    "email":"villina80@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538616698/cfa9c8b52f8aade3238fff843de16b93-1730302064"
  },
  {
    "email":"lallyb@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538649466/68a765f9c35588eed7580abda2b8573b-1730302065"
  },
  {
    "email":"m.benedieci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538715002/ad436b6dba07ed5a135fa0bdcd138f4b-1730302065"
  },
  {
    "email":"patriziaf64@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723538682234/bd9a41436e166e3d28df15762aa22f65-1730302065"
  },
  {
    "email":"vanessagatto@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538780538/b6294df909d3c5de95848bebf3f065eb-1730302065"
  },
  {
    "email":"annaritabianchi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538813306/46e3b067f7e978056ca6ce43432ffd5c-1730302065"
  },
  {
    "email":"silviapressato16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538846074/bec96deb4c623438aea09f6d5e4ee24f-1730302065"
  },
  {
    "email":"gilly.girardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538977146/55d148ee720c8c9dc734b757a8af3088-1730302065"
  },
  {
    "email":"claudia.falaschi.72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538878842/95fa036d3131c475a6849aa401657367-1730302065"
  },
  {
    "email":"marinaagozzino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539009914/597fea51c2fc7aea29c4fe4902bc3a04-1730302065"
  },
  {
    "email":"monicascipioni@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539140986/9d9fa362ef82f9691658b9ea70b98610-1730302066"
  },
  {
    "email":"silvia.mili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539075450/9ac783ecb9caf97ba152a51571c995ef-1730302066"
  },
  {
    "email":"amaya.regal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539042682/7cc954ba808f52a5632e6483aaebac1a-1730302066"
  },
  {
    "email":"ely.ami88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723538944378/703fb25f7816c517a0e5a2ee03117e6c-1730302066"
  },
  {
    "email":"ing.p.paggia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539206522/3fc3f65473103e601a773d982aeaf801-1730302066"
  },
  {
    "email":"martina.raich@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539272058/ed30c89fc946b96117e7c8d49af8cee9-1730302066"
  },
  {
    "email":"barbara.terenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539173754/cb6ca3e4981b857746a69ca76e9d711e-1730302066"
  },
  {
    "email":"tatiana.morando73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539304826/acecb8455bef048be4efe04415ad1ccd-1730302066"
  },
  {
    "email":"coloniasara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539337594/52ba1b046acf6db231c3bee13c234b0b-1730302066"
  },
  {
    "email":"petronelli.giada@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539370362/dee3901ddace44a4339b6bc31d7ff245-1730302067"
  },
  {
    "email":"lillaclippy@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539435898/bd805d4381efae9b7d6313128ece1a65-1730302067"
  },
  {
    "email":"carmencorda@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539501434/64b70e9c04a48f41eedf559ecdb35bb3-1730302067"
  },
  {
    "email":"mottab5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539403130/8a6ed1dbcf7ead7912e2d4259d64fb3e-1730302067"
  },
  {
    "email":"tiziano.morosini@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539566970/2db0b293f0bedf41c0eaa3bc520e98bc-1730302067"
  },
  {
    "email":"achab1955@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539468666/cce96cfad2f20ac24101ae60256d6077-1730302067"
  },
  {
    "email":"barbara.settesoldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539665274/c868ab5f7edff6c7a1fab796e1aec34d-1730302067"
  },
  {
    "email":"alessandra.cardosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539730810/11170dfbd54556b38d36c27cbeb606e5-1730302067"
  },
  {
    "email":"larisoncik2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539698042/c5157b9097a1d9bfb7a74822150b7744-1730302067"
  },
  {
    "email":"barbaravagaggini7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539763578/d73c5b8aa6d3016bd793c94cc4bfd60d-1730302068"
  },
  {
    "email":"red.snapper@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539632506/fb422953acc5e002225615bc8ec658c6-1730302068"
  },
  {
    "email":"marisabenetti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539796346/48b583be89a1c5a657fd78654b27dfc9-1730302068"
  },
  {
    "email":"annaflora.marin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539927418/9591a06220f3931d1aefa95e45a8d2be-1730302068"
  },
  {
    "email":"manubobbio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539960186/b4665c22b54e051d3e69081b0ce46c3a-1730302068"
  },
  {
    "email":"breschiclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539829114/33a093a200583c8aed92f03f652cb1c8-1730302068"
  },
  {
    "email":"zanardellielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723539894650/197377cafd1cbd1af2b41dfbf0415ff3-1730302068"
  },
  {
    "email":"danyscaf@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540091258/809946e787c35223fd447622c1264afd-1730302068"
  },
  {
    "email":"isadiben18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540025722/9ee72d222ff1faa208adb020542919c2-1730302069"
  },
  {
    "email":"futuroarte9@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723539992954/393119f617b3b0dc7264d6e42ecf4bfe-1730302069"
  },
  {
    "email":"alessandrataffi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540124026/4f426b29f5ee42b508d9bfa994793f70-1730302069"
  },
  {
    "email":"mari.angio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540058490/afc8903ae4ef07c51af4331d7cc56aa3-1730302068"
  },
  {
    "email":"degaetano.c@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540189562/72e029ce79af88329d4d9da65e168f4c-1730302069"
  },
  {
    "email":"brunello.giuly@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540156794/7ff49899ab692b6e32b368816af7d3df-1730302069"
  },
  {
    "email":"antonellafiordi59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540353402/9e5da8d0f537df29002e9edc0c85c29f-1730302069"
  },
  {
    "email":"pasquale.capotorto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540222330/c3a78796ecfc45c02822edc46cb1c760-1730302069"
  },
  {
    "email":"laura.boasso@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540255098/f9c1c828acc74b99c1f47f6f7ccefd88-1730302069"
  },
  {
    "email":"santesartimariaelena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540418938/8ff70cea942ebb273d9467ed493af6f2-1730302070"
  },
  {
    "email":"elisabetta.pichenstein@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540451706/b7eec45df6454e9735f1233f328f0ba9-1730302070"
  },
  {
    "email":"maiteimmobiliare@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540386170/94ca2e427f73afbea40d964d382f8f58-1730302070"
  },
  {
    "email":"moni_morelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540550010/267c0cbd17b7c58b6d12d620dbdb2bc2-1730302070"
  },
  {
    "email":"grazia.disalvia@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540615546/5223db8b862d81a4ea4461cb0ec99f66-1730302070"
  },
  {
    "email":"gmenardi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540582778/38cbe0fda6d8151464d09fac3313080c-1730302070"
  },
  {
    "email":"beatrice.a68@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540648314/3584236eff046d5508b3bd3fac2548f9-1730302070"
  },
  {
    "email":"fiorindaki@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540746618/4cccf60e55a2e87c71a9d39215012a73-1730302070"
  },
  {
    "email":"vera.scano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540713850/83fd50b6a8f21bcfbc504a02a09449d9-1730302070"
  },
  {
    "email":"laurarebaudengo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540681082/a968ebf104e95b6f2e97506e8f3b0f26-1730302070"
  },
  {
    "email":"salata.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540779386/787a45b2da843a85e697879cf4e3216a-1730302070"
  },
  {
    "email":"gina.barbano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540844922/5bc2f828619d2ce8af34f26951ace491-1730302070"
  },
  {
    "email":"antonellalorenzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540910458/36126c703be537a3dcd22cff695f5b81-1730302071"
  },
  {
    "email":"carmela.balestra1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723540943226/e25aee9257df7cb5bbe18df98b6ead40-1730302071"
  },
  {
    "email":"c.pan@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541008762/67c7780a897c9027722dbe6e35df4021-1730302071"
  },
  {
    "email":"letizia.iati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723540877690/911e2c5de0db674d008ea38b78b00fcb-1730302071"
  },
  {
    "email":"rosanna.miglietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541041530/f5ed5e8aa9b65825e1bc6996946ac0fe-1730302071"
  },
  {
    "email":"valentinaquintiliani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541107066/7955ed91bdf13e364c370891dc65af07-1730302071"
  },
  {
    "email":"chiaraballarini77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541074298/8e7c19ff75a70e1ba61fa99dd948fee8-1730302071"
  },
  {
    "email":"mp.orecchiuto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541205370/d4896498607ea50f6f0496b539ca546c-1730302071"
  },
  {
    "email":"marina.studioscola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541336442/458415ced10ad8f4f755d758825d904d-1730302071"
  },
  {
    "email":"danielalandi77@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541238138/d7fd3349bf0ffc8c87583bd753d70e95-1730302071"
  },
  {
    "email":"1977barbara@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541172602/953efc52d0311609a35d6e54b166e373-1730302072"
  },
  {
    "email":"daniela.anatrella@aruba.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541270906/8064aa6d3dca6fc2a4957b89aa067b92-1730302072"
  },
  {
    "email":"caro.giuntini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541434746/227e714c5310dbb5fe34e718ce0a6404-1730302072"
  },
  {
    "email":"a.bresciani@zato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541533050/849a36a30931f1727bfc56b2651aac68-1730302072"
  },
  {
    "email":"spinaangelo64@otmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541401978/b57f389aceff4eb270ddb661f590454c-1730302072"
  },
  {
    "email":"a.rusciadelli@uniurb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541598586/b8907f94ab5992cf830e6b8ac05d3406-1730302072"
  },
  {
    "email":"avv.isabellaassenza@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541565818/df1bfc2ce0e38832aa77177b6c60e772-1730302072"
  },
  {
    "email":"alessiascottodicarlo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541467514/7cf8fdc798c920ef6c4d1e30ae1e8349-1730302072"
  },
  {
    "email":"federicichiara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541631354/1f092e91286e56d20e9547887c586013-1730302072"
  },
  {
    "email":"disauro.simona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541664122/f45ba4a050a2d4725ee2515d5acd4e49-1730302072"
  },
  {
    "email":"elena.tortone@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541762426/b56331f957ee4b3e81ab495f4b659e2a-1730302073"
  },
  {
    "email":"cristinamason@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541729658/a8656a94c2af3ae082f5170cd67d77a2-1730302073"
  },
  {
    "email":"tatianasatta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541696890/4c4138faa8559c626248fcf8f62ccd58-1730302073"
  },
  {
    "email":"maratafiammetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541795194/353dbb5372d90e1ec9b74ac3f3580b0f-1730302074"
  },
  {
    "email":"mariarosariadevita77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541827962/e0602e6716f26a0f32811571623a0aee-1730302074"
  },
  {
    "email":"annalisafanizzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541893498/d93fb678f0fe01f92f48415b19b12be9-1730302074"
  },
  {
    "email":"pantuffl2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541959034/ba44808259231f79a26717eec0bb1e67-1730302075"
  },
  {
    "email":"cristiana.sciandra@cartsangiorgio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723541991802/cb277ccbd7b8d76fa29844842db10321-1730302075"
  },
  {
    "email":"ab.18455@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542024570/16773b01e05025b205955666a6e53b97-1730302075"
  },
  {
    "email":"mafaldabla77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723541926266/f9434542e7aff7ef3eaf95980493cec1-1730302075"
  },
  {
    "email":"titti.selim@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542090106/42806fd78e48ebcebc2e8eac47a25fb1-1730302075"
  },
  {
    "email":"crimarimilano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542122874/4ae43ce9536bb95d976b5a1360394538-1730302075"
  },
  {
    "email":"elisacevasco21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542057338/93fa4ec6fbc370591a46daf1fdd8b830-1730302075"
  },
  {
    "email":"messaligiulia23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542155642/7937181bcf797ac7decfaf1edd3fb1d8-1730302075"
  },
  {
    "email":"ninab611@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542221178/735021ab37bf8f778c5dc97bb2c7741d-1730302075"
  },
  {
    "email":"rosalia79@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542188410/e8648789566c896b36fe48a5652d4445-1730302075"
  },
  {
    "email":"paoloa65@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542253946/b9f91716959587394c0d79e0327c6af2-1730302075"
  },
  {
    "email":"raffaele.miranda2@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542286714/fcb94cecfe4666f93647b6b1685aa882-1730302076"
  },
  {
    "email":"stabilmente_instabile@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542417786/e63109f0c4ecb72b479fcc539e0ac164-1730302076"
  },
  {
    "email":"chiarafiorot78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542385018/8c74e9a8342a1b8aa5fc541f4991508b-1730302076"
  },
  {
    "email":"silvia_severini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542483322/8ad2d8e73f8f79dcd014a303d0cbe831-1730302076"
  },
  {
    "email":"gaspare82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542516090/07d27ea3ad119e87ce6cd2ebe2ff677c-1730302076"
  },
  {
    "email":"bertoletti.emanuela2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542352250/7ee4f6cb3e2d57f22051c2783db8d04d-1730302076"
  },
  {
    "email":"info@marcodelrio.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542581626/335d9c1ae87b0a152392cc6e3a2c61b3-1730302076"
  },
  {
    "email":"barbara.sciandra@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542450554/3a0b916f62dfe6cdec0c1baa810c9c0d-1730302076"
  },
  {
    "email":"ivana.claudio2012@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542614394/4857c0c6032ba106f31eae92609dae02-1730302076"
  },
  {
    "email":"fede.r78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542712698/47dfb2265844aae3c354db9f5384d7ee-1730302077"
  },
  {
    "email":"carolina.mameli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542745466/12ea78afd8b552d4a7ec3867746db408-1730302077"
  },
  {
    "email":"martatrivella78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542679930/d973f536cb570e6e0447c6cade839103-1730302077"
  },
  {
    "email":"ilenia.antoniazzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542647162/6ceae052a950bd485adabd08a1a4c773-1730302077"
  },
  {
    "email":"michi69land@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542778234/d802b54385246ced8038208e0ac2be0c-1730302077"
  },
  {
    "email":"info@hotellacommenda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542843770/43c6bef8e93ddb1e99e79c16d3068126-1730302077"
  },
  {
    "email":"alessandromarinobonanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542909306/b8997408902cf22416a333de6fdcf5f0-1730302077"
  },
  {
    "email":"ilariatonelli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723542942074/05159dce902a933262b7910489ff0b3c-1730302077"
  },
  {
    "email":"anna.tede@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542811002/622882485b3753fed68aae859bd71cbc-1730302077"
  },
  {
    "email":"lceolan@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543007610/5801e7bf7acd201a50021814a3aa19dd-1730302078"
  },
  {
    "email":"silviantonini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543073146/5c822956cc1dbe0244bd03038499057d-1730302078"
  },
  {
    "email":"fragio1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543040378/98cb1e54b9202b1803ceaf4e5725405f-1730302078"
  },
  {
    "email":"luisaagostinog@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543138682/0606b93e3e69f5aac60359974525ace5-1730302078"
  },
  {
    "email":"info@esteticafiorellino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543204218/4a1a44c4db75f07f05609454f0bdfde3-1730302078"
  },
  {
    "email":"marimusca78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543236986/98002433d4e5325af3cfbac8ad17c265-1730302078"
  },
  {
    "email":"prof.asimeone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543105914/78f6036b5025553fc2ae4dbd0ca1a3a6-1730302078"
  },
  {
    "email":"barbara.sanna@liceoazuni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723542974842/b04776f187e47f6ca6ec25041f61f47a-1730302078"
  },
  {
    "email":"nmartino74@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543269754/eefd18cb19e59812cdf262b0ae90e10f-1730302078"
  },
  {
    "email":"greghiggeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543368058/676d4ceaf32bf9df593ef2ff50402846-1730302079"
  },
  {
    "email":"rosanna.inn@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543400826/32b9c73499c0ebe44ce0f433f4f8944f-1730302079"
  },
  {
    "email":"elisa_pavesi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543335290/c6b20d8148633d7f270509e885b6ef57-1730302079"
  },
  {
    "email":"monica13x13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543499130/32788ac5eebfcc9662e6318e6991992a-1730302079"
  },
  {
    "email":"bricorbella71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543433594/bdac18feb474eeb58b8d729b1e978fd6-1730302079"
  },
  {
    "email":"mmadrigale69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543564666/30e51d2d619c2f27a056fd2c05a6a27f-1730302079"
  },
  {
    "email":"monicals@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543531898/f1d7e94176d9d7d55d17217c1a453097-1730302079"
  },
  {
    "email":"paola.bovone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543466362/47fa7a44eff6a809cdf3246c64232d2b-1730302079"
  },
  {
    "email":"cribertocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543597434/21f35c791f092ce6bd11a910e330d3d0-1730302079"
  },
  {
    "email":"valeria.sgobba@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543662970/6b8c44faa33101fc82bb8482c87de666-1730302080"
  },
  {
    "email":"serena.pattaro@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543728506/5177608b137d3bf5e169cbfd8be06571-1730302080"
  },
  {
    "email":"a.simo@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543695738/303ddd79f90807ee04852fe6514ea8f8-1730302080"
  },
  {
    "email":"sara.aceto@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543826810/5585170b820d3fb61fb69224dcf2be55-1730302080"
  },
  {
    "email":"vale.civardi80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543794042/6d9dba2dea0ed3146cb21d16bc21b4ba-1730302080"
  },
  {
    "email":"costanzonicoletta2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543761274/a47fdf4919dee69bbcd0ee439c863781-1730302080"
  },
  {
    "email":"cinzia@studiobarni.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543859578/c40c3bfbf03f1807ae2d093f1a72a803-1730302080"
  },
  {
    "email":"consuor73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543892346/66d5a9edc80dd35e3a8d1420718b4a01-1730302080"
  },
  {
    "email":"dirosaelena@gmil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543925114/60a96b6b85e8e761d0a4669990bc1731-1730302080"
  },
  {
    "email":"ellebioffice@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723543990650/334a8569065dffe2147f6a2603622e78-1730302080"
  },
  {
    "email":"francesca.ribolla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544023418/c8380b7a85ff77cfbff1e151793d6c06-1730302081"
  },
  {
    "email":"rachelariccelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544056186/da00d842a8394a6e5d400dc230fb31d2-1730302081"
  },
  {
    "email":"ely873@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544154490/bf5915c636c38ae9adf5bdc61a6d0623-1730302081"
  },
  {
    "email":"filippi.francesca02@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544187258/03c817eded9a041e2196a94ce52e8af3-1730302081"
  },
  {
    "email":"piattogiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723543957882/45a7287bcb53804e4e70f48efc128efe-1730302081"
  },
  {
    "email":"cicci.1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544088954/2cfb5fcf2601a520b02c4a9f5845ab8e-1730302081"
  },
  {
    "email":"elena.fabiola56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544220026/e6dea2b0007df4f00b964cac49a1c713-1730302081"
  },
  {
    "email":"annalisa@studioalbini.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723544252794/3cad2342f159e787f808de8b3e7502f3-1730302081"
  },
  {
    "email":"daniela.cassinelli84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544285562/986856b183496bddc74ef8b403d7f0ed-1730302081"
  },
  {
    "email":"eprandelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544351098/1e95115115fc5f794f2f709dcb16cd8b-1730302081"
  },
  {
    "email":"bandini07@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544416634/eb7ca6c9bdfa805b3261e392efa93467-1730302082"
  },
  {
    "email":"passerinicristiana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544383866/d28a8162dc0f0e3c0418276c05f21bbc-1730302082"
  },
  {
    "email":"b.ascoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544449402/19943b302e0862fb7a2ae61d81002267-1730302082"
  },
  {
    "email":"pedrinimanu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544547706/07907ad4dd5ab0d4a22f22822b0d16ba-1730302082"
  },
  {
    "email":"gabri1.tonoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544514938/4540d70f6b1a1751f260d60d3fce53a1-1730302082"
  },
  {
    "email":"rossella_gio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544580474/7a93457d091d0c66f28e08e4908ca40f-1730302082"
  },
  {
    "email":"an.delvecchio77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544482170/baf4e7e1f156ad2edfc0991d9ede2cbd-1730302082"
  },
  {
    "email":"aqmministrazione@rossomonza.mi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544678778/40ef2f9f271eb0f49695354172000491-1730302082"
  },
  {
    "email":"deasaber@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544744314/5b9542b44fd38b34bc5bf7f02b6be8b4-1730302082"
  },
  {
    "email":"marlenecoppola70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544842618/6d85b7abfd44fe64f677b08f5e274a88-1730302082"
  },
  {
    "email":"lmbourdezeau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544777082/5f539b43c0b43b1f1942de73182120d6-1730302082"
  },
  {
    "email":"vemonti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544875386/5db222aa616c28fb49ea65c8d9e5424a-1730302083"
  },
  {
    "email":"mauro.pugliese@generali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544908154/b47c6a1f081fbd72042bd42f482501e3-1730302083"
  },
  {
    "email":"chiara.buti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723544711546/a131aa3bb597dce3a3557c9c370c5c53-1730302083"
  },
  {
    "email":"emanuelacuccia70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723544940922/5a1a7aea47ec6e009a36876872077529-1730302083"
  },
  {
    "email":"silvia_finetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545039226/6c58a796d49c0f0e266572727f894b3e-1730302083"
  },
  {
    "email":"romori64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545104762/892dc4992180e03232c27f3504c92011-1730302083"
  },
  {
    "email":"roberto_anastasio@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545071994/96c1854fc2148e6d3916b233b3026d86-1730302083"
  },
  {
    "email":"elenacpinto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545203066/5b5e2c5b46fa8ca9770d3e2df3765bf2-1730302083"
  },
  {
    "email":"simo.orlandi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545235834/6bf077b39df70aa4258e031aeb314919-1730302083"
  },
  {
    "email":"desi.sabrina@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545301370/cd325559871ef75f66f73092105be44e-1730302084"
  },
  {
    "email":"liu.r@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545432442/ab42e4074ec656def38d29c2288e81d9-1730302084"
  },
  {
    "email":"valentina.zaratin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545137530/1b39de61009a5d3ccb9c94b204f122e0-1730302084"
  },
  {
    "email":"cprati@ariostea.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545465210/edaa9a91336316fd65e1c878c27e096c-1730302084"
  },
  {
    "email":"bewitched.g@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545497978/63d62bfaa6a58945bb759e3c6e4b9b0e-1730302084"
  },
  {
    "email":"marino-fabio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545530746/02566ab64a613cd1d4268c7de41fda0d-1730302084"
  },
  {
    "email":"danieleperi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545596282/8e2085e868a0abf6afe250a359a2c2ef-1730302084"
  },
  {
    "email":"evannasirelli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545629050/6d66cac845322b17c819726d8ece34f1-1730302084"
  },
  {
    "email":"ambracaselli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545661818/a098e7e1f35378187477bd45b018fff4-1730302084"
  },
  {
    "email":"paolo.dibartolo@auslromagna.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545334138/7196db2d564935fd5af7af7bb345b99e-1730302084"
  },
  {
    "email":"emilinda@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545694586/4d606f9f116d51b14436c36484225fd6-1730302084"
  },
  {
    "email":"mottes.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545760122/14dff216fabcd9732ea572e960a7666a-1730302085"
  },
  {
    "email":"avv.livia.fiorillo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723545792890/9d883bcc248d6e6b4b6bfd77611a1ca9-1730302085"
  },
  {
    "email":"maurocimmino24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545727354/3a3a272902d1e3dd306051e7ed0a3120-1730302085"
  },
  {
    "email":"ilenia.pirola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545956730/5c00e52f27d8c1859d9528eb0eacbb94-1730302085"
  },
  {
    "email":"paolagulinatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545989498/3b649da5cd43c86a55c6edfaddca6cba-1730302085"
  },
  {
    "email":"alicedisconzi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723545825658/34026b5f6beeceeac4aeba20c06dee97-1730302085"
  },
  {
    "email":"battistini.lucia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546022266/82ae77954b46dc2ec588b1fea7103b9b-1730302085"
  },
  {
    "email":"simona.voarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546055034/fa486e312a3e41481d2128c85c690126-1730302085"
  },
  {
    "email":"kviero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546087802/37d86e7cdcce3b2dd3095808bb3aa367-1730302085"
  },
  {
    "email":"valeriacuocci2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546218874/00faccf893d2d543039f1720329a1316-1730302086"
  },
  {
    "email":"marcip78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546153338/a87e8ba083e4b6380f0bc61a6e15e193-1730302086"
  },
  {
    "email":"nicola.pepe1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546251642/39280511d67cf3b96dd6218e94e6e726-1730302086"
  },
  {
    "email":"elisabettapostoliti@avvocatilavoro.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546317178/ee276461303b1d9d6caecfba863d51f5-1730302086"
  },
  {
    "email":"vera.volpato@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546349946/7768d7b39bb5791b26ab28fb3a6aee17-1730302086"
  },
  {
    "email":"simoni94007@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546120570/773b6a82f3499420fba7483191252d36-1730302086"
  },
  {
    "email":"s.castrini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546382714/24782387a964cffc08d0e020664fce3c-1730302086"
  },
  {
    "email":"annaboutique@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546284410/6637e2c16a60d53e88023cc46767256d-1730302086"
  },
  {
    "email":"ilariagigliotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546415482/9f26143f0f32cc737331c7f566be5c4d-1730302086"
  },
  {
    "email":"saracorradin76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546481018/8b04148e0f53e8209ca77c166ee1f887-1730302086"
  },
  {
    "email":"ferrantefrancesco1992@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546513786/da9f8df0dfe500adac1bb1716598a55d-1730302087"
  },
  {
    "email":"angelicabastianello97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546546554/c0c0e46cc9a782742d6e004fd8503ad9-1730302087"
  },
  {
    "email":"karura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546612090/1e6b3e188fdf33be27e5434b97ab2050-1730302087"
  },
  {
    "email":"viasolferino1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546644858/c73e9a9d88038119a9a1f64071c8e982-1730302087"
  },
  {
    "email":"bapostudio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546677626/fbe77b72873f2afbf2f4a5860ee0005d-1730302089"
  },
  {
    "email":"selenaduilio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546710394/814539d990adcf725f3e45cff69c00c0-1730302089"
  },
  {
    "email":"vichigiulia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546808698/e8ab0db927a87aa24461b16e38f0d93c-1730302089"
  },
  {
    "email":"info@simonacarignano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546874234/08d34ed44d8046bacc73d337185c3935-1730302089"
  },
  {
    "email":"sonia.petronelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546841466/28913814500d0d22ddc44e51ef65c9bf-1730302089"
  },
  {
    "email":"rubia96@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546775930/ad0a94d64d31ae7a55039dc1370156d8-1730302089"
  },
  {
    "email":"paoletta81_2007@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723546972538/4932ebf3a888d33694ae48f39189063a-1730302089"
  },
  {
    "email":"serenainnusa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547005306/d4b77b0b05d1a9fe1180875e2a96485f-1730302089"
  },
  {
    "email":"donata.scovoli@marcegaglia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546907002/7fb7557be88f1c282cc438c9528fa4e1-1730302089"
  },
  {
    "email":"cristina.passarella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547070842/c1eb5f4a32e8b024516f418ecc1e0a55-1730302090"
  },
  {
    "email":"francesca.parente74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547038074/54cbff3ba024f5dbfbbf8c88923fc4af-1730302090"
  },
  {
    "email":"chiara@lautosrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547136378/17f8b5b7073b8addd40540e9b71e3d51-1730302090"
  },
  {
    "email":"monicadilella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547103610/952e65802b4a3d8727a7c5240014164e-1730302090"
  },
  {
    "email":"lufraroma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723546939770/dbbc12692802ae5344c612603558c03a-1730302090"
  },
  {
    "email":"valentinamichieli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547169146/589164c5c12bc1c8e9f6f6d915958e65-1730302090"
  },
  {
    "email":"p.degiorgio74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547201914/97b068afb49bc81d664104d010a2e4dc-1730302090"
  },
  {
    "email":"annacanessafrac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547300218/03825629b86ea10257921e5c8b062f8a-1730302090"
  },
  {
    "email":"luisa.dicaro@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547234682/4111b4c087879f57a8526d6e8c2b4654-1730302090"
  },
  {
    "email":"maricrist@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547365754/ddc353856636dedc6da0cef4b8dff90f-1730302091"
  },
  {
    "email":"vanep92@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547267450/263dbf9cd751fe9ad83b0ffa92b098cb-1730302091"
  },
  {
    "email":"aurorafondelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547398522/dcd1fe28113a003f529ba4ec9f0c27a2-1730302091"
  },
  {
    "email":"emmasa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547431290/69115876b19bb3d6d55f06f5b707e92b-1730302091"
  },
  {
    "email":"virginiaibelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547496826/adefb6d2c10f8fd6393ae709eb4a2d8c-1730302091"
  },
  {
    "email":"s2esse@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547529594/ad5a1706a9079f36c8c6520cc931fa5e-1730302091"
  },
  {
    "email":"criciacci69@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547464058/38ee9fa55fce21cadd3c626fcb4745cb-1730302091"
  },
  {
    "email":"sonia@mercifoma.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547562362/a3c37e5e2a0a3c0c78b1d56938e76b27-1730302091"
  },
  {
    "email":"alessandrobondetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547660666/edfb0b41cac31ece2e831c9f4d7bacc0-1730302092"
  },
  {
    "email":"annufiac@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547627898/1c069e937b170fd3addb6b62cec60c77-1730302092"
  },
  {
    "email":"salatinonicoletta@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723547595130/d7e477fb1a0ce4ddd6224f732e3a5c97-1730302092"
  },
  {
    "email":"antoniacorrado75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547726202/4a636edeb0b4629124a67912068fa41c-1730302092"
  },
  {
    "email":"alessiaargia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547758970/fac4d60199dcf0dc69ba1608d2cc7d23-1730302092"
  },
  {
    "email":"castrogiovanni.giusi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547693434/5799a9f233182991984317540464f2cd-1730302092"
  },
  {
    "email":"carolina.dalbosco@sad.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547857274/24834a0053b2df9fd011ea774e5733dd-1730302092"
  },
  {
    "email":"giulimatte@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547824506/7c6dbf7aeee5942ab7f4782b76186486-1730302092"
  },
  {
    "email":"elisa.miraglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547890042/2471db78c06145cef89f75975ec96272-1730302092"
  },
  {
    "email":"irrera.c@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547922810/0128b83fda15913f060b8d2e398ef94c-1730302092"
  },
  {
    "email":"timodella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723547955578/f0cbfa2026247cef1f7df962434e0634-1730302092"
  },
  {
    "email":"sabinarossi@infostudiosrl.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723548021114/c04d4744dd29010f1831637fe832d7c1-1730302093"
  },
  {
    "email":"alfonsoamitrano@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548086650/87f3693e13a62e7fa14b3d795fc2c540-1730302093"
  },
  {
    "email":"gmecacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723547988346/ed9df07b228bcf40ebc89e5b862ae824-1730302093"
  },
  {
    "email":"angela.mercuri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548184954/73709f982f992bc91eca460c22828cd1-1730302093"
  },
  {
    "email":"rosapina80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548152186/2570f6cf0a53a8e8f3f371850d610feb-1730302093"
  },
  {
    "email":"cpartipilo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548053882/38681075153bcc14636498ae4922199d-1730302093"
  },
  {
    "email":"marisadv@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548250490/25bb7206ccfff219f29f19de616ddefa-1730302093"
  },
  {
    "email":"tassod@italbrokers.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548217722/5d656a01ff543f385280c052ea6a080f-1730302093"
  },
  {
    "email":"arianna.paolacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548283258/faa2b590901a2876f5ee409995778286-1730302093"
  },
  {
    "email":"piemonteseluana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548447098/645ac4c0e8efad55d801558c08c77849-1730302094"
  },
  {
    "email":"andrea.quarchioni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548545402/74f106d4e03038f56fd039d2b218a063-1730302094"
  },
  {
    "email":"michelaaru@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548381562/eebc89860241f44be4638dc9b9b2bf17-1730302094"
  },
  {
    "email":"sbragisa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548512634/65fdf2f9514ee47f80859ac822dfd7ef-1730302094"
  },
  {
    "email":"michela_lazzari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548643706/23eb3163290330323522e89aba6ed57c-1730302094"
  },
  {
    "email":"lisasilvestri79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548709242/3b10e267f79a65a7bc2f9099a4df9d27-1730302094"
  },
  {
    "email":"carmenrug@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548610938/cc69abf8772b7d316be72427324dee77-1730302094"
  },
  {
    "email":"pagani-barbara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548742010/95dd576fbe93b5cf1ff427b6dce5deef-1730302094"
  },
  {
    "email":"carrierimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548676474/cfa8ea50f4c815dc304224d421fda8dd-1730302094"
  },
  {
    "email":"eleroccia11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548807546/9b426c3e11a9225a4396ca6e3c7eb0c7-1730302094"
  },
  {
    "email":"marabinialessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548840314/bb917bd035d04ab8668c8c5538fd9525-1730302095"
  },
  {
    "email":"ilaria.torello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548873082/f2e2a51bd155ff67b8e3bcfeff3758af-1730302095"
  },
  {
    "email":"chiaraga3@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723548905850/e9f28038b7ddbd88fb4071ba4bda368b-1730302095"
  },
  {
    "email":"savioratti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548971386/c62975229b9cd7e426282de595f9e428-1730302095"
  },
  {
    "email":"michaela.priori@autostrade.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549004154/30b592a94ee55f8d183b28a3de06ff10-1730302095"
  },
  {
    "email":"paolacanella.vr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723548938618/d40ac622360497b3da1aa0169595a8d3-1730302095"
  },
  {
    "email":"paola_abbate@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549036922/8c0f1066b9a4c8447890d3a74cbd173d-1730302095"
  },
  {
    "email":"denadai71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549135226/7c3e3ba51b15cff9faf70aae7391f3fd-1730302095"
  },
  {
    "email":"lucialobosco1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549167994/6215f6edfb8b945ecc1011ce6325a23e-1730302095"
  },
  {
    "email":"anna.sacca1976@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549069690/6cff3a96d69e2eef3e6bee0605136a6f-1730302095"
  },
  {
    "email":"gm@slm.tn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549200762/6187af72e741a32e1b37d7236b200be4-1730302096"
  },
  {
    "email":"vmarturana@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549233530/5f8e4d5440555fbdf0fb3487420a5d77-1730302096"
  },
  {
    "email":"tommasodebenedetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549266298/55f889ac4b556c7a21002745a6f098b7-1730302096"
  },
  {
    "email":"maria.ripepi1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549102458/50ecb22490c4fb42dec74a6abc75f023-1730302096"
  },
  {
    "email":"teresa-caruso@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549299066/7f6595eb8f128e13a107ff714ec5327a-1730302096"
  },
  {
    "email":"serena_digiovan1984@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549462906/4bbc3bf69f645420335e430fcc195e49-1730302096"
  },
  {
    "email":"egger.verena@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723549495674/f59cc1c4de51c3a3dadb6a3b60e666b4-1730302096"
  },
  {
    "email":"toninaalessandro@hotmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723549430138/adf68e17c504de7e46601590101d5235-1730302096"
  },
  {
    "email":"nadia.csc85@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549528442/5941e8fe0cd032f1c6d82c3fd90527ab-1730302097"
  },
  {
    "email":"beautyelle@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549561210/01de980e2519e4952d3e0c65bf98c557-1730302097"
  },
  {
    "email":"graziamistretta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549626746/aaeadd29df3ef58fcaab6e8da5f0d000-1730302097"
  },
  {
    "email":"raffa_monguzzi@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549659514/ef39a8c7b0fabce7ec329dad8b44f1c9-1730302097"
  },
  {
    "email":"nicoletta.iacobini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549364602/9c69bdd5dec6455e031ec62d65fc6154-1730302097"
  },
  {
    "email":"rcirillo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549692282/2c0c83c2429267ea25a1da7b2d0eaac7-1730302097"
  },
  {
    "email":"ilenia@effebilotti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549790586/5c670183afe0b07ccef2c2a3b08d2dee-1730302097"
  },
  {
    "email":"concetta.fortezza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549757818/3a32e9571ba3235e56c3cf8ffe45ca58-1730302097"
  },
  {
    "email":"minenna.anna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549725050/e90e7d010ef11e3497186da4ccfed0e2-1730302097"
  },
  {
    "email":"manuelarosato72@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549856122/a9e9e7e221b6561ad1d3992679705e55-1730302097"
  },
  {
    "email":"alessandra.gattamelata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549921658/1530d5970d5e9e000b080a968687210e-1730302097"
  },
  {
    "email":"loryviaggi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549888890/2cd7d572409bbcd310966eaeb615d99d-1730302098"
  },
  {
    "email":"isidoranatale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723549987194/8e3399e13653c0f6aba06ad28c82492f-1730302098"
  },
  {
    "email":"emanuela.abrami@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723549954426/a683e151aaf500ddade1aa74cfd3a281-1730302098"
  },
  {
    "email":"silvia.frisoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550019962/ab7c05f26fea779c2eb9c918ff67eda5-1730302098"
  },
  {
    "email":"cartini.claudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550118266/bcc6e2c40fab45084af5aae3a1339c6a-1730302098"
  },
  {
    "email":"massicanova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550052730/1f716d58adf40a6cf3423f2a67578ec1-1730302098"
  },
  {
    "email":"antonucciolga@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550183802/0c2e550f57d3fb673aea0be806b6a846-1730302098"
  },
  {
    "email":"stefimg75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550151034/6ff76455a1e7f24b33728acf24d574c2-1730302098"
  },
  {
    "email":"comocri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550282106/4ab868972a1e8a81d31b293074cc3893-1730302098"
  },
  {
    "email":"mariatribunella78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550249338/9d6503af76e6bcbf670ace24a6e80ac4-1730302098"
  },
  {
    "email":"samantha.federica.berti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550314874/d7f902524db86ccd049f1b728cd6659e-1730302099"
  },
  {
    "email":"danielacanziani74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550347642/25fc0e1283abc0c1aea9d89e6a0fd0c5-1730302099"
  },
  {
    "email":"federica.galelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550380410/5d3f699007e8f0337868a15831b95b46-1730302099"
  },
  {
    "email":"delfytur@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550413178/3e45dbd61967037033b01df98e525a46-1730302099"
  },
  {
    "email":"fedehp.2018@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550511482/36ad67f2750aef752f3840b06b0a2e9a-1730302099"
  },
  {
    "email":"digennaroteresa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550478714/eee8d3462d35dace05d5396d675eb3e6-1730302099"
  },
  {
    "email":"tania.menchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550609786/5ca53807a5428068e3318b883475c118-1730302099"
  },
  {
    "email":"pinnarossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550544250/b2ad594aacb42a8414f84b6131ba70ba-1730302099"
  },
  {
    "email":"martina1289@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550642554/2dd9f3fb408af5a3e546185f43606b5d-1730302099"
  },
  {
    "email":"fraporrini76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550675322/23f2d2980abd2dee22695d175ab105f3-1730302099"
  },
  {
    "email":"chiara.breghiroli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550708090/e7a549a48ec3dde6c34168cf721b0fbb-1730302099"
  },
  {
    "email":"elena.crm23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550740858/f9f8d8337564c55daa008f0fe15ed0c9-1730302099"
  },
  {
    "email":"valedauria@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550806394/c941892288058a08489a5e9492aeee61-1730302100"
  },
  {
    "email":"cassetta.federica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550773626/a4384343eb0df6ca270b81b6af9680bf-1730302100"
  },
  {
    "email":"gerardo@fitad.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550839162/a43f2f90c8e3ddf492fc3866cc237611-1730302100"
  },
  {
    "email":"grazia.gasperini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550970234/f49553dec9604e084a473e5ed96d75b7-1730302100"
  },
  {
    "email":"mariellacozzolino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723550904698/3a985e983d87fd755493d3012efa4a2c-1730302100"
  },
  {
    "email":"tatabetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551003002/5bffb5e73b822db550dac4c746ebdba3-1730302100"
  },
  {
    "email":"luigi.zarrilli@ingv.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551101306/5a741430ad03f46bd8a7c9eb1e42448b-1730302100"
  },
  {
    "email":"silvia.battaglino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723550871930/32fa0f09f3fc4f6e40702501f4cf87b2-1730302100"
  },
  {
    "email":"biondocarmen88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551035770/37749051de9c05da1ddf059cee9c763e-1730302100"
  },
  {
    "email":"elenarambelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551068538/e977f393ec69a97804dac3470f2844c2-1730302100"
  },
  {
    "email":"nelly.insalata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551134074/b264f8e965c8c23809a7b77c2f4576ab-1730302101"
  },
  {
    "email":"cinzia.trevito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551232378/bed4877ac78cd805adf07be8c23f360b-1730302101"
  },
  {
    "email":"nausica.guglielmo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551297914/ee6c0359f77eac9de66e169eb95895e0-1730302101"
  },
  {
    "email":"finance@palmamasterbatch.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551363450/cd2adea9f467fbdaef56acf4da609d94-1730302101"
  },
  {
    "email":"beeea@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551265146/ef6ded26d874c3a4e593db53d2674050-1730302101"
  },
  {
    "email":"antonella.toffanin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551330682/eebbd3f66dcd2d88a3e1a1bba4c46ccd-1730302101"
  },
  {
    "email":"francesca.senia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551396218/a67191af5f05337f3ba1d74434941a31-1730302102"
  },
  {
    "email":"oriettabroglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551625594/5925c33cd28a99bd688fe9454c8d2fb4-1730302103"
  },
  {
    "email":"enricofely@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551461754/f80ebad4e75ec53054029335d09fd92f-1730302103"
  },
  {
    "email":"s.izzo2310@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551560058/21c86cc3cedb2a5afa80f33cb56eda41-1730302103"
  },
  {
    "email":"lambruschini.oli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551428986/15be3bfa7c7778898e5753c5873fefd1-1730302103"
  },
  {
    "email":"francescacillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551691130/ea7151b3c5c354c39876e1b007450b6a-1730302103"
  },
  {
    "email":"chiaraballero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551658362/ee26a113436f96f481898c1ed421f4a1-1730302103"
  },
  {
    "email":"scgnoma75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551723898/25a7478131e65c3f38d6aa34bd5ccee3-1730302104"
  },
  {
    "email":"francesca.zuccherin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723551789434/05ed2d52cd3c6278c5ffb886f4a7ae01-1730302104"
  },
  {
    "email":"daniela_zancan@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551822202/a56bb02d6ded6795b168226e2a7d453b-1730302104"
  },
  {
    "email":"giancarlo.bottolo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551887738/1f5bb58001a3e038afefc97064421078-1730302104"
  },
  {
    "email":"v.cancelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551953274/850a047424d86ae187d4196d8c879b2c-1730302104"
  },
  {
    "email":"raich.j@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552018810/d99d673258d613356978861b90728f66-1730302104"
  },
  {
    "email":"pandolfialessandra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723551854970/2f81da32594969011c7cf52d34f33a1b-1730302104"
  },
  {
    "email":"ambra.tesi@uchastings.edu",
    "url di attivazione":"https://verdissima.it/account/activate/22723552051578/7a667a078c6d44ba949ca6ffdee65a89-1730302104"
  },
  {
    "email":"pina.manganiello7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552117114/6723408e63e2540aa407931cba5fdbae-1730302104"
  },
  {
    "email":"michelavalentini@cavagnagroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552084346/b25070bc9c25fefcc04772f163ab8893-1730302104"
  },
  {
    "email":"s.civitareale@sacaservizi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552149882/df269020140212beb63ee1b886d24233-1730302105"
  },
  {
    "email":"camicara@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552248186/a4324f03a132be63161f838ff6dff09a-1730302105"
  },
  {
    "email":"lorenzofrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552280954/dd88a8e5151d40d0d7c663a46ef509de-1730302105"
  },
  {
    "email":"valentinab0905@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552182650/bd79179ec8bc8ec2894f84e5ba2347f0-1730302105"
  },
  {
    "email":"manfroni.eleonora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552379258/3464e70c868eff42ea938f9b7675be77-1730302105"
  },
  {
    "email":"lucia0872@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552313722/f9d2071a255da93d4c1940988869d225-1730302105"
  },
  {
    "email":"paoladallaporta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552477562/c2d7a47cdda2a60ffadf5765fd3ce406-1730302105"
  },
  {
    "email":"cadamurogiuly@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552641402/12626bc2da2d5609f227834a2cc51b93-1730302105"
  },
  {
    "email":"micaela.ercolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552346490/2af2103fa8c919cf598ed1f0c155b2db-1730302105"
  },
  {
    "email":"cristinalavorgna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552575866/30218c081dde7e1e138333cb5ddb41cb-1730302105"
  },
  {
    "email":"eleonora.iac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552674170/13cda31e6ed5db178488f740221d0cff-1730302106"
  },
  {
    "email":"ulimeli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552706938/0b116bc6565cbfa25e46632dbd9a8e04-1730302106"
  },
  {
    "email":"fulviaemiliani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552739706/85a93527cb5fed8d406d12b389f659d6-1730302106"
  },
  {
    "email":"michelacardofino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552772474/3c24f73c1f54535a852f4cb677bcb9f0-1730302106"
  },
  {
    "email":"barracomariacristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552870778/920e01efa8ce83d738fffb5756cf77aa-1730302106"
  },
  {
    "email":"luigicabella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552936314/966ad8857988bb631da8cd38c57076a0-1730302106"
  },
  {
    "email":"giocondasimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552969082/d6e09236308bff85528d8017f349afee-1730302106"
  },
  {
    "email":"palma-paola@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723552903546/9352346e76a4321e87f38ca13b14d48e-1730302106"
  },
  {
    "email":"g.lollini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553001850/2f8e313fae40d864e18a22f69f2dc51f-1730302106"
  },
  {
    "email":"manuammira@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553034618/982f8142d7aafd213949128510bc155a-1730302107"
  },
  {
    "email":"saraferretti85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553067386/0cc0e3af0d37583c6c3316478a405383-1730302107"
  },
  {
    "email":"angeladapont@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723552838010/6d5d613228efbae073245620edf80d8d-1730302107"
  },
  {
    "email":"isettabelardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553100154/db58d2dd7a86916abe0e4aa192d4ab1d-1730302107"
  },
  {
    "email":"ale.tomy@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553198458/c2b159b755aa11205b76835b82ac4c27-1730302107"
  },
  {
    "email":"marziabrambilla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553263994/5c8bff0f0acee5c489cc712230e0fdd0-1730302107"
  },
  {
    "email":"giada.longaretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553165690/1a971c3ebaafc169795d4bc273f5bc08-1730302107"
  },
  {
    "email":"festaclaudia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553362298/65f2656b6c1508b96f5af49c2dabf292-1730302107"
  },
  {
    "email":"loridepro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553427834/e436ebc46447a1efb067ad9477285d46-1730302107"
  },
  {
    "email":"fran_ce@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553460602/59f2da0e557b6c44c191595822af3fec-1730302107"
  },
  {
    "email":"angjdep@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553329530/f5a6a8d50f92444fa12b8cd780cef4ed-1730302108"
  },
  {
    "email":"marta.pierantoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553558906/fe2bc192db3159357b0f3e362b818916-1730302108"
  },
  {
    "email":"alessandra.farina82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553493370/77ab76086e023bf24b1d49334a10b177-1730302108"
  },
  {
    "email":"n.vestina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553689978/59dc805b26ae47388bdf7fc0d1be37f2-1730302108"
  },
  {
    "email":"fra.torres@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553722746/4405251bf7ac6d516cc4ab6f2121a3ed-1730302108"
  },
  {
    "email":"restaino.annarita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553657210/259a4c38274199a34465d5459540a616-1730302108"
  },
  {
    "email":"adele.romanazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553624442/080f35fff3bc4b50e85ded041c6d1ab7-1730302108"
  },
  {
    "email":"biologafranco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553788282/efcd7214b80fe41b50c2d2f0224b7f7d-1730302108"
  },
  {
    "email":"adeledifazio44@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723553755514/001e252bfdbba2da9c96c32bf250acff-1730302108"
  },
  {
    "email":"martina.donadoni@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553886586/1818e2982aa57469f45e635cf69fc8a0-1730302108"
  },
  {
    "email":"gabriesimo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553821050/102fdb1b22f0afbff503369e8443fb0b-1730302109"
  },
  {
    "email":"seliscas@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723553952122/926b68549c8f6ece7301a904f25a8da5-1730302109"
  },
  {
    "email":"annagarofoli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554017658/f9fe7d876830e81287fbc430baec27f9-1730302109"
  },
  {
    "email":"marinapugliese12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554050426/095b92dfb7976ff03bf1dc08a7c1f307-1730302109"
  },
  {
    "email":"adopov@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554115962/73b63f8fb805a269259f05e90c091e52-1730302109"
  },
  {
    "email":"marialuisacoviello@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554181498/c6e347bf09a1e862b81e3c5cb940a1b8-1730302109"
  },
  {
    "email":"silviazerbini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554083194/cbd048337e7c639938ed91b53e59e161-1730302109"
  },
  {
    "email":"taroli.katia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554247034/e9de037610df753555edc0a8f1b35dd4-1730302109"
  },
  {
    "email":"clara.aversa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554148730/d925844339b5932f747eb6ac80e1c8a3-1730302109"
  },
  {
    "email":"eleonora.ballarin69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554279802/793365850885e4b9cd0ea817463f5f2b-1730302109"
  },
  {
    "email":"jaqueline61@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554345338/c9a902d2fc02697dbfdc0cb8a5f8134e-1730302110"
  },
  {
    "email":"maurapompili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554312570/5b5344f167f604f4878240fb55057ae7-1730302109"
  },
  {
    "email":"conte.silvia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554378106/ee7dd19c94a943f6db4f4671c13f6826-1730302110"
  },
  {
    "email":"fede.borg@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554476410/7e98197e445f1315818a9ec9064087b9-1730302110"
  },
  {
    "email":"ilaria.sciutto@gmx.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554509178/88b441ec4bcaeb30b3a84e3e6f1257db-1730302110"
  },
  {
    "email":"barbara.benigni68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554443642/c060ab75e4c54571f95b69ec88ee559e-1730302110"
  },
  {
    "email":"liberabua@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554607482/b3f924bd4385a25722be6cbd7cd7b18e-1730302110"
  },
  {
    "email":"phoebe.24@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554705786/9c79aac47eeba1bf6bf5e39c76debacc-1730302110"
  },
  {
    "email":"cristinamorelli75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554673018/7da6fada75292e6599bcdcdbd40b4191-1730302110"
  },
  {
    "email":"fabiola.ghezzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554738554/e65b5fcc26bd0a757902e177fc55a8c2-1730302110"
  },
  {
    "email":"parpacla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554640250/68474cfd8f644f6d52d019687140d9b5-1730302110"
  },
  {
    "email":"mavi.col@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554771322/e9a3af2583ae98e8332731b7578fa7c1-1730302111"
  },
  {
    "email":"berti.laura82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554836858/cb647c9d03296968507280742c009a4c-1730302111"
  },
  {
    "email":"tonyanna2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554869626/219fe1ae4463a75814bdb402806c0612-1730302111"
  },
  {
    "email":"paolasignore78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554804090/0a485a00dd81f2911a50d9db31b0c6c8-1730302111"
  },
  {
    "email":"gianna.coffani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554935162/9700526030a444b1d4e14f7829fa787a-1730302111"
  },
  {
    "email":"claudiamaldini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723554967930/7001b8d790b3687672f6a5ca037f4936-1730302111"
  },
  {
    "email":"manuelafra@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555000698/1b1df682b6a575f5aad7caaf924ab903-1730302111"
  },
  {
    "email":"lavinia.cans@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723554902394/1345fbef6e9d7c81f8138cdd24590de9-1730302111"
  },
  {
    "email":"annapaolafroio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555033466/eba589ff3940d08e21d4233330402a7b-1730302111"
  },
  {
    "email":"milenaaccoto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555066234/d88e1f0997332be4e22c35191368da60-1730302111"
  },
  {
    "email":"pamela.tozzo@unipd.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555099002/fbe5689546db135f8c125a9b260dffd3-1730302111"
  },
  {
    "email":"lorenzapiraino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555131770/5591da13e392d337a2abef6a25fd1b91-1730302112"
  },
  {
    "email":"rominagiombani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555164538/0382ff2a48914f4798556be19ac25115-1730302112"
  },
  {
    "email":"eng.andreaboninsegna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555262842/320a6cb767fa65cc23fb3f4b86ec04d9-1730302112"
  },
  {
    "email":"lago.serena@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555295610/b5cbbac930c67e4611fc2be7b2b594d1-1730302112"
  },
  {
    "email":"r.chiappori66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555230074/8b21518cb2c67b9d15f742a5b9c8d5c3-1730302112"
  },
  {
    "email":"e.moser@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555197306/7b41a7aa6f68de1a6292d2a96bd51509-1730302112"
  },
  {
    "email":"alida.calza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555361146/0b9c1555c93796d51c73e975939db920-1730302112"
  },
  {
    "email":"luisatomelleri@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555426682/038c10751ce4b309196c56fb05ba99db-1730302112"
  },
  {
    "email":"claudia@battilana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555459450/3a7c28de60ba73e70df41ea49c1754d7-1730302112"
  },
  {
    "email":"mardeganmicaela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555492218/5727895789b922689c9d761c451e2555-1730302112"
  },
  {
    "email":"lgabriella@gecosandria.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555688826/c1e69e36bdc93d105afe371c9ee6ba48-1730302113"
  },
  {
    "email":"dellaportaanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555721594/5a2b3b3dc6df56a8089f226cec74b91a-1730302113"
  },
  {
    "email":"saragiuntini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555590522/f7ab464b25190c39401f96094ec97ba1-1730302113"
  },
  {
    "email":"molinofabri@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555819898/2148916825ba9e80b110523ca624a48c-1730302113"
  },
  {
    "email":"milena.meda@leaderconsorzio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555852666/51720ab3370359edcae0b191ba214df2-1730302113"
  },
  {
    "email":"nelly22.stroncea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555754362/2843350f12b703aa90950316eed4aec7-1730302113"
  },
  {
    "email":"attardi.stefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555787130/a8a09266278cb29ab6ceb09c63cf7503-1730302113"
  },
  {
    "email":"c.pucci1959@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555918202/445c92e94acae1d00ee464ef82499e8f-1730302113"
  },
  {
    "email":"mariella8273@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723555950970/e890ae1581d51b389b97c667411860be-1730302113"
  },
  {
    "email":"claudia_garofalo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723555983738/2cf14f18935b17ee76eed87f4789c176-1730302114"
  },
  {
    "email":"valentinacaretta90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556016506/a916f243694ba5f42951010528e4177f-1730302114"
  },
  {
    "email":"antonellagaggiotti@bresciaol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556049274/30a44bd402ca53311c1fb73c14e4a97c-1730302114"
  },
  {
    "email":"francesca.gajo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556082042/e7140de045d18ee61d3d9ab8ce1e86a3-1730302114"
  },
  {
    "email":"aledacol1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556180346/ccdbee3ceab23e76bd0ac4f696f2270c-1730302114"
  },
  {
    "email":"oriettabrizzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556147578/5f66f461e3bb004791ef66d6ab4809d1-1730302114"
  },
  {
    "email":"fantivale@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556245882/059e436edbcec7ebf9ab41178941940b-1730302114"
  },
  {
    "email":"auro.donatelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556213114/b59d181e7778e5e739881ec2ed7e13df-1730302114"
  },
  {
    "email":"paola.ma69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556344186/8dce3fe9accf0000b41b697fa4128e4f-1730302114"
  },
  {
    "email":"francescadiletta2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556376954/5af1851676fec6eb874a8801ff8ab4f5-1730302114"
  },
  {
    "email":"lanfranca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556278650/a79c378d2e0f270d3f037d616f771fb1-1730302115"
  },
  {
    "email":"barbara.mercati5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556442490/f19f795eebf6a17189de0058e820b181-1730302115"
  },
  {
    "email":"romeistefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556540794/bfa7fff89f7c5cc2526e6b48801b7054-1730302116"
  },
  {
    "email":"robertabacci68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556508026/f82fe42b348da7a04132a913c3c84671-1730302116"
  },
  {
    "email":"zantonietta.az@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556639098/8e71a3b73c0277b10fc95198848c83b4-1730302117"
  },
  {
    "email":"mariagrazia@loggia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556606330/f87ef74bf18bd1775580896dd9a84b41-1730302117"
  },
  {
    "email":"sergio.acconcia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556671866/b5d2fc88cc817ab0a777cc2d9daa106a-1730302117"
  },
  {
    "email":"silviacav30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556475258/7c191285a5825f81a65fc480a9746ae9-1730302117"
  },
  {
    "email":"ileniacitraro10@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556704634/e5abfdabdbce6d8b104f1a1176cafd47-1730302117"
  },
  {
    "email":"daniela.giandinoto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556737402/fe83f01e6492050935b3d282dcb8aa1d-1730302117"
  },
  {
    "email":"m.silvia82@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556770170/8ee12eff840939b84e270b74dd3767be-1730302117"
  },
  {
    "email":"antomoi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556802938/22f6ae35a1e59619467e433ae04e4285-1730302117"
  },
  {
    "email":"erinapoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556835706/15000e4a5c9763383e0584f8118cfec6-1730302117"
  },
  {
    "email":"donatellamanunza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556901242/ec334b73c64d655e0dffc1f753687be6-1730302117"
  },
  {
    "email":"graziella@cesconitalo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556966778/5bdd7240a896be682299523efb34723c-1730302117"
  },
  {
    "email":"maria63.ml51@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723556999546/7bfdd6ba6c6ffd10ee70c9cbca6e8f76-1730302118"
  },
  {
    "email":"screma73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723556934010/713d40fdbd656d2336ed2263624a6de4-1730302118"
  },
  {
    "email":"laura.nar64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557032314/ad520df2ed06c09fe178d605b9e93fd8-1730302118"
  },
  {
    "email":"alessandra.delbianco@avvocatidiimpresa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557065082/e5703077961ee8672b77dd4763df0ae1-1730302118"
  },
  {
    "email":"beamacchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557097850/ec72fd090620fb149bb31305f984d687-1730302118"
  },
  {
    "email":"beatrixhitz@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557130618/8b0ec18f63c1f93b930d8c3b0106cc8e-1730302118"
  },
  {
    "email":"ale.150@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557196154/7cf377b6f2a063e256e74d690f02639d-1730302118"
  },
  {
    "email":"acclia@aliceposta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557163386/3c67c1cf65927b9b4e32f7ec42f1ebd5-1730302118"
  },
  {
    "email":"sarabrunori2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557228922/8fcb0fff7e6fda6c449e9bb028ca4951-1730302118"
  },
  {
    "email":"renatazn@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557294458/862d0dd803d3141519a4eff7b4f49dea-1730302118"
  },
  {
    "email":"rosy.ilardo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557392762/32cd55d2339f0e0945b23d2eaca1091d-1730302118"
  },
  {
    "email":"m.luy82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557359994/ff7fcbbc297f40f40410a50a2984f7b3-1730302118"
  },
  {
    "email":"epecchioli@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557261690/80f958f2a96e27020f7fd74b637ccc4a-1730302119"
  },
  {
    "email":"catiagelmi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557425530/c29f8f6bb660805135612bee404b35e0-1730302119"
  },
  {
    "email":"melann@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557491066/26e2dcc8645699adb822e58bd95a24d8-1730302119"
  },
  {
    "email":"sabina.pinnelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557458298/11c42043adc65987f319242c5cfe30ab-1730302119"
  },
  {
    "email":"chiara@francoferraro.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557556602/050139d52d05ae0d342aff3663b42169-1730302119"
  },
  {
    "email":"lucia_mancarella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557523834/e5af7cd99ef9e76b7a4f2cfd6e68528b-1730302119"
  },
  {
    "email":"federica.pagliardini@enereco.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557622138/be6f9f695802393c5c53a50221b35502-1730302119"
  },
  {
    "email":"alessandrataccioli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557687674/1a6f2d4fd3a7e6b14f5420683134810d-1730302119"
  },
  {
    "email":"blacklady74@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557654906/7d43b58b58ec5dadc6f084358815e36d-1730302119"
  },
  {
    "email":"antoerc66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557720442/289b49b8e6971aefdb82c2b9fdfc6248-1730302119"
  },
  {
    "email":"anto_sgarro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557589370/c257589f163c0d3f9e05f8ee1e619f58-1730302120"
  },
  {
    "email":"michy.box@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557753210/2581e9b8315886466a4fc259e18747e5-1730302120"
  },
  {
    "email":"pagsy7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557785978/14d30c1745319889d1e4ece259213946-1730302120"
  },
  {
    "email":"carlotta_82@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723557851514/91daca3cb8b9e8711a5f0a8a566c8676-1730302120"
  },
  {
    "email":"marinellafranceschi88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557917050/a49416a577df3f7186eab9c2e1588a59-1730302120"
  },
  {
    "email":"aivlisa3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557818746/82451d7e09dcd3974bedccdfeb611325-1730302120"
  },
  {
    "email":"veronica.ventre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557949818/80e1b796e6820f6174b86bd977f0b44d-1730302120"
  },
  {
    "email":"pedottistefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557982586/ae446730a7d766341f4043955e67dee9-1730302120"
  },
  {
    "email":"dani.mox@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558015354/4b505c9ab0ab9912146bcfe2f7ab739b-1730302120"
  },
  {
    "email":"francescaperhat71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723557884282/ac6ee09d79fc64aed30d15ae17c6da0f-1730302121"
  },
  {
    "email":"ele.bragantini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558080890/59b1ffdd3eda35e609707d48187d93f5-1730302121"
  },
  {
    "email":"ale.piccinini.zeni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558146426/445639669c7de82320f3f5e3e2029247-1730302121"
  },
  {
    "email":"costantinonerina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558179194/e15ad213f909cf7de97589cb050bce3f-1730302121"
  },
  {
    "email":"mary.azzarone02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558244730/c6aa37089c1dd4cbce0de1001adaa4e3-1730302121"
  },
  {
    "email":"federica.acconcia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558048122/3c60c339290a0dcded0d17fde1ea6856-1730302121"
  },
  {
    "email":"salvimarina5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558211962/3af7c6623e93f476fb91c12ccf2300c6-1730302121"
  },
  {
    "email":"patricialipari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558277498/6a6a204a4b72a711da5bd9da5c53691d-1730302121"
  },
  {
    "email":"emilia@uniss.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558343034/fe474b75cee14e35f394bcd6d62061fc-1730302121"
  },
  {
    "email":"d.iaia984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558310266/8df2864108fc31cc36f50fd06cff021e-1730302121"
  },
  {
    "email":"elisa_caputo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558408570/83274677eb4eb90df3329b68aedfa324-1730302122"
  },
  {
    "email":"info@studioberni.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723558441338/08d72cd107ba6ae9c4da7e0c1ad5f671-1730302122"
  },
  {
    "email":"vito_gianello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558474106/5c68cc3b7c895a34aaa176decfc823b2-1730302122"
  },
  {
    "email":"giulia.tosi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558572410/73f29c88cb58073a79482b9f6404cad0-1730302122"
  },
  {
    "email":"federica.mariuzzo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558539642/44d495e1f551dd74c7f07c2798a1eaef-1730302122"
  },
  {
    "email":"simona.colicchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558605178/4d4251ca4b0cfe4d442a7372c88d1ba8-1730302122"
  },
  {
    "email":"elenaboer77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558375802/4ec28fd71c6f755f0a396f26d5ee0005-1730302122"
  },
  {
    "email":"rossellaintoppi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558637946/b9ca9a13eb2f55cdfcdd92f7135c2984-1730302122"
  },
  {
    "email":"silviarusso196@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558769018/039125f909c4a82522dc57a615914238-1730302122"
  },
  {
    "email":"valeriapintus1810@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558670714/70bd53206f4d6c7166092f2ea58fec15-1730302122"
  },
  {
    "email":"mluisaberetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558703482/6890d5681e94b6f7d0b29af98c5413a2-1730302122"
  },
  {
    "email":"pivacargiu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558801786/2bb080dc518a53856d0a8c0dd668656e-1730302123"
  },
  {
    "email":"vale.espo8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558867322/9e30bc747c2d30f346e52554c05d365e-1730302123"
  },
  {
    "email":"claudiapolito@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558834554/3421eda2df93a59303cc723991eca237-1730302123"
  },
  {
    "email":"giuliastaccini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723558965626/3f2f9862892658731ce60bac89aa5f16-1730302123"
  },
  {
    "email":"lauragori.77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559031162/336872d661f3862909353acb139fc14e-1730302123"
  },
  {
    "email":"campagnanna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559063930/8ff7c9a2211b2768323a1463e03b0a52-1730302123"
  },
  {
    "email":"letizia2882@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723558998394/d1fa1f3d72da48cb3cd3913e77ed5ae1-1730302123"
  },
  {
    "email":"isabellasarziamade@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559096698/19acd8e001a24706035ae021be193400-1730302123"
  },
  {
    "email":"zucchet.elisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559162234/4158d19313b6f851e7113cf1c48736c8-1730302123"
  },
  {
    "email":"grazia.valsania123@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559227770/27ae4549a1290174a0c190274227a928-1730302123"
  },
  {
    "email":"ilaria@francoferraro.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559260538/ae04d06c22c63838c7a70789910d3053-1730302123"
  },
  {
    "email":"sarasimeoni83@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559195002/967ebc4376243a56dc4c2b2b2c187648-1730302123"
  },
  {
    "email":"elenamarianava@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559293306/85ae1e72dd472515995816311e101da3-1730302124"
  },
  {
    "email":"luanazambon@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559457146/46bfb7c0595127b75b1e72c202b1163e-1730302124"
  },
  {
    "email":"tancredisonia15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559326074/f6e02b384cc8d64bfefa072c0a1a6355-1730302124"
  },
  {
    "email":"adriana.scilef@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559424378/f123345a5cb47b8be05df0a721bdeabb-1730302124"
  },
  {
    "email":"luciacatucci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559489914/0d2210ad599c9ddffd1da956a5497cdc-1730302124"
  },
  {
    "email":"marikabracali@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559522682/c28e7e11f657ed84fc038fd63344b476-1730302124"
  },
  {
    "email":"lisa.manelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559686522/d59e9e48a322f04a890330685dbef0a1-1730302124"
  },
  {
    "email":"roberta.bosiobs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559653754/f2242721c4ab40fe3ed9b8b16abbad39-1730302124"
  },
  {
    "email":"chiara.gesu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559719290/abccb437dbb59f46a9c5c7f9e1d4a792-1730302124"
  },
  {
    "email":"a_russo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559620986/4c39aef831be97813ea200cb61986f83-1730302124"
  },
  {
    "email":"paleselina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559752058/762731bbab2bb49fd4305de64e6a4d91-1730302124"
  },
  {
    "email":"iuliacamelia1981@yahoo.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22723559850362/c7e4925f8019c42a83ac3de01aaaafe9-1730302125"
  },
  {
    "email":"ketty@carlinifrutta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559883130/1429d4a026e34c4daa3b7377367651a0-1730302125"
  },
  {
    "email":"m27gabry@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559948666/daaf86234c34cbc5bf86645fd967b255-1730302125"
  },
  {
    "email":"silvia.torzoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723559784826/134bb2e95b8d8a545567ef38cc8a641e-1730302125"
  },
  {
    "email":"carmen.ber@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723559981434/812c558d5cbbcdb32bcd7f888aca4910-1730302125"
  },
  {
    "email":"martinila69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560079738/fbe4aaab6dd478cf96e682a2311c3619-1730302125"
  },
  {
    "email":"elenanapolitano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560112506/d49f634c150b1a4fc14b955243457fd6-1730302125"
  },
  {
    "email":"angela_casamassima@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560145274/a26823c65f77519b725cd36b4ba09fdd-1730302125"
  },
  {
    "email":"arianna.ciampolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560210810/55f352f314bea2d70927449263e81068-1730302126"
  },
  {
    "email":"annama.bruno@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560178042/a9bb8812025aa975b93c780e4b177462-1730302126"
  },
  {
    "email":"michelamariotti01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560276346/9de83ae7e8b8a73a3711674be3ac0e0e-1730302126"
  },
  {
    "email":"babs.schwienbacher@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560014202/5551f352f201ee09a0b60144291f65b3-1730302126"
  },
  {
    "email":"bernardini.elisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560309114/b5c6ce3d63fca2acf4282d561e36e918-1730302126"
  },
  {
    "email":"parisinielisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560407418/f1d525d29216ff9dea771d3c7f8c5f4e-1730302126"
  },
  {
    "email":"silvia.bustreo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560440186/eb29fe049ad86d519c56071da7bf12f5-1730302126"
  },
  {
    "email":"napoleones@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560472954/39591e349e80cdbba944f808707e0d3c-1730302126"
  },
  {
    "email":"anet.ooyman@nomansland.nl",
    "url di attivazione":"https://verdissima.it/account/activate/22723560341882/43334675e1103f1b6fae051af826363e-1730302126"
  },
  {
    "email":"monica.mastroianni@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560571258/52b00a8611ac068cdbdff0b00f8b5e6a-1730302126"
  },
  {
    "email":"elinicod@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560604026/e3bb0f6621e9ead5b4d6500eb19ac804-1730302127"
  },
  {
    "email":"pin.gar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560636794/fb89f91e01d4b38402775b38f2457455-1730302127"
  },
  {
    "email":"arditipaola9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560669562/17f569f36ea12e8e14b15a833e01639d-1730302127"
  },
  {
    "email":"katia.caidominici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560505722/daa0b4877a88c96f6aebd1d90aeaf068-1730302127"
  },
  {
    "email":"chia.fox86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560702330/845e9171647a57fc96071aed4313e14a-1730302127"
  },
  {
    "email":"sara.giuliotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560735098/6bd96064ad6ccb08ef56eadc073b211a-1730302127"
  },
  {
    "email":"camillamalvaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560767866/5a75412791e1f6d506e405c87549a871-1730302127"
  },
  {
    "email":"dinimartina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560833402/a1136346461d744407d94d7f9619ad20-1730302127"
  },
  {
    "email":"annaritafrancioso@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560866170/421b7e6a60720197fecef42a889d7e25-1730302127"
  },
  {
    "email":"anna.zamaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560800634/12d6a557993d7a5f3334ea901b140b3a-1730302127"
  },
  {
    "email":"martina.cremonese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560931706/689094d192cf73ea48712bbd9fa8214f-1730302127"
  },
  {
    "email":"elena.bratti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561030010/fd407fa739aa4dc76af2097a08f66a5e-1730302127"
  },
  {
    "email":"sabrina.carr@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561062778/5f861f797e4f14727c5b7f7c965c2b7f-1730302128"
  },
  {
    "email":"silvia_cal@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561095546/268634669522ece17b6911fd0031e542-1730302128"
  },
  {
    "email":"stefanialuc78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723560898938/4fea6365761c7aa2496ebb6387020b31-1730302128"
  },
  {
    "email":"d.rossin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723560997242/ebf412251d18f1da7838c6f49d49ffbd-1730302128"
  },
  {
    "email":"giusipersico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561292154/6fe34346de1de3ed87b542dfff51c8d5-1730302129"
  },
  {
    "email":"dont@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561128314/d3718a73e926aa9bb115b0a4d8f73cd7-1730302129"
  },
  {
    "email":"carolyncassady@rocketmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561161082/ad4eb30bc3e0caa34bf8c00acd572409-1730302129"
  },
  {
    "email":"maximmihaela14@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561193850/af64936bfb7d331f366881ed5f80005d-1730302130"
  },
  {
    "email":"francyrighi82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561357690/5ebe6d11302dae1e78e295674321ab1a-1730302130"
  },
  {
    "email":"f.tonziello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561324922/96d7d8909d3ad27d935e16bd6775a53e-1730302130"
  },
  {
    "email":"valentinabuffa85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561423226/e5e8803c366a005e415758d7a243d564-1730302130"
  },
  {
    "email":"chiaradipofi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561488762/14f590db14df029f9fcec54b9b7ff84b-1730302130"
  },
  {
    "email":"claudiacost03@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561455994/f4baca4e0d9940183b8c81698963e576-1730302130"
  },
  {
    "email":"paola.dellarmi@enel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561521530/1448f8d0555083665050fd908e213a51-1730302130"
  },
  {
    "email":"simona3t@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561554298/5b1d9d89e08f284b24c69f9c82abf99d-1730302130"
  },
  {
    "email":"robertagianessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561587066/ea6dac528a3b65f387817a84d97ffbc3-1730302130"
  },
  {
    "email":"deb.lettieri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561390458/7498339bb073a8602e9b0de2bf4ce711-1730302130"
  },
  {
    "email":"claudia.bonciarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561619834/fa8526d4e2f0ca98ebc16b1221ffa190-1730302131"
  },
  {
    "email":"crisera.marina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561652602/411182b25d9ec7c6f054c22a7c7f7663-1730302131"
  },
  {
    "email":"margy.zonno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561718138/33b644473b30728744007a3f1454cad0-1730302131"
  },
  {
    "email":"o.bastianelli@kairospartners.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561816442/a0f2ea1edc324e045df4a38ccf935e5f-1730302131"
  },
  {
    "email":"giovanna.turpini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561750906/4b929d13d7885416979948d07c6e1248-1730302131"
  },
  {
    "email":"azzurrapalucci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561685370/0132f6218005848f47311aa0471e37f8-1730302131"
  },
  {
    "email":"zannaclaudia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561783674/0d3f4e31c79e7847c59589fc49808216-1730302131"
  },
  {
    "email":"origiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561881978/86443b23939bd94ad5f1035b0e97f4ce-1730302131"
  },
  {
    "email":"chiaradrusi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723561849210/93d5fd4565567860d39ba32be8f655fe-1730302131"
  },
  {
    "email":"elypuddu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723561914746/d9b6f717641309acde9be85bf02b1441-1730302132"
  },
  {
    "email":"manuelamuggianu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562111354/f1c02d78473bc80c36fed92a550a1647-1730302132"
  },
  {
    "email":"daniela.bottarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562078586/7f79cf54f65c6efc170f4bc10a0df4b0-1730302132"
  },
  {
    "email":"direttora.xi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562013050/7cfd117c3b98acf2be1e30dc8287a736-1730302132"
  },
  {
    "email":"perinifrancesca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562176890/43b6bf35a472a2952074877e67ad9f30-1730302132"
  },
  {
    "email":"tiziana.patti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562045818/c055ebce5dcc8362b9099271a23233a6-1730302132"
  },
  {
    "email":"teresa.castiglione@unical.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562209658/c33589a1723e0bb93c9ccc456d572eb3-1730302132"
  },
  {
    "email":"giovanna.menichelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562242426/694f67d1a564138717402b5318f0c3d9-1730302132"
  },
  {
    "email":"simona.i76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562275194/29e8b58caa97557b849612527f541af5-1730302132"
  },
  {
    "email":"mc.mignogna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562406266/308e43df20a9a8712704fdb98e928841-1730302133"
  },
  {
    "email":"evaserventi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562340730/271ab41e042a67f9e78f882281d370a0-1730302133"
  },
  {
    "email":"lina@studiosardelliruggiero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562439034/5ed4fc1aa48a52e33212336e4ae58116-1730302133"
  },
  {
    "email":"alessandranaddeo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562537338/b4a71989d003f008c730d075667bd58c-1730302133"
  },
  {
    "email":"elecaipi81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562504570/b1028145f4c2a8bf3ddf03580bc3fab0-1730302133"
  },
  {
    "email":"fisioelettromedica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562373498/135f097db2d5b6d20e0e669384e8bfab-1730302133"
  },
  {
    "email":"simona.pesaro@torciturapadana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562635642/7f6597a41d1ba0fff0bbb9af3356f5a9-1730302133"
  },
  {
    "email":"giorsi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562602874/1cd2a9bf094f25b2c200b754c32309a2-1730302133"
  },
  {
    "email":"amministrazionidelbupno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562668410/56f9ccf75c06cf86608fb793aa8c7099-1730302133"
  },
  {
    "email":"fabydoro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562701178/e5b5b8b6810ca452401916c9dc7b83c4-1730302133"
  },
  {
    "email":"sabrinabonucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562733946/4b7499900c4878bfec7f1f8c5f4f907a-1730302133"
  },
  {
    "email":"pesci.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723562799482/fe021624120f3b5b94b36f156901956b-1730302134"
  },
  {
    "email":"ntroiani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562832250/171425ed1164e390179d1cf23266bea7-1730302134"
  },
  {
    "email":"barbara.bramati@spaziofuturo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562930554/614a105efc3e28b54bb4c4f9772d0a04-1730302134"
  },
  {
    "email":"silviarossi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563028858/4431d0b3f180cfd4f0e3a50319825b1b-1730302134"
  },
  {
    "email":"natasciamassagli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562897786/05e7211a4f6c9d21d10925940b948672-1730302134"
  },
  {
    "email":"luisa.noce@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563061626/9c5fecfd4ffc318894a70aa9e9349aef-1730302134"
  },
  {
    "email":"carolina.borgiotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563094394/89179c9cf2aa44d807da40c5ac90cf3a-1730302134"
  },
  {
    "email":"manu.loda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723562996090/5cda010c19e89c6a075913f6bc5e12c7-1730302134"
  },
  {
    "email":"sara@due-effe.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563192698/10157b39705278c23ce61e6724c50e5a-1730302134"
  },
  {
    "email":"sabry.fab8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563225466/c2174477ab678fee60906cf3fc1a9e91-1730302135"
  },
  {
    "email":"elisa.duca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563127162/fdb797be7ab9688e850d721ab24e7743-1730302135"
  },
  {
    "email":"roberta.zenere@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563159930/07a38e974b697d6f9f6c4d814d96cc7d-1730302135"
  },
  {
    "email":"a.bolognesi4437a@ordpsicologier.ti",
    "url di attivazione":"https://verdissima.it/account/activate/22723563323770/bf874f14a6709c014ff1d1e4fa2b5565-1730302135"
  },
  {
    "email":"maria.manc9.mm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563356538/19f37722c1cfe2b4561cc99c7cc191f3-1730302135"
  },
  {
    "email":"giulianasantaniello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563389306/49268b8e9ead7a433db6478aa97bcb31-1730302135"
  },
  {
    "email":"tatianabizzoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563291002/a1459f1836d71e818021d0a399e76d4d-1730302135"
  },
  {
    "email":"luciaballarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563422074/56559ddb360146f52b011d93a96fd8f2-1730302135"
  },
  {
    "email":"mariaconcettademattia@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563487610/581ec9f6c0864b32bc6103117077b3a2-1730302135"
  },
  {
    "email":"bmatteuzzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563454842/a65716a8116486a73e24f62a50dc50f6-1730302135"
  },
  {
    "email":"gretapredella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563553146/a11f7d18404f5272a2fa510e45807b80-1730302136"
  },
  {
    "email":"loredanasorbello@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563520378/0a25ecb68f34f1be8a8b843420bc3ca4-1730302136"
  },
  {
    "email":"mmarradi65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563684218/b7fe909055b695889f2938fd2a04eedb-1730302136"
  },
  {
    "email":"giuliana.sala.gs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563585914/a80e5dd3c20a3606ce1da0a0e4da2170-1730302136"
  },
  {
    "email":"claudiacomino7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563716986/0c312bb6423793620287fe6c05d742e3-1730302136"
  },
  {
    "email":"gfrinquello@peroni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563651450/152a305a5e134304184ebad787b58e59-1730302136"
  },
  {
    "email":"didodaniela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563749754/bbb2a41094a0f54486d513a98be1bea2-1730302136"
  },
  {
    "email":"paola.palombo96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563782522/6e772fc8d4d1a62a50207614dcc1d2ae-1730302136"
  },
  {
    "email":"bvermigli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563848058/de1838772c616a96f65eedb999c9cb0d-1730302136"
  },
  {
    "email":"cardinalimaria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723563815290/aeff7aef80c54e8196d69772cad714f1-1730302137"
  },
  {
    "email":"giusybonanno76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563880826/3c7bbd42fb83329aa532097c4ec3710c-1730302137"
  },
  {
    "email":"mokina.di@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563946362/4f6803850484629475fa173d6318e9c4-1730302137"
  },
  {
    "email":"baby.marktg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564011898/95ad5b7e781ef0d9f0d02cf1e8fb2009-1730302137"
  },
  {
    "email":"adele.chiabodo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563913594/1798cac6c7418e48be15bed2f13eb3e4-1730302137"
  },
  {
    "email":"emmerrecinque@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723563979130/2696243ae7f259625674f1cba86f9f51-1730302137"
  },
  {
    "email":"didisabba68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564110202/f2ae8e8e4bb8620b648a9d0999d86689-1730302137"
  },
  {
    "email":"gabriella.marchetti@unife.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564208506/3a3bbb3b93be775bab4b6c66b609eb0f-1730302138"
  },
  {
    "email":"gio.mameli1993@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564142970/2afcbd7848cfd32282154e3efee6e6c5-1730302138"
  },
  {
    "email":"jacnicmichael@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564044666/e1d75d620df76b4f23b7cfa026745c31-1730302138"
  },
  {
    "email":"zena.5@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564077434/2786ad18869632b35f204a5aa539a424-1730302138"
  },
  {
    "email":"barspre@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564241274/d0e88924d95b12c81fb24438d9fd8a74-1730302138"
  },
  {
    "email":"martasgargi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564372346/794b4cf07800da5c6af2f7b79b479859-1730302138"
  },
  {
    "email":"info@studiolegaleforte.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564306810/e7b651242af5b4265c8065ba0da72303-1730302138"
  },
  {
    "email":"a.monteleone89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564437882/5cc33e17ae8605381f294305b48aedba-1730302138"
  },
  {
    "email":"luana.marino94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564470650/d0819cc5234270cd69f449b762950e07-1730302138"
  },
  {
    "email":"lucy2061974@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564568954/29bc24f4a130b2d3766cbaa2fc53b183-1730302138"
  },
  {
    "email":"iliakos@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564503418/b0be5f27d44bfcb8f5a9f759e854eb18-1730302138"
  },
  {
    "email":"emanu942009@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564405114/4777621bf55caa99b94dc8a590d9cdde-1730302138"
  },
  {
    "email":"gabriella_gulli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564601722/043ddf1bde5048203f8690108c16bfd2-1730302139"
  },
  {
    "email":"michelapioli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564765562/1b1abc6c21c6a0e48090f4a7f5ca8e51-1730302139"
  },
  {
    "email":"veronaanna18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564732794/587adf33d12792b27ad2f007860493d4-1730302139"
  },
  {
    "email":"mm.biagiotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564700026/707918372d1a9a9f4b8dd77b079b675e-1730302139"
  },
  {
    "email":"alessia.mattia1999@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564896634/912468cbd5f7681479b353ac92bb8f49-1730302139"
  },
  {
    "email":"elena.ferretti1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564929402/ab8bfa5744f7aa38352ffe9e5664cb0c-1730302139"
  },
  {
    "email":"raffaella.leandri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564962170/b30c93d57b44f8aea5735415106a0f3c-1730302139"
  },
  {
    "email":"giadaguidotti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723564798330/0dfe54b4e4c592a3c58b792917ef3e08-1730302139"
  },
  {
    "email":"mcturco@unisa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565027706/65b550de1851859ef38820465bf76605-1730302139"
  },
  {
    "email":"chiaracol@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723564994938/3aeb90e6e91a995acc1918a5dbd2429c-1730302139"
  },
  {
    "email":"marziaiop@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565126010/fc79a554a7afda766c6e40044243e982-1730302140"
  },
  {
    "email":"sabrinacuzzocrea@uahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565093242/de90953e70c22d07a21467afa737b237-1730302140"
  },
  {
    "email":"clara.pozza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565060474/152600a2f690bc8552c96f1e5a00a045-1730302140"
  },
  {
    "email":"maxsonic76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565191546/2857e9f2f775f31686d2be1817b87d2e-1730302140"
  },
  {
    "email":"bellini97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565224314/fd03e9766010cd9a109e55355d35774f-1730302140"
  },
  {
    "email":"chiarasabatini07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565257082/f0123aaf5f21a19b652d1d44c65efb18-1730302140"
  },
  {
    "email":"alessandra.delbianco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565158778/ba966f0278890182dc92cc1b446eaf8e-1730302140"
  },
  {
    "email":"annamariatordo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565289850/ee8eb4444ee878aee6a4133f5abd3e82-1730302140"
  },
  {
    "email":"tiziana.dimattia85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565322618/6f0581e8007288ff9d5a2257758a8acb-1730302140"
  },
  {
    "email":"pea@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565388154/9ca98698049cba1ac95d1073948cc43b-1730302140"
  },
  {
    "email":"tibaldirita3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565519226/d617c277083bbf2fa360d8dd2cadf8ab-1730302141"
  },
  {
    "email":"roxy.dream@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565355386/abc76d10097edd4ba8104833bc4b8e04-1730302141"
  },
  {
    "email":"fra_miche@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565551994/c62a9ad3d8ef46a4e232aae0aa6736bd-1730302141"
  },
  {
    "email":"roberta.giubileo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565420922/d6c748ed934f7d6b576c7d208b8961bc-1730302141"
  },
  {
    "email":"esseb66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565650298/0029b6427caf0ab8409e0250e9e07b1c-1730302141"
  },
  {
    "email":"mar-mar@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565683066/710437c6fc4a02dab7c163d8e8ed7588-1730302141"
  },
  {
    "email":"sparpinel@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565584762/02aa1b542f843c53206b9df11620669a-1730302141"
  },
  {
    "email":"occofferp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565715834/c5032709ea6cde7246aeb6781248bd73-1730302141"
  },
  {
    "email":"ottis19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565748602/1df8d46d48958b458ab6083d63e7180c-1730302141"
  },
  {
    "email":"elivant66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565617530/f3f510bf55fc4dc5c1e6d74f3dd0f48b-1730302142"
  },
  {
    "email":"leonor.hernandez@unitn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565781370/7a5e13b8bb26879a90d17d1f631b9892-1730302142"
  },
  {
    "email":"salimbeni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565814138/05af33268e469777fa9f0251921a74f5-1730302142"
  },
  {
    "email":"elyravell@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565879674/4d25c3f94f6c26c8bb3e4934ddff4499-1730302143"
  },
  {
    "email":"astolfxy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565945210/86b1b84c688da55cbaa95d9f2161b610-1730302143"
  },
  {
    "email":"margheritacosta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723565912442/e08b3b4ed639926c925fe7dff946e760-1730302143"
  },
  {
    "email":"ilaria.scacchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565846906/dd9d1e1ed27ccbf1230cd6582492f2c6-1730302143"
  },
  {
    "email":"desantisanto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723565977978/aa5d4a279c99e59dc37de92a8b22cd43-1730302144"
  },
  {
    "email":"manumaruz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566010746/2ed5c9db81ffadbc973b5e5937b44d81-1730302144"
  },
  {
    "email":"mg.delrosso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566076282/168438bfc4bba41c1edb8936e68a2e31-1730302144"
  },
  {
    "email":"vrazzauti@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566043514/449d29862cd2ef6281e6cf186ca8ec7b-1730302144"
  },
  {
    "email":"anny_l@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566174586/61f65a1c0e5978da22c064eb35cd2719-1730302144"
  },
  {
    "email":"tamaracra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566305658/22bd6b5b0ddfa1ba3e31e5fa914fa2a9-1730302144"
  },
  {
    "email":"r.leoni1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566240122/029555d746c0c4b3c56f378ee65cdd55-1730302144"
  },
  {
    "email":"lauracolagrossi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566272890/92ba6add26098f4e0dc33fc055659065-1730302144"
  },
  {
    "email":"vinciroberta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566436730/38688bf9551c56a4cac81dace6a72ad6-1730302144"
  },
  {
    "email":"lore.at81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566403962/85ebd927dbe1c7e98d3471763f53c13f-1730302144"
  },
  {
    "email":"su.ada@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566338426/8eaa04a161aedaacb4204ef0a7397ee2-1730302145"
  },
  {
    "email":"federicafiori981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566469498/b045a23bb2bc9b69ef5031b60f2d0373-1730302145"
  },
  {
    "email":"maria.lagana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566371194/cd68ea5c5d646867e8036d55df6812ce-1730302145"
  },
  {
    "email":"ceresie@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566600570/5a3c5494ac6097945241e6702bba31e9-1730302145"
  },
  {
    "email":"raissafrascella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566535034/b49029e2e1c0862d0ca4dd11c9fcf340-1730302145"
  },
  {
    "email":"a.gagliardini76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566567802/142cd06f742768e77930418af35f727c-1730302145"
  },
  {
    "email":"maestremerlyn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566666106/cea580b1d55375aaf72395cc74acd366-1730302145"
  },
  {
    "email":"andrea_monica2005@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566698874/d0f4b29a3babc176af9819e1e85fe6c4-1730302145"
  },
  {
    "email":"michelamarchetti89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566731642/c00ebe32a29cd5e245e8bcf0171300f5-1730302145"
  },
  {
    "email":"franznorbiato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566862714/b8bd243d8cc73024e896f6320f944173-1730302145"
  },
  {
    "email":"silviadebortoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566829946/92a2a606178650af6947452aecf2d495-1730302145"
  },
  {
    "email":"adriana.adiletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566633338/c041bdfb65cb095e58cc4db98d57686b-1730302146"
  },
  {
    "email":"maripane@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723566764410/84a6019f4118315e2f9f451bda849519-1730302146"
  },
  {
    "email":"mohrkatja74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566993786/c07dc85cbedec796f6939101c1ffc2a6-1730302146"
  },
  {
    "email":"colombari.arianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566895482/93657b39013a96274e5e5c1fd63b75df-1730302146"
  },
  {
    "email":"cristinarosin@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567026554/352f68108984466c7344e0954511e978-1730302146"
  },
  {
    "email":"mariagrazia.barbagallo24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723566961018/af5aa3d6b5abb5d7dc7cd02b86754858-1730302146"
  },
  {
    "email":"cusanodomeniko@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567092090/a8a275b6d5d2e6e32a459addcce489a3-1730302146"
  },
  {
    "email":"arianna1670@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567059322/c356a8963fd7c945267efd0110d2cbf2-1730302146"
  },
  {
    "email":"gianna.tiatto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567157626/e464282773583d18243ab660aa63a0b4-1730302147"
  },
  {
    "email":"borranilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567190394/ca7778cd5cacf1184fe86ac1cd680da9-1730302147"
  },
  {
    "email":"francy.vitale69@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567255930/7799a2c172c0f1cab992253ec8336882-1730302147"
  },
  {
    "email":"tiziano.polo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567124858/d61607cc269ba840b531f3f6a33a078c-1730302147"
  },
  {
    "email":"vpiccolo23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567321466/a50ce5bb696716ce0a37d93023b69cab-1730302147"
  },
  {
    "email":"serenacaprio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567223162/b7828e640b51d05da7c0c729e47fa9be-1730302147"
  },
  {
    "email":"dattoma.ida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567288698/7b69f34d25ad23d4687ee124f845d992-1730302147"
  },
  {
    "email":"ritagaetani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567354234/81bde458d75c2f17dc5d3a3ffd5a3a86-1730302147"
  },
  {
    "email":"magicianred@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567419770/bb21795222fbfa546d231229f5fe55f6-1730302148"
  },
  {
    "email":"stefanocarrisi0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567452538/7a0020b6c78e383f4aeb8c748a8843bf-1730302148"
  },
  {
    "email":"paoladinnocenti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567550842/03a96d7d51bf79e7fb162377fb0d2992-1730302148"
  },
  {
    "email":"pbrunori64@gmsil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567387002/e3304f636e9998c265bbb6b9e752cba1-1730302148"
  },
  {
    "email":"m.benedetta.mariani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567616378/40589c167f1c494aad5928d8eb714e37-1730302148"
  },
  {
    "email":"katia81.c@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567681914/bf9f6f8972b5ede52cee508863c6e81b-1730302148"
  },
  {
    "email":"carfizzinunzia1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567812986/c8a2d5fa4bcd2bd91d8d4ce996ed2079-1730302148"
  },
  {
    "email":"veronica.rafani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567845754/f5ad48ff74a951dd70394bf559edfbaf-1730302148"
  },
  {
    "email":"ila.strinati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723567583610/26f8217a83db9419cb75a23a76d7c8f3-1730302148"
  },
  {
    "email":"alba.fusaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567878522/88a3e99999dd0c6dfc3c36d06e6d36bc-1730302148"
  },
  {
    "email":"marycasprini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568009594/a12f7994a8d452b48ec50f9157381a89-1730302149"
  },
  {
    "email":"virginia.mangc2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568075130/3613d197706be53a81007674509bf9d2-1730302149"
  },
  {
    "email":"lidia.ambiveri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568042362/65a9c1d72edc6f3968c1ed87297c2c34-1730302149"
  },
  {
    "email":"mapigra163@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568140666/42c65e3e203a30c4e03b582d6388c5fc-1730302149"
  },
  {
    "email":"mon.beltrami@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723567911290/72e187dbade0c9499188f001f4699736-1730302149"
  },
  {
    "email":"rosanugnes@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568107898/8cc5a653ab93d764965e1df85a106c00-1730302149"
  },
  {
    "email":"dluccaroni@myo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568206202/61af2b78bb087b2b79225859634c793e-1730302149"
  },
  {
    "email":"kadiaops@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568271738/c235f5f16558b70bff23ecc7973b4b6d-1730302149"
  },
  {
    "email":"biancadaria.manfredi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568238970/3a5ea7a3a0ec1dacf389fc7976ff23fc-1730302150"
  },
  {
    "email":"mcingenito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568337274/d9cf2989ca4f2413163fd9f3f1db510c-1730302150"
  },
  {
    "email":"m.stefaniabalena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568173434/6173dfc97bc0cd925f33b2f941ed9ca4-1730302150"
  },
  {
    "email":"vanita.oscar@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568435578/ced07344e5c9ca3dede39cc7b6588c1d-1730302150"
  },
  {
    "email":"andrea.marini.xxx@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568304506/2ce6d54ecc6a98bb004a493fa38775e6-1730302150"
  },
  {
    "email":"stefano.polimeni.sp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568501114/ae5a2c7185a360ad5ee70b4f8bce7b57-1730302150"
  },
  {
    "email":"antonio.cocchiaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568370042/9f844f04195e2c7eca20629b183105ac-1730302150"
  },
  {
    "email":"elisalicon.mn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568533882/991ed19d5f3d7e1e3bd8c3c0d5244709-1730302150"
  },
  {
    "email":"ilabru79@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568468346/b16da703c4ea9668922162072d6ff3e8-1730302151"
  },
  {
    "email":"arch.angelagiordano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568566650/99ad4abb1085bc2fba66ce4679d4597f-1730302151"
  },
  {
    "email":"topazia@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568599418/d800f2170252b0fc706e7db2bc9f5d9b-1730302151"
  },
  {
    "email":"sara@newpetfood.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568632186/12678a4355915962a9d8bb7f6dccdcce-1730302151"
  },
  {
    "email":"katiadamore@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568664954/78595684667d7530ab50d63335c6f2e2-1730302151"
  },
  {
    "email":"panerotiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568730490/0cd75f02169fbbc32116b7f068f3afb5-1730302151"
  },
  {
    "email":"brescianini70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568828794/fd5073afe1cf565dfc2d9c6f99ff6d5e-1730302151"
  },
  {
    "email":"sofia.pelagalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568959866/5a3fec7f9fb2534286518a5d72fd9d11-1730302151"
  },
  {
    "email":"isabe_lla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568763258/83a7636669537b28eda669ff020f6de2-1730302151"
  },
  {
    "email":"lor.pattaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723568796026/6dbe1faafe5260546b21f4a6e3965444-1730302152"
  },
  {
    "email":"rossy.cavalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569025402/b6aeee747a0a40504155819c786561ec-1730302152"
  },
  {
    "email":"michele.daria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569123706/b13f389ddf8b5a56c09b14b32aace798-1730302152"
  },
  {
    "email":"laura70f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569156474/633b4abac27916ab0f28f742c251e30a-1730302152"
  },
  {
    "email":"electrabelluzzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723568992634/6ab73b6b85a3c6460a525c1a3731ba9b-1730302152"
  },
  {
    "email":"silviacarlandrea@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569058170/85207a72bdef50327d47a281f4858352-1730302152"
  },
  {
    "email":"ldelgro75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569254778/412bba069a0c9253a5b57bad9c8269c3-1730302152"
  },
  {
    "email":"sergio.paolo40@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569222010/92793de6fffa6fd62e5e4996c1852d70-1730302152"
  },
  {
    "email":"simitorretta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569287546/7a6bfebd1b9359da54fa62ce28a1e140-1730302152"
  },
  {
    "email":"caterina_rda@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569189242/d0613e880b2715f1054760b7091bbd33-1730302152"
  },
  {
    "email":"rossanaraspollini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569353082/74be57ed7f1403b25e9f30d14b80753b-1730302152"
  },
  {
    "email":"mi-19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569320314/f7c56f2c3aa11f7dc5d602ca525ede27-1730302152"
  },
  {
    "email":"roberta.onofri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569418618/749a63bb7f6707d7aa7f540adde35a81-1730302153"
  },
  {
    "email":"silviaisid@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569484154/2a177c7c4a31865ce6b87942e3042b9e-1730302153"
  },
  {
    "email":"rossella@tecnofood.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569615226/bc73f3f6b6c89def4ceb680e610a2656-1730302153"
  },
  {
    "email":"fra.marano82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569516922/6652744e324f258400f6727ba57cdd65-1730302153"
  },
  {
    "email":"mteobaldi94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569451386/de11e37d872c0fabca7b469c81db017f-1730302153"
  },
  {
    "email":"luciana.fatuzzo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569647994/97674ba2f9ffcfbfb21852127ca20ccf-1730302153"
  },
  {
    "email":"saramadiai@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569680762/3ae3436d641ef067526158441b96ee20-1730302153"
  },
  {
    "email":"oriettangio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569811834/c8d186c73f5bf3b75d9153abb95f6e34-1730302153"
  },
  {
    "email":"stefania.uccheddu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569844602/c8ff41894534de7acd062ef6b7b462c5-1730302154"
  },
  {
    "email":"edi.hanku@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569877370/b5d97159c677aaeb9bc410a2de4c31fe-1730302154"
  },
  {
    "email":"matilde_rossini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569713530/7169a9168ef6ca93fb06cc9f579152fe-1730302153"
  },
  {
    "email":"anitajo.anna@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569746298/c13af9106020957cf308382176dae97e-1730302154"
  },
  {
    "email":"robertavarini63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723569942906/2ecce5851e512a5a705b87e7bad5f0fd-1730302154"
  },
  {
    "email":"cricalderoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570106746/8617d4fdc35575b04b73b2e0acc4cf4d-1730302154"
  },
  {
    "email":"donataguerrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570008442/0eb4dcdd0bbc1f91ddb7c894d5bed975-1730302154"
  },
  {
    "email":"chiarabugini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570139514/7a20e8f0243e567b56b74f36d13f9540-1730302154"
  },
  {
    "email":"marionetto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723569975674/9dcd5e556548bc0e8bd01bc81eae8173-1730302154"
  },
  {
    "email":"gretuccia.t@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570172282/46fe5e7997bce4267fde8a130d3f5a07-1730302154"
  },
  {
    "email":"silvia.fabrin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570205050/c112e4edb781025c3d5269e9f4d557a1-1730302154"
  },
  {
    "email":"mariellasgro@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570270586/f12e479dbb05d69ae3f3ce060b08cb4d-1730302155"
  },
  {
    "email":"melgari.info@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570368890/64a87d148e09e8870d20bee233538a12-1730302155"
  },
  {
    "email":"avv.pappalardon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570336122/3289d59740771e3143b5074262627764-1730302155"
  },
  {
    "email":"bbulgarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570303354/ddccfaffea3cf57591ea9b96971cfbc5-1730302155"
  },
  {
    "email":"alessandropalombi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570434426/4b87cb3ca4497244009b33e9b126e948-1730302155"
  },
  {
    "email":"sandrabo800@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570401658/40ca53f4ee3caac47c10189a4c9130e9-1730302155"
  },
  {
    "email":"veronica.modenese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570467194/cbc223613b010da5579fae85ef8db111-1730302155"
  },
  {
    "email":"ingrassiantonella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570729338/9e7b69088f7d1910bcb66ff4a23ec50a-1730302155"
  },
  {
    "email":"rozzinimanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570631034/491527444576e63ef9a0619e68ca0ced-1730302155"
  },
  {
    "email":"bilibili89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570794874/f3ecd7fe1d9fc5bd38ecce59a741debc-1730302155"
  },
  {
    "email":"cristina.torre@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570893178/57ac5180e397ddf5b811377966f59d52-1730302156"
  },
  {
    "email":"info@baus.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570958714/80d7650a4a62111b8bd2be8b5ad63a13-1730302156"
  },
  {
    "email":"traversitrasporti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723570991482/1724b4c8eaf3a0f36752e2031fa9a41d-1730302156"
  },
  {
    "email":"antosal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570925946/1a7301b9ac9083b77698f2f850089b11-1730302156"
  },
  {
    "email":"carla.digianvi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723570827642/52bbca7b47a1aaf6ae89c799268d4758-1730302156"
  },
  {
    "email":"mariateresapezone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571024250/d5d36b11886ecee471af0e0004d973ac-1730302157"
  },
  {
    "email":"stefi.drusi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571155322/532342a6ebe1ef6888631fa5fede5501-1730302158"
  },
  {
    "email":"carlochiaralice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571188090/7adb124a8f5491a5a6506ab3e2a0a3d4-1730302158"
  },
  {
    "email":"daniela.vallo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571089786/4124ed468a39b50f9cd73a129914991c-1730302158"
  },
  {
    "email":"castaldo.arch.agnese@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571220858/5b0dc926a34320b378038dccee0f4f68-1730302158"
  },
  {
    "email":"mareluna74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571319162/f18a77a3ca08c00812d5b5037890c0ef-1730302158"
  },
  {
    "email":"rosa.ilaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571286394/cf23a294ffe77c63da5731f0daf668e1-1730302159"
  },
  {
    "email":"cristina.marani@studiogragnoli.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723571253626/6b8cdedcd4882e7e90d54039f154c5b1-1730302159"
  },
  {
    "email":"vincenzamisuraca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571384698/ec4e415f15c4c7c1e7b573babfdb2d27-1730302159"
  },
  {
    "email":"gilda.pace@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571351930/184ccffc10fc90bb129ee906a1f32bb4-1730302159"
  },
  {
    "email":"e74rago@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571450234/c02c6a6666efa5da7367fe866745af17-1730302159"
  },
  {
    "email":"angical@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571581306/26192782a67b085f131aaf8f8e40d82a-1730302159"
  },
  {
    "email":"avada@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571646842/92f6393dcfc909d9c418b0323844d5dd-1730302159"
  },
  {
    "email":"ila.merlano79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571483002/aab9dc984bcb4a773aec7db38b3f75e4-1730302159"
  },
  {
    "email":"annarita_m@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571417466/ee2dcb2c67f44be0927740be1eeb5d5b-1730302159"
  },
  {
    "email":"mariacucccu@studiolegalecuccu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571712378/3065d2cb4da1d2040ae3eb66a0b787af-1730302159"
  },
  {
    "email":"zanca_da@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571745146/542c82db01801a8962508c1576ddbef6-1730302159"
  },
  {
    "email":"mkb.net@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571843450/ad114b6e07455bd9ea5428a4438a77d4-1730302160"
  },
  {
    "email":"eurin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723571876218/74942e6497a02e83ae24e2bfb8d5e19b-1730302160"
  },
  {
    "email":"erika.fedrigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571908986/3c56ce508e0eec3e507863bad9b2bf1b-1730302160"
  },
  {
    "email":"giuliaurbani90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723571974522/8d232c0dcbc35e264de2536d48900ece-1730302160"
  },
  {
    "email":"iolagiallonardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572072826/261fd4c30d53633dec3ecf958200e5b6-1730302160"
  },
  {
    "email":"canutisilvia6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572040058/5fd8daae222aba6d615dd12fb52829a7-1730302160"
  },
  {
    "email":"maritanpaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572105594/14af475adb43b1b9b9c330c7e32c5545-1730302160"
  },
  {
    "email":"diana.carpita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572171130/92c354ff4191b65d690c5f4e5c7334dd-1730302160"
  },
  {
    "email":"manrose78@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572203898/9c7a313e4a8a27f1940f77b690c1a76e-1730302160"
  },
  {
    "email":"fabiana.seghini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572236666/3782c01b279b0710e1894ab7e25059dc-1730302160"
  },
  {
    "email":"bianchiclo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572269434/ff3a6fde7dd6a7c14ae6ed2071804f72-1730302160"
  },
  {
    "email":"chiaralorenzutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572367738/2b4ea7f2f6755a53f697dbd010d10de6-1730302160"
  },
  {
    "email":"elianina81@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572433274/7f9070abff058c03a3ac44838e23b3b8-1730302161"
  },
  {
    "email":"simonacastagnari83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572498810/0144e1bb9b25a55f14b00cd7f8e11036-1730302161"
  },
  {
    "email":"c.brucoli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572466042/3e61ced0e30d7fde854c00eda420e416-1730302161"
  },
  {
    "email":"ds.sara83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572400506/9bf638542ae406af04a5da382283ae2a-1730302161"
  },
  {
    "email":"mgvoltini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572597114/36128ae953b09863ee3b20ab07574f33-1730302161"
  },
  {
    "email":"a.salsano66@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572564346/a9766979f80476f93bdbc4fb74d334d0-1730302161"
  },
  {
    "email":"e.nespeca@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572531578/d495418880a0362c2bcb9aac38623739-1730302161"
  },
  {
    "email":"essezeta72@gmail.co",
    "url di attivazione":"https://verdissima.it/account/activate/22723572695418/3b58ce62f8bcf3c1cb221a26223d757b-1730302161"
  },
  {
    "email":"ilariarisegato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572629882/662c76c6d95251e7faf5f3a226701e69-1730302161"
  },
  {
    "email":"silvia.arfilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572728186/e4690c22b70be3d5b253c6674da01788-1730302162"
  },
  {
    "email":"ilaria.toncelli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572793722/beb0fbd20141b9b3bb3098d18b920fc8-1730302162"
  },
  {
    "email":"roxyross@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572760954/7df5b890861098c15fabb0c7dc16bc8e-1730302162"
  },
  {
    "email":"lilianacaruso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572662650/d111f06fc180701b0f60141cf6b939a9-1730302162"
  },
  {
    "email":"manuela.ba@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723572826490/4f9fa4941e45f716b25b63b978b75773-1730302162"
  },
  {
    "email":"belanzoniclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572859258/6de2ace4f7e8c63d3d4aa54d0eac6643-1730302162"
  },
  {
    "email":"drnsmmrtn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572892026/6ec24848cb4a696e37b84b5e87101142-1730302162"
  },
  {
    "email":"martina.borgiotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572924794/284ef7ae91f90fb9e17abb602322bc2c-1730302163"
  },
  {
    "email":"monicaprovinciali68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572957562/af6dcf519c524dc18278a2b803171870-1730302163"
  },
  {
    "email":"michela.pertile@protec.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573088634/01414676b2f2aa5ae3a529fcc21ad89b-1730302163"
  },
  {
    "email":"davide.gotti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573121402/a5e9a79c510ca1387f7b3cebec532a26-1730302163"
  },
  {
    "email":"barbaradefrancesco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573154170/316bfc227beb4ed2ef66fe27e0cfd5f1-1730302163"
  },
  {
    "email":"cristina.capuzzi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723572990330/855dbc5fa2400f26c2542e78bde171e1-1730302163"
  },
  {
    "email":"annadigaeta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573285242/4527a889668dfae1e953ac0e43afacea-1730302163"
  },
  {
    "email":"francoartigli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573252474/de81c7faab048fa0b0a56181da92c441-1730302163"
  },
  {
    "email":"silvia.ruffato.65@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573186938/b504acfb36145a4fa8fb3b8c4130c1ba-1730302163"
  },
  {
    "email":"arnaldi.cristina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573318010/d135020cd81b06e090e65befdd2378d6-1730302164"
  },
  {
    "email":"rosy.badella@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573383546/1eff8517ec4270ae0866abdf641029eb-1730302164"
  },
  {
    "email":"livia.zizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573350778/69c7240c22cdcaf1c0d08753c6253be1-1730302164"
  },
  {
    "email":"babida17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573416314/e599176e8cb20d282f48e2990b043785-1730302164"
  },
  {
    "email":"lorenzaneri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573481850/05be4e07a774522dafa44645f0b5d560-1730302164"
  },
  {
    "email":"hilaryfede@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573514618/9c8980e4144fd51b49753e143faaf6b8-1730302164"
  },
  {
    "email":"maria.putrino@alice.ti",
    "url di attivazione":"https://verdissima.it/account/activate/22723573612922/c805910f8861544eb96aa80f28796725-1730302164"
  },
  {
    "email":"simsicuro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573580154/cc6880344b20eb34aa551bdd0f51850f-1730302164"
  },
  {
    "email":"gabriellamail77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573678458/1d18667d17383fca8c092c0f3512efe8-1730302164"
  },
  {
    "email":"pirolisara@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573645690/f13896fb721166676dfea6f982964d0f-1730302164"
  },
  {
    "email":"c.alessandra89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573711226/1ce843fc3efa9c3865f659f6bc2d5006-1730302164"
  },
  {
    "email":"patti.allarchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573809530/d0ceffac7151195ca4d0acdf4069ac1d-1730302165"
  },
  {
    "email":"alessandra.spagnol85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573776762/aac5430487aa1d1c5887f07b795ed9f9-1730302165"
  },
  {
    "email":"save71@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573875066/0483e390776176c08ef848a1a2ade926-1730302165"
  },
  {
    "email":"fabienneve@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723573743994/b73699c9bac52ad82654988392173d2e-1730302165"
  },
  {
    "email":"luisa@valdelsa.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723573907834/ef708be1287e6450f500261838ba50c2-1730302165"
  },
  {
    "email":"rossellabellopede@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723573940602/cb5fed0f855e0b269b6cc0cf2df54cb3-1730302165"
  },
  {
    "email":"manuelacelenza@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574006138/a951bbb4060e0ea6e3484490c63f4b9e-1730302165"
  },
  {
    "email":"isatin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574038906/fce08661ee44dc41ca7af89dafbfdbd0-1730302165"
  },
  {
    "email":"francilisa14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574104442/8e47f8f96c9a980bf8872df3f265a4c5-1730302165"
  },
  {
    "email":"paola.severgnini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574137210/a07120cb3eefdcba192caec746332073-1730302165"
  },
  {
    "email":"lorena.lussana@carpenterialussana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574169978/275ed873eaa10fb63e55e201ec772e12-1730302165"
  },
  {
    "email":"faccioli67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574071674/3e6a410ec3e7a56f429fbe31d14b94b0-1730302165"
  },
  {
    "email":"fadmin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574301050/bad619476fcdd8c5aad0087d2dae63de-1730302166"
  },
  {
    "email":"rudy_manghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574235514/3960a87222c9942225719539c8f5ba1e-1730302166"
  },
  {
    "email":"annalisa.gelain@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574399354/06bd4c06c5f75cc26fe978b148f4b04b-1730302166"
  },
  {
    "email":"federica84maniero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574333818/6e96e3541872f4696c9a7906ddeee223-1730302166"
  },
  {
    "email":"danigigliuto26@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574366586/b131fc3bb45d5bf53307c0a8643dc6ec-1730302166"
  },
  {
    "email":"annalisa.r81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574202746/87de5069f530a9da2573bc6765c4f0f2-1730302166"
  },
  {
    "email":"barbaradellagotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574432122/673ebed381d90f57210a1fa1b9d023d2-1730302166"
  },
  {
    "email":"corsomargherita@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574464890/0eae21a70175bb68208627a48e8aade0-1730302166"
  },
  {
    "email":"carla.larosa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574530426/a65940f92f9e48db01ab010b24a6f56b-1730302166"
  },
  {
    "email":"micaela.rambelli01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574497658/71d55ea5a5c96be4f7b47cf59b868270-1730302166"
  },
  {
    "email":"monica.papetti75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574595962/50ffdcff04c250b99480d0264770bca0-1730302166"
  },
  {
    "email":"alfonsinamessina@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574628730/fdac546adf1f42d5cbe08ad17ccc5abd-1730302167"
  },
  {
    "email":"elenapierantoni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574661498/cfe6e804ea7ea020fcf76d6e50422240-1730302167"
  },
  {
    "email":"antocat@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574694266/59e395a9b889bf84c771b8e0e05de5a9-1730302167"
  },
  {
    "email":"maria.victoria.ioannilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574727034/75e42ff1920b9676e34e3ff49774489c-1730302167"
  },
  {
    "email":"antonella.spagnolo1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574563194/58bcb9f699bbf3c0ed68ba2cd336ce0d-1730302167"
  },
  {
    "email":"ambrapellegrini77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574759802/995f7b18152c6a0d4db025ac45b43334-1730302167"
  },
  {
    "email":"v.lattanzio82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574858106/219396bae20b83c0b9a2f79f0f580237-1730302167"
  },
  {
    "email":"vincenzo.pp@love.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574923642/1a761895c9b9eb4c3c59946ff8d58b9a-1730302167"
  },
  {
    "email":"cristinanizz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574890874/5aaad2f13e1dbeaf6f42bf4ccb7e77d1-1730302167"
  },
  {
    "email":"tripodivana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574956410/7d1317d101d310d2be3c7292afc384b9-1730302167"
  },
  {
    "email":"annalisa081095@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723574989178/a4df0de939ee37aa836f75f51b4d6230-1730302168"
  },
  {
    "email":"destro_francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575021946/1f34dceaa93327c670aa6c5b46d7cc30-1730302168"
  },
  {
    "email":"giovanna.bellina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723574825338/78310814084843fc18bae589216ea859-1730302168"
  },
  {
    "email":"sonia73milone@gmail.cim",
    "url di attivazione":"https://verdissima.it/account/activate/22723575087482/f665659e9a046bd04391754936d58d00-1730302168"
  },
  {
    "email":"barbaralucianido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575153018/6c7008a0241c814e39542aae6da4b9c8-1730302168"
  },
  {
    "email":"giuseppinamonaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575054714/30b7ea8c17c42fb4fadae74762791f06-1730302168"
  },
  {
    "email":"ada.bosco68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575120250/d04dbf63aa61e99c318d57d159edfbad-1730302168"
  },
  {
    "email":"danielabgln@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575185786/fd8e3524c54356084a25e2b7fb5358e4-1730302168"
  },
  {
    "email":"giulialin.revelant@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575316858/6f1aed1607634f4a794c06055ac469b0-1730302168"
  },
  {
    "email":"mcris.russo63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575284090/fc53742d941d44b206ace78eac257b14-1730302169"
  },
  {
    "email":"teresa.bonu75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575218554/79bceb4d6697b2bac6ff0e383d5b3529-1730302169"
  },
  {
    "email":"ebuttaieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575349626/1f6f36ec603c98a3ae4f6d2d3aff0899-1730302169"
  },
  {
    "email":"luigipoppa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575447930/0fe102f1a902b12b8409bf3e1899760f-1730302169"
  },
  {
    "email":"barbarabertocci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575415162/92bff4dc25741647f45aeb5604249149-1730302169"
  },
  {
    "email":"matiarcaini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575480698/6010ccb1657817d17f41e71ce8596416-1730302169"
  },
  {
    "email":"dadacinque@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575513466/d295a7ef661f1cae44bf3b46d7c6072c-1730302169"
  },
  {
    "email":"teseialessandra88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575644538/351a09ab5e41217f909e22daa42a6005-1730302169"
  },
  {
    "email":"carmelinaciocca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575677306/e15206f24f7f735d89571d69686a8f12-1730302169"
  },
  {
    "email":"marilazzareschi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575611770/2c375bffc7fd0cb1395532a27391d372-1730302170"
  },
  {
    "email":"lucmosc73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575710074/6cc521245774e8885879246b7c28e22e-1730302170"
  },
  {
    "email":"nonnisluca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575742842/8fc5b72f7d6cd2d6eb38083d4e61d19b-1730302170"
  },
  {
    "email":"valeriapigini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575579002/a68a18ab6183679fdbf1a9ceb6c13a27-1730302170"
  },
  {
    "email":"sofiadecesare@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575775610/900cb4e72c722ecf27f6a20b53e476b0-1730302170"
  },
  {
    "email":"bettanadiasignorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575808378/a4c6541561271f7cabb73dda59ad6a13-1730302170"
  },
  {
    "email":"ari.bertocchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575873914/3dddeefe72ff354b3238e3fac964e23c-1730302170"
  },
  {
    "email":"leochima@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576037754/2cafc36963e3f8dcf439e70bbf1ffbee-1730302172"
  },
  {
    "email":"benedettaspallanzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575906682/59bb0966abd7cb355faabb1e7f876546-1730302172"
  },
  {
    "email":"caterinapiane@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723575972218/9876ca508e8612e085eb8bff518dff34-1730302172"
  },
  {
    "email":"miriabecciolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723575939450/56626da6ec6729053e35486860e2dc05-1730302172"
  },
  {
    "email":"kater_79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576136058/5a85adbf3c25bad94a44b2e24ef30750-1730302172"
  },
  {
    "email":"tecbion@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576070522/4f777d24e203594d723831945c5aa021-1730302172"
  },
  {
    "email":"giovanardigiulia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576103290/ea6c2d4bdb9e2daa2186d7a18fbe8907-1730302172"
  },
  {
    "email":"avvsimonafulceri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576168826/39581b3f92e1a3db7eee6a58586d3063-1730302172"
  },
  {
    "email":"valeriacasulli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576267130/ccf222e10b2ca2b82be0c57f823ac4ba-1730302173"
  },
  {
    "email":"caterina.pizzenti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576234362/62f610733b06169b6403e3691e47d58c-1730302173"
  },
  {
    "email":"antinea.st@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576299898/567ed174461a11abcc27544e70325732-1730302173"
  },
  {
    "email":"cate.tanga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576201594/b58a2d3dc831b3361af6d359ca2c34c9-1730302173"
  },
  {
    "email":"paolaxsan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576332666/758b306079bd8a339e5318cc44c97537-1730302173"
  },
  {
    "email":"anna.panigalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576496506/f64ad301559c024d39e2df835aff4c06-1730302173"
  },
  {
    "email":"santi.silvi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576398202/36eef526649532617d6d6744a8d8a2b8-1730302173"
  },
  {
    "email":"francescapeveri94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576594810/cf58f7eb29d40fc49fc42ea7dddaf7e5-1730302173"
  },
  {
    "email":"saravitagliano.sv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576529274/b3edb89325000fcd37b4d4150bf3a094-1730302173"
  },
  {
    "email":"claudia.marzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576562042/f68cffddf6fb42cb9018908f469f263a-1730302173"
  },
  {
    "email":"lisa44@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576725882/87e935f0129c57a910b9a05625483237-1730302174"
  },
  {
    "email":"luisadanna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576430970/5887d22b1a1b67e4d381ee372e845b90-1730302174"
  },
  {
    "email":"marianna1602@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576758650/fdbc6504abc3f62aca42d40ff1b02442-1730302174"
  },
  {
    "email":"michela.bertoldi@savioapa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576856954/03b3d1852e1898dfb4fae91d3ee14647-1730302174"
  },
  {
    "email":"allemani.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576824186/dfdc6d537c1330a9f0b1359fb9212ddc-1730302174"
  },
  {
    "email":"cecilia.giacomelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576922490/5d7b8318e16caf1fc7fd8f8928eed205-1730302174"
  },
  {
    "email":"cigolinielena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576889722/471e7a51ebc879e1d9b7d99396ace2d7-1730302174"
  },
  {
    "email":"elferra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723576955258/e707c545943c6efe12f03f7e5f012ef9-1730302174"
  },
  {
    "email":"lalecap73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723576988026/f09162c6a83357b5d27c4e7b8f94e217-1730302174"
  },
  {
    "email":"c.barbie014@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577053562/15eba12c247e269b38f2e38461238496-1730302174"
  },
  {
    "email":"lormat08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577119098/c5d198fd3a8c347e7ce3536c09334037-1730302175"
  },
  {
    "email":"nadia.bassino31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577020794/fc0697dbbfd0152895643cc588764acd-1730302175"
  },
  {
    "email":"acquisti.web@microprogel.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577151866/bd69c5f9879731fc0921000a3f66b8e1-1730302175"
  },
  {
    "email":"erikatrangoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577250170/560506d3e9341a5083f3ea28295e07c4-1730302175"
  },
  {
    "email":"simona.braga96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577086330/94842d0ea063e9c1ca4d263d881adda6-1730302175"
  },
  {
    "email":"stefania.lampis74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577282938/ee80aa137593cfdc6dae448a973a8a49-1730302175"
  },
  {
    "email":"ssaranaldi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577217402/98c8e239e4bef186ac10cd46376a3ad5-1730302175"
  },
  {
    "email":"fedcantore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577315706/6e63e3cacb99d2255ce82a527f352166-1730302175"
  },
  {
    "email":"marianatristezza@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577348474/e5bf3fffcd5fb40e051cbb087252b9ad-1730302175"
  },
  {
    "email":"delpozzomarina67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577414010/4848c8cc9ed95e48b22c551037f576c4-1730302175"
  },
  {
    "email":"francesco.concilio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577545082/358d15c2d5f1e48fbba04d82597298d9-1730302176"
  },
  {
    "email":"adrianacristescu1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577479546/ebc26437d0f9d80fa2f0a399ef4a3328-1730302176"
  },
  {
    "email":"s.sambuchi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577577850/0559226c96d05da015bd11054c2247da-1730302176"
  },
  {
    "email":"fransantoro@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577610618/c96a7dbc41d6ee98aef565096c9c75dc-1730302176"
  },
  {
    "email":"deboracacciola28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577676154/d00fb07c34e4a507535e55a412c51f09-1730302176"
  },
  {
    "email":"elisa.vaccari.24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577708922/1ac1cdc77f86a1f4388e7bc8398737d5-1730302176"
  },
  {
    "email":"giuseppe.lasala@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577446778/d55d62de5686556b9a3bfb961db7bad2-1730302176"
  },
  {
    "email":"emanuela.gandolfi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577774458/5d910d3ae8781a9a9544e9413c2cad3f-1730302176"
  },
  {
    "email":"principec80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577741690/99a936a39b53f757780e2aff0fa7137f-1730302176"
  },
  {
    "email":"principec1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577839994/a6bb5d3e8336bf93d53db52e84d117fb-1730302176"
  },
  {
    "email":"corrado@ombcsnc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577807226/858ebc1e924ea166c6bcead19d1bf964-1730302176"
  },
  {
    "email":"amministrazione@salvatorisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577872762/1355464a9914f80a3f2c2d8feee51a20-1730302176"
  },
  {
    "email":"rinomutarelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577971066/7c972d881edd84ac9bad6882f7d1d633-1730302177"
  },
  {
    "email":"bg.cropano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723577938298/fc6e12438eceb08ed25f9ba245654f33-1730302177"
  },
  {
    "email":"antonella.delmagro@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578036602/f5320236fae204d4fff90eb8b3e6aeaf-1730302177"
  },
  {
    "email":"barbara.carpita1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723577905530/4374b700b7edc391b65506f8e7fc81fd-1730302177"
  },
  {
    "email":"elenacecchi68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578102138/d5b04b91651ce00b3274926b1c89ca24-1730302177"
  },
  {
    "email":"caterina_77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578134906/21e1b1da0d21e5b3d0ba9aaefe18e4c8-1730302177"
  },
  {
    "email":"sabri.virgilio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578200442/611ded2b78e1b29768a44e903fc42d01-1730302177"
  },
  {
    "email":"francosann@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578233210/51defc1801dc8143456339eb9ae9ec02-1730302177"
  },
  {
    "email":"annalisarovatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578265978/9171a287e930102faf2aa1a35fee0c5c-1730302177"
  },
  {
    "email":"coppolam572@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578298746/e42e24c1869b69746cb3218a63bb594c-1730302177"
  },
  {
    "email":"emanuela@edfsystem.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578069370/30402fa5a3285bde1faf74f05f2245e1-1730302178"
  },
  {
    "email":"annalisadizoglio1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578331514/c4caaa799906175e1238cbaa8f1f46c9-1730302178"
  },
  {
    "email":"ines.massa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578429818/e2f4763a3f6a03984b2eeb1a83b6093a-1730302178"
  },
  {
    "email":"alessandra.scollo84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578397050/f059a143275bd544b432e7818dc2806d-1730302178"
  },
  {
    "email":"cristinasciajno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578495354/cc650f6e5342579737c62881d9dd59ab-1730302178"
  },
  {
    "email":"chconsi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578462586/d204d4afc82eadb57edfab2baf5a937a-1730302178"
  },
  {
    "email":"mariadazzeo77@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578528122/2844d11d1e39be283b37bd3a986201c1-1730302178"
  },
  {
    "email":"giusi.cacciola3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578593658/fa08d2ee372bccd52401016f0393e9b6-1730302178"
  },
  {
    "email":"nicapicciariello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578626426/d4fbe31cb672eef242230ff96902cf03-1730302178"
  },
  {
    "email":"robertadaniele80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578659194/4da3a3f0053dc0342966d6bc94fe50d1-1730302178"
  },
  {
    "email":"schiavetti.ale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578790266/fd5cda6721fe1abd1ad5998015b0b62f-1730302178"
  },
  {
    "email":"barbaraorsi.net@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578724730/5e3424a8f630811d95ad26888390c4e2-1730302178"
  },
  {
    "email":"belluzza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578560890/186f507c7423a6186954c2d12e5581bf-1730302179"
  },
  {
    "email":"monicameacci@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578855802/d9987517311fe26c2a63364a3d0d0f62-1730302179"
  },
  {
    "email":"elisa.calvaresi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578921338/df15d9db4fae3fe58200ab690814e84d-1730302179"
  },
  {
    "email":"sara.boriani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723578888570/57a459217892bee204def48f268ab29a-1730302179"
  },
  {
    "email":"salvatore@vsimpiantielettrici.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578954106/342bbd8f4274b56d54536893620b3434-1730302179"
  },
  {
    "email":"daniela-graziano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723578986874/8fd578d59a1444b930e2ac7df8e0cd91-1730302179"
  },
  {
    "email":"luigimercadante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579052410/3ea439afd145a7dd6602173d4da75b93-1730302179"
  },
  {
    "email":"katia.salva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579085178/7296c4ea76233b64e52c1e3b6da9fce7-1730302179"
  },
  {
    "email":"mirela31@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579183482/160feba1e78fe15ba11a09eca13ffea1-1730302179"
  },
  {
    "email":"alina.stoica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579216250/e262fa594257cc9e3d4e5aa0e986a76b-1730302179"
  },
  {
    "email":"anto_magni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579019642/9a7600b872aa4f2a33be02eb4a080964-1730302179"
  },
  {
    "email":"raffaella.benetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579249018/cb44710c57a850e039c7d8b57deecd4d-1730302179"
  },
  {
    "email":"annavallesi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579314554/6823c6e537e52cc0d1ed6570baf150d2-1730302180"
  },
  {
    "email":"claudia.berti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579380090/74f40ed58b6a284ed5c7cab7f4db5c13-1730302180"
  },
  {
    "email":"thealeoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579412858/34b05fdd099739e883a1f5cad141942e-1730302180"
  },
  {
    "email":"simona-rossi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579478394/b59ea03cf2b4070a6943942d21f169ad-1730302180"
  },
  {
    "email":"barnum210696@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579347322/a675ea9d5ad4ce100afa0154e993e7e4-1730302180"
  },
  {
    "email":"gabriella.deangelis.stne@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579511162/5c82dd1f0bc8511b16f30b0be4717974-1730302180"
  },
  {
    "email":"cabeti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579543930/24eea19befcb4de0379d16fe76a65ee9-1730302180"
  },
  {
    "email":"mariellapiazza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579576698/8026c5352e1cb7d5b9f918f88b651f06-1730302180"
  },
  {
    "email":"ilaria@andreavalenti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579642234/2c2084aea8e050b1e18992c237d90a9e-1730302180"
  },
  {
    "email":"laura.marescotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723579707770/b4bfd4475ab1a919a052b08abd592f4a-1730302180"
  },
  {
    "email":"nicolettabassini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579740538/cf43b4854ae5d5f1acfe697e9a39a246-1730302180"
  },
  {
    "email":"romricc75221@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579773306/66e49b6a71f18c6048d19bf520a61207-1730302181"
  },
  {
    "email":"alesimosa@glail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579838842/a0b6b72d65aac26c7f5450de90d51839-1730302181"
  },
  {
    "email":"nnmazzone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579969914/582a59d177a178d1e315888bbefcb4a6-1730302181"
  },
  {
    "email":"ben.seget@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579904378/f97232bd70ea2270638301a2602e2478-1730302181"
  },
  {
    "email":"ellenica22@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580035450/74073730fbf7cacf3b6f464e73fffb25-1730302181"
  },
  {
    "email":"rossellastasolla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723579871610/e7b070b8fdebe8589154cf72d0db3249-1730302181"
  },
  {
    "email":"dottorfisio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580133754/a204667e58f893996eb9b951f0b516ba-1730302181"
  },
  {
    "email":"mariamart3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580166522/bbf515ff855b5612e80dc1a0f84d78bb-1730302181"
  },
  {
    "email":"955speed@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580264826/dee08d02876c8590dd37cfddfd3bce59-1730302182"
  },
  {
    "email":"silvia.citi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580068218/7fc11565c14e19b7e2a784a47de71d6d-1730302182"
  },
  {
    "email":"valentinalodi1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580199290/20224c9827d64c6731f18016fa7e1a7a-1730302182"
  },
  {
    "email":"orsinghers@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580297594/66885b6d5c3793b7f651fecb561e38d6-1730302182"
  },
  {
    "email":"immaiodice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580330362/3014dae31946427759ae63e4b3c4cc3e-1730302182"
  },
  {
    "email":"delgiudice.ant@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580232058/fb08374893736235896b1a1ac7aff6a6-1730302182"
  },
  {
    "email":"jlecapp77@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580363130/536dd574c237f6909c48c9a6e8d4b2a0-1730302182"
  },
  {
    "email":"san69ric@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580428666/83b1ef44c648ec4f166af375ebc7d507-1730302182"
  },
  {
    "email":"posta@danielamirandola.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580494202/ee09f564e70b4b6a82ff4d9264926fa4-1730302182"
  },
  {
    "email":"era.39@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580461434/3cc937e436c69922279a915babe2605d-1730302182"
  },
  {
    "email":"albertabagassi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580526970/ef79d46653b05c060d1d0e24b2d166c0-1730302183"
  },
  {
    "email":"pascalicaterina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580395898/3c6782a57806e3c24e2765426eaea22e-1730302183"
  },
  {
    "email":"ruggi61@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580625274/89e7495292bac13977e8d680eb652995-1730302183"
  },
  {
    "email":"graziaelianaaccardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580559738/c491880db34c296f4a9bf5c693816d37-1730302183"
  },
  {
    "email":"info@damademolizioni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580592506/047b62166f5f5eb20af1b6ffc85104d5-1730302183"
  },
  {
    "email":"graziagurrisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580658042/88c3f59e13b0922b319f66278f897476-1730302183"
  },
  {
    "email":"vitodleo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580789114/278b2d8549ec289c94d5578f7989ff4d-1730302183"
  },
  {
    "email":"kekkoo77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580723578/d60782cfdc53a73e079582171c928f58-1730302183"
  },
  {
    "email":"tassellimari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580690810/95bd72fb45056218060f6f596ac79797-1730302183"
  },
  {
    "email":"elena.dimascio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580821882/c0dfe2edf2ec1ce82433465f71ca0bae-1730302183"
  },
  {
    "email":"gabriellarizzo84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580985722/d8efbabfd35ae39d4234e5d7b370779c-1730302185"
  },
  {
    "email":"susannaiacoboni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723580887418/03ef6b41b2d1b61c45426994b2cc51b3-1730302185"
  },
  {
    "email":"anna.giustina@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723580952954/938d32348b9c1129a1c1ff9eebf795a7-1730302185"
  },
  {
    "email":"federicagallina75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581149562/fd113dcc775ce5938a0bb52336d6298d-1730302186"
  },
  {
    "email":"giuliatamburello06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581018490/2d311d5b38c1fb4c79367ba131bea9e3-1730302186"
  },
  {
    "email":"avvrobertapesci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581116794/3c0ae01fd25968e7747f7edc78bc5437-1730302186"
  },
  {
    "email":"marinabertoni2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581182330/9462621a78641cd478bbaa9f36256f02-1730302186"
  },
  {
    "email":"federico.anitori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581247866/e21a166b390b52d72dab646936e70c66-1730302186"
  },
  {
    "email":"crmr@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581215098/1abc2cc703182966c57aa434a622a14d-1730302186"
  },
  {
    "email":"carmela.pulice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581280634/a73afd77dc17e5132222d26b021819b7-1730302186"
  },
  {
    "email":"annazarrilli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581313402/7339121e07bcdae9928864a76887ecd9-1730302186"
  },
  {
    "email":"minbarbara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581346170/d4c0dd07a01f50c65c5c44a663907fb5-1730302186"
  },
  {
    "email":"danielamassetti3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581378938/bd5096a65b96f4be71bd0542757674a5-1730302186"
  },
  {
    "email":"vivianamanuela.russo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581411706/5ab32eb1db316bdf74945d4417651e4d-1730302186"
  },
  {
    "email":"r.lapilantos@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581444474/e3e24d34708703bd5758bbdbffe1dd5b-1730302186"
  },
  {
    "email":"agemmabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581542778/f5dacf1200aaeb852f1fbc05334153e9-1730302187"
  },
  {
    "email":"mariasilvestro08@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581608314/9ba7b1521dfcb7ce937e8fbca6e419fc-1730302187"
  },
  {
    "email":"ambra.orsi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581477242/43519752940fcbb66ef1ebeea280c313-1730302187"
  },
  {
    "email":"bonmari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581510010/3c2fc70ac68598bae0542da7fafd8a5d-1730302187"
  },
  {
    "email":"simona09@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581641082/14c0e0ced021c1410740eef1e05ae94e-1730302187"
  },
  {
    "email":"angelasilvia.petilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581673850/5b33fa4b5de4a54785638e634defee73-1730302187"
  },
  {
    "email":"g91084@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581739386/b89f1cf4b05958362d5bb4a6e3a95ef9-1730302187"
  },
  {
    "email":"studiogiuliano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581706618/85cd017549b5a0b4a1af8922054f301a-1730302187"
  },
  {
    "email":"stefanialopiparo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723581837690/456648a7400ab85981845338c3d88081-1730302187"
  },
  {
    "email":"ariannacoloni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581804922/8e900ed4734834d5e3917fb792d48534-1730302187"
  },
  {
    "email":"maryapaola90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581772154/bf78f95b9761c09bb12ea2c4c72039b1-1730302187"
  },
  {
    "email":"antonellaspina5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581870458/93c87a6b913de19540873a39e914090e-1730302187"
  },
  {
    "email":"elesappa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581903226/af14019a3243e854ee4ada0216125f3c-1730302188"
  },
  {
    "email":"francesca.27pace@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723581935994/bf87d8755ca76f17954905280bb2c803-1730302188"
  },
  {
    "email":"msdronio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582132602/4bbfd648156192a99fd57c3a19792d66-1730302188"
  },
  {
    "email":"gabiriarubini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582263674/6e4fc5ed1477669b0884442528a93540-1730302188"
  },
  {
    "email":"erika.francia82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582001530/923356d9fda0809f64e4325df4f01e45-1730302188"
  },
  {
    "email":"elena@elettricatma.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582230906/d535790818f8e89a4899490ee4a026fc-1730302188"
  },
  {
    "email":"giusysup@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582198138/c6ca0a24f2ddbc415cc3c1227b2826f7-1730302188"
  },
  {
    "email":"danielasabatini1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582296442/1502a239e08d3f47b240f5b30ad282d5-1730302188"
  },
  {
    "email":"anna.trevissoi@lamborghini.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582361978/5de17677c2cb0bdbe164ccf8481d472e-1730302188"
  },
  {
    "email":"cristinacarpinato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582329210/81092f4fddea696e0dd90a99f79cbc74-1730302189"
  },
  {
    "email":"irene.peruzzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582427514/95ba95b3ce84a61884ca0e4d320089ec-1730302189"
  },
  {
    "email":"orlanditiziana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582394746/7afe14e1ac6a31cd3a806fcbd089f05b-1730302189"
  },
  {
    "email":"francescaportulano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582525818/5b72cba41f976d0b4ee100716064cdd8-1730302189"
  },
  {
    "email":"avvrobertasardano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582558586/343a0ceb375aeb79668f7d530361977d-1730302189"
  },
  {
    "email":"ari.iacone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582591354/f5a07834e6a334cc79be9c84eea3e27d-1730302189"
  },
  {
    "email":"nociforov@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582624122/f9903101e6c3143f6745f63d4ad5995c-1730302189"
  },
  {
    "email":"cinzia_testardo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582656890/ec213a59b7823c18eeb3d91df51c58f7-1730302189"
  },
  {
    "email":"barbara.rodella83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582722426/b7d2dae7705ab46d253cc35e5e2552bb-1730302189"
  },
  {
    "email":"mia_serda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582755194/5e7b0755b05ca49b7b652c3402e29fdb-1730302189"
  },
  {
    "email":"estermaria.ferlisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582689658/44df275f41142279f0a2fcadce26b13f-1730302190"
  },
  {
    "email":"giusylag@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582820730/970d0344a0e41f1ec37dbc0936e3c51c-1730302190"
  },
  {
    "email":"procaccipatrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582787962/34322f15f6384b3757ddc8fe69a7b86f-1730302190"
  },
  {
    "email":"nicoletta.chessari01@universitadipavia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582919034/b82aaa151dac639568c7803a4b64118c-1730302190"
  },
  {
    "email":"mari-73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582853498/7a490ac5062111ad98b1eacd80a93c1f-1730302190"
  },
  {
    "email":"agm.stefi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582886266/a38cd10a285b3b6e07596f0dbc845b94-1730302190"
  },
  {
    "email":"manubellas@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723582951802/0c3980ff189fe8b877772d198b7b8aba-1730302190"
  },
  {
    "email":"angela.corgiat@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723582984570/78ffeaf518e52e99cc0f44316a164246-1730302191"
  },
  {
    "email":"giulia.tosti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583050106/b125216fca2e57c55d506e90d0a2a092-1730302191"
  },
  {
    "email":"moira@ilquadrifoglioimmobiliare.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583115642/91ec02607a5ee76d67e43d80598cf168-1730302191"
  },
  {
    "email":"tiziana.testini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723583181178/b0e36cc23d0d456f1a0f2bc77b444680-1730302191"
  },
  {
    "email":"erikarautnik@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583017338/eb6072783099108be241c5842580476f-1730302191"
  },
  {
    "email":"andriola.vita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583148410/af8982e28a0ec66ee729544d0cb65836-1730302191"
  },
  {
    "email":"emanuelabellizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583213946/642d855b4c577186e773c49b71541056-1730302191"
  },
  {
    "email":"lorena.xof@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583279482/38bc4c1978605a3c140812aeea891e33-1730302191"
  },
  {
    "email":"mmada63@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583312250/41b856271f262cbad9c226884ea5beb6-1730302191"
  },
  {
    "email":"avv.teresa.grauso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583410554/27d96211971dcb49ad17bce13538dee5-1730302191"
  },
  {
    "email":"raffipensa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583443322/d8d238e9ddf6c8dec182f054a32131cc-1730302192"
  },
  {
    "email":"aardisia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723583246714/d11b6b774d5c747dd47e9a9e75c9cd8e-1730302192"
  },
  {
    "email":"ferrifra75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583574394/822094f9cc00cf0d3bc171c3ef85e224-1730302192"
  },
  {
    "email":"robertarebellato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723583476090/fe13e3d534dd4e7899746a7fac3c4a25-1730302192"
  },
  {
    "email":"mariapia.dicuonzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583607162/e82a9e7f5a42620a574b09281d7777b6-1730302192"
  },
  {
    "email":"hanna.cramborn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583508858/87d7f12114865ab99441bec5ddb89d56-1730302192"
  },
  {
    "email":"elisa.tosi@terzaeta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583672698/db388ef1c967abfa0b99c05d4a5c778a-1730302192"
  },
  {
    "email":"silvia.quaglierini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583771002/17ae99b4043ccba64477ab15477bd158-1730302193"
  },
  {
    "email":"giulibusca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583869306/1953483cc9c25aee82ac1881210dab51-1730302193"
  },
  {
    "email":"e.mirandola77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583705466/08bfc40eef53a07edec44de14aef7755-1730302193"
  },
  {
    "email":"monicamalisia66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583902074/8f04f9adcd91d41bbb69efde0560d670-1730302193"
  },
  {
    "email":"menichellicaterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723583967610/694a897ec761400d53eef42ba721397a-1730302193"
  },
  {
    "email":"e.belicchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584000378/311df1f4ec9b8fec8f2a1edc4830a6ae-1730302193"
  },
  {
    "email":"francesca.bettosinigiusti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584033146/7e3454e91377371a5efaa6ae67950717-1730302193"
  },
  {
    "email":"marialuisamanzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584065914/eb087fb3ab45446e4a445b4cf074b641-1730302193"
  },
  {
    "email":"eliana@ondaligure.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723583803770/8c78fb43cfdcc43242e72a87c2153f8a-1730302193"
  },
  {
    "email":"mariarita.risoli@creditosportivo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584262522/559501f6e7433d02ffdb46b0063c6c2c-1730302194"
  },
  {
    "email":"desiree.diddi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584164218/b7cd5eea0ea0b6a8f7c1f3ce4fec35f3-1730302194"
  },
  {
    "email":"alessandraiodice@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584196986/4aab0edc91ebbc4082d806ee18ec9ecb-1730302194"
  },
  {
    "email":"larag0703@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584295290/ce95b5f55fcda3fc90ab1c3457e423e2-1730302194"
  },
  {
    "email":"lidgels28@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584229754/0fa1c7387b109b9726d6be36a1e96f9a-1730302194"
  },
  {
    "email":"colavecchiabarbara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584393594/edd98e7bbbb645724edbe0b8dec947cc-1730302194"
  },
  {
    "email":"venturini.valentina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584328058/ded80911ffa04afc863b41d1ecc8d27f-1730302194"
  },
  {
    "email":"dany965@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584491898/5346b515c95b4da6a04cfb177d5b5f1e-1730302194"
  },
  {
    "email":"diamanteblu66@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584524666/60e3e5b0d5e9092976a8b2dbcbc135ce-1730302195"
  },
  {
    "email":"annapolidoro@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584557434/bdf04cff27decf2c5413e6eae8252872-1730302195"
  },
  {
    "email":"vcicala@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584590202/061776baafe187f13600434970342e43-1730302195"
  },
  {
    "email":"moiraizzi29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584426362/58b4e572a5a0e78c2f825a8ef2b4cd8c-1730302195"
  },
  {
    "email":"vbelli68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584655738/63b010b0ba6c69e3d54513526ea4d9f9-1730302195"
  },
  {
    "email":"giovannaspagnoli69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584622970/504006545650d7d05c25038cee1871a6-1730302195"
  },
  {
    "email":"simonettct75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584721274/7b1628b4787fbcc6370a114bd73e8d90-1730302195"
  },
  {
    "email":"pilu65@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584754042/cf300e572e98f7df2a981a36200fbebc-1730302195"
  },
  {
    "email":"vio0la@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584786810/93d291df28425aea96d816440ceace30-1730302195"
  },
  {
    "email":"avv.annabellini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584885114/3b2b5fd82c728f36feda8d6d3765a407-1730302196"
  },
  {
    "email":"marymanco23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584819578/9faf19a472171ef1f53ec7017d3735d0-1730302196"
  },
  {
    "email":"consorti.alessio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584688506/3a3614064fb7a663da52323807f9a371-1730302196"
  },
  {
    "email":"lara.tivano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723584917882/f6db0a15fbd214a7d5710e083c2f6cda-1730302196"
  },
  {
    "email":"adriana.popa@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585016186/6cf8622517dba2cb5caa6a0e96b54ef0-1730302196"
  },
  {
    "email":"carlabellagamba@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723584983418/b4f053e300778c2636f5add7c5d9b6d0-1730302196"
  },
  {
    "email":"mosaico100@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585114490/84d7b037d0f3a90f2f94f8304befaa0d-1730302196"
  },
  {
    "email":"vivarelligiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585180026/279e3d2db139c46fd4e7d479e5e80da0-1730302196"
  },
  {
    "email":"linaria585@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585147258/7d639c2e01696a48201980475f951856-1730302196"
  },
  {
    "email":"agnesebennati@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585081722/2873a2e8af7c6c12509acd5577053c3b-1730302196"
  },
  {
    "email":"moky1177@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585245562/94c1afc5cc7ab8af2eb2147cfbfd8bd6-1730302197"
  },
  {
    "email":"saily.moya@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585311098/635134c01edec3fd518fb4b4075f5587-1730302197"
  },
  {
    "email":"sa.b@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585343866/1197aa22ff3f2b32bcfe95dd3d74a83b-1730302197"
  },
  {
    "email":"lilith7923@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585376634/4b024eaa1b9ddd9914e79810657ead2e-1730302197"
  },
  {
    "email":"lucarellamarianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585409402/5f93f69a5deffa66d3cc5bdfe6d12ac4-1730302197"
  },
  {
    "email":"camillacrespi42@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585540474/8ed7a3b957729d370f5e8c5bf7e0fa4c-1730302197"
  },
  {
    "email":"aldesina.mariani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585606010/f5c8dc7d662343559e372f2f14b04558-1730302197"
  },
  {
    "email":"valeria_bello@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585507706/fe8a2c82a091428c9e94d8cc45fe0d7a-1730302197"
  },
  {
    "email":"giuliapompa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585474938/45283b291d40c7b6271e78d50d8f05fe-1730302198"
  },
  {
    "email":"paolapala3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585704314/b37f0baf5df45928e87a925d9ccee3c4-1730302198"
  },
  {
    "email":"maraia79@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723585737082/758ea3af903c34f3451a08740f55c850-1730302198"
  },
  {
    "email":"donacal88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585802618/b7110c6d6ffe0dd485b72a135f60a5ab-1730302198"
  },
  {
    "email":"romina.bonjaku@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585671546/2a235510ef6784db65825cc9eed09f43-1730302198"
  },
  {
    "email":"sideco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585769850/bdd059f9165753039e9924617770d02e-1730302198"
  },
  {
    "email":"antelmigiulia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585868154/e20c147d2395934ae487b9b61a40f0ad-1730302198"
  },
  {
    "email":"familypolita@aliceposta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585900922/0d3307c37415b3d1e8ef43add5395dee-1730302198"
  },
  {
    "email":"zurzolop@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585835386/e9dd582a4aa79f8cfc2678053be554e8-1730302199"
  },
  {
    "email":"zardo.giorgio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585933690/51fb0c01e75d2f10ba55eeb2c548a367-1730302199"
  },
  {
    "email":"manu.santilli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723585966458/01f4bb3773d618e71306daf32b25e08a-1730302201"
  },
  {
    "email":"cristinaburato65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723585999226/03247437fa9934ababf568ae2e8e5734-1730302201"
  },
  {
    "email":"mariapaola2494@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586031994/71b52208ae2bec3807c1e47794383fd1-1730302201"
  },
  {
    "email":"rita.serafini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586064762/4ac3084aa49ca6b87a661faf687ea203-1730302201"
  },
  {
    "email":"ada.firulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586097530/aa209e579dd42202f0b3866f9752e8ea-1730302202"
  },
  {
    "email":"simonamattea@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586130298/85ed099b30f44f715153b5b8a9292eac-1730302202"
  },
  {
    "email":"ambrosioni.carl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586163066/d4814d14813ec460535a0ea7a8e85f0c-1730302202"
  },
  {
    "email":"marci.perone@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586228602/cf1cc9e9c51c15b7be5c950e51e0470f-1730302202"
  },
  {
    "email":"macieri.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586261370/6cf43e3ebbc13b3473cc5b1181d900ab-1730302202"
  },
  {
    "email":"lauraiacovelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586294138/95b38271c3687bbd1b3eb533d6920148-1730302202"
  },
  {
    "email":"lialion67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586326906/ff4bce09e828529ead1d5863d80313b4-1730302202"
  },
  {
    "email":"vendra61@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586359674/c6ba09a51694d668f086ae2470a1d6b7-1730302202"
  },
  {
    "email":"alessandra.ferli.17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586195834/08a58703ac54124848e807a71f792ea7-1730302202"
  },
  {
    "email":"marcoppanna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586392442/efaf33c74111f78fc058a26e2e2297b7-1730302202"
  },
  {
    "email":"mmorandi49@gmaul.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586457978/3bae7d30427ad48aadbc2e4c6b59acd7-1730302202"
  },
  {
    "email":"rossella@beauty-point.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586490746/3ea08d0569d371bd989a1c28c66d21e3-1730302203"
  },
  {
    "email":"elisa_andreoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586425210/b00cfa3961a985ab3f37e41d29d2be20-1730302203"
  },
  {
    "email":"alessandra@magicarautomobili.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586556282/4ac63ba23e7a4a55107dd92bb5bf0814-1730302203"
  },
  {
    "email":"olimpia62@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586523514/15074d3a5bd3c8575cee9b6c164ad8fa-1730302203"
  },
  {
    "email":"monacim@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586687354/288445fc11ae05a77638d8bdf7e70720-1730302203"
  },
  {
    "email":"ramona84.31@aliceposta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586621818/f5aeb8bfec59f96da6a5cecea60bab15-1730302203"
  },
  {
    "email":"zupparmello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586720122/08e455dfcb1f9880bb3387e50bfce594-1730302203"
  },
  {
    "email":"marianaaron68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586818426/fb5cc9a75b29bdd2d8c95525b36fa130-1730302203"
  },
  {
    "email":"clissadonatella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586851194/da92e91c5bce9a59fe3fb3efd0b0f883-1730302203"
  },
  {
    "email":"marinamariniello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723586752890/8a8246b3d7b4b981b2c129071c5b3147-1730302203"
  },
  {
    "email":"stellamarina71@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586916730/f9e6a30ab4ddc39fe8c326cb397d8992-1730302204"
  },
  {
    "email":"elisavolumi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586949498/c106e174a19d5d764a02f4cd0ef8e295-1730302204"
  },
  {
    "email":"viktoriyakoltsyuk@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587015034/1c3ad31fbb9663a511280296c1cbbb46-1730302204"
  },
  {
    "email":"lauratosi80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586982266/b80ca98481158a61e7c5d4c3e6febfc2-1730302204"
  },
  {
    "email":"angilla01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587047802/96860a8619af28886ea38adc4cb14602-1730302204"
  },
  {
    "email":"marikamas@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723586883962/4847f723a0639b0ebc20d4cc832c1e8d-1730302204"
  },
  {
    "email":"pacettialessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587178874/814bf6742b4ca91e8b802e2bc74e2c9a-1730302204"
  },
  {
    "email":"aleconsu@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587146106/9058ad926a159c6a30244737f72e5e83-1730302204"
  },
  {
    "email":"parodimonica08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587113338/ef60d46a6d323bd51c7c459f9e38d4e5-1730302205"
  },
  {
    "email":"nadine.graubardt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587211642/106584d8f0608dbae0a2040bb475ef77-1730302205"
  },
  {
    "email":"perdigaoana7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587309946/868bc2f375a38e1be54c27e14d8610f2-1730302205"
  },
  {
    "email":"ilabocci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587277178/2723ae550e3bbe3b962eccebf2df63d5-1730302205"
  },
  {
    "email":"daniela.partini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587342714/a418b304bf7a0795eb93f01565abfbca-1730302205"
  },
  {
    "email":"buselli.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587375482/1829daac9cea83395772c1dd0ece57db-1730302205"
  },
  {
    "email":"rosyline7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587441018/cce42f3be7f3f088a9f913774de46e43-1730302205"
  },
  {
    "email":"marinellap70@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587408250/2c0ec6cfa76447ceeb5da8ee9a945ddb-1730302205"
  },
  {
    "email":"giuseppe@creonet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587473786/58a792b161a3a0f4bb1a4edcba1d81c5-1730302205"
  },
  {
    "email":"cmarzi_r@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587506554/3901cad05cea04efff6093e0ed2353ca-1730302205"
  },
  {
    "email":"capleand@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587539322/9ab2df26dd2563cb3fc20ccbcf375395-1730302205"
  },
  {
    "email":"viadana.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587572090/9225a01d8ef84a1dde23a8c8f0a29673-1730302205"
  },
  {
    "email":"stsala86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587637626/d95e2761638047388abc2b4c9b31da46-1730302205"
  },
  {
    "email":"letizia.minetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587768698/f1c74c90bbdcf82b45a1dca9b972c07f-1730302206"
  },
  {
    "email":"antinorifrancesca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587834234/7c0d04ce088255859977f0a22d8c74f9-1730302206"
  },
  {
    "email":"varetto.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587801466/6eaf7e932de68344688d30a9117ff1be-1730302206"
  },
  {
    "email":"eleonorazagolin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587867002/ceee5a565850d9e40bfa2ac8d7f1ba5c-1730302206"
  },
  {
    "email":"lolly30maggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587899770/3698a30991026124225ea88b65391576-1730302206"
  },
  {
    "email":"elisabetta_filippi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587932538/a61d1942183f2dac904e48ecfe0bd11c-1730302206"
  },
  {
    "email":"licia76f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588030842/807dca281f5745a2bafaf890b7e5745f-1730302206"
  },
  {
    "email":"mfrancescamaida@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723587965306/6088eedb6ff2657748f482cb9152305e-1730302206"
  },
  {
    "email":"alessase@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723587998074/e8683aa05a1d0cca9b695606c6d27599-1730302206"
  },
  {
    "email":"graziaampisio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588063610/d92940821c4fc3bf554f70df8c494c23-1730302206"
  },
  {
    "email":"amm@isotta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588096378/1f4628dbd7408d0c30eb083fe7b73865-1730302207"
  },
  {
    "email":"morangio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588194682/b5266dbaf78eed6a072e85fd73a94f54-1730302207"
  },
  {
    "email":"adele.gnisci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588260218/baa4b689c8ef64f19a78ab908cacfb95-1730302207"
  },
  {
    "email":"ea29@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588227450/00344ecee29f9dbe46a2e9491f178c99-1730302207"
  },
  {
    "email":"rossella.buizza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588292986/dc94d3b57acf7c2bf4a9af773cb1e504-1730302207"
  },
  {
    "email":"veronicapiccione437@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588129146/826ad5f5ef3de74eb30643c0848e814f-1730302207"
  },
  {
    "email":"fabia.digiandomenico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588358522/3fc8764179f7b21ae88bf8bdc5926600-1730302208"
  },
  {
    "email":"barbaramarcomin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588424058/01f19e151a6bb74a74f8b4681bd8cf29-1730302208"
  },
  {
    "email":"mmmonika@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588391290/e76a94917f84d1a6df09eb266df85a38-1730302208"
  },
  {
    "email":"pieraschiavone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588325754/7db7c77d18f44e5e1d503b5cf51bea54-1730302208"
  },
  {
    "email":"annalisa.pradella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588522362/e7e5971e745fbc5d1d161e39bb026c52-1730302208"
  },
  {
    "email":"ternieva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588456826/63f9b1ee79e325042c6b511b68266890-1730302208"
  },
  {
    "email":"tsygankovamarina@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588489594/b2bff19110b1e06316fcebc101935331-1730302208"
  },
  {
    "email":"valeria.caprioli87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588653434/2bc1a5a192057ba1cf7741c8cdadc490-1730302209"
  },
  {
    "email":"missmondo@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723588620666/c060060dc412671d606c557ad66d0a74-1730302209"
  },
  {
    "email":"vale.tina1989@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588718970/e578d56a313af1722df890f62e46cef9-1730302209"
  },
  {
    "email":"29.moncler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588587898/2b1205eed5f6ff2c5a5e170760e77bed-1730302209"
  },
  {
    "email":"valeriaiozzia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588555130/32a05c99f9e5addc4b371f9cd559a46a-1730302209"
  },
  {
    "email":"dianagiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588751738/899d4ade6c86c564f1e727c1e9314969-1730302209"
  },
  {
    "email":"mara.furio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588784506/7950475bb432591335fc2e9f84afddca-1730302209"
  },
  {
    "email":"virginiarito@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588817274/3999cf01a3630472e5520144c86202f1-1730302209"
  },
  {
    "email":"paola.brunella@studiotodini-brunella.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588850042/8366a831cb88e20d757acb7c3f6dc23d-1730302209"
  },
  {
    "email":"simonetta.lazzari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723588915578/b994c175cb66cec3ed13ae762d143352-1730302209"
  },
  {
    "email":"tosiorietta12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588948346/185eefa81dc1010842ae224a8ec26d33-1730302210"
  },
  {
    "email":"scandurajosephine@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589046650/232d9f34e45da7452adbf0219d8f5402-1730302210"
  },
  {
    "email":"michelacontini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589079418/f5cc0bec06150fe8d4c936a718ccf561-1730302210"
  },
  {
    "email":"rino.penzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589112186/688c5b2aeac295a971f76733c1b2c299-1730302210"
  },
  {
    "email":"elevannicci@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589144954/b602a5bf7d0af1a047ef61635b8b8b82-1730302210"
  },
  {
    "email":"ilezank@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723588882810/d5e554d115d59d793652477287c8b8be-1730302210"
  },
  {
    "email":"moniscia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589210490/f917d5b16f827e2071c8c5e087b72b4f-1730302210"
  },
  {
    "email":"cactyves@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589243258/14f37429bef961059b1ae84ca2b164ed-1730302210"
  },
  {
    "email":"vcelesia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589308794/3f8b88de26feca075924cb846b23a82f-1730302210"
  },
  {
    "email":"shopping101678@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589276026/2fa85aba560dbbbe9ba61d1e3a4f274e-1730302210"
  },
  {
    "email":"patriziapanico57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589374330/ec09921530b9055ee6c83f63e83ef179-1730302210"
  },
  {
    "email":"plfarinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589341562/7120dd11935902dcc98cb09a68073002-1730302211"
  },
  {
    "email":"ffchicca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589472634/52f66b2521895ac56972833788373267-1730302211"
  },
  {
    "email":"di.lorenzo.debora8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589439866/7bac27052f55c9048c0950a0faa9c357-1730302211"
  },
  {
    "email":"bagiottim@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589505402/32de23ef19c1a84e197646427b617ba7-1730302211"
  },
  {
    "email":"casa.giraffa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589538170/5f49971aacdf5e6335a5eb8e7d6efac3-1730302211"
  },
  {
    "email":"p_emanuela81@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589669242/fe81db4015303da1813b788e2fcd88dc-1730302211"
  },
  {
    "email":"mochielisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589702010/f18a9013157119f970b43eb8762e6a95-1730302211"
  },
  {
    "email":"madmilani@yahoo.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22723589570938/e822eeed9b53c19e30cb32ed54796db5-1730302211"
  },
  {
    "email":"ilanepal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589603706/afc113307d8f8610a8099f1ed04b58fd-1730302211"
  },
  {
    "email":"luca.moratto1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589767546/28309dd1e809ed72702a79babfccb836-1730302211"
  },
  {
    "email":"passalacqua.anna70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589734778/187c88a90eebcf9352b9dec6ae1f5985-1730302212"
  },
  {
    "email":"emanuela-mariotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589833082/c599ce911a873048b6b4f9f9e61bc2bb-1730302212"
  },
  {
    "email":"mariacrigiannini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589865850/28715040077c52411fcada9857941639-1730302212"
  },
  {
    "email":"p.montini@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589898618/f8085be20a444a5d8d3a5266d64e291d-1730302212"
  },
  {
    "email":"maria.labruna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589800314/12ee956638b4d4e6dbc8d0c7b34e9ecb-1730302212"
  },
  {
    "email":"ilenia_aliotta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723589931386/25549dc656ff76874ee0c0550608a21b-1730302212"
  },
  {
    "email":"soavelaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589964154/8ecc22ee9273091848bef1c4d4b2ff9c-1730302212"
  },
  {
    "email":"lovatoveronica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723589996922/f132b9a803663ea14652f036c324dbdd-1730302212"
  },
  {
    "email":"victoriasergi0101@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590062458/3807f328edc611b864b2dd01d6466a94-1730302212"
  },
  {
    "email":"chiani.valeria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590095226/c911fb8dbb0c3e7ea027141d00cd79a8-1730302212"
  },
  {
    "email":"antonellaraganati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590127994/88703b1d7c0d1352af15d42e4339b87b-1730302212"
  },
  {
    "email":"robbi_zan@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590193530/0aca4b8dbf449357994d36c1d900127d-1730302213"
  },
  {
    "email":"barionfrancesca@hotmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723590160762/5c737faf6e0711c8d574b8250d5c03d4-1730302213"
  },
  {
    "email":"giorgia.gridelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590029690/3ece46927404053aefba87ae5406c94d-1730302213"
  },
  {
    "email":"caterinafrosali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590357370/647180be04ca1c78cb882de28a0db3fe-1730302213"
  },
  {
    "email":"stefano.mandorino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590455674/a0c578b4bb80eb3ca95661ead4ffa583-1730302213"
  },
  {
    "email":"emauro62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590390138/9cc12c06384f75ce3e3cbc1dfa6d24da-1730302213"
  },
  {
    "email":"anna.bendazzoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590488442/9eee525c4783955a3ea1c47707fa918c-1730302213"
  },
  {
    "email":"ciacarzedda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590226298/cc25f71fa9997b32654162a056f4f0b5-1730302213"
  },
  {
    "email":"carla_nicola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590521210/6074c4d7ddc1e0d088a96853acda20c0-1730302213"
  },
  {
    "email":"francescamangano58@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590553978/858af88cf8fceb05a06d701b922e5e44-1730302214"
  },
  {
    "email":"irenecappellano5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590685050/7753dc63e6f5412369c7527333ea0935-1730302215"
  },
  {
    "email":"chiaralocatelli77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590717818/8b477bfcdac87742774cd206391ccb08-1730302215"
  },
  {
    "email":"silvia.fabbri77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590586746/c0246e7d0f2b77a83707bba7dca72bfd-1730302215"
  },
  {
    "email":"ermycapodicasa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590652282/483e24d9418e192d041287202b5b7702-1730302215"
  },
  {
    "email":"soavelaura7@gmal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590816122/2529c4ec9fe3ae738870886a817f72e8-1730302216"
  },
  {
    "email":"lauracinanni75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590881658/4fff3a571b7dc40c3d5e1020897ffdb4-1730302216"
  },
  {
    "email":"binisilvia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590914426/dcd5e322400812e1698fba38e0b42314-1730302216"
  },
  {
    "email":"moca.falsone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723590947194/f6e0332ff987e28696082e8cd18cf928-1730302216"
  },
  {
    "email":"marzia2405@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591045498/4f402f047bc2ab7ae44e72970e79b4fd-1730302216"
  },
  {
    "email":"serenacaioni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591012730/4db09da9525e2e07eab0aeb35c3f4939-1730302216"
  },
  {
    "email":"rosella_rusconi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591143802/4d19b8c0ee02744cb20ae704f3dee72e-1730302216"
  },
  {
    "email":"ariannafish@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723590750586/d94f3196b7e6fdf430152b34ad9be984-1730302216"
  },
  {
    "email":"sabrina.buttafoco1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591078266/d42489bb6b27bb06b0e3931eedad4e71-1730302217"
  },
  {
    "email":"monicasangiorgi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591242106/b5d7b4b8ec6cce8a7cf877d15dc36506-1730302217"
  },
  {
    "email":"mari251079@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591176570/cef5b96433a81bd95f1f7c15b7511655-1730302217"
  },
  {
    "email":"guendalina.guarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591209338/1802fcf31c657a4e1d26435d2f1538aa-1730302217"
  },
  {
    "email":"mariagraziasapia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591405946/a8b0d899d4b8317e14ce0315ac514030-1730302217"
  },
  {
    "email":"roby68682010@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591373178/63f080da3797d67e58adb4db90330110-1730302217"
  },
  {
    "email":"angela.facciolla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591471482/fde925d6b4f83090803352e4aaf58fc4-1730302217"
  },
  {
    "email":"manuelamgl@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591340410/f005c3dc3733172809a1ff5b9e722799-1730302217"
  },
  {
    "email":"lorenamaltese@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591438714/23460c51a32de872ce4b5111b7930e1c-1730302218"
  },
  {
    "email":"mariarosariapiperata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591537018/553664aec21b180f118ed27bc053514b-1730302218"
  },
  {
    "email":"boni55@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591602554/bc246ea8fa84cc005bee685ced6f6e38-1730302218"
  },
  {
    "email":"paolapieroni73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591635322/f4c68a684b79e283fc8ce21704ae8712-1730302218"
  },
  {
    "email":"luisabertuzzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591700858/5ec693a9c2593a801f9cf0961b6a03ca-1730302218"
  },
  {
    "email":"c.beltrame08@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591668090/468b054bafe583d984aa231e6af6b615-1730302218"
  },
  {
    "email":"ritacio13@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591733626/c9ac4adbdcc0e27c3e4886a431dbe550-1730302218"
  },
  {
    "email":"raffabale@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591766394/3c5d7cb83fbbca4dd27987c14bdce049-1730302218"
  },
  {
    "email":"damianisilvia09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591799162/8cb3a8005519b16d527d862b2944b1fe-1730302218"
  },
  {
    "email":"bavotapatrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591864698/1380fc9fc0ad2796e85495cbca9e4d68-1730302218"
  },
  {
    "email":"elena.amgonese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591897466/309a5e87d8999b7f703f979a4fc961a5-1730302218"
  },
  {
    "email":"natascia.sgaravato@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723591930234/3b9f2984faa0ad35a5776786ed76d9c2-1730302218"
  },
  {
    "email":"nadiafabbrin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592126842/394e7e0451c5ba0420d1dab922655d0c-1730302219"
  },
  {
    "email":"annaconti.26@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592094074/0f3f2ef40c12070c8e3aa24420933b19-1730302219"
  },
  {
    "email":"belinda2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723591963002/5b4e0cfa1df225c506dcbf33e3044978-1730302219"
  },
  {
    "email":"grelli.giovi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592159610/18a726ef20871ed9d9a1192315cab9a0-1730302219"
  },
  {
    "email":"samu8@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592028538/d71cad539430eb453bab53c233a54f7e-1730302219"
  },
  {
    "email":"dellaroccae@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592192378/f32c25c2f4f74426304f33677f4befe6-1730302219"
  },
  {
    "email":"bibi.biscotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592225146/93407f8966a6c6c9671c5f2400f9a0ba-1730302219"
  },
  {
    "email":"lorena.picco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592257914/dc3ce886f70fbdeb7a47e038ec1a7652-1730302219"
  },
  {
    "email":"giulia.stefanellibechini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592323450/4631d23e845a0ffac8b36819933caff5-1730302219"
  },
  {
    "email":"sandra.cargnello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592356218/e5ada7ec9126013647eaa14937599c17-1730302219"
  },
  {
    "email":"ilariaventre@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592421754/2e4a5e9a4936668a24d17a74aef18e67-1730302220"
  },
  {
    "email":"lucianakim@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592520058/afe1c3aa9e8d890c0ebaa062a9b65442-1730302220"
  },
  {
    "email":"natascia.tomaello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592388986/669bd669458580e2279f1eded030f567-1730302220"
  },
  {
    "email":"fernandasacchi57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592487290/989dc4d7e26e24745184c855384f0d9c-1730302220"
  },
  {
    "email":"mmlavini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592585594/2e225a70d49605f276918a571121c4ac-1730302220"
  },
  {
    "email":"roberta.cicala@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723592454522/ac554c2fff3a0136f15ff1b33167c719-1730302220"
  },
  {
    "email":"silviapilosu.sassari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592618362/ab0f6fa8217f66327efaae78fa0e36ac-1730302220"
  },
  {
    "email":"agnesedelpo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592683898/7a91753bcc892610d710bec18c654371-1730302221"
  },
  {
    "email":"elena.talassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592716666/86826be5a3f5b1805d1eebc0102cb132-1730302221"
  },
  {
    "email":"s.antonia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592651130/4349dd80a1a4ca7cbf4a8a56ea27f844-1730302221"
  },
  {
    "email":"gagliosa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723592782202/6f78e7e11fd18b2dd2f778d335b47526-1730302221"
  },
  {
    "email":"letizia.corbari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592847738/4d8400afe196ed90eaf59deb25115bad-1730302221"
  },
  {
    "email":"alessiagioia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592913274/2854b9cc55ebdd3cbefbe16442264b3f-1730302221"
  },
  {
    "email":"rosanna.irato@katamail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592946042/839f34971d72aa57974316bca137c069-1730302221"
  },
  {
    "email":"olgaburlea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593011578/bf5d7ffe7dd3c0c74b7633caeb0f3325-1730302221"
  },
  {
    "email":"b.lorenzo78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593077114/b3b95179b124820f8a69b6ed1a358915-1730302221"
  },
  {
    "email":"polimara@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593175418/392e1916967845d64c83553c9ef7427b-1730302221"
  },
  {
    "email":"s.crucitti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593240954/d5445ca8115cfb9ad061c6bfeef94c8b-1730302222"
  },
  {
    "email":"c.chiara79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723592978810/07813177fc782b1d4483f46a2ca92f16-1730302222"
  },
  {
    "email":"bigvalley@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593142650/12218f4f02db6c8617506fd365d5cb5a-1730302222"
  },
  {
    "email":"faccettabuffa76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593306490/6b9c24e5dab25c53612dc3095c32b06c-1730302222"
  },
  {
    "email":"devilspdm@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593273722/e887f6ef2cbfbab8e2989210846a765f-1730302222"
  },
  {
    "email":"conci.puccio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593339258/07336e0f680f34a5fd683b94dfb82bf9-1730302222"
  },
  {
    "email":"ilenia.rota@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593372026/9589689dacdc032ee1bff643efc67909-1730302222"
  },
  {
    "email":"ele.campisi82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593404794/9f5d081a6e31cd95b7fb09bd1fa29811-1730302222"
  },
  {
    "email":"silvia.hotz@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593503098/38915200edd5afda03c3fc690f690bb8-1730302222"
  },
  {
    "email":"eliana.perrucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593535866/8e21c16876a4d4d630b1783d348612ea-1730302222"
  },
  {
    "email":"aurelio.forte@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593601402/d2e20a5cfe368e6f7a8e77fbd40d3f21-1730302223"
  },
  {
    "email":"cin.zorzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593437562/b9ab48016de77a702dfec5de8532dca9-1730302223"
  },
  {
    "email":"isabellastellina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593666938/61998e94ce221a317b1326cc87c150c1-1730302223"
  },
  {
    "email":"cristina.gambato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593634170/82f7a990892b8f8caec534ed46c70161-1730302223"
  },
  {
    "email":"barbara.predonzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593765242/1c8179b18ec0abfae53b2f8652ed9448-1730302223"
  },
  {
    "email":"giudi.guenci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593798010/702e37f44377a6f74b897c1deecd4616-1730302223"
  },
  {
    "email":"tkatuscia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593830778/8a8b606dcba1ebe4e46a6d4bef3f8867-1730302223"
  },
  {
    "email":"anna_pisani1@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593699706/89f430a1f37a1553ce7063d8cac076d5-1730302223"
  },
  {
    "email":"carlapecoraro79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593929082/ea7bf578feefa077c649bd8f66aeceb7-1730302223"
  },
  {
    "email":"chiara.bruttini1304@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723593994618/52fcc48c2cb1afaffc8d2ab4b909a6ae-1730302223"
  },
  {
    "email":"feliciam.cozzolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594027386/bd00fb3eac6dc83101236dc73a06dd40-1730302223"
  },
  {
    "email":"faelliveronica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723593863546/2efd6db24550f03810c2ae1f88c0afb2-1730302224"
  },
  {
    "email":"tcallipari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594125690/1a20dd8755b622a0f2185d2104ac53d0-1730302224"
  },
  {
    "email":"info@valeriaforte.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594060154/68adcef97f0e9af824e9ae5046f3e5b1-1730302224"
  },
  {
    "email":"linda.dalmaso@unife.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594092922/1a11478e0b900ef8dc198e2800894cad-1730302224"
  },
  {
    "email":"cristinamazza@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594191226/4bef69c89a3dc44e5b4fe89782d4b31c-1730302224"
  },
  {
    "email":"pegorarograzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594223994/1227c942e149a65d8a69dac5c4c9d7ab-1730302224"
  },
  {
    "email":"angelafronterre1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594322298/a981ba5f5a6ab84a634d2bd8982f1be8-1730302224"
  },
  {
    "email":"135ciccio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594158458/983c8e85d2dc8b14aeefcab18d5c89ad-1730302224"
  },
  {
    "email":"frederic.bonjour2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594355066/7b564d61c3a99cf53009fbbc0ee8d8ac-1730302225"
  },
  {
    "email":"grames20@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594387834/cca14e587b3383a874d58bf5952f940c-1730302225"
  },
  {
    "email":"alessiavigorelli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594289530/2228a56c6cdae34226e239c42d3314da-1730302225"
  },
  {
    "email":"valeria.verde@unicampania.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594453370/ad8e27a2c5c30eadfac80e2d65073c84-1730302225"
  },
  {
    "email":"bellanterosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594486138/69234a1823d42f6437b0be759168b519-1730302225"
  },
  {
    "email":"boudoirboutique@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594420602/f065e8387b6f74dc11776c240daf8418-1730302225"
  },
  {
    "email":"martina_carzoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594584442/62a1d9f5ce43d6bd64ff32138ab94ba7-1730302225"
  },
  {
    "email":"villa75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594551674/2b9c271844a189d2e92957ee69e3c5c0-1730302225"
  },
  {
    "email":"s.malpassi2002@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594518906/6a2fdf5af88dc5aad2c683636a9669e4-1730302225"
  },
  {
    "email":"monikamora@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594617210/e2fe3bd60e76c3dc93949182a1aac7cf-1730302225"
  },
  {
    "email":"mena.dgr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594715514/dfa197e0870598d62119e48cd1a25dfc-1730302226"
  },
  {
    "email":"claudiacosta503@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594781050/af844734cabdd80e5fc8e017f531f821-1730302226"
  },
  {
    "email":"miriamcorsini74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594813818/e9e1bcb9d8e4f9a96009711a88c72fd0-1730302226"
  },
  {
    "email":"florisahtl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594649978/ffc06f25c2f1ea2db62015c8f5e47c03-1730302226"
  },
  {
    "email":"vanessa962009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594748282/dff51c5073410ba8841a30e9eb05f6ff-1730302226"
  },
  {
    "email":"francescarosa71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594912122/8d6360e3ec2bd9a35c6d36e0f5fae69b-1730302226"
  },
  {
    "email":"ghilopa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723594944890/97a73c00112d4ee46c5b0b1977911f4d-1730302226"
  },
  {
    "email":"simona.breschi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594846586/bafc2ce4915631ed20128ac7f8765dcc-1730302227"
  },
  {
    "email":"silvia.meregalli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594879354/56c6ad610c6d3928c0ba7ebadd5749be-1730302227"
  },
  {
    "email":"tanyarusso01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595010426/8c70a5eb27706c1f7cb4174fad0482bc-1730302227"
  },
  {
    "email":"giovanni.tezza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723594977658/8107eb06971d73c79e0307be900f6397-1730302227"
  },
  {
    "email":"eleonora21tv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595043194/4dd3d8bf00a2f5b9e4c940862e39292b-1730302227"
  },
  {
    "email":"sabrinarsm@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595075962/38e1f4cf7fd82b4a469e6afa1418e930-1730302227"
  },
  {
    "email":"idea.lo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595108730/9963241676445fdd14ac199e96c2f26e-1730302227"
  },
  {
    "email":"carolina.leggieri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595141498/8c7a644db80d9b0161a8965c8d8f7600-1730302227"
  },
  {
    "email":"sabrina.buttafoco@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595272570/a2ec9d3aa21f89ae458e51b9f03ce109-1730302227"
  },
  {
    "email":"simona.genga@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595370874/db82467290b6534fae5a47b24e9e1fab-1730302227"
  },
  {
    "email":"danalore.css@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595403642/0cee3289d9e6c33266d250133f59af54-1730302227"
  },
  {
    "email":"gemmaka@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595534714/6e0066b7dbabd763cb2313c17e470813-1730302228"
  },
  {
    "email":"fra_male@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595174266/a94116ff17ad7da5e68c3af767c42f09-1730302228"
  },
  {
    "email":"sarapantano@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595600250/cd0fc5ce4206be44441d048c7ec5ac99-1730302228"
  },
  {
    "email":"gusvania@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595567482/9de0c873f6864f88e27156e249476de2-1730302228"
  },
  {
    "email":"noemi.gobbi2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595633018/057652cb435c622902eb2ecd4a939070-1730302228"
  },
  {
    "email":"beatrice.boccia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595665786/fea1dafa3cd8cb525fcd9a500667c0ba-1730302230"
  },
  {
    "email":"mluisa.porcu@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595731322/50c9c07a33739a700910f9eff60973b6-1730302230"
  },
  {
    "email":"stancarialice@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595829626/ba5752da87df408dbd2f532bfd754dd8-1730302230"
  },
  {
    "email":"luisa.orlando@mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595764090/33f0d7feb9826d035148e4ca4e4feae1-1730302230"
  },
  {
    "email":"arch.tozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595862394/de525c8ca00a8efdde5c7ccf96e4d326-1730302230"
  },
  {
    "email":"fabrizio.delazzari@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595698554/f5ebed17eb9dec1d9cfcbbf07af4d533-1730302230"
  },
  {
    "email":"n.pellizzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595895162/5b0a302d57bdf081e5ffd693b3eaeb18-1730302230"
  },
  {
    "email":"bordinemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596026234/cedf3308785a9710b8fe233a15b44ed6-1730302231"
  },
  {
    "email":"lorenapennacchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723595993466/bdfe401ff8adfdec6a8ba8b22a74891a-1730302231"
  },
  {
    "email":"aniuska.startari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596091770/729271b56ff586e077d3f8b58a7cf518-1730302231"
  },
  {
    "email":"m_viotto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723595960698/3139905d6727222877888f1eab96decf-1730302231"
  },
  {
    "email":"latuasailormoon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596124538/d644b9d01a82675dcc12bc99e6926aa1-1730302231"
  },
  {
    "email":"dp_francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596157306/2d94c68bb81bbabc0e03dcf0374a443b-1730302231"
  },
  {
    "email":"beatrice.titti1907@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596222842/ca6f6990175d6d139e375b313550016a-1730302231"
  },
  {
    "email":"ross.santarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596321146/850fe553dacc9de10b926c573aabaae7-1730302231"
  },
  {
    "email":"antonellalaporta1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596353914/c420a3cc39b57b82ad24392a14c33a10-1730302231"
  },
  {
    "email":"valebonty89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596190074/04df32eb8f57e64f90f2922c49af5d5f-1730302231"
  },
  {
    "email":"rossella_laduca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596386682/fcac57bb4910d29bb958d22a4a126e0b-1730302231"
  },
  {
    "email":"paola@divitoluceassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596419450/ebf1449e3e8dc30509eaf5e251dfca71-1730302232"
  },
  {
    "email":"valentina.meloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596452218/b1efbd864d51941c2c52048d90cb694a-1730302232"
  },
  {
    "email":"cincoz74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596550522/b1e3ab88428f18ef5cabefef046992f1-1730302232"
  },
  {
    "email":"arch.francescasavarese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596517754/ae65fd1d961d0d1eb8a250dfcf0969ce-1730302232"
  },
  {
    "email":"s.gresta.sg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596648826/8de1530269d8c73227a5c2d54925722c-1730302232"
  },
  {
    "email":"ugoliniv@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596747130/19c0a699597518127a6f4ae727d6b146-1730302232"
  },
  {
    "email":"sofia.zanovello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596845434/2b7051c5588a65435ef54e50ea9a46a3-1730302232"
  },
  {
    "email":"alechop@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596714362/8514f0d49c1591e9d386c82eb6a74728-1730302232"
  },
  {
    "email":"laura442@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723596878202/1f847186daf6a2b6dd21cbab41bdfb35-1730302233"
  },
  {
    "email":"karin.suen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596812666/f92bf65c851e3200aff116a2aab0779c-1730302233"
  },
  {
    "email":"nella@euroconsul.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596943738/3eb3a433c708f66e331ed9429512c004-1730302233"
  },
  {
    "email":"serena.eufemi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596976506/e75276a5d31fca24145a9327eaa1ebd5-1730302233"
  },
  {
    "email":"saravannucci3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597009274/0d923f26bfa6d7858bac6e83c8996511-1730302233"
  },
  {
    "email":"miriam.tds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723596910970/5aeb41aeadc6a5c57e6901f4b6e5d4ae-1730302233"
  },
  {
    "email":"rosina.nicastro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597173114/8a930f2f88b06cbdfdd7e39af7c1518b-1730302233"
  },
  {
    "email":"enrica.palomba@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597205882/30608a06afe812edf76fbf9d5e74bd39-1730302233"
  },
  {
    "email":"zampierimariangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597238650/a81225e1a059907b45516f11d57b89bb-1730302233"
  },
  {
    "email":"mbisettotrevisin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597271418/69832f579deb8ab5d3ad51d0e9a07144-1730302233"
  },
  {
    "email":"daniela.grimandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597107578/084fa6ed0315566bc19603e184d724c8-1730302233"
  },
  {
    "email":"giove8016@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597336954/aeb0007e9d2f170c43d5fa55f1d9aa1d-1730302234"
  },
  {
    "email":"pezzolicristina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597304186/27254ede7c36ca983a4f54bf9ddf48f6-1730302234"
  },
  {
    "email":"cristina.parazzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597402490/85484f07c74da37c9ef0d91ea06b6faf-1730302234"
  },
  {
    "email":"dosifederica94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597468026/7190ed58fb9f46f32cdc9cc5752d3dc1-1730302234"
  },
  {
    "email":"paola.orsi3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597435258/cfd0dfd5bd31961ba3d88956b531ca1e-1730302234"
  },
  {
    "email":"tironcik83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597369722/7b42de4fb8b4bc04887c5773abea6684-1730302234"
  },
  {
    "email":"b-silvia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597631866/1de2a5c0f0dcdfe0c4dfb226353da11d-1730302234"
  },
  {
    "email":"pepita8888@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597533562/6b4ef716a7e8a8b90a14463d4b872be0-1730302235"
  },
  {
    "email":"fabianamerico@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597697402/db21598d241ab889ded20d423a1c05a7-1730302235"
  },
  {
    "email":"studiomillimaggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597762938/90abdfde4a0c73e723415c22a2ed705a-1730302235"
  },
  {
    "email":"danielamongioi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597599098/3906731c68e196e53ccc8a99fb27094c-1730302235"
  },
  {
    "email":"info@g-co.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597828474/e921f9203fe15ab3165a25d9979927b0-1730302235"
  },
  {
    "email":"denv68@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597861242/6b8ca1a17f4a6e71b41e13aabe02abc3-1730302235"
  },
  {
    "email":"lieselot_germonprez@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723597926778/cd0a7045ba84c0a4943129d64494ed30-1730302235"
  },
  {
    "email":"barbara.traversone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597992314/84443811a3636eb7862b6560ee4930c1-1730302235"
  },
  {
    "email":"claudiagambararo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598025082/04ebe1c35e057e5d8e0aa525f5de26a5-1730302235"
  },
  {
    "email":"lucy8621@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723597959546/4a1b5d4070e625a6fc22e4321ed220c5-1730302235"
  },
  {
    "email":"veronicafarri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598090618/e2a310a3c55ba9d3788ef0bcce8f4cf2-1730302235"
  },
  {
    "email":"liliana.rove@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598123386/2f5589e5b01927e280dc0910c00e9b0f-1730302235"
  },
  {
    "email":"vincenzaguarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598057850/7bc5f28e1c8cbb8b6caf8d06c68cf98e-1730302235"
  },
  {
    "email":"fiorelladinorscia@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598156154/cd6077a83d77c5cc252359fe7bf26273-1730302236"
  },
  {
    "email":"valentinatamburinimpr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598188922/147d23570b1eedc80f2a3336a60621cd-1730302236"
  },
  {
    "email":"alessandralenzo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598221690/eb052eaf746b6616d4a616e7b7bcc36a-1730302236"
  },
  {
    "email":"dgiusy29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598254458/b29791f5b79a48f04f6212e7979cf613-1730302236"
  },
  {
    "email":"maddacasa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598287226/f9c15b31783c81e8d1993379fdf6ad1c-1730302236"
  },
  {
    "email":"mermina.anna67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598385530/727e5e8ecc91fbd5b378fafc36cfff59-1730302236"
  },
  {
    "email":"mmassari@teletu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598319994/6630c2e182d8ac2bbe010892e95a33ce-1730302236"
  },
  {
    "email":"alessandra.scatassa@ericsson.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598418298/10e4ec0b7707a9c22ba53488ba415c5a-1730302236"
  },
  {
    "email":"labravalina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598352762/82a66c74c57c0bc18bb9ad1a9a3bf388-1730302236"
  },
  {
    "email":"verort@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598451066/3980b40566806334de9cdffd88e1ea05-1730302236"
  },
  {
    "email":"topigatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598549370/e5af2aec793513912e1dfccee82394dc-1730302237"
  },
  {
    "email":"silvdonat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598483834/17ec81900c48fd8e041adfb96895d808-1730302237"
  },
  {
    "email":"cecchini.caterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598614906/11fcaa110720ef940fda44df18c13b24-1730302237"
  },
  {
    "email":"ilariazoccarato77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598582138/607c8c67e225e8fe68b0f12368fd632a-1730302237"
  },
  {
    "email":"giulia86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598647674/a8103a6183fc50e80157d08a44ea281d-1730302237"
  },
  {
    "email":"spitfirerossoblu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598680442/dd2b59c2ab8af6303668d9efc41bbb1d-1730302237"
  },
  {
    "email":"tizianoparri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598713210/0b8a94277aee8bfd7dc42a67d985399d-1730302237"
  },
  {
    "email":"trastullom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598844282/4ab81336117f59c5ab157be8080edd54-1730302237"
  },
  {
    "email":"vivianacupone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723598778746/2c33e0ec9f0e38d993a57726bed390ea-1730302238"
  },
  {
    "email":"totta5@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598516602/e0082d31a378ecd0825c36043efbc215-1730302238"
  },
  {
    "email":"avvelisacavallaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598942586/dd42f08002fffc421e67e5b27e9e6ed5-1730302238"
  },
  {
    "email":"giulia.985@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599008122/f1218e8c76ea836dd854ea2c6cf1ee6b-1730302238"
  },
  {
    "email":"silviaquaresmini81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599073658/47ff0306c117eea8b74ad3364acebbd4-1730302238"
  },
  {
    "email":"carlaordonselli59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599040890/2a64d455ab040b7dce6d11a76cb8f086-1730302238"
  },
  {
    "email":"barbara.giorgione@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598975354/687a5b6a3c4dee7638b9dc639587bfb8-1730302238"
  },
  {
    "email":"maramassella@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599106426/fe7652e37a3b7df49d011533cdbb40f1-1730302238"
  },
  {
    "email":"catlisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723598909818/cb0124531cef3d2d6c3b71c5346839b4-1730302238"
  },
  {
    "email":"mispatty@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599139194/57508748a636b6755d034b2ab2682a07-1730302239"
  },
  {
    "email":"martina.ronzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599368570/6bbd0b01e7abec25a0299339982f92f7-1730302239"
  },
  {
    "email":"vittorialorenzi01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599401338/d8e5c3b8462b19a08a34007a512a1172-1730302239"
  },
  {
    "email":"cippetti05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599532410/2f5dbafb59efef8d090995a0a329bd70-1730302239"
  },
  {
    "email":"alessistella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599270266/39d53a07a084e556d4106a448545c115-1730302239"
  },
  {
    "email":"biscarini.irene@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599466874/d37b542f92de41ecf9e5b007386d24f2-1730302239"
  },
  {
    "email":"ninni.piemontese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599565178/73384f22015845b98a70e4fd111af76a-1730302239"
  },
  {
    "email":"coccosandra98@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599597946/c4519e2140e980ff79e1644b5ea0920d-1730302239"
  },
  {
    "email":"nellagangi0713@gmial.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599663482/5ddc1326508b09cbf205d40ce8895734-1730302239"
  },
  {
    "email":"gianca.dony@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599696250/e1d441258c56c1ce84addce7f860316d-1730302240"
  },
  {
    "email":"alessandrapescatori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599794554/abcd48011981645255e75ffe5b8548e3-1730302240"
  },
  {
    "email":"stefaniavalori@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599892858/99f67fffacae29a24351566da8841267-1730302240"
  },
  {
    "email":"fedepozzobon@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723599958394/d495a743b4161668e5b9d27cad2c1a58-1730302240"
  },
  {
    "email":"radaellijasmine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599925626/6a62aeeb3953291aede73eb8e9e37830-1730302240"
  },
  {
    "email":"gallettifulvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723599991162/d2488d015a7781ef92b4c174635dba52-1730302240"
  },
  {
    "email":"ornellabuonacucina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600023930/f512b496ef6d0fb45dfa5379555cc3cf-1730302240"
  },
  {
    "email":"minu.azizian@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600056698/7bde87452e8406d741d001b2476d9c39-1730302240"
  },
  {
    "email":"emibarde78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600089466/200a8723975d8ed2b293f24962288cb0-1730302240"
  },
  {
    "email":"camben2006@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600122234/91a49f845d843678bf4169c4cecd3be9-1730302240"
  },
  {
    "email":"gianna.marchese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600155002/4997eb65892dbe157322d3648778b649-1730302240"
  },
  {
    "email":"roveripatrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600187770/db503ed3c4e28d933f6d87443ac2c34b-1730302240"
  },
  {
    "email":"sararosi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600220538/2ebd9e6debd36a7c5a6dccf6493f3dd4-1730302240"
  },
  {
    "email":"monimarini00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600286074/e133591c8e1efc5bf260634850ea8493-1730302241"
  },
  {
    "email":"chiaramaffezzoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600384378/243add062d19c010634829001fda386d-1730302241"
  },
  {
    "email":"alenamazerikova@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600417146/baf5149fbf42e7e1358828e0ebef90ed-1730302241"
  },
  {
    "email":"raffananni73@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600449914/7955bcf94b269dd35277d7025994b46d-1730302241"
  },
  {
    "email":"angela.mauro@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600515450/aa03f04bddeedf9b8156433ca474964b-1730302241"
  },
  {
    "email":"valeriggio@yahoo.com.ar",
    "url di attivazione":"https://verdissima.it/account/activate/22723600482682/405ec3f9c01b4278c7f6bbd06aba1c1f-1730302241"
  },
  {
    "email":"longotiziana5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600318842/b4aaebfe8736b01e4b087a0cc82d94c2-1730302241"
  },
  {
    "email":"marco.orlandi.79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600580986/85dd33318b7fad74de4fa3442b2de3a5-1730302241"
  },
  {
    "email":"filomenapellettieri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600613754/f2b7b6d8073790120b9a2a223cef80f4-1730302241"
  },
  {
    "email":"pinarella56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600646522/e9ec531652901d4c8e594ea6ebc54689-1730302242"
  },
  {
    "email":"antonella.calonaci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600548218/7103cbc1233295ef23616144554e7089-1730302242"
  },
  {
    "email":"stancicualexandra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600777594/b7e656d682bea8223619f11b017fb3cb-1730302242"
  },
  {
    "email":"claudia.bruscia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600712058/852e6e873f3a6bf9995e099d4c48690e-1730302242"
  },
  {
    "email":"alvaro.rapali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723600744826/d40f8876161835ed9b40eef7ef9b1365-1730302242"
  },
  {
    "email":"ernestina.armandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600843130/f35ac93e30a103ce5030a44541c2507b-1730302242"
  },
  {
    "email":"marina.caristia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600941434/15413c495c1e469bc73046ea51251a85-1730302244"
  },
  {
    "email":"scalomeni70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600974202/e58acefbbe48b5c38c477efb193cf61f-1730302244"
  },
  {
    "email":"silvia.carlesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600875898/8063029748a93b355e27f9ac38d70fcf-1730302244"
  },
  {
    "email":"ghimbraoxana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601006970/1ac3310ac49a3509a002d931f82c8d49-1730302244"
  },
  {
    "email":"giospao@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723600908666/2ed3ef23eaff61799de6d969d55210f9-1730302244"
  },
  {
    "email":"bbiagi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601072506/cdf7ac569631ccc4c14e18d1f55ac223-1730302244"
  },
  {
    "email":"elisadamasceni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601105274/3f735892df5242d221f8a54de38288f9-1730302245"
  },
  {
    "email":"giulianarosamilia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601138042/a0d1c8fdc882afdc0899449912e24069-1730302245"
  },
  {
    "email":"marcolinilaura@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601170810/7b1876b14fe46cbbda62b1495ea7d112-1730302245"
  },
  {
    "email":"sarah.fagnani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601039738/40884f6542916ff2ba2108f31e639892-1730302245"
  },
  {
    "email":"romdaniela@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601269114/64830db67cd096580b62cfbbf1fd903b-1730302245"
  },
  {
    "email":"lucia.nicolai@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601334650/2f3625ab914d9b24be740ef9d557400d-1730302245"
  },
  {
    "email":"michela.intimamente@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601400186/2c62077f3c7956c0dc062453af20ac4d-1730302245"
  },
  {
    "email":"mariddamaria.poli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601301882/a5e709b1fb09eac8205fc9853b9134eb-1730302245"
  },
  {
    "email":"laurasabatini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601432954/6d8caaf8247c1e25eeae4de7ebc91ef7-1730302245"
  },
  {
    "email":"lauratiboni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601236346/387612b6c7757e1f22d4a5f49a1439c2-1730302245"
  },
  {
    "email":"c.pozzato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601465722/15c842489d7947e50079769985a71d30-1730302245"
  },
  {
    "email":"barbarinaferri72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601531258/eff319e392bd7abdcfcf7bb2b3e99bd5-1730302246"
  },
  {
    "email":"angy.cardinali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601695098/23944d2aabc3f04b8101d6cd8736374e-1730302246"
  },
  {
    "email":"kiaram78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601564026/49b7f754968d1a7134fdcb5ae0c85f0f-1730302246"
  },
  {
    "email":"contexsrl16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601727866/443521b902b6c6f201dc1b9f3de970a6-1730302246"
  },
  {
    "email":"paola.cotugno84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601760634/bb1cc4877dcea08880c1e0dea54a8fc4-1730302246"
  },
  {
    "email":"chiara.passagrilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601629562/bc12da231833636cfeb645f294bbacd7-1730302246"
  },
  {
    "email":"claradello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601596794/633581ed3dd15c8ac76a8dc9c2137bfe-1730302246"
  },
  {
    "email":"nadia.voli77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601793402/7f2bb1a61cf158fef10413da1837b54f-1730302247"
  },
  {
    "email":"landi.raffaella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723601891706/23e9fe2b39cce36c48b8c5e30445beea-1730302247"
  },
  {
    "email":"banchieri65@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601957242/f784300d288d18fd76fe7fdfc494ea52-1730302247"
  },
  {
    "email":"daniela62.ds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602022778/f15b54262270a759228771a9100febf4-1730302247"
  },
  {
    "email":"dangelisstefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602055546/61fa94801453597ed904d30e00fc1ae2-1730302247"
  },
  {
    "email":"marialauralencioni64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602219386/208c444c63f16524f029f371dc687bc2-1730302247"
  },
  {
    "email":"stefania.berruti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723601858938/4006b7e7a6e2d75167d460496ca96243-1730302247"
  },
  {
    "email":"giadaf@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602088314/6a282cd6852be6baccefdeb6e1ae020d-1730302247"
  },
  {
    "email":"deborah.trento@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602252154/d53ba21325ca6bbce81f872cafcbb967-1730302247"
  },
  {
    "email":"info@intimo3rose.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602350458/87365f8df0953262c1e39d2c4128a2c2-1730302248"
  },
  {
    "email":"giuliomedico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602448762/2b9d35ecef7c7d487321001d2fd2f061-1730302248"
  },
  {
    "email":"pallade_atena@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602481530/acac2c3eaeb4d367fa61eeba99e6a82a-1730302248"
  },
  {
    "email":"giaquinta.nicoletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602514298/389f36d1f5d5ccb19f84a42e409a4ae4-1730302248"
  },
  {
    "email":"irene.coratti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602547066/fdb1270f129bc54b99b35839a22af9e2-1730302248"
  },
  {
    "email":"anzalonemelissa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602317690/b406233016d5a484ea9695066db9a09b-1730302248"
  },
  {
    "email":"bosi.nadia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602579834/46a36d6ca7a9fd2817f789cd3a263261-1730302248"
  },
  {
    "email":"rina.gri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602612602/bbd20a4428f6aceadc131b60315b130a-1730302248"
  },
  {
    "email":"sofia.palazzini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602645370/daac0e8b83868ebff0a6337c85be3bbb-1730302248"
  },
  {
    "email":"palazzo.giuls@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602710906/725ca5b1441b0c05dbff003451bca595-1730302248"
  },
  {
    "email":"speranza0126@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602776442/d01c58361dcb0b2d70a5e9c2dcd7112f-1730302249"
  },
  {
    "email":"cristina.cossu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602809210/fc2ccf17d2cd7f4c8a6116e661ae7b7e-1730302249"
  },
  {
    "email":"simona.mariconda@belex.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602841978/72255973d2c62825d49e5ee3fc8d90c1-1730302249"
  },
  {
    "email":"massimo.cedrato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602973050/644689127b92c16936bc24f89788e728-1730302249"
  },
  {
    "email":"federica.vendemmia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723602940282/6980fca52f159a9a4735eb5aeb26d624-1730302249"
  },
  {
    "email":"monicapersonalnew@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602907514/7b6be7fadda80d4e28a95efb086f212f-1730302249"
  },
  {
    "email":"miki.gmb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723602874746/2c82449eb25991effa9aedcd44e937f3-1730302249"
  },
  {
    "email":"mariacristinaestefano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603071354/eee6b0e14183346952383be46a0dbf37-1730302249"
  },
  {
    "email":"sarabaldi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603005818/5ec939aebfeee42d7d0e204a9fcb73b6-1730302249"
  },
  {
    "email":"salumificiolombardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723603202426/4763d9586565933fa512da01a2a5910a-1730302249"
  },
  {
    "email":"galantiannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603267962/c3721cd178f78f95d15b5c49e25d3ff6-1730302250"
  },
  {
    "email":"barbara.calabretto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603235194/022fb56bc5e9ce9e7dbb662306ef4b73-1730302250"
  },
  {
    "email":"giovannagiordano58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603104122/63a71f28b38b769e0ce0090a4243cd62-1730302250"
  },
  {
    "email":"antonella.giaguaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603136890/ed3486270949028ee6e06d13ee1ce173-1730302250"
  },
  {
    "email":"silviatos85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603333498/5c5321143b2ee4f9acc909bfd2dc951a-1730302250"
  },
  {
    "email":"acoronella063@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603431802/70713090816bda8a98cda9d6b3bf8dec-1730302250"
  },
  {
    "email":"soniagiro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723603300730/d13c257db1a4e6a20844bdb85db10333-1730302251"
  },
  {
    "email":"isapassoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603464570/fc6d2aef080478d08f3716f583964580-1730302251"
  },
  {
    "email":"connie.caterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603497338/3a6ba57bcde98238e07aab372b163ba0-1730302250"
  },
  {
    "email":"caterinapalmeri@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603562874/8decb6dc06ab0a4405dc2f62bcdce6f7-1730302251"
  },
  {
    "email":"magda.avigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603530106/af8b25b6029c2b856c9cbbc260a293e6-1730302251"
  },
  {
    "email":"chiaracutuli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603595642/db54aeb1e9a3a7e913cee9bfe0675ffc-1730302251"
  },
  {
    "email":"dr.gabrielescarabelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603792250/176ffca8f29460893e0806ff7311c0e4-1730302251"
  },
  {
    "email":"monicabiondi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603726714/c21d93b2375ac5b6c7bed48cb36bde3d-1730302251"
  },
  {
    "email":"paolarizzi60@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603628410/2db0c39ff39453e864adcacb6ba829ad-1730302251"
  },
  {
    "email":"denise.bernabei78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603825018/64c7e7d6f16ac8bd7f4461865339823e-1730302251"
  },
  {
    "email":"annamarina.devivo@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723603857786/f625f0a07ba38ecdb2ca7037a5a8ea8b-1730302252"
  },
  {
    "email":"cramenghi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723603890554/9ffd5c6f6439a18db16be2480afcf130-1730302252"
  },
  {
    "email":"eugenia.trotta88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723603988858/998ed04adcb7b3d45681f960a228c850-1730302252"
  },
  {
    "email":"giovannavaiani790@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604054394/a9ab54c94abe9bea4f7dce3eda0dd891-1730302252"
  },
  {
    "email":"lisafier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604087162/7769c1266447191f02ea1a6501be0ffe-1730302252"
  },
  {
    "email":"chiara.braga@perkinelmer.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604119930/bacacd0e6420016bd4108e33c57320d6-1730302252"
  },
  {
    "email":"lara.peracchi.pr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604185466/25c24722c3c49d594b1567a7833483c7-1730302252"
  },
  {
    "email":"orietta.schiavi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604152698/c33a644da62941fd2a86d3e7af227332-1730302252"
  },
  {
    "email":"silviatosin@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604218234/bbc07b5c632331bbc7c637c5485f5262-1730302252"
  },
  {
    "email":"lacorr@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604316538/715e8c79fee11b67ff4c5f155ac61cd5-1730302252"
  },
  {
    "email":"diego.ulivi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604251002/187a6f39be225cf9d1de535d84cea68f-1730302253"
  },
  {
    "email":"lara.ferrando73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604283770/4ae3d3ee8387261b3359c101f1bf3176-1730302253"
  },
  {
    "email":"daniela.sic58@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604349306/6f4b84c6a0ade4f347a99a3e9de79264-1730302253"
  },
  {
    "email":"benedetta.mancianti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604414842/1fe86407f590123d0a5545bd00e86349-1730302253"
  },
  {
    "email":"tessa.fasbressi@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604447610/c71eb61424c7124098fec6cd93fcdc8a-1730302253"
  },
  {
    "email":"avv.paolaspena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604513146/f14416a3563ac6d691c524aef7007e54-1730302253"
  },
  {
    "email":"albertopp@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604545914/326363bc09ba28814d3f98c904e27ea7-1730302253"
  },
  {
    "email":"eugeniaferrero.m@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604611450/1f31184099f2751379c56ae12faafcaf-1730302253"
  },
  {
    "email":"mluisa185@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604382074/0be8882320b3f9d22ef313daab393a37-1730302253"
  },
  {
    "email":"catiacarpineti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604676986/40886c88a51b3c01abf62f6f292ef549-1730302253"
  },
  {
    "email":"marina.ulian@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604742522/917b965ffdc99e2ade3725aae32e6a86-1730302254"
  },
  {
    "email":"lido.macs@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604775290/d25f29909e430e94b1192bc1985bba84-1730302254"
  },
  {
    "email":"marchicarola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604840826/1cce03d9fde4fbdc903d6fbc2349525d-1730302254"
  },
  {
    "email":"alessandraconti07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604644218/ba947127feff9c77b4df3c47058db4ec-1730302254"
  },
  {
    "email":"francescopoce@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604808058/0e16938cef2ba320e9731239e10991a1-1730302254"
  },
  {
    "email":"jo.papj@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604939130/243496ef9e8674d8876ec30b1d7baf11-1730302254"
  },
  {
    "email":"laura_vaghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604971898/3921db2a9f16fa93dd5a501c541f9c00-1730302254"
  },
  {
    "email":"vanzimanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723604873594/a379c05b43b72093ae4f3d3adf21b510-1730302254"
  },
  {
    "email":"tiziana.trassinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605004666/4049fa0a22d80369d535a3dfb34bfd99-1730302255"
  },
  {
    "email":"barbaranoro75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605037434/56e19f1fe902ae0d3ae4bff23940e150-1730302255"
  },
  {
    "email":"pepperosa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605168506/355b60fc0e9269e82c2ea858493b0ee9-1730302255"
  },
  {
    "email":"mellymelly@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605135738/dbfa1943f8d96196bc37c50bea188de7-1730302255"
  },
  {
    "email":"cova2015@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723604906362/882517297eee109951b3d265ee2bb8a8-1730302255"
  },
  {
    "email":"sonia.boldrini1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605201274/b602ee9c5c6aa0a045a23a5949aa15b5-1730302255"
  },
  {
    "email":"rosa.rolle@fao.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723605234042/5c5eb8da73d7818736102341af2ca4a3-1730302255"
  },
  {
    "email":"federicafornaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605332346/af81754f56d8cd3b3543ef05d37ce717-1730302255"
  },
  {
    "email":"rfariello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605266810/bbbbe546cd75a8e17e762f616bc9cd78-1730302255"
  },
  {
    "email":"francescavanella70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605365114/b442e2c98b9aff8cfc68982ae2a10cab-1730302255"
  },
  {
    "email":"romolola79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605397882/3118d4b5eefad7145715c426eaf13347-1730302256"
  },
  {
    "email":"massimo.daini19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605299578/eec4aedd735ba280c009a6695510961f-1730302256"
  },
  {
    "email":"gabriellabotta20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605463418/0a40687cd0cd8e1c31e93f5e47b8741f-1730302256"
  },
  {
    "email":"lcmlcm233@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605430650/e50b2b1341f52dcabbe26b281708598c-1730302256"
  },
  {
    "email":"costanza.viciani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605594490/1309b09969358df869f9c9bdc2b9e817-1730302256"
  },
  {
    "email":"giuliaravenna12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605561722/7cd4d239e90281d1c10afc5211c4f856-1730302256"
  },
  {
    "email":"costagraziella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605528954/a9666260a8b168fa41df2ae6f06459ff-1730302256"
  },
  {
    "email":"elsa.pozzobon@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605627258/536a5fcbf58321d4b306fbf30cdff90c-1730302257"
  },
  {
    "email":"birgit@mutschlechner.bz",
    "url di attivazione":"https://verdissima.it/account/activate/22723605496186/60e8f2d8645dc818bd9a9d3f8ad6ad80-1730302257"
  },
  {
    "email":"mariano.fenizia@ipnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605660026/c72237aa4d4d3c757409887c0c3b435f-1730302257"
  },
  {
    "email":"vittoria@fagiolistudio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605692794/e1e3a57685250dd02a26f0877c5e7719-1730302258"
  },
  {
    "email":"luciazirino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605725562/4d9d0bc91a0d4d914dcee57769ea89be-1730302258"
  },
  {
    "email":"annacapasa62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605791098/9b6c5adad664e37fe7db654db65b8238-1730302258"
  },
  {
    "email":"farmaciasatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605823866/7493a410369d116afcf3629d62b9d621-1730302259"
  },
  {
    "email":"egiusfredi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605856634/22f7c8522835eaabf0f998a58b693e7a-1730302259"
  },
  {
    "email":"federica.spallanzani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723605758330/d04a9c654856ead0e4167b31ef1f9fdd-1730302259"
  },
  {
    "email":"cri.carra78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605889402/3ad863c2692d3b9766fabfc56286449e-1730302259"
  },
  {
    "email":"francescaminieri28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606020474/8c16ce8cdda0ab0805f7d1971427e865-1730302259"
  },
  {
    "email":"stefania.corazza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723605922170/945c12f79ced683273c6c3740fa7dbfb-1730302259"
  },
  {
    "email":"simone.dallasta@autotrasportiferrari.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606053242/14375a996a5601c6377159921c8ecf00-1730302259"
  },
  {
    "email":"assuntatotaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606118778/e30a9d363aaa4f553fffd2f23347638a-1730302259"
  },
  {
    "email":"tommaso.folcini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606151546/b2243620dfa5debe194ebf8d69e75edf-1730302259"
  },
  {
    "email":"annamercalli@cerim.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606217082/69da62feff61c3d0e758d0f1c3db9c48-1730302259"
  },
  {
    "email":"alessiavidali19.av@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606249850/af73ad37050096251ac93b730efdc6a8-1730302259"
  },
  {
    "email":"laura66amadio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606315386/64e5ac12adc9ad58d3b4dfe81bccffff-1730302259"
  },
  {
    "email":"sara.frosio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606348154/8789c2be158c3bcf7fa8c4db6d6e25db-1730302260"
  },
  {
    "email":"vaniavan@alive.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606413690/1dfdce6a6b953b6fe9f67490bdcb1499-1730302260"
  },
  {
    "email":"alberto.micheloni.it@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606380922/b10a4dee00393390b68b046b60e33a48-1730302260"
  },
  {
    "email":"susannaservi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606511994/bb1b9a7e882ddc9f5149aa0641a8b766-1730302260"
  },
  {
    "email":"memi.pezziga@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606282618/2c8bf4ea78c0379b149278e445a79d6c-1730302260"
  },
  {
    "email":"silvietta.1986@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606479226/386de8467b29a600f90328055e8d247b-1730302260"
  },
  {
    "email":"gabriellatrerotola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606577530/e2482eb397060f449d6e85acbb06e3de-1730302260"
  },
  {
    "email":"betty79loda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606643066/4a95ec91a496ae54a2a52be783b96371-1730302260"
  },
  {
    "email":"giady986@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606675834/661a58c004a7b9f69db4377b520da043-1730302260"
  },
  {
    "email":"furlanierre@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606610298/c59c61c889f2525aa486c160e7a1ffd0-1730302260"
  },
  {
    "email":"flavioconti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606708602/251d8c814ffda3b47dffa97bf44ef7c1-1730302261"
  },
  {
    "email":"carlaconticello@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606741370/6c846a79f57ffed368886ccff388dbd9-1730302261"
  },
  {
    "email":"olga.spiriadou@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606839674/efcf206ce5399ecbef3e069bd6f5aa43-1730302261"
  },
  {
    "email":"chiaravallisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606774138/6b70b1ac4f4e1ec7ccefd27d683f2fe3-1730302261"
  },
  {
    "email":"danidani1958@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723606872442/df1e4b62d2fe5acf03cb9e9fc72a6804-1730302261"
  },
  {
    "email":"leo_paolo88@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606806906/43521494f309e9b1e0cd8ebaf1e4c461-1730302261"
  },
  {
    "email":"chiarab79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606937978/ec3af1a8b9460eaddcafb9ab34ae5b85-1730302261"
  },
  {
    "email":"fabio.prealta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723606970746/9a149c7e40e871ffbdc2b182c76c274a-1730302261"
  },
  {
    "email":"maria.dimiceli@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607003514/7d18043b9da0e85d64d00ebdb805dda3-1730302261"
  },
  {
    "email":"alessiacaterina08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607101818/e4e5e3b467f36bc3d655a5981f8bfc78-1730302261"
  },
  {
    "email":"castamrk@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607069050/1ea0a4fe4df86b96673188c1ab0049d4-1730302261"
  },
  {
    "email":"leonardina5@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607036282/799f8b4a131ccf70f6a54eede8fa25d1-1730302261"
  },
  {
    "email":"thor20@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607134586/4a1b934d1d65e95e180ab27fdc666e54-1730302262"
  },
  {
    "email":"manuela.melandri@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607200122/5d0b841eb8e0bff46bcb2a5c09c955e0-1730302262"
  },
  {
    "email":"federica.borelli93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607265658/080108d5c78d92118c6742136b9e9722-1730302262"
  },
  {
    "email":"a.collini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607232890/e43b6c7a38b8bbeb2793a484a872e74e-1730302262"
  },
  {
    "email":"ilariofederica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607298426/f2d774ec910d212fd3e5f3073e9cb5c8-1730302262"
  },
  {
    "email":"barbara.zaccone@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607363962/a131c80dd1c9594d57e54f4ec741a130-1730302262"
  },
  {
    "email":"mara.bufano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607331194/53cb2d397fc330d8a9eccbeafbaf6d00-1730302262"
  },
  {
    "email":"barbara.biscardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607167354/a35a40a997e0d23a4da5eb8e8a6c3ae1-1730302262"
  },
  {
    "email":"demaio.paola@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607429498/3552e1e00e4ca9cf46464dc1ea28f6e4-1730302263"
  },
  {
    "email":"mcc2201@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607527802/a1e0d03809876a5458983dfa59532c09-1730302263"
  },
  {
    "email":"rosariastabile77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607593338/61834668871483c54306564e6746e4fb-1730302263"
  },
  {
    "email":"linda.froso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607495034/bb3a868de8f0da77680b6100b63132a3-1730302263"
  },
  {
    "email":"katia.selli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607396730/b2452053771f3acd621c5ea48ff6a26f-1730302263"
  },
  {
    "email":"silvia.aspite@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607658874/ad74d1b9cff041a371c92b631c0aa481-1730302263"
  },
  {
    "email":"nellabianco@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607626106/47b0f6fd2c5db03b96e84cad04b16925-1730302263"
  },
  {
    "email":"consuelo.costi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607691642/31693283914d71cf5605393f805a27d8-1730302263"
  },
  {
    "email":"zonia965@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607855482/0e7d8d8eacf419fe2e168dccdbffcf6c-1730302264"
  },
  {
    "email":"francesconava62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607888250/1f5631b91f40d9111d2c2ffdec13fdae-1730302264"
  },
  {
    "email":"demu77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607921018/1625fac0084598d336aab624891b0c1f-1730302264"
  },
  {
    "email":"alpacadelleande@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723607560570/071bd416cd0d7106c1aa07accff70d45-1730302264"
  },
  {
    "email":"marco_stijnman@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607953786/6b87669578f37c02cd1f2ec2b961e0cb-1730302264"
  },
  {
    "email":"nicolettacare@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723607986554/416df85fb131acf06896366a38dc592c-1730302264"
  },
  {
    "email":"kia_1972@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608019322/4ec039add45b8b2083d1c310d5bca4bb-1730302264"
  },
  {
    "email":"geraldineleardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608052090/537649dedcf5832186275ddb1fd01ffa-1730302264"
  },
  {
    "email":"eleonora.tandoi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608150394/a915873647dcf8398b14ab897a2b6e19-1730302264"
  },
  {
    "email":"alicesoricetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608183162/d4288cfefa8b76cf1e78fe1eefe8b266-1730302264"
  },
  {
    "email":"saramail7006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608215930/414dba5b67663914bf1c6a179ab6d7b9-1730302264"
  },
  {
    "email":"danielaricci467@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608248698/568659de1863013f9b5e3ea3a066519f-1730302264"
  },
  {
    "email":"paola.vicina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608314234/ce185e85dab18b45d3eff333875d9a33-1730302264"
  },
  {
    "email":"e.carraro1971@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608445306/9e938565c3d394297e44d5e2e0899114-1730302265"
  },
  {
    "email":"manuelbordina@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608510842/5ac93dc7afece7324bd9421aaffaa67c-1730302265"
  },
  {
    "email":"ydo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608478074/6fc927fa5c1bdac0925965c5b9654955-1730302265"
  },
  {
    "email":"paolo.sfriso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608412538/bb846cfce3c4e74e2e84af97fef04855-1730302265"
  },
  {
    "email":"ferruccio.zani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608379770/9646107786bd782dd0128aad23fc9e78-1730302265"
  },
  {
    "email":"sfedrighi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608674682/1c52f8269361867f4b9cdd7321b227bf-1730302265"
  },
  {
    "email":"info@cadgnese.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608576378/47fdcb4979556dd8c75adae85f8caaac-1730302266"
  },
  {
    "email":"silviabrentari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608740218/22073a0d731c3d5955991ca190fef097-1730302266"
  },
  {
    "email":"maria.72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608805754/8017571d7aef84e72009974bc271bf73-1730302266"
  },
  {
    "email":"paloschisilvia69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608772986/c896d1dc841aae4481bef36e4567afe5-1730302266"
  },
  {
    "email":"tiligu@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608904058/167f65300e877fe14ee9bc9f22409f4b-1730302266"
  },
  {
    "email":"1maria74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608936826/2b6478f90bf04558c4cdc431b82996ac-1730302266"
  },
  {
    "email":"cinzia.baratto@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609002362/d20f40e36936c32541d563bb4ab81561-1730302266"
  },
  {
    "email":"annagualano1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609067898/c0f935c858f5902cde8816dd8c4ea24f-1730302266"
  },
  {
    "email":"labellamarillide@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723608969594/a981659b2fa3c40246c504f6eb53e1c0-1730302267"
  },
  {
    "email":"vale.bartozzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609166202/0fda562d54b0dae74ff5f35379e49b6f-1730302267"
  },
  {
    "email":"martinellielisa1992@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723608838522/596831c7ef2443bb0e5230ba0dec623a-1730302267"
  },
  {
    "email":"maxsilvia89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609133434/fac7b62ffc2b76b66486de112b89bae6-1730302267"
  },
  {
    "email":"beatrice.studio.bb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609100666/5f7c26ab948edd11a75d000ef9a11a30-1730302267"
  },
  {
    "email":"monica.sasdelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609231738/0fca34e27dddc7dd785ca0d94e28d9b5-1730302267"
  },
  {
    "email":"75trilli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609264506/f1018dbb5180d87f1cafc0a9150a985f-1730302267"
  },
  {
    "email":"iupper@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609198970/1b6036704ed69dd4b197278a7dbbbda5-1730302267"
  },
  {
    "email":"bazzocchi.benenedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609297274/9674a6f777eff5370d5fd3bf4e097936-1730302267"
  },
  {
    "email":"vincent978@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609330042/297857052191db7a88927236d8afa7b3-1730302267"
  },
  {
    "email":"meryvasciarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609395578/bce6fe03c661d359c2069b9bce75f59d-1730302267"
  },
  {
    "email":"giorgia.crespi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609526650/9e46a90bbd984743794c6214865892ab-1730302268"
  },
  {
    "email":"jessnomore89@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609624954/7a6f8d0324834634ec74a5abc4580012-1730302268"
  },
  {
    "email":"mariachiara.mc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609461114/ccc94a40caac91c1c7791bdc3c278842-1730302268"
  },
  {
    "email":"chadinairina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609657722/f30146f3ee1d223748ecd102abba2fa9-1730302268"
  },
  {
    "email":"losito.antonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609756026/f5bc7f2b9a60903d5b36d6b6621cb6f0-1730302268"
  },
  {
    "email":"damiani.paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609592186/64cb89cf3744db9315b0165e22933e59-1730302268"
  },
  {
    "email":"avv.stefanosalvioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609788794/db839db85387572a3a10ac9f845de48d-1730302268"
  },
  {
    "email":"marty2189@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609690490/8f400bd9a55848c3d62a3bf0ed390295-1730302268"
  },
  {
    "email":"chadina.irina1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609821562/966fe64974bbdfb39f22f2fc11a92931-1730302268"
  },
  {
    "email":"laura@lesinigo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609854330/ec8eeaef1e86ab5176e1ea3015a679f7-1730302269"
  },
  {
    "email":"chiaramarchi100@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609919866/7d51d669700a158c1f2c1c31dbf7ef12-1730302269"
  },
  {
    "email":"paolamaiorino.75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610018170/46cb270716a8e84ed8a4c1d415c6cffd-1730302269"
  },
  {
    "email":"mariaeni85@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609985402/ccbad892b88b086f9401cad6bd07590b-1730302269"
  },
  {
    "email":"verodav@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723609952634/b0804f7189c0594b5f11074ad75257d3-1730302269"
  },
  {
    "email":"valeria.ancidei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610050938/307ad5b1e47844ed9702252eca87c880-1730302269"
  },
  {
    "email":"sdiazzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610149242/d11aadcb2fdd615c3a4b414b26c379f8-1730302269"
  },
  {
    "email":"flora.spadetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723609887098/fb10bb91995fa78e7ad5dfdc8d6d8ff3-1730302269"
  },
  {
    "email":"bonettiangela6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610083706/1b2e7105dd2166a73e977df7217ac994-1730302269"
  },
  {
    "email":"lauraderosa1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610214778/5f3e29954229ab207c8bb1d784f3d5de-1730302269"
  },
  {
    "email":"melissabaldasso@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610247546/8d8d4088b12685a03ba8baadfc70bfe3-1730302270"
  },
  {
    "email":"deliagiusy10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610313082/bd6dacda044a48a8203edad845d9f168-1730302270"
  },
  {
    "email":"donydam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610411386/e91de83509deaf2b30cd43a8ce552a4c-1730302270"
  },
  {
    "email":"saramontonati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610280314/63181ed97c41f9b70fea107f928f5985-1730302270"
  },
  {
    "email":"ele.masse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610444154/fa0bba4e460c0d7b2932ec1327bae2f4-1730302270"
  },
  {
    "email":"marisanicoletti64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610575226/01fbe3b446b6dfa6b984fee8af0b0a58-1730302270"
  },
  {
    "email":"ada.mv.facchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610378618/1a369b05903095b460b0b2542086db3c-1730302270"
  },
  {
    "email":"cristinacocchieri@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610509690/a6072b71ad97357e003aa99b49fc51a9-1730302270"
  },
  {
    "email":"roberta.frison8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610607994/9ce0faf7e9dbff79bf11e2e40ea8bf42-1730302270"
  },
  {
    "email":"matildecarta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610640762/28aabeb11887d023855df508065d32a2-1730302270"
  },
  {
    "email":"annalisa.acquati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610739066/214372244274d6e332115fedef98e32d-1730302270"
  },
  {
    "email":"manuelagalassi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610673530/2eefdc14d90afa65d5e50a72c7adf979-1730302271"
  },
  {
    "email":"licia.depropris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610771834/a0208303ee4a19d9da824e4e5854b669-1730302271"
  },
  {
    "email":"casonilorenamodena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610935674/c3c89a80fd28c6601a93328e129b77d7-1730302273"
  },
  {
    "email":"lavery82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723610804602/27b454329d76d6fe8640b0e6ec571c04-1730302273"
  },
  {
    "email":"larabogani.xs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610870138/1f10acd87b72560bbe9f60283dd4576f-1730302273"
  },
  {
    "email":"marianeronezano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723610968442/57582510baf6252d81d8d1eaf7e6afd7-1730302273"
  },
  {
    "email":"ppatrizia.ferrante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611066746/c41b503c55dc8ba22f864431e2be810d-1730302273"
  },
  {
    "email":"annabra@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611099514/fa108348ca45d66fd927bebd2f536ca0-1730302273"
  },
  {
    "email":"ata.togno@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611197818/818ffd8d292fcd4451f3d74a3af88a12-1730302274"
  },
  {
    "email":"lizzese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611165050/ac7b032d8a424f4f0cc7e663f17257a4-1730302274"
  },
  {
    "email":"angubold@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611001210/01e2f4c4160e53959127b62c0f284bc3-1730302274"
  },
  {
    "email":"federicatreggia73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611132282/520e5be9138b3a53673c68e33082106c-1730302274"
  },
  {
    "email":"robisgh@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611296122/83646310e4492c4f2d0293b2a4840d8f-1730302274"
  },
  {
    "email":"tronci.valentina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611361658/0cb3cfbcf04ed90ca7d8cb6ce0bc88dd-1730302274"
  },
  {
    "email":"studiolegalescarpati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611394426/8271b2c22fcceb27956f001b1d519fc9-1730302274"
  },
  {
    "email":"silviadanna74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611459962/57ae4c9598759e96c971e9c713f7ee04-1730302274"
  },
  {
    "email":"anna.decandia@windtre.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611591034/92d27b225c7f4e6f60a70905282aa3e4-1730302275"
  },
  {
    "email":"avvocato@martavolpi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611492730/a730ef3a08f2e810f12e6be088c9548f-1730302275"
  },
  {
    "email":"lui.colucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611689338/20c49e2548a43e2f7cbb063371884dbe-1730302275"
  },
  {
    "email":"ferrarafabiana@librro.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611263354/b1109dc41eca028f98ee46ece55ca912-1730302275"
  },
  {
    "email":"amvlonghi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611525498/5df1f0255b257b87fc1a420c3cb00ce9-1730302275"
  },
  {
    "email":"lo.bal@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611656570/8d7c920549862fc97e82ec498dda1b53-1730302275"
  },
  {
    "email":"moonywitch@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611722106/be3e191d126337a652763b6a1be07aa8-1730302275"
  },
  {
    "email":"gina.zavarise1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611885946/9a0676e1ab1fab3097fe7290ea249455-1730302275"
  },
  {
    "email":"debora.g.5@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611853178/500a1f145085ed2141b22ef82a7c828c-1730302275"
  },
  {
    "email":"valentinalibertucci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723611820410/f47d76ae5def18252d401d7e456171f2-1730302275"
  },
  {
    "email":"susyalfieri13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611951482/41948af5efc9ead3ab13c487e913dce4-1730302275"
  },
  {
    "email":"bigianto.64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612049786/23923f9166efd3a5f1ec586b2184064e-1730302276"
  },
  {
    "email":"lina80.dambrosio80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612017018/620cacb29b55d38db2dc11eb961bf7b5-1730302276"
  },
  {
    "email":"veronica.mariani1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723611984250/6ee1986f72762081ea2f071c8e23a04f-1730302276"
  },
  {
    "email":"ariannatommasin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612115322/51f23e9f33f642a3c3f3ad6996e11c33-1730302276"
  },
  {
    "email":"marziaportoghese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612148090/48b79c971a301a73bfb94c33c0d4c05d-1730302276"
  },
  {
    "email":"jasminelocatelli.10@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612082554/c33cc604afb5e15461c79131cce4bb51-1730302276"
  },
  {
    "email":"romantschu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612180858/5a0d169c75d6f9fb0e88fb824c42a622-1730302276"
  },
  {
    "email":"fedemari72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612213626/9b7d993f9dcfa7ca6f1bf353a26086fa-1730302276"
  },
  {
    "email":"cristina91167@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612246394/4dfae544898e3c65dd99423e099836d5-1730302276"
  },
  {
    "email":"s.terrachini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612279162/b50ca7d43525d6da2b8f5f4b7d1c432d-1730302276"
  },
  {
    "email":"tizianaacquaviva@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612377466/b7e4f326c61e5a55710bb430232aa2ff-1730302276"
  },
  {
    "email":"laura@wws.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612311930/731bf942b837baf43dd0ffe36413904c-1730302276"
  },
  {
    "email":"eleonora13u@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612410234/d8140ce40854efd087faf63b83155a34-1730302277"
  },
  {
    "email":"monica.crippa64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612344698/c9cd37c9f156e2d00c842e7365cc317c-1730302277"
  },
  {
    "email":"luciagiorgetti.03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612443002/fa6ec19dfda2bcb25f0737e24830a864-1730302277"
  },
  {
    "email":"silvia.leonardi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612475770/502557e3997720552bd887269f4e059a-1730302277"
  },
  {
    "email":"chikay13@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612541306/fab9932f195d36a928f0769f1a1fd84f-1730302277"
  },
  {
    "email":"nobinyakova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612508538/c0dfefa437250eeb7574985a54526fba-1730302277"
  },
  {
    "email":"laura@studiolivornini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612639610/db4777c977e83fbb3c9536f6e66995b8-1730302278"
  },
  {
    "email":"loredanaland@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612574074/39d9c07ed554e065f8f462093b5a46e3-1730302278"
  },
  {
    "email":"maria.mastrodascio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612672378/62e4d6aab0560ecda4bb065c0b013da6-1730302278"
  },
  {
    "email":"dchiste@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723612606842/ceca0f62b31dcea838f6b7e02a05f7d4-1730302277"
  },
  {
    "email":"chiara.libe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612770682/d3ea2f413d95c953a016b34de31d5428-1730302278"
  },
  {
    "email":"cri.montanari1604@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612803450/5369fda8a97e4a0f4425cddba1779488-1730302278"
  },
  {
    "email":"teresagambatesa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612836218/7a24d6c50d87799e0c7773ca03985f35-1730302278"
  },
  {
    "email":"emanuela@dicoviarchitecture.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612868986/38276c3ba323b6fc70b4744cdd709278-1730302278"
  },
  {
    "email":"pifferi610@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612934522/1494ab8a044c7f26470e2ff6870fc4f4-1730302278"
  },
  {
    "email":"piccirillosandro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723612901754/4855ef29b2fdf24b55600e3a757405be-1730302278"
  },
  {
    "email":"anna.dalmaso@conceriasabrina.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613000058/64f2fb1248971055a189c7585a2361f6-1730302278"
  },
  {
    "email":"ele.deba81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613163898/27f26f242a586d828dc7a3e7fd517e1e-1730302278"
  },
  {
    "email":"chiarabodini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613131130/fe5e2f5f2ecd6711ec0cd611a884c982-1730302278"
  },
  {
    "email":"eleonora@ascani.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613098362/85392b695c11dc043f54f6629f4b3d7b-1730302279"
  },
  {
    "email":"suzel@originalmiles.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723613196666/5c880d309e2773b9010edbe50e2007f1-1730302279"
  },
  {
    "email":"pablimala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613262202/2254b8da6a4ddbaadd06f052f33e0ad2-1730302279"
  },
  {
    "email":"polielena1991@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613229434/aaa14fba1b9003b1b0da524c0cb29694-1730302279"
  },
  {
    "email":"alessandro.nardi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613294970/858c2ba3b1c00b7193c879266a4d3735-1730302279"
  },
  {
    "email":"beatricedelrio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613327738/a35b37d7ca4fd89c87ee976262986ee7-1730302279"
  },
  {
    "email":"susyderosade@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613360506/5dc7e022171d575f5fa06cd62bdcb467-1730302279"
  },
  {
    "email":"rinellacommodaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613393274/fc6513d8035782c6b273ba52d95d48c3-1730302279"
  },
  {
    "email":"roggero.mariateresa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613426042/99ef43a168be2142ccf8e0b375ef7123-1730302279"
  },
  {
    "email":"ila.bellini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613458810/cffa733dd7b95f16902ffddd79c193dc-1730302279"
  },
  {
    "email":"lorenza.malinverno@tentori.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723613491578/8e936b123036e20fcc4bdfc78ecea989-1730302279"
  },
  {
    "email":"norapodologo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613557114/72db9723b71c73be1b2b7fefb265562c-1730302280"
  },
  {
    "email":"cecirossi2012@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613524346/f33fe1b4cab23ed76e9ff55a386ca635-1730302280"
  },
  {
    "email":"gabriella.proietti1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613589882/536a482cf1f5ecd8ee54f3686faab5f1-1730302280"
  },
  {
    "email":"cocciailaria6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613655418/d478d050397bbab4445734eac9e57617-1730302280"
  },
  {
    "email":"yorivo@yahoo.co.jp",
    "url di attivazione":"https://verdissima.it/account/activate/22723613786490/7c8fb1c6812592ca560d46618bef1eb4-1730302280"
  },
  {
    "email":"giulianamura81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613688186/1d3517a186b2b966b5eda0af50285a4c-1730302280"
  },
  {
    "email":"annamdif@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613622650/1e2303313558da97674bbc5e636945ca-1730302280"
  },
  {
    "email":"laura.branchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613720954/25cf3ad66dcd271b120c9b25a56c7561-1730302280"
  },
  {
    "email":"iritravel79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613852026/365a27924e0f06f7cf6cb64a30bd513b-1730302281"
  },
  {
    "email":"elena.l1984@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613884794/d4242afdfbc0b1738c3c2728bf6e63c0-1730302281"
  },
  {
    "email":"onutza_cool_tec@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613950330/bce96c691d5abd39509385fbf6a08778-1730302281"
  },
  {
    "email":"mari.bianchi16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614015866/fc7402e7115beb73bbd6b20cf8bdcd0d-1730302281"
  },
  {
    "email":"marcellalaz@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723613819258/d272b70fe11123e463c25af76536bb82-1730302281"
  },
  {
    "email":"francescapappini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723613917562/5f7076effd2966db0f00def6a91e2894-1730302281"
  },
  {
    "email":"serafin.broglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614048634/ee417e061a4fc61e9df345e72834bc8f-1730302281"
  },
  {
    "email":"luca.spalla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614081402/6d961956f5a0229acc6575a4072ea937-1730302281"
  },
  {
    "email":"rossana.pinato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614179706/5d660626aae1fbcb95ec286f136a1c17-1730302281"
  },
  {
    "email":"ines.moroni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614212474/84da7c61239647ef55e88198d1bd0a10-1730302281"
  },
  {
    "email":"segatrenato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614343546/5dff58a2d83f81af7e5e596a6325c782-1730302282"
  },
  {
    "email":"lianalucarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614310778/1cb3b830ac8c31c4f5e6809ce3944d62-1730302282"
  },
  {
    "email":"elycarpi91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614376314/6959fbca6aae2b6e9a12f2bb6e4015c4-1730302282"
  },
  {
    "email":"bilotti.s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614146938/0f8c09322711270032df0db85db0a929-1730302282"
  },
  {
    "email":"silviaferra@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614441850/bae26f9d32666934ae354c0d8a55533e-1730302282"
  },
  {
    "email":"alessandradicesare@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614474618/e02aa88d27b90565625ee68cee558911-1730302282"
  },
  {
    "email":"attombrimanola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614671226/6dcb14ce6a721b13e60d7ae67d447bb5-1730302282"
  },
  {
    "email":"federica.tarroni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614540154/222f599f21110ea2218db54e12b3c0a8-1730302282"
  },
  {
    "email":"caterina.sabusco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614802298/0c263d7b9a49a1aa5fa0bcac002120e0-1730302282"
  },
  {
    "email":"francesca@vigogerolamosrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614835066/f83e1c9ca99ad4d84edd0056635a06c5-1730302282"
  },
  {
    "email":"r.ferretti@premoliferretti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614736762/b892aea9ca3e988c3b0ca5d696689d8d-1730302283"
  },
  {
    "email":"koto.michiko@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614867834/d3be03fa2b779d5adcb4548dbcea99f1-1730302283"
  },
  {
    "email":"erica_piccioni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614966138/4dd7aa12456026273fe178c15bd83b87-1730302283"
  },
  {
    "email":"marziabenvenuti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723614933370/972019e73d1052dab6eafce35b0e1710-1730302283"
  },
  {
    "email":"jessica_emanuela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723614998906/738a5fabe347cd32afbec23f8259f0b6-1730302283"
  },
  {
    "email":"enza.federico60@gimail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615031674/77e37aba1e2a60f030619273d7970c64-1730302283"
  },
  {
    "email":"eleonora.bana@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615097210/eab0c3d437a692e786b1128bae41d596-1730302283"
  },
  {
    "email":"ritaah8@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615129978/e64b3c3f1e14bd1596f9bf71df4d2bb0-1730302283"
  },
  {
    "email":"ale16.zecchini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615064442/de62661b6500fa3ea1ddcc6a24362d53-1730302283"
  },
  {
    "email":"paula66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615195514/57f3baa794cb34ff2146f48b7710576f-1730302283"
  },
  {
    "email":"valeria_mengacci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615228282/130ca60799412cee3e90b5f3df1935f5-1730302283"
  },
  {
    "email":"robertaclinca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615293818/a9ec925d239844097b934fa23d128b8c-1730302283"
  },
  {
    "email":"laconcaf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615359354/cf56881c510fed2ac65988d7a70d2707-1730302284"
  },
  {
    "email":"temporella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615326586/ffef3fb41f5b6fb5fb75062765a97ff3-1730302284"
  },
  {
    "email":"erikaliguori@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615490426/0693ece023226d2d3017eca1e9ad9922-1730302284"
  },
  {
    "email":"ornella.ghiselli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615392122/e8a610097ba22cf642e87b144e42f72c-1730302284"
  },
  {
    "email":"vannym74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615424890/cbc66ec4089428643fafd718e53ebd62-1730302284"
  },
  {
    "email":"lyubashenko.nata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615588730/9323e0c2f8136020ee22629200e2cbc2-1730302284"
  },
  {
    "email":"albarosaaprile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615621498/9389d3d5339353de2402256097fb1f24-1730302284"
  },
  {
    "email":"buzi_emanuele@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615523194/3804469303d2abc8336338b47693ec54-1730302284"
  },
  {
    "email":"farina-maria@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615654266/f3bca8f9fa6651e78e2693c86bfb63bb-1730302284"
  },
  {
    "email":"virnuz17@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615687034/4a5971921e30945c00ba6b68e1a1b21d-1730302285"
  },
  {
    "email":"maura.sasia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615719802/48936888cc9012c38484fa54d855b8aa-1730302285"
  },
  {
    "email":"orefice.manuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615752570/fa79e8a49072b7b60a99163ee61fe004-1730302285"
  },
  {
    "email":"isapavanati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615785338/14b0e51dda07d7d5cb821668704e9712-1730302285"
  },
  {
    "email":"santi_catia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615818106/be4cffee6696714a462095c53f5b1d59-1730302285"
  },
  {
    "email":"eledetti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615850874/c3f8180d2557b2311b6c69e552600f61-1730302285"
  },
  {
    "email":"info@essetrecostruzioni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615981946/a68056dd02c2fc6e4050e25cf00a4262-1730302287"
  },
  {
    "email":"simona.divirgilio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615883642/7edcbdc2be3db965ab19d2a8e7aba035-1730302287"
  },
  {
    "email":"g.salgarello@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723615949178/4f6e17e72e161fd37ef2543aacea3e57-1730302287"
  },
  {
    "email":"camillagimondicg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723615916410/f3f885c4991cef196877383929609970-1730302287"
  },
  {
    "email":"benedetta.rossi3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616145786/65295b92bdc3cb17645066a074f613a8-1730302287"
  },
  {
    "email":"contardi.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616047482/b0ed691d3fe8a1052c4825fae6ea1b0b-1730302287"
  },
  {
    "email":"elisabettademajo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616113018/e2817331fc58f811942ee7f4e9f1ac6e-1730302287"
  },
  {
    "email":"giorgio.ceppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616244090/8197c8b07dcc50d7a5308f6f28b7676a-1730302288"
  },
  {
    "email":"rosalia.cinquegrani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616211322/2073a54a312b8dde57c285a097b96d08-1730302288"
  },
  {
    "email":"giurgolafrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616276858/5214f97c66eaa094b97842358e500290-1730302288"
  },
  {
    "email":"pscuccimarra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616309626/7a13a41a71e02ac8bbce7f81f39cb0d9-1730302288"
  },
  {
    "email":"giuliabruni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616342394/193db4a38e40aa606f20589a8c5a01b2-1730302288"
  },
  {
    "email":"martinafaustini04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616375162/57e27da1071944cc7fd1fe299d48cedf-1730302288"
  },
  {
    "email":"bellmarco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616440698/005b4243676aee3edd2af01f97fa7c3c-1730302288"
  },
  {
    "email":"saramichelotti.23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616407930/7f7d756e18d980dad9530c77754ac903-1730302288"
  },
  {
    "email":"valenzano.rosangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616178554/9795d8a1ba15c187882db06f599dce8a-1730302289"
  },
  {
    "email":"gjveneziano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616473466/8cfa12063c744c408292fb368b410ec5-1730302289"
  },
  {
    "email":"anastasia.garattoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616539002/1c83b0cd0f310b6302ecd725cc55ecd4-1730302289"
  },
  {
    "email":"elisa.g@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616506234/fe3e6a69a5c66e8e55a0e4ce4c0c659d-1730302289"
  },
  {
    "email":"miladelucia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616571770/0a697153fc0943d5d87c09c33249d145-1730302289"
  },
  {
    "email":"amoino79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616637306/4272404f9155c5f34b35e3b82a018781-1730302289"
  },
  {
    "email":"francitode@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616670074/0427b856fe74fe951789373d3585518d-1730302289"
  },
  {
    "email":"marcellaambrosino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616604538/5c77419c2c6c35e30f446d3a2c47b35c-1730302289"
  },
  {
    "email":"rossic433@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616702842/a05f9f9da10d44dbfd3c4d5f9319cd7b-1730302289"
  },
  {
    "email":"ambraragusi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616833914/29b6e3b97d8a4afa11e7cfdf31ca12c4-1730302289"
  },
  {
    "email":"federicacicognani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616735610/8d9b57d2bd02009a65e577849b38a590-1730302289"
  },
  {
    "email":"difelicesimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616801146/abf6c5ff86f19c2b599ba59f7250dc02-1730302290"
  },
  {
    "email":"barbara.serra73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616866682/1918116678b66162493669767f47b0e0-1730302290"
  },
  {
    "email":"ross_2009@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616899450/48fd7f5a71a66c6c13255b0645ce3310-1730302290"
  },
  {
    "email":"silvia.uguccioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617030522/867a4f027d91539778c2d224f73677c3-1730302290"
  },
  {
    "email":"cecilia.murgia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723616932218/f747c7e69ab3f6b54c9542ba1ebb6869-1730302290"
  },
  {
    "email":"sonia.cremascoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723616964986/c86c94cba7e0812fed4af8a5087ee6e6-1730302290"
  },
  {
    "email":"marti.bortoletto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617128826/4e44e8e96331f9a7160f97ee90b633e6-1730302290"
  },
  {
    "email":"lucifera_lu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617194362/42dbf55fc318fb9da809ae7a964bff93-1730302290"
  },
  {
    "email":"giuliapignotti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617063290/3b70245a3630ce6f4a5fbd1b39a611ab-1730302291"
  },
  {
    "email":"lguastella17@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617259898/730e3cb681ac92db032a1c57cb4c9bee-1730302291"
  },
  {
    "email":"viviz1977@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617325434/29d307b718cc54e5b24ce8a6690f532d-1730302291"
  },
  {
    "email":"bin.tiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617227130/9727d4d63bbb9260e4af9d30d2a1f487-1730302291"
  },
  {
    "email":"caterina.proietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617358202/67c28aa302851689e2c3d77d0986729f-1730302291"
  },
  {
    "email":"calvimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617489274/4b51e4d6bd1a91c83ce1ec3a4a4291b7-1730302291"
  },
  {
    "email":"vigo@mavaco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617522042/675995c4cc5746f1e7cbad6ecd31b5c2-1730302291"
  },
  {
    "email":"keira177@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617423738/882e4c69704f1da2e7aea31786fd4d7d-1730302291"
  },
  {
    "email":"giuliananesso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617390970/89af7dfb69013b2ad274e60050238dbd-1730302291"
  },
  {
    "email":"febach79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617685882/3b658bdc07489cc0997a86d5473078b7-1730302292"
  },
  {
    "email":"valentina-fanfoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617653114/81930d216a8a654b25492d916d1c8f75-1730302292"
  },
  {
    "email":"daniela.bonvicini@tecnosystem1981.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617784186/a6b42998210f51d505f9a6eaaf70c68d-1730302292"
  },
  {
    "email":"monbel69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617751418/530ca4a1cfe3904c17e5f675723f7721-1730302292"
  },
  {
    "email":"manuerrico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617816954/bf97af72c0603dd093529e2f64b413a9-1730302292"
  },
  {
    "email":"miucci.lucy59@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617948026/c34119c26240f5530047dd8f40ce1b7c-1730302292"
  },
  {
    "email":"stefania.pelucchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723617915258/d0146ffaa7b119e7d2803c00d6358a20-1730302292"
  },
  {
    "email":"ross.lissa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617980794/c05c54eb1308e61a7ab06ff3b132319c-1730302292"
  },
  {
    "email":"bucchi1401@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618046330/a973b1486355dd793dc24fed82c28fee-1730302292"
  },
  {
    "email":"brunad59@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618013562/51a2f34f7d985cde16b29513a71a8ef8-1730302293"
  },
  {
    "email":"noemi.molteni2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723617849722/6962e97a007d72442bef731b7eb58ff3-1730302293"
  },
  {
    "email":"rosanna.volpi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618079098/fba5a37f9fbeffd4e2b84366053ca01e-1730302293"
  },
  {
    "email":"giorgiotagliapietra1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618177402/8b86786e34b4028ca899b48d7b29e724-1730302293"
  },
  {
    "email":"s.mirmina@flexycom.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618111866/02de4ab46ebc3a4ac125f6ad7ded0d24-1730302293"
  },
  {
    "email":"rose1990@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618242938/693c19e8c9aa74a75dd47053b1068e3d-1730302293"
  },
  {
    "email":"alecsandra87@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618210170/c3b82dddb5f471c12e9b4f1eea710048-1730302293"
  },
  {
    "email":"achaiah06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618275706/124fdfb83f45e12ee26dd2c92258ac8e-1730302293"
  },
  {
    "email":"mariangela.daniello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618341242/f49e5c4b2c6cfd6aea8e61a42ba3a1de-1730302293"
  },
  {
    "email":"irenecuneaz@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618406778/e4ead81c8edc16d5244c40714f5b58ed-1730302293"
  },
  {
    "email":"monvigl@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618374010/5c4fb4d528d9f3ce6c4019cf3ce88be6-1730302293"
  },
  {
    "email":"c.buscaroli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618505082/5d9fe7b479c35b77774628438d4a9711-1730302294"
  },
  {
    "email":"simonetta.pasqualini06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618570618/d3738e86d244b4e3326aa3d191cf3ac1-1730302294"
  },
  {
    "email":"alessandramaniscalco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618537850/c030bbb2dba7d81499ddc6eaf86ebe37-1730302294"
  },
  {
    "email":"bvetrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618439546/74062f74d25e948227d8affdc8134425-1730302294"
  },
  {
    "email":"g.cambria9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618701690/bb1e4575b529e881c10e245cfa0b1fb2-1730302294"
  },
  {
    "email":"tbaraldi@alteanet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618668922/792648e8d411ab531363d145605cc92a-1730302294"
  },
  {
    "email":"claudiasenatore@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618734458/7deebdadaa3b1dab9c2b9d61e7758522-1730302294"
  },
  {
    "email":"isabela.hrizu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618832762/aeacf52a077a58f510d43b4b422119e1-1730302294"
  },
  {
    "email":"federicacassinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618603386/64696e1621b2e61c244f174731a6a6f7-1730302295"
  },
  {
    "email":"giuditta.gardin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618865530/7af58b311490917897e58d6e85c1f9a6-1730302295"
  },
  {
    "email":"massimo_marin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723618898298/f0f5f96528a1ce21a46009e8a7a3d181-1730302295"
  },
  {
    "email":"emanuele.bonomo@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22723618799994/b3ae3bcb7a8cdba33c43ca274bf63593-1730302295"
  },
  {
    "email":"liviaeffe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618931066/0bf3970d4b94c7881d17935e99ff135a-1730302295"
  },
  {
    "email":"francescatina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619029370/f241f296ccdb7041d105cb44275fe140-1730302295"
  },
  {
    "email":"antonellacusimano1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619193210/1a4bd7f02a81a0054ddb7bdacdad9e12-1730302295"
  },
  {
    "email":"mazzola.laura@studiomazzola.info",
    "url di attivazione":"https://verdissima.it/account/activate/22723619062138/cb1828ecb0b2f0cdbfced56da34a2ea6-1730302295"
  },
  {
    "email":"barbarabaroncini642@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618963834/beb7260cab6d20ce3042faf9518b23bc-1730302296"
  },
  {
    "email":"valentefederica2@gmail.comfede",
    "url di attivazione":"https://verdissima.it/account/activate/22723619225978/44de6eceaeb292887bbbabfe805453de-1730302296"
  },
  {
    "email":"fefo75@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723618996602/35e98399b66fdaba64ef21add4949a33-1730302296"
  },
  {
    "email":"alessia.puglisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619258746/570d2d374a5d29f3670dc329f9e54472-1730302296"
  },
  {
    "email":"ely121983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619291514/a3b53393ec1b8af333c71984f7b7355b-1730302296"
  },
  {
    "email":"alessandratansella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619324282/12ac6fb4519b05b29b28ddc6bc2afb35-1730302296"
  },
  {
    "email":"rfiorgentili@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619357050/22d87d92191a92c1fe78adb6c5118698-1730302296"
  },
  {
    "email":"raffavalentini03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619455354/56cf785414e5340a434834da34c4f3aa-1730302296"
  },
  {
    "email":"manuja68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619422586/dbc2420684b8947784fc3e768b1a8545-1730302296"
  },
  {
    "email":"paola.h79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619520890/aea61299b724f239568490cdb493953d-1730302296"
  },
  {
    "email":"archgiuseppinapizzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619488122/fe7a5e3d0ab421ed2d09f88a2a1ae224-1730302296"
  },
  {
    "email":"gadamo170@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619586426/c745153eaf4aaddc9eccc23336f3d2df-1730302296"
  },
  {
    "email":"thomas.beghelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619553658/a11f733cbc9de207ab96edac8c08c2d1-1730302296"
  },
  {
    "email":"elena.spinelli@policlinico.mi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619651962/8d401918e32cde4d75b05d76ea466acc-1730302297"
  },
  {
    "email":"chiara.turri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619684730/65cbc65664120c2c7b9090395b7a4a89-1730302297"
  },
  {
    "email":"axelgiudi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619717498/3adbe8eb442b80b4317af5dbe9cabd92-1730302297"
  },
  {
    "email":"federica.manfredini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619750266/999e5e80a6fada7e422f4550bcb4372a-1730302297"
  },
  {
    "email":"silviamarchetti4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723619881338/08c10188be0eac9dd48d82d9f980e962-1730302297"
  },
  {
    "email":"klaragulla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723619783034/d5953845979517852cf29a0d4bd8d665-1730302297"
  },
  {
    "email":"barisananna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620012410/00c596582ba5a9419774b0fd81f6e794-1730302297"
  },
  {
    "email":"sdellacroce64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620045178/43905af26ea5761add0f53481e31df41-1730302297"
  },
  {
    "email":"laurasoprano78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620176250/ab437d12cfc3f1dd78d8cc03fafbb593-1730302297"
  },
  {
    "email":"cristina.borgato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620307322/1874be3fd6e9b294fcdc4e3c7a90213c-1730302298"
  },
  {
    "email":"morettisilvia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620143482/e259e2e5434eefeb03155a6e1cccd2dc-1730302298"
  },
  {
    "email":"claudiatolini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620340090/38f45e37191f961198c823efb3133c69-1730302298"
  },
  {
    "email":"chiaramen80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620241786/ebf2d9c4d99eaec4c50e15e5c3a2288e-1730302298"
  },
  {
    "email":"ellis30vicentini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620405626/6f8f7357f57600b4fdb707215d8a323d-1730302298"
  },
  {
    "email":"elisabettaurlietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620438394/03a523cfc7f3065f8a388cf8f5bbf94c-1730302298"
  },
  {
    "email":"lorena2001@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620274554/4a1da123d4a4eae3d69180f22ee7fd22-1730302298"
  },
  {
    "email":"cinzia22564@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620503930/3f00dd43d84c8d61a31919d360aae194-1730302298"
  },
  {
    "email":"giulia.anna.guicciardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620471162/4c88beea5bd8902640d9c85cd55e5f38-1730302298"
  },
  {
    "email":"zanotti197333@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620536698/d4dc6dda7b966c4487c9d7cbd9ee59c2-1730302298"
  },
  {
    "email":"ale04011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620602234/de352b8469b424a696664f43d0937653-1730302299"
  },
  {
    "email":"silviadami@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620667770/32de93f29157bba4806b4e700d378187-1730302299"
  },
  {
    "email":"crisegu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620733306/64f6354fdd3c04ef1a7c27a782de56f7-1730302299"
  },
  {
    "email":"bovino@gmx.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723620766074/36076826087c3d414e86183d2a16b8b0-1730302299"
  },
  {
    "email":"jiojio89@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620897146/11fa73baf5ab65c3d3452494888569a9-1730302299"
  },
  {
    "email":"info@hotel-lesalpes.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620635002/ead5c6c2489e47bf97b09d7cee227ff2-1730302299"
  },
  {
    "email":"giulia.meoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620831610/0b648c1f93835f6dee7d20029398b1ed-1730302299"
  },
  {
    "email":"enricadallava@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620798842/04007624aba23b0d2dbe4fd6cd7df3f9-1730302299"
  },
  {
    "email":"c.boerisaruba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723620962682/0e36755081ddb5366c19ce851dc56985-1730302300"
  },
  {
    "email":"ombrettacampiotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723620929914/6c321781228c4fb6305204beab986c25-1730302300"
  },
  {
    "email":"rossana.dimarzio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621060986/0dd8a6b195519df04c075ac34aa01afe-1730302300"
  },
  {
    "email":"mmdrusiani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621028218/59dd8b0fee71d454fd4c77664b2f6b0a-1730302300"
  },
  {
    "email":"enricapiz@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621093754/f9f9c8b692fd62fea7636ba0036d6976-1730302300"
  },
  {
    "email":"elena.biscotti@studio.unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621159290/292a6f8974067368c22e440a01763689-1730302302"
  },
  {
    "email":"serramonica96@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621126522/7f3424a1a070a90e85bf883f90ea102b-1730302302"
  },
  {
    "email":"giuseppe.paone@bancagenerali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621192058/7e0f963c3fa37bded9ec355508464966-1730302302"
  },
  {
    "email":"angeladenaro@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621257594/069cbdb7f44f35480064b9a04c626886-1730302302"
  },
  {
    "email":"chiara.altini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621224826/5e0c7fccad6d7b48124f3d5b735671da-1730302303"
  },
  {
    "email":"francesca.maffietti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621355898/1ed1a748024fcf439643947f88f0d35c-1730302303"
  },
  {
    "email":"stefania.miele@mielemas.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621454202/b4c5729698c5f3b77c81a443f871cff8-1730302303"
  },
  {
    "email":"giuliana.bon894@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621388666/bd00c6071371bd2fc0fc0dc317114a70-1730302303"
  },
  {
    "email":"ericamalugani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621421434/b77113febe614b59bb771c03ca2113d2-1730302303"
  },
  {
    "email":"ele.milesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621486970/31ad2e76c34c08b06defdc217037b6fe-1730302303"
  },
  {
    "email":"letizia.zoppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621618042/ab0e912cc90bf1a1ab1ff58ec1faf827-1730302303"
  },
  {
    "email":"lauraolocco1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621585274/85239f7c107a315a686fb20f981e4155-1730302303"
  },
  {
    "email":"elisa.salandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621519738/35f5d73d50827c5d5dfbab99605b5376-1730302303"
  },
  {
    "email":"lararosta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621650810/256ffd59fad994d1206622f743b37c24-1730302303"
  },
  {
    "email":"scillamontani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621781882/8e3bec90ba4bf61923b11cd418356c42-1730302303"
  },
  {
    "email":"chiccagio78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621683578/f8a449d89d068bc7224a339473e60d8b-1730302303"
  },
  {
    "email":"dipietrantonioanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621847418/813952faea5812c595f4039cab5a655b-1730302304"
  },
  {
    "email":"pzanna59@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621880186/2f6f01358681bf7db8f3d94c6f74a4c7-1730302304"
  },
  {
    "email":"marcellabetelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723621749114/a297152316eacb36c39e3c2ce8a9b0ff-1730302304"
  },
  {
    "email":"emanuela.chiozza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621912954/7e7374e3a1465d8887e6eea0755ef35b-1730302304"
  },
  {
    "email":"amanda_vera64@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621978490/cb0d5d026b3e1f74ba2cb6fe9400f638-1730302304"
  },
  {
    "email":"lastefy62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723621814650/0118ac12af52199d42ac97cba0562cb4-1730302304"
  },
  {
    "email":"annaloel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622044026/aa4286090c439ab8e761b4392af32944-1730302304"
  },
  {
    "email":"serenascimeca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622142330/03e85e391ceaafcb3afa0dff19fc67ce-1730302304"
  },
  {
    "email":"mariliamaio1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622240634/a5c477bcb69528dd80b5e0dc824ae78c-1730302305"
  },
  {
    "email":"francesca.caprini@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622207866/0d310eccb2972e47b7f0914bb5d617c1-1730302305"
  },
  {
    "email":"lori.vargiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622109562/d3146bf53fd5c57599d502f2f5145ed2-1730302305"
  },
  {
    "email":"benedetta.vinciguerra@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622437242/ef7ae4942bd39e993d4c9c1138ff715d-1730302305"
  },
  {
    "email":"mebiasini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622338938/f15f366adcf2d8d59df5bc6c1fda94ce-1730302305"
  },
  {
    "email":"luoliva66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622306170/e6ba51a463173ca670297ef71637c91f-1730302305"
  },
  {
    "email":"valeriadanelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622371706/0ada2f469c72b9af582e46c6b6bed8db-1730302305"
  },
  {
    "email":"m.canterino@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622470010/02490b29981d299502fa7048af3ff015-1730302305"
  },
  {
    "email":"giorgio.chiarelli@pi.infn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622535546/8fcee390d05d0e7a2fab228b40511494-1730302306"
  },
  {
    "email":"manfredini@msw.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622633850/de1d564306c9f8c52c71489f9ad7c8e1-1730302306"
  },
  {
    "email":"vezzolifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622568314/95110d1d9f04f270e59a9075c9694737-1730302306"
  },
  {
    "email":"marilela@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622502778/42eaa6de6044ee81b937b09719adac0d-1730302306"
  },
  {
    "email":"angelapapalia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622666618/73db657253db47e7547e127b103f9a47-1730302306"
  },
  {
    "email":"susyio@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622732154/1c5812838554ae2c28d593e26e534b02-1730302306"
  },
  {
    "email":"serena.sclavo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622797690/d6d14bf7f65988f84dc6c102049d401a-1730302306"
  },
  {
    "email":"anna_bignotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723622764922/59990d3a5aa4b1642659246c5cf1d67e-1730302306"
  },
  {
    "email":"sarasaporito78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622699386/f92cb6376067382276efdf3dcaec8f4f-1730302306"
  },
  {
    "email":"christina.krey@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622928762/99617b91d7dc7ff05ef6ea1bd4523cb0-1730302306"
  },
  {
    "email":"arianna.certa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622863226/506042cd3d0eb704bbd7748e01e83bbd-1730302306"
  },
  {
    "email":"patriziaperuch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622830458/6c2b72774cf429993c7fde72aa02157b-1730302307"
  },
  {
    "email":"almapassante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623059834/945356aa527bbfd10a0301ff4644ec07-1730302307"
  },
  {
    "email":"ragozzinoalessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623027066/a94fada55c26a9b66ff1b0d004c20994-1730302307"
  },
  {
    "email":"e_cazzin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723622994298/3778da6de183e496cf748bd06e31fa69-1730302307"
  },
  {
    "email":"luisapollio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623256442/854235c18fd3fe494c02a387be57b0bf-1730302307"
  },
  {
    "email":"manuela.masotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623190906/063d8a80856983284f7cafdd96d90eb2-1730302307"
  },
  {
    "email":"scottodicarlodaniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623387514/9df6dd4d46f6f7a6f977cad43a5247c0-1730302307"
  },
  {
    "email":"massimo-girotti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623321978/59f58e63e13363e9cc07e5d4fbcc58d7-1730302307"
  },
  {
    "email":"maria_grazia_m@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623289210/ef250f6721e8b8bbe3305a64eb8fdbd8-1730302307"
  },
  {
    "email":"larosarossella72@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623354746/655ca214c753b1bc2b1fdab318de7e09-1730302308"
  },
  {
    "email":"claudiacosta91280@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623485818/52d843c07fc773bdf97fa227ba54626a-1730302308"
  },
  {
    "email":"freemel71@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623518586/929bff795d0b6f72529176eaa441de5d-1730302308"
  },
  {
    "email":"cristina.torella87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623616890/3cc209c26cc32031eae8c619bf42781f-1730302308"
  },
  {
    "email":"sardellale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623649658/95647a1f2723caca01f7db01fbe4b447-1730302308"
  },
  {
    "email":"danielanconetani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623682426/ea5b221f9f8f6abc3b7cda8c1b362800-1730302308"
  },
  {
    "email":"moon84@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623747962/f56d55e5d434b7e9605bff1a3cd55d6b-1730302308"
  },
  {
    "email":"orietta.omiccioli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623420282/b507eba407ac146410f21d3acb300c24-1730302309"
  },
  {
    "email":"albagrassi60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623911802/e15f856acfbc3e546e5ca4c0d4fa2b4f-1730302309"
  },
  {
    "email":"mocerino1@antofoto.191.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623780730/83940a02e2e79a6bea2c5d1166f6342c-1730302309"
  },
  {
    "email":"debbyshine@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623715194/c9cc9087a9aa81b4ea76824a4cecf4d7-1730302309"
  },
  {
    "email":"giorgiacigna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723623977338/4ae82eb9279ee840d011f28c53c7c073-1730302309"
  },
  {
    "email":"valentina.turrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723623944570/d3268a3aa3fa235357bb8a1aab3c8df5-1730302309"
  },
  {
    "email":"giomail1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624010106/af69da8ee8636fb4401a7138e7b45f62-1730302309"
  },
  {
    "email":"cap.walter@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624075642/cd7cd414c8fbd1171a7a30983b37d1c0-1730302309"
  },
  {
    "email":"a.veronelli@studiogv.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723624141178/faff12f52e944c8723bdf4251437d467-1730302310"
  },
  {
    "email":"paolo@forasassi.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723624173946/bab59c9e27cdfcc3b673c8ef1188babf-1730302310"
  },
  {
    "email":"simonetta.lobrutto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624042874/87bf3d2bf0bcf76d1a67125b086741d0-1730302310"
  },
  {
    "email":"annamarco08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624108410/e9f26ec4d23154ef3d0056df4c4a2b9b-1730302310"
  },
  {
    "email":"evita86@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624206714/7261cb2eee10926f74c21f66566874c6-1730302310"
  },
  {
    "email":"tizianaricco@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624239482/457f12d4f0ce99c6cd899728fe6fd133-1730302310"
  },
  {
    "email":"barbara.sanna@liceoazuni.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624403322/6a000392647ec4c45c6e7292b6393c8b-1730302310"
  },
  {
    "email":"andreatati2007@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624337786/ae3cbc467c26b2bad6d3165a7375dc84-1730302310"
  },
  {
    "email":"logiudice.margherita@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624468858/98862d3a43a194df901da47db079b843-1730302310"
  },
  {
    "email":"francucci59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624436090/935261ae143dcdca657e51cee180c969-1730302311"
  },
  {
    "email":"alice_mo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624534394/8d73e24965a61124a7222249bbe5fd82-1730302311"
  },
  {
    "email":"lucia_minetti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624370554/d4aac999a0314756f2f9b4fea21f08c6-1730302311"
  },
  {
    "email":"silvia.772003@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624567162/c53d1b0383f9f9c52efe9c9031112d3f-1730302311"
  },
  {
    "email":"romagnoligiulia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624599930/e80ea04116b91cd29906790f4e2b5c9b-1730302311"
  },
  {
    "email":"alessandra.paraboschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624501626/b2055f682108a825f11af2c04039e38f-1730302311"
  },
  {
    "email":"raffaquara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624698234/15c5a2ef0eec5e93632bf942da07a73b-1730302311"
  },
  {
    "email":"alessandrasilvestri84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624796538/01b3b4b72e45bca1f8c3439c354754d4-1730302312"
  },
  {
    "email":"barbara.mannai72@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624632698/e372afd3bd75799e7757f827616e19c7-1730302312"
  },
  {
    "email":"vgalimberti57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624763770/09c16feb9ed79fc41a0408a557e15683-1730302312"
  },
  {
    "email":"silvia.curione@giustizia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624829306/509dcb410baba9b0ed904f907ac31c91-1730302312"
  },
  {
    "email":"francesca.ragagni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723624731002/62e7eac4481f8a8af3895ebfbd4ed64b-1730302312"
  },
  {
    "email":"impossibile2016@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624862074/efafaa67cde4ef48546def80ced35503-1730302312"
  },
  {
    "email":"lalla_luglio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625025914/e3bc7af6eaf92aa42a3eb3447670b9df-1730302312"
  },
  {
    "email":"ylevshina2013@yandex.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624993146/7420b0cead16a16dbafe7aad98907c13-1730302312"
  },
  {
    "email":"ilaria80.andreoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624894842/1346402dbfd7bc4c1747cac99895357b-1730302312"
  },
  {
    "email":"disalvo.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723624927610/af27dd2323e849a79d0907c1b4eb2358-1730302312"
  },
  {
    "email":"nakupenda_123@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625058682/3f5ec3b4e31f2990cd5c9f31707ab508-1730302312"
  },
  {
    "email":"shaila@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625124218/60945a297f22414b330d490d74ca7208-1730302312"
  },
  {
    "email":"angelica.mastro@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625156986/b07acdcdaf58b48ece8cc6e0479b2318-1730302313"
  },
  {
    "email":"terryammale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625222522/12e3cb0334c51e90385a392f1f33ec04-1730302313"
  },
  {
    "email":"stefaniasavarino1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625189754/1243eaf6435854bcc133fab39df66959-1730302313"
  },
  {
    "email":"saraste1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625255290/867adad29cccd956abfab4473d13e027-1730302313"
  },
  {
    "email":"alessandramalatesta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625320826/d251fbe8fe44af142f1b1d5e4768c74b-1730302313"
  },
  {
    "email":"giorgia@footprintlegal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625386362/8a267daab4547882759960569a878d7f-1730302313"
  },
  {
    "email":"salcriscuolo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625484666/54f8ade999da34d3d9cebaaf264b3268-1730302313"
  },
  {
    "email":"nadiamaccor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625451898/148f140e0184ae8cb9ec408ed5a49ad4-1730302313"
  },
  {
    "email":"pintuccimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625550202/94b019bbea3fae6b66ef6f4724ca6066-1730302314"
  },
  {
    "email":"patriziazocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625517434/ff18d633078a8324faa43db723bb4125-1730302314"
  },
  {
    "email":"silviazot66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625582970/58013d197eef2e74b3c16eaf92d2b73d-1730302314"
  },
  {
    "email":"claudia.deste@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625353594/8e8a884efef6697522639473d4fb5f4a-1730302314"
  },
  {
    "email":"germana.troso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625681274/b03719681aac32e1f805ded43179c36c-1730302314"
  },
  {
    "email":"manuela.bonino@faicindustry.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625812346/aace93f0076464002f51fe8d1eceb887-1730302314"
  },
  {
    "email":"pontoniteodora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625845114/b35c1430e8fe07a00d105f2f8b57557e-1730302314"
  },
  {
    "email":"siltin72@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625714042/2f5075fa35ee5db36fd028cfae1f5f94-1730302314"
  },
  {
    "email":"mletizia@studioassociatomonica.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723625910650/9ae41abf2ab1566ee93dd008778eb440-1730302314"
  },
  {
    "email":"branca.cecilia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723625976186/ba21061df26535bbbf7dee428529feda-1730302314"
  },
  {
    "email":"irene.trevisan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723625943418/d12bac3d1f5cafdc5107d5095c3ce8c8-1730302314"
  },
  {
    "email":"enrica.bazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626041722/e2fc197a503daf8443c70d0c5271bd16-1730302315"
  },
  {
    "email":"seralibrandi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626008954/263d2d04c20cf8fdcf66efe2404c9980-1730302315"
  },
  {
    "email":"nathalie.vandoorne@yosoyformazione.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626172794/f7e2e204f3edec28db970e4b9fdeaac3-1730302315"
  },
  {
    "email":"frida.montefusco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626107258/b22418dd6d6ca023e49509a1e04319e2-1730302315"
  },
  {
    "email":"caterina_susini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626271098/3e7744e0c98cd670130c258896132fdb-1730302315"
  },
  {
    "email":"sciaccasofia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626140026/7f7de6bc61a5bea853b8e8d3d7e9689d-1730302315"
  },
  {
    "email":"emanuelaforconi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626369402/54392609aeffa1940e538ab9fa067589-1730302315"
  },
  {
    "email":"gioacchinogiannelli9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626402170/70de19768ded3e351616f2cbef90e96a-1730302316"
  },
  {
    "email":"f_gentilucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626467706/02ba3215393dfceabccc5fd93f0f2095-1730302317"
  },
  {
    "email":"maggiemely@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626500474/da2c3f5643c6e879ed722070cecb2abe-1730302317"
  },
  {
    "email":"denise.tronchetti@gucci.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626566010/e6bda4840aa1a8c08061810e601ea6e1-1730302317"
  },
  {
    "email":"battasi.giovanna55med@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626598778/26f98ab41e9ae200d70ca4c264a70800-1730302317"
  },
  {
    "email":"emily-951@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626697082/4f43e80e092cc4968c612cdea0fadca3-1730302317"
  },
  {
    "email":"sergio101it@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626664314/af9e7c63aa19fbf666660a824e0e8d22-1730302317"
  },
  {
    "email":"luisapanaro@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626795386/6b9ab0d0820d4fecc20499a81ab89189-1730302317"
  },
  {
    "email":"giulymax82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626729850/9468a19bfeb8b19e1148f24b144735e7-1730302318"
  },
  {
    "email":"m.nanetti@aci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626860922/6c3043972efcac9a3848578ee4f23f07-1730302318"
  },
  {
    "email":"alessia.consultel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626762618/8d4381372c77f7904213a552d15eec4f-1730302318"
  },
  {
    "email":"monia.merlo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626828154/0b714b4c7d7e8b728184b8f0ec94ad23-1730302318"
  },
  {
    "email":"patriziapolia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626893690/b13f2186d1897f60c97d94688125e57f-1730302318"
  },
  {
    "email":"osti_paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723626959226/db9477fef1574b865a5755268fa8d1fa-1730302318"
  },
  {
    "email":"mgd78@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626991994/b8560fb65e7024c456e384785ebf6dfd-1730302318"
  },
  {
    "email":"annagallostampino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627024762/6f7259dd5163c511c04f409b1bc26c02-1730302318"
  },
  {
    "email":"iaml@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627090298/1d8ab9c38f2d08b842fae48436f8fe0a-1730302318"
  },
  {
    "email":"lussorio75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723626926458/5d2665aada1e1a8ff28b811aa122cdb5-1730302318"
  },
  {
    "email":"pachetto62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627123066/b4b1accc4db8ce5918389da08d723d7e-1730302319"
  },
  {
    "email":"ilaria.fredianelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627286906/b303a0dbb412393c9f7a91b985300af6-1730302319"
  },
  {
    "email":"patrizia.accattino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627221370/b21c46ddfc196ad1d4f0c4bc3adb8551-1730302319"
  },
  {
    "email":"mugnalu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627319674/37ec835f594a1ad7563a5890906318d8-1730302319"
  },
  {
    "email":"luciaingenito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627352442/c42ca62e5e615d18b9451f2c70115dc8-1730302319"
  },
  {
    "email":"annap@alice.sm",
    "url di attivazione":"https://verdissima.it/account/activate/22723627155834/5c9a30390296a9e306dcf40163e23e9e-1730302319"
  },
  {
    "email":"laramarilena@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627549050/e72c35474dd4aa0310a5d13863453fc3-1730302319"
  },
  {
    "email":"gemmastasi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627516282/c6baf64541075f964143c9b78b8388f6-1730302319"
  },
  {
    "email":"x.net@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627483514/ee87f3d3d843c2180cc72bf2c6acec76-1730302319"
  },
  {
    "email":"infermiere84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723627450746/5489c531cd360f31da0c57a64d7cbce5-1730302319"
  },
  {
    "email":"ile.mocali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627581818/69d42d486a7f63b2bb9ec9698407b095-1730302320"
  },
  {
    "email":"sissicolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627712890/ae21a3c805b6969f558809310b40eb4c-1730302320"
  },
  {
    "email":"lilla.zampini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627680122/cf2b8261c6d98d8265c2898804c7c454-1730302320"
  },
  {
    "email":"veronica867gz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627843962/0fc88966bf5507582b6e7386232589c1-1730302320"
  },
  {
    "email":"antonellapiccirillo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627876730/22a939bc6d4e24a157c19bd41056f0e4-1730302320"
  },
  {
    "email":"vanilor13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627647354/898d599748ec376d6980561974dd1581-1730302320"
  },
  {
    "email":"graziaserricchio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628073338/80c35a41692e9a18d59a033caee7ea68-1730302320"
  },
  {
    "email":"giorgia.guazzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627942266/19817bb5d6d3913e1206b37a0ab0d091-1730302320"
  },
  {
    "email":"claretta1@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628106106/65215a836d6417d448a2d98cc117b7b4-1730302320"
  },
  {
    "email":"angelaguida09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723627778426/0970f2bb0bdf27098535007c6130055e-1730302321"
  },
  {
    "email":"silviaolivelli64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628204410/b59a203129d0d100790678b265bcfa88-1730302321"
  },
  {
    "email":"moenia.delsorbo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628302714/2cfde6408bb7950a3fe3b96613ba19bb-1730302321"
  },
  {
    "email":"mdelsorbo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628335482/75c25239f985358451c6dc60b5967821-1730302321"
  },
  {
    "email":"milearamini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628368250/4a54b6e2ddfa4670fa965cc8cd48ef4a-1730302321"
  },
  {
    "email":"carmela_cm@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628401018/1023dfe54c3589fe7d5d49e869a394e7-1730302321"
  },
  {
    "email":"lory83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628171642/8b11da2e609e9c80693f8e3665b7183d-1730302321"
  },
  {
    "email":"rominasalzano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628433786/39f938b617d24b8dabdfcd93a2faa63f-1730302321"
  },
  {
    "email":"lucia_incarnato@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628466554/d1adedecaed4c92dc4a4d6ab58db19fa-1730302322"
  },
  {
    "email":"cpietrantonio2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628269946/4fc03a2f9f0d8c0f5e928da75b0c9b4a-1730302322"
  },
  {
    "email":"alessandro.rillo135@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628532090/ba1a23a2edf25b13cc47b6c24a69aec8-1730302322"
  },
  {
    "email":"gagnarlichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628597626/9fb39df028aa2754045105b4144a2ca7-1730302322"
  },
  {
    "email":"silviamonchieri@infostudioemme.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628564858/2017822e76a38e5a9edaf7243ab8a53c-1730302322"
  },
  {
    "email":"paolarosaria.tarricone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628499322/9c729c1e83f4df4903fb9d8ef2ee63bc-1730302322"
  },
  {
    "email":"danilolatini65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628630394/8d5046c8df12772998a0765b3c3e3f68-1730302322"
  },
  {
    "email":"laurapatriziacagnazzo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628761466/2e21588f214bd982043b8ba1cb8763dd-1730302322"
  },
  {
    "email":"sabrina.conte@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628728698/ae5dcc60f0627dfbc29cd3dbd4fce897-1730302322"
  },
  {
    "email":"claudio.piana@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628827002/0dd4993fd757b26f4f0e7ea01883ecbb-1730302322"
  },
  {
    "email":"cinzianenciarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628925306/27f243d9d2065695f638d8a1b5ca81e3-1730302323"
  },
  {
    "email":"diletta.tabacchi83@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628958074/baf13fe35f6e0d1ceecf619ba2cc3370-1730302323"
  },
  {
    "email":"c.paola.c70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628892538/e177dedd3d5273f722ce0414d44a49e1-1730302323"
  },
  {
    "email":"marinamontanucci26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723628794234/e79e389210cd62c2ced8fd6882f7a634-1730302323"
  },
  {
    "email":"vannys1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629154682/eeebd55834b5942412c6e22b9742a6c3-1730302323"
  },
  {
    "email":"sabrina.carboni@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629121914/71b2ba38419e2824d7d83c8aa34bcdf8-1730302323"
  },
  {
    "email":"maryp_87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723628990842/9e3092d66396d1187d0731b3fdda9d32-1730302323"
  },
  {
    "email":"kokomanilola@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629220218/d4539a02961672d6cc913fedcac00985-1730302323"
  },
  {
    "email":"matteo.verga@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629318522/f00aa01fb4795d073423776dc8797f71-1730302323"
  },
  {
    "email":"s_p_i_r_i_t@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629187450/e8c5a8e90f232e56514c5012265fff6a-1730302324"
  },
  {
    "email":"gos.cristina76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629351290/31cdc88633eca467a4d8ebaf668d01a2-1730302324"
  },
  {
    "email":"angelacarapezza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629384058/434990de5f1a53e81d97b27840b348b2-1730302324"
  },
  {
    "email":"agatamiceli1985@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629482362/f25ad3362ccaea85ae0c65f0e2f2ea79-1730302324"
  },
  {
    "email":"valeriodoctor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629515130/7956a096a1acf0550113924282b09c0c-1730302324"
  },
  {
    "email":"angela.serafino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629547898/ce127edb4622dbea31a4828a5fc7c926-1730302324"
  },
  {
    "email":"donofrio.mt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629580666/5c03cf5c8bfc5bcbfe067d0e05ea3212-1730302324"
  },
  {
    "email":"luciadelogu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629678970/78e5d7bf24daaad507ecb62609ea1e8c-1730302324"
  },
  {
    "email":"elena.porty@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629711738/b9c34eb8367fa4d40f68e503e314dbca-1730302324"
  },
  {
    "email":"sara.nicola@stellantis.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629744506/f2fa1681b74b75ebd6ad3afa80533d3a-1730302324"
  },
  {
    "email":"danielabuscetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629777274/bbe893af2d9f39011f83a3c6614c922c-1730302324"
  },
  {
    "email":"paola.vacchiano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629842810/fc99be1c46ef43c9256a59c542657503-1730302324"
  },
  {
    "email":"info@morlicchio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629810042/f09297d8704069a65915fbe0fcf5413c-1730302324"
  },
  {
    "email":"six1984it@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629875578/b017624f94b9794b1c5231aaca3dd5ba-1730302325"
  },
  {
    "email":"linaferri73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723629973882/e652247d901bc92bb2550a266ec404c0-1730302325"
  },
  {
    "email":"milena@edilcommerciogroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629908346/1f53632eb761d0bb1ac20e3582998914-1730302325"
  },
  {
    "email":"virgirom@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630006650/9d361af9f449294c09f9835a16854ae4-1730302325"
  },
  {
    "email":"i.dacca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630039418/9e59595e74bfb51dbce60b8b6f00d8d8-1730302325"
  },
  {
    "email":"opaschielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630104954/feefbb911714518893d83da71e5eb435-1730302325"
  },
  {
    "email":"lisabianchi1999@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630236026/6ad5b2b5507e306fc0d925008aa57e81-1730302325"
  },
  {
    "email":"ariannatonetti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630170490/517a61d2cf409226db476091b5f6acda-1730302325"
  },
  {
    "email":"e.daniela1984@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723629941114/48e150bf1d9936ed7abc50aea002349d-1730302325"
  },
  {
    "email":"fedebx@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630334330/cb3f58f44d6e96cb3fb38f871a12c648-1730302326"
  },
  {
    "email":"danielacapolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630268794/a05b546aa7cddc69f106037e3ce12fe1-1730302326"
  },
  {
    "email":"studiolegalelorito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630432634/63fa9beb999dcc541044c4a76ad74564-1730302326"
  },
  {
    "email":"elena_mistrorigo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630399866/d629ba6aed4236632425bca6a563ea12-1730302326"
  },
  {
    "email":"alessandra.carmanini@coopcst.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630465402/e05f580b1f2cfe5f1aa499e303e4e6b1-1730302326"
  },
  {
    "email":"anna.biscozzi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630498170/3e85c766a7d20612d294335035695309-1730302326"
  },
  {
    "email":"antonellagaggiotti45@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630596474/ad6c105847fb9fade8ae691719e76e76-1730302326"
  },
  {
    "email":"paola.cancellieri@enel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630530938/4b68e79c31b1f59c757d0b54fbad68f1-1730302326"
  },
  {
    "email":"paolo.montini@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630629242/41917b6be8ca3ce861ad6ff44b262fb6-1730302326"
  },
  {
    "email":"olimpia.frapiccini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630727546/05399f283d64051f634c32ac4665c267-1730302326"
  },
  {
    "email":"cristina.faggiolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630694778/04cea4b68f86ccab009a2304e3c5b3df-1730302326"
  },
  {
    "email":"danielab79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630760314/5bfd8d659502c933df61688303500d11-1730302327"
  },
  {
    "email":"g.panteca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630825850/5b10add248c7e82f9a592163983e1b7e-1730302327"
  },
  {
    "email":"elisabetta.raggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630662010/69dae7e81c2afc79fa43590a5a62fe92-1730302327"
  },
  {
    "email":"amministrazione@mogliani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630793082/b2f005254de569ffce58d034bfbc72f3-1730302327"
  },
  {
    "email":"luciana.lattanzio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630858618/66a8e35483f556817b2565ecb40e2c9e-1730302327"
  },
  {
    "email":"margheritalacava@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630956922/2dec7d74b48dbb6e5891f1b543fb4b97-1730302327"
  },
  {
    "email":"luigialaterza4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630989690/504e1614261383b15e5007df8578c058-1730302327"
  },
  {
    "email":"dedaluscassano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723630924154/9ab860b694fb300970d91536948ca0a9-1730302327"
  },
  {
    "email":"beatricegatti32@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723630891386/9c0e2c03d42f0704584e5c25775d7a79-1730302327"
  },
  {
    "email":"saralspace-news@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631153530/44aae0519ab6405d87df9cfd862c29ff-1730302327"
  },
  {
    "email":"elena.bruzzese@bruzzeseuova.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631055226/2e5add3243ccb8a38bb3df3b97a8e2db-1730302327"
  },
  {
    "email":"graziafranceschetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631186298/7ced30633907a7b0057b4b068e838940-1730302327"
  },
  {
    "email":"magliulo.elisabetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631022458/0ed316b501d3a98d2c2844e5ef2f3231-1730302328"
  },
  {
    "email":"alessi.deidda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631251834/b74780723d902b9a33d40ebf617e47b6-1730302328"
  },
  {
    "email":"liria74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631219066/3bea05be7836d1d4d8f51303d29d56da-1730302328"
  },
  {
    "email":"centolagiulia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631382906/f22b8e33bd249d40e8391e642fb296e4-1730302328"
  },
  {
    "email":"energia1962@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631415674/569e3358f223c24edac2a316fbf0cb03-1730302328"
  },
  {
    "email":"milenacirillo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631317370/c4c7a030c1eeddca063c2d25276290d7-1730302328"
  },
  {
    "email":"marco.adobati@telecomitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631350138/88cdd8d4b246a929c34d0ec0d5df9054-1730302328"
  },
  {
    "email":"laura.galli.1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631448442/76b47bca39220cc3ac72bb361c159e2a-1730302328"
  },
  {
    "email":"rp200813@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631481210/00bb6239c67cd60c09065ff3194360b5-1730302328"
  },
  {
    "email":"francescapogliano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631513978/3fb510863c0bbe12aa74fff4edbc2382-1730302329"
  },
  {
    "email":"anna.capparini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631579514/ce1b45e3b90e5768edd7804a5a3a3375-1730302329"
  },
  {
    "email":"niecla@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723631645050/23381522e5e03ca190e39c659112d9b9-1730302329"
  },
  {
    "email":"gabzos68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631677818/c277621a64933688da463385d0795622-1730302329"
  },
  {
    "email":"pietrangelok@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631743354/5191d546817bb7be3c75d567854c8a65-1730302330"
  },
  {
    "email":"cristinalazzerini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631874426/0c26c3f1ae89f33d5a3edb1303c96d95-1730302331"
  },
  {
    "email":"nuzzoivana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631776122/e29942be93f149fa663649d294cb8841-1730302331"
  },
  {
    "email":"antonellabonfogli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631808890/f0b347b1a8e375b3da5dacb2e9b4844a-1730302331"
  },
  {
    "email":"rossi663@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631841658/8e05f90c01f4b19a7d574369c82629ee-1730302331"
  },
  {
    "email":"marzia.roda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631972730/dfe7b6ef8d0887e18beed107ce17af88-1730302331"
  },
  {
    "email":"chiara_borgia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723631907194/6946c7cad3bcdf27ec9f33cb682adb62-1730302331"
  },
  {
    "email":"laura.rossi2661@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632071034/5d0de0f21bd20db9e770943e83295bcc-1730302332"
  },
  {
    "email":"annalisabonavigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632038266/6818b64001f0b871af4c8052280076f7-1730302332"
  },
  {
    "email":"francesca86aquino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632103802/c901d83a432a6142dfc10714eedc8cdf-1730302332"
  },
  {
    "email":"annacano2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723631939962/e8f8c9623495f1a0f7a0d6b10f97b9c4-1730302332"
  },
  {
    "email":"mongiovespa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632169338/5e2c66c28049339f2ef01739414e42de-1730302332"
  },
  {
    "email":"cristinabrandolini18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632136570/91caeac4924e2dc90897fb20a6e11cb8-1730302332"
  },
  {
    "email":"benedetta.franceschini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632005498/e752b3867c825f3bab888d8480eb8761-1730302332"
  },
  {
    "email":"brunacialone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632202106/e4e4e08e612dfd0b2ddc4b2d416114cd-1730302332"
  },
  {
    "email":"cfrassica74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632300410/018cda352426d8c2262e93123fa19a1d-1730302333"
  },
  {
    "email":"patartom@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632333178/d35547423c21638b0d979f778e371202-1730302333"
  },
  {
    "email":"angelazarrilli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632267642/2f57655ebd6b6b323708556df0190861-1730302333"
  },
  {
    "email":"cvono0@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632365946/ac1d86306162abc3ef33300ecf3830f4-1730302333"
  },
  {
    "email":"carula.mur@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632234874/aea680f1ef5496861bc3a1db80219456-1730302333"
  },
  {
    "email":"valentinadonzelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632431482/3170fde17a47121a543b481c18623c1a-1730302333"
  },
  {
    "email":"coin.sandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632529786/2f53b0d8b70e5c767993ce66870ad40c-1730302333"
  },
  {
    "email":"elisabiotech@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632562554/4919637a8503d54e7bb92c3fb28e222b-1730302333"
  },
  {
    "email":"francescaviglione@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632726394/55df190f1a9dd4ee9e9c96e6cca6098a-1730302334"
  },
  {
    "email":"vezzoliromina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632398714/294d7a4a44150a600c2a08c02bccb0c8-1730302334"
  },
  {
    "email":"nadalini.giulia27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632628090/53517ebb6d60c54c9556f8c74b671dda-1730302334"
  },
  {
    "email":"antonellamartella17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632595322/ff546a8175c79b42fed35c5029fb4af7-1730302334"
  },
  {
    "email":"elviromita@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632791930/b5b3ab07aadbdcbc71d49648f36fef6a-1730302334"
  },
  {
    "email":"francesca.lafarina@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723632890234/4a5f8c2fce44023151b93b3332714404-1730302334"
  },
  {
    "email":"elena.peroglio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632824698/57bea61f5d41bbb3d8f692657c1bfc2c-1730302335"
  },
  {
    "email":"maria.giulia995@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632923002/c6917811be36f87ca47df397b5a99a98-1730302335"
  },
  {
    "email":"daniela83firstasp@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632759162/eb4ee0709fb38dcb4e765161ab4cade0-1730302335"
  },
  {
    "email":"margheritalorusso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723632955770/e7b4ffd041627542f632e8bafb9d13b5-1730302335"
  },
  {
    "email":"alessia.lupo.87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723632988538/3e7513e63828289e701934be2854eda3-1730302335"
  },
  {
    "email":"barbara.lampariello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633054074/8596480cb37d8477f44407d3cc1122a4-1730302335"
  },
  {
    "email":"rmgargiulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633086842/5fb8486cc1e9852a95d00d9102e0c397-1730302335"
  },
  {
    "email":"alessandra.frisco1998@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633152378/26f099785f710ce67db4aab97439937e-1730302335"
  },
  {
    "email":"mirtabusi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633185146/a8368f1ef2877389cb68b042fbf6584c-1730302335"
  },
  {
    "email":"eugenia.carrieri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633217914/35827ac7b5d58b3e5914b6c987d2bbc4-1730302335"
  },
  {
    "email":"venasabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633250682/1365160b93bedfe38a94a6744db41c0f-1730302335"
  },
  {
    "email":"barbara.bondi18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633414522/0e6761f3e2f607df7f8994ca9068afe5-1730302335"
  },
  {
    "email":"martinacanta76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633348986/3a157059b6ea350c655c0cfa446e793d-1730302336"
  },
  {
    "email":"moneypenny.cm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633447290/c715f491cb98fdd182593ada7b41d002-1730302336"
  },
  {
    "email":"sarabrollo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633480058/d1edb8f4c096269870c287bd8500480e-1730302336"
  },
  {
    "email":"cristina.r07@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633381754/575fcca0ed10df80dd91b3c9b3354768-1730302336"
  },
  {
    "email":"farina.margaret@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633643898/4d115b06ecb7f0049979a15b2982134a-1730302336"
  },
  {
    "email":"nicola.chiarappa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633578362/bf55b35c2904492eb9e29c2a8e9e6a8e-1730302336"
  },
  {
    "email":"daniela.tirapelle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633709434/62c0acbc66a773cce2d4e11af1ac28aa-1730302336"
  },
  {
    "email":"sdipane@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633611130/69449adf5e7c6c5fe9ebfd247ea2cc75-1730302337"
  },
  {
    "email":"stefaniasammali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633742202/557841d38e20ea0f29219bf3a27970a6-1730302337"
  },
  {
    "email":"laplacaalessandra.si@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633774970/e8561c3b30b22df788d28d4d4afa3583-1730302337"
  },
  {
    "email":"melis_simona@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633807738/ad10376a46db7f2e4e98716c7653990a-1730302337"
  },
  {
    "email":"cristina.stra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633840506/a3bd1a1a4cfee4ec5c940c6a09ab3629-1730302337"
  },
  {
    "email":"giadabonavino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633873274/423f90d2de919736e087a47eef9c64ef-1730302337"
  },
  {
    "email":"lauristefania77@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723633971578/96679921297e520d50f3f43adbb6b343-1730302337"
  },
  {
    "email":"79.giorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633938810/621ef9ab19475414b222b25f8fedbb7f-1730302337"
  },
  {
    "email":"benedetta.setta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723633906042/877d69a35d6e0dde0a4e13c33133c51c-1730302337"
  },
  {
    "email":"silviasusin@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634135418/5e41e6ae413f0551814dab948697b300-1730302337"
  },
  {
    "email":"valoppo71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634200954/39c2b9af8275f4404c158de6bb7d3243-1730302338"
  },
  {
    "email":"elvirasordilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634168186/cd89b6c4765354fb6da38e4ae038a47d-1730302338"
  },
  {
    "email":"menapappalardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634299258/46dd6c5abbc7417660073b86989f5714-1730302338"
  },
  {
    "email":"armidadimicco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634069882/9b4275e14e0cc07ab55887f9354f0d23-1730302338"
  },
  {
    "email":"elisastef@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634364794/7e7bfef787c0b45ccfa2845f89c75c8b-1730302338"
  },
  {
    "email":"chiara.fornarola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634266490/d32badee8f48802e6f5f0a0d53fe0f3a-1730302338"
  },
  {
    "email":"sminella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634397562/1b52e3786f9469a9a00d9cc30a941031-1730302338"
  },
  {
    "email":"simona.divalvasone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634495866/56471c17955f8234128c3d6eb8f2c448-1730302338"
  },
  {
    "email":"maximo125@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634528634/c2547be3167114df39038b774ec82d6a-1730302338"
  },
  {
    "email":"aclaudiam24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634561402/877008317fe19854f47bc2dd99ccf669-1730302338"
  },
  {
    "email":"enrica.strazzabosco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634463098/c8a94a93ea6effa203a00a29ac7b4497-1730302339"
  },
  {
    "email":"info@ilchiostrosiena.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634594170/e9502097d4be1822289a88d4fe2a9100-1730302339"
  },
  {
    "email":"melaiucate@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634758010/f7593846787bf4d2f6d61bfcb832d444-1730302339"
  },
  {
    "email":"soniacantarelli83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634626938/0e726786f9ef918dd0ed8fc2c0c16d41-1730302339"
  },
  {
    "email":"annagilc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723634856314/f7d174840e8873ccbf1647c8e0161b29-1730302339"
  },
  {
    "email":"martagalletta.rg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634987386/c322bcde46bcef6fd38c2a1535f5d866-1730302339"
  },
  {
    "email":"cmaggiora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634659706/641f4cfb3048bf7eae306d754182301b-1730302339"
  },
  {
    "email":"cla.magliulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723634954618/204330a1fc28294dc723f119303370b8-1730302339"
  },
  {
    "email":"giulyy@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635085690/dca3d687e42b0b83738b0a6562ff10d9-1730302340"
  },
  {
    "email":"nchiorlin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635151226/199450be19e8e661aacd3d88031a361e-1730302340"
  },
  {
    "email":"piras.paol76@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723635020154/fe690108378f70c223e5bb96e45cf0f7-1730302340"
  },
  {
    "email":"laura.bernardini74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635347834/4566d34465e56c4245df79c152903292-1730302340"
  },
  {
    "email":"gennyanello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723635315066/41d4f86f10db5a75882bf4b8ee10eee3-1730302340"
  },
  {
    "email":"alessiamagnanelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723635282298/ebf5107ed779a01bddd097321bdc3196-1730302340"
  },
  {
    "email":"lamendolalucia82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635511674/ba6a9e5f61a2c86128e8f689b783b905-1730302340"
  },
  {
    "email":"angelasammarra1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635413370/3d0b2d4a25db8dbf45ad154bd26fc3f0-1730302340"
  },
  {
    "email":"daianaciciriello@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635544442/1a4787654ece26c9b1e93f9c49c75cbe-1730302340"
  },
  {
    "email":"danifranci69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635249530/a713a7d9e077029e57db4b7ff6dc2459-1730302340"
  },
  {
    "email":"gina.diapico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635446138/c65e209b1df417348d88661326295a55-1730302341"
  },
  {
    "email":"studio.donegana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635642746/2c05480872233b4bece48c792af2de24-1730302341"
  },
  {
    "email":"gerardostillo@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723635675514/a1cf801cad753360fca069b74d5a7f96-1730302341"
  },
  {
    "email":"macriale77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635773818/1153ec878bd9bcc0ea52fcd3f9ce14ba-1730302341"
  },
  {
    "email":"roselisa6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635741050/74b42abf6ae3654d0d0a03a8658a9288-1730302341"
  },
  {
    "email":"kimberlyschelfi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635609978/06f9c1aa2c94adf03f0d46eb0a0df1d0-1730302341"
  },
  {
    "email":"elena.savoldi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723635806586/f944a24213febdbaea3cb49d996cb376-1730302341"
  },
  {
    "email":"sabrinascroccaro71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635839354/d5af60f93c3487c50b828816719d6abe-1730302341"
  },
  {
    "email":"terryverdirame@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635904890/0165ac4a1e1b77d12859e13df29d8082-1730302342"
  },
  {
    "email":"ficco.letizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635970426/7cb0e2be274464c9630d5e7ab38d8c53-1730302342"
  },
  {
    "email":"robertapippucci67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723635937658/6a97c9503eb7ea1ba944ffa9edbc972a-1730302342"
  },
  {
    "email":"ginomangano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636068730/2d68ac72a0b8e2645efb717086d5c90c-1730302342"
  },
  {
    "email":"ilaria.becagli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636003194/b88c8dd10a10fb14dfb0fd2e3f7b04cc-1730302342"
  },
  {
    "email":"chiannalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636035962/fea913639d6e4c0ef7543aa4f7824ef3-1730302342"
  },
  {
    "email":"donata.santato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636134266/2598838b63522b0e5f1af7164951ad79-1730302342"
  },
  {
    "email":"michyberry@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636167034/ad054c5a0d95848dae165b8dc8ee1878-1730302342"
  },
  {
    "email":"paololoi@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636298106/1dc14c7a9ecbd72335ef3a16adea7b6c-1730302343"
  },
  {
    "email":"dangelo.giovanni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636265338/202c0d8c5b21e2e43c769879f5cdf350-1730302343"
  },
  {
    "email":"giustinabaratta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636199802/0b7b20769496639e52bf6650ab245a65-1730302343"
  },
  {
    "email":"alice.bonomini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636330874/4068f8d415b5d5e9447d79a110e52cf9-1730302343"
  },
  {
    "email":"scaramuzzomara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636363642/dac71f2ba88687b2d03a947430e47414-1730302343"
  },
  {
    "email":"czig1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636396410/35f561913b3d40df8e3b0620202813fa-1730302343"
  },
  {
    "email":"ef1973@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636494714/5d9dd3630daf47dda2cd542ff39c6dc4-1730302343"
  },
  {
    "email":"giulypis@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636429178/059f637fdc104e54cb1530822aee0335-1730302343"
  },
  {
    "email":"mflabrozzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636527482/7a131db9cae2cb3e878f7d5e97bd1f7c-1730302343"
  },
  {
    "email":"nadiaruzittu@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636593018/f0b3eef194b471e4920fdf1a131ebd4a-1730302343"
  },
  {
    "email":"fgulino1@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636691322/81bc2e3e3d57fb9c85576e87600dfedc-1730302343"
  },
  {
    "email":"emiliagraziarastelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636658554/87b5d15a4b8029cd7b3529ba70633456-1730302344"
  },
  {
    "email":"gangemifede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636724090/2650586b6493b03290d18d8360329ba5-1730302344"
  },
  {
    "email":"sara.gaiardo@matrix.to.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636756858/a48eddb583a832ff768e41cd594eb9c5-1730302344"
  },
  {
    "email":"ecostanzo0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636822394/b963b2b6368de20626678076f4e27dd6-1730302344"
  },
  {
    "email":"silviapire81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636625786/182376b20de1ae1bf4f675ccf3a0f2e3-1730302344"
  },
  {
    "email":"laura.parolini.berardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636855162/002b15acd5906428db7d1aa2f19f3169-1730302344"
  },
  {
    "email":"giulia.cornelia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636953466/6f1a793e186b0f035c77cd367d64dad7-1730302344"
  },
  {
    "email":"barbara.davico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636887930/c9fd38821cc898381f19e11398fbb37c-1730302344"
  },
  {
    "email":"pegasoglad@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723636920698/21f4e5df950ef980bf94d56df6856dc9-1730302344"
  },
  {
    "email":"arianna6997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637084538/3cbc1fd5091dc86686f66cbd7f471204-1730302346"
  },
  {
    "email":"rosimessico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723636986234/38e84be5413a5896a2b6a116af55c193-1730302346"
  },
  {
    "email":"simosic.ss@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637019002/afc3a56507ae65801c085e6ba49fc903-1730302346"
  },
  {
    "email":"elvirarom@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637051770/ca57daab6cd4adf70becfee131d7db14-1730302346"
  },
  {
    "email":"giloman@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637150074/d2a25295e5231922dc33e6e924432649-1730302347"
  },
  {
    "email":"stefaniasarti4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637182842/03be5eb3050ba08efc6dd550d00004d7-1730302347"
  },
  {
    "email":"silviatomba@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637117306/f3de2e4dd3bf01ec131d8a352ae3313e-1730302347"
  },
  {
    "email":"pez_ele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637281146/684a26896cbe9859ecc8492e59d608ed-1730302347"
  },
  {
    "email":"annapicone1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637215610/c11c889214ed85f300615838899af80f-1730302347"
  },
  {
    "email":"saliernoangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637248378/ff08436a51651db33bcb80a777471662-1730302347"
  },
  {
    "email":"guerrierogiovanna@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637412218/f63048ca0401592b29326a9e586121a9-1730302347"
  },
  {
    "email":"alessia.fusaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637379450/6a3cd810dcab29696148b0c15f418ff2-1730302347"
  },
  {
    "email":"manuca.c@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637313914/1390bf7cc7ea49a3abb53add4376833b-1730302347"
  },
  {
    "email":"avvdallesaline1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637477754/e1fd49391812a9985a0180bb5c41181c-1730302347"
  },
  {
    "email":"serecima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637346682/d3896337193d0d85ec8d386f6079534b-1730302348"
  },
  {
    "email":"mmpodda@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637576058/aacbeec43afe8fb747b2a0747fbcde44-1730302348"
  },
  {
    "email":"terrych75.tc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637543290/53123ae48cac94fbddb39e36ba84e8d9-1730302348"
  },
  {
    "email":"profumodibellezzasnc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637510522/e2921f34ff34f49f9b763803fd1ee719-1730302348"
  },
  {
    "email":"rosamaria.rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637641594/325583718183fc7b869f7cbf7ac2e52f-1730302348"
  },
  {
    "email":"graziella.derrico@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637674362/7ec8455e7aafe4a85ecbc5a7be6a744a-1730302348"
  },
  {
    "email":"giuliapasini91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637608826/8196cb80cb2f46c278142b3f711ab0b5-1730302348"
  },
  {
    "email":"viviana.mele@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637707130/650500e4fd929822f3b0d29845529211-1730302348"
  },
  {
    "email":"victoria.lorini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637772666/5f1a53a61817c3f733d833cc5043cd8b-1730302348"
  },
  {
    "email":"simonacappa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637739898/bcd11e6f8d54acf9971cc28d4b778fae-1730302348"
  },
  {
    "email":"farina.nunzia54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637838202/1766067e5660db96cc6ace1351553366-1730302349"
  },
  {
    "email":"missro75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637805434/76cbcc061d073e2dff3a1066a77297c0-1730302349"
  },
  {
    "email":"mariacuccu@studiolegalecuccu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637870970/392b04b7ce1340b073ae89a176704942-1730302349"
  },
  {
    "email":"monicacorna73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637903738/b58914c124a3b2a89b74f6577c2b8112-1730302349"
  },
  {
    "email":"valentinazenaritn@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723637969274/34b358a3b97324bf61c37d0e50f390eb-1730302349"
  },
  {
    "email":"drogoangela@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638002042/58905edd7c94ca632f610610ace0a97f-1730302349"
  },
  {
    "email":"michela.costa.mi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638034810/5ac81a4a15d60d5e6d5bba45aee8ac49-1730302349"
  },
  {
    "email":"silviapillitteri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723637936506/d10965dfe377478e50e87444c4a800fc-1730302349"
  },
  {
    "email":"fren.beltrame@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638067578/dfce6cecc6143cf91a8cfad5a65ecf35-1730302349"
  },
  {
    "email":"dorianatrinitrilly@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638165882/c06c04a5bfa4b25edbb38f443a76a5bc-1730302349"
  },
  {
    "email":"hotel.thomas@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638296954/95c2fcf9ca9ac8fec92cba9de99366e5-1730302350"
  },
  {
    "email":"daniela.ponta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638198650/5ebc580cd1f30e5f59ade19363292bb4-1730302350"
  },
  {
    "email":"alessandra_annoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638362490/d2807b18658ee26c5b235d5ed7f28cd9-1730302350"
  },
  {
    "email":"carla.bellini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638231418/7dec9fcb848da812c5eaefee6f11d0c0-1730302350"
  },
  {
    "email":"adina.oro74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638395258/4c14e1bb276ae93eeee3022aaac86426-1730302350"
  },
  {
    "email":"lchasson@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638264186/d07db93bfda2b7cdfc30adb866e2c72f-1730302350"
  },
  {
    "email":"francesca.zugno@luxottica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638428026/5ac93f02f91afdc2115dbf3634627523-1730302350"
  },
  {
    "email":"ritastara5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638591866/e5d0f4e34992c5a42078e0b95eb109ad-1730302350"
  },
  {
    "email":"tiziana@rossettosrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638526330/fab69dcd4db50cf3783b2310d1ca5bf9-1730302350"
  },
  {
    "email":"luisa.spina75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638657402/472004c26d6e33009d97a93d89f9ad8b-1730302350"
  },
  {
    "email":"ebontempelli@mag.ca.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638690170/248ceebcf2c6b10bb1fdcb0d2686d47b-1730302351"
  },
  {
    "email":"matildapau@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638722938/5f1fc3621bcdb4c9fbe037a1ca6c0196-1730302351"
  },
  {
    "email":"cristina.ottoboni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638755706/bfd487306468aeb5db560a129ce086ed-1730302351"
  },
  {
    "email":"galvanidoris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638624634/a1f8dca4773cf6021ce480a7f6b0becc-1730302351"
  },
  {
    "email":"danielaborrelli2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638821242/a2d221fa7910a290af4d3fd3bb271083-1730302351"
  },
  {
    "email":"f.quaglietti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638854010/9e8ecea4b56944692aaa45f258250a83-1730302351"
  },
  {
    "email":"corinne.pastore@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638985082/bcb17e380137c959685bbb85bab99314-1730302351"
  },
  {
    "email":"saviolisimona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723638919546/ed24a1f0af88aa3c089b7a1d8830b869-1730302351"
  },
  {
    "email":"chiara.agostoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723638952314/52d207318ee7bd024847c3e078abe6d8-1730302351"
  },
  {
    "email":"paola.menapace@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639050618/d7ecb2fd6140202001b50e98cb84e2dc-1730302351"
  },
  {
    "email":"eli.rem@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639148922/12aea93bdf81223bf6f9e5b99cd6d1b3-1730302352"
  },
  {
    "email":"alessandravisi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639214458/7ef34829993f69832294ce2043653468-1730302352"
  },
  {
    "email":"annaluisadellanna@gmai84l.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639116154/0a660603e878503e99cfc979615be300-1730302351"
  },
  {
    "email":"rosanna.bozzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639279994/d6e47fa00c58a1aae9bf906196bd0dd8-1730302352"
  },
  {
    "email":"paolaalberto13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639345530/de9accbc244a7fbb4258546085918c1c-1730302352"
  },
  {
    "email":"r.miello@studiomiello.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639411066/ecf7b1d45e908c2c9135fedbe1792d59-1730302352"
  },
  {
    "email":"lorenzorapisarda1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639181690/843d039910cb81f3095a62b489f9999e-1730302352"
  },
  {
    "email":"olibarr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639378298/0a6f0439d16eeab3819b8adc3e3d2096-1730302352"
  },
  {
    "email":"annalisa76.amadio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639443834/9458747fbf905c43b2fd48d9312f0c6d-1730302352"
  },
  {
    "email":"buscemimaria@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639509370/ffdf5a2b3601edcf8dd14cebac52780c-1730302353"
  },
  {
    "email":"r.cieslarova@seznam.cz",
    "url di attivazione":"https://verdissima.it/account/activate/22723639542138/859dd0b8f3570880f8053882c44b1647-1730302353"
  },
  {
    "email":"elisa.cristofoli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639640442/1e193d60cc369bb36d0547febb8595e3-1730302353"
  },
  {
    "email":"federica.tiberi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639607674/58497487fb265c2f33ea795a42e969d3-1730302353"
  },
  {
    "email":"frandepalma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639476602/845683038e875f3981ce47defabca3c0-1730302353"
  },
  {
    "email":"paolariccia63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639574906/8b91b7ffd3893efca6721ada61c326dd-1730302353"
  },
  {
    "email":"d.brandoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639705978/c0254f610828373837d45862d70edafb-1730302353"
  },
  {
    "email":"akirepat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639673210/eca3701309ecee197693553a6f1acd00-1730302353"
  },
  {
    "email":"valeria.fe@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639738746/902f2a6a2ea79cd8fdfeb40b58a6c001-1730302353"
  },
  {
    "email":"barbarabernardinigalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639771514/87353105e091c84d38196bdfb7706e86-1730302353"
  },
  {
    "email":"cmd.edizioni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639902586/96b6cdeae238a282a003a3d512d757bf-1730302354"
  },
  {
    "email":"cinziaercolano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639804282/28d5047326ab1fc4c92846900c798584-1730302354"
  },
  {
    "email":"salvatore.ielpo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639837050/872cdc04227e9630e3893f82eae12b84-1730302354"
  },
  {
    "email":"aspasiano1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723639869818/c9b189d26f50ab633147962c9950810a-1730302354"
  },
  {
    "email":"cetty.cor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640000890/08abc4adc6115568d4c9dcafbd6a7ff9-1730302354"
  },
  {
    "email":"surano1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640033658/fd201d31ca05ed3a971027a0811eab70-1730302354"
  },
  {
    "email":"valentinafrangipane@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640099194/f749da9dc92e9568a6a2cfe2105f45e8-1730302354"
  },
  {
    "email":"moriconilucia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723639935354/3ec0dd0ac80f97bd6734775776ff36cf-1730302354"
  },
  {
    "email":"emma.a.sartor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640131962/6e5134fe93a8efacf251408e363f403e-1730302355"
  },
  {
    "email":"valentinamonticelli11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640197498/4616d2ae987487dbaa87877d5d5d7024-1730302355"
  },
  {
    "email":"avv.paolaromano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640164730/467bf844257299593451e04c44bad413-1730302355"
  },
  {
    "email":"manuelalorenzini76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640263034/4ea80b01d6db03784847b2b198c33286-1730302355"
  },
  {
    "email":"simona.amadei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640295802/29689fdb19ea3c1fbd0015370603834d-1730302355"
  },
  {
    "email":"roberto.tosini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640361338/b3f040f76cc80f1ccba984680969da67-1730302355"
  },
  {
    "email":"arianna.paglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640230266/4f90ccb02f8d77d1504bfae009164f67-1730302355"
  },
  {
    "email":"paolademc@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640394106/dff7463172fb193ae9b0c473233cdf67-1730302355"
  },
  {
    "email":"mai.romagnino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640426874/6601f09ae273a739faa921eabc8c6855-1730302355"
  },
  {
    "email":"angi.ferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640525178/374062db9faa1fb45667292f3c2c1932-1730302355"
  },
  {
    "email":"massimobrunilde@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640492410/b4304d4f6c0581e0fb2cffb22f141358-1730302356"
  },
  {
    "email":"annalisabellobuono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640459642/b062bb677138a36c305e1672d7775a40-1730302356"
  },
  {
    "email":"chiagililli98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640590714/7545896e1fd2ef7d6b5294978e9c80f9-1730302356"
  },
  {
    "email":"malucchimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640623482/8f9e2fbaa17b12cd10b2b296921ed65b-1730302356"
  },
  {
    "email":"b.moncher@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640689018/7fe38a03e4abca763c8ab488fed403f7-1730302356"
  },
  {
    "email":"isabfilippi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640721786/ab3e62c3ff3b644db3cba8b28c050d00-1730302356"
  },
  {
    "email":"sofia.pellegrini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640754554/b14cdb9eb8a967946d1a2c52ebef18ee-1730302356"
  },
  {
    "email":"truncali.viviana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640656250/c9b2d0be43bb6038e97baff34dbadb65-1730302356"
  },
  {
    "email":"ariannacrescini71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640885626/d8e05e578922ab5db48551ba80dd77f4-1730302356"
  },
  {
    "email":"francesca.damato83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640820090/ceb5cabdc53696179cf5809bb06472ea-1730302356"
  },
  {
    "email":"elisabettapel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640951162/ac674cab08e31158d7ab8b46d011e08c-1730302356"
  },
  {
    "email":"andrealice2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723640983930/5432f45e7c052ca498c208de716db27a-1730302357"
  },
  {
    "email":"thebluedog@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641016698/0a187814136f608787be57cd50baeedb-1730302357"
  },
  {
    "email":"purpleina72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723640787322/5c96fce41f20be3055ffb8205460194e-1730302357"
  },
  {
    "email":"mariachiara@saccanistudio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641049466/f897e93986317b1cee9b7892396c200f-1730302357"
  },
  {
    "email":"mimmaventola@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641180538/9cdc38cb4f3bf72bfcb25a6ef165303c-1730302357"
  },
  {
    "email":"cucciolona66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641115002/751b1e68a56584b6cdee27a9c9f42f5f-1730302357"
  },
  {
    "email":"antonella.bella@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641147770/457ea004516e788d38784c6248334f7f-1730302357"
  },
  {
    "email":"daisy44@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641213306/b5faac26785113d6e5e8fbb9c24fc24d-1730302357"
  },
  {
    "email":"fsdshop223@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641082234/8b6aba598cae2be1b63a2d5408fec6de-1730302357"
  },
  {
    "email":"katyacapasso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641278842/41c9a388f25c88684a92de4b53409263-1730302358"
  },
  {
    "email":"peppapig2707@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641311610/ee070002516f683a8a93ecc4c4301c38-1730302358"
  },
  {
    "email":"rafser28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641246074/b12afd4a62acfaa5a1ff884b28be3d46-1730302358"
  },
  {
    "email":"gianna.f78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641442682/169212e07c68246f2f0205c37e896579-1730302358"
  },
  {
    "email":"luana.biasi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641475450/03b258053f867002d549a15b12050238-1730302358"
  },
  {
    "email":"lukas.aichner@aichner.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723641573754/21d4bec8d9072cfba24ebf4594bcf7ae-1730302358"
  },
  {
    "email":"alessandra.bonvicini95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641508218/82a82996210f5f3815862a8f472abbd6-1730302358"
  },
  {
    "email":"tony.coppola73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641704826/87bd5dcebe28b28b2c55695d0924ccf3-1730302358"
  },
  {
    "email":"lauras1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641770362/7b349936e230a48b226b3b7416f3736c-1730302358"
  },
  {
    "email":"barbarab@egautomazioni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641868666/04c4b5a87940d9fbd1e70507c430a6c0-1730302359"
  },
  {
    "email":"linda.rullo43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641803130/c0013955ba3e1f9c29ff06c372a4e1d2-1730302359"
  },
  {
    "email":"dory.mulas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641901434/0d10b53a3939018e2af9b25184796226-1730302359"
  },
  {
    "email":"orchideaglicine@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723641672058/3a53432b46ea9c0f58dd3c477ef295ec-1730302359"
  },
  {
    "email":"razzamartina@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641934202/7f4b059a52aee9460cb797f4d9f3d805-1730302359"
  },
  {
    "email":"montagni.simona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642032506/be4b10eb229201e7975394adeb278b8b-1730302361"
  },
  {
    "email":"giovanna.malvestio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642065274/1ddbb43c5f6a64aacf0b43a7aac66ece-1730302361"
  },
  {
    "email":"borsarisilvia.sgp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641999738/c814af17a96894af1b705853dbd38392-1730302361"
  },
  {
    "email":"valente.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723641966970/24cf0398e57aa54be85d7c774650293f-1730302361"
  },
  {
    "email":"bosiostefania@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642196346/abbff2dc9dca0ed80768b8bde35032b4-1730302361"
  },
  {
    "email":"lucillamussi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642130810/fb01ba13301ef7c00bd763f06d4140ef-1730302361"
  },
  {
    "email":"montanarichia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642229114/a1f2c298ed47c40b760068a110312381-1730302362"
  },
  {
    "email":"amandameloni66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642261882/fc8d508b04f398ca3fdc3b03bdc01e71-1730302362"
  },
  {
    "email":"patrizia.rinaldi70@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642163578/0bf4c70343cf99ee289829e2685d0937-1730302362"
  },
  {
    "email":"fabrizio.pratellesi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642327418/d88affb462d54d3e42d3a42f8a168a86-1730302362"
  },
  {
    "email":"benedettafaini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642392954/a6954282c80629aefa0a3673d6870884-1730302362"
  },
  {
    "email":"lgodontotecnica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642360186/ec97b84b6b2be892a8bf878e547b051f-1730302362"
  },
  {
    "email":"carlaric.cdo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642294650/326fa91771be2ccda846a71cab3db0a4-1730302362"
  },
  {
    "email":"giuliamaria.parodi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642458490/67d371257a0f52943a290b95a71e3d44-1730302363"
  },
  {
    "email":"paolapriori57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642524026/016dc197e1e59ae5333be0a30d9a62b4-1730302363"
  },
  {
    "email":"alice.fucili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642425722/d2ec005d493be6adb3deed1ce9982c5d-1730302363"
  },
  {
    "email":"simo-67@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642491258/74f3bdf3b94f7363132f8beb8f69621a-1730302363"
  },
  {
    "email":"graziellaburruni@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642556794/2c499c95ffcc9d18fbebe915a4088a87-1730302363"
  },
  {
    "email":"l.martinoli@auxologico.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642589562/47d990111d8cb34dc589cdab909ce9cf-1730302363"
  },
  {
    "email":"nellapostadinella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642622330/2e9f63eccd7b68cbf87d0d4a89ad544b-1730302363"
  },
  {
    "email":"acardelli@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642655098/4d083b8c9df65a37183389274e779062-1730302363"
  },
  {
    "email":"agneseprivitera03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642786170/5ffb743491a242eda66b0a56a4d9d8d0-1730302363"
  },
  {
    "email":"aurorafilindeu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642720634/5f7961e1e398ca8b81e042869f471e4a-1730302363"
  },
  {
    "email":"enasuelli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642687866/78fdcbfe5d3341751a87d91ee02cfcb1-1730302363"
  },
  {
    "email":"sylviazaffora@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642818938/c08d13f850388882863104462e2de058-1730302364"
  },
  {
    "email":"parpamaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642917242/175d46ce2f53ed735f6f94355a716e1e-1730302364"
  },
  {
    "email":"treorologi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642982778/b9a557532b731e876afde9e6afd76a02-1730302364"
  },
  {
    "email":"bosso.giorgio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723642851706/e9443263e9ecc66c76d7370a708f3e41-1730302364"
  },
  {
    "email":"valentinatiberi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723642950010/92ccbdf9c759e0fcb91d7d209f1f59c2-1730302364"
  },
  {
    "email":"elena.cantini78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643048314/51f33cfc48d04429d614024b26698343-1730302364"
  },
  {
    "email":"f.pellicini@studiopellicini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643113850/7ceb408fcceb85f58a59e286c8bdf3b8-1730302364"
  },
  {
    "email":"fontana.elenamaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643343226/258eb9bfd0ade81460b7b02689885ba6-1730302365"
  },
  {
    "email":"bianca@stilnovo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643375994/cdb85fe12a8e1c080cb31ada287cb988-1730302365"
  },
  {
    "email":"iomariannagarofalo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643310458/46faeb5d65a7b4dfe71e73ab55f4fbba-1730302365"
  },
  {
    "email":"graziadimartino30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643408762/3c99aabb3772ae6e1a75f2732738a071-1730302365"
  },
  {
    "email":"federica.basso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643441530/f8fdd3f78814bc145cfe790967335f5e-1730302365"
  },
  {
    "email":"mara.navarropentimalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643244922/8f786b53c2469eac4482dda89426e8ec-1730302365"
  },
  {
    "email":"sara.lattanzi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643474298/76e55233530fddec3b5802196fce9af1-1730302365"
  },
  {
    "email":"priyagrover@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643507066/c5d0ff4ded8499086bf2cdd4b3282b3c-1730302365"
  },
  {
    "email":"vitdina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643572602/9dec8e3c6165703544760f17c8718ebf-1730302365"
  },
  {
    "email":"sabrina.benetollo@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643605370/d2e161139e5f5687399c035ab1b0df45-1730302365"
  },
  {
    "email":"gazzitano.antonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643638138/6052be899372dca99fce771942dea91c-1730302365"
  },
  {
    "email":"valeibba@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643736442/91454c759290d1ff7e02141784fe0434-1730302366"
  },
  {
    "email":"baldi.marina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643670906/1f76a2baace6a0193eea0c859131e2e9-1730302366"
  },
  {
    "email":"moira.antonini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643539834/a1319ecb60ae49247bf443545d3431b7-1730302366"
  },
  {
    "email":"francescavicenti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643703674/81ac2474b0855e2b5e462b08441ee914-1730302366"
  },
  {
    "email":"martinimara@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643801978/ed9c6fae128fb2773e1456e49f6b2cf5-1730302366"
  },
  {
    "email":"martigraziosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643834746/6dca8e6bce30baa5c368986886925855-1730302366"
  },
  {
    "email":"silvia.rizzutoo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643900282/912682c1b1b2cac1fbcd207c90aa4195-1730302366"
  },
  {
    "email":"bimaui@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643867514/7d6a0b43e2553eb4c778d23b17c4392a-1730302366"
  },
  {
    "email":"sf1962@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723643965818/ec47af071b25276c43afc0383fd14c1b-1730302367"
  },
  {
    "email":"danielabonato.gsa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643998586/f0bce81914eea021922ce6a893e85bd9-1730302367"
  },
  {
    "email":"ascolipreziosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643769210/ca4919c31f1236c31f07472a300e5416-1730302367"
  },
  {
    "email":"ezorzutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723643933050/501faee369a2bbfa27eabc125c0c2b4e-1730302367"
  },
  {
    "email":"30.1982@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644064122/d01088eea4e7e32974e32e6a758feec2-1730302367"
  },
  {
    "email":"valeriac75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644129658/c59cc08806df188a57a268679af9e1f0-1730302367"
  },
  {
    "email":"sapori.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644096890/c82371b4a982c11e68e45db1dfc60141-1730302367"
  },
  {
    "email":"lilly.wunsch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644162426/c47391cf54e3340dfcb30a6d0fa29ed3-1730302367"
  },
  {
    "email":"sarah.rebew@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644227962/c1911fc48abfc102a80963f588b78480-1730302367"
  },
  {
    "email":"ilfilo.derba@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644293498/fd32bb9838a3e107d625f292e36e9285-1730302367"
  },
  {
    "email":"mausilia.inserra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644359034/25adcc8970446dd434090ad45d363c90-1730302368"
  },
  {
    "email":"farmaciazizza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644195194/625be9a37aeb67661cda3a0e3570e24d-1730302368"
  },
  {
    "email":"luisafastelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644260730/ecdba8321f8e41e3aef2f3c2c617431a-1730302368"
  },
  {
    "email":"martinelliman@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644391802/ab31c74289d025d66f6e6c23171cdce0-1730302368"
  },
  {
    "email":"millearcobaleni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644522874/db00b5ffa1c0ac4124f858b96999c9db-1730302368"
  },
  {
    "email":"paolacatania72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644555642/e4b98c7d88029d0c8b23df8cbc1812b2-1730302368"
  },
  {
    "email":"mhm@unife.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644653946/cd6d47b86b401730a05f63227bf233e5-1730302368"
  },
  {
    "email":"elisa.patriciello@neuromed.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644686714/b2ea042f5574cc2ab88d673e9b3687f8-1730302368"
  },
  {
    "email":"cinziasale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644719482/8063cd3bed8fdb20ed0b262cbd1fba73-1730302368"
  },
  {
    "email":"a.stiratella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644424570/30f64518848d7f28550e7571383a1210-1730302368"
  },
  {
    "email":"pennisi.cri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644817786/fc85b094931ba24f12d4ca536d124590-1730302369"
  },
  {
    "email":"gioviura.1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644883322/5c36331285ad1917a4a381fd60c5bd2f-1730302369"
  },
  {
    "email":"giusiloppo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723644916090/86c9e86669c54cec7c06f3f773e53276-1730302369"
  },
  {
    "email":"giulia.marabese@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644948858/1048786608c290ea04f41bfa1a980a9d-1730302369"
  },
  {
    "email":"mela.bolo81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645079930/d97a12c10890655b6114af07cfd5d809-1730302369"
  },
  {
    "email":"rosangelabasso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645178234/fa1494a805a8846e84b3ae6e6be97bb8-1730302369"
  },
  {
    "email":"l.torchiaro73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723644785018/d671a893ec17d0d59aea3a8ecd8dde97-1730302369"
  },
  {
    "email":"giovanna.cocchini@autosas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645211002/c0971709f1089d7958a37b66f4cee1ff-1730302369"
  },
  {
    "email":"antmorabito@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645243770/24b8a0ff53c382bfe13d067718202ae5-1730302369"
  },
  {
    "email":"farfallina.k78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645276538/3ebe5b06dc71880d0d9d513cc47e2de5-1730302370"
  },
  {
    "email":"francypapas@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645014394/9bab2eb083663e9a428d64f98a4f12ab-1730302370"
  },
  {
    "email":"francy7015@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645374842/431d553d0410cfd4da5bc0215669a379-1730302370"
  },
  {
    "email":"enrica.maccioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645407610/c09857eaf6602e2a8b89df15ce9a5340-1730302370"
  },
  {
    "email":"mtdemarzo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645473146/3c5d3b29a5952339fc027d069115bbe4-1730302370"
  },
  {
    "email":"federica.retali@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645538682/8ac922fcabc2f9c922c0a4956bde69c4-1730302370"
  },
  {
    "email":"yohania.ruizgonzalez@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645440378/54461fc129a7a59cc92cc77355c76cfa-1730302370"
  },
  {
    "email":"minneci.laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645571450/ec4b84017ad71fbae11b9af6e7da67fd-1730302370"
  },
  {
    "email":"hwaidakmiriam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645604218/6c1084a2eca2a7cfdd6e8851655180a2-1730302370"
  },
  {
    "email":"giuliacaminiti71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645669754/cda8f17415e8c06242648f6012274cea-1730302370"
  },
  {
    "email":"zanpaoli76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645735290/7aedd77b717728ec94a1d9344ccf9d16-1730302371"
  },
  {
    "email":"torchiovirginia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645702522/d685851a20d4c0ec4d250900ee542f49-1730302371"
  },
  {
    "email":"michelapaolino84@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723645768058/852d757b11544f31bb1e039a48b4c598-1730302371"
  },
  {
    "email":"villacanovagarda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645899130/0f7a527c491bc4d84cafdfe50c6f29b1-1730302371"
  },
  {
    "email":"roberta.mossini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645931898/873822bd88cf9226049f4d27df2c1c4d-1730302371"
  },
  {
    "email":"emmebi.499@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645997434/7d33e5acbb5658eefc1c05d2afc2c449-1730302371"
  },
  {
    "email":"anna.realdon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646030202/b8476857a2ce35015d171813adf507ed-1730302371"
  },
  {
    "email":"ciminellipina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646161274/3aac5a8fecdf3fb29d0e310d6ddf6db1-1730302371"
  },
  {
    "email":"alice.poggio83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646095738/841ee53c396f22ecbe636a498fdd752f-1730302371"
  },
  {
    "email":"tiziana.fll@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646062970/f384634f98a1043deec139d7e3eb4f4d-1730302371"
  },
  {
    "email":"francidemattei@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646226810/9550e1804f1d0483a17a47928404f8fd-1730302372"
  },
  {
    "email":"cotrone80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646259578/5c3a2d145fe958c90a35be77292eb05d-1730302372"
  },
  {
    "email":"maidefit@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723645964666/0d5b8b72c1bd49ef35ac4c8875336ae7-1730302372"
  },
  {
    "email":"evelinaettorre50@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646292346/d4d3aab82daf5c7b89fee657cd6f4920-1730302372"
  },
  {
    "email":"bosa.debby@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646325114/cc7ffea7e7c6bba6e4e6c835378a1075-1730302372"
  },
  {
    "email":"cavallaroamalia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646357882/ed6bc39890fd61f2487fb11992484eb8-1730302372"
  },
  {
    "email":"silvia.queen80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646194042/c2cd421a9b5b29ce0773f9dcb7df0e3f-1730302372"
  },
  {
    "email":"carloevera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646423418/db5165bf03733b1bac6834e159f98042-1730302372"
  },
  {
    "email":"eleniafantinato@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646390650/e10cae40a5f476bc87287c5559bb8513-1730302373"
  },
  {
    "email":"dottfrancescapapacciuoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646554490/38bc813c0c2ae25cf53764e5dcd4a83f-1730302373"
  },
  {
    "email":"pietrotarasi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646521722/673a8b9d4c82a3e943700b8b9ed14cbe-1730302373"
  },
  {
    "email":"cardurante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646620026/7933c09fda2b0549dd44648950b854b2-1730302373"
  },
  {
    "email":"anpadula@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646685562/9dc40dc9cb2c798b523f673522b2cbc6-1730302373"
  },
  {
    "email":"silvia_lavorerio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646587258/c53d3087701ea769d79bfe63f505ad68-1730302373"
  },
  {
    "email":"maria.fiorese@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646488954/52d9adea95015ad9c4e3c3b97aabe372-1730302373"
  },
  {
    "email":"ala.campanini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646783866/bf244c148fa9615893a2c8380c9d90c3-1730302373"
  },
  {
    "email":"cristiana.fascetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646816634/e8e103290554335e90f4c5c97ed7bf4a-1730302373"
  },
  {
    "email":"annadiana1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646849402/6e2807011b34946f88f0bbe3e1059c7d-1730302373"
  },
  {
    "email":"daniela.alunni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646718330/605180fd30f2df9ba0128d2cd728bff8-1730302374"
  },
  {
    "email":"elisa.chelli1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646947706/36a31738ab0c635e19dd2cc75733f749-1730302374"
  },
  {
    "email":"my_bubi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723646914938/c97471575dcf40687df0534864149177-1730302374"
  },
  {
    "email":"mariagrazia.runci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646980474/c0f9a87c214afa0571978c265806b1d4-1730302374"
  },
  {
    "email":"am.armentano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723646882170/844ff9558027ad41e49d3b165fa6f456-1730302374"
  },
  {
    "email":"cataniaviviana@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647046010/e9ea7450c525fd30eaa965572c157be2-1730302377"
  },
  {
    "email":"giovi05ls@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647013242/8c79532454827f3b70d0c26cecc78201-1730302377"
  },
  {
    "email":"da.jenina@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647111546/c23026bb3a1185d6f0ea5a2a478f7570-1730302377"
  },
  {
    "email":"agatacarini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647078778/0653c72534fa571d366e2bb9461dba88-1730302377"
  },
  {
    "email":"natycaste74@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647308154/702e565e35893c80bb5dfc945ec78cb8-1730302377"
  },
  {
    "email":"graziella.scalercio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647177082/293ba0ed115b7dd7d3550c1ff5ac551f-1730302377"
  },
  {
    "email":"f.russano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647242618/74cdec44d6e8708e0e184afc0b5a3f9e-1730302377"
  },
  {
    "email":"gabriellamammoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647275386/4d30f7012cb6e73fe7caa47f6bec2e6f-1730302377"
  },
  {
    "email":"sandralavagnoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647439226/08aafc4eb788f161a98663049da556c1-1730302378"
  },
  {
    "email":"guriolikatia7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647340922/a88ea5b0de9fb651b8648b9fcd1d2867-1730302378"
  },
  {
    "email":"alessandra.brc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647406458/f9fd0ac7a4e170e687b5a1a1ae89393f-1730302378"
  },
  {
    "email":"anna.roello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647373690/5c228993f3dc369ce35ed20431cb546d-1730302378"
  },
  {
    "email":"andrea@mogliani.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647504762/4d12327bbdc98911cebdeabd172bf992-1730302378"
  },
  {
    "email":"torino@kacrocetta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647635834/ea787d18d54c12cfd93b3f25db0cc330-1730302378"
  },
  {
    "email":"luisaquartini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647471994/938eeef701eaf5252c030de81d7a38ae-1730302378"
  },
  {
    "email":"chiaramc@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647668602/367afbfafb01fc613156dd0b8095965e-1730302378"
  },
  {
    "email":"roman@studio-aa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647701370/66d90bce172f083fe550d2baefbd8e7e-1730302378"
  },
  {
    "email":"elenatonerini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647734138/a9bab89f6ce2f0e2eeb24ef1ea9edbb6-1730302379"
  },
  {
    "email":"angelarendinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647766906/2c6cc40fc2555aa33f14444f4cbcc434-1730302379"
  },
  {
    "email":"mariagiuseppaprencipe@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647799674/50338322d39cbe8da600247517c14e5f-1730302379"
  },
  {
    "email":"livia.cavanna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647832442/307ef888bd02894ff9ec587134fd15f7-1730302379"
  },
  {
    "email":"jlenia.cattani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648029050/ae153e3d67f9057563cc7e3dd31ef160-1730302379"
  },
  {
    "email":"benedetta.rotelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723647996282/f289fd5c4d92ff684e90407d5be4a515-1730302379"
  },
  {
    "email":"mirca.milanello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723647865210/81262c8ca79fc6f66d9664a67d8b3be8-1730302379"
  },
  {
    "email":"letizia.valerio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648127354/350994d23d064751e2cb981a45505f10-1730302379"
  },
  {
    "email":"mariangela.malcangio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648094586/50af82ea832a6ac217408d945110b23e-1730302379"
  },
  {
    "email":"c.bolletta@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648160122/d8b172e116d629f95f34fadab74cbe23-1730302379"
  },
  {
    "email":"geotruglio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648192890/50f79a5ab105c653cb9d6e5201b5d571-1730302380"
  },
  {
    "email":"carlavolpi727@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648291194/81b68c41cf637952075248f1598b4705-1730302380"
  },
  {
    "email":"greta.greta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648225658/4d349c53124157acb5b002544c30ec6a-1730302380"
  },
  {
    "email":"c.monica80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648258426/fd7673d4352026041abec844ab39b790-1730302380"
  },
  {
    "email":"soniakutenshi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648061818/21197e3bca5cc5abd0a48d8e01aefdd1-1730302380"
  },
  {
    "email":"diana85_italy@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648323962/b0212ce2d0990572ab2dce42eb8fae55-1730302380"
  },
  {
    "email":"simo.tirelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648356730/2f4eaabed57bd5f38bc8db8585588382-1730302380"
  },
  {
    "email":"francescaaddato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648422266/4740437535579bc85844f5f632c1b29f-1730302380"
  },
  {
    "email":"genenappi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648553338/1e67bcfee6fe1551440c6f848c1396f8-1730302380"
  },
  {
    "email":"giatosco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648618874/08c6e6f46622633c108badbd84a1240e-1730302381"
  },
  {
    "email":"colomboletizia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648717178/905fc91f962a5866cabc0c867f9c0a7f-1730302381"
  },
  {
    "email":"rossana.bertolio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648749946/2890c92a4881983a5e75d65540186254-1730302381"
  },
  {
    "email":"ipsilon88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648815482/15ad2d65fd470eb5855b8cc514b67b55-1730302381"
  },
  {
    "email":"tocchettigiuliana21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648487802/f32b6c23b25a35c5cd2c87c770ae9835-1730302381"
  },
  {
    "email":"stefania.dallago@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648881018/91f0dd1215b8d005ca5fbeba84d648e8-1730302381"
  },
  {
    "email":"giadanasti71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648913786/5e20cae6e664608437dd368e2cd3a070-1730302381"
  },
  {
    "email":"dani.camisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649012090/c114c51c544c26b47e2bc81e37a1dfe9-1730302382"
  },
  {
    "email":"lorella.puglisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723648946554/66ecec118d3d827cd425ecf13bc51bc5-1730302382"
  },
  {
    "email":"attanasi.lorella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648848250/7fd33db5cdb0b9f5faf14a63021975a0-1730302382"
  },
  {
    "email":"alessia.agosto@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649044858/034d89834c3e046a823cd2e7bd79107a-1730302382"
  },
  {
    "email":"ambraotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649077626/9f87846b42cd030d3d8039a0b01526ff-1730302382"
  },
  {
    "email":"katiaderubertis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723648979322/06bd560e7e0be5e9a264c534efdc2fa2-1730302382"
  },
  {
    "email":"eloruggiero.er@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649110394/bb7f9a59ccb7a2d3a113d6f42a03323f-1730302382"
  },
  {
    "email":"rachele.azzalin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649143162/63e88f08a1900bef7451c57a8257a5a8-1730302382"
  },
  {
    "email":"elenavenice67@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649175930/0bb2369c12560c675d02451804f6f153-1730302382"
  },
  {
    "email":"la.marghe@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649208698/21c1bb4018a56ad4eff9584109661ab8-1730302382"
  },
  {
    "email":"heiner.mayr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649274234/454f820b39e41a814c2084d09b391e6a-1730302382"
  },
  {
    "email":"velardoluana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649241466/e39ea3f7e0c7a115199e31cb1dffe0f9-1730302382"
  },
  {
    "email":"sangelini@rcs.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649372538/8d2ccb94ac58ac49590ff33821acaae7-1730302383"
  },
  {
    "email":"piquitosdeoro2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649339770/a2d177461652fb2ed52e07f1d07ec538-1730302383"
  },
  {
    "email":"vale.rama@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649438074/79f4470cbe1fabc01e9cb4525306ea60-1730302383"
  },
  {
    "email":"fedelombardi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649470842/e3e4fedcb93feb72d2b2bbf98d03d349-1730302383"
  },
  {
    "email":"bredaemanuela72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649536378/b6dbb32c09cb38f7b9639da7adce6580-1730302383"
  },
  {
    "email":"annunziata.tania@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649601914/29bc442412366d33c7960d6d06c7fe63-1730302383"
  },
  {
    "email":"barbara.carlesimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649405306/eeb6be105635923a6d5832bad5f669c2-1730302383"
  },
  {
    "email":"alessandra.lombardo@goldschmidt.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649634682/e86d49c30f33d8954c83238016759001-1730302383"
  },
  {
    "email":"rpuletti@fideuram.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649700218/33eebd882db9169f5b9eab200b60d944-1730302383"
  },
  {
    "email":"gabriella.cinquini@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649667450/95b9da133783cd1e346585341a6a4227-1730302383"
  },
  {
    "email":"teresadest@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649765754/0d6dd0fa96c82e3fb8f0ddd7aa806edc-1730302383"
  },
  {
    "email":"mcgavazzi@fmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649732986/8c203c0612b32129a8c540e5a89eaed6-1730302384"
  },
  {
    "email":"baita.raffaella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649798522/bf96b6c9b9d4f6225d868d7969f1353a-1730302384"
  },
  {
    "email":"stefania.dirosario@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649929594/1c676daa7ad19c7b5c2046c6f42c9715-1730302384"
  },
  {
    "email":"tiziana.azzola@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723649995130/7edd80c99e4b0a425f4da62b57c12325-1730302384"
  },
  {
    "email":"moniav1976@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649962362/37889491c4c9846b89fb9c8a1cec9dbf-1730302384"
  },
  {
    "email":"robyroby0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650060666/47868bf8f492c0f3ce0e5b8cd422310a-1730302384"
  },
  {
    "email":"carba76@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723649864058/20a017f0df8ce52b965031327963b7ac-1730302384"
  },
  {
    "email":"loredana.mancini@mps.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650126202/0d42c8f420190ef35048d88bc31d620d-1730302384"
  },
  {
    "email":"adele-spagnuolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650093434/aa0f13f3ff4bcefa5a4236ca58d09e78-1730302384"
  },
  {
    "email":"giulia_giu.vln@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650158970/0a44b0f0e1206266eea4023a45777e56-1730302384"
  },
  {
    "email":"aledegrazia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650191738/07fd220d69dab8f42931a37cc3d98d07-1730302385"
  },
  {
    "email":"pollinimolinari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650290042/cd3d2138d9f6fd4b14e37519a7d6e185-1730302385"
  },
  {
    "email":"silviagrassi22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650257274/79057c4b1ef9f5953708e250be49f6be-1730302385"
  },
  {
    "email":"fvalentino81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650388346/08da134db7e1822f37f60589aca88454-1730302385"
  },
  {
    "email":"valeriabonciarelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650322810/ff3e0b46acebc8d5013c21839679b7c9-1730302385"
  },
  {
    "email":"marianna.reale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650486650/87facdbb15d80ff3a1009bb3cad39687-1730302385"
  },
  {
    "email":"mcarlabarletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650519418/6eeb5a009073fc03b01b276b2ba8d0a1-1730302385"
  },
  {
    "email":"grifoni@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650552186/42339f4e5b82bc8675c00544a7008a21-1730302385"
  },
  {
    "email":"b.farnesi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650584954/11ee2933f8757be60f4a4e4facff871d-1730302385"
  },
  {
    "email":"isabella.santicchia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650453882/4dc13490109b3ded79bdef6ce0d5ceff-1730302385"
  },
  {
    "email":"rgbmarchisio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650617722/85e1d36cf6d062bf79e9c7d0f2727b5a-1730302385"
  },
  {
    "email":"antoferrante@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650683258/0470d227202ffbebcad7e286eb18f7e5-1730302386"
  },
  {
    "email":"giovanna.venier@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650748794/f0c8910739bd23f014a3fc323b973893-1730302386"
  },
  {
    "email":"tizianamarra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650814330/efbbcb016483adb6af199fa7e78bcca2-1730302386"
  },
  {
    "email":"archbarello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650781562/8046c774cacfff52028de07304c8f83c-1730302386"
  },
  {
    "email":"adele.funari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650978170/e84aa86b52bd79ede886799dbd297638-1730302386"
  },
  {
    "email":"mariangelaschito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723650879866/ce2a1faf74b507fb0e0e8caf67027f77-1730302386"
  },
  {
    "email":"linda.tarantino.firenze@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650945402/24566b586bd6c1a184c440a9dee99876-1730302386"
  },
  {
    "email":"laura.ranzi1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723650847098/35449ab10dcf3220ecd1fd4fa85ca55c-1730302386"
  },
  {
    "email":"giovannadamiano1952@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651076474/53e72dfd949fd1d1a0e04ff568a3fefe-1730302386"
  },
  {
    "email":"ssaggini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651109242/5393465cebb450ce159c98dccaf83af0-1730302386"
  },
  {
    "email":"eleonora@benessereinfarmacia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651142010/43047a131bf889f774fcfa0eb7e41a72-1730302386"
  },
  {
    "email":"orianaottone@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651371386/8b012026fcc78ed6a6d23fbb0c5f1402-1730302387"
  },
  {
    "email":"ale5485@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651043706/d19ec0ead239fa8040e5c757ecd66f79-1730302387"
  },
  {
    "email":"v.zantedeschi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651404154/9738f66bbc6155e43c7f6fd5c5e2fd22-1730302387"
  },
  {
    "email":"mic.gianne@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651273082/6da51256604f35c79fbeb81c58d9a2bb-1730302387"
  },
  {
    "email":"luisa.scudeler@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651436922/b22b5592249e2b48b9f0f959260e5253-1730302387"
  },
  {
    "email":"stefania.balle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651567994/50a76ab9240bd513c6edf333dd61db6b-1730302387"
  },
  {
    "email":"olga.uberti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651633530/f147099a3a815643ecce94778c7d2040-1730302387"
  },
  {
    "email":"sara.pozzati83@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651502458/159edbe7e7a0d3799613d491f2bfe982-1730302387"
  },
  {
    "email":"l.martini0274@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651666298/147636bcdba9626298c17544e52cafa8-1730302387"
  },
  {
    "email":"eva.gazzillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651600762/0b0f6f8e1fa98f27ff282a6f618c253c-1730302388"
  },
  {
    "email":"marchiale75@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651731834/db5a5e1ae82baf90d8effcf4fdf07c36-1730302388"
  },
  {
    "email":"le.rossweet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651764602/be6db37481f8be7ca5c9719550abbcd6-1730302388"
  },
  {
    "email":"sabrina.paganoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651830138/9192984a3facfd2ce2b8c31f604ff856-1730302388"
  },
  {
    "email":"danypie@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651862906/c4eb509999ee7d285ce07a3c6ca0bfd5-1730302388"
  },
  {
    "email":"giudice.luciana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651699066/13b22734154dbb734150473485fab1c4-1730302388"
  },
  {
    "email":"itachil@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651797370/b22955499bc07a22f0a356999817b838-1730302388"
  },
  {
    "email":"db@gdcassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723651928442/ffac4c19d8425721116421ecaba11b55-1730302388"
  },
  {
    "email":"tirlonielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651993978/165c1bb5e10a994c0d5bf298f63853e9-1730302388"
  },
  {
    "email":"lausap@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723651895674/2a28fee788f8c0b8c25cf31469940b4e-1730302389"
  },
  {
    "email":"silviarodi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652059514/2b07a839caa7721acc7d4f92553b336a-1730302389"
  },
  {
    "email":"fra.sordi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652125050/50fad465e00bf01f2118d6767fddd370-1730302389"
  },
  {
    "email":"giovanna.cici@icsammichele.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652157818/e975d5b5458ae43d907d2a78a4ca4da1-1730302389"
  },
  {
    "email":"interlandigiulia79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652026746/b118ac4d144d9c65fdd8b0dde50d463d-1730302390"
  },
  {
    "email":"anulliroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652223354/09495128defaa1962ee6e0ab62bd26c5-1730302391"
  },
  {
    "email":"camillamontalboldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652256122/79ab36a8ff4f17ac4ab6256e65f8f004-1730302391"
  },
  {
    "email":"marcofede66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652288890/6485d8f726ac0503f0f3190673fa0045-1730302391"
  },
  {
    "email":"studiobarni@conmet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652190586/df705fcd02049bc2d4314942dc42ed4a-1730302391"
  },
  {
    "email":"gabrielelaragiome.fds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652387194/b818b45bc092cf09535e97c446affbb8-1730302391"
  },
  {
    "email":"danielatirelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652419962/9cdc645aae2062b6f200b7671784416b-1730302391"
  },
  {
    "email":"paolabazzano97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652321658/1c72fa04a774ee3868fcd6cd0e1e30ac-1730302391"
  },
  {
    "email":"lauralfini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652354426/7ded4d45b310334b7263c7d6dd0c473d-1730302391"
  },
  {
    "email":"rosinaclementi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652452730/a4608520922d92e575fc5bf8875f6af9-1730302392"
  },
  {
    "email":"elena.cassinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652485498/bbb56b2bceb428e65c395b66b73a86d3-1730302392"
  },
  {
    "email":"silvia.ignoffo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652551034/7926d39c0f2a4fc963586abedc16e88d-1730302392"
  },
  {
    "email":"pinna.marcella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652616570/e8bcc8ee631aa40bfe5b2adb9867286f-1730302392"
  },
  {
    "email":"info@perlediliberta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652583802/0d91b9c310149f1760f5a5a96455ca34-1730302392"
  },
  {
    "email":"chiara.prezza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723652518266/e75601c41c09cb7e50428b55840598e9-1730302392"
  },
  {
    "email":"anzalonepiera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652813178/705aee2c6d3245d5a1eecea289442480-1730302392"
  },
  {
    "email":"mimma.malara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652911482/57e5bdfdea9c5cfc31e060dc8acaf63a-1730302392"
  },
  {
    "email":"costanza.mariconda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652714874/05ced5be20d2cd97af85b21f78468cb6-1730302392"
  },
  {
    "email":"censifede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653042554/37164ce8414cfd460c0560f4ca27a784-1730302392"
  },
  {
    "email":"garofanofabiola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652944250/4df5ed1336ac001787675f48e21f42cf-1730302392"
  },
  {
    "email":"tania.foscolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723652747642/f3108c57f5f2744ac52f8857a327cb2d-1730302392"
  },
  {
    "email":"rosi.gianni75@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653173626/88b7d54cae01ae411b6e3dbf3cb7f8b4-1730302393"
  },
  {
    "email":"paolabrv.06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653108090/c810424364ebc374adc4c7fb97950003-1730302393"
  },
  {
    "email":"donatelladiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653206394/5a97acdb1c05f2061401bd65e268326c-1730302393"
  },
  {
    "email":"tommasinimarika@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653271930/8e950cbeddb5484ce9f09e308bdb1966-1730302393"
  },
  {
    "email":"folker.annutsch@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653239162/b1ce238c5f77bc80aea33a0e75900afa-1730302393"
  },
  {
    "email":"annacampo1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653304698/b469cabe7bd9476be4c89e2eba77c813-1730302393"
  },
  {
    "email":"claudiajun@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653075322/8047b33369f8265929b237326aa77349-1730302393"
  },
  {
    "email":"grit.b@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653370234/b09945cb5f19da5b534ebef7c6edf297-1730302393"
  },
  {
    "email":"stefaniadelpriore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653403002/927c7d7dcae666a9f68ea660c4d0259f-1730302394"
  },
  {
    "email":"antonellagrimaldi04@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653566842/d628e0fc9c7d7eaf55062aad2381eddd-1730302394"
  },
  {
    "email":"viscardi.barbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653435770/2c8dc1063b7087763bb0280428d7d692-1730302394"
  },
  {
    "email":"mariapinaceschini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653632378/ba8e62f6b910859e60e4366f0343efaf-1730302394"
  },
  {
    "email":"gaetano.angela74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653665146/47baeea651dec0bc1cb366a280d851fa-1730302394"
  },
  {
    "email":"natasha.caiazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653501306/b9aa61b071e729105ed5fbf7b9e1019a-1730302394"
  },
  {
    "email":"roncarati.giorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653697914/9853de67ec2617f074627d8744ed6f7c-1730302394"
  },
  {
    "email":"schiavipatrizia56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653730682/897d299a3e56c002bf7dab5dce3d1c45-1730302394"
  },
  {
    "email":"vpf.demarco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653763450/8ce9acb9c426fc2b7204c67af99aac94-1730302394"
  },
  {
    "email":"marisa.lottero@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653796218/d07bfec453ec26fe5a921fbbf2dee0c3-1730302394"
  },
  {
    "email":"l.carughi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653828986/fa26fc49d0d7cbebd4d352b948fea491-1730302394"
  },
  {
    "email":"carliano.68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653927290/3bfdfafde5dc26c0f66bad156f456646-1730302395"
  },
  {
    "email":"monikatahiri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653960058/bc67b1532899e3f2722bbe117fe5e4e9-1730302395"
  },
  {
    "email":"cinzia@marcarino.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723653894522/1a5bc031aa8d3e87b26a7a12b5c80eb6-1730302395"
  },
  {
    "email":"stefytime@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653861754/15797f0d79a8562f3510c6e8b9603f3a-1730302395"
  },
  {
    "email":"elilc77@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723653992826/722ec6c83c9bfaabe93f1e2f92f3ac77-1730302395"
  },
  {
    "email":"roberto@artusiocostruzioni.191.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654058362/e03331ec7586dce0e357df1b8d04ef25-1730302395"
  },
  {
    "email":"elisadaprato79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654189434/c8d25a13a555befa01df1186063c997d-1730302395"
  },
  {
    "email":"paolalupi126@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654156666/53bf528517d83ae58381ea4440908266-1730302395"
  },
  {
    "email":"r.buscaini67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654091130/6a77b4c4162f9273a2f89230d505d1bf-1730302396"
  },
  {
    "email":"melisabi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654222202/25edb0106ea8ba4a843ea0fe8c19c44a-1730302396"
  },
  {
    "email":"mail@porrinigroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654254970/7b01cbbb83c57433b763f16270a2f5d3-1730302396"
  },
  {
    "email":"patrizia.punto@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654123898/7afa3bb14a581819b1d281565a56966f-1730302396"
  },
  {
    "email":"e.gazze@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654353274/a4532e3dc9fd9ef77de99b46c91c57e1-1730302396"
  },
  {
    "email":"michelizzialessandra07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654287738/7ca3b8f9b93a6fb58445358ea39571b2-1730302396"
  },
  {
    "email":"raffaellacalvi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654386042/48ef6d13b31aa68681e02721c6ec08c3-1730302396"
  },
  {
    "email":"giorgiapedron91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654418810/8f632ab60723cf42e25c7089ecc9fb8b-1730302396"
  },
  {
    "email":"maristelladesimini81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654320506/ca263d0aff64e089131753ab21330292-1730302396"
  },
  {
    "email":"noemi.88@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654484346/0bf2111d452c10c86c0b91b0d44d080f-1730302396"
  },
  {
    "email":"campana.serena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654451578/9e859f7a2543edade8d8416feb885cfe-1730302397"
  },
  {
    "email":"pinanat@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654582650/0a06730c8c45007edcc28684bfc224c2-1730302397"
  },
  {
    "email":"par.biofarm@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654549882/756945c207bd6a1620184e8bea354b88-1730302397"
  },
  {
    "email":"tommasi.manuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654680954/3e319a8154a495b59d47bf96d27b4cc1-1730302397"
  },
  {
    "email":"francescaprati23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654713722/d3fd64c6b3039adbc817c31a95918faf-1730302397"
  },
  {
    "email":"pat1317@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654615418/4f99052f3756f715405b305e636fa60b-1730302397"
  },
  {
    "email":"antonellam.fara@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654779258/fa4aa063de4983b77ad373160a922608-1730302397"
  },
  {
    "email":"silvialibris@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723654812026/8c7a81ff84dbff01a31dcce569cc844e-1730302397"
  },
  {
    "email":"posta@naturae.uno",
    "url di attivazione":"https://verdissima.it/account/activate/22723654943098/2088e90712a577c38715fd0d795021d3-1730302397"
  },
  {
    "email":"flori.comparin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654517114/85102e12dd3733111351e2be54c8221c-1730302397"
  },
  {
    "email":"bellussi.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723654975866/24a9260d48ec668eee23578ff185e261-1730302398"
  },
  {
    "email":"giannacloud23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655008634/a5b28dab6be46926fba60c07d65a8cfa-1730302398"
  },
  {
    "email":"sharirabc@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655074170/7d7dea0b36402877b23932d478e8f710-1730302398"
  },
  {
    "email":"michelameroni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655106938/7222c60e150d029c78b9153a552a1903-1730302398"
  },
  {
    "email":"bizzi.sabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655139706/0f87a43711e76842b6bcf3734d8cc064-1730302398"
  },
  {
    "email":"giovanna.scalvinoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655172474/57e2cd1f05f7f427358e17534bf88aa8-1730302398"
  },
  {
    "email":"rocarbone2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655041402/3f56ba71ec073d5ec6e93ec2fe4ae9df-1730302398"
  },
  {
    "email":"mabo5760@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655336314/96f70de6cbc4ef978bebe656126f8d2e-1730302398"
  },
  {
    "email":"ferrarigloria78@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655303546/b77f0d25b6dc0f6d947f4829bb72fad5-1730302398"
  },
  {
    "email":"mariellazenoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655369082/3459962a83d03fbab169e33aa4c52343-1730302399"
  },
  {
    "email":"tizianaincontro24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655270778/4936cde6153933163142e7c770c5ca84-1730302399"
  },
  {
    "email":"ginatota@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655434618/15ce337cd9270bc2091abb4239269f00-1730302399"
  },
  {
    "email":"laura.cersosimo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655401850/39baa8c7d7a5714747d674756ae1d88f-1730302399"
  },
  {
    "email":"filomenamautone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655467386/50e02e09382dae3a745bb04b95371b09-1730302399"
  },
  {
    "email":"monicaprovincali68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655500154/fbf50b9729f86aa9bfd739993c7e23ea-1730302399"
  },
  {
    "email":"karoline.knop@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723655532922/58e06e5e88539a426de0eead26eceb7a-1730302399"
  },
  {
    "email":"casellasimona77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655565690/c754d39437df20c578eb7a7f13a40a99-1730302399"
  },
  {
    "email":"ivana.giulialore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655598458/eaddef61bacbea7afbd417ea7beb8522-1730302399"
  },
  {
    "email":"federica.antonietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655729530/73df3a9804d423125af74ec7fbbf8ddd-1730302399"
  },
  {
    "email":"barnik75@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655631226/7b554a4355f7df2621054cb431e5927f-1730302399"
  },
  {
    "email":"manuelaciccale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655762298/380803583db3488d9d938d4e9945f234-1730302399"
  },
  {
    "email":"cecilianat@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655795066/e077e17c64d66d6ac802de4f8b435cff-1730302399"
  },
  {
    "email":"maugeri.lu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655827834/7e3a8b7eb6f6dac8dc72e62a104be9a2-1730302400"
  },
  {
    "email":"lopezfabiana736@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655893370/28cc6ce3b7739627bc56d376f8f3f396-1730302400"
  },
  {
    "email":"tordovalentino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655926138/57adfe7ac873087e336cd7b50d318e71-1730302400"
  },
  {
    "email":"alessandra.ionta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656024442/cc8acc752933cfe5d11a2a8acc49ee26-1730302400"
  },
  {
    "email":"gotitiziana@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656057210/04c2eac5124c804bab3a59b41e1f37f3-1730302400"
  },
  {
    "email":"isa.caramuta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656089978/257776f05c4ecabd5f17f895c26bd418-1730302400"
  },
  {
    "email":"simona.ballins@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656122746/4e2137fa97c554604bcb534bdf5476a6-1730302400"
  },
  {
    "email":"giulialovazzano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723655991674/68ad2ef7366d1a09eb8316879a8f5140-1730302400"
  },
  {
    "email":"c.marci@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723655958906/1261c44e4fc0bfd1e8801f15c112860c-1730302400"
  },
  {
    "email":"flo.armosfere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656253818/8748bdb446d84b7f06e6c7ecd3227c12-1730302401"
  },
  {
    "email":"alessiaqgl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656417658/fc55dee8417544c3e6ebf0546a6df184-1730302401"
  },
  {
    "email":"rossana.delpicchia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656286586/b6d4e17f036b317d128670cf9be3cef1-1730302401"
  },
  {
    "email":"marialuisapagani56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656319354/9890da74c319e995668643077535d73c-1730302401"
  },
  {
    "email":"carolina.negri@unive.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656352122/1add6895dad346dc6cf91559a8855688-1730302401"
  },
  {
    "email":"morenamercuri1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656450426/24b29bee8e295b29d3dac3350c24a474-1730302401"
  },
  {
    "email":"paolaplatia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656548730/2fc565c5ed29b958d0d41928f5fee592-1730302401"
  },
  {
    "email":"studioesteticocinquesensi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656614266/052c67092a94714bf36848f78c64e9eb-1730302402"
  },
  {
    "email":"vittoria.dettori65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656483194/e08756e57ad2d8951abcf23d0152cfb6-1730302402"
  },
  {
    "email":"lory.pezza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656515962/de92e973469a6704827985df4f4e2836-1730302402"
  },
  {
    "email":"roberta.q@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656679802/e304416135c599765a883d56d1e96143-1730302402"
  },
  {
    "email":"barbarascafi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656745338/15600a0f3ab33b9f22a33420343cf5b7-1730302402"
  },
  {
    "email":"pungetti.r@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656647034/9c58dc0e4a2009c610fc4d413436b094-1730302402"
  },
  {
    "email":"cordula.oberhuber@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723656941946/3c0253dfcdc80940662d006b2acc2201-1730302402"
  },
  {
    "email":"elinico82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656909178/44ba42fb78e3d40d15d0952caa0ce721-1730302402"
  },
  {
    "email":"myriammaritan@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656974714/d955b214dc95ea67f5d8f9e0034f9e85-1730302402"
  },
  {
    "email":"sfranceschi@remax.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723656876410/26606b55755edad5e492847ee7a42c84-1730302402"
  },
  {
    "email":"p_sabrina78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657040250/9bf5c872eda526eb327a11c47b34e7ec-1730302403"
  },
  {
    "email":"marta.melina1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657007482/d7d6e33ff382b375104413d43d0ec61a-1730302403"
  },
  {
    "email":"studio.claps@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657105786/85b9666c6bf95f0da4a7b726ab4f238a-1730302403"
  },
  {
    "email":"mgr89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657269626/d552596ccef4080d9379a59f269ef94c-1730302403"
  },
  {
    "email":"annspana.app@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657302394/ef716236c2edb80b1a3865a663056b39-1730302403"
  },
  {
    "email":"simonaparacchini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657400698/54b1c5c2b24c8e9140628a78507bbb75-1730302403"
  },
  {
    "email":"avv.francesca.turano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657367930/e3dd3f11d77f7d92ddb9fd04a85a96b0-1730302403"
  },
  {
    "email":"sharifontani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657433466/b63afdcc0aeaeefd81c4daa76002f571-1730302403"
  },
  {
    "email":"susannalinari57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657335162/ec209b50dc2cbc41f913a2e547a5dd0e-1730302404"
  },
  {
    "email":"marzia_poli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657466234/b4d503254cf3ea83a247db5baab42730-1730302405"
  },
  {
    "email":"crirusconi87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657499002/1ea19a09bf7f5d3b6772eda1982c914f-1730302405"
  },
  {
    "email":"taniaminelli@tiacali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657564538/9047dbcb89a2fa6fe6531f97008258e6-1730302405"
  },
  {
    "email":"rpapadia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657531770/d19a493e690f25ea34cef1823f7d9b6b-1730302405"
  },
  {
    "email":"saldem@mac.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657630074/4403f225026444bde3495ae990a9182b-1730302406"
  },
  {
    "email":"barbara.audi@canavera.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657662842/2763c7eed237a2ff1d613f64e9645853-1730302406"
  },
  {
    "email":"katiacanaletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657695610/8fe0594efa3304cd1aca6a6400033f7a-1730302406"
  },
  {
    "email":"bea.setti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657761146/a11dada6591445fb36dc52f895a2290d-1730302406"
  },
  {
    "email":"rosella.ocello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657728378/b2c3a5fda9c92201c15d91320db52286-1730302406"
  },
  {
    "email":"antonellapagini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657793914/4ae43b52c9c9df3813569cc8a2cfbf2f-1730302406"
  },
  {
    "email":"pascali.giovanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657597306/5e928c9a048d03b7f239f72dd8a3bd9b-1730302406"
  },
  {
    "email":"v.scarnera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657892218/f8b1c8a3bcfe5b4c52e96049041d173c-1730302406"
  },
  {
    "email":"gianfratetabacchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657859450/11ef6da3e6aeb771499f80f225fcc926-1730302406"
  },
  {
    "email":"amadei.e@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657826682/eefa3a95824a11cbdf802bcf81ecb245-1730302406"
  },
  {
    "email":"a_perfundi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657924986/bf7f26187f34eafee7583e48834bc8f2-1730302406"
  },
  {
    "email":"edemetz@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723657990522/1fb0c5062c28d290f4c70bc06d278d3d-1730302407"
  },
  {
    "email":"marianna.corsi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723657957754/e077e0cad7fbb5a7dfd359e089454034-1730302407"
  },
  {
    "email":"carolgiro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658023290/15b9c5e4b477c0d22f98e1480ecfb67b-1730302407"
  },
  {
    "email":"er.rocchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658056058/e2184d487dfd455daf0ea67a51d78827-1730302407"
  },
  {
    "email":"carmela.gibaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658121594/f1779bb9fda22ab7a709d82301708e4a-1730302407"
  },
  {
    "email":"frisco.rossella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658088826/8fdf6b8229b72de5fc94af7040242de9-1730302407"
  },
  {
    "email":"zekiyzeiri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658187130/8fd42daf2a1b2c6eaad3b5e47ab42ae0-1730302407"
  },
  {
    "email":"cinzialatina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658219898/78f6fdea4eb8913336129f9b501af469-1730302407"
  },
  {
    "email":"martina.spina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658252666/c8ae3ebdf95118b6d02f6f2f1d3fdc75-1730302407"
  },
  {
    "email":"lisapaterlini82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658154362/65462384524a9741e9132cfba732c7db-1730302407"
  },
  {
    "email":"paolanargi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658318202/d5a9a272474a8f8d8e89011eb3f194b7-1730302408"
  },
  {
    "email":"valeria.toniolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658383738/585a06e62b101a2b64085ec34e57a24d-1730302408"
  },
  {
    "email":"contilo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658350970/b65e844504e402b767809358e1fcdf22-1730302408"
  },
  {
    "email":"mariag.dedomenico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658285434/1eda73a47a941cac1aa64134e72d1feb-1730302408"
  },
  {
    "email":"elisa_magra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658449274/d76deaf4cc7114e74413f804d532c22e-1730302408"
  },
  {
    "email":"cristina.lorenz68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658416506/b88c24462fcf6c10c3c535cf8e1b74bb-1730302408"
  },
  {
    "email":"mariastocchi66@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658514810/04b701c7ea0977bd52e7ab15d49cd453-1730302408"
  },
  {
    "email":"difabiola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658580346/36437709a4b439eeee291a4082a0d901-1730302408"
  },
  {
    "email":"v.pernasetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658645882/b1d394594778af3ee9f123aa1cdd6f25-1730302408"
  },
  {
    "email":"silvia.fontanesi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658744186/585b3d6fc028ce06d68fe2d36d40d19f-1730302409"
  },
  {
    "email":"nicolettamontel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658678650/8d3a5d24b2d255f69b5612650942ff5c-1730302409"
  },
  {
    "email":"stefydeguio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658613114/a1b9dfc519df9f7c14c3d39fb40de5be-1730302409"
  },
  {
    "email":"rosy.badella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658776954/9fc0be0ce350ad4382da4e22c5f319b2-1730302409"
  },
  {
    "email":"federica.capulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723658842490/4a73c7958c30448ff18eff6ac768b731-1730302409"
  },
  {
    "email":"galloar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658875258/3b189516436046fd0ad1d3349d032215-1730302409"
  },
  {
    "email":"haihai2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658908026/cd00096a9a3a07a2ca1bfc9d42866035-1730302409"
  },
  {
    "email":"smstefaniamanzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659039098/0bb96fb717a65a7ecdc071be38615d54-1730302409"
  },
  {
    "email":"elisa221986@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658973562/5b8b7466b99ba641b8d7816d6c7c201e-1730302409"
  },
  {
    "email":"avv.ilariapinzauti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723658940794/67fe22ccee76dc01751245f08fd09d07-1730302409"
  },
  {
    "email":"barisanfabri@gmail.co",
    "url di attivazione":"https://verdissima.it/account/activate/22723658809722/c517885fb101393bc5771463c8e938d0-1730302409"
  },
  {
    "email":"agata.gualco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659071866/14189260bd3a0558d2a032836675e57f-1730302410"
  },
  {
    "email":"liguori_francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659104634/9dac117bf4797796d705c34c8aba964f-1730302410"
  },
  {
    "email":"luisa.cogl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659137402/0cc0384fbeacae4eb0c45f0a76f6901f-1730302410"
  },
  {
    "email":"elisa.zanobetti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659235706/03d639035ca1132700387e644e472402-1730302410"
  },
  {
    "email":"elenapallocchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659202938/fa1620510b827d605ca0f2b94e52118c-1730302410"
  },
  {
    "email":"laura.masserini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659268474/7f850eb3aaebb35155a999d349d696a0-1730302410"
  },
  {
    "email":"avvfrancescasantoro78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659301242/bfc129e1fba769eb4050c60799f8b492-1730302410"
  },
  {
    "email":"lauragigliarano@lbero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659334010/98b424614d56fd9a7b3c07cf7c3dbf88-1730302410"
  },
  {
    "email":"antonella.ester@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659465082/b656242a423179ab8a46a1d7fa58d6df-1730302410"
  },
  {
    "email":"ale.bian@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659530618/78bb27a110ccbc67ee0a0ec80218a843-1730302410"
  },
  {
    "email":"alessandra.ripamonti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659497850/8ddf5b9a1f1fec01aedb694187228b06-1730302410"
  },
  {
    "email":"mgpiluzza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659432314/054f3e7cb7c985febfe52bf42caec241-1730302411"
  },
  {
    "email":"camilla.galletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659727226/4359ce0e5b8c58a710b1235099f4ec71-1730302411"
  },
  {
    "email":"marinellabisconti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659596154/4b4a03b2f3940ea6abab9e6479262768-1730302411"
  },
  {
    "email":"gionini76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659759994/6fdaf3b6a80fe3ce534367fce87eaddc-1730302411"
  },
  {
    "email":"leonardo.giuliana@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659825530/7d83c8956bdf5ded4659093e57d2d69c-1730302411"
  },
  {
    "email":"rossana.raspollini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659661690/d843394abfdbcb63254895c051fbc2e2-1730302411"
  },
  {
    "email":"ale.marrocchini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659792762/bc91c59931387ecb2f5963e4f77b50ae-1730302411"
  },
  {
    "email":"giusy_franco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659858298/b7228e2f294898b8872f7d5f26ee154e-1730302411"
  },
  {
    "email":"eral.39@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723659956602/d7f924eeb153a939b604441ec97bdc05-1730302411"
  },
  {
    "email":"serepolpi03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659989370/4c726add027026f2c16915c3acf307b3-1730302411"
  },
  {
    "email":"nazzarenaconduezeta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660022138/e4d9229c4829957d6729e1f8c66c6e4a-1730302412"
  },
  {
    "email":"mcomb83@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660185978/b1f7525c3a5c44e026d27c80d6ca0695-1730302412"
  },
  {
    "email":"gloria.beretta89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660153210/c15570195509b790c81fcb2babf14218-1730302412"
  },
  {
    "email":"ornella.granchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660284282/c422f8602a7939e8f2bb0e963e598571-1730302412"
  },
  {
    "email":"federico@pratowear.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660218746/5435827f69246bee0413df5e09e38ca2-1730302412"
  },
  {
    "email":"chiaracprincy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723659891066/79adb8a8188d4b171e01a8e1b89f0735-1730302412"
  },
  {
    "email":"saraalchimia83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660317050/63eef444e7f8b270ddaf74110bf2882c-1730302413"
  },
  {
    "email":"ornella.sudano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660349818/2dc63d14bde127d35f0dfe5749246a54-1730302413"
  },
  {
    "email":"a_spanu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660251514/cda622f33aeefc0da229ee0a5a45fdbf-1730302413"
  },
  {
    "email":"menna.anna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660415354/0437f341edab0278fef22d5019a673c1-1730302413"
  },
  {
    "email":"ildasavelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660546426/aa470dede92e5f58e27de82f73c25274-1730302413"
  },
  {
    "email":"fornaceporfidi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660382586/589164bd8a277503feea714326b36a40-1730302413"
  },
  {
    "email":"elena.bermani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660579194/3cb7f5bd51cd4a153a2fdec0fc039c86-1730302413"
  },
  {
    "email":"carla_80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660480890/55536c5158254abdd6c201ed91223959-1730302413"
  },
  {
    "email":"pamelabellofatto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660677498/df84feeb6fbc746d86e72a40d254a509-1730302414"
  },
  {
    "email":"ar.diba@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660611962/b8c6b135391d332d05b71d6ce7fde227-1730302414"
  },
  {
    "email":"alecale71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660743034/559e772480ac63153f1714d47e4be38c-1730302414"
  },
  {
    "email":"lorella.gandolfi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723660775802/7733ce29505321c6d6b1fc07bd180690-1730302414"
  },
  {
    "email":"chiara.itc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660808570/e64449fb3371e93abc2994c90f395f69-1730302414"
  },
  {
    "email":"evi.zingerle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660710266/c9d37b2673c290c6239b3bbe88a49e80-1730302414"
  },
  {
    "email":"cuccinella62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660939642/42caf78d318378f45651fcc0655eb6e1-1730302414"
  },
  {
    "email":"stefaniapetrucci83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661005178/761e371a8ac54d4dcae42636b89bb1c3-1730302414"
  },
  {
    "email":"frigerio.giorgia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661070714/c57d39289c356c505b6301bb54f3737b-1730302414"
  },
  {
    "email":"lika-star@bk.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723661103482/662bedddba61208c64acc234133f1ca8-1730302414"
  },
  {
    "email":"veranovara83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661136250/4be5efc2ec7da285c7318aea90e52f82-1730302414"
  },
  {
    "email":"ilaria.gianni165@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723660874106/bbe02a52b57c075ae4fb0eb158ebabc0-1730302415"
  },
  {
    "email":"doctor.marin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661234554/f66b0f471d6047cd2d4b90379512fa6b-1730302415"
  },
  {
    "email":"vale.poletti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661169018/43ee9d4c52fa502dc8b582e1756653d0-1730302415"
  },
  {
    "email":"gbrancacci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661201786/ae10fa213a8328ce1c8d783eae66457f-1730302415"
  },
  {
    "email":"federica.fini@alice.i",
    "url di attivazione":"https://verdissima.it/account/activate/22723661267322/213287f5b6fd843d97e2cdbd39192b77-1730302415"
  },
  {
    "email":"saracoronetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661300090/bc8b87b6044dd147816263ff3ba20257-1730302415"
  },
  {
    "email":"apalmisano@autobruino.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661332858/324a01144da98ee8974f29f733103b2f-1730302415"
  },
  {
    "email":"olta.karepi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661431162/8761e391248a602d56ffcea67ed7ba97-1730302415"
  },
  {
    "email":"zennarofrancesca244@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661398394/9ffae7ddb2e3f4331091dd94505c593d-1730302415"
  },
  {
    "email":"naggia@bianconigroup.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661463930/71ac27857a33c7418af70aeb40c5bd63-1730302415"
  },
  {
    "email":"martelli.giulia89@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661529466/39f57031f3e42ecf78f017b5700deae6-1730302415"
  },
  {
    "email":"mariangelesmarquez@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661496698/2e50c018e0ecb532c807dcad3234d6ec-1730302416"
  },
  {
    "email":"lanfede@hotmail.jt",
    "url di attivazione":"https://verdissima.it/account/activate/22723661627770/08d2b85f8e633166862ce3f826ea9f2a-1730302416"
  },
  {
    "email":"maricaselva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661562234/8df6f93c8d06978325a312dd5aafaa9e-1730302416"
  },
  {
    "email":"l.altieri77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661660538/4f0bc01459ff8fb37689ecb8b1b7b8f5-1730302416"
  },
  {
    "email":"alicefogli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661595002/81794bbc8649d1bc09fecc8a9c5a8c3c-1730302416"
  },
  {
    "email":"tiziana978@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661726074/7b187c4a4621c9c2a3ce86c1b4935365-1730302416"
  },
  {
    "email":"vismara.luca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661758842/f7938f2aa4a14ca88ca217f0541568cf-1730302416"
  },
  {
    "email":"marta.bissaro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661791610/e601419d49fab866f84f76cac88e6b95-1730302416"
  },
  {
    "email":"anghela1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661857146/ec9771b0bf00eda6ec63fec7769f594d-1730302416"
  },
  {
    "email":"viorica.tomescu01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661955450/167f940d8c7375a4c283f7664fc7e459-1730302417"
  },
  {
    "email":"fcasale@federgolf.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661889914/a2ae91cc449c5bba285bf5f50451f77f-1730302417"
  },
  {
    "email":"cminoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661922682/a34ce3821b1b0c263f2e292ce43287cd-1730302417"
  },
  {
    "email":"anclem16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723661824378/e48d1f6115f976f11cbc80c7eb8fdcba-1730302417"
  },
  {
    "email":"mari.mazz.mm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662119290/dfa5b9cf534d597a88741075e672806f-1730302417"
  },
  {
    "email":"manuela.paracchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662152058/6b432fa7ef95086afd661477347ee528-1730302417"
  },
  {
    "email":"monicaantonelli66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662250362/46410b67f89a608f6580d64766ddef5a-1730302417"
  },
  {
    "email":"elisa.caporiccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723661988218/56776947e69dbd3e08387f45cdfd0c53-1730302417"
  },
  {
    "email":"claudia_micle@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662348666/b9178aaf253416cd06251de9a58b3d14-1730302418"
  },
  {
    "email":"chifenti.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662315898/1bd8e51b78a6c9b768a79ed9cd8ddd07-1730302418"
  },
  {
    "email":"senakerniqi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662283130/f0ce2b67796308cc6151855811213e4a-1730302418"
  },
  {
    "email":"federica.fantini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662381434/a2cbf143c3a981cc597213c4c9f4e319-1730302418"
  },
  {
    "email":"arch.angela.cima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662414202/d844c6008769d8aa156aa031295a831e-1730302418"
  },
  {
    "email":"valerichero81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662479738/3ae57a8a4572ed11b3bbd8696fafdef9-1730302420"
  },
  {
    "email":"sefora.serr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662512506/f6aec50dbf140c7015cae2a1a43fd4bd-1730302420"
  },
  {
    "email":"lucia.pasquali@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662545274/338ef5a89260f7dd31c3fbc94556e342-1730302420"
  },
  {
    "email":"bassoveronica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662578042/790e8cc57b2b9ffd3118f99fdf276aac-1730302420"
  },
  {
    "email":"lisacusano75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662676346/d67f36cf0754a7b22a349dfa583edf3b-1730302420"
  },
  {
    "email":"c.letizia1981@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662709114/277d523596c2c237fee4269597b150a5-1730302420"
  },
  {
    "email":"alec.rmi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662774650/569dc2f87ed7d123293d53eaff90fed7-1730302420"
  },
  {
    "email":"littlewackos@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662840186/0a03122ffecd0095eba36722963b3961-1730302420"
  },
  {
    "email":"chiarabarone22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662872954/6aefbdb3a597bc0c17669a70fb20766b-1730302421"
  },
  {
    "email":"kris19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723662741882/b3a466a5d5622f2384a29393389c40cc-1730302421"
  },
  {
    "email":"vale.fantini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662905722/0f582ce467ef28e1b4b08e53f01cc506-1730302421"
  },
  {
    "email":"luca@pototi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723662938490/44468732a91295b6b584d68c1ca5b1ac-1730302421"
  },
  {
    "email":"g.ianuale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663102330/57778441572ddfb4a973b8b046049a8b-1730302421"
  },
  {
    "email":"valeria.zucchelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663135098/01cba04a94c023b322e0d69effc6de3f-1730302421"
  },
  {
    "email":"noosongiale3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663167866/7e6c56b72f5a2d8451f2b5866b7c0b7e-1730302421"
  },
  {
    "email":"cinzia.buoncompagni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663069562/2c3b6aa29d6661afc2b197de8790e7b2-1730302422"
  },
  {
    "email":"sara.pini1291@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663200634/059bbdc4a2589d852f8b2cc41af3ef78-1730302422"
  },
  {
    "email":"studiolegaleavvocati@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663036794/979954a17113ab42179fc6c9c768e645-1730302422"
  },
  {
    "email":"raqluc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663233402/23997f207383fbe143e38c7bb198bd74-1730302422"
  },
  {
    "email":"vicariov@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663298938/76ccf223ea30afab88610249551084a0-1730302422"
  },
  {
    "email":"mazzulla.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663331706/cae96d894bcba31f4545aa804a978872-1730302422"
  },
  {
    "email":"stefaniacalabrese86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663364474/76aca8ad7b3273c6b02045c289c3f41f-1730302422"
  },
  {
    "email":"antonellaguzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663397242/9750fbc94dda8c392e812c3c5d4cc115-1730302422"
  },
  {
    "email":"rosati.mariateresa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663430010/e35e590fa99f7aca0a3a6194859e7099-1730302422"
  },
  {
    "email":"cinzia.bar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663462778/a18e59aa6772dfc175a6bf27a15d5375-1730302422"
  },
  {
    "email":"irefru@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663528314/9843fa78c86bd6e8b72bd89b845415a8-1730302423"
  },
  {
    "email":"mariabartucca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663561082/e5ebe41734c9d77e96f0361aef674800-1730302423"
  },
  {
    "email":"carolidupre@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663495546/2585ac47b9b045261382afbcbd161967-1730302423"
  },
  {
    "email":"beatricefurlotti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663593850/51a868a7d323eca7b83a39759a3c4e80-1730302423"
  },
  {
    "email":"serena.gallotti2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663659386/4b0af1c4739fb4713609cb73258412c0-1730302423"
  },
  {
    "email":"domenico.orbitello@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663266170/96a9303e97e8585cae6d6c5b76d2afbd-1730302423"
  },
  {
    "email":"poli.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663724922/5bbb671fa9adb4e2ed1d843cad93cedd-1730302423"
  },
  {
    "email":"very.monica.83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663790458/a90d52b718f47cff7cf877054085732e-1730302423"
  },
  {
    "email":"gisellagioielli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663888762/bbd9da475dcb95f6e53d79af941a014d-1730302423"
  },
  {
    "email":"bernava.mila@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723663757690/bfab991dd8dc9bb473f8b04c2013dfa4-1730302424"
  },
  {
    "email":"pelufforory@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664118138/5d892251975dea0cbb695aa6a9bcf3a3-1730302424"
  },
  {
    "email":"milena.martarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664085370/f58cda92b03006b493c9fa2b5575ea93-1730302424"
  },
  {
    "email":"arianna_barbieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723663921530/87bab72091ffb29ae82d2c5b7aefb690-1730302424"
  },
  {
    "email":"orlandisilvia85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664052602/fba52840b7bcb51d58d0e5ca4f3f3a2b-1730302424"
  },
  {
    "email":"paola.ferrari11@protonmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664150906/e2c5d796d2eb68a8ed0249cbb2909ae8-1730302424"
  },
  {
    "email":"tittiprinno@liberi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664216442/c5026ff011ee96e78e44136344e6db31-1730302424"
  },
  {
    "email":"salotti.serena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664380282/33ac9918ba6ce144ca353756f445f137-1730302425"
  },
  {
    "email":"mteresa.barison@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664413050/8de795c8a5307b7907f53ebc87cf5b2c-1730302425"
  },
  {
    "email":"bonfiglioli.eleonora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664249210/e382b855614b4b2d691d65100cc78406-1730302425"
  },
  {
    "email":"erremala@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664183674/06342dab92d7312b1ff63b396d95124e-1730302425"
  },
  {
    "email":"francesco@luna-srl.org",
    "url di attivazione":""
  },
  {
    "email":"alice.delucca85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664576890/37e3f8d61f8e1c83ff077590b6fe4fcb-1730302425"
  },
  {
    "email":"lucia_langella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664642426/cd3fe25a9697b65d8d6113114d528fad-1730302425"
  },
  {
    "email":"ogliariluciana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664544122/e391854ae037baaa056c24fa625ee36f-1730302425"
  },
  {
    "email":"scardovielena@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664478586/3da32c59ec62969a2ab848e31f755c7e-1730302425"
  },
  {
    "email":"balistreri.screponi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664675194/bfb3439f985981ec127fdab12e550f4c-1730302425"
  },
  {
    "email":"donatellap69@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664707962/3c47bd531b54f0e56b9dcb5926640b67-1730302425"
  },
  {
    "email":"papifufi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664806266/351d64e04e61f24f445438c2f57ef42f-1730302426"
  },
  {
    "email":"branciasilvana@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664839034/9e736f1005599e6790a2a1e9d2eca25b-1730302426"
  },
  {
    "email":"clacla.delvecchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664871802/cf134b3e099f39487a01df49604f31d5-1730302426"
  },
  {
    "email":"paolapetrelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664937338/76a035aba238378e2bc15a6f041442f1-1730302426"
  },
  {
    "email":"annacabit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665002874/f231e7adfcee48ab74e299ed1c8ed615-1730302426"
  },
  {
    "email":"princicri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723664970106/b610974bd046aca9df00d3b9953f9420-1730302426"
  },
  {
    "email":"roberta.ranzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665133946/e2d419734ec6643d8d6d704826aaaaab-1730302426"
  },
  {
    "email":"rita.liati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665166714/b72910fc56dfa94ebdd92adeed2f4c64-1730302426"
  },
  {
    "email":"stefania.specchiulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723664773498/a2563dcff4f43dbda02e312c5d892eae-1730302426"
  },
  {
    "email":"n.slapinska@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665101178/76f84b64f24f22228e450e549f2f2529-1730302427"
  },
  {
    "email":"mattuchinabarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665297786/15b163418da242cbdf931c7626135d27-1730302427"
  },
  {
    "email":"cristinafrignani1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665330554/f4b2f80fd1f8da9ff4718cec220e6d63-1730302427"
  },
  {
    "email":"mariateresa.lentini2510@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665265018/0337cf3d15f2ec85f11e18c618dfb928-1730302427"
  },
  {
    "email":"simona.laudenzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665199482/5b810101cda42e64d9a278dc414b043f-1730302427"
  },
  {
    "email":"loredanapletto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665363322/4eb8c7294444a541231459ec23c526b5-1730302427"
  },
  {
    "email":"daniela_severino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665396090/c6bdefc31c5fbb4cdab55979f625f362-1730302427"
  },
  {
    "email":"violabellazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665428858/d2ce9c4d6f4bb225a97252a57cc45697-1730302427"
  },
  {
    "email":"vilmarivolta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665494394/133eecb5862525d9af9f26dfd312e55d-1730302427"
  },
  {
    "email":"bellotto.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665527162/c038698281dcae808f0a920cabcb2501-1730302427"
  },
  {
    "email":"rosalia.scavone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665625466/51012b057c1f5cda32296a4860d728cc-1730302427"
  },
  {
    "email":"cozzettomonica60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665658234/4dbf5b1cabc6cbf2b0081007f459e5e7-1730302428"
  },
  {
    "email":"marcannito@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665691002/b34cfbe34adb7715dda2228ae7e3308a-1730302428"
  },
  {
    "email":"fabiolatuveri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665723770/5a0e833009499440c484f1d40cecb8eb-1730302428"
  },
  {
    "email":"pieradechirico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665789306/2d57bf77a40a5f8c72e5cc15188ba31a-1730302428"
  },
  {
    "email":"purpura@framarpallets.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665822074/7ad3a883546495643c0bd435681cd7a3-1730302428"
  },
  {
    "email":"marino_roberta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665920378/61ec6fa2f0dbbc58d694f65dee6f06f6-1730302428"
  },
  {
    "email":"valeria.volpe@lvinsurance.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665854842/f09728eac17595e62fa1d201a35420fd-1730302428"
  },
  {
    "email":"ilaria.de@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665756538/7cd570bb02a9830fbdc1c335e316b530-1730302428"
  },
  {
    "email":"alessandro.renzulli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666018682/cd346deb0d07d0e06f72996d10f345d6-1730302429"
  },
  {
    "email":"dasilvaelizene8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723665985914/de47665aa39aea979e2222a5f61f5693-1730302429"
  },
  {
    "email":"armida.carolina@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666116986/e37d262b03d6805e7d28cd60193ae4d6-1730302429"
  },
  {
    "email":"biancapan@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666215290/d42531fc6911d4f7ccc2eb80b4c8b6a9-1730302429"
  },
  {
    "email":"pacini.francesca83@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666182522/e2261bfbd7fdc8aac3d2b6a384250430-1730302429"
  },
  {
    "email":"germana.milanesio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666248058/5d3186b209e85bea324f0330056ca961-1730302429"
  },
  {
    "email":"z.med@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666346362/7b69f0ec75b0aa16e1405e295a794c57-1730302429"
  },
  {
    "email":"cristina100374@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666379130/c555adc10100c89196a53558da16c0be-1730302429"
  },
  {
    "email":"francescaventurini81@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666411898/a63ff9ce77229dd649b407c6858464e2-1730302429"
  },
  {
    "email":"eleniapet@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723665953146/bde8f3bff2424ceb72aa4500600ff1de-1730302430"
  },
  {
    "email":"avv.elisamatricardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666280826/e0c6c6bfc09482ef7f4b31fc9522a4f0-1730302430"
  },
  {
    "email":"elisa.soncini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666477434/b5de0d95c5aa30660e77bce0c697e550-1730302430"
  },
  {
    "email":"tamaradellaciana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666542970/0ca2f6165ca97f9809f8d67197b75dea-1730302430"
  },
  {
    "email":"adragnale@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666510202/ce76688ed3249958c8f3d84a08e870ea-1730302430"
  },
  {
    "email":"am.barlocco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666608506/a453fcc2067293032910c8323eb3d933-1730302430"
  },
  {
    "email":"valeriakosir@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666641274/65811663c7ed30d50f53d0cf105e1d7e-1730302430"
  },
  {
    "email":"francifab@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666444666/a4c32901ec4c3e3e64bb21daeb164b4b-1730302430"
  },
  {
    "email":"stefaniaburza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666674042/cc8a7ffcd9616478e784b2ff7366e87e-1730302431"
  },
  {
    "email":"lavinia.loiudice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666772346/c56bc222c3f37b7d4af7abdcf45864e2-1730302431"
  },
  {
    "email":"haroulita_8@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666706810/a236c7c922bd829f6302dee869434f6b-1730302431"
  },
  {
    "email":"laura.gianfranceschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666805114/b76cfdd8849b511e21414aceff3d8b49-1730302431"
  },
  {
    "email":"celestevlaudia4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666968954/716c071494ef7f82189dacfd9d65a3d1-1730302431"
  },
  {
    "email":"forninotatiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666870650/3ce6e4b07ac8384d321301bff6051327-1730302431"
  },
  {
    "email":"angela.rocco12@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667001722/80603a89b155d07c9c796f211b476854-1730302431"
  },
  {
    "email":"marikabardini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723666936186/9a2d4ec9d396aa5847383cbcac811161-1730302431"
  },
  {
    "email":"fede_gotti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723666837882/acfd729b738678e57c1dc65d61b38b89-1730302431"
  },
  {
    "email":"emma.tramonti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667067258/77a7d6161a571b84ab390c57e52fbb0f-1730302431"
  },
  {
    "email":"jessika.masoch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667100026/f7e66f9f1fb5f1657b1dc2e5bff96ff8-1730302432"
  },
  {
    "email":"monicaoggiano7522@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667198330/d6f7a80657b5fe7f6a88a9b2f84d53f3-1730302432"
  },
  {
    "email":"consorziosolsoc@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667263866/3d2afc8a0e3593c2599d3aabc6d1e53e-1730302432"
  },
  {
    "email":"paola.garofalo1966@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667296634/f0767f5a451e45bae204485fc284952e-1730302432"
  },
  {
    "email":"janepro72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667362170/51c910e58412ee62ee371cff67d9eefa-1730302432"
  },
  {
    "email":"letizia.campanini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667165562/ee24942b8da98c3b74a767873c4947f8-1730302432"
  },
  {
    "email":"ksicaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667329402/c5284d6c80b00879728418e7b87739a2-1730302432"
  },
  {
    "email":"rdellegrazie@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667394938/45805716aa3da643b7dc9cc673ccf17b-1730302432"
  },
  {
    "email":"danielabergami73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667427706/aa6ede98ee04a93c50eb030947d1887c-1730302432"
  },
  {
    "email":"simoneanna09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667460474/1e20b53acf3543a8887dca4ca31ed8b8-1730302432"
  },
  {
    "email":"maria.telora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667526010/e7cefd50abe66028840727640ba90c47-1730302432"
  },
  {
    "email":"leoni.monica84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667493242/e31bc2d9b821f4bbdd5eea8f0f45f365-1730302433"
  },
  {
    "email":"telefonomaniasnc.grosseto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667624314/1a54d06efa39d8035e4615ca63f443a1-1730302433"
  },
  {
    "email":"silvana_mari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667591546/52562b1408be26d59d28823f182c6b73-1730302433"
  },
  {
    "email":"super4591@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667657082/927ce9ac67bf88bb2c0f0c3785f477b7-1730302433"
  },
  {
    "email":"nicola.negri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667558778/3049a09a01dd2e5a34aff40f34dd89a9-1730302433"
  },
  {
    "email":"valeriabidolli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667886458/96222946f18f2a404666b68c8318659b-1730302434"
  },
  {
    "email":"giusilovasco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723667984762/bb2bc3940669e522d66978545a485e90-1730302435"
  },
  {
    "email":"studiozermianisandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667919226/bd0fcd80000da975997b680c4a9262c5-1730302435"
  },
  {
    "email":"emma.locabg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723667951994/1b9bbf76d9d0335b481cbcc91116e09d-1730302435"
  },
  {
    "email":"marigiu.dimarco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668148602/89bcd551372bc483affc36870190f8b2-1730302435"
  },
  {
    "email":"mc.filice15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668115834/ba77e4f0d1b8b1a18d0ee7ea4ec55fe3-1730302435"
  },
  {
    "email":"miriamdelvecchio@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668050298/7abe5b1ca34a4e4461011443d2008a2b-1730302436"
  },
  {
    "email":"veronicarestivo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668181370/a11185a0332d88bd078dfbdad3cb5c37-1730302436"
  },
  {
    "email":"tznbaraldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668214138/e005c4a8043e8590988bfce22fa91228-1730302436"
  },
  {
    "email":"studiolegaleboccardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668083066/f5d17965e06c06b93bb4684ab040c061-1730302436"
  },
  {
    "email":"valentinaolivieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668345210/b589dfdccbc6cd8bf3aadb22b98b33a4-1730302436"
  },
  {
    "email":"marigiusti73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668410746/0c1c51dd7060342c3ef6f5f0c5950607-1730302436"
  },
  {
    "email":"kbattistello@alteanet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668246906/575d1feb3be43a500c884c471ef6acc5-1730302436"
  },
  {
    "email":"enrica.mensi79.em@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668443514/a9d180b3115df262cf26cb0d43a915f3-1730302436"
  },
  {
    "email":"giorgia.tucci@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668574586/25beb67cfee1c52224cfd925a67eb4eb-1730302436"
  },
  {
    "email":"irenecap87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668607354/09528d0ce7599f9c9d1c5bb044e591d9-1730302436"
  },
  {
    "email":"isabela.hrizu+9@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22723668509050/569621f6b035ccbd7f87273a60169c7b-1730302437"
  },
  {
    "email":"elenaprofera@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668476282/9a008bfad6f48ed3a1f979cfe7469562-1730302437"
  },
  {
    "email":"dellaferrera.laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668672890/6239f8d4d9738f5eb6d0eafe66629364-1730302437"
  },
  {
    "email":"patatinafede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668705658/c934d52f5557f351df67845a3d1b9a75-1730302437"
  },
  {
    "email":"tiziana.ft@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668640122/ec68e7215e4bde42f808866ff25f30e7-1730302437"
  },
  {
    "email":"e.donadello@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668738426/459302708dd353f4a0efe234ab047d52-1730302437"
  },
  {
    "email":"stefisb@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668771194/c3620f366edadd8ce08256dcebd3a0ed-1730302437"
  },
  {
    "email":"ma.mariaacone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668803962/f22ad7e24083b17d9f976fe86f8cfb22-1730302437"
  },
  {
    "email":"silvana.schiavina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668836730/c485f865aea99a07c2093ef36a70e9d5-1730302437"
  },
  {
    "email":"paola.manolli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723668869498/d5112492644f79dc045f58fb20ffd709-1730302437"
  },
  {
    "email":"otticini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668902266/89a642e3c7871028848419eaa181447a-1730302437"
  },
  {
    "email":"stefania_sergio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668935034/cfa9165108634ff0e5d90a1026e84b96-1730302437"
  },
  {
    "email":"francescasimoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669000570/e46e35b92c5d4993cd5fdb4bfba57a17-1730302438"
  },
  {
    "email":"lenuzza70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669033338/983032e183d67a96cd49e92ce9020325-1730302438"
  },
  {
    "email":"chiara.riccardi.privato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723668967802/caec94e50e95660d9b38192c61b4aafc-1730302438"
  },
  {
    "email":"babyerika1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669066106/fa586fd498983d61a237d2545cd5fac6-1730302438"
  },
  {
    "email":"maurapirovano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669098874/f055a74481ae84004c1c1604a8d2bd0e-1730302438"
  },
  {
    "email":"fideliofashion@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669262714/d1ec78b69b65bf7d36181b5fb061f105-1730302438"
  },
  {
    "email":"chiappa.francesca70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669164410/82e3afa261de925ddbb3923e40bbb188-1730302438"
  },
  {
    "email":"valentinamanu@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669229946/dddfbb149fffd9a2496dfd2e77f86085-1730302438"
  },
  {
    "email":"lorefortuna77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669295482/d8eaa541c040cc4e3820355c60aeddd4-1730302439"
  },
  {
    "email":"paola.cinquanta84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669426554/0c100ae11765e3f121bd556670720fcd-1730302439"
  },
  {
    "email":"scopafrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669197178/429fbac9d0d4e165fae69c87d135900c-1730302439"
  },
  {
    "email":"concetta-rizza@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669361018/e4ab1adf30252faf69b67772e12ecf1f-1730302439"
  },
  {
    "email":"iride.filoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669492090/ee713dc08b8d3c5520c0674a7a28a6ff-1730302439"
  },
  {
    "email":"michelatedaldi09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669590394/bbee07e5c82e7bfea5a7c5a91b6299e4-1730302439"
  },
  {
    "email":"serenaalb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669557626/2ce76ba6b03a32f23ff5f68daac2de3f-1730302439"
  },
  {
    "email":"labelp72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669459322/a3931143be479b64ff3ab979db5d9cb4-1730302439"
  },
  {
    "email":"serena.formentini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669721466/35c3677ee11501e7092a45691243b3f6-1730302439"
  },
  {
    "email":"mariacolombo1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669623162/01eedec0f910d2ec1c78f3f42a12a07a-1730302439"
  },
  {
    "email":"mia.polise@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669655930/df74ac9c4ea9f5b01f69e0cbc1cd9041-1730302439"
  },
  {
    "email":"demarini.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669754234/163b2a279cb2b6a8527bd24e8f75046f-1730302439"
  },
  {
    "email":"eleonora.carano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669819770/e83daf52e73c67daef16cc6454a7c371-1730302439"
  },
  {
    "email":"sonia.tombini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669885306/4bc69f79392d81a45885572f1b10b867-1730302440"
  },
  {
    "email":"roberta.ditroia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669787002/c41dba8d822f481e91bca729059885dc-1730302440"
  },
  {
    "email":"federicatombari@lubero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669918074/4bdf80e35e5be171165af02b4b182a5a-1730302440"
  },
  {
    "email":"alessandra.crenca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723669950842/44563a28c6438353e4444883490c3407-1730302440"
  },
  {
    "email":"vivianacelona@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670016378/c23bca932522709352a9cef41034793c-1730302440"
  },
  {
    "email":"natalemiky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670049146/ecf4bf4b893927e6ff4be011ffd79824-1730302440"
  },
  {
    "email":"alemarsano1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669983610/f9e1b553043e455ece9dd75d4ed7a2f0-1730302440"
  },
  {
    "email":"silvia.raffo80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670081914/9bfcb56b75d33d34d9cc6d7afc383641-1730302440"
  },
  {
    "email":"catycola.mail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723669852538/2d457883d360ed523a95497c12dd0fb0-1730302440"
  },
  {
    "email":"lucianarapini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723670180218/21e734af0a415097d386f204238526f6-1730302441"
  },
  {
    "email":"valeriarossini.81@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723670147450/b6a4eec91fe88869c7b366c4a658217a-1730302441"
  },
  {
    "email":"helencap@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723670245754/0c18a637f40450be53400cb34e58323c-1730302441"
  },
  {
    "email":"parafarma.amass@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670114682/41ff3c710b0b0d852ce5092b3bc200a0-1730302441"
  },
  {
    "email":"tiziana_cuneo@cotyinc.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670376826/1b2f1f88a43627a8d7a4aef312162339-1730302441"
  },
  {
    "email":"lorenacucy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670344058/ead4a6c02144501ae5231820de89bc10-1730302441"
  },
  {
    "email":"benedetta00.capitani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670442362/05b98bf0d3ff71148854a3f6c6989207-1730302441"
  },
  {
    "email":"vivileona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670507898/2d8adf57ab2e3871c568ee1c9dd77d4e-1730302441"
  },
  {
    "email":"acquerella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670573434/f44d4bdfb10f4a33fc2f6d38b3b3c8b8-1730302441"
  },
  {
    "email":"cinziameloda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670606202/83476d6249d5332d6ed53cdf0068855c-1730302442"
  },
  {
    "email":"sonia.sorvillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670704506/99726ee89635b5e16077c948a9fd309d-1730302442"
  },
  {
    "email":"luanacasarano7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670835578/e1d50e79a0e1ef23e78cea29abad9f69-1730302442"
  },
  {
    "email":"simonacos@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723670868346/0f018e8e7db64e2b6ff5707d4bdc7e0b-1730302442"
  },
  {
    "email":"p0lam@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670409594/8ff4cbe8f950f619d1d0550f32a3fb20-1730302442"
  },
  {
    "email":"alessandro@piccini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723670901114/c7c698d922642681cb2ff5120d21099e-1730302442"
  },
  {
    "email":"anna.turbil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670933882/5228548a27a3065b68cf71ac65dfe7db-1730302442"
  },
  {
    "email":"fedeleonardi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670966650/b8ff1e5c7a4c2764fd08c0e465780e6e-1730302443"
  },
  {
    "email":"erika.gentilini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723670671738/e26dcbf658fc59c2902bf443bf8c737e-1730302443"
  },
  {
    "email":"roberta.benni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671032186/304a94e85361b663d5a3bc150fd4d6ec-1730302443"
  },
  {
    "email":"rossdil374@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671064954/2e7f4f38f21da6ccd3b2668ddace48ac-1730302443"
  },
  {
    "email":"ornellamoretto57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671130490/a8cf0d74bbb39d341a47c38109442540-1730302443"
  },
  {
    "email":"adrianaronchitelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671163258/ed9616a29a3741c83db0364d66a1192d-1730302443"
  },
  {
    "email":"carlocristina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671196026/07d21e9bfd72626116c0c17d75b507ce-1730302443"
  },
  {
    "email":"rossella.gregorio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671392634/8ef2c8a6af19d5c2e5314a17182a9a29-1730302443"
  },
  {
    "email":"elenaguglielmi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671359866/a514928fa7084202fedd0ce2de313560-1730302443"
  },
  {
    "email":"sileonardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671261562/36c2fc202be85739a51ea17df8c3da98-1730302444"
  },
  {
    "email":"gaia@studiodavini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671458170/7dbe727dd1e4afbf49ea9a966c4a742f-1730302444"
  },
  {
    "email":"eleonoralosa86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671490938/86ff6e6d7fa3b1afcd23c58c92e48d18-1730302444"
  },
  {
    "email":"azzurra.lella11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671589242/c4e8629eebbfd69d422f75351c0a9a37-1730302444"
  },
  {
    "email":"elena.seri@a2a.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723671097722/a933239a8232cad9c1297247b5ae4c56-1730302444"
  },
  {
    "email":"angelicacincini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671556474/ad1b9b344ab3ad7a57a7f7f1c7a90f21-1730302444"
  },
  {
    "email":"feriguttipaola2013@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671654778/f2c336127aa6fc0535b351d2d792a875-1730302444"
  },
  {
    "email":"ariannaromei@oti-srl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671687546/f71e2b5e06894734a89b360bac042efd-1730302444"
  },
  {
    "email":"studiomascali.ct@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671720314/a5d35b4f8c77987742192b4731337af3-1730302444"
  },
  {
    "email":"monicadefeo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671785850/bde522226672a7af443c5d5e6f8b0b8c-1730302445"
  },
  {
    "email":"carmen.laporta.clp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671851386/bf476d4858d8bafb32b4691941c51148-1730302445"
  },
  {
    "email":"sara.gambino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671753082/547ecbb5d7f5de968b6be8ea834be403-1730302445"
  },
  {
    "email":"ericagelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671884154/3057a2124cb9c575f7c254ef574c7d24-1730302445"
  },
  {
    "email":"egamuzza@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671916922/32356a5f81ce56f9555985e38948bb8d-1730302445"
  },
  {
    "email":"annaluelia83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672015226/c87159c52bfe3645ca2ee8b60ff68bd2-1730302445"
  },
  {
    "email":"bresocristina1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671982458/37b7bb6e4d2a7cf174bcea31e44a4afc-1730302445"
  },
  {
    "email":"vivianalabarbera@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723671949690/f31c3585e20188ee3b7063a896f5acd8-1730302445"
  },
  {
    "email":"loxdiv@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723671818618/5407e24abca1e57c68223c1dc759185e-1730302445"
  },
  {
    "email":"desireeproietti1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672113530/adc11020a0a7f70f70e414925fdf5488-1730302446"
  },
  {
    "email":"daniela.leonardi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672080762/6dbe3f98509586f6ad4cb555e14df04d-1730302446"
  },
  {
    "email":"giusi.grm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672047994/01fae350634e8b4ebcf7a14aa8cda8d9-1730302446"
  },
  {
    "email":"cristinacelico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672146298/bd978efd0d4785ec02305a14741ecaca-1730302446"
  },
  {
    "email":"ascione.giovanna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672179066/4dc4d195e5d6598a2a974203181d0a86-1730302446"
  },
  {
    "email":"eleonoramarchiol@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672277370/ced5caadb9ef5930cb508a95b6ab1fce-1730302446"
  },
  {
    "email":"robertagalli075@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672244602/bdc7ec3fa06302caebeacce7257e6ae1-1730302446"
  },
  {
    "email":"manuelanobile18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672408442/15858029f5e0fc47bd48328d5ea254e3-1730302446"
  },
  {
    "email":"luca@antonelli.info",
    "url di attivazione":"https://verdissima.it/account/activate/22723672342906/6c678a290c026c3b1b6957f7980538eb-1730302446"
  },
  {
    "email":"irmapagliara1965@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672375674/8fcbadfa883a79f677d6b7edd8bb9608-1730302446"
  },
  {
    "email":"karin.furggler@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723672310138/5ddb548f2c4a6965ede2cfe4b6e6fcc1-1730302446"
  },
  {
    "email":"arimigne@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672473978/e07a86e90da2707b9ec147689e6a7f05-1730302446"
  },
  {
    "email":"f.maurizio1965@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672572282/93d1988d3f0ba0eebb236c8e84502715-1730302447"
  },
  {
    "email":"pippi.calabrese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672539514/37f0231e7bb700255a6b280ee7aab011-1730302447"
  },
  {
    "email":"carla.laudati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672441210/0e24d76781233db18b159002f84523ec-1730302447"
  },
  {
    "email":"linda.francia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672605050/fbc05f2fc15c08fbe88892d49e155721-1730302447"
  },
  {
    "email":"melissa.rossella@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672637818/83f2b1fdc1cbaac397c59a1bf9aa6e95-1730302447"
  },
  {
    "email":"valeriamoneta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672506746/abe394fd02220e3c2562915ba2a68c44-1730302448"
  },
  {
    "email":"cicali.giorgia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672768890/04702266701ceb74665af11e80efaa1b-1730302448"
  },
  {
    "email":"fali783@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672703354/5e60e503f4a885f7d0f9ee8e402753f3-1730302448"
  },
  {
    "email":"valonox76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672834426/36ca6c2ba3b371854455822bf98fe180-1730302448"
  },
  {
    "email":"miua@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672932730/2ecdaf8d0c53671fd8207a88a45f2422-1730302448"
  },
  {
    "email":"ireross@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672899962/d40a4164e78bf7d59f97df48a9e08cff-1730302448"
  },
  {
    "email":"giustiag05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723672867194/5b4e62cd801c3f70d999f631f4934659-1730302448"
  },
  {
    "email":"beagiaccotto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723672965498/c7b9498aa1e995322ab566bf22ab6a10-1730302448"
  },
  {
    "email":"clarissadeservi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673194874/20730b05d74631ff81a5f0053b67869a-1730302450"
  },
  {
    "email":"marta.cipollone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673031034/78e581191cf268bb8e0261bf08504196-1730302450"
  },
  {
    "email":"laura.fontana@studiolfconsulting.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673162106/3cec10a4fdfa91549840bef097d994ef-1730302450"
  },
  {
    "email":"soniatosoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673227642/2a16ddc5873003dd6092264874764b93-1730302451"
  },
  {
    "email":"roberto.zanesi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673260410/85083deb952e4a331269e13f693a31d9-1730302451"
  },
  {
    "email":"debora.manzoni1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673096570/25d8214e523d28e5b4b40fa065df4fe7-1730302451"
  },
  {
    "email":"terry.claudia84@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673358714/46c67b5818d4bfae3d617dd781a5d729-1730302451"
  },
  {
    "email":"elisa.degisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673325946/dc6b305688ee05459336aee3043f48c1-1730302451"
  },
  {
    "email":"fornaro.giusi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673391482/1f4c388883ac4c8ac0a723bced3f21a0-1730302451"
  },
  {
    "email":"silvia.ghisi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673489786/d01ede677fc6afff256438c819486589-1730302451"
  },
  {
    "email":"fabio.martignago@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673457018/6b80784210e44826272a985c51338b83-1730302451"
  },
  {
    "email":"v.sicchiero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673588090/b31c3be108d5d77db479254d6336220e-1730302451"
  },
  {
    "email":"monica_graziano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673620858/b14c00289ff8e3378788844f9a7f0723-1730302451"
  },
  {
    "email":"bbiatrix8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673686394/6762e3d20114a3325a587c37fe4d70b6-1730302451"
  },
  {
    "email":"renata11474@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673751930/8677d5d513ac777cb6f1b0ef1c3533cb-1730302452"
  },
  {
    "email":"cri.dotti70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673719162/93eee0ed55ac78090ba97e03312ac0da-1730302452"
  },
  {
    "email":"lucyfra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673817466/9f7606aec6fab16ab05a454af9105c89-1730302452"
  },
  {
    "email":"antonella.cuccuru@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723673883002/49d9cf16bdd3e72b47adc55bb66f14b7-1730302452"
  },
  {
    "email":"silvietta2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673915770/944b0180697d6538dce4ed2c1f6408df-1730302452"
  },
  {
    "email":"caccamo.adriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673784698/e79f2bb30ccc0d8b2de925515b86f5d4-1730302452"
  },
  {
    "email":"archlauragiammanco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673981306/68e4602511548e8d8725de3bdae4c56d-1730302452"
  },
  {
    "email":"giulia.borrione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723673948538/6f12006784a283eb6b9e23ebe72d1c7e-1730302452"
  },
  {
    "email":"francesca.magnani2191@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674046842/c608f9655b94fc6532ba8fa839c3a4d3-1730302452"
  },
  {
    "email":"dvlucy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674145146/6a281dc998edb306334a3d3d3dc1ca9a-1730302452"
  },
  {
    "email":"monica.loddo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674079610/a3e6840be9027d263e669115ad87da4f-1730302453"
  },
  {
    "email":"tizianaimperatore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674112378/b9f906c791ecad14e82fb479ae45b498-1730302453"
  },
  {
    "email":"veaangiulli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674177914/f2a2e2bfca40677810d5bf90bf9abe06-1730302453"
  },
  {
    "email":"sabrinacismpi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674210682/678c5d5c18cb304f7970fd04be1da918-1730302453"
  },
  {
    "email":"sabrinaguadalupi78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674243450/b47d2923edf84818695e9a618aac5c8f-1730302453"
  },
  {
    "email":"sozioceleste@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674308986/b0090c36b0b845044f412ae7eff4e56e-1730302453"
  },
  {
    "email":"carla.b82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674341754/597bd740d1c9109032d8d677895abc23-1730302453"
  },
  {
    "email":"e_stasi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674276218/d203b1eb20e2488d9e980d46eee1a639-1730302453"
  },
  {
    "email":"casseselia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674374522/10d5e7da7e8af2f5e4af33994424e8d6-1730302453"
  },
  {
    "email":"simo.borgese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674407290/1b310550c1fab5415fa7c32a9ce7a372-1730302453"
  },
  {
    "email":"daniela.elettromek@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674505594/45b43e3e055168a6ef2858f7f35b4788-1730302453"
  },
  {
    "email":"debo1681@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674538362/4bbd351fe2782b109933892fb78cf7db-1730302454"
  },
  {
    "email":"silvia.ruggieri90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674636666/3c207e37996f90b4f480f5021fb42c4e-1730302454"
  },
  {
    "email":"dolores.polvere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674702202/557d09a76c0d8b3eff24d7e9ecfffb8c-1730302454"
  },
  {
    "email":"g_fasano@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674669434/2311fd6db0239fd9739e10be668720e4-1730302454"
  },
  {
    "email":"sgraglia67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674800506/2237a75e48ce1474d1da019f0ac211c1-1730302454"
  },
  {
    "email":"spirito.divento@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674866042/da061a9ac9b0d206f6aa6c6edd056c80-1730302454"
  },
  {
    "email":"annavalota58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674767738/3f8c40cf1e852a00ba2fa3f7020b46a2-1730302454"
  },
  {
    "email":"antonietta.pompa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674964346/06f7c664e4316a2c9e9f29e81dd5e275-1730302454"
  },
  {
    "email":"gs@avvocatosatta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674931578/1714ec05b59d511e25bf1858da3d791b-1730302454"
  },
  {
    "email":"angela.datteo15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723674898810/a180f97078a3e8171880f16b04aaac10-1730302454"
  },
  {
    "email":"serena70rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675029882/627ae2a08ed5fa56d00bbd89e7fb46cf-1730302455"
  },
  {
    "email":"sara.vignali15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675062650/bc97ddb118afdd1317c1780fa4b77d2c-1730302455"
  },
  {
    "email":"maura.flisi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675095418/50faa10f1d41c5d91c1ae2fb279ef6b4-1730302455"
  },
  {
    "email":"vichj81@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723674997114/43adc11ded82def4ceeab7aa9dad700e-1730302455"
  },
  {
    "email":"manuelanigito77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675128186/75f2ebc356b699a55119ea0a7d21d235-1730302455"
  },
  {
    "email":"info@manufattincuoio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675193722/d450574f40419c3d3a06e9f63f97dbdd-1730302455"
  },
  {
    "email":"poppo-94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675160954/594b988a72e1cc9206b22d816e2f81f2-1730302455"
  },
  {
    "email":"franca@cigarsense.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675226490/7ccc6f6b7168e68075e16c15af751c8b-1730302455"
  },
  {
    "email":"crasti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675259258/815353a929cd744d18d92e2ba08f83c4-1730302455"
  },
  {
    "email":"poggiolaura09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675390330/c6862ada9107454889b6e06186c45a3c-1730302455"
  },
  {
    "email":"federicatrento@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675423098/23be978cac719a3e532eb576d8269f94-1730302456"
  },
  {
    "email":"gigibruja@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675455866/0eaf2d9e8b026c8e9254b1e249f0887a-1730302456"
  },
  {
    "email":"74malui@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675324794/6d2c88cb26424f5d613a357e2a74c406-1730302456"
  },
  {
    "email":"samantabilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675292026/611c5a531f101b1e1e210c9e432826e7-1730302456"
  },
  {
    "email":"barbaraforacchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675488634/0e90ce66158313e91f931735712db2dd-1730302456"
  },
  {
    "email":"lauselini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675521402/27a71eeb3bb5c97290d45ec09ddbff64-1730302456"
  },
  {
    "email":"paolarbt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675619706/ac679c81143bab695fce6190f280edba-1730302456"
  },
  {
    "email":"frasera1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675586938/96fda9ed11dfeb87df36bc122c318c1d-1730302456"
  },
  {
    "email":"77t.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675685242/7ddf982946a1fa738896ba89754f191a-1730302456"
  },
  {
    "email":"annamariatraietto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675783546/144bd0cde0c4abd751e387e09a536ccd-1730302457"
  },
  {
    "email":"giulia.orteca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675718010/39fc53006faadc54681395a8824f8fcc-1730302457"
  },
  {
    "email":"pier@omtcarate.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723675947386/ccf3c7304ef1c9fe413ecd4c1e591c25-1730302457"
  },
  {
    "email":"daniela.raboni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675914618/1ac81240196fb631a3bc47d29420b26a-1730302457"
  },
  {
    "email":"ciavarella.carmen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675750778/8e9cfd9f7393fce1db4576e739ff9236-1730302457"
  },
  {
    "email":"kcarboni72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676012922/b68d502b5cd6efcb14c015131bfd2826-1730302457"
  },
  {
    "email":"calamassigiulia13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676078458/d53e6c4268e62623a5a92ef4e3af1a5f-1730302457"
  },
  {
    "email":"nicoletta.m72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676111226/d57a6060e06e5a775d61a99a6ed88d4c-1730302457"
  },
  {
    "email":"simona.meini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723675980154/06b70da849be1ca4bf37fa0eae5261e6-1730302458"
  },
  {
    "email":"vita.lamuraglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676209530/d1ea25251e88767f403be54aaafb2904-1730302458"
  },
  {
    "email":"calogeroaucello@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676275066/c1d9f619d06b5398927f5bfa2f66e25d-1730302458"
  },
  {
    "email":"pierpippi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676307834/ac460a6408236f7d419784da0c4a76b9-1730302458"
  },
  {
    "email":"elibari64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676176762/be6e8a8b70d9790032cc7c60c82691a5-1730302458"
  },
  {
    "email":"valeriamik@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676242298/14b28d986853d402f302c48d047fd175-1730302458"
  },
  {
    "email":"mguaglione@sirm.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723676373370/e7d8455658c0a79d33e9598b4210b569-1730302458"
  },
  {
    "email":"elisabetta.vezzoli@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676537210/3db25e60b5d37343cc62deea33935cbb-1730302459"
  },
  {
    "email":"mila.bocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676406138/8bf2d7f4c606dffe3b292b2b13a928ca-1730302459"
  },
  {
    "email":"daniela.cordaro66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676438906/bbb5f4274b0f00c99f56aee42f35d2da-1730302459"
  },
  {
    "email":"noretta1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676340602/ded88347d6af692a5ac01cf66ac578ba-1730302459"
  },
  {
    "email":"maria.aquilina87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676635514/15a2a673ef0cb29e315be757b1a0d98b-1730302459"
  },
  {
    "email":"peccialucia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676602746/f421015cbcd600364a7deff9406567a5-1730302459"
  },
  {
    "email":"nora.bertolotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676569978/a4e767dca402667cae3f516a9050f445-1730302459"
  },
  {
    "email":"cinzia.rocchi@leragazzeviaggi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676733818/f7203e34585051fff103b7a445b8dfff-1730302459"
  },
  {
    "email":"fabrizia@arcadiagenova.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676766586/19477a67c23c630d4d77f7beb3ddf00b-1730302459"
  },
  {
    "email":"cafarellailaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676701050/825a881db53df97a3906b83bcb1d4e80-1730302459"
  },
  {
    "email":"annamariamuraro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676832122/927a95c976f842fd6b13f5cf05309b2a-1730302459"
  },
  {
    "email":"renzi.giulia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676864890/9fcfb0a507c6cda8db5fdc3d30aba518-1730302459"
  },
  {
    "email":"tordellabarbara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676668282/c814c5a3b60edfba2938be862f1efef2-1730302460"
  },
  {
    "email":"c.diletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676799354/fe4dd62765921ec64d4810a29fb30d8f-1730302460"
  },
  {
    "email":"halynashulhach@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676930426/71d212a61b3907304bc060da0c59c48a-1730302460"
  },
  {
    "email":"carlottapag@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676897658/de2a581b124b061d85f3ee94e6875101-1730302460"
  },
  {
    "email":"elisa.marsotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723676995962/ef19f81da69becd9803bdc38a82fcf87-1730302460"
  },
  {
    "email":"m81tresy@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723676963194/c8f701ba3b0eb94901b3c64a6cbdcd1b-1730302460"
  },
  {
    "email":"federicalenti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677094266/ac66aca8048b577105c79dd7671629e7-1730302460"
  },
  {
    "email":"manuelalapi1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677061498/e85dd71b4720f7c77c6022fb32c3d8b3-1730302460"
  },
  {
    "email":"studio_kappa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677127034/6639c0c9a1c4e3687e502d50e843bc3f-1730302460"
  },
  {
    "email":"chiarahpm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677225338/70d436ee5323d1b5d0cfa70b44fcd639-1730302460"
  },
  {
    "email":"cinziamarley@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677323642/b5b19b3faab93b3b7d3ef1283e91f2a3-1730302460"
  },
  {
    "email":"francesca.gradi86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677159802/1150141178dbe768f69156169936c065-1730302460"
  },
  {
    "email":"pina.marruccelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677356410/c47c34e01fdcbcb8d97c75da82ee6f79-1730302461"
  },
  {
    "email":"michela.biag@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677454714/d5da6dfcb44c5796f6b2a238ea2dbb2a-1730302461"
  },
  {
    "email":"m.marcolini@filcovending.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677389178/b42d2c5f37abe3d3b2427fa64e10feb5-1730302461"
  },
  {
    "email":"roxxyy71.1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677421946/b194c681c6a0f0ecafb4e8dbb5892749-1730302461"
  },
  {
    "email":"elisa.tanoni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677618554/0277532ce10d33ad1d43abb02e34e729-1730302461"
  },
  {
    "email":"tiziana.ciomei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677684090/afcc604b4ed787d4b05d9ba0ba5f22e9-1730302461"
  },
  {
    "email":"calabresetiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677585786/fabcead52fc76f9ef73475bb165b42e8-1730302461"
  },
  {
    "email":"barbara_bognar@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677716858/18034b6c853a165be3560e376dc74dad-1730302461"
  },
  {
    "email":"milone@alpistamp.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677782394/9b32c170455c496c31c814037b808ab5-1730302461"
  },
  {
    "email":"franci.canepa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677487482/910e06ddfb4be2545940426a91548f71-1730302462"
  },
  {
    "email":"ginagiacalone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723677847930/da34399d8635974e83593f1aca88df48-1730302462"
  },
  {
    "email":"cri.cianiseren19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677815162/a4cdf434e2238048a77a9adfb10c7d11-1730302462"
  },
  {
    "email":"ruggierojose@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677880698/7d18ee787ea31eeb2f69d37a7cc65cf3-1730302462"
  },
  {
    "email":"corradina.dellaluna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677913466/ecc997e32211e085fe4f0d69570989ae-1730302462"
  },
  {
    "email":"alessandraridolfi1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723677946234/e25149bf669e4bc5f6c8c8957ffc0377-1730302462"
  },
  {
    "email":"gramagliamargherita@gmil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678011770/7d43ae3899a6ad386cf0e0f531ba691b-1730302462"
  },
  {
    "email":"mariadascoli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678044538/d1228cd7b3f4873d6b30e41b28cf2598-1730302465"
  },
  {
    "email":"rossellaesposito88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678110074/cb6af4721aeaabf9652396af3d11ad8e-1730302465"
  },
  {
    "email":"info@ilcommercialistaonline.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678077306/3f16445179f2803a4db170168014af67-1730302465"
  },
  {
    "email":"silviavirgulti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678175610/7a7b359e2af75e656669364fddd1eb73-1730302465"
  },
  {
    "email":"etta.coccoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678208378/e5ea2b296c9e9422c3955e110ab6a072-1730302465"
  },
  {
    "email":"catiacrepaldi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678142842/6a9d68776db4a9ebe94707ab670c698e-1730302465"
  },
  {
    "email":"valeria.digravio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678273914/0dc7f0221866158defef779c23721db6-1730302465"
  },
  {
    "email":"minicabsi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678437754/95e4fa17694e0e6d9a480af999ed59b6-1730302465"
  },
  {
    "email":"citraror@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678503290/85a6635237e0ee5e7e502ed74adfe614-1730302466"
  },
  {
    "email":"mario@firmemoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678404986/8e848dbb2736006ec8a5fb1dcc6a9ee9-1730302466"
  },
  {
    "email":"lorenzoecristiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678536058/f562ecb8c75b1869d7b0b48e4f07075b-1730302466"
  },
  {
    "email":"antonella.gregor1fp8@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678601594/07abe70e24ce5412d3bcd497cc9f32af-1730302466"
  },
  {
    "email":"claudialberto69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678634362/2deb783dbed4521f750344c03141535a-1730302466"
  },
  {
    "email":"petrinca91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678667130/3452cdf8c2c3d3526755750d87e60f30-1730302466"
  },
  {
    "email":"erregi27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678470522/b5a96ede8537d878ec00014e9b1ed4b1-1730302466"
  },
  {
    "email":"adifrancesco.22@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678765434/c3c3ef89aa9a0ba13798cab0bff2bda1-1730302467"
  },
  {
    "email":"emanuela.iannaccone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678732666/1566662d8aaeb00b03ebaf89759597ef-1730302467"
  },
  {
    "email":"elvirasabia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678568826/6d682d72b73f9e3fce88b6254d2d264e-1730302467"
  },
  {
    "email":"74barfed@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678896506/bcbbe411a61ee0000602654fb46ecedf-1730302467"
  },
  {
    "email":"ian_lilla@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678929274/3c8537768cd930346bfc566925596a54-1730302467"
  },
  {
    "email":"hotelgirasole@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678699898/71983f40decd229566d09a99365475db-1730302467"
  },
  {
    "email":"contessimara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723678863738/b35c7f10c77b14ab9b5fe1693298bc83-1730302467"
  },
  {
    "email":"antonella_58@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678962042/62075445bc0ee3fa8a47c370963e09aa-1730302468"
  },
  {
    "email":"marti_lovere@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679027578/f25de0d71804556b8da5d82da8ddcd49-1730302468"
  },
  {
    "email":"barbara-politi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723678994810/ba71a81597e91ba4c60b83978b75fc4b-1730302468"
  },
  {
    "email":"silvanalapalombara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679125882/46b68fdda9adc1ee6b90742e64f74564-1730302468"
  },
  {
    "email":"ragazzimarianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679093114/23c73a871387b4371fa2272ed644d691-1730302468"
  },
  {
    "email":"lmassarotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679158650/857028909388d6e5d706fc557d816901-1730302468"
  },
  {
    "email":"iolanda.ruggieri1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679256954/b3ef450c1772e17a58b0ab7926c404ad-1730302468"
  },
  {
    "email":"ro9berta.oriolesi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679224186/0dc30802384bc52cb9bdc4f424fcc54d-1730302468"
  },
  {
    "email":"amministrazione@viscardo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679289722/a0f87a32ec3f3166ed1ee97e6e43ed83-1730302468"
  },
  {
    "email":"claudia.reni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679322490/61958128e3d79e7e0c64b9711b277d81-1730302468"
  },
  {
    "email":"mariateresa.cenni@univergomma.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679060346/c7076972bbc7b5f60fa910f886073fd6-1730302468"
  },
  {
    "email":"carlettivalentina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679420794/b442c766e011021205504e210b6844b4-1730302469"
  },
  {
    "email":"maria.perrone.1508@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679453562/c6a8e3ec88330321bbe4d18e3cb0772a-1730302469"
  },
  {
    "email":"loredana_carlone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679486330/4130babdcdc572804fb61c3bcceba48d-1730302469"
  },
  {
    "email":"silviavce590@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679519098/3831458045c9807a415885d672da1a60-1730302469"
  },
  {
    "email":"perissinotto.fr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679617402/7594124dbcf401fa1344af24322f01c2-1730302469"
  },
  {
    "email":"chiarapenzo@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679650170/33f42ae06f711053f161a5939f144d28-1730302469"
  },
  {
    "email":"erikaste92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679682938/4d057a1fafa9cc09a84bc36f27873735-1730302469"
  },
  {
    "email":"sofiabelardi098@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679584634/ff0ea6553ccee79d494536966d6b9895-1730302469"
  },
  {
    "email":"lorrom@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679781242/d98c3a88127b558c83a140e47e4017b1-1730302469"
  },
  {
    "email":"massarinifederico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679879546/8ba8e568ee14d89283a99e7472a0e404-1730302469"
  },
  {
    "email":"laura.brighenti93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679912314/c8a528482098d2f587056946dd5625ab-1730302470"
  },
  {
    "email":"mariella.randazzo.5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679945082/e569e4e7f537e0f97fcd3d9c67ba9889-1730302470"
  },
  {
    "email":"micheladifoggia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723679977850/4f164214b241d92a53ef85ab3c52dff8-1730302470"
  },
  {
    "email":"giancarlo.bottoli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680010618/c9f0d3f150d49c6911a96168b368036d-1730302470"
  },
  {
    "email":"lyuda_tr30@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723679814010/7826f67bd7d29534bf379a6e813fffa6-1730302470"
  },
  {
    "email":"laura_fab@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680043386/45f1c45102aaf7c57669dbc23faa0d64-1730302470"
  },
  {
    "email":"giombinialice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680076154/17034b247216b32f8430cc046281fd30-1730302470"
  },
  {
    "email":"marzia.sebastianelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680141690/66810eeeb5525966d14111deb5e16a33-1730302470"
  },
  {
    "email":"elia@cannellacomputer.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680108922/7fe753ffcce19c4e712da2184f7bd429-1730302470"
  },
  {
    "email":"taia82@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680239994/07a476b3a12f1635302a8ed1f6b32a4d-1730302470"
  },
  {
    "email":"ilgiardinofiorito73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680207226/6018ae5ee704794fdb527813faefadef-1730302470"
  },
  {
    "email":"aloisiag@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680174458/17530788c29f8887cb39226d52f4ece2-1730302470"
  },
  {
    "email":"giuliana.faggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680272762/28b4c825a2a0a345dcd478aac43a69a6-1730302471"
  },
  {
    "email":"syl.vy_p@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680305530/c9c37c0699d89a5592a142d20600b40a-1730302471"
  },
  {
    "email":"gaia.fontani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680502138/9393448fbf9495871fe8306bc76fba61-1730302471"
  },
  {
    "email":"raffaellafedele.rf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680371066/bc9a67cbf76634532f06b4b2c4438ed0-1730302471"
  },
  {
    "email":"fcariola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680436602/8ca716d76f59a83229c5cf276c79b3a7-1730302471"
  },
  {
    "email":"miriaflaviani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680567674/b61ebd85c5a6d9177973afa883dc19b7-1730302471"
  },
  {
    "email":"alessandrasimonetti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680633210/c5a53c194dd023265ebec6f9f0ac4f5f-1730302472"
  },
  {
    "email":"serena.pescatore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680665978/ba131d0a14bad81828f9e0212ddb958d-1730302472"
  },
  {
    "email":"elisadesabbata@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680600442/1a38aa1f42c79c1c5d37562cba014779-1730302472"
  },
  {
    "email":"vero.pisi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680469370/6ac2431f471e1226a908729b0a1666f9-1730302472"
  },
  {
    "email":"stefaniamonterisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680764282/bcc7e04fb17a7c35bdda703949f9b0f9-1730302472"
  },
  {
    "email":"parinilinda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680797050/349843d0715fbaddd41e6f5e3ec67c06-1730302472"
  },
  {
    "email":"annamorisi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680829818/6fcede89388ef22153c26c296ed20ad4-1730302472"
  },
  {
    "email":"saragarau84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680698746/e96ada84b2ffce3679b8c04ddf70ffac-1730302472"
  },
  {
    "email":"cannizzaro.letizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680862586/229d8e7220776d937e2533d71b869532-1730302472"
  },
  {
    "email":"delbimboe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723680928122/dfc299512873c254dc61e4fa8770a2ea-1730302472"
  },
  {
    "email":"simona@riccirappresentanze.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723680895354/babd02fff22713e4a203728fa1813336-1730302472"
  },
  {
    "email":"rmugnano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681059194/1ad6a9cf483904a4cf96615a99d5d2bb-1730302472"
  },
  {
    "email":"ste.bonifazi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681157498/ef692053449210ff40a759ab68486ebd-1730302473"
  },
  {
    "email":"stefi72@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681091962/e6a0e5b59320911896c4d2c11df88ac3-1730302473"
  },
  {
    "email":"monica.pittaluga68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681190266/efca08ee8f0d56654ae3dfb1a73de856-1730302473"
  },
  {
    "email":"elena.sedoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681124730/a477dedc2d1a469cee6232d4926e23d9-1730302473"
  },
  {
    "email":"giusi.suraci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681288570/01b01f961dd1ceb97f14fb1f95101c9c-1730302473"
  },
  {
    "email":"marronecarla@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681386874/32bd0070c15a7fb19dd68ab5df050592-1730302473"
  },
  {
    "email":"assunta.bonifacio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681419642/fde5a132d4fa203e2141d251e1584091-1730302473"
  },
  {
    "email":"ore.ste@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681485178/54267b001a8a583f5eb2affb8889243a-1730302473"
  },
  {
    "email":"bedinantonella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681583482/2646ff4e12dde12d1d792368798633fc-1730302474"
  },
  {
    "email":"raffaella.alberi0@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681452410/5732c93a103332968b4d7b705b5aee4c-1730302474"
  },
  {
    "email":"elisa.preli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723681517946/a5a661600b8eecc3bb1537bc9fc06409-1730302474"
  },
  {
    "email":"tizianamarsala69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681616250/b874035a888d2730c4943840c7b84566-1730302474"
  },
  {
    "email":"ales.gullo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681550714/7a723f11417867feff5f8684d5d93bd6-1730302474"
  },
  {
    "email":"danielaeffe2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681649018/a4888f8575f558eaeba39eb50984c711-1730302474"
  },
  {
    "email":"raffaella.bellomini@vienrose.ut",
    "url di attivazione":"https://verdissima.it/account/activate/22723681714554/71a6415d9dfd3aaa9e5bb69cc893139d-1730302474"
  },
  {
    "email":"pa.anna73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681681786/0167a655ce368f186aa38f92dc735df5-1730302474"
  },
  {
    "email":"chiara.zumbo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681812858/8cf95c7d03027d462e8177836d93bdb2-1730302474"
  },
  {
    "email":"cristina.piscopo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681845626/0f991db1dd05f2e3cbcb5a3e84e69406-1730302474"
  },
  {
    "email":"ciamaglia.barbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681747322/33142b34f0f2db805ba0021b0ccea41a-1730302474"
  },
  {
    "email":"gabrielladelisi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681911162/11510177423f482e3a194283106ae317-1730302475"
  },
  {
    "email":"ilaria.marchesi@hofstra.edu",
    "url di attivazione":"https://verdissima.it/account/activate/22723682009466/443c35dfdfcd1e7a07ed7ca6403fe1a9-1730302475"
  },
  {
    "email":"robertociarrocchi56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682075002/c0ff644783dbde41b39b1c11e1d27b58-1730302475"
  },
  {
    "email":"fiammacaldiero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723681943930/845f068fd964e9f88c0c6afbf14c9542-1730302475"
  },
  {
    "email":"rozirozi2@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682238842/8fb7f443984fcb72f465e1a7f94e77e7-1730302475"
  },
  {
    "email":"nicolettaneri4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682271610/eb60dc5e754ad15b30e0f60b309caf9e-1730302475"
  },
  {
    "email":"micaela.greco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682304378/8cbf8754f4d8fde1cf51940ff676a383-1730302475"
  },
  {
    "email":"pieroniandrea.mc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682173306/b30712de27b41a0935881c5043c431eb-1730302476"
  },
  {
    "email":"maribonaccorso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682369914/7671d388977a8a05fd9d0e75bf6b96b6-1730302476"
  },
  {
    "email":"deacri@gem.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682140538/87206dd0d832889a3947570e8b839b7e-1730302476"
  },
  {
    "email":"rossana.marulli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682337146/afdd22bbf284a810d1522e3f4ddb480a-1730302476"
  },
  {
    "email":"elisabesso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682402682/1168bdd46e2e6ed99fdc684f0540c487-1730302476"
  },
  {
    "email":"chiar.eramo@wuerth.ot",
    "url di attivazione":"https://verdissima.it/account/activate/22723682500986/484b404be344235a8498e1e05369294f-1730302476"
  },
  {
    "email":"tokarz.gosia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682566522/c6b6fed62fed51f9e9fe5939d82fc409-1730302476"
  },
  {
    "email":"mariobellastella@maxy.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682533754/06830d6163289f9c860f51cf0cdc5e15-1730302476"
  },
  {
    "email":"lorena.pedrazzetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682599290/99be38e3252e03065a74fc55614a78ce-1730302476"
  },
  {
    "email":"antodg1980@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682435450/a446fc6f166f638a70f859d8a3b723fb-1730302477"
  },
  {
    "email":"miottovioto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682632058/90e874ecceae8f8156a8cfb77e03a9c1-1730302477"
  },
  {
    "email":"lisa.chinellato@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682664826/420e8000228477af0d13b0191e63f5d6-1730302477"
  },
  {
    "email":"francescocartia24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682697594/e2c039032a1352c5255035f1e7d11afb-1730302477"
  },
  {
    "email":"lauratecce6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682763130/ae977574e1ff106a224e64d94ba000a3-1730302477"
  },
  {
    "email":"paio.72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682828666/37fec279fe198c54dbc198ca3053fb9f-1730302477"
  },
  {
    "email":"marisa.longo57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682926970/37c05a1f202a70e3b19f1a33ba9f2d48-1730302477"
  },
  {
    "email":"sabrinafusco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723682959738/cc2655ac1db9faaebae363ea01185861-1730302477"
  },
  {
    "email":"annam.f.comandatore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682861434/686a22d31228c4da3341dbdd7a25644d-1730302477"
  },
  {
    "email":"benedettasprugnoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682894202/735b72637677551083f1146f294e21a1-1730302477"
  },
  {
    "email":"lanzettisimona75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723682992506/edd79c3437cda3217123f90e82b21d78-1730302478"
  },
  {
    "email":"ruggimary62@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683025274/46362fb2dc871177861a1e544f230a9f-1730302478"
  },
  {
    "email":"pescemarina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683058042/80c083c4272fab51e326515c65a2741c-1730302478"
  },
  {
    "email":"mariamarchese06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683090810/a4cb4cdaa02f254082bb1e81039b2776-1730302478"
  },
  {
    "email":"elisacravero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683221882/baf9dd6517536c4a0711268fabc05782-1730302480"
  },
  {
    "email":"francymartina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683156346/f9845c709e56561f18af9e458ae4dd9c-1730302480"
  },
  {
    "email":"raffaella.becchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683189114/01461723d149ba0aa1286acf8af18cdf-1730302480"
  },
  {
    "email":"sara.vicanovic87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683320186/e14207c2a5b0da7c53186b1eaf79d5e5-1730302480"
  },
  {
    "email":"kbiasuzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683123578/6f7158c19ec84f7701a3b04aa8583c08-1730302480"
  },
  {
    "email":"md.barbaradeangelis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683287418/636d04b3d2e3f1cde680ce97ad7e6ca7-1730302480"
  },
  {
    "email":"katddb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683352954/637487a35d61b21e8c5c217928ab4b99-1730302480"
  },
  {
    "email":"emanuelascorpo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683418490/42d08bc2707f05aae09ad3eb64ba09c4-1730302480"
  },
  {
    "email":"assum@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683451258/649498b7133df6dc4b9940b65182deb5-1730302480"
  },
  {
    "email":"stefyferranti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683516794/663ac1c568761594425e8512453fa561-1730302480"
  },
  {
    "email":"fabiolapetrocchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683484026/4b565afdbaaf3aaac7737d3bb0ea8b41-1730302480"
  },
  {
    "email":"eleonoracamuso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683647866/c8e8e14eece891de4434d5e909469f52-1730302480"
  },
  {
    "email":"broncetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683811706/29b3b6a1c8c8439a77221366ccf735b5-1730302481"
  },
  {
    "email":"simona.martellini.cap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683680634/2059cd49b6fc0b8f71cfc37fa2470661-1730302481"
  },
  {
    "email":"mariarosaripa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683713402/de28bda1a0e7636ee68dfc32b1ab4e1d-1730302481"
  },
  {
    "email":"sulfilodellacreativita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683844474/8a42117387e1b3823ac989a82d772e87-1730302481"
  },
  {
    "email":"elisamatilderastelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723683877242/2413e39b28b44857a6b5cacd349fa4d4-1730302481"
  },
  {
    "email":"deborahbattisti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683746170/b02d7c65aed4e63d53620c7aad82ff10-1730302481"
  },
  {
    "email":"annalisadelguasta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683910010/3a9cee89df92db9613b0da96070f15f7-1730302481"
  },
  {
    "email":"federica.micelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723683975546/95aeb9a732afee67c0a56c0aa99659d5-1730302481"
  },
  {
    "email":"sonia.rellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684073850/9ffaacad192a58564d8dcb9abbc748d2-1730302482"
  },
  {
    "email":"mik.68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684106618/fa4174d7fc2a53be0d06be9c5e811306-1730302482"
  },
  {
    "email":"roberta.cosenza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684172154/9d48082bf8cd89d132143f82b1f121d2-1730302482"
  },
  {
    "email":"ficaracristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684139386/e9e61f13d1c97abba438d208a0556ae6-1730302482"
  },
  {
    "email":"delazzerol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684041082/58b8047cc233dfaf2eac5414e799d1ae-1730302482"
  },
  {
    "email":"stefaniadelcarlo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684270458/5bdc0dcf35f112f0e51c3f67e7a1217c-1730302482"
  },
  {
    "email":"francydago23@yahho.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684237690/4d087ffd7c447dd368c6aa60223cec32-1730302482"
  },
  {
    "email":"ellerizzato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684204922/cefbe971c4b3bc1f3c405840bbead1fc-1730302483"
  },
  {
    "email":"nadiacitterio2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684368762/e77ec2a31598721dfc41915a5450a018-1730302483"
  },
  {
    "email":"fede_vermiglio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684401530/9f1f6b90c7073ef48acc800937e78d82-1730302483"
  },
  {
    "email":"valentinauriati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684335994/d832e38b4794712afe3e2c1a5ef67531-1730302483"
  },
  {
    "email":"sandra.massa73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684467066/b65ba15b92ad24c0fef21c41a5d7793a-1730302483"
  },
  {
    "email":"elisapiovaccari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684499834/490ee4c6daaa2ebe97084da4c41fe0b7-1730302483"
  },
  {
    "email":"rosannamartinelli4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684565370/f69355d94702de64e5b871e138a90822-1730302483"
  },
  {
    "email":"castagnarisimona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684303226/9f4afe75e900e5d50ca6bb089da1ed76-1730302483"
  },
  {
    "email":"monica.gamberini63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684598138/2f25e391792fceffdb3292d15755ceb1-1730302483"
  },
  {
    "email":"cinzia.giovannone.cg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684630906/23951347fee193354142e096e13d090e-1730302483"
  },
  {
    "email":"ramona.gendolavigna@posta.istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684794746/b2101ed568d2ea0503e7a2f87d8de447-1730302484"
  },
  {
    "email":"alexis.nespoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684696442/00b587a4befca6d737977c39792d8d0c-1730302484"
  },
  {
    "email":"annagasbarrone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684729210/4f383092157713778989595a818fb15f-1730302484"
  },
  {
    "email":"mdenicola@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684925818/65145d89bca1f10c05f623632db9a15b-1730302484"
  },
  {
    "email":"mariangela.yr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723684761978/ad80de92f9074844087c04d20fee616e-1730302484"
  },
  {
    "email":"a.vatrano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684991354/5a0521048a74d9e01da6844111d1e5d8-1730302484"
  },
  {
    "email":"elena.palm@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723684958586/b8020bb06da8751eabfae847a77cd25d-1730302484"
  },
  {
    "email":"cecilia.bottai@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685089658/88945dcb417d0142567cba533c870c7c-1730302484"
  },
  {
    "email":"vies.e@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685155194/b38481e42025c383b1d3cc21118344f7-1730302485"
  },
  {
    "email":"nunzia.nu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685122426/5647c44d120808fa76ed509cf5460e0e-1730302485"
  },
  {
    "email":"selvaggia.ar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685056890/76619957b10591517f7d3fb72b42b022-1730302485"
  },
  {
    "email":"menalanzante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685220730/19a416888e83cdb7b4c412be0863749d-1730302485"
  },
  {
    "email":"auradf86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685253498/4394c864430fb323bc5457db1b744212-1730302485"
  },
  {
    "email":"marycossio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685319034/add9688f1a0c2c9e124e01c6f11cfe1b-1730302485"
  },
  {
    "email":"michelaiscrizioni10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685384570/ff1f790a2f0d42bad1a28bffd0c87d29-1730302485"
  },
  {
    "email":"sabinarega@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685286266/02eaaf98a7437f83524a63125be97f16-1730302485"
  },
  {
    "email":"monyyy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685417338/6adb31e6b296f17b7a47d5cc23476412-1730302485"
  },
  {
    "email":"alphecca22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685482874/e915044b64b75d060004b517264be433-1730302485"
  },
  {
    "email":"catrintamburini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685548410/e1a4a9664b9c5627a5957dff888b1ee0-1730302485"
  },
  {
    "email":"robertantonello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685450106/c11a77d864b7b97ddc98a119f605888d-1730302486"
  },
  {
    "email":"antonella.raganati@unina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685613946/607eeb13d270995af5c90cda77af5259-1730302486"
  },
  {
    "email":"mary.ary@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685712250/c7789902fc84bfc3e75af71d48a04297-1730302486"
  },
  {
    "email":"elisabetta.dandrea@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685745018/33d96940dd35a2062e19ed972b29b9e2-1730302486"
  },
  {
    "email":"simonagiusti.s@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685777786/5c02ce10ba8456e200ce524beead546d-1730302486"
  },
  {
    "email":"lottibarbara70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685810554/096f71c66bf8d6c0317b8c8b5d72dd6d-1730302486"
  },
  {
    "email":"francesca.p88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685679482/6c6a08e314beac6909c487a8f3c1eb50-1730302486"
  },
  {
    "email":"agostinellivalentina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723685581178/cb884ce82819455c0daae4e982531916-1730302487"
  },
  {
    "email":"veramonzani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686039930/5bbc35617b95bc511734031f83ea9ebf-1730302487"
  },
  {
    "email":"valeria.ducler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685843322/4a38f3ac0bbc8a77d5face0fa5f14181-1730302487"
  },
  {
    "email":"arigiu88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723685908858/5a3f32bfba7f9630b379ea19c6f5d13a-1730302487"
  },
  {
    "email":"laurinaruggiero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686105466/58a67b5d46be4abd91c273154aff8571-1730302487"
  },
  {
    "email":"a-morena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686138234/724a394f5cc7fba09ec0def5d5610412-1730302487"
  },
  {
    "email":"mil.nez64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686203770/cd369ca7af7910fb08e618f5c89d561e-1730302487"
  },
  {
    "email":"michelamerli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686269306/7abef63dcbd2a0c000292baafae45f18-1730302488"
  },
  {
    "email":"bapi1968@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686072698/bcb31611ea3580dfbf9bd8451d8e8acc-1730302488"
  },
  {
    "email":"anna.leone0506@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686302074/f909a9ccc146be38838bc8068fed2d63-1730302488"
  },
  {
    "email":"lucia@apima-fermo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686367610/e9800ce77f6e925ef5d87c8e5886279b-1730302488"
  },
  {
    "email":"siricci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686236538/610e7165d6f8eff0b291539344c43f14-1730302488"
  },
  {
    "email":"francesca.paciarelli@barsotti.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723686400378/6f3fb97c4cf3fee708f149d822ae9f90-1730302488"
  },
  {
    "email":"ila.pauletto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686498682/4e7de059e262efc68c1b7ad185d41724-1730302488"
  },
  {
    "email":"elisa.bertazzolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686334842/eefc634af5def796ffbb2b0a332e530c-1730302488"
  },
  {
    "email":"djoekeludwig1962@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686531450/0cde7e3e73e382a344be643a0cfbd023-1730302488"
  },
  {
    "email":"stracciafrance@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686433146/0cc93e67c01d3ed7b21036dfb44ff05b-1730302488"
  },
  {
    "email":"mariellarusso63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686564218/0d0715f6fd0d86c10e56787003211140-1730302488"
  },
  {
    "email":"nikofit1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686695290/a6882e58e8d01d43def5b0657155335d-1730302489"
  },
  {
    "email":"bertifrancesca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686760826/0905309bd660233857f2ca377919f260-1730302489"
  },
  {
    "email":"calamarosilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686793594/e8cf3bb7f5103ef373a5d5f342037176-1730302489"
  },
  {
    "email":"rch.br@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686859130/3f68dedd188f02e1214532e3941a4ecc-1730302489"
  },
  {
    "email":"pat_buz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723686629754/e584315d5888b7ab1f341b8b295a9806-1730302489"
  },
  {
    "email":"lau.bat.69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686891898/a6c70e201aaed93c1027e5055f96f179-1730302489"
  },
  {
    "email":"gabriella.pierabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686924666/1b00d5ef5ae96c57c58ae439dfff7041-1730302489"
  },
  {
    "email":"laura.rogolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687022970/63f0bd7e81b06933d4c312736408b67a-1730302489"
  },
  {
    "email":"romyrossetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686826362/167a72ce0211c34d21479dc271520cc4-1730302489"
  },
  {
    "email":"valeria.stella79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687121274/7b4e1bec65a402ef613958e5650d97c6-1730302490"
  },
  {
    "email":"ste.didio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723686990202/c4a9bc2b08fc386160337cfcd2d90b25-1730302490"
  },
  {
    "email":"stefaniadipaolo69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687154042/bbb9e06cf1650a97e2a537f64519f9e9-1730302490"
  },
  {
    "email":"carlascatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687252346/2612153022d0fae5e9da58678b670a61-1730302490"
  },
  {
    "email":"crisalide.42@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687219578/a15c2b004e7bf9cb131af4a8d4c4585f-1730302490"
  },
  {
    "email":"enrica.zatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687186810/e25536a397eadb32a0d42fec029bdf90-1730302490"
  },
  {
    "email":"angelamilazzo0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687055738/21eff223f5132443d74f8b6b741e1f2a-1730302490"
  },
  {
    "email":"paola.sartor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687317882/4baf4726b8de205f9eb702c957b5f5a9-1730302490"
  },
  {
    "email":"twysty@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687350650/ef7618d004739d50b8a42577103471da-1730302490"
  },
  {
    "email":"annateresaandreozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687285114/bc817d53018ee5107bfc183da0c96ca4-1730302490"
  },
  {
    "email":"katjusa@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687383418/03fd247f10f993a922b517f6476906cb-1730302490"
  },
  {
    "email":"valentinacaranci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687481722/da828b7c29e05a6ae9199813e91cf748-1730302491"
  },
  {
    "email":"renata.bongiorno.1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687514490/d7b3928f9814772c5ce745b43f07ada7-1730302491"
  },
  {
    "email":"lauboy71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687547258/7778d0f6de874376b07acf5f69ddb11b-1730302491"
  },
  {
    "email":"s.saretta@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687580026/646e0a0e6cd6473180f50f896baf84fc-1730302491"
  },
  {
    "email":"ele12041981@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687612794/885cec8a60321ed18b60dd3484b15544-1730302491"
  },
  {
    "email":"daniela.blasi.70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687678330/8b2c13dec088ccdccdcebac6eedbb4ed-1730302491"
  },
  {
    "email":"maya.gatani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687448954/8985143ddb1c5488c3c569a0a80577e4-1730302491"
  },
  {
    "email":"giovannacovre.5@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687743866/029d58f3816fe33312f1d0840e558a4a-1730302491"
  },
  {
    "email":"t.lisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687711098/689237b060c300bb6137f1b5798892be-1730302491"
  },
  {
    "email":"moiragiumatte@interfree.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687842170/e3d69ce32bc76f5a4ab82f84f6ac0a35-1730302491"
  },
  {
    "email":"cascino.alessandra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687874938/542f7fd0d7bbaa7f0eb64dd427f9897f-1730302492"
  },
  {
    "email":"michcipollone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687809402/f49e75097d0949a899d862032b77e9cf-1730302492"
  },
  {
    "email":"franzcalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687776634/86f86cf575144a232cd01cc1d2c29223-1730302492"
  },
  {
    "email":"r.mandressi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723687907706/9b7adf2ab63716347b60f827c126473b-1730302492"
  },
  {
    "email":"paolasergi20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687973242/16de558ac161313c7c24982871eb31ae-1730302492"
  },
  {
    "email":"angelametta81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723687940474/0e44d08584bb31c4044681c1d35cf7ab-1730302492"
  },
  {
    "email":"paola.basconi1961@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688006010/364a6bb49dc60f4a260aef0b733223f4-1730302492"
  },
  {
    "email":"serenasilvia1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688038778/32e73073fe32f1337490bfa1b0962230-1730302492"
  },
  {
    "email":"cocco.t@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688169850/8262b1cb21c42fecdad0ed457b3540a4-1730302495"
  },
  {
    "email":"passamarinella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688104314/33226f8c92d3125ed80b286dfe1fae6a-1730302495"
  },
  {
    "email":"maddycolombo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688137082/51c42b422021521194c34ea28274d579-1730302495"
  },
  {
    "email":"sara.antoniazzi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688202618/d95e6041845e8d5f8dae7cb4c500cb87-1730302495"
  },
  {
    "email":"lamaildidaniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688268154/388c01afa0bd5919121d479f6e1e7a09-1730302495"
  },
  {
    "email":"annamariacalabretta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688300922/47518a02b5d95f2ef96ed63ec6408965-1730302495"
  },
  {
    "email":"beatrix67@bluewin.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723688071546/441d57353b7452775d319171c2e848a3-1730302495"
  },
  {
    "email":"cami_ang@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688464762/c7d0e56240642afd04bfa9de94c157d0-1730302496"
  },
  {
    "email":"rosaria.addamo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688333690/ec7b1f17db381b673b7ef961d03491d6-1730302496"
  },
  {
    "email":"ritamaniscalco70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688563066/e0e241e9204fbfbc5f50df7c25540e06-1730302496"
  },
  {
    "email":"la_gigli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688530298/bacfd54d864bf25cea68528eef2ac376-1730302496"
  },
  {
    "email":"paolapiarulli7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688595834/1e22a95322c1415839f2f320194db4cf-1730302496"
  },
  {
    "email":"chicca.max@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688628602/52e9e617a416e3d1438dcf9988ac0775-1730302496"
  },
  {
    "email":"gessicasanta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688661370/75246126f7ef013fc3b2a025392e2bf4-1730302496"
  },
  {
    "email":"mariaantonietta0513@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688726906/1daba648420495f8a32a442e2c7e197d-1730302496"
  },
  {
    "email":"isottabertoletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688792442/154bcfa3bd2f2deb7072a684c80b253f-1730302496"
  },
  {
    "email":"clotildemuzzi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688825210/4d541d8a93282cdee1c5397bae519064-1730302497"
  },
  {
    "email":"lauradepetris@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688923514/5768460f24a1d933219df2341f1128c5-1730302497"
  },
  {
    "email":"antonellamollica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723688759674/495fe8f951e2a1cb58b1566b2a26c21e-1730302497"
  },
  {
    "email":"costanza.gargano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723688989050/c60057bf19ca4837b49a485d361f54da-1730302497"
  },
  {
    "email":"monicaperolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689087354/77b3d1b79e9a9fb87b48f949ba308029-1730302497"
  },
  {
    "email":"katiuscia.cecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689054586/c111d00ae0ffa9256cfc51f48e9e8b45-1730302497"
  },
  {
    "email":"paola.fratta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689120122/499daeb2f609d3915cc4469760545b3a-1730302497"
  },
  {
    "email":"antonellagattero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689218426/f8cc086bd5c799b615f13ba59f55f24c-1730302497"
  },
  {
    "email":"virginiagigli.98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689283962/f762f34616da56ce43a0e00cba4c1a1e-1730302497"
  },
  {
    "email":"paolacampana77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689349498/0071f85baf86db54d165cefe638f5892-1730302497"
  },
  {
    "email":"rosa.grazia.bua@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689480570/9bb3ac3388e4875e67682b12f614f519-1730302497"
  },
  {
    "email":"angelo.doglio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689415034/85999a31dec6eb9ba49b618cd9e630f0-1730302498"
  },
  {
    "email":"mariangela.ventruto84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689513338/640d57021ec69c7cbd1b172022437f8b-1730302498"
  },
  {
    "email":"andrea.pasquazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689316730/3b98d0465c0a06e6a05ee97c1499ddd7-1730302497"
  },
  {
    "email":"francyancy@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689611642/8ba6a167d481ab1450fcedb6542f173c-1730302498"
  },
  {
    "email":"caterina.albert80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689578874/b798280c5b3c36e74e29ffd1da1ce083-1730302498"
  },
  {
    "email":"ilenia.tramacere@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689644410/68646f371b47d355ec6004cede655b2b-1730302498"
  },
  {
    "email":"claragione@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689677178/19f9585d4e814d8d70f45e4b4a8516b0-1730302498"
  },
  {
    "email":"brendalr93@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689709946/aaec5b95436437dc9e4f19f61be89128-1730302498"
  },
  {
    "email":"clausloc86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689808250/740fbf435970881ce671121c48880131-1730302498"
  },
  {
    "email":"patriziafrioli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689873786/08ddb9dc2022fa95f6f44bf4d5c5ff0b-1730302498"
  },
  {
    "email":"silviamac73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689972090/eee7ee687f5d2b8093253e8e72ec73da-1730302499"
  },
  {
    "email":"emmeeffegigi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723689906554/e4f05d48e3489e8b2f76548aa5dfe64a-1730302498"
  },
  {
    "email":"giovanni.ronca00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723689742714/2094ef3060f79296fb41892fd60250e8-1730302499"
  },
  {
    "email":"marydelu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690004858/e44cd843ffabb5c8f527271dbc0de456-1730302499"
  },
  {
    "email":"alessia74inserra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690103162/19a5dd221ca5878f8b0303f56460844e-1730302499"
  },
  {
    "email":"lara4275@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690037626/ab7b4d16ace6d929a0801ef686060ee0-1730302499"
  },
  {
    "email":"anna.difo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690135930/a2af8f2741ec16b615c1bedfcc5583d5-1730302499"
  },
  {
    "email":"kattigatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690070394/89b08ca9cf1a56f3e59ed132913174ce-1730302499"
  },
  {
    "email":"eleonoralorenzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690168698/fa40a3c03e9f6eb53edd8c5352574b34-1730302499"
  },
  {
    "email":"pyfer@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690234234/7111006823825b72b284904bee90024e-1730302499"
  },
  {
    "email":"inesangelone74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690365306/4eea15f133727b9f500ffce9d7adb84a-1730302500"
  },
  {
    "email":"serena_vanzolini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690332538/767000cd1cba6d46c17648d66f0c1714-1730302500"
  },
  {
    "email":"laurabrasolin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690267002/f3138a100dbf267056b1edf1b415641d-1730302500"
  },
  {
    "email":"francescaimperato91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690299770/0c2c1bcd0495d0e6b69fe3a681186bbe-1730302500"
  },
  {
    "email":"simonatms@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690430842/6fafed3716c760bc5859cf28915e6d3a-1730302500"
  },
  {
    "email":"tiziana.schepisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690463610/c069703e1c4f04153c4d9a55f9f2bb08-1730302500"
  },
  {
    "email":"danieladiber@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690529146/c2dcc962e0eb644cf2bc330f97857b78-1730302500"
  },
  {
    "email":"michela70bott@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690561914/f612669e1e197d0624a8165b87f7a828-1730302500"
  },
  {
    "email":"kovok@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690398074/2fa2aeac35b1e5862e6c2106015e2534-1730302500"
  },
  {
    "email":"bene.magni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690594682/8de85c32688489bdf8e46dc1e64e596e-1730302501"
  },
  {
    "email":"ismailativ@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690627450/c2e25dbc998e20f6d42314f945fd2002-1730302501"
  },
  {
    "email":"valeriamicheluzzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690692986/9ebb6ab1e3358a6b7f6677c99be4ab28-1730302501"
  },
  {
    "email":"malmici@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690660218/24a2a008c39a0421d4f3a1d6223c1b54-1730302501"
  },
  {
    "email":"siza1904@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690791290/7f0b1bfe7f5541e9a3acb3b07787c872-1730302501"
  },
  {
    "email":"lucreziagiannoccaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690758522/89c1cd5ff928b432b310649ffb037250-1730302501"
  },
  {
    "email":"marchegianiauto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690725754/34ad09a7009bc957c0768328436378e7-1730302501"
  },
  {
    "email":"nyastolf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690889594/c17681b9f9857942544e02e32647ba28-1730302501"
  },
  {
    "email":"dany-marazza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690922362/a7a95ab0db7bf3461e7ca52c909bdf01-1730302501"
  },
  {
    "email":"olioh_f@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723690987898/d6dae14b3d0f7746da8389c99c3068b5-1730302501"
  },
  {
    "email":"angela.adin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723690856826/0dba98cb57d93c782398f771b13d6983-1730302502"
  },
  {
    "email":"ciribicipadenghe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691086202/a8079ea1771a1dfafb4319fd8ff82ec4-1730302502"
  },
  {
    "email":"nunzellalaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691020666/ef702f3fc5d02719fa27c3f93dab1fc6-1730302502"
  },
  {
    "email":"gessicapressacco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691053434/e342b0468a2e8c4325b238a15ffc9477-1730302502"
  },
  {
    "email":"primulanuova@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691151738/d7d8663886c7274d24717fd0cceeafcb-1730302502"
  },
  {
    "email":"straymari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691250042/aaf88a662f0f338de80d545887e45f41-1730302502"
  },
  {
    "email":"cristiano.mauri61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691184506/978ac113ad5fd6cc914c08d7c008778e-1730302502"
  },
  {
    "email":"desabatoclaudio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691282810/4ac3f9368367bf6206b33d3e3ddf6474-1730302502"
  },
  {
    "email":"a_sciarra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691348346/1e2a94cd5276bc26e19a282a52c76c07-1730302503"
  },
  {
    "email":"nadia.luciani1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691381114/b395e180559bb876a63f975e68852bf0-1730302503"
  },
  {
    "email":"romina.alessi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691217274/529c9385218d470e4a6e650929145c12-1730302503"
  },
  {
    "email":"avv.gianninisilvia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691315578/50714f3066c4533b93fccac18c454760-1730302503"
  },
  {
    "email":"lauratedeschi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691413882/f45fe5574e627799e058f8d3c73d1411-1730302503"
  },
  {
    "email":"erikapio37@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691479418/28430af86ac4e7db637932bd09406f61-1730302503"
  },
  {
    "email":"denise_cam@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691512186/ccdf6522264712d864da276d8aa2b937-1730302503"
  },
  {
    "email":"vivianadileva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691577722/705d4ef5daf6a2c3b8a633fde2bb67d4-1730302503"
  },
  {
    "email":"anna27marchese.91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691610490/e4e6cb0e36b5aa74e37031e71e917076-1730302503"
  },
  {
    "email":"chiara.speranzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691446650/381600de2a7d9ad548a6afd1ae74b0e2-1730302504"
  },
  {
    "email":"alexpin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691774330/de9d2e0a9048457a87c5e73567b9b655-1730302504"
  },
  {
    "email":"alessia.criss@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691708794/ab9a92a531a044ec8ba231168589e14c-1730302504"
  },
  {
    "email":"deboracriv@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691839866/ff70341a879f5aeb678e551667ac7c96-1730302504"
  },
  {
    "email":"petrucci.ambra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723691938170/2cf5e19aa7c325488f1be6f93259e9c9-1730302504"
  },
  {
    "email":"marian78@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691643258/110775e16549e3942fbd3b0cfdfc6929-1730302504"
  },
  {
    "email":"lillyrei@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691905402/5e6e3bd0f248837db0ae00360e3ee9f2-1730302504"
  },
  {
    "email":"robertomicaela@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723691872634/64ac7d68b86cb509bbd6d85039a172cc-1730302505"
  },
  {
    "email":"cristianavuerich@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692036474/41b7d8036d886d11668ea9578b02662b-1730302505"
  },
  {
    "email":"paolamauradea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692102010/b2d41f16ded1cbe52f899d5bd06e7175-1730302505"
  },
  {
    "email":"valeoriginales@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692134778/7d171d098754de3b6b42d7fb63cccbbc-1730302505"
  },
  {
    "email":"margherita.centola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692069242/e5178170008240dcfb3f65fac98f63ff-1730302505"
  },
  {
    "email":"cbaldoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692167546/734a2b1d187c3cd5f0f5511674513107-1730302505"
  },
  {
    "email":"jessicastar83@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692200314/e0c0c2e8d7593acf0030e41604ae7e57-1730302505"
  },
  {
    "email":"giorgiaarmani86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692233082/82a774486ef9d3b3249b90aa96bed678-1730302505"
  },
  {
    "email":"mc_cataudella@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692298618/25d9e374244499dec649f0d961785e93-1730302505"
  },
  {
    "email":"bonnies1476@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692331386/a4425fbccd49d1ea4c84e9ec7a3181ee-1730302505"
  },
  {
    "email":"claudiaanna.gattini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692396922/5718c41049f11377376b3c10152d4b52-1730302506"
  },
  {
    "email":"direnzoamalia@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692364154/1cf9d171332669baabbe5cb7071f4516-1730302506"
  },
  {
    "email":"gaia.pavia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692429690/167da6677d2e4abcb1540ad4a1326c11-1730302506"
  },
  {
    "email":"silvi-etta87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692265850/5bcb0161dcab96acc5614cff5bedb232-1730302506"
  },
  {
    "email":"lorenastefani1964@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692560762/9d70ce8e5f8de8bd251397d33aaf5c57-1730302506"
  },
  {
    "email":"francesca.turini79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692593530/d031509a5eb9d84e89fb618e29fa7185-1730302506"
  },
  {
    "email":"sara.dallacqua@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692659066/e918439ddcccd69fc895105ebb5d3613-1730302506"
  },
  {
    "email":"antomennuni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692527994/5416f9b6e7ab95c72b9a4b8b551ccdf8-1730302506"
  },
  {
    "email":"chiara.antonini1@posta.istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692757370/910b91d6867d7b5bc102735a75845e5b-1730302506"
  },
  {
    "email":"coccinella073@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692790138/668f1bde3cfc0c09ac877ae9c9724897-1730302507"
  },
  {
    "email":"paola.gasparin83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692921210/743fb37aaf4255ea9bdddd32a4e02033-1730302507"
  },
  {
    "email":"vera.epifano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723692855674/0628ad00b440829a94b0a6c052ad6285-1730302507"
  },
  {
    "email":"martagorini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692691834/2d2e533bce4d4710e3ac5f5f3a83892e-1730302507"
  },
  {
    "email":"bettabas@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723692822906/95b5488388d964a17acafcac98fd00d5-1730302507"
  },
  {
    "email":"marangon.valeria@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693019514/da77c2114f6b024d572cb7f069c66a7b-1730302507"
  },
  {
    "email":"docvera.84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693052282/3b24c4f758ff95defc968123b5283306-1730302508"
  },
  {
    "email":"barbieromanuela8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693216122/9b165015c26563856cd430dbf3dfc278-1730302508"
  },
  {
    "email":"petra.punta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693085050/748402eb7ca3b77d5ce9f4e4f9d31603-1730302508"
  },
  {
    "email":"marioconte67@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693248890/85f86b67aa01da662f58a6ccd3b9af67-1730302508"
  },
  {
    "email":"brunaprocida@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693150586/7cff01b76fa0c062769b3dbda96ee22e-1730302509"
  },
  {
    "email":"mapi.z2010@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693314426/963c7780a6b38371e8aaf050520dd53b-1730302511"
  },
  {
    "email":"decaros2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693347194/acc4b1c20cb0678e6dedc20161af9df3-1730302511"
  },
  {
    "email":"adelaideortenzi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693379962/9dd223cb8e1ed922f7fdd8f372960c2f-1730302511"
  },
  {
    "email":"ritaserra0109@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693281658/a4839cea7f9e24715e1c130efc4a5b66-1730302511"
  },
  {
    "email":"mariarita.melita1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693478266/82c02b206f923cf9f4a0541f938a2289-1730302512"
  },
  {
    "email":"paola.tapinassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693511034/2d52ba6057ff15823af79e69d655c263-1730302512"
  },
  {
    "email":"erna.ilmer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693543802/6e8fd3f9b5075a8a47eec3ce8cba220e-1730302512"
  },
  {
    "email":"kimmaiolo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693674874/4653b1a283dba0b270c152f06797ca25-1730302512"
  },
  {
    "email":"a_tselikas@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693412730/e6d1617d7943d1f1dc0c0f8784a1f468-1730302512"
  },
  {
    "email":"claudiabartolini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693642106/5753456d36142f3a64160e83f5a883b2-1730302512"
  },
  {
    "email":"nicola@camer.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693707642/bf09f71e727b148e048fedc02bd80757-1730302512"
  },
  {
    "email":"bruni.chiara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693805946/3cd0b39b7c59ff908abde0215835c3c0-1730302512"
  },
  {
    "email":"latucci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723693773178/353103699830105a95064e9ffff4419b-1730302512"
  },
  {
    "email":"micol.simoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693871482/715b61bb5fdcb2dac4453b76362363ad-1730302512"
  },
  {
    "email":"francesgiants@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693838714/65c05a1b64f82afb428d9765ed2ccad7-1730302512"
  },
  {
    "email":"spataforagiuseppina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693904250/c57bde485607f868ca3f6978acff3380-1730302512"
  },
  {
    "email":"gatti.martina13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723693969786/9d1ebb61829dbaf05191599daf3cbcbd-1730302512"
  },
  {
    "email":"r.cantello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694035322/51057ad322bab0944adf1e3c05fedc05-1730302513"
  },
  {
    "email":"fabiana.saunig@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694068090/384e351b746adb73386b8c380c9c3abe-1730302513"
  },
  {
    "email":"marzi0274@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694100858/bf5340ca6c34903b9e61baa2b496db63-1730302513"
  },
  {
    "email":"federica.delzotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694133626/7ff4480c18171702bbabcb469988fc7b-1730302513"
  },
  {
    "email":"danielagambarara@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694264698/9ce540b8a48347863fccae499fd4e68c-1730302513"
  },
  {
    "email":"vaniglianocciola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694297466/b431ea41ae484a1658ab188a95639b99-1730302513"
  },
  {
    "email":"tiziana.talarico.84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694199162/36057a154bc861d132c08469db29fc14-1730302513"
  },
  {
    "email":"colloca.stefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694166394/423161a9a699e198ff8d47b93b711d88-1730302513"
  },
  {
    "email":"rgrilli67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694461306/c3bec41438ac8ace88e4f591bd97ea69-1730302513"
  },
  {
    "email":"claudia.pesatori@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694526842/f1a7f89c3d16904ffe5436bf0a773180-1730302514"
  },
  {
    "email":"clinicagaiavet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694428538/61e8879d5bcd3679260f02ae598c1637-1730302514"
  },
  {
    "email":"msirabella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694494074/8780712178711cc3ca1500d09615fb87-1730302514"
  },
  {
    "email":"silvietta7@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694657914/6f4271e987fa6eaea9b01a6132314ce0-1730302514"
  },
  {
    "email":"paologiglio2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694592378/d6092850832277c044d5f440568876e5-1730302514"
  },
  {
    "email":"anna.mellozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694395770/7b727fe4d0ef3f54b5988d995e9ed167-1730302514"
  },
  {
    "email":"arontini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694723450/f6c54d8fc3c6f24c323100674c51543d-1730302514"
  },
  {
    "email":"lauracosta71@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694756218/d719534d1fbcfe02bae64e7d2b6d644c-1730302514"
  },
  {
    "email":"milena_m@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694788986/3cc5be453375ecb92645d2707eb843e5-1730302514"
  },
  {
    "email":"mauriceruti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694887290/e834c08e35683294268597dbef9f8ef9-1730302515"
  },
  {
    "email":"lauracakesiena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694690682/3187b8b8c58b8a6277b2a6638ecdbc8b-1730302515"
  },
  {
    "email":"milena.vetrano2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694854522/ed31af6c06ec8df063e595da4ecc67a6-1730302515"
  },
  {
    "email":"giuliani.alessandra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723694920058/a053811031e519fec2e018b00dbe02a2-1730302515"
  },
  {
    "email":"fra.giusti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694952826/0f367ce136f33033b241c75f6f227c06-1730302515"
  },
  {
    "email":"stefania.lombardo70@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695018362/5d22ec7d6826a99628b06d4994f3bded-1730302515"
  },
  {
    "email":"catia.cioncolini@gucci.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723694985594/5f96547e9d770b4c1cdaa22bd31993bd-1730302515"
  },
  {
    "email":"paolacalbi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723695051130/c3b674ae1dcfcb8a8668f440d83bbc71-1730302515"
  },
  {
    "email":"sestostormo74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695083898/68dab9f0fe61de10c9dce88944eb9225-1730302515"
  },
  {
    "email":"lcantaga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695182202/63f0e969b227d68053deed8fd99719cd-1730302515"
  },
  {
    "email":"paolo.dani.radin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695214970/b41971c1506a7ee1a7ae8c4c7d5b8a6b-1730302515"
  },
  {
    "email":"armatisilvia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695247738/8b8039cb34dfb6f7f955c48a0133c813-1730302515"
  },
  {
    "email":"ferrazzanifabio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695313274/354e5ebdd572797febddfc5db416b167-1730302516"
  },
  {
    "email":"sara.chiappe69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695280506/4b4b73a10bc37ad2626ba057bd821e76-1730302516"
  },
  {
    "email":"giulianasannino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695378810/1fb4251fecf1732be5f871ce8751bd9b-1730302516"
  },
  {
    "email":"ingrossopaola68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695509882/a8449e40d38f63efacf03cf3751dc35c-1730302516"
  },
  {
    "email":"marianaddeo69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695477114/ba65b3468bd1a403df5e4ae1721a8536-1730302516"
  },
  {
    "email":"annamaria.incolingo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695346042/ea6b7c27f51a40407128316db0d259a9-1730302516"
  },
  {
    "email":"crifreestyle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695542650/9149613f3199aaf7c8a0abd69c6524fe-1730302516"
  },
  {
    "email":"elisa.gambini80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695575418/5721526cea877a5e8663fd7fdfad5876-1730302516"
  },
  {
    "email":"laura.gaspari@studiocanovi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695608186/24da8983194f525986f1c3d67cc8d6b2-1730302516"
  },
  {
    "email":"noemiteodori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695673722/ca0edf815b655a7560e18630d54e74af-1730302516"
  },
  {
    "email":"giacalonecatia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695640954/59313eef3925d438508978814b362acb-1730302516"
  },
  {
    "email":"ribechiniserena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695772026/a5ab0117f13c76c2a03daa4c96ad56d3-1730302516"
  },
  {
    "email":"lucrezia.martinelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723695739258/a078c83a84fafdd619d8ba8bce11bbd0-1730302517"
  },
  {
    "email":"valentina.biagini@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723695837562/8a399b1fc024ae8c391d7fadadb350e1-1730302517"
  },
  {
    "email":"geron.marta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695870330/a1b983cca0062e3bd6916ba9a2a8bdce-1730302517"
  },
  {
    "email":"danila.papaleo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723695935866/46e73774b24912a33c3072ce18443ce5-1730302517"
  },
  {
    "email":"danielaguerisoli82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723695968634/f0f59ae159238276f9718b79ad0c7753-1730302517"
  },
  {
    "email":"fabianalaselva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696034170/c213425edd1a3d8ab0db37eb883c2201-1730302517"
  },
  {
    "email":"egis.zeneli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696001402/2292f77a2168937e6d236f6a1677ba99-1730302517"
  },
  {
    "email":"elvira.lazzeri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696066938/9c4fb7d04a817b77c9c34886dc9e36db-1730302517"
  },
  {
    "email":"luccetti@ftgm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696099706/b722bfa7f7f611f2dd3b135f07a4ffc7-1730302517"
  },
  {
    "email":"antonella.alesci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696230778/a8e239e8e6e784e81a335e24e9735cd7-1730302517"
  },
  {
    "email":"barilebianca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696263546/9fb2ba4191fae48f32091e35ae1a15ff-1730302518"
  },
  {
    "email":"gio_longo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696329082/f9191ed7191a9387792f830423dcceb3-1730302518"
  },
  {
    "email":"martina.casadei76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696198010/bd7a11c8fed489a65d0fbcf1984b68c9-1730302518"
  },
  {
    "email":"schifanorosalba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696361850/541493c3e715ef2b0ee5c92f644a6091-1730302518"
  },
  {
    "email":"sara.bertolucci73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696492922/a9d4cfdc4b795dec99972d62a7ab2a83-1730302518"
  },
  {
    "email":"celinou64@hotmail.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22723696525690/0668a420dd9d1e524785de634a476902-1730302518"
  },
  {
    "email":"daniela.schiaretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696558458/10836bdfe623fb138ac011b5b2f9828c-1730302518"
  },
  {
    "email":"marinacerruto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696394618/05d57ec65fcf5a84fbd4c6ae3b8e7869-1730302518"
  },
  {
    "email":"vallifuoco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696623994/268b87cc266295d2ecdf33bb0784792c-1730302518"
  },
  {
    "email":"scillabussotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696656762/d942b14e9c5f2e83df6c0bbab1775933-1730302518"
  },
  {
    "email":"mgermini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696689530/c09b823f998e0207a7904899d386e6ed-1730302518"
  },
  {
    "email":"sabrina.paliotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696591226/5da00b5618f93c04f71d275be0015438-1730302518"
  },
  {
    "email":"brunella.bellotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696722298/6c17d8ccaddc98d670cb34d0f647042e-1730302518"
  },
  {
    "email":"francesca72morra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696755066/fd631066412b2d96d6af0dc412bde9ca-1730302519"
  },
  {
    "email":"anna.romegialli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696886138/f44836256e7fcd8cc51415fca2454936-1730302519"
  },
  {
    "email":"argebar.pg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723696820602/9f60f4579382308f45d0090138642b00-1730302519"
  },
  {
    "email":"toniaderosa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696984442/b0b5371a1e3e457fea129141d0927339-1730302519"
  },
  {
    "email":"laura.arcenni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697017210/cfd133b1e61cfc8d6c383c5682524d57-1730302519"
  },
  {
    "email":"veronica.righi.si@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697049978/69942903e8ad5b50090c21f4ee7c59da-1730302519"
  },
  {
    "email":"miofantini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697082746/f10d3f7b2d4f2072431dc863aafc7569-1730302519"
  },
  {
    "email":"dani.rinaldini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697148282/bfe6040ca6aa2c046d3a61bbb4d02d80-1730302519"
  },
  {
    "email":"criszuin@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723696951674/4b0bd02991d4d0cd362c8c39690808c1-1730302519"
  },
  {
    "email":"scanduragraziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697115514/aecac15bb1e548e6e2f33514574f1271-1730302519"
  },
  {
    "email":"valerond@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697213818/3ea92415bbe201d05694ffab294d9a17-1730302519"
  },
  {
    "email":"antonelladeramo9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697246586/d3694e0ad1b6648b148c2d4290169354-1730302520"
  },
  {
    "email":"dianaksnk@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697279354/02764846bfa8be5ce715d9a539311786-1730302520"
  },
  {
    "email":"massimilianoginanneschi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723697312122/df0ee6d7f6a8f8088ad8ea7673ecaa8a-1730302520"
  },
  {
    "email":"daniela.pepa15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697344890/8472cf34c35bf3b61b8c32f29d7e3527-1730302520"
  },
  {
    "email":"gaia.morra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697377658/d91a2d613bb0b6409169da2adf29969e-1730302520"
  },
  {
    "email":"ester.monteleone783@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697443194/33a82013c57a6e5c98b43eabdb8afaf4-1730302520"
  },
  {
    "email":"mariarosari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697508730/d8b07cf3d8dc2088a5163239f03d134f-1730302520"
  },
  {
    "email":"casaalea@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723697607034/9fd9423f358b2f26e47e48e789151ac4-1730302520"
  },
  {
    "email":"patri.riva.3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697410426/99484037aef387479f9c80fe383d7f35-1730302520"
  },
  {
    "email":"boschi.elisa3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697639802/19f9caf92ffdb722d0f9d953bc0a9f71-1730302521"
  },
  {
    "email":"sterpeto8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697672570/07fce295050b2943095ffe2b99f2e701-1730302521"
  },
  {
    "email":"samantha.capitanio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697475962/c178406e6d00b54bb69ec1bc2a49b038-1730302521"
  },
  {
    "email":"alexandro3105@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697705338/6812ab9e638b27b10c327f4bc5857439-1730302521"
  },
  {
    "email":"sabrinanaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697738106/ee191e428c58d0759db6e574923441b6-1730302521"
  },
  {
    "email":"elisa@tsnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723697803642/d772914a23be09b4fe43b20881df4011-1730302521"
  },
  {
    "email":"fracvc1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697836410/deccb1a10b05dbdcb8fde113eb2e0914-1730302521"
  },
  {
    "email":"angyr83@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697770874/46e2bb9a12a9064710fd865dddcab779-1730302521"
  },
  {
    "email":"ag.annalisafanizzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723697869178/957440716b476901f375893a9ec87971-1730302521"
  },
  {
    "email":"raik.hauptmann@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697901946/708babad6797ab29b42ae8f698709e9e-1730302521"
  },
  {
    "email":"lauramawit@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698000250/e9fcc514c054f720b8e6b9b5545fecc2-1730302522"
  },
  {
    "email":"kettyalicetoppano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723697967482/1079facada11e8b34515217b370029ce-1730302522"
  },
  {
    "email":"angelamaria.bucci@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698033018/1913a02dd26ffe26161eaeef41ff632e-1730302522"
  },
  {
    "email":"misskey@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698098554/1d19df01bb82ed68499793fa967f0cb4-1730302522"
  },
  {
    "email":"nmanf74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698164090/0f170aa6ea995e2e68cc4b16d78ef2bc-1730302522"
  },
  {
    "email":"valyyn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698131322/8bd7e8a9305e43cf7386c6b4d8f598d9-1730302522"
  },
  {
    "email":"nicolettapaganelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698196858/004e394cd4f8bed99b169643b2dc2d2c-1730302522"
  },
  {
    "email":"monica.coggiola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698065786/5aa7116205d306d6053cac18cd35b04f-1730302522"
  },
  {
    "email":"ilifil@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698295162/19878680db3e034d7d9256e301709529-1730302523"
  },
  {
    "email":"avvprada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698262394/dbb49f4819bc237ad171c7a96947e9ab-1730302523"
  },
  {
    "email":"carmendiiuri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698393466/0d2d88853fa2a8c1dd57a0749e854cba-1730302524"
  },
  {
    "email":"maurobrizzi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698360698/6643295aa1675b31823d7e332b88f784-1730302525"
  },
  {
    "email":"sabrina@fabioperrone.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698327930/97c23efdc5633846409c44127883804e-1730302525"
  },
  {
    "email":"ele.palombi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698426234/3c658d21a94b516d64437c51bcf71caa-1730302525"
  },
  {
    "email":"diletta.baldassarri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698459002/ca3262bec99ecb3046d5cebe29fe10e0-1730302525"
  },
  {
    "email":"appleseventysix@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698491770/b3e1b28c803a9d6be9adce598ac31159-1730302525"
  },
  {
    "email":"bianchilaura770@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698557306/24c53950d2625c1bcc5aeea5e73c705a-1730302525"
  },
  {
    "email":"mariafoti66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698590074/cc24e9d9a901f5103df96024385dd9c1-1730302525"
  },
  {
    "email":"francescamangano58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698622842/cce87bdec6da2afbfa5566b7e2f2d74f-1730302525"
  },
  {
    "email":"michimorelli71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698688378/31792c5e4eaeaf9b751991f4615dd5d5-1730302525"
  },
  {
    "email":"misslaladg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698753914/c7117132f9f1671ae9ccb3a5002e0916-1730302525"
  },
  {
    "email":"annapaola.cevoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698852218/c865b10ec7d9036c3a224ff73ad1a646-1730302525"
  },
  {
    "email":"beatrice.orsini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698950522/72904f50e26a205b8a203aa5666ae076-1730302526"
  },
  {
    "email":"naneth@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698917754/1294bb286b551efe44e90a739fb1e2d6-1730302526"
  },
  {
    "email":"siriadascanio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723698983290/680f6b4d42e0c4a1e545bf45e709d71a-1730302526"
  },
  {
    "email":"stefi.lastoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699016058/e4cd3db4ebaef5c0e614de7aaa7e394b-1730302526"
  },
  {
    "email":"lo.polenta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723698819450/72f5c9723598d49838d41ad6e8478bdf-1730302526"
  },
  {
    "email":"maestri.tiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699212666/e3a2614fee37ce0fea3661b29827b220-1730302526"
  },
  {
    "email":"mezzadritiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699179898/e40d79576f320b1e6292077c24072642-1730302526"
  },
  {
    "email":"canonicosilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699343738/872baaf49e204f1a6a7f258590e77ea9-1730302526"
  },
  {
    "email":"teasilvia82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699245434/b9d682d731731fea9b35b9be6982e35e-1730302526"
  },
  {
    "email":"ann.leggieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699442042/a108c72a61220f181d02f410ab93a992-1730302527"
  },
  {
    "email":"pezzi@psychologischepraxis.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723699474810/ff0866425aa3e3644fc19ab77a874929-1730302527"
  },
  {
    "email":"topologa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699409274/8385efb3c6a867eaf3adc9cd2968e875-1730302527"
  },
  {
    "email":"cafiber62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699671418/1bdee17616472225f98ae7597c83393c-1730302527"
  },
  {
    "email":"giuliana-91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723699736954/eae5af0b7c92582523966533e10a9de1-1730302527"
  },
  {
    "email":"gilli.isabella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699638650/51610da75e203dd19f7dddc24965bb73-1730302527"
  },
  {
    "email":"manuela.sperati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723699769722/5faff32d80ac14f66cb1bf03bf8ee274-1730302527"
  },
  {
    "email":"manu.giacobbe83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699802490/5226113835b133010ac08e8cece0acbe-1730302527"
  },
  {
    "email":"info@forco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723699868026/32bb6f388beca5f3212487907073fb8e-1730302528"
  },
  {
    "email":"manu.compagnino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699835258/6e9836889bb6b2604bdf1e5a831b3af0-1730302528"
  },
  {
    "email":"giulia.levorato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723699966330/09d2076a7401da2ac213eaba8e5f83d6-1730302528"
  },
  {
    "email":"lauraferro83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723699704186/33df76cfe89b45e38fa0f2db95de1407-1730302528"
  },
  {
    "email":"enrico.martinello@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22723699900794/57ddd2582d54adb43a43049b43dcc628-1730302528"
  },
  {
    "email":"claritaspy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700031866/bf0a20c13ec2c2962d24989e6bca4c17-1730302528"
  },
  {
    "email":"jessica.sommariva@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700064634/3ee4b40bc1689f9496100d1a379819fb-1730302528"
  },
  {
    "email":"eleonora.salvati.es@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700162938/29e2e8cbd9054e4fc24879f7983f8dff-1730302528"
  },
  {
    "email":"edilpiovesan@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700097402/4b00cb4cf7f45ecd0f9eb9c6adc88ccb-1730302528"
  },
  {
    "email":"faccioraffaella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700130170/dfea658788c53512f655684f0f19c976-1730302529"
  },
  {
    "email":"tiziana_1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700195706/7ef6146ee3fcf3ae422d184b02367de7-1730302529"
  },
  {
    "email":"teresaromano93@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700261242/c86a38246da2ac50afcf53fc22d33094-1730302529"
  },
  {
    "email":"ilaria.pinzan@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700392314/2d25d1c971ba08251b5aa6a3d2d66fc1-1730302529"
  },
  {
    "email":"cocchina79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700326778/665dd4c575635b8fb51987ef460a6a61-1730302529"
  },
  {
    "email":"elena.perego@adnkronos.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700425082/ec18fc4fda4501a66aa72cbc528b169f-1730302529"
  },
  {
    "email":"andreafocarete@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700457850/1f06578a261a0e2b520666ad717d87c6-1730302529"
  },
  {
    "email":"laurosella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700294010/e5687c02ab8ff8e64852aa1270d67594-1730302529"
  },
  {
    "email":"venturinisilvia77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700523386/18ec622c32235f9a5df964b18b0acc50-1730302529"
  },
  {
    "email":"vittoriagallellivg73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700556154/045fa5529d7b9146e84dde32a67f2fa1-1730302530"
  },
  {
    "email":"simone.caggiula@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700490618/01158a27ad402969ea079a90c014e031-1730302530"
  },
  {
    "email":"chiarabaroni.balaw@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700687226/bd6b2fde147016ed0c847352132bcf5c-1730302530"
  },
  {
    "email":"giuliano.anna@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700719994/83df49d17412a9cc29964b330dc02df6-1730302530"
  },
  {
    "email":"cmusicco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700654458/b3b8ab77b73027e05bcbc1f823ad4546-1730302530"
  },
  {
    "email":"vagagginisofia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723700785530/ca192aa9ed9461d6a2fefdf8e3c7a3b6-1730302530"
  },
  {
    "email":"marcellapazzelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700851066/2705d517150d3e58bd5587b7c369e0ad-1730302530"
  },
  {
    "email":"chiara@c-labstudio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700883834/132aca2344711fdd8578f7b4183b2764-1730302530"
  },
  {
    "email":"maddalena.iaccarino08@gmail.comomcom",
    "url di attivazione":"https://verdissima.it/account/activate/22723700949370/2f42297d09392a259b8ce681f92e0797-1730302530"
  },
  {
    "email":"robby.toby83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701080442/615005264aeb9c54fc303990c2efafac-1730302531"
  },
  {
    "email":"francesca-papi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700818298/1b5e8c147f43d0d568b0842646babe2a-1730302531"
  },
  {
    "email":"m.saramin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723700982138/0ded938a557d2c710912cc0c680e9c05-1730302531"
  },
  {
    "email":"tizianabasile1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701113210/e0b71e4c33b93097fbc0a55d76c2f9fc-1730302531"
  },
  {
    "email":"robertaguglielmana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701047674/b3654ab429e4b3abeec2cc0733d0f121-1730302531"
  },
  {
    "email":"salagaiatto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701145978/7fed28815f58ea2c1411fe7e211c8e7b-1730302531"
  },
  {
    "email":"michelina.elia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701211514/8a0b385dc3abe523602a91f433000b2c-1730302531"
  },
  {
    "email":"bernardinialessia172@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701244282/7388beff26c300a53e1dcc740f7d6fde-1730302531"
  },
  {
    "email":"isabella.zamignan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701277050/7b3ed5349f0433a69d0bfcc014bccb08-1730302531"
  },
  {
    "email":"silvia.costanzo2012@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701342586/7632fe4d1500aaaa0f92aa150417855a-1730302532"
  },
  {
    "email":"simonarosetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701309818/789f1b2c34dc3fda011db2eacd426e86-1730302532"
  },
  {
    "email":"lauretbi1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701375354/0a0f5ee1d9de85e44b0756b52ddb326d-1730302532"
  },
  {
    "email":"stefibuffa1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701473658/1b8f7841de57bc9cbe307c81a9311321-1730302532"
  },
  {
    "email":"giuliana54@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701571962/08070e729bca4a596e0663a38f330fdd-1730302532"
  },
  {
    "email":"flavia@avvocatitorresanichini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701440890/4448c2f585a46a99df60ea0075493d6a-1730302532"
  },
  {
    "email":"bardellifrancescam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701408122/fd27db5c71e03a3f40173980de7014a8-1730302532"
  },
  {
    "email":"sagrumi@alteanet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701604730/b1f8fe5bcf97e971349179e9871d74ef-1730302532"
  },
  {
    "email":"rosella_dalterio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701703034/293244ca17dba3bf4835fe9644465b6e-1730302532"
  },
  {
    "email":"sonia.ambrosetti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701768570/84ed44c24b9d5e14948c1ac8c154f1fa-1730302532"
  },
  {
    "email":"borgnaf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701735802/83d5af90e1bc1b5d80009176024faff0-1730302533"
  },
  {
    "email":"azizromero88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701637498/e8eceef9c4ed673e20f59955d6e3ddf6-1730302533"
  },
  {
    "email":"luciapingelli3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701866874/6482f00fa59e3d2d96a42113eb8004f0-1730302533"
  },
  {
    "email":"m.grandelis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723701801338/27c477f423540d5edc0baa3cddf02179-1730302533"
  },
  {
    "email":"lucia.ciucciarelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701834106/8739f86bde76cea7779f6db3e26558da-1730302533"
  },
  {
    "email":"pdallolio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701899642/b0c72cfa2dd53c7ad4cf822406eaa69f-1730302533"
  },
  {
    "email":"emanuela.dellorto@magazzinidellorto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723701932410/1cfe5ac8609b548ff1f76cde98eb4178-1730302533"
  },
  {
    "email":"maby86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702129018/936a0e73ae646f60816b922a9a2cee7e-1730302533"
  },
  {
    "email":"ciolli71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702161786/39e90dbd754f1532ff91eda9d2a4cba5-1730302533"
  },
  {
    "email":"a.esposito@notaiocaccavale.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702260090/f6469530ae0714ed12fd1b2a1a1c2e4e-1730302533"
  },
  {
    "email":"ltrambaglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702227322/3b298dc58af759b3007efb82cf2780a1-1730302533"
  },
  {
    "email":"lauravrns@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702292858/d3b20ed280ac2340fede081a35d93b39-1730302534"
  },
  {
    "email":"pitstop10@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702325626/7a58e925bd5b9bac31e10d22200f7561-1730302534"
  },
  {
    "email":"scimenesr@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702358394/5e4fa25ee7da23ffaa38734e6f27ef75-1730302534"
  },
  {
    "email":"paola@zallocco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702194554/325b08ae3f488f7a948a1d6903203e8a-1730302534"
  },
  {
    "email":"enrica.giro65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702391162/1196f7c00ba7b09d1ea372143a83bc3b-1730302534"
  },
  {
    "email":"giorgia.casti@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702522234/df11a1ba28e750411077f2e548d510a3-1730302534"
  },
  {
    "email":"vaeberle@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702555002/faeceac3f3dfed4256b9687dc4cf595e-1730302534"
  },
  {
    "email":"jleniaseghezzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702587770/35aac5e1a3e7556ec63a1d07615cff03-1730302534"
  },
  {
    "email":"alexdesi81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702620538/ce1ea4c0c933a9cf4f98498837069c62-1730302534"
  },
  {
    "email":"sabri.mirmi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702456698/e4dfc98a374c10e42a6bf44683d921e3-1730302534"
  },
  {
    "email":"drperna.raffaella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702686074/05d78833df17f2940f4aca13ab04b9f3-1730302535"
  },
  {
    "email":"andreea1280@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702751610/68a79b47d28b9b28a5d4ca521e98c19a-1730302535"
  },
  {
    "email":"lidiamonegatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702718842/a9c8c7e2efcc07ccc933d6d1a1f9a91a-1730302535"
  },
  {
    "email":"bazzocchi.benedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702653306/d233f11e71ed335372ae3dd6fb57305e-1730302535"
  },
  {
    "email":"villa.i@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702882682/00d9397ef7c63c725d50c1325a63920a-1730302535"
  },
  {
    "email":"giolanco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723702817146/0ec16d37177e2cc769cf75a1c05b67c1-1730302535"
  },
  {
    "email":"francimuntoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702849914/6737f174d83142a5502cf3534912b97e-1730302535"
  },
  {
    "email":"baldisseraelisabeth@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702784378/c88f51f12d5165898d4e2c1d55ea4481-1730302535"
  },
  {
    "email":"elisatesta.avv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702948218/3b282646d8de116a7cdd05a0f3d09f60-1730302536"
  },
  {
    "email":"stefy001982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703046522/72f4b1c8e32f6cbd8d03684a92a537b4-1730302536"
  },
  {
    "email":"ersice47@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723702980986/219568331b0ca09d43b9616cc3ff747d-1730302536"
  },
  {
    "email":"flori25@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703177594/ea05d3c3949aa7ffe7abc6a075b5ea5e-1730302536"
  },
  {
    "email":"michelaluc@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703079290/d579eaa59e7313152e8439cbda8f2243-1730302536"
  },
  {
    "email":"aurora_91181@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703243130/f7a54232ddf3b81f6d489096f42d4895-1730302536"
  },
  {
    "email":"mdv.registrazioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703275898/5d036f9f4791e39c502c0a311c6d44a6-1730302536"
  },
  {
    "email":"realini.elisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703308666/c20d76f0efdc576b329bc36863a3a382-1730302536"
  },
  {
    "email":"mariagrazia.bellocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703374202/22a26d7474d7ed6f93af8300905a5216-1730302536"
  },
  {
    "email":"elisabettasittoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703341434/e6a9225df94d26af27e77a3771d9b4b5-1730302536"
  },
  {
    "email":"paolatalladira@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703505274/adde1f5f655689e02811bffe0297e718-1730302537"
  },
  {
    "email":"giorgiasgro@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703406970/f2b178149a26f78be404177eb2771a9d-1730302537"
  },
  {
    "email":"pogattino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703570810/5129c883baaef4fb8f569c1acc669799-1730302537"
  },
  {
    "email":"nikyso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703538042/172e17a17e417305606a656e317946f5-1730302537"
  },
  {
    "email":"meryvasciarelli83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703669114/3b5687605d81991b0d360f1076b2b474-1730302539"
  },
  {
    "email":"arrigo.bazzoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703701882/5e75bda2acb43264d588a07e3bdfa9a5-1730302539"
  },
  {
    "email":"patt.58.ps@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703603578/911d2eb45e03accb04915efa17c071c3-1730302539"
  },
  {
    "email":"as.ls@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703636346/832fbc8670f44a5ccf7ad72a75d89faa-1730302539"
  },
  {
    "email":"gavi.fadda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703734650/7444c567dc7a28d761f11bdf3f857f9d-1730302539"
  },
  {
    "email":"leonasia1957_mg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703832954/730ee36f81a47136d4311ceda6acc524-1730302539"
  },
  {
    "email":"lewisky14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703865722/ead9de2224052056a3326db21d2ff044-1730302539"
  },
  {
    "email":"bonellie@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703931258/0d07e151ab6755064ebc31a8cecbaaf6-1730302539"
  },
  {
    "email":"m.cossa@borghiniecossa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723703964026/97456bf47c13db5dd9111c11a576863b-1730302539"
  },
  {
    "email":"mariagloriatrabucco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703996794/7db051566a7e78feb17048df3abd562b-1730302540"
  },
  {
    "email":"impre76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704062330/3eb50e284d2c0ccb1c03b56af421e3bb-1730302540"
  },
  {
    "email":"messineo.dani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723703898490/e6bb43a00a4b6612223f45ac7db48b6e-1730302540"
  },
  {
    "email":"sabrina.contabilita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704095098/6b5454b251da03d6c3b4229e0cfbf5c6-1730302540"
  },
  {
    "email":"leonardog@omniway.sm",
    "url di attivazione":"https://verdissima.it/account/activate/22723704127866/81b33b1f94b3f1adfce49353d29cba51-1730302540"
  },
  {
    "email":"patrizia.ram@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704324474/581f3c527db30dfda20eb909e4fbcaf1-1730302540"
  },
  {
    "email":"elenacaputo80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704390010/7942cf42fa2b7b43efeb574ca4acccaf-1730302540"
  },
  {
    "email":"enzablancato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704029562/351bbd65123adffffe0fceb7accbc72b-1730302540"
  },
  {
    "email":"laura.ancellotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704422778/0f8a93e82c46d13eb2fa24209ffb0c69-1730302540"
  },
  {
    "email":"stefi.crispino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704488314/1e97e8c393839d1f208e978a491fdffa-1730302541"
  },
  {
    "email":"claraazzolini0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704521082/c45118062e16a92e9ab608ec1431d0a4-1730302541"
  },
  {
    "email":"antoguido1956@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704586618/4bc40435b9f911c4f9adb4b2b42067e5-1730302541"
  },
  {
    "email":"ing.buganza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704455546/5e8eeca67eac83cee285c66a5bc02684-1730302541"
  },
  {
    "email":"laura.marti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704619386/9019bcf85f16fb2acc0b0e1451cd9871-1730302541"
  },
  {
    "email":"simona137@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704553850/efb934f1987600ac52cec850f724dccc-1730302541"
  },
  {
    "email":"gentili.mony@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704684922/0006e71c5f81ce3b0451ae20d9930d03-1730302541"
  },
  {
    "email":"cristiana.casse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704717690/62ed682e690b7a7f7615a0fd307f278f-1730302541"
  },
  {
    "email":"nataliajesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704750458/8fac22297c3acef6b4c7fb6ebcbb4b65-1730302541"
  },
  {
    "email":"lorenzalonoce@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723704783226/6940d15581118be5dc6ce35819ee266a-1730302541"
  },
  {
    "email":"tiziana0888@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704881530/8567379eddfe180bb3231832edccd0cd-1730302542"
  },
  {
    "email":"michela.salvioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705012602/188794491b2e4495260514e23ae81d91-1730302542"
  },
  {
    "email":"s.guerra75@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705045370/8aaba8e47970b6143fc4248e00749f8b-1730302542"
  },
  {
    "email":"elena@garbinipetroli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705078138/1690452d2da41961a26b4c7cf8868c8c-1730302542"
  },
  {
    "email":"alessandrafaiella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704979834/c1a6543bbbcbb489ff5050742227144b-1730302542"
  },
  {
    "email":"federicabianchi441@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705110906/3e4127196d968398da2464796aed7f5b-1730302542"
  },
  {
    "email":"duo@cheso.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723704815994/223e89b2f6ef4d27d1bb045d6c67706a-1730302542"
  },
  {
    "email":"anelli.cristina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705143674/894d29d6b5807ef89cbaeb97e62c7bc2-1730302542"
  },
  {
    "email":"m.widmann11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705176442/0b6e5b7919a0d7c93a033db360ac2020-1730302543"
  },
  {
    "email":"sonjahofer71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705241978/e105950b7de49c9741c34eb41b74759a-1730302543"
  },
  {
    "email":"asiagrando2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705307514/5b39d9f60d49e362310612fdcd780899-1730302543"
  },
  {
    "email":"m.malfagia74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705340282/81486e48261a18ead131893f0d81dcb4-1730302543"
  },
  {
    "email":"mariaelisa.chifari@stormreply.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705373050/71fdf0e3f026e562ed9c1f27160f9279-1730302543"
  },
  {
    "email":"giulianavirgili73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705274746/b1490d50242d6aadab073c86fe485607-1730302543"
  },
  {
    "email":"pam.forastiere@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705471354/3ae2ccfec648f57c3cb629a451d5209b-1730302543"
  },
  {
    "email":"alessandranestibianchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705438586/f5d6ccffc5dc51e2160e40f9aa2df055-1730302544"
  },
  {
    "email":"messner.juliane@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705504122/756ec3b3fd2b43207af4123d6d50906d-1730302544"
  },
  {
    "email":"dentellapaola314@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705536890/54c96d5c5d54358b4fbb504f0d83a91f-1730302544"
  },
  {
    "email":"e.tommesani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705635194/f5f7808067e3d41acd68f154160825e5-1730302544"
  },
  {
    "email":"lalli80@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705569658/f91569bcc95bed4666cb69c5deb0981d-1730302544"
  },
  {
    "email":"natalitaisac1997@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705405818/d67a65cafe1bcb903ccb3addb1bc725e-1730302544"
  },
  {
    "email":"belardinelli.ele78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705766266/5b8961c5a6544413aea7afb8c6e36c3a-1730302544"
  },
  {
    "email":"serenabarbero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705733498/03e262594c7a47a54e6b3fd88f1d199d-1730302544"
  },
  {
    "email":"maraia.fonta84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723705700730/c846ebb35e1804d4c4d88c974f363704-1730302544"
  },
  {
    "email":"barozzielisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705831802/447144b857de98b083ebff01c7e6a7a8-1730302544"
  },
  {
    "email":"serenella.tiberi13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705864570/e11dc7868b0498e107b9b3cbaaa3da38-1730302544"
  },
  {
    "email":"veronica.colasanti81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705962874/a79eaaa588d1b853dd33eb86a453bd7e-1730302544"
  },
  {
    "email":"laura.camarri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723705995642/b2f526b9cf7a3cf0b32683552e105a73-1730302544"
  },
  {
    "email":"lbucci110@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706061178/6385ff645a603117320a5652fe0bfbb4-1730302545"
  },
  {
    "email":"studioargentisabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706093946/a3eb03af48c090fec9dc43f520cc7dd8-1730302545"
  },
  {
    "email":"c.boving@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706126714/6e95daace825a80ebb87b3e76eebdce0-1730302545"
  },
  {
    "email":"adelina.marra0503@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706192250/d3f63bf8d0ed153be2efe1a5cab58af6-1730302545"
  },
  {
    "email":"agatachiavetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706159482/02aa0df5740805b5f9e6c0e940c26947-1730302545"
  },
  {
    "email":"paciarottisrl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706225018/d77788bead64213bae28ce8ad6ac9642-1730302545"
  },
  {
    "email":"cristina.grosso09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706323322/ac6cf87b1420dd0097f0d644f227b74d-1730302545"
  },
  {
    "email":"chiara.felicetti@mediasteel.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706421626/e9910ace3231c5d543473474be4b2a44-1730302545"
  },
  {
    "email":"skykatia77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706388858/0ba5a975de82ea75c050bd37511492e5-1730302545"
  },
  {
    "email":"mastropasqua.lena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706356090/b68eb4bed79bc611b9d78b8a62fc1f16-1730302546"
  },
  {
    "email":"carla.garavello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706487162/8e83b28a3cd1557cd4ec695d2e743252-1730302546"
  },
  {
    "email":"eugeniapetescia1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706519930/f3c1e5a319db447eb51d048f8efeda59-1730302546"
  },
  {
    "email":"francesca.volpato86@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706552698/16ee08785cbe3e4e8ed077aa5041109a-1730302546"
  },
  {
    "email":"terri85@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706454394/553e76259787fc3dd6c6aad9fb54408f-1730302546"
  },
  {
    "email":"galassi.lrn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706618234/416b202c1bf466fc40a475b364023ac6-1730302546"
  },
  {
    "email":"codeluppiandrea@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706585466/c3211ec2fe6d766a06bc507feb28fcad-1730302546"
  },
  {
    "email":"chiara.bardelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706651002/00bd4248553e1dea12ed37000e2cc7f0-1730302546"
  },
  {
    "email":"bertoli.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706683770/b97412aec15f154a585592d43b3de134-1730302546"
  },
  {
    "email":"celestiniflavia19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706814842/26cdfe3c0b4c5447e404d5b6893e88c0-1730302546"
  },
  {
    "email":"camillacerutti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706716538/ee3d643fa6bd5786bccbed6997e163a1-1730302547"
  },
  {
    "email":"bccogliardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706847610/62837dc72d6d18fab92ee50b44bf295f-1730302547"
  },
  {
    "email":"sar.benato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706978682/c40a9852c70b619f6e7114cdc4023d9a-1730302547"
  },
  {
    "email":"mario_391@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723706782074/26040ac8eabe296d248777c1969ae1c9-1730302547"
  },
  {
    "email":"frency81@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723706880378/3b6774e98e76ed235c0007795c87620f-1730302547"
  },
  {
    "email":"sabrinalippini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707011450/cfe818bd00dd6e92d5b2cd8c1b6d349c-1730302547"
  },
  {
    "email":"monica_andreea2003@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707109754/7f791531b728bf62cf159ed935c55f43-1730302547"
  },
  {
    "email":"lucaschipani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707142522/f53b9488e72f33bfe909c780c89a03d0-1730302548"
  },
  {
    "email":"toria_dg@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707044218/ef9cd422abeb821a198468ebc50a5d99-1730302548"
  },
  {
    "email":"robertomigliavaz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707273594/182e8874dfb889ea591ce449e3b63e8c-1730302548"
  },
  {
    "email":"marcella.accolla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707306362/bc4b8d0ee6a031fb861195cd4e8e25bd-1730302548"
  },
  {
    "email":"avvantonellacosta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707208058/ce3530d60fee38ff73cacb6ad52021af-1730302548"
  },
  {
    "email":"barbara.corsi.po@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707240826/33bf164faf78f3354b1af1834362e45f-1730302548"
  },
  {
    "email":"veronica.paganin80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707339130/2fed162346c52e84986be5eb82f155ba-1730302548"
  },
  {
    "email":"robyan87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707371898/e3bbf3e08a43eab3d151d6a258d302a0-1730302548"
  },
  {
    "email":"pinalm1990@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707404666/2293340196c062b1aefec38bde909043-1730302548"
  },
  {
    "email":"alex.dbs@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707470202/f2994e467e932b3b5574ca533d1ba896-1730302548"
  },
  {
    "email":"p.bertotti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707535738/c65a8ee93258d56a784619ca53268041-1730302549"
  },
  {
    "email":"stella.marina35@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707601274/a9e30539cfd5aab62a1c8d6001d951c8-1730302549"
  },
  {
    "email":"gandini.marina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707568506/7b287416bd88b25c10fdb451f03fc5d3-1730302549"
  },
  {
    "email":"fiore.giovanninifg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707437434/729583f98c06f1ebc4ff796c8a37df55-1730302549"
  },
  {
    "email":"g.brusati@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707666810/6fc00220370c26a656f94f25e2a72a34-1730302549"
  },
  {
    "email":"ale.frau86@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707699578/8d328b4875cb1579ff6aa242015e9e8a-1730302549"
  },
  {
    "email":"federicamorelli5793@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707634042/816664c4054253c09a51ad5de56cabb6-1730302549"
  },
  {
    "email":"danielagermino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707732346/e1195a85c602dd09f5d849d60b84ebd8-1730302549"
  },
  {
    "email":"studiodottorcorti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707765114/7e9df32706aeeae736e9589332775754-1730302549"
  },
  {
    "email":"bisio.angela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707830650/dd0981b4d11a14059a95322f8c0ef2b9-1730302550"
  },
  {
    "email":"giulbia75@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707863418/6af70be8e6f325ca042f647c8ac97873-1730302550"
  },
  {
    "email":"raffachopper@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707896186/5e712e0c12159fd1076943c92d350303-1730302550"
  },
  {
    "email":"guido.luigino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723707797882/05407901c1c0f202eebd4f6d874fecb5-1730302550"
  },
  {
    "email":"michelarn@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707928954/4165df7104a993fc95a8e5f4d1aa6c7b-1730302550"
  },
  {
    "email":"cri.ale03@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707961722/1d51e28e6394b0577e8e9e8d2b1581ff-1730302550"
  },
  {
    "email":"carra24@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723707994490/57a0129d7966cfa2ba4197aa8249c0ce-1730302550"
  },
  {
    "email":"ale.bertoletti98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708060026/a54c3d658e785c6bd6f1b538f34ae8f3-1730302550"
  },
  {
    "email":"mery.ponti64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708092794/5db127461da4f7407bfae86872f4de03-1730302550"
  },
  {
    "email":"v.guidetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708125562/bc063da57a833075acefd94f40dd63e8-1730302550"
  },
  {
    "email":"kathja@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708158330/d04e2ca7a098b73cf4b3ee97130589df-1730302550"
  },
  {
    "email":"giuly.gatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708223866/ea79a2754b48fc1c8e83bb53b7ddd87e-1730302550"
  },
  {
    "email":"ordinebaubau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708289402/d9ed24b05d39362c6ec1ebb4a623a7ba-1730302551"
  },
  {
    "email":"studioveiceschie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708191098/40a36d88f38c166535e361b3f66c26fe-1730302551"
  },
  {
    "email":"info@francescamazzon.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708322170/9c96eb162c268d804c41230eff66b096-1730302551"
  },
  {
    "email":"stellaramon63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708453242/8473de592ea7f81edd43b4c9f2eaa252-1730302551"
  },
  {
    "email":"federicaborella@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708387706/8dc702918cecf91d0d15f02458d77cf1-1730302551"
  },
  {
    "email":"valepistolesi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708518778/f6e6871bc6e8efcceb21c7bcd86cc3da-1730302551"
  },
  {
    "email":"chiarabuss1948@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708420474/b4997ce5f284ebd3a20095ce3d11b4af-1730302551"
  },
  {
    "email":"dori01ottobre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708354938/e0c5a1f98e303796408d5c70d8bb6cb8-1730302552"
  },
  {
    "email":"leone.barison55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708551546/2ac9f248cd422b6ccd8014e977235bb8-1730302553"
  },
  {
    "email":"claudia190@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708584314/8d73e63cf7d356382613e1c6875f4fe4-1730302553"
  },
  {
    "email":"angelica_pi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708617082/7075ccb5cf4b244de38e27757bdb19f5-1730302553"
  },
  {
    "email":"vincenzina.veronesi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708649850/f1a34a5c1bb8bbe817e5fbd0509de3d1-1730302553"
  },
  {
    "email":"babicami71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708715386/b9f84a343d75b4c062d258dd68d3fdaf-1730302554"
  },
  {
    "email":"marrapodimichele@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708748154/99dba966f89b76f09e5d213c677bfaa3-1730302554"
  },
  {
    "email":"vittoriabru@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708813690/404596840b7be7ff584ef9dbe42271bc-1730302554"
  },
  {
    "email":"francescapezzoli6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708682618/67c8a7ae1d59a0a1aab37ed58309211a-1730302554"
  },
  {
    "email":"brunoenrico.41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708846458/0fec740399963b0597da9261cafb098a-1730302554"
  },
  {
    "email":"ale65.sberna@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708911994/3bafeca8fdcc6924bb1cd09714cdcff1-1730302554"
  },
  {
    "email":"elenaevito@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708879226/79f94342abd6045190d7d5bb01bf23c5-1730302554"
  },
  {
    "email":"conchelioni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723708944762/4a57ed0b2f64931f0536e3d15a3f0783-1730302554"
  },
  {
    "email":"dolcepegaso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709043066/b51f7253cb5b9d15ba33927fe28eeaef-1730302554"
  },
  {
    "email":"picciolo.anna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709010298/e7ae69c6cd0c788e126e45e44485f215-1730302554"
  },
  {
    "email":"avv.eziotursi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709075834/4253414bbd3bbd452fdf240e706cb35e-1730302554"
  },
  {
    "email":"ritabeccalli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723708977530/230a9705798343cb7142b738d9bc26ad-1730302555"
  },
  {
    "email":"martinademidio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709108602/bd50f7e710beb2b725feb0ec7d0767c6-1730302555"
  },
  {
    "email":"maia08@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709206906/7db8c2dd2d7e7dd5197a6cc2bc3fe763-1730302555"
  },
  {
    "email":"piva.bagnoli@gmail.vom",
    "url di attivazione":"https://verdissima.it/account/activate/22723709174138/fe8a57e5d0dccddccd7b5ac08b6568b3-1730302555"
  },
  {
    "email":"francescapolidoro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709239674/3bb0aa000d461e8365306653643e8814-1730302555"
  },
  {
    "email":"iride_13@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709272442/f4bcbdaa0b21f925f5c55d49c229af9b-1730302555"
  },
  {
    "email":"marimancini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709305210/f8836d0c7581a8979fca56c11a22525e-1730302555"
  },
  {
    "email":"ilariamiatello02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709370746/7c58f1c44417c4b60164c7247db17983-1730302555"
  },
  {
    "email":"atacontessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709403514/025c5ed7012aabbf711999af0df13fd3-1730302555"
  },
  {
    "email":"danielle90@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709501818/6eb864c2e5cdae1bacf716b86114144a-1730302555"
  },
  {
    "email":"gallo.paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709600122/8718dec7a92a20d3fcd1805207200f49-1730302555"
  },
  {
    "email":"cri.ri72.cr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709567354/9ea8729b5573ef2cb79dbb242a286ec5-1730302556"
  },
  {
    "email":"sara.crociani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709698426/028500a9d748e61cfe8f9dc105b43fc9-1730302555"
  },
  {
    "email":"alessandra.fornari71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709731194/9b23ddbffad46598fd26da39e9f53217-1730302556"
  },
  {
    "email":"elenamauro.ts@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709796730/804f499cb3875cc485c6982ddbc4faaa-1730302556"
  },
  {
    "email":"pezzimarg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709829498/20f1b11b5e5e374e7991f2b0cb27d426-1730302556"
  },
  {
    "email":"loredanapersano79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709862266/14d8ad2c7d5fe9bb077d1d8119536688-1730302556"
  },
  {
    "email":"stefania.denotariis@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709763962/ad2ae41e32912d560722f29bd1735d2d-1730302556"
  },
  {
    "email":"hirikatt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709960570/63d23f796b3c8bebefbb51d3562b6084-1730302556"
  },
  {
    "email":"maestrachilegge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709993338/614158edef39d038ca3c1a7766687f37-1730302556"
  },
  {
    "email":"desmolazze@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723709927802/64af4b6ad02c5de6c4434fcbbf146140-1730302556"
  },
  {
    "email":"manuelalapi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710058874/b84a61e6ac0894de29485150ce03b2d5-1730302557"
  },
  {
    "email":"amolarte49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723709895034/81f6c99759fa8861364c4c33e5302410-1730302557"
  },
  {
    "email":"cecilia.tedeschi@icaosta-re.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710157178/0a315f3cd6105ad420cc530b9143b290-1730302557"
  },
  {
    "email":"mara.chic67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710091642/fc9ec6e87dcecdc610b46f4d9590ef08-1730302557"
  },
  {
    "email":"b.cerroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710124410/59eb6fb80f783a79e7c85458f17e3195-1730302557"
  },
  {
    "email":"isabellas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710321018/e771eee0740139ed04cc0120eb0b4f22-1730302557"
  },
  {
    "email":"giulimoz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710288250/67f482a76fa60e0a9d928d742238eb53-1730302557"
  },
  {
    "email":"eli.pasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710222714/44d5bd6f7ed7d197510535b0ba7626b3-1730302557"
  },
  {
    "email":"rb17475@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710353786/f37c0e8007e0f32a47e7f42be2798c78-1730302557"
  },
  {
    "email":"tizianapica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710386554/4c17a9b6cdad8a69991c6f7d895a1351-1730302557"
  },
  {
    "email":"mpetix93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710452090/9090c7d6aad9840618c9675f952e811e-1730302558"
  },
  {
    "email":"benedetta.leonardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710419322/e887fdbe59aa2ba2a0b63fff2e3bd1a9-1730302558"
  },
  {
    "email":"lcnctl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710550394/32456f54735f55bf223b63212af64f97-1730302558"
  },
  {
    "email":"libreria.marescritto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710648698/1315b6386558b45a811606a266f1ee53-1730302558"
  },
  {
    "email":"violyg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710583162/fc6554ab9a0721337c8c5d5bc8c316f9-1730302558"
  },
  {
    "email":"federica.desiena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710779770/c5403e2f7d581b61ff140cd8edf9068c-1730302558"
  },
  {
    "email":"laurapastori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710681466/8799d4284d91b19fa0fc4c4eb2d6b2d6-1730302558"
  },
  {
    "email":"zavarellalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710747002/5b4d31c3bb74fd3a50884ffd94562f65-1730302558"
  },
  {
    "email":"carmenrea.cr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710812538/a39e6c358ba16640d543856309b480e4-1730302558"
  },
  {
    "email":"josephine.lero97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710878074/d8e3fa2346de4879abafb8e8a7146f17-1730302559"
  },
  {
    "email":"rosypellegrino556@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723710943610/d428695c68c2bf7877465b04453461df-1730302559"
  },
  {
    "email":"tiziana.guadagno@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710845306/71c430533cf26b08be3b19c8ba4ac8aa-1730302559"
  },
  {
    "email":"n.stroncea@logolsolutions.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711009146/ac83d4fe86683c838dfb2d2b735fe869-1730302559"
  },
  {
    "email":"patti_tom25@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711041914/40dcab2fc064481ca558b2fcee3ae9db-1730302559"
  },
  {
    "email":"vanhong.doan@frescobaldi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723710976378/67c3d8d0fd25d956b785a838d6242989-1730302559"
  },
  {
    "email":"facontie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711074682/0936202b7d3b1740d5feb2496602b849-1730302559"
  },
  {
    "email":"referenti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711140218/cd33075a04e9c761761fff979980868e-1730302559"
  },
  {
    "email":"stellamarina53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711107450/684cc93a67706280e26725e1de544dea-1730302559"
  },
  {
    "email":"manaresi.arianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711205754/c3ec9801ef5ca3264c90ea664bead6a3-1730302559"
  },
  {
    "email":"butifrancesca77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711238522/376585af0f548b3d3bf06246143cb49d-1730302560"
  },
  {
    "email":"franco@failli.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723711304058/dd0f99cf51de04a150dd915e03ffb55a-1730302560"
  },
  {
    "email":"laura.carniel24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711336826/89d01eebe941512c1d5219b7417d3156-1730302560"
  },
  {
    "email":"racheleronzoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711369594/fbc3c2800cf74fc19bc70941a1160830-1730302560"
  },
  {
    "email":"la.ferretti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711533434/5e63b74dc5f9aa39f58c088126edadaf-1730302560"
  },
  {
    "email":"silvi.serio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711500666/62545b8ab91db8635cf25aef7edf38b1-1730302560"
  },
  {
    "email":"vero.delconte@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711435130/bced903f86f8fbec6a14a2ecd338aaab-1730302560"
  },
  {
    "email":"beatrice.mambrin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711566202/91ce3f0ecdf54461ea294c98851e5a34-1730302560"
  },
  {
    "email":"eva.zanardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711697274/ef62f3821dfae91a04af926c739624a2-1730302560"
  },
  {
    "email":"m.vg@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711762810/1a3977ae1e1a51cdf640c00459bcc499-1730302560"
  },
  {
    "email":"mariaambrosio66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711730042/eb2f18a93d6a9733c043bd86e453738d-1730302560"
  },
  {
    "email":"cinziacappella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711795578/5309ea86367831f5c1c06ff96951a77a-1730302561"
  },
  {
    "email":"tiziana.gioioso@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711893882/e6c1a3c2fde213f0e5abd86899605791-1730302561"
  },
  {
    "email":"sere.sant@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711631738/d4b4b07959543c2d03dd0727c513fecc-1730302561"
  },
  {
    "email":"raffaele.dellecave@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723711926650/7c25b23a1c14b085243430ca75395182-1730302561"
  },
  {
    "email":"chiarascuola188@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723711959418/f8b5e6a8367411dcc7b9ee382bc7d294-1730302561"
  },
  {
    "email":"lostinspeck@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712024954/535164ec152855edb871d7554503d87a-1730302561"
  },
  {
    "email":"danielapriori@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712090490/2d8be32829c6c51416bace4219ea5431-1730302561"
  },
  {
    "email":"17medena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712123258/9503f0b630674a83bf6b08ede063f9e6-1730302561"
  },
  {
    "email":"mashamaria228@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712287098/5a0b87d70f80fb1f50969fb3f24f594d-1730302561"
  },
  {
    "email":"deborachini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712221562/c10a33229bb9573fcac186cd390dce8d-1730302561"
  },
  {
    "email":"mariaantoniettadimars@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712319866/4ed58fe088e33a0db21536448b8dfcaa-1730302562"
  },
  {
    "email":"ilaria.oprandi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712352634/bb126403d1d9dcd3e57aab5016787bac-1730302562"
  },
  {
    "email":"antomargotti65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712156026/e14e842677e4db3cab805479c6f5bc1e-1730302562"
  },
  {
    "email":"gessicabidini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712385402/59b90f32514b52d9568d5cea316c6991-1730302562"
  },
  {
    "email":"paolo.bonfanti76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712516474/6d4eda5bd700fef35725e58eaf68379b-1730302562"
  },
  {
    "email":"roxcarla@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712483706/5afbe7a609e8fbfebcc5749cdfe8e6ec-1730302562"
  },
  {
    "email":"silviatucci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712418170/da97a5baed7507d83d15805b16d01507-1730302562"
  },
  {
    "email":"rosellina.giaimo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712549242/bfc07cd1642a942e68b78c800cda851d-1730302562"
  },
  {
    "email":"testonelibero222@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712647546/1af66e3869aaf6e55c7f27aa38c22dc6-1730302562"
  },
  {
    "email":"sabina.piccolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712680314/0ec149ece03ec86084d58f0e02a4562a-1730302563"
  },
  {
    "email":"racca.francesca@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712713082/b63535fec61503975d057abc2c6b0b10-1730302563"
  },
  {
    "email":"francesca.zanovello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712745850/93e489055c8467ed82fd51dfc81977bf-1730302563"
  },
  {
    "email":"palermo.loredana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712778618/db1d565bb362065a7a284f53f4225c79-1730302563"
  },
  {
    "email":"francesca.brivio1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712811386/903bb0db53f9cfc4cf23468b116d15d9-1730302563"
  },
  {
    "email":"anna.giorgio80@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723712844154/d4dbb8e4667849d762b75a87a0b83b9e-1730302563"
  },
  {
    "email":"paolucci.francesca1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712876922/95cd994b3c0f912fbda3f7e6ad9f9cbb-1730302563"
  },
  {
    "email":"avv.beatricediana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712450938/d732a9a3b135aa04a8809be39d0542b5-1730302563"
  },
  {
    "email":"alexrossett72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712909690/54d20b61ed3b592592eb7e4566553373-1730302563"
  },
  {
    "email":"dinucci.roberta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713007994/80869b7ede8d42d760063e5028492924-1730302563"
  },
  {
    "email":"donatella.tomassetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712942458/dd23e1789813e3f032553cd773d4eacb-1730302564"
  },
  {
    "email":"a.brocanelli@elica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713106298/91dbf54157be7a4b49e90c033713fa80-1730302564"
  },
  {
    "email":"giusy.scilipoti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713040762/1c8c34e70e6ef993bf66d8482855880f-1730302564"
  },
  {
    "email":"avv.picece@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713171834/f78c3719bf49d69552956fa6fd7bd2a0-1730302564"
  },
  {
    "email":"mariagiovanna.bertini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713139066/34d83d234eef8e30e7e794a790fb7828-1730302564"
  },
  {
    "email":"enza.bianco71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723712975226/deb440e6aca8e81c50f499cfa1c9459b-1730302564"
  },
  {
    "email":"locatelli.lg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713302906/40963be571352034f2980b00826799ed-1730302564"
  },
  {
    "email":"cosimamarisa01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713237370/aa286fe99a111f4a2d66f255e536714d-1730302564"
  },
  {
    "email":"seregala@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713368442/4fc44baf171a2c45baebfb88a840cb25-1730302565"
  },
  {
    "email":"cris.bata1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713204602/26ea7d3989c635419b219d122873ca43-1730302565"
  },
  {
    "email":"lindajliv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713466746/eeb2f67074d68909d198ab6a14add3d9-1730302565"
  },
  {
    "email":"exalibur_75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713401210/f6013fb1ab426f5ea9a5f4b894aacf6e-1730302565"
  },
  {
    "email":"martynator14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713433978/1e4ab236c5ae2b805c4893286b3aef73-1730302565"
  },
  {
    "email":"danielaflecchia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713532282/7d48283bb543c073fdd0eade9ff8e62f-1730302565"
  },
  {
    "email":"massera.gloria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713565050/49e80e38daff281a1c4f1c0c3eb41f4d-1730302565"
  },
  {
    "email":"michiandreani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713597818/c73e07b52e7abba2f651ea0ddcd35b2b-1730302565"
  },
  {
    "email":"tania.menabue@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713630586/db00fdcdcd27c82077fea81d294b7674-1730302565"
  },
  {
    "email":"paolaocchipinti192@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713696122/21085f17fb8f67f65d3013aa6823236a-1730302567"
  },
  {
    "email":"adabbo6@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713794426/a05f4575529bf1ff2ec38c5dfa8a0608-1730302567"
  },
  {
    "email":"giulycam57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713728890/48120fa78393b81cccfffdecf07f18b0-1730302567"
  },
  {
    "email":"robertabernardini16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713761658/38aa5a3165828266f713f19714ad3875-1730302567"
  },
  {
    "email":"munaro.antonella1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713925498/1527034ce1d536782491d98fe7dda4de-1730302567"
  },
  {
    "email":"a-giulia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723713859962/175e94822d85d29e567c38076c60e132-1730302567"
  },
  {
    "email":"jaquelinefiaccabrino28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713958266/2450becb2682d214b031980c6d166674-1730302568"
  },
  {
    "email":"raffaella.dangeo1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723713892730/89e6ec33430247d363b3dec513803a4e-1730302568"
  },
  {
    "email":"ceciliacadioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714122106/d22c17919656bc5b30c503a986686b38-1730302568"
  },
  {
    "email":"cri69.masini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714056570/32e0da68c0c6079b95731efbca208f7f-1730302568"
  },
  {
    "email":"federica.giovannini84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714220410/5a6727de476f3588284b6c85463797c0-1730302568"
  },
  {
    "email":"aliac@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714253178/9f53d7531c952590ffc54c2b3b278682-1730302568"
  },
  {
    "email":"marceladodoc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714285946/a9ea82d53eef68f74ef593682c8f038b-1730302568"
  },
  {
    "email":"roberta.acciari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714089338/1beb5cfb03edeb7127e936fa732350d3-1730302569"
  },
  {
    "email":"l.ambrosi68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714154874/b264bbea3b1dbee62688e8af09783221-1730302569"
  },
  {
    "email":"dania3.p@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714384250/adbe63dd46559f671db1e7f26b5505d3-1730302569"
  },
  {
    "email":"silviabrighenti76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714417018/cd32e17243bb5b9b6d7f740bacb0e6a3-1730302569"
  },
  {
    "email":"ilenia.sandi30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714449786/4a3481dc37843b3a27beee62e147b505-1730302569"
  },
  {
    "email":"sarkakrb14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714318714/725215ddf993f79c19c785642b4482a8-1730302569"
  },
  {
    "email":"mariumaietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714482554/d855e86b29965f7f3506b6d207ea7426-1730302569"
  },
  {
    "email":"flavia.ricotta.didone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714548090/c4eeb492481f7c1c83e86848b0301cf5-1730302569"
  },
  {
    "email":"dany@danielabaravelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714613626/3282b1d3b6ddaca4a2fea7b3fa5eeba8-1730302569"
  },
  {
    "email":"nata71@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714646394/b03ae1ab88c70559945e4dcb84e75117-1730302569"
  },
  {
    "email":"mcpazzaglini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714777466/a12cee0f7212a38a59c8001e211936ac-1730302570"
  },
  {
    "email":"val.brio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714580858/dda97ad0beb503a05720e889fb5b3e43-1730302570"
  },
  {
    "email":"michelle2308@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714744698/6d5716dc92f0734990ba608324e1b8ee-1730302570"
  },
  {
    "email":"lucabruscolini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723714875770/6e09e649e8a6e57ef73030a65e9ca6a0-1730302570"
  },
  {
    "email":"luigiademarco79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714810234/d896c96ae3d837a02505acf3117b4e32-1730302570"
  },
  {
    "email":"aurelia.schincaglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715006842/a01def9ca0016de4a037f524361734e3-1730302570"
  },
  {
    "email":"stefania.sinigaglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715072378/7179840e2e31a18abc0626089df0e943-1730302570"
  },
  {
    "email":"carmenarzuffi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715039610/6b5f9db434baf53b790fb227819c4d96-1730302570"
  },
  {
    "email":"amici.serifot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723714941306/df9953871dbd2d64f559f1eda6c6f65e-1730302570"
  },
  {
    "email":"silviamaina@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715137914/18001e476359241ae39dff69c207c514-1730302571"
  },
  {
    "email":"fiorenzacolombo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715203450/7501782381c8f57f3a53fe8cedf638ce-1730302571"
  },
  {
    "email":"francesfc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715301754/6b9964953abbc25969104ec2c4a3d03c-1730302571"
  },
  {
    "email":"simona.carbonari@rai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715170682/4db0b52a1190ef483e736b4c7dc95784-1730302571"
  },
  {
    "email":"orlandifranca60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715465594/a592da7d1b65926383dfdfa0a4a75f88-1730302571"
  },
  {
    "email":"maiello.tiziana74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715400058/4af5683aaed4e05ee00dfef4db843aa6-1730302571"
  },
  {
    "email":"rodalmaschio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715334522/ecdfb27dede8bd9e40612b275a237def-1730302571"
  },
  {
    "email":"laurafiorenza69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715498362/91f2c880d9a474544a20f38674c3b4dd-1730302571"
  },
  {
    "email":"francesca.magnifico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715563898/8ce2e78dc39a199b55cc8dfb76941668-1730302571"
  },
  {
    "email":"lacontea01@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715531130/2abc58f82ef23f7b52a216be19ecef2d-1730302571"
  },
  {
    "email":"santa.ercoles@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715596666/7aa4e1a2e977cc6fcd5f4416c15e13a0-1730302571"
  },
  {
    "email":"chetiballi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715629434/97103400ecbfffc1c572d00f101a646b-1730302571"
  },
  {
    "email":"mariaindolfi03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715694970/b520769bbba502ebeca57a8a644d9202-1730302571"
  },
  {
    "email":"fra.tibaldi1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715727738/33d30845e34bb20cb26a91f8c140041a-1730302572"
  },
  {
    "email":"sandracaroselli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715826042/042282776644f1c3f1951d8a9ce8297d-1730302572"
  },
  {
    "email":"sonybazzy@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715760506/f005ee43212e3699e713af7de372d5ef-1730302572"
  },
  {
    "email":"mariateresa.baffoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715858810/cf378dd42603512e1a9743b17256ddef-1730302572"
  },
  {
    "email":"defalcogiovanna87@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723715989882/cf8a690df0e8f5a626bebb8f83709103-1730302572"
  },
  {
    "email":"cinzia.s.cirillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715891578/320dcec37783ce7a75d7d58379d9b52d-1730302572"
  },
  {
    "email":"dott.ssa.alessia.rizzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723715662202/ea643d01a459fe7faa8b0bc9b888bf16-1730302572"
  },
  {
    "email":"camilla.rigamonti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716055418/e88611269179876da744db372f087d21-1730302572"
  },
  {
    "email":"isterix86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716022650/5ad1eec6f63753edbfdd322e7d26f7fb-1730302573"
  },
  {
    "email":"patrizia.ferraro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716088186/99d472746e91f95945340f549e79547d-1730302573"
  },
  {
    "email":"rosariagramaccioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716219258/e6f7abc788bd4b2f9b0abc2247339886-1730302573"
  },
  {
    "email":"pingitorefilomena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716186490/51c49896ca97d43753f6aef2e5912c5b-1730302573"
  },
  {
    "email":"paoambr75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716153722/a6088dbae71a65a0eb02ec1576a365cb-1730302573"
  },
  {
    "email":"inna.rozhdestvenska@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716120954/24542f67fab71de0f0d5bd1f8f17b47d-1730302573"
  },
  {
    "email":"zanettisilvia1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716252026/fe9e75729c7c9b6e0c59ec0a7e723a65-1730302573"
  },
  {
    "email":"crivellinis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716317562/2d1a96a45a7d9f8ae00c2a812529b6ae-1730302573"
  },
  {
    "email":"pennapaola1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716284794/6d51cd50a9476a212250996a66dfd052-1730302573"
  },
  {
    "email":"rantonini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716350330/12df58a19570edad4b703fdb4bdba931-1730302573"
  },
  {
    "email":"danirubbiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716481402/34dff7ee6a2c00de91acca5238af310e-1730302573"
  },
  {
    "email":"cinziagibertini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716514170/9d3fdab4e36f535f64075cfd268d6013-1730302573"
  },
  {
    "email":"pinucciacalabro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716383098/1c479e905ff579e0f5ea53758b8785d8-1730302574"
  },
  {
    "email":"bergonzonimarilu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716579706/99f261f593d0f5655c189c515c221833-1730302574"
  },
  {
    "email":"pellonara.simona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716546938/eba2a049b35841f03b0596cb1bd505ab-1730302574"
  },
  {
    "email":"mellanosabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716645242/99a2af30802bc8aed32c5a3d35010b3f-1730302574"
  },
  {
    "email":"favarotatiana@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716710778/f3572f9c8230fe9e75214ae772fe071f-1730302574"
  },
  {
    "email":"sabmorciano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716678010/87e41e5733ba11eae5f1219f857e408f-1730302574"
  },
  {
    "email":"blsckmamba06@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716809082/f2d4b310c6d24c7a80e65c32399a9299-1730302574"
  },
  {
    "email":"nenery@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716743546/b8400a484c9f2997c6ced39b3c9ecbe4-1730302574"
  },
  {
    "email":"paola.brusini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716874618/778a437a3a0f2dba471ed9ea7783869f-1730302574"
  },
  {
    "email":"antonia.cuomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716841850/e59153a3da7c870de2781553a7a24867-1730302574"
  },
  {
    "email":"astrel1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723716907386/06d11671d0c021a194572c2c72079aa3-1730302574"
  },
  {
    "email":"gabriella.perin@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716972922/976652cfbbd46662492595c2454fff65-1730302575"
  },
  {
    "email":"balzan_francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717005690/786cd248c0a5adda947469eca8a9b82e-1730302575"
  },
  {
    "email":"vitiello.rosa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723716940154/0ed549cf4abf4413f6821e314a7c7025-1730302575"
  },
  {
    "email":"ariannatommasin0966@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717038458/177a1f4adcbaef84a7ccec39b6ec16e9-1730302575"
  },
  {
    "email":"chiaramaianti1997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717103994/bc8c5e55ede13ff848cc561c46fd6d4a-1730302575"
  },
  {
    "email":"adeesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717169530/126db92cf6773ef0024ce9577d00549a-1730302575"
  },
  {
    "email":"lorenzapacetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717202298/8c99d78a0b9fd853cc281d5fab9ece5c-1730302575"
  },
  {
    "email":"milule66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717235066/33a3275730b271bda831b6232819d001-1730302575"
  },
  {
    "email":"eva_terren@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717267834/5ff4624c265318116149116546faaac3-1730302575"
  },
  {
    "email":"francescabonacchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717366138/f07349b2c6f7956a386099c786cc683e-1730302575"
  },
  {
    "email":"tata_cla76@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717398906/110f7e44ea9838e10edcf9a7bf72065b-1730302576"
  },
  {
    "email":"raffaella_rizzo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717464442/6b518e8f4b32f7f5bca3b607f1ce0c3b-1730302576"
  },
  {
    "email":"elisapallini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717431674/dd38b794687d01af32e3418de157a632-1730302576"
  },
  {
    "email":"elisacorbetta60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717300602/b4b338ae71a01142ef779f6e6705956e-1730302576"
  },
  {
    "email":"annalaura.patera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717529978/c2c203a3150b4092d71bb4ccc0b41841-1730302576"
  },
  {
    "email":"beatricemontesi88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717759354/5d1b56059459253a42d84b0a80a93539-1730302576"
  },
  {
    "email":"rossivalentina_v@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717661050/86a6c886bc12c410b696249eb768c082-1730302576"
  },
  {
    "email":"francesca.danzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717792122/5643a3b2071ceb095506b55bcf0bb80b-1730302577"
  },
  {
    "email":"v.cirioni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723717857658/487f5294944a9f7294d18cd750f17824-1730302577"
  },
  {
    "email":"emanuel.alegabri@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723717562746/29f73b93e1bfde3a147288ffbfbdaea0-1730302577"
  },
  {
    "email":"paolasollini57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717890426/9c5ed3c87bb6aa05bb0851b5857657ab-1730302577"
  },
  {
    "email":"domyfiore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723717923194/ffb10d2f037ab417838c0b3eb843421e-1730302577"
  },
  {
    "email":"fioretti.fiorella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718087034/db1c4191e3eab34ee993a0cbd0f1239a-1730302577"
  },
  {
    "email":"studio@torrisi-procopio.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718054266/bac498633386c0293a5afa5ade6ea89b-1730302577"
  },
  {
    "email":"graziellacotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718021498/0019f2ad3b05bfa9d2b1893e6dff5c57-1730302577"
  },
  {
    "email":"spinelli.pdv@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718185338/318d71642a2770ee3e6ce32c922d73fb-1730302577"
  },
  {
    "email":"alemasciu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718218106/e89907f53ba3ecbb385b6908c74fd85c-1730302577"
  },
  {
    "email":"salvilaura11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718152570/fee0c8c790cc4e2e458170cd65fbae1d-1730302578"
  },
  {
    "email":"vale.delonghi84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718283642/f1d84473fb9f1656b470fe0e72bb2a85-1730302578"
  },
  {
    "email":"sveva.calabro97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718381946/75391ce17b306864a82830339990ce33-1730302578"
  },
  {
    "email":"angelica.gasperini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718349178/b473ac9f223d661d736ae4e6735baccf-1730302578"
  },
  {
    "email":"giovannacanfora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718250874/904838b1a135e4ec9f029ba46b1ec9c6-1730302578"
  },
  {
    "email":"lallix.18@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718414714/8938fdbbac66d645716a98b7e91747b3-1730302578"
  },
  {
    "email":"samanthapedini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718447482/9cdb302bec5f37a2755304e93fd387ce-1730302578"
  },
  {
    "email":"michela.salvucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718480250/d1abb7949e9212a25533c7712f8da87f-1730302578"
  },
  {
    "email":"fr.roma@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718513018/15b8d0d39d41ea980fdbf9956e563651-1730302578"
  },
  {
    "email":"vale.cognetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718545786/c9e5e0cf52a6134d97e3365042eb35e1-1730302578"
  },
  {
    "email":"zenti.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718578554/04f2e7450ca427f4874a766c555ce228-1730302578"
  },
  {
    "email":"martamascilongo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718611322/e62a558d5b559b72a9255217c3557914-1730302579"
  },
  {
    "email":"girellidaniela1975@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718709626/f858c5029da85c051ab42622c0e4abf8-1730302579"
  },
  {
    "email":"assuntadestefano21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718676858/13f63ca1901a2fa2e21cbfd25e8a6f35-1730302579"
  },
  {
    "email":"info@pogopop.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718775162/79826ff99e29bbd8dc00f78b0e49aa6d-1730302579"
  },
  {
    "email":"alessio.baldi@grupporosati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718840698/b1b651ac7553b52f19bf79f1d8135e31-1730302579"
  },
  {
    "email":"irene.q@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718807930/bcfbecefa1833bbd83d773798f489cb9-1730302579"
  },
  {
    "email":"bettaturchi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718644090/9647cbd67de8b638cadb8932b21ea892-1730302579"
  },
  {
    "email":"e.delfi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718939002/8e03debb2cf007e4d0f68e18167223b7-1730302581"
  },
  {
    "email":"spipol@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723718971770/7b3229a3e08492a260acdbe454f35e51-1730302581"
  },
  {
    "email":"lorussoanna66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718873466/d9f8adf6120c05816fe224a6b371d67c-1730302581"
  },
  {
    "email":"bobisan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719004538/891070625276cbdffd97d61336bbd3a9-1730302581"
  },
  {
    "email":"sicilianomiriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719037306/23583c43a3b8c531a68b0abfad5ada08-1730302581"
  },
  {
    "email":"monicamarcolin@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723718906234/b77793907bbe306a5ffbe5271ebf1817-1730302581"
  },
  {
    "email":"fullin.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719102842/ad3827867e03370676a609d4ccfc337f-1730302581"
  },
  {
    "email":"elboc@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719168378/196d3e331232543d0b4a88f6186c0512-1730302581"
  },
  {
    "email":"info@lgsystem.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719266682/717457c5247754b26ca2ff7d951eb115-1730302581"
  },
  {
    "email":"pucci.elisabetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719299450/f96e6443bce4231f944c51033d00b551-1730302581"
  },
  {
    "email":"valentina.armetta@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719364986/60f8f423aafeb6f928cb3fc04fa3ab10-1730302582"
  },
  {
    "email":"valentinacartaig@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719233914/2c209f2f1fbf20394727c73d3f818444-1730302582"
  },
  {
    "email":"tiziana0ferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719528826/8e97e5c602401c2e4a658a9653b9e33e-1730302582"
  },
  {
    "email":"deborapiccirillo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723719561594/8ae1ba68e2ab9d239535d311104487d6-1730302582"
  },
  {
    "email":"sonialudovici7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719594362/a6b27cdd574b0dfdd18ffb075d2397dc-1730302582"
  },
  {
    "email":"marzia.biziak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719463290/399bc75cd8a4ae1d72a79532ea215bc4-1730302582"
  },
  {
    "email":"lbaietta1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719823738/76c1e49013af86302c8883a7d4252c5f-1730302582"
  },
  {
    "email":"slobodyaniryna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719889274/8bbb4a58946610c8310adccd88164218-1730302582"
  },
  {
    "email":"violalonghi5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719922042/a5a6418e9ab200458469cb99ae0c06b7-1730302582"
  },
  {
    "email":"rossella.bertini24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720053114/adcfe6749262751e04682d570a28633e-1730302582"
  },
  {
    "email":"socchigrossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723719954810/f6373ecc10d1801dba24b33d3163204b-1730302582"
  },
  {
    "email":"emmebi12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720118650/86447b9fbb7012414b8bc19dbbc88bfc-1730302582"
  },
  {
    "email":"nunziatagiulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720282490/099678a904075cb77c61bdd9fbc06dbd-1730302583"
  },
  {
    "email":"fabiolagarrone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723720315258/96f508a7c870037d82df75f734b80402-1730302583"
  },
  {
    "email":"anna.maola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720151418/bc53b95176076df89de55c338a6ce557-1730302583"
  },
  {
    "email":"jade.removille@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720184186/64aac6acf513426afb03c8722e8f5859-1730302583"
  },
  {
    "email":"griffafabiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720479098/60774571087d9c5554293b4d79e1b76d-1730302583"
  },
  {
    "email":"bnigra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720446330/6b72fef25d9299cad253664726a34876-1730302583"
  },
  {
    "email":"r.mattana73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720348026/603c0c17ae0222aeb879258a75f0cfc8-1730302583"
  },
  {
    "email":"marta@pasquotti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723720511866/e908a18e54ca7ef03fcfc10d1e1427ee-1730302583"
  },
  {
    "email":"isabellachiarucci@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720610170/70b4c1ad9c87c51a0e00db95723a433e-1730302583"
  },
  {
    "email":"cathie.favre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720675706/72443178948355e873395bccf9d99baa-1730302584"
  },
  {
    "email":"lcasolino.94@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723720642938/df8ebc6b46af310445b90511149a02df-1730302584"
  },
  {
    "email":"izzyblack78@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720380794/7ed37094a864b918d79daa940cc48f51-1730302584"
  },
  {
    "email":"alice_generali@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720577402/8295f272bd1441895bffabf2a3574602-1730302584"
  },
  {
    "email":"dany240967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720774010/1a6620d6569d0b064c0327df6fde548c-1730302584"
  },
  {
    "email":"belbecco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720806778/86c549bd4961b13d63e5f046ec820472-1730302584"
  },
  {
    "email":"natalia.assiso@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720839546/a3266bf2d29045c3c38efe88d1abc87e-1730302584"
  },
  {
    "email":"diletta.cavallini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720872314/fe9597f5d301825dbbae61145d14a5a0-1730302584"
  },
  {
    "email":"cupellotatiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723720905082/c948c10bedf72763f65b92dcc40ea3ae-1730302584"
  },
  {
    "email":"lives.giuliabracci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721003386/791e0c91c615a8ba7b62bce4564bdd93-1730302585"
  },
  {
    "email":"s_martini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723720937850/a772b8a291f899952328649e514c3975-1730302585"
  },
  {
    "email":"i_roshca@rambler.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723720741242/cef3e3b3385af359169e80a59b2ca4e7-1730302585"
  },
  {
    "email":"giulia.detela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721036154/f8d9bdf0102ee594ca1124f47fe72a96-1730302585"
  },
  {
    "email":"lisi.pir@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721068922/31bb28debb9bbb2dd42244b0b917b874-1730302585"
  },
  {
    "email":"silena53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721199994/5be261adecdb84196c082e415dd6e6a3-1730302585"
  },
  {
    "email":"sbergamaschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721101690/cb9b3a0be0bd7f65fafe86824472ea8b-1730302585"
  },
  {
    "email":"magnidonatell@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721134458/38666ac480c28d1d9db71eccccd172d3-1730302585"
  },
  {
    "email":"cinziaruggieri1@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723721167226/ef0675605680fad41ad0bc523f4e3249-1730302585"
  },
  {
    "email":"stefania.fantini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721265530/9b3a131587fc4e412346ad7bf67a662f-1730302586"
  },
  {
    "email":"btrenca1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721232762/7401cb949dafc5691305d1eb4cf386d0-1730302586"
  },
  {
    "email":"anna.mariagerini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723721298298/1c9c5c202a1e48febaa370c733a23ede-1730302586"
  },
  {
    "email":"nicolettacecchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721331066/79135c66f054b45d485efd890a1f37bf-1730302586"
  },
  {
    "email":"moki67@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721363834/59ece7843d2c2931e1ef528304f28716-1730302586"
  },
  {
    "email":"si.mantero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721429370/5dff41d39312ed00945dab3be5ea179b-1730302586"
  },
  {
    "email":"esmeralda_mi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721462138/e41f7f4b243b21be836c5daaefb4fdef-1730302586"
  },
  {
    "email":"contino.s79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721396602/b4a5b41d6a439743e6a934ade00f261c-1730302586"
  },
  {
    "email":"venzarosy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721527674/d84c1b622edc8ffe7234d91038db79ce-1730302586"
  },
  {
    "email":"giuliaveneziano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721560442/866cd4805949d4a6f6e69dd320f71ebb-1730302586"
  },
  {
    "email":"ilamolibo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721593210/0f880938bc6cfb48a783350b68c00c47-1730302586"
  },
  {
    "email":"roberta.nolli74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721494906/706f1a6099af68e29ded56211dccef50-1730302586"
  },
  {
    "email":"omeovet@bonfi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723721625978/3a54dacf76ff6bf87e216d26184e604c-1730302586"
  },
  {
    "email":"nady.81@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723721691514/3ddf1dfb9b4f31b5f1e022d5a9cf4808-1730302587"
  },
  {
    "email":"giovannapaolino1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721822586/f1466643aac1c6349a581dcb2026dd93-1730302587"
  },
  {
    "email":"mghigom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721789818/daa2df6fbeff68863f2790c7d3fc7475-1730302587"
  },
  {
    "email":"federica_stella189@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723721724282/821e765acf77fda7b792c123191d0fc3-1730302587"
  },
  {
    "email":"lindasantangeli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721920890/ceaf00030867ccf674963de12a1888ec-1730302587"
  },
  {
    "email":"lenatka78@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723721888122/776c474ce46860dc9e74fb254bd41e2d-1730302587"
  },
  {
    "email":"valeria.zurlo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723721855354/afb227a8403a514e87efcba7d7118ee3-1730302587"
  },
  {
    "email":"laura.nocentini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722084730/683e0f807dc7b6c9b1e5e9ad77179bfb-1730302587"
  },
  {
    "email":"lollori74@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722051962/9f57075aa38d365e46ffb5becad2ae4c-1730302587"
  },
  {
    "email":"anna.azzola01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722150266/137ad90738f8e8563a795d6ccf3b95ba-1730302587"
  },
  {
    "email":"gbordi87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722019194/e16f0ba5297564c05dffd673a36db8b8-1730302588"
  },
  {
    "email":"ciabattisandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722346874/256f9255d79ce3a8c8dce427f1fc567b-1730302588"
  },
  {
    "email":"anna.mallamace31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722412410/10f68e352b8c2d1b678d41e2c59e1895-1730302588"
  },
  {
    "email":"serella.bellini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722445178/85ee00e21d9b9012d0e73aed2928843b-1730302588"
  },
  {
    "email":"delia.giuseppina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722543482/428a44ed5225f4631ab20ca8864cb380-1730302588"
  },
  {
    "email":"oriana.rossotto@eidos.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723722477946/17822fdd2914cbd708851869f09db928-1730302588"
  },
  {
    "email":"paola.dirco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722183034/d9d308a122f456db189941213aa3bd40-1730302588"
  },
  {
    "email":"belindagianpi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722674554/45087d4314a1b02466658ffe347ebc3b-1730302588"
  },
  {
    "email":"silfavino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722707322/bdbe542151f2f222e996622e14cd84e2-1730302588"
  },
  {
    "email":"robmasc1305@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722641786/b69534c3c620867fc3d274bfb1df1df9-1730302588"
  },
  {
    "email":"giovannavaiani79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722576250/a3974448f85d7a7a788a23e9873608ac-1730302589"
  },
  {
    "email":"rosalbamasseroni9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722838394/c39999335c4c6195dde99523c1d8afae-1730302589"
  },
  {
    "email":"pkmusic17@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722772858/f6ba1d237d50186d4012bbfb066d548d-1730302589"
  },
  {
    "email":"presenticris@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722740090/16ada5fe83a8df3ef49366a1701403df-1730302589"
  },
  {
    "email":"terry.bianco82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722871162/e760e0dc34d9412a90b5d700c5598e1e-1730302589"
  },
  {
    "email":"paolaidin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723722903930/84641a85bfd4c46134583861c450c985-1730302589"
  },
  {
    "email":"angelavoronin72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723722936698/730c9282c6d80de53a896598daf89a48-1730302589"
  },
  {
    "email":"vittoriarega@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723067770/255483c193bdb3f2740b5797cf187aa4-1730302589"
  },
  {
    "email":"cri.gonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723002234/a97603b82d335a963063990ebe633408-1730302589"
  },
  {
    "email":"daniela.proma@galardisrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723035002/3be8ed80400fc519fb8bb72e16dfa5b4-1730302589"
  },
  {
    "email":"mlalollini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723100538/de88c11501681df821ff0bdab80b8b08-1730302590"
  },
  {
    "email":"steleofe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723133306/701882c1384e6e78ce47326a2a31c7ff-1730302590"
  },
  {
    "email":"alessiaminora@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723231610/2732e8e070dd4db188f78ea6293b103b-1730302590"
  },
  {
    "email":"simona.1971.sv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723166074/59fa551711fad3151320719a7e2f73b0-1730302590"
  },
  {
    "email":"bettagueli1705@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723198842/c6bcd7b045861313abf20cdf0044e5db-1730302590"
  },
  {
    "email":"castellimatilderoberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723297146/1797e2cdf9bb5378a687f20832fe662f-1730302590"
  },
  {
    "email":"francysop87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723329914/2aa13c5f77ce68b39c17c99691116588-1730302590"
  },
  {
    "email":"raffaella.maggiolo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723362682/44fb847e319e145416bee6944db5e1b3-1730302590"
  },
  {
    "email":"lisa.g92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723264378/3073123094fc704bad1d3c26a58a96fe-1730302590"
  },
  {
    "email":"melania.rebonato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723493754/4645388daa3e643d32b9d3c30fb122d8-1730302591"
  },
  {
    "email":"emanuela.proverbio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723526522/20736464221c561a05bd19ab2f3ad1ea-1730302591"
  },
  {
    "email":"schinderija@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723428218/bc19e821f76ca7988c41a916a703b5dd-1730302591"
  },
  {
    "email":"francescafaraco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723395450/0d403fde43ebed7f00115fe79b46a103-1730302591"
  },
  {
    "email":"elisa-cappelletti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723624826/2c7f9fa2d3b1911c038a5812be8c9ee0-1730302591"
  },
  {
    "email":"argiolas.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723755898/3c798437b77304709e4622686e3014f0-1730302591"
  },
  {
    "email":"marikaventurelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723690362/4713cab3d0c2a00e489e414632351220-1730302591"
  },
  {
    "email":"mo_bu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723657594/48d684b16d5bf7fd92847730317b643a-1730302591"
  },
  {
    "email":"bibi.barbara71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723559290/30b63d298ae0ab10b4ee7d59dbf38489-1730302592"
  },
  {
    "email":"christianbartolini20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723886970/80facfbc3af1f8f4decc3833e42ab1ea-1730302592"
  },
  {
    "email":"fabiovisani65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723821434/f3c89a28798e4618f71d9b44aca6327c-1730302592"
  },
  {
    "email":"niki1980@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723919738/ad8db320ef4c1c786119169117865d7b-1730302592"
  },
  {
    "email":"elisa.taccetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723952506/a582a682a3a6047141f51614d4d7f4ab-1730302592"
  },
  {
    "email":"benetazzochiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723723985274/5190edbb3ea04eef230fbc0ac03687f5-1730302592"
  },
  {
    "email":"ariao@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723723854202/2f7dcf2c06b686cfe5cb3cf2aa0d5026-1730302592"
  },
  {
    "email":"eugeniagiaculli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724247418/ca81639fe386df59a2b8216be6f5b46d-1730302594"
  },
  {
    "email":"simonetta.rosi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724214650/6b77ad7573212e644067d69f6002f84a-1730302594"
  },
  {
    "email":"gbrunoldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724181882/1a2187d1e2fcd4f35c2bc19f861f70f2-1730302594"
  },
  {
    "email":"anna.dauria09@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724083578/2c234190c67faab7fad7cff060f5058f-1730302594"
  },
  {
    "email":"soavita67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724312954/7da13f2b44ae3c274fa84dcb27f7321b-1730302594"
  },
  {
    "email":"sofia66rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724378490/8cd4adc637826f7b7f4537237a340572-1730302595"
  },
  {
    "email":"arianna.trozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724411258/1e7868f6e1fb09572f1c362f365c3b92-1730302595"
  },
  {
    "email":"elena.acciari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724280186/3be70aac6407b3faf7bd8335c61fad4b-1730302595"
  },
  {
    "email":"naki.vinci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724476794/94fc4a3729d780eb6f6d1f103afb4ecc-1730302595"
  },
  {
    "email":"brambillamt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724509562/63498b72381c8ce07d012b502a12f89a-1730302595"
  },
  {
    "email":"enidpipa@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724607866/ff2e0ca83a3c3533e9cabb880cc465cf-1730302595"
  },
  {
    "email":"ludovica.vaccaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724640634/cac905a3cad8eead64ccca45c36a4e61-1730302595"
  },
  {
    "email":"venny1971@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724771706/5e6c028bd33e598d4d1819f4e031c048-1730302595"
  },
  {
    "email":"simocleo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724673402/a40a0c36d547abb8a1f6e38220148d56-1730302595"
  },
  {
    "email":"elyana84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724837242/2497fedfed2c4ba25c699cdc201e4a94-1730302595"
  },
  {
    "email":"elisabettamilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724738938/76b841d1895c72fbe20bd65c1bdcdd73-1730302596"
  },
  {
    "email":"mema74@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725001082/cc4067414c7bba0609166eec40c9afc4-1730302596"
  },
  {
    "email":"paolasabato979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724902778/6bf6f787e5790a83a2459bdfe1755c08-1730302596"
  },
  {
    "email":"irenerudmann@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723724968314/10c57fa34e4302b96b43be867d96862f-1730302596"
  },
  {
    "email":"pintonelena@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725066618/300fd273edeb7ab3c78d8ef132e1ec6c-1730302596"
  },
  {
    "email":"angeladapont@yhaoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725033850/fab9dd0d0023713ae735cde1e842b637-1730302596"
  },
  {
    "email":"cortese71@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723724935546/6d9e2099c8023af512111e1a7fe6fa7f-1730302596"
  },
  {
    "email":"sonia.todon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725132154/33990867ac0d73eb49a425216d3a1d85-1730302596"
  },
  {
    "email":"lorenzagentilini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725263226/12a283771fab95b372cd8d80434e886b-1730302597"
  },
  {
    "email":"ursulabenzch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725230458/c2857ef07b52aa6b54f0c0c1ba22c90c-1730302597"
  },
  {
    "email":"paolasaraceni62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725295994/970fbee30f2294687cca9e353ec27e46-1730302597"
  },
  {
    "email":"monicab575@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725328762/f8bf7d42db7ab46479d9d729179cc20e-1730302597"
  },
  {
    "email":"sara.forlani1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725394298/463ae3377596db2f9f2deb904a9d3c14-1730302597"
  },
  {
    "email":"gioculan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725361530/f48e7332582a85b20706ceefb6fd3ff0-1730302597"
  },
  {
    "email":"silvia.fineschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725197690/83ad14a4daf7c1546a6383eb2d44a4d0-1730302597"
  },
  {
    "email":"nunziatropiano1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725492602/68c3c9bdfd18eb4e377f06df522b5c8a-1730302597"
  },
  {
    "email":"infoarenalaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725427066/9aea08f45260a19c6d910df4cef74080-1730302597"
  },
  {
    "email":"swethahe@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725459834/4e55f5fb74fe34eb4f401018ea8ab4e2-1730302597"
  },
  {
    "email":"aurora.finardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725590906/efc7f5e9ad56b3df86876f33fb281fe7-1730302597"
  },
  {
    "email":"patrizia.bonuccelli@vianova.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725623674/22252a3cfb0b1a1da7b6306c6d7625a0-1730302598"
  },
  {
    "email":"janulia30@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725656442/284fbca8e2d3dc535a6aa3137c041a04-1730302598"
  },
  {
    "email":"sabritursi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725689210/d239a578a87de1073d52390445fe6f0b-1730302598"
  },
  {
    "email":"daniela.cadenasso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725721978/5d05ce460d7a810d387181463711809e-1730302598"
  },
  {
    "email":"v.rivolta@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725558138/ce704966b0825b7c4873dc96dda712f1-1730302598"
  },
  {
    "email":"alessandragrillo84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725787514/4c579c5ca349e7917edd19bb09a410e4-1730302598"
  },
  {
    "email":"ilenia@rindifur.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725820282/443ce4b28fe626416aef6139f4f4daa8-1730302598"
  },
  {
    "email":"elena@lmmedicaldivision.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725885818/b03c737fb5c65398c755ecc4eafdc395-1730302598"
  },
  {
    "email":"chiara.cenzon@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723725853050/ecdadd88c5ef494cee732daff5cf92b2-1730302598"
  },
  {
    "email":"marinoanto70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723725951354/7722d3d2fb93fb6fbdad771185361ee7-1730302598"
  },
  {
    "email":"a.comploj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726049658/0b8be93d2a85c4a727d3648b2defaa43-1730302599"
  },
  {
    "email":"valentinapagliaro21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726016890/a67025f12464fcf2692f5b0e11dcf63b-1730302598"
  },
  {
    "email":"susycaputo63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726180730/256771a7940cfbfe2eeeb0aa0c311baa-1730302599"
  },
  {
    "email":"bjecorte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726246266/24c8689f160314034447da8e0955d154-1730302599"
  },
  {
    "email":"elisa.ferro@progetto81.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723726115194/64668be4b8fc80963a24539c18d6e271-1730302599"
  },
  {
    "email":"gemma.barboni01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726082426/b01c2ea7773b391d8ca34c116033d6bb-1730302599"
  },
  {
    "email":"blondevi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726279034/6063c3042e7efa2c88542fd68a949375-1730302599"
  },
  {
    "email":"bommarac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726311802/36f30b4f361654ff8250644473c1d78d-1730302599"
  },
  {
    "email":"valeria.w93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726377338/65b87ad3d17383fcb9a8ffc2c7fd4706-1730302599"
  },
  {
    "email":"xedmea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726344570/2e6df58dd793fe966dca7225116fb1e5-1730302599"
  },
  {
    "email":"ale76rvs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726410106/9f4b4f9bc6ad611c6e1ece512a102a1c-1730302599"
  },
  {
    "email":"smarialisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726475642/6d2103cc91a9efeed0a2918200386dad-1730302599"
  },
  {
    "email":"micaela8@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723726541178/7ba1b6705fee1e9a77f24b7758dbb765-1730302600"
  },
  {
    "email":"fabifafi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726606714/892a55d85a8927eafe55d77bf767a4a7-1730302600"
  },
  {
    "email":"mariachiara.durio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726573946/efc4011637fbd2af2d1add364aabf859-1730302600"
  },
  {
    "email":"iliapotemine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726508410/d2fd3f2a695497b3dcd11c8f65937a5f-1730302600"
  },
  {
    "email":"flaviacorsi1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726672250/b43ca8aa17ca40d7e50e6b6f49c85cfa-1730302600"
  },
  {
    "email":"giuliapretto81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726639482/c6d3c264c58b25d213b8dbda6fd91c9e-1730302600"
  },
  {
    "email":"marta.sottocasa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726737786/528ca4ce89365fb5eaae7ecda05d819d-1730302600"
  },
  {
    "email":"titti.picciotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726836090/ef7705acc0c86780842c7cf7a9225eb1-1730302600"
  },
  {
    "email":"tiziana.borsi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726868858/6d919a37a472370c3d89ca348c3c4f7b-1730302600"
  },
  {
    "email":"lukulele@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723726934394/82ff521a71c9cb04b79e849803a6f23a-1730302600"
  },
  {
    "email":"lucia.sudati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726705018/7de660c3d1961b3e70c9a7e58157e1ec-1730302600"
  },
  {
    "email":"scussatdebora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723726999930/5c676452e8b017a846950869b599eab3-1730302601"
  },
  {
    "email":"mirkonicolini.1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727098234/ad23e47c7286022d373187c921cd2604-1730302601"
  },
  {
    "email":"samanta.cinti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727065466/4d4f46755ac7758a758394846a5c4f48-1730302601"
  },
  {
    "email":"sharkshark853@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727032698/7fa641e23c6e4b841e7071d02f80abe1-1730302601"
  },
  {
    "email":"paola.olivieri@studiobuffoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727131002/5b2ea912ead7810f2960c2dca0483cc2-1730302601"
  },
  {
    "email":"r1976t@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727163770/042dfe32a5e356d267156b44fa5a64b8-1730302601"
  },
  {
    "email":"paola.vannucci19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727262074/81bec660b0d4d2aab077e8ffa6b28b5f-1730302601"
  },
  {
    "email":"ercolanielisa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727229306/159a8b858863e2765c42cde7d4dec673-1730302601"
  },
  {
    "email":"veronica_blue1@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727196538/ba5247f0ccf9139ab21ac9c8e87b594f-1730302601"
  },
  {
    "email":"giadaannoni95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727294842/9215f159e317920988fe8425b06dba48-1730302601"
  },
  {
    "email":"silviazanoni79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727360378/cb06647e4e210e732b7e1771ac21ddd4-1730302601"
  },
  {
    "email":"info@alpenhotelrabbi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727327610/4270b02d38f43812a3a03122a9119a43-1730302602"
  },
  {
    "email":"solferina18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727393146/76002a0b0b111a37a6cb6a4af5ca7895-1730302602"
  },
  {
    "email":"sf.innovazione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727524218/8483fcc62da686ff79fac4237fd127b5-1730302602"
  },
  {
    "email":"cinzia.arico79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727458682/c3acf399c7490d21dd7caf82b1ba338d-1730302602"
  },
  {
    "email":"renatafrancesconi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727622522/ef7b368fdb63df3e6069070ae62112f3-1730302602"
  },
  {
    "email":"stellasenna03062015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727425914/aab263bf7dc6a2f6169d9db76d8c663d-1730302602"
  },
  {
    "email":"ciardellinovella@gmaill.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727819130/30c58c82e8f4b743ce59d041f1c0c64c-1730302602"
  },
  {
    "email":"giomilla11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727688058/bdae2f3a1574bf8d0900dd1b528186b1-1730302602"
  },
  {
    "email":"jennibar918@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727655290/8b699cb9ffbe3731dd16290a81e7053d-1730302602"
  },
  {
    "email":"bassocri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727720826/125f2250ebf2809031df5b588e63bde5-1730302602"
  },
  {
    "email":"elenazarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723727884666/75839faa346ffc5b25028dfa9d208e4d-1730302603"
  },
  {
    "email":"vaniaconte@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727917434/7c9e62b3cb09f3334315fd36ffcb4771-1730302603"
  },
  {
    "email":"monicaminotti@sarti.mi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727851898/2a49f3ac8dcb31fdb2275bc7ff3701e2-1730302603"
  },
  {
    "email":"febbraio02@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727950202/40bfb41cd6441fe5bd285e525683f0f7-1730302603"
  },
  {
    "email":"emilietremblay90@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728015738/4a09d648c081d1e81ff3d3506a96823f-1730302603"
  },
  {
    "email":"elena2578@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728048506/becdc0e9fb5bb623f17ee0ddd98a9ff7-1730302603"
  },
  {
    "email":"mariangela.debiasi9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728081274/4f6f89464e18333ded79354be7482a98-1730302603"
  },
  {
    "email":"paola.scaglione@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723727982970/1e4070e73d99b8fbe9b596415882e81d-1730302603"
  },
  {
    "email":"zlldnl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728114042/47df814d2b62a392ff3af4074fd0beff-1730302603"
  },
  {
    "email":"saradurisotti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728179578/ee2dc04be7c4b7f2f8b70bf89157a4db-1730302603"
  },
  {
    "email":"federica.braja@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728146810/df456ae7e731767dd1be6bd837f40dec-1730302604"
  },
  {
    "email":"yeliraf@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728212346/9f167d5c1cb79e00edaa935911c92a3a-1730302604"
  },
  {
    "email":"silvia.tegner@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728277882/7f4899bd161a1a3247095f9f61f4970e-1730302604"
  },
  {
    "email":"gemminx@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728310650/a970fe4c9d305a1a5ba5b0c95fd6632b-1730302604"
  },
  {
    "email":"gaetano.venturelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728408954/a25f9a9ac6ecda4ff767d62c05394396-1730302604"
  },
  {
    "email":"federica.bucchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728245114/f05a70d85e1fcc28ae3826560d5b82e8-1730302604"
  },
  {
    "email":"elisacrivello@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728441722/1d66f47abb7e69691fe3024a38b195b3-1730302604"
  },
  {
    "email":"fassinarosella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728572794/154918286e3643c999b8e6650bc9023f-1730302604"
  },
  {
    "email":"fede.zulian75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728703866/44cf29bfe16906bd942edeed58aa44ea-1730302605"
  },
  {
    "email":"annalisavia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728638330/7771b6f1c984c6710c1f65c5415119bf-1730302605"
  },
  {
    "email":"milanese@milaneseitalia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728474490/218a5599148f04591229e586196586bf-1730302605"
  },
  {
    "email":"gabritre@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728736634/053c91b699d47ed471fcc53fc6681a6c-1730302605"
  },
  {
    "email":"simonagranucci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728769402/2196e2053ccee1a24302550ee09cbfde-1730302605"
  },
  {
    "email":"valentini-m@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728802170/d061383adc566bc09000dfaf0ee16ee8-1730302605"
  },
  {
    "email":"j_fornaro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723728671098/b61fe1a85b3f8ca8c4f68104400aafbc-1730302605"
  },
  {
    "email":"sabrinaboschetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728834938/0d2bbea784c2b4bdd275d4f7cab927ff-1730302605"
  },
  {
    "email":"monica.pasquetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728900474/66ae2f69c0fc9aa96c3ce44a46389bd0-1730302605"
  },
  {
    "email":"elisamanzato5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728867706/487e89ccefe3db9af58d9a7f1299bff7-1730302605"
  },
  {
    "email":"graziella.cavallaro77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728966010/c87167d18e69969d8e1c7d32b206e415-1730302606"
  },
  {
    "email":"dasci257@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723728998778/3ee3c2f5af5f7bc800439838fcfc0dd4-1730302606"
  },
  {
    "email":"elisagilardi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729031546/b3f9de3f40165e542a2384688345fbf3-1730302606"
  },
  {
    "email":"sandragrassi60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729064314/0c3ccdc47fc632721dc9799f27ac65fe-1730302606"
  },
  {
    "email":"alessandrarussia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729162618/9bd6ba8a136fdee4f1883c7be4a18a94-1730302607"
  },
  {
    "email":"stefania894@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729129850/38edecee791ce1c98f94994526ce6c24-1730302607"
  },
  {
    "email":"eliabau@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729260922/083a5edd727a73ab4feec8ecaf1b7ce0-1730302608"
  },
  {
    "email":"grazia1964@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729228154/2ca9719787e273e2d7280200682ba836-1730302608"
  },
  {
    "email":"avvdeborasalomone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729195386/6adfad023871c6c66e88f3f396c58490-1730302608"
  },
  {
    "email":"uauibella@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729326458/469724863fbe03d22f5d3ffb00d337c7-1730302608"
  },
  {
    "email":"paola.garbe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729359226/d70dafec0350a8f98f90d03bd1510f05-1730302608"
  },
  {
    "email":"linda.allevi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729293690/a3aaba64c39ab9cf79b4f8dd2eb6b1fa-1730302608"
  },
  {
    "email":"g.serraino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729097082/f9b34c2f845527efad8771ebd5cea53d-1730302608"
  },
  {
    "email":"rita.zongher@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729391994/cb3d18c9130cb1e4b5b8ccc3bef931d5-1730302608"
  },
  {
    "email":"danielacurto5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729490298/0f94ecbff0bf349706d964d288a84df3-1730302609"
  },
  {
    "email":"stefania.anzillotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729457530/f1b6feabcea5fe3f5a20051c8bec4721-1730302609"
  },
  {
    "email":"natascia.selva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729523066/581e6c7db00be906fe2e8a9e41a8d919-1730302609"
  },
  {
    "email":"mrs.marinka@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723729621370/d22bdbb26cfd614002c45b3fa01e21f8-1730302609"
  },
  {
    "email":"michela.ditonno71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729424762/0727691625a870b42adc5d4eb1b3c7a5-1730302609"
  },
  {
    "email":"francesca.gamba.fg@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729555834/91a3354d5eacaf878d07da5a391a01ce-1730302609"
  },
  {
    "email":"2002gele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729654138/6c1f831f6db8ced53a6eb27dca0e2b94-1730302609"
  },
  {
    "email":"sofiadamico@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729686906/0759c151f7af6e8a4adc8d3bb6b88b61-1730302609"
  },
  {
    "email":"elena.falavigna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729719674/8a0f10f430594146fb80fa3d49d8f9f8-1730302609"
  },
  {
    "email":"mincolellipaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729785210/733e5451fa64612f494d711ea733e5d7-1730302609"
  },
  {
    "email":"m.dandrea@maurys.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729817978/54bd5396990f8d35cea9ee24383cffc4-1730302609"
  },
  {
    "email":"dsalvestroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729850746/13b6c14a5f00289c8cc57cb309c5a44e-1730302610"
  },
  {
    "email":"simona.catelani72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729981818/0bde1924451e51da7457a2e30068ccdc-1730302610"
  },
  {
    "email":"babid77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723729916282/9350a469725d34fb2e2d0c9df3c873e7-1730302610"
  },
  {
    "email":"rossellabianchi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730014586/291cab60a0c634518ab9c2d49e70f2e6-1730302610"
  },
  {
    "email":"v.parma@studiogabellini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723729752442/13844db04994308cbce02c7bcda6af42-1730302610"
  },
  {
    "email":"a.marchese@pbtankers.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730211194/e884abbda928fa24d5fc9d483da1afe2-1730302610"
  },
  {
    "email":"enricagiorgini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730178426/73ca25293fc137a30dd880f93e0ee8ab-1730302610"
  },
  {
    "email":"veronica.vigano@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730243962/60a8a3dcd20821c1cb697d818e7a9cf5-1730302610"
  },
  {
    "email":"eva.vezzosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730276730/a9a8afbd112ec3d1897426a146e1de21-1730302610"
  },
  {
    "email":"epicmario68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730342266/fd44978523ec024d0a0380c5f0c3123e-1730302610"
  },
  {
    "email":"vittogri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730309498/dff5bfb02696d5029ead8ca2851a1bdd-1730302610"
  },
  {
    "email":"ilacala@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730375034/5030a5fc646f1510a8c3e9f015110eca-1730302611"
  },
  {
    "email":"elisabettadattola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730473338/f8ed24e6e09ef15baacaccd33ab197e5-1730302611"
  },
  {
    "email":"ricciecapricci82@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730506106/35f99b6992b5b0138c81a4b21b8d0295-1730302611"
  },
  {
    "email":"kiara.novelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730538874/83b2d3aff8fd2869ce0f04f4a3742c52-1730302611"
  },
  {
    "email":"lucrezia85@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730571642/111ae5c55fca6f8bb6779984815dc928-1730302611"
  },
  {
    "email":"cinzia.adastra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730637178/3dcfabf38ead24c4addace6c8ad349f5-1730302611"
  },
  {
    "email":"salvatorebruno54@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730702714/848975f9a07f2f4b7624a85ff511a51a-1730302611"
  },
  {
    "email":"absinth@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730669946/0977e8322e5f8f5dac290d0261ba64ca-1730302611"
  },
  {
    "email":"marcella.landini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730604410/2c4040af9461f9c8569b50090de39054-1730302611"
  },
  {
    "email":"silvana_benedetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730735482/9f7efcf1da7a9b73f34f7f9058730984-1730302611"
  },
  {
    "email":"gabriella_degiorgio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730866554/733b89318cf3eeea81499ec1227e8b23-1730302612"
  },
  {
    "email":"federica.targa7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730833786/50b417604a19eb8376760c1af57ceb5f-1730302612"
  },
  {
    "email":"elenapatteri@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730899322/6323d9fc74c342fec5115894890e55b8-1730302612"
  },
  {
    "email":"fedisusanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730964858/9142f1be1ab0f88d70fb4a1a07575ffc-1730302612"
  },
  {
    "email":"dabecri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730997626/2dbf3216ce44a49b2ae7f441cdc36851-1730302612"
  },
  {
    "email":"mariannagiordano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723730801018/bf16c21a6b972d1e2e8bb1c08bd49a7d-1730302612"
  },
  {
    "email":"assubra1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731030394/ce7f5c9f373efc3cf9c4831c7b2ea0c8-1730302612"
  },
  {
    "email":"massimogrespan2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723730932090/a63433fbabab7d7d80c7e93229cc6cb2-1730302612"
  },
  {
    "email":"zilina.eva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731063162/0ccb0fda06b1da250f979a2c7f89b4e8-1730302612"
  },
  {
    "email":"federicapresti@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731095930/7ff1c2cb829b4adc98d5f301128380db-1730302612"
  },
  {
    "email":"annagasparri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731128698/72e3873e548a87677ea6797d50120b03-1730302613"
  },
  {
    "email":"va_1971@yahoo.it",
    "url di attivazione":""
  },
  {
    "email":"simona.congedo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731161466/52b6cb2a4a4e374433577ffa5140fcf0-1730302613"
  },
  {
    "email":"lucialazzeri79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731227002/db9061f30f42dda11407002747a166dd-1730302613"
  },
  {
    "email":"jakulinkatja@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731194234/a3598709e2976df0329692776051dee2-1730302613"
  },
  {
    "email":"fnc.manni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731358074/531035e86444b866e7090ddbf4980784-1730302613"
  },
  {
    "email":"rana155@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731390842/a17464e7d2658120b83017cff9bb177a-1730302613"
  },
  {
    "email":"vannaparrucchieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731423610/9e3707dc5cccd76547aa93a0ddbba597-1730302613"
  },
  {
    "email":"costanza.mosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731489146/8657bf8977ea850179eb1c1783882069-1730302613"
  },
  {
    "email":"paoladazzi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731554682/29a03b16c906a353a3ca920cffe0bf62-1730302613"
  },
  {
    "email":"mchiara_mon@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731587450/51ff44a16dafee4ae61260d03f4772b5-1730302613"
  },
  {
    "email":"adelaide.ditullio@studiodtp.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731620218/597989cabac14ee122e8a03e318cb1f7-1730302613"
  },
  {
    "email":"mariapaola.pasquale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731685754/34e4451c34a31b99607a14dfe45f9539-1730302614"
  },
  {
    "email":"terzulli.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731784058/7fe79341c8a01ebd0bb6a9dcefd42258-1730302614"
  },
  {
    "email":"info@boutique-chariot.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731652986/64cca89bf5a5e1bcfce658ffe2d749fc-1730302614"
  },
  {
    "email":"f.lorenzi@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731816826/c759a4d1e24a9141d677f00670f72e3f-1730302614"
  },
  {
    "email":"chiaracandido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731849594/f282a636fe42f6e7bcd6205a58156d5d-1730302614"
  },
  {
    "email":"simonagagliardi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723731882362/ecd78bdf10f77cd1bcc22bdf7602dc18-1730302614"
  },
  {
    "email":"ileniav@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731915130/0f31f634e3e787fab15151debb80ea56-1730302614"
  },
  {
    "email":"kalo1948@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731751290/2dfc8b268449d915187a062bed087edf-1730302614"
  },
  {
    "email":"caribesister@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731980666/266a55c2ad7a27af356f4c044d0f2c4e-1730302614"
  },
  {
    "email":"monica.golle@ctamilk.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732013434/6e9d95e80f75f0dd284347eb402429ef-1730302614"
  },
  {
    "email":"rosellagaeta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723731947898/a9677278d0e1968f86a91e8b6cc4e0c0-1730302615"
  },
  {
    "email":"rivacristina6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732177274/cd7ed3c7d70fa1a018ba7424e2f0e270-1730302615"
  },
  {
    "email":"mariagraziaspiga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732242810/3e6c98524c07f234f9e2fb188561eade-1730302615"
  },
  {
    "email":"francescacontri00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732078970/6a0b6b1d66346e00b42f12639a9d14f1-1730302615"
  },
  {
    "email":"lilac.giulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732275578/e08b2b5c7ac77c17ed62136fd9e623a5-1730302615"
  },
  {
    "email":"amy.stilson@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732111738/1fe8c35ba75a4e8b55449b7e48a69052-1730302615"
  },
  {
    "email":"annachiaraciunfrini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732308346/561b29340e8af0cb9b2b5ea842c87c96-1730302615"
  },
  {
    "email":"angicia111@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732504954/9bfd5e99c0a15c7bdb83faddbfa518ae-1730302615"
  },
  {
    "email":"mauriziovirgillo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732439418/428145f40efcb78645d4c449c52c4c61-1730302615"
  },
  {
    "email":"nina010@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732537722/1b74d93228219e7a9e0fcd269ee1b725-1730302616"
  },
  {
    "email":"camate@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732603258/60db7e3087aa75cea3f37fbd38871805-1730302616"
  },
  {
    "email":"veronicahercolani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732373882/602a77c149f1aef49498c684208c48e1-1730302616"
  },
  {
    "email":"paolanolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732668794/4e3d69b20a56676b478c9b2cdf7e29db-1730302616"
  },
  {
    "email":"mastella.carlotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732734330/942f9495f71b7b7600f9dbf7a862026e-1730302616"
  },
  {
    "email":"filoformo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732636026/f09ad45f225ca8c0773107168341606c-1730302616"
  },
  {
    "email":"barbara78_valle@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732930938/0e21224270183bafd74208f2649b903f-1730302616"
  },
  {
    "email":"mariaileni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723732898170/9e457e084e1b88a2170f0223018e8809-1730302616"
  },
  {
    "email":"facchin.gerry@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732996474/a1c47e325ed19ceb0a281493e29953c5-1730302616"
  },
  {
    "email":"irenecolombo66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733029242/dd021f155ffc23d8021f952bc4c4295d-1730302617"
  },
  {
    "email":"anna.bursi@stellantis.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733094778/ea03561ba5893730521396d3c210125e-1730302617"
  },
  {
    "email":"carmenvisalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733062010/1a09a155e305fb0a7424688677bf13b8-1730302617"
  },
  {
    "email":"valeria.monestier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723732865402/1b98634cc4ba70fbe3be36640f956673-1730302617"
  },
  {
    "email":"b.franciosi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733225850/9cd025b7d29e3932e632eb491497e101-1730302617"
  },
  {
    "email":"valerysollecito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733127546/7a206093e91ccf64843bdeac0299ae16-1730302617"
  },
  {
    "email":"raimo.marinella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733291386/d7b0f8919f93e1dc8d42a90468251517-1730302617"
  },
  {
    "email":"ivetta.gozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733258618/31e877394aba86ee5e14015c31ee9d97-1730302617"
  },
  {
    "email":"mrln.pn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733455226/e60454a4f8cee8254da8654d9d454451-1730302618"
  },
  {
    "email":"maria.tasciotti@intesasanpaolo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733389690/7633d880837677ad9cdaeb3eac92f4f1-1730302618"
  },
  {
    "email":"filomenamoschetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733422458/ed6d28b2b6b68256c43d1675fb527273-1730302618"
  },
  {
    "email":"farmaciavogogna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733520762/501a06f2332600ddd6e8d9196288b752-1730302618"
  },
  {
    "email":"annalisasanna75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733356922/6fa1b82d11b7e732b9df946df80bd497-1730302618"
  },
  {
    "email":"francesco.davoli69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733586298/0ef344a927882c6b0ff90e8479f81851-1730302618"
  },
  {
    "email":"elisa68ferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733684602/2d4f76d15bbf9b50aaa0c5f98689a001-1730302618"
  },
  {
    "email":"silvia.ramonda65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733750138/d7ee5df9eb13bd0e07d2775f6589e194-1730302618"
  },
  {
    "email":"mariacarmela.pappalardo8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733619066/43ef1cf52ceead25beae9b2fbd203811-1730302618"
  },
  {
    "email":"cleopatra.1983@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733651834/6ee735ed85e63f243b659964d51a75ab-1730302619"
  },
  {
    "email":"a.serravallo@studiolegalesd.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733782906/424cbc73d895c822db683f26e5eb2d0d-1730302619"
  },
  {
    "email":"alida.piras.71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733848442/cf046511490cb7e33e34c2a838108d57-1730302619"
  },
  {
    "email":"c.spelonchi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733881210/b0b3268cafbef37a56c73e203141bbb9-1730302619"
  },
  {
    "email":"rezi_tila@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733913978/91d949fa1d7e20533cac252db93c5bdf-1730302619"
  },
  {
    "email":"mcerrano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723733946746/ed5a19fc891937b553921dccb2838d20-1730302619"
  },
  {
    "email":"mm.franza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734012282/2f1f8887afad6ebab61d31cc36d29826-1730302619"
  },
  {
    "email":"oriettaenea46@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723733979514/e95850262cb40c66567ecab8dc6c72f2-1730302619"
  },
  {
    "email":"annalisa.vignali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734045050/5a2e8c3416f67fcbe82599175945561f-1730302619"
  },
  {
    "email":"lauracrovari@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734077818/5c68cd6c765288280cb0a5a012d07f03-1730302619"
  },
  {
    "email":"caterina.freschi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734208890/bc127bd1dd6413cd505da21eedc705bf-1730302619"
  },
  {
    "email":"lauralonghitano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734176122/36aadf9883ea8e4966449222894e54ef-1730302619"
  },
  {
    "email":"foronigiada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734274426/f3eb6d0e065a8456ab35cdd5076bffdb-1730302622"
  },
  {
    "email":"flavia1975finotelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734372730/aa2f2a2b8d71c14acd8224a36a1efa5b-1730302622"
  },
  {
    "email":"albertaclaudio91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734405498/6932c6f701e41000f20e92354c0a368b-1730302622"
  },
  {
    "email":"mariajoseforestieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734339962/aef6dd6a449b2c01b93e3765a0d6d164-1730302622"
  },
  {
    "email":"giuliamaria.parisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734307194/33800b2f32645e272693b32136b6eee5-1730302622"
  },
  {
    "email":"mirianaraimondo12345@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734438266/34416a47c667c005cc15c807aa2b6fa7-1730302622"
  },
  {
    "email":"mirkocoletta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734471034/2019df3fb15554b8b334066b80ac2a4b-1730302622"
  },
  {
    "email":"graziasella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734503802/be28f77e2ccd52c9044b3b3c86ad9526-1730302622"
  },
  {
    "email":"fulvbart@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734536570/2ea67b89d37e7a38e0722b4eb5be1c66-1730302622"
  },
  {
    "email":"dori2506@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734569338/365e028aebe5cbdfc3915bda86a8eaee-1730302622"
  },
  {
    "email":"giulia_lenzini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734602106/0ed38aba3481b0dc87e701ac8ad46ea7-1730302622"
  },
  {
    "email":"betty.ferrara1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734634874/c911cd66bacf7fd5f2c869d030e7e29e-1730302623"
  },
  {
    "email":"nada_sa@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734700410/c4d82b06f68fe31fa6284ed1746c48a5-1730302623"
  },
  {
    "email":"monica.roncon@agricolagrains.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734733178/61b820bcc1b2c1d5070409719c90fc39-1730302623"
  },
  {
    "email":"natascia.poli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734765946/81755ff5a8d7cd8e79ef4f82264edc1a-1730302623"
  },
  {
    "email":"chiara@vipnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734667642/90842c53eee2e357315c35378d49f960-1730302623"
  },
  {
    "email":"carmela.annunziata77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734798714/e65d07a7b5e547ca33c2751e55f66bda-1730302623"
  },
  {
    "email":"franciciccar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734831482/093b4ad0ab10f299dd60be6452b90225-1730302623"
  },
  {
    "email":"fumagalli.si@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734897018/0d5dabbff9bc890b03ebcbe7c8aa33e0-1730302623"
  },
  {
    "email":"pisanumaria1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723734864250/814d877c2d61d722634957339561ab72-1730302623"
  },
  {
    "email":"wayvic13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734929786/59afd9a483887faf8931abf6d9b4e0a4-1730302623"
  },
  {
    "email":"francescaperotti2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734995322/1dee5e5d7a1836a7aa53d769ed278118-1730302624"
  },
  {
    "email":"rossimarica@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735028090/7eb1e6789f44207d13a5544c70f1bd40-1730302624"
  },
  {
    "email":"noise6869@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735060858/ab0c5c15f19879ab17b3013778d7468a-1730302624"
  },
  {
    "email":"c.fiorin69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735191930/ddd6f443cb84e24fae6861527e373304-1730302624"
  },
  {
    "email":"gio.dadda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735224698/fc9d6413109463dc0fa78c4919c5ee3c-1730302624"
  },
  {
    "email":"alessia_p27@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735257466/e58530199646e6823ce3341bf58311fd-1730302624"
  },
  {
    "email":"ines.castellari66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723734962554/863911d0de93a9cc0a69bfde058ad9b1-1730302624"
  },
  {
    "email":"valentinalutri80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735290234/9bc413ae72c7d383229a4f8e36dc9ab7-1730302624"
  },
  {
    "email":"friky.mail@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735388538/9013c233f43a67c8111e6527f17de126-1730302624"
  },
  {
    "email":"federicadb2000@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723735716218/0796845ebafdca345b41f113bf738e73-1730302625"
  },
  {
    "email":"silvia.damiani@auslromagna.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735355770/0911764f363b8a77d93d147d6d939bb8-1730302625"
  },
  {
    "email":"ariannamola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735421306/7de103a9bbfb7dfea8397a6742ba6e33-1730302625"
  },
  {
    "email":"manuela.simoni77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735454074/65badb558e8d71579ce1d99c4af9a4ea-1730302625"
  },
  {
    "email":"elenacarol80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735847290/dae3470c437febd71439ffa9cf068679-1730302625"
  },
  {
    "email":"enrica.monti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735781754/c84f88aec7ce776b7fb705fa8a53c0d9-1730302625"
  },
  {
    "email":"simonettatonga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723735945594/48afb5ab2e401beab4f7093e253a9bcc-1730302625"
  },
  {
    "email":"simula.giovanna@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735912826/dea4d63881f1999e3cdc0cdcac993306-1730302625"
  },
  {
    "email":"alecama169@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736076666/39352df204a0245e5d908d3f61084e53-1730302626"
  },
  {
    "email":"giadapaopao@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736011130/b886aaa34550ccbefadaa0a857cd1e44-1730302626"
  },
  {
    "email":"stefania.galligani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736109434/bf2dd98d37c44ab94b20d63b43ca7f11-1730302626"
  },
  {
    "email":"cesena.francesca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723735978362/20c2af2484d3c8498b535b772366c168-1730302626"
  },
  {
    "email":"sardinateresa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736207738/00c737b9fa25176fc555188c05794aae-1730302626"
  },
  {
    "email":"mariacolbacchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736240506/648270525fe808ccac8d813c22298d55-1730302626"
  },
  {
    "email":"mariapia.mariani@iss.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736273274/ab42c7262bbc18d1b35fb73376cbbe7c-1730302626"
  },
  {
    "email":"francesca.bertini.bg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736338810/bfc61a391ad117135fbe6011913fb8c9-1730302626"
  },
  {
    "email":"cecy13@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736404346/ff09c141c0ac2962d13f3964b28ba40f-1730302626"
  },
  {
    "email":"dalessandrorossana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736437114/5bc2e5bc16b18f65ba166c750f63a5be-1730302626"
  },
  {
    "email":"dcpuccini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736469882/b916da51742e5a3d25adcca75a4a6d71-1730302627"
  },
  {
    "email":"store.bologna@verdissima.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736371578/aa13323ce7fea35b931d812f471dfebf-1730302627"
  },
  {
    "email":"marta.pugliesi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736666490/e35a154d4d34ec268e17b75c2a7b15b0-1730302627"
  },
  {
    "email":"nica.zanon.nz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736568186/8c8b7e9c9a90a5b116409125194ec334-1730302627"
  },
  {
    "email":"desiree.bertana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736732026/3d513d66a02431e4875cc44a65a03129-1730302627"
  },
  {
    "email":"e.cavalli98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736797562/c5cbb5c314e1bfceffca036c060f4d93-1730302627"
  },
  {
    "email":"antonellaciccarelli92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736764794/db6519bd9bcff69ad5c0ef9fa96c2371-1730302627"
  },
  {
    "email":"serena.bucossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736699258/f806d5e81a6df29dead80d1b7c8fda1a-1730302627"
  },
  {
    "email":"elisabettabottacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736895866/7eef42e6b07efff7adeddfdcf3d215aa-1730302627"
  },
  {
    "email":"didipiu2008@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736961402/cc5ba813918f63f7f06247b3e677d6da-1730302627"
  },
  {
    "email":"sabina.vaccari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723736928634/d88c56b1e7993fe7000316c6a1e6acb4-1730302627"
  },
  {
    "email":"e.bianchi85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737026938/0bfa72146a1289a73282fc5b13db059c-1730302628"
  },
  {
    "email":"marco.franzoni0@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737125242/146aa89cbfff1d0d4f40faa9944ca373-1730302628"
  },
  {
    "email":"p.barabaschi65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737092474/3d2c315af166c0e8a73a1b1290b282ba-1730302628"
  },
  {
    "email":"alessia77.m@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723736994170/7c4afd825f2a6d5aef981f45ee0e6d7f-1730302628"
  },
  {
    "email":"alina.marg@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737158010/fc6b50ef0129434822dc0df6e183c2b3-1730302628"
  },
  {
    "email":"f.roversi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737256314/c862b2b5f0c36b8b69ab93e2d580f0a0-1730302628"
  },
  {
    "email":"emaroni@comtechitalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737223546/b99e2aaceab50405b74f3daa5536a2a8-1730302628"
  },
  {
    "email":"valentina_magno@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737190778/55258649005511d7b1518eb9e00e2c8c-1730302628"
  },
  {
    "email":"amgfichera@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737289082/264e555a8491f429580a7d6f93af844a-1730302628"
  },
  {
    "email":"simonettadosso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737387386/96f5d4b6e8752a2aae384c6de15fde44-1730302628"
  },
  {
    "email":"fiorenzacalore6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737420154/625f89d2a228273bb6641564457e02b6-1730302628"
  },
  {
    "email":"patrizialaura@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737452922/4138690397571cc8af8c86565a59de39-1730302629"
  },
  {
    "email":"lorim04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737518458/71862676f91b597fc92a73be07456f51-1730302629"
  },
  {
    "email":"barbarasantini00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737354618/40916f22e5854945cce1f9f05cd69437-1730302629"
  },
  {
    "email":"paola.divito78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737551226/4ece7527e89b1ea5b47d90c50d02e462-1730302629"
  },
  {
    "email":"sarah.visintin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737583994/e15e45b84d1e4658745442dfe937d5e4-1730302629"
  },
  {
    "email":"stefaniazambonardi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737682298/95517715485ba097e886a9f2a8007814-1730302629"
  },
  {
    "email":"devasanta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737485690/b3e170efe0f2e0a3f9e06e94b66a234d-1730302629"
  },
  {
    "email":"barbara.cecchini2@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737747834/53393d3b4d8ab6dc398b2abe04a56399-1730302629"
  },
  {
    "email":"avv.marilenaalbanese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737878906/06150e1ac483b163cb83c7845b981f49-1730302629"
  },
  {
    "email":"mozzorecchia1953@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723737846138/695cd5923bb16c2016cf0121270635c8-1730302630"
  },
  {
    "email":"silvia.scoccianti@uslcentro.toscana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738009978/690249201e5d0e80380708cedfe15ab1-1730302630"
  },
  {
    "email":"angelitadacamo1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737715066/1b05596435309494800ca20437e30377-1730302630"
  },
  {
    "email":"fraasso@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738042746/5cc03d4c1353008a325be1478fb75062-1730302630"
  },
  {
    "email":"francecartei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738075514/45d032f4298c3ff38b35d7e64e145364-1730302630"
  },
  {
    "email":"mariagiannuzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723737911674/d0efda142edf86c165187efd9befda7d-1730302630"
  },
  {
    "email":"_lizzy_@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738108282/3b877f92a72f895c047750bf3fe589fc-1730302630"
  },
  {
    "email":"petrarca82cinzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738141050/26d2d33bb969daa8e9a94cdd6f84a1fe-1730302630"
  },
  {
    "email":"sb2010f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738337658/320be3c44dd46d2e8599683bed77c3f1-1730302631"
  },
  {
    "email":"rominabarbieri888@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738403194/fe9feb42b72011c8e60cb05ba70f777f-1730302631"
  },
  {
    "email":"alessiacapone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738304890/09ddc9572976b0cc50e4f6d2d3bf0671-1730302631"
  },
  {
    "email":"rossettiannalisa25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738435962/9b52417a2dfd7886a87a6f2886eaaac9-1730302631"
  },
  {
    "email":"ariannamiscugli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738501498/65f595732588c59172254662a366c9a2-1730302631"
  },
  {
    "email":"simona.colone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738534266/9241c137426f725860f3b0d10c16a47f-1730302631"
  },
  {
    "email":"saty2001@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738468730/70c279e5bb4449bb5c4e7b40529e4b73-1730302631"
  },
  {
    "email":"joanes.duni@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723738567034/8588b5d30f041215437cdac500b8a9a0-1730302631"
  },
  {
    "email":"rtrserial@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738599802/3982e2be0452945e019bdf08a8c02958-1730302631"
  },
  {
    "email":"vandonibarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738632570/6fd07b239d7663d7571acdc9d07a3b62-1730302631"
  },
  {
    "email":"laura_fenny@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738665338/7a6868e83d9991d5fc6356c1228b2fbe-1730302631"
  },
  {
    "email":"licorossi92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738698106/dc5c0415ae8965768e169389476df7bc-1730302631"
  },
  {
    "email":"marascampuddu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738763642/31a326b3677d37d7c823379b0b5e07cb-1730302632"
  },
  {
    "email":"verdissima@matteo.simplelogin.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738861946/5561bb8f37d1f6ca8e1ee5907500183b-1730302632"
  },
  {
    "email":"roby.ma.73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738894714/39599377603fdbb82da76f261a64887f-1730302632"
  },
  {
    "email":"rossella290668@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738796410/dfc1368be533e69237d085dc61e20182-1730302632"
  },
  {
    "email":"info@lideaan.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723738960250/1652a784dbc5905cae52c1bfa35e2581-1730302632"
  },
  {
    "email":"11federicat@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738927482/1fd812bec0fbb78dd2be136769c40d63-1730302632"
  },
  {
    "email":"sabribertolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723738993018/f50dea8e9196d79b472be9780c811022-1730302632"
  },
  {
    "email":"mary.89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739058554/5a0b93de217f7f83dc0672ac510264d2-1730302632"
  },
  {
    "email":"climacentersrl.cortona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739156858/b2cf35717d2a46ee7fb857ffc1536a7a-1730302632"
  },
  {
    "email":"roberta.lesina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739189626/0cc4010ebb27532764ac55e0655f7ba7-1730302632"
  },
  {
    "email":"dipizio82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739255162/e193aa2adfb4e251006c4139c9ced30f-1730302633"
  },
  {
    "email":"ruscigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739287930/d69b0df04f324b09d0162069facedb99-1730302633"
  },
  {
    "email":"annalisa.1206@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739222394/eb8a3daff81caa8e560768cd9b73133b-1730302633"
  },
  {
    "email":"laura.calcinai7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739320698/49f61f2abb16da18e8ac41d61116b567-1730302633"
  },
  {
    "email":"dnl.gen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739353466/9f20b7af6480293bff93574763fcea2c-1730302633"
  },
  {
    "email":"ceccato.cristina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739451770/9e261c07457ef9086c9698d35b42d31d-1730302633"
  },
  {
    "email":"daninonnis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739386234/677d6ec9b6aebcda6778af8903bcb200-1730302633"
  },
  {
    "email":"paolaricci8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739484538/52463112870d8cf409066be3ad472b4a-1730302633"
  },
  {
    "email":"cinziafinotto@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739648378/c908d2640d27b264d0006287060d1fe6-1730302635"
  },
  {
    "email":"valentinachianello33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739615610/921225208aeb95240d106dfa0cf5474a-1730302635"
  },
  {
    "email":"66agatamoskala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739517306/f96a0cc1490cc429d1b63a16434e8519-1730302635"
  },
  {
    "email":"garbarino.emanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739779450/c2c5140a36bd60ce3f118adc8130d94f-1730302636"
  },
  {
    "email":"afucelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739812218/e4182d761b07f6960a427adb54444a56-1730302636"
  },
  {
    "email":"jole592008@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739713914/dad47bf60f997659d19af1cf7be3b6fe-1730302636"
  },
  {
    "email":"puddu9@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739844986/66b65df0210d3c4544c165264c3f1243-1730302636"
  },
  {
    "email":"crifox@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739746682/0675cb3ca5efa73b60dbfa4393abfd42-1730302636"
  },
  {
    "email":"ardiana.curri@dionas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723739877754/7c1e0f7858512f8536c398e5f3ff1c03-1730302636"
  },
  {
    "email":"zillilucia@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739910522/3463d6eb5a489deffa7ce1632cb225a1-1730302636"
  },
  {
    "email":"silviavisentin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739976058/26303495178813ca38aeda0284121427-1730302636"
  },
  {
    "email":"ufficio.design@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740008826/24906cf49dc564ce5598cbcc381d7504-1730302636"
  },
  {
    "email":"rosedimaggio64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723739943290/94fa1dd14413c102e677a278c7431fbd-1730302636"
  },
  {
    "email":"spedizioni2@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740041594/eb310cace2825ba3192c1633dc17ae2c-1730302637"
  },
  {
    "email":"ufficio.prodotto@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740107130/c3aa8657e231241fb3b273600dbe7ab4-1730302637"
  },
  {
    "email":"backoffice@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740139898/7162edc9a924bf9bd2bc1f7f5d60a8a2-1730302637"
  },
  {
    "email":"ufficio.stile@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740074362/745697baab4cab8b41209616eac2b145-1730302637"
  },
  {
    "email":"ufficio.grafica@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740205434/76f3df3e77768c11b238b7ee06d4b793-1730302637"
  },
  {
    "email":"erikaspadoni85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740369274/49c34cb2e83e40b90114d1fae7a831ef-1730302637"
  },
  {
    "email":"claudiademilio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723740467578/1cf4f06849da454c681708672093cd67-1730302637"
  },
  {
    "email":"mi.ferri07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740500346/170c4fcb61fdcdd61a707c6f42699258-1730302637"
  },
  {
    "email":"eli_tome@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740631418/7693083085e1d3a782c34533639275e9-1730302637"
  },
  {
    "email":"ufficio.gdo@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723740270970/461457f42f42d34f02978df2bd94e7bf-1730302638"
  },
  {
    "email":"alessandraghiro55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740664186/9333d09ff7de905b34b7960e8cb842e6-1730302638"
  },
  {
    "email":"romibeltra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740565882/664cf39920a2a9eced26603308751d89-1730302638"
  },
  {
    "email":"albertabucchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723740762490/8d6e8a7c82c93eda2ab9dc95dc58040c-1730302638"
  },
  {
    "email":"peolissima81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740795258/c76ec3a4e101b507b0bf9f4e72c3ae18-1730302638"
  },
  {
    "email":"melissina09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740828026/c35a2fac577e67566b47bf2cd994c8db-1730302638"
  },
  {
    "email":"giorgio.greening@t-online.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723740696954/2c5eb786a4922b4578df17900413393f-1730302638"
  },
  {
    "email":"laura.lory2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740729722/dd5fc02281f66eb4b7a29df0672c71c4-1730302638"
  },
  {
    "email":"mariagraziaconforti@yahoo.it",
    "url di attivazione":""
  },
  {
    "email":"annik90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723740926330/3466fd18cc0c6fc3f5c52ece2f7332d4-1730302638"
  },
  {
    "email":"blueness@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723740893562/39f2e648b485985cb00e627570c519ac-1730302638"
  },
  {
    "email":"cecilia.trevisanato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741057402/23e3f6248c84b36d488c419d97f92eb2-1730302639"
  },
  {
    "email":"consuelocerri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740991866/1ef4ffbd0e85cd901f32da6dc6ca9f05-1730302639"
  },
  {
    "email":"magno.carmela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723740860794/14253b98885ef960dfbcb6833c2d9ad8-1730302639"
  },
  {
    "email":"carlottalualdi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741122938/2407bc4eeccdc292beb541214ce12154-1730302639"
  },
  {
    "email":"enotecalippolis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741090170/fc02a4dfbb1749d5e2f073b2629a38dd-1730302639"
  },
  {
    "email":"caniglia.maria1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741024634/33c8e4345d9ab7f03702b955bbe33691-1730302639"
  },
  {
    "email":"giraffa2013@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741221242/6ad0635fb1d4e2225be13561e55ba180-1730302639"
  },
  {
    "email":"nicoletta.piscaglia@battelli.istruzioneer.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741286778/814e6df616d44b5ea62446f97661f501-1730302640"
  },
  {
    "email":"lauracampisi1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741188474/33ed1696b6f18de2133769e639d80c78-1730302640"
  },
  {
    "email":"elenasica2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741352314/4835cb101b704a4691d04d7b36c92a13-1730302640"
  },
  {
    "email":"f.teneggi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741385082/442d35109aa137fec10f73dd2da67692-1730302640"
  },
  {
    "email":"antonelli.rob@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741483386/cce47d9da020bd7c88edd9968604ab34-1730302640"
  },
  {
    "email":"taniacollini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741516154/1b69e8f4d9464b022246d47b04442070-1730302640"
  },
  {
    "email":"ilariacingolani84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741548922/fe33cb907b960664490ab3711d304dad-1730302640"
  },
  {
    "email":"simone.burger@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741581690/6040d402e4860380ec8828b7815d1008-1730302640"
  },
  {
    "email":"concyatt@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741614458/c93886df9237f4800d4fdefadf06a57d-1730302640"
  },
  {
    "email":"marilenadintrono@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741647226/86cd91c911063b5b5a755d12e6bfda1e-1730302640"
  },
  {
    "email":"danielacampanini22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741254010/fbc0d95933666e64bbc09ff3533134b8-1730302640"
  },
  {
    "email":"giaval17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741679994/ec5e7e2a42cac5010609adcfb5f3e5dd-1730302641"
  },
  {
    "email":"chiara.galli07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741745530/ba023109e568016c35b67ba957348ef5-1730302641"
  },
  {
    "email":"antoerc66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741778298/4538be9f26af93c6d2741534f258b191-1730302641"
  },
  {
    "email":"franca.to2010@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741811066/217bff4b6fd87421704c71d03b443fa6-1730302641"
  },
  {
    "email":"marina.chiumeo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741843834/d5b40e879bb99f8fa166612b44ca27ba-1730302641"
  },
  {
    "email":"cohpatrick@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741909370/36d982de30f9e88daf5afd46aa223b13-1730302641"
  },
  {
    "email":"petruccicri@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723741876602/89bfa40379df63ecfa0172dc1c712d5b-1730302641"
  },
  {
    "email":"edilia.salustri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723741974906/16bd1cc49578f8057d278a5b8dde5de5-1730302641"
  },
  {
    "email":"clavini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742007674/5835c05d18b9c01f4190c65313baa9ef-1730302641"
  },
  {
    "email":"e.gianmoena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742073210/e6b232d33f8a65c6d964ad122a3181a8-1730302641"
  },
  {
    "email":"chiara.zanini.88@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742105978/fd7a8b1f22642f4be8dc2f6a133cfdaf-1730302641"
  },
  {
    "email":"barbara.pensa@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742138746/e3f171f88837254d81adfff7b19c8c17-1730302641"
  },
  {
    "email":"rosella.minghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742171514/6fce8fa0281a0359141f0b2e148dde30-1730302642"
  },
  {
    "email":"esterfer73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742269818/83d70b02906fc0de1c43000f7e2f1abc-1730302642"
  },
  {
    "email":"kiwetto88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742302586/85405c6fe82eb740c97443c11c8aaa22-1730302642"
  },
  {
    "email":"sonia.toso.sindoca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742400890/9a2d531ed95412610246d89ff1f5e935-1730302642"
  },
  {
    "email":"tiziana.paglini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742368122/764288e45f6d71f7604b5df911d95021-1730302642"
  },
  {
    "email":"anamuj85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742433658/b1478e5be52aec13a366db1e2a4fea14-1730302642"
  },
  {
    "email":"eli.2009@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742466426/ee9738c0da04270ca1a55e4e875e269e-1730302642"
  },
  {
    "email":"desiree.cianca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742499194/3e80f1afc6099b8fc2f18dc0c583e16d-1730302642"
  },
  {
    "email":"f.c.wolf@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742531962/ebe04fc7aa446be77f78024d3a90e9e3-1730302642"
  },
  {
    "email":"ciciriellomimma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742564730/a0787e34e224c6dfdbd9dcb3ee8136d2-1730302642"
  },
  {
    "email":"giopenta2011@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742597498/586b7879ae40e14a4bd6102d67d709a0-1730302642"
  },
  {
    "email":"silvia.khachatourian@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742630266/2e02be996dd7f097669cfee5c50e43e4-1730302642"
  },
  {
    "email":"icarolina@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742663034/c74c920550ff76c268293833844d7919-1730302643"
  },
  {
    "email":"simonadelume1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742728570/5e2554a2911fe2e435a3b0451744824d-1730302643"
  },
  {
    "email":"la_laf_@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742695802/40029e62fa3335d2b8babe04a8864c8b-1730302643"
  },
  {
    "email":"flavia97thebest@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742826874/c761340e989e8bce7b615214138b95c7-1730302643"
  },
  {
    "email":"ba.campoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742761338/755cd24c23fcbeaeb9d1865a06f7d4b4-1730302643"
  },
  {
    "email":"gentilangela69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742990714/a86ef32e74cb786500fe0ee0cd8f7443-1730302643"
  },
  {
    "email":"newyork.miky@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723742925178/62201a8f09f82b320813e74c608e51a5-1730302643"
  },
  {
    "email":"antonellagiraudi.1107@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723742859642/f177373d8730cc69b02bb0bc7e0e8271-1730302643"
  },
  {
    "email":"lindabraggion@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743023482/ee69ccbb38f7517c900671880b9d72be-1730302643"
  },
  {
    "email":"mail.ale.grassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743121786/814a9c6089a8106276a77613e162c0fa-1730302643"
  },
  {
    "email":"tiziana1473@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743056250/31cf8199afdc2013407e3a15f69a45c8-1730302643"
  },
  {
    "email":"m.graziazoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743252858/b2a298edff16d84f2d09f4e153bf586a-1730302644"
  },
  {
    "email":"simreb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743220090/4572ad6a08a24010da7948f3cd1bd53a-1730302644"
  },
  {
    "email":"manfre.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743351162/5ee8823282465e1727ebc7908a6e5d28-1730302644"
  },
  {
    "email":"luisa.danieletti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743318394/8404d4388554f467f80f7895d275bbfd-1730302644"
  },
  {
    "email":"frapiz75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743547770/9b1d21f54897c4e3ad98afddd421edd5-1730302644"
  },
  {
    "email":"r.usai@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743580538/f011da688776fe8a7361e516ca07492f-1730302645"
  },
  {
    "email":"clementinalugani@yohoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743449466/e0e384bf06e12473a7c2d5a29d4ad2a0-1730302645"
  },
  {
    "email":"irene.mencarelli@bancamediolanum.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743613306/4b9d568f3039523d4481b67815d21e4b-1730302645"
  },
  {
    "email":"fabriziatelesforo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743482234/4ec08ee94dd2cad0977fd481ecb3ac6c-1730302645"
  },
  {
    "email":"lucatombari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743646074/716cdbedf4ed6934f8662c2493436d58-1730302645"
  },
  {
    "email":"sacolla0206@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743678842/82f760ff0c998219d03b10388ca198de-1730302645"
  },
  {
    "email":"roviana80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743711610/f01b0d26ca176c3800f89d76c6f9dcdb-1730302645"
  },
  {
    "email":"mimina.leo92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743744378/9f3ba7316b90c595290fb7b5987da384-1730302645"
  },
  {
    "email":"elena.benzoni.co@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743777146/a2375fb336cf3dddd4906b0b464b8ae7-1730302645"
  },
  {
    "email":"spatarorossella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743809914/703232eacc8bf8fc62e4ebad14da5a89-1730302645"
  },
  {
    "email":"alexabragagna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743908218/0f313cc8c43d39d49bc9f2724fb7001a-1730302645"
  },
  {
    "email":"zodebu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723743875450/24f0abd6a5acfa354fa08235c10910c7-1730302645"
  },
  {
    "email":"avv@rebeccarovati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743940986/b4bd70fa12dad6a333fd519b7147fd43-1730302645"
  },
  {
    "email":"marisvalerica48@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744039290/3b64965e55a7ebc276b0ab21dce70fa3-1730302646"
  },
  {
    "email":"mela.maretta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744006522/6e60f89fee0825576f5893b8d47f5277-1730302646"
  },
  {
    "email":"kriz581@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723743973754/de9b93a1ff397bd59d994390fe2cec8f-1730302646"
  },
  {
    "email":"paolataddei@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744170362/0ce68b0f8c557a672ddb69124db53b4d-1730302646"
  },
  {
    "email":"ritagiuli2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744137594/8d157b3e85cb00790e25d011016e70de-1730302646"
  },
  {
    "email":"laura.depeverelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744072058/94ea2466e0da6d69f063f5868d4c0e90-1730302646"
  },
  {
    "email":"giul.guido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744203130/b7aad1495ee3b5988b90767ed16dcc58-1730302646"
  },
  {
    "email":"martina.piccoli1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744235898/6f93512225676cad4c26d1be5bca23fb-1730302646"
  },
  {
    "email":"valentina.andorlini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744268666/29da203e85228290532a757d76da924e-1730302646"
  },
  {
    "email":"nadia.valmorbida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744366970/ad532758fe1bf2524069f63880a1eb48-1730302646"
  },
  {
    "email":"carla.giamminonni.tr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744334202/f27a9d033565a257d26577e1d8e317d3-1730302646"
  },
  {
    "email":"bocchisabri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744432506/63bcadf812640fa2f4eabe19d4043427-1730302647"
  },
  {
    "email":"susy@ingrande.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744498042/25283b5c730424d35d452b5d4a9b4b58-1730302647"
  },
  {
    "email":"aaaclaudia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744465274/92a6db597063b5d8c9f9f8d16e737c8a-1730302647"
  },
  {
    "email":"mariaguarnaccia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744563578/ae4124ade5ae8e35529f6994e3fb4ebd-1730302649"
  },
  {
    "email":"a.marchetti@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744530810/e186b9946ccc678aaa4a953aa71a4e4a-1730302649"
  },
  {
    "email":"narbuc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744661882/fc98de990798d4553be1b660bc8a371c-1730302649"
  },
  {
    "email":"leonella.vellutini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744596346/1e9e2a92731bbb37627becffd8226bfc-1730302649"
  },
  {
    "email":"francyleo82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744792954/1d4efeb6ca3a352c9c01f7ce73cfdcb7-1730302649"
  },
  {
    "email":"dalilagervasio2019@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744727418/89358b8ece936382ef14c18c5eb5f5b0-1730302649"
  },
  {
    "email":"beatrice.arrigoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744760186/db91e6e0682c4649f77bb6b633a01256-1730302649"
  },
  {
    "email":"luisella.corradini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744858490/9715779ef577bd7109bdabd1b582d112-1730302650"
  },
  {
    "email":"c.perlingieri23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744924026/658032763dd241830a154997e2944a72-1730302650"
  },
  {
    "email":"eugenianeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744694650/31ddb9b3399d4abe57fb43a3c5f52c20-1730302650"
  },
  {
    "email":"olmi1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744956794/fc8af2dbb8a7726151ef552ed09830da-1730302650"
  },
  {
    "email":"fany70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745022330/63c2e5b57eeaea0b860820c7676ec1b9-1730302650"
  },
  {
    "email":"moniapirisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723744989562/c13b99b56b61e58198ff7ec4e9d0d75a-1730302650"
  },
  {
    "email":"franchina382021@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745087866/96a5d7d3b292a9fcb0736c63209608ce-1730302650"
  },
  {
    "email":"francesca.pagnini22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745055098/197fb27ad0e489b2fbee50ebede965cf-1730302650"
  },
  {
    "email":"ste.corsi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745120634/0f0f8ed31d375765497839b4697570d6-1730302651"
  },
  {
    "email":"n.hoxha83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723744891258/8647252eb01caa7091efab0698168f30-1730302651"
  },
  {
    "email":"guerrierimonica1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745218938/f5c690e55c7ba07f1e807f7b9eca8ad0-1730302651"
  },
  {
    "email":"fedepolz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745284474/69f02b7b2da24de88a7dfe4959ce0f66-1730302651"
  },
  {
    "email":"carmen_stefaniu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745448314/9332049a30c6efefc2b56fe557acc849-1730302651"
  },
  {
    "email":"veronicanceschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745481082/229d30385f1088cdf6fa638212d06aa9-1730302651"
  },
  {
    "email":"barbara.dagradi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745415546/cc9efe38bb526b5009d96209c1ca6a43-1730302651"
  },
  {
    "email":"taveraslarissa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745186170/19a89565dbe68716c8dcef387d919a9d-1730302651"
  },
  {
    "email":"mariangelina.russo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745513850/9be71a9d58d2c56951b49434cba5c705-1730302651"
  },
  {
    "email":"chiara.iacucci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745612154/34343b4850ea0eb9c3e387312d5dfaeb-1730302651"
  },
  {
    "email":"dalessandroantonia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745579386/1fe5e0a020e0247530f451cd8066bdac-1730302651"
  },
  {
    "email":"ele.fratini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745644922/8957ce943962fa886be216ec84e41c03-1730302651"
  },
  {
    "email":"tiziana.lanza2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745874298/fe96b8cee71587be708af29d5e7be47c-1730302652"
  },
  {
    "email":"yuliya.sudzinko@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745677690/69955bf0e07fdeb94adcc7bbc319fd24-1730302652"
  },
  {
    "email":"cristinabalboni2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745710458/f390b8b375f1dae24abd14f1514efb7c-1730302652"
  },
  {
    "email":"manuelaseppi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723745907066/5290a406e10a186190c3f3c6af538aa7-1730302652"
  },
  {
    "email":"r.tartaglia19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745939834/d4e06d047a8f5bc323f4464851e1cc46-1730302652"
  },
  {
    "email":"valelicchetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746005370/83479bd25a99ae3be0a1200d77ed72c1-1730302652"
  },
  {
    "email":"mara.masini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723745972602/b4503e99e4cc55009a5fe5c0f1bb44c9-1730302652"
  },
  {
    "email":"c.nuccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746038138/3b570151cd586cc402c5f621ba860b52-1730302652"
  },
  {
    "email":"mascherina02@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746169210/72a4f60c541f1598ff0f6bdd0a4bba06-1730302652"
  },
  {
    "email":"lidiarovati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746136442/8c2cf6ce470f3e88c0e5bd9d5ebe42a6-1730302652"
  },
  {
    "email":"elenatolardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746201978/01761f4a765d84e7c8b1025b04ebe99e-1730302653"
  },
  {
    "email":"carlafiore99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746267514/66327542ee4e8668ab81b168f645e439-1730302653"
  },
  {
    "email":"margutten59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746234746/9e6b1d161b1283551f8140352f8d21ab-1730302653"
  },
  {
    "email":"irenestraga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746070906/eae77f2589fc04ffe3058c857bcfc883-1730302653"
  },
  {
    "email":"katia.grazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746398586/769188aef8091e7962129b0ab06e7082-1730302653"
  },
  {
    "email":"manunta.d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746365818/eaf581501692ba36a1d2adb12a102145-1730302653"
  },
  {
    "email":"melissa.fontana@afgn.legal",
    "url di attivazione":"https://verdissima.it/account/activate/22723746431354/18c9479093e848c3cf65a1b84fc824f5-1730302653"
  },
  {
    "email":"elenatombini3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746333050/b9b97e1685db10b42c4ad7e13abc9ab6-1730302653"
  },
  {
    "email":"elenapievani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746464122/3327ab481ebe878b90f510e9511670bf-1730302653"
  },
  {
    "email":"hellenallori@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746529658/5b2cb1be114159bb42cb8b85c87e145f-1730302654"
  },
  {
    "email":"natasciaregazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746562426/e2d0e94576b9106e3e2a7412863e6d1f-1730302654"
  },
  {
    "email":"emanuelacugini.70@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746627962/dd77e43f93a567c18a495e211f214af3-1730302654"
  },
  {
    "email":"kiarsmonte@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723746595194/909c90bed84a1bf6b851c6efd370c4a2-1730302654"
  },
  {
    "email":"dignanilucia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746660730/92057d38d988ec37c5b2df1bc6b20a4d-1730302654"
  },
  {
    "email":"flaviated87@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746693498/6c92c7f673c90a661cfce766cbd489f7-1730302654"
  },
  {
    "email":"marta.vezzani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746759034/04451f5772f96f2471627b0ec488aabd-1730302654"
  },
  {
    "email":"madeleine.rohrer@posteo.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723746791802/a31dd2deb2875d5b569af50eb7327b1d-1730302654"
  },
  {
    "email":"simona.tuzi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746857338/d213e0feed678430799d720d44d04ac8-1730302654"
  },
  {
    "email":"b.vagaggini@ao-pisa.toscana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746890106/4d387591500379fce4fd3d2d8fad54c2-1730302654"
  },
  {
    "email":"danigugli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746824570/9756b7fe4a10077bcc174eb6a2f57fdb-1730302655"
  },
  {
    "email":"mfalzea@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746955642/3ab4f31d8623e49d1db3655c0e36b4d2-1730302655"
  },
  {
    "email":"martinafonda63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747021178/971f6ba4f4acd6913171c25b052d32bc-1730302655"
  },
  {
    "email":"monica.mai@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723746726266/c3cff70798de475e8e4db742520fad1f-1730302655"
  },
  {
    "email":"miscoriastefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746988410/645fd34f343162362fd924fd8ba71397-1730302655"
  },
  {
    "email":"angelamortillaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723746922874/f807ef304b334102d857e8b815c9868d-1730302655"
  },
  {
    "email":"camilla.barollo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747053946/0ee39c6ca9294fa6a1908858b1b4e8fd-1730302655"
  },
  {
    "email":"silvia.bittolobon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747086714/2d32ef72bf2ed2cc84f60d72a197b3b5-1730302655"
  },
  {
    "email":"millybarba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747119482/e431f18e4949dfb2ef9b20385f093bd7-1730302655"
  },
  {
    "email":"pretty.margaret.sm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747152250/529d9bffcfe373def32b34408bbb820e-1730302656"
  },
  {
    "email":"cristina.cominelli1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747283322/1956a9b74330f662f753258559b3d08d-1730302656"
  },
  {
    "email":"rossella1172@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747185018/4bbfecf75a232268d738c628e51a7cc7-1730302656"
  },
  {
    "email":"cinzia.lazzarini@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747316090/eb62e5db7b052e6d394786a7d50f9334-1730302656"
  },
  {
    "email":"c.casini92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747479930/92f8fb68a7610b34f2497b9c5150ed82-1730302656"
  },
  {
    "email":"giulia.mm21@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723747447162/276c22330f8bb4df98c75f77c870a138-1730302656"
  },
  {
    "email":"gariffosimona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723747578234/7ed16e367e351ddb4090db677abc7671-1730302656"
  },
  {
    "email":"manuelamarcantonio2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747512698/b5a2ac6f205f5c34d687c2da2589c8e1-1730302656"
  },
  {
    "email":"veronicaviterale85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747643770/d7a8a114ef49ca477140d363ff5478cd-1730302656"
  },
  {
    "email":"tamara.ghelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747676538/3e4b3586c7f006ee940c3c8fa453bc63-1730302656"
  },
  {
    "email":"cialabrinia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747774842/84e6e79df8db559d7059938854d7e1b4-1730302657"
  },
  {
    "email":"lucia.scainelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747709306/b6ef1bdb140dfb0dd41c5267c1155598-1730302657"
  },
  {
    "email":"serena1301@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747840378/6280b48722d17ac4e766e8541a4d97e7-1730302657"
  },
  {
    "email":"valeria.deidda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723747742074/763e940dd7da050cadff39bbe92e658d-1730302657"
  },
  {
    "email":"mariarosaria.zito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723747938682/c231c16f32b1c2d7d8095c5f819038ad-1730302657"
  },
  {
    "email":"rosanna.nacucchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747971450/5dd6ac1834b70e1d96e294c6544be0c4-1730302657"
  },
  {
    "email":"danielaranieri.d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723747905914/43e38a586c990a0c6a4b91c6091f73c3-1730302657"
  },
  {
    "email":"maccarini.valentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748004218/735cd613d3ae865b7e119385883049d2-1730302657"
  },
  {
    "email":"p.sabbatini@costruzioniminnozzi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723747873146/6cd8b50d431a69605ed6a4ecc4da64de-1730302657"
  },
  {
    "email":"rosita.miglioli@mediaset.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748069754/8ee3280fe71a4e7087e5f1c2a6bc9ec0-1730302657"
  },
  {
    "email":"micky.congiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748102522/445592febfa37d0eb762dd2ae6326a2e-1730302658"
  },
  {
    "email":"paolapetrucci76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748135290/f87162578a8bc0ebc0baad1b3de013b7-1730302658"
  },
  {
    "email":"giusymassaro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748266362/9ed8ae80ed075fecc83398e6254a7690-1730302658"
  },
  {
    "email":"salvatore.sardelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748364666/ae70eb5a4cb2eb9c59d2ff3c02e3db3f-1730302658"
  },
  {
    "email":"danci.dorina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748331898/021b9d26af483eb46d680b54b7b3d304-1730302658"
  },
  {
    "email":"annamariapieroni13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748036986/94f316f0b48f846939a7a40c394be06c-1730302658"
  },
  {
    "email":"barbal64@libero.iti",
    "url di attivazione":"https://verdissima.it/account/activate/22723748397434/f6b967fa57281506b8ea13c75008e7f2-1730302658"
  },
  {
    "email":"luisa.repossini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748430202/1a8f6c2cc416685a0aafd785e0c4f149-1730302658"
  },
  {
    "email":"saragall@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748495738/7d146acc3bc9e629d825ed9f7599bc5f-1730302658"
  },
  {
    "email":"adrianarusso7227@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748528506/34a09e99de9f792a1a7e87c69d6d9c41-1730302658"
  },
  {
    "email":"giancarlo.ribaudo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748626810/b59c652296a76c149697f6ddde8b0c9a-1730302659"
  },
  {
    "email":"deborahaliani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748692346/e0f226f51808c9690d1d35c9e3ede8c3-1730302659"
  },
  {
    "email":"claudia.buccella@siel.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748659578/f36b5fc7114a8ff712403011a937dc9a-1730302659"
  },
  {
    "email":"diva_srl@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748725114/cbc5cfe6be78d9201b89e3bf050b3a2b-1730302659"
  },
  {
    "email":"matera312@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748561274/7bcf727acb2db569b4d7a2750d74f3f3-1730302659"
  },
  {
    "email":"annamaria.sberna@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748823418/e24176152cbf7547c7e785ec8a374abb-1730302659"
  },
  {
    "email":"mv.desimio90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748856186/7431c217e0aba0ee63323116b6818c99-1730302659"
  },
  {
    "email":"laurag68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748954490/e625daf265626bd5a4b31a47ea8f5e1b-1730302659"
  },
  {
    "email":"ilarianannizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749020026/8abf6972425dd1f85abf07ab6764f840-1730302659"
  },
  {
    "email":"mariella@italotrasporti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723748921722/a2635525937c5ec9d94ab54c04c36c92-1730302659"
  },
  {
    "email":"adelinadiedoardo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749052794/b4081458fbd37f2ed075b2a40ca362cb-1730302660"
  },
  {
    "email":"celebrucs@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723748987258/f6a5fd42a5ddc37a2f2cc0abddc7714c-1730302660"
  },
  {
    "email":"annacigarini9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749216634/e8797643471882f693d0a60069b7b442-1730302660"
  },
  {
    "email":"dilettamp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749183866/f0b81d6b8fa14ee6b39df5843c8c71e3-1730302660"
  },
  {
    "email":"info@molinosantantimo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749249402/f70ec26e8fffe7d0b75980db9aca1ded-1730302660"
  },
  {
    "email":"t.pittello59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749314938/862c33bce023237c8d0bb095b156bf67-1730302660"
  },
  {
    "email":"chiara.manga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749380474/521234db9cf316e7d2f5ceb5e6eb6a01-1730302660"
  },
  {
    "email":"iside_19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749282170/03ebcb46913f9862967b95926efd8deb-1730302660"
  },
  {
    "email":"gualernil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749085562/eccf28a98e2776161dd3d947d9b2cc47-1730302661"
  },
  {
    "email":"francesca.cricelli11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749413242/ba97bd34ec2a59d71165b56e8f119205-1730302661"
  },
  {
    "email":"steveazzalin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749577082/7c887b7666c4e03caf36528e3c2c5c85-1730302661"
  },
  {
    "email":"antonietta.mezzalana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749478778/6019b7954c67ebcf29aa8c4c5dd3a159-1730302661"
  },
  {
    "email":"agenziafoodservice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749446010/a6dad848a86f2ecf3c5a0f746bce4ca1-1730302661"
  },
  {
    "email":"saramorotti28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749675386/080c327cc8b855b6bc7d7b5891f9f7ee-1730302661"
  },
  {
    "email":"avv.giuseppinadicrescenzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749642618/2c79d1770a38b0835edd847b33e48ea0-1730302661"
  },
  {
    "email":"pdonnarumma@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749544314/a5a4ce63c2e4b294d0ab51be9f62b5b9-1730302661"
  },
  {
    "email":"elisa.sabbatini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749806458/a38a55b62d55b19e444389754960bf5f-1730302663"
  },
  {
    "email":"michelamonella@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749740922/5a5f2a266cbdb97f2bfa584dcf8353e8-1730302663"
  },
  {
    "email":"nadejda.parigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749839226/bbc8d8d7a0cb1af1e608b188da596ae6-1730302663"
  },
  {
    "email":"manzi_elena@tahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749708154/79c849d891b9bb7d54fe4823d809c773-1730302663"
  },
  {
    "email":"laurasantagiuliana4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749904762/18085cc5ccddda575f858cdd3cd5f82b-1730302664"
  },
  {
    "email":"shohrehfakhr@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749937530/9a89201f4a130fddb3197593feec73c5-1730302664"
  },
  {
    "email":"lauraguasti17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723749970298/c20d0630e1a2ecf737701576d0ff1611-1730302664"
  },
  {
    "email":"claudia.galimberti70@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723749871994/30c50b0199e75e6c909610ffa4103cd1-1730302664"
  },
  {
    "email":"arianna.cipriani78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750035834/0e37c6ccb0af61633f4398aee5dc8a1b-1730302664"
  },
  {
    "email":"ovaleprenestina50@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750134138/6581aa33e7e5648956a27858e3995920-1730302664"
  },
  {
    "email":"silvia.caputo@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750068602/27b19b326f7ec7e1d5fa54304dad8b40-1730302664"
  },
  {
    "email":"a.solimando@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750003066/00577cf777bcfeaa47d3f0e2baf19efc-1730302664"
  },
  {
    "email":"elisa.morganti79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750166906/2b8c6d30702cf68cb9793ee67f39e2ba-1730302664"
  },
  {
    "email":"rossella_ganz@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750232442/fe58d9e502bffa9d23ce419e156fc4ae-1730302664"
  },
  {
    "email":"elycampione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750199674/4e848b97e71b0d2cdfe13e5c03e11b1f-1730302665"
  },
  {
    "email":"lori.au@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750330746/e996eae76718f9b756c57a8277be7935-1730302665"
  },
  {
    "email":"benedetta.ver@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750363514/27d3c454422080a62867466733dd5869-1730302665"
  },
  {
    "email":"nadia.crociati@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750396282/301d2f5633f1587aa89d78eec59c613e-1730302665"
  },
  {
    "email":"serenamori86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750527354/6027eb7b6590d02c5a55748b31612a85-1730302665"
  },
  {
    "email":"scosciapatrizia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750461818/957c47c913f9a4a88146e73c37a9fb40-1730302665"
  },
  {
    "email":"marianna.dagos@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750592890/3f9b032dac1be459f5d5fd40bb1c2055-1730302665"
  },
  {
    "email":"anna.amorosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750297978/753c73117c5d975ac3d73d34ef8366c7-1730302665"
  },
  {
    "email":"sarazzelle2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750625658/bce1bbb680ef02e56efda833a3306d0b-1730302665"
  },
  {
    "email":"saguatti_dile@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750658426/3f6486edb8f509762aeafa487e55a11d-1730302665"
  },
  {
    "email":"francesca_mara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750723962/0dd474e97f8f2035586cda30b1c97e45-1730302666"
  },
  {
    "email":"milenatoppetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750789498/b5e0fea19b79db90eace507e5e339cb5-1730302666"
  },
  {
    "email":"ritamasini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750691194/f7e73e414aba39dffe44ad3e29924e84-1730302666"
  },
  {
    "email":"nico.cardone2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750887802/d87d8ec12b73befa35974e8d1c0a0aa4-1730302666"
  },
  {
    "email":"m.dange76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750822266/e32b1e4b9d66c46b1720b3d235e68af0-1730302666"
  },
  {
    "email":"giorgio.inno85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750920570/b70084ea9691637ff75b497ef64b93f4-1730302666"
  },
  {
    "email":"deleonardis.ilaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750756730/507531cecd9ee5bace31b74bf9f255f2-1730302666"
  },
  {
    "email":"angela.geremia31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723750986106/b4b69b7be65ea4f77efc86b7499b0837-1730302666"
  },
  {
    "email":"valerisalva72@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751018874/d24838e5a0e82a94755d5c51288558cd-1730302666"
  },
  {
    "email":"irenedemicheli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751051642/1a70fffb68d07dc040e2db44e853f4a8-1730302666"
  },
  {
    "email":"avv.danielaragazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751084410/4ddb9dc5dbb339c502a20b82f3c3d946-1730302667"
  },
  {
    "email":"scordamary@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751117178/479c17791e245b9ecde4fb4d045ef650-1730302667"
  },
  {
    "email":"ceruti.rossella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751182714/79f0fdb0b3fae88747316404d6b536db-1730302667"
  },
  {
    "email":"valentina-deangelis@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723750953338/8adc761a7eca11b02eb59cf882e018a7-1730302667"
  },
  {
    "email":"francescacavallo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751248250/ecfe2b4d5f6c061c4a5866a58d8caa41-1730302667"
  },
  {
    "email":"annalisadilda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751281018/9e520b88e60c858818efcdd4001333e0-1730302667"
  },
  {
    "email":"clagala64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751313786/9539c67f0b6a403a1afc089f55addde3-1730302667"
  },
  {
    "email":"nataliatym@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751346554/25811fd7f7b59a2e575f852769c94ef4-1730302667"
  },
  {
    "email":"moiradilo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751215482/414beeb29f910aeedcd0cdcc50f47d6b-1730302667"
  },
  {
    "email":"marian.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751379322/cdf052108480a4d6da7b644d143c388a-1730302667"
  },
  {
    "email":"alessandro.deventura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751444858/6a091c556a183a140552163698585f11-1730302668"
  },
  {
    "email":"f.recine76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751510394/fb450e7d01a0f654f67ce496195b29e1-1730302668"
  },
  {
    "email":"giuliarossetto85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751543162/4cc799bbeb99520b6a95f352e6d5d9e1-1730302668"
  },
  {
    "email":"stellablu73@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751412090/18933b9cc7943046cb8a2d6a6508a7d2-1730302668"
  },
  {
    "email":"frucianom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751477626/f84a0ca6891cbf922603857e961af4bb-1730302668"
  },
  {
    "email":"kimberlydanza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751575930/9dc090b354a5c1625aa4ebcd8e553b7c-1730302668"
  },
  {
    "email":"spigolonelga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751641466/c0b2b0e64dfd6786fa193b62c405e0af-1730302668"
  },
  {
    "email":"gloria.iob@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751674234/97052b3945810aac9e043ec3b0958858-1730302668"
  },
  {
    "email":"melica.mari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751608698/d46809f67596369c7178d523c0eec9e8-1730302668"
  },
  {
    "email":"lucamencarini.snl@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751707002/4801494d8f228508cbc07d8968dc9d86-1730302668"
  },
  {
    "email":"ricky.studiolaser@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751838074/681624c2a3cabe9e1305fccd4b0f876f-1730302669"
  },
  {
    "email":"angy77bs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751805306/17436732cff5fb0c93611e37e17f6d21-1730302669"
  },
  {
    "email":"caramancini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723751870842/43f9f16527dfe5aea01c78c1373dc5ca-1730302669"
  },
  {
    "email":"cinziazerbinati5@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751903610/bc13c03f2d3c7dab11f21451d8cb3940-1730302669"
  },
  {
    "email":"paolavallermosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751936378/1e0b21b0f656d30e4bb0cf181e38fa5e-1730302669"
  },
  {
    "email":"sabry.usmi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751739770/29dcddff3b82b6b6ca33de6226b1aa8e-1730302669"
  },
  {
    "email":"fmarcella67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723751969146/17eb0c9c9fd085d3c8f5ca13a2e56e6d-1730302669"
  },
  {
    "email":"peterweger@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752001914/7d35063497d58a5b520703fee18f8827-1730302669"
  },
  {
    "email":"stefvigolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752034682/f7de982859b69619d7967027f62cf1b9-1730302669"
  },
  {
    "email":"serenadelsecco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752067450/8c9a1cce7b06d73376b1a8882592b5b7-1730302669"
  },
  {
    "email":"amaliarufolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752132986/6a8edeabcac6731be45b3b4c1a0dc427-1730302670"
  },
  {
    "email":"sarabena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752198522/1abc94b952def2e1b8283ca4733e14fd-1730302670"
  },
  {
    "email":"alessandra.piccioli@posta.istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752165754/52e3234db5ea5a7ac649036de301bdf3-1730302670"
  },
  {
    "email":"gemassetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752231290/c52524d18257da01121c027bb8d727cf-1730302670"
  },
  {
    "email":"carmendinardo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752296826/ddf43382c816fec1a5b666aba1a85602-1730302670"
  },
  {
    "email":"claudia@sarziamade.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752362362/f663f1daf086ef78998385588c7b815d-1730302670"
  },
  {
    "email":"bcstudio.iaia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752100218/90508daf8f36ce83b7da838adfa3cfaa-1730302670"
  },
  {
    "email":"varchy78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752427898/9466f3aff7d0a2b291523048b6980884-1730302671"
  },
  {
    "email":"pierangelo74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752460666/be4c0b13aa25c33d3ed3075c7444ff47-1730302671"
  },
  {
    "email":"focacetti.rosita@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752264058/549e21ad3dcb8b6136cd7e048bc6252a-1730302671"
  },
  {
    "email":"avv.milenalaghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752558970/56324632f54de1043f3c1f1a8ffbcd93-1730302671"
  },
  {
    "email":"vitarandazzo07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752526202/777a59a86b2de21089b53a9115d47842-1730302671"
  },
  {
    "email":"chiarabaldo79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752395130/08103c4bef14e9428479015cc38c650f-1730302671"
  },
  {
    "email":"francescabarazzoni1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752591738/23fe5e0ac84eead017c8d3c6d70cdd0a-1730302671"
  },
  {
    "email":"viviana.scampone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752624506/8a8fb012422d8bb6f0142a145d158b09-1730302671"
  },
  {
    "email":"ilda.vadini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752493434/1b08ad373117b658c9e041f63ddaea9b-1730302671"
  },
  {
    "email":"krikri1976@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752657274/fe8df505998b4a7f03d7dc7d2fbc0b23-1730302671"
  },
  {
    "email":"kunterweg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752690042/7f9024ce9713629bc406a3a9ae87397e-1730302672"
  },
  {
    "email":"enricamerli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752755578/1617bed3a903792b0d814e4ac1914512-1730302672"
  },
  {
    "email":"alecigno3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752821114/1d4e5656d9b045591087f85b6310937b-1730302672"
  },
  {
    "email":"patrizia.provinciali@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723752984954/10b434a9162e8fe26da116ca3b17de89-1730302672"
  },
  {
    "email":"federica.salvati@generali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753017722/e23799c00c998b9e947a0006dfdfc4d8-1730302672"
  },
  {
    "email":"rossanapanasiti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753050490/4fd469d76a1692b425d6b37943836166-1730302672"
  },
  {
    "email":"roberta.marchili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752853882/8ec45345a78fb961c9ac3e9c18fca2f3-1730302672"
  },
  {
    "email":"claudiacaroti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753214330/a3e6f60446ef1e5198a79606993745eb-1730302672"
  },
  {
    "email":"ma74.paradiso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723752886650/15c3ff3263187db76c2b8347d64de6ca-1730302673"
  },
  {
    "email":"cristinaromeo1004@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753312634/f92d3c64cc606fd3f598828cd9434f10-1730302673"
  },
  {
    "email":"roberta.vasile11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753279866/394c436fe92e91278036e0dc7a65a2d5-1730302673"
  },
  {
    "email":"f.serafini@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753247098/6dd8add3858bd4e197f386f9680e483c-1730302673"
  },
  {
    "email":"commerciale@eurofrigor.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753345402/25b31ec0afcbe72666ba8335fbc89f6e-1730302673"
  },
  {
    "email":"silvia31@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753410938/f361791850ced3122d0ae8a73fc56eda-1730302673"
  },
  {
    "email":"paolavignoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753443706/4805d05d379ad6d7de6ffe7df6761288-1730302673"
  },
  {
    "email":"gazzinielisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753378170/8d8a859fd67d78baa7405b4305484eaa-1730302673"
  },
  {
    "email":"amirante.rita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753640314/4c2586430b1e4d8ca463d8ee575b0111-1730302673"
  },
  {
    "email":"silviabigliardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753673082/a2b9268474cb520a1222a64bcc111efa-1730302674"
  },
  {
    "email":"giorgia.cipriani74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753574778/9c1ea4a955d3516b413564ab27ca6d61-1730302674"
  },
  {
    "email":"dittamiceli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753705850/9ca4dff24679926065859f94bf90e8bf-1730302674"
  },
  {
    "email":"giorgiadivita@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753607546/23841a3048ded33153ac2b1190dee484-1730302674"
  },
  {
    "email":"rosadesimone64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753771386/9b729bcbc49fe47a3ab7dcfceee9dbb3-1730302674"
  },
  {
    "email":"anto.raso72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753836922/e60a70a9684425a83474314efcfa61a2-1730302674"
  },
  {
    "email":"karin@chef-italia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723753738618/90809630c81dda5359aaf10cc506608d-1730302674"
  },
  {
    "email":"genoveva.ambarus@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753869690/c1ee7719413330cda9f284b34b893a87-1730302674"
  },
  {
    "email":"uluffa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753902458/264b2a1e4dc620dea8d86852b6a68cdc-1730302675"
  },
  {
    "email":"giadadallara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754000762/e135ffda3b1261a1b9bcf3455aacaa2d-1730302675"
  },
  {
    "email":"rossellabarbiero62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754033530/9373bd11e2c4a9549b2dfaa5ac345d3c-1730302675"
  },
  {
    "email":"marta1982@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754066298/cde8ec964a12ef35dad315d02be94307-1730302675"
  },
  {
    "email":"giorgia.acerboni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754164602/f2726be89aa71a804d674fc5ffff68d3-1730302675"
  },
  {
    "email":"alessandra.spagnol@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723753967994/3ea2d8f81937ea7bb03838c33bd00f25-1730302675"
  },
  {
    "email":"anette.seppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754262906/5a4e954a6c050a5560ea7ea1d27c2bc3-1730302675"
  },
  {
    "email":"emanuela.nici@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754197370/685ea4ca215b602ae6a3edd69f152185-1730302675"
  },
  {
    "email":"kele101@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754295674/9346c956461178abb68fa9bc22359d1c-1730302675"
  },
  {
    "email":"maurodellacostanza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754131834/0577e06b0a2bd6d081e6fe98eaa4db52-1730302675"
  },
  {
    "email":"daniela.sabelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754361210/276a7e415b88d96b3b9c06fbc4be27ac-1730302676"
  },
  {
    "email":"lorepiras@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754328442/c632781428488577ddf82f58c8b9c352-1730302676"
  },
  {
    "email":"newvogue.montagnana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754426746/0de969bf15f4145763805e59601ae62c-1730302676"
  },
  {
    "email":"rubina4.mail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754492282/3f5fdeb5a80e004bfcaf6a6fb723bec0-1730302676"
  },
  {
    "email":"claudia.reier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754525050/7d7f87bbb9f57434d6a7580979262f06-1730302676"
  },
  {
    "email":"elyrinaldi23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754557818/5a011a92f345e9ead33187ae6f0e8d56-1730302676"
  },
  {
    "email":"comigroupsrl@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754393978/a60a0af7457b4e2b0d74530fe0bc0b59-1730302676"
  },
  {
    "email":"veronicabianchi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754754426/085e1d6c4ac39146e8e3976d4714df63-1730302679"
  },
  {
    "email":"carla.garioni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754623354/ccd36e68ad83afaac07e9b1f52c87a5e-1730302679"
  },
  {
    "email":"grazianasavarino1@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754721658/ab8a561cad3961798075fd714ffc82ce-1730302679"
  },
  {
    "email":"martilola7072@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754688890/b042faad428d1a46c88d5fb2492d6f99-1730302679"
  },
  {
    "email":"rosy.vento@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754852730/80191b8a3ce298bfd9490c810aab026b-1730302679"
  },
  {
    "email":"claudia.nanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754885498/2de590ae3516a37f739a10486e16f6a7-1730302679"
  },
  {
    "email":"giovanna.andreoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723754951034/41198d0c9efda9061a7556b7115c44b5-1730302679"
  },
  {
    "email":"siviorlandi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723754983802/dbbd654838032ca3afbf79ff87814a70-1730302679"
  },
  {
    "email":"vittorianazucconi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755016570/9a0d74d7865a85ba052ffea36e294adb-1730302679"
  },
  {
    "email":"silviamariamalagrino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755114874/6a8b142c665eb080011e3e8e8665871a-1730302679"
  },
  {
    "email":"luminati.laura63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755082106/6f56cba0429ab9cf2e3ca1efd8939015-1730302679"
  },
  {
    "email":"carlamv.bruno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755180410/dd2a21a3968006254d9d15d419eb3ae0-1730302680"
  },
  {
    "email":"mariarita_71@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755213178/f765a1ca537906d84f71a3d3ac50adce-1730302680"
  },
  {
    "email":"angela.roberto2012@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755049338/5b985cd152d56a09610a3b4453c8da5c-1730302680"
  },
  {
    "email":"caponera.alessio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755147642/8f2b5600ababe4a8ec5e06e08b3b1eb4-1730302680"
  },
  {
    "email":"loredana.recanatini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755311482/14a9873802f51853d23a9d46f5a685c8-1730302680"
  },
  {
    "email":"pdermo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755377018/994dfe6e1f6ed15754c63af5f9a1ea16-1730302680"
  },
  {
    "email":"khaole.hassan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755344250/3077e66a4afa74d0ea78af34687cd017-1730302680"
  },
  {
    "email":"alessia.mt@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755409786/b460d70893607b552c73a3a648b44bc7-1730302680"
  },
  {
    "email":"daniela.ene@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755245946/bb833784e0e65aa69f0e139e4e798ff8-1730302680"
  },
  {
    "email":"simona.scibetta@unikorestudent.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755540858/b8f414befa754306d42bf9804e38900e-1730302680"
  },
  {
    "email":"titabb978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755573626/e947a05c1124c4b6b998827c59c9e1fb-1730302680"
  },
  {
    "email":"seialaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755671930/6f00173aba55df8f409bba5126b79c10-1730302681"
  },
  {
    "email":"ghibertoelena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755704698/96a9a31326f018357f0e91fdc04c5d37-1730302681"
  },
  {
    "email":"monivalery.80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755737466/ac96f062506aa9c587f39827f855b12a-1730302681"
  },
  {
    "email":"dilello.loredana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755770234/2f8278294c0ce6b833b05de322d7f9f8-1730302681"
  },
  {
    "email":"simonausardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755639162/4a6f456fe1a10613697266d646383112-1730302681"
  },
  {
    "email":"silvia.15.fontanesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755868538/c980ff57deb868f393e3a4a47d11e9a1-1730302681"
  },
  {
    "email":"scarpellifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755835770/1cb5629b5f414f34dd104b2e08b27f26-1730302681"
  },
  {
    "email":"simonabramato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755803002/4947ac2611bc4c848c6a623cc699c635-1730302681"
  },
  {
    "email":"luikerry@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723755934074/932f4a639beb9969624d0a7cfb3b2706-1730302682"
  },
  {
    "email":"sabrinacannella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756032378/ecb027e3d24db1e6bf751055ef08f26e-1730302682"
  },
  {
    "email":"simobruzz69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756065146/ff535e74e9e7fe30cfca90262f3baaae-1730302682"
  },
  {
    "email":"patrizialucarella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756163450/cf5db784784a8b74c8f19f6bf4fa0065-1730302682"
  },
  {
    "email":"antonella.ravelli.ar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756228986/cf6688d3b141c3bb81f9209e5c5b6f84-1730302682"
  },
  {
    "email":"micheladuiz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723755966842/e9226c868b5d50c18e3bb2bd878b4f5e-1730302682"
  },
  {
    "email":"molly.argo6@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756294522/9dc0600c328eb7bf16c0e90d60ba82fd-1730302682"
  },
  {
    "email":"elisabettacammelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756327290/923cde6369fb35c2b08fe349262f65ff-1730302682"
  },
  {
    "email":"bantonini775@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756261754/006b74289aa6553473140415478283ec-1730302682"
  },
  {
    "email":"annalisagiorgini0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756360058/f3b00ec3e64253ffbc680e8e73e73d45-1730302683"
  },
  {
    "email":"mimmofrac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756392826/1fb0dcda251c9d739d2aced3cb2e81d6-1730302683"
  },
  {
    "email":"catiuscia.zampieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756458362/574f4663e23526467f61834b88cec127-1730302683"
  },
  {
    "email":"storacev@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756491130/eb45155c672016e06982294eda85f7de-1730302683"
  },
  {
    "email":"serenellad.stefani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756523898/a1a09ac781886364bc1f41f2775694a6-1730302683"
  },
  {
    "email":"barbara.guidotti.bg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756556666/9f4f27d1233ac4ff99fc9cce5776ed4f-1730302683"
  },
  {
    "email":"eleonora@studiodonatiweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756654970/87dbb26611e8c0d661025bcb382c2a61-1730302683"
  },
  {
    "email":"lisata6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756687738/247f62719a8e946da676620ed596be2f-1730302683"
  },
  {
    "email":"m.collari@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756425594/0d5df970a30745b4a2168373df646be2-1730302684"
  },
  {
    "email":"nicitagiuseppina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756720506/fa6af1de292421ff3c320d1bad5f3166-1730302684"
  },
  {
    "email":"patri.gragnoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756622202/2de497e233d24a0e588425237620b85c-1730302684"
  },
  {
    "email":"laura.paoli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756753274/ef946973a5db45aaf6ef632262019c66-1730302684"
  },
  {
    "email":"alessandra.amato41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756786042/031cb9e619abefb74eeca1e05cefd1f5-1730302684"
  },
  {
    "email":"francesca.thinkofilm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756818810/f948c877ce1b06df4273ea029d75f7d4-1730302684"
  },
  {
    "email":"elenina100@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756851578/bf1135890256cf99c38cb07404bcdb08-1730302684"
  },
  {
    "email":"alessia.arzani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723756982650/8a8e9c044f8aa920de2560eed346e93e-1730302684"
  },
  {
    "email":"avvdebspinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723756949882/de05bdadb041146442144f7ce54e14da-1730302684"
  },
  {
    "email":"alessia.fittipaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757015418/59afe69668cb5051dea619957bbe58f6-1730302684"
  },
  {
    "email":"sissi9699@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757080954/e88198c94158b74c3cd6e2e990ebc3fb-1730302684"
  },
  {
    "email":"linablume62@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757146490/298d1dd2c198d01d4660f8e2f27939f5-1730302685"
  },
  {
    "email":"avv.claudia.ricci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757179258/b78deb4f1376e2cd42bcc706f0311cfd-1730302685"
  },
  {
    "email":"gmaselli@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757277562/6dd64bd6aefff2e8345de5091c1803f4-1730302685"
  },
  {
    "email":"pgiacosa@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757244794/250b10145a47a7699182a72323008afb-1730302685"
  },
  {
    "email":"mariangela.frasca@generali.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757310330/275e7138ef4d60bded1d34cd213f53aa-1730302685"
  },
  {
    "email":"annapugnetti8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757343098/e4485b31879c337635e1ea0fd57afa5f-1730302685"
  },
  {
    "email":"paola.barresi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757375866/9cf923814458bdad9ab762dc13b22b6f-1730302685"
  },
  {
    "email":"cerdellialessandro@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757408634/d21c9368d66e97008115a74bae50c4bf-1730302685"
  },
  {
    "email":"conciv72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757539706/9e9c60719f7227a607686bf1ec81e6cd-1730302685"
  },
  {
    "email":"francifallavollita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757506938/8394790b7dfec6438ef38748a5b5fcd5-1730302686"
  },
  {
    "email":"romy.bof@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757474170/a34c470e6f6de8ff18ff0bcf884cbe60-1730302686"
  },
  {
    "email":"luisannacrescenzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757572474/6bbe8fe154c9860c23fe86ed9d40d5eb-1730302686"
  },
  {
    "email":"paolagamboni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757703546/7dddaee78609554e19f31a799568604a-1730302686"
  },
  {
    "email":"cinzia.esposito64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757441402/4857f149876280bd551555bcef52df5b-1730302686"
  },
  {
    "email":"rella.anto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757638010/316e2ebd6020768c9e9d1838125ca907-1730302686"
  },
  {
    "email":"ipazia19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757605242/a37bc3d9f7fcaed0748340ca9f1feb9d-1730302686"
  },
  {
    "email":"grazia.arena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757801850/f7085fa01e493a7d805f0a5e891af1a7-1730302687"
  },
  {
    "email":"premluna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757769082/9da33d371b53a9d6888d2a2ea9321dcc-1730302687"
  },
  {
    "email":"antonellacalcagnile@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757834618/c23698dab9f98848d76f1a89fca17377-1730302687"
  },
  {
    "email":"camilla.roffi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723757736314/d0b983317ad1dc32b2c43e3013f2c016-1730302687"
  },
  {
    "email":"stefibrianti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757900154/826146820730a15dda9e327a22dcc649-1730302687"
  },
  {
    "email":"ferralice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757932922/55f2c8579f793c88ef05bccc1f44b6ac-1730302687"
  },
  {
    "email":"cinziagaleotti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757965690/cac9d78b71cc3859a9b26090972847d0-1730302687"
  },
  {
    "email":"elena.cairoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757998458/5589f77401f861e734553d4a74777f41-1730302687"
  },
  {
    "email":"diletta.lepri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758031226/9baa1e7e9281cdbb982ea6e359efae24-1730302687"
  },
  {
    "email":"casatimanuela@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723757867386/1c4ab234c59fe56e3b8fa438b2225eeb-1730302687"
  },
  {
    "email":"chiarasonnoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758096762/d839b015b2af479a17d5e2f0ce6ce427-1730302688"
  },
  {
    "email":"seadolphin67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758129530/a8e6f734a36dc27fb37399f23f189f65-1730302688"
  },
  {
    "email":"gretanegri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758063994/a6593acb3cdcdbf70548afdf69623f1a-1730302688"
  },
  {
    "email":"claudia.orsolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758162298/9475329b109209f0c2884ab9eaf2ef1e-1730302688"
  },
  {
    "email":"f.venuti@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758260602/ed045e53dcdbf9df8aba017664051b23-1730302688"
  },
  {
    "email":"graziact9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758293370/fb973d6372a6fd5c51d520ec54dfaeaf-1730302688"
  },
  {
    "email":"betty.fraschetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758195066/a92024484ec05dfeea4b177ae15f7423-1730302688"
  },
  {
    "email":"sonia_zangoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758391674/1dbdc21310a97a3c86327ce3fe381dd2-1730302688"
  },
  {
    "email":"architettodanielacalabro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758424442/e239725468e2eefd840885ba091c2710-1730302688"
  },
  {
    "email":"sonia.buffa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758555514/83d6a582f9c3a1e935009b376ebcd882-1730302688"
  },
  {
    "email":"paolairenepajetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758457210/08e8042ac3c0d91823a8a520e25f59e5-1730302688"
  },
  {
    "email":"devito.valentina16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758588282/6c9ab1cf43f4bee05cf6c0018d60dc41-1730302688"
  },
  {
    "email":"veronica.mondelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758686586/d0ea1218c8a48a7c19e4d5588289534e-1730302688"
  },
  {
    "email":"elysa_padova@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758719354/c787e30f0b5be7ce5f65996bb6c8f0ab-1730302689"
  },
  {
    "email":"artemidedanza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758752122/3f640ac3ce7c2fbf4006a537c731d5cc-1730302689"
  },
  {
    "email":"anna.manzolaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758817658/63f7a5e4e2a4f5d224be251fd3380ec0-1730302689"
  },
  {
    "email":"silvybalducci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758850426/015ae9e592ce798fb53ba38577a80155-1730302689"
  },
  {
    "email":"raffaella.bellitti71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758653818/8b9a30828fa557cd1a118ce7250c1cdc-1730302689"
  },
  {
    "email":"lorenamigliore07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758948730/2676e4addb2498f3d165a318be8e1959-1730302689"
  },
  {
    "email":"noemi988@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723758981498/135721d77ae59d49809008f4e707c1ae-1730302689"
  },
  {
    "email":"iole.coccia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723758915962/2cb62206035a9394303b7363628ba643-1730302689"
  },
  {
    "email":"m.perathoner@unrwa.org",
    "url di attivazione":"https://verdissima.it/account/activate/22723759047034/b5cf2811fd496c8b24a196a992e0bf94-1730302689"
  },
  {
    "email":"cinzia.ferrali@moreno.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759145338/48afcab0d9ca6df15efe3291ec797bf4-1730302689"
  },
  {
    "email":"gsonia.sorrentino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759276410/9995f66d3ef516518c6d100f6b4b7457-1730302690"
  },
  {
    "email":"elena.dalcanton@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759243642/ff19b13198d7db234fac4cad786b3f38-1730302690"
  },
  {
    "email":"buonoelisa10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759341946/27154fbebcc8677824d5d3e57ef2fd67-1730302690"
  },
  {
    "email":"annalisa.manzoni@it.nestle.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759407482/3dbcb41a26262658ac9b4a5afbca4bfc-1730302690"
  },
  {
    "email":"gracearca72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759178106/c4373dba2e0b55931c31e807c70325ba-1730302690"
  },
  {
    "email":"grazialive2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759309178/b6b84dd05dd69f9af9c8871c31325398-1730302690"
  },
  {
    "email":"anna.sommariva@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759473018/f08c3f1582291694ebd668ea8a2523a7-1730302690"
  },
  {
    "email":"lapatty.tv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759440250/24c52a4aa1099134930f73f763a5e468-1730302690"
  },
  {
    "email":"antoniaprotopisani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759571322/0be978467b1a615c6c3eee0d61f39404-1730302690"
  },
  {
    "email":"catemarco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759505786/82d1258d89d87e05d4642587b6c8e3eb-1730302691"
  },
  {
    "email":"christian.pixner@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759636858/164ef791d1aec5dc6411d4f6c17f8c3e-1730302691"
  },
  {
    "email":"i_am_tata@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759669626/cb53f0bbba57b80d4fa64c4da4c748ff-1730302691"
  },
  {
    "email":"francy2697@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759604090/1945c7a54efaa7793822b31c626640d6-1730302691"
  },
  {
    "email":"manu.pescara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759899002/64e54cdaceccf52c26805d144cb3db85-1730302692"
  },
  {
    "email":"mardigi74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759767930/f540b94f1cb84ff0eda0b8d5c2abf5d8-1730302692"
  },
  {
    "email":"silvia.tagliavento@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759800698/adfda0c628c8c8d944b427ee58a9adeb-1730302692"
  },
  {
    "email":"marianto.acquaviva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759735162/b50799c9ebf0348c6810f8789805d31c-1730302692"
  },
  {
    "email":"fabioansaldi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759931770/e08f5e58a446b6fa7a313b0babb65510-1730302693"
  },
  {
    "email":"marinacapecce@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723759997306/54a7538cd39e77378bfac61d672ae772-1730302693"
  },
  {
    "email":"tere.raimo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723759964538/db6a9d968a2bd53f3e9f0092fdef8e45-1730302693"
  },
  {
    "email":"simonafantoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760128378/a6f1749131eee59a44cd0b906250d195-1730302693"
  },
  {
    "email":"cristina.demarchi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760062842/9d970cc8a3354ca0bb8807985c6bb62d-1730302693"
  },
  {
    "email":"alessiac.85@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760095610/409d7fdd1f4473c6ebdbb0603f7dc074-1730302693"
  },
  {
    "email":"cancellierecarla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760193914/229eecfd845cd21c1c1a460d873c757c-1730302693"
  },
  {
    "email":"pacifici.francesca82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760161146/a06c30edbb9f0fba65bfc59fc7748a1f-1730302693"
  },
  {
    "email":"nikifer65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760324986/42571a9a67149d8b07d95ea05260fccd-1730302694"
  },
  {
    "email":"nadiatoscano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760259450/d9b350184b7720f8425d09ed395008fa-1730302694"
  },
  {
    "email":"nadysim@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760488826/9cd9d34d7ee5189ff1cf3475b82ee7bd-1730302694"
  },
  {
    "email":"vaninsilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760292218/6f9c0468ebfd13334491ecce5b2bb616-1730302694"
  },
  {
    "email":"giusyparrino21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760521594/80fb0c3e65540d7e92c8190dc43e511e-1730302694"
  },
  {
    "email":"giovannapizzanelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760390522/f1c01e61fd63e739f040e4dc1000c40f-1730302694"
  },
  {
    "email":"lexamarkou@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760587130/64a48df43b4e667fa5a5a3d5f92b5f35-1730302694"
  },
  {
    "email":"biedi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760554362/81da2fc6d2a2d9ac881c855351ac7e05-1730302694"
  },
  {
    "email":"labotek2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760750970/c33a42a316dbfc00b0ebf16503a1ecbe-1730302695"
  },
  {
    "email":"patrizia.demi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760619898/07a6681eb4599b7132710f253c6cbaa2-1730302695"
  },
  {
    "email":"ciliegiaviola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760718202/2a10cabfa2c35090985478d3faf0b154-1730302695"
  },
  {
    "email":"emabrb@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760652666/533e1ab2a74a717977e8c78400de6df0-1730302695"
  },
  {
    "email":"mara78menino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760783738/c27ab578edda4d33f3e3d3cf3f413d1c-1730302695"
  },
  {
    "email":"valebasso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760914810/f49e62885300f76d6b4c0eb4d49a7b6c-1730302695"
  },
  {
    "email":"chiarasaracco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760882042/4abdd1c704344ed50715c980491e198d-1730302695"
  },
  {
    "email":"silvia.biscari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760947578/69068fc67167721583fba21e82cc9e10-1730302695"
  },
  {
    "email":"micheladalmonte@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723760849274/26bfb351f05f4c30bebf827dd291170d-1730302695"
  },
  {
    "email":"lara.morazzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723760980346/5d82a46e6d6ed00f742a51fa781332a7-1730302696"
  },
  {
    "email":"napolitano.riccardo.96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761078650/256164e5cab911f03fc653dc8701656f-1730302696"
  },
  {
    "email":"m_radatti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761045882/64ceeaede976fbab92f3849fa9c8cdae-1730302696"
  },
  {
    "email":"nives.picco8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761111418/c6b2f8c88bdcbfc196836ee6ca0ea722-1730302696"
  },
  {
    "email":"laurabase76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761013114/639c0ef16734c71ae4ece3837050720f-1730302696"
  },
  {
    "email":"barbara.anglani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761209722/ec28807b8230a9cd2a2d1444b5221605-1730302696"
  },
  {
    "email":"ilaria.dresti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761242490/6dcf86cd5048c28a2932104e79729f98-1730302696"
  },
  {
    "email":"toali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761275258/1ecde2e9f935ad0508b137e154562576-1730302696"
  },
  {
    "email":"mamone.carmelina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761308026/3526c6e4dd482986ec190c529a85dc22-1730302696"
  },
  {
    "email":"laura.rt@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761373562/009ea60548df39ef0fcce2a9c95f76ff-1730302696"
  },
  {
    "email":"benefantu@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761340794/57795d4fe82e660242427aa9c9485d82-1730302696"
  },
  {
    "email":"paolabassi2504@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761439098/0d4e9f6d134feb80db386e84c24448a2-1730302697"
  },
  {
    "email":"alessia.pelillo@enel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761504634/50357bb634c9cd1ab5b454601c6e3332-1730302697"
  },
  {
    "email":"sessavaleria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761635706/7c744ecdd95c950643d7e51e2bbe6b68-1730302697"
  },
  {
    "email":"lauran@tessiltoschi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761570170/d91fdb4fdc754a04a0bb79938223ff23-1730302697"
  },
  {
    "email":"pedrini.monica71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761701242/3afce986b8bfb653aff6e340b15095f8-1730302697"
  },
  {
    "email":"lidia@ceky.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761766778/9f80cf6295d3989fd1b2e8f67c50fe86-1730302697"
  },
  {
    "email":"monicaperetti70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761799546/84c9cbeb5800785729612eec0929a40d-1730302697"
  },
  {
    "email":"laura19031960@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761668474/c7dbc8ee3200cec486048bd12dbdd8ff-1730302697"
  },
  {
    "email":"paolo.manusso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761865082/6e12a6b37be0f35f2b6c489374fad2f8-1730302697"
  },
  {
    "email":"gioie.gioielli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761897850/dc99964b39171d407cb8c44fe7d14546-1730302697"
  },
  {
    "email":"simona.ghidoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761930618/fc43a4d34f3501d2dc7d13f6e006d22e-1730302697"
  },
  {
    "email":"tedemaio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723761996154/8687c36ba2cfd18f4cf6b023d199dafb-1730302698"
  },
  {
    "email":"flavia_sbarbaro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762028922/3d65c01d9133e8bb50c10fd7790935b6-1730302698"
  },
  {
    "email":"zavettiericarmen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723761963386/e62138b811dc405a436eafbd8b9d89de-1730302698"
  },
  {
    "email":"sabrina.santo2@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762061690/db537c743acd93be3a64ad2a5d3c694a-1730302698"
  },
  {
    "email":"eleonora.ci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762094458/d6814a08e6b6554fe0a88877b48f8933-1730302698"
  },
  {
    "email":"antonioliserena@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762159994/e96d81c1c07d7b715a94b51287f680d2-1730302698"
  },
  {
    "email":"mariachiara.perego@fastweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762225530/35e7001695ac84cbe6dd231e73072f04-1730302698"
  },
  {
    "email":"kandinski@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762258298/b2787e4879b93c4a5589e6f51947403e-1730302698"
  },
  {
    "email":"angelapaludo54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762127226/aa026448570527d5fa4a940dcb6a5ae2-1730302698"
  },
  {
    "email":"fabiola.scala@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762192762/8ea45ddb46677a6389234e03bfddec5a-1730302698"
  },
  {
    "email":"p1mazzitelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762291066/a76b9870304028e022400a7793bfd31f-1730302699"
  },
  {
    "email":"fuchs.simone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762356602/1145a6f785c9b843294a62b5edeb030f-1730302699"
  },
  {
    "email":"scolletta.davide@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762389370/9cbb398b090c3eb73be4f0b9132c828a-1730302699"
  },
  {
    "email":"martamindel10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762422138/cad55a587ed6fd963059389debb0ef75-1730302699"
  },
  {
    "email":"giulia.bergamin96@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762487674/3f516f9c71fa165cb596fcd4de5bc96f-1730302699"
  },
  {
    "email":"marinahcl3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762585978/e82de8364840ebb3a50f5107e6ffff5c-1730302699"
  },
  {
    "email":"turrinav@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762618746/098e562a08f0323cc16221cca105c749-1730302699"
  },
  {
    "email":"bb_fucile@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762520442/225cf8fd937df465b8f36703ff6afba2-1730302700"
  },
  {
    "email":"anna.mascherpa01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762553210/ca2c48b89da8646c9084e0bc7cf93fca-1730302700"
  },
  {
    "email":"cbartolucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762684282/8d901d3e51b779911132675deb481329-1730302700"
  },
  {
    "email":"b.rovina@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762749818/30ee9c8548477c23260c09140e6a7d13-1730302700"
  },
  {
    "email":"roberta-costi@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762815354/3f125b58d72c3793e9205df9ea42a10c-1730302700"
  },
  {
    "email":"alberta.maturo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762782586/559c0e3baba51a34f4ab0a7166754f2e-1730302700"
  },
  {
    "email":"miriam.duca@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762717050/2348de07d4778feb6d13cb173e3b6d1f-1730302700"
  },
  {
    "email":"genziana@buffoningegneria.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723762651514/14ac3edfba1224a9b54ea3782e7fc893-1730302700"
  },
  {
    "email":"marabi1976@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762946426/da89118716b1b8ff943e7631d42ac4d9-1730302701"
  },
  {
    "email":"mariapiarosi2009@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762848122/f43bfab69f4f6b3a09aa6306229832b5-1730302701"
  },
  {
    "email":"marinellafaraci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723762979194/31404f78c68140d3c574cbcb0a198fb2-1730302701"
  },
  {
    "email":"alvemo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763044730/88a64d51d00285b881fd5703876ff54c-1730302701"
  },
  {
    "email":"valentinadavi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763077498/4d2605b50c67c0b06104277ada49c118-1730302701"
  },
  {
    "email":"forzafabiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763143034/881ba56ab4e11b63bf06b0ed249f6af1-1730302701"
  },
  {
    "email":"my.cicala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763241338/df03936e7ce08cb7aaf1bde120a179e3-1730302701"
  },
  {
    "email":"ilaria.pasina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763274106/f73101ee930ca69f15f142fab94e2681-1730302701"
  },
  {
    "email":"paola.pennasilico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763306874/b88b4afa70f0f1c64d87c41d837105d2-1730302701"
  },
  {
    "email":"pierantozziarianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763372410/067032ac77597b163737199d173f37a1-1730302701"
  },
  {
    "email":"simonetta2566@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763339642/dace682013ff038140e5ccb7f20184a7-1730302701"
  },
  {
    "email":"lucia.gasperini1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763405178/37f26ff590f8d585d56b66404fdb8b68-1730302701"
  },
  {
    "email":"marayabarbie@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763470714/7081c87aa5b3d9001684188b67b73875-1730302701"
  },
  {
    "email":"gaetana.guerriera@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763536250/d8dc181d6ead46fb6a1e970e27c80b42-1730302702"
  },
  {
    "email":"lleone90090@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763601786/6a74498b70e224f68a0f377e7097e4b7-1730302702"
  },
  {
    "email":"sara.inglima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763634554/942fa14e3791169f51e04905d25c48a7-1730302702"
  },
  {
    "email":"pdevido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763667322/0195cda7f3af16a9f969da0fbaf95768-1730302702"
  },
  {
    "email":"magnaniroberta@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763700090/77dcfc9c00350fec3ca270472adad9a2-1730302702"
  },
  {
    "email":"e.dodesini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763732858/c751714fbdfb208ae77f0d1c43250c11-1730302702"
  },
  {
    "email":"cristiana.casentini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763765626/c4557e2a8d515932fa0b7bc428a228a4-1730302702"
  },
  {
    "email":"aboscaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763798394/26d80438fafb72739ff41d2cbe1c45ee-1730302702"
  },
  {
    "email":"a.dondana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763896698/afdc5389ff8106214c5690ea729ab747-1730302702"
  },
  {
    "email":"brunellaconcettina.arlotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763962234/bd6dd9c0b0c49d1d14d93aa8df132b1c-1730302702"
  },
  {
    "email":"tossettina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763831162/6b2b4423eb2e20fe00f11764f88db149-1730302702"
  },
  {
    "email":"monicafantato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723763863930/2809a7609fd899887f2e3e70d4dc8f71-1730302702"
  },
  {
    "email":"aleacquista@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723763995002/072b27e42ecee63231d4bb879c355457-1730302703"
  },
  {
    "email":"teresabuonin@gmal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764027770/1c85b37da88fa52c78e6af406edff148-1730302703"
  },
  {
    "email":"marikamaragna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764093306/7b9d7c96dd750cf00967b9b66b88becf-1730302703"
  },
  {
    "email":"elitavani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764060538/93f8aff230e69e3f9981681c8604bf2e-1730302703"
  },
  {
    "email":"annazardini70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764126074/8a1d9b51efa1d98b56ad0a42e63f5b3d-1730302703"
  },
  {
    "email":"gaietta.09@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764191610/90422c54d20fd347d773e480b38b9ac2-1730302703"
  },
  {
    "email":"sabrybernabei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764355450/25345a1433e1edf79518ff4653886ca9-1730302703"
  },
  {
    "email":"cristinadegobbi71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764322682/bbb74d08753c34cba40683a26781f422-1730302703"
  },
  {
    "email":"luciabattista2011@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764388218/a60496edae9423a47467898ce13537f4-1730302703"
  },
  {
    "email":"luciacarraro1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764257146/ba610f7c4f340f222db72096fb46f17e-1730302703"
  },
  {
    "email":"franzazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764486522/1e64e07f4b1127bf87adabaed5087218-1730302703"
  },
  {
    "email":"jil1966ssl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764453754/95fbd1ad689fb227649dfed1c972ba41-1730302703"
  },
  {
    "email":"s.michela82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764584826/8ac3f306df06e52c0733e9d9b9ceda2b-1730302704"
  },
  {
    "email":"davide@biasiluciano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764519290/3dea15ad508fc909669bad9dc36fd900-1730302704"
  },
  {
    "email":"orsola.pezzella@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764552058/0312fab24d158fca4fd9896b79131c44-1730302704"
  },
  {
    "email":"stellamerlini4@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764617594/518d2fa849fad4b325f1768be2d50bc6-1730302704"
  },
  {
    "email":"a.palombi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764683130/217aca27de77a99bc0a2f6c01b0e3a80-1730302704"
  },
  {
    "email":"antonellaaiello83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764715898/b55667612624b6f2f55f9593645cc8e1-1730302704"
  },
  {
    "email":"gabriella1910@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764650362/3f868a8225101055cbb82fcb2f82867b-1730302704"
  },
  {
    "email":"eziotaiola@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764814202/da93d21d01fda832eac29708328f45f8-1730302704"
  },
  {
    "email":"stefania.pistolesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764781434/e3415a35e53e81469d0506e5793e4873-1730302705"
  },
  {
    "email":"simonanardiello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764879738/a2fba9204e3328a1a4d07d093e3ea57e-1730302707"
  },
  {
    "email":"benedetta.masella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764945274/4c2f7a4eb5f73f06d6122121b5ec0a16-1730302707"
  },
  {
    "email":"michelachirico1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764912506/240732087d30a9dce098c33e259607c2-1730302707"
  },
  {
    "email":"michelam@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723764846970/f657a2b43e409d4955c46bf283726e28-1730302708"
  },
  {
    "email":"enricaengi7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723764978042/548f9430b096e09139739832f9450cc1-1730302708"
  },
  {
    "email":"ornella.ventura76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765010810/03a30b8a4c3b71e6c32b2b904ec6c6c8-1730302708"
  },
  {
    "email":"palmina69p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765076346/2da1c1a7dfb7e5c36a53564c32219b38-1730302708"
  },
  {
    "email":"mpisciotta@lavoro.gov.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765109114/b7c7ede9ce82db413d3b4c589be7c7c2-1730302708"
  },
  {
    "email":"panchettia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765141882/380b6d4a19700079121d714d286411a2-1730302708"
  },
  {
    "email":"lorenzamancinelli.94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765240186/8b4b7981190335b9e628a5186044253b-1730302708"
  },
  {
    "email":"lory.massari08@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765207418/ba50e2f904e8c92271c4b44123dfa79e-1730302708"
  },
  {
    "email":"patricia.fleischmann@aol.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723765174650/b0c07810f4044d4f21ef6c4d1e867bfa-1730302708"
  },
  {
    "email":"elda.favari@unipr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765272954/2a00d80ca3f911e9c8ccd97fba2f8d11-1730302708"
  },
  {
    "email":"amm.alorusso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765305722/733bac4dbf63dd939bdda54887a85737-1730302708"
  },
  {
    "email":"annamariatropea@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765338490/e63f45fc9cb731005622cf3c32a3d3d2-1730302708"
  },
  {
    "email":"mariangelalongo307@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765371258/f0a3fa3745306a482c690e0663b112aa-1730302709"
  },
  {
    "email":"lucilla_ronfini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765436794/e190746bd708c5f7604d634a924db0e1-1730302709"
  },
  {
    "email":"sere.desy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765567866/4a3cfca4e237a2fbaa2dadb8183f1dd4-1730302709"
  },
  {
    "email":"milenacalabr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765502330/1192888eb6a14cb679b5374eb4a5927a-1730302709"
  },
  {
    "email":"vanessa.ternana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765600634/e7c5bb12bf3f725bbdbbf7ecebed304a-1730302709"
  },
  {
    "email":"hans@caspaiou.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765535098/2499d3f105b822b3f8cd090a89c8fe5c-1730302709"
  },
  {
    "email":"katrin.boscheri@live.de",
    "url di attivazione":"https://verdissima.it/account/activate/22723765469562/d51ad9c56fdaa5beb9ccdf685a7f9b62-1730302709"
  },
  {
    "email":"dani_maggi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765666170/e6faef637c8f68f1e83ba97dfce34132-1730302709"
  },
  {
    "email":"franpesca19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765731706/39b833b339cfb8fe4ff59b250e361638-1730302709"
  },
  {
    "email":"barbara.benassi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765698938/9ba615587e323ae2b9016d2fe5873772-1730302709"
  },
  {
    "email":"ale.paolini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765895546/f83ac9b082776957ec3a111c7a6ede88-1730302710"
  },
  {
    "email":"fedebag@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765830010/203bc4a40662cb71ece5ec41e80e6f26-1730302710"
  },
  {
    "email":"furlan_raffaella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723765764474/a28e2159be5f75ef230b1e118f38f0af-1730302710"
  },
  {
    "email":"servallipaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765928314/909c1e770a654f2c3b13dd617c2744de-1730302710"
  },
  {
    "email":"fiorio.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765993850/3ebf229349eef1478904434c8bb5041a-1730302710"
  },
  {
    "email":"elenaconto2401@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723765961082/b6d49cbc55bc8886bb4c0f5c851db16c-1730302710"
  },
  {
    "email":"tatyboari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766026618/042021a6a21f76eb1cbd316b04bb4090-1730302710"
  },
  {
    "email":"mariarosadenicola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766092154/c09926222de2846303170ecdbeac3ec1-1730302710"
  },
  {
    "email":"loredana.codric@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766124922/f18cf442022612eddb97358ca1bfda70-1730302710"
  },
  {
    "email":"martina.biancacci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766059386/abacf6e7a3e91ce78f298184619f4212-1730302710"
  },
  {
    "email":"paola060660@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766190458/86169e2cc8996c1a66cc46d4e87a52d0-1730302710"
  },
  {
    "email":"cettybb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766255994/009dcfc6dde54b04f71a1c86740c6d92-1730302711"
  },
  {
    "email":"silviamariani78@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766288762/999ca7c8acb166d13c9be45568b1cc4f-1730302711"
  },
  {
    "email":"taniapatti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766223226/f040bf1d4d1b6d7b9d8a3989050089e7-1730302711"
  },
  {
    "email":"micazentilomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766354298/d88381783ad5dcf1ab3d00827c9b4a5d-1730302711"
  },
  {
    "email":"valeriapatteri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766387066/4663620d1964e3f1dd6e77a3925d4567-1730302711"
  },
  {
    "email":"silvia.tagliaferro1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766485370/fa9d831816fbe7126d7d05efafa59dba-1730302711"
  },
  {
    "email":"simona.masiero09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766550906/8c1da184d976c979728abb21254bc076-1730302711"
  },
  {
    "email":"danielapersio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766452602/09aaf607bea1b9ca194522478312dbb2-1730302711"
  },
  {
    "email":"muzio.laura1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766616442/5a64dce3e9ce50c4d704ecf021b4362a-1730302711"
  },
  {
    "email":"michi-p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766649210/e973af1a8d8aee7eb73900bd8948f26c-1730302712"
  },
  {
    "email":"barbararossi86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766583674/9ce6001511b6ae2044053c32cd730d0b-1730302712"
  },
  {
    "email":"antonellacarimati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766714746/77ae6533b861e90a5797ad162c2425c1-1730302712"
  },
  {
    "email":"ccarissimo64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766747514/fbaad0db377c45f0563802e9a4428fda-1730302712"
  },
  {
    "email":"sara.molinari10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766681978/b558c3abb1e90a1033030473d8b67a90-1730302712"
  },
  {
    "email":"sabrina.c758@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766780282/e7914d0265e01ad37481decf05e90e2d-1730302712"
  },
  {
    "email":"adiganci71@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766845818/91039b6bf958a70fadd043cb3d49d140-1730302712"
  },
  {
    "email":"patrizia.mantoessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723766878586/a2ebc0045405de6979728ef85360c2bf-1730302712"
  },
  {
    "email":"annafoti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766976890/6911911ebc400980cf5a61dd84fa31f8-1730302712"
  },
  {
    "email":"rosannaiapicco@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723766911354/f4e94237677fa9e62e8a6009cc0cebe1-1730302712"
  },
  {
    "email":"pattyrello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767075194/bad4225e10c87aab2f756459842af8a0-1730302712"
  },
  {
    "email":"alessandra_mencarelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767107962/6a79ce1a2fe2b49983c1a962cec0f0ee-1730302713"
  },
  {
    "email":"simo.tacchini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767042426/a971c1fac0943404697b34e18f629595-1730302713"
  },
  {
    "email":"bettasg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767140730/384c8b79615e19521a8f64b4c8dc1359-1730302713"
  },
  {
    "email":"smatteini66@gmail.coms",
    "url di attivazione":"https://verdissima.it/account/activate/22723767206266/2b0c0beafa14ba5053928d24922ab666-1730302713"
  },
  {
    "email":"alessandragrassi261@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767239034/12dbac26d6c1c1c9da6d31f9be736af8-1730302713"
  },
  {
    "email":"michela.aita14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767173498/f581dd8ccb6349f94931590a6607a5c5-1730302713"
  },
  {
    "email":"marilenacrippa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767304570/4d6e38165ce6b097edea349b5768c9f5-1730302713"
  },
  {
    "email":"emilianaagostini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767337338/ce06dc7b618da8f667013d501f8b95f9-1730302713"
  },
  {
    "email":"a.vezzetti@studiomagnino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767271802/a77bdf609cd49793fbfbce7554d2f552-1730302713"
  },
  {
    "email":"patrizia_leanza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767468410/587418d5bf5ee2ace0118fbe44c72c5f-1730302713"
  },
  {
    "email":"giugioc@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767533946/e325dbdbac455bd0cfe4c47a877c5c6a-1730302714"
  },
  {
    "email":"veronica.cibin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767402874/ce366210eb7cad6cb3ff11a70d64a632-1730302713"
  },
  {
    "email":"lalleta.mp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767599482/5e82a682757cb07117d4a1f7586dee62-1730302714"
  },
  {
    "email":"mariasabina.vigna@giustizia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767730554/44652d620c43938b6024e3378b1760e3-1730302714"
  },
  {
    "email":"alinaalge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767632250/aba9ecf334b1a44d32542134633a8e85-1730302714"
  },
  {
    "email":"raffaella.vignolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767665018/f2419bd331a307bccbe8ffd6d7e5bdb6-1730302714"
  },
  {
    "email":"lalla.sorrentino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767697786/790f2154e25941f3eb1842c0c30ee4d2-1730302714"
  },
  {
    "email":"roberta.tribi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767763322/56ae4df296934815f3d45b2371ef674e-1730302714"
  },
  {
    "email":"mario@hotelrivage.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767828858/343393bbca5d98ec84cd5122fe6c7198-1730302715"
  },
  {
    "email":"antonellaleopizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767796090/1d30e19f1a85e65643b690555bcf1c5a-1730302714"
  },
  {
    "email":"losilisa1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767894394/5e5088cf43d88af1eaf2376d2e6e79e8-1730302715"
  },
  {
    "email":"annalisameledandri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723767861626/5119cc9a443a2539876d31ab84345b99-1730302715"
  },
  {
    "email":"mtbizzarri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767927162/de67d0281603cbbfe18dc1ce3a9d6481-1730302715"
  },
  {
    "email":"cristina.rose@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767959930/8e78f535d33d13462858d7f791561423-1730302715"
  },
  {
    "email":"fedece@puntovista.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723767992698/734d69abef5a5a7d97c3f76275236d24-1730302715"
  },
  {
    "email":"anfra.dalessio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768025466/727eb9204f8d501e3bef353bd1977c65-1730302715"
  },
  {
    "email":"simonebet91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768058234/ad6d7e9a5510470d66d321b9e193f436-1730302715"
  },
  {
    "email":"alessandra.alberti71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768123770/c95b726defe812e3e2578e2cc393427a-1730302715"
  },
  {
    "email":"romandiniserena1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768091002/3ddcbfa017ef6d83a83ab6371d23ee2f-1730302715"
  },
  {
    "email":"gio.morichetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768156538/c6131b95ffb123e985f022c3b7fecb87-1730302715"
  },
  {
    "email":"bica.anna77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768189306/5fd2aee513a594633776f19ebb2993ae-1730302715"
  },
  {
    "email":"daniela.panetta68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768222074/9eeb5ceee2c19831f4d1fca3dee6a303-1730302715"
  },
  {
    "email":"claudiacst@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768254842/cb13c243cf3408312e8d1fc02ea43513-1730302716"
  },
  {
    "email":"giuliasery@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768353146/aa71a8e65a005f5c05eca65356eb9d11-1730302716"
  },
  {
    "email":"caterinalaletta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768385914/c413c69419050177c2666fd1cd754cf9-1730302716"
  },
  {
    "email":"annaliciad@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768320378/bb94bfd66c391f076fccba945db05295-1730302716"
  },
  {
    "email":"sara_ferr@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768287610/78ba488057b34b728b23dacbae2e385c-1730302716"
  },
  {
    "email":"devicomt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768418682/3c9aeec4f935b7c42c15cfc3fd77d0eb-1730302716"
  },
  {
    "email":"fabinadiaticchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768484218/5ee50164106623871bfdb18d24c51087-1730302716"
  },
  {
    "email":"teti.d@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768582522/e6a3e54a2634fffbe607ccd7bcb9655b-1730302716"
  },
  {
    "email":"daniasalvadori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768549754/0b7bcc99898d8254ec732b4f3ddd9566-1730302716"
  },
  {
    "email":"daniela.sposari7781@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768516986/a5fe85ac5ef9e00ce505872fdb61d23d-1730302716"
  },
  {
    "email":"lucina.cilia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768615290/8c5a43eceef0e0a01019f38e3bc15d40-1730302717"
  },
  {
    "email":"laura.stucchi1@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768680826/c43c25369ebce3002a632a003335b2b2-1730302717"
  },
  {
    "email":"vanessa.dilaghi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768713594/f98fe36df6084928e3595de66fcd1dd6-1730302717"
  },
  {
    "email":"cinziatodisco@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768779130/0c8f50828c08fa7f26db6c089aacb9c6-1730302717"
  },
  {
    "email":"robertazanobini61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768746362/82f725c19f6ada0afa6ff1d181c7d916-1730302717"
  },
  {
    "email":"ilariaveltri1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768844666/74559906e6be403022d363da11802dd3-1730302717"
  },
  {
    "email":"nadia.baccanelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768811898/fc1d41a033ad3fcee3c1b5c19d688fd1-1730302717"
  },
  {
    "email":"martina.max@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768877434/2792a550fea27aa3643fcfec1150a9ca-1730302717"
  },
  {
    "email":"stefaniagiuliari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769008506/d5043df3cbc73aa49eea0bce681fbf54-1730302717"
  },
  {
    "email":"pasquinimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769041274/ae1944954f2d3543c1b5b029a593693b-1730302717"
  },
  {
    "email":"daniela.n@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723768942970/fcb37c9481b820161860b5eec906b3dd-1730302717"
  },
  {
    "email":"ale98.spaccasassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769106810/dd6304f754b4282ba3f36db65fc582b3-1730302718"
  },
  {
    "email":"sabrinagianessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769139578/8a711d5b9ffe0b09da95b6098058ddc0-1730302718"
  },
  {
    "email":"9fortunella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769172346/51f865b687d445d3bdaba78450e7b906-1730302718"
  },
  {
    "email":"sabrina@delfanti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769237882/ba901eedfb4c4598d4e714806ecf13ac-1730302718"
  },
  {
    "email":"danipat35@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723768910202/9e35c59ce5f6680d60454998fe20e2e5-1730302718"
  },
  {
    "email":"bruna.marcato@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769368954/f8f976d92574f261289d0685fcbb3511-1730302718"
  },
  {
    "email":"anto40@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769467258/ff2521c8e27065c3d22d9cabc5f9d728-1730302718"
  },
  {
    "email":"giuliapilutti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769434490/24d25dbe58eadc45fd2496094f8fcf6a-1730302718"
  },
  {
    "email":"ale79r1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769500026/b5ba826f48d325a913ec7578a40032ea-1730302718"
  },
  {
    "email":"nicole.sandri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769401722/3141be41af017b4f6572a12326a56675-1730302718"
  },
  {
    "email":"alepugl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769565562/a398f3f9a4c782fa81d755f2f476ce22-1730302719"
  },
  {
    "email":"claudiabignamini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769631098/ecfc3f5abdee98e5525054ec03e05d41-1730302719"
  },
  {
    "email":"france.gentile84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769598330/bed06ff20cba3ef25a5b7aff6ad83eec-1730302719"
  },
  {
    "email":"arianna.tancini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769663866/d05be4bae1d38c54b236f635fbda8ae5-1730302719"
  },
  {
    "email":"luisadisciuva@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769532794/fc02c94ec135a9c095be9c273de30932-1730302719"
  },
  {
    "email":"svetlana.rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769827706/fe5452aea39c4707bdfcbdc4dce735c4-1730302721"
  },
  {
    "email":"amgam@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769696634/82c4153dfe3be2d848877a11ff641c66-1730302721"
  },
  {
    "email":"marinaiceone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769893242/7f109233eaf01128c611ab3d4608d7cf-1730302722"
  },
  {
    "email":"bmessineo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769762170/b517b0f959c65336f2e44e42af65282e-1730302722"
  },
  {
    "email":"valeriadami19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769860474/c2c503266d2d7099268d955666b71df3-1730302722"
  },
  {
    "email":"mary_diluccio@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769794938/adca4c35f8d2320ff648feead8ff9cea-1730302722"
  },
  {
    "email":"marina@volpelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770024314/8ee25258f35263b00bd5427789b49c76-1730302722"
  },
  {
    "email":"marili66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723769991546/e4c31507a4b955f2d7bca47c138d58b3-1730302722"
  },
  {
    "email":"serena.menardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770155386/a4293a53dc3f06c15c9cd4a5c54efa77-1730302722"
  },
  {
    "email":"monica.bernamonte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770089850/4bc7a85b26e6ffadecc12b876255bd78-1730302722"
  },
  {
    "email":"lisetta.lupi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770188154/1ffa33df4a7a74a2d9a2f50bbba8ec5a-1730302722"
  },
  {
    "email":"stellaraso245@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723769958778/5cf345f9d2f02c410155d7b6ae665dfd-1730302722"
  },
  {
    "email":"giulia.destro70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770253690/b20eb6037910ccae1d8b66545d9eb020-1730302723"
  },
  {
    "email":"silviacala@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770220922/59a5e284d361e14c341b5017ca72e68a-1730302723"
  },
  {
    "email":"katiusciascala@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770319226/d9de57d982b079972b96b8d689b4361a-1730302723"
  },
  {
    "email":"mociolina@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770286458/9131c16b3b717c127655003d6e7527e6-1730302723"
  },
  {
    "email":"angela@dimensione-avventura.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770351994/b47f14d41dc7f49bc2acbe90bffc4e06-1730302723"
  },
  {
    "email":"carepie@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770483066/a1b3dbbc8f8e94ed2cda04db0f222291-1730302723"
  },
  {
    "email":"lorymarrapodi@gmail.co",
    "url di attivazione":"https://verdissima.it/account/activate/22723770450298/a653bf1c215ae076be4acb743280daba-1730302723"
  },
  {
    "email":"angelamarzocchetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770417530/09e0dbc67144ff0d69fb59a380f61080-1730302723"
  },
  {
    "email":"eleonora.milano.85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770515834/ae5dad144127c9c97508b236691f1970-1730302723"
  },
  {
    "email":"daniela.delloro78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770548602/b32d19f1d5d228d5c98bb3c7cff45f00-1730302723"
  },
  {
    "email":"stefania.mannelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770614138/29fc34fa7d0e5f0bb3049d7725ab050b-1730302724"
  },
  {
    "email":"robertofaz1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770679674/d54d2579e365f2fe6cda0560b6804860-1730302724"
  },
  {
    "email":"silvia.marongiu@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770712442/acbd0a27bc881b49d580331653ad88d7-1730302724"
  },
  {
    "email":"collocamaria@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770745210/358558e6c5b1957c410e7ade4425bc52-1730302724"
  },
  {
    "email":"amadeoroberta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770777978/1b2cec2e9930c75352d0a3cd0466c412-1730302724"
  },
  {
    "email":"vales.designer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770581370/b66909518edfa6d4ae036d8cb8641b9c-1730302724"
  },
  {
    "email":"rosamaria.caminiti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770810746/d72cf7953b562af75af4d7240698cab8-1730302724"
  },
  {
    "email":"info@galimbertilino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770843514/e3df3e0c67b58bb90d934fe8725489d7-1730302724"
  },
  {
    "email":"birretta61@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723770876282/f9d42d2e3ea2ac58f56bbbeb0ce8bc02-1730302724"
  },
  {
    "email":"roberto.malatesta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770941818/ae5f45b31fc34de35bdd0bec025d0955-1730302725"
  },
  {
    "email":"anzamonic@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723770909050/8cf561b1629e5e4bd19c71bfcca2d058-1730302725"
  },
  {
    "email":"monica.camilla1969@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771072890/a148674cea66ce0eb61af20f68db4a46-1730302725"
  },
  {
    "email":"crapanzano1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771040122/1e5f15abc52c3ea0aeca80266dae2a34-1730302725"
  },
  {
    "email":"osylbaba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771105658/80545f8c25de6ff0c1e602e83f2301b7-1730302725"
  },
  {
    "email":"barbara_barreca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771138426/e3361a098b35dc1b19183dcb21902f70-1730302725"
  },
  {
    "email":"lory.ceccarini66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771269498/bed36a0ad0445dfd93d190552aaa52a8-1730302725"
  },
  {
    "email":"esmeraldaspagnolo3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771203962/a81c0fb82fb8fb11f80c3a30613d6dc1-1730302725"
  },
  {
    "email":"michelinlaroc73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771302266/854bd7de0704802af1df02a0ac9c14c5-1730302725"
  },
  {
    "email":"sessa.ester@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771335034/56695874b569b9cd93162e0187470f81-1730302725"
  },
  {
    "email":"silvanafratantonio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771367802/4509fc5f887c16ed187eea169087546a-1730302725"
  },
  {
    "email":"info@aloe-arborescens.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771400570/b74826bb8ad2ea2276fea52c4287ec13-1730302726"
  },
  {
    "email":"laura.patrone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771498874/a7db32f4d0d1b364de937927e7d4ec98-1730302726"
  },
  {
    "email":"katiaalberti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771433338/e9295d9018924515aa4c32c9613f41c9-1730302726"
  },
  {
    "email":"erika@avvocatovillanova.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771564410/45e43aa92eebe7c91bde3d7fa4479d27-1730302726"
  },
  {
    "email":"kwierdis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771597178/77db5488eee9580fb712ae9b5b5f4345-1730302726"
  },
  {
    "email":"daniela.beghi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771662714/4be5038f5f490f5297f4214bb39805ff-1730302726"
  },
  {
    "email":"saramassimiliani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771629946/d129ebe4f3847646443184efd0a816a1-1730302726"
  },
  {
    "email":"danellimonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771761018/48b29828505defe2cfd413f76ce74cfe-1730302726"
  },
  {
    "email":"sabrina.cosato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771826554/2a59ba7c993dedcb2d03ab0df660e757-1730302726"
  },
  {
    "email":"mirjana.ranchanov@makdia.mk",
    "url di attivazione":"https://verdissima.it/account/activate/22723771793786/e04ab4c7453c3ec52c93e5b159bc4733-1730302726"
  },
  {
    "email":"spigoneilaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771892090/a007214ebab1c45ee2a2dcdb59eb0e02-1730302726"
  },
  {
    "email":"germanagabriele922@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771728250/41ee964364044c25e67f2ef52e8de16d-1730302727"
  },
  {
    "email":"c.maggi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772121466/40fcadf09e215e0ab364f7c9789545eb-1730302727"
  },
  {
    "email":"aloap08@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771990394/8797f98651a64aa929d121213ecdfdbf-1730302727"
  },
  {
    "email":"chiaragallopin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723771957626/8ce5c24b3c9200e4b5cb7e3f5c58a7fb-1730302727"
  },
  {
    "email":"francesca.girolami@asst-mantova.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723771924858/dcd9c6d3e73069e438ebbe7e79ca916d-1730302727"
  },
  {
    "email":"giusi.consoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772154234/3d9f087bd1fc62895e4ebb234c38e503-1730302727"
  },
  {
    "email":"milenacolli2004@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772252538/b90fa18542fe50d2d1b82a57c2e619c9-1730302727"
  },
  {
    "email":"marisalotitoapple@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772187002/a47dd0d796895a75d36e5d1f669d65bb-1730302727"
  },
  {
    "email":"grazia.berrittella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772318074/ad520ba1d4ab6185f2f13523f98df61e-1730302728"
  },
  {
    "email":"cristiana.giorgini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772285306/8e7adf301cef8a177842ab30b354e33d-1730302728"
  },
  {
    "email":"verolipari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772350842/ffe4dd683fe36f85e2009125e2653312-1730302728"
  },
  {
    "email":"ilariamar79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772481914/0299cec93a914fafcf67ce19884b3431-1730302728"
  },
  {
    "email":"orietta.angio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772449146/1fb591ca07cfe209669620db802c5ccc-1730302728"
  },
  {
    "email":"elesani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772514682/967c1a31fef4ae66593bdf8070233b29-1730302728"
  },
  {
    "email":"silviaceniti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772547450/a3fa23e59ce1fae696c638cf01e07243-1730302728"
  },
  {
    "email":"msoniait@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772612986/8e90205fb2087cf3117d8f36d4e7be49-1730302728"
  },
  {
    "email":"livia.mannucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772416378/30cec5c9861098a5bc13757b042b0445-1730302728"
  },
  {
    "email":"lorena.brandoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772645754/4f1b6b415e297b5a934242a979371363-1730302728"
  },
  {
    "email":"carmelabarba92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772744058/fb629ef33f07c47befc1d5f4aa9a5f7d-1730302729"
  },
  {
    "email":"sara_max84@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772776826/849267d53a062c2150d3407d49b37e38-1730302729"
  },
  {
    "email":"gianmi@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772809594/289bc128bb8febb202cf166f81168295-1730302729"
  },
  {
    "email":"vamadean@yahoo.ot",
    "url di attivazione":"https://verdissima.it/account/activate/22723772711290/ba2d9805821158a97367be66cf89d465-1730302729"
  },
  {
    "email":"eleonorabuziol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772907898/cdfcb3cd8faad31741b053538617bdf1-1730302729"
  },
  {
    "email":"delucaida1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723772875130/30545b2c2deb06668ecf48ede93d009e-1730302729"
  },
  {
    "email":"cristina@studiocolaiezzi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772842362/a9a76ed5e5612002b51fdbaa0429f2ab-1730302729"
  },
  {
    "email":"f.sciulla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773071738/acc34fd21e3bad545138c2847cf4bca7-1730302729"
  },
  {
    "email":"nicolettacabianca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773038970/20d12b5e37531f57d09970da1eb4de69-1730302730"
  },
  {
    "email":"gloria@gemar.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773170042/655fefeeb22babb296e900210fc9cc3b-1730302730"
  },
  {
    "email":"berninichiara@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723772973434/e1ab61e355b1a18986aaf8f34459da13-1730302730"
  },
  {
    "email":"sarchiantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773104506/ec80cd3ebb7f488ead45c7cfc76a086d-1730302730"
  },
  {
    "email":"nicoloantonia76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773235578/3e5ba4b4b826430617a5445e5be14803-1730302730"
  },
  {
    "email":"brigitte.rohrbach.1@meineinkauf.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723773333882/e082cb71f5817d0a7d74c5959e7137d4-1730302730"
  },
  {
    "email":"pampana.giorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773301114/eaf4208774dfc26f9ad77a4212b0eeb5-1730302730"
  },
  {
    "email":"graziagagliano65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773399418/a018e75c0473624afdfbd09423bdb0db-1730302730"
  },
  {
    "email":"n.matteoni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773432186/0af5b943d84467a939e042dea317209a-1730302730"
  },
  {
    "email":"danielamariariggi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773497722/43e2abc6c66fcf7a4fa3c30159640b4d-1730302731"
  },
  {
    "email":"costadaniela2901@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773464954/a117b0190d728e61edc9ea46c574cabf-1730302731"
  },
  {
    "email":"eva.semprevivo@gls-italy.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773661562/b649050c6d837ad54e7effc06cfb5bf3-1730302731"
  },
  {
    "email":"costadaniela2901@gmail.comgiordy",
    "url di attivazione":"https://verdissima.it/account/activate/22723773563258/73ba2a77a1eb6de0d1a8c0dbcae7194c-1730302731"
  },
  {
    "email":"conval000001@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773596026/dd5cc2c876f84a14591347493a02f1dc-1730302731"
  },
  {
    "email":"cat.pistolesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773530490/9fbf43376b452b99d0f0ed7d62558485-1730302731"
  },
  {
    "email":"idabracco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773727098/38b1c6240bdaf3c9105efe966a7323bc-1730302731"
  },
  {
    "email":"annasales@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773759866/ea7744999d1c23a398377b85c0d6a2b1-1730302731"
  },
  {
    "email":"suly@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773694330/4440d36b3927db438d1b6986059d70f1-1730302731"
  },
  {
    "email":"liliana.moia@italgas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773792634/f0ad8412360e650218a3b2a1d11b44f9-1730302731"
  },
  {
    "email":"kicked@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773890938/35e7cfb263fa48855d2dc7dc0dd3259a-1730302731"
  },
  {
    "email":"cipo.carmen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773825402/16fc97aa95e45349294fbe786a90e1a3-1730302731"
  },
  {
    "email":"francyviola72@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723773956474/5975753833a2d9c78b5cd8ecb4bf8986-1730302732"
  },
  {
    "email":"evapanelli@supereva.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723773989242/7e6189c545a66f2cbd48da69eb7435b1-1730302732"
  },
  {
    "email":"allypippi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774022010/427e8d1927666b725ab9004118b28fd2-1730302732"
  },
  {
    "email":"elemotta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774087546/c800691ac0cc140776ef4bdd2958e9b6-1730302732"
  },
  {
    "email":"a.larizza82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774185850/0a3d27641ffc433e639b6fe87af2adf1-1730302732"
  },
  {
    "email":"bonellitrade@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774054778/4a7f0d409a64de8b04c1db33b913a361-1730302732"
  },
  {
    "email":"noemimassetti10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774218618/4c5533afe94cbbb7bfdba496d8db7a43-1730302732"
  },
  {
    "email":"loredanalauretta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774251386/3476be7bda357dcc8a28b14dbda9c411-1730302732"
  },
  {
    "email":"viorica.riscan@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723774153082/9049f9e6bf8a4780dd84b72221cef4fc-1730302732"
  },
  {
    "email":"francesca.gambuzza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774284154/2045597fc467bfee6a5b89406bc6ff58-1730302733"
  },
  {
    "email":"elebanzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774316922/30b0e37e81938c57fa6027a75ca5b49f-1730302733"
  },
  {
    "email":"monicafil@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774349690/79449b4b8279a4527044a5ce7af34eb0-1730302733"
  },
  {
    "email":"silviagallozzi9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774382458/09b779f1fa338a1f023d3655d177bcda-1730302733"
  },
  {
    "email":"valeria.mazzola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774415226/4b8f935664aeba71aad92e4e6cc2c772-1730302733"
  },
  {
    "email":"frencibalbo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774447994/0e0fb9c755627b381987a87a73b07d1d-1730302733"
  },
  {
    "email":"silviafabbri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774480762/717e76d73e23752cf0dbbf3b77103127-1730302733"
  },
  {
    "email":"augustar83@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774644602/7c3ddbfae05ebea24c8aa0d1954e1b02-1730302733"
  },
  {
    "email":"elena.demarinis01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774710138/eb4aad32683743a6a88c004f5514cb4f-1730302733"
  },
  {
    "email":"ranastrana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774611834/9604329c6ba89ac639de72bd629be99d-1730302733"
  },
  {
    "email":"raffaellabiondi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774808442/8c30d65eb2423e890e798c27c236ac98-1730302733"
  },
  {
    "email":"mara.malagoli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774579066/e160a2d5517b21b913464be4ec6fb149-1730302734"
  },
  {
    "email":"elenauccisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774873978/3f7cdb356d1f6a580e8a7e3cc51d2b3c-1730302736"
  },
  {
    "email":"vascosara@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774841210/2685e93645e308811d8ca31a664443f6-1730302736"
  },
  {
    "email":"belluno70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723774939514/1de5f998e9de5f94bf8fc5e07823a9db-1730302736"
  },
  {
    "email":"sonia.mazzucchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774906746/8df46629ee75948c13274f3c7d7712f8-1730302736"
  },
  {
    "email":"l.reami@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723774972282/82d1b134fe7bc3977ace055d30031be7-1730302736"
  },
  {
    "email":"incardonanatalia6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775037818/cf4254303a357068cae38a9d40d240cc-1730302736"
  },
  {
    "email":"martabechini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775103354/3c5e49bf963101a059596778ae46a96b-1730302736"
  },
  {
    "email":"federica.polci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775136122/0363f9aeedd86f10e47c4a4cc2e6c60f-1730302737"
  },
  {
    "email":"paola.zerbo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775201658/2b6026b70d3166e696ee4354d3b3c1b4-1730302737"
  },
  {
    "email":"susannadalcortivo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775070586/1e6137150ae02bf136c62f664f893dda-1730302737"
  },
  {
    "email":"irmalosi65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775267194/6dc7118670efb5b742bdd21c0745b091-1730302737"
  },
  {
    "email":"m.cazzagon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775299962/5317f8ed74dc2e6c6f7d41337c9c985b-1730302737"
  },
  {
    "email":"muraraffaella72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775168890/6f68241a70e03b9fec6b82160db952d1-1730302737"
  },
  {
    "email":"carlini.anna2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775332730/0f1d615db2b0e3dcc87d62a8e96426b2-1730302737"
  },
  {
    "email":"em0661@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775463802/803930eb3d0e655ff3c3ed944cd7c80b-1730302737"
  },
  {
    "email":"damiana.pellegrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775496570/e3c4df9a1c751a99a2fbc0d42aa92057-1730302737"
  },
  {
    "email":"evaluce38@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775529338/9588012edad2b939e689b5d9733c201f-1730302737"
  },
  {
    "email":"ciaoeve@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775627642/bb7ed70f0ad3d362d41c20354ccc733d-1730302737"
  },
  {
    "email":"rosalbailari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775660410/94ae3a6d79ff1f452e11740d64dff0c5-1730302738"
  },
  {
    "email":"bernarg@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775758714/4771dd3e57e952e1b015a88ec5c07875-1730302738"
  },
  {
    "email":"simona.bag@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775594874/509c1457aa7d06b5e427fe6679e9a38c-1730302738"
  },
  {
    "email":"alessio.bassano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775693178/83dd933420267ca091ce21f2efa6f2a1-1730302738"
  },
  {
    "email":"colleonipatrizia81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775791482/51ce6bbe1b7f415969ac1110e26852f4-1730302738"
  },
  {
    "email":"stefania.avolio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775725946/8fb1b8a98a7020d6abdf884838755bc1-1730302738"
  },
  {
    "email":"martacavaleri1999@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775857018/8b9b39e0c2059ef2364a398989610308-1730302738"
  },
  {
    "email":"annamariac6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775922554/1a01d145b2b954a8fe9c436480645c37-1730302738"
  },
  {
    "email":"tizianacordoma68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775824250/37b728164ed75d56247199c17d8c7954-1730302739"
  },
  {
    "email":"biolcatirinaldi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723775889786/3ce704a367656e112b49bf3e0bd9cedf-1730302739"
  },
  {
    "email":"nadia.rischia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775988090/1950496fb736b238acce982ec61c685d-1730302739"
  },
  {
    "email":"silviaroncagliolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776020858/cb62d7cfb2a5db8033e01593d7cf5aed-1730302739"
  },
  {
    "email":"simonamusio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723775955322/9bce5b3c62fe2812295a1deafd1b716a-1730302739"
  },
  {
    "email":"idaricci1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776053626/19c33e7ba390ed9bc592c9d2f4ae2225-1730302739"
  },
  {
    "email":"silvia.regazzi@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776119162/4f3ee8b4ec384aeb3394168b3f6a4878-1730302739"
  },
  {
    "email":"francescam82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776086394/1fb3e61ae41c28a3bc684650808cfcc2-1730302739"
  },
  {
    "email":"guerracristina35@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776151930/f9df1c6a2de50a45337bf8a548edf9e2-1730302739"
  },
  {
    "email":"primoalberti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776184698/e82e2b0472aa83b5dcc973cfa9cb9cb6-1730302739"
  },
  {
    "email":"m-leopardi@libereo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776217466/ca947b072c2de4c3fa1775a9a04a81b8-1730302739"
  },
  {
    "email":"nato.s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776250234/628d9dcfb12b934b85c2b36848dddacc-1730302740"
  },
  {
    "email":"laura-martano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776348538/5327c018d9a04414adeff6eaaf013b18-1730302740"
  },
  {
    "email":"manuela.limentani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776414074/ae82a41069f697c55bff60654b041bcc-1730302740"
  },
  {
    "email":"rossetti_s77@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776315770/2e35a16603037c83d22d158af485b506-1730302740"
  },
  {
    "email":"leonardatroia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776446842/d0fb7c28948814b634d7c41b6628f843-1730302740"
  },
  {
    "email":"studiog.bullegas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776512378/6b2b20c15d8504285114e67bbfcd867b-1730302740"
  },
  {
    "email":"lauraandreani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776545146/ece2b98b770df36e013fb6d7d23aef96-1730302740"
  },
  {
    "email":"amministrazione@ppm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776577914/423fcfc5c7a6c4d8111058d98188300c-1730302740"
  },
  {
    "email":"francescalupo77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776479610/b8a6b4379d8dd296b0d24cd9419c5d9e-1730302740"
  },
  {
    "email":"rfadda@piuvaloreprestiti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776610682/bdeecbcc6e8686e2e2d93e1420e5dcbd-1730302740"
  },
  {
    "email":"sara.laperla7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776676218/26cfa78d6fef9cb074789824b1983e03-1730302740"
  },
  {
    "email":"camilla.valsecchi@comune.milano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776708986/6665762321488663a0e8ee9b8e8707e1-1730302741"
  },
  {
    "email":"ilaria.bonati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776774522/e4034f4275e8fc1458baf8190f81447f-1730302741"
  },
  {
    "email":"ditirrodebora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776643450/f0928565781415d1583afc40f1991e8e-1730302741"
  },
  {
    "email":"stemodica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776807290/588ea9f4ce76d427956897373c49000a-1730302741"
  },
  {
    "email":"r.casciani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776741754/041bd8871a7e7eddda8024e470ae9b98-1730302741"
  },
  {
    "email":"elisa.crepaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776872826/660749ff328ca49ce9d15711352e1445-1730302741"
  },
  {
    "email":"paola@mobilimarangoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776840058/4cca45a8c2efbc560f4ade6b47881b48-1730302741"
  },
  {
    "email":"fiorini.romina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777036666/ca37cda41b84dbbfff5ce968a86587a6-1730302741"
  },
  {
    "email":"marcella64@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777003898/efa650158886055b3d7a9867ff9f433f-1730302741"
  },
  {
    "email":"franziniangela13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723776971130/383c25464288daa0781f775e52a394f5-1730302741"
  },
  {
    "email":"alinacoiffeur@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723776905594/28a0ee92d9b653ce5dc2ea367ddd766e-1730302742"
  },
  {
    "email":"ersiliacinzio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777167738/ba21d77635abc5763cdb97b035fd6ab8-1730302742"
  },
  {
    "email":"simonapuleio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777134970/4a371509f1d087c914559fb93a9efcc3-1730302742"
  },
  {
    "email":"cinziaranno@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777200506/04a8a8df583d6c096c531519c431ef08-1730302742"
  },
  {
    "email":"federicasette.fds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777102202/93566c9ce0cf7af5835113ce8fab64eb-1730302742"
  },
  {
    "email":"laura89f@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777233274/3101701495870de012f1b1396e7cbcc6-1730302742"
  },
  {
    "email":"ombretta.patria@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777266042/6b73845878bbadfe8d7d5c657607cf48-1730302742"
  },
  {
    "email":"antonietta.sacchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777331578/b47cd1d65c4a5c01fa6f3efc379d4532-1730302742"
  },
  {
    "email":"isabellarossi20@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777397114/8593918531ec559076df53c889ae2667-1730302742"
  },
  {
    "email":"rossellaemme2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777462650/9712a14f5950f366a58d09a5ae123e45-1730302742"
  },
  {
    "email":"francesca.tomada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777429882/666e05d3179479e21b13c9f6be212b6a-1730302743"
  },
  {
    "email":"sarparisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777528186/dcbe3d3e99f0d1203d4d6191c6be663d-1730302743"
  },
  {
    "email":"ludovica@marsico-lex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777495418/7fd9c57d5e9c9a258b66d058e68374ae-1730302743"
  },
  {
    "email":"laurasenna401@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777724794/9702a79cb5708947f6e95384e78e786f-1730302743"
  },
  {
    "email":"silviaseneci1970@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777790330/09aae20188afa4757056738ede9dbd7d-1730302743"
  },
  {
    "email":"marzia.vieta@m4usrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777659258/dd7f6c796cf9e7f827ff85f85946e393-1730302743"
  },
  {
    "email":"gio.inzerillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777823098/1f90ea46a61b58512bb0f4d2dc828ef5-1730302743"
  },
  {
    "email":"chiaralugli2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777888634/c0235170c0f731ea9838fcd5875eb2f0-1730302744"
  },
  {
    "email":"marzia.sabattini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777855866/82b8ed81a543d1f31d0b3b5108f3a116-1730302744"
  },
  {
    "email":"raffaella@pneusmarene.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723777921402/77beb677c3849016f16c98e8fdd402a9-1730302744"
  },
  {
    "email":"barbara.cesari76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778052474/b6932784c3a54a784da004ebe874c1a7-1730302744"
  },
  {
    "email":"melissapirondini.mp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778019706/1f50d4a1612bff7da6bfb4db96566a47-1730302744"
  },
  {
    "email":"patrignani.sara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778085242/8caeab707ccbcfb51c54717201d49f21-1730302744"
  },
  {
    "email":"rossana.mascalchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778183546/0b84c76add5b9442482246fd9ec82d31-1730302744"
  },
  {
    "email":"camilla.petrella09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778150778/2654f9dc008fb0bb45dbd099c740658a-1730302744"
  },
  {
    "email":"p.bertoni73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723777954170/ea6c0a6d2659d117c474ae6715714759-1730302744"
  },
  {
    "email":"roberta.bacci@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778118010/2c994fe43bfd16fc1f6808365012306f-1730302744"
  },
  {
    "email":"elenadeveronico@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778314618/34eede2513f6425e3569507f893eba48-1730302744"
  },
  {
    "email":"a-crispino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778347386/eb349d2d4bef8e43d4ee495968f38df8-1730302745"
  },
  {
    "email":"gianmariatalamo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778412922/7d2a29f05ab5ae8d38e91af58677131c-1730302745"
  },
  {
    "email":"giorgiacatellani00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778445690/f78a4d05f3dca988ab48367db2817bb2-1730302745"
  },
  {
    "email":"sarahiacopini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778380154/95cebaf3a9fab8b818f7e896c8d8ace7-1730302745"
  },
  {
    "email":"cri.miranda@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778543994/b1e115ed2e8450213148cf1e1cf23a65-1730302745"
  },
  {
    "email":"roberta.guglielmo.rg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778511226/731c1f4167735e0353de1f39e78b178b-1730302745"
  },
  {
    "email":"beninialice.ab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778576762/10d19821abbdcf36a8b9a45125da8b94-1730302745"
  },
  {
    "email":"giulianar64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778642298/981bf88143989d884a8a0dd0ea7dcecd-1730302745"
  },
  {
    "email":"carla.pigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778609530/ac0c19b5a64fa78a8c8d84a319158969-1730302745"
  },
  {
    "email":"teresanegroni64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778707834/81b335cd21d6b391554904b9b6135373-1730302745"
  },
  {
    "email":"yskeggia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778773370/fcddbe694f9b28f65d75409b8da7a491-1730302746"
  },
  {
    "email":"riflar.mocerino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778740602/ce7abc38805235df6afbc35af29f419e-1730302746"
  },
  {
    "email":"rosalbamoliterni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778838906/1d49c88650e1a5df91732e454c2617ca-1730302746"
  },
  {
    "email":"stefania.gioia1207@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778675066/65175abcb54eeaa52ac3ea025ddc73b1-1730302746"
  },
  {
    "email":"mcdesii60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778871674/cc8fcfdbf3db18ccd631748ec98f2724-1730302746"
  },
  {
    "email":"aicardi@studiomontaldo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723778904442/b993388db3731f81bf85b8ba4a98d24f-1730302746"
  },
  {
    "email":"simonetta.sbaffi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723778969978/f89cd17154c29f54e21b0f92bc16c5e5-1730302746"
  },
  {
    "email":"martatripepi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779002746/a3c72b9da80dac4b45c7af8d9ad076b4-1730302746"
  },
  {
    "email":"valentina.bonadeo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779068282/e119f5962c8a574564a34a5d05e062ee-1730302746"
  },
  {
    "email":"mariellamaggi69@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779166586/f2acf0fe2e18f9c8faf54d5d39115ad9-1730302746"
  },
  {
    "email":"giardimma70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779363194/035fc1bf3fdf50f7b39a70899cf12a90-1730302747"
  },
  {
    "email":"antonellamolezzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779133818/0e1d8c2886abfbe231e1b7f29ab2785c-1730302747"
  },
  {
    "email":"soniagavazzi@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779297658/edacfd7b311f5086bf3fb89b3e9159c5-1730302747"
  },
  {
    "email":"rossovera77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779330426/2927e6ef01214372acc3d95dcae332b0-1730302747"
  },
  {
    "email":"giannaua@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779428730/2a603c6a96665f2774f52711cf47662a-1730302747"
  },
  {
    "email":"fabio.dimango84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779395962/981312f90b25911aa7aa2410002bd387-1730302747"
  },
  {
    "email":"roby.pezzoli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779461498/46a0dfdfa41b211d9b40241372792d9f-1730302747"
  },
  {
    "email":"mol.id@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779494266/7d2a263ac1e67d11c294bd61e85ad63f-1730302747"
  },
  {
    "email":"giuseppinareda@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779559802/152cc6d6de7327395094af2fa9385148-1730302747"
  },
  {
    "email":"emfocone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779527034/01b00d101e1309ecb49cc4f31acb125b-1730302747"
  },
  {
    "email":"annalilia66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779625338/1a73fbc904555147da28858fd50cda38-1730302747"
  },
  {
    "email":"donatella@conceriatirrena.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779658106/4ff443d43332f72d6529746ee5c6ae04-1730302747"
  },
  {
    "email":"alka23.am@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779690874/a39d7ebddd29ce798988a0e353e73d9d-1730302748"
  },
  {
    "email":"karin.siebenfoercher@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779821946/90a4399e8e5563fb77a84c080b9a337a-1730302748"
  },
  {
    "email":"silviagrazzi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779789178/1deffa72b49109c6e91db855d77e4083-1730302748"
  },
  {
    "email":"martinafiaschi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779756410/b25278fc9a5ecde85c795acd2785e541-1730302748"
  },
  {
    "email":"robiba29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780018554/599d7624f197ae6232f573a6dd15c8d4-1730302750"
  },
  {
    "email":"giovanna.secli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723779985786/08e9de68d1cf344e5c947e91ba853679-1730302750"
  },
  {
    "email":"m.arcari1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723779887482/7fb4ca413d917ac7abdc8bce88632e5e-1730302750"
  },
  {
    "email":"l.cannito1960@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780084090/e9a59e63f540b4aba88f5474ac7686a3-1730302750"
  },
  {
    "email":"luisalofoco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780149626/a4643390501d04b6dd8d6e90e82ec749-1730302750"
  },
  {
    "email":"cristinasapori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780116858/e93a1f91040a7c3136bc5019eb6fadc9-1730302751"
  },
  {
    "email":"marialaura.brusi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780051322/d33d933a43dd99422be8b0d9ac3cd6ee-1730302751"
  },
  {
    "email":"marinamasturzo6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780247930/e3497d27d922ca04b10c35fba3e799c3-1730302751"
  },
  {
    "email":"giodest91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780313466/9767c1ad7be5033bea32a0bc9229a368-1730302751"
  },
  {
    "email":"malbertini84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780346234/321c1d6f2fdec3779b37f8debf839ba5-1730302751"
  },
  {
    "email":"robertabelvederesi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780182394/e96e404223c1e795a132f0fd4bb0f0d8-1730302751"
  },
  {
    "email":"eugenia.pino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780608378/01f6e0274a216acc1e3f85a085d9e409-1730302751"
  },
  {
    "email":"v.perkan@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780411770/a3bfbd8108176fdae90754bcdf3cbaf5-1730302751"
  },
  {
    "email":"francesca-delp@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780379002/49c7cdfa0557f1caed7275c3a11c02f8-1730302751"
  },
  {
    "email":"ferrari.sabry@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780673914/43a0b9b3672a2052b767c2d2b02a2536-1730302752"
  },
  {
    "email":"cristina.bazzan@bwa360.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780706682/1b1ceb71abd7a49bb37064e0aeff6094-1730302752"
  },
  {
    "email":"elly1264@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780739450/063aeac99e3ce963ac7d73158edb0217-1730302752"
  },
  {
    "email":"alema124@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780837754/84b848caee37cca787827de2e59682f6-1730302752"
  },
  {
    "email":"silviac5gs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780772218/c853e6451b7143fb304a8747992c8392-1730302752"
  },
  {
    "email":"rosadandrea90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780641146/61fdd26569c9744d16f00ff41046a93a-1730302752"
  },
  {
    "email":"pa.lex@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723780936058/f5065fa5ba32025abbb2821e362a764e-1730302752"
  },
  {
    "email":"familybaiocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780870522/182fb5fe40031c49e40c7cf9320897d5-1730302752"
  },
  {
    "email":"pfaccioli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781001594/824b94f2f11686a93d17187860ad6e4b-1730302753"
  },
  {
    "email":"chiara.belli3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780903290/84c25500255a38bf8e620d40b7176197-1730302753"
  },
  {
    "email":"fedamodio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781067130/2cb29a334c40cd3c6b0ae9b4aca2efec-1730302753"
  },
  {
    "email":"tizianaperuzzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723780968826/641ac1f9bb41169de5e9718e146138b4-1730302753"
  },
  {
    "email":"morrealerosetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781165434/93ed43ab9ebd9c5091e91c49a3476b28-1730302753"
  },
  {
    "email":"moiracosta@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781034362/3c67e488f65645eda77106e33dd7967f-1730302753"
  },
  {
    "email":"silvia.fontana80@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781198202/7a76420247e190bfd8258ff78e78dcf1-1730302753"
  },
  {
    "email":"liciasigola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781230970/4dacd192dbff71fcf3d7f83f37008c86-1730302753"
  },
  {
    "email":"wendyx@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781263738/27b1610256bc493d2707ed0ee69cd099-1730302754"
  },
  {
    "email":"luigi.foletti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781329274/4742fa61d61359cf83b4f94e880be5c8-1730302754"
  },
  {
    "email":"giusemucciante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781132666/ade006382f45b10bcbbf7c3703974e9b-1730302754"
  },
  {
    "email":"diambrazeta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781394810/f17f4a52753a702afe72f76246bb9ea6-1730302754"
  },
  {
    "email":"marti.lombardo66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781460346/6ada98526a26380f68e6c9d7c1ddad9a-1730302754"
  },
  {
    "email":"carnacinastella@tiscli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781362042/c95f81f15465330dbc23fad7144dd88a-1730302754"
  },
  {
    "email":"sofia.fattorini@mps.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781427578/b85403448d290db3455abd35762ca001-1730302754"
  },
  {
    "email":"pudduros@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781493114/7d26bf743dc1d5160e0c9ca8922f2fab-1730302754"
  },
  {
    "email":"sirenera@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781525882/d79ce7ac3f6ea2c0840659af12319f3a-1730302754"
  },
  {
    "email":"pellegrini.clau78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781591418/d8c7af529b7a1f738cd51ef579f002a1-1730302754"
  },
  {
    "email":"guidopicchi@studiopicchi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781656954/1bbaf3c18c79a61239ed767aba573f86-1730302755"
  },
  {
    "email":"almerinda.dibenedetto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781722490/61b4a900daec8adc7851ff0e94b6204e-1730302755"
  },
  {
    "email":"martapergo72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781689722/6328c40feca51b18b16f0f21a7deae4d-1730302755"
  },
  {
    "email":"federica.daponte@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781755258/3a1a72bb93256aedbc2551f2070ab318-1730302755"
  },
  {
    "email":"plabenazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781820794/021ec4181f0b04068d846d950cafe080-1730302755"
  },
  {
    "email":"lorenamirizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781853562/b2d1a67ff79d8353e4570502859f67b2-1730302755"
  },
  {
    "email":"eleonora.piermaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781919098/a1bbf19257f7b49cf37bde1980ced79b-1730302755"
  },
  {
    "email":"alessandralarossa88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781951866/8fe4cc6b36542723be9ec1e60a4c4d97-1730302755"
  },
  {
    "email":"mariorav13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781788026/ca7c4979ff1995787c0c7ac1beb6b64a-1730302755"
  },
  {
    "email":"cinzia@carraragroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723781624186/bba14ce762e88d78a3fe4e42a171646d-1730302755"
  },
  {
    "email":"martina.pierboni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782050170/a7c4404b0fe4f39729c4983342545ccc-1730302756"
  },
  {
    "email":"aloiaelena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723781984634/f8f8b77479ee9cdfd99da2b9fbe0d69c-1730302756"
  },
  {
    "email":"franca.serra@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782017402/0c7a2986dd57bb0d9c6c0a973e629bc6-1730302756"
  },
  {
    "email":"patriziavincenzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782181242/6e5e84bb718ca27a2d22d5a1d26ff199-1730302756"
  },
  {
    "email":"mariarusso1275@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782115706/df274d9e3763558b634215800b2bb2fa-1730302756"
  },
  {
    "email":"c.gori@feb-srl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782082938/4bd633224c3efe3bd458c4dc884a5ea1-1730302756"
  },
  {
    "email":"elena.dalcol@omdmeccanica.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782312314/f068313b5bcea9a479e0b6c804505d8b-1730302757"
  },
  {
    "email":"irene.fratini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782377850/30ce160c3128490596e538fe55d1bf74-1730302757"
  },
  {
    "email":"letizia.cabascia66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782279546/6541dfdfe30b264a3718cfb61dea4efe-1730302757"
  },
  {
    "email":"cumerlato.g@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782410618/513d3fdfdf3a9bcd2c1dda1439153c0e-1730302757"
  },
  {
    "email":"francescagiannelli@commercialisti.fi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782476154/1fed7c85516cba600dd35d3934acdf5a-1730302757"
  },
  {
    "email":"val_2676@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782345082/9ae8e22ea0bf63b0668fb55dbfe3f2c7-1730302757"
  },
  {
    "email":"antonellatantillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782443386/938ab0b55cd6037c03187c78df7d8ca2-1730302757"
  },
  {
    "email":"laura.t75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782508922/c65ea2b194238cf6fe77e2cb382534bb-1730302757"
  },
  {
    "email":"isacedroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782574458/51e0a28e6300543350621bce54827245-1730302758"
  },
  {
    "email":"annalisa.maroso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782639994/69708c1ea025bde532f3145d67913a53-1730302758"
  },
  {
    "email":"federica.fanucchi@delgrandeninci.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782672762/8b95d7d944befb60ea503ed5b124cd12-1730302758"
  },
  {
    "email":"rita.direttora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782738298/2b6ea20fc8992bb2276e2ae268bfa8ba-1730302758"
  },
  {
    "email":"sabrina.saltabanchi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782541690/3bc3857f37be93f2befba27c27e2d841-1730302758"
  },
  {
    "email":"aleedo19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782607226/b121826394f6d1a667f664ad2bd1cefb-1730302758"
  },
  {
    "email":"biondi2008@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782803834/1d8037b3a0acfc3756fa9e42bbd4a808-1730302758"
  },
  {
    "email":"bondericabond@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782771066/9bbc702243e484110f81eff6d79b90ce-1730302758"
  },
  {
    "email":"dforetic@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723782869370/aaa8ad14bf4f4c238645ece656113c47-1730302758"
  },
  {
    "email":"lorenagargiulo01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723782902138/1650b9e1777cc1df1246e70cf35fcb91-1730302758"
  },
  {
    "email":"saraernesti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783033210/577f3ed260590d22ddad82ae8516b234-1730302758"
  },
  {
    "email":"silviamasera02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783000442/d92eac5d32a0a3330592ee117abc4ed7-1730302758"
  },
  {
    "email":"carmela.arpaia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783065978/fc18a33afc2b78f172ad8656293d3303-1730302759"
  },
  {
    "email":"pasqualina.marano@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783229818/6fd6fc7b9dc8c599c23c7f5c136fdfeb-1730302759"
  },
  {
    "email":"emanuelapelizza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783262586/840fc437db5fb947dc4f0ced26340246-1730302759"
  },
  {
    "email":"ludovica.paris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783295354/2da35fd4052deb9d58bdd1bf43a58bd1-1730302759"
  },
  {
    "email":"s.gottuso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783131514/17d7b175b93fbb600cff18084d8d1887-1730302759"
  },
  {
    "email":"rosaluciacristarella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783328122/0678c5f76b95e7fe06bb4cd8b0adfc1b-1730302759"
  },
  {
    "email":"michelaq79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783098746/179db8ebd35d630cdb991e1ffa301489-1730302759"
  },
  {
    "email":"bonoantonino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783393658/53c0f4d0f7593546262f1a15bc826905-1730302759"
  },
  {
    "email":"bettileo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783360890/fbc1bbebbd6f2a544e83947b290af024-1730302759"
  },
  {
    "email":"geppetta23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783426426/05ee888745ffcc27cfee425e360f9ca8-1730302759"
  },
  {
    "email":"cristina_trevisiol@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783459194/31552200ce7dcb81c2ad41ac170dfad4-1730302760"
  },
  {
    "email":"norina.palese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783524730/594ffcdd346eb89f3aadfc8243d348c1-1730302760"
  },
  {
    "email":"zedda.marzia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783491962/bf858ab02561ea48b30ed13eeda25f2b-1730302760"
  },
  {
    "email":"maurocaravello68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783557498/5d3670eee436f00bbf07a80c84a89c08-1730302760"
  },
  {
    "email":"stefania_storti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783688570/84196b2f6bfa1e8dd252b2660b34e1c8-1730302760"
  },
  {
    "email":"mariateresadilorenzo1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783754106/c65610ea133eb4b3be5d589a3f2ae67b-1730302760"
  },
  {
    "email":"emmacasali74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783885178/145bcf2fdb0d0a6b84825ceac41a856b-1730302760"
  },
  {
    "email":"raffi790@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783917946/f7776012490aa16d72e6bad9bff17e8c-1730302760"
  },
  {
    "email":"alessandra.zaccarini.62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783819642/bf01d6243e88a8151468668785ca04f4-1730302760"
  },
  {
    "email":"contisimona73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783950714/a70a26a6820dc5d6f4002e98ddbbdcdb-1730302761"
  },
  {
    "email":"lilianaporta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723783983482/f0d40791ff884d900a4a6cb3c124de41-1730302761"
  },
  {
    "email":"cotoiamichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723783721338/8136afeaefe81d09d258c2d9d7790c1f-1730302761"
  },
  {
    "email":"francesca.intimo.casa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784049018/d30d863b1f380b1d7379ea442b17ff51-1730302761"
  },
  {
    "email":"deboradonato68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784147322/c512c7ed84eb59df6f632256dff8122f-1730302761"
  },
  {
    "email":"siresunset@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784114554/dc70cc2b60525bc0cfcd4c52f20c695c-1730302761"
  },
  {
    "email":"cristina.venturini@mediolanum.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784180090/624d461597353d9ae65ee9e9670676c7-1730302761"
  },
  {
    "email":"simorichetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784245626/4a64fa4b8bb3ac5a55d0b788b105d28b-1730302761"
  },
  {
    "email":"nadine.messner@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784343930/6e8c4ace7f0d12d46357027c5f819fe8-1730302761"
  },
  {
    "email":"mrosa.peteno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784311162/28526d3420f0e19ad8fe7e9b2405c66e-1730302761"
  },
  {
    "email":"giuliacupelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784376698/a223aedc7092053a457521b620bc9478-1730302761"
  },
  {
    "email":"giorgiagusmeri986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784540538/d3549880e681af9267ec2b0968337fc6-1730302762"
  },
  {
    "email":"nadiaalpi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784475002/6601df21a6bab8ca4baea8b60cc262a1-1730302762"
  },
  {
    "email":"eleva10@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784409466/4339d71cb2a9512a5524a6a8743798e1-1730302762"
  },
  {
    "email":"ventrella.annalisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784442234/88df33cc533658cf7ad79d769cc263e6-1730302762"
  },
  {
    "email":"manuela.tonini59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784606074/df55a469afed57ed42eb24e110921d6d-1730302762"
  },
  {
    "email":"rosamaremmano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784573306/8cb48c7babe6567be6d6511b925ce495-1730302762"
  },
  {
    "email":"francescachianella71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784671610/e46f5324faca6a75f712db6b931dabef-1730302763"
  },
  {
    "email":"marinadelpozzo67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784737146/a7ae0764acd2a67a8a46ed8c402e62ee-1730302763"
  },
  {
    "email":"mfilingeri88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784638842/653ee636ec2400e8a3228e393f86e618-1730302763"
  },
  {
    "email":"r.squadrito@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784704378/7a4383570de16cc99075bc13e99d3153-1730302763"
  },
  {
    "email":"sbertonasco68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784769914/36413f13a00b0109fa506b1245459f6e-1730302763"
  },
  {
    "email":"marinellisonia250766@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784802682/e2840f2a0433aa2265fdf08351aa2588-1730302763"
  },
  {
    "email":"elvirapezzini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784835450/9f9ab2ff080017ac24663e04faf84c2c-1730302763"
  },
  {
    "email":"arianna.alloisio77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784868218/d5c2450e13e5f7e842eeb9b46662e757-1730302763"
  },
  {
    "email":"federica.garello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723784966522/2156cc4fdbb4b51ee08dab32afcf5f87-1730302763"
  },
  {
    "email":"paolamosolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784900986/3d4b6699beb85893dbf6a17d5d2b20f6-1730302763"
  },
  {
    "email":"ari.palagi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723784999290/ea12480e38425ec29727c907193e88fa-1730302763"
  },
  {
    "email":"elena.barletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785032058/a6f72c307247c39c9b8021b89fd06112-1730302763"
  },
  {
    "email":"fran.pont@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785097594/95e9db9df910388ce5f46be1c03f6f20-1730302765"
  },
  {
    "email":"lucia05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785130362/fa27313512ac829233924e41bc8821a2-1730302765"
  },
  {
    "email":"anna.armonia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785228666/d16b33e4b8080f511e1f5d5eeb07fcb2-1730302766"
  },
  {
    "email":"francescaterranova20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785163130/c05dfbe0e8ab1544e0f265793331b357-1730302766"
  },
  {
    "email":"gabriella.lettera1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785294202/bc114b9467000f6c1afc1d7b6dcadb68-1730302766"
  },
  {
    "email":"patrizia_core1969@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785064826/873ee1b7bdac77c1708e422f8f6abf56-1730302766"
  },
  {
    "email":"trivellinilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785261434/44b8836acff26b26455db9ab08b5ab2d-1730302766"
  },
  {
    "email":"allison.fraschini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785392506/0539dd45c41c90cfadfe4746cc257bcb-1730302766"
  },
  {
    "email":"r.chiarello@frigosystem.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785359738/a6610d44cbaf2f326c3ce22e3a8a19de-1730302766"
  },
  {
    "email":"valentino.titti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785458042/175bc9d7cf0c1538512ddfeb93f0077d-1730302766"
  },
  {
    "email":"sabrina.topcasa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785425274/72e1c5cc1d5790a2916a443660e8bd0d-1730302766"
  },
  {
    "email":"valepappalardo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785490810/1694acc4a805f7e77e885e3110ab6b06-1730302767"
  },
  {
    "email":"giulia.biasin88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785556346/819a99f5845af6724f995ee4eabff3bd-1730302767"
  },
  {
    "email":"daniela.fallini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785720186/732e5b6645e6949d480edb80c0acd5aa-1730302767"
  },
  {
    "email":"alma.rossi54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785589114/24c36b66c0e9f5fcb23897c49df97314-1730302767"
  },
  {
    "email":"cassarvanessa1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785752954/964c1438f0316f2d73efbb5f5c201422-1730302767"
  },
  {
    "email":"gabriella.misitano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785818490/d44063b7957c33cc128605dd7cfdcd3c-1730302767"
  },
  {
    "email":"dcanova73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785785722/5d3da43e4cafe85c6b66e7e5482d3cf3-1730302767"
  },
  {
    "email":"magda.mastronuzzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785884026/a9d6690ab9ec95a4345acd331bebe835-1730302767"
  },
  {
    "email":"gjosefine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723785916794/2239771f8b6e5d7950287b6b0c81c145-1730302767"
  },
  {
    "email":"patferrini58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786015098/cb19f3d8934a52ded988f9a7cd44c5a7-1730302768"
  },
  {
    "email":"simonarigano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786047866/b26ab8e211244684e6c6d2c0c32cab7a-1730302768"
  },
  {
    "email":"dott.ssa_biscaldi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785982330/4785f07a88f878c623a98f28fe3fd548-1730302768"
  },
  {
    "email":"elena.tosca@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723785949562/29934fd00274c3c4178efc29ff66bd2e-1730302768"
  },
  {
    "email":"zavaroni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786146170/61825644282e1009e11b74b853aed6a0-1730302768"
  },
  {
    "email":"mikagio79@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786178938/eaf1ed66912d7806f68e8147428638b3-1730302768"
  },
  {
    "email":"francesca_teso@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786244474/349380cb00f888a5534f7904d05b9582-1730302768"
  },
  {
    "email":"aledoddis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786211706/c378250123d6e2888a0fb121826d5f3a-1730302768"
  },
  {
    "email":"robertadellaiuto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786310010/03df816268293843ceda258c7a548805-1730302768"
  },
  {
    "email":"guendalina.dami@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786342778/3c5174cfa7462291648d285c20f18bf8-1730302768"
  },
  {
    "email":"moniquepianca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786473850/d2a52b51823e2c7352fabc35124d49ce-1730302768"
  },
  {
    "email":"g.elisabetta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786408314/215d2f735ca98a12e06a696987602150-1730302768"
  },
  {
    "email":"teresa.iacomino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786375546/5caf2d3a1d3adf6db39f0fcf4ae6f876-1730302769"
  },
  {
    "email":"jonne.cordioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786572154/2c0e9b723402086d0931ad6058b17b01-1730302769"
  },
  {
    "email":"deboni.ester@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786604922/fd4bd40e62f2d4b57061c5bac2c7d4c3-1730302769"
  },
  {
    "email":"sara.manfredotti@smeg.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786670458/740086afe9175456b6289af51f44d6a6-1730302769"
  },
  {
    "email":"arianna.vi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786506618/216e355d6fc860f72494ed8c62af958d-1730302769"
  },
  {
    "email":"ricciguido@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786637690/c076cfca04e95394b96dc0d62197c5f1-1730302769"
  },
  {
    "email":"laurag68@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786703226/ebc8a1773b4317aeeb2a987f1e656e25-1730302769"
  },
  {
    "email":"mariagabriella.mascia@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786867066/a9b807779bc2447b92d275581f314be0-1730302769"
  },
  {
    "email":"pina.scintu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786801530/b4c87911f3a0bec3389c17e4141e748a-1730302769"
  },
  {
    "email":"gallinal@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786899834/9ae2c572d12fa4219c55b147a8ce6ae2-1730302770"
  },
  {
    "email":"marikabed@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723786965370/2ec8c1f1df20bddfeedb2f8689391f7c-1730302770"
  },
  {
    "email":"patriziaarrabito.73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786998138/1206a63be846d8b0f3ba281975597ee0-1730302770"
  },
  {
    "email":"paola.rastello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787030906/c2d0b504a5f876aa244ff25eba905200-1730302770"
  },
  {
    "email":"annalisa.vanzanelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723786932602/fb810ab1e9ed92a77b7d11597b462795-1730302770"
  },
  {
    "email":"mimosa680@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787063674/2ce2a32bdf19ca086e559b953f8f0ccf-1730302770"
  },
  {
    "email":"domy.marra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787129210/37e3812d49a25bcf9c31bcff81ca31a5-1730302770"
  },
  {
    "email":"evyco74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787096442/04286c8b745bf5a981ee3a38c5d1094b-1730302770"
  },
  {
    "email":"taniaperrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787227514/2fe2518945f595c341153340f9e73b35-1730302770"
  },
  {
    "email":"mereu.simonetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787161978/894ab5b2b36711b6ba144c964a04fbe3-1730302771"
  },
  {
    "email":"dorisocularoncology@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787260282/d7704353c2b8613fb26917ce8c142c86-1730302771"
  },
  {
    "email":"francescaalberti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787293050/5b8d09fbf5ebda8f9bb92983c32e1790-1730302771"
  },
  {
    "email":"sabrina.boldrini13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787424122/c535149f84a9c4b5e2ec7cc243804a39-1730302771"
  },
  {
    "email":"concettaromano.nj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787358586/4fd6c8811100954a2aea0d6f1e4e5e3c-1730302771"
  },
  {
    "email":"spezianimargherita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787456890/8faa8f744d51c3011582a0147936ad23-1730302771"
  },
  {
    "email":"emiliana.dimaggio@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787391354/41b7d50b984917ad44f8786d5d133dea-1730302771"
  },
  {
    "email":"claudiacandia00@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787522426/2e18104527a182d469ae12cdfe54143d-1730302771"
  },
  {
    "email":"donatella.boscariol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787325818/c0cd5ed39d4010f034f85aca8c6d5865-1730302772"
  },
  {
    "email":"barluzzim9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787587962/1304a28103b51d2ebe514da5f64d710d-1730302772"
  },
  {
    "email":"alessandra.miozzo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787555194/caaff3d52de87462cad5e6cc9d3094c8-1730302772"
  },
  {
    "email":"tonio.doria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787620730/ca0a0df4cfd0196531388cafd92dfdc4-1730302772"
  },
  {
    "email":"giovannidesos@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787653498/bff10e8665ee7769b57a0ac6d1c1f5b6-1730302772"
  },
  {
    "email":"guastalu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787686266/0c314191b70a02d0366acd7d8e6711e5-1730302772"
  },
  {
    "email":"hannelore.bernegger@gmx.at",
    "url di attivazione":"https://verdissima.it/account/activate/22723787719034/9a3083b957b801a0bfb9b47b96dba451-1730302772"
  },
  {
    "email":"serena.fonte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787751802/99552b2b1e3021a05f19b5eba5b1eb4f-1730302772"
  },
  {
    "email":"edytart71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787850106/72897acfaffc3d9935dc0bb2787e3186-1730302772"
  },
  {
    "email":"fpiccardo75@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787882874/e2f43c8bb4811268f6614f2f834ef149-1730302772"
  },
  {
    "email":"rinodamico1965@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723787981178/d04eac60a6e8ddb7f86673f018a6685f-1730302773"
  },
  {
    "email":"antomandri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787948410/4eec3cf7951b046f59e3ed695b36660b-1730302773"
  },
  {
    "email":"minnitifederica1985@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787915642/88295e9532b3aae8280a8d7f7e1d1773-1730302773"
  },
  {
    "email":"cicerinutrizione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788046714/dcf311bcf6383d1af9198c268ac8ff9c-1730302773"
  },
  {
    "email":"rossella.cobelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723787784570/037df1ffc6e702f97e60742dc9bed868-1730302773"
  },
  {
    "email":"milenaspedicato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788210554/619815ad5df1e36676b6bec898a49a9f-1730302773"
  },
  {
    "email":"anna.adami@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788112250/b9c17656739d1a6675711c9d9e2bf17b-1730302773"
  },
  {
    "email":"harlessio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788079482/43d8240db82214d0a632a721a14bb431-1730302773"
  },
  {
    "email":"maripala64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788145018/23188549fe88fd7bdc3322a4986d4bd0-1730302773"
  },
  {
    "email":"gio.alonzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788407162/70c131d71bda08cadef417fdac93ed55-1730302774"
  },
  {
    "email":"anna.madia61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788308858/21e381610c9fba752d857f4d070199ac-1730302774"
  },
  {
    "email":"capriotti.eli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788276090/21cafd11b81e490af3852de3b415ddd7-1730302774"
  },
  {
    "email":"silvia.balzoni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788472698/12dc97ec1230fdf01aac77a8d5f2b158-1730302774"
  },
  {
    "email":"marinabruni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788243322/6fba9137372672347d0c6a1997b52a4e-1730302774"
  },
  {
    "email":"g.angari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788505466/98255e6113c1ba9c7c94e4b19093ad2e-1730302774"
  },
  {
    "email":"annamaria.caniglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788439930/7c3a6b9128e8b2ba1de05cc5a429dccc-1730302774"
  },
  {
    "email":"malusavio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723788833146/51975f2f6d1393833f5d39fcdfca364f-1730302775"
  },
  {
    "email":"arianna.maito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788865914/041e37191f77c5be4587fcf807677798-1730302775"
  },
  {
    "email":"alex.ratti92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788734842/ee77718fe3f5a2257a62ca803ddaa060-1730302775"
  },
  {
    "email":"nadia.lopescarvalho@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788898682/6ffac1546c5bed72d118c85e680903b8-1730302775"
  },
  {
    "email":"francescoseverini@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789029754/fb1fc41e1271be820803ed090813534a-1730302775"
  },
  {
    "email":"lucia_giorgetti@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789095290/91949f3f8830da4a2a00819abc92506b-1730302775"
  },
  {
    "email":"rossellabianco@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789062522/221c0419e60edb358c6059914fd2fbf4-1730302775"
  },
  {
    "email":"topicca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789160826/06b6d718b498530c41a62b062e14a508-1730302775"
  },
  {
    "email":"faucielloroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789226362/2240c6e08a270b70fec9e7f5f8aa2299-1730302775"
  },
  {
    "email":"francesca.corvaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789193594/75e9f55430c8b761a932b140a797face-1730302775"
  },
  {
    "email":"kappaterra83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723788996986/0a24e69b36a95afbbf1d661ead1622a2-1730302775"
  },
  {
    "email":"francescabenelli88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789259130/f524a177531f6168026957a77b65faea-1730302776"
  },
  {
    "email":"costafiorenza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789291898/34e9edd5138d5b6c28367e7b19b1fa6a-1730302776"
  },
  {
    "email":"veronica.rafani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789324666/7099341da7dc7aaa2c39826a522c9733-1730302776"
  },
  {
    "email":"tom.macc@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789422970/08c0330b86c9dda92bcdf10ce73efd25-1730302776"
  },
  {
    "email":"moniasusta75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789455738/ff8598f746c6902fcb3112dd75178d84-1730302776"
  },
  {
    "email":"gaz.marilena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789488506/9820b79c1f12319a41b52c2a49504a7c-1730302776"
  },
  {
    "email":"loredanaciano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789390202/890790bf816a9242705c7bfffda35a4c-1730302776"
  },
  {
    "email":"monicalanza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789586810/233a8f93fc01370b8c347686c0d8d7e1-1730302776"
  },
  {
    "email":"angber62@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789652346/22c211acd143156f01e24b00b8a94cb9-1730302776"
  },
  {
    "email":"silvietta.m82.sm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789685114/d75a90e2dc9434dc7c46a56ba85f1423-1730302777"
  },
  {
    "email":"acquisti.mave@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789521274/7686a32fc3622036b1f316fc1ef3fcb0-1730302777"
  },
  {
    "email":"ferrara.idarosaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789619578/dbf8ca9eb55752f28e8926026fd8ce1c-1730302777"
  },
  {
    "email":"salvatiramona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789783418/fc403e8878c89e7e0ac246759df7cd71-1730302777"
  },
  {
    "email":"acamporaclaudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789750650/da250b76b1513e28688e89697638f35b-1730302777"
  },
  {
    "email":"aggazmira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789717882/8aa360c96bec7d2635b4a31dc0ae9e68-1730302777"
  },
  {
    "email":"enrycat73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789816186/08f6ae0606e551577cfb191d5cd9c315-1730302777"
  },
  {
    "email":"ilariasatta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789881722/166fe906423ac001bb6ddc19e401aff2-1730302777"
  },
  {
    "email":"ludmila.deli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790012794/df81f9644654fe8d667bc782e6416dca-1730302778"
  },
  {
    "email":"patrizia.pacenti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789914490/26c85cd87bb1ec89580221f231927e0a-1730302778"
  },
  {
    "email":"lauradadea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723789980026/c585289fdc4c19ea8c38b499d97a1b27-1730302778"
  },
  {
    "email":"m.mini2005@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723789947258/a1e8bc91251f6d099da7696ba8fa27bb-1730302778"
  },
  {
    "email":"linda.dr.caira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790045562/8d323b8b6733396913f64fea2a46379e-1730302778"
  },
  {
    "email":"meryinlove@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790078330/b34c04f5de559e9dcc578ddec6e16bea-1730302778"
  },
  {
    "email":"laur.messina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790143866/b66c6220318b824af78c49f30695b63f-1730302778"
  },
  {
    "email":"myroslava.ercolani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790242170/53fa31cf0d45a006a5a8dc8aa6a7f83f-1730302778"
  },
  {
    "email":"a.loprete85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790111098/0996a99b50efe57108cf0f25b9cfde8a-1730302778"
  },
  {
    "email":"margherita.candela70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790274938/3272f05830cf0c5cd7d8b1516a0e8a3f-1730302778"
  },
  {
    "email":"mazzi.serena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790176634/cc6b64845a6a6489081aaa3cac8080ca-1730302779"
  },
  {
    "email":"pina.francolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790307706/de671b928a1e55c713d459894998b9b3-1730302779"
  },
  {
    "email":"simo.pisani65@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790340474/541a96a91df68c082c310fa71ac7e5bd-1730302779"
  },
  {
    "email":"silviacortelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790438778/63c9e5777490b1eb6e1e7918060df1f6-1730302780"
  },
  {
    "email":"mtrento@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790373242/831ec95a9f62abf07de4c24c1c5d74bc-1730302780"
  },
  {
    "email":"azinsantoro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790471546/08294626fcb66cf46bebc4515b7eb495-1730302780"
  },
  {
    "email":"louise@louisegalvin.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790504314/4551a4fcb3c5de58a134b2c75b8eb8f2-1730302781"
  },
  {
    "email":"rosacipriano.it@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790406010/17f159e441face0777c7a514be752a72-1730302781"
  },
  {
    "email":"sonosenzastivali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790537082/0deebc52c4f88ffeb737637af9aa7c28-1730302781"
  },
  {
    "email":"lally_f@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790569850/32a4cab720c4bc80644c23be2c3ea54f-1730302781"
  },
  {
    "email":"alessandra.bi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790668154/6ec2551588c660364c379d80328b0723-1730302781"
  },
  {
    "email":"dorianaballestra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790635386/9c0c466fafe1bdb750d2514f1a85e585-1730302781"
  },
  {
    "email":"marcella.megli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790602618/95e316364fb8a0b60e26b2c54808423f-1730302781"
  },
  {
    "email":"adelina3mps@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790766458/bcea3dc3b61bd7a1954eff1b7ba9baa0-1730302781"
  },
  {
    "email":"s.pianigiani13960@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790700922/903f7f07494d093843b46db589450825-1730302781"
  },
  {
    "email":"francescav.78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790799226/64585b80fe7dbb32b0664499eaeb7757-1730302781"
  },
  {
    "email":"roncaligiuliana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790897530/9112a673d0f3825318c8bbca5b472c3c-1730302782"
  },
  {
    "email":"michelapassadore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790963066/55be4520014258f032ff99246ed9efde-1730302782"
  },
  {
    "email":"veronicazingone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790733690/9a9e48a6dfc78623ca4dc42898da0b90-1730302782"
  },
  {
    "email":"carolinka81@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723790864762/a38a066632609d62b20ad319b3ed27ed-1730302782"
  },
  {
    "email":"lisaleon997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791028602/84dc50bec72839290e721fb0e4a7256c-1730302782"
  },
  {
    "email":"stefycam@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791061370/7946575f0a5ee1d943c3cc271bacdc4f-1730302782"
  },
  {
    "email":"mara_piscitelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791126906/41aabf4a1406cf0099a2aea8d5263313-1730302782"
  },
  {
    "email":"picciutobeatrice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791159674/f857c4da45992895ddebc31afaa988ad-1730302782"
  },
  {
    "email":"alberta.musetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791192442/efe5345df92889d27176ba24364cf435-1730302782"
  },
  {
    "email":"stefanianav@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791225210/f600cd5c9a58e00816da0d5e2d01c7df-1730302783"
  },
  {
    "email":"emanuela.penati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791257978/d1a860cc73f5b34f748d63cce8b3f987-1730302783"
  },
  {
    "email":"criago3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723790995834/f5a4acb9e103eeaaa9031c5b5bb239c2-1730302783"
  },
  {
    "email":"mariateresafasanaro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791290746/58e4d29ec8b68f00b299c2dcd2701329-1730302783"
  },
  {
    "email":"eleonora.amilcare@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791487354/7afbb66d1132f8bc06f7604fa13a1015-1730302783"
  },
  {
    "email":"annamariamaffei2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791421818/665fbe1f045bfc6e292e5bf4eddde475-1730302783"
  },
  {
    "email":"valecns@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791585658/5b1e18cc8690b550dfb73759fccfdda8-1730302783"
  },
  {
    "email":"zancasimona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791520122/32194ec965e074a7901bcc357e10e4ab-1730302783"
  },
  {
    "email":"martarubini78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791683962/1879e79a93288b5e033d8ec3c15f58f5-1730302783"
  },
  {
    "email":"pierluigi.facchetti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791618426/b35072b74b1da6b4d44a7490788d1f85-1730302783"
  },
  {
    "email":"franca.sambo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791651194/561340fb3067f009053f49fee60e6941-1730302783"
  },
  {
    "email":"marta.otto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791749498/13eaabd51810fe06a36ef94da5f248f7-1730302784"
  },
  {
    "email":"asiacarmelaferruzzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791815034/93760fac4e6c4ea1330568ffbf75471d-1730302784"
  },
  {
    "email":"fabry.marchesi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723791913338/a04a9a0a2d5adb590ec08989784840d0-1730302784"
  },
  {
    "email":"angela.giacobbe86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791880570/8a5718cb45de761e66e90b44565ff75b-1730302784"
  },
  {
    "email":"fannyb1608@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791847802/26023580706206fb7bedc454ede47077-1730302784"
  },
  {
    "email":"viviana.pedroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723791716730/9fcee02584a3c0b69b0590a3b87d61c4-1730302784"
  },
  {
    "email":"evelinagualtieri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792044410/12bae096827af21e363384021b9f06e3-1730302784"
  },
  {
    "email":"ellerremme09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792109946/645281095a2ad1e62187ffbc41414a42-1730302785"
  },
  {
    "email":"manliananussi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792011642/abe771c7b043d0b564cb2d6b7ee169c0-1730302785"
  },
  {
    "email":"rgiuffreda@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792175482/fdfbeaa6ffa4e384bc0c78cc117c1a4f-1730302785"
  },
  {
    "email":"meluccia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792077178/261e0ebcae25b942e879d77d45f28053-1730302785"
  },
  {
    "email":"emgandolf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792241018/2f02d1341fbe6d943dcff4acafcb2973-1730302785"
  },
  {
    "email":"rigobello.laura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792273786/6139ec7454382387a98f47a2cc2e7173-1730302785"
  },
  {
    "email":"apicrespi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792208250/4b1ccceb872ad9ee445f7f64652be0b2-1730302785"
  },
  {
    "email":"mg.cacciamani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792306554/1bf21e11ce0895b721321e369df40470-1730302785"
  },
  {
    "email":"bassetti.laila@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792372090/60f8988ea16ba02e63bef7a3140e678c-1730302785"
  },
  {
    "email":"lisa72c@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792339322/8916c4b043dbf710feaa972bdea434d0-1730302785"
  },
  {
    "email":"antonellapagliarini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792404858/36c0487c67506c840fe2cf2ed4c87f53-1730302785"
  },
  {
    "email":"giada.asquini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792470394/cb0678780e17da22db4f2b653574a15b-1730302786"
  },
  {
    "email":"matteogiulia50@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792503162/83295daec525d9d19964e65db507df25-1730302786"
  },
  {
    "email":"ligoriovittoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792535930/c5a8c2ddec86639b57303034e60e517e-1730302786"
  },
  {
    "email":"giuliana.bampi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792634234/4fac81987a539ad4a079805d22cbb4b5-1730302786"
  },
  {
    "email":"roveretofederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792667002/0e83f97836381571cd5d4686ab928257-1730302786"
  },
  {
    "email":"conci1980@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723792568698/e126014c37f918cd10923e10e2244d08-1730302786"
  },
  {
    "email":"morenapimio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792732538/d2aa8b504cd3a5414815de02614f7a5e-1730302786"
  },
  {
    "email":"oriana.lamonica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792699770/3c690978cc84217fa2eab0fab801a348-1730302786"
  },
  {
    "email":"giorgia.meneghini11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792830842/d4f0cbeedd21d76dc6c4006c384fe7a9-1730302786"
  },
  {
    "email":"enzasantese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792863610/6ac2565ad4044544b0ce7bc031a0a8a7-1730302786"
  },
  {
    "email":"manuelamorghen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792896378/538931e7ac357b1359b1614c74439715-1730302787"
  },
  {
    "email":"angela.dimarzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792798074/f3152aa82292dbf7c5349cd277173eba-1730302787"
  },
  {
    "email":"chiarapierrotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792961914/c1fc5db08fcd45dd2240b52d9e02a788-1730302787"
  },
  {
    "email":"elvia.giudice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723792929146/2d87d31fc806f219fe92c84bfc556c99-1730302787"
  },
  {
    "email":"tartarelli.a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793027450/4c8a1aeeee064edc22b1affd9b1456e3-1730302787"
  },
  {
    "email":"maria.vaudo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793060218/a576bd52d84c241abcfe84062d791846-1730302787"
  },
  {
    "email":"maryriva@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793158522/2fc60afe4d21b26cef751f73f7e66714-1730302787"
  },
  {
    "email":"lucrezia7rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793191290/bee2e3e7c1f13ceb51c8d3fa852ff567-1730302787"
  },
  {
    "email":"serenavettori05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793125754/13935702b7404474b9f022cda2772245-1730302787"
  },
  {
    "email":"pampaloni310744@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793256826/a1bbc9dbc4455364cd3abaf622aa4c90-1730302787"
  },
  {
    "email":"mariateresaamata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793289594/ab8afe6fef24384b3fe37f888a883506-1730302787"
  },
  {
    "email":"emilia.falcone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793224058/4bd2051fc138d2d2696f6d62ca087b14-1730302788"
  },
  {
    "email":"pino.franci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793322362/0641eae1ca0d6ac79a7da6834bd6b4a1-1730302788"
  },
  {
    "email":"vince.nancy@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793486202/4f5a92573a32f48d4d67b9f8c53bd532-1730302788"
  },
  {
    "email":"annacarletto.5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793355130/730ccf57fcffaccf35895ea88ed7ae77-1730302788"
  },
  {
    "email":"lasimpleplanner@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793617274/634599d17160e826f96866fd8abd09e7-1730302788"
  },
  {
    "email":"lauracozzi.73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793584506/eef5bbc8ab6dde931a69ed3652860dd3-1730302788"
  },
  {
    "email":"rosabelluardo67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793453434/6e3b6881c12bc7a00f7438450d89ecfc-1730302788"
  },
  {
    "email":"laraparmeggiani1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793682810/b26ffd2a7de581946826078bd029f9e8-1730302789"
  },
  {
    "email":"valentinapassero81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793518970/ab9d270bf6fec4505aec69debc906e51-1730302789"
  },
  {
    "email":"antonella.melfi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723793748346/c68cc8ff7ee0f5c6d4caad64ff079e2b-1730302789"
  },
  {
    "email":"sarabucci1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793846650/576c2a0813aa69a668ac65986b64ab84-1730302789"
  },
  {
    "email":"alessandrini.b@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793715578/7ac7b54629363494b3971b6d9982ec5a-1730302789"
  },
  {
    "email":"robedelma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793813882/7f556af4edc825dc9e859187a45a64ee-1730302789"
  },
  {
    "email":"giulianamalandrino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793912186/b82cd9e846ef3e0ad77e0cba41dc6484-1730302789"
  },
  {
    "email":"s.caffarri@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794043258/517d41829084d8c898872905e31e76ba-1730302789"
  },
  {
    "email":"annalisa.magini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793879418/546d247ee144411cb424cd00be32ef67-1730302789"
  },
  {
    "email":"dina.maglietta70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723793944954/ead175bd65f58cf24d63570f2865fdfd-1730302790"
  },
  {
    "email":"moniabrunetticr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794207098/0a55eeffe406ead06031b777cd26c0e4-1730302790"
  },
  {
    "email":"alessandra.gherardi@gherardi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794239866/b8058fa9dbd02547e20b9f0d08843d22-1730302790"
  },
  {
    "email":"fanny.bigoni@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794305402/dfd8a4cd835b9013589149ec5b18862a-1730302790"
  },
  {
    "email":"pelattielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794272634/4f94d4c187efb8935bda0a1e6284f7bd-1730302790"
  },
  {
    "email":"danielaborgioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794076026/a6ade616085a3c993e8a4d7693dd880f-1730302790"
  },
  {
    "email":"arturoeufemia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794338170/b84397fa3ebc0ab7c25f7c5e67dc4a16-1730302790"
  },
  {
    "email":"letiziamcmac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794370938/5064bfb177e866ead8bd08be38d240e9-1730302790"
  },
  {
    "email":"sofiamarti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794403706/b983b343b8aa15a778c2f1ae0ad122c7-1730302790"
  },
  {
    "email":"delsal.patrizia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794436474/d98fe56f6b6119d6f052108b5b6a8a01-1730302790"
  },
  {
    "email":"info@mozzone.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794469242/71d6f6298b30985b1bcc5b8e5e357bbe-1730302790"
  },
  {
    "email":"roberta.cobelli8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794567546/a08417341e6697709e818e5a4073d937-1730302791"
  },
  {
    "email":"emanumaya@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794502010/869dc482c1fa8110f61198326bbffbc2-1730302791"
  },
  {
    "email":"1000susy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794534778/d7c7380cd90a73c0457aa5142b8f9fbb-1730302791"
  },
  {
    "email":"c.gazzale82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794633082/b75917cc0e93e8f53052e5929932b1b6-1730302791"
  },
  {
    "email":"emanuela.gabaldo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794600314/d72e04b29ef231ab45fb6086aa5e7d32-1730302791"
  },
  {
    "email":"am.mastrangelo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794698618/9d7f8ce2daaf3d210c09b7a13ef7bc81-1730302791"
  },
  {
    "email":"denis.virgili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794764154/7e2940f145c4df3ce8f667c0e27e3965-1730302791"
  },
  {
    "email":"giusybonanno1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794829690/5b631406737b39d45b8c3550d1dbf2a1-1730302792"
  },
  {
    "email":"cristiana.peyla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794796922/d4a0bb4822753e747b6645c30581d335-1730302792"
  },
  {
    "email":"paola.casta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794862458/d16faa7b8076607ad4f1d3c881edeb73-1730302792"
  },
  {
    "email":"clab73@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794731386/f3feff151cae64ea77d69e471943850f-1730302792"
  },
  {
    "email":"michele.amoruso@orasesta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794960762/10f7586c1e63d4e47f4cfad530774dd8-1730302792"
  },
  {
    "email":"rebecca.montanari22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723794927994/46c7f2e2699681e433209c5a862918c3-1730302792"
  },
  {
    "email":"antonellamunafo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723794993530/cd99a44375b13f80950babf565a2a76a-1730302792"
  },
  {
    "email":"paola_aiello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795059066/9c2cf141fa639671d59844aafc801325-1730302792"
  },
  {
    "email":"sofia.menaguale@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795124602/54085159579c12da5533c0b385ca14d8-1730302792"
  },
  {
    "email":"antomassiro71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795190138/dafac1287b51646def4b4c9e288a4884-1730302792"
  },
  {
    "email":"lara_victoria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795091834/b26f21dc58c0a795ced63c7ca1c892a6-1730302793"
  },
  {
    "email":"monicabale@lanostrafamiglia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795255674/b40eb2b2fd36723f08a7210c32282e05-1730302793"
  },
  {
    "email":"eri.87@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795157370/cb0ccf0e8c98567e9a50f2daf6f7c7d0-1730302793"
  },
  {
    "email":"vera.ferraretto89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795288442/63fa0de723e73b00b02951488c3cd83a-1730302793"
  },
  {
    "email":"littlepomi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795321210/9071ad992d2dcfa7e62a67c90f069964-1730302793"
  },
  {
    "email":"laura.lagorio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795386746/35c6c13c3ebb4b773d0ed2fe9c91aa64-1730302793"
  },
  {
    "email":"crlgmr81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795222906/b46c737b91f353ec84129d7049cfa760-1730302793"
  },
  {
    "email":"andripronce2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795517818/6e4fd96329c09e30053f0e5ba888a3d2-1730302795"
  },
  {
    "email":"soniagiro1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795583354/f7621f93bb5b82569907cc547c29176f-1730302795"
  },
  {
    "email":"idabruno04@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795485050/4f751ecb1cc13be6a628fd7b36aa005b-1730302795"
  },
  {
    "email":"ale66@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795648890/654ba3e8619852e023ab54d1fb815e8a-1730302795"
  },
  {
    "email":"elisa.antichi10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795681658/c18c6a5fa2ee472ec60318d5bdb75dbb-1730302795"
  },
  {
    "email":"stefanotorazza12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795845498/29f16cb0d531e2ef8d322b4fe8a7ab66-1730302795"
  },
  {
    "email":"eriz1972@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795779962/773bb8b74ee9b48788dd854face15310-1730302795"
  },
  {
    "email":"mbernini65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795616122/ed6fcae5d8a54e7586d3bfbe4c1e55c8-1730302795"
  },
  {
    "email":"manu171@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795911034/d356bfe0eff1aa9642d79e424e1caad6-1730302795"
  },
  {
    "email":"alina_urculescu@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795878266/1b35b49c5fdbc18e4aa2ec31d1769060-1730302796"
  },
  {
    "email":"gabriele.pin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723795943802/60d4878535c2e7dc83755bc28abcb169-1730302796"
  },
  {
    "email":"elisapiasentin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795976570/06a7dc5a2d26b6ef8372dd4860567fd7-1730302796"
  },
  {
    "email":"serena.berardi.sb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796009338/95e063fbea10903d897b756d03e7fca3-1730302796"
  },
  {
    "email":"mariangela.longini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796074874/3556d1283dd33a4515725b0fdb7e9f58-1730302796"
  },
  {
    "email":"gacquisti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796042106/1215eff6908500936f6e018de129e987-1730302796"
  },
  {
    "email":"rosanna.stio@assicurasrl.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723796107642/dc511777290949840f582ec558aba21a-1730302796"
  },
  {
    "email":"ruiuemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796173178/7d860a42b1908c20c2af22e3349e3271-1730302796"
  },
  {
    "email":"naniamariaconcetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796205946/10a5d0d0304cc3f4bd1fcc6297e511d6-1730302796"
  },
  {
    "email":"pfornari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796271482/2005a6b0a7bf2e7e2e08def7da9797d2-1730302797"
  },
  {
    "email":"stefy.mengoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796238714/deb752a1794f191c20cf02362458e38f-1730302797"
  },
  {
    "email":"chiaramaragno1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796337018/685259fcbb934b68b7cd237c4b073318-1730302797"
  },
  {
    "email":"rossi.adele@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796369786/a4ccbc3fa5da2702cbf7d98189dffed0-1730302797"
  },
  {
    "email":"cl.dannibale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796402554/f50abc52228e57adc99173de93047da5-1730302797"
  },
  {
    "email":"cecchielena@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796468090/f984f51bd1a00ab73d8bce7f811c4d7c-1730302797"
  },
  {
    "email":"iaponica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796533626/0c03925a37e23e4f4dcaeb2b4701f517-1730302797"
  },
  {
    "email":"rossanascaglione@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796500858/c4bcc2ec20c2507ea8222f4bff44a4da-1730302797"
  },
  {
    "email":"roberta.discanno@libeto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796631930/83f3942c5dd0c68a910daf1a66ba73aa-1730302798"
  },
  {
    "email":"larissabianchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796599162/456f3304e47acda37731fe09754d135b-1730302798"
  },
  {
    "email":"silviabucciarelliabc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723795747194/9ce036911355321e2c693f3aed423d4e-1730302796"
  },
  {
    "email":"emma.c@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796697466/c2ff2da733f4862bdab6a755479665ec-1730302798"
  },
  {
    "email":"emilybt_2020@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796566394/27532ff1c67c57e65ebcc7cc72035d1e-1730302798"
  },
  {
    "email":"silvanavullo0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796763002/8723f393cef3570bd8603e148f2da37f-1730302798"
  },
  {
    "email":"cate.desantis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796828538/c9421628d7c2a2cfd0ae7a4e0b55724a-1730302799"
  },
  {
    "email":"denisuto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796861306/cbf4c4b178a2a1c33d7d5ead92862f86-1730302799"
  },
  {
    "email":"antonellacaravita@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796795770/9bfef6feea7f85376062c6ad00626d2c-1730302799"
  },
  {
    "email":"dona.sti73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796664698/47b2e015ed337875392ff093891e4ea7-1730302799"
  },
  {
    "email":"marinadirenzo58@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723796926842/5df399a25ec6ebaa42b9333764012cd4-1730302799"
  },
  {
    "email":"donaimby@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723796894074/4c176982400313e00a92f3cd61930277-1730302799"
  },
  {
    "email":"concetta.1019@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797025146/24af7d662f2df2e2cdbcfa8c6ce9dfcf-1730302799"
  },
  {
    "email":"carlamotta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797057914/e9486e510585ef4122d2f2ea40f44e0c-1730302799"
  },
  {
    "email":"elena.gradoni.1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797156218/60061443a93f394bcb82236bb87ca888-1730302799"
  },
  {
    "email":"michele.ilgrande@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797254522/45f63a7faa47bf641d01e35a7653973f-1730302799"
  },
  {
    "email":"annatreltd@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797188986/c251324f697d2f30456f332e2470930c-1730302799"
  },
  {
    "email":"cristina2009vr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797221754/e45567e1cc0cb3f468488c08ea8940d4-1730302799"
  },
  {
    "email":"letizianicotra@yahoo.iy",
    "url di attivazione":"https://verdissima.it/account/activate/22723797287290/045bfec58b3b2ba852244f33b3d7a9d3-1730302800"
  },
  {
    "email":"laura71bertolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797320058/aff5a1d1fefb19d7c46b35e5ab572d71-1730302800"
  },
  {
    "email":"maryago81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797385594/bbcecd97c6773c2236180b221f2bf45f-1730302800"
  },
  {
    "email":"ericagian95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797352826/0ec20f81fc73c517ce90c22c8410c92f-1730302800"
  },
  {
    "email":"fabiolafontana.pi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797418362/fe4810543d3ae97173a29e627d82c766-1730302800"
  },
  {
    "email":"francescatredici1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797451130/a586958529b622487c0cc0b2b4387e39-1730302800"
  },
  {
    "email":"serena.giugliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797483898/05663bce083048a7ddf4ec51bb0660a4-1730302800"
  },
  {
    "email":"rossella.ragazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797549434/7c0e75a16da46c3c4d9205f042e62fa3-1730302800"
  },
  {
    "email":"marabaldini51@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797582202/fa8dde71a020aabee3e94cd8e1be54e9-1730302800"
  },
  {
    "email":"ann.pappalettera@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797614970/995b99a1da75efd179f03cd0e04b4f7b-1730302800"
  },
  {
    "email":"lucia.comerio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797647738/08f3a90693938dba5e733d93f4d054c7-1730302800"
  },
  {
    "email":"laura.2g@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797680506/060193ea23d6d3b3dbf7b3276fada52a-1730302800"
  },
  {
    "email":"kalincatargetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797713274/1c8b53b564201ab2f6b89d548a21bfe6-1730302801"
  },
  {
    "email":"kasiak79@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797877114/0a62879942c163af155d87f526ff8f26-1730302801"
  },
  {
    "email":"rosannabertoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797811578/d92864b7fd58b9c7df9622f60063a9e1-1730302801"
  },
  {
    "email":"carosella.marisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797909882/f72cc7ca22d893188d2c99889004b5e4-1730302801"
  },
  {
    "email":"simona.gasparini1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797975418/04b5a8e8bddd6a0570b8bea0e7106fac-1730302801"
  },
  {
    "email":"canziogenny3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723797942650/b40b072401f3c180f07d6dce55d2b015-1730302801"
  },
  {
    "email":"mohito11@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723797778810/47dc44c7a4e3104f3648096ad3591bd7-1730302801"
  },
  {
    "email":"ivanalomedico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798040954/26a89bf2897a771e0c405f824624c251-1730302801"
  },
  {
    "email":"antonella.cabazz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798106490/c8fa5734020a67423c258f41f75b886e-1730302801"
  },
  {
    "email":"pc@quondamdesign.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798139258/39d3ec5c1af1fae251e040a4df8f20f4-1730302801"
  },
  {
    "email":"ilaria.silvestri72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798172026/92699a729a10a59e6ea44e89df3a8a0e-1730302801"
  },
  {
    "email":"valentina.lana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798204794/4fd7a9a2ec776160fb46e689754b3968-1730302802"
  },
  {
    "email":"ri.lex@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798303098/b4e8f136405407aae45210bb99a1eddc-1730302802"
  },
  {
    "email":"rebecca.montanari@unibo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798237562/a3edb4827c3c56ae92faec4ac9d0de7b-1730302802"
  },
  {
    "email":"tiziana.cane@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798335866/2f141724caccbd2581946d780781e943-1730302802"
  },
  {
    "email":"danieladalonzo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798401402/c663fbcd399da1b75e886cd260ea2a29-1730302802"
  },
  {
    "email":"elisabettacarpignoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798434170/afb83715f394e5031ea2dfe9bf115150-1730302802"
  },
  {
    "email":"cristinapltr@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798466938/a8192a745739f505cef032d22dfa3ab9-1730302802"
  },
  {
    "email":"giuliatavanti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798499706/4b4cf60621ea02bdff2503a742d2367d-1730302802"
  },
  {
    "email":"marisadetoni68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798532474/23aa7db15181bca68662b2f620339c79-1730302802"
  },
  {
    "email":"francygiuly1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798663546/c14f971f763d9bcfdb002ac5de51dca5-1730302802"
  },
  {
    "email":"nadia@granitidallenogare.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798696314/a24e3b3d5d0b9dadc8d6f4ddd6e82ccb-1730302802"
  },
  {
    "email":"mariamignano82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798729082/be8bbb0de9704f7ee4d005c0b42fc4de-1730302803"
  },
  {
    "email":"ilariacoppetelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798565242/f848db723d8bbc1dad8d7d49bff30a8b-1730302803"
  },
  {
    "email":"lorenzajachia68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798761850/3aac567b3cb8d50e93f278a675758d71-1730302803"
  },
  {
    "email":"bartolomei@studiofranchi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798794618/5d34c98e1e033f779c6c736122ff706b-1730302803"
  },
  {
    "email":"nuova.cosmet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798827386/550317934fbc2edbd8f49d2463c97698-1730302803"
  },
  {
    "email":"serenamalpaga88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723798860154/c5d58155a6bec9a4516e180067f87b10-1730302803"
  },
  {
    "email":"alessiaceccanti74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798892922/dbb6c9041b8da8d17295e17e48158191-1730302803"
  },
  {
    "email":"beatrice.sabatelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798925690/a8fb8474e3989218a759c89b916097d5-1730302803"
  },
  {
    "email":"elisagussoni1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723798958458/9b2568877559e5b96d9d86bfba7d34f4-1730302803"
  },
  {
    "email":"ilariapesce00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799122298/025b5f8c3916428e93603e7ce5444ef8-1730302803"
  },
  {
    "email":"luciabiagiotti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799089530/8daee2c05986d9365403cd2b9684afe5-1730302803"
  },
  {
    "email":"vanessa.gagni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799187834/353efad2ada92652e029aaf5498a9340-1730302803"
  },
  {
    "email":"natasha.belcuore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799220602/60551609939be74deaacf462a0e80c17-1730302803"
  },
  {
    "email":"francescapresotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799286138/6e15d03161b25ebe05858b993bf71df0-1730302804"
  },
  {
    "email":"ale.moro1973@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723799318906/718e4f311b1f34242d981700f482bbe8-1730302804"
  },
  {
    "email":"nicolenervi95@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799417210/548177f5cbfed7010776388dbb1ee08c-1730302804"
  },
  {
    "email":"antonella.lutzu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799351674/6a325291423e162824edf799b07dd41b-1730302804"
  },
  {
    "email":"arlindamasha@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799449978/cffa785d75285bf8dff23ea2755462c1-1730302804"
  },
  {
    "email":"chiaramerlo36@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799482746/269fbdbff12405af3a85bac91c7eb4e1-1730302804"
  },
  {
    "email":"sandra.tulipano30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799515514/f7ec222e77eef1e68dcc8ee90714b59e-1730302804"
  },
  {
    "email":"energia2020.psg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799646586/6eff7ed67f9408171d6fd17792aff02c-1730302804"
  },
  {
    "email":"elipetrini20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799679354/ec49c9d7111e9a040bc38a258059d97c-1730302804"
  },
  {
    "email":"roldoantonella18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799777658/69eca5e7ec2060417e4676ab51a23c26-1730302804"
  },
  {
    "email":"lanzonilucia64@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723799843194/b1c619cbccde010269e4474fa02fc0f9-1730302804"
  },
  {
    "email":"giasmario@yhaoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723799810426/664cde41c5f80a4ad4f12065b9e2de30-1730302804"
  },
  {
    "email":"antonella.cristarella1985@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799908730/08a64a69c9dc1f13a7b49e50183a8269-1730302805"
  },
  {
    "email":"francesca.busat8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799974266/fdcd13437c02da1522d56f19ed0729a9-1730302805"
  },
  {
    "email":"luigigambino1999@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723799744890/36d6f0e3a07d129052691d4e86d20f30-1730302805"
  },
  {
    "email":"cafa.rossana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723800072570/4018241e8df71781f3e815b79590182c-1730302805"
  },
  {
    "email":"elimedde92@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723800039802/892b7a0557ddd8408b6ac9c29116b7a1-1730302805"
  },
  {
    "email":"antonelladurante25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800138106/992753ae78d7f9eec54443d166e15fb3-1730302805"
  },
  {
    "email":"elena.ballerio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800301946/b70cd045dab3de40f786ef2a1a47f9cf-1730302805"
  },
  {
    "email":"lorucri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800400250/fc7793b48079f0276643a152ca7151f9-1730302805"
  },
  {
    "email":"babispazioporta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800433018/9c868bf5f9cc2f1ae30ee0f3b48d7c1b-1730302806"
  },
  {
    "email":"calvanichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800105338/aa749697aca49e499ea336afb15b90f0-1730302806"
  },
  {
    "email":"fede_eli89@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800465786/52b60c710f7a48ae7dffd4d3ca167bc7-1730302806"
  },
  {
    "email":"lorenza.zucchelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800531322/316de0ca25c6dbe30b777acfacd81330-1730302806"
  },
  {
    "email":"zelda062011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800564090/3a4ec8c8fafdd7daf216331eeb4b70ee-1730302806"
  },
  {
    "email":"monica.pampaloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800367482/704b8a15b5b20283be0aba5785364412-1730302806"
  },
  {
    "email":"paolasteffani79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800629626/bc0f38d98718a334c39e0d16e564371e-1730302806"
  },
  {
    "email":"alimentaricoppola@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723800498554/c08599b8d30d660847e263509fd97085-1730302806"
  },
  {
    "email":"marilena.madonia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800695162/0ee0624c8ffbd4282914b40b3f3d5d92-1730302806"
  },
  {
    "email":"monicadichio13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800727930/65227b070f15302e14fd2fcc89db2d69-1730302807"
  },
  {
    "email":"morobert25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800760698/1082d66d35b155633ee69d9c2c564d98-1730302807"
  },
  {
    "email":"elisabetta8@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800793466/5f34715397cbe6f376b207ed9b89e0a5-1730302809"
  },
  {
    "email":"kparys@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800826234/4552628d440b7d7ff15135d4459d6867-1730302809"
  },
  {
    "email":"cristina.marchetti1964@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800924538/93684dd201b6723bab9b22391d549941-1730302809"
  },
  {
    "email":"loripao@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723800957306/378fbd950cde3f4c05f4f3007b3d1cb8-1730302809"
  },
  {
    "email":"stecampicelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800990074/0d2e6406b5eaf386f5acc254a961d513-1730302809"
  },
  {
    "email":"sbenvenuti92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723800859002/9f0c91a4b6e74d25b68775cf5e86d253-1730302809"
  },
  {
    "email":"silviamoretto15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801186682/d81206366f74807d332822f42c098dbf-1730302810"
  },
  {
    "email":"sabrinabia78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801055610/c1b33aa19851059de8c864bedcc23506-1730302810"
  },
  {
    "email":"stefy1504@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723801252218/328991de285e91cacbb50dffa8bdef78-1730302810"
  },
  {
    "email":"florianapupa@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723801219450/55d6aeeb86477000f0231c3ce362434c-1730302810"
  },
  {
    "email":"scacf.alt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801022842/534f4d9caec5557ad9f759176ffe4804-1730302810"
  },
  {
    "email":"santavavalle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801284986/549caeb498a4247e2a20caff1ff15ce5-1730302810"
  },
  {
    "email":"cstringari@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801350522/c6b02d805636dff69496fe82c4446d24-1730302810"
  },
  {
    "email":"valentinarosini.rv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801383290/3d686519bc3024000ccee075fa9185d0-1730302810"
  },
  {
    "email":"racolla.cinzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801416058/32e426fb60c598ab77a7bb6ca052db42-1730302810"
  },
  {
    "email":"annamaria28687@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723801448826/816432fa2681909e50732e3597cba008-1730302811"
  },
  {
    "email":"roberta.micali2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801514362/ec5ac7f383920a9b50364023f9e7f252-1730302811"
  },
  {
    "email":"monica.dilodovico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723801317754/ef02940c6513712a6088fd50516a650d-1730302811"
  },
  {
    "email":"viviana.richetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801612666/220315870be760d9a47040b134d6061d-1730302811"
  },
  {
    "email":"paola.marino01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801645434/78190dc5a919b7eb146d6a393d98aa9a-1730302811"
  },
  {
    "email":"silviatrisciani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801547130/ffb85768280b8a1b258dbb6080bae37c-1730302811"
  },
  {
    "email":"giovanmosc327@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801743738/ef59553ce6351f864e9c4769f2039e28-1730302811"
  },
  {
    "email":"maria.fasoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723801776506/22ac0dcbb1f331b609d84822fe16ec37-1730302811"
  },
  {
    "email":"patrizia.db@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801842042/2273fa52f8cfcf3e906ecd5d4b7bec10-1730302811"
  },
  {
    "email":"carlabriccolani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801940346/b0f39d4972a2e3cc7a9b8f0384401585-1730302811"
  },
  {
    "email":"sabrinamarus@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801907578/f5687e077476db86f111d8b1bffb8b2c-1730302812"
  },
  {
    "email":"maria.capasso197208@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801973114/6a20b24e93c4f5cfa9971f2ae79607ba-1730302812"
  },
  {
    "email":"simo77.croci@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802005882/76b10e6bcbbd4bcf5426a30856f1791f-1730302812"
  },
  {
    "email":"lubica.vysvaderova@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802071418/bc37e8df60ac31299d488fe7ee9c058e-1730302812"
  },
  {
    "email":"patriziapeg23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802104186/5a45e3d2beb783883960c4b9bbbbd996-1730302812"
  },
  {
    "email":"mariaclaudia.caianiello@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802169722/3bb6664222700485ce3f3a27da0cf321-1730302812"
  },
  {
    "email":"giulyorsi10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723801874810/7dc988374cf397fcdd7e9588eb48349d-1730302812"
  },
  {
    "email":"crisi2493@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802268026/70face57d5e9d362982cc838d65139ad-1730302812"
  },
  {
    "email":"carpita.mc57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802300794/a5dd51dd64fc4216efa20040218ed058-1730302813"
  },
  {
    "email":"annafil85@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802333562/1f427eaee5d9d83b2afcdb77e97a1d3e-1730302813"
  },
  {
    "email":"allegraprotopapa0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802202490/41c71664ed5efe9a6b26850a9ffa0b34-1730302813"
  },
  {
    "email":"zannettinodonatella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802366330/d09eb1499824b5ea311ad7fbc0421cb8-1730302813"
  },
  {
    "email":"sonia@cgr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802464634/ee06e6e6fd67679e6cac15547edd2e5e-1730302813"
  },
  {
    "email":"sonabarbara9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802431866/f58cbdffd8067a91e22a48533ce4d856-1730302813"
  },
  {
    "email":"daniela.ballatore74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802399098/7d669332b5d911572f14047f66e49861-1730302813"
  },
  {
    "email":"ritasandoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802562938/e67f6eeeb46364d2eb9bda7724fc7cb4-1730302813"
  },
  {
    "email":"fede.vescovi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802628474/09fb9c2a5c843da56e63b0fc55b1917a-1730302814"
  },
  {
    "email":"silviasanchi82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802694010/8f0e4a55f661af12e1cfbe8e5ada21f0-1730302814"
  },
  {
    "email":"claudia22964@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802595706/7a00366c9ecd153af1a132d2748bcdab-1730302814"
  },
  {
    "email":"bertocchi.debora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802726778/d41f5a5a0f6977acef00bd5f4113dcb3-1730302814"
  },
  {
    "email":"marialuisaorlando@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802497402/06ca1f3bbcf6c0c4b04aa454339ce7ef-1730302814"
  },
  {
    "email":"laura.moretti28062003@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802759546/cf23a249dd152b415de09e1a1d14d478-1730302814"
  },
  {
    "email":"marabencivenga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802792314/ca8d1c3ca4fb7ff9b3e498babe67284c-1730302815"
  },
  {
    "email":"lberna.10209@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802661242/ef7d6a9926aaa862654c6e18cba74ce7-1730302815"
  },
  {
    "email":"avv.pistrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802825082/f5ed84add2a70659660b36955e5d305c-1730302815"
  },
  {
    "email":"marilenaaccinasio@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802956154/fa042975aa8ee9f18a92acd79736463b-1730302815"
  },
  {
    "email":"elena.qua@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723802923386/750f893c7014f27ee17d44d571d0acd7-1730302815"
  },
  {
    "email":"l.regnicoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802988922/5e0b42acedb087e4fa5996384d24593c-1730302815"
  },
  {
    "email":"crlpower@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803021690/6060507f3baa68c26da8e05e45000b7c-1730302815"
  },
  {
    "email":"simonanicola70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803054458/c1177527127ef86534b8185857a54d23-1730302815"
  },
  {
    "email":"mirena@mirenalingerie.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803087226/c594f56a38c963c4ca1662afffd0c556-1730302816"
  },
  {
    "email":"nadia.bertoglio78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723802857850/af80cc943fb02fe3d07c3150797a56af-1730302816"
  },
  {
    "email":"cianella.nadia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803185530/bee7762f94e30cf30cd125a8525b941e-1730302816"
  },
  {
    "email":"yevheniyashulha@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803152762/c5e57d596f6b2d42010e22922ce93919-1730302816"
  },
  {
    "email":"ancazainea@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803119994/c4a83fcd6ce35c50c252a015c6cf888a-1730302816"
  },
  {
    "email":"heavylover@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803218298/d5a3b13a0037d69f183319b24eead88c-1730302816"
  },
  {
    "email":"albasina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803251066/405345b9ecc57e2de5422abbfacb4240-1730302816"
  },
  {
    "email":"m.mieli89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803349370/6985a610e8a019a6bfcae47929f3af56-1730302816"
  },
  {
    "email":"claudiozunino02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803283834/e62fdec005d41fd9ab5725d9fcfcd6c5-1730302816"
  },
  {
    "email":"alessandra.marzolla8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803382138/861be99866daaf7cfa7fa23681badb15-1730302816"
  },
  {
    "email":"roby72giaco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803513210/637eba69d282b4dce84a5955d0546d9e-1730302817"
  },
  {
    "email":"mlillo@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803480442/41d5b4667989901ed36977fd37af0e55-1730302817"
  },
  {
    "email":"laura_ferraresi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803545978/c268cb8b5b92dbb5e4b7654fd6960b0a-1730302817"
  },
  {
    "email":"eguidi.rsm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803611514/d1cba73d7e99767a98127f20b64d96d8-1730302817"
  },
  {
    "email":"mamoneclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803709818/eb8dc6346d31b6566de085b27c7e66bd-1730302817"
  },
  {
    "email":"viola.sacchi26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803644282/a2c36b2dfdb19978c4623c7260b720ee-1730302817"
  },
  {
    "email":"francesca@vigogerolamosrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803775354/d65bc737fb29e88b5f6cd89e05c363de-1730302818"
  },
  {
    "email":"rosariasalerno72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803808122/817e47203f25ba521ad6c5a4c72857cc-1730302818"
  },
  {
    "email":"annarita.dede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803578746/db3bbabc4f9a4b218eea033eb0e243a6-1730302818"
  },
  {
    "email":"angela.geremia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803840890/da13f485d10bca88f1a68e13d480a07a-1730302818"
  },
  {
    "email":"lu.masoero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803906426/ff0ac52d6845b1a664c16e9b3d6e6e46-1730302818"
  },
  {
    "email":"marziad71@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803873658/c98681d7ccf1aa0ac56d1eae85111aec-1730302818"
  },
  {
    "email":"lella75ld@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804004730/b5bd0869dbc31c1649350d906bda6f18-1730302818"
  },
  {
    "email":"milena.brancaleone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723803971962/e6232bcc3761227aea1685482a9d1d65-1730302819"
  },
  {
    "email":"francescaromanagabrielli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804037498/d757e2380016999669e00d030f16f63c-1730302819"
  },
  {
    "email":"vania.morini@openjob.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723803742586/df8ffd54a9bd2a98d6cdb60bd43675dd-1730302819"
  },
  {
    "email":"morgyvi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804234106/9cb85406a5d72eb6d1904b1a6d7b7f2b-1730302819"
  },
  {
    "email":"francescarefolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804201338/46f92a65cf2bee154262291b06d02d0d-1730302819"
  },
  {
    "email":"franceschyna5@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804168570/d2376471254e978dd4ddebae3885ef07-1730302819"
  },
  {
    "email":"alba.faccagni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804299642/a05651f9f8b10bc3bcd4f1e2a45e2f21-1730302819"
  },
  {
    "email":"antuaneta.grama@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804332410/3d72128d8042ec5da9c4803c7d94426d-1730302819"
  },
  {
    "email":"fogazzis.a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804430714/1e799f0b5e5eea2a4e3662dcf75084c3-1730302819"
  },
  {
    "email":"leo.ang@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804397946/5c2fc47cd83bb6eafdfcf68196702271-1730302819"
  },
  {
    "email":"monica.zilli30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804463482/31e81409b2a99b4ef959e301f9f1aca2-1730302820"
  },
  {
    "email":"gianfranca.perugia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804496250/6f477e4a61caa704f19e423b36e97e38-1730302820"
  },
  {
    "email":"rosara3rap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804529018/f195ac9af3e735a75a822ddd15e085e4-1730302820"
  },
  {
    "email":"orsi_cristina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804627322/ccedf5eb0dae0247eaae5b880a02a933-1730302820"
  },
  {
    "email":"romina.spinozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804561786/aaa164576f0a7ff4514ef17aec8895e8-1730302820"
  },
  {
    "email":"barbarabottolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804725626/57a36369921f654b29ab4faec9277a7f-1730302820"
  },
  {
    "email":"kolarovap7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804660090/7c65168526f7021d300fc3c5105513f9-1730302820"
  },
  {
    "email":"monifac@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804594554/a001e4315a42f1ca0f45d329fddfe0ea-1730302820"
  },
  {
    "email":"francescamanf@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804791162/da21c37c2706524a381fce575631a61c-1730302820"
  },
  {
    "email":"quaresimalorenza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804823930/d4bbea629f91ec5ef5919f625a7f5721-1730302821"
  },
  {
    "email":"giussgiuss67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723804856698/8dc7f0c9860e784d781bf40576b84781-1730302821"
  },
  {
    "email":"ginofranzini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805151610/0f03485c41c6fa6813c467f7635a4ece-1730302821"
  },
  {
    "email":"lorettadieci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805184378/1a6807c5ae7f394d0b612e62fb1b047d-1730302821"
  },
  {
    "email":"antoniettasilvestr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805086074/2f1bbf3bb4373a942f207ea6ef9db846-1730302821"
  },
  {
    "email":"giorgia.maurizi8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805217146/021c21dc4707105c66bb5c012f5d56dd-1730302821"
  },
  {
    "email":"marziapignotti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805249914/0e5106ed0abf94604442de4ee30b2933-1730302821"
  },
  {
    "email":"angelabarbetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723804955002/13dd60b9689abeca18cdbcf37d5d1ed8-1730302821"
  },
  {
    "email":"dichiaratania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805348218/d12cd99d6c642068558faf7cb1610540-1730302821"
  },
  {
    "email":"swogana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805282682/5ee6a1c999a1808a38e85c73ab3bdc3e-1730302822"
  },
  {
    "email":"monyfon@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805380986/add96e5d53a8eec4d85c45210a374396-1730302822"
  },
  {
    "email":"giannettibarbara7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805315450/b48b93f7603ec2f0ca983cc188de33ec-1730302822"
  },
  {
    "email":"silvianastatuto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805413754/42794966e0d897873f0b5bbe6423b4ee-1730302822"
  },
  {
    "email":"erigiu12@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805544826/12d27cc2a8308dd06f861da81b746b31-1730302822"
  },
  {
    "email":"vittoria.sorino67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805479290/47104939ed2c1941194484696d5a5c82-1730302822"
  },
  {
    "email":"sonia.chiaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805577594/a74c4dc144c9c97da9842ed13046b0d4-1730302822"
  },
  {
    "email":"dany8811@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805512058/44575d227ee669883e543898342c2e53-1730302822"
  },
  {
    "email":"perua@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805741434/2dfd2f647351cee5e24fcda3777ad568-1730302822"
  },
  {
    "email":"fiorella.griggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805774202/6fd2ac885a0562554d82d9085155fa9f-1730302822"
  },
  {
    "email":"elenarivolta23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805839738/1344cfa97f1f55efdab241b54baa5390-1730302822"
  },
  {
    "email":"robyferri64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805872506/d284aa6e9208672b6c77a46da463dfa5-1730302823"
  },
  {
    "email":"purgatomarta69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805905274/c76c227d513e4b4bc545dc4102f8b4f9-1730302823"
  },
  {
    "email":"enricapaoletti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805643130/3a227f7564e0c59c058b7777f0476659-1730302823"
  },
  {
    "email":"fabiola.belardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723805970810/e760ac5c9dcca8f0d9b65d59e310162c-1730302823"
  },
  {
    "email":"brugnoli@m2g.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723805938042/135adc89ce7ef8d2d63c00bd0ce5ff7b-1730302823"
  },
  {
    "email":"biagimaria63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806003578/7121c450ad2f2dc47b7d30f5a859c621-1730302826"
  },
  {
    "email":"charles.peg@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806101882/f3dcadf9e4ce76fb907f16c2b17952fc-1730302826"
  },
  {
    "email":"tittidecicco05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806134650/da30a3d42e80e47ae0ed16b5ff7dc6ac-1730302826"
  },
  {
    "email":"monicabrusciano.mb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806069114/b3ecc998929bac668a30590ee22028f6-1730302826"
  },
  {
    "email":"corsarablu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806200186/36dabf192ff5fe1314ad1d90d59f3a86-1730302826"
  },
  {
    "email":"mgurtis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806167418/1c27548bc206c013c1077867930fe6ee-1730302826"
  },
  {
    "email":"mariateresa.bertulazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806232954/081bd2f472c390b95a1dfd9ecd952988-1730302826"
  },
  {
    "email":"francesca.pupillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806331258/76fd39e12d1a3ed3a65ddced5e779a76-1730302826"
  },
  {
    "email":"renatacampanini4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806364026/b5320495bdf21c4c187a3368b79efcb3-1730302826"
  },
  {
    "email":"dadamo.stefi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806265722/c6070577e60eff0305cbf9955f9fa1e7-1730302827"
  },
  {
    "email":"marangi.antonio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806396794/a717de3ad60cbd7545a421f1eeb95e6b-1730302827"
  },
  {
    "email":"dbelluardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806560634/ab438fa8f9978ae1965d5be0833822bc-1730302827"
  },
  {
    "email":"serenapantella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806429562/de8dcb7012a08a5697bc77ebc23708ce-1730302827"
  },
  {
    "email":"silvia.grippa70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806495098/9d0a32b0037be97cfa6a8050174bbf44-1730302827"
  },
  {
    "email":"lorella.cortellucci@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806691706/ffcbc39c8b51eb567708b968fa4743fc-1730302827"
  },
  {
    "email":"simonatoromina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806527866/dd5bfb67f77d1bb7126f9456ce033e48-1730302827"
  },
  {
    "email":"distef372@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806626170/6f33c72fc1ac47ab48491a1c55d640a2-1730302827"
  },
  {
    "email":"soniafochi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806724474/725d125e2756bc29a6adc1c7024e200d-1730302827"
  },
  {
    "email":"venditorpaky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806757242/390113b7477f59c05fe952977d59eb72-1730302828"
  },
  {
    "email":"stefaniacurina64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723806822778/77ec273b2342523383eef0109d1fb21e-1730302828"
  },
  {
    "email":"alessandra.checcacci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806790010/4b28fe81e9cefaffe18319bb33796d00-1730302828"
  },
  {
    "email":"mirella.lestingi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806888314/13eb34b1b1f31179f1c71668d07882bc-1730302828"
  },
  {
    "email":"m.laspada@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806921082/297c95ee0ca366c8e9fbadb01e7fd03a-1730302828"
  },
  {
    "email":"lellaseve@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806855546/4003578078c698989d6fd7164b1f63a6-1730302828"
  },
  {
    "email":"alessia.cirilli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806986618/2a7020519bf577e4e60c6bcc8b6ec341-1730302828"
  },
  {
    "email":"donatella.rzz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807019386/bdb45e0f3fb7afcffcf0aea4a17d8682-1730302828"
  },
  {
    "email":"manu.gentili@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723806953850/433acca81417fd52d3a605dac7571cee-1730302828"
  },
  {
    "email":"muratfiano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807150458/2fa49d01e2844b18820ccc15d09b907f-1730302829"
  },
  {
    "email":"elena_981@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807052154/78462923e888045dac292bee1fb94dc4-1730302829"
  },
  {
    "email":"rosa.flora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807183226/a1a9b784798f7cb5be64a3a223fed065-1730302829"
  },
  {
    "email":"olicor10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807215994/4e5e7edf4e84241133f81dce9908cd62-1730302829"
  },
  {
    "email":"chiara.cc444@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807248762/a9d9ded7a31673ca9ed382103d87b000-1730302829"
  },
  {
    "email":"aureliaricci1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807347066/a19d2d421dea9082b85ab08653182fb8-1730302829"
  },
  {
    "email":"lmarelli70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807379834/fce6066c4fd18177928b8542b5d52c8f-1730302829"
  },
  {
    "email":"mariaantonia.spanu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807412602/32f6cd8037aee76d58029232af60c80a-1730302829"
  },
  {
    "email":"tiziana233@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807084922/fd26353d32aa5d856d6e1d1756d1f933-1730302829"
  },
  {
    "email":"julia.mortera@uniroma3.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807445370/217c9992962d56dd60b5373d65218286-1730302829"
  },
  {
    "email":"fioregiugno@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807510906/ab7f0c841f10fc941bbc38ad3e098dd5-1730302830"
  },
  {
    "email":"ombri1974@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807543674/c5d307d3717877f60555ebfd5f866bbe-1730302830"
  },
  {
    "email":"elisa.mainardi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807478138/35f9b6bece36bc0e31e62b7167641ad9-1730302830"
  },
  {
    "email":"lacarleo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807707514/f4a99b39f64c2d690c71a2c2f679d6c0-1730302830"
  },
  {
    "email":"tassinibarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807773050/26a490c4616b22f0fe6da3892c16340a-1730302830"
  },
  {
    "email":"teresadivilio@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807740282/cfec0b1a5f05759ab1fe984116251aff-1730302830"
  },
  {
    "email":"placman@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807805818/9247586868059cc2403ee84de8d5e875-1730302830"
  },
  {
    "email":"bruni.silvia@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807904122/38ed6c4fed2c88e5ab3de3ee4d3677c1-1730302830"
  },
  {
    "email":"battistellawa@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807871354/bd46a51b57cb767d0ad7b60df630a3a8-1730302830"
  },
  {
    "email":"teresadefrancesco.81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807936890/bd3608308b6e5c3849e8502c66baccf7-1730302830"
  },
  {
    "email":"lella.liguori@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723807576442/0887a89e2e1775487b19682f0ba48629-1730302830"
  },
  {
    "email":"alesandra.dellepiane71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808067962/ac50c363778b29e84db9b3d989dd7098-1730302831"
  },
  {
    "email":"giulia_velardi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808035194/3208b1afb556b5a94107acd9d9016b3f-1730302831"
  },
  {
    "email":"mara@residencemichelangelo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723807969658/6803600bad3c31b8878664b389c1acb6-1730302831"
  },
  {
    "email":"veronika.santa04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808100730/a8669eeaf6ace3cd457b45dfb4a81700-1730302831"
  },
  {
    "email":"diego.bartolomei43@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808133498/240146bee6a5a1826e40d24ba54b0b3c-1730302831"
  },
  {
    "email":"giuleria70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808002426/dc14225e486b732a3722366cf7f531fb-1730302831"
  },
  {
    "email":"francesca.carri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808166266/7bb7b72a7dfa95ec7e73482b7c43da2f-1730302831"
  },
  {
    "email":"platop3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808199034/72dca53b1aec192cd69e0494bf69dc87-1730302832"
  },
  {
    "email":"maddalena.volpi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808362874/f968c6e2c0e418c80e10c76784cacac2-1730302832"
  },
  {
    "email":"tittylo@libero.or",
    "url di attivazione":"https://verdissima.it/account/activate/22723808428410/82bbe2c51c63fcb761f46f06a16870bb-1730302832"
  },
  {
    "email":"irenemariani84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808231802/16bce081fc54152e0a959db4e35be996-1730302832"
  },
  {
    "email":"silvia_moscardi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808493946/3b36462a7f7304027a9dc372a4e589c8-1730302832"
  },
  {
    "email":"nilatini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808559482/799dba19fb42661615aca8973db1dce8-1730302832"
  },
  {
    "email":"francescosubri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808461178/95d5211b888d640b8f792c8964af7cdd-1730302832"
  },
  {
    "email":"giulipaola82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808592250/9fecf79d420e563dc62190e14fce1752-1730302832"
  },
  {
    "email":"rodellimonica55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808657786/d6e704ef79d90efa635ca94d1b9a348f-1730302832"
  },
  {
    "email":"realemarika39@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808723322/e172eb5fa5813d9ee3be71dd1a4bc5cb-1730302832"
  },
  {
    "email":"simo-simo1@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808625018/e83cc4f3182dc44941037a42fdfa751a-1730302832"
  },
  {
    "email":"barbaracorazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808690554/af2692665c62a6440aaca2037d0996cd-1730302833"
  },
  {
    "email":"la_linea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808756090/33caca20f0e4aed8e78580a20cdf0f7a-1730302833"
  },
  {
    "email":"eniko.fogorosy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808788858/e7380e7b88b803fe6c8cb75b249f3a69-1730302833"
  },
  {
    "email":"ladyveronic1108@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808854394/7c88f95d71154c6ff25cce2e888bd0fa-1730302833"
  },
  {
    "email":"v.latteo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808919930/81124c7bcebed76b700e1ef478f38993-1730302833"
  },
  {
    "email":"m.costanzo@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723808887162/99e717ab2a2bdca63ccba6e4f2ee0a28-1730302833"
  },
  {
    "email":"fabionicolai4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808952698/d851c602afe308e7cdcdb68a762963e3-1730302833"
  },
  {
    "email":"soniaand71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808821626/4dd794c48a2c034b81a1b007eccff1e0-1730302833"
  },
  {
    "email":"giannabarh@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723808985466/95550af110a8166de04ddf9e4eced401-1730302833"
  },
  {
    "email":"eson.italia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809018234/f702756d1dc28e0ac1c531a504e8f220-1730302834"
  },
  {
    "email":"vittoriacamillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809182074/e185cc4b2b6191646fc131713af242f1-1730302834"
  },
  {
    "email":"avvmartamarchetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809149306/db73e04e1e3c1458a91983df2a7cda2d-1730302834"
  },
  {
    "email":"bernharddincau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809214842/f3dcf26ee7f6b96714fc3991ad74ca27-1730302834"
  },
  {
    "email":"dax68@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809247610/b93898a90a7dc4dfdb217cad94604d4e-1730302834"
  },
  {
    "email":"sara.bressani@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809313146/7892ada49a890e8a965d3232bfdfd9b3-1730302834"
  },
  {
    "email":"lucia.schibuola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809345914/6431ea1d2c42bf1dcd008dca43e88590-1730302834"
  },
  {
    "email":"busiroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809083770/0d5884818ec00b1f687ffee93a26732e-1730302834"
  },
  {
    "email":"katiacodutti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809378682/57b1f42419dd8013d1f76efd87602a83-1730302834"
  },
  {
    "email":"ilamaspero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809444218/b87d7b2e68ee5796ca11190319e89171-1730302834"
  },
  {
    "email":"raffaella@pontebbanacarri.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809476986/fab1a63c6f73d8682012647159bb24c8-1730302834"
  },
  {
    "email":"dani.rampone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809542522/d995bfec9b56fe7ba3b0a6eb2bbba13a-1730302835"
  },
  {
    "email":"lavi.panizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809608058/0c8971e97be8f9154a287dbd5b2423e2-1730302835"
  },
  {
    "email":"francesca.desabbata@cheapnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809411450/77401b5e931e24388df7377fcd3b13ba-1730302835"
  },
  {
    "email":"sabinastaccioli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809640826/1bdbbb0e0a6774fc3aa183dda0a8d7d4-1730302835"
  },
  {
    "email":"tamarastecconi49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809575290/ecdbf335ed69a47acbde611b9d873f55-1730302835"
  },
  {
    "email":"alessandra.passaro72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809673594/eb6ec8cbc96a686c2e452c63ae9a058e-1730302835"
  },
  {
    "email":"valeria.mencucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809739130/5b3d0fa8d004304b24a67ed6b76b9512-1730302835"
  },
  {
    "email":"laurazerini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809771898/21636dff7e888b742e36a444fdec5c75-1730302835"
  },
  {
    "email":"robertonadalin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809870202/191ab1e5e3caffcee3e7f9d341c4da39-1730302836"
  },
  {
    "email":"maria_letizia_f@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809706362/cec80d2c1f7cb93664ff530afb8b5a7a-1730302836"
  },
  {
    "email":"patrizia.palmeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809804666/27af1fbbb031b9eebbcc9a54c8d58e07-1730302836"
  },
  {
    "email":"marilenasanchez@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723809902970/944f4938dd01586d089aa63cd82c6920-1730302836"
  },
  {
    "email":"segreteria@clarafondfabrizio.191.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810034042/a447fae4b2ece419d56c96d3772d92aa-1730302836"
  },
  {
    "email":"fede_c85@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810132346/f4c7a276ca2e5dcf62f9b03f7589da01-1730302836"
  },
  {
    "email":"stefania@massimotessandoribernini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810165114/22798c9ec837766af2d7bbcc525d9400-1730302836"
  },
  {
    "email":"unga.mil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810197882/8475333e7b399d02a358314a128e4996-1730302836"
  },
  {
    "email":"alte.palombi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810263418/a4471541f22070340550faf831908c3c-1730302837"
  },
  {
    "email":"fistetto15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810230650/5ee2eb6cba64e34a2c3d72d4c381289c-1730302837"
  },
  {
    "email":"cloclodia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810328954/e891054718af2d3248ed9d410ea73af3-1730302837"
  },
  {
    "email":"tempoestate@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810361722/2d1e81561a199d7f5a7ff57140fbdf01-1730302837"
  },
  {
    "email":"silvia0572@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810394490/74dba66baf9c5898d96aea536b44f469-1730302837"
  },
  {
    "email":"trev.nadia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810525562/16a738eccbdcfa798b933a4425a98e07-1730302837"
  },
  {
    "email":"nefer.sansoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723809935738/0d164fb6ebcee58b40e4e1ef5438a26b-1730302837"
  },
  {
    "email":"ruthunterholzner@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810623866/7c5963ca2c42446815cbe382fc5d3a21-1730302838"
  },
  {
    "email":"elemereu.em@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810558330/ab7fece6210ac97ce10e050b5a7cafcb-1730302838"
  },
  {
    "email":"mncsimonelli7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810656634/424755ce939aad95f7b32832fa734df9-1730302838"
  },
  {
    "email":"annasquin@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810591098/c4824170517469b54606f2b4c093b65f-1730302838"
  },
  {
    "email":"lia@studioliabalzarini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810722170/c7398cd7b20d2f97138f0b4d56db545c-1730302838"
  },
  {
    "email":"stelladedom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810787706/20f68364d5baad7d4dc03e29c4dab61d-1730302838"
  },
  {
    "email":"spipola728@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810689402/9039122de394903b3c945da4af978984-1730302838"
  },
  {
    "email":"bida.klejsa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810820474/78dcd3c4a3783430e945234b71c0088d-1730302839"
  },
  {
    "email":"maria.sapo@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810754938/61b2c9e491bafe0f65510d1d708335a1-1730302839"
  },
  {
    "email":"gallipierpaolo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810853242/c1d1fd8888e8d2a4af53379be3004011-1730302839"
  },
  {
    "email":"giovanna.vaccaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723810918778/23c7e3e50e16b2d6d3606caa569465b3-1730302839"
  },
  {
    "email":"pa.paulone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810886010/311aa4a43674f9e44a664f6d9142e44b-1730302839"
  },
  {
    "email":"samuela.melini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723810984314/4c87be2b04caa18da8103e967341884a-1730302839"
  },
  {
    "email":"robertacogo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811082618/464c031e06ce1e76f65bb99aeb001126-1730302840"
  },
  {
    "email":"avv.anastasiasaporito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811115386/eff457e3bb1d4217b6283489caca7646-1730302840"
  },
  {
    "email":"mavigallorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811017082/c32bf5b9b6754cf09b6a05ac89785101-1730302841"
  },
  {
    "email":"alicecherchi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811049850/fddf428b534dd9e756a8b96c533d9b48-1730302841"
  },
  {
    "email":"carlaguarino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811180922/059aa6965e047893461abe5c10d6a692-1730302841"
  },
  {
    "email":"gtousco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811213690/409479745607114b83c509a47d467770-1730302841"
  },
  {
    "email":"lmelli.68.lm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811279226/4c68ce1f79b5e7d8e10405b1330475ff-1730302841"
  },
  {
    "email":"marta.pescari02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811344762/f44b1348dd9747c091cac7b625de06d4-1730302841"
  },
  {
    "email":"marchitell@tiscalinet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811377530/d67d12d463c6aa7d792595cce7764b9a-1730302841"
  },
  {
    "email":"giustina.cavazzana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811246458/a5c18014ca6021149f303b9dc021e94e-1730302841"
  },
  {
    "email":"fraded76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811443066/0c2d4cf91c30e91c8a22d53a7e74e1b9-1730302841"
  },
  {
    "email":"cristiana.f73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811410298/ed8231a30d655dd53697d07edcaddd9d-1730302841"
  },
  {
    "email":"silvia.viviani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811574138/bbbcf82380edc91cf8c5ace9d3bc269a-1730302842"
  },
  {
    "email":"annavoig1972@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811606906/b5221496d485af637fcbefcd283c339b-1730302842"
  },
  {
    "email":"marcyb82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811541370/fb6202afdd617f32bde9632f550706c6-1730302842"
  },
  {
    "email":"altrimenti11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811475834/ddc8ff0740cb664521c975bc4ee8aa43-1730302842"
  },
  {
    "email":"speranza-ciardo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811672442/c5912e671139b8442926564ca3afd586-1730302842"
  },
  {
    "email":"mariolu.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811639674/bf696039fb4c7074531745efd3595443-1730302842"
  },
  {
    "email":"caterina.baccega@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811737978/8743e0a1352305c993a3615a6b309c20-1730302842"
  },
  {
    "email":"fangeloni1902@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811836282/1c1a0af3a0c06d43e6c7baaf3169ae24-1730302842"
  },
  {
    "email":"frseganti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811803514/bf3415710243bae9ca04d1c38c7dcaef-1730302842"
  },
  {
    "email":"pulce87@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811967354/723d44ddecffe03c488f25856e99e6d5-1730302843"
  },
  {
    "email":"laura.zannini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812065658/5bfe1930c8ae1f2ac610fc9130b6463d-1730302843"
  },
  {
    "email":"enricagiu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723812098426/dfbe37b16533f249ee476e24f56a9c0c-1730302843"
  },
  {
    "email":"angela.albanese-v@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723811934586/3b674d2f306571e2401f2974abc845c3-1730302843"
  },
  {
    "email":"lauratoccalino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723811901818/6e59815a461d0355c3b0fb5597f2479c-1730302843"
  },
  {
    "email":"donauetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723812131194/d5e2a30752ecdcf75bd622a439aceeaa-1730302843"
  },
  {
    "email":"ilaria@maglificiobartolini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723812163962/3334381afbbfc471f4332c7bb9a72869-1730302843"
  },
  {
    "email":"matteazzigiovanna1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812327802/032131327eb833ba93dcf59791981647-1730302843"
  },
  {
    "email":"tommasi.rossi@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723812262266/86febee2962324ec5b2bb98b1a3322df-1730302843"
  },
  {
    "email":"antonellacanu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723812295034/6663a3adfc2ba043152bbd799c9e834e-1730302844"
  },
  {
    "email":"claracereda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812458874/574e3ef44bd23d3203487290962be4b5-1730302844"
  },
  {
    "email":"rosmaryladisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812360570/4c90c34e6efaf2c28009703b1f260575-1730302844"
  },
  {
    "email":"giofranca.ragnedda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812557178/ef93ea0c408a9e092432b7a80ed3f596-1730302844"
  },
  {
    "email":"laretta971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812491642/a9d5fb6645ea6adc89e2697435cdc31e-1730302844"
  },
  {
    "email":"claudiadirodi76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812393338/dfae8a6e2f709afe65ac0f405b0f179c-1730302844"
  },
  {
    "email":"spitali.m@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812589946/ccafc6343d6ba71fed241ff8ee84ca32-1730302844"
  },
  {
    "email":"nadiazitano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812721018/c4d72b9a8eda50a48068df06afb5819e-1730302844"
  },
  {
    "email":"mariaritadbl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812622714/602f7a9f29e98eabc5d41498c6fa9cf2-1730302844"
  },
  {
    "email":"acquamarinacervia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812852090/bc6a46e3bd61f9a5d4203157ab9e373f-1730302845"
  },
  {
    "email":"francesca.sorelli78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812819322/00911e214b5135a767e91d7297ef6883-1730302845"
  },
  {
    "email":"dajna80@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723812786554/2d53222712cbf46120b7073fb7240ae9-1730302845"
  },
  {
    "email":"alessiaiovino09@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812753786/44a81311393a4e8508f45468f8041766-1730302845"
  },
  {
    "email":"meris.baffoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812917626/0f299f795163e2ae0f5f1bc5ecee650f-1730302845"
  },
  {
    "email":"mattiachini@pecchiolifirenze.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812884858/6e9f9c689c83e720d8c193c6b7bfbf7f-1730302845"
  },
  {
    "email":"younes.63@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723812983162/97b73c75beafdc0334bfbc1a4a77c9d7-1730302845"
  },
  {
    "email":"claudia_piras@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723812950394/e8249c2843c59e66226d1b7ce28c4d66-1730302845"
  },
  {
    "email":"tatiana.mirca@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813048698/8e825fa51f4fa5d204b1dbd3284bb178-1730302845"
  },
  {
    "email":"torreslucia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813015930/3997655eaaacb26d629573509fc199ec-1730302845"
  },
  {
    "email":"sara.angelotti83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813179770/08f62675715366689fddb53b2443d18d-1730302846"
  },
  {
    "email":"gabriella.gatti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813245306/6ce8e19a0b074fd10e66f26c5d1879aa-1730302846"
  },
  {
    "email":"rodi03@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813310842/85b530f244203a9368bff26cd335badb-1730302846"
  },
  {
    "email":"giovannaghilardelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813278074/ce5598f9581e787f358e48ad0c20da72-1730302846"
  },
  {
    "email":"fedele.patrizia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813114234/990b884678febaadef6cf9515389f0ea-1730302846"
  },
  {
    "email":"occhiblu_76@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813212538/feac50cff1ad9316ea3a802e95a174e7-1730302846"
  },
  {
    "email":"info.raffaellaesposito@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813376378/d693319c21506b5c8e162d60af75a2c3-1730302846"
  },
  {
    "email":"c_barra@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813343610/5b09cd604d20d4552961cd5645200001-1730302846"
  },
  {
    "email":"valentinagaleazzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813409146/722bd5c9293dcdc72814b577cca37f78-1730302846"
  },
  {
    "email":"aslucchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813474682/536aee8caa22e926ed374e0e4e8250a3-1730302846"
  },
  {
    "email":"annapastr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813540218/a787bdb25e14a53c4408aa27323c6272-1730302847"
  },
  {
    "email":"teresaalbisinni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813572986/4d3886879024656c0dd2c7cbf8f971a2-1730302847"
  },
  {
    "email":"sanguetta051971@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813441914/ca15efb263ace853fd71ebc68e06be0f-1730302847"
  },
  {
    "email":"stefavatar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813507450/2304e4326ea21058abe9596de8cfb542-1730302847"
  },
  {
    "email":"paola.michelotti46@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813638522/2de87c15141b4078551e577af22f608f-1730302847"
  },
  {
    "email":"manuela.beni63@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813736826/4bf4f05a08a737ef8fa7bff156bf3354-1730302847"
  },
  {
    "email":"chiaranoja@yahoo.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22723813769594/2d7e4fd9d739afb80b2beec9210a9513-1730302847"
  },
  {
    "email":"silviascuero@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813671290/79035c49a2fb2f94e439d3387f6222fa-1730302847"
  },
  {
    "email":"alessia.guerrieri1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813802362/c6c1fbb470475d08821ab2f9271010e6-1730302847"
  },
  {
    "email":"lastella33@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723813835130/fe04788ed88586237e788eddfe4b0101-1730302847"
  },
  {
    "email":"raffaelladeluca79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813867898/acebb0eebc9029ca91613f78cef4b7b1-1730302847"
  },
  {
    "email":"annalisazacc23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813933434/320502743944bc98a13971290225fd92-1730302848"
  },
  {
    "email":"anna.dasso86@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723813966202/f588f5db76331022b2b914dcad6589ae-1730302848"
  },
  {
    "email":"ciciolotta57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813998970/76d57f99b2a3d08248f1a15718bace68-1730302848"
  },
  {
    "email":"prof.valentiniemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814031738/a27d65ce5f95ecfe90ad81305a9bbe89-1730302848"
  },
  {
    "email":"cristiana.gallai@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814064506/512941859d2af8f288f2c92222682c41-1730302848"
  },
  {
    "email":"esteticastefania71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814097274/201c24662e7fbb38b1b32003ee1fcdd0-1730302848"
  },
  {
    "email":"izilianti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723813900666/5a03f34654c75367c21b37f7609d3ed2-1730302848"
  },
  {
    "email":"donatellasannino1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814130042/0b19daeee86c7d49dd356d574223a654-1730302848"
  },
  {
    "email":"phil.cattaneo@iol.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814195578/ee25c3fb8c46adebc26ef227100b3e5c-1730302849"
  },
  {
    "email":"usilvia83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814228346/f3ce2d567254920ff8b1e5191d7ece53-1730302849"
  },
  {
    "email":"vittovi1975@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814162810/567e06318eef305d00aa9075f5291f77-1730302849"
  },
  {
    "email":"elisabettabarbato@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814326650/4143861e19968de7270ff38aaf3ea1ab-1730302849"
  },
  {
    "email":"marisa.paternoster@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814261114/7fd6bb72ce74d55ae8ea3848e03e226c-1730302849"
  },
  {
    "email":"mluisa.pugliese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814293882/1af0ee11aa7113f3a030bb1a126270b6-1730302849"
  },
  {
    "email":"dana80@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814392186/943212c85e6d102b1426546e59946ce4-1730302849"
  },
  {
    "email":"laubert@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814424954/75f03cf4be91bb83e976b1c99029ebe3-1730302849"
  },
  {
    "email":"nesiilaria@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814359418/4f8f05abf6eb75666a7eb8f51522615c-1730302850"
  },
  {
    "email":"vincenza-pastore@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814523258/9086143982d9bb75564a649cb554311d-1730302850"
  },
  {
    "email":"francychen@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723814556026/15645223b3c468c97851887fdf33aa31-1730302850"
  },
  {
    "email":"mariafiorella.nencini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814654330/84ef533c65f359da4f49ff0d0b381c4e-1730302850"
  },
  {
    "email":"emilyborghetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814490490/785f06ec85070985ccb0600559425c0d-1730302850"
  },
  {
    "email":"chiara.guscelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814687098/d415d55e89618808e3956cc7ae51d270-1730302850"
  },
  {
    "email":"silviasalisburgo@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814752634/959edbca1aa00b5c8a6545020e7db414-1730302850"
  },
  {
    "email":"novesaiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814785402/8929ce2d111af1f3acf6612cad1565be-1730302850"
  },
  {
    "email":"annav.patera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814818170/f3ade934b13533c1617f04dcb556e430-1730302850"
  },
  {
    "email":"mariarosamagnano@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815047546/07eb3befba5682cf43763e8031cd7b63-1730302850"
  },
  {
    "email":"275paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814949242/117462999003e9a4aabc6ef5e4ec325b-1730302850"
  },
  {
    "email":"scirghifederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815014778/274dbd66e8ad78eae8ec5747c1085913-1730302851"
  },
  {
    "email":"manuelamerola@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723815080314/3d9b850cba4eaa2658dbd1e45daf5913-1730302851"
  },
  {
    "email":"giove.daniela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723815113082/37b0566c4b95303aa1e081ae45752318-1730302851"
  },
  {
    "email":"dani.casoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815211386/c4b4d8c0c3471b9c58e6a31c04cb0f22-1730302851"
  },
  {
    "email":"veronicamartinelli86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815178618/08077a993b38f902c78b01454c4dc663-1730302851"
  },
  {
    "email":"sara.giustozzi@iclod.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723814883706/1181f4f0351d7071911e2b3db8fdbbb9-1730302851"
  },
  {
    "email":"estercarlomagno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815309690/369e5e464343d32793a5c54439db875f-1730302851"
  },
  {
    "email":"violaf18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815244154/33e968967a3513b50d202e43d06ecb0b-1730302851"
  },
  {
    "email":"analiverani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815342458/ff188159b224165cff7883310f27687f-1730302852"
  },
  {
    "email":"lugliogiuseppe8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815440762/c7623ce5077083ec851315e780dcfe35-1730302852"
  },
  {
    "email":"silvietta.rotondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815276922/54ea0c09c176e85540236657858a8e5d-1730302852"
  },
  {
    "email":"robertapantano@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723815473530/94c38c24bce7e841c89e9412d148ff3a-1730302852"
  },
  {
    "email":"lattanzi.cinzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815506298/e46a81baa66f074382ffc14d468d7271-1730302852"
  },
  {
    "email":"daniela.erani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815604602/9b63cecefe7ad1f145ad25bc3d6c5334-1730302852"
  },
  {
    "email":"alettasalvatore@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815670138/bb7e16b47144c86caea4f48208fbf79b-1730302852"
  },
  {
    "email":"vale.bottura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723815571834/02d67fbe0020f839a76f91e36983324c-1730302852"
  },
  {
    "email":"simona.sordo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815702906/783ae6e2b7a8c312139ffe40e729d60c-1730302852"
  },
  {
    "email":"eebrusarikaya@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815735674/2e60a159b0567450e0ff905fba5a9e13-1730302852"
  },
  {
    "email":"simona.borriello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815768442/f97fe7a19ec645fc542a1ef64d9bf76e-1730302852"
  },
  {
    "email":"debbie0268@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815801210/99d7aac3eb7e0909c8d7202ef293164e-1730302852"
  },
  {
    "email":"silviacotroneo.studio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815833978/06c6588bc2f8810da1036c25eee1cf37-1730302853"
  },
  {
    "email":"zaira_fallacara@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815899514/a1742db0ee66621b923ad2977b15f4e4-1730302854"
  },
  {
    "email":"nikicasale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815965050/405ef7fb3d5a067df3e8ea83816199cd-1730302854"
  },
  {
    "email":"ctiberti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815932282/a7293f1f207e3ce3c15121f721fcaae2-1730302854"
  },
  {
    "email":"f.dolceamore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816063354/7e5ef3c6f2e9b7d5e0933c6d0785049d-1730302854"
  },
  {
    "email":"vittoria8011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816030586/eb1c390fccb97366d95c0107a2275836-1730302854"
  },
  {
    "email":"francygrisolia75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723815866746/a917bea3e44b1e4443158272098a2c7d-1730302854"
  },
  {
    "email":"valentina.marchetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816161658/b3361cf1d3413b961972aeac18e41acb-1730302855"
  },
  {
    "email":"giuli.sassi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816227194/b91d801b191775cddf8e197359674d9a-1730302855"
  },
  {
    "email":"ale80.galassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816259962/c4807c2e8b1a379d1cfed652dab87fb1-1730302855"
  },
  {
    "email":"catoccicristiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816128890/10f417a555d0c6112bdc1386f9ff6ffe-1730302855"
  },
  {
    "email":"bibby.desimone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816292730/6fd9beb055679e3eea3e7bb5aca43b18-1730302855"
  },
  {
    "email":"aleferra12@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816096122/2e83c9f6380ceeb2defa4c29b3cbead1-1730302855"
  },
  {
    "email":"caterinamartinelli86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816325498/6f441442a262f4e3a3d8cccc58413a3e-1730302855"
  },
  {
    "email":"robbavalo78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816391034/d8b3dabb84d825b8d65574420fe52d1b-1730302855"
  },
  {
    "email":"dybalabarbara27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816358266/a392da7f0abe6ec65e750e18438204a4-1730302855"
  },
  {
    "email":"francy3891@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816423802/5ca35ac38444ad5d74bfd3c405f104e4-1730302855"
  },
  {
    "email":"fra_ska@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816489338/4138a398aa32cd90d02f8a8913d127db-1730302856"
  },
  {
    "email":"miavoltan@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816554874/aa91a6fbb4533c49f06942e85df32fe2-1730302856"
  },
  {
    "email":"venanzia.annese@unisalento.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816522106/2845a4ac71fae1d8f2bc48bbf7a477eb-1730302856"
  },
  {
    "email":"desantis_raffaella@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816456570/ab46ca4fc91335feb75f7c258710e44f-1730302856"
  },
  {
    "email":"atufano@unina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816685946/836a51ff3017122d688c06c592eb4e05-1730302856"
  },
  {
    "email":"elemi99@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816587642/40aacd116a6468bd9f7fe4c1578ac350-1730302856"
  },
  {
    "email":"lillaegi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816751482/f671b9e041df0c4a3fd0baef76af50cd-1730302856"
  },
  {
    "email":"gheghi.pozzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816784250/a53d30118b13cf96194164b7e4ce69f1-1730302856"
  },
  {
    "email":"jadeeclipse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816718714/43a99012d2148c1f1f2dffcfd1b45b7a-1730302856"
  },
  {
    "email":"ritacretella2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723816915322/1dd40ed5bcd3868786b86ef6004e2b30-1730302856"
  },
  {
    "email":"bereniche@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816948090/986ae4ebc1c685f48eb14ef2d50df3a7-1730302857"
  },
  {
    "email":"renatapolonioli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816849786/8ef5763b36c658da9f7a7f45054f89fd-1730302857"
  },
  {
    "email":"palombi.maria@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817013626/163a963739587c6eea9f629a6376c4e4-1730302857"
  },
  {
    "email":"francesca.cazzuli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817079162/72956ba0ab0186846e872f0d6d181e26-1730302857"
  },
  {
    "email":"gisellaboschi@hotmail.com",
    "url di attivazione":""
  },
  {
    "email":"sandraraffaelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723816980858/2e1e0489536c7b652ae2b11b211cf773-1730302857"
  },
  {
    "email":"laramodolo1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817210234/25e8e4c9c0eebdd3f1b980871423b420-1730302857"
  },
  {
    "email":"mariateresa.pollio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817341306/597cb50bc42b5448abbddc43712b45be-1730302857"
  },
  {
    "email":"valemore@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817275770/8359ff11b29bfc718bac221720ac53f1-1730302857"
  },
  {
    "email":"buzzina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817144698/b22ca0815fe9f0559f65028abeb7ab2f-1730302857"
  },
  {
    "email":"mircamax@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817406842/b44935de523dab39ab6b5b25ddb4138a-1730302858"
  },
  {
    "email":"giuliadarcangelox@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817439610/c4ed41eeacdc21037651af5f3305a721-1730302858"
  },
  {
    "email":"annalisa.benetti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817374074/3f56b1a065684733c978f95d218cc905-1730302858"
  },
  {
    "email":"ely.cassader@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817472378/a6063ebd62047313fd78b9dd9adca1d0-1730302858"
  },
  {
    "email":"maura.scarcella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817537914/1a7486d9e8415168d68ede4ae816a82e-1730302858"
  },
  {
    "email":"lavi23@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817570682/5816f4eadb57ed7d1461ff79d2c21774-1730302858"
  },
  {
    "email":"lalpini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817505146/e57e5ae8ecf5a1e6ad61e0522337a980-1730302858"
  },
  {
    "email":"veritaemanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817800058/c46e8ad3bd1c38d9e4770c083bcb07b4-1730302858"
  },
  {
    "email":"avvborgese76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817636218/67a4617f5893d347b7d409e6aa0caf1a-1730302858"
  },
  {
    "email":"restagnoi@pianfeieroccadebaldi.bcc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817668986/19c4e281eaa653d8b2a54e59f3d5cb72-1730302858"
  },
  {
    "email":"astrid.bazzoni@studiobazzoni.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817898362/57f44e4334dbf62aafb964b03d1faad1-1730302859"
  },
  {
    "email":"silviaguazzotti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817865594/9811c7a17ab6df8c5da682d87a849782-1730302859"
  },
  {
    "email":"mariagiuliascorsolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817603450/aa4ddbe6bbf9e582f90253646f5de73c-1730302859"
  },
  {
    "email":"roberta.bennato@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723817832826/1c734d36fd350c984b85174ab0d8d8a2-1730302859"
  },
  {
    "email":"dubialessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817996666/b8b2e91f5c8770e8b893881c09694676-1730302859"
  },
  {
    "email":"nillable0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817963898/53bcdc95895afaab183eb81522388599-1730302859"
  },
  {
    "email":"elenascorrano14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723817931130/9aa9d925ca9405104ae0ca0070c0c2eb-1730302859"
  },
  {
    "email":"adele.dimuro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818062202/5aa79eeb4427dab7e6fa18436ea60498-1730302859"
  },
  {
    "email":"fedepapagni942@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818094970/95a04fa8068603443a0a5c3af16dfdc5-1730302859"
  },
  {
    "email":"lavi.bonc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818127738/73c8f1e897f6098b8fa5281d9a4e475a-1730302859"
  },
  {
    "email":"michelabruni1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818193274/875a81f9b3d3cab8f06f73ff779f2a52-1730302859"
  },
  {
    "email":"katripodi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818226042/17c2712b16c665344737f9a036920cc2-1730302859"
  },
  {
    "email":"rita.orru@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818160506/27cb28f52172f43621153f3df34992cf-1730302859"
  },
  {
    "email":"paolapassarella81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818258810/73252f9b4f10d84c4d83e649db07cbd1-1730302860"
  },
  {
    "email":"serena.niccolai@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818324346/7c764c80956369610b04cbd4f4c6dbb4-1730302860"
  },
  {
    "email":"bbeatrix92bianchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818389882/82d20db65ce3f0b7ac5815f7d63dcb2a-1730302860"
  },
  {
    "email":"giuliaiosca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818291578/cdf16664b6b8b2deb9b2839adde2408f-1730302860"
  },
  {
    "email":"lisiveronica11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818455418/3bf0e58fb432d074585287b360df2d9c-1730302860"
  },
  {
    "email":"oliva1992@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818488186/01d3498f2b221c8e1b1de708d13e5615-1730302860"
  },
  {
    "email":"cristina.narcisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818586490/73aede94dab8cb34695db325483efa81-1730302860"
  },
  {
    "email":"sil.gambarana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818652026/561fb5a325125a385a4e675bdc921ad9-1730302860"
  },
  {
    "email":"laura.fazzini97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818684794/456b9cbd6e9fc1c0af95a76b3f9e6661-1730302861"
  },
  {
    "email":"evelinaschirinzi@vigilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818520954/a17cf8eadcd9ac93b7d2e1cde8df1bae-1730302861"
  },
  {
    "email":"vale.arrigucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818750330/2c4eeedb14cda8f1f77cfb3885fdeddf-1730302861"
  },
  {
    "email":"mariraffin64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818619258/01dd657b451c5acdfbcdd3fa884e9c2e-1730302861"
  },
  {
    "email":"debora.f1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818783098/8d80c35f9b7c1479a4f71e6552b426ec-1730302861"
  },
  {
    "email":"giulietta951@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818815866/1d79e3dea449adc781ec0d2a22a1e67b-1730302861"
  },
  {
    "email":"masusy12@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723818848634/ffc41869c62e9551405684a1be94f6ec-1730302861"
  },
  {
    "email":"mariamarchuk4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818914170/ac25cbe6f1b85855adde054cf372c6c7-1730302861"
  },
  {
    "email":"alessia.milan@iutlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723818979706/8e7befd5633ad14f6c560111b4ff768d-1730302861"
  },
  {
    "email":"giusitcha@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819045242/112d8302eea21f062bdebcee9d1c5a0c-1730302861"
  },
  {
    "email":"laura.lauramauceri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819078010/1b1a7c0dd466ecc729329e1ff0ca1195-1730302861"
  },
  {
    "email":"manzi.michela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819012474/82d08ce8bd96376e019f9a5728bc12a2-1730302861"
  },
  {
    "email":"gracecam74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819176314/8d9aec3a24bfeeab807d374a2379335f-1730302862"
  },
  {
    "email":"lory@fuorimeta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819209082/af315f45913c1b35ba10854ab337f39d-1730302862"
  },
  {
    "email":"ergitameziu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819241850/4b8cc8ab9af179671bbfccd03b6d0b01-1730302862"
  },
  {
    "email":"astorrisilvia81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819274618/80e32f4d99753fc7f92109bd30a12165-1730302862"
  },
  {
    "email":"silvia.pratico@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723819340154/bf278223d0eee732e81bbf11d88159dd-1730302862"
  },
  {
    "email":"criromei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819405690/1d654d67fcfd8201b71ac9093c8b4597-1730302862"
  },
  {
    "email":"advasun@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819307386/54419d136b78ecd579a6bc50cf893d6a-1730302862"
  },
  {
    "email":"rimaden@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819438458/45ab1d698e85b156d7968c8f12d858b4-1730302862"
  },
  {
    "email":"dan.dez@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819372922/7d76c95293b027373782e8fc544c15a6-1730302862"
  },
  {
    "email":"gissara.angela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819471226/b09c67724efbfee44427503e45178e0c-1730302862"
  },
  {
    "email":"chiarageroldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819569530/2c05e7a4cb0074f7fe791ec70ef7cf0b-1730302863"
  },
  {
    "email":"irenecianfagna@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819536762/669be95af8d716745e1381811372d3b2-1730302863"
  },
  {
    "email":"greta0712@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819635066/a07ea0c64bb864a2ea521e5d54fe2bd4-1730302863"
  },
  {
    "email":"veronicascaglione@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819503994/e06b251b15fec47ec760915ec72b35ad-1730302863"
  },
  {
    "email":"chiaramigliorini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819667834/34fb6595f9db15141069109d89b942bb-1730302863"
  },
  {
    "email":"chiara.appiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819733370/03ef13116dc129ca46a1b367debc8b40-1730302863"
  },
  {
    "email":"mirelafrroku74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819766138/485109a861723f3cb39c5fbc0393f794-1730302863"
  },
  {
    "email":"marta.scalini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819929978/a6ed615c18847da0522cff1c84642016-1730302863"
  },
  {
    "email":"mariluco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723819897210/9ad0d9dd2ec379db8b8a980e66567925-1730302863"
  },
  {
    "email":"elena.puato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820028282/7f1e65b747c1b83a4f876107441b8e73-1730302863"
  },
  {
    "email":"m.chiarabuscicchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723819995514/6355a7e72613cb68ce6a678813b45db5-1730302863"
  },
  {
    "email":"enza.vallario@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820093818/b3fa1ba48938aa3fbc891513950be2cf-1730302864"
  },
  {
    "email":"maria.actis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820192122/ffe9f8ccc823d508a8c8e279b41f0fea-1730302864"
  },
  {
    "email":"paola.guerini.pg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820126586/3c4ea85365afb75669e3de9ec1f1dc2f-1730302864"
  },
  {
    "email":"taramy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820159354/bec144fa941621f5686bb4a587755f7c-1730302864"
  },
  {
    "email":"avv.giuliamicio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820224890/6e0ea33a1f300d2e7e8b631209ec0003-1730302864"
  },
  {
    "email":"marinatrombetti78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820290426/5e9ace2e6dd45da2336f72e4a7ed8a9b-1730302864"
  },
  {
    "email":"cristina.locatelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820355962/88cc4e0560e5c880a7887960913dd489-1730302864"
  },
  {
    "email":"dany_de1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820388730/a288f95434079515557f74dd5e06d1c2-1730302864"
  },
  {
    "email":"elenabrugnolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820323194/a52c873521203a0f6d47bb9bd71b75f4-1730302864"
  },
  {
    "email":"micandre111@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820487034/e7780ee24c63630c8be529dca9b273c8-1730302864"
  },
  {
    "email":"olga2022litvin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820454266/f1542f8848b781c3d8c2689b3e865a9e-1730302864"
  },
  {
    "email":"avvpuocciangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820749178/0d7832e0deec28557157d66f523b4cf5-1730302865"
  },
  {
    "email":"mariclemen@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820814714/4170ce99200bbddddf51da35531d417b-1730302865"
  },
  {
    "email":"ilaria.intra@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820945786/b791ad175ac5e24df3919423011417de-1730302865"
  },
  {
    "email":"derosa@idealcarsrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820716410/74e2d1f80a6a8ac7faf8d835e1b40f82-1730302865"
  },
  {
    "email":"facchinettimonica1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821011322/7e0ca9f1d88d67f7c18820c866e28b28-1730302865"
  },
  {
    "email":"mari.tozzi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723820847482/e22bf0047e83e4e241ee64c8106e561c-1730302865"
  },
  {
    "email":"letiziatomarchio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723820978554/fba98cb9e7a83c5c1330a9cccf367749-1730302866"
  },
  {
    "email":"rachaelitaly@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821207930/e4da643b96259bebc17ff57e838ad3e3-1730302868"
  },
  {
    "email":"giuliaboccianti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821076858/a34ca27fb2ef1705ab07385df124f986-1730302868"
  },
  {
    "email":"alessiacolonna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821142394/1b37ca60d8fa15cb35bc310c67f5b0fb-1730302868"
  },
  {
    "email":"arianna.anzil@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821306234/035ff7652c198f069d57656e26a0b6ee-1730302868"
  },
  {
    "email":"elisa.amadei@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821240698/60ab4b1a39b777de30e661ef223535c6-1730302868"
  },
  {
    "email":"ilaria.brandoni8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821404538/bc52ebf3ba8e64761cf0ea8cbc549292-1730302868"
  },
  {
    "email":"cinquecentomia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821044090/eacdc5dfe77bd42616702990fbc7f7d3-1730302869"
  },
  {
    "email":"loredananespeca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821339002/72d1f4c12ab8dfec4ac662b29d3fde3c-1730302868"
  },
  {
    "email":"anna.vegezio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821437306/c6ab6ae30365cf19745847e3cb478f91-1730302869"
  },
  {
    "email":"giulia.garnero@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821535610/dc0f333e185e3ee1ba4fda95aa5650e6-1730302869"
  },
  {
    "email":"f.pezzuto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821568378/3891818e5b0c74264e50f8a14f7b6c4e-1730302869"
  },
  {
    "email":"p.anniballi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821502842/511016a3111038ea0cf09ca4313154de-1730302869"
  },
  {
    "email":"pasqualipatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821601146/3b64042c55a6def807955e845b68e6be-1730302869"
  },
  {
    "email":"laura.pirovano67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821371770/4d79c663da041827bd5171419bcfa7a0-1730302869"
  },
  {
    "email":"beazilio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821699450/c8ef70e132fb8578ae0ddf1d7fca2bff-1730302869"
  },
  {
    "email":"enrica.scimia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821633914/fe1e2e4ba45d7bbc57f66fe1a643308f-1730302869"
  },
  {
    "email":"troysi.eleonora@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821797754/f1e5729a5e25643ebdc7e9f5675ad911-1730302870"
  },
  {
    "email":"daniela.menna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821732218/aa072202d9cc23b43431a8e5cb5c4cd3-1730302870"
  },
  {
    "email":"misschri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821863290/26da2a30f76be82c4ff7f4149a78e405-1730302870"
  },
  {
    "email":"alvitiroberto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821830522/909030510f82c0eb561595efb42831f0-1730302871"
  },
  {
    "email":"sonia.marziali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821896058/55bdd1733daa4768bb8f01a3f22014d1-1730302870"
  },
  {
    "email":"bettalemmi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821994362/c654e0f4ec85e31cb57e2ac409405964-1730302871"
  },
  {
    "email":"marisabattistelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821928826/2dcc51fb61d0b44a749234d6b05c25cb-1730302871"
  },
  {
    "email":"mussoannamaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723821961594/69064b85c2186e3c41397aa9546589a5-1730302871"
  },
  {
    "email":"maruska@calderari.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22723822027130/6bf13fc2bd1f028aaec6f837618d788b-1730302871"
  },
  {
    "email":"bananebananeloup@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822092666/d33756996baeff9b28804ef6151ba087-1730302871"
  },
  {
    "email":"mazzinicarla1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822059898/3a8b9860c4b2a7b53de86c6034ef2839-1730302871"
  },
  {
    "email":"avvocatoannamelchiorri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822190970/340fe5e3605ecbc8ad37b9f2bf0c8161-1730302872"
  },
  {
    "email":"lianacarbons@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822158202/80652afa816a53b9f6eabd12a75597e2-1730302872"
  },
  {
    "email":"pasqualepelella.n@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723821764986/c80c9660940eb875bd2c199514877b1b-1730302872"
  },
  {
    "email":"giovanna.bensi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822125434/11363796532ea8d285c5c852198d04cf-1730302872"
  },
  {
    "email":"pau.herreraletelier@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822223738/035c842ab3a1b111395d6c0bcac14550-1730302872"
  },
  {
    "email":"sdv@studiobarigelletti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822256506/d3d1741a10b093eac9cde2f8ce6c3dc1-1730302872"
  },
  {
    "email":"nardolillo.filomena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822289274/475a38a63a92d62613360513e1709538-1730302872"
  },
  {
    "email":"moniaspada@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822354810/e12b0d3101199b8a952aad3433cb8014-1730302872"
  },
  {
    "email":"laura.cenci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822453114/dd07c545507f49a47fd614cc229ddaff-1730302872"
  },
  {
    "email":"adeliadicicco86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822420346/1de3b6e69feb6bc8daa472e6d98e2860-1730302873"
  },
  {
    "email":"bertolae75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822518650/996e943b6ca8636ec4187cb364bbc14a-1730302873"
  },
  {
    "email":"mazzoni.cristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822584186/f73e6a88245c36e0ebf0a314ff6e6154-1730302873"
  },
  {
    "email":"m.perrone@perroneassociati.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822387578/6ce2ad3f92a0bf5598d339a28bce4893-1730302873"
  },
  {
    "email":"isa.comi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822616954/f0c20dc0f9bae2e9139c685263302f57-1730302873"
  },
  {
    "email":"clamaggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822649722/6509c85713ece0ebec7a83d6694d0277-1730302873"
  },
  {
    "email":"dallastasimone@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822551418/a5b3aed901bf71d8ab4343df9a833a7c-1730302873"
  },
  {
    "email":"al.arica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822748026/97a58f3fbd8a0b96a3efa921ca7b6356-1730302873"
  },
  {
    "email":"dfgiusi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822780794/eefc77e683fea3705a9a7eb38d60b6c3-1730302873"
  },
  {
    "email":"francescabaldassarri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822813562/22f248a7c3f4773fcdd3a0c7a2e24f07-1730302874"
  },
  {
    "email":"fefederica.bertoni@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822846330/2343f8d37f9538d3b8e320bb130c8045-1730302874"
  },
  {
    "email":"maf26@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822682490/c9ab49e33b4ac2b13cc1dc31b50c632f-1730302874"
  },
  {
    "email":"silviastac87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822879098/9ace56731f4d5b4cb32b0192314ff9eb-1730302874"
  },
  {
    "email":"mariavi.gallo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723822944634/8d15095c0ffd30054fca17a5c279c3fb-1730302874"
  },
  {
    "email":"acdanianna22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723822911866/3f9ac44a7d6ec69e2cac01161a1a10a1-1730302874"
  },
  {
    "email":"zarina_21@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823010170/26a048cfa08dad5a570cd26dfff9df1d-1730302874"
  },
  {
    "email":"shabanasamira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823042938/625383da866d4bcabdb7f542063053ad-1730302874"
  },
  {
    "email":"elisamorri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823141242/fc041c6d2963e2a627e9615571e15585-1730302874"
  },
  {
    "email":"silvi.perego@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823075706/cc07905114513557333c6f64851560ed-1730302874"
  },
  {
    "email":"lattaccabottoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823174010/86d4b6fa124d00e6a777c5c83826673b-1730302874"
  },
  {
    "email":"claudiag28@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823206778/b57939e9afadb05f9d9cf9fbc574c946-1730302874"
  },
  {
    "email":"bavellir@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823239546/82cf059d593233d398f87a301fcdecc3-1730302875"
  },
  {
    "email":"olgacatanese@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823272314/e2671b34d74d4b9120cbcb6f1f9879dc-1730302875"
  },
  {
    "email":"mariasilvia.zanin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823337850/e972f02ce0430270f78281c5c61ab77a-1730302875"
  },
  {
    "email":"elly_mary@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823403386/56668737f349c5a03626af96879dc74f-1730302875"
  },
  {
    "email":"sara80casadei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823436154/4a4cbf37b1a168032be141d99faada3f-1730302875"
  },
  {
    "email":"stefysan77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823370618/4abc30fa56d137b911a39f20729df2af-1730302875"
  },
  {
    "email":"milena.chiarello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823534458/236b9b6a385c5b1aa234a66a06beae9c-1730302875"
  },
  {
    "email":"mcarlaottaiano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823501690/5a85cb29c1e827a034d4a695e0dfcc28-1730302875"
  },
  {
    "email":"avv.francescagalletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823665530/1ad0024c573977133dfb0dc60a6cffed-1730302875"
  },
  {
    "email":"valeria.cucchiaroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823698298/8dd215aa12419044a60065946021b857-1730302875"
  },
  {
    "email":"tittiscotto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823632762/991a7095b7df4694671864bb8ec327da-1730302876"
  },
  {
    "email":"mariaantonietta1958@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823731066/c703b8c5b247ea70a3de65be010b5321-1730302876"
  },
  {
    "email":"elenaboldrin90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823796602/2124c5a5439b1ab49e45938c2a55bc0c-1730302876"
  },
  {
    "email":"info@labottepiccola.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723823567226/e04248c39f27fd93062e4a32c7cce9b2-1730302876"
  },
  {
    "email":"a.chirico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823829370/578a7bab8a9f785435bf6dd2572f38da-1730302876"
  },
  {
    "email":"annamariacrasta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823763834/9ed5dc487e8a7c0c0190f2e004382137-1730302876"
  },
  {
    "email":"feliciacarfagna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823894906/c6cf79e83f88be1b4771ffc1503359f4-1730302876"
  },
  {
    "email":"martina.masiani@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823993210/70b93000ce03064c82ddfe38ceb86855-1730302876"
  },
  {
    "email":"car.diva@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723823862138/8adabfdfc76363d4dfd4919febdaaf2c-1730302876"
  },
  {
    "email":"emanuela.giampaoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824025978/a5d233aba49efd2d5dde29c6b4222308-1730302876"
  },
  {
    "email":"marchfilippo2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723823927674/20e474f709efa1a79e5b789ac6c5700d-1730302876"
  },
  {
    "email":"luisa78lmb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824058746/986076c7725076ca5e74b4b9aca5feb0-1730302877"
  },
  {
    "email":"alessiapag@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824157050/147ecd918eb4fc6a839dbcff0f137d17-1730302877"
  },
  {
    "email":"sabrina.mangili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824124282/8b72a707a2ecd41b161d71cd64483dd3-1730302877"
  },
  {
    "email":"mary.carmine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824091514/9ad6418acf73a132f7aa2bf1fe586c4e-1730302877"
  },
  {
    "email":"costanza.malservisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824255354/d76ee5cfb9bb2fca1d747eb89ef642f4-1730302877"
  },
  {
    "email":"duchioccia2001@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824222586/42789b36a2d18e032515c7d95d406b06-1730302877"
  },
  {
    "email":"ritavigna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824288122/6a1a7065dd7780bc0863bdd3f4311677-1730302877"
  },
  {
    "email":"frency77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824353658/fe31982958734e1d274b48c3a495bad2-1730302877"
  },
  {
    "email":"sartorelli_snc@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824386426/27f8c745196de4f73583be2ff5fbd93b-1730302877"
  },
  {
    "email":"giovanna.quidacciolu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824451962/bcd75e510a0c62d0ee8494a15dd175f8-1730302878"
  },
  {
    "email":"romano.graz2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824419194/eadfe422f73b3d9488a33c4bac0d215a-1730302877"
  },
  {
    "email":"emitira@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824484730/b2b84f47345086fb82ce3279af0e2986-1730302878"
  },
  {
    "email":"t.tardio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824550266/f445a5d810be875e06a18a4562c2ba10-1730302878"
  },
  {
    "email":"michitren@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824583034/8f446fc2872c7c56e4a0547118d5ce81-1730302878"
  },
  {
    "email":"mfravale@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824681338/a95008551c5deda87953ae54b086b90c-1730302878"
  },
  {
    "email":"anna.malcangio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824648570/204ed156f19f19bef7b887e1b0e13765-1730302878"
  },
  {
    "email":"irenebartalini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824615802/4b8857bc2a0b189d44bf33da3d6c5d67-1730302878"
  },
  {
    "email":"nagazine1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824714106/d39bb001e86c75fc2f7a158c00590bb8-1730302878"
  },
  {
    "email":"ppalelli@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824779642/773834d744f63c11ff95f1f6dcaed47d-1730302878"
  },
  {
    "email":"aledeporzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824812410/0939118566bb4681d050694f63acbb1e-1730302878"
  },
  {
    "email":"c.dadderio@aliseo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824877946/f21624a464cdd024d6450d53ec0fb8ba-1730302879"
  },
  {
    "email":"chiarabuizza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824746874/3628b89dd12a0f837292089acfbefa4b-1730302879"
  },
  {
    "email":"mmemola@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824910714/6349740f814ec1972e70878f0e246796-1730302879"
  },
  {
    "email":"arkstefania@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723824943482/bd7fdc0e83435422eaf102c29efc8578-1730302879"
  },
  {
    "email":"r.mattei@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825041786/52752fc2609b7749a95e0b6433defeae-1730302879"
  },
  {
    "email":"cate74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825172858/b1e819f286e9a749901024be880e80f2-1730302879"
  },
  {
    "email":"francescamiccoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825205626/42100a47f3740cef90af23ef0b6bffcb-1730302879"
  },
  {
    "email":"vivianamangiacavalli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825336698/cdfafc1858eb1e766d8d1933b0f51626-1730302879"
  },
  {
    "email":"soniamoscato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723824976250/6ff90dcea3d4e709522ca9cd2e4add1d-1730302879"
  },
  {
    "email":"elenagrena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825369466/fae30db9fc5359a453d66daf2565c317-1730302879"
  },
  {
    "email":"annamaria_brancaccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825435002/b3aff67ccc7d432606a0445d6a2ab05b-1730302880"
  },
  {
    "email":"marina1976@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825566074/794144889c3bfcaf14af3b093f2ec730-1730302880"
  },
  {
    "email":"chiaragallond@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825631610/e6d80b73ae02e01df9c8bf18d72ab058-1730302880"
  },
  {
    "email":"alessia.ferrando01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825402234/617691a06aa15cf522b0820845e290d0-1730302880"
  },
  {
    "email":"giometti.dania73@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825697146/d1010f4056a210ec8f40232a13088d2d-1730302880"
  },
  {
    "email":"antonellagiglio77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825729914/56117b5f5aa11a8a2378b5c2ae64e1ea-1730302880"
  },
  {
    "email":"marti.maraschino@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825664378/c89718132958593da728dd8a37e30288-1730302880"
  },
  {
    "email":"erika@ighirigori.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825598842/f373930985b783991222d68c1701add9-1730302880"
  },
  {
    "email":"ottonellofulvia18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825860986/c8e15924f7cc5fadea6467ee31a8562d-1730302880"
  },
  {
    "email":"carlapira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825828218/dd9940155e921b5021d92c1474408b4c-1730302880"
  },
  {
    "email":"paolap73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825893754/9e24441f4d93dabcbecaa7c5ee9d36bf-1730302881"
  },
  {
    "email":"nunziaroberto70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825795450/453094bbf6c8025b5794cb3d5d9388e2-1730302881"
  },
  {
    "email":"m.rota@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723825926522/9eea1323aafd9e20518723d8dbeaaa59-1730302881"
  },
  {
    "email":"dinavalentina0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723825959290/5bb4174d1f810b839bdb3bfda470291c-1730302881"
  },
  {
    "email":"rosadem@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723826024826/0bbbf9e46e97f77cd06758f4d19bd84f-1730302881"
  },
  {
    "email":"silvia.pellarin@hp.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826057594/7450f6f0817f96cec934ec732bfbc5d1-1730302883"
  },
  {
    "email":"eletrilli0376@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826123130/47573c47cf7c6bc243b5999e0db88115-1730302883"
  },
  {
    "email":"ciavolinog@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826254202/03ccde895a40132c5bd811312f72253c-1730302883"
  },
  {
    "email":"gracycot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826352506/c045297f08b6208e403abb1064205407-1730302883"
  },
  {
    "email":"rossilvia2012@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723826319738/09693fbef839345482d26b6da8f64ef2-1730302883"
  },
  {
    "email":"turfaby@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826090362/619095f4669acb8e7b5002adb3872985-1730302883"
  },
  {
    "email":"alina.bia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723826450810/e6fc1270d86f1f3121fcac6bad76389c-1730302884"
  },
  {
    "email":"gufmar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826385274/cbe74702b0c03057263d75c9ae04b4c7-1730302884"
  },
  {
    "email":"pubblicam@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723826286970/726d12e28322366b57427839e1c8ec5a-1730302884"
  },
  {
    "email":"danielavegni80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826614650/f215794f460940117e04479e5f6ae326-1730302884"
  },
  {
    "email":"elirigante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826581882/ac7d48fc4b1ad8040e5b124ba44f0116-1730302884"
  },
  {
    "email":"morelloalessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826680186/b39ca74123c2116bcafec8a4ada6bab2-1730302884"
  },
  {
    "email":"tersignisara30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826712954/c38670b24b4ec44c6d2bc1ff148a63be-1730302884"
  },
  {
    "email":"storthouse@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723826745722/3f22c692f060afc04e7226672ec3930a-1730302884"
  },
  {
    "email":"silviadercoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826844026/ccd82240fea1c93f0e7bd99f67e939c9-1730302884"
  },
  {
    "email":"clo.s80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826909562/fba2e82efebe29119b04e626bc11b4e2-1730302885"
  },
  {
    "email":"vballotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826876794/09acef010e17a69b3edcff8c9fb3d4ff-1730302885"
  },
  {
    "email":"cristib71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826942330/fd93df4f62b7aaf6c32fce1205fc2aea-1730302885"
  },
  {
    "email":"antonellamagagnato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827040634/2672700bdf6b96c2200666868f5b2893-1730302885"
  },
  {
    "email":"alberto.bompani.ab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827073402/4f8eb54598bb414abaa33b1c2821c005-1730302885"
  },
  {
    "email":"qibolove@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723826811258/2b2da1ebd45e9a330f239bcdd965379a-1730302885"
  },
  {
    "email":"femo1677@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827106170/2890f7c5c7399387143b238945a98fbe-1730302885"
  },
  {
    "email":"dm.vida.dm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827007866/63b1571378407e84346fe093eca9151d-1730302885"
  },
  {
    "email":"mditota@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827237242/6ef7c99f01c661d3e6c251163093f287-1730302886"
  },
  {
    "email":"licccristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827270010/3406feaed6af2416584833e6a0310cf7-1730302886"
  },
  {
    "email":"carminatisim@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827171706/8ec42150ea5b485423a56e708a43f0e1-1730302886"
  },
  {
    "email":"giobi84@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827302778/c20ac8f2e9b02c6341187674b5f3f8a7-1730302886"
  },
  {
    "email":"luciomasiero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827138938/c55a759d931ec2c9c012d53427920398-1730302886"
  },
  {
    "email":"linda.guglielmo22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827335546/9295e2e5034e253a50543591beb225f9-1730302886"
  },
  {
    "email":"marenco321.sm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827433850/a6541eefed4bd320a665d9ba61f1c009-1730302886"
  },
  {
    "email":"barbaralitame@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827401082/3459332413394b6c8ab9cd7982563686-1730302886"
  },
  {
    "email":"rossella.castangia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827466618/13bf159b6bc98e14f45983fc04e9041f-1730302886"
  },
  {
    "email":"valentinamellano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827564922/54d37515404eb1f435a1d8996a7ab111-1730302887"
  },
  {
    "email":"caterinasciu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827368314/b085b22c48f8f70aacf8155f27f14f35-1730302887"
  },
  {
    "email":"elysa75a@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827532154/86c0db3380c079243a1d6b057906c76b-1730302887"
  },
  {
    "email":"luigi.lamini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827597690/02883fd993b24af32f0865b7c5fdcfbb-1730302887"
  },
  {
    "email":"pierluigi.s1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827761530/11795deaa4f1456b89ab4ca7b00ca639-1730302887"
  },
  {
    "email":"dottoriv83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827728762/8e498c79850991e894bd664b4eb34ab8-1730302887"
  },
  {
    "email":"m.lara.91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827630458/aa28e9e12dcc1a0650fc12319069e40c-1730302887"
  },
  {
    "email":"mgiamba72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723827794298/3579dac20a8aeb5902409b8232887ddb-1730302887"
  },
  {
    "email":"annaromanelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827827066/be0f39b0f66cafe42012bdd0c1f3955d-1730302887"
  },
  {
    "email":"elisa.rambelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827663226/06af865b2183c93031dcfc98099ef8f7-1730302887"
  },
  {
    "email":"perini@promab.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827859834/5a94183cfbe6ecb23d542bf3dac3f2bb-1730302888"
  },
  {
    "email":"roberta.verola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827958138/acadad8403f523a7fdaef1b6b5575286-1730302888"
  },
  {
    "email":"silvibeggio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827990906/1761e3663b6b8808e226b206e299d25d-1730302888"
  },
  {
    "email":"milenamai17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828023674/11c6295d8841d5cfeabf4d7c3dadbeb2-1730302888"
  },
  {
    "email":"mirella.daietti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723827892602/fc05fb26525fa8e842ea28d76ff25b13-1730302888"
  },
  {
    "email":"grazia.trinchera27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828056442/fc60fd4d2cef8d6f6985b4a40092e1bc-1730302888"
  },
  {
    "email":"france.lolina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828154746/f0576ae5bd47b6d334dd194c0252cc1f-1730302888"
  },
  {
    "email":"isabella3011@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828187514/ab2fb9861660f689d4349440e7bf3e1e-1730302888"
  },
  {
    "email":"vallonz06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828220282/804fc5aa90214d1db9509103e018bdea-1730302888"
  },
  {
    "email":"pinuccia.ferrarotti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828285818/91055705954667a769fd888387e610e5-1730302888"
  },
  {
    "email":"marcella.bulfarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828351354/70bbafa252a21d365f64453c40b718af-1730302889"
  },
  {
    "email":"cristofarokarola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828416890/b0bc728afd4823c4c162ab70aa7ae946-1730302889"
  },
  {
    "email":"marianna.testi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828253050/fb9f45e6a1195a7b08621213f9f22939-1730302889"
  },
  {
    "email":"info@domenicobaratto.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828449658/63c1d66f76a8ffcd376af069d794bbba-1730302889"
  },
  {
    "email":"cristina.mallamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828318586/d56458f562d2e2c180ffb7741fc0c50c-1730302889"
  },
  {
    "email":"ant-carlo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828482426/4132be82960399091c3e990c19dbdabc-1730302889"
  },
  {
    "email":"lucia.gallerani@areasicurezza.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723828580730/106ceb5fc83fc205f2cd2353e91e5031-1730302889"
  },
  {
    "email":"jennirenzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828515194/7de5328ad4e3ee138a6af41b04feee0b-1730302889"
  },
  {
    "email":"raffaellasirtori@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828613498/ebb304e40fa0007470c969ea2221b554-1730302889"
  },
  {
    "email":"elisadori@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828679034/8efacf7641c37c7d06a45a0105480eb9-1730302889"
  },
  {
    "email":"chiara.patue@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828711802/b359028c5eb3ade3449cf315b089e36b-1730302890"
  },
  {
    "email":"pdibenedetto@manzoni.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828777338/02778306419d7070f7a5a8eca97ccee2-1730302890"
  },
  {
    "email":"stefibernini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828810106/bdeb33d613a73bac29698b349eec88a1-1730302890"
  },
  {
    "email":"favinopaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723828646266/03403be73e0d0dab803df08d7c6f5a5d-1730302890"
  },
  {
    "email":"aurora.delia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723828941178/284d05580972003b7aa4f7a2c36cee75-1730302890"
  },
  {
    "email":"simona.magistroni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829006714/961bb41c6a38450d1073db1272067d4a-1730302890"
  },
  {
    "email":"patty.goldoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829039482/df8deab64a0f8c44ba2057adedd87f58-1730302890"
  },
  {
    "email":"valecaroti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829105018/31dd09579141798cdaddade510a19c57-1730302890"
  },
  {
    "email":"boselli76@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829203322/1e197a285fe976d4d35dbed717c88a0a-1730302890"
  },
  {
    "email":"multispazio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829367162/b492afc7fe0d245c6bae22972a2ac46c-1730302891"
  },
  {
    "email":"barbaramercuri18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829072250/0512b168722499c9dcde1021d13556d7-1730302891"
  },
  {
    "email":"silvia.tabarroni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829465466/4d2ad75020cb71bb7982510d9fbdcad7-1730302891"
  },
  {
    "email":"gracebell.30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829432698/c3c0535d342d0b796ce8747b46ff55f2-1730302891"
  },
  {
    "email":"andrelondo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829236090/81957c2c7e2e5fc6d8a12383effb8872-1730302891"
  },
  {
    "email":"soleebellezza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829563770/da4d768427b51913d40c8d649b7e114b-1730302891"
  },
  {
    "email":"anninaannuzza@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829531002/e089a9712aa84b8280721bee99042860-1730302891"
  },
  {
    "email":"caterina350z@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829301626/f4a5599158699b94905d8b2288bb4c12-1730302891"
  },
  {
    "email":"valentina.petriccioli@isa2laspezia.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723829629306/83b43056c79b29c4f26bf60af6ad3393-1730302892"
  },
  {
    "email":"nandoromi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723829727610/f01c6e302d3ace871ec62821c290ff50-1730302892"
  },
  {
    "email":"cinzia.ramondetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829694842/a6b41c5172672c25f3a0bc14f616f4dd-1730302892"
  },
  {
    "email":"marfer2673@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829596538/7c3ffee672f1827529944b8788e4940c-1730302892"
  },
  {
    "email":"98sarahf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829793146/6e28b9ac5812a542681d856c6163747c-1730302892"
  },
  {
    "email":"mg.ferrarelli02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829760378/46ab956a2fff92c7d5ebf5a6b4bc7da6-1730302892"
  },
  {
    "email":"emanuelamanfredi9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829825914/5eb0f80d147385c8004aa0d383f0b4a1-1730302892"
  },
  {
    "email":"ettodino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829858682/fe937e2c1abd695c3bf7b0c911f0e3a5-1730302892"
  },
  {
    "email":"luisa.landini@ronchigioielli.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829924218/b74bc9d06abee3a821fe603c336b28a4-1730302892"
  },
  {
    "email":"veronica.galioto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830022522/d5567e07accc0cde2f2e5c595faf3c7b-1730302892"
  },
  {
    "email":"crisallika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830055290/eda8e2b84987913245051ba192cc93c2-1730302892"
  },
  {
    "email":"m.angelini67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723829956986/3c3d6a9c26976350c43139ccbff1d9e4-1730302892"
  },
  {
    "email":"deagostiniromina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830120826/91f81de11e9e0d02711d026155cdddf2-1730302892"
  },
  {
    "email":"federica.dalchecco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830088058/b551d9d8af9484536dc5433a58c20166-1730302893"
  },
  {
    "email":"marikabracali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830186362/bd58053214edc11c2c11db0f0db9ebb6-1730302893"
  },
  {
    "email":"martina.corradi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830219130/7734698fd559edf7cc45cf471bda6225-1730302893"
  },
  {
    "email":"smalandra75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830251898/f5c3e5a9672419e40118fecaf5853d25-1730302893"
  },
  {
    "email":"silvia_pavan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830350202/0ec447a81e9c99f3f0c543a2458cf6be-1730302893"
  },
  {
    "email":"maria.mussida@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830481274/6a6ca8fb52e91ee67ae812e4d6c49a4f-1730302893"
  },
  {
    "email":"isapesce79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830415738/d00395241d50fa96f59baa9bc1c87c29-1730302893"
  },
  {
    "email":"claudias86@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830514042/12427c68491755a2a37ba341ea01b2a3-1730302893"
  },
  {
    "email":"bice.tononi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830546810/b3f290211833ae96f17d37f60d69d9a9-1730302893"
  },
  {
    "email":"bronzimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830284666/27fc4dea96a9f55705aed482321b0769-1730302893"
  },
  {
    "email":"maria_faraglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830579578/5c0215b9493a976254df8c5a8a4ea4f0-1730302893"
  },
  {
    "email":"barbarabagaglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830645114/0af9bf748350f3ba8013fe5b30b3c959-1730302894"
  },
  {
    "email":"lorenza.parabello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830612346/6b53af5ba2a4385044ee113f2b5aaff4-1730302894"
  },
  {
    "email":"r20101959@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830710650/8ebb0e45a9176fd37191316670c48263-1730302894"
  },
  {
    "email":"margheventura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830677882/5b8113e12bd770c67b962a91f52867d2-1730302894"
  },
  {
    "email":"cristina.rigamonti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830808954/a4c1dcec9aec0384c2e93d8b9735193b-1730302894"
  },
  {
    "email":"michitoniolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830743418/b5a695502a994d8c970c8aff581366f3-1730302894"
  },
  {
    "email":"b_veronik@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830841722/17dfa6fe7f721776e5940aa55f7b1fad-1730302894"
  },
  {
    "email":"ginatalarico@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830907258/8ff6b1b6f8fab893b7379b0ee6d1a4e0-1730302894"
  },
  {
    "email":"pezzato.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830874490/4d8f333c400ef0f6e0045b02df5d59c9-1730302895"
  },
  {
    "email":"elisa.ecoretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830776186/535570f56774473cfde1da17d8c545ff-1730302895"
  },
  {
    "email":"claudiabocchino78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723830940026/e3200d82c72b620767269f44091382a8-1730302895"
  },
  {
    "email":"azzurraciambellotti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831005562/2bf2059bd62a37c4b38bbba98f21c2e0-1730302895"
  },
  {
    "email":"rossana.totaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723830972794/cea4e15fc6a03a6adadacb54300e9985-1730302895"
  },
  {
    "email":"angelacrisafulli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831169402/3fcef320b3d2d3a8d9adcac3bae35ae6-1730302895"
  },
  {
    "email":"silvia.petrin75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831103866/e03d437cbcdd0c6a77206ea7355bf777-1730302895"
  },
  {
    "email":"chia.frn80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831038330/6d9e5b3488393e589f3e925b7d80f63e-1730302895"
  },
  {
    "email":"vitamaria.lorusso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831071098/5db59ec6f51b144484c660f3b17f3b51-1730302895"
  },
  {
    "email":"tizsilvestri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831267706/a43ae917ecfcc77533bc7b27723ac018-1730302895"
  },
  {
    "email":"pauliina.deanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831202170/58cac7cf31752023a076a58fc3d17db0-1730302895"
  },
  {
    "email":"simona-77@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831234938/9f35b883e90902f07be49510119aab3e-1730302896"
  },
  {
    "email":"studio.elisabettabaglioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831398778/9c58116351710291b2331fe21947b389-1730302898"
  },
  {
    "email":"alessandra.dipietto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831333242/c4c2b60ff89bb2624d83fa583f66088c-1730302898"
  },
  {
    "email":"cristinasimen1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831366010/53a6da3e3f3e34afa6e2cfab3d034e71-1730302898"
  },
  {
    "email":"ica.sorbi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831300474/dc1716dcb0def4e6fcd4cfc8fb4ccd28-1730302898"
  },
  {
    "email":"silviamamma@me.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723831431546/bd8a0ee25aef265178912749178fa246-1730302898"
  },
  {
    "email":"patrizianovaro43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831464314/50bcebb6729cbcc961d7681cd26b9cb5-1730302898"
  },
  {
    "email":"riva-alessia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831497082/556c472d16eb5e64945ea439768d3a98-1730302898"
  },
  {
    "email":"manuamo91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831529850/936841c49de3c7c214082d5c0b7c00d1-1730302898"
  },
  {
    "email":"mcimenti@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831562618/afeb3fefed9e719e06691c48518d337e-1730302898"
  },
  {
    "email":"mariannagaravello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723831759226/2d5174a17ca9d7f6766b0d8e7a2ad019-1730302898"
  },
  {
    "email":"stef.sechi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723831923066/ab60fef76f60cf218516d5d1d988e3d1-1730302899"
  },
  {
    "email":"vpiemonte@fideuram.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832054138/6d852be682557b628b43f6e0f5583ea0-1730302899"
  },
  {
    "email":"miraviglia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832119674/a1c2181c6c27e4c6df2f0f1d47b1f4d5-1730302899"
  },
  {
    "email":"corrias.lorenza@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832152442/ba531cb17396f4942f4aa71c2fa12f17-1730302899"
  },
  {
    "email":"danberia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832185210/bbce0f5fb65c6944af527a37d0880462-1730302899"
  },
  {
    "email":"minelli.anna77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832250746/c4bb9bd98f8eaabb7aa45c01aac5ebc5-1730302899"
  },
  {
    "email":"battistiniscale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832283514/de8a4c5dffde5d6b9bff657a57079dc1-1730302899"
  },
  {
    "email":"benedetta.barro@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832217978/558988bd5e444e564d0f5afc51ca7502-1730302899"
  },
  {
    "email":"laumartin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832349050/3b2ffdfdde05bbe8b084e5f93ac265f7-1730302899"
  },
  {
    "email":"elisa_dollorenzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832316282/57e6b7d0dd3ac802df9493d296847d2e-1730302899"
  },
  {
    "email":"rossana.latini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832447354/4a90daac39e567a70d3466718bc098b0-1730302900"
  },
  {
    "email":"marisacolucci54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832512890/c3aa28d7792d34fa8a3c26f389749276-1730302900"
  },
  {
    "email":"vignadanielle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832414586/bf561a030fef28130df4868e5c4d3a03-1730302900"
  },
  {
    "email":"m.graziamichelini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832545658/a9057caebd5c4220a1fca0971965e788-1730302900"
  },
  {
    "email":"robylander@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832381818/6682796b4e97798414e3fa627e38a8c5-1730302900"
  },
  {
    "email":"barbara.boscaglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832676730/aa01efbf250fcbbde80247dfb1f36be3-1730302900"
  },
  {
    "email":"antonella.ugolini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832578426/28176c01a3788f2dadf974130d4834df-1730302900"
  },
  {
    "email":"marina.7673@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832807802/5871e7ca787721193fa994f3fe1a827b-1730302900"
  },
  {
    "email":"chiara.cantagalli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832611194/17f3d18b3512da3de822a8bcef2172fa-1730302900"
  },
  {
    "email":"gaia.rosenberg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833004410/b045cb2018f76b12ec76005ae44370cc-1730302901"
  },
  {
    "email":"chiarabucelli@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723832906106/ba92383be894f793456feb23fd937ba4-1730302901"
  },
  {
    "email":"alessandradivani10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832971642/4b7cca2aadda9470daa23c67203e9668-1730302901"
  },
  {
    "email":"luisasbrizza@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723832873338/faed4043d394a9ab7996a056b4bb30b1-1730302901"
  },
  {
    "email":"mariangela.golia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833037178/a97dd3991fb8f227c7a696f8630b6479-1730302901"
  },
  {
    "email":"giulia.degliesposti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833102714/0baddeba37dbc9390f66bafc8fa3e219-1730302901"
  },
  {
    "email":"faustotagliaferri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833201018/836d847eaac89c5b96426d2c1f98871b-1730302901"
  },
  {
    "email":"gentilevalentina985@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833168250/305943cf4d38ce2b3a9cd99e2661b4b4-1730302901"
  },
  {
    "email":"uvapassa88@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833233786/045a1ec668bb49a91e93698170f93904-1730302901"
  },
  {
    "email":"annamariaricci0608@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833266554/2ba8185d55d2836ebcd9936b772adcb7-1730302901"
  },
  {
    "email":"avv.saraerrico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833430394/c38a75b87a447042f963bfcb47d9a986-1730302902"
  },
  {
    "email":"rrapillo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833364858/be559cb51581d32980255eb284d0a399-1730302902"
  },
  {
    "email":"irebandi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833332090/1bd2ffe609e7832a9b2f9dfaabf8dae3-1730302902"
  },
  {
    "email":"giovannamaccari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833495930/177e47cb5dedebed113db6c3a7654c41-1730302902"
  },
  {
    "email":"ritaeffe81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833528698/df0b2c48ceee9cb9ca0e1eb08b737835-1730302902"
  },
  {
    "email":"gionorri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833299322/a4c792529d4c7b98adefbe5f2afd58e7-1730302902"
  },
  {
    "email":"luciamoriconi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833561466/c81baba203d64009546d79240ff0e3c1-1730302902"
  },
  {
    "email":"mariulang@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833463162/d2441b388578548014efc1faaf72d414-1730302902"
  },
  {
    "email":"assuntagrimaldi7733@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833594234/527c8b78deec4e2f3fecec1c85810478-1730302902"
  },
  {
    "email":"sibillasipione@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833627002/f753934e769ada250137665c1d3a8e32-1730302902"
  },
  {
    "email":"valeriagiannecchini72@gmail.comgmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833692538/fc4a2711ec292375637a3305ce818b8a-1730302902"
  },
  {
    "email":"siouxsie3@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833659770/46e46c1f6174fb4c0b543cca264784b1-1730302902"
  },
  {
    "email":"mara@studiolegalebiaggio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833725306/abc82870e1961aaf3d26e2d9177f045e-1730302903"
  },
  {
    "email":"marziabracci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833790842/8f8bbaf32d1b83e72a35e20780484361-1730302903"
  },
  {
    "email":"elisacoletta81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833823610/8181b9324537ecdac52244e02a1c5c3c-1730302903"
  },
  {
    "email":"vale3781@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833889146/c18d86cfa65b179e2cfcede5cbf83c42-1730302903"
  },
  {
    "email":"fabiostefania1963@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723833758074/339a69001d1e2c95b8d31049aa49967d-1730302903"
  },
  {
    "email":"cinzia.cingolani76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833921914/f55a9883119de86c8ef461d057aba521-1730302903"
  },
  {
    "email":"simonazanzi@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723833987450/82867f33da1ff6aff6f06f442230d9f4-1730302903"
  },
  {
    "email":"penokia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834020218/47bb84c3e09c95228f1c24576566be14-1730302903"
  },
  {
    "email":"francescameneghello@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834216826/f44ebb00dbaf732825ff674a02777e11-1730302904"
  },
  {
    "email":"lunardi0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834085754/c633f308f1cbd069ac437f51835387b9-1730302904"
  },
  {
    "email":"md2265.md@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834282362/08238bc982e57ce7e78c4a481f9c4475-1730302904"
  },
  {
    "email":"marghe.cavassa@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834249594/1391242db8b89942e9e29924032508d0-1730302904"
  },
  {
    "email":"sabry5fabbri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834184058/faf200943bf013c5833144c5461f9740-1730302904"
  },
  {
    "email":"mauraiencenella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834118522/8174ae7a34cda5d7d172e380e747f462-1730302904"
  },
  {
    "email":"valeria@diven.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834315130/0d3f094871e164484e16f077e0e671ac-1730302904"
  },
  {
    "email":"manuelax75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834347898/e78a0527087584677779c4849463fa3b-1730302905"
  },
  {
    "email":"veronica.neretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834446202/c4688eabff292077032cd9675c699547-1730302905"
  },
  {
    "email":"annamaria3dimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834478970/e3559fbb49b08004972aaef10a46c5bb-1730302905"
  },
  {
    "email":"hairfulvia56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834544506/340964751701dfe79f3df144addb1222-1730302905"
  },
  {
    "email":"marta.antonini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834610042/a85b93c143c1ca4c0a4fa5fd5a7cb3df-1730302905"
  },
  {
    "email":"francesca.canese85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834413434/47bb2bff6eb222a4b648141f1759915c-1730302905"
  },
  {
    "email":"ida4vittoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834642810/05ddbddc7fa171797dcdbad66b1f9084-1730302905"
  },
  {
    "email":"laura.borgogni60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834741114/9852bea5460ed7340151740ae150872e-1730302905"
  },
  {
    "email":"sabina.pavesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834675578/b3860656897167abc6b8822e807de90a-1730302905"
  },
  {
    "email":"maria85@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834577274/8cf362869f8825b5a44ce3ff8c120ffb-1730302905"
  },
  {
    "email":"giovoppido@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834773882/01c7a4d51c797aad8784cac17c1aba68-1730302906"
  },
  {
    "email":"elenina_r@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834839418/223dd36d6e5aea8a42d4abf275f0c440-1730302906"
  },
  {
    "email":"rosalba.pinto1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834872186/25939b4f7219421e030328c0bd205b6a-1730302906"
  },
  {
    "email":"robertagiandonati@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834904954/fcd7a7f1c8d263b8a4837b5067948956-1730302906"
  },
  {
    "email":"elisabetta.cibelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723834937722/ba413e10320d3c36b903b7ab9a49d824-1730302906"
  },
  {
    "email":"vittoriapischedda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835036026/fe5de46395af9b43bd195dcbecf8fd7b-1730302906"
  },
  {
    "email":"bianchinsilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835068794/859b889f7243b4b06736da24c58c4eef-1730302906"
  },
  {
    "email":"danielalucciarini9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835167098/56cdbe0bec455ffd61342113ea8f429b-1730302906"
  },
  {
    "email":"michicamossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835199866/308b2eac93d145a1809325b03d2d6405-1730302906"
  },
  {
    "email":"triestina.corinto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835265402/95796467d640409b40e30c03257c9228-1730302907"
  },
  {
    "email":"ale.bluwave@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835232634/94f2ac2d8a55f4797b48e7a6a83fb487-1730302907"
  },
  {
    "email":"cfumei@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723834970490/8fe2a5ee67e508dfd73693f658b3e453-1730302907"
  },
  {
    "email":"giuly_ross@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835101562/1c28b713edc89686db6a194f52d86a77-1730302907"
  },
  {
    "email":"funnyrusso75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835298170/87d11e4c7c18e78bcfe4552acec7da0f-1730302907"
  },
  {
    "email":"borghesucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835363706/aa631f86b3677b5a39d9264331b57130-1730302907"
  },
  {
    "email":"nadiaguadagnuolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835330938/5ccec982becfc046e04fdf1d1b456441-1730302907"
  },
  {
    "email":"md.222@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723835396474/bd2ee9efc7b7c442e23eaff136a20e51-1730302907"
  },
  {
    "email":"elisafregonese14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835462010/0a23f4743de63250b4b0e6b1c645052a-1730302907"
  },
  {
    "email":"annagioia.lo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835527546/00ec2a035157c160272e9fba44c6da08-1730302907"
  },
  {
    "email":"stefania.radice@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835560314/c4bad7d006bae17ec977a7681f6fcc0b-1730302908"
  },
  {
    "email":"bastariantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835494778/312eb04b21ce4cee40cb035cdfd11a0d-1730302908"
  },
  {
    "email":"lucia@luciabeltrami.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835724154/21e47fd2167648c741ed5895f270550e-1730302908"
  },
  {
    "email":"cinzia_dimauro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835658618/12f3c9e83e67e9a1b4b445eea678c756-1730302908"
  },
  {
    "email":"sag_giagu@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835625850/972fd89c0e986087b9d5a1c980c13117-1730302908"
  },
  {
    "email":"zucchi_claudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835789690/224e97f20c1ecd3a59396deda2c80709-1730302908"
  },
  {
    "email":"matilde_1979@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835593082/e337d80c458e7d003f38982e27fec973-1730302908"
  },
  {
    "email":"luciaprima57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835756922/fb0814c83830ac94580610af8ed6c8a1-1730302908"
  },
  {
    "email":"frasna74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835887994/ca9b1519f6de454ae46de93ededd1399-1730302909"
  },
  {
    "email":"marziabordoli@interfree.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835822458/c4638281e1f8d67bef7719f84aa750aa-1730302909"
  },
  {
    "email":"nunzia_petrosino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835953530/197e2d77c8894a0075cd7e69e5c5186f-1730302909"
  },
  {
    "email":"sandro.rav@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723835986298/052f090b4b09329d64900fb1150aae47-1730302909"
  },
  {
    "email":"daniela.trincone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723835920762/9a63965768899216127bd0d543175e3f-1730302909"
  },
  {
    "email":"cmeliota@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836019066/bcc7513508107ae51d877f6f2c5a94ce-1730302909"
  },
  {
    "email":"simo.rabitti70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836051834/a3f4f3be8a27ae0caf8366a07b4c5504-1730302909"
  },
  {
    "email":"renatamorresi13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836150138/a6dff76fa7ebace68369ac9cac63926e-1730302909"
  },
  {
    "email":"lucianomarino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836215674/1fd2f99408afbade82c4cc9b32254669-1730302909"
  },
  {
    "email":"monicaducoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836182906/74f90f4688c3c451ff00e4e4c4eb9a58-1730302910"
  },
  {
    "email":"antonella.pesce@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836313978/9c12bb63e0856aa535b89a07fd73156d-1730302910"
  },
  {
    "email":"nebula.27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836281210/5d1588e320133f8aa59242204417ecc0-1730302910"
  },
  {
    "email":"stefania.azzalin@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836117370/249515785ddda93bd13df0c1e6bfc3b6-1730302910"
  },
  {
    "email":"fratesi.giulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836346746/87398273a1540baf9ef7d5aa2ef17eee-1730302910"
  },
  {
    "email":"rosaria.bellosta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836379514/18664c8bc67f5218bf4cfac9e4f5fcb1-1730302910"
  },
  {
    "email":"valeria.monaci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836445050/5289b342f21066d685806fe748225034-1730302910"
  },
  {
    "email":"fabiola.biondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836412282/e1c45ee2cd3afe0329895ebf3d186153-1730302910"
  },
  {
    "email":"mariaelenacolucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836608890/27776f924a7c1c18523c7c7dc7c0707f-1730302912"
  },
  {
    "email":"elisabetta.66@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836510586/b69ba15595fc99b5ea13a9e82a134007-1730302912"
  },
  {
    "email":"moira.panseri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836543354/f0cb471f1c912009029338246d81f6bb-1730302912"
  },
  {
    "email":"bellinichiara@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836576122/9ee21de78cb08800943a1f976fca43b7-1730302912"
  },
  {
    "email":"daphneannie@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836641658/e97adaa9ec8d238e102ff406be16a790-1730302913"
  },
  {
    "email":"merlo.simona72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836707194/495aae34bbfa49378c9d8d8194087415-1730302913"
  },
  {
    "email":"albarosa.zacc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836739962/e5b397db6a724b9b886c496fb6d18b43-1730302913"
  },
  {
    "email":"monica.mattana.64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836772730/193123024021f7f79b057008f9911aef-1730302913"
  },
  {
    "email":"ing.roberta@bieffeci.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836805498/13b6094406c6d6965959dd90b8477f63-1730302913"
  },
  {
    "email":"rossana.de.bonis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836903802/687bd7d3f1fde40775704175fdeb398f-1730302913"
  },
  {
    "email":"ciretta.bozza@icould.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836969338/117ceeeaa069503a830fcf13a9cfa282-1730302913"
  },
  {
    "email":"elisa.sanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723836838266/0060deef35465b0fd8a7a32d7fdeff79-1730302913"
  },
  {
    "email":"ffavilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836936570/24da1825220ca0ae4d752f3eefd6a62a-1730302913"
  },
  {
    "email":"smetelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837002106/203e2b3116343249ad6cbea2210ea286-1730302914"
  },
  {
    "email":"nicoletta.valerio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723837034874/aca1b0d7a91ee9e985a6990af97929be-1730302914"
  },
  {
    "email":"virginiafiorenza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723837067642/2255fb696fd46dd8263dac0ddd038ccd-1730302914"
  },
  {
    "email":"federica_norzi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723836871034/62bdadadfe266d77d9f947df8909e652-1730302914"
  },
  {
    "email":"antonellamarzucchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837165946/984960467a0a1d8a5d58e945c2775d87-1730302914"
  },
  {
    "email":"lorettazinghini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723837133178/fd8b547bf85cf951ac3b0c172f487502-1730302914"
  },
  {
    "email":"valentinagosi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837198714/2a43688dc1d709cf15e108880916b50a-1730302914"
  },
  {
    "email":"tiziana.lingesso.82@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837297018/4e4c81c726a4d113fdb5550c8ef74245-1730302914"
  },
  {
    "email":"lucialandi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837264250/e6f4441227334b976269a153c94a85d3-1730302914"
  },
  {
    "email":"baby197672@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837231482/41a330939f5518e65bc9341533db9054-1730302914"
  },
  {
    "email":"danielacauli70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837362554/1e5a3189721f8867eabd2c75af3546c3-1730302915"
  },
  {
    "email":"elisabetta@musicante.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22723837526394/bf34f3fb52407c3e99f1efca3b8ac251-1730302915"
  },
  {
    "email":"marianiraffaela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837460858/19aecd3d38f851bfa4d80a7cccdb7325-1730302915"
  },
  {
    "email":"ada.agostini01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837329786/fc9c4da3c75912e6a6f57de6224b70bb-1730302915"
  },
  {
    "email":"manuelasavina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837591930/fad40dd3ac5e3cf290896e9437b1d17a-1730302915"
  },
  {
    "email":"daniela@studiorogai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723837624698/eaefcb634e897d3673a36d96e02fe20d-1730302915"
  },
  {
    "email":"manuela.gibbin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837657466/5b2c2af1fa908a305370bbdf0859d407-1730302915"
  },
  {
    "email":"feduxgin@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837690234/6452f4fade865114327a16d269b87328-1730302915"
  },
  {
    "email":"elenabene4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837821306/d872aee61fabe9c5a0510e98379ee082-1730302915"
  },
  {
    "email":"paolamutti60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837788538/2fa585a953bd4b9b58adfddeaae0ca35-1730302915"
  },
  {
    "email":"paolavalore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837723002/56d3af3a7e62e1503f5101482cd4449d-1730302915"
  },
  {
    "email":"fancellorosa8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837854074/2b394a7d2047f4a84bb15be447cd1295-1730302915"
  },
  {
    "email":"cristinacol2004@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723837952378/50e617ef40b943429f7e681ff947b739-1730302916"
  },
  {
    "email":"romina.stefani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838050682/1b7bd7550fdd4bb4174a190824011b1a-1730302916"
  },
  {
    "email":"marisa.laverde@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838017914/d3db82c5fcf01da44635119021d3a069-1730302916"
  },
  {
    "email":"nord1601@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838181754/0f9bf12548cb8b04fb277bb388be8f2c-1730302916"
  },
  {
    "email":"elblema@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723837886842/26ea08fe91423bd97937d10e16b773a4-1730302916"
  },
  {
    "email":"alice.muratori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838083450/e9ce37902703a03b2e85a5dd3e95286b-1730302916"
  },
  {
    "email":"susyricci@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838214522/0773562581a782d2669db739f4b6359b-1730302916"
  },
  {
    "email":"elisa.scotese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838247290/ebc976fed6e4e9a0a13c6d0263b64374-1730302916"
  },
  {
    "email":"chiara-vallacchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838345594/c3e3b8c79cff97ea2ac9ba285f294c06-1730302916"
  },
  {
    "email":"alessiadifilippo1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838378362/9ca3bd2dde404568084f6f50827196c3-1730302916"
  },
  {
    "email":"elenafeliciani98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838411130/186d9c0790171c0a1c223f2c94591cd0-1730302917"
  },
  {
    "email":"burkeiuliana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838542202/d3c9baff4d009171f2f6daa63850aa0b-1730302917"
  },
  {
    "email":"michela.trimboli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838574970/bce61ad1f4b80509571928037e4f3d38-1730302917"
  },
  {
    "email":"morenamossina18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838509434/47cb92ca9840f1d44ffc71fbabc9f0c0-1730302917"
  },
  {
    "email":"angelabossetti.ab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838607738/6ecd2df552b14e1e212c533c0b2e76e4-1730302917"
  },
  {
    "email":"adelaidecapuano1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838443898/aea5168e64a94c4395033c379aedd5d8-1730302917"
  },
  {
    "email":"giorgia12345.gdp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838706042/16e3de24f18f5ce1d83f5d6e96a3cd9b-1730302917"
  },
  {
    "email":"meli100@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838771578/2dd7431768d81689ded0f66a710d0bbb-1730302917"
  },
  {
    "email":"martina.decrescenzo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838738810/33543b88318e4120d6cf4b14056c707b-1730302917"
  },
  {
    "email":"stanzy2001@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838640506/b5a44b9ff678eb3633664932d28f2e58-1730302917"
  },
  {
    "email":"bassiba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838804346/3b9e03dbd8e52f3ea62712afb77785c0-1730302917"
  },
  {
    "email":"lucascrivano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838869882/15dda1c739492d37f9d26d414c377984-1730302918"
  },
  {
    "email":"dararossella77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838837114/9d57a1eca3eaa65a169e5f3361065916-1730302918"
  },
  {
    "email":"morena.angel63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723838968186/6d53aea0ef20df0367febdbf2ed6855a-1730302918"
  },
  {
    "email":"aromaoli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838902650/9f6705065218fb0e2b8b1ef94610aa8e-1730302918"
  },
  {
    "email":"elepolacco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839000954/d4c516eb5fe09499f083769ef3a9b8d8-1730302918"
  },
  {
    "email":"tluppino18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839033722/29ba882129ca77a9b085552d9a2de037-1730302918"
  },
  {
    "email":"simonett.saracino@unicatt.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723838935418/1574989f9b2ee5d5d0e1f2566f644a3b-1730302918"
  },
  {
    "email":"lara.calannipileri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839066490/19469cbc3439630c1b9391ca918deac8-1730302918"
  },
  {
    "email":"pierdonato.vercellone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839099258/91755815d5dcdd3c8ae5d84daad8c99c-1730302918"
  },
  {
    "email":"valentina.castelli.1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839230330/871808a613c0731e81fd4a66e7767424-1730302919"
  },
  {
    "email":"gaetanaformicola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839164794/f181bd91d8e908ef8b729e4c47e0391e-1730302919"
  },
  {
    "email":"ida90mind@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839295866/789c7faa441ba13a52bf7898c1bb72ea-1730302919"
  },
  {
    "email":"antonella.romagnoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839197562/bdb8e848812248ad40873880f591b187-1730302919"
  },
  {
    "email":"iuso.sabrina64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839394170/011f8e92e7456847ce4f46d418ed4668-1730302919"
  },
  {
    "email":"chiara_pis@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839328634/0401a28ff465daa5001ea00783b1a99f-1730302919"
  },
  {
    "email":"francescacito.9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839361402/1df35a55c74551e077e93bbcdaa99e53-1730302919"
  },
  {
    "email":"remoaddamo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839525242/451e5701950dcd216fd38039e106aaa6-1730302919"
  },
  {
    "email":"rosanna.buonomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839558010/6a5c13cbde1381168ab58344df47b10f-1730302919"
  },
  {
    "email":"castegnarosilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839426938/b83a50127ea4b1be00aa71ddc14e8d2f-1730302919"
  },
  {
    "email":"barbaracerea69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839492474/23587178dbe73d8f56d09c7b06b4e937-1730302920"
  },
  {
    "email":"lellazoli74.at@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839590778/c27042b916e97bcc4d66ad750ac8d1bd-1730302920"
  },
  {
    "email":"ilariavolpi41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839656314/eeeed651c44f39e0018ce55968faa290-1730302920"
  },
  {
    "email":"joebar46gb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839689082/d2797e62171110aa5b43d4fdc6a1177b-1730302920"
  },
  {
    "email":"francesca.giovanzat6@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839623546/871cc6b2b1b96c226445e467f520cf40-1730302920"
  },
  {
    "email":"gbaldecchi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839721850/13bbb91da54f2b1c719da0981a4a7fbd-1730302920"
  },
  {
    "email":"annamariamontagna24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839787386/19c5c31cebcf24082c4215445b60578e-1730302920"
  },
  {
    "email":"brendavela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839951226/f73881e050900e8c2a91dfe985fb70fa-1730302920"
  },
  {
    "email":"giordano.susy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839983994/73b19d99e90012a84448b788e691023c-1730302921"
  },
  {
    "email":"vanda.frappi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723839918458/861c7db6ca4828215b1711302099b82b-1730302921"
  },
  {
    "email":"robertapuxeddu63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840016762/ecfabb4f1684b5384e60c4182dfdfad0-1730302921"
  },
  {
    "email":"giovylicitra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840049530/f88f1549336e320c4556d910393b9052-1730302921"
  },
  {
    "email":"ascariroberta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723839885690/caf0057952fd2483ac34411538fe85db-1730302921"
  },
  {
    "email":"lisaherrmann49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840082298/29fa98fa4400e87fd0b77e3df6187f0c-1730302921"
  },
  {
    "email":"agnese@michelecampion.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840147834/f874b51313248678f78f93c1d5b77350-1730302921"
  },
  {
    "email":"paola.galbusera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840180602/63ef9703a5bb96616c5090db531aa577-1730302921"
  },
  {
    "email":"esteticasamsara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840213370/ea2b5d79f816484c8861257ef48bd991-1730302921"
  },
  {
    "email":"mik2308@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840246138/566d343251682936b365ca15e2deef58-1730302921"
  },
  {
    "email":"saraquattro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840311674/a8eec5b3674f3cf56514edaa797204ff-1730302922"
  },
  {
    "email":"lorellacaretti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840377210/63aaff57413bc8749c5de56d7484f5b4-1730302922"
  },
  {
    "email":"robe.rta@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840442746/5ff5a68206d29561a374c11599e473ba-1730302922"
  },
  {
    "email":"agatajane@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840278906/43af349dab079dc5f4faab87327ef87f-1730302922"
  },
  {
    "email":"claudia.lanfranconi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840344442/cd27272ff179f07e74363b715c51285e-1730302922"
  },
  {
    "email":"marta1193@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840541050/569e2912a64326f499188e53bc58f9e3-1730302922"
  },
  {
    "email":"moniacomparone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840508282/2f4e236b1811615f7c70e48034578ce9-1730302922"
  },
  {
    "email":"andreaguidiforli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840475514/09c6137a2c7ddfcc9316b4dda416ce88-1730302922"
  },
  {
    "email":"paola.pavis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840606586/cb605fa70f3c30a2f7797aa8dff8e0dd-1730302922"
  },
  {
    "email":"h.palu75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840704890/dd908efb8e5b52c60f5735570c31e2a0-1730302922"
  },
  {
    "email":"paola.10@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840573818/1c4e2391c73772371a678c7bbbbfc411-1730302922"
  },
  {
    "email":"gamba.cristina@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840639354/47cef21ddbbc437c4bd40a9245517f59-1730302923"
  },
  {
    "email":"lombardicatia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840835962/02e3b5cb40e041425e6cd606599723f6-1730302923"
  },
  {
    "email":"susanna.vassallo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840901498/8be52f01a2d5cf0f05fc4e897d527d34-1730302923"
  },
  {
    "email":"cate-chicca@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840803194/494c48b85137d05266899c77a491ecb0-1730302923"
  },
  {
    "email":"valeriabonetti17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723840934266/b9c1717c5f1352a6c310d17068a99dcd-1730302923"
  },
  {
    "email":"luisapasotti@studiopasotti.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723840770426/1ae780c3435a40a1e86846f63ce44c85-1730302923"
  },
  {
    "email":"santori@pessi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723840999802/63a49fc55751ba8710fc230fe3bd884e-1730302923"
  },
  {
    "email":"mariarosa.stefanoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841032570/1ca844440799e2e1725b508dbb7ee07b-1730302923"
  },
  {
    "email":"alessio.pacifico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841065338/eca71863828394cd8b3c1ce7ed759be2-1730302923"
  },
  {
    "email":"tita70@quipo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841130874/218ff229b31bf1938e21e7c2611e40da-1730302923"
  },
  {
    "email":"fabiana.ledda@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841229178/67f48fea447b9cfb30ec510b616484c0-1730302923"
  },
  {
    "email":"silviaboleso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841261946/65a346a50729a86fb42109e8e85f008e-1730302924"
  },
  {
    "email":"rebeccacastagnoli99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841327482/a0976febeaebaf7da9ddf150a3152a28-1730302924"
  },
  {
    "email":"elviraafeltra@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841294714/3d45bbaf458afea5a9a39f2d771ea1f3-1730302924"
  },
  {
    "email":"orietta.cortesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841360250/7577ced73c8aa40f948a6df01df9bb29-1730302924"
  },
  {
    "email":"ileniapanicucci@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841556858/83b20c5c71081c6343c173ab1de70d5b-1730302924"
  },
  {
    "email":"mery04.mb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841393018/85fffe75d1690d415d0dca22dc6e9805-1730302924"
  },
  {
    "email":"anna.maulini.1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841425786/09087ea8b45182a00c7d292c88504815-1730302924"
  },
  {
    "email":"alessia.papini@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841491322/91170ad60ac713c1d173691e2e49cddf-1730302924"
  },
  {
    "email":"sofiamagia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841687930/48ebb044de29c16132b3467e30019589-1730302926"
  },
  {
    "email":"cristina.maria.bertolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841589626/1885e9d00d7049ab9ee82d46daa53ccc-1730302926"
  },
  {
    "email":"dott.scala.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841622394/59513f6272bfb6be64f7e70457e67c42-1730302926"
  },
  {
    "email":"stefaniamazza@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841819002/51d3a3279ca85eb56098383df9bf1196-1730302927"
  },
  {
    "email":"cinzia.fagottino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841753466/ba1a4fc75458dd7ee5c17e939d1585af-1730302927"
  },
  {
    "email":"sabrinadigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841851770/14a97959acc8aac6eb218c5bd7a86280-1730302927"
  },
  {
    "email":"maria-m79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723841720698/5e3260e459ad59eea3d0fd45319fd291-1730302927"
  },
  {
    "email":"merypandolfi62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841982842/0caddaac25d634300584c32ca41e0899-1730302927"
  },
  {
    "email":"rekha.novara0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841950074/72efdfd6fccf0d676b2224b1c7cd5994-1730302927"
  },
  {
    "email":"vcr.toscano@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842015610/7c6e75847b06ab330e12f2d3161a9ead-1730302927"
  },
  {
    "email":"serenella.naibo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723841786234/e3f7090878ea4033784f8d1c6f804d8a-1730302927"
  },
  {
    "email":"fabiana.desiderati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842146682/91a69adece5edc2fddf12c05c5fd6b45-1730302928"
  },
  {
    "email":"gcardella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842081146/00d89cdf3ae6e8c7d31facbc539612a8-1730302928"
  },
  {
    "email":"annarosamerlo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842179450/4cdf75e27956f07c33c2e5a1440de034-1730302928"
  },
  {
    "email":"cinziacosmetologa84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842048378/bc645b11a20c69b2a6ced4df63160271-1730302928"
  },
  {
    "email":"piccolomomix@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842244986/92949689fb5de053a72deb3f3e63cf1a-1730302928"
  },
  {
    "email":"cremamoira954@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842212218/9f303b6b9877402ea4c0c42619ec95cd-1730302928"
  },
  {
    "email":"m.zafferani@poggieassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842310522/101be72e567ad2b33afa7507738ed165-1730302928"
  },
  {
    "email":"sdg.delgiudice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842277754/10e3455746c26a240dc249686d98b2fd-1730302928"
  },
  {
    "email":"manila.baglioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842408826/f72229b45dec8b1d6abdaa4ce2514039-1730302928"
  },
  {
    "email":"ravot@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842343290/680a505bacadcf08e574772030ece6e2-1730302928"
  },
  {
    "email":"fantozzimichael@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842474362/6e23ac283212173966ceaebeb0e44168-1730302928"
  },
  {
    "email":"francesca.colombo@ammlex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842441594/23586495bc33f335240c2071b1d61946-1730302928"
  },
  {
    "email":"paolasanguineti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842572666/d0664b061ad966f73948eb9b5f817a2a-1730302929"
  },
  {
    "email":"alessandra.tesei@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842605434/4c1ef8dbae4c60d0743a03cb0e2ca822-1730302929"
  },
  {
    "email":"tatjanajj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842638202/2b9a2c1cde15961609b89af0f5b25e73-1730302929"
  },
  {
    "email":"catiuscia.schiattarella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842670970/e8c9f94a1a87172cbf7a023f54f8f15e-1730302929"
  },
  {
    "email":"lucia.nardiello@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842736506/1d01c5ae758a6c892eb2dbb341a9d283-1730302929"
  },
  {
    "email":"recesvindo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842703738/cc3796a855759add768932b3865f2af0-1730302929"
  },
  {
    "email":"endimione.blu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842539898/fddfb971aee870c876d76e673e28ae9e-1730302929"
  },
  {
    "email":"do.fabrizia@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842769274/674971fdb12375380a6c27db0d25ce48-1730302930"
  },
  {
    "email":"veronicamagnolfi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723842834810/175b85b4df6937e3a6f240d0bb630edd-1730302930"
  },
  {
    "email":"poggi.stefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842867578/6886e3ede119c5de99b9ffe4ccf8d1c5-1730302930"
  },
  {
    "email":"francescataibbi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723842802042/332a7fcd6fb2fcfbcd52d726d7435405-1730302930"
  },
  {
    "email":"avv.rizzo.gr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843129722/a5f333b4cbf9896083e360693d89a35a-1730302930"
  },
  {
    "email":"m.longobardo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843096954/586e60a46691c5fb84fdce11c5d827a8-1730302930"
  },
  {
    "email":"longo.luisa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843228026/6586eb2e8398f31db7fad9bd43ab0233-1730302930"
  },
  {
    "email":"gennycarotenuto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843359098/f4f28980eb1a3219535b29f44645c04e-1730302930"
  },
  {
    "email":"iaia.cagol@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843293562/07633738a4dce23afe612c8969e073c1-1730302930"
  },
  {
    "email":"natalefare@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843391866/531391b0a2d1db2ab5d19afe79d8cf36-1730302930"
  },
  {
    "email":"bianca_falappi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843195258/f8fcfd38f6e63f66bf1cc8ac10db086a-1730302930"
  },
  {
    "email":"valentinazorzin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843490170/1f5a619bf145ecde40baa47786261cc3-1730302931"
  },
  {
    "email":"tizianamurru@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843424634/a7b3a653ce283151885a642e59307e68-1730302931"
  },
  {
    "email":"antonio.valcovich@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843522938/44f5e6c7eab25522f4c2c09af258ab84-1730302931"
  },
  {
    "email":"mariaantonietta.panza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843555706/b562004d5da31d37c05cd94d0ecfe5f6-1730302931"
  },
  {
    "email":"ari220872@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843752314/43bececd6eba922482fd2e1c7d05835d-1730302931"
  },
  {
    "email":"helga.scoponi@cedeform.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843621242/55e7cd199e488e9d0070aaf6bd4f4c53-1730302931"
  },
  {
    "email":"lilianacoradello@apss.tn.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843719546/8cc9edbff4c041665dde9c8c807f0ea7-1730302931"
  },
  {
    "email":"paola.caserio@vetreriabiava.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843785082/749be662970021bd7312a173a17c5353-1730302931"
  },
  {
    "email":"claudiazanni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843850618/fdee4448b7e18895ca531c523fb3b760-1730302931"
  },
  {
    "email":"laura.muffolini62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843588474/1d1b8dff57522b4ec5f031f4a196089b-1730302931"
  },
  {
    "email":"saradepaoli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843883386/eca464e2d035394e893d4b6b43077184-1730302932"
  },
  {
    "email":"promozioni.negozi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843916154/d661d583d3e416b431d946097d414b17-1730302932"
  },
  {
    "email":"elena.sveva.flora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843948922/1722a550908dd27552fa4f89dff56bce-1730302932"
  },
  {
    "email":"robertadeangelis4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723843981690/4cf2c4a599ea882d66d9919b0bfd0118-1730302932"
  },
  {
    "email":"e.soldano1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844014458/919cd8d42151059cfc0d9775206c0ded-1730302932"
  },
  {
    "email":"laura.pironi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723843817850/a9873a5baa42e92e8581dec2bfd39877-1730302932"
  },
  {
    "email":"elena.nerone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844112762/972e6a64546b3412eafe638506fd8d5d-1730302932"
  },
  {
    "email":"angela.pigato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844145530/bf1ca966cdf84e3ff5b97a398c3336f1-1730302932"
  },
  {
    "email":"lella716@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844178298/179811f299e3a7b58436b143003c58b6-1730302933"
  },
  {
    "email":"ecicu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723844211066/19bd22ced2ce4ab2a05ace3a58a9f72e-1730302933"
  },
  {
    "email":"maria.mastrodascio@allianz-trade.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844047226/0c4ca968d90210eecaf20680f355653d-1730302933"
  },
  {
    "email":"ilariascialpi1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844309370/36614e1a9bbdd6207a783e729aaf9dd4-1730302933"
  },
  {
    "email":"francesca.azzola1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844243834/f7c893dcf3e17ef02123a02d7db517af-1730302933"
  },
  {
    "email":"isabella.cipolla1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844276602/e56e5124e6e24fed92f1a029e69d49bb-1730302933"
  },
  {
    "email":"avv.alessiavita19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844342138/e7fe5cd951c4e8db697e7141a6848f25-1730302933"
  },
  {
    "email":"idamarelli1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844407674/b20a30b89c05654c8b6aa6b047ad1ca3-1730302933"
  },
  {
    "email":"studioplinio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723844604282/5e20c57519ab4e0c0c437864806c5345-1730302933"
  },
  {
    "email":"rob.pederzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844473210/b54c51cefb1664bdf885f29276a50a38-1730302933"
  },
  {
    "email":"alesmas79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844669818/633bd3ea48e5a05dff52577c221c64ba-1730302934"
  },
  {
    "email":"colombi.vit@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844440442/6fc75b514c8e2d69a14cee3a8ced5a29-1730302934"
  },
  {
    "email":"martina.ro089@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844702586/2390dfc3c34ded3890e394b653a80330-1730302934"
  },
  {
    "email":"patrizia.bisi56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844768122/4c4a8c8d72ccbffd509303e2da17e2b0-1730302934"
  },
  {
    "email":"enricamaccagno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844833658/1dc3ecb8647cfec27619692e3ae9d37a-1730302934"
  },
  {
    "email":"catecappelletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844866426/85d98fbef96b5de7596308ac9698d6c1-1730302934"
  },
  {
    "email":"roma76@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723844931962/d342e2a9f9c9e9884fe49bc8834b4783-1730302934"
  },
  {
    "email":"margherita_orchidea@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723844997498/3d60b9b230a7be26a95f1688ad4ce792-1730302934"
  },
  {
    "email":"anna.gennaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844964730/76a8cc5387c2f470f6e1796b49e5b876-1730302934"
  },
  {
    "email":"elisa80.ez@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845030266/08e5ddec443e292190f233e9bd5d0d04-1730302935"
  },
  {
    "email":"cre.marika.19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723844735354/0d182c40dced1a4418617562a42cd16e-1730302935"
  },
  {
    "email":"enrico.falcipieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845128570/355d772b521ec995723881ef14a5e147-1730302935"
  },
  {
    "email":"curtiletizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845095802/bc0ba24465ae19402ec515ca154877ad-1730302935"
  },
  {
    "email":"addeoelsa295@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845194106/8b725cc1549492e40c80f3fa357b4181-1730302935"
  },
  {
    "email":"lorenza.vacchetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845226874/0d706cb43b6d0b504f43a343ad8fa2fd-1730302935"
  },
  {
    "email":"gretamendogni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845292410/4ccc38b21548b12b86d44afc0f6f9def-1730302935"
  },
  {
    "email":"francadori58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845325178/a947f42daeb3612b279b38b6890cba65-1730302935"
  },
  {
    "email":"barsantidaniela@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845423482/0288c37c997162d44fc65818cdfdcabb-1730302935"
  },
  {
    "email":"g_reibaldi2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845390714/8a3536f52590c14dae2eae205d36bd03-1730302935"
  },
  {
    "email":"adaraffa23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845456250/c2f11d6c975b23b482ba004bac47108d-1730302935"
  },
  {
    "email":"leonielisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845521786/a798f44dcb72021b927a7aafd7d731e4-1730302935"
  },
  {
    "email":"panti79@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845489018/53a7ee37f0b87eaf4f6e84f6f5bf367c-1730302935"
  },
  {
    "email":"maria.perretta1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845554554/dd8ace71fcaefa00edf5bbcb2d6ac2fa-1730302935"
  },
  {
    "email":"ilaria.campeggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845587322/96cd6147c1b34a74ebb7de3cdd6ef23a-1730302936"
  },
  {
    "email":"giuliatoti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845620090/54710a8bde642e20a9a0393778d114e8-1730302936"
  },
  {
    "email":"lamo@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845685626/1b8641269a468c3da47c9ee920928167-1730302936"
  },
  {
    "email":"marlia2000@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845652858/ebef843861fe59ea83b289ad82e75463-1730302936"
  },
  {
    "email":"nonni.liageorge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845783930/ec60f04d8f7fdb5f0ac6d05b479ca112-1730302936"
  },
  {
    "email":"e.bonuso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845751162/9ce3ef3e3e34f32a573acb87741c1803-1730302936"
  },
  {
    "email":"giulianervi83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845816698/af49baef807523ed134c5106dc633859-1730302936"
  },
  {
    "email":"ileniasajetti86@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845915002/52448c28495bb7146a662637fc1a2dab-1730302936"
  },
  {
    "email":"elisa.bertuzzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845849466/cb2c2335ae07907cb7028b7c0a212ac5-1730302936"
  },
  {
    "email":"mcomelli15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845718394/616560b066c15f8ae6d95bd0a8c3770b-1730302936"
  },
  {
    "email":"barbarapagli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723845947770/4f180f613cee644a94c63a64d64f900c-1730302937"
  },
  {
    "email":"ttrisciani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723845980538/a1c206bca2b304a2d2fa0d574b2056da-1730302937"
  },
  {
    "email":"francesca.spinelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846013306/9a3079bf1afce2aa813e61e79dec7321-1730302937"
  },
  {
    "email":"valeriabiscaro74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846046074/3b015dd6787130d450085aa30b63ee78-1730302937"
  },
  {
    "email":"paolanicolini_2020@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846078842/03f53e1704cbb8f031fb173a11ded1d9-1730302937"
  },
  {
    "email":"tizianavalzelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846144378/32c3c213f3b0afd3a9b245268fa54880-1730302937"
  },
  {
    "email":"paola.migotto@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846177146/97b4e0af9bfe5a9d460c726827913b2c-1730302937"
  },
  {
    "email":"cristen@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846209914/aff9219d2137b214f065d226d2a43bcc-1730302937"
  },
  {
    "email":"dodolardo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846111610/09b6ef941727e41408725785aa9e4f45-1730302937"
  },
  {
    "email":"sandyver@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846242682/7b8aee10ce7a7b5511a5caec0dccc39c-1730302937"
  },
  {
    "email":"avv.tizianaceschin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846275450/3cff4f033f593b04f22c01bfb38c2ef7-1730302937"
  },
  {
    "email":"bea.romagnolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846340986/e0c0321b8592c1a2c0c5a44445fdd1f1-1730302937"
  },
  {
    "email":"saisi.c66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846406522/f3293ead2e671802f393d4a61af69a03-1730302938"
  },
  {
    "email":"alessandrasaggin.studio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846439290/f7356f3b2600408bd397de91de1e9d69-1730302938"
  },
  {
    "email":"martinelli.mariagrazia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846472058/e510d7a16387cb53fcd95bd611567e30-1730302938"
  },
  {
    "email":"elisasiclari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846504826/f0b36443a99ac80b36e3ada7bd96b603-1730302938"
  },
  {
    "email":"tetavaniello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846570362/8bfcfe64ff945e07724dc9d21d1bcab6-1730302938"
  },
  {
    "email":"delmoro.giulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846537594/661afaad266ea6cb5dd36a55384d5312-1730302938"
  },
  {
    "email":"ste_garlic@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846603130/e8baae628848e0e50871fcdddd4c72e1-1730302938"
  },
  {
    "email":"sabrinaiardosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846668666/0cbddc08d5c875487475c19ac8efab33-1730302940"
  },
  {
    "email":"stefania.orgiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846734202/d6262d481dfed741458c7e618bc52031-1730302940"
  },
  {
    "email":"dona.pirru@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846635898/8c9d982b0f44f4a14912b8baa5b2ff3a-1730302940"
  },
  {
    "email":"alessandraorsoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846799738/053e94a72ad4855bac7d970607ec55d8-1730302941"
  },
  {
    "email":"veronica230779@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846865274/1f9d9a82bd4b4e51c2de167c0421e0fd-1730302941"
  },
  {
    "email":"rosalbabuccelli@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846898042/64603434d18f4ccaf6901f965af7e60a-1730302941"
  },
  {
    "email":"fortunaderrico66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723846996346/f20f315ea78c4b044f362f8b4cae5ec9-1730302941"
  },
  {
    "email":"chiara_casini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723846766970/1812bc66efb03c3bd7840521d5959e6c-1730302941"
  },
  {
    "email":"antoniettarubino19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847094650/e40ba04cf63b55010e32822723ca6ca4-1730302941"
  },
  {
    "email":"luciadicintio61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847061882/3ff85a9e8aa6c0224d922fb538d424fc-1730302941"
  },
  {
    "email":"r.rosini100@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847029114/9c47a3ab40542027e542905dfd2d6c04-1730302941"
  },
  {
    "email":"busi.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847160186/b8524505bc8cb43f9dbf02519c8a46d3-1730302941"
  },
  {
    "email":"paolita_p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847225722/12c69aac1c5097d79a46771d4396a043-1730302942"
  },
  {
    "email":"margherita.valcanover@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847192954/3ace6590dd9bd52d7eda87a55d5e8cd8-1730302942"
  },
  {
    "email":"faustabb@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847258490/8856de9447678628980ea5a1f4870cb6-1730302942"
  },
  {
    "email":"costanza.pirastu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847356794/74a5a82be9d0adf8134c6a61a686029c-1730302942"
  },
  {
    "email":"lusonac@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847455098/d6eb2df31cfb9d9605c9f6680ecea04f-1730302942"
  },
  {
    "email":"susymontecchia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847324026/d716f16f1f0b3d4d216d9fb7c035b5b7-1730302942"
  },
  {
    "email":"rosy.beretta@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847586170/5c97f341afafcbb0789248090998ca42-1730302942"
  },
  {
    "email":"anitamartucci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847553402/a104ca35941abae04125610997f1629a-1730302942"
  },
  {
    "email":"chiaralucchino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847651706/799b3e855c110f29ed202255350b98fc-1730302942"
  },
  {
    "email":"ale.antonini82@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847487866/d01152f6b17baafd223b48ac8de1aa4e-1730302942"
  },
  {
    "email":"risso.ve@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847717242/73e41378abc716202c786b379f05df2c-1730302942"
  },
  {
    "email":"lomb.chiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847684474/cfe8a31865252faa8534ad0d2863d974-1730302942"
  },
  {
    "email":"v.capaccioli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847750010/20240aff4c667860f9735972fe7ea84e-1730302943"
  },
  {
    "email":"dott.francescaguido@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847913850/428f4704908d84a21ece5a99ed2b036f-1730302943"
  },
  {
    "email":"francesca.borghetti80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847848314/f975724862cb469685ff3ffcadc17e92-1730302943"
  },
  {
    "email":"bacus19@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723847815546/d297b2c4d24a78223c26c5b74ae5ccce-1730302943"
  },
  {
    "email":"agrigio.tosetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723847946618/4e0e4f773cbdda3d58244f6b580b58f4-1730302943"
  },
  {
    "email":"claudiaricci@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848044922/4778b118aa1d90a6442a429b9c3dc533-1730302943"
  },
  {
    "email":"danielaraffaelli961@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848012154/ad902a160901f19fcebbd7fb7e34ff4a-1730302943"
  },
  {
    "email":"eleonoradelvecchio1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848077690/6cb7ebee7d148c2830b27661afd188d0-1730302943"
  },
  {
    "email":"ccornaglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848110458/6dc80607d0a830b0b0fa82bbc4314dc9-1730302943"
  },
  {
    "email":"doloresgiustiziero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848208762/4d57e5770120ad2ff253bd4b9c850b1a-1730302943"
  },
  {
    "email":"tranfocarlo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848274298/bfb303bf1c45d2dc11e784453ef2194a-1730302944"
  },
  {
    "email":"caterina.calistroni136@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848241530/a990270ac34a3c7a0547d5c401de240e-1730302944"
  },
  {
    "email":"delia.uri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848175994/9c63f1d17a9d6bdd14cf0c5cee7bfd45-1730302944"
  },
  {
    "email":"marta.scarscelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848438138/dab6a89ca955f02dd3d7fcaa199266fd-1730302944"
  },
  {
    "email":"gianv.dandrea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848470906/076232133bdfdc7d1a32dc374bccd87c-1730302944"
  },
  {
    "email":"marmas4.54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848601978/26d6b15ed21e0bc3f91624c8dc107ab1-1730302944"
  },
  {
    "email":"sabina.prestipino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848667514/ff9e02bc5f79e3d2092e450a0ec74232-1730302944"
  },
  {
    "email":"meggysann@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848339834/ba213f2e59c056a3411cbf6461ff5454-1730302944"
  },
  {
    "email":"catialavinia.grandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848503674/0315062e5895bdb5ac7a2acb3e7b7cdc-1730302944"
  },
  {
    "email":"lom_sim@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848700282/c487a890cf206dddcff51d584d433a0f-1730302945"
  },
  {
    "email":"fedele.serena@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848864122/acd14884d6370f0e0d0c73d75c75f467-1730302945"
  },
  {
    "email":"paoladelbuono.68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848831354/8e41885053d2abaa3e5110797164cc20-1730302945"
  },
  {
    "email":"barbaradema2010@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723848765818/f167e9c9e6a5f2c1f12bae9991315b73-1730302945"
  },
  {
    "email":"nonsolotagliodisara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848896890/cfa7a91e35aa4c1189e1dfbed9484571-1730302945"
  },
  {
    "email":"ale.magli70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848929658/32c8f143b4e9beb3ce8e1754df244463-1730302945"
  },
  {
    "email":"bettin.henn@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723848995194/e51dacb3c40949ea8e65eaa33852119f-1730302945"
  },
  {
    "email":"logistilla13@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849159034/93b9797a6699fc6c5ffcd6910f972ba6-1730302945"
  },
  {
    "email":"angena@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849224570/309f779bb322e8ebb9bf8e061be254a2-1730302946"
  },
  {
    "email":"scarolina65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849027962/6f7471f3efc74e1651f19ea3a175856f-1730302946"
  },
  {
    "email":"giorgia.cingolani@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849191802/1f35fbde47607c026cf43375acbe741a-1730302946"
  },
  {
    "email":"tomadaile@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849322874/a8fdc95c45c7c8fd614da1377d1b8838-1730302946"
  },
  {
    "email":"carla.saragozza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849453946/f0e75babdf6832caeced415474d69e96-1730302946"
  },
  {
    "email":"soniabonomelli966@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849421178/ae15d8bad3d2d21dc1b4b2a304c7ae50-1730302946"
  },
  {
    "email":"cavannapaola11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849093498/b1caea1df0a1891f0236f271cd807017-1730302946"
  },
  {
    "email":"flavia.bonfigli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849486714/18b4e57d4bbdabaf37845a394b4e8a54-1730302946"
  },
  {
    "email":"monica.galbiati74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849552250/915e7673d22297362767c9919a8aa191-1730302946"
  },
  {
    "email":"alessia.ce8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849519482/db469ae2b5128867b7acbf0c7a46d8df-1730302946"
  },
  {
    "email":"vanessa.milo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849650554/9319113d95339a5102d4d56538b51f71-1730302947"
  },
  {
    "email":"giuliag84@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849683322/b7d64cc3d3950e58b414fa6e5078aa0c-1730302947"
  },
  {
    "email":"magdeska@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849748858/dbd82a5606e8b74be6ddfed63c8b8057-1730302947"
  },
  {
    "email":"liliana.leuzzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849781626/c8459411f0d28f29b8cb3a257bd87c0d-1730302947"
  },
  {
    "email":"serena.mazzocchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849814394/cac92f070184eba6268f5294b52b1cd4-1730302947"
  },
  {
    "email":"clarina82@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723849847162/2b066080b1d431887636b8d07ceec75a-1730302947"
  },
  {
    "email":"diruggieroalessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849879930/1896f508e6c66b154464dff0268fea8d-1730302947"
  },
  {
    "email":"diletta.balduzzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849585018/0067091c19373d54682b214c7fdd2624-1730302947"
  },
  {
    "email":"clautiztrieste@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849978234/e994618d4e25ba2fe9a479802181c8b3-1730302947"
  },
  {
    "email":"perale76@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723849912698/e7bb4d40577ff6e612ae01a4a5fd373d-1730302947"
  },
  {
    "email":"marinakovari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850011002/c9407b7b9c32ecd6c483abcdc1a430f9-1730302947"
  },
  {
    "email":"saralucarebecca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850174842/30b6d52feebeb7faf95a150ea4904e97-1730302948"
  },
  {
    "email":"s.ginghiali@ui.pisa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850076538/d931986ed9c27f523d8337b74bd98d7f-1730302948"
  },
  {
    "email":"enza.arduini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850240378/faf7135c10a2ad26aa278646a54427d9-1730302948"
  },
  {
    "email":"angela.semenzato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850273146/f09820c7a0d80982d28b3db1195b573c-1730302948"
  },
  {
    "email":"francesca.ciambotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850305914/4fe77665aa5395cbd247e9a4e40605dd-1730302948"
  },
  {
    "email":"gioia.orsili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850371450/f24bcf331585a9827e2d231e192ff452-1730302948"
  },
  {
    "email":"esme88mn@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850404218/46c17b2ada00e8c173294724467e3635-1730302948"
  },
  {
    "email":"tambellinipatrizia1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850436986/ad1caf258ab5f8ee5512116592562862-1730302948"
  },
  {
    "email":"avv.ceciliagargiulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850502522/d1c3ac98348f5ab2d352666ca0533028-1730302949"
  },
  {
    "email":"brasileylenia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850469754/7a8fde4c9d7cb21fd194a66047a7f48e-1730302949"
  },
  {
    "email":"bacigalupo.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850535290/136d6ed038b6d94ce006c971d48fcd00-1730302949"
  },
  {
    "email":"grasso.marinella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850043770/920619553b2e5a074cd229c03b0df9ed-1730302949"
  },
  {
    "email":"gaiamazzuoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850633594/abd5df6197388cb14d32888e98d78154-1730302949"
  },
  {
    "email":"nedjma@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850699130/7db6ed886cebb1c23ead41cfff8bc902-1730302949"
  },
  {
    "email":"carbonelinda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850764666/f97c2c9af65b820fc65fbb77ee1c4b04-1730302950"
  },
  {
    "email":"laurasabrinacaronni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850731898/7c2c572923ca35f23e45256a0206cff1-1730302950"
  },
  {
    "email":"valentedania@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850600826/15080724465a7aa621c0cd7598f918d5-1730302950"
  },
  {
    "email":"loriana.bruzzone@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850862970/d7bb386024f2b3faf282d7c19f1358dc-1730302950"
  },
  {
    "email":"valeriatardia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723850797434/6a05ac2313fcf6fea97e8711fba1a027-1730302950"
  },
  {
    "email":"paola.canepa.43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850568058/e05f2a9d2f0d632761185bda30d657d7-1730302950"
  },
  {
    "email":"babirossijl75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850830202/e9f2a76087f3af875c59e3a65462cfd3-1730302950"
  },
  {
    "email":"elisaoss@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850928506/38287ac530a1f51f79a6291762bb4e40-1730302950"
  },
  {
    "email":"ox.sinco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723850961274/e0ed24e8c8517ffcced2d9559548a808-1730302950"
  },
  {
    "email":"salima19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851059578/d7864fc6bc2764e75505e38bad477142-1730302950"
  },
  {
    "email":"nddenisova93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851026810/4d881a02bf970f75bd57f0df1eac9945-1730302950"
  },
  {
    "email":"robertobonardi77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851092346/bfedc16432098e58c24957d22083d681-1730302951"
  },
  {
    "email":"rosavaglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851157882/23a31a6172da4e0aad99f201d6b7386b-1730302951"
  },
  {
    "email":"la.corr64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851190650/4842ee44a398ca03ff35ae0e2168a71c-1730302951"
  },
  {
    "email":"domgiulia31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851223418/fb4e866d4479c018826ad342767358da-1730302951"
  },
  {
    "email":"treale76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851288954/04a309ae56a296cd98684117578b7a70-1730302951"
  },
  {
    "email":"sbacelli80@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851354490/329f97342aab02b945dddeda9c47fde5-1730302951"
  },
  {
    "email":"matteo.fonta75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851387258/c4cdd6a0ec94a2479529dc1c4df88557-1730302951"
  },
  {
    "email":"architetto.arillotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851256186/2bd96c0df27985a08ce25f9e8a35825a-1730302951"
  },
  {
    "email":"r_dondi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851452794/c1269ef73335f20df9bdde72310a48cc-1730302951"
  },
  {
    "email":"miuccianna7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851420026/9799f7613ddc612d87ee6ecac93c1da2-1730302951"
  },
  {
    "email":"kety.luzi@auslromagna.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851551098/104c49212c6f8afea3a370eb43ce72e0-1730302952"
  },
  {
    "email":"giuliacardinali78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851518330/8589f4b0e6639d11a2e2b5c80b1508f0-1730302952"
  },
  {
    "email":"sara.fattorini23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851616634/7a5e8d9e28f10675e7fa8a6491c0b75e-1730302952"
  },
  {
    "email":"ella1404@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851682170/d3ff221c9c09e9bf0c0c480d995e3bda-1730302952"
  },
  {
    "email":"f.gatto81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851780474/e3702c3a85726f0a6b3e4d1ccb7661ff-1730302952"
  },
  {
    "email":"felicetta.granata80@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851911546/093224a3a51a568ed0f36283dceed93e-1730302952"
  },
  {
    "email":"luca.bonomi.bg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851878778/d5665c45bda8127f85f3067fb0cb2ae7-1730302952"
  },
  {
    "email":"costanzafrak@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851747706/17d03b54b1bbf7d9a2bd20da6a155b41-1730302952"
  },
  {
    "email":"mic.sartori@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723851944314/236706bb5cb18d317f46293d3ab57ed4-1730302952"
  },
  {
    "email":"aribond9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723851977082/bb31092a77d9b8e1a301bb766b63bbbc-1730302954"
  },
  {
    "email":"f.fortuna@bcassociati.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723852140922/1ffa997cc14bf15c22aa0892af073865-1730302954"
  },
  {
    "email":"caterina05@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852108154/c79422e85ccddadf0da09bc0dc3e431c-1730302955"
  },
  {
    "email":"sarazoggia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852239226/ee3671502927093e3aa313b38c59522f-1730302955"
  },
  {
    "email":"f.cataleta67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852206458/aa7fa87e349d99f26b2e8dabe5ee5a67-1730302955"
  },
  {
    "email":"silviacerisara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852271994/8cb89443fce3052c2715307e594121ff-1730302955"
  },
  {
    "email":"kiara.basile@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852042618/cbdd8ee77688a9fdcb49d5888c5a18a2-1730302955"
  },
  {
    "email":"bibabibo67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852337530/a085497a9d7541c21e504caa9c0db31a-1730302955"
  },
  {
    "email":"nicolettapacilio1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852304762/9142166ca4674c4869374be779a2de2b-1730302955"
  },
  {
    "email":"nicoletta.bernardi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852468602/678024dec40b4ab11997f779c95c20eb-1730302955"
  },
  {
    "email":"2012r.mancini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852501370/8d79a8961c4113a0f329d7bec8f80bb2-1730302955"
  },
  {
    "email":"mary2884@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852534138/1aaa31c3c5455d144afe06a3135a779f-1730302956"
  },
  {
    "email":"cristiana.collu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852370298/024de37caff847cb3f6b04f4497483c9-1730302956"
  },
  {
    "email":"elenaligozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852599674/4c2ad9c2cfd026a201b23de9a29ad1f6-1730302956"
  },
  {
    "email":"scasati1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852435834/1f3be008c2bbf0dd2b08a08fbd6d3f1f-1730302956"
  },
  {
    "email":"fantini.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852632442/5f6e74c991254df102d0627c8eb6b8cb-1730302956"
  },
  {
    "email":"genzianag@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852763514/c034420560904e3a7777da5cccf08929-1730302956"
  },
  {
    "email":"avv_carlofratello@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852665210/c779b3e62d3221bb8af5a128b2bc202b-1730302956"
  },
  {
    "email":"marboljobmail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852894586/a24aa229e5313a07c0f8ee3e26b50dc4-1730302956"
  },
  {
    "email":"ponza-@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852697978/49c6d7f83ecc038e8833df1fe4371d1e-1730302956"
  },
  {
    "email":"zgg.ngl@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723852927354/536899d16b370b82f671d41294195ad6-1730302956"
  },
  {
    "email":"mgrazia.al@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852960122/d71d0c2aa3ec31e9dbf4b0dcacbe89e9-1730302956"
  },
  {
    "email":"galassiannalisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723852992890/a8fc64b7aea446b92a611b97275111f5-1730302957"
  },
  {
    "email":"nadiameneghini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853058426/464cadd7f8b5eacd77b0e9b5dc2052ba-1730302957"
  },
  {
    "email":"costaro001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853091194/03d144fbc855761efafa545a6687db11-1730302957"
  },
  {
    "email":"raya74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853123962/d4de59be44dba77d015b0debbe00aa0a-1730302957"
  },
  {
    "email":"vanni.ermanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853025658/35617e5c48b25b95c1bf4a75f0e9a4ab-1730302957"
  },
  {
    "email":"artoni.ester@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853156730/377ab8380154abed07b52d57b3304b15-1730302957"
  },
  {
    "email":"emasantolini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853189498/96fd6b0d112b6bf530b02641c097992d-1730302957"
  },
  {
    "email":"endek@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853255034/7ac0c5f40feb0c958184a2b7671c39a3-1730302957"
  },
  {
    "email":"rosanna.db@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853287802/c19fd6684129998c985f4a6a4fb44e48-1730302957"
  },
  {
    "email":"85silvia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853222266/df63fae639284dc7a3dbcf11cdf4f227-1730302957"
  },
  {
    "email":"erikamarra80@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853353338/a091601d90eb00c1853d5e8950f1b260-1730302958"
  },
  {
    "email":"elibuzzoni@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853320570/88bbc49fc5a9176757ca83e639ec29da-1730302958"
  },
  {
    "email":"erica_roncato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853451642/1cec40e262f32f3885996ef3c0be390c-1730302958"
  },
  {
    "email":"sarchiellop@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853418874/0e8cbdb6d8dfc8621a52ffae11b954ae-1730302958"
  },
  {
    "email":"kio.marta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853549946/5f92cbfdfc116a999c7be54d0db1cdfb-1730302958"
  },
  {
    "email":"ilaria.b11@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853484410/68be099bb3f850fb6af85185ab00a89e-1730302958"
  },
  {
    "email":"clarapusceddu70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853582714/d7337afa3f452ba7722455b442f602d1-1730302958"
  },
  {
    "email":"ambra.salvatore@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853386106/7d44cea5930b3cf23f467446ca02b91f-1730302958"
  },
  {
    "email":"francesca.veronese@studiobergozza.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853713786/cdd4a6c1c5e1d6ff9b35916901dba664-1730302959"
  },
  {
    "email":"francesca.rici@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853615482/f9fa73893aa36add59c446947f540457-1730302959"
  },
  {
    "email":"g.lasalvia1014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853779322/44119435aff46ac3d85014470fb60aad-1730302959"
  },
  {
    "email":"emanuela.capellacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853746554/8e223b4d78171422f07a078e998470a9-1730302959"
  },
  {
    "email":"nicoletta.soravia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723853812090/76d46360c356a499159ccf18633c8d28-1730302959"
  },
  {
    "email":"giulia.scr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853910394/a8f4020046134eaadd8912724a9c5881-1730302959"
  },
  {
    "email":"beatrice.lastrucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853844858/06ed4f6763e59dc4fe12929dac112703-1730302959"
  },
  {
    "email":"luciaperugini553@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853648250/3db9133908b36c190d75b54f1086f35b-1730302960"
  },
  {
    "email":"cristiana.tozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854107002/7f402ed9a788ddf5b02f6759234fee8d-1730302960"
  },
  {
    "email":"sofia.laquesabe.paravati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854041466/a24344fc84cd4c9edb66b2dc3a7dd639-1730302960"
  },
  {
    "email":"picchiopicchio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854139770/4039ecb08a435bf25097d97677a466d5-1730302960"
  },
  {
    "email":"sricordi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854172538/54dbc5945da96e1be107b362b412df32-1730302960"
  },
  {
    "email":"mcmonaco@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854303610/6e7e9e2a0648bd463d91099940494086-1730302960"
  },
  {
    "email":"emmadecesari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854205306/0e1958d2a125cb34e31588b5f5f3480e-1730302960"
  },
  {
    "email":"ida.iovine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854336378/cb91eaa545dc153054d5c41b7ca234c5-1730302960"
  },
  {
    "email":"franca_rame1@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854369146/6f061c1adce507f858f7c875288af097-1730302960"
  },
  {
    "email":"mihaela.marton@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723853943162/c6e66d68066af2dc8cdfd67d4fa0849a-1730302960"
  },
  {
    "email":"laura.mcr11@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854500218/2d5d1242ca47920392cb08005ac78231-1730302960"
  },
  {
    "email":"ilaria84.munerato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854467450/d170e75bfbb41a3b5be1025873145878-1730302961"
  },
  {
    "email":"anna.cariboni@unimi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854598522/12ab12f5988bd9b5442cd75ace6934e5-1730302961"
  },
  {
    "email":"fabiodn@mac.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854631290/1b709d1c191e093a91ee8c79c86dede2-1730302961"
  },
  {
    "email":"noticesenatico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854565754/04242a4645fc25482fe0dd478782ccb7-1730302961"
  },
  {
    "email":"alessandro.quagliarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854664058/b24f70ff69e9dba42ec2a250c2d9417c-1730302961"
  },
  {
    "email":"f.massarotto74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854729594/c1109a2ba574e05f3a48fad4e024b7fe-1730302961"
  },
  {
    "email":"daniela83.locatelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854696826/19c44438c4fb18b72b7faa7f1b9921cd-1730302961"
  },
  {
    "email":"stevedo2006@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854532986/b25141390ceac1095aee20cd8ee535a0-1730302961"
  },
  {
    "email":"giulia.palermo91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854762362/a3d0e2ce538062cda95962362e1713e0-1730302961"
  },
  {
    "email":"sabrina.bellinix@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854795130/da63136ba8b3e3b9f04a668e0dd566b3-1730302962"
  },
  {
    "email":"paolessimanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854860666/8f5b8174fa7a4dcdf56d652464639cd3-1730302962"
  },
  {
    "email":"gio-suisui@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854926202/498405369ee4a2661185c3d0c204d214-1730302962"
  },
  {
    "email":"mic.cordera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854827898/863bc1cb7ce4f68703dbc09b277ad55c-1730302962"
  },
  {
    "email":"elizeli84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854893434/0a5467b24437a78b358ac0a7ba7d849c-1730302962"
  },
  {
    "email":"fraboggio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855024506/1194e95032013fdbfbc8f9fa40cb09b9-1730302962"
  },
  {
    "email":"danilagrittani95@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855057274/42f044ee012d3f56f2537238d9473a55-1730302962"
  },
  {
    "email":"laila.martella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723854958970/267c3e6ae41c8471357dec87aab9e3e9-1730302962"
  },
  {
    "email":"elisabetta2cattaneo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855090042/1ff125a0e2c88618866ce0a5ecdb8c8a-1730302963"
  },
  {
    "email":"mereupeppina89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855188346/c33c4e2a02fc25db770b802a25817ef8-1730302963"
  },
  {
    "email":"incerti.simona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723854991738/01ba1e655d38b26e6fe37da50212a075-1730302963"
  },
  {
    "email":"aless.brog@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855122810/99bf8b080cd30b2684eaf1ab7115c8ce-1730302963"
  },
  {
    "email":"malfa@immobiliareortigia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855319418/8033217fc524e70ec9192ce3a9b10bc1-1730302963"
  },
  {
    "email":"margherita312@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855352186/1f3bdb78c82fe48ba66dec5744aa2caf-1730302963"
  },
  {
    "email":"mariapiainglese@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855253882/dcafe105713f3b9c505dd30554d058cf-1730302963"
  },
  {
    "email":"raffaella.manzo1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855221114/5a863f719de6de235cdc74a790ce3735-1730302963"
  },
  {
    "email":"contealmasy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855450490/4cc04ad302b464268538f7334a9ab616-1730302963"
  },
  {
    "email":"mgabriella.digiacomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855417722/4706a41fae69fdf4d5be59aeaee2a990-1730302963"
  },
  {
    "email":"castellano.angela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855384954/926e912aec76d588fc904b4a1881de11-1730302963"
  },
  {
    "email":"sitarica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855483258/9314ace6009cf1c4047a68cce5244455-1730302963"
  },
  {
    "email":"belloclo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855516026/5661bef9fc3720bd9d05ffa90c031e98-1730302964"
  },
  {
    "email":"patrizia@ruta.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855548794/dd0fd3758ed7eb7f31c4146cbad95578-1730302964"
  },
  {
    "email":"antonellamensi.gio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855614330/9baef1d56fbf5af242e4b25ff262ca56-1730302964"
  },
  {
    "email":"finubarbagallo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855679866/f878aa25e75d8589699f844fc1290856-1730302964"
  },
  {
    "email":"peruzzi.r@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855712634/94f272b4b015bf43ca1493a651372f9f-1730302964"
  },
  {
    "email":"maria.borasi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855745402/e78ed7ba8debd800093f9943782fc0cc-1730302964"
  },
  {
    "email":"rosmy.canonaco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723855843706/173235707df017d43e72acd3ca60a2d7-1730302964"
  },
  {
    "email":"talitakat03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855909242/81449e15302faa7076d9d54ba900da6c-1730302964"
  },
  {
    "email":"psuncini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855974778/9e6f4ddabf6de637eff6908fe48e8f16-1730302964"
  },
  {
    "email":"marialup83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723855778170/744cc3be168b95ab100a5413688ee656-1730302964"
  },
  {
    "email":"mariscarcia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856007546/76097d19c3720b213f689e3728c4f8ed-1730302964"
  },
  {
    "email":"marianna.manicone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856040314/8cbedb9e9c7a31ed5679e78439b7ae6a-1730302964"
  },
  {
    "email":"ostrica15@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856073082/0c23d0b3e1e97acb422529c4c2d428f6-1730302964"
  },
  {
    "email":"chiaraborsetti76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856105850/005a3609bbf58f2757fd2e1f6f585008-1730302964"
  },
  {
    "email":"bouchettasoufiane@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856138618/615c738e19d1ea6f81156231bdc75117-1730302965"
  },
  {
    "email":"lancioni.vet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856204154/d6658176c1c9c33f67ce4656fe9a2118-1730302965"
  },
  {
    "email":"v.ciucchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856302458/e9fef78c09022f25bf8c4d0c2b862563-1730302965"
  },
  {
    "email":"flavia.lanza.cf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856171386/3d6bbcf04e8b0022dc982cd64d14d55f-1730302965"
  },
  {
    "email":"simosbe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856400762/35ea8f8d175e0aee3327817d5403a260-1730302965"
  },
  {
    "email":"anny.renna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856335226/1feb8a58c53d8a6aae298e967c73c8ee-1730302965"
  },
  {
    "email":"tonipat@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856367994/e81fecb73a00963f5decf8bc735169a6-1730302965"
  },
  {
    "email":"ema.russo1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856597370/780abe33efc8f01910bb16ab1a42d48a-1730302965"
  },
  {
    "email":"ferrazzi.sara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856531834/696291bc74ab933298ca517b2f7b72aa-1730302965"
  },
  {
    "email":"f_carrara@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856564602/a9c24085bc12ac63d568e9eb51da7868-1730302965"
  },
  {
    "email":"umberto.tagliaferri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856630138/cf81cb4add85f119c24bae39f3a62776-1730302966"
  },
  {
    "email":"tappino35@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856695674/45e0cff8d798b6476344fc06390b4d1b-1730302966"
  },
  {
    "email":"amministrazione3@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22723856761210/a7665b4bfc1af9757881306a4601986c-1730302966"
  },
  {
    "email":"sabiribo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856793978/82250f3c49ea98563a1adc2b25d2459f-1730302966"
  },
  {
    "email":"cristina.tagliaferri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856859514/2724eb1c09855fbf89ae0af5d8b65967-1730302966"
  },
  {
    "email":"titticapraro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856826746/d934f516378c50946654a021a9b51db9-1730302966"
  },
  {
    "email":"orlandi.michele.64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856662906/35876587ecb7e3b57fc31a3c3c2d1cfc-1730302966"
  },
  {
    "email":"lucia.di.ciao@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723856990586/8359d8a709f1bf183d22e82d0fdbc3ef-1730302966"
  },
  {
    "email":"annamaria.mater@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856892282/069bab9a13f75ebea831d39ed5e99298-1730302967"
  },
  {
    "email":"pdelbra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723856957818/03a24043619d9a612b646fa9769112ba-1730302967"
  },
  {
    "email":"melinamorabito.04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857056122/aaafb93d6141c1fab683487a69143e14-1730302968"
  },
  {
    "email":"ilaria.sbabo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857088890/d1f6dd8663bf49b2097185b5644c0f85-1730302968"
  },
  {
    "email":"minacaramiello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857154426/47428efd42c69f8c941d610a81ff01e4-1730302969"
  },
  {
    "email":"sarapioselli73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857023354/cf27b564cc0b7d357435e48f19ad79ea-1730302969"
  },
  {
    "email":"culiersistefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857187194/48f8e1f12d10917a7e8c902b57b82caf-1730302969"
  },
  {
    "email":"petriza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857219962/2285a836333f3c0be6b975ad7cc7a54e-1730302969"
  },
  {
    "email":"robibi30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857318266/316fda3e90cd67ff207cdbd4a804091e-1730302969"
  },
  {
    "email":"ienco.miranda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857351034/f901a5f52b3b619079418d061f49ce43-1730302969"
  },
  {
    "email":"nadilio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857383802/38d8782b8e13713f6725bca9684e0237-1730302969"
  },
  {
    "email":"salvuccilaura@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857449338/e53843c0858578d6139301dd35f11f7c-1730302970"
  },
  {
    "email":"michela.mimi2300@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857482106/5423cd49791381294deb71db81613acd-1730302970"
  },
  {
    "email":"diletta.salmaso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857416570/b39f3cbf7928c4c27372a59533c99388-1730302970"
  },
  {
    "email":"laurazorzi5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857547642/c0b640fc7d8e59334a9a61a7d24f7bee-1730302970"
  },
  {
    "email":"luciacatarcioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857613178/892efca5b44cba4530a33258a770886f-1730302970"
  },
  {
    "email":"sarah.colonna@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857514874/f55c4bb06b1a1dcca40eebfed64d3711-1730302970"
  },
  {
    "email":"barbaracecca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857645946/cdbf9df071b39131a81ac7977e0ff3d2-1730302970"
  },
  {
    "email":"salvaterra.walter@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857711482/8f65cc0e9fa8ee1b6eec266edf0a9410-1730302970"
  },
  {
    "email":"michela.gianotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857744250/78cc9b25d55988ba0ebef057b83926dc-1730302971"
  },
  {
    "email":"rosa_autorino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857842554/88cb71696187e685c0be87a676381470-1730302971"
  },
  {
    "email":"margheritabettoni52@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857777018/3d0ec28581c71c374a58f250e37e7b91-1730302971"
  },
  {
    "email":"carladominique82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857908090/b17ff76eb64b283574849e38fd89fc67-1730302971"
  },
  {
    "email":"relaxandbeauty@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857940858/37395874bc822a0c09be72f8b10f629f-1730302971"
  },
  {
    "email":"felloniluciana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723857973626/e8acfbd89f2e925045cf13cb29be910e-1730302971"
  },
  {
    "email":"claudia.monzali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858071930/fcd669b1d5cc058eecb10fc1851c288c-1730302971"
  },
  {
    "email":"sarataramelli@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858104698/608f4af42b70dc642f30ce080f765740-1730302971"
  },
  {
    "email":"algieri.lidia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858137466/0adf83c75d8f2dcbce9ac177626bcc3b-1730302972"
  },
  {
    "email":"rosnig@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858170234/eca4020483c77fa0590a307d6c1faf49-1730302972"
  },
  {
    "email":"susyleo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723857121658/e78e472a5a1453c25e3cf3cc97a20c4b-1730302972"
  },
  {
    "email":"annasparascio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858334074/e7e82753f56bf973aa071eae5f4ad738-1730302972"
  },
  {
    "email":"francadebiasi67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858301306/a40ca33de9d8b3c48371efd471748411-1730302972"
  },
  {
    "email":"ecorinascita@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858399610/5ddf910975cf72fa23600fa18cda60a3-1730302972"
  },
  {
    "email":"marias1739@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858366842/cc533c06e5fda75be07d73eaa84753ca-1730302972"
  },
  {
    "email":"la.bossa03@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858432378/4e15a2f4749cce22fb0f8503840df164-1730302972"
  },
  {
    "email":"daniela.nardini66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858465146/4eac038567c4453e6eb6f1def6be1d8d-1730302972"
  },
  {
    "email":"antonellabiasiotta79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858596218/302e08a00db0d84392510705587bb59b-1730302973"
  },
  {
    "email":"aappennina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858563450/461c6cfb7c588a042eb65f2c48b62db6-1730302973"
  },
  {
    "email":"magric74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858661754/b10d8a0e8f3087dfe17cca700dea30b9-1730302973"
  },
  {
    "email":"teresa_desantis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858497914/ba5c3b217b9b25f17bcafb672cfcdffb-1730302973"
  },
  {
    "email":"filippi.clod@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858727290/a37d100b258775c2e8fb762de8326c6b-1730302973"
  },
  {
    "email":"alex.montorsi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858694522/489ee590210be3dd1fd60fbab478245a-1730302973"
  },
  {
    "email":"emanuela65ef@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858760058/a1f9fd0b37a7cf8cf516c64f48e03aa3-1730302973"
  },
  {
    "email":"danielareggiani.dr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858891130/1df30b1093f919b8e8a99bcab65b5197-1730302973"
  },
  {
    "email":"lucia.blasi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723858825594/d2a8c686d0dc8f93d25836ad134e1a1b-1730302973"
  },
  {
    "email":"fg2574@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858858362/5bbdb8ca1f7541bd8af188ab8fca5415-1730302973"
  },
  {
    "email":"aldo.gramigna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858956666/a6d9a42e9e6d35b535aab835545f9851-1730302974"
  },
  {
    "email":"lena.melni@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22723858989434/b373fec41a2d9fa3306a9f6fb2354ea9-1730302974"
  },
  {
    "email":"francesca.buccheri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859087738/4193d087b92e9df18ff64388462e8c9d-1730302974"
  },
  {
    "email":"cidonato@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859218810/a2d8ad2c1687890ec0caf1a09ae5df4e-1730302974"
  },
  {
    "email":"ariannagrz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859120506/97d69eaf9cf115198e5aeb23cc730389-1730302974"
  },
  {
    "email":"simonafrauneri23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723858923898/da54b52831d6ee743e376d19b05562c0-1730302974"
  },
  {
    "email":"michiperi41@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859284346/4e30cdcc5b5709a1c4df33c6a761baf0-1730302974"
  },
  {
    "email":"sarapivetta@prrarchitetti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859317114/a140001ddfe0c40bba6b87096c6b15e0-1730302974"
  },
  {
    "email":"applina85@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859415418/d61e53dd7983d74592b07598a1d9d59c-1730302975"
  },
  {
    "email":"auriauri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859251578/bf38d49134ffc9b69393677f842b35e6-1730302975"
  },
  {
    "email":"tittikitty76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859480954/b2435076d533c17e59eb6b9b9db22e64-1730302975"
  },
  {
    "email":"annalisapc@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859382650/deb6a27789953d1535a5e8005b91f12a-1730302975"
  },
  {
    "email":"antonellavsp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859612026/46f2fd5ce0fc3108a7c03525d0fefee2-1730302975"
  },
  {
    "email":"susy64@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859677562/04c74cd90bc56600d2c399d0df938b5e-1730302975"
  },
  {
    "email":"mpnprato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859644794/c4c265085ebd40e12742512cee34fbde-1730302975"
  },
  {
    "email":"marinella62mb@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859775866/cdf3e668e10175f8c0fd69607181e940-1730302975"
  },
  {
    "email":"silvialeso92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859808634/d5256319ca95f3d2b30116ab161edc1b-1730302975"
  },
  {
    "email":"ebaratella77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859841402/5b40929e6b237da2b9fc858650dd7dd0-1730302975"
  },
  {
    "email":"taccottibarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859874170/d80ab99f09aa9e2951bf70a69129f238-1730302975"
  },
  {
    "email":"maxgerry@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859710330/86e0c55d9a0ae92555f6f1a3521957af-1730302976"
  },
  {
    "email":"stefaodd@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859906938/f97eaf2633eb5af11bb146a5e3e66c3e-1730302976"
  },
  {
    "email":"andreoni49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723859939706/c3b8290152cacbb1e662a63337a90797-1730302976"
  },
  {
    "email":"stefania.re_1965@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723859972474/a94e88f9113f758e5f4a2d5dcf54e32d-1730302976"
  },
  {
    "email":"simona.perini02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860038010/7209b19b9fcf483cbdfe40e26cc6f3a3-1730302976"
  },
  {
    "email":"lauralalicata0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860169082/6940005993fce9565b90df88fad76821-1730302976"
  },
  {
    "email":"b_wilma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860201850/5ea2b2da645a7390c1b3b3f6ec379498-1730302976"
  },
  {
    "email":"rossellamaria.pierro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860103546/16862c8982fc0e6cbdea3b283d78a068-1730302976"
  },
  {
    "email":"annapanebianco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860234618/bc291ebfa4fc53852645b431b373d89f-1730302976"
  },
  {
    "email":"elisa.cor@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860136314/0143f350f8d5babeac321ad19eb123b9-1730302976"
  },
  {
    "email":"chiaraciaffaglione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860267386/a49c85d4466ccd123e7d8b7cd6a79f17-1730302976"
  },
  {
    "email":"martina.seeber@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860332922/605f5a4470fc68f9b9c712e5c45603c0-1730302977"
  },
  {
    "email":"silvano_62@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860365690/898f97364c7a1900d7c32992d6b6121e-1730302977"
  },
  {
    "email":"maistricristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860300154/35b50db47c185dd31ef433f0d46080a0-1730302977"
  },
  {
    "email":"grazianocapa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860463994/21980cc94667a9b474a9f0597f6bda65-1730302977"
  },
  {
    "email":"marisa.descalzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860496762/ca12601e827e675440080fad035d8593-1730302977"
  },
  {
    "email":"miakurkhulishvili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860693370/1a534bee4cb09b6c84ea010edc3bcec2-1730302977"
  },
  {
    "email":"7lavio2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860562298/8965553b53fe5c73e52c9b5b1b548d2a-1730302977"
  },
  {
    "email":"simona.bassi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860595066/309ab85d02ed8e729cc83ccec42ac967-1730302977"
  },
  {
    "email":"elenazambardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860758906/c04e018e81bdba26d2df68bb88d7489b-1730302977"
  },
  {
    "email":"francescatonoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860824442/a963afc47bba22845eac4ab656172130-1730302977"
  },
  {
    "email":"manola.cecchetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860791674/79dbd4c073362e10fa41acda97b58cf1-1730302977"
  },
  {
    "email":"alepiatti7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860857210/09474a1718e3741eab690d4c652fe7cf-1730302977"
  },
  {
    "email":"barbaralugarini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860889978/b17afc9e6f1745a086aeec82ad5cde91-1730302978"
  },
  {
    "email":"mariella.sasso58@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723860955514/eac9db03c836261b1df4eafff4c05006-1730302978"
  },
  {
    "email":"marika.leonelli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723860988282/c54fba9573401ed93c68d8132500d239-1730302978"
  },
  {
    "email":"tcastriotta@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861021050/7e9da777574a959704d056cca252d022-1730302978"
  },
  {
    "email":"katiaginesi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861053818/30eee06a9f725eb0161f9436de87ad66-1730302978"
  },
  {
    "email":"arianna.delre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861184890/22174c5b52d12c5f2f70ca07e5f4e0bd-1730302978"
  },
  {
    "email":"sarahcferrari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861152122/ad5d8905a6b75a066164e0c78c2734e9-1730302978"
  },
  {
    "email":"nadiacurcio@dotcomcp.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723861283194/a9998a5390169c40a3ced361d37392b4-1730302978"
  },
  {
    "email":"conforti.emanuela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861348730/7722705726ff58122c0ab71ad676b17e-1730302978"
  },
  {
    "email":"rosanna.spallone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861315962/39aa210caf21d6823fdeaa4d64a08897-1730302978"
  },
  {
    "email":"clarisse_cb2018@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861414266/2529e896f4bb16b3f494deffbcd8ebdf-1730302979"
  },
  {
    "email":"nannini.patty@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861447034/eb557b455764c203a2e8a986e6abf27f-1730302979"
  },
  {
    "email":"emanuela.vincenzino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861479802/df7e023e42d7a335b5f2859adea487c6-1730302979"
  },
  {
    "email":"fede.mangolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861381498/7262119d9f46ea8c4b158abade82e70e-1730302979"
  },
  {
    "email":"m.alfieri86@icloud.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723861610874/48ff9e6a95a998279de6f76274b4addd-1730302979"
  },
  {
    "email":"rovelli.r@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723861545338/69656f48fa7722beb8cbacbd4e4f13f0-1730302979"
  },
  {
    "email":"pistoia@mdc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723861741946/5b7798c8eb9243928442036cb14ba281-1730302979"
  },
  {
    "email":"danilacabras@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861774714/fafa4f0aab2331973a5d5e090a265f6a-1730302979"
  },
  {
    "email":"lorenavitale0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861807482/05640ec12e29ebb833e514b52450b1dd-1730302979"
  },
  {
    "email":"barisone.luisella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723861840250/d5650b4807fcd99fd2c21f9fbbf57e6b-1730302979"
  },
  {
    "email":"gioiabuonf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861873018/c1a916d1f6198bf0729b0298e798913b-1730302979"
  },
  {
    "email":"ariannapirotti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723861905786/cb0dcb7bea869462c1b53e904ff1146a-1730302979"
  },
  {
    "email":"arch.alessiaconsonni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861971322/646b0d9670c816065cef80bc9c57a6fb-1730302980"
  },
  {
    "email":"mara.negrini74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723861938554/b928730ce7fb31026bc26b99b1135b75-1730302980"
  },
  {
    "email":"e.dellaversana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862102394/d3b9996f33df98a078553bf61f471dd7-1730302980"
  },
  {
    "email":"masinimonica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862135162/205562ce30ecd66cb4559ea626cab44c-1730302980"
  },
  {
    "email":"robicarnevali@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862233466/e6964919c90e1fbe3ad73ff27316fa00-1730302980"
  },
  {
    "email":"cristina.danielli59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862266234/8cdd469561610d89b68d777c8b54a8d8-1730302980"
  },
  {
    "email":"barinicaterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862299002/af4d63f29324480255cf4105b44ce8f8-1730302980"
  },
  {
    "email":"vteodorani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862430074/3b79e61f5e142070902745d24a8b8d5a-1730302980"
  },
  {
    "email":"sv3tly@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862200698/1eaf0ace47cdaac857df92f6f3ec562b-1730302981"
  },
  {
    "email":"serena_iacovelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862397306/23ba88446722e31b4a7332f11ac6a810-1730302981"
  },
  {
    "email":"costantino.luci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862331770/9acbb8fead86a77d8e16efe61d283b51-1730302981"
  },
  {
    "email":"vpagnoni90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862593914/0bcb720ddf430d9a092b9a6b1bb69c26-1730302982"
  },
  {
    "email":"isi.na@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862462842/68eff4100340d79bfa7f1ee55c467c39-1730302982"
  },
  {
    "email":"margherita.cassari@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862561146/b8aee3a6dbc63331abfc661661876e8d-1730302983"
  },
  {
    "email":"d.giuli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862528378/0be0d4125be308e7238cae2e1a745040-1730302983"
  },
  {
    "email":"margheritacaleffi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862659450/70a1967ee4d9a97867c858b66d338244-1730302983"
  },
  {
    "email":"gabripam@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862823290/655d8b9e3b846f88c77487e28154f8a3-1730302983"
  },
  {
    "email":"simona.stra3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862692218/75366cf9436f2409ae9fd97a33d57054-1730302983"
  },
  {
    "email":"serena.tavani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862790522/99cb69d049449bd91ede4bc27d555879-1730302983"
  },
  {
    "email":"laura.marasso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862724986/e3336460bf99c8ad6c8075193d4c2cd8-1730302983"
  },
  {
    "email":"ilarianervo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862856058/49881f3bccd91a576697ceae145fb493-1730302983"
  },
  {
    "email":"fedegrino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862888826/4f2d9f62ef3d1a1df796f99102ad0803-1730302983"
  },
  {
    "email":"danielafrigerio@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723862921594/f768fbbddaa011b6238251a8a01d0e2d-1730302983"
  },
  {
    "email":"monzanna60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723862954362/d83298a53a5905ac84f1155725671a06-1730302984"
  },
  {
    "email":"cinziaoro@ivloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863019898/b5d4f128aa7ef77a0a58f2c304a24b09-1730302984"
  },
  {
    "email":"loredana.delrio66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863052666/92d03a34be0a64ebdedf39e672fa4295-1730302984"
  },
  {
    "email":"daniela_marchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863118202/054dcef67ccf1d6551d5f95b839d7ed9-1730302984"
  },
  {
    "email":"annalori87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863150970/07f03aee2e98421ff3a7483294e677dc-1730302984"
  },
  {
    "email":"alerostop@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863249274/02e8c61d4579f0ec94ac2f5784bd3c0a-1730302984"
  },
  {
    "email":"battiforafederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863085434/5685db2b132b7dcd876d87b59e23d6f7-1730302984"
  },
  {
    "email":"olipepe@unina.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863183738/4dfb7cd326cbaf6efc0694f3f734e5ae-1730302984"
  },
  {
    "email":"saveriosax@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863282042/ea8f4f31757593644a6874709a575a01-1730302985"
  },
  {
    "email":"fatamail74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863216506/011d052d6e4bdd6b0eeb519478e35f00-1730302985"
  },
  {
    "email":"soldo.annarita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863413114/32247d44149861f257ad8a2502fc173b-1730302985"
  },
  {
    "email":"clotildecalascibetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863347578/332b41bb5eac74b15e131612758b03ab-1730302985"
  },
  {
    "email":"milena.boccone1066@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863314810/27929fd1c165df482d25571da6741976-1730302985"
  },
  {
    "email":"gio.pezzoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863445882/9b5884156c235d9d7d80110230e6358b-1730302985"
  },
  {
    "email":"bettinaferrari21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863478650/e4839ffbccd70374b06ae9f1c40bbbd5-1730302985"
  },
  {
    "email":"massmorg2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863380346/4179f013aeb13012947f17532348d0ac-1730302985"
  },
  {
    "email":"gibosinienrica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863511418/2cf1777bee8230ff8b5ca5582ebdb0b9-1730302985"
  },
  {
    "email":"info@pasticceriacenteleghe.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863544186/401ae640b37de62e64dcd24073a2ae75-1730302985"
  },
  {
    "email":"mariacarmela1292@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863642490/c102e1276207fd47d3092f93f952636a-1730302986"
  },
  {
    "email":"miriam.kiem@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863740794/4c06c57d9e0022219e287784a63b9151-1730302986"
  },
  {
    "email":"giovanna.sartori84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863773562/29f0c3a4d95b3619a53bd89a1f95d86e-1730302986"
  },
  {
    "email":"elena140478@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863904634/4d73f2ef1e454bc8b5bf4b5464c0665c-1730302986"
  },
  {
    "email":"tlugini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863576954/208df3adbe0f2d82f3ccc10c9e14f634-1730302986"
  },
  {
    "email":"visintinsimonetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863806330/bdea09bb947f411d2a277dfc8b4b0351-1730302986"
  },
  {
    "email":"irenedeboni69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723863609722/7678c86d896de6d57a3bda08c886c749-1730302987"
  },
  {
    "email":"mariellacozzolino1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864002938/765a952471ba58d58419411634af9f7d-1730302987"
  },
  {
    "email":"annaforconi@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723863937402/5f37e100e3a38938b192a890cf355737-1730302987"
  },
  {
    "email":"lodovica.de.santis@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723864068474/2bafa09eae93a061975839a0edecac5c-1730302987"
  },
  {
    "email":"vrusky@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864101242/120c28306b698d119a7683a7814937f5-1730302987"
  },
  {
    "email":"caterinagiaimi2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864134010/22e72361f545223519a1e0f9dd08cbe9-1730302987"
  },
  {
    "email":"avvlindafrancesconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864166778/198719b25a61309fde88d5bba6f9f6f1-1730302987"
  },
  {
    "email":"simona.agnolis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864199546/6f6ae8b4442872b0227a2715a2be9615-1730302987"
  },
  {
    "email":"rm_raggiodisole@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723864232314/f24e72b8635f9820b9bc60c39b8a5aef-1730302987"
  },
  {
    "email":"nicoletta.perondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864297850/8b34aefd60ccbc4f29564b85053943c9-1730302987"
  },
  {
    "email":"sabrinachinappi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723864330618/04444538a34cf8423c4ef0d458341c62-1730302987"
  },
  {
    "email":"annsnn75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864265082/c06a9a44d4948ddaf0d6e0e3186ac8cd-1730302987"
  },
  {
    "email":"cristina.nisita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864363386/4d7b5974bda70958eb524a1b423a4701-1730302987"
  },
  {
    "email":"simon.buono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864396154/9c1ea4080630b6e7a90bf63a3834f169-1730302988"
  },
  {
    "email":"ilenia.serracca@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864428922/82ad884f866a743d9f1fa4cd980679f4-1730302988"
  },
  {
    "email":"carolina.gatti90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864592762/29ee7a3bf109114b34db57784ed9f7a2-1730302988"
  },
  {
    "email":"pintonellochiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864625530/aa01ac3fb3e38d9efd2a91d704fc4e4d-1730302988"
  },
  {
    "email":"coppolecchia.angela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723864559994/e677419f9e98870fb952950aa4e46dcd-1730302988"
  },
  {
    "email":"eli_andreoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723864691066/d00bb46c33d5d2187575c04ac28a2375-1730302988"
  },
  {
    "email":"simonaconti1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864658298/67e04f105186edb50389d6f604c0adf5-1730302988"
  },
  {
    "email":"sabra.boldrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864723834/b3f9a18d977f211e74b36f2cb9552662-1730302988"
  },
  {
    "email":"elisascavino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864789370/61c38acc449e1819fff5b4ef0a572676-1730302988"
  },
  {
    "email":"valentinapix@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864822138/049011be7118ebb745b0a634c011ed9c-1730302989"
  },
  {
    "email":"rosselladonnici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864854906/2bd8a2b2652de030dd108dcf142353b4-1730302989"
  },
  {
    "email":"apilloni276@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864887674/d2601b91633ea80db4d7d27ed2480971-1730302989"
  },
  {
    "email":"manuela.riva.67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864756602/a30b80e701d7ef3fa519d8f76705963a-1730302989"
  },
  {
    "email":"rosalbalunetto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723864920442/4feeb8609397b2b780b9d951c74d118e-1730302989"
  },
  {
    "email":"ambravettore@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865018746/06858a3f8fa7d4197064ba2f3c20dd49-1730302989"
  },
  {
    "email":"luigiacaccia65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865051514/6d82648005b80b7fd43e519fed43e599-1730302989"
  },
  {
    "email":"natalizioivana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865117050/78fb16a03e6054b10b7907cb4fef0af2-1730302990"
  },
  {
    "email":"clongo@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865182586/e829cb9a78513cf09fcbccf51a392c79-1730302990"
  },
  {
    "email":"vallivela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865084282/b41e2dde6b5ac4f95305aa93d360c1a1-1730302990"
  },
  {
    "email":"deborahcerretani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865248122/12076d39aad05cc49f6600511de86ff2-1730302990"
  },
  {
    "email":"danielaramoni10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865215354/eba32d0174452dd9c1950e673432f3c4-1730302990"
  },
  {
    "email":"alegiusiana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865280890/6856eeb872d3dbea5139999751bd530a-1730302990"
  },
  {
    "email":"albertinellialice@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865313658/d9d90015a0c83628ede6b3db39cf1838-1730302990"
  },
  {
    "email":"m.oromed@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865346426/cb8dadb3e8759e334c7a73b73f4878d1-1730302990"
  },
  {
    "email":"ada.fiordelisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865149818/30dcb5195bace560f5f8bdff10927b3d-1730302990"
  },
  {
    "email":"mascia.lucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865411962/c24ffff11b20813662a6680c32b5215c-1730302990"
  },
  {
    "email":"kat.man@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865444730/6d024124d2587f1c9eb039e8690f2035-1730302990"
  },
  {
    "email":"vagia91@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865510266/0c20c71bfbbe95ba199ab310df23f2b3-1730302991"
  },
  {
    "email":"chiaracampanella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865543034/8f71fb2fbe78e4f86a81ec71fea9b69d-1730302991"
  },
  {
    "email":"cristiana.pedroso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865674106/41c077f7c1cf1411229eadd4947ca71e-1730302991"
  },
  {
    "email":"elena.p74@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865608570/1863455ea6590680a8afd64bc8827c18-1730302991"
  },
  {
    "email":"claire.argenta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865706874/43f91bc77754b0b967e93469c4807866-1730302991"
  },
  {
    "email":"chiara.lovotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865739642/38fffe7872754a64f0eb8f334d6e3a26-1730302991"
  },
  {
    "email":"francescafrassetto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723865772410/9cee9afe155f7a2d8c41f1b8c7662331-1730302991"
  },
  {
    "email":"evafalcone66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865805178/dfdc0d5fd56e73aa13165d81d9c3dda9-1730302992"
  },
  {
    "email":"alessandralinda.fagiolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865870714/6633dbc9bf517fd2640de36c8dc03c28-1730302992"
  },
  {
    "email":"barbarazicaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865903482/cba3050cbfcff5171968adf20addf8ba-1730302992"
  },
  {
    "email":"soniadegano67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865969018/ecbb0b5006ddda142919c90063c54aed-1730302992"
  },
  {
    "email":"barbara.pollero@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865936250/de4b02bfc75e9467df2c8daff557701c-1730302992"
  },
  {
    "email":"deboran997@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866001786/6d2471dcae94a9e280784cf49a64ec5c-1730302992"
  },
  {
    "email":"elena.tettamanzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866034554/d733ae33bc331de398a7a67eb9497f38-1730302992"
  },
  {
    "email":"rogia1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723865837946/f23ed143949c131713923389ec2acab7-1730302992"
  },
  {
    "email":"zanni.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866067322/4eb7ea91a06d9e20f22ab1457360a58b-1730302992"
  },
  {
    "email":"manuela.ela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866198394/53676badf8aba1883979f9f4bc3cae39-1730302992"
  },
  {
    "email":"silvia.zanni@aovr.veneto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866100090/a630c9356ec9b11deff39956dda47ea3-1730302993"
  },
  {
    "email":"paganiguido@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866165626/f55371f335813df83ff4062968454233-1730302993"
  },
  {
    "email":"jandb@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866132858/333ecff4f71c38dbfe01f92690c99c22-1730302993"
  },
  {
    "email":"marinellatroiano@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866263930/38cc35d3a1e8bb7c33124b8a03461985-1730302993"
  },
  {
    "email":"mariellamura253@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866231162/a703257023ce099aaaf9a87b94c8f9c6-1730302993"
  },
  {
    "email":"sabrina.sacchi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866329466/f27f5b60a5badd6abe8048ad8661ef13-1730302993"
  },
  {
    "email":"alonissos67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866362234/9aa015b669ad614088f7aebec4aefcef-1730302993"
  },
  {
    "email":"mariarossella57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866296698/d6ca204f6be2bc3ca23c47697075ecd7-1730302993"
  },
  {
    "email":"e.ventura231281@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866493306/40bccfae6566f56a9d9f093afbfe5dd0-1730302993"
  },
  {
    "email":"rosselladelvecchio1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866427770/eea89535f74fede0537b2c6a2e4254c8-1730302993"
  },
  {
    "email":"alessandra@alessandracatalano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866526074/6aad4e27a4c53000bf8a99356b76a198-1730302993"
  },
  {
    "email":"giannadenicolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866395002/256674e91a745bea1e622b67164a4a5c-1730302994"
  },
  {
    "email":"lidiacarbonetti27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866591610/0a4013890c1ddee7ce80b4c0d2ef07eb-1730302994"
  },
  {
    "email":"elenadreams@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866558842/ee7a509112938907e07343c6ea5f795a-1730302994"
  },
  {
    "email":"lauraadami71@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866722682/d69f0dbc7c959dbb75c6daa522e68929-1730302994"
  },
  {
    "email":"framet75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866788218/a15f3b96821e5457bc1b01a589a39e0d-1730302994"
  },
  {
    "email":"franci78.mula@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866624378/9223c54f4b3a1d106a4c795c912e5fdf-1730302994"
  },
  {
    "email":"filomenananni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866820986/d4fe7ef9819b861f206f4ca085381eef-1730302995"
  },
  {
    "email":"lea.brambilla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866853754/52723a008529c80303b48a606d09e8e0-1730302995"
  },
  {
    "email":"ersiluna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723866657146/42913aff8eb682b90ed8f02ea919224c-1730302995"
  },
  {
    "email":"barbara.belardini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723866984826/29b8a7591300481c47d25b3c37b3bce2-1730302995"
  },
  {
    "email":"angelika.bendetta@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723866919290/3e678b6612549ef0795dab399b5e2e46-1730302995"
  },
  {
    "email":"digennaroviviana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867017594/851d4c4f8960344ca4fd7f9260c410f5-1730302995"
  },
  {
    "email":"malafabrizia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867181434/6dc127a3355fa08204d52f1db6cacbed-1730302995"
  },
  {
    "email":"info@villettavaldisole.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867214202/73ce5fa60b1d1bf02b492cd9b90ffc93-1730302995"
  },
  {
    "email":"annalisadegiosa@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867246970/7e3b3e2cb564187d05ebcd2297de8384-1730302995"
  },
  {
    "email":"silvanabuonanno@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867279738/ebf88323a4f73fd0d897fa27ad0909a3-1730302995"
  },
  {
    "email":"gmorlino@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867115898/02bd58c0e29d441c8cda9c76eabf8df9-1730302995"
  },
  {
    "email":"esse75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867443578/5b6dd425e3416bd8d6c072733a0e51fd-1730302995"
  },
  {
    "email":"serena.fontanelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867410810/856c1c529aa37352bcb37b7375178951-1730302996"
  },
  {
    "email":"saratissimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867509114/bd98eedf047dd71c8932b660b4693976-1730302997"
  },
  {
    "email":"info@stefanianardini.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867476346/796f54a0ec861e715f71b79c8978ec00-1730302997"
  },
  {
    "email":"carmelabellassai22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867574650/592bb5166e225e35bbf839a9831cf09a-1730302997"
  },
  {
    "email":"sara.spol@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867607418/3d5b1dff79993ff7f273ec5bf190f13a-1730302997"
  },
  {
    "email":"amorini.eleonora@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867705722/90b1e9b8c7b843a9ab54259149dc74e0-1730302997"
  },
  {
    "email":"ing.laura.ranieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867771258/108d2a43b5173b4b0499bd33f394d3ee-1730302997"
  },
  {
    "email":"pasinianna56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867640186/e602a50fbf69aaeafe27e2b9ebd02476-1730302997"
  },
  {
    "email":"michela.saurin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867672954/fa9e801d2147bb51534598404ff51ad8-1730302997"
  },
  {
    "email":"delfinaradovani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867902330/eac4d95fdf0790d74ddd7b760a9fd624-1730302998"
  },
  {
    "email":"silviadema.95@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723867804026/b229074e77b3c559b20ed1723d383644-1730302998"
  },
  {
    "email":"giorgiadalessandro91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867836794/8d15af565e0bca02ed2daa3f2b316dd3-1730302998"
  },
  {
    "email":"marina.roni75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867935098/5dccde5df94f24a298c194cfad084c7d-1730302998"
  },
  {
    "email":"eli.garghi9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867967866/b140ac986396b67a3392a237b7c2cc77-1730302998"
  },
  {
    "email":"claudiagerotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723867869562/e84dfbe88fdc07f2cce1f861f244f8a5-1730302998"
  },
  {
    "email":"letizia.francalacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868000634/3c581ea166f4a986efc7c8e42add5955-1730302998"
  },
  {
    "email":"sb.sabrinabellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868066170/ed8b0842acd1d8da0cab3aa00c087418-1730302998"
  },
  {
    "email":"roberta.brunoldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868033402/82821fe8c1af93b9effc3aaa81579826-1730302998"
  },
  {
    "email":"sandra@kbpromotion.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868098938/540070ca36b8896fe723a63f913b5a31-1730302998"
  },
  {
    "email":"bradamag@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868230010/dd8f19d37e62376654c7737d0bdc5f9a-1730302999"
  },
  {
    "email":"tezzapatrizia@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868295546/11afa8c9e8309a5d484b19416f3eacb5-1730302999"
  },
  {
    "email":"loredana1961@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868262778/1c99250d256547189eaf48a3bb891ee7-1730302999"
  },
  {
    "email":"mara.franchini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868361082/39dc709b23e61454f87260fe54bd8343-1730302999"
  },
  {
    "email":"lauramal.62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868131706/3baebc755e15806742b3784a383a5fdb-1730302999"
  },
  {
    "email":"anna_nastro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868426618/47649a0be81c8b58ccfcf73c05594111-1730302999"
  },
  {
    "email":"chiccafranchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868459386/4812c75a1bd1a443a16d1c1d8f9056b8-1730302999"
  },
  {
    "email":"pizzichini@castelnuovo.tv",
    "url di attivazione":"https://verdissima.it/account/activate/22723868492154/8dbb662416a3fb0a2cdee5649b681837-1730302999"
  },
  {
    "email":"pardinibarbara@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868524922/ef83f95ae6fbca02faa07f3c695e8690-1730303000"
  },
  {
    "email":"ngerarchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868328314/670db7c0792e48c757af0e0f3165edf0-1730302999"
  },
  {
    "email":"perronelucia93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868590458/23154b5a6b958d2f2c6110f63daed22d-1730303000"
  },
  {
    "email":"luisatrento5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868623226/2a7bf8a9368248b6226da376e3fdf1ef-1730303000"
  },
  {
    "email":"annalisa.cozzani3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868688762/1bd29b211b9825458353e84deec9d1b3-1730303000"
  },
  {
    "email":"debgiuli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868557690/c7fe30d017c9fff0fb5ee3652f06db2e-1730303000"
  },
  {
    "email":"f.stumpo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868721530/6dfbb43f72ab69b8a344cf99ae0274ca-1730303000"
  },
  {
    "email":"taramellilaura@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868787066/abe54c3db04c30415ad650aac36aba30-1730303000"
  },
  {
    "email":"katiacinziacasera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868655994/4e463df3a02171f299f8e08d1fa2f6c3-1730303000"
  },
  {
    "email":"pantaleonisissi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868819834/fc00bee235a630fc0201f96dbeea1816-1730303000"
  },
  {
    "email":"barbaravitali69@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723868950906/12a8bf62eb78b7b542d52ac8305de1ae-1730303000"
  },
  {
    "email":"valeriadistanislao@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869049210/916e36a4beb5cdb72747ff7bcf90ca60-1730303001"
  },
  {
    "email":"simonetta.pastorini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869081978/20de9f1295b7a6960863ed36e18a223e-1730303001"
  },
  {
    "email":"famdavideclaudia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723868983674/55b14c381abcc8e67cb4c3ddf671ddb3-1730303001"
  },
  {
    "email":"mritacesari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869114746/8decb91320ba140ee5759524875e5834-1730303001"
  },
  {
    "email":"filomenacinque1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869278586/07988338f548bd7d886b5593e00f15aa-1730303001"
  },
  {
    "email":"silvia.messi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869180282/03a84b6c3cfb3bc5f97723fa52bc53b8-1730303001"
  },
  {
    "email":"cris.sebastiani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723869245818/88ee9d6520546d1e8ce6479fb56f0e72-1730303001"
  },
  {
    "email":"sofilipstick@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869147514/06a3aea4fb6ee6f4d62121b6d1a89fe7-1730303001"
  },
  {
    "email":"marilisa10@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723869376890/e76df7c39931350caea4f8a9335290a3-1730303001"
  },
  {
    "email":"sabrymor75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869409658/911d632399e99a6a1b829d7d69f13de2-1730303001"
  },
  {
    "email":"daniela.deagostini.dd@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869507962/421431e5f7932518b2e44ea88f200bf6-1730303002"
  },
  {
    "email":"rossella.digiovanni73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869573498/aa5d595350e20352e44a11bf3a1ef45e-1730303002"
  },
  {
    "email":"vicky987@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723869671802/f4d56845db4f1865a82712fb1dae78e0-1730303002"
  },
  {
    "email":"chiarachiarelli53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869475194/5743256559d3017268010c346ba87409-1730303002"
  },
  {
    "email":"disotto1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869344122/45f7d40d8f5140ac4a8ca59a45ee2941-1730303002"
  },
  {
    "email":"francescanannini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723869704570/b452294482a09a317999b8a5fe595572-1730303002"
  },
  {
    "email":"esabbatini697@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869770106/48fb2539ba4256bf75448335df7cf8fd-1730303002"
  },
  {
    "email":"esantini@isimarconi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869639034/d17b43c2aa1bc502716223af634532dd-1730303002"
  },
  {
    "email":"elisa.giallatini1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869835642/5c48a88209fcbe6233c98415d00757d5-1730303003"
  },
  {
    "email":"ergacerchiari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869802874/039984021342c8d1e6c357b93598832d-1730303003"
  },
  {
    "email":"martini.lara@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869999482/006a2b5e201dd8de0489bc37c94ca512-1730303003"
  },
  {
    "email":"promari56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723869933946/80566694b6e78c4b67aeff2d1bc3e0e8-1730303003"
  },
  {
    "email":"mrosi.sar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870065018/1f68f92a23b61d3c2de34fef88637404-1730303003"
  },
  {
    "email":"margheritamarchese3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870097786/eb8e049c235ef9bba608fc73cdc0c9bf-1730303003"
  },
  {
    "email":"ariannapuggioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870130554/f8d92a0989bfe6df43fa64c2b660da35-1730303003"
  },
  {
    "email":"deparigi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870163322/7cc56bedcd7cfc572fb02d0d5ec811dc-1730303003"
  },
  {
    "email":"luanaballaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870032250/357b49234b9622ff36f782e6a5d6799a-1730303003"
  },
  {
    "email":"ceschilaura74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870228858/19892ca234af2d78dbce949e652e4d1c-1730303003"
  },
  {
    "email":"paoladinelli2022@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870261626/b3f9040f6c30e1eb8ec9a64241815061-1730303003"
  },
  {
    "email":"ranzof@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870392698/e7ead4beeed396226073819d39a26776-1730303004"
  },
  {
    "email":"ag.cicerellocinzia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870425466/fe9dca6493cd1dc5385688eb62614617-1730303004"
  },
  {
    "email":"quistis69@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870458234/4c2b7eedb1c2d2d13051c9c1994dd2b4-1730303004"
  },
  {
    "email":"selene.guglielmo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870327162/2ac131c0bc1a37bbdc9c9f1e68439bf2-1730303004"
  },
  {
    "email":"fiorenza.ferrari81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870294394/064a5571755590b8ee37f4a64c3f720d-1730303004"
  },
  {
    "email":"antonella.di.ferdinando@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870523770/17b4c1a720350d6b9d5020662e3416c4-1730303004"
  },
  {
    "email":"fabry.anzillotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870556538/030de1175466a2cea79da8bd0644381a-1730303004"
  },
  {
    "email":"margheritazanini97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870622074/303ead2650cb6744d1bfe86cf4ef6639-1730303005"
  },
  {
    "email":"simonagaddi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870491002/86cdda5f0ed81f41c229accd2f6752ff-1730303005"
  },
  {
    "email":"tvrenna54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870589306/24b12dc9e707056359bad7555c7e5e44-1730303005"
  },
  {
    "email":"antonia@martoccia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870884218/a3521c14d107ae293abdd915632c29de-1730303005"
  },
  {
    "email":"sandrazoratto@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870785914/0b5efe3ab9091bbe6140b1b7379ebc77-1730303005"
  },
  {
    "email":"k.pirker88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723870916986/a5121604365b5b6a6332d28d40bd0009-1730303005"
  },
  {
    "email":"enzaiapaolo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870753146/573c565ca7d8f149bd010647db7bb357-1730303005"
  },
  {
    "email":"katiusciabai@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870654842/f78ea5b6c4ccdadc4fac092d275cc484-1730303006"
  },
  {
    "email":"lucia.fazzina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870949754/4ded7cebec1872c536662958b56ec571-1730303006"
  },
  {
    "email":"romina.cagnin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871015290/982a1652a4ffe998ca5cf060487b2797-1730303006"
  },
  {
    "email":"cristina@demaio.bs.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723870982522/ed175a19da28375516e3f0099345a45d-1730303006"
  },
  {
    "email":"iverdirosi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871048058/55c4e9afc4a4039098a8bdb4bfe4690b-1730303006"
  },
  {
    "email":"lauracalzolari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871146362/beaaa4116aa4a3600e0ec859bec7999d-1730303006"
  },
  {
    "email":"federicasat86@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871080826/fd3ffeea1cece41e7ff559c57ce7c242-1730303006"
  },
  {
    "email":"lucia.assolari@rami-mmt.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871179130/186ffe553687f0ebabf3a7c46c3e42fc-1730303006"
  },
  {
    "email":"francescatraina@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871244666/faf2bd465c24b989a4f3bc84528812d5-1730303006"
  },
  {
    "email":"veronica.menici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871211898/519bdd08681fa91815a79589605764d0-1730303006"
  },
  {
    "email":"paoladalfonso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871310202/f5dcce732cc00457f2f2849eee8abd42-1730303006"
  },
  {
    "email":"francadibe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871408506/1e07c0d4ef8ce8f1aff6ecf3f160dcb4-1730303007"
  },
  {
    "email":"valentina.caracciolo82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871342970/29002e4efe1e1b7976c5236a733784bc-1730303007"
  },
  {
    "email":"dariarossato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871441274/75f219974ecb908b01e96feaf5029821-1730303007"
  },
  {
    "email":"elena.salvadori11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871375738/85e5ecf2d26ff6777ab31490fb900b91-1730303007"
  },
  {
    "email":"cinzia.arienti75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871572346/445a5895335fb1d86a2e7adf49482ef4-1730303007"
  },
  {
    "email":"cantando@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871637882/d9bcef3c3619431ee31fd094b06f9507-1730303007"
  },
  {
    "email":"monicacinquini@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871539578/29e2bc649ad6dd76b7f5f3ce9e2b8fb1-1730303007"
  },
  {
    "email":"annafiorin67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871506810/2b12dd7dbf73f223c9151cb66b3457f9-1730303007"
  },
  {
    "email":"elisa.caselli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871670650/8bf6bf0bb3a8d06266d38a9e118a58ba-1730303007"
  },
  {
    "email":"fmabilia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871736186/d897b90ceacf0d1b21e316ca9d0b71a2-1730303007"
  },
  {
    "email":"scotti.greta@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871703418/b91bdfe71f9a0bc36b976f4ae4c729e8-1730303007"
  },
  {
    "email":"marta.vinciguerra23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871768954/c5be851d0def0c2e70328205604d531b-1730303008"
  },
  {
    "email":"t_imma@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871801722/369f1699a19f991c5a3143d83e537080-1730303008"
  },
  {
    "email":"neveinmexico@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871834490/75a8ebbc6dbf0a71e4532c55bf21df90-1730303008"
  },
  {
    "email":"elli_b75@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871867258/e7db7237b66b53286fdd0146935ce354-1730303008"
  },
  {
    "email":"francescafrancia290775@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871900026/56f461d7414197c9a75f46112bab34f7-1730303008"
  },
  {
    "email":"valentina.quadrone@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723871998330/5d70c68e4c2a40d4c87f26307a88d799-1730303008"
  },
  {
    "email":"terrymarinuzzi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872031098/f8e80c7b694eebd128cd1475046c4d72-1730303008"
  },
  {
    "email":"f.russo@ipocriti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871932794/be2d42e7b901cd09a52b3c81bad177a7-1730303008"
  },
  {
    "email":"sofia.cardella@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872063866/ef10faf5e3ca7168ff243b6329d1e4f7-1730303008"
  },
  {
    "email":"annafrontini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872096634/5f54cab8a8744226290acf45035a22c7-1730303008"
  },
  {
    "email":"cgambare@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872162170/25b0a90d07e51620827cdb9c1fb891db-1730303009"
  },
  {
    "email":"silvia82.p@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872194938/03b41e63847f5eac1c4916c2ba41a280-1730303009"
  },
  {
    "email":"pbruni80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872260474/44e5eb28995151943128e4564b28e5ce-1730303009"
  },
  {
    "email":"barbaraninni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872227706/3cd64a4f05db54f5e10b14f939f80152-1730303009"
  },
  {
    "email":"mariangelamarra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872391546/ec2fd2634dd393311861abf2c3734c56-1730303009"
  },
  {
    "email":"lauraferrari110@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872424314/56bccdc88150f02c0ce9cbcdcc724118-1730303009"
  },
  {
    "email":"beatricemarciante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872358778/14ecc76b77b7a1f90b717200adcd0379-1730303010"
  },
  {
    "email":"erikalambra84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723871965562/5a0d1b89ceac64b5711062693c52178e-1730303010"
  },
  {
    "email":"elviramaio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872620922/1fb3526c2b6f63e39e45d59fd918c6e3-1730303011"
  },
  {
    "email":"laura-nestola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872555386/671a3a2c5a441b686e4dbb6f1c4d159d-1730303011"
  },
  {
    "email":"titti.amantini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872457082/f3c9e5cb3955b424754354fc675c9c09-1730303011"
  },
  {
    "email":"bianchiema20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872653690/7f3458b1dee7708c46ce1e7fdda21e9d-1730303012"
  },
  {
    "email":"p.ghisleri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872686458/f9066955f39f13db2911a99a19f01dec-1730303012"
  },
  {
    "email":"chiarabelinda71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872522618/6d262c8be5665d62e2dab70af9ac8527-1730303012"
  },
  {
    "email":"marteboc23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872850298/4ceba5002eb4e40447d246e51758f372-1730303012"
  },
  {
    "email":"barbaraelmi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872817530/bac3632d7403cba5392e4d0c83eeea6d-1730303012"
  },
  {
    "email":"beatricemaria.magni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872915834/060c4ec9e7b21c5418cf2a3dc93b1c73-1730303012"
  },
  {
    "email":"tadeja.jakulin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723872883066/e7de142ec4c26417c9e43d4444c77e15-1730303012"
  },
  {
    "email":"k.condomitti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873014138/9966eb11b84ab08e5fc2feb79266ad12-1730303012"
  },
  {
    "email":"ele.agnelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723872751994/94aa4bf1d1bf938dfe8e9ef9f5bc33d4-1730303012"
  },
  {
    "email":"simona.caporali@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873046906/54035e779cc6697973e84456f658d077-1730303012"
  },
  {
    "email":"stellaagnese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873079674/daa4dada8028e992f921d7dc7f45ad60-1730303013"
  },
  {
    "email":"assuntamorelli79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873177978/c8dcc193375fd4069b0f25f845cfc327-1730303013"
  },
  {
    "email":"monica.cavalli9295@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873145210/abb9d74cc6057a5e8ec28cb0eadf2231-1730303013"
  },
  {
    "email":"rossana.borgia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873210746/ada49a186e13963080469d0cbf79ae2f-1730303013"
  },
  {
    "email":"annamantoani75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873243514/594b21cb71b0f16fd6801e239d5faff9-1730303013"
  },
  {
    "email":"b.kate2011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873341818/52bb88d604bccbb86c78c17727f67e14-1730303013"
  },
  {
    "email":"baggiogiorgia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873407354/562e1b2d2733577568ee22bb8f19a0cd-1730303013"
  },
  {
    "email":"fcanovi@canoviassociati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873276282/4a5341454ab0c15cdd21317b50ea97fb-1730303013"
  },
  {
    "email":"vbarbaglia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873505658/1c0004b2d07ce17c3d84af5228e98487-1730303013"
  },
  {
    "email":"luciano.altomira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873538426/734fd623b27ce1b674814510daea6dfd-1730303013"
  },
  {
    "email":"gfurlanis@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873440122/057f6e4f56e9521cbcddc18eaa470c0b-1730303014"
  },
  {
    "email":"martameninpulse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873571194/343e8751208607793f2c91a8deda29ff-1730303014"
  },
  {
    "email":"lellabaldelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873636730/a031f585f574ef21f1f6c009036e7624-1730303014"
  },
  {
    "email":"grzaccaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873669498/23ca466031466c07e2830456488f81b6-1730303014"
  },
  {
    "email":"cettinamaceo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873767802/0351e1711f8eeb4a6c9b1c2564aee599-1730303014"
  },
  {
    "email":"gioelia@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873800570/e697ef28f69e36c6171eb171aff446a5-1730303014"
  },
  {
    "email":"wossap@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873866106/ff42db87a961da837cc3a8f32d5726b9-1730303014"
  },
  {
    "email":"iris98@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873833338/ffbfe98e0b0f3ea6ef556eab428d7526-1730303014"
  },
  {
    "email":"valeriamancinimv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873931642/582ca914af2be5ccc7e574d2a82b53d0-1730303014"
  },
  {
    "email":"paolinanava@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873702266/9478b17d4e2f4c9f6df5374c1c943138-1730303014"
  },
  {
    "email":"francescarigo9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723873964410/1aad7c838cf9cd709dc3f05990aa74ec-1730303015"
  },
  {
    "email":"damato6@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723873997178/425772e6e364859d1b3d9b00c51339bd-1730303015"
  },
  {
    "email":"anna_frati@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874095482/3a3a0fbf74c68cabd7759fbd91ebc999-1730303015"
  },
  {
    "email":"ssiotto@auditaxlegal.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723874062714/ea80e2d03cc049809ddd8e8bb0819393-1730303015"
  },
  {
    "email":"mariapia.brienza@crob.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874128250/18057ec73be36a4cda9ea6c2f5c55ad8-1730303015"
  },
  {
    "email":"manueladisano@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874226554/02cb5309e6deb383bca9ec37517d19c5-1730303015"
  },
  {
    "email":"lallib80@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874029946/2a9c6a424510939182d5b4ffa3a5566f-1730303015"
  },
  {
    "email":"gattofunf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874259322/2585f2dfd43107a722697a253b464ebb-1730303015"
  },
  {
    "email":"lisa.magni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874292090/32bd965fd5da9e5287338cb8abb137fb-1730303015"
  },
  {
    "email":"rachele.speciale@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874357626/f11c67c28cabf2d0189d8b7c776b3e9a-1730303016"
  },
  {
    "email":"christian.bonafini@gpmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874324858/b8aac834125a80c2401aa6d4840c017c-1730303016"
  },
  {
    "email":"silvia77guerrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874390394/31128785252e9667aa10b803ccb9bb9a-1730303016"
  },
  {
    "email":"filizbes80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874161018/86b514928d292fe7d93b296fef5b4195-1730303016"
  },
  {
    "email":"rominasgoluppi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874455930/a951ee6701d928bc7be62f1ed8ae5bc5-1730303016"
  },
  {
    "email":"annanigro46@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874521466/e5a7bd68ad4dd47b026bc8d65583dabb-1730303016"
  },
  {
    "email":"segawilma.54@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874488698/8c6312e2055f36ac1b8376dc14861d02-1730303016"
  },
  {
    "email":"avv.tirinnanzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874587002/b6592b26ba267703d45decc24fa02d86-1730303016"
  },
  {
    "email":"dallerbafd@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874619770/1af66cace4e1fe491a702530c51fc165-1730303016"
  },
  {
    "email":"l.traversa@ilbuonriso.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874685306/4c69899e22d6359450b64be4919fa1f1-1730303017"
  },
  {
    "email":"valentinabellotto72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874652538/e1bbd1e7cfbe62cdb1ac84ae23a9cb94-1730303017"
  },
  {
    "email":"federicadepadova@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874423162/75e9ea27705c650319835bf2f8521745-1730303017"
  },
  {
    "email":"fiorentini_anna@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874718074/3a6180d7a2ec67100fec2f1b64d7106f-1730303017"
  },
  {
    "email":"rosy.sant17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874783610/c3f28aa144f63bb60631a3bb23b9dd0a-1730303017"
  },
  {
    "email":"ilaria.socciarelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874849146/f3d651c6382d73ae541f4fd2d1d76009-1730303017"
  },
  {
    "email":"cristina.costantin87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874914682/f1c9740fcb154a6cd45438345ba31088-1730303017"
  },
  {
    "email":"martinaceloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874881914/d9a7490f32110151caaa080de108b577-1730303017"
  },
  {
    "email":"federica_ghilardi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874947450/623ead7824a11fa34471d441e901a225-1730303017"
  },
  {
    "email":"danycini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723874980218/63157633220ded8fa91421ccdb18271a-1730303018"
  },
  {
    "email":"p.zeta@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875045754/92fe78bd65ea254a93350688a7563f42-1730303018"
  },
  {
    "email":"nicolerusso07@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723874816378/d77537daf64ceaa309283e2ae654c56c-1730303018"
  },
  {
    "email":"elena.paglini@paglini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875144058/cf68c25a08bcda08e71fa442168adf8b-1730303018"
  },
  {
    "email":"avvbarbarapecchia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875111290/8533e58616e25d0c80df26596bdb6359-1730303018"
  },
  {
    "email":"begali@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875307898/afdd463e3f0ddaca62fa83d92446a93f-1730303018"
  },
  {
    "email":"lisabertelli85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875275130/5c7424a010bba8d96238f81cb57f5442-1730303018"
  },
  {
    "email":"minutisilvia73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875078522/f4b4257b679b8a78005824527a50bfac-1730303019"
  },
  {
    "email":"barbaraveri1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875373434/3ee4ed49b8183208c02de94b1a5e2fdf-1730303019"
  },
  {
    "email":"debbybd@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875340666/869f3f65b5883daa6f8edbecb650b7ac-1730303019"
  },
  {
    "email":"gloria.zaccarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875438970/0ceca9a55508f5e726efdafc91385035-1730303019"
  },
  {
    "email":"silvia.dalcero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875537274/9ec47bc978e7dc1486ff684716e724ce-1730303019"
  },
  {
    "email":"lucia.lenzi1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875471738/563e941950508bbe0a36dd611097c724-1730303019"
  },
  {
    "email":"beba.paradisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875602810/43ddd3bcf91c9b027198a2914e5a7a07-1730303019"
  },
  {
    "email":"ranieri.federica@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875635578/d37c07022c610a8cc1a492f351f5c496-1730303019"
  },
  {
    "email":"gellicristina8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875570042/fbcb994c05c1790820bc45e9e3b3729b-1730303019"
  },
  {
    "email":"lucia.esposito3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875733882/ca84d29911e9dce0c64e38d61ed440ca-1730303019"
  },
  {
    "email":"annalisa@sidamit.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875668346/e7e30b5ab44485a8350d39b3699f6e83-1730303019"
  },
  {
    "email":"giuliabarbagallo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875832186/76d04cee6a4916d4aaa145d31cd36037-1730303020"
  },
  {
    "email":"bububluotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875864954/c34a7151355d02d18aa866348c7b8f91-1730303020"
  },
  {
    "email":"maddalena.manzini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875799418/2dad01b3298d9251d703adfa5038acd6-1730303020"
  },
  {
    "email":"rosalindacrivelli72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875766650/68a624d32c3e45732c49176ad9da78e8-1730303020"
  },
  {
    "email":"kikipirre@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875897722/45df4b562809f729b441e60afcace3f7-1730303020"
  },
  {
    "email":"rossanantes@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723875963258/7368ec62951464a5ab748e951fcb40cd-1730303020"
  },
  {
    "email":"angelagiancristofaro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723875930490/47be71ee9bd7a15223e79a9810a9437c-1730303020"
  },
  {
    "email":"iris82_p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876028794/e07b6c6ef35f778b2c94de13685b6663-1730303020"
  },
  {
    "email":"silviavannetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876094330/7475dafd4427abddc37eca5c73c4cb28-1730303020"
  },
  {
    "email":"francescobaldo88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876127098/a6013d2b56c31724fa909cde8aebb85a-1730303020"
  },
  {
    "email":"agenziapacetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876061562/62dee969f576c3d647def0f89c4cf48b-1730303020"
  },
  {
    "email":"lucia_pedrolli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876192634/c054c0af49c4cb7f25cf5547102f00a3-1730303020"
  },
  {
    "email":"rivendita93ra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876258170/91b3e4a621946510cbd040882e01c8ad-1730303021"
  },
  {
    "email":"caterina.cocchiglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876356474/e39fd0635fd87f503f399707eacae0c9-1730303021"
  },
  {
    "email":"sola.elena80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876290938/6e87a53dc3f2e2226eafd9d9ff2841f1-1730303021"
  },
  {
    "email":"albinomonica63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876323706/4a176a05d72d255c949ec535e77b2cca-1730303021"
  },
  {
    "email":"angeladai72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876454778/78b4eb4c60bfb89dc5476a51d2c11ffc-1730303021"
  },
  {
    "email":"elda.zanoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876553082/f11839df947b6d63fd3a7c018516dcab-1730303021"
  },
  {
    "email":"ramona.fraticelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876585850/f53908570093a373b27c732087ba7b68-1730303021"
  },
  {
    "email":"nafiof1980@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876651386/fca627dfe70f6a3620ef9462c242ef24-1730303021"
  },
  {
    "email":"monica.tavella5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876422010/d9e4f0884f460676cc20eac2cbd6ab91-1730303021"
  },
  {
    "email":"myoli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876684154/839eed68271193008c7094072a656e74-1730303021"
  },
  {
    "email":"serena.romano@e-distribuzione.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876782458/b78c11349791ca11193803bcbb792b81-1730303022"
  },
  {
    "email":"brigidavivaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876815226/907c678a35233ff8044d364f2f086356-1730303022"
  },
  {
    "email":"giovannaimperatore@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876749690/73c328681c675dff4cb536059350a261-1730303022"
  },
  {
    "email":"pass35619@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876716922/c10c28ff0383642da90d4351b7d48a4e-1730303022"
  },
  {
    "email":"gabriellabarreca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723876913530/b0d1447132d4b9de052b5a38d26d509b-1730303022"
  },
  {
    "email":"mrosi21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876946298/c0e275b5c5c544f01d0d7f9576774783-1730303022"
  },
  {
    "email":"chirico@ismed.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877011834/bde9096726507f9dd2bd24f75a4244fa-1730303022"
  },
  {
    "email":"annaroncari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723876847994/54842ef5bed248b603d988ed62c2b08a-1730303022"
  },
  {
    "email":"ap_qualcosa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877142906/42041796aa5968f18331751df38b4c0d-1730303022"
  },
  {
    "email":"giusybruno9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877110138/64b6ff6ce56562bfc7344ce7cb1f708a-1730303022"
  },
  {
    "email":"mh9630@mclink.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877175674/cb6d09f955aafcafa994723881425149-1730303022"
  },
  {
    "email":"danielazecchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877208442/e375b74bad53ff75cef7cbb22c6cb0b6-1730303023"
  },
  {
    "email":"fiory03@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877306746/811526794158501ea5b1a3a076618040-1730303023"
  },
  {
    "email":"robertavignocchi6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877077370/26d880f96b0614f8526768c7b24f83ce-1730303023"
  },
  {
    "email":"lesteticaerbusco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877437818/3c6798b60ef8508533e9444280229420-1730303023"
  },
  {
    "email":"tzulietti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877372282/d7b556f0866b1e07ee38a962f7020259-1730303023"
  },
  {
    "email":"alberta.maturo@gma.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877241210/4e36fadbc0c4ec3862c18c7a9d8cb3ba-1730303023"
  },
  {
    "email":"cecilia.sgarbi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877470586/0050f6877ae64f3eff64259c17a67331-1730303023"
  },
  {
    "email":"mariarosa.ferri@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877405050/1b44c1c2136a7f7072585a0d6d97336b-1730303023"
  },
  {
    "email":"donatella.onesti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877601658/7f03cb1c34115035d72d4f2d4deee642-1730303025"
  },
  {
    "email":"luciaceli17@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877634426/38a09ab984e3aa5e216fd43c4ecdabf8-1730303025"
  },
  {
    "email":"giovannasegreto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877536122/481a2b51fd82d3a0cefb4b66769753e3-1730303025"
  },
  {
    "email":"valentina.palazzolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877699962/1729e8691972105c0ba1fa1220555f8b-1730303025"
  },
  {
    "email":"mcristina.vacca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877667194/88a9a2afdc81ae68aa91631601769449-1730303025"
  },
  {
    "email":"mariaritapetrelli59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877798266/a0c829d6393e1d5380eefe392c306390-1730303025"
  },
  {
    "email":"sabrinamerlini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877503354/c070e16040a13c8a8ecb2067b1f478bc-1730303025"
  },
  {
    "email":"napoletanocarmela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877831034/a549207038ac0999be6acb650d56ca26-1730303026"
  },
  {
    "email":"t.ciasullo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877896570/7ef7930aad544b7234100fc32bc42ff2-1730303026"
  },
  {
    "email":"danielad0771@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723877994874/d33f39d9e81036b07104623bda3ffd06-1730303026"
  },
  {
    "email":"antonellamengoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878125946/4486abdf9062e323d334156ab4a54de3-1730303026"
  },
  {
    "email":"cparisi74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723877863802/eb8c6ee81887cc821c9dd97cf8b5b592-1730303026"
  },
  {
    "email":"riccardo.malavasi216@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878191482/21bb788e71d3ef5c7c0def4ab2e2a1c4-1730303026"
  },
  {
    "email":"emiliana.devico21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878224250/9a77ea9ef9c45ad209a4d75bd44939a2-1730303026"
  },
  {
    "email":"costantinilaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878322554/60e4dc2a6030634810b71c72c77a47ec-1730303026"
  },
  {
    "email":"zolzettichpierluigi@virglio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878093178/f45d88e58fe5b78980c2ca2407ce0171-1730303026"
  },
  {
    "email":"chiara.biancotto0207@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878355322/9eed6827ebb22c59e78db68e2c752fc9-1730303026"
  },
  {
    "email":"carmen.saffioti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878420858/1ab8e4124d61fb255364fa9fe361f548-1730303027"
  },
  {
    "email":"danielap65@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878388090/8f7ccd0a34d3d386e05516754ac4e04e-1730303027"
  },
  {
    "email":"evasnnr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878551930/aac9ea180503140b85c4699fd109b27c-1730303027"
  },
  {
    "email":"stefanoregistrazioni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878486394/bef2b7b085acecb06468cbc57ba5e97f-1730303027"
  },
  {
    "email":"perinlaura@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878289786/2861f0f1fa458a2c003f734326401eaf-1730303027"
  },
  {
    "email":"cioccogiac.gianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878715770/e42f4dc776d2562fc9272c06f0ada3da-1730303027"
  },
  {
    "email":"giacomo.lotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878748538/ec8f63175c9fd4c499e10ae01c41bfe7-1730303027"
  },
  {
    "email":"mmaestripieri73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878683002/2f1bc7a5516657b4fbad9157398db104-1730303027"
  },
  {
    "email":"silviadibasco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878453626/8992897cafbdde633652597144dfe86d-1730303027"
  },
  {
    "email":"tania.mologni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878781306/874ad7718580e735533d67ac59640a6a-1730303028"
  },
  {
    "email":"giorgiabusoli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878879610/249370a2859d546de31f48e276257d4a-1730303028"
  },
  {
    "email":"gilberto.95venturato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878814074/a0751059474a7e1c0dc00badca79729f-1730303028"
  },
  {
    "email":"manuelatondelli81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723878945146/b9691935a3d2f427e8a95bbf726cb884-1730303028"
  },
  {
    "email":"cettolina69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879076218/b34a191b6bf9ddf73c3289ec51f93ccf-1730303028"
  },
  {
    "email":"miozenia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879010682/eee7e1576493c6580dd29e7c3ebbc9b6-1730303028"
  },
  {
    "email":"studiocacciarelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878912378/7f23ca718a57c1781a2c668fb17c1f9b-1730303028"
  },
  {
    "email":"noemigas81@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723878977914/2255b35125077c702f8b6fee5ebe39a3-1730303028"
  },
  {
    "email":"sabrymessina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879141754/991437f5a39255f07121377f727f2aaf-1730303028"
  },
  {
    "email":"luiginaprontera@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879174522/5bf5b5081868ea73fb6217a3cda68134-1730303028"
  },
  {
    "email":"dondi.elisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879207290/a78a63593794ca9b387de5df45e37846-1730303029"
  },
  {
    "email":"krismorando@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879240058/f26736672dd82de7456ff7a166718642-1730303029"
  },
  {
    "email":"lucigas@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879272826/30682b8333bf794922fa57847a698d3a-1730303029"
  },
  {
    "email":"sarabelloni.sb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879338362/ab1620de4614204659de0ccba61ff6f6-1730303029"
  },
  {
    "email":"1968cri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879436666/c3e6d49caf7d4d9d92cff5489e5a74cf-1730303029"
  },
  {
    "email":"ferrarateresa9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879371130/9291adb7b5c649128d99e2d25dfd70ae-1730303029"
  },
  {
    "email":"chicca2078@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879403898/9af841f8e7d3615aabd0d271b4eb39c3-1730303029"
  },
  {
    "email":"jolandab@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879305594/f6cc69dcc76f869db39340b9510965c3-1730303029"
  },
  {
    "email":"matilde.fri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879502202/b672a131e1ac44100b00ba57711e0f01-1730303029"
  },
  {
    "email":"profvisonef@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879600506/d92dec0f42e61f033c5ae7694ff8d383-1730303030"
  },
  {
    "email":"lina.avveduto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879534970/4b35b79fa25169914b251a9382836582-1730303030"
  },
  {
    "email":"annastreppy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879469434/0fe7ad2d20b225cec201b691b116ebad-1730303030"
  },
  {
    "email":"michelafoglia82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879633274/316eda4efe742b925610f18271238114-1730303030"
  },
  {
    "email":"elisabetta@ilcicalino.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879698810/5a99aad08eb4bb57d4f6c375f66a3227-1730303030"
  },
  {
    "email":"letifoss.lf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879764346/5942ed573f2fed140ee00fd8597113f9-1730303030"
  },
  {
    "email":"chiara.sampo22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879797114/6cc93d18409d589a16931e0baca47429-1730303030"
  },
  {
    "email":"claraschipani_@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879731578/f9965ed7dc0d41f103afd7daa23d2082-1730303030"
  },
  {
    "email":"alecurri64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879895418/ff099d18b237fa93a25a25e22ed5b2b8-1730303030"
  },
  {
    "email":"v.vezzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879960954/ba77803d4cf84d14d6122b520f32ff93-1730303030"
  },
  {
    "email":"magiannelli73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879928186/39a589bc5fa7e4ace4f36e6e429b8010-1730303030"
  },
  {
    "email":"spesafacile@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723879829882/526216a6cdb4a9d0abbd048cb4bd08c0-1730303030"
  },
  {
    "email":"lellasmaldone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723879993722/d8671d6890283ce24e585936024d65fb-1730303031"
  },
  {
    "email":"chiara.michelon@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880157562/efaf9631f75c848f3fe698fc7bf3e2ef-1730303031"
  },
  {
    "email":"s.faqir@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880059258/5a3f5e12e35a56f801b4930c50ae4e9c-1730303031"
  },
  {
    "email":"ornellasiviero@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880190330/e801b1fb8d69433f60021547013053c3-1730303031"
  },
  {
    "email":"chiararosazza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880124794/a772fcad7ac2f0b2bc4e3c91636dbc72-1730303031"
  },
  {
    "email":"camygaspa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880223098/9c2558bb1a67f1356159ab35d1b505da-1730303031"
  },
  {
    "email":"giulia.9@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880255866/3a54ac3138a6ca69398740d1a0bd1cb1-1730303031"
  },
  {
    "email":"alessia.lupino70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880321402/61001c7094f88c3a9c6f6feab410b112-1730303031"
  },
  {
    "email":"rossella.caso@unifg.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880386938/8910d8f823ae61233f6887386bea6b7f-1730303031"
  },
  {
    "email":"francesca.deangelis1987@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880452474/5a7a0c10912c8e696ae801be047d824a-1730303032"
  },
  {
    "email":"soniabecks@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880419706/0a4b7ee236450cba37590ae6bc13e32c-1730303032"
  },
  {
    "email":"robertapadula@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880485242/168f038b443633578b0d11e0e4666008-1730303032"
  },
  {
    "email":"alle09@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880518010/c32fb9877d3b641b31bc5b43762c739e-1730303032"
  },
  {
    "email":"martina.suzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880649082/b3c32a6d777954e3a8143bf5cbe70ae6-1730303032"
  },
  {
    "email":"artu.96@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880288634/5d49bdcdceb2f44a643118024498e38e-1730303032"
  },
  {
    "email":"irenenesi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880681850/e56d309fd5d090a6bbc6d661546ed4ed-1730303032"
  },
  {
    "email":"ilaria.stu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880780154/3dc57f459b03d0495fcf5e3e1495bccd-1730303033"
  },
  {
    "email":"zaccagnini.d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880747386/77a507c32ef65a3b3dc967116a1323e9-1730303033"
  },
  {
    "email":"bianchind@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880714618/829e44f8cae7773509a3f42975f2e327-1730303033"
  },
  {
    "email":"beanarsi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880583546/88b343119e1d190ac57c2513accfefd3-1730303033"
  },
  {
    "email":"eos_a@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880812922/5ef11ab900d9290646d2f20be78c6bfd-1730303033"
  },
  {
    "email":"superbab16@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880911226/d05978cbd05a6be434a03fdbd14c8e6a-1730303033"
  },
  {
    "email":"robertamonaci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880845690/5c112564165ed2230edb9e20ab0b5ba1-1730303033"
  },
  {
    "email":"c.addamo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880878458/3897ddb8d8456f0a8772b2f68048738d-1730303033"
  },
  {
    "email":"ele.bagatti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723880943994/d5d750b0322566d698790add58b08173-1730303033"
  },
  {
    "email":"anouschkavanrossem@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881107834/795e41035c3ea1f24d09b23aeb8e6c1f-1730303033"
  },
  {
    "email":"elisa_sez@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881140602/72cb0fa4fb5aaa2e54a281ed7594e5ca-1730303033"
  },
  {
    "email":"dalia.giubilei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881206138/aa9254a37bc764d348b130508ae6f444-1730303034"
  },
  {
    "email":"laurascavarda2563@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723880976762/589cf5059426a5b5c7aaa8022b2668ad-1730303034"
  },
  {
    "email":"info@ellemmeattrezzature.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881173370/146fad57816eacd4d411b81f21aefa91-1730303034"
  },
  {
    "email":"ila.fio68@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881075066/299cf619993591e80452942cbd664496-1730303034"
  },
  {
    "email":"la.molino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881369978/2b3712f211e41ba088d618c8b84936b7-1730303034"
  },
  {
    "email":"barbaradanese@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881304442/71a579dbfb74caf19c7f22791a2559b2-1730303034"
  },
  {
    "email":"vale83vp@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881271674/4c44931bd2c41965252ca92b3066c5cd-1730303034"
  },
  {
    "email":"elicorradi61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881337210/c99f4eb5444aa84021cc676412cded7b-1730303034"
  },
  {
    "email":"chiara.cecchini94@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881435514/e164a13c233692232421e8807a6dcd5b-1730303034"
  },
  {
    "email":"cate.paonessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881402746/deabe5facaa61286d7cb0302c73b3195-1730303035"
  },
  {
    "email":"sciorio.silvia75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881468282/72251accf080cdfd27d1d7bcd47803a5-1730303035"
  },
  {
    "email":"silviodelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881533818/3a9d262f0204a779cb536618e91c6478-1730303035"
  },
  {
    "email":"info@marioditommaso.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881599354/20a03c4d5fd22f9999827853885df05a-1730303035"
  },
  {
    "email":"chiarabarbaro86@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881632122/c9e4f301c3008ffbca466b7f78647cb3-1730303035"
  },
  {
    "email":"arditica@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881664890/ad8416fc47f2729ff50a2e0705ccd098-1730303035"
  },
  {
    "email":"rosabarby69@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723881697658/08089d8065dec71eb8f89b4a30593d11-1730303035"
  },
  {
    "email":"mariafabiani67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881763194/9296f6d0b0b559dedee2d5aec9049389-1730303035"
  },
  {
    "email":"angelicalovato5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881501050/0694f5a9d5fe854866852940986e95bf-1730303035"
  },
  {
    "email":"carla.panzeri71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881828730/48bf40d58418d36209777ba5db5f7c42-1730303036"
  },
  {
    "email":"drcama.valeria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881927034/1ecad51c287ac90d4dfd1dd3b9289497-1730303036"
  },
  {
    "email":"ritastasita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881894266/2bf5cc09a4a5c96eec559aa53d8e930c-1730303036"
  },
  {
    "email":"stefania.chierici86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881795962/750094696972339e7737e1953c504e42-1730303036"
  },
  {
    "email":"silviamazzi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723881959802/8ac26264fe45d1f3a903f507e6d4053f-1730303036"
  },
  {
    "email":"francescagaiarossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882090874/9ebacc75b44e28a0a391cd219a723609-1730303036"
  },
  {
    "email":"barbara_giannelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882025338/ae275b39e6d5f7f4075ff0ebef0a5ae9-1730303036"
  },
  {
    "email":"pozzi.benedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882123642/dbf0e9483f3da0614ceaf4c31453988f-1730303036"
  },
  {
    "email":"robertastellabrienza@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723881992570/bf896f769d476c8122468b8f4e03476a-1730303036"
  },
  {
    "email":"mimi.strappelli.59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882287482/f6a0ebab6f05b81b9d0dabbebb3022d0-1730303036"
  },
  {
    "email":"rossi.riccardo64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882320250/ff6fbecf763e8e5edf8c81f8370568e7-1730303036"
  },
  {
    "email":"ketty.malva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882353018/383c91b9f1018de1e58a8ee310f11c3a-1730303037"
  },
  {
    "email":"a.vent@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22723882385786/9517d9843f7796d57d4b746526eb80fe-1730303037"
  },
  {
    "email":"stegui.gd@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882451322/87d84db530f8b4ce92e313b3b91bc5ef-1730303037"
  },
  {
    "email":"ilacontessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882484090/445f74d32cd394d624e5fb4a6c3c8872-1730303037"
  },
  {
    "email":"monicamartuccelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882221946/599c22bbb25a9e5dd59648d4b5e986b9-1730303037"
  },
  {
    "email":"miriam.anzivino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882516858/c0b133d5be8b4b8094d41d1ceb7488f9-1730303037"
  },
  {
    "email":"chiurieleison@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882549626/dcdd094052f60c473e117500041795b3-1730303037"
  },
  {
    "email":"laura.chierchia@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882647930/84bf06aa55be0cddb9e9e6fd7b25f32c-1730303037"
  },
  {
    "email":"rb.fava@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882615162/ac0d3a33de3b61ec8e8140eb7bad9a36-1730303037"
  },
  {
    "email":"brownvale84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882680698/cd721d5a737c0b75a4650ddaced37b7f-1730303039"
  },
  {
    "email":"montorselli@studio-stati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882844538/39cbad8e65d3950ed140ccd6061e7478-1730303039"
  },
  {
    "email":"rita.pelloni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882713466/3bfbe47d828b394302efd11c5707b821-1730303039"
  },
  {
    "email":"amceccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882746234/599d6b5895c8e6ceb10af6c640e82eec-1730303039"
  },
  {
    "email":"p.magnifico@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723882910074/7e0c645e3fd21e8e252ece43003f13d3-1730303039"
  },
  {
    "email":"simonavotta72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882942842/ff47a8fe6aefb158319f244c27bb4088-1730303039"
  },
  {
    "email":"skalameramarina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882877306/affa3361215f11a3f704c03da6090f43-1730303039"
  },
  {
    "email":"mariateresa.varani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883041146/ba6fbd2ebc28cba3aa98d9ed8ed48bff-1730303039"
  },
  {
    "email":"lippo1984@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883008378/882b90de04320cf614c0db8746630e6a-1730303039"
  },
  {
    "email":"alessandra.sciarretta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883073914/2dcb8db053a2571574f827945efda437-1730303040"
  },
  {
    "email":"cri.perchinenna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883106682/17e981f8fa1061063d1ede589b40aa38-1730303040"
  },
  {
    "email":"tienisarafood@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723882975610/43a64fa570ef7a86b2277260d2b03e15-1730303040"
  },
  {
    "email":"simoni.serena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883139450/af379967f85d901696e0888c9afbcd34-1730303040"
  },
  {
    "email":"paolacaldana75@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883172218/4af67a9c6556df92ccf10dc066e0d7cf-1730303040"
  },
  {
    "email":"margherita.deminicis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883237754/bfd9a26e9f4c707b9f6276deb497ba70-1730303040"
  },
  {
    "email":"mariarosa.tonutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883336058/f377b2af71ac5fa85a9d579f38aad01d-1730303040"
  },
  {
    "email":"info@angelicaariano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883270522/302ad3f7b08b4a83a33eefede9b2396a-1730303040"
  },
  {
    "email":"giuliatan91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883368826/8a079d4206b1fa09e98a99fd35645179-1730303040"
  },
  {
    "email":"taniabacchini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883401594/2e1ffff40e8b5e7b3ed367ecb6326750-1730303040"
  },
  {
    "email":"marcobarban74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883499898/a3f655d74f30a7d4c22183eaf3e9338c-1730303040"
  },
  {
    "email":"elisabrichetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883532666/4abce613191239704e0b4080f1248e0e-1730303041"
  },
  {
    "email":"alessandra.dionisi28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883565434/cefeab197c84b5f23052335cb20759c4-1730303041"
  },
  {
    "email":"avv.delcarlo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883598202/329852a35df270cb1d038c5ae80e9c9a-1730303041"
  },
  {
    "email":"cristofori.vit@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883630970/49fdbb2954488e73c6978f98b2effbc0-1730303041"
  },
  {
    "email":"rosannasgroi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883467130/14e79673a3e79b3d32cff52025b8cec4-1730303041"
  },
  {
    "email":"mattolinimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883696506/e9c7c8a59783aba83545473bff556dfe-1730303041"
  },
  {
    "email":"daniela68@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883729274/b2b2c86af9a45029430e564624ccf76b-1730303041"
  },
  {
    "email":"elisa.volpe@rinascente.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883762042/d6f0c77a8e6b34c45bc7b6babb184984-1730303041"
  },
  {
    "email":"denver.dv@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883794810/98d7c20e499424c0ddf0e3f159aee3b1-1730303041"
  },
  {
    "email":"contarinovalentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883925882/7e551a690fc29004d0f4dd9ab5d33c40-1730303041"
  },
  {
    "email":"mariapierariccardi53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723883958650/bafed4f9851f8ad610bfda3f9a018e28-1730303042"
  },
  {
    "email":"berno68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884024186/46059719d21841ef072f7e7ff7455b96-1730303042"
  },
  {
    "email":"carlafranza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723884089722/f04c9fe68b292c7f9a84c193e9e50d71-1730303042"
  },
  {
    "email":"mg.ls@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723883827578/cfd479630e299a92683e15fbac8e4b59-1730303042"
  },
  {
    "email":"anna.pelizzari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723884122490/4d046a4c0d384317a1ef11b2bd556ee3-1730303042"
  },
  {
    "email":"francescagenua@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884220794/380c4d6db0a9e4b316aba42ee2bdc8db-1730303042"
  },
  {
    "email":"lucyfly.mosca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884155258/f78a810c433c876f649a7c500ec6e1ad-1730303042"
  },
  {
    "email":"marika.fidone01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884188026/a8a951150beef332b05f38af87a3f6d7-1730303042"
  },
  {
    "email":"cinziacavalieri65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884351866/55cfa4635c41a943aee3f1a7d0aead6b-1730303042"
  },
  {
    "email":"p.carlini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884384634/b2250f687bafe6b68bfda3717f15157e-1730303042"
  },
  {
    "email":"cristina.scarpato@aermec.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884450170/b930e5a842a483af65263776a0d787e6-1730303043"
  },
  {
    "email":"lorenzasartini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884515706/0e87225dd9499c8a42d9ed32f51ad429-1730303043"
  },
  {
    "email":"sandrabefaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884417402/c05b6c7d9a202f690d14118fa4e78589-1730303043"
  },
  {
    "email":"michianelli96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884548474/d2d8c54482022ba4ce0dcafbce3aa86c-1730303043"
  },
  {
    "email":"michy_rainato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723884482938/19b98a40685fe5a02078d7d0079152cb-1730303043"
  },
  {
    "email":"acanessa@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884614010/3cb0e99bb09e80b73687e16c9e4bdbea-1730303043"
  },
  {
    "email":"polareske@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884581242/cd100fe092fe10811401d6af34edfa51-1730303043"
  },
  {
    "email":"kricca1969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884679546/b427fb7eecfe49deee6fa5dd35380b6b-1730303043"
  },
  {
    "email":"pucci.claudia74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884745082/00d262e2b314a7c5640a750d242ecd2b-1730303043"
  },
  {
    "email":"ornelladt@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723884810618/c9cce6ac4329e5a32be46b97d3f95f1c-1730303044"
  },
  {
    "email":"ylenia.ticconi90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884843386/6d0cdfa3042bc025077c70184953ff33-1730303044"
  },
  {
    "email":"baroncini.giada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884908922/554b9bc2ccfc463297fd9bb262dd9d4f-1730303044"
  },
  {
    "email":"elena.remigi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884712314/cc6b79823c13f03a756ef8ef7dcdee45-1730303044"
  },
  {
    "email":"robpirelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884941690/332045dca3cff163942f0be4553112bc-1730303044"
  },
  {
    "email":"norma.gritti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723884974458/915de68a20e6e1dad6fbc5d5e49914ce-1730303044"
  },
  {
    "email":"soniaritano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885007226/96dc5e73aca19df1a971cc00113ecc79-1730303044"
  },
  {
    "email":"vaniamalacarne@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885039994/7b364b4f8d3219bfe273248ed98d78c3-1730303044"
  },
  {
    "email":"giuliademarchi.216@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885105530/cb7df3fb2830b14302f58e342c0e1e87-1730303044"
  },
  {
    "email":"paola.vigano1@studenti.unibg.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885171066/1ab289258441ec952694e8cea469cfe3-1730303044"
  },
  {
    "email":"mendolia.giuseppa@legalmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885236602/bfc56ee361b5124352652155ad901b9b-1730303045"
  },
  {
    "email":"simona.gurrieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885269370/6caff19e44f9d6dd9142f42439c57e4c-1730303045"
  },
  {
    "email":"ciottokatia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885302138/89963dec7f36513a3fa1e482451556b0-1730303045"
  },
  {
    "email":"martacirilli1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885334906/b1181006c8f8d73132008b3e553b41e5-1730303045"
  },
  {
    "email":"ila.faroldi@gruppoinfor.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885367674/48b7ff6c06e3656078242b6802714b73-1730303045"
  },
  {
    "email":"samanthacasaluci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885400442/48d49505e4ce9d6e4e93164f0098f241-1730303045"
  },
  {
    "email":"diana.cecere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885433210/4b981b1a25bceef6b23aa52481c3ef17-1730303045"
  },
  {
    "email":"fumcris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885465978/3853df8d33282361bc5d47858c855b9d-1730303045"
  },
  {
    "email":"silviasantosuosso@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885498746/14577f88bafbe4a36595b6ed35c36b30-1730303045"
  },
  {
    "email":"giusi58@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885138298/1cdc1b5deff920b6bd12f22f83820f51-1730303045"
  },
  {
    "email":"laura.walter.site@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885564282/3ce888320cf848a9e502742e8a785285-1730303045"
  },
  {
    "email":"rocchib74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885597050/c32f0d19afc650a5f45e8c2a6ba59b57-1730303046"
  },
  {
    "email":"katiuscia.celli1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885629818/9bf8bc79087298f0904fa9636fa82a0b-1730303046"
  },
  {
    "email":"sabrina.tombolan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885695354/43fe64e60d24eb3a7132949f52b2a28e-1730303046"
  },
  {
    "email":"stefymora76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885531514/4b4e85f3713069796dc8939c4d21419e-1730303046"
  },
  {
    "email":"graziabalestrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885662586/e64f7f60018fa5918436f805e384b394-1730303046"
  },
  {
    "email":"dagmara.markiewicz1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885793658/9fb0e6a1f5ca440ae47349bcfe891dab-1730303046"
  },
  {
    "email":"elisabettaromano@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723885760890/ee30b374ed3a2037c5b519d5ebac4e66-1730303046"
  },
  {
    "email":"martinopaolina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885728122/db5a1609cf5095dee0d49c70cd8cb8e6-1730303046"
  },
  {
    "email":"barbara.azuni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723885957498/aee052b824f894e06654e84205d8b63b-1730303047"
  },
  {
    "email":"pbalasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886121338/2011f11f6065855e983260b198e49c3c-1730303047"
  },
  {
    "email":"granchi.silvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886154106/4ab2d8f90a711bbd7fc9f6d470558e8c-1730303047"
  },
  {
    "email":"lauraferrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886023034/78dbd40dbb2dce5ba4117ea392cb7de4-1730303047"
  },
  {
    "email":"paola.leoni.roma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886252410/c7a1306c6e9d733946bebc44e9cfafe4-1730303047"
  },
  {
    "email":"michela.andina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886285178/c8c1481bc4e93488c84e09c62fea945b-1730303047"
  },
  {
    "email":"menrob29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886088570/d4b2df16c0ab222d3a670fcb1df9fe59-1730303047"
  },
  {
    "email":"rossignolifede@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886186874/a9192c22def4fba3eb3aff4c2ebb7349-1730303048"
  },
  {
    "email":"l.montironi70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886317946/f75a721a57507b49929f824f0b9792a7-1730303048"
  },
  {
    "email":"eluccioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886383482/d0130337cedfb80d6a03daa13cadaf17-1730303048"
  },
  {
    "email":"dabergamotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886449018/238e0737156fe85ef83a8afad949c085-1730303048"
  },
  {
    "email":"lia.padolecchia62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886416250/da1197aaf3cde650cb79f9916ab7a1d4-1730303048"
  },
  {
    "email":"selenab7229@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886481786/3b98aa375f0d8f743e8d3fb23983982c-1730303048"
  },
  {
    "email":"sarafranceschi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723886514554/2b2e2e2c12934a331d0f6703f5d584e0-1730303048"
  },
  {
    "email":"scorpione.15@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723886580090/b5aae7fb7fe9d86b39f5f21f1925e438-1730303048"
  },
  {
    "email":"rosanna.tremonte72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886612858/d99ecd6b407063134e4d6023c1451c77-1730303048"
  },
  {
    "email":"danielapagliara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723886350714/9b065e7918c1993c8b021552066c8e0c-1730303048"
  },
  {
    "email":"sara.montagnese@unipd.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723886743930/c59f6d51ad4455435c8c1a03021927cc-1730303048"
  },
  {
    "email":"gasselinrengin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886678394/c0527a8934ea4a8b087a01c3d576ce46-1730303049"
  },
  {
    "email":"martina85mattia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886809466/00542d7d60d74e0550f2476b5c613299-1730303049"
  },
  {
    "email":"lucia.fiorini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886776698/345aa703703b8b3e4c69238b118b7c98-1730303049"
  },
  {
    "email":"michela.paoli@studiolegalegaleazzi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886907770/ba5b58b80f9112f36f83e1ae38362bac-1730303049"
  },
  {
    "email":"chiarafilippi63.cf@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886842234/05720fb7b1361dc32c7386f6b71f1e41-1730303049"
  },
  {
    "email":"paola.bosatelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886973306/97a4ba6c9a82ad9e46fbef0210f70f42-1730303049"
  },
  {
    "email":"barbarapremuda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723886940538/63e3aa0361b9779b56772becc38dd0df-1730303049"
  },
  {
    "email":"eva.lecciso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887038842/d65b1ef25ebf8ddeb225477f5c0c9ee9-1730303049"
  },
  {
    "email":"mariaantonietta_zocchi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887071610/cc9d72969b7fd2a2147399a736778c64-1730303050"
  },
  {
    "email":"fabianamorganti77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887137146/14c7c00fc9dcf8017194a2f6c5691c0e-1730303050"
  },
  {
    "email":"mariaantoniettamarra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887104378/af51843e862bf23576103863a90e7b0f-1730303050"
  },
  {
    "email":"stamperiapozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887169914/6d6e11026da9d082f05f83ede235b1c9-1730303050"
  },
  {
    "email":"lafebbra_bl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887268218/7f101d34f39763219710dc5a4eb63a4e-1730303050"
  },
  {
    "email":"antonellatreviglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887300986/78692730551f5e96ec4feb554f31fa8d-1730303050"
  },
  {
    "email":"marianna.tango10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887333754/bf2aa4a98dc24534f581521d058ab996-1730303050"
  },
  {
    "email":"rosaornotrosa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887366522/f7dbe910afe170c5ef1da732b423b467-1730303050"
  },
  {
    "email":"pamela.pezzotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887399290/ea58ac09fb7af10551a7a86f9e7c8594-1730303050"
  },
  {
    "email":"carmenvarchetta@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887464826/457b8710fa7f022ca381bbc02b770ee8-1730303050"
  },
  {
    "email":"ely.belli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887497594/641d5fe81693a4581b792062e0c1af18-1730303051"
  },
  {
    "email":"pinadigiuseppe74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887432058/d6d1049fe4ff6e86ffa0f1a8a4286964-1730303051"
  },
  {
    "email":"gulibensa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887530362/d5f75a31fa61ab0eb9d59d06bc0e9294-1730303051"
  },
  {
    "email":"fabio@montimac.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887628666/2d86bde1e48ce540d909f336e37743ca-1730303051"
  },
  {
    "email":"gianlucarui@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887694202/7c40b885e48b83837d63b8d5a6d61e5f-1730303051"
  },
  {
    "email":"ce81@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887759738/0c82bafb0d88fe534ae25b3524fa859b-1730303051"
  },
  {
    "email":"jennysci74@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887563130/6bada9595467c8adff29d0072c105e5e-1730303051"
  },
  {
    "email":"federicaciampani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723887858042/b1c2fc334716b3610a40ad1b99b7d7b0-1730303053"
  },
  {
    "email":"monica.mastroianni@live.i",
    "url di attivazione":"https://verdissima.it/account/activate/22723887890810/d1c0e8042d9687bcc59f365289c0a31d-1730303053"
  },
  {
    "email":"moniatosato77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887726970/c27c36a56042b5755f9a9323776fba6f-1730303053"
  },
  {
    "email":"oxana.iozzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887792506/0c3e5f88c46d4704f8c00c82861b9869-1730303053"
  },
  {
    "email":"fransy75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887923578/438178552338d4e040d00894801d760b-1730303053"
  },
  {
    "email":"valebertu83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887989114/e98cde0c45fb67d676d55e6c55cfe9fa-1730303053"
  },
  {
    "email":"ale.mastrofrancesco@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888021882/a923b1793d29ba745e614e633e5e8559-1730303053"
  },
  {
    "email":"avvlauracaminiti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723887956346/24dec2407ba2abceeef59f5ce8a3ea68-1730303054"
  },
  {
    "email":"marialn.boselli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888054650/5f0e7b28abfb3587132f4374ea1eb328-1730303054"
  },
  {
    "email":"g.pacelli@univpm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888120186/3a4b90ad8d15a40f55fe3eb5f1aab8c3-1730303054"
  },
  {
    "email":"cogema.mn@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888152954/80a4b86fd2eae28b1b3440a39db1ceb3-1730303054"
  },
  {
    "email":"carlavignoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888316794/369d3ee54c6fbb695d833068b15684d8-1730303054"
  },
  {
    "email":"giada.benazzi@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888087418/91304ffbb30811b8cd00c4a85bda3236-1730303054"
  },
  {
    "email":"cappelli.vale78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888218490/3ff1181cce4bd3333a69e4f7873e45f5-1730303054"
  },
  {
    "email":"silbarma@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888349562/4f89a40b2e9d9460c111c481426dd02f-1730303054"
  },
  {
    "email":"tittimimma65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888382330/8febd7b3d864c78fcbc75f6c1edbf479-1730303054"
  },
  {
    "email":"paolagalli77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888447866/2167939c81689702f415c83707440a88-1730303054"
  },
  {
    "email":"botteroantonietta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888415098/1032f777ed8b5c33d1a253b22c112f10-1730303054"
  },
  {
    "email":"roberta.floro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888480634/2f392ea7fbe6151ed375d8e1b4844393-1730303055"
  },
  {
    "email":"numeronovelatina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888546170/cb3db95c331f4e114a21c80fe8edcb4e-1730303055"
  },
  {
    "email":"valeriammirato@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888513402/73d36d7d8497acc11f748bca49878f06-1730303055"
  },
  {
    "email":"longhi.elena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888644474/61f474fb3c984449f5192fcd5a5815b4-1730303055"
  },
  {
    "email":"marinalaurabi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888677242/0fdebe09aea9586821d626d879ee956b-1730303055"
  },
  {
    "email":"elena.cossu.ec@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888906618/d4c9e9703745d8ca3bd39eacbd97286d-1730303055"
  },
  {
    "email":"b_schinwald@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888873850/a6bada81cf5b8a1070330331c0d1b5e4-1730303055"
  },
  {
    "email":"rafbart68@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888710010/e1fbccadcc0618ce1b59542b6e32c87a-1730303055"
  },
  {
    "email":"elisabettamartini90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723888939386/ac7b876bf72c681995e5533b8a38d144-1730303055"
  },
  {
    "email":"stefaniagargano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889037690/9710aa80e769db8802495c45ab782627-1730303055"
  },
  {
    "email":"roberta.tomassini1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889070458/795b5e89b7f900a30802d69c3fd941a0-1730303055"
  },
  {
    "email":"gugu63a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889103226/acaeb55fb24c125a7ee03794910e69f6-1730303056"
  },
  {
    "email":"roberta.r3@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723888972154/1a43d494b51d0def420c6997accaa211-1730303056"
  },
  {
    "email":"maioranav@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889135994/1cb1aa9df01a9152800ddb91aaaaa53d-1730303056"
  },
  {
    "email":"mary.bigg@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889004922/46b483f0c33401b00e391126ba243331-1730303056"
  },
  {
    "email":"mariannapaciullo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889168762/803f9460f69db907fa11249c2e1287ae-1730303056"
  },
  {
    "email":"lestermilano@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889201530/3704cf17e45c696ab7da098dd7169ee7-1730303056"
  },
  {
    "email":"daba2502@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889234298/137664e7f3e32828d6585d954d000c0d-1730303056"
  },
  {
    "email":"giulia.maccarini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889332602/6b23e2a2d4daecc8e62bd4ca826722cd-1730303056"
  },
  {
    "email":"sabrina23868@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889365370/5e62f67acea8370d0313e73c549fb07f-1730303056"
  },
  {
    "email":"cristy.viola@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889299834/91b4e38a9d7c363fd80e825a8dbbcbe3-1730303057"
  },
  {
    "email":"shaneweb@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889398138/ce031f6edb6fa239ae33cd5247373fe3-1730303057"
  },
  {
    "email":"marzolla.paola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889430906/a4a12617bb70711e846d0082a12a755e-1730303057"
  },
  {
    "email":"ilenia.marinello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889267066/4df6ecdcb8297a7fdc4b358ee9eade14-1730303057"
  },
  {
    "email":"marghe.corciulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889463674/6a0cafff7b053016b12c8b93ce6edede-1730303057"
  },
  {
    "email":"paolaceli87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889561978/47f33e99527f26d80a5d66b2d63ea469-1730303057"
  },
  {
    "email":"katyabubu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889529210/2cfdb30523d7d1430a562b4f8d91f81a-1730303057"
  },
  {
    "email":"elena.colopardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889693050/2f1c62611563573334e7c27530b92096-1730303057"
  },
  {
    "email":"rominabartolini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889791354/fa3c51553e9f16754e18ffdf9fdaa438-1730303057"
  },
  {
    "email":"orianaclaudiarusso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889660282/830b9c7f380c6491193a0c1960019cc9-1730303057"
  },
  {
    "email":"alessandra_esposito74@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889758586/c785704facf57b105cddb2997fb26e46-1730303058"
  },
  {
    "email":"bonottoele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889856890/638aec2f1f8a602aa0a71240274ce897-1730303058"
  },
  {
    "email":"b.gianelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889824122/6d6a173479c1d4819b7ef308f2c734c1-1730303058"
  },
  {
    "email":"silviaromeosir@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889987962/1d1fb6205b1067a8c8494700bbb71da7-1730303058"
  },
  {
    "email":"marziafioretti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723889955194/cc0ab4789fccb4dd3749de88d12d9355-1730303058"
  },
  {
    "email":"francoascla607@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723889889658/1de2fffcfd651492b95fab59dec4a508-1730303058"
  },
  {
    "email":"giorgiadicati77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890053498/dbd5d0696e09fecec76c38f805b1ec71-1730303058"
  },
  {
    "email":"donatella.gattazzo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890119034/40c25a638124b6188fe102947f352461-1730303058"
  },
  {
    "email":"paolaaldighieri75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890086266/425fad66f9adbef90660eade375b27e6-1730303058"
  },
  {
    "email":"cristina.mazza@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890151802/5eba7beff23b550488605848588ba8ab-1730303059"
  },
  {
    "email":"paolarocco2312@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890184570/515f61c2dbcc9fd46896f3f87c420c2e-1730303059"
  },
  {
    "email":"frescariella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890282874/c486fcf5299a50dc4f5d00bd0efef254-1730303059"
  },
  {
    "email":"larabaccetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890315642/2949d82b777f12629c8cd0b675a6b566-1730303059"
  },
  {
    "email":"romeo74.rr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890348410/61134764a27003c1221e6beac14b9419-1730303059"
  },
  {
    "email":"simona.andreoli70@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890512250/80ad08e5dc921a8250acb8211eeacca9-1730303059"
  },
  {
    "email":"info@searefrigerazione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890479482/7a4e6e6680c0810911822d4ca8205e74-1730303059"
  },
  {
    "email":"silvia.pinalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890446714/c2734ba7c624f1eee17040ef4522d97e-1730303059"
  },
  {
    "email":"donata.basso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890643322/8b91f31eb1ec621f1ace3e61acbbd488-1730303059"
  },
  {
    "email":"elisafabbri28@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890577786/56e02d81a097c5c29406ba83f06ad3f6-1730303059"
  },
  {
    "email":"robertademarco1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890676090/302b8c7a2f58b05b4f0dc5a21d6331b8-1730303059"
  },
  {
    "email":"liana.baratto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890610554/48fe01466d4b41944f4f63875aab079e-1730303060"
  },
  {
    "email":"francescagoia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890741626/e82351d841703e1f89bf6bb71aa813c2-1730303060"
  },
  {
    "email":"smormorina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890545018/39dc5584a0283392335e2e14c384961b-1730303060"
  },
  {
    "email":"margheritascognamiglio11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890872698/8f954e0970fe97888d86afeb10a87235-1730303060"
  },
  {
    "email":"chiara.steiner@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890807162/7850fc8d68111b5a2f0f26da517c0787-1730303060"
  },
  {
    "email":"sabry.girl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890905466/673b5e1097040574eb613e74f5a5be50-1730303060"
  },
  {
    "email":"federicamima@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890839930/26a0c15501cce26971aa60cce922b425-1730303060"
  },
  {
    "email":"dm.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891036538/c23a03463354bd834e87208ef1abd311-1730303061"
  },
  {
    "email":"anna.calvo84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891003770/c33f67883d9034bb6d124bb22e2ad213-1730303061"
  },
  {
    "email":"cocciasara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723890774394/ec2058298fdeafc19a7e90c4c4512c6d-1730303061"
  },
  {
    "email":"margherita.cheinasso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723890971002/b9e4e32479d150846991187b5d7a7160-1730303061"
  },
  {
    "email":"michelacampana@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891134842/85ae90143681b8914c38ad65bad9dbce-1730303061"
  },
  {
    "email":"bertolonena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891102074/a3ee0c654a59cbcb1651b598ffbd1b97-1730303061"
  },
  {
    "email":"fragni.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891200378/686732fb683623b83d691915e187acea-1730303061"
  },
  {
    "email":"stefybotta70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891167610/2d6a908794fa48834f219f4092f9c275-1730303061"
  },
  {
    "email":"giuliafalconi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891331450/cac455b53977463e8b9a1101bab6ab1c-1730303061"
  },
  {
    "email":"gaenia23@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891364218/97c9050646b77b38820f00a5d7c76a51-1730303061"
  },
  {
    "email":"annag1970@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891429754/406d4ec7c60ca2e71833e8e8b8e60c2d-1730303061"
  },
  {
    "email":"danielacatino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891396986/2bf3cf90508e7112fdc7f794d5d58947-1730303061"
  },
  {
    "email":"scacciari13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891462522/e4b00281d07977fd211d518b2569d280-1730303061"
  },
  {
    "email":"emanuelasbaraini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891495290/266c4a33485ac77738f73043436dadfc-1730303062"
  },
  {
    "email":"mary.francis@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891560826/e500cbba6e24a0d661d25cbb9ac307f6-1730303062"
  },
  {
    "email":"samy73s@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891593594/03369700423b13f868caa7c87bc3ec16-1730303062"
  },
  {
    "email":"defalcoantonella8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891626362/2f5fe15e4197d5aa9cae3410854f0a2a-1730303062"
  },
  {
    "email":"vale0410@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891659130/2a1171b9003bbe1bb84f328706052423-1730303062"
  },
  {
    "email":"lapupa77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891724666/d49854cd880b074edfc87ee398962ca6-1730303062"
  },
  {
    "email":"rercole286@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891691898/6c2b83ff451b0eb0bc8610499f638e0a-1730303062"
  },
  {
    "email":"s.calabrese@calabreseautogru.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891757434/2edec170708dc257f44585f56cb8aa0c-1730303062"
  },
  {
    "email":"bettychic@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891855738/436eb3d4c3b50f172dfc0d7ef5fa844a-1730303062"
  },
  {
    "email":"bonci.alessia88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891888506/16896c404c4c8a69574e04b9e7471c83-1730303062"
  },
  {
    "email":"lu.lis@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891822970/6866fbb7dd4b91e09c9e71ca05029703-1730303062"
  },
  {
    "email":"elisa.manfredi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891986810/ba224883fbfa3badb83e36b46dfc7c13-1730303063"
  },
  {
    "email":"muccianakim@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723891921274/5c803ac50058bd0ea44781a24802df71-1730303063"
  },
  {
    "email":"valentinabeauty@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723891954042/4203fb6cd6fa6083bdc8d18ef65cb8b1-1730303063"
  },
  {
    "email":"electrabelluzzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892019578/b5fddf14a6db06ca62459e84110caac8-1730303063"
  },
  {
    "email":"morofk@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892183418/cbfefb6c0aaf630493d549b44747c220-1730303063"
  },
  {
    "email":"anna.zangheri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892085114/cd0156a80a3f69459024e2159742c1c6-1730303063"
  },
  {
    "email":"claudia.ghinolfi@iccastelnovomonti.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892117882/65089842e10da16fec477299169f2cce-1730303063"
  },
  {
    "email":"simo.reggio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892347258/be82807f3c6361a6d98e5f5697243da2-1730303063"
  },
  {
    "email":"pellegrinosilvana2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892314490/f70302de3f11e79b7d44d1a4864bff7f-1730303063"
  },
  {
    "email":"michelapellegrini73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892248954/c273549cde126019990d824b1a50450e-1730303063"
  },
  {
    "email":"oriettabrunetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892281722/b8fb8b4ce208db077b2d88aa89c611d9-1730303063"
  },
  {
    "email":"annabellav@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892380026/e9c5c85c46f35f1589db61c4cfd21500-1730303064"
  },
  {
    "email":"ceciliamastelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892445562/cd639aec5aa17aa3e3dab5d0b6bfcbae-1730303064"
  },
  {
    "email":"enrica.gentile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892412794/3a122662bad32aeaeffb6ff4658870da-1730303064"
  },
  {
    "email":"serena.bellante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892478330/aa0a967a07f8adc3381e9caf32488396-1730303064"
  },
  {
    "email":"mirna.derigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892576634/a1162931806f364f60bcda8d75d75f1b-1730303064"
  },
  {
    "email":"pieropaolini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892543866/deddc147439209c0323f94fb7bd2afff-1730303064"
  },
  {
    "email":"patriziabellani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892609402/7c0e2965635f4bc9e5ed8056da04c3c5-1730303064"
  },
  {
    "email":"silvia.fragola@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892707706/8964400f09a02cfbbbf9ab54a2ba84ea-1730303064"
  },
  {
    "email":"ravagnan.isabelle@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892740474/dcc9822bc21903ba06114e508b5fdf10-1730303064"
  },
  {
    "email":"marina.braida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892674938/09a24ceda454bc5a597509107075d02a-1730303064"
  },
  {
    "email":"avv.soniavulcano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892511098/13a25fbc4805beb5533623be6c9ddbb4-1730303064"
  },
  {
    "email":"michelenitti67@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892773242/14f019ce260658637c802c132c9c1e28-1730303065"
  },
  {
    "email":"citroteresa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892838778/ab60ff43ec8a60779c363ef7f56715b8-1730303067"
  },
  {
    "email":"g.goglino1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892904314/3861c70e56940c12438acc298dda1a11-1730303067"
  },
  {
    "email":"bergamini649@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892806010/42d4f9a9ef7781ed58963f98aa2eac77-1730303067"
  },
  {
    "email":"matbru1976@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723892937082/453476b25b469c7a478e1d7662391c75-1730303068"
  },
  {
    "email":"elena.volpi2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892969850/4415593a5f0d64f91df59ca7dae73ba5-1730303068"
  },
  {
    "email":"lorellamarin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893002618/4bffd1bbee2d0eb972db0d4252e6533e-1730303068"
  },
  {
    "email":"federica.canni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723892871546/b9ec9852f648e0ff41db2e8a997377aa-1730303068"
  },
  {
    "email":"ottini@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893100922/706e393a7e2a731a850d888d1e5d5296-1730303068"
  },
  {
    "email":"lavinia.vallillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893068154/d1575ea2ae3b241dd7d55ed3e6a93af1-1730303068"
  },
  {
    "email":"pinubonaccorso@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723893035386/8a10b2ca6ce224f71c4c264fb1f35ef6-1730303068"
  },
  {
    "email":"sabrina.leonardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893199226/5785d2279cae64997809d4dae6dc22d0-1730303069"
  },
  {
    "email":"giu.volpone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893166458/ee9b2c453ac7222cc21c9bbdd524d1bc-1730303069"
  },
  {
    "email":"sarabicocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893231994/67ff049aec04e1198a055be15b4e01ac-1730303069"
  },
  {
    "email":"raffaella.pelosini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893133690/637b76d3d959cc968912ce452ef74020-1730303069"
  },
  {
    "email":"alessiam2021@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893264762/3fd650a2529a4ca840ad3e29913c6d90-1730303069"
  },
  {
    "email":"laramalnati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893297530/028ddfe30e0d21904a2fbc2e001ea39c-1730303069"
  },
  {
    "email":"mottertiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893363066/204f3f35b3882a10f195eb931a6a526a-1730303069"
  },
  {
    "email":"chiaramarani5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893428602/462dda93a94d2e47736b254a0fc5ba83-1730303069"
  },
  {
    "email":"bgorrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893461370/e95176df3b1b932bbadce16e5f5fff95-1730303069"
  },
  {
    "email":"adelediflumeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893494138/e025649e064311f0bf1242268f042e29-1730303069"
  },
  {
    "email":"federica@selenis.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893559674/20a7edb42353e0147a6acf1ad4ab4995-1730303069"
  },
  {
    "email":"chiaracucinelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893526906/8c9ce49051258eee42d88dfbcd8e94df-1730303069"
  },
  {
    "email":"chiara@charleston.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893657978/7e10864b0301f24948767e19d6873d8c-1730303069"
  },
  {
    "email":"pamela.andreoli@er.cgil.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723893723514/79f1b32b0d5a8e470057a42d1f9aafc0-1730303070"
  },
  {
    "email":"pinadelorenzo71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893821818/b28b2eb02b4e975f7ae94da33845efcf-1730303070"
  },
  {
    "email":"colombofrancesca1991@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723893887354/f9180f3f54bcbd2116dd00339168e0b1-1730303070"
  },
  {
    "email":"bernardi.flavia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894182266/6924f8202883fd2c4c6400a3c53a8eaf-1730303070"
  },
  {
    "email":"enrica.campatelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894280570/ce5ee99a8c367941a6cc530db0e05a2c-1730303070"
  },
  {
    "email":"emadesani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894215034/e95dea058fee53060f44dfa7dcc45bb2-1730303070"
  },
  {
    "email":"lucislenoci@gmoal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894313338/eca64d6e59dff3a5736da549876d2a1a-1730303070"
  },
  {
    "email":"filly_daniele@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894411642/1fd111fbcb23d13bc6c6c03664e80497-1730303070"
  },
  {
    "email":"silviapias1@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894378874/d60aba100198470281e0ecc44a67f2a0-1730303070"
  },
  {
    "email":"terrymary83@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894346106/ddb1480cf729a786374d646a41184feb-1730303070"
  },
  {
    "email":"alessandra.quattrociocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894444410/96827d5b871e2b11004d5e3f46c32eb9-1730303070"
  },
  {
    "email":"russoantoniio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894542714/81b4338630dae5518f0a326f5bb5001f-1730303070"
  },
  {
    "email":"caterinapaoletti1968@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894477178/cb1cd0df9934813374c9fb76fc657352-1730303071"
  },
  {
    "email":"saramore1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894509946/cb190071631db0a8625d57c72751d918-1730303071"
  },
  {
    "email":"nocenti.maruska@hotmail.ir",
    "url di attivazione":"https://verdissima.it/account/activate/22723894575482/aff7cec7a975533394bf691195b3c2ad-1730303071"
  },
  {
    "email":"c.rabini750812@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894673786/b081ce98fcd8b3a35769bfa687d66253-1730303071"
  },
  {
    "email":"elena@carweb.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894608250/7f72c88c7f323b62b8971ca08d27a8c5-1730303071"
  },
  {
    "email":"stoccco.stefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894772090/a69d1f400cc9c7cb32ee77be1405a44d-1730303071"
  },
  {
    "email":"manuel.oliosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894641018/61ae76e64b5de6e2cf73cb455ba8328c-1730303071"
  },
  {
    "email":"silviacavaletti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894706554/df3a774c7ce496f9362f4e263cadb4eb-1730303071"
  },
  {
    "email":"eliana.perosino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894739322/506ed1abeda976f2a2e0a545a3cf0d79-1730303072"
  },
  {
    "email":"ghettytrimarchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723894837626/4e71f8311704cd93926ae3ae394c3f62-1730303072"
  },
  {
    "email":"chantygirl81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894870394/be7ab3e547cd2a424b24bcf3542cc3c4-1730303072"
  },
  {
    "email":"angela.tarozzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723895034234/ba214175d2929a9a1074eb0cbba4bef9-1730303072"
  },
  {
    "email":"elenacelsan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894968698/d926c2ea047ce5f3b9177447635d2836-1730303072"
  },
  {
    "email":"santilavinia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723894804858/579d14c79f7cbfbbef43edb0fd1db67b-1730303072"
  },
  {
    "email":"avv.tamara.lessio@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723895198074/3a6bdbf4ec33ae8a8f11455efd3f76af-1730303072"
  },
  {
    "email":"benedettaridi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895165306/6b166877818d90aeebf74ffc5f61e48b-1730303072"
  },
  {
    "email":"rossella.melano24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895001466/03cce512ad592a0bf0616488ec3fc615-1730303072"
  },
  {
    "email":"marat211110@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895296378/42b3eac3dbc8f1d19fa22892a43a366f-1730303073"
  },
  {
    "email":"mariapiacassano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723895230842/1f091b53047d83d06cfa7ca3f1cb369b-1730303073"
  },
  {
    "email":"fraserraino@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895329146/a897124cd55b05ef1b0791d591230564-1730303073"
  },
  {
    "email":"fvannia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895394682/9cd6a45fcdfdd3e60fb5f3f074367e4a-1730303073"
  },
  {
    "email":"mardaniele7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895460218/c5d5f33134dddb2acf997c52db9e4e3c-1730303073"
  },
  {
    "email":"gabrielaoldrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895558522/12bc4da72cb4bf2ccb36951cb4afbefd-1730303073"
  },
  {
    "email":"roberta.santini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895427450/bfe26beeef0278675ec4c655edefcccb-1730303073"
  },
  {
    "email":"eforesti9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895361914/0818cebb77205607cd3f0380a2d15886-1730303073"
  },
  {
    "email":"ullodaniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895492986/d25acafe035bd6aa3c0136722bf88401-1730303073"
  },
  {
    "email":"sisab@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723895591290/a92fe432e41e7e311bfd8121686fdd5e-1730303074"
  },
  {
    "email":"katiusciavaccarini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895624058/012ad60e2bea4103b4ff73b309c322bc-1730303074"
  },
  {
    "email":"paola.cadeddu79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895656826/28116750f2fbd99636d410e079547092-1730303074"
  },
  {
    "email":"annalisa.cangini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895853434/369a736db3c9a66f3b2eb846d6e066f1-1730303074"
  },
  {
    "email":"albanicolosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895722362/7228128cc63d5fefb45cec9fd21da5ef-1730303074"
  },
  {
    "email":"lory.giussani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895820666/52dbd846b9505c372e4dd3af829f54ff-1730303074"
  },
  {
    "email":"silviafrancioni@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895918970/4b8f9fbd7e58bc61c4ae17a9c8af8be7-1730303074"
  },
  {
    "email":"santina.francesco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895886202/27ed08204a46e6a2712b75bb1f8e3cc0-1730303074"
  },
  {
    "email":"vitavi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895755130/7aa7f9eb4f9ed978f0a67e0719081a7c-1730303074"
  },
  {
    "email":"donabellomatteo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895984506/6953ba3764fd73ef8a7f3daa0ef07bcd-1730303075"
  },
  {
    "email":"mirellamorandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896017274/ec91aed4c77a0c9160c94ace79f0e1ad-1730303075"
  },
  {
    "email":"iannone.vincenza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896050042/5e4aac1563203c40b11ab63373d5a53b-1730303075"
  },
  {
    "email":"avv.francescapetrucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723895951738/47e2f9154efa54822972e9506cdd1629-1730303075"
  },
  {
    "email":"larissa1988@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896082810/a1c6aa43f113302c718fa2d4b864fdf5-1730303075"
  },
  {
    "email":"dun67@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896148346/30623962e26d8f3bb9e46b35bb6d5b4a-1730303075"
  },
  {
    "email":"sissicomp@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896115578/93531362bb424d13996a4e7a9e9ab49f-1730303075"
  },
  {
    "email":"mariangela.galisai@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896344954/0feaeb21544131bd5ff1b673701df329-1730303075"
  },
  {
    "email":"giuseppe.molla@mollasrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896377722/ee0cb2667c7c67f6b21cd929613a42f0-1730303076"
  },
  {
    "email":"mariannachia@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896410490/9889712093044c4ec87b87f6816adbc1-1730303076"
  },
  {
    "email":"t.maffettone@stradeanas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896246650/47112501746306e8a9b5198dd06ed7fa-1730303076"
  },
  {
    "email":"irenecheccacci75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896443258/e688ecbf70372a4c6830479850221fb0-1730303076"
  },
  {
    "email":"kathi.pernthaler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896574330/14fb2f9f083aa3f1dcc3aeb30ad8a9f3-1730303076"
  },
  {
    "email":"ariannalamura@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896607098/ff0333eaae80da1e79cbeac0911532df-1730303076"
  },
  {
    "email":"miriamcr26.mm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896639866/52a33377c572cdfc33c41a5e1c930c18-1730303076"
  },
  {
    "email":"laralara715@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896279418/0c5fa3113a35270f1dc6e005f859887d-1730303076"
  },
  {
    "email":"daniela.giordano@ibbr.cnr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896541562/c9f807f56e6ef16471bfa17c3968fe11-1730303076"
  },
  {
    "email":"digrandi.alexandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896705402/33a45579ca3f28b03a3825f032d96a3d-1730303076"
  },
  {
    "email":"chiara.dematte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896869242/cf444e45bbf3844e4639b1ca758df69c-1730303077"
  },
  {
    "email":"conanbull@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896836474/ba0ea53fa7183e8b2c21b92588c57198-1730303077"
  },
  {
    "email":"telga.moratto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723896770938/5821c3e50cc746b1eaabd872019665f7-1730303077"
  },
  {
    "email":"gmagliocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896967546/1c32e9c498e9e13ea301b3e91ecb4291-1730303077"
  },
  {
    "email":"alessiafailli31@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723896902010/d8b20342d180208924a3e9f093d28b8b-1730303077"
  },
  {
    "email":"frocca66.fr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897033082/1e69f40818d4deafecfd92c1c7238ebf-1730303077"
  },
  {
    "email":"auroraturbati86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897065850/b4e4978c5c4f7356ab6a3cd99761fa12-1730303077"
  },
  {
    "email":"elena1815@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897098618/2dfae65647d4aade7ce3419812cdf370-1730303077"
  },
  {
    "email":"laurabiagion0899@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897229690/643036ad2062271962e30b7382634bfe-1730303078"
  },
  {
    "email":"simona.mangini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897196922/a4df0ec3b6dfaaa772a541b4f7ba0f9a-1730303078"
  },
  {
    "email":"giuseppina.urgo@studiomontemarano.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897000314/cc77c6d5683e7bc79393edd95238a4be-1730303078"
  },
  {
    "email":"ottiliajjj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897327994/5b02176039691afae878bc9b497db94d-1730303078"
  },
  {
    "email":"montella.adele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897295226/06c679eb1d1697b045bf48924c75a228-1730303078"
  },
  {
    "email":"claudiarita.marciano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897360762/47b4ae907f17401c450e37d2a4429081-1730303078"
  },
  {
    "email":"manufurfaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897262458/08a619a4490334c8a4a77ac2234a538f-1730303078"
  },
  {
    "email":"danielananna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897459066/a5d566ba99a4bb576400a1f180de58f8-1730303078"
  },
  {
    "email":"peruginiantonella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897524602/d762fab5fe7f9c769eae421e251c8c86-1730303078"
  },
  {
    "email":"emanueladrago.92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897491834/d9f44a29d36c2e88d6177d858d820bb4-1730303078"
  },
  {
    "email":"clareby@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897557370/abc33947c9b8af03bc3e10c648542667-1730303078"
  },
  {
    "email":"paoluccinicoletta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897426298/5bbb7819da7dcf885a4667e8185fc3de-1730303079"
  },
  {
    "email":"valegalad@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897622906/1631c963ad06a43274b7950a24b6c510-1730303079"
  },
  {
    "email":"daspar.ge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897655674/6e55f1cb52936f812158d96b6b9df884-1730303079"
  },
  {
    "email":"ongari.paola1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897688442/4113d3b6be6ab6f7432f256fcfe0bfac-1730303079"
  },
  {
    "email":"clagrano@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897590138/6ebea4a882fdcd063a344fa290975285-1730303079"
  },
  {
    "email":"geom.giuliabianconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897721210/2f091686186925edc42a8c15c1898d46-1730303079"
  },
  {
    "email":"letiziacaselli1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897786746/e4b2820dd2cedda84d950e7bbb6054ab-1730303079"
  },
  {
    "email":"martaspreafico76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897753978/3e31319cbf381b4cd82bf53e1d83f92f-1730303079"
  },
  {
    "email":"alessiacantello@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897852282/48623d9acb9f3cf36d3f9ba93480f301-1730303079"
  },
  {
    "email":"ing.michelecosta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723897885050/47806b719919969099f3c655d66ac93f-1730303079"
  },
  {
    "email":"luisadoct@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897950586/d71ccfc42ae79bd9bbb4af1516986c21-1730303079"
  },
  {
    "email":"jomanuela@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723897819514/67f6737ac2cc31487ba1e5b3e7bc2602-1730303080"
  },
  {
    "email":"giusyminelli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898016122/17ad3b2b9b9ca6b3c02b6a8883fcbbb4-1730303080"
  },
  {
    "email":"ramona.bacchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898048890/bad9de3e77201fb7f58b441dcdecbbef-1730303082"
  },
  {
    "email":"ruvolofrancesca732@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898147194/be7390f058ff81e942a24a38b8c251ea-1730303082"
  },
  {
    "email":"silvia76.sl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898114426/c0af2a925b43a5b07e6309757ef2c6c8-1730303082"
  },
  {
    "email":"silvialagana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898081658/7ae00e921abee37e55fe8cc48c8144e5-1730303082"
  },
  {
    "email":"marialuisa.nicoli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898179962/a3b3e0a7300c7f69cc5200241ee8ced4-1730303082"
  },
  {
    "email":"m.bedont@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898212730/31e5abff4d3738c7caabfb0c4de73260-1730303082"
  },
  {
    "email":"g.stefania@gaffeo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898278266/db86d97a340a5e8203c6566969d312fe-1730303082"
  },
  {
    "email":"mariagiovanna.rossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898311034/00eebebc8f5d11ae3d41c33a2c644463-1730303082"
  },
  {
    "email":"sonjamacri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898376570/d091b281309e4efcb717073b56bfcea2-1730303082"
  },
  {
    "email":"frasalsi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898442106/e12f6c3b594f2a014ca84632df9bab52-1730303083"
  },
  {
    "email":"danielamazzucco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898409338/22611245a87ae1e810900b10f9c23502-1730303083"
  },
  {
    "email":"conte.caterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898507642/b7ee51f52e78ee6f077117cfd229b684-1730303083"
  },
  {
    "email":"annalisa.lazzari1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898474874/4302be2ffd4693225f7e12ee2d2b987b-1730303083"
  },
  {
    "email":"cistri966@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898605946/e70b49ae97ad8ec00a9571d5bf9ecbdf-1730303083"
  },
  {
    "email":"monique.2011@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898573178/0c1eec6fc707e84085912aef5f1f986d-1730303083"
  },
  {
    "email":"ros.sacca@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898802554/be15baaa4f0e54435c0ba1368e5907a7-1730303083"
  },
  {
    "email":"carla.fazzina@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898540410/171fd4af3a5c4aff283894998ccd74c0-1730303083"
  },
  {
    "email":"demarchi.cristina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898704250/68322d53566c3a8099bbd137874076e7-1730303084"
  },
  {
    "email":"margheritasinisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898868090/2f76137d2df2143c754fe5130cb4ff36-1730303084"
  },
  {
    "email":"supermisha@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723898900858/b5b55a09c6be7f530da91ab18e303fd3-1730303084"
  },
  {
    "email":"bazziluc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898966394/e70cb4008cfa5b6a2593fe1c04659ace-1730303084"
  },
  {
    "email":"pattiscolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898933626/671d0bb120ec7561c3313101a0fc85ef-1730303084"
  },
  {
    "email":"valeriagioffre87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898999162/8084827f77196a0cf3b4ed19693feef0-1730303084"
  },
  {
    "email":"luciatermine@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899097466/9d69f97ed23c95fdbca51cd4fc0c9e2e-1730303084"
  },
  {
    "email":"gioia.giacobazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723898737018/4dd649fba1bf474c52b755c645760ff7-1730303084"
  },
  {
    "email":"elisa_boccaccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899163002/8aa4197b288aac1567894f41f69fffa6-1730303084"
  },
  {
    "email":"annalisa.fogazzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899195770/8f958b2dcc087e5af03739bb6662ee63-1730303085"
  },
  {
    "email":"sam.som@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899130234/f8407288922577c57e3c07a663ceeb8b-1730303085"
  },
  {
    "email":"elisabetta.mocera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899294074/4a11759332f07d202abbb15a543dda74-1730303085"
  },
  {
    "email":"annarosamangone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899359610/518ede2cf40960c20048c1917446e500-1730303085"
  },
  {
    "email":"raffaella.brugnini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899392378/cf406b835d1e64a77576b07e03af4643-1730303085"
  },
  {
    "email":"letiziaaleandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899261306/413f6b689ffa5281f493ff02ceb1313c-1730303085"
  },
  {
    "email":"claudia_ge04@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899425146/05092b8c357486ae5b9846f407ab46e7-1730303085"
  },
  {
    "email":"lorellacalvi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899588986/7b5e48711d14ae3872b529c27b473f5d-1730303085"
  },
  {
    "email":"monicaciardelli87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899621754/e882181aa653d55b834cc1c90ff3fafd-1730303085"
  },
  {
    "email":"family95sc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899654522/db91adf4818ccdff706748a02abd7b33-1730303086"
  },
  {
    "email":"ritacozzolino76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899556218/c0238028b3d5fd719db18e8c79a778a2-1730303086"
  },
  {
    "email":"betty.pettenon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899720058/8ca17da6024a026bf075a082b4d58f24-1730303086"
  },
  {
    "email":"antonella.tornello16@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899490682/6ef16f860a64543f602e0aacdbd3cb3b-1730303086"
  },
  {
    "email":"idegani2002@yahoo.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22723899752826/71fa5d10a046e756bdf92cf93866d681-1730303086"
  },
  {
    "email":"helga.egorowa.dz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899785594/68abb891706fa57625939974b0ea8890-1730303086"
  },
  {
    "email":"martacesari@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899851130/703d7dfe57accc545cbcdae454f09b5c-1730303086"
  },
  {
    "email":"martalenz@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899818362/6383978e3531f2302b2223fc3b28a106-1730303086"
  },
  {
    "email":"alessiar87@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723899883898/6b1812ae5310eb14a7deb67908391e35-1730303086"
  },
  {
    "email":"serenasavarese1921@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900047738/fdbca01d982cea1505f780ddc6bc5f91-1730303086"
  },
  {
    "email":"annadinelli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900014970/14c8066daeb587a8b7a78c2edc420c21-1730303086"
  },
  {
    "email":"stallonegiorgia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723899949434/1f0f177f4ec81d3dd66c71d364c0fed9-1730303086"
  },
  {
    "email":"sensodifelicita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900080506/5297881b1be3f272a296bc97f2a3579a-1730303087"
  },
  {
    "email":"elena@artessile.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900178810/b4da1456d8145d379210a41f6f6288ac-1730303087"
  },
  {
    "email":"ilaria.manfieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900146042/186c83682eff6afb83364e5abd607f12-1730303087"
  },
  {
    "email":"alessandraforalosso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900211578/ca2cf47573435d3f692830e634cc9c1f-1730303087"
  },
  {
    "email":"mario.pirisi67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900309882/3adefa1b725dc9659a0aab77fffdf413-1730303087"
  },
  {
    "email":"dany.pad@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900375418/8aa45373489af37cdc07b016586be36f-1730303087"
  },
  {
    "email":"tavernafrancesco5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900440954/d176312cc3b45db346bf04ff8fef743d-1730303087"
  },
  {
    "email":"laurazaccarelli75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900244346/45617eb37bdcd55e761b57b7b4e60a55-1730303087"
  },
  {
    "email":"silvanasavoia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900539258/1917e6e77f66473b4b9a714dcc24e4a8-1730303087"
  },
  {
    "email":"alessiadelcarlo85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900277114/710c154bcb4764e805bdd8adb28f838c-1730303087"
  },
  {
    "email":"mbadanellidonati@yahoo.con",
    "url di attivazione":"https://verdissima.it/account/activate/22723900572026/3034a2d7ab1f96d092c8f8df36bceb6f-1730303087"
  },
  {
    "email":"francescataula@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900604794/d306cc39f757e3a87587a4cbcca0df07-1730303088"
  },
  {
    "email":"simonaspera72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900670330/4dc42b4b0381a008829e2531acd57d07-1730303088"
  },
  {
    "email":"plugin.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900703098/e68ab6a647344686b416f815fd94ec8e-1730303088"
  },
  {
    "email":"ale.frigeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900735866/ae45903fe1044da4344e93e06cdf91c2-1730303088"
  },
  {
    "email":"federicaroccato82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900801402/e66f7d46670243af2c960681bc6d67d9-1730303088"
  },
  {
    "email":"disantoclaudio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900768634/0bf470eeeabee38306a3f30f97bee647-1730303088"
  },
  {
    "email":"b.flamment@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900866938/4de89cfef9d77193309e1d64781f7919-1730303088"
  },
  {
    "email":"corgiolupaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900932474/66089dd8c0378451dd5c80078d34b549-1730303088"
  },
  {
    "email":"antonellabraglia0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900899706/c16e1bd1179a6ece7f6156cc668a3fa0-1730303088"
  },
  {
    "email":"moniadicarlo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723900834170/c800d3e95d8da436ee6ed5bdac5940a8-1730303088"
  },
  {
    "email":"f.sabetti59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723900965242/db926f00d9844ea0d7d7a73bc6f95784-1730303088"
  },
  {
    "email":"marciapandora32@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901063546/4f1d7075598eec90f631f78e532485b6-1730303088"
  },
  {
    "email":"martinasassi00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901096314/1e9d28caf81ffb97cf9c28e39bf98dff-1730303089"
  },
  {
    "email":"claudiaromanu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901129082/783b706ee213bd0e27e304b1494a67ba-1730303089"
  },
  {
    "email":"ersilia.ditullio@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901161850/e68a79976335c671303d65f6c2fbd1d0-1730303089"
  },
  {
    "email":"anto@millennium2002.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901194618/3673937fade27892f99e1d148a1df396-1730303089"
  },
  {
    "email":"b.bonazza72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901260154/bed4aacd3e50aa4814d8a37d299e4ae4-1730303089"
  },
  {
    "email":"mario.pedone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901292922/ba1ec5d929a5af4c56f0d0e1fd0cc86c-1730303089"
  },
  {
    "email":"claudiabufalini@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901030778/1d51a2c83ea78fb1e5f4001fc247a57b-1730303089"
  },
  {
    "email":"zangheriveronica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901358458/d429533462e32f9d65d54ee5695e6ee2-1730303089"
  },
  {
    "email":"smastrocola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901423994/8289cfeeb20de6d39a88fccefb92dded-1730303089"
  },
  {
    "email":"marika.vanetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901391226/9f961a16e591d1ffae6ba7f7e332ebf9-1730303089"
  },
  {
    "email":"elena.tolasi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901456762/ce31c18d089ae9a1c7117e352d93fb41-1730303090"
  },
  {
    "email":"francesca77.pro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901325690/83f408d177553caa92cf94b610bff228-1730303090"
  },
  {
    "email":"giugarag@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901489530/e91caf313db552e96e32686c3d808b07-1730303090"
  },
  {
    "email":"federica.andrian@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901522298/6ceb9a26e3f662f2a5d0a2fba643d03c-1730303090"
  },
  {
    "email":"evatinazzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901555066/79363cc8c8718cc4b71dc71eb454a7bf-1730303090"
  },
  {
    "email":"idabuscetto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901587834/47f30ce6b332e7639c20ecc7452e8e40-1730303090"
  },
  {
    "email":"roberta.nonni@faentia.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901620602/ac2eeee6c7a37a19330b814e238448df-1730303090"
  },
  {
    "email":"risha@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901653370/aa91440aed1204dfb3f3a24fa7dc36c4-1730303090"
  },
  {
    "email":"annalisa.dellavalle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901751674/52d84eaafd976fbb816c37218236b80b-1730303090"
  },
  {
    "email":"gliangely@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901686138/f47c1a66dc8ec91236053edfc6d1d901-1730303090"
  },
  {
    "email":"claudia.todaro91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723901882746/26ea550cd225a97c87a0b4178fc70d99-1730303091"
  },
  {
    "email":"annamassa@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902013818/3457ea395def379aa115cbcbc03e66a9-1730303091"
  },
  {
    "email":"cecilia.tarantino@uniroma3.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901817210/172c68ab27922f91ab868cc62d346b63-1730303091"
  },
  {
    "email":"mcalvano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902046586/22096627b09e3a4323835484ecf4b3a8-1730303091"
  },
  {
    "email":"valerianuzzolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723901849978/1dd15dfc03a95681ecdef116b0604c7e-1730303091"
  },
  {
    "email":"viviana.fonti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902144890/ecb1468dd5c4f8f6c1c314bce2d1ea1e-1730303091"
  },
  {
    "email":"rosariamanfellotto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902079354/2336bf7273fc2403ea1a31ac0805c9af-1730303091"
  },
  {
    "email":"milagros.luca01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902177658/51f8159620de48035e45abc3dfb89f70-1730303091"
  },
  {
    "email":"tutino.caterina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902210426/59ed20a32d741fd9af5e25fa6f146f9b-1730303091"
  },
  {
    "email":"adesantis1980@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902243194/db7ebd66157a8d0a9bd65928c68f2cec-1730303091"
  },
  {
    "email":"stefapetrus@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902275962/173e3937b567edf1173b17fa2f13a481-1730303092"
  },
  {
    "email":"katia.dargenzio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902341498/44ebdc78e16f2d103feeec648fc5334f-1730303092"
  },
  {
    "email":"ghilda_pensi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902407034/c64517d16da6ef30b30dacfd897b1edc-1730303092"
  },
  {
    "email":"daniela.benintende@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902439802/e18231118e9f9159b124212e50048004-1730303092"
  },
  {
    "email":"fannjp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902374266/3738694e11a695e8eb2a66e8efea0c30-1730303092"
  },
  {
    "email":"fabiola.delsanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902472570/c4cb525bb302e6622af61ddb79ff9f67-1730303092"
  },
  {
    "email":"galassoerika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902505338/43a57452f30c040dd272636fadf692af-1730303092"
  },
  {
    "email":"ale.asia71@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902538106/38412e7d2e81297e9af25260a81a93df-1730303092"
  },
  {
    "email":"ferraridebora72@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902636410/0f0b29c6ca02f7ef9b9fab1031af2587-1730303093"
  },
  {
    "email":"videlia.logiudice@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902669178/df702fa87822852148c094a2068582ff-1730303093"
  },
  {
    "email":"katiar303@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902570874/f5c17d681f522702d77c5040fafbbdef-1730303093"
  },
  {
    "email":"sara.zazzaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902603642/f0c066021914fc86085a3434ac409800-1730303093"
  },
  {
    "email":"stefaniadintino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902833018/a9965111726e9b05cddf6da3e5d34736-1730303093"
  },
  {
    "email":"tessariangelica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902800250/72fa09ed7e1defb6dc9b4cbddf9e0ccd-1730303093"
  },
  {
    "email":"anna28.ceruso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902734714/a670a709fbc35fe9b6c2add384bb753e-1730303093"
  },
  {
    "email":"veroniquepartidos@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902931322/721322d17953f0e81e46a41752e6372f-1730303093"
  },
  {
    "email":"ezaffanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723902964090/53cbc5e5b03094f091b85390ad56c17f-1730303093"
  },
  {
    "email":"francydido1980@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903029626/ab6b04558db12d9fb427a6cb5deca3f4-1730303093"
  },
  {
    "email":"manutaliani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723902996858/2003c737718ab579f68cf96e84bef5f7-1730303093"
  },
  {
    "email":"morini_cinzia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903062394/08aaf2cbc4e3b1947c1bd193116df123-1730303093"
  },
  {
    "email":"robertagro@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903127930/4704508cc21c31326b7e5411b3e8db5f-1730303094"
  },
  {
    "email":"mariaconcettairaci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903193466/391172e5838bbebfcd83cdccc94409b1-1730303094"
  },
  {
    "email":"danielafedele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903160698/26ab46ee5dafcb66dced8f308a4ddb01-1730303094"
  },
  {
    "email":"mcolombo71@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903324538/c250e87b5c3b67787f838c5d5ab339b0-1730303095"
  },
  {
    "email":"fabio.strinati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903226234/fb05c10df1ae38d750f59ac860589842-1730303095"
  },
  {
    "email":"alessialupino86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903291770/0cf8e0b9db0001456e894427e1c543ff-1730303095"
  },
  {
    "email":"s.ranieri72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903259002/05236f12930613da2c18c0906a7063d8-1730303096"
  },
  {
    "email":"elenasironi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903357306/6dea30a9c731c571e12338188458d14c-1730303096"
  },
  {
    "email":"chiara75.marchina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903422842/db6936d29a8f157931485ada5131ee63-1730303096"
  },
  {
    "email":"serena.muraca@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903455610/58e0d24f07ad476a4fa37afa57964f65-1730303096"
  },
  {
    "email":"alefiloni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903390074/ca74a32331218ed6e41f47753c19ce94-1730303096"
  },
  {
    "email":"valentyna.vale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903488378/2eac281bbe95a5690e991e9a470ffc19-1730303096"
  },
  {
    "email":"dpsilvia983@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903553914/e6dc7d8848a6ad10b58c176f9ca2b981-1730303096"
  },
  {
    "email":"stefaniavalenzano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903586682/520b143184f5dead705ade309a72e244-1730303096"
  },
  {
    "email":"morgan.doria@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903619450/bca947aef55a4d15c24391b975ef977e-1730303096"
  },
  {
    "email":"federica.ubaldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903684986/05407d88d7740bf0b1d2dd676ed9c76d-1730303096"
  },
  {
    "email":"cinziaruffilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903750522/a33ee835a8206f590fa6589224c43061-1730303096"
  },
  {
    "email":"robertatrusso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903783290/3d9809aedfca2724ec8a7340a745ca10-1730303097"
  },
  {
    "email":"maria.loiacono13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903717754/cb251033ad512fce8bfcfe1f6ae43ad2-1730303097"
  },
  {
    "email":"gian_cla@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903652218/726bd4d433f0b598edda4b454a3523f9-1730303097"
  },
  {
    "email":"marcedami1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903816058/99522b34ecb08b53c9f6b1674f7e5c0d-1730303097"
  },
  {
    "email":"giusi.lattarulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903881594/7d75d83d7dbe8a0badf5ae53ef26ddd1-1730303097"
  },
  {
    "email":"mosyukirina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903914362/801030c263988866b58d3d3a1499ce61-1730303097"
  },
  {
    "email":"lindameli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904012666/d9990b1830e6644f2ae29aac25ffd550-1730303097"
  },
  {
    "email":"sabrinacivetti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723903979898/1deef6f4e526a28932d9e364841503b2-1730303097"
  },
  {
    "email":"airadgavi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904045434/1b63d4f405ebe87c986dd29bbf73ff97-1730303097"
  },
  {
    "email":"roberta_molin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904078202/fba1bee19725733f3cab19e5e8f1e355-1730303097"
  },
  {
    "email":"andreinapanseri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723903947130/b94feecb379f19952795333eb4aaa4ad-1730303098"
  },
  {
    "email":"burtinifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904143738/377df080fd4d805ab21a0e91f4fcf026-1730303098"
  },
  {
    "email":"mariannarando049@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904209274/867462a8f922e85037ca30cb2a85d746-1730303098"
  },
  {
    "email":"info@hotelgrado.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904110970/33938c6670b3d88e71af0d6667a325d5-1730303098"
  },
  {
    "email":"lfortuna05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904242042/bc7dfc7c2244d15ded7a8da25a7ec743-1730303098"
  },
  {
    "email":"trevisani.susanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904274810/95c3aa3d9d4de62214db1e5011a7e3a8-1730303098"
  },
  {
    "email":"famigliapezzotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904340346/dd5472445d1f6e82454d50199126ff7f-1730303098"
  },
  {
    "email":"f.delsanto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904176506/c58e14695fa7d385c10d2481a0cc90f2-1730303098"
  },
  {
    "email":"neurone.v@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904438650/79580534c5784cc9c49c08106e517dca-1730303099"
  },
  {
    "email":"ilaria.marmiroli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904373114/19367f4be751bf4a34fcc3669284c3b4-1730303098"
  },
  {
    "email":"cristina2379@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904504186/863ca66a307766198a85a24e62ae6653-1730303099"
  },
  {
    "email":"veronica.zerini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904602490/6dba57a84b9f8f2b535cad4d5889583a-1730303099"
  },
  {
    "email":"carla.ravaioli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904569722/5a5e13fa8cb1a70eb52944d28c35078a-1730303099"
  },
  {
    "email":"serena.stopponi@unicam.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904766330/98600dde79f155c04a414a2c7b869bb0-1730303099"
  },
  {
    "email":"giadacusumano.98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904405882/6a993c92abbbde97faa52d913f8d4ec2-1730303099"
  },
  {
    "email":"filopic6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904635258/108de6256293784f86042ec4ed4e51e9-1730303099"
  },
  {
    "email":"rita.avi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904799098/573eb1199126d778c58f4887578b74ec-1730303099"
  },
  {
    "email":"nataliacsuarez55@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904995706/d954b60302e941b50b4368630ce08288-1730303100"
  },
  {
    "email":"annazaninapple@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904897402/4c4c9075534f790243ca830fa65e15b1-1730303100"
  },
  {
    "email":"bartelloni.alice@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723904733562/3d3ac4a23d64073ae6d3fbd9cd8653cb-1730303100"
  },
  {
    "email":"bianchi.fede87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723904962938/44bcdbc84b46e49fd7b228a195802ded-1730303100"
  },
  {
    "email":"aurymici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905094010/ed2dabd3bda9d9b079c93c6ac163bfb8-1730303100"
  },
  {
    "email":"pentolino1982@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905061242/29cbb40546d657fbb44e5b4a98092608-1730303101"
  },
  {
    "email":"anna.negri756@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905159546/480f26074e815da4da3c393e84d094fe-1730303101"
  },
  {
    "email":"baronchellimaria79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905126778/a406dfdfb9c941638bbbf11ee466781d-1730303101"
  },
  {
    "email":"roberta.pasetto61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905028474/c8a4ef3c28d1be35408e55b32d0f411a-1730303101"
  },
  {
    "email":"ivanascarantino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905192314/4a86345b12ce13b2cde9b321b5a9b5a7-1730303101"
  },
  {
    "email":"liliapuccio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905225082/cbb9eb32d551c62aba205b78a7112ba4-1730303101"
  },
  {
    "email":"roxde@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905257850/01be57ce6c43d8cb5fb27aeaeba00139-1730303101"
  },
  {
    "email":"parlatoilva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905356154/ba21c361514c4c1c806483ff3cf22c1f-1730303101"
  },
  {
    "email":"antolini.nadia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905323386/9d19d1c819139cf61ef47e1b1fb22fe9-1730303101"
  },
  {
    "email":"rosamaria.stefano.crespi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905388922/77e8c0b95052c327a6b07e6fe9f7213d-1730303101"
  },
  {
    "email":"maria.delgrosso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905421690/7103d51763d9882efc625603322520c2-1730303102"
  },
  {
    "email":"bru.dettoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905454458/6d16bbc2397b1b72e1db54b33d43ed03-1730303102"
  },
  {
    "email":"sterrantinok@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905552762/10c0f60a4afa5c3be267589d9d2b66e4-1730303102"
  },
  {
    "email":"cinziatronconi.ct@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905519994/9a7a1adb6c1f988ac364e13b4a8a37db-1730303102"
  },
  {
    "email":"marialeanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905618298/131f403dec890f8a950eefa0d49000f4-1730303102"
  },
  {
    "email":"sirtaki74@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905716602/348744cc24c6769bb0ffa04b3adef5c5-1730303102"
  },
  {
    "email":"biagio.bonasera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905651066/8d05fd83d0caab3f40cea4b9a5027eca-1730303102"
  },
  {
    "email":"dellabellatanja@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905585530/03c31ea300a63e698ab141e53d746a35-1730303102"
  },
  {
    "email":"ilaria.mazza88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905749370/fa98910cef43c0aad1e1e9c4467cd2d5-1730303102"
  },
  {
    "email":"paoladn218@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905814906/a1d90722614daa18fccc98c785fa0f5f-1730303102"
  },
  {
    "email":"laviolasilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905880442/988aaf03d21e6a2600ea9e4d14be2e8f-1730303102"
  },
  {
    "email":"vernassi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905913210/0a746dba285908afec5709a348526a85-1730303102"
  },
  {
    "email":"federica.franz.96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723905978746/f1738553e9532d68b8155d9f2a00b6b1-1730303103"
  },
  {
    "email":"tl80@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905945978/f01b27e6f7b0c0c2436332ccecd882bd-1730303103"
  },
  {
    "email":"paolafigari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723905847674/f5f86424751b793aa5294bbd7f9cacec-1730303103"
  },
  {
    "email":"cperrotta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906011514/587d9d2a8389bbf85c6aa88970b8febd-1730303103"
  },
  {
    "email":"soniapaolacrescini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906142586/157ad3287a412a26627450b9e2df913d-1730303103"
  },
  {
    "email":"maria.papariello3@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906175354/66bae384011c8bf2a435f887e3bffc2a-1730303103"
  },
  {
    "email":"elvio.bonsi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906109818/8e4403d59174078341dd86c62f343c3a-1730303103"
  },
  {
    "email":"tittiviscardi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906044282/9f292e2dc4da5d2190d0ccfd4f80477c-1730303103"
  },
  {
    "email":"frfemia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906208122/b0c70fc7524c86204306286b70fbc573-1730303103"
  },
  {
    "email":"grisuyuma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906273658/ea76a778d891ecb1cd936beb51793a5c-1730303103"
  },
  {
    "email":"siltur.turchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906306426/d8f60a802a167ff588e902771021d1eb-1730303104"
  },
  {
    "email":"barbara.terenzi8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906339194/020d63b42f47601bdd198de8670a4f38-1730303104"
  },
  {
    "email":"luciaiazzetta72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906371962/797b108a3817072d56f2ca80a28dc9f8-1730303104"
  },
  {
    "email":"francesca.amadini04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906404730/07e0e0dae7d505a9aa340604908bbd49-1730303104"
  },
  {
    "email":"ialex2002@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906437498/2de524169a76ef9fbb4bed2706a659cd-1730303104"
  },
  {
    "email":"zerbini.patrizia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906535802/05e78eea0be51e839be6d7bc6a1565c5-1730303104"
  },
  {
    "email":"loredana.difino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906470266/8f868ab388bff1847799c8b066489155-1730303104"
  },
  {
    "email":"foresti.simona@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906568570/2f264a695a922c9e2bd31506230f8344-1730303104"
  },
  {
    "email":"mariagraziaacquaviva57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906601338/fc2d04baa6f7fd2ce2ed371e697bed9a-1730303104"
  },
  {
    "email":"roxiromano@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906634106/889f5d9aec0c642fc352a1eeef52770e-1730303104"
  },
  {
    "email":"vioricacovalenco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906666874/d614bb5251b606eb2daf1f646eed4db6-1730303104"
  },
  {
    "email":"moramarco49@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906699642/6271a3c567cd1a7b82c6d335236bb700-1730303104"
  },
  {
    "email":"molli16@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906765178/b41ee04d9d54dbb49103c0f036b4b7e7-1730303105"
  },
  {
    "email":"ester.polito@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906830714/bd10a0d0cc93cdaed4607978aae9ac7d-1730303105"
  },
  {
    "email":"giovannaferrari.ge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906797946/a3f3234275f24d60d6c23168d43b7af3-1730303105"
  },
  {
    "email":"valesera73@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906863482/a3ea62266c464cb37882bdc6ecb101cf-1730303105"
  },
  {
    "email":"isabellemattioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906896250/a2f1c1f91cdc06ac0f1796339b027311-1730303105"
  },
  {
    "email":"giovannacuri08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906994554/b7b2767c17bbbc6103e203868039c514-1730303105"
  },
  {
    "email":"stefaniapadula10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723906732410/d197813105c3ea912f271b3acf62e8ef-1730303105"
  },
  {
    "email":"antonellavallante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723906961786/2ce80b13bf56c54566903edc567a0eda-1730303105"
  },
  {
    "email":"filo.marzano65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907125626/86247eedc95e74684fabb142abfa1b65-1730303106"
  },
  {
    "email":"luisella.panzeri7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907060090/c3be472da2bdfbe7436390e810cf7da8-1730303106"
  },
  {
    "email":"simonarnone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907158394/47d00322b3c374dc3c449d56692ff3f9-1730303106"
  },
  {
    "email":"rosannat77@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907027322/f187c3cdf8eb23b5f7679f9082c0e63a-1730303106"
  },
  {
    "email":"rosa.sardo@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907322234/a4f53230d5551a1da7716ccecc3c0d14-1730303106"
  },
  {
    "email":"clementina.ferraro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907191162/c580484f1e9d94c2bd6d60aefb227ce6-1730303106"
  },
  {
    "email":"barbara.barilaro9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907289466/d66cd26438f10e40d796d5afdf4a5566-1730303106"
  },
  {
    "email":"giada.benzoni75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907223930/e84ae4099e9f4fab3e7a31daa174bfd4-1730303106"
  },
  {
    "email":"m.cavagna76@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907355002/1164d2ab8027ff8236b48bc36e8c45a2-1730303107"
  },
  {
    "email":"doninicole.00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907387770/9649ca834770550e5cea71a1434f83b8-1730303107"
  },
  {
    "email":"chiara_360@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907486074/617989014a258b01b95b15e137444f64-1730303107"
  },
  {
    "email":"gulmanelli_f@camera.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907518842/c4f0a35d7bed0ea078f6dab31d436fca-1730303107"
  },
  {
    "email":"devitokatia74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907420538/22a3e148876d2afd3e64e9067b12dc01-1730303107"
  },
  {
    "email":"elisabetta.vecchierelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907584378/7992e5f4d1c30eb8adb30b4f59345949-1730303107"
  },
  {
    "email":"federica.bonventi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907453306/81250841d4264c2e69c1694e420384a9-1730303108"
  },
  {
    "email":"m_beccari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907551610/43a93c1d55a59e12701125c4f1ad1f9f-1730303108"
  },
  {
    "email":"tommasino.bruno@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907617146/0ca3baafd33719b8fa0c3dc9d334511b-1730303108"
  },
  {
    "email":"memole603@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907748218/04a51124fb7d06bacd9cbdfb443dd16b-1730303108"
  },
  {
    "email":"info@realcamp.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907682682/b927b24acee44e37ab40ae8f680db506-1730303108"
  },
  {
    "email":"caterinabot70@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907649914/2edb38d007e2f2d84db8196697916763-1730303108"
  },
  {
    "email":"giovymar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907780986/4fa1ce7eaf5ff40925c0347114cc0f5d-1730303108"
  },
  {
    "email":"fabianafusco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907813754/1a7b1a4e4a48942aa9604d87ff487e4d-1730303108"
  },
  {
    "email":"marialuisa.navacchia@isof.cnr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907879290/90c7a2e2027fe0709672c631b287876f-1730303108"
  },
  {
    "email":"mgrazia_greco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907912058/e71785378081a657c74b2b9c2ceafac9-1730303108"
  },
  {
    "email":"silviatassoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723907944826/19b0ac373a3621cb8cdbb789e809de23-1730303111"
  },
  {
    "email":"tomasi.cri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908010362/6de68a589e855a86864ff53f0a69c697-1730303111"
  },
  {
    "email":"iolandascandozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908075898/44425a157f15e589d183bd02662a16e8-1730303111"
  },
  {
    "email":"claudiagulisano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723907977594/226d3708d29dd9092e536981989dacef-1730303111"
  },
  {
    "email":"cristianamant@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908206970/8ade72017768072e2aacef58f594b27c-1730303111"
  },
  {
    "email":"mariat28@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908239738/af80a85c524c7538f0d5abf0dcf95435-1730303111"
  },
  {
    "email":"elenazonari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908174202/f0c2132453a23c3161cbc42d154aee0b-1730303111"
  },
  {
    "email":"arianna.galloo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908305274/2865beab4e39fb025a80da0821862c85-1730303111"
  },
  {
    "email":"studio.penzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908338042/511a90b39afac7d14486efb6dd5a47fa-1730303111"
  },
  {
    "email":"elisabet.n@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908403578/47c8b2536bf3c1e562b659e6e1e429d5-1730303111"
  },
  {
    "email":"angy_22@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908370810/c67ed57086f9e8d790543bad4025b088-1730303111"
  },
  {
    "email":"dinste143@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908469114/095f6eb5ba1233858da536b6e4f9b7b6-1730303112"
  },
  {
    "email":"giuliacase@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908436346/5d19b0f9953cde0dcc0fbaa935d0e116-1730303112"
  },
  {
    "email":"cattani68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908501882/f7185253de1480b21916b2c7ef31443a-1730303112"
  },
  {
    "email":"claudia.bonassi.cb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908567418/c7cb6917c4ecef54bfa1f821ba535ac5-1730303112"
  },
  {
    "email":"aria.lupi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908600186/b3570eaebdf1a5e23495273ea0f8b96f-1730303112"
  },
  {
    "email":"toniacimmino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908632954/0ffe75d57c29eb91d8493ed6b0b0ee02-1730303112"
  },
  {
    "email":"lfugazza@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908534650/717fd045d6921694120b039ada9deae8-1730303112"
  },
  {
    "email":"laretta1205@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908665722/ea1cfdcc6f8b600991ca50968894f598-1730303112"
  },
  {
    "email":"elisacostantini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908698490/cfa997f2534f001be7556c6b2622d383-1730303112"
  },
  {
    "email":"mon.pasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908764026/06959e7a41fd091caed71249115cb95c-1730303112"
  },
  {
    "email":"veralella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908829562/a3f8145b6221462d870167f2fb9ebdb5-1730303112"
  },
  {
    "email":"sandrellaberti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908862330/8346c087353900aa19e9af2ab471be4f-1730303113"
  },
  {
    "email":"silvestri.ml@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908796794/78837cbcf43bb57513810e670da9fad4-1730303113"
  },
  {
    "email":"maio19@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723908927866/60204d4ba950bb020b2ec22dc07ad3cf-1730303113"
  },
  {
    "email":"azanelli@recomec.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908960634/daf0037d04565661982f187ceaaf9c9a-1730303113"
  },
  {
    "email":"domitillagattari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908895098/3f152a798e72b7b1dbe5e8a7d18859fa-1730303113"
  },
  {
    "email":"chicaelena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908993402/3619df0ae8dde22b3d46a127564a2d61-1730303113"
  },
  {
    "email":"simonacerri3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723908731258/e1972c97dbebdb5f53fcd8fa2f0fb5ee-1730303113"
  },
  {
    "email":"amastropasqua@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909026170/55d3e940a087b6dc54efd0eae0652433-1730303113"
  },
  {
    "email":"azzuzzola@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909091706/22a5f214db65756b7f656da73e4d0c25-1730303113"
  },
  {
    "email":"pmarini2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909124474/f9bd99db7b9fbec6b88475a1dddf0fac-1730303114"
  },
  {
    "email":"amustillo6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909157242/80378f0fe1105c96e71e85a37970bd56-1730303114"
  },
  {
    "email":"agnese5858@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909222778/947e06e94838ae5b48ddde856b82274d-1730303114"
  },
  {
    "email":"chiapilati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909321082/3a9aa84cddffcb8621c8f33cc5ef437f-1730303114"
  },
  {
    "email":"stefania.ursida@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909288314/d3f39ab26de2c797e31ada6360cdca43-1730303114"
  },
  {
    "email":"sarabelelli@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909353850/66457ef99c343c247d612c3a07f1cf3d-1730303114"
  },
  {
    "email":"e_visco@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909386618/1f09cfa080354432ff658d89c7348439-1730303114"
  },
  {
    "email":"eli.bellini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909484922/ba1213e0e941eedb0359bd9a0d1fe4a7-1730303114"
  },
  {
    "email":"andrea.morselli68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909550458/0433764d3cc256623b25822e06f00339-1730303115"
  },
  {
    "email":"loredana.colangelo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723909517690/c830f960a5d7e45bbd996f1f54de97fe-1730303115"
  },
  {
    "email":"angiu06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909648762/c8f6d1dd4087c670c239b49962379cd8-1730303115"
  },
  {
    "email":"dajanasette@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909615994/c73a77e58a42885c26c4d996103c454a-1730303115"
  },
  {
    "email":"gessica.fur@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909681530/1805783afa08a61dd3a0867cd5eabaad-1730303115"
  },
  {
    "email":"lau.ganda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909714298/3dc92dcfad5322e3cd566a5fa05b3c76-1730303115"
  },
  {
    "email":"macchivaleria24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909779834/2dff1cabc50653c6061089fc5621b7c8-1730303115"
  },
  {
    "email":"marinatortarolo57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909812602/9b88cd5603322660fe782f2084b13922-1730303115"
  },
  {
    "email":"mariarosariamancaniello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909747066/f9f1cd06094b4957c28b53545c72e1e0-1730303115"
  },
  {
    "email":"roberta.tagliaferri75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909845370/292cbbbea4f7ddd634e84f1f5fa60cbb-1730303115"
  },
  {
    "email":"titta.gandolfi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723909976442/5c61f091af22b670107c8ef8dd7a4f37-1730303115"
  },
  {
    "email":"harmine@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910009210/8c046cd25b8753a7c76336eec1421c21-1730303115"
  },
  {
    "email":"elichiabotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910041978/b78b76282af3ac7c21a2235f4889ad6e-1730303116"
  },
  {
    "email":"f.cicchetti@studiolegalebarbantecicchetti.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910074746/cfc39ec9697dd908ec919cac1e0204ec-1730303116"
  },
  {
    "email":"carlaevangelista80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910140282/346494c9aeea256840a5b54d75bbec5e-1730303116"
  },
  {
    "email":"mildurastante@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910173050/0f783e2d7a7293f59e17e5a158bf9f97-1730303116"
  },
  {
    "email":"monicademma@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910402426/0653a02c995423521c6d3d2e1ec7a9a6-1730303116"
  },
  {
    "email":"chiara.magic@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910336890/3099bdb83b9665f2f76e73c7aa80b9f8-1730303116"
  },
  {
    "email":"giulydebart@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910467962/7cbe6b100c5baff1e6969d469a802085-1730303116"
  },
  {
    "email":"manuela.cernusco@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910205818/85889e37c34fe6067a5e7b3727404966-1730303116"
  },
  {
    "email":"deboraadamo17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910435194/f3c94d25e95c093c93500c50ec5724bb-1730303116"
  },
  {
    "email":"piccolo.martina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910599034/5fecf7f9bcef98171931d0845ccbf4e8-1730303117"
  },
  {
    "email":"alessandra.bonola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910697338/6695e9aa15e7ea401cd2ed393435cbc5-1730303117"
  },
  {
    "email":"marinaildecoro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910631802/715c245f4e9ef3d1c95f644590fc616b-1730303117"
  },
  {
    "email":"angela.cormio.66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910664570/0adab84ad78e708a084472debd96c7f6-1730303117"
  },
  {
    "email":"ussanofrancesca67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910730106/c4c5020b1e1f5817865f18af8b26dd05-1730303117"
  },
  {
    "email":"lamacchia.anna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910762874/c67449d8eaf4247335d244859c2b4e2d-1730303117"
  },
  {
    "email":"mamacri3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910795642/e4cfd1ffc96466a2372e18a02128865d-1730303117"
  },
  {
    "email":"lala.b@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910861178/2323824de468e1363983485198c5a1e4-1730303117"
  },
  {
    "email":"paolarattini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910926714/e20ac93ff1e41e257f8d23f727ab542c-1730303117"
  },
  {
    "email":"lennina66@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910828410/5b9bab3b3af8e3ae2c5e378a7a0fb28e-1730303117"
  },
  {
    "email":"facontib@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723910959482/1ffc9d8f0501facbd4584037772b5e53-1730303117"
  },
  {
    "email":"michela.alberti75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910992250/0b6e7f9f824903aed5a20dc0cc12e97f-1730303118"
  },
  {
    "email":"patriziap2006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911025018/4d690610af5dd2b6280e0568a6237610-1730303118"
  },
  {
    "email":"hotta88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911057786/dd6c9a5711e13a8d7966a951d77a8190-1730303118"
  },
  {
    "email":"paolotta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723910893946/ca3eac7a6fcd4fb200c4c3abd56e0026-1730303118"
  },
  {
    "email":"coveccia.ale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911123322/239f0ecbba5426591d3f8f2989939b05-1730303118"
  },
  {
    "email":"cristianparisi75@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911090554/69a2d94735217aacb07da4000f52d532-1730303118"
  },
  {
    "email":"graziana.stellacci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911156090/f147f971b0d8dc43786d9f501ca15be1-1730303118"
  },
  {
    "email":"arianna.cenni.ac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911287162/6a83f4906fe312f96ef6d1ffe3fa15bb-1730303118"
  },
  {
    "email":"li.ve84@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911188858/dda5984f706d170ebba16cffcbfd736a-1730303118"
  },
  {
    "email":"lauravalentini120@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911352698/4217448dc5e74a45a0f1b304b13568e2-1730303118"
  },
  {
    "email":"angela.1@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911319930/fa66db617736f1a7b6d96b5742714d9d-1730303118"
  },
  {
    "email":"elisa.mizzaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911385466/2823fce359fc8d8ed7d48946cb34b363-1730303119"
  },
  {
    "email":"debora_c@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911418234/4734642b75da83d87a5fa75597704c97-1730303119"
  },
  {
    "email":"claudia.fabbrizi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911451002/bfd02692a94dc6a038ab327e8a0d6b56-1730303119"
  },
  {
    "email":"gaglio.giacoma@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911549306/2e90fca0d703c738d586f552ff4653ca-1730303119"
  },
  {
    "email":"mariacristina.scelsi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911614842/8b596778f7a91a1db9f97cea7a227bb3-1730303119"
  },
  {
    "email":"marilenaquaglia@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911647610/f5e544d10b9d3bf272242359dd6a78b0-1730303119"
  },
  {
    "email":"jiejingdai84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911713146/66cf470fc017651f98a56b9368556d9f-1730303119"
  },
  {
    "email":"silviabizzi7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911680378/9808c9467950768b7474a066b4cd5ae1-1730303119"
  },
  {
    "email":"faggino71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911483770/89edde8455e51c69193b84beeaf4b109-1730303119"
  },
  {
    "email":"valentinacaponera@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911745914/49d6fce716f6eb0277faa2c775035360-1730303119"
  },
  {
    "email":"elisaaonzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911844218/ad308236d3c3c2ba40dea808e639852e-1730303119"
  },
  {
    "email":"anna.luongo4@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911811450/228b55b3cf4f156b2b81a1bd8e661093-1730303120"
  },
  {
    "email":"enrichetta.desanctis68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911778682/3d5b6507cb2a96c084ef72af1393d215-1730303120"
  },
  {
    "email":"tombinielena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911942522/9f7184fe95fb6c508b5d7cf2ab96078c-1730303120"
  },
  {
    "email":"dalessioemanuela90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912008058/116e358062026d9d609efdfda05a14b4-1730303120"
  },
  {
    "email":"pattydibello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723911876986/f1fdd4af3700a072aea5bdd01ff9e365-1730303120"
  },
  {
    "email":"alessandragregorio1805@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912040826/bdeef9cd6954dea919edb16ceb4da6ca-1730303120"
  },
  {
    "email":"studiomillmaggi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912073594/02271230c5aceef62a075802cf542574-1730303120"
  },
  {
    "email":"m.vittoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912106362/8e6f8df380060cc4094d257fb23bca10-1730303120"
  },
  {
    "email":"mariannalatrofa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723911909754/97720cf7385e7a39391b390c3867c8e7-1730303120"
  },
  {
    "email":"simba.casadio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912171898/31022de82153dec152be6e9a7074cae5-1730303120"
  },
  {
    "email":"cramini.veronica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723912204666/cab1f35c7954e342406aeafe93d7ad20-1730303120"
  },
  {
    "email":"boscosonia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723912237434/3f948244d1bb9d63b706598e934e103e-1730303121"
  },
  {
    "email":"francesca.fonsidituri@credipass.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723912368506/2d208fb7051920224530597c3373c2bd-1730303121"
  },
  {
    "email":"ileanaparrino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723912401274/c7bc8991191a00e698babc2fd3a72fe0-1730303121"
  },
  {
    "email":"veruska.alessandroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912466810/cd5085af82748a98b428edf4b0470bad-1730303121"
  },
  {
    "email":"sabina.sargenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912270202/e0647658c6178b5c6362e9d6758f489f-1730303121"
  },
  {
    "email":"lauranot@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912335738/7a76deef57c3ca3660cf1259285ed6a2-1730303121"
  },
  {
    "email":"roby.mariotti81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912499578/81c51bc8c5263387b9b584b19115b620-1730303121"
  },
  {
    "email":"nanib87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912663418/d22606361fd83cfdcc792cb5c4db37f1-1730303122"
  },
  {
    "email":"nocodiga@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912630650/fada39893599dc5c1a1acb4f43a189c5-1730303122"
  },
  {
    "email":"serena.enanita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912532346/320eb84e95322f1f4d485ca46b1b5def-1730303122"
  },
  {
    "email":"catiatassoni0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912696186/52e5407f4e891425d5c7dfa367c1c038-1730303122"
  },
  {
    "email":"deborah.macellari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912728954/f027972e3c819fb9be93635419aa6930-1730303122"
  },
  {
    "email":"bonifazi.valentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912565114/2125085530aa90ccd982960f0d483b08-1730303122"
  },
  {
    "email":"riri10100@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723912761722/91dd2bb0d59d1b5a13e581cdbe7ba063-1730303122"
  },
  {
    "email":"casalanza2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912925562/230ffe04b65c889309d3bbab214002f3-1730303122"
  },
  {
    "email":"elianabaseggio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913056634/c23c4fc4b39d335cca6b36c5204a48fc-1730303122"
  },
  {
    "email":"lucia.iannucci2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913023866/edc1221328693a86159e1109a3b4f4ae-1730303122"
  },
  {
    "email":"avvelisabettascuotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723912958330/0bb9baf70fadcc7b6d4b96b0d055e378-1730303122"
  },
  {
    "email":"gmilani3000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913122170/7ec9153a6e5131ea4fa924f0fbd9d268-1730303124"
  },
  {
    "email":"connieu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913154938/3846eee793557e9256a206f17c2da0f2-1730303124"
  },
  {
    "email":"gisbussi.francesca323@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913187706/8f6843fcc5fde9d5e950456e294c662b-1730303124"
  },
  {
    "email":"teresa.cini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913220474/dac7a7daeb0e9bb5a360c8a12021840f-1730303124"
  },
  {
    "email":"noessing.dietmar@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913253242/63dad288a26a21c1ddff9192e06d727e-1730303124"
  },
  {
    "email":"quadrellisara79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913286010/3bf76f1f81781cb0e8ab6d8905e459c3-1730303124"
  },
  {
    "email":"silviapiroli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913318778/42661cf4f6121d8a7f71a3e3f6d201cc-1730303124"
  },
  {
    "email":"allefo.cosci731@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913384314/5ef6c1eb7c9282dc3c8daf17fd0a24c1-1730303125"
  },
  {
    "email":"roberta.burtini@libero.it",
    "url di attivazione":""
  },
  {
    "email":"eleangeli01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913449850/6a56b3f0a424ebd37b5bb063dba479f4-1730303125"
  },
  {
    "email":"rosa.alba.sacco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913417082/72729573e9d73805889cf66ad8f9872e-1730303125"
  },
  {
    "email":"andri09.aa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913515386/b9e95bac30c4029fba4ad6dca4ece7f6-1730303125"
  },
  {
    "email":"marina_pisani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913548154/b027b47680a5e73e7690b8599ac080b4-1730303125"
  },
  {
    "email":"dafiumerosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913580922/946fd8bac09c374d73c83f6e5b8a8ff9-1730303125"
  },
  {
    "email":"deliachiereghin@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913613690/9d4e9fafaf4b475da9168f44850f347a-1730303125"
  },
  {
    "email":"micciovaleria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913646458/0359893d75124f8a5bf9ddf531ee370c-1730303125"
  },
  {
    "email":"mamorizzo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913679226/37fc25b54c539f836a611fa51a4b5ce2-1730303125"
  },
  {
    "email":"stefania.rinaldo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913744762/254e29a7e6f5466f21027fb55b7e6921-1730303125"
  },
  {
    "email":"enricavallati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913777530/ef7eb8c264571f997f4a4e0c7fb4daba-1730303125"
  },
  {
    "email":"alessandragara1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913810298/a0f6db396baaba83fbf3c46c28144922-1730303125"
  },
  {
    "email":"silviafellinger1959@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913908602/52046de761f68a251ea9323556f43a56-1730303126"
  },
  {
    "email":"mara.baggia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913974138/87a5a749c179f6bdf238b09930e3d986-1730303126"
  },
  {
    "email":"angela.chiericati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723913941370/e086f7e47c85a33c548819d508b5503c-1730303126"
  },
  {
    "email":"ffloro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914039674/f963a0297f760856e3913c1e20aff774-1730303126"
  },
  {
    "email":"cinziag.ghezzi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914072442/5d89b5b2033d89ce6e5f2800562a95ec-1730303126"
  },
  {
    "email":"marghet81a@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723913875834/a1243ba0b47c3805cf0e4026cdc0e685-1730303126"
  },
  {
    "email":"patrizia.detitta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914105210/6949ba4565fd4cd50a50fcd17470bc6f-1730303126"
  },
  {
    "email":"ele14176@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914137978/53c92adf05de351778296e329344775b-1730303126"
  },
  {
    "email":"dorianacintio64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914203514/5dc0d2fd2b5b8d036df882235baf5840-1730303126"
  },
  {
    "email":"gabriella.ruffinatto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914301818/2317b84084afabac33c90f48fa5fc269-1730303127"
  },
  {
    "email":"f.elis89@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914170746/2eb3b81fa390db6b8c8fae03ed769e71-1730303127"
  },
  {
    "email":"nunziiaa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914465658/f4819a44d9e18a6979b1c8e05a73eadc-1730303127"
  },
  {
    "email":"vgiada88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914269050/7d55d9d8232f6c83bc7873b63be20ef5-1730303127"
  },
  {
    "email":"manuelagiuliani1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914498426/6bb02d3b7776fb70b578cc4bc685779f-1730303127"
  },
  {
    "email":"degirolamo.vittoria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914367354/d316c20ce07c8c4629547b705c6bbd08-1730303127"
  },
  {
    "email":"esmymarco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914563962/f2dc4ed0a88597cdc41287c26e30bcad-1730303127"
  },
  {
    "email":"elisabettaspina71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914629498/3680dbab6f176629681ce6718d2afae8-1730303127"
  },
  {
    "email":"grazib77@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914695034/b1f3ba8e7a7f9cb0b393cf9e90f7b9aa-1730303127"
  },
  {
    "email":"topoli.em@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914727802/c52028abc5134c9213a0c3f3d43cf3f1-1730303128"
  },
  {
    "email":"mproxy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914531194/7e48cfd0cad9433b3f16bdcd3ea6bdff-1730303128"
  },
  {
    "email":"gildaba@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914662266/237e650256efc21df7a75c08130af44d-1730303128"
  },
  {
    "email":"luigi.tiozzo@lacquachiara.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914793338/a15b27488574286dc7984107798934dc-1730303128"
  },
  {
    "email":"arcanda1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914826106/d3d1704c87c6bae028342946650a172e-1730303128"
  },
  {
    "email":"simonaborghesi5@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914858874/df31da4aa5377266d0f5b2cdf209c73e-1730303128"
  },
  {
    "email":"melaniaso@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723914957178/c90c5b046a229908207554f56efd0e4a-1730303128"
  },
  {
    "email":"angela.colaiacomo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914891642/8bb673b5884cce5a2df7b5d10cac8b80-1730303128"
  },
  {
    "email":"antonicacapelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723914989946/9c49fa8f6dcd969e77a85a4b0e5f8a9c-1730303128"
  },
  {
    "email":"laramaura@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915022714/953c4a274be7acaf636de740c7ecceea-1730303128"
  },
  {
    "email":"assuntapicariello@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915088250/eef97745a1fef1ae9bebf463cd5a80c7-1730303128"
  },
  {
    "email":"pesa52@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915153786/23fd1503d8bc59642a91f512bbc9bbab-1730303129"
  },
  {
    "email":"elisa.delfabbro71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915055482/cffb7340be42469f21bd36a16d21bf8a-1730303129"
  },
  {
    "email":"valentinasette2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915186554/f9a1b619380721e78ce80a5acf908208-1730303129"
  },
  {
    "email":"luna997@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915317626/96dfa91bc23fedb0318c564d82d0af87-1730303129"
  },
  {
    "email":"elisarro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915252090/13474dd22a433dec6e4094ba11de6309-1730303129"
  },
  {
    "email":"aalfrediani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915284858/39fddab7bbcd869a4a5b9520f50c62ee-1730303129"
  },
  {
    "email":"elisabetta.dallago@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915121018/58da39315224ffbeb96bd554633be731-1730303129"
  },
  {
    "email":"michela.dagostino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915448698/bd28d9a93ce3a1c4a6980725976c3e76-1730303129"
  },
  {
    "email":"gaia.bellon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915383162/f641718cb7d31ffb840ffcb1b8577777-1730303129"
  },
  {
    "email":"maria.fantozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915415930/546099312708060a6a843b9b7e774f6e-1730303129"
  },
  {
    "email":"pisapatrizia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915350394/9487b25416ebd8ee9ffb68189de91a0b-1730303130"
  },
  {
    "email":"martinapiccola@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915579770/6f94a0474d535fdbfea3b52ae0c6e58a-1730303130"
  },
  {
    "email":"serena.legittimo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915514234/787239ae0f7edae67b3563bdf6ad7e69-1730303130"
  },
  {
    "email":"claudia.gand78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915678074/34ec49a7f6db5501c2cb224b5836a070-1730303130"
  },
  {
    "email":"rainerimari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915612538/7f39cbfc41674fc91e01cfe147c565c7-1730303130"
  },
  {
    "email":"noruzza_s@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915743610/32155be1cc208fd3a1bf4a9f496a277a-1730303130"
  },
  {
    "email":"sonia.megna@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915481466/6cdb5240db5ee5da08115e3c8bfcc203-1730303130"
  },
  {
    "email":"concettadelucia13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915776378/fcd9e59f21e5bd34f928f895c733620a-1730303130"
  },
  {
    "email":"avv.enzabiscotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915809146/d1f74f3d155e05ad5190df5442f46020-1730303131"
  },
  {
    "email":"parentinibarbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915841914/9556d77eb1dbc56118859a92df7a2952-1730303131"
  },
  {
    "email":"alopex84@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915874682/60b9db6482057fe8faa8126ee354f244-1730303131"
  },
  {
    "email":"michelini.paola@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915645306/6046342e751ca75417edd85e73c26dd9-1730303131"
  },
  {
    "email":"carlacanestrari@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723915907450/ffb82524eda35c042772057839dcb14f-1730303131"
  },
  {
    "email":"maydanskaolena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723915940218/e47ec9c3bd024a406905337da39ccc24-1730303131"
  },
  {
    "email":"ac1uisti_mc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916104058/0e431828200c0fd215edeb15eb54bff1-1730303131"
  },
  {
    "email":"emanuelletortola@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916038522/0ef76a35fca74af21fd63be5ed78d7d4-1730303131"
  },
  {
    "email":"bernardi.annamaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916136826/e644df6035b15ed794eb7f6f16563eba-1730303131"
  },
  {
    "email":"evaventu1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916235130/783d19bd935590dafa552651563851a1-1730303131"
  },
  {
    "email":"glamonaca8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916071290/daf38582be69b5a3e2882e29c8e7d6c8-1730303132"
  },
  {
    "email":"quagliadaniela75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916202362/71bc381a340e45dbba1664aeefeb5b38-1730303132"
  },
  {
    "email":"marilenascutti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916267898/6d0a2697c5db3b6fdd5918627e0168b3-1730303132"
  },
  {
    "email":"liliachiereghin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916300666/2b3cb57f19e9186057843b33cc833cb9-1730303132"
  },
  {
    "email":"danielatornesello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916431738/72d3e216e8b6f0af3b76a2ea231f8598-1730303132"
  },
  {
    "email":"isabella.trombani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916398970/85b17f39d0843d2ad0a9ceb675b513f7-1730303132"
  },
  {
    "email":"irenesassella2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916595578/c3ea836c4724610f8fad9d6735214a99-1730303132"
  },
  {
    "email":"chiara.74pascucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916464506/5554e78f3d2f27134aa88ca4de1e8f2f-1730303132"
  },
  {
    "email":"zelinda.la.ganga@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916497274/b9af8c9a8dc9f1d99965d86e09627147-1730303132"
  },
  {
    "email":"vooggi.studio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916628346/882cffed887e69943608c84231bd97b5-1730303132"
  },
  {
    "email":"michela.massei@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916562810/11bc1c75b3fc5864a0f40064a45fe392-1730303133"
  },
  {
    "email":"danielaruocco67@gmaila.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916726650/f0b68c630d0bec1b3f276a93b2b35f48-1730303133"
  },
  {
    "email":"mar.graziarossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916759418/df0322430e128762ae44a69d42ab2d38-1730303133"
  },
  {
    "email":"irene707@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916693882/52fa24921fd92de4803185c0e43919e4-1730303133"
  },
  {
    "email":"mariarosariacaschetto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916661114/edf66e084f7ba008565268652f5d8d35-1730303133"
  },
  {
    "email":"barbara_demartino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916824954/e696ce8be912f1acbefef142f1878fca-1730303133"
  },
  {
    "email":"giorgiamaggini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916792186/3f57818c94022772417043a10437c683-1730303133"
  },
  {
    "email":"sgiudici.fam@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916857722/e2503fcbd397b8b09aefa5f3d4ec41c1-1730303133"
  },
  {
    "email":"lallaale.zanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916890490/319c1990d4cd792de9612d53a8abfc44-1730303133"
  },
  {
    "email":"eleonoradugo@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917021562/2031e0bb279d2c20e4dd642a18166c56-1730303134"
  },
  {
    "email":"maria.iovino@avioaero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723916923258/c017f14c5144ce392665db72abcf23c6-1730303134"
  },
  {
    "email":"chiaragerevini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916988794/d36ca6e4d2bd47c7c761b8902137aaec-1730303134"
  },
  {
    "email":"diego.pianta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917087098/c518a9db3dabfc804e7c9fec0108c19f-1730303134"
  },
  {
    "email":"chiarabernardini81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723916956026/cbfc8392fc095c930d6cb892f27cc37e-1730303134"
  },
  {
    "email":"loredananapoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917054330/b2ff9712fd5d6fcb0de96ffe190fb024-1730303134"
  },
  {
    "email":"commerciale@gestionecontotelefonico.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917119866/b338e27ce9de2c8d41fd0f30c828b69e-1730303134"
  },
  {
    "email":"tina.galletto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917185402/8818370f1387149614809eb2779cecc8-1730303134"
  },
  {
    "email":"mano.marcelli@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917316474/1fb25a397d80f4b36ac194a16124b839-1730303135"
  },
  {
    "email":"flo28borraccino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917152634/737c5bc4e3a4ae14dc41d6a674d7ae80-1730303135"
  },
  {
    "email":"alegura@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917349242/1af4d69d8b379143c13c93a938d5ef73-1730303135"
  },
  {
    "email":"orietta@ornellababy.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917382010/9c45aa1be1b0263e477eafab7ba3abed-1730303135"
  },
  {
    "email":"marytessaro.tv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917218170/c9767b98c35213f382116e77bede3dde-1730303135"
  },
  {
    "email":"liviasaporito77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917414778/36f102762b0dc55989fff2bc31d50edf-1730303135"
  },
  {
    "email":"giuliacairella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917447546/da4e7c6c034d4469e260b19524c798a2-1730303135"
  },
  {
    "email":"fabiolaservello67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917578618/2986e06c42bf5401607d11cc44402721-1730303135"
  },
  {
    "email":"sabrinabenammar93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917611386/cfee50b3bb90817646886c8786802407-1730303135"
  },
  {
    "email":"danielabarone@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917545850/634ac507587729d86a71fcaad3b193f5-1730303136"
  },
  {
    "email":"pasqualina.tosto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917676922/17b07626d6f44768776751d37103e320-1730303136"
  },
  {
    "email":"manolabardel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917480314/f82609f2c32d62e27ead2c88e6061780-1730303136"
  },
  {
    "email":"violuterosse@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917644154/fdc7770c1a951859f420071af11c1807-1730303136"
  },
  {
    "email":"parcy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917742458/082a8fa96006937300f80ebc47c765bd-1730303136"
  },
  {
    "email":"elysav@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917807994/acf949a8514e6e2a3dae6f9d3d64e2f3-1730303136"
  },
  {
    "email":"tizianadeluca42@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917873530/3b12d2b84973bcec19d9decefdacf819-1730303136"
  },
  {
    "email":"miki115@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723917840762/c9ce4dfc981b38ce57009e7a78d35330-1730303136"
  },
  {
    "email":"elisa.bergami@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918004602/0e273e3ea6d8c08efb81218c769e72b7-1730303137"
  },
  {
    "email":"maddyrossi05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917971834/72aeb53b40f7ae71abd333ee60325a7c-1730303137"
  },
  {
    "email":"carla.scottolavina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723917939066/b00fc1d332b780f8f64184e5b9a4dbab-1730303137"
  },
  {
    "email":"arianna.caprioli.98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918037370/7563d1658010755ea52fe5fd7f48ea07-1730303137"
  },
  {
    "email":"giulia.chessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918168442/0087b9c42d1200070d7962d2ccbdca37-1730303138"
  },
  {
    "email":"saraardolino26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918070138/2adcd5de4c56d2e72e49aa6002894f07-1730303138"
  },
  {
    "email":"a.imperlino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918135674/1bd11c5cf20e332135282b48f119c96d-1730303138"
  },
  {
    "email":"giovanna.attianese1970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918233978/7be5defd328e81d0dd1a143b11c96faf-1730303139"
  },
  {
    "email":"gvf.girolami@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918365050/db8613f16471dc4cc9d501abecdecf3c-1730303139"
  },
  {
    "email":"claudia.grieco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918102906/dab5d57caa6661d8630e7c3d23009ca9-1730303139"
  },
  {
    "email":"vanessagambino@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918397818/c4cc92c7f61238107baf5e320c911dda-1730303139"
  },
  {
    "email":"nguidi8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918430586/2c8c8e9aacb2d4c13752842d32b8d633-1730303139"
  },
  {
    "email":"aurora.graldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918463354/fa69be589845feb7a6f74dda3773532f-1730303139"
  },
  {
    "email":"elisabettagaspani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918496122/664790b6f2bc03e2210a7a37d1a04dc0-1730303139"
  },
  {
    "email":"susanna_zampini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918528890/05951460de2f8c1c1d09cbffdef1aee6-1730303139"
  },
  {
    "email":"s.tatavitto1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918561658/e8109a6ca0bf3ca8cb1d6a8a72dc46a4-1730303139"
  },
  {
    "email":"arianna@studio-asa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918594426/98024278e30bb3ffec7345d9dc3a70c4-1730303139"
  },
  {
    "email":"donatella.salvatori@taletespa.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723918725498/cdd885b794f0c52d67fa20156c9d1830-1730303139"
  },
  {
    "email":"edda.novello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918758266/7fd7188eb7fe93a04b71407db50a0a79-1730303139"
  },
  {
    "email":"samimichela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918823802/88cc561671e15e863c543480a43c9ce1-1730303140"
  },
  {
    "email":"re.lisa.ro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918889338/ec12b5fb89feecf187177e5a189c807d-1730303140"
  },
  {
    "email":"anto2263@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918922106/36aecd8eb392170608dfd6d05eaf2b35-1730303140"
  },
  {
    "email":"simonaagliardi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723918954874/1dfb6fdb221be61d3f258f662c3b6a82-1730303140"
  },
  {
    "email":"danielamarceca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919085946/5079932bd504e6804b6e64cc6fc82d46-1730303140"
  },
  {
    "email":"anna.pizzolla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919053178/61c9a07b29e892683e40ed2fcc631fec-1730303140"
  },
  {
    "email":"danpopmar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723918987642/be7f4897dbbad646f25f4fb681faf2ae-1730303140"
  },
  {
    "email":"ranierianna17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919020410/199c0245c2f2b9917ee5eff6a2c5ba49-1730303140"
  },
  {
    "email":"barbara.bori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919151482/9c43e27a7f6bb68bfdd237f00391e1e1-1730303140"
  },
  {
    "email":"mariapinacampisi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919118714/5cf2be8d44126516397096b4333b7d74-1730303140"
  },
  {
    "email":"paolofezzardi23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919217018/a2d31477d284569f119d239beebed50f-1730303140"
  },
  {
    "email":"domenicamerlino2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919348090/ff52a7538b091c0bae10b88db49cf2fe-1730303141"
  },
  {
    "email":"monica.valent@businte.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919184250/b53ecbcfa9407f716089db157baaa757-1730303141"
  },
  {
    "email":"paoloboy@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919249786/e8e1ab5bfc6700f480b2afde31c89e45-1730303141"
  },
  {
    "email":"daniela@massimini.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919282554/31a9923625850bb7c9558d16b0cd6c04-1730303141"
  },
  {
    "email":"vanettichiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919380858/73827d789575fd8ace242ca6231bf7a4-1730303141"
  },
  {
    "email":"giulianamereu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919413626/443db9ec05f96be3e939b3946549f959-1730303141"
  },
  {
    "email":"luiborto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919479162/07440e938babd5b398125371fb2c1634-1730303142"
  },
  {
    "email":"arch.francesca.marchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919544698/f88e8b450ed1d1a86aff131cf8ced299-1730303142"
  },
  {
    "email":"dm_marti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919511930/8422b591dc28e7910772ad00451dad7d-1730303142"
  },
  {
    "email":"robertamartino@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919577466/36d8d89eb9c15b9cf54863f2b3976424-1730303142"
  },
  {
    "email":"chiara.sciarabba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919446394/5576251448ed0d26e1ce6e2b1e353071-1730303142"
  },
  {
    "email":"tiziana.blasi@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919610234/604ff964f54500e20057f96ffff7de5c-1730303142"
  },
  {
    "email":"azzollinomaria@lobero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919643002/d52ae995f754aa656f5039bda555413b-1730303142"
  },
  {
    "email":"tinellijenny@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919675770/a0a9f3172f50a0a9f5eb9a277c45d8bc-1730303142"
  },
  {
    "email":"carmeladido13@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919774074/df4b6a573934be286952b0323a56cba7-1730303142"
  },
  {
    "email":"fauquara@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919839610/336453c013e4cb056acb754cff5f2153-1730303142"
  },
  {
    "email":"aronzani.ar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919806842/b0b1aa3a3a31ad9c60deaf8162ad15e6-1730303143"
  },
  {
    "email":"impat1972@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723919872378/3798168a2d47806a0f95991cc5865b0a-1730303143"
  },
  {
    "email":"robertacampana22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919937914/48d0ee82dee05b9cd17ac39923a0a3b1-1730303143"
  },
  {
    "email":"rosannaveneri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919905146/87bc0075f502ea62aa9bd9377d49a8a9-1730303143"
  },
  {
    "email":"ligasalessandra04@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920036218/5e37d8fe46fa97f600517d55da1db246-1730303143"
  },
  {
    "email":"ml.casamassima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723919970682/cdf41206810700d12639f396032e2483-1730303143"
  },
  {
    "email":"maria@perino-impianti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920101754/423ff84e5d4892e4501d89966ab35bc2-1730303143"
  },
  {
    "email":"ilaria.cerrini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920134522/240030286ff94440af358cf4f19584ff-1730303143"
  },
  {
    "email":"jeannemariebima@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920265594/0f505f652ebd974ea0b49203193df349-1730303143"
  },
  {
    "email":"valentin.arfe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920200058/ca09f17943abaaf0090cc9f5e0fc7bd0-1730303144"
  },
  {
    "email":"patbald2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920068986/f2e7d799d2af8fc996d81e70165f0f40-1730303144"
  },
  {
    "email":"barbara.pagnini67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920167290/185405e436e16fda9c1af1a8d5e9faa1-1730303144"
  },
  {
    "email":"paoseregiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920331130/0e749dc34fadbb621569a1c025b13fbe-1730303144"
  },
  {
    "email":"luisa.biffi1a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920363898/d590694a37df2cc42ea5583b377d976e-1730303144"
  },
  {
    "email":"daniela.cielo78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920396666/880e9bb7bb6eac915a2e8532869b93b0-1730303144"
  },
  {
    "email":"sonia.bovo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920462202/7c60cb608d43eb88ccc315138cf3c47f-1730303144"
  },
  {
    "email":"cristinabonnal@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920527738/a7fdf2052626b079bcd7566f4c164d5e-1730303144"
  },
  {
    "email":"anna.celleri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920560506/ad82cb3315354f036999424a657dfe38-1730303144"
  },
  {
    "email":"avv.claudiabonetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920691578/d60a14a6b54564d15e921cc74ecc2127-1730303144"
  },
  {
    "email":"paola.calestani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920724346/b6fff46ffb699e1ecde2cad35ac0781f-1730303144"
  },
  {
    "email":"amministrazione@tenutatanislai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920494970/e47b647a54c08263b55a696ceaab85cd-1730303144"
  },
  {
    "email":"matybella69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920757114/35d3de1aa75cb0cf1330fec2ee225de1-1730303145"
  },
  {
    "email":"linda.depieri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920822650/9a8b44d6d49a460dfd96b74ed20b66ff-1730303145"
  },
  {
    "email":"elisabettapasotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920888186/9379e32f2319345ec435376fa0282f3d-1730303145"
  },
  {
    "email":"valentina.carraro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920986490/eb02d4c89cfedc9755ca78af883facd2-1730303145"
  },
  {
    "email":"70melissalibero.it@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723920920954/b30af76d816c9bcf9bd4b04331d0241f-1730303145"
  },
  {
    "email":"rosamarianna00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920789882/d78fa05f6b022c9c044336eb8dd7fda1-1730303145"
  },
  {
    "email":"annav15780@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723920953722/922504678a632ca55298a404af691cea-1730303146"
  },
  {
    "email":"simonamenegaldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921052026/55ece9639164b54d7ace772af5c43253-1730303146"
  },
  {
    "email":"l.piovani@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921084794/bf9983297f1a89e4976c662c03d9e0f5-1730303146"
  },
  {
    "email":"bianchipina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921150330/71a0c65aa3526d8a56c9757b723b405b-1730303146"
  },
  {
    "email":"tuccime@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921215866/c89e92ff34d669907cdad398832f3497-1730303146"
  },
  {
    "email":"adric.mattei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921117562/b67d7f26648ca85e7bb69ed11094f871-1730303146"
  },
  {
    "email":"margh.me@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921183098/b47460707ed9545372e4219953aec566-1730303146"
  },
  {
    "email":"mariannar2006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921248634/edc7f54308d0677de8552b7b78d4cf7e-1730303146"
  },
  {
    "email":"alinapatrick_hiris@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921346938/0ec31e9a3710bf861f6f335753085194-1730303146"
  },
  {
    "email":"annabianchini_a@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921314170/0d2041d553208d1748da7bc791fa91ab-1730303146"
  },
  {
    "email":"giusybari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921478010/b2de9e22cac0ab4fd8060494f5e05674-1730303147"
  },
  {
    "email":"busca.simonaroberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921281402/653013a173c61e3f28d3a697064f189f-1730303147"
  },
  {
    "email":"flavia.padoan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921510778/87264b112d838e154209b79939f58f82-1730303147"
  },
  {
    "email":"capone.serenavita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921576314/abe7717ba4116a004f245acb3041165b-1730303147"
  },
  {
    "email":"francesca.graziuso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921379706/a59188201db4ce4d0e328ad1f7fb8890-1730303147"
  },
  {
    "email":"monica.garonna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921543546/904a111a6a27b4ae2e84693ea4832fdc-1730303147"
  },
  {
    "email":"fdr0807@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921609082/ca6649e1940000202d5d98d21b23f1e0-1730303147"
  },
  {
    "email":"stefania.d@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921674618/4b06c97407f75c5456896cd4c7646967-1730303147"
  },
  {
    "email":"sonia.sperduti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921772922/792757eb42520a497ccb8b2a32f9b2be-1730303147"
  },
  {
    "email":"info@gabbatha.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921838458/8d2cec7af074433d5480505827bdc685-1730303147"
  },
  {
    "email":"francitor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921641850/8758131049516377e4cdfcfb47a61242-1730303147"
  },
  {
    "email":"alessandraitaliancook@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921871226/8468eaf8a56cb3647448a325c9d130ee-1730303148"
  },
  {
    "email":"sabrinabrusaferro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921936762/6e77b2c4d924f937e540247345e3f4c2-1730303148"
  },
  {
    "email":"beafri74@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921903994/6d21b2e1745ca61a1ce7d23618e9d5ee-1730303148"
  },
  {
    "email":"moronipa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723921969530/11fe1af12ca3d6f9fa96f9c0482c8e1c-1730303148"
  },
  {
    "email":"essetimail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723921805690/ea31cc51892a21d3e00179ef443b9160-1730303148"
  },
  {
    "email":"rinierig@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922067834/3ab33702434f5891dcf01834fe080e9d-1730303148"
  },
  {
    "email":"tizianatiziana1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922002298/702a5864b6cc333171ff11679dbcf424-1730303148"
  },
  {
    "email":"carmenscifo@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922133370/969bd0261a05c5ae07909e8cd39bfc69-1730303148"
  },
  {
    "email":"valerio.delprete51@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922166138/68e960588904da4315d6cd762f0a0cad-1730303149"
  },
  {
    "email":"tatiana.spreafico@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922231674/2dd130f8dc404d5c603f59a8be996fa4-1730303149"
  },
  {
    "email":"lucianasabatino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922198906/852cbdddb38415b5bc172c07316b8e18-1730303149"
  },
  {
    "email":"cvitucci74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922329978/74e4b016245bb7b1cae186a34f782b48-1730303149"
  },
  {
    "email":"scanferlacaterina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922362746/cac56cfe70540c17f9f4a6b9c6ac74c7-1730303149"
  },
  {
    "email":"federicard@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922264442/71cbd025bf1f6ad2da762f220e0c6abd-1730303149"
  },
  {
    "email":"annalisaghibesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922395514/85d40b69bf1d06d37a29ba4ce15debc8-1730303149"
  },
  {
    "email":"aureliavioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922526586/65382d937be2fe963ecb402188930f5e-1730303149"
  },
  {
    "email":"antoderrik@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922559354/c22d42a0b7b2f93ca0f6c109be03cbe0-1730303149"
  },
  {
    "email":"concetta.manto@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922493818/6b7de55013f98ee3f374d03f9998420d-1730303150"
  },
  {
    "email":"terrysmile61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922657658/e009505f2f050bb935c70996110a283a-1730303150"
  },
  {
    "email":"chiara.tironi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922297210/2a9b86e28c5f30fbeffac6480cdfb1f2-1730303150"
  },
  {
    "email":"ginevra.vanni2004@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922592122/b5c465364dccf13b46e27231c74e2dcc-1730303150"
  },
  {
    "email":"caterinajo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922723194/eb7b0183e4b92d81a7ef4ab9d1c3b2cb-1730303150"
  },
  {
    "email":"sabrina.manigrassi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922788730/625cab87899ef70892e05eecad2b558a-1730303150"
  },
  {
    "email":"fravichi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922887034/bc0951555b6d61d375d7e93a5050ab22-1730303151"
  },
  {
    "email":"giuliacasadio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922821498/4c5b122deb931d15b309c6c931ca1927-1730303151"
  },
  {
    "email":"caimmiromina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922952570/1ae0c3dc46d04c30a63a0573e39867ea-1730303151"
  },
  {
    "email":"marimicio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723922985338/2af5339fa6d75176ab407be6ccce899a-1730303151"
  },
  {
    "email":"tiziana.trapella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923018106/ac00c77fe0e7a73bfe9f2dffa135f5e0-1730303151"
  },
  {
    "email":"laura.gangitano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923050874/1ee07a786996d66bea05d2a62eef8881-1730303151"
  },
  {
    "email":"patriziastudiosuccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723922919802/b72d9f07a0d60c6c6cc9d47d0c59d47e-1730303151"
  },
  {
    "email":"pakipaola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923214714/59a8e73fec30d3ee2029f448cda18a7e-1730303153"
  },
  {
    "email":"mezzullo.francesco@gdf.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923116410/e988bd205acae6042ba6be5e07020746-1730303153"
  },
  {
    "email":"valeria.nobili1985@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923083642/a7fa6f9e6faef5c49956585184779ac2-1730303153"
  },
  {
    "email":"maricle@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923313018/78e2f6cbc7ec43b3bc8aed01069568fd-1730303153"
  },
  {
    "email":"gentilex4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923378554/85100b32f9c4a17bb7de42692a99f36b-1730303153"
  },
  {
    "email":"caterina.rizzi.45g@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923247482/c5a8d0f84d1b43c84cc3bbb065226c22-1730303153"
  },
  {
    "email":"parolini.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923181946/9f57a9b1e768eec26adb7900df045366-1730303153"
  },
  {
    "email":"fabiola.ma@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923411322/913896c6683007cab07fc35c44ab4225-1730303153"
  },
  {
    "email":"cristina.calizzani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923444090/dbf2193640ef51214563be254f57b014-1730303153"
  },
  {
    "email":"alberello.it@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923476858/30059c62af864f342b7f22ab08522ebf-1730303154"
  },
  {
    "email":"forconimora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923640698/f039a25422af5a45086f87a7d82469ff-1730303154"
  },
  {
    "email":"guzzetta.melissa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923673466/0466e4382f7a7a12fdc10c3aabf69bca-1730303154"
  },
  {
    "email":"taccon.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923542394/b1d68a018e7a265f407749a66992f827-1730303154"
  },
  {
    "email":"mariannamormile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923771770/3fa7f47abaa9978cc1ec811dbe7fbe3b-1730303154"
  },
  {
    "email":"avv.abellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923509626/0746766b3b541e9b688f19bb72a2e23c-1730303154"
  },
  {
    "email":"mariavincenzanapoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923804538/7ce094afd6eb0a5a2118b963aad30451-1730303154"
  },
  {
    "email":"daniela.palanti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923739002/641186293846146294c934ed54b5de45-1730303154"
  },
  {
    "email":"marida.vatteroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923837306/86894c7d8b0537ebdf0b7662d3915b6c-1730303155"
  },
  {
    "email":"daniela@druidonet.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923902842/f4d72a40d4b79e38bfccf7300fe69777-1730303155"
  },
  {
    "email":"pizzarelli.annamaria81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923968378/c7e674a7a8dd000a65774d62d91dcd99-1730303155"
  },
  {
    "email":"annasorci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723923935610/8303e7c28a562b232318626775c3eb61-1730303155"
  },
  {
    "email":"assunta.tortora@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924033914/140b4fa8a70de7cf700ea8350901c768-1730303155"
  },
  {
    "email":"margherita.maffey@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924001146/1510cf82c1a8a6aff8e709b37f1f7d3f-1730303155"
  },
  {
    "email":"galassiserena78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723923870074/2e37348a507123ba699f4fa867c82ea9-1730303155"
  },
  {
    "email":"zanconatogiulia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924066682/0e3badc1c0db9ebbee591d1469d6b110-1730303155"
  },
  {
    "email":"alice.canu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924230522/48c1193e319ebbeb715aa095ff4acb60-1730303156"
  },
  {
    "email":"gel.arch@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924197754/4c3e1706bc6cf3f5f67d353aa6cb28de-1730303156"
  },
  {
    "email":"alxs7908@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924164986/484f6ff9cbc65f0cc88262a143a49fc9-1730303155"
  },
  {
    "email":"iva.spano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924263290/d134abe15fdac6702b0aace5a30db1ad-1730303156"
  },
  {
    "email":"mariani.fiorella151@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924296058/9c06e039567f02c0f07cca1d9acd1caf-1730303156"
  },
  {
    "email":"paolagiavara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924394362/9b31dea1e9f829f434c4258f1793e851-1730303156"
  },
  {
    "email":"mancimari86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924459898/b35d023a983553a95444eeb7e53dfcdf-1730303156"
  },
  {
    "email":"emilianapolitano27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924361594/e9ef83eec0f510dc4318932db5d9b01f-1730303156"
  },
  {
    "email":"gabrycola77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924492666/7dcd38bcf72b5342b7dd8a4db0c74479-1730303156"
  },
  {
    "email":"ale.viva-76@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924427130/1c9657fcc9ca821d46db70d665f7489d-1730303156"
  },
  {
    "email":"lorenzo.frondizi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924525434/3088cafde80ec9df8221ae4d59f2e941-1730303156"
  },
  {
    "email":"smiledv74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924590970/97373d1341aa0c0c990c35188a4f85f8-1730303157"
  },
  {
    "email":"daniela.venza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924558202/292a17fb72623a9ab2fd64f227a12216-1730303157"
  },
  {
    "email":"laurettabk@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924656506/590aae430f37c012516abb4044018e60-1730303157"
  },
  {
    "email":"limitonevittoria2016@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924689274/c7cff2537360e02ce5a8fc56181f0ca2-1730303157"
  },
  {
    "email":"dvitali97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924754810/ed042817b84bf50ee1eaa72fbdc3ce3d-1730303157"
  },
  {
    "email":"carla.manduchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924623738/f8587b81629946794a06e6d925d8553c-1730303157"
  },
  {
    "email":"danielacaira@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924787578/801b3247f33f74e68cb7fdcde55cef34-1730303157"
  },
  {
    "email":"rosacardone65@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924722042/92cde18132d8c4c993d749a236836c3d-1730303157"
  },
  {
    "email":"stefania.boldini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924820346/d15c528685c286cf785c472ffdf88070-1730303157"
  },
  {
    "email":"ingalessandroinfantino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924853114/2a1d683b52d3d41f74429ad4e0f73bd5-1730303157"
  },
  {
    "email":"ele_edo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924951418/cfb0bfa50a10e75afa14d8f253716990-1730303157"
  },
  {
    "email":"c.traiber@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723924984186/f9c679f69038eea8ff75ac0cece06cfa-1730303158"
  },
  {
    "email":"minasacco64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925016954/237d3e47ddef0cc5d71b12c9a8f87669-1730303158"
  },
  {
    "email":"marialinamorelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925049722/2f3941001e387366a7edbeb173bb7e63-1730303158"
  },
  {
    "email":"francesca.truddaiu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723924918650/97e327bb84c64b2ddac95e3ee47895a7-1730303158"
  },
  {
    "email":"annamaria.bonizzoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925115258/004da377d0df8633dc569ce83d01974d-1730303158"
  },
  {
    "email":"matildemichielotto20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925148026/6e321ee03c33c960f0c2a0c39738ea60-1730303158"
  },
  {
    "email":"fcapodagli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925082490/76395cb7976a8d8130a02b6b566ad02f-1730303158"
  },
  {
    "email":"gdangelo@unime.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925213562/3c3b511fb8ccdeadbb4b10adbb4198ec-1730303158"
  },
  {
    "email":"aregoladartelamezia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925180794/798a8342304f213b5284afe3009cd002-1730303158"
  },
  {
    "email":"mariacortese197770@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925246330/4777a159492d825d42766c3c2c9f6f6d-1730303158"
  },
  {
    "email":"evaperciavalle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925279098/9da4ea4c30cc3e96e808c4fee338735d-1730303159"
  },
  {
    "email":"annalisa@antoniazzi.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22723925344634/00b02873b47d3938ae61dd741ca0da59-1730303159"
  },
  {
    "email":"azzurraferi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925311866/9fef07e2cdac2f2fac695cd69f94c8fb-1730303159"
  },
  {
    "email":"gabriella.ferraro@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925410170/ff0c90e6f43923865653e4bc6bccb633-1730303159"
  },
  {
    "email":"a.martu75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925377402/e14a1746c8ff4f87032b2d75c442c956-1730303159"
  },
  {
    "email":"raffaellasalvarani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925475706/2b979d13b562b260675c6cd1fddfe5e7-1730303159"
  },
  {
    "email":"laura.ciceri71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925508474/bfd01bb571f0b42879d502c1d418b993-1730303159"
  },
  {
    "email":"mauraeliafumagalli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925541242/ccbb6adc086ef7826ed083763728f749-1730303159"
  },
  {
    "email":"grecosalvatore65@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925574010/d453f3e11241d0d0be03274243d9d863-1730303159"
  },
  {
    "email":"mrcrnld@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925639546/a761a31240500bd3562659048157bf0e-1730303159"
  },
  {
    "email":"alessia.vigolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925672314/5215f397aee4ff566b53ded9155b9359-1730303159"
  },
  {
    "email":"sabrinacorti75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925606778/d1deab1d4a65d50310172bca445aaf08-1730303159"
  },
  {
    "email":"g.rotriqueenz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925803386/81757b011643408900de7dfb3d7c2a9c-1730303160"
  },
  {
    "email":"manila58@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925901690/e23877fe5a095358d6e0c800bebb6709-1730303160"
  },
  {
    "email":"daniela.aguzzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925705082/92d944c6413b830db05082d72c6dfdc7-1730303160"
  },
  {
    "email":"francescamondella@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925868922/1bb934980010fd85b1dc82ac68c421e6-1730303160"
  },
  {
    "email":"del.fil@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925934458/de8e05f25f53db5745f2043f926542fe-1730303160"
  },
  {
    "email":"rosatody70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723925967226/058ef39e42f047c605daf3a64d6f6fd4-1730303160"
  },
  {
    "email":"pinobiscari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723925999994/0c9189de0a41443b85f9f69991c54b47-1730303160"
  },
  {
    "email":"annaritag67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926032762/10fbede7cbb155df5428be0a4fb8747c-1730303160"
  },
  {
    "email":"simona.dimartino@studiostefanomelis.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926131066/e7f3dbf3ea54364877a6b3762901f516-1730303161"
  },
  {
    "email":"carla.liber@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926098298/2bdd3d5f7822372ab146d89b953e8555-1730303161"
  },
  {
    "email":"paonecla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926065530/cdf60dfff1280eaff66b93b89b04edda-1730303161"
  },
  {
    "email":"saraferro2310@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926163834/5ef388931d531376f60b8f0650189708-1730303161"
  },
  {
    "email":"suelafarruku85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926196602/afcb95ea3730aa9182f11a01fcd0d86f-1730303161"
  },
  {
    "email":"daniela.scatena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926229370/96673699b5e09411e2681f9bfcd9cd92-1730303161"
  },
  {
    "email":"claire.damonte@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926327674/33739673fec15d16c2721444255ffc7e-1730303161"
  },
  {
    "email":"claudiacristiani8@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926393210/a03cfda2bd8d825afef24d24d907c431-1730303161"
  },
  {
    "email":"lorece1958@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926425978/8944af8c69f83d669db46e2230d2749f-1730303161"
  },
  {
    "email":"maria.cangemi@ipsiakr.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926458746/2ed724ae30dcf8c13a87ba0056a5bf49-1730303162"
  },
  {
    "email":"simonabinetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926262138/2cb11f51cc359b782ea7fd6f47502371-1730303162"
  },
  {
    "email":"paonedan@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926491514/57f6ebfbe5105ed351c776d46bd186b0-1730303162"
  },
  {
    "email":"albergoastoriaa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926524282/e4ee1137092d9d066de92d36bcff5589-1730303162"
  },
  {
    "email":"dajla20@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926557050/4e6bf0b1d9f7b2d4c46a438cba023492-1730303162"
  },
  {
    "email":"marina.capelli67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926294906/b0ae7c82fa51c4197dd9642e115dd41b-1730303162"
  },
  {
    "email":"marypulejo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926622586/530d7d135860bc88e1bac45406f25920-1730303162"
  },
  {
    "email":"michela.vitq2611@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926753658/9a5aea4cd5cfc63850b044fb5ca167a9-1730303162"
  },
  {
    "email":"paolo.oraini@unipi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926720890/68b2d9da6b45e753fd1cadb2f3e20858-1730303162"
  },
  {
    "email":"cristiana.pallottini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926786426/45577204d85163a3d28f2f659097b80a-1730303162"
  },
  {
    "email":"ritarcadi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926589818/26d0af2dc0d96d39466d82b6b5ff5da7-1730303162"
  },
  {
    "email":"giusi81.giordano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926819194/0786d8e022d4c49af2aef05178261fae-1730303163"
  },
  {
    "email":"giovanna_innocenti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926851962/c044678e46c606d9e3fd2d04eae83842-1730303163"
  },
  {
    "email":"ale190666@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723926917498/3988de7da7e8cdc52b11fb601fd0c17b-1730303163"
  },
  {
    "email":"lyusonemy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926950266/e0c6977807107d7b95581a04150ab101-1730303163"
  },
  {
    "email":"serenagnudi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926983034/dc444ec06fa4c4b7fd10f5ce8c637516-1730303163"
  },
  {
    "email":"amelia-albertazzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927015802/9c76533fa445acce0ab43bacc4469627-1730303163"
  },
  {
    "email":"donatinatravascio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927048570/e9617d3515706cb23390ca79c6b6a01c-1730303163"
  },
  {
    "email":"francidomeperrone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927081338/dc57a04fa5746143828cc9aa5a0dfd8b-1730303163"
  },
  {
    "email":"francescaromano1602@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927114106/a381f68e769336ed24ede0b2c8ef4925-1730303163"
  },
  {
    "email":"francescabiolo.93@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927179642/dfee0359c430a80a5bf3d5acc44d6cd4-1730303164"
  },
  {
    "email":"turininadia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723926884730/2f1ebd2dc53dcd5b580b3951f05aa9d2-1730303164"
  },
  {
    "email":"cristina.pizzarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927245178/ad085dd41c9fa9f2f0228d56f754cb32-1730303164"
  },
  {
    "email":"caterintiglietta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927277946/f6a22d2d35667d0420214f2cd8c53fa4-1730303164"
  },
  {
    "email":"avv.naccaratorosellina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927310714/8c768972917bbe99251f362bbc8dff40-1730303164"
  },
  {
    "email":"simona.dolce@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927441786/1e86d40d5a3eb12b7d170c97a974d7da-1730303164"
  },
  {
    "email":"sanlinopapa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927409018/50e4ff91fe24bc0068c8e457059c202c-1730303164"
  },
  {
    "email":"erika.bassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927212410/9aa75fd5bd379914c073fc66f6afe554-1730303164"
  },
  {
    "email":"riccardi.sabrina@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927474554/172a02c6ae01bdef407d4e5dd352f3fa-1730303165"
  },
  {
    "email":"anna.garbesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927343482/977029f8e80f5950b3d7610086776760-1730303165"
  },
  {
    "email":"bimba8181@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927572858/d1c739bb35713fd44e55fb9b4120a966-1730303165"
  },
  {
    "email":"soniasonia25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927540090/5c595fa24eb73d4c2529770d089e6ca6-1730303165"
  },
  {
    "email":"simonetta.morel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927605626/b2c50566c1128295f5f24f9194a3bbc9-1730303165"
  },
  {
    "email":"salvucci.lara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927638394/fd2ab644bb5e401fa9d61c7fba45be8b-1730303165"
  },
  {
    "email":"michelama21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927703930/15927c69353ced4a55b8e2842d5b960a-1730303165"
  },
  {
    "email":"francescalollino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927671162/b75aac6c895f2da8d2a79793f5e95d68-1730303165"
  },
  {
    "email":"monicapao78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927736698/6bfb353d43aa214b42bd9dcbdc05fdac-1730303166"
  },
  {
    "email":"daniela.scuteri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927769466/e4e91065cfd0a07983ff76d11764488e-1730303165"
  },
  {
    "email":"lisaraf@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927867770/a097cc11596c3eeb05adb2c3c92c6790-1730303167"
  },
  {
    "email":"patriziadb66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927802234/10949de7ac3c91cd02d51a53a37bea5a-1730303167"
  },
  {
    "email":"antonini.nico@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927933306/3d8d0382a294cb7b840887c9b6972c54-1730303168"
  },
  {
    "email":"ziomitch@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927966074/1dc8e877d7aa2afaaa59791aea003a2d-1730303168"
  },
  {
    "email":"birillo006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927900538/4faaded3ab378719ee65c3cddc4299ae-1730303168"
  },
  {
    "email":"costaisabellachoara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723927998842/cc8a84327b61e356a600bb703e0c9877-1730303168"
  },
  {
    "email":"tiziana.dimonte@studiocristofanelli.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928064378/51e2e66392d9bf19cf31ee562f96c781-1730303168"
  },
  {
    "email":"nicomira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928031610/dc3904060977333e6899be3f21067744-1730303168"
  },
  {
    "email":"g.pacchiana@avvocatipacchiana.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723927835002/e24867a4bb69c5203011006d36e96536-1730303168"
  },
  {
    "email":"federicadebenedetti2001@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928097146/3142a7331a50fd7f68a07d7377749227-1730303168"
  },
  {
    "email":"elisabettaferrario@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928162682/b632e9810ad7177ced75c7439cd36269-1730303168"
  },
  {
    "email":"e.preto83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928195450/136d9c8e22ec6607d9fe39e7458f948d-1730303168"
  },
  {
    "email":"samubendu@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928293754/c8c6f24b65c0f0f34fea2bb15f93b6e3-1730303169"
  },
  {
    "email":"lugra90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928228218/53fe5e0eaf9bcd8270f1fa780339805a-1730303169"
  },
  {
    "email":"toniamarinelli2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928359290/3a124c0e8aae07f2430185f1f113aeba-1730303169"
  },
  {
    "email":"lorysissi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928424826/7f4bbf2956974f0a130de8f46ff516a4-1730303169"
  },
  {
    "email":"franzandoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928523130/ce9a377b7030773d7f65ba6509ee2389-1730303169"
  },
  {
    "email":"tamagnolisabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928457594/1c865553e076646fb52fae5e07cdc5b3-1730303169"
  },
  {
    "email":"stefbellesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928129914/3d2fbb763305727ba673e111bc54c01d-1730303169"
  },
  {
    "email":"defranceska@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928555898/057c049c38c4490c280fa79a77816370-1730303169"
  },
  {
    "email":"carolabertoldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928588666/0aeb181012e145f179d0ca579f869e42-1730303169"
  },
  {
    "email":"cinzia.minacci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928621434/98fa2cefa247c42b3918a62e1c51b742-1730303169"
  },
  {
    "email":"seriolifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928686970/6df7b84e44101785b0469736b08a5bb7-1730303169"
  },
  {
    "email":"viscomi_marianto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928850810/0d82ef6d9f560b111c43d95457a2cb36-1730303170"
  },
  {
    "email":"and.morelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723928654202/f978c2481c5fbf97c648cdbd225a6572-1730303170"
  },
  {
    "email":"monica.mastropaolo@studiomancaruso.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928883578/d17e38e87a71d8d2e689abac751d3dc9-1730303170"
  },
  {
    "email":"sony.filippini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928916346/aba4902e2a217e9d5ab9a83fbc88216e-1730303170"
  },
  {
    "email":"moqui15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929047418/e16ed2981869bd6b6f8b75e13e466b67-1730303170"
  },
  {
    "email":"patriziapetrini62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723928719738/f7abf5e31097646256ed8ce7acc5e949-1730303170"
  },
  {
    "email":"mammaniko123@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929145722/a2f1a3fa66a73caafb5cbe1568c03674-1730303170"
  },
  {
    "email":"ingridfloriana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929112954/ecd42b6690d85f55327bec4f3544636d-1730303170"
  },
  {
    "email":"avv.piovano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929244026/1ba3b3b70288145d1b02bd9a35db4d57-1730303170"
  },
  {
    "email":"gianlucaboniello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929276794/ca38d1102a7d3ab3d3c07e40a96d067d-1730303170"
  },
  {
    "email":"manila.p@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723929407866/426ca42c0b79d1203b6f96f1bc9b7515-1730303171"
  },
  {
    "email":"marinmonica1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929309562/8043581aaf6c33e3b9a0a7160d99606d-1730303171"
  },
  {
    "email":"stefania_ravecca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723929440634/f98ca477e5157f8b27696444dafe413e-1730303171"
  },
  {
    "email":"zatti.sas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929342330/633c8f5ecec6aa34a3aadeaa1ed6cc51-1730303171"
  },
  {
    "email":"alessiafederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929506170/4d0312e84c0250d038a695819e427280-1730303171"
  },
  {
    "email":"klipsya.cr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929538938/7f4b9eb6d0e35454f9a94e2bdb776c26-1730303171"
  },
  {
    "email":"jenni.fortini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929571706/31b255d2a0ef9d0be259d72b95df5c35-1730303171"
  },
  {
    "email":"ingrid.nikpali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929473402/0362559e8cbb0fbcdf59a092273679dd-1730303171"
  },
  {
    "email":"isaia.stefania.si@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929670010/3c0bc298715b8f025d0050bb8f0b2d10-1730303171"
  },
  {
    "email":"robymod71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929604474/8654bfbb0003570f2887b3e7943db55c-1730303171"
  },
  {
    "email":"isadora.lebouillon@yahoo.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22723929768314/c380e5b6be9c2e3e669f094f27143c28-1730303172"
  },
  {
    "email":"eleonora.ragni01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929735546/94080079d88b016e255feef5281f6ab5-1730303172"
  },
  {
    "email":"cr1c3tina@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723929833850/4ab99ef72671c6f8611ed65fbdbe467c-1730303172"
  },
  {
    "email":"luisianadambrosio1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929801082/e4dd56c80aa19bdead237b74cbd55305-1730303172"
  },
  {
    "email":"antonellacorona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929899386/c0f4338879b2c89c38550acb8c39da84-1730303172"
  },
  {
    "email":"sabinabiancu@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723929932154/371bedd474f42e29c8ace9773e250046-1730303172"
  },
  {
    "email":"pantera71.es@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929964922/6529b72dfb0e3b7391c835011b426822-1730303172"
  },
  {
    "email":"biavastefania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930063226/c953627b0f1568bfc8ef94f16b7e73fd-1730303172"
  },
  {
    "email":"bresciani.daniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930128762/880dbbe37c7b249c3ac43ce75a6a68ba-1730303172"
  },
  {
    "email":"fede.guglie1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723929866618/a4838d02ffbfb0af0e3dd4bb644a3449-1730303172"
  },
  {
    "email":"simona.errigo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930259834/15fefad8b7dee093cd75bc2ba8df1f19-1730303173"
  },
  {
    "email":"raffaella.spada07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930292602/cfe0216aaecac7b5314f8d47c60fd353-1730303173"
  },
  {
    "email":"fabiolafilippini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930161530/5f759a753c7c0563330a3f27130fbb8f-1730303173"
  },
  {
    "email":"azzurra.n@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930095994/63d77d6906afd7a1f014ab7642f295a1-1730303173"
  },
  {
    "email":"mgalluccio@holonsrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930456442/3c02b94aa8aa5fa13f786d8114ae84b0-1730303173"
  },
  {
    "email":"luc.bertelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930489210/2c592eaef7925d1f28af748ad8e050cd-1730303173"
  },
  {
    "email":"mcgusmini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930325370/30b13adf335d828d5675e6c464725f0e-1730303174"
  },
  {
    "email":"a.grasso@grasso-law.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930390906/edae6098f8c996b070614bd181242206-1730303174"
  },
  {
    "email":"dorkaty@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930423674/00387a408f710f9186caebe0cfe82ecb-1730303174"
  },
  {
    "email":"serena.bellari@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930521978/21dfb6f73a8a3eb1f67bfa8bfa5ef05a-1730303174"
  },
  {
    "email":"giorgiabellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930554746/9adb5e828a32f3972be302bdb4b260ca-1730303174"
  },
  {
    "email":"vale.gullini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930620282/8aa17478bcf34522db26b6742ca99dee-1730303174"
  },
  {
    "email":"stefania.finelli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930587514/715a76a454b2c1498481d9f0ca600aaa-1730303174"
  },
  {
    "email":"virgola_1982@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930653050/ebf07536cb747a7e0594510428ce8d9f-1730303174"
  },
  {
    "email":"scaffi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930751354/1f4ebf11bab8e6ea0b3ee4107fe65539-1730303174"
  },
  {
    "email":"adrynalo1985@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930849658/ee26df27d38432c55e482c15bc2d4ab6-1730303174"
  },
  {
    "email":"gloria.ballariano@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930816890/13e5d3e5ac14cb1744467a6ec595b7b3-1730303174"
  },
  {
    "email":"le.massai69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723930915194/d0f0d4a02c133456bf0921d4292e87eb-1730303174"
  },
  {
    "email":"chiara.cesena@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930784122/5ee1d0967c9caddea557b4edfc1d2aca-1730303175"
  },
  {
    "email":"manuela@arcovacanze.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723930980730/5be9a3a5a35ff36458d6ed95b8c64cd2-1730303175"
  },
  {
    "email":"palottomarialuisa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931046266/814272673d0d3d15a781c7ad9043f414-1730303175"
  },
  {
    "email":"valentinacomp@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931013498/ab717d27ef9ca3a62aea7b57ce85b768-1730303175"
  },
  {
    "email":"simonacavinato1972@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931111802/2b216f129f15612bdb47fbf4d5a8a202-1730303175"
  },
  {
    "email":"barbara_armano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931177338/216911da104405c435b74039c148060e-1730303175"
  },
  {
    "email":"caterinademaria@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931079034/8f4747c3c4c93095bace06bab7aa88d9-1730303175"
  },
  {
    "email":"fabyl76@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931308410/7ae1288637078a90ff58cc6bfbd6b476-1730303175"
  },
  {
    "email":"giovanna.clivati@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931242874/54aef50924698c3afa78e2fbb868aee5-1730303175"
  },
  {
    "email":"raffibet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931373946/50f178a6bc0a4d0920afb951241c526d-1730303175"
  },
  {
    "email":"raffy.morini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931406714/fadd25a2ede7219f4b13fea3bf8a7563-1730303175"
  },
  {
    "email":"sabattiantonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931439482/94e49947f3e12d7b75b08e686774a6d2-1730303176"
  },
  {
    "email":"federica.sofigiugiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931472250/8168bb19ec2b474d6f3879f6d2562fb9-1730303176"
  },
  {
    "email":"valegiova@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931570554/6c28cc624b5311744010c37cb4952316-1730303176"
  },
  {
    "email":"giuliavittoria31@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931668858/b535e6dc97abd55053ec18ebc33d8304-1730303176"
  },
  {
    "email":"alessandranocentini82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931701626/81e0afc09a1fd8f4d308316fe6cded2a-1730303176"
  },
  {
    "email":"vanessacambianica98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931734394/1ac75b28842c39681fefc650c943ffc3-1730303176"
  },
  {
    "email":"aaa@aaa.aaa",
    "url di attivazione":"https://verdissima.it/account/activate/22724024697210/049850be432133b04bb812e34a1feb22-1730303176"
  },
  {
    "email":"pdtdaniela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22723931505018/915a28622148a93e29c53bb2693580c4-1730303176"
  },
  {
    "email":"barbaramengucci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22723931603322/c53b9683fefddc155ef34362130c304e-1730303176"
  },
  {
    "email":"a.castello@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724024729978/d8654a6e813a40210213b595bd6be330-1730303176"
  },
  {
    "email":"a.giorgetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724024795514/9a8b7e7e23d8e755cdee4d45345e6155-1730303177"
  },
  {
    "email":"a.veronelli@studioandreagaetani.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724024762746/d8b3fb3427527dfc26d22184028200a3-1730303177"
  },
  {
    "email":"acasadimaryon@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724024893818/d0607b333edca6f542ab9c89018c11c4-1730303177"
  },
  {
    "email":"achiropita.lepera@uniba.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724024926586/a16931bc9e9855db34f29e67ee9ebf57-1730303177"
  },
  {
    "email":"adami.giovanna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724024959354/db5f4d016f0e4c0e65636495bccb12bf-1730303177"
  },
  {
    "email":"adstudiohairgrosseto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025090426/c7eb68e840234f4e9eda38ec012c9710-1730303177"
  },
  {
    "email":"afcostruzioni1959@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025123194/23b7bc7e2ab58531a6e4b5d2e1fa7ec9-1730303177"
  },
  {
    "email":"adelevergreen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724024992122/a27c819ddcda180bb839aa2da259c498-1730303177"
  },
  {
    "email":"ale.lombardo74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025188730/5010aa23477a2802b0a59377e66a6424-1730303177"
  },
  {
    "email":"aicardi555@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025155962/161480ad2f2820323b788ca72b960c83-1730303177"
  },
  {
    "email":"alessandra.calendi@fhpgroup.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025319802/806abaaa4fb26308598e703b6f75724f-1730303178"
  },
  {
    "email":"alex-amorosi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025385338/a03a305df72585f736101cff91a903b8-1730303178"
  },
  {
    "email":"alfonsoamitrano1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025483642/f8aa64f7c97501a04ec30b2ed688242b-1730303178"
  },
  {
    "email":"ale.tortarolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025254266/89b18cc39087d8e874539d6b505949e9-1730303178"
  },
  {
    "email":"alice.ciccarelli@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025516410/41d72e11c16a730ec5936cfabc18f683-1730303178"
  },
  {
    "email":"alice.flauto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025549178/b43c1adb2a03da0d59fce7abf71859b1-1730303178"
  },
  {
    "email":"aleppicina@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025352570/10ef0a211c946047a58088504fe4a817-1730303178"
  },
  {
    "email":"alidangelamail@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025680250/ebb49cf89dc99c7d8a00712d86ed346a-1730303178"
  },
  {
    "email":"alimar2020@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724025713018/b1acb02f1dafbc85a95b5be4ce30ccf7-1730303179"
  },
  {
    "email":"alicegiuliani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025581946/e97f728cdcc13f3b6c5bb3207f4823ea-1730303179"
  },
  {
    "email":"allachim.ac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025745786/fb965779018fc16862e00c689041eb3b-1730303179"
  },
  {
    "email":"alpiluva@graff.net",
    "url di attivazione":"https://verdissima.it/account/activate/22724025909626/ab567260c8ff20f9308f3be061f3bb1a-1730303179"
  },
  {
    "email":"amelia74.romano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025975162/69317442f913053a6aebffc5f2d88aa7-1730303179"
  },
  {
    "email":"aminichino@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026007930/9e5046516d8ca4262d065129f7a89984-1730303179"
  },
  {
    "email":"alidagiacobbe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724025647482/62dedd2f7f276aa86ab442b6af30a0d9-1730303179"
  },
  {
    "email":"amministrazione@chimitek.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026073466/01168b2c83413ead072c4620d1c7059e-1730303180"
  },
  {
    "email":"amministrazione@ellemmeattrezzature.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026106234/a08d247626a2d0024b5f00e0ca6dc175-1730303180"
  },
  {
    "email":"andreamodelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026302842/a9fc2ba39c6cf6f23b33a40610f8bc05-1730303182"
  },
  {
    "email":"andrea.ianda72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026171770/aa1209f61a67ac87915c94cb243cb75c-1730303182"
  },
  {
    "email":"angela.fiore76@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026270074/97891dc64ed33fc54ac4a7be569abbdc-1730303182"
  },
  {
    "email":"angelo.pandini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026368378/7a7a7c761a972ad7fc29dfab3e58f91d-1730303182"
  },
  {
    "email":"angj1dep@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026433914/31ecf3930f3b0793c22fe4dbad594cc6-1730303182"
  },
  {
    "email":"anitanencioni123@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026564986/4358590b430137a0b03c9423a0f1ba5a-1730303182"
  },
  {
    "email":"ammidentalstudio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026139002/c69e05720eb5786903eacc0abb6d5686-1730303182"
  },
  {
    "email":"anna.giuliano.ga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026696058/c6643af9fbf5a05884041e5059911484-1730303183"
  },
  {
    "email":"anna.gallo889@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026663290/b1598d1f249d9b1fa4ec22d734f1cd8b-1730303183"
  },
  {
    "email":"anna.chiti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026630522/391d92b48694fb515fe968f83b9a3b0c-1730303183"
  },
  {
    "email":"anna.canoci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026597754/a3823584b243833480fbc09237e011a2-1730303183"
  },
  {
    "email":"anna@adaminet.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026728826/5ce68dbb2e7878dbfd3edbeed0336801-1730303183"
  },
  {
    "email":"annalisaazzolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026859898/99379facc34e4b562fbcd10244d1198b-1730303183"
  },
  {
    "email":"annaelisa2122@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026827130/99fed495092405eb3dd7d2631c471dc8-1730303183"
  },
  {
    "email":"annacapparini@unahalto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026794362/39b9220fbcb2add8c1b9643e2c569ad9-1730303183"
  },
  {
    "email":"annalisasanna75.as@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026892666/821c3da953a86258f1ab076596958906-1730303184"
  },
  {
    "email":"anna93azzola@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724026761594/fb34b121ce694108e344d8162e0ad508-1730303184"
  },
  {
    "email":"annaluisadellanna84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026925434/4076d41b4e823a1733b580fe202849be-1730303184"
  },
  {
    "email":"annamaria.perfetti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724026958202/10214f726ab90eeaa0f0d6cce290f686-1730303184"
  },
  {
    "email":"annamelchiorri@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027122042/b2785d597500f4d997e980555b2a1026-1730303184"
  },
  {
    "email":"annamoscariello@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027187578/d6a3ce6c9cd472424934e1bec505688a-1730303184"
  },
  {
    "email":"annamuraromaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027220346/0f073ea43d4be7b08049143ab970ac54-1730303184"
  },
  {
    "email":"annamariasarlo58@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027089274/cbe06c24151fbe2128c727ad6e4684fc-1730303184"
  },
  {
    "email":"antonelladisabantonio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027318650/dde90bd6dafa3152e6c50fc5ae2d2c6f-1730303184"
  },
  {
    "email":"annarita-palladino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027253114/6168aaf4bd1c75fdbedde4d7e5819621-1730303184"
  },
  {
    "email":"anto.cesareo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027285882/8c752c1ba8ec8412bdf46f16da8344db-1730303184"
  },
  {
    "email":"antonellamollica1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027351418/cfb50e70252e2b330a446a6971cd6313-1730303184"
  },
  {
    "email":"antoniogiacobello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027515258/0a0348382a1398b3797c911c5a993664-1730303185"
  },
  {
    "email":"antoninichiara79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027482490/ff9e7f47ce4219e6a037b17d99247401-1730303185"
  },
  {
    "email":"antoribecco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027548026/dc444974d92af8a2eeab93eda397409f-1730303185"
  },
  {
    "email":"antonellatantillo@gmsil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027416954/62687da273f0522e02a138c064cb0ed0-1730303185"
  },
  {
    "email":"antoschiappacasse61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027580794/3b619666af3a42785cb69b0307f14f14-1730303185"
  },
  {
    "email":"apeacock07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027613562/38f5b19e22d93e80e96d314224921ae8-1730303185"
  },
  {
    "email":"ar.moressadaniele@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027777402/b2e38b8855d14b4b2038058e0f422cee-1730303185"
  },
  {
    "email":"apiccioli@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027679098/908cbf99a7e4cb6cbef2a04572dfdbdc-1730303185"
  },
  {
    "email":"arcabasso@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027810170/bceda14f37bdbd790f339ddf8f44e974-1730303185"
  },
  {
    "email":"asca.posta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027842938/c16661f36d9a7b17f3b8a641f67aefb4-1730303185"
  },
  {
    "email":"asp.097713@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027875706/d0b72c12fc295661954e0bf72420f890-1730303185"
  },
  {
    "email":"apibiri69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027646330/d79f725e0e099c4d998bb582e1622298-1730303186"
  },
  {
    "email":"associazioneangelidellanotte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724027908474/51d6625cc84cebad7e0670bb646fb453-1730303186"
  },
  {
    "email":"atilvenna@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027974010/5b26f6639f4889972d4cc973810df32e-1730303186"
  },
  {
    "email":"auroragulla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028006778/3c404ed7eb4b18c8cbc89b02fc3d4c45-1730303186"
  },
  {
    "email":"avv.michelacongiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028039546/9de300feabb8a574f8dfaa1b829b830b-1730303186"
  },
  {
    "email":"avvocatogiorgiodimicco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028105082/49f1085add65717d1bb734d302f89a99-1730303186"
  },
  {
    "email":"astolfi.laura@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724027941242/6c1e3ddbf97763fbe540c49bd0ec6ce9-1730303186"
  },
  {
    "email":"azzollinomaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028170618/2f14981021eceb0cac7ac7e161799c99-1730303186"
  },
  {
    "email":"babilan78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028236154/068b716f387c42d3e15358a475194b4f-1730303186"
  },
  {
    "email":"babsi.wierer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028268922/418b31afa0f8b662d498d8dd4f1e9fda-1730303187"
  },
  {
    "email":"baldagm69@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028301690/50cfe1872c9b69699fa7b77f9871356e-1730303187"
  },
  {
    "email":"barbal64@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028399994/298fc5d8fb75399b84e89eb2df810ee5-1730303187"
  },
  {
    "email":"ballin.anna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028367226/ec4ff69ec8ddbf263f21fcbad663f1aa-1730303187"
  },
  {
    "email":"barbara@cafissi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028531066/1adb8a7824b7fb33930174812543daf5-1730303187"
  },
  {
    "email":"bastet2026@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028629370/1af08e0bc80d0636f45f4f093c15d91e-1730303187"
  },
  {
    "email":"barbarapotenzone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028596602/48eafc2d47a86becae5c7ab9997c2141-1730303187"
  },
  {
    "email":"barbara.bonifazi@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724028498298/5733e27354e1ce3884e4632b0b120d24-1730303187"
  },
  {
    "email":"battistonisara08@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028662138/c158ccf7b9ee7f42136d001269fd2332-1730303187"
  },
  {
    "email":"bbosello@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028694906/cfe7facbd030f0c8226ef82e04f6f6ac-1730303187"
  },
  {
    "email":"bernarg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028793210/ccf6977c9c1965495dd0dd311bdfecca-1730303187"
  },
  {
    "email":"berti.elena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028825978/b9c51b42ee5225f0ff33d3bd3b37bdb3-1730303188"
  },
  {
    "email":"benedettamatucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028727674/847e459916a21863cd1526951b709e08-1730303188"
  },
  {
    "email":"biancamariaascoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028924282/3b8a87d85baedaac86f63fd1b74d4616-1730303188"
  },
  {
    "email":"bonadeo.sara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028989818/ad6dd6d195d2c641bf3b7a58deb5e516-1730303188"
  },
  {
    "email":"brigitte.gruenberger68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029022586/bb0c220f391202df7b67bb6b8c35cce3-1730303188"
  },
  {
    "email":"c.luciani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029055354/831eeaca6ef0975527b01c006f6e57d8-1730303188"
  },
  {
    "email":"c67997278@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029153658/11b10dadd0f2363ce3169ead3cb9c3b9-1730303188"
  },
  {
    "email":"c_damato@icloud.con",
    "url di attivazione":"https://verdissima.it/account/activate/22724029120890/5e03b8df4b0530c09a96dc799a3b41b5-1730303188"
  },
  {
    "email":"betty.ferrara1967@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724028891514/39326d9109785ddef8bbafde047cf9e1-1730303188"
  },
  {
    "email":"c94149070@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029186426/cb600cbf56b7e8291001d316a6d84edd-1730303188"
  },
  {
    "email":"cabsi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029284730/e64baac3eaf4dce3aeabe47f3d66d9cf-1730303188"
  },
  {
    "email":"canali_silvia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029383034/659bf7cb5900450621cc296205874ce6-1730303189"
  },
  {
    "email":"camilla.lintas@aulss9.veneto.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029350266/f443825b2984b685c1bf72117728ea47-1730303189"
  },
  {
    "email":"cabsi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029219194/4417e4f60330d94433b5caffbf4978d5-1730303189"
  },
  {
    "email":"carla.carissimo@nausitalia.net",
    "url di attivazione":"https://verdissima.it/account/activate/22724029481338/9cdd616fc919a650b1826e621ccffd9e-1730303189"
  },
  {
    "email":"carmelascandinaro1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029579642/057c862c45e5f838ee3e257f4bb5d7f9-1730303189"
  },
  {
    "email":"capponiandrea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029448570/3098335dc94403c1bcfddb1a40c6e82f-1730303189"
  },
  {
    "email":"carmine.marino03@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029677946/898503736c2a2abbf61f661734a2a684-1730303189"
  },
  {
    "email":"carmen.sbarbaro@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029612410/457165bdfdaaf0fc200387a576399b59-1730303189"
  },
  {
    "email":"carolinacattaneo.cc@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029710714/bc6dc10bd5a0796c86345f15b26f82b0-1730303189"
  },
  {
    "email":"carloada@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029546874/6183be7bc4d31effcc39f859af6dac92-1730303189"
  },
  {
    "email":"cattarinussimoira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029776250/a5121b6b33b162ea4640b9880f45bd19-1730303189"
  },
  {
    "email":"cconti1977@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029874554/430341fcefc09ea7da4121039b881c35-1730303190"
  },
  {
    "email":"caterinapalmieri57@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029809018/327fa0a57fbbaf8e30453746a5e291a9-1730303190"
  },
  {
    "email":"castamrk@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029743482/225ffeaf00624e087ff5edede011a6d9-1730303190"
  },
  {
    "email":"cecilia.10@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724029940090/d258ceecdd8ae64b04e21daebb8ab832-1730303190"
  },
  {
    "email":"chiara.rossi@icportalurago.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030038394/9c8836a75854c5089b6659648d1cb873-1730303190"
  },
  {
    "email":"chiaragiorgetti91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030103930/c7d380e3c95cdb5f588aaddba299a913-1730303190"
  },
  {
    "email":"cenzon.chiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030005626/ea77b903537cb054855c4521b7cb7c34-1730303190"
  },
  {
    "email":"chiaramasutti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030136698/d1c041508e6bceea063a5b46032f06a6-1730303190"
  },
  {
    "email":"celesteclaudia4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724029972858/6ef9d884a1aaf35b971a6314d6a38ea8-1730303190"
  },
  {
    "email":"chiarasagrs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030202234/045242c24758a0d5b28566a72b95aeed-1730303190"
  },
  {
    "email":"christian.pratellesi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030235002/2c60f3729da40323f1de901d9e564ef0-1730303190"
  },
  {
    "email":"ciardellinovella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030267770/138827c1ce7aa0be3010de157f6af4df-1730303191"
  },
  {
    "email":"cinziapolitano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030366074/5901f9697af681d75172e68fefda533b-1730303191"
  },
  {
    "email":"ciro.terracciano.ceo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030431610/403874e55129cb7b7bc49020deef4007-1730303191"
  },
  {
    "email":"ciregia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030398842/7e31cc0e8bdb8463af99510f9d7f5f13-1730303191"
  },
  {
    "email":"chiarasala80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030169466/4418c3349711baa5841710250319cd12-1730303191"
  },
  {
    "email":"claudia_billi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030497146/52cde955bb9187f2df3da99e0f3c8c99-1730303191"
  },
  {
    "email":"cla_toliver@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030464378/2e9e9aed7fa9e38937860f61727c36ff-1730303191"
  },
  {
    "email":"claudiazito1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030562682/690fab0cfe281f117b194f86ab78759c-1730303191"
  },
  {
    "email":"colombo.francesca1991@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030726522/57d7d60141bef6e1513eaee2665421da-1730303191"
  },
  {
    "email":"cmagistrali@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724030595450/1fd875141e4f7e744ff328149a3df840-1730303191"
  },
  {
    "email":"concettarizza64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030759290/ad88874bbfcdf1b76536cc75f79b8ec1-1730303192"
  },
  {
    "email":"costanza.mariconda@studiomariconda.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030955898/f8e12f349d7a157284416fb56a81d154-1730303192"
  },
  {
    "email":"clararuggiero1994@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030529914/1790bf480e60f4e87ef2f898eefa07b0-1730303192"
  },
  {
    "email":"cosimo.marchitelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724030988666/2680ba2f416bc9b1bcff4a4a0ae64426-1730303192"
  },
  {
    "email":"cri.capodanno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031054202/1713545c2aa8e2f48303c1510410ffcd-1730303192"
  },
  {
    "email":"cristiana.libralato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031119738/d643ba442c86387443e985741076fb6a-1730303192"
  },
  {
    "email":"crimagali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031086970/a7d324533294c479ab35af817d312370-1730303192"
  },
  {
    "email":"cristinabonetti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031218042/f840735e86e9fb413803d02c47dc1a0b-1730303192"
  },
  {
    "email":"cristinabargero75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031185274/967613c6048b58f6975820d327401aed-1730303192"
  },
  {
    "email":"cristinafusi79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031316346/0ee3063d8b6c7baa455e48859397c8f9-1730303192"
  },
  {
    "email":"cst.pesce@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031381882/f8ef9c4eb3c5448ce5df3db7a18ab6ce-1730303193"
  },
  {
    "email":"cristina.argentesi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031152506/e5a666c8e15c66ccb7343ceedc7ca431-1730303193"
  },
  {
    "email":"cuccuruanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031414650/cfd251659f37c044aa91d73739f84223-1730303193"
  },
  {
    "email":"crivellinis@mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031349114/89123eac32a9b4496557251995bcbb4e-1730303193"
  },
  {
    "email":"d.meneghello1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031447418/ae5d1577bbacba142143a044085eb8ad-1730303193"
  },
  {
    "email":"dabiasini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031480186/9799d8d5308c95cf6f8d1fdf716ab58b-1730303193"
  },
  {
    "email":"dalpiccol@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031545722/e74a0ec2ca821d025d12f4155a6f0f79-1730303193"
  },
  {
    "email":"daianaciciriello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031512954/0dc3da0f806d10bc9bb315d0087afc7d-1730303193"
  },
  {
    "email":"daniela.bonatogsa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031644026/7237962e82b81112a6e28a5f48261740-1730303193"
  },
  {
    "email":"daniela.buscetto@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031709562/4d3db11f7d0e353ea0ed48a62283bceb-1730303193"
  },
  {
    "email":"daniela.bonato.gsa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031611258/818785fd547d29643c5e4460caaca408-1730303194"
  },
  {
    "email":"daniela.fabbiani@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031742330/2666789ecd67fa318f79c61fa7f9ab1c-1730303195"
  },
  {
    "email":"daniele.magnosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031840634/b00011b77af850daf906ec35e3394be3-1730303195"
  },
  {
    "email":"daniela_delloro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031775098/ba317bd18b7cc98aa020d91ec945908a-1730303195"
  },
  {
    "email":"dashin@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724031873402/4d3a63527ffdc2f0dace6cc511ef6895-1730303195"
  },
  {
    "email":"danielaruocco67@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031807866/1e67c62f566c700ce0b88f653846eeed-1730303195"
  },
  {
    "email":"davide.gambardella@immaginificio.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724031971706/95186fc5756bae640746332d690d46fe-1730303196"
  },
  {
    "email":"deboramucci970@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032037242/134861550b5793886def3fe376bf2fd8-1730303196"
  },
  {
    "email":"deliranzadanza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032102778/ce5131d269f59dd7b14f33d6b0a31143-1730303196"
  },
  {
    "email":"deborascandinaro@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032004474/2bf4f8e948e8c694d51144cdd6f434d7-1730303196"
  },
  {
    "email":"dellaferrera67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032135546/37136d53737a1158f3c95fa685e374b1-1730303196"
  },
  {
    "email":"dem.antonella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032201082/d38508b503dc00aeb18df73041d0e17c-1730303196"
  },
  {
    "email":"distintepia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032299386/3a62b65c08ec0d0cc016a858323bfa89-1730303196"
  },
  {
    "email":"dianoratamburro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032233850/336732edc5556260586800a822f3a5f4-1730303196"
  },
  {
    "email":"dmb.demarchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032332154/d6762403f2296e815494c1615eec2b2a-1730303196"
  },
  {
    "email":"domyol88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032364922/0f91ba895abfc7f3a707e566ece7f014-1730303196"
  },
  {
    "email":"donatellapedani@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032463226/6ca5266ff77dbb623d10a75ace7770bc-1730303196"
  },
  {
    "email":"donamari75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032430458/2c6f383d0fffa516c1defdaaefdb8673-1730303196"
  },
  {
    "email":"donati-donati@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032561530/f82e53a39b40684b84f97eea79b94e5e-1730303197"
  },
  {
    "email":"dorianalabbate@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032659834/a403262c9e90e89470e42389c8b2e474-1730303197"
  },
  {
    "email":"donatellinapedani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032528762/166873016ff7a81e8a4e27b45cf62208-1730303197"
  },
  {
    "email":"e.ettorre@gomecsrl.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032692602/f6bb576fdf6b72fe397ffee750a00d04-1730303197"
  },
  {
    "email":"elda.zanoli@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032725370/ffa0021834017be5132085001827dd6f-1730303197"
  },
  {
    "email":"elebree3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032823674/f5b825156c8fa960bcde84f9a51558ed-1730303197"
  },
  {
    "email":"elena.scotti80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032856442/860fd6ea1074c73fe6a1efbe9c39e562-1730303197"
  },
  {
    "email":"dory.mulas@gmal.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032627066/decfd8d05cace994f5901a56a8f26a33-1730303197"
  },
  {
    "email":"elenabiffi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032921978/c5d150cbbb4359ca5a9dd66573eaa538-1730303197"
  },
  {
    "email":"elena216@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032889210/b965808d3428836258d8ae62b01c6988-1730303197"
  },
  {
    "email":"elenapolichetti@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724032954746/ad468e7923b06f61b222b72ba0b6302d-1730303197"
  },
  {
    "email":"eleonora-locatelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033053050/58cd8df281638a49c825d1747af9b6da-1730303198"
  },
  {
    "email":"eli.capriotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033085818/af0da6b6571689ab84a025dced192537-1730303198"
  },
  {
    "email":"elenvanella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724032987514/84abaa365cb7cfe1d9e115f0877442f9-1730303198"
  },
  {
    "email":"elia.roveredo02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033118586/20cff0b839a20c545937ce4de2071027-1730303198"
  },
  {
    "email":"elianafrisonelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033151354/44668da591651c9226e8eb834debc098-1730303198"
  },
  {
    "email":"elisa.duo744@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033184122/91bbee165ba8944af3fabe59338d0e73-1730303198"
  },
  {
    "email":"eleonora.milano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033020282/9370f86305584c13b34d47fea2b5770d-1730303198"
  },
  {
    "email":"elisabettafraschetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033249658/3c7f1681c5754619b48dbe324f3a2c8e-1730303198"
  },
  {
    "email":"elisabarni81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033282426/486a526de59f59c4b5cb818800879573-1730303198"
  },
  {
    "email":"elyelisa81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033315194/7c6a112a42e1d9a57ee831f1aa2dd577-1730303198"
  },
  {
    "email":"emanuele.bonomo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033380730/cd60bd7061b35363b4675bdd0cbdd0b0-1730303199"
  },
  {
    "email":"emanuela.pege@gv3.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033413498/3ceadb4f87d09896132fbdb83aab1b69-1730303199"
  },
  {
    "email":"emilyparisi79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033446266/5d588671b35dd0f1e14df1e1b3c88fd2-1730303199"
  },
  {
    "email":"emilypic@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033479034/4bcaae7db9cef3f54d4b573dc59cad23-1730303199"
  },
  {
    "email":"elisbettapel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033347962/b9b77c5a3f9b939a4550d99ea3a1ad68-1730303199"
  },
  {
    "email":"emivei@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033577338/835f2e005a02a7133e01d722ed83cd97-1730303199"
  },
  {
    "email":"enrico.margherota@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033610106/b6e06c43f8184a9c92b847c1d96a4708-1730303199"
  },
  {
    "email":"enry75b@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033642874/19cab6652ee90169d1df8817021eec72-1730303199"
  },
  {
    "email":"enrica.mensi@yagoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033544570/4c5b840ce1555e219eb039db8b567853-1730303200"
  },
  {
    "email":"enrico.cianfarani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033511802/e0dad3734c103fe0921ff57e196425e1-1730303200"
  },
  {
    "email":"f.golin@fincasa.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22724033708410/d4cc72c439318157e37ee67c12d2bed0-1730303200"
  },
  {
    "email":"f.ideale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033741178/84a8e40def39b6b3f8ac6e3836b7a6bf-1730303200"
  },
  {
    "email":"f.tommasin@tommasinfondi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033773946/99ee901ae2b82347c7aadc543441399b-1730303200"
  },
  {
    "email":"f.totonelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033806714/4c94e5f7c3301b96f07737c519f418ee-1730303200"
  },
  {
    "email":"es.logoteta@politicheagricole.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033675642/c1a9cfaa1b46792a10aebc90359472cb-1730303200"
  },
  {
    "email":"fabycastel@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033839482/8b7d40b103b4f2d927755b081f93ea4e-1730303200"
  },
  {
    "email":"fantosi19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033872250/8f34ba05b81bd43b72e635b830b9af15-1730303200"
  },
  {
    "email":"federica.masoni02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033970554/4314e7308c996792d56d57f6a6ea091c-1730303201"
  },
  {
    "email":"fedemorg87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724033937786/08ae651bea8b7de5c23cb56962e7f595-1730303201"
  },
  {
    "email":"federica.taccone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034003322/8e83b3f84a18e23314549fb3b1dbb4e3-1730303201"
  },
  {
    "email":"farmaciagabrielli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724033905018/d31078ede7fa1ab4430a00dc2823f3d5-1730303201"
  },
  {
    "email":"federicapolci@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034101626/09c001f9f5dd8b32b026b1d4eb38d972-1730303201"
  },
  {
    "email":"federicatombari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034134394/3c1890258a1421de4f261b56a94ecaa1-1730303201"
  },
  {
    "email":"federicatombari.ft@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034167162/8008a611c0cdd3380d276d42f065a3aa-1730303201"
  },
  {
    "email":"ferraresi_laura@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034232698/bc124fed70a6a1cd611d591bbfc8bcc1-1730303201"
  },
  {
    "email":"fiorettimirco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034298234/7cd94ff72130b08c48f27455a4f67ba7-1730303201"
  },
  {
    "email":"federicadb2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034036090/43ae9751010b45633636115f7b9bf5de-1730303201"
  },
  {
    "email":"fra.ostello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034331002/d89564b8c95645e8205322799492e64b-1730303202"
  },
  {
    "email":"fmarcelli42@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034265466/7b213fb1588ab1edc1bddc315a369bc1-1730303202"
  },
  {
    "email":"fradise77@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034396538/b1965538c686bd97408c76aa642c4368-1730303202"
  },
  {
    "email":"france.gio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034429306/44aae9a05e39ba4b66280329030958b4-1730303202"
  },
  {
    "email":"francescamangano58@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034527610/bcfea138fa7ba11d17c954f0c29c784f-1730303202"
  },
  {
    "email":"francescog987@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034593146/76d66675cd43b415c69ccb83cf8e1fc7-1730303202"
  },
  {
    "email":"francescaprimo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034625914/b9ae794b9076cdd67cd7f26f5c71c6d6-1730303202"
  },
  {
    "email":"francesca.defra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034462074/2ea5cdf9856b411691b8368d94a1e476-1730303202"
  },
  {
    "email":"francesca.rodeghiero@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034494842/e9e070e0024b1fdfb78ac389395664d4-1730303202"
  },
  {
    "email":"francescojuniorsini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034691450/dbb8a5ce766933035c56b9071ff5f809-1730303203"
  },
  {
    "email":"francino_86@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034724218/05ad2f6014dcb01dda34e212303a42a6-1730303203"
  },
  {
    "email":"francis.volpato2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034756986/b55063a37d2a1ce5525825f90ddfbdc0-1730303203"
  },
  {
    "email":"francescapellicini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034658682/59157eea40cf6e30bdc056e227e0e53b-1730303203"
  },
  {
    "email":"franco.monchieto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034822522/d90389a39e93aa45197dc16073758788-1730303203"
  },
  {
    "email":"francone.barbara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034855290/7392aa9866714576ae3a6b02b4e8e55c-1730303203"
  },
  {
    "email":"francis.volpato2@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22724034789754/b2c0bc854e7a50baddbec31de6e8b263-1730303203"
  },
  {
    "email":"frasalve@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724034920826/98b9fa51deba65556f8a9431eb0e4037-1730303203"
  },
  {
    "email":"g.luglio@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035150202/43ea833ebfc4395ef5b19a5d574f203b-1730303203"
  },
  {
    "email":"g.manica@manica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035182970/825e5555b9e4fb865b8d6a1bab304aa5-1730303204"
  },
  {
    "email":"furetto111@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724034953594/8ba43240367f0b832c31da3bf31f3232-1730303204"
  },
  {
    "email":"furlancinzia86@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035051898/34544a6fc47b050761400ba819a655e5-1730303204"
  },
  {
    "email":"gabribond1410@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035314042/3995b45ab740032ac26e351b8edaa27a-1730303204"
  },
  {
    "email":"g.pacelli@unvipm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035248506/20b9b19498a448b689cacef30ee9757a-1730303204"
  },
  {
    "email":"gabri.corvasce@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035281274/43a48461fd2f14e556b21ff7f4d3db4c-1730303204"
  },
  {
    "email":"fuscoefigli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035084666/cc31eb39b7fcee613738095eb9af2596-1730303204"
  },
  {
    "email":"gemma.stasi@gruppoinnova.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035445114/7594e5108e1e87c7092de63e4827762f-1730303204"
  },
  {
    "email":"gemma.barboni@posteitaliane.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035477882/44f43f289b085cb514724aa22ef99a51-1730303204"
  },
  {
    "email":"giabarto68@gmail.cm",
    "url di attivazione":"https://verdissima.it/account/activate/22724035576186/6c051640bdb95b4f7b2c57179bcfb215-1730303205"
  },
  {
    "email":"gaspa2@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035412346/5ddfba8cf089c88c235445596d5bb273-1730303205"
  },
  {
    "email":"gianluca.merlo@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22724035641722/de2511236cf17d86d1d1fbaa03851924-1730303205"
  },
  {
    "email":"giada.cicolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035608954/23666cb1ee49451352d3ef557942e526-1730303205"
  },
  {
    "email":"giannapapagni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035674490/300f886adf8f39371c5643ea179c9bcf-1730303205"
  },
  {
    "email":"giorgia_og@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035772794/bc0549a60d96d12dab58ba425702c3fd-1730303205"
  },
  {
    "email":"ginettacanali71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035740026/4060099092768490989940563d962f54-1730303205"
  },
  {
    "email":"giorgio.castelnuovo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035805562/ba65840717c54bd8b5f30386290cc8de-1730303205"
  },
  {
    "email":"giovanettoni.chiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035838330/6331253985cdc0d3b04abab7ff16022b-1730303205"
  },
  {
    "email":"giovannaiosca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724035903866/bc7e5446a587f25b2b1c69dbdaebc3fd-1730303205"
  },
  {
    "email":"giovannavaiani791@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035936634/f0eb564df0c75b1af1de01d01db1681e-1730303206"
  },
  {
    "email":"ginnyferr29@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724035707258/85930a45abd98f889410fca340ba94f3-1730303206"
  },
  {
    "email":"giovid@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036002170/566e9b666a2b767179f9a83da8d0f044-1730303206"
  },
  {
    "email":"giulia.fabisji60@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036034938/3f447dfb798807c624c5d6b16d2e3e51-1730303206"
  },
  {
    "email":"giulia.meoni@uslcentro.toscana.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036067706/d6976fd355f376d9208b9cb658eaeeca-1730303206"
  },
  {
    "email":"giuliafabiani.home@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036100474/bde6056d5ef5ec869244ac2dca1c0a3b-1730303206"
  },
  {
    "email":"giulianapascucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036133242/797fed90b51e342c4e44e3a0e60d1768-1730303206"
  },
  {
    "email":"giulianapascucci@proton.me",
    "url di attivazione":"https://verdissima.it/account/activate/22724036166010/676d403ddfde2bef04fd3a413292805a-1730303206"
  },
  {
    "email":"giumiky1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036428154/b5a12bb373f06de555ae469c2114b641-1730303206"
  },
  {
    "email":"giulio.cavani@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036329850/50322ee34d6d9b63f881cac04d7749cc-1730303206"
  },
  {
    "email":"giuseppa.inzinna@unipa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036460922/d559ff2cc5e8b5878d5f623d4068a274-1730303206"
  },
  {
    "email":"giuliaveneziano@gmqil.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036198778/73b6aa5e5b7d8729e1d91297725f9bb1-1730303207"
  },
  {
    "email":"giuseppemarino03@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036493690/b7b85baab530991cac54f0c2ae8c015e-1730303207"
  },
  {
    "email":"giusydifelice2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036624762/00c54bb16772795b743cb272034af3be-1730303207"
  },
  {
    "email":"giusybi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036591994/ecdcbe6409a6883974587874bc3ebe6e-1730303207"
  },
  {
    "email":"giusyrussogiusy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036657530/bf636961718ef7523beca79b5510e3e8-1730303207"
  },
  {
    "email":"giuseppina.lococo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036526458/3af793a59d9dac074f2aa8fa2a7b0be1-1730303207"
  },
  {
    "email":"gppstn32@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036723066/796bb03bf241f36e3e01801fa25d53f6-1730303207"
  },
  {
    "email":"gonnelliamedeo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036690298/dbc61c6fb35fffd9c5a7089687cd2f92-1730303207"
  },
  {
    "email":"guelibetta1705@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036886906/08d76b8f436945abb100dbe483012138-1730303209"
  },
  {
    "email":"grossi.angi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036854138/74713b1a164ebfc029ba7d483f2a3c6c-1730303209"
  },
  {
    "email":"gugu63a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037050746/c160123bf973a6530395cee462fa2ceb-1730303209"
  },
  {
    "email":"guendalina.perigli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036919674/48fe2c159052e2040013e58227fe05bd-1730303209"
  },
  {
    "email":"graziasella61@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724036755834/2ac1775e0e57cec83d6c5adc95ac6a67-1730303209"
  },
  {
    "email":"graziavet61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724036788602/f562aedcdca8c74f94858fea64063b9d-1730303209"
  },
  {
    "email":"helmut.piok@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22724037116282/20b88c678d05bd49a3757c2927f25a0e-1730303209"
  },
  {
    "email":"icabsi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037181818/59f6eeedbdd8a0ee2b5282ab2bcc52bd-1730303209"
  },
  {
    "email":"iem.marangoni@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037280122/783c8637fcfa8cef748413e886ff4e1e-1730303209"
  },
  {
    "email":"ilenia@rindi.eu",
    "url di attivazione":"https://verdissima.it/account/activate/22724037312890/d1c65ca789b2d9da2f3bd20bc4078507-1730303210"
  },
  {
    "email":"ida90mind@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037214586/68794476607813647974cb2c5b093cf0-1730303210"
  },
  {
    "email":"info@loscatolinomagico.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037411194/c8d9fc8e8f496e62e95b6a922d2625f2-1730303210"
  },
  {
    "email":"iaccarinomaddalena08@gmail.comomomcom",
    "url di attivazione":"https://verdissima.it/account/activate/22724037149050/107190061a26f86235acd94ea0850f74-1730303210"
  },
  {
    "email":"ileniacecchis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037345658/a1f200f1748981e22349cecbd7fed392-1730303210"
  },
  {
    "email":"infobreglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037476730/6d5cd84c57bad5eae67833f032b990e0-1730303210"
  },
  {
    "email":"irmalosi.kepos@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037509498/5925e4e7fc3fe92aedbc4a54245a1a10-1730303211"
  },
  {
    "email":"info@studiotavalazzi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037443962/8f18e0adb6100a75a2790f577707c100-1730303211"
  },
  {
    "email":"isabellacattani30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037575034/dfb0d017ea0f8c85e16f1e7956d0b3c1-1730303211"
  },
  {
    "email":"isabella.marzo2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037542266/4c63a4e58d8656d512bcb948272b4930-1730303211"
  },
  {
    "email":"jekaterina.sabina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037640570/a089c57dcf11d36d60a5253158b36975-1730303211"
  },
  {
    "email":"iva.debellis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037607802/a9a113643c063aae9bbb5fe592149833-1730303211"
  },
  {
    "email":"katia.damiano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037771642/ecd69af0ad8760698f63480f1accc5b1-1730303211"
  },
  {
    "email":"k.grossi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037738874/22a3a9d3d444e39b55f7af62c83eaf1a-1730303211"
  },
  {
    "email":"joale2007@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037673338/d3efa63dd1e5d8b26898d3866d70ac06-1730303211"
  },
  {
    "email":"kd@criver.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724037869946/d11b9daeb6d4ea55f7aca7b0bc86ddf4-1730303212"
  },
  {
    "email":"kim@speakingbodies.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037902714/06e366699d376e17564f41673a9f4ba6-1730303212"
  },
  {
    "email":"kbiasuzzi1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037804410/37c4e1a062fb2a2d2092b2c3d5754746-1730303212"
  },
  {
    "email":"krostyna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037935482/7174971fb8ad3247d40de337825bb910-1730303212"
  },
  {
    "email":"lamacchia.giuseppe@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724038066554/59dec8824855391cbdf82c02ce7d824d-1730303212"
  },
  {
    "email":"lakaka@gns.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038033786/f2842f868aaf9096db7b45888a84f6e3-1730303212"
  },
  {
    "email":"lanervi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038099322/7fe922bfa306feb58a77916af9b15ddc-1730303212"
  },
  {
    "email":"l.scotti@findomestic.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724037968250/740066e93a2eae48ed27a7c67bcdd326-1730303212"
  },
  {
    "email":"laura.porreca9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038197626/38d40deef0ba0655479d48b6009b4925-1730303212"
  },
  {
    "email":"lanzoniucia64@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724038164858/5fb548caa92738ef10c367ca0ad70125-1730303212"
  },
  {
    "email":"laurabernardoni1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038328698/5fdc57b2d657b0fc1f929a56d996f26a-1730303212"
  },
  {
    "email":"lauracasalegno66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038361466/44341b7d56f163c6292314cdc05f3c71-1730303213"
  },
  {
    "email":"lauramarcarini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038394234/9e7e8f849dd3f416205c1b0ada8af342-1730303213"
  },
  {
    "email":"laura_barello@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038263162/9edf9263646d53128ad24ac1499561e9-1730303213"
  },
  {
    "email":"laurettagera68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038492538/5b28a207bc64ffb943f8f86f7010d811-1730303213"
  },
  {
    "email":"laurin0403@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038525306/e06369ed592c8730ec0bdaa6eae12c62-1730303213"
  },
  {
    "email":"licia.capriotti@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038590842/36b9663bb4168fde1dc07209441caa23-1730303213"
  },
  {
    "email":"liotta.marilia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038656378/c9e8ff8ad0e6e6fa78a1a2d416bf3b30-1730303213"
  },
  {
    "email":"ligipaola@ligi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724038623610/c102f1d86bd350622bf33102d3ef5def-1730303213"
  },
  {
    "email":"laurascotti@yahoo.itl",
    "url di attivazione":"https://verdissima.it/account/activate/22724038427002/04ca09592e56ae9b453cde57d98331d9-1730303213"
  },
  {
    "email":"lisa@puravidaviaggi.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038689146/26d756be5b79c61601e4f14d32ab74ce-1730303213"
  },
  {
    "email":"llangella@notariato.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724038721914/58cb05366a1459541527ba8cc14e7eb5-1730303213"
  },
  {
    "email":"lorenabordina74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038852986/57266920cb8663b85ad062ea2f69921e-1730303214"
  },
  {
    "email":"lorenza.malinverno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038918522/14f1e8eec51082d401cb3b3d96c0f534-1730303214"
  },
  {
    "email":"lorenzaberselli@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724038885754/dae4263ab13fab3611f0d67af3d7ec67-1730303214"
  },
  {
    "email":"lucasantone77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724038951290/2bf84003c3b359945e864c1e7f8bbc5a-1730303214"
  },
  {
    "email":"lucia.battista@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039016826/c10b204919af2fbfc31c91f6599feb9c-1730303214"
  },
  {
    "email":"luciadeflorio@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039082362/32a71dd5096882159f91db20ca3c8800-1730303214"
  },
  {
    "email":"lucialenoci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039115130/77e47dee851b77b03fd39515e5c29d6f-1730303214"
  },
  {
    "email":"lucia.battista62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039049594/eee6bf0bac6a2a189af50700b5e21584-1730303214"
  },
  {
    "email":"lucianadadamo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039147898/50ab39dcfd15ea5c6f1cee6001f89ac0-1730303214"
  },
  {
    "email":"luciaroma@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039180666/d9094b92e348b1379bf9f44650ceb9a5-1730303214"
  },
  {
    "email":"luckyemanu@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039213434/555992f850e9e22d55b8a4097d32f5f4-1730303214"
  },
  {
    "email":"luisabalestri@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039475578/173384a2558ec1a62b7dbf7dcd1fe95e-1730303215"
  },
  {
    "email":"luisa.ravisconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039410042/182f7a8f078d84384a74d6e86e58ad3c-1730303215"
  },
  {
    "email":"lucreziam@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039246202/ead6cb7ec90468be804a8d2569bef423-1730303215"
  },
  {
    "email":"m.vittoriascebba@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039508346/a273a4ca16ce453081aa67524fad6809-1730303215"
  },
  {
    "email":"maggioni.veronica@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039606650/a7a56c4b89c29477e7db63504011f0a9-1730303215"
  },
  {
    "email":"magmas202@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039639418/c523e1c6d50f3b2be8aa592ed6df0f03-1730303215"
  },
  {
    "email":"majla.costantini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039672186/919b19a41ca45a9779e01a0db3dfdde5-1730303215"
  },
  {
    "email":"malube@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039737722/72b753b44521c82febd0a6ffbc1d5e5c-1730303215"
  },
  {
    "email":"maddalena.iaccarino6@gmail.comdffdďŕ",
    "url di attivazione":"https://verdissima.it/account/activate/22724039541114/23228a736807ea319b354da1cf52dc80-1730303215"
  },
  {
    "email":"maenabechelli@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039573882/d3c3435589044aa37863ac3eeb9fe44f-1730303215"
  },
  {
    "email":"mandrilesabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039770490/fbe3cd671d4681714dd6fd37332d5a97-1730303215"
  },
  {
    "email":"manu_marta@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039803258/947e1eb6798e6a7b99df9e6b9aa6f720-1730303216"
  },
  {
    "email":"manuelafasano@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039836026/57c4cd3f6b6c7ce2e6f719a198488cd1-1730303216"
  },
  {
    "email":"manuelamnb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039901562/33f8297e849201dc924ced0a8cf945d4-1730303216"
  },
  {
    "email":"marcella.giorgianni@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039967098/a1daa75ad1283cfb462b18c6a40fae81-1730303216"
  },
  {
    "email":"marcofede82@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040163706/3378c0869780e30d313ec6e74ef7e8cc-1730303216"
  },
  {
    "email":"marco-cavaleri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040032634/44c6f88d4539ee392c8262b2ddef64cf-1730303216"
  },
  {
    "email":"margheritabettoni7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040229242/9d97dc7368a53293cadf23fc53c592b8-1730303216"
  },
  {
    "email":"mara78d@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724039934330/6db3d71bb616cb7d29ade683d5948130-1730303216"
  },
  {
    "email":"marchiale75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724039999866/17225872c184439f6786dac3f17ef3de-1730303217"
  },
  {
    "email":"margherita-panico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040262010/5516b3b030db17567028a4f2dfdf50f4-1730303217"
  },
  {
    "email":"mariagiulianafloris@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040327546/0c3e31f5999f3aad5116857c4a6ff31c-1730303217"
  },
  {
    "email":"marcy.long@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040196474/09ec3f126402efbbeac44c3f1b769a5c-1730303217"
  },
  {
    "email":"mariarosa.3000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040458618/525eb55a84427018d9baa67ab85ec3e8-1730303217"
  },
  {
    "email":"marida.vattetoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040491386/16ed1c795093a0fde5888f655d8c9d7a-1730303217"
  },
  {
    "email":"margheritasinisi@linero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040360314/2c51e4c40487c3e6042cb0423e8ad0f2-1730303217"
  },
  {
    "email":"mariluce77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040524154/ad59823f823225515837dde2ce4771d5-1730303217"
  },
  {
    "email":"marinoanto70@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040589690/ec87da5ed9f906d3aa240baf4adddc5e-1730303218"
  },
  {
    "email":"mario.mustarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040622458/ca3003c0e743303048fa0f713529ab6e-1730303218"
  },
  {
    "email":"marialuisamargiotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040393082/6295eefe69a9b57f2eba9a564983e4fa-1730303218"
  },
  {
    "email":"marta@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040687994/faf56ab18acd39bb33b39ef7a6c942d0-1730303218"
  },
  {
    "email":"marta.debiasi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040655226/699a6f1236d5931996920792a8c57c07-1730303218"
  },
  {
    "email":"marimassimo779@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040556922/62fdc8703ff72a0071a187146c09a1be-1730303218"
  },
  {
    "email":"martina.tomatis@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040720762/07f77608a7727cc8a69267d26f5f4e4f-1730303218"
  },
  {
    "email":"marzia.capitanio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040753530/b23af0a0fce449ee486b5ba387ca888e-1730303218"
  },
  {
    "email":"massimo.trezza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040786298/80907899465c971caa7924070c273d4f-1730303218"
  },
  {
    "email":"matteo.boschini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040851834/17de4d9f3be176d8aac95c6c65b86b9b-1730303218"
  },
  {
    "email":"matilda.deprado@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040819066/fe6265728e6ac2e28d3210cd1f4eb8dd-1730303218"
  },
  {
    "email":"mauro.guerini@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040950138/81d7c4615fab7c1a39ce73ab1dab5c55-1730303219"
  },
  {
    "email":"maurizio-virgilio@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724040917370/877018bb0e2bf2c11310af5f59ff3a5a-1730303219"
  },
  {
    "email":"mautonefilomena2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041015674/2c6c7327ffe8291fe7b08eef917cb619-1730303219"
  },
  {
    "email":"megsantangelo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041081210/dea26f99bde9c27aabe39f4f0ae8abbc-1730303219"
  },
  {
    "email":"mdvcons@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041048442/948c204fb221e2325d99125c39da32f8-1730303219"
  },
  {
    "email":"menadelprete@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041113978/9184cb13926fa7645434ef6edda0644b-1730303219"
  },
  {
    "email":"meronieliana469@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041146746/5bb2c3149c54794e76a872b6e32263ee-1730303219"
  },
  {
    "email":"mgbertolami@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724041212282/34bd677cb3a698cd507cc3c9dc917fe1-1730303219"
  },
  {
    "email":"mauro.tarragoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724040982906/05f33960505a0459abb39759bcfa3a42-1730303219"
  },
  {
    "email":"michela.arata1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041245050/c9c4101e61710dbfa545d3519fef1392-1730303219"
  },
  {
    "email":"michela.liparota@mircovisconti.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041310586/c3b59876159e3e390165e1846e446bc7-1730303219"
  },
  {
    "email":"michela.napo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041343354/e7cd79bddc557997dec2844941100ff4-1730303219"
  },
  {
    "email":"michela.pieraccioi72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041376122/ae4f0d67e3154e7d1e9213fa1e81696e-1730303220"
  },
  {
    "email":"michelabergamo2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041408890/59a39195ec8b1c68c524daa92849f55f-1730303220"
  },
  {
    "email":"michele.marrapodi@unipa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724041539962/c658ac6472f0d3a6d7f92528be6f9765-1730303220"
  },
  {
    "email":"micheladallatorre@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724041441658/5d85f7d6ed1bde9ef4f48cfd99444291-1730303220"
  },
  {
    "email":"mielekatia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041605498/e9b54c72b2c5457f7dcf757175a22152-1730303220"
  },
  {
    "email":"michelon.altea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041572730/90d7d1bdbc1e213255a62879d3883b56-1730303220"
  },
  {
    "email":"milenamaiello27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041671034/2b9fd9bbd5fc01f802291bc7938b3730-1730303220"
  },
  {
    "email":"milano.eleonora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041638266/41b7fb8184b5de52ff08d502ae4b7b06-1730303220"
  },
  {
    "email":"mirelladaietti53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041703802/4125366987627ea8eb8f52cdefc595bf-1730303220"
  },
  {
    "email":"mocerinoantonella68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041900410/9f88060c3cfef249e3585d4afa49f9b5-1730303220"
  },
  {
    "email":"minacieri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041736570/ad3c0fd3ecf48dc6bd4e418338ac148f-1730303220"
  },
  {
    "email":"mmerico13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041867642/0b3d382fada2035f52200cc6d817b96a-1730303220"
  },
  {
    "email":"monica.golle@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041965946/c0644f681e1dba959eac40173a87f532-1730303221"
  },
  {
    "email":"monica.mattana@cnr.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724041998714/3454ef41cca8c320ac48760ee037b950-1730303221"
  },
  {
    "email":"monicaioli@fastwebnet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042031482/8dae5bca24b663e9493dde42ad6a3168-1730303221"
  },
  {
    "email":"moniatossto77@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724041933178/e3b13b9e65defa228b08dfccb523fefe-1730303221"
  },
  {
    "email":"moreno.pignoloni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042228090/3c14686c7af34bfb1be70faabba38def-1730303222"
  },
  {
    "email":"more.francesca969@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042162554/162df1ad61b91b5ec275110412744e5e-1730303222"
  },
  {
    "email":"montini.g76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042195322/00fa5b45a550e36ab5d9c6330d698fb7-1730303222"
  },
  {
    "email":"mranchanov@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042424698/22dd0aacfd736f59fd66bb8e0e0f3660-1730303222"
  },
  {
    "email":"morsuccif77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042391930/1e1f76a2aa2854925e882a2f0c12d1f2-1730303223"
  },
  {
    "email":"monicafedeli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042064250/96cf6fdfe5a9af41d93e5b8feaa09918-1730303223"
  },
  {
    "email":"muneratto@outloook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042555770/20bb82a62cc36a7b52339ab174884273-1730303223"
  },
  {
    "email":"moreno.gallerani@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042260858/fdba4b27fb594201c0ab82251324c1be-1730303223"
  },
  {
    "email":"mtamoruccio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042523002/e39bcc9e8c037693e0b44614f5349130-1730303223"
  },
  {
    "email":"muzca78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042588538/4882f4dadc2ab0f9dc41ca7dce454ebb-1730303223"
  },
  {
    "email":"n.stronce@logolsolutions.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042621306/b756dce49a8468494ebfe99e1d638703-1730303223"
  },
  {
    "email":"nadata47@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042686842/75be4c1e45bd02e2f5ba2b32c3a25533-1730303223"
  },
  {
    "email":"nackermann45@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042654074/7de6b96d5e9ee4424d473f8fd6b3050a-1730303223"
  },
  {
    "email":"naggia2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042752378/91020053dc32822d26f6271aac13d95a-1730303223"
  },
  {
    "email":"naicolpis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042785146/b6f55dc860ab711ad4a1bc76d1cfa229-1730303223"
  },
  {
    "email":"nicola.simona2008@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042916218/05d888726dd4e3439af4f6a4fe3fee6a-1730303224"
  },
  {
    "email":"nadiabrambilla@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724042817914/b09c4b244196ba6761f7b27c73a4cede-1730303224"
  },
  {
    "email":"oswald@chef-italia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043014522/65f66b2250690da8c3bbf84995487750-1730303224"
  },
  {
    "email":"nicoleta.gaceu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042948986/a3f5e0cc30a2b410ced2160133338606-1730303224"
  },
  {
    "email":"p.mantoessi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043080058/f117c5cdd4a45a5cb52e3a83e446c585-1730303224"
  },
  {
    "email":"nicoletta.tambroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042981754/204e415efbb9e08674ff94345de341ed-1730303224"
  },
  {
    "email":"oretta.bozzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043047290/8cbafa06972551fff5c2ae467dd69482-1730303224"
  },
  {
    "email":"nicola.simona2008@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724042883450/f215677f03aca0d602519831958482c6-1730303224"
  },
  {
    "email":"pami81@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043145594/46681ad15802b964880f063bf8b77ad4-1730303225"
  },
  {
    "email":"paggi.samuel11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043112826/4f7cea555c5215c51f6a4003b6cb37f1-1730303225"
  },
  {
    "email":"pao.cris@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043178362/cd9e7203cfea7858af0f628eee1f0dc7-1730303225"
  },
  {
    "email":"paola.basconi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043211130/240e4653daf51edca9f5ca1d8ecf2450-1730303225"
  },
  {
    "email":"paola@dallaportasas.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043276666/8769dff66b5074f556158b7e92f4090c-1730303225"
  },
  {
    "email":"paolamarsano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043309434/d54e53ed161cdeaea1c83c777d642539-1730303225"
  },
  {
    "email":"paola.folchitto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043243898/0d556f40ee0ecc033caa9d2478d27186-1730303225"
  },
  {
    "email":"paolapalelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043342202/53da5738f030e2d509498e24d6990aea-1730303225"
  },
  {
    "email":"paolotrucchi74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043440506/93b5593e311242cf627cbe8027f84720-1730303225"
  },
  {
    "email":"paolascala72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043374970/b05fac834fc1042bdef2e223cc486765-1730303225"
  },
  {
    "email":"pasquinavalentino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043506042/7e111e9f9cf507518d26e8b6e401cb21-1730303225"
  },
  {
    "email":"patrizia.deiana@agenziaentrate.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043571578/678c2a58cb968fd614cb005be06282b8-1730303226"
  },
  {
    "email":"pavinlegno@login.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043604346/65fa1cd9a41a8def1aeecd4e2b272b0d-1730303226"
  },
  {
    "email":"pass356$9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043538810/5b00a880a25e2983dbdb7410d97fab1b-1730303226"
  },
  {
    "email":"papacciuolifrancesca7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043473274/1f646b323a6e98895362f98ebd555cfe-1730303226"
  },
  {
    "email":"pbrunella@studiobrunella.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043669882/9e1dc28889e9001cece60249a1966e27-1730303226"
  },
  {
    "email":"piana.federica@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043702650/ddd58eee535df16e3e53800f3c4d9a13-1730303226"
  },
  {
    "email":"picchy.cp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043735418/ff694b856e1a9b4facef28653cad6f65-1730303226"
  },
  {
    "email":"pierlucorradi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043768186/6f1b3dd04148d053f303219eb5dabde8-1730303226"
  },
  {
    "email":"pina.pastore73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043833722/c7656b6b0f96ece10bbd7ab1e27b498a-1730303226"
  },
  {
    "email":"pinadelorenzo72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043866490/14a736ef2accf875ed1697602543b1ce-1730303226"
  },
  {
    "email":"pina.francolino@icolud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043800954/69ff7765239682c7a4dc360183f8a78f-1730303227"
  },
  {
    "email":"pizzutonunzia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043932026/064229f4434ced4cd42d589b54e25a1c-1730303227"
  },
  {
    "email":"pmutti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724043964794/a27173268df0061e6abd5db6c876e7cc-1730303227"
  },
  {
    "email":"pisolo19.pm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043899258/596f455a4ae1ced316a5ae5510827867-1730303227"
  },
  {
    "email":"polepolesrls@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724043997562/d3766b6f1d463204656e3fd90f2656c8-1730303227"
  },
  {
    "email":"primulanuova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044095866/bfb4c00df4bbc86ed8a1075a90c1a8c2-1730303227"
  },
  {
    "email":"psandrini68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044128634/eeb17fccd3f32841118284005d0d53c3-1730303227"
  },
  {
    "email":"puna.francolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044161402/b24e5aaad46cd26031a6864a43a42c7d-1730303227"
  },
  {
    "email":"primcicri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044030330/36baaec445c1dc877ab51491e150fb2a-1730303227"
  },
  {
    "email":"pzornetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044194170/f51ae9df3f38e8776c470b7854370a41-1730303227"
  },
  {
    "email":"r.setta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044226938/ff6527171b754042fef629e9441dc1ae-1730303227"
  },
  {
    "email":"raffaella.bellomini@vienrose.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044292474/e152b0afda831bf98c828badd28deced-1730303228"
  },
  {
    "email":"raffaellacalamai@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044358010/7ff9d8844f4be40a57fa9efbd51e972d-1730303228"
  },
  {
    "email":"raffac06@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044259706/bf309de01b87fba827452e38ee56279d-1730303228"
  },
  {
    "email":"raimonda.v@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044423546/d5cbb1912db36a21180707ec30ed7810-1730303228"
  },
  {
    "email":"renatedec56@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044489082/fe5302ea66dec644f00516999a6a2429-1730303228"
  },
  {
    "email":"re.centenaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044521850/478d8a4a10a040e304d728dfc9901646-1730303228"
  },
  {
    "email":"raffaella@ponterossocarri.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044325242/cf565a368099da600482cbb2f678b9ac-1730303228"
  },
  {
    "email":"ricann0802@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044554618/be8be66e0ca519dcc0412d733ce0bed6-1730303228"
  },
  {
    "email":"rita.giancristofaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044652922/6f9b6696794c485bb4798f9c74c8e08f-1730303228"
  },
  {
    "email":"riccardo@studiorogai.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044587386/dadd11b97278e7dd2daf6bd6c0773ae8-1730303228"
  },
  {
    "email":"rita.menghini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044620154/e89814f6eb5307b435983a662ca9705b-1730303228"
  },
  {
    "email":"ritag017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044685690/8193289c45238be8f5850455859c34e9-1730303229"
  },
  {
    "email":"roberta.1966@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044816762/d424e59d0de356b3ff0efb19991fa9de-1730303229"
  },
  {
    "email":"roberta.gentile75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044783994/87643150e713fe96bc8f83127dbed48d-1730303229"
  },
  {
    "email":"robertacisco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724044849530/cdbda19d51269205d60e233960fbe069-1730303229"
  },
  {
    "email":"rivafabrizio54@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044718458/1fcb27d57d7f6640f80df5248dffbab2-1730303229"
  },
  {
    "email":"rodella.barbara83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044947834/c6ddd4d2566d875b42027b6d61618a0d-1730303229"
  },
  {
    "email":"rocky920lewa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044882298/b6f4910d5ffdc9bd8f3db525e614e819-1730303229"
  },
  {
    "email":"romina.fiung@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045078906/1bfed90908e22acda3cf4af0a42ba9e7-1730303229"
  },
  {
    "email":"rosariamanfellott@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045144442/6b10176e6d5f100ba13b98e29af633f6-1730303229"
  },
  {
    "email":"romaisernia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724044980602/b8b9f6c891af845465fecae65ac0da1e-1730303229"
  },
  {
    "email":"rossella.bonelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045308282/53915518b9929e6140b75b1496818ca2-1730303230"
  },
  {
    "email":"rosellaoc@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045177210/657671e758907cfcb8b38833efba67cc-1730303230"
  },
  {
    "email":"rosy.nacca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045439354/116ca894b5a692062a674a11d25a35cc-1730303230"
  },
  {
    "email":"rotafederica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045472122/f11b2977cd81493791134846d525c667-1730303230"
  },
  {
    "email":"rosita@easyreplica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045209978/ea241e8658d2618b147a0f14426c66ab-1730303230"
  },
  {
    "email":"rossella.cobelli@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22724045373818/ff28cfffbc01cde4b9032003babbaa64-1730303230"
  },
  {
    "email":"rov.cr10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045570426/64e9f83e72c1e104eebb67e4a5f349e9-1730303230"
  },
  {
    "email":"rpezzoli@epaflex.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045603194/163e353fa8e1f63e2912b99006fce1e0-1730303230"
  },
  {
    "email":"s.traversone@italtherm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045635962/41b3583f9350c9f6679cfa8b48651131-1730303230"
  },
  {
    "email":"sabinarossi@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045701498/46e0676a4b29170b4de08e9fc14d1bd5-1730303231"
  },
  {
    "email":"s.caiella@pambags.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045668730/4cff9317369801487271b06d276ac096-1730303231"
  },
  {
    "email":"sabribocchi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045734266/448092b97ed8692e57770f4eb8fe991d-1730303231"
  },
  {
    "email":"sabrinaciampi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045799802/cb9e4c54d2c15cf4e1dd6c4fd436fada-1730303231"
  },
  {
    "email":"salvilaura72@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045963642/78dc4230e83486afb04e5c78e98ed4db-1730303231"
  },
  {
    "email":"sabrinaciampi@ivloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724045898106/9023a460fbe861957efa9d4bf3ed36ff-1730303231"
  },
  {
    "email":"salva_dc@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045996410/3154c51e952b0cdde8b0af5e45e856e8-1730303231"
  },
  {
    "email":"samanta.ivy.mes@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046127482/aa6bc4dd4a6816bb83f8612a71bf6940-1730303231"
  },
  {
    "email":"sam6k2alias@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046029178/3608be1b105d41e8e844313381be9531-1730303231"
  },
  {
    "email":"samanta15.6.74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046193018/1c1dfbd53f3f35b501284abd70c81372-1730303231"
  },
  {
    "email":"sabrina_santi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724045832570/5875f7e9f269c1454b818cec94df0bf4-1730303231"
  },
  {
    "email":"samantagiribuola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046225786/6b2d5bb56c25d062277820c00e8ef43c-1730303231"
  },
  {
    "email":"sampaolesiivana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046291322/5fd293fb977d4c11261825a06b21474e-1730303232"
  },
  {
    "email":"sara.zazzaro@bccterradilavoro.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046487930/2eeefa9c961dd4990c5fe644f1950d28-1730303232"
  },
  {
    "email":"samendola2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046258554/a99dbab1681f5f3e7447a8afb7965d08-1730303232"
  },
  {
    "email":"sandraaprile@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046422394/0227361ec0783e9a009cb0f85502f9d8-1730303232"
  },
  {
    "email":"saranarcisi83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046520698/1b029769b4da86f31b9aaf26c8b4c799-1730303232"
  },
  {
    "email":"sannaalessandra1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046455162/da9b0acbf30a9e1830f75e0068e4d3cd-1730303232"
  },
  {
    "email":"sarannagiovanna.74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046553466/a701645d6549f1f57b6b5ea889948bf0-1730303233"
  },
  {
    "email":"scm@scm-stampi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046651770/3158f4d75dfd4eaf078dd2da80cd4bce-1730303233"
  },
  {
    "email":"scandinarotatiana96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046586234/fb22c1fd52e1cadf7a5c104304719e6a-1730303233"
  },
  {
    "email":"scordamagliam173@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046750074/0eecefb407529442c9cf7b2965c37bb0-1730303233"
  },
  {
    "email":"schnucki@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046619002/1ea8474f9e6d652ca2d92131cd193451-1730303233"
  },
  {
    "email":"sebynicky@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046782842/13da9437bee7bee2b7e1fe7900c67ff5-1730303233"
  },
  {
    "email":"serena@papaya.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046815610/4ac8f48bbaaddcc0542db56ce07f291c-1730303233"
  },
  {
    "email":"serenaromandini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046946682/d862f72c990dfc28775c6b168f9fb5b5-1730303233"
  },
  {
    "email":"serenaparrucchiera@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046913914/80423956904fedc46ebb3cf4065108db-1730303234"
  },
  {
    "email":"serenadepirro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724046881146/2003bfa469f7f856425c9844b95e4165-1730303234"
  },
  {
    "email":"sereschepis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724046979450/e5991e9532ab3bab09c6187f93290450-1730303234"
  },
  {
    "email":"silvana.cacocciola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047077754/e590d3705a3295fa8d55ea3e79f08af9-1730303234"
  },
  {
    "email":"silvia.schiavoni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047110522/32fc7bbebf66618429dea860ace9f7bc-1730303234"
  },
  {
    "email":"silvia.tirinnanzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047208826/14ca0c63e039561403a8d4f5629d86cd-1730303234"
  },
  {
    "email":"silvia_aquili@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047241594/9f3688debac6cf6ef24cd7da87eaf424-1730303234"
  },
  {
    "email":"silvia69.tanzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047307130/c75a9e4aa4f2fe29be25928dbe59aabb-1730303234"
  },
  {
    "email":"silviaber81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047339898/eaede892a7083239a80abb7758ae8bf2-1730303234"
  },
  {
    "email":"silviafio88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047372666/9158da4e0cf85aecefdb20aa54311bf0-1730303234"
  },
  {
    "email":"silviamariamalagrino@g.mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047405434/fb00d62030d31ac9009e7d1239c54a02-1730303234"
  },
  {
    "email":"silviabalzarini@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047274362/9e0caaf76c90fbb12aa84da29008579e-1730303234"
  },
  {
    "email":"silviantonini1007@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047438202/fb2ea38b1c49f6fc759298a2eed20586-1730303236"
  },
  {
    "email":"simona.caldani@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047569274/3f2a31eccf094316d2b2b9c7baf958b7-1730303236"
  },
  {
    "email":"silviapaloschi50@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047503738/9273ac6586f10de9c14e5721c312e225-1730303236"
  },
  {
    "email":"simomiche@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047602042/da72ed6cca7e8c273c82e985d9f77190-1730303236"
  },
  {
    "email":"simona.richaud@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047634810/09ce5c036a92f44caf7e9089f97fd0cc-1730303236"
  },
  {
    "email":"simonetta.saracino@unicatt.it",
    "url di attivazione":""
  },
  {
    "email":"silviomigliori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047536506/36261decf8b0e895bb583f7a129f0871-1730303237"
  },
  {
    "email":"simona@primaverasrl.net",
    "url di attivazione":"https://verdissima.it/account/activate/22724047667578/65683969a095c24ae4202f7c6cd7496e-1730303237"
  },
  {
    "email":"smile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047733114/e53a7a822d4537cd86a0730ddf9a3ca7-1730303237"
  },
  {
    "email":"sonia.guerra@scuola.istruzione.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047962490/078f1c83dda4c3d8c5591ef19b5aa5f1-1730303237"
  },
  {
    "email":"soniaemiliozzi@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047995258/c190f313af640e76d9ab8aa780651ebf-1730303237"
  },
  {
    "email":"smircosta.74@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724047831418/1f25937bec682dbae8f1545ef4bc7c73-1730303237"
  },
  {
    "email":"solazzone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724047929722/3656f67511e2b4fccf860dcc109c28b7-1730303237"
  },
  {
    "email":"sorelline90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048028026/b28f30f45fb007622d07f8fad460794e-1730303237"
  },
  {
    "email":"stefanellistefy69@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048093562/4ac37c8ecc091c2cce0b81c145dd0ea5-1730303237"
  },
  {
    "email":"spaziomoda74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048060794/8470d80f6abc4e79a83100fd2306ca63-1730303237"
  },
  {
    "email":"stefania.lucarini@uslumbria1.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048126330/5210844a780c323cd454b40c5d885bd5-1730303238"
  },
  {
    "email":"stefania.mannelli@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048159098/d5a6c834858efb043a6fac687ea83ac0-1730303238"
  },
  {
    "email":"stefaniacicciotti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048257402/d719d232417d8434736e69c0e577a300-1730303238"
  },
  {
    "email":"stefania@notaiocaccetta.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048224634/a3cef0bfe1b8a45abb0e91176f510f70-1730303238"
  },
  {
    "email":"stefaniairene.re@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048290170/5330a411c71d1c9233c761b7ad47c78d-1730303238"
  },
  {
    "email":"stefyspeedy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048454010/8da8e079682108fbf2801ee191f27419-1730303238"
  },
  {
    "email":"strfy1504@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048519546/9b8831be061a23502512f98eb2944408-1730303238"
  },
  {
    "email":"stefaniapetrolo71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048322938/bad7faa5e0f950c06e3a31d24890aabc-1730303238"
  },
  {
    "email":"studio.acostanzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048552314/18d65bdd46095b4491d9b4824e679500-1730303238"
  },
  {
    "email":"studio.pb81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048585082/0634b94d1227d0e6a419404798fb5977-1730303238"
  },
  {
    "email":"sue.ellengrifoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048617850/c1be67ea0a987559477b28fb9f221073-1730303239"
  },
  {
    "email":"stefy1594@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048388474/f228e1014e0066b82c4effa828776463-1730303239"
  },
  {
    "email":"susanna.zampini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048683386/fa2a5546167ac7c548751cb8b7c9b0f0-1730303239"
  },
  {
    "email":"svetlana.atamanova@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048814458/a25470a591b828ee5c4d66ad76ae493a-1730303239"
  },
  {
    "email":"sylvicor@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048879994/9670284e122129f74e76822949a75616-1730303239"
  },
  {
    "email":"tatianapaduano@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048912762/5512c9a2f4031f94970e9aa936bd4799-1730303239"
  },
  {
    "email":"tatianascandinaro96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048978298/d9a34537c00aa249e9503cd46e8e68de-1730303239"
  },
  {
    "email":"taniapierini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724048945530/5589b7e369600f71248888bfe4e44c13-1730303239"
  },
  {
    "email":"susannafelicetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724048716154/3e3389aa572fe6dd54bc2ac7ca3f752f-1730303239"
  },
  {
    "email":"teresa@sartorigroupsrl.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049043834/6abdeaae9756ca64dd465523ed4891f4-1730303239"
  },
  {
    "email":"tina.sansalone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049207674/3de5db834a67ffac769f7eed16c2858f-1730303240"
  },
  {
    "email":"terenzia70@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049109370/d6e6b0c894ca1059e8c2620b4f2c8fae-1730303240"
  },
  {
    "email":"th@ut.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049174906/fb16f03a31cf50147db5eb3cde3db2e5-1730303240"
  },
  {
    "email":"tommy.ubaldo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049338746/8148c2acf228933504eb5c7590ae0df4-1730303240"
  },
  {
    "email":"tiziana.cocchi@pi.camcom.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049273210/dcf42dd6e90556a42d443e878a5fde44-1730303240"
  },
  {
    "email":"tizi85.s@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049305978/451fd43e3baececa6c45e2a9c902b404-1730303240"
  },
  {
    "email":"toposveva@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049404282/e4b0ae9b8c2a4e6b431bf0f951b7270f-1730303240"
  },
  {
    "email":"tittarelligiulianoi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049240442/0f166ff6a29b293b53ba7c195bb43a19-1730303240"
  },
  {
    "email":"traslochilopresti@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049371514/b1dd884132e902b340bea4938b0b916e-1730303240"
  },
  {
    "email":"trinciaalessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049437050/52ad8f012325d2faebea61e455e3819a-1730303240"
  },
  {
    "email":"truskawki1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049469818/488044fd95604c64aaf3ebb1abb9e932-1730303240"
  },
  {
    "email":"ugoantonella@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049600890/9178bf6592efe1fbf7698fc319a05947-1730303241"
  },
  {
    "email":"valbonamoqi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049633658/8ed42ecdb3dc2cd9db1759dc92a24fd1-1730303241"
  },
  {
    "email":"valefrongia@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22724049731962/094a451440a4aa0dd647766619781b99-1730303241"
  },
  {
    "email":"valelignini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049830266/beb4804cc7c4af3a8edc95981fe60317-1730303241"
  },
  {
    "email":"valeria.tobbia@iclamaddalena.edu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049928570/98e536aab779859e3bf8d603533373b9-1730303241"
  },
  {
    "email":"valemax11@icloud.me",
    "url di attivazione":"https://verdissima.it/account/activate/22724049863034/06ef6656b2436af92de9190990e97a21-1730303241"
  },
  {
    "email":"valemax11@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049797498/937d8892de0630cf9a4421ea4088cd6f-1730303241"
  },
  {
    "email":"valinox76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724049994106/cded86b27abb1374da79585c08ea7be8-1730303241"
  },
  {
    "email":"vasalvato77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724050026874/8f545276423c3b9b2c852089edc640c6-1730303242"
  },
  {
    "email":"veronicacolasanti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724050125178/6ec3a10c42df3a9c9b7f9e5547dc4d91-1730303242"
  },
  {
    "email":"vidocq69ap@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050190714/cb937f4c76b04477a52fb07798473bf7-1730303242"
  },
  {
    "email":"vincefla@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050157946/c978eae235c9fc9ba576f18123d53370-1730303242"
  },
  {
    "email":"valeryold@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724049961338/3d1c6325603941bcea8f61f80728087a-1730303242"
  },
  {
    "email":"vera.rizzato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050059642/47e90257e9c596392f798b8f5e8d31d0-1730303242"
  },
  {
    "email":"volkova.vale@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050420090/1f655f7f4bad2d65ce2d9ef41ad7a6c6-1730303242"
  },
  {
    "email":"vitalorusso@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724050223482/e7a54e277282eb2d9c4db0722d924c11-1730303242"
  },
  {
    "email":"vittoriapaglierani29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050387322/8955d4d9280135ee180390fe66d2e248-1730303242"
  },
  {
    "email":"xaraf@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724050616698/3a4fee953a671b7d1ef6a2b3a7cb36f3-1730303243"
  },
  {
    "email":"ylera76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050649466/db177344a5b14e58bc382cf5cb6bc13a-1730303243"
  },
  {
    "email":"vr.paola@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22724050452858/5a953668f42238749387c8eccbc63cef-1730303243"
  },
  {
    "email":"isabela.hrizu@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22725504958842/f42c66008d5f07290b460a6a63a7f7aa-1730303243"
  },
  {
    "email":"francesca.dainese.1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726645940602/4cf987cc072f8bd7891a88bbe0aac737-1730303243"
  },
  {
    "email":"claudiapini9474@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646006138/ad1caf71b05f01e394d976628698c13e-1730303243"
  },
  {
    "email":"zambellidida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646038906/ed3b7e06adb7ff4a8756c27f13a456c5-1730303243"
  },
  {
    "email":"wondervyv@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22724050583930/b93f6dc8642788dbc7bd09b07a1aa926-1730303243"
  },
  {
    "email":"antonella.roldo@derigo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646137210/47498728547b1d19a3f2d6c8b85b31f2-1730303243"
  },
  {
    "email":"tdgfhj@mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646169978/6917e59efe42ee1950bb969e1a77bd80-1730303243"
  },
  {
    "email":"dev@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22726646202746/155298a6e0e2539db90faf0d5283c365-1730303243"
  },
  {
    "email":"muneratto@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726646301050/3925a362538ef38ad80ef8c56e18c021-1730303244"
  },
  {
    "email":"barbara26rosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646333818/4cd4ba210ad3f219e4a9a254b050a355-1730303244"
  },
  {
    "email":"danenr2009@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646366586/60765ff1d9845cf8f335c5646ab9a39a-1730303244"
  },
  {
    "email":"anna.reggiani@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726646530426/914a4cb5efffe2098f6d3243336617c2-1730303244"
  },
  {
    "email":"ceci7446@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646399354/b29e9aedd6287efeeac692997098f5be-1730303244"
  },
  {
    "email":"robertacornaglia.25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646235514/8bf5d68ef96ef4fcf5f78efe8c3c7964-1730303244"
  },
  {
    "email":"momilla74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646595962/fe1edbe7f34c03e15df64a455d259b80-1730303244"
  },
  {
    "email":"cberaldin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646628730/c1349230bee3615cc2382db00e789297-1730303244"
  },
  {
    "email":"patrizia.venzi@aertecnica.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646792570/0b2c47d4ec376285bbe2f925f92d22b5-1730303245"
  },
  {
    "email":"nannilo63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646694266/2ca0459614751fc8487e697093a4b56d-1730303245"
  },
  {
    "email":"coghiddi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726646661498/89d24fa8a4fa23da5e520084d81ca77b-1730303245"
  },
  {
    "email":"elena.torcini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646563194/898d3e5dc81e1b02b04f39b4fa773c5e-1730303245"
  },
  {
    "email":"moniabro@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726646858106/ab5dad70e27a2591537719021ddffa73-1730303245"
  },
  {
    "email":"simone.beron@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726646890874/5fcd67a553ae6b2266d2ff009792747d-1730303245"
  },
  {
    "email":"ellerre04@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726646825338/e614fe977b4f1f8854e1685957a62ef1-1730303245"
  },
  {
    "email":"kdibarbora@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646923642/28ed061cb26ccc0796254125fda787eb-1730303245"
  },
  {
    "email":"anarfernandez92@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646956410/97741dd74c6924d83c5413568f8149dd-1730303245"
  },
  {
    "email":"santadeangelis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647054714/e9cf61a9139cc12f9dcb14170429b932-1730303245"
  },
  {
    "email":"enza.gargiulo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726646989178/3e92ed6e8f71dba5395798391afebd2e-1730303245"
  },
  {
    "email":"nancyinsolia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647087482/00edbe28087b16fbe2bc11c50a6633c1-1730303246"
  },
  {
    "email":"moretti_silvia1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647153018/a1ccb6b97f6efaf98ee5cb6e3afa648a-1730303246"
  },
  {
    "email":"gloria.cisternino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647021946/5e2af60d45e37e14879dbdbd1cc085f5-1730303246"
  },
  {
    "email":"biancanevebadoo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647120250/8345b560e9ace07d79735a663c673c72-1730303246"
  },
  {
    "email":"grecsim@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647284090/0d64b50430b2d6f272cd405b75579f8e-1730303246"
  },
  {
    "email":"irenelucchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647218554/6667507195e9c8fd96685cb482c9aa7a-1730303246"
  },
  {
    "email":"bfedele@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647251322/50d1f8dddbb316e1317c9d4fbe5dcc8f-1730303246"
  },
  {
    "email":"delaurentiis.francesca2019@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647185786/29ae8920fa1d23132d7eff2db0b0df17-1730303246"
  },
  {
    "email":"vincenzacanale@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647447930/a9bbc832116ba12030760c7ff63a8937-1730303246"
  },
  {
    "email":"francinca@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647415162/df990b836c172fbc3237dcec898e1607-1730303246"
  },
  {
    "email":"rossananisato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647382394/fce509ab1d8386960030685b3820940e-1730303246"
  },
  {
    "email":"simboldri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647349626/af25bd2555fe414c487c4ca255b932fa-1730303246"
  },
  {
    "email":"babicefola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647611770/7b3746e8bbabbbcf733fd442699eccd8-1730303247"
  },
  {
    "email":"francescaonnis.78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647579002/bebb09e9a10ceb819a199dd723af9e35-1730303247"
  },
  {
    "email":"claudiasotgiu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647546234/d85471c96b4df27e34450426792b73c4-1730303247"
  },
  {
    "email":"lauraolocco@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647742842/951e1b6781839871982afb1bb1dd0d76-1730303247"
  },
  {
    "email":"antonia.mungo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647775610/8033884465f372d17034f5bd281e61d1-1730303247"
  },
  {
    "email":"cristinacappa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647644538/99c8ad7c8752ce69b0c038db943bb5fe-1730303247"
  },
  {
    "email":"nico72_6@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647710074/b9669f6baa46bb8235c3a1b748a9aa22-1730303247"
  },
  {
    "email":"galbiatialessia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647873914/9b9412ff693fd4d003c09e733213b6f5-1730303247"
  },
  {
    "email":"manch75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647841146/acb947271674225d3f5aa798b5ce6327-1730303248"
  },
  {
    "email":"benedet.rosetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647808378/22d3090c8127edab2a4fe88cde427a73-1730303248"
  },
  {
    "email":"matbat10@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726647939450/22104ce577bd1ec43d3f70cf852a55c4-1730303248"
  },
  {
    "email":"giulia-turatto@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726647906682/142a73a360d202bfd4ab718f547dc430-1730303248"
  },
  {
    "email":"mony_ka_6769@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648004986/6d83c0d5f442fb7e58303385d9d04378-1730303248"
  },
  {
    "email":"francesca.celi976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648103290/e89e5a2e3d4dd5c25d582c2bb2b50823-1730303248"
  },
  {
    "email":"apblasco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648070522/842ede9e5910afb6c44aa6cf75987e49-1730303249"
  },
  {
    "email":"gz.ilaria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648136058/4a703d86f785d5df60d5d07dcdb941c2-1730303249"
  },
  {
    "email":"albabucchi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648201594/2947fe2dd58854907015ce5bd8f24ca3-1730303249"
  },
  {
    "email":"sylviageirnaert@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648037754/272111113cb4a1894f89310f40f5b7f7-1730303249"
  },
  {
    "email":"dimarinomarina1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648168826/1df0fad33af87b46deef94f6dcdd8225-1730303249"
  },
  {
    "email":"beth@splunk.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648234362/49a1ae805ea804e0974592a6dbefb69a-1730303249"
  },
  {
    "email":"simy_prezioso@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648299898/8349199389be7931e9dc23e46e6312aa-1730303249"
  },
  {
    "email":"silvana_mag@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648365434/df1960f20ea653b2a226e9942ea9684a-1730303249"
  },
  {
    "email":"manola79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648332666/933c10f1bb99b46a78e4c44b066fc9d0-1730303249"
  },
  {
    "email":"mariasolefar97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648267130/814bfa0759ae1b931d7074cb6ddfac05-1730303250"
  },
  {
    "email":"sabr1982@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648496506/12a1fb7d7533fc34e2b0273d5a756f7c-1730303250"
  },
  {
    "email":"zofrealuisa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648562042/e9edf880b583dd87247898fa499f851e-1730303250"
  },
  {
    "email":"brigittegruenberger@yahoo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726648398202/4d23b580724d1a04a2b4d89c9cbeff00-1730303250"
  },
  {
    "email":"barbaracapo184@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648627578/b4b5e573d49c6d5ab020a58b28c9716a-1730303250"
  },
  {
    "email":"nuria.r@telefonica.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726648463738/60c005102669711cf57221c54d41fdf3-1730303250"
  },
  {
    "email":"marlenef76@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648660346/2ae135ea85b2c4ca5dc1a03b074b12b1-1730303250"
  },
  {
    "email":"marcella.morfno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648758650/de736886c4de9da932abb874651ebc57-1730303250"
  },
  {
    "email":"uta.glassner@plus.ac.at",
    "url di attivazione":"https://verdissima.it/account/activate/22726648791418/4ad411bcf00b7d60b73b9b93417a97f0-1730303250"
  },
  {
    "email":"annamaria.timperanza@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648824186/16d81a88dd67d2afb353a9e5be9d86c1-1730303251"
  },
  {
    "email":"mariagrazia.aquino94@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648889722/7fdf23b9b2e4f7ed1dcd63b126a21adc-1730303251"
  },
  {
    "email":"roberta.cicala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648725882/76129d24c9bca4e9bb9158e9f3191969-1730303251"
  },
  {
    "email":"loredanatonnini59@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648922490/305ca27e6d093858af5b7c304ccdbf20-1730303251"
  },
  {
    "email":"luciamuccio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726648955258/fe019d1d954315571137983cd81954cc-1730303251"
  },
  {
    "email":"virginiasini82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649053562/8c6ae02ff00f044febc580306055f90f-1730303251"
  },
  {
    "email":"venturimara7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726648988026/061d0160e552a625af41b45b97c7f42e-1730303251"
  },
  {
    "email":"alemala4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649020794/cef4c5b471e2ff8b7075ce8ca340cb93-1730303251"
  },
  {
    "email":"giuseppina.milone82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649217402/e5c7850878cc0c919caeec9e55973235-1730303251"
  },
  {
    "email":"barbara.gonnelli@bluewin.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22726649184634/862d448fa583270ebc2b3e02bfbe758f-1730303251"
  },
  {
    "email":"f83a86@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726649119098/01133c9f11dc907534bc02080a4f07a8-1730303251"
  },
  {
    "email":"tittisilli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649086330/ae91b10b6301033b1844788a36f61971-1730303251"
  },
  {
    "email":"mariaelenasantelli70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649381242/519aaac3a969810467d229f5b96946f7-1730303252"
  },
  {
    "email":"ci.rodica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649414010/677d5c8b5977ab8bc31603cf37359073-1730303252"
  },
  {
    "email":"germana.troso@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22726649250170/16d4ca9d6fe4d2ce6e9a14a983ab23b1-1730303252"
  },
  {
    "email":"afnogueira@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649446778/2c2e504b10299749d5493b2f582cfcb0-1730303252"
  },
  {
    "email":"luana.ravera@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726649282938/4d9d688514de9f8d3f41ec206f4c20f2-1730303252"
  },
  {
    "email":"dany9168@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649479546/ea1d16fe32658793976a3575d2416d95-1730303252"
  },
  {
    "email":"lovataty777@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649643386/f3352ee15170d2e027ea5cf3abf22f66-1730303252"
  },
  {
    "email":"daria.calligione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649545082/af41f2f03992f677a4ea800c9ff7c359-1730303252"
  },
  {
    "email":"agnese.chiani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649676154/0827149b277c9613e59a0d3782cf59d6-1730303253"
  },
  {
    "email":"raffaelladav89@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649741690/6da14b50a482d1ba8d0164584e80325c-1730303253"
  },
  {
    "email":"reentash@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649774458/1fabdf807627f6416c0686be1bf2e778-1730303253"
  },
  {
    "email":"nuti.simona@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726649577850/f1a72be1e417e96cd77e8a691d572b2d-1730303253"
  },
  {
    "email":"xanthi95@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649807226/75fce10008f65427426de73d2598b78b-1730303253"
  },
  {
    "email":"monicamontaldo@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726649938298/abc1a5bc2bf2e5e2ae09857e37a9fb50-1730303253"
  },
  {
    "email":"solagiuseppina71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649839994/f4abd1cf96001e520eea55df7cbf506f-1730303253"
  },
  {
    "email":"cristina.crippa82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649971066/4f349babf4b0a691c425677409c70de4-1730303253"
  },
  {
    "email":"martia23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650003834/0e426491cbf6e06e0daece7a8151c45b-1730303253"
  },
  {
    "email":"emiliepery3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650069370/bdec1a0599fdde96380736746a048a5f-1730303253"
  },
  {
    "email":"roberta.axel74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650134906/141a8ab6e5a717299f0036b91dbdac5b-1730303254"
  },
  {
    "email":"benessereangela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650167674/f9eaf809860fbbfb3ed44f3079e8ded7-1730303254"
  },
  {
    "email":"doriana_licata@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726649905530/bd8a24c685d0d018794f4c171f7ceb69-1730303254"
  },
  {
    "email":"cettina.cavallo75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650200442/109bb1232c5e393c5663492343239ee4-1730303254"
  },
  {
    "email":"lslisa84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650265978/cd720b995a662d0c4a415a06f6979465-1730303254"
  },
  {
    "email":"do.carnevale@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650102138/c72373825093b552dbd5d0c648bf4671-1730303254"
  },
  {
    "email":"conart_ft@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650298746/6c79cd13fd672912d2b23535dd606f72-1730303254"
  },
  {
    "email":"luisazofrea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650331514/392dfea494ef2c7240d7503158bbbe5c-1730303254"
  },
  {
    "email":"p.tonel@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650364282/8af2453253fa1700b7d4bdd39eb45843-1730303255"
  },
  {
    "email":"federico.razman@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650397050/131c5353e00dacceebf80233ab0c1894-1730303255"
  },
  {
    "email":"chiaramazzei26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650429818/7a021d8216471a87a33029c95d5e3238-1730303255"
  },
  {
    "email":"lilianavotta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650233210/d606021943ceeaf72cfd45175644b272-1730303255"
  },
  {
    "email":"simona.martino.mef@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650495354/1f36ee5da1d2ca4c48953af9e040eed0-1730303255"
  },
  {
    "email":"clabonomi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650626426/bf69dc287bfe92256183d167c741c591-1730303255"
  },
  {
    "email":"galtarossaerika@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650462586/0a1afcd06f0797e7eae84321526bfa49-1730303255"
  },
  {
    "email":"lia@spgbrindi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650528122/8aad02985474332d883d4f80eda0cb4e-1730303255"
  },
  {
    "email":"sam6k2mes@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650560890/3fb50add87915f4da407802d1493956b-1730303255"
  },
  {
    "email":"arcangiolisara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650724730/f8077ccb9d4a63b2953fa25b95399652-1730303256"
  },
  {
    "email":"tiziana.murolo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650757498/7c441b895d9f80edbfa50781c28ccb27-1730303256"
  },
  {
    "email":"d.bartocci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650691962/ce10d79c2e83c6a86c9ac4f7b2d2bab0-1730303256"
  },
  {
    "email":"jessibauer@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650659194/d3b9c2f1129aa0ea39871fd7cf4171fc-1730303256"
  },
  {
    "email":"galia.sergio@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650921338/17cd5b6f6313489272586ef528422aac-1730303256"
  },
  {
    "email":"cynthiamasraf@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650823034/35712c41198722aa7c54d4c02d255393-1730303256"
  },
  {
    "email":"castagnettib@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650855802/013483ba50e6e5f2e6c5190e9cc1f21f-1730303256"
  },
  {
    "email":"simona.alicata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650790266/f74d4663dfdef01902452ca59cdc066f-1730303256"
  },
  {
    "email":"bifgiuly@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726650954106/e4bef2aac3c9ac32ad7e076d64003399-1730303256"
  },
  {
    "email":"claudialunanuova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726650986874/4005f7664764688f64f8a3abb565f501-1730303256"
  },
  {
    "email":"giovi.calegari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651052410/becd0890f4a5dd48d79edaaa9f033abf-1730303256"
  },
  {
    "email":"claudiabertuccioli00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651117946/b026fb6d7379a2fe6473dc2e81b8f424-1730303256"
  },
  {
    "email":"b.quacquarella@fineco.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651085178/839b273e5ae4012bf52ea363a5686dc3-1730303256"
  },
  {
    "email":"isabellabongini1986@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651150714/5877d7411f99c92a28c81d79d79d7e26-1730303257"
  },
  {
    "email":"smd_sarahmarida@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651019642/ca4a649542c116589e6b68a9b38a79f3-1730303257"
  },
  {
    "email":"catiadininno81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651183482/51d244739c28999fb2bc65cd4eb8276b-1730303257"
  },
  {
    "email":"chiara.luzii@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651249018/8b407f6f807d44df46315e0cdbfc7d72-1730303257"
  },
  {
    "email":"cri_pa@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651314554/e0fe10da2fa0031b5f6209fde7951271-1730303257"
  },
  {
    "email":"fuchs_franzi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651281786/e6d76bfa691533a40cafd2c54cdb2519-1730303257"
  },
  {
    "email":"gfprisinzano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651216250/213397896d77ad353c21d984cdf37662-1730303257"
  },
  {
    "email":"ok.okanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651380090/d025c532ac736d00e991efa1fcbaa4b0-1730303257"
  },
  {
    "email":"jorge@pnp.pt",
    "url di attivazione":"https://verdissima.it/account/activate/22726651445626/a0728eeba585606b5d1eae1d91beca71-1730303257"
  },
  {
    "email":"loredanacostanzo63@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651478394/706f3472bde9f4ddaf40642d14d339a8-1730303258"
  },
  {
    "email":"enrica.richardson@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651511162/b1b24ae3d30d41f336467b6043c10a78-1730303258"
  },
  {
    "email":"mbonetti7630@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651412858/8261f960908af4fa53d70afbf603c6da-1730303258"
  },
  {
    "email":"christinekienzl69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651543930/7079c10c84954ca84bb261950ece5d6e-1730303258"
  },
  {
    "email":"jelenapaceiko@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651609466/8c23334c243d17b717d08c8e3bc12f1e-1730303258"
  },
  {
    "email":"mantizia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651576698/c1745c5db89453af8b9c03e712a441f1-1730303258"
  },
  {
    "email":"s.guz@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651642234/12ce70c820e6272ead7fd4e0012f1a3d-1730303258"
  },
  {
    "email":"yari.longobucco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651740538/225a1e05c0dd266d37a97c7e2d582cee-1730303258"
  },
  {
    "email":"pamela.dsuria@enel.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651707770/b3632b15e32a3ee8bcaf755a2418a669-1730303258"
  },
  {
    "email":"spenceresx@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651773306/50199cf6d4e2124205bff08f6dafb964-1730303258"
  },
  {
    "email":"loredanalavolpe@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651806074/87eecd8161a9ea1c2d3ebde297ab9bd6-1730303258"
  },
  {
    "email":"berenger.angelique@wanadoo.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22726651838842/a94db28ca744152b234269e8a3664554-1730303258"
  },
  {
    "email":"mmarmiesse@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726651904378/db7bb3adc0b11c57d17c8e2c5f570c4c-1730303259"
  },
  {
    "email":"valebri81@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651969914/8090c1275b23c563ef2e1b1c8770e021-1730303259"
  },
  {
    "email":"elisabettamanes@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652100986/b9ec9926cd7539dba9c0810281cfb741-1730303259"
  },
  {
    "email":"stefania28luglio1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652133754/e1eebfa3d097fcb1a30f5f31d78cd52a-1730303259"
  },
  {
    "email":"giovy_20_@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652166522/56e44913159aefed33c557f427cc7982-1730303259"
  },
  {
    "email":"anna.moramarco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652035450/191ece4f468ccbb2fe1f5d538e412801-1730303259"
  },
  {
    "email":"gretamigliori@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726651937146/01733e1834839b60491b28e9a81a1f6c-1730303259"
  },
  {
    "email":"ritagentile@d-consult.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652199290/18d662d0b634c9ed81ba63516cc4a9b9-1730303259"
  },
  {
    "email":"luciagiangaspero@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652232058/90c43a39baa558a6040a80a4af5e2e70-1730303260"
  },
  {
    "email":"alessandra_c75@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652297594/a1ef9e6809c28129fe101dd2155cc6dc-1730303260"
  },
  {
    "email":"francesca.geri@cromology.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652264826/2ae48ff80ce66f88c8f54c5f4dfeaccb-1730303260"
  },
  {
    "email":"dallariva.lorenza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652330362/a4df2ddf8d42b1c9dcda8590abc8dbfe-1730303260"
  },
  {
    "email":"nymeria.legge@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652363130/4449678d89c4462c451e30a159f9a5c1-1730303260"
  },
  {
    "email":"vmontagnani@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652428666/6ce8655d4ea6936114fa244da60d59c3-1730303260"
  },
  {
    "email":"palmagrassi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652395898/632c42630c698171387899d3248aca5f-1730303260"
  },
  {
    "email":"annaluisadellanna@gmai84.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652461434/79525ec89abda97e4248349ab5927230-1730303260"
  },
  {
    "email":"mirella.villanova73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652526970/d45a1c4b20ccdbfcd440caf975dd2afb-1730303260"
  },
  {
    "email":"anastasia.bezginova@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652559738/d05415a90ee00c6c245f5f5c24bcf299-1730303260"
  },
  {
    "email":"annette.majoor@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726652592506/526daa42d18908080daa463c782441cf-1730303260"
  },
  {
    "email":"alessandrapegolo@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652690810/9ed713fce30930b010e1e04284b38dfd-1730303260"
  },
  {
    "email":"grazia2611@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652658042/3530636681882eee1c0b75e2a8a934ef-1730303260"
  },
  {
    "email":"paola.romuali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652854650/62cdf2872e5a1ba0523a7dea8ca89440-1730303261"
  },
  {
    "email":"irene.scocchera@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652756346/66ab5e8004d6f724000838669db6c2b1-1730303261"
  },
  {
    "email":"paola.romuali@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726652920186/93da42d2cf0435cf0499525d24e03280-1730303261"
  },
  {
    "email":"chiara.innocenti1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652887418/ee414c1903dc10d4f6fcde8c9bc85fe3-1730303262"
  },
  {
    "email":"edu.larisa@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652723578/d0228ef7b0ac0e08f70a3b9440fb28d2-1730303262"
  },
  {
    "email":"arianna_bertocchini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652985722/fb355f8e1342c2102c2742507f26eeed-1730303262"
  },
  {
    "email":"maria.gaeta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726652821882/ea6c6c9f59e9f0ee84d2a3c03cee6e65-1730303262"
  },
  {
    "email":"carla.perotti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653084026/2ae3b67cd8b35d518f46ef61120a5562-1730303262"
  },
  {
    "email":"pbaragliu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653018490/9c66837449eed4e31137b5c8bd49d1da-1730303262"
  },
  {
    "email":"haennichr@bluewin.ch",
    "url di attivazione":"https://verdissima.it/account/activate/22726653051258/eeb89bc89c6ed1041705ac8c0c11fd54-1730303262"
  },
  {
    "email":"elisa.annunziati@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653182330/eb5bd5eea6faded4069c414dba6c44d6-1730303263"
  },
  {
    "email":"bebelinelche@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653116794/e08d489c1e9f818eface9046dd54cfd7-1730303263"
  },
  {
    "email":"elvinzengin@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653247866/225a46a0d554a8e70cc36812beaec0b4-1730303263"
  },
  {
    "email":"cra_cra78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653215098/91991af7929959d3a95103dc174dc1af-1730303263"
  },
  {
    "email":"ferelx@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653346170/2e177dbcf522e7b7be99c8783ce41c01-1730303263"
  },
  {
    "email":"silvanacucco@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653313402/780f03dfb16e5f821ac0a7b508b89ca7-1730303263"
  },
  {
    "email":"chiarabri90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653378938/d5f685ab437f2f6cf053c6df0654f298-1730303263"
  },
  {
    "email":"silvia_winnie@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653477242/aec76a4952eb04dc1a8fadab4cc9d957-1730303264"
  },
  {
    "email":"carlettalanata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653280634/a5df1f710f7a13d4bfa2264a424dfd74-1730303264"
  },
  {
    "email":"cinzia.ferrali@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653510010/5a64553f1e5f90bd5d1c0872a1d17bd7-1730303264"
  },
  {
    "email":"73bmarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653444474/17ebe7ff46ca48949831571363b2d5c3-1730303264"
  },
  {
    "email":"morika.bressan@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653608314/c352970eeb761aedd20e240c95559b51-1730303264"
  },
  {
    "email":"leonardoamante@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653706618/d13ccba0864836d8ac21fcd9396da977-1730303264"
  },
  {
    "email":"annabertolazzi65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653739386/62bde2797521bfe377963fa3d18a6379-1730303264"
  },
  {
    "email":"janet.ryle@hotmail.co.uk",
    "url di attivazione":"https://verdissima.it/account/activate/22726653772154/e3ecd3d56539618e7516ba7f51d95704-1730303264"
  },
  {
    "email":"laurarisso79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653542778/a93b06cb8fe7f648e4135562f338eb40-1730303264"
  },
  {
    "email":"sasanelli.e@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726653673850/064ddf99113ce852906da70e055d9f45-1730303264"
  },
  {
    "email":"asartore65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653903226/8fc1b14a19aa98dd4112a8db4848a749-1730303265"
  },
  {
    "email":"von.doering@posteo.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726653870458/1de7e00ec7d80f6a94e14a960ab54fec-1730303265"
  },
  {
    "email":"snn.elisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653837690/df233f7e734b2aecd425638cc9dbda8a-1730303265"
  },
  {
    "email":"monicarizzo1005@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653968762/868b1128951a74403c9e5588d583e643-1730303265"
  },
  {
    "email":"villanisimona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726653804922/b22b73934bc3b0d6bbde61fa342e84db-1730303265"
  },
  {
    "email":"avv.ciardielli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654034298/58206d3e5fd14dbe49359a6df1243333-1730303265"
  },
  {
    "email":"gentilcoremariannax@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654001530/a02d40f667578661623846c9564fd4c2-1730303265"
  },
  {
    "email":"carmela-melfi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654132602/b2813a50ba22bfe67ab055ae055d2b73-1730303265"
  },
  {
    "email":"nicosca07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654165370/67f09a14498e9ee2fd8e746dfdb23856-1730303265"
  },
  {
    "email":"gbraida@olimpias.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654099834/4f6f0d5154d9487ffebb68139a63411a-1730303265"
  },
  {
    "email":"clara_pastorello@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654067066/fe25192f12c1dce651272eb8c79357b6-1730303266"
  },
  {
    "email":"simona.alfo@staff3000.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654230906/75bcd5a93d3d7027362fbd4e6eae9706-1730303266"
  },
  {
    "email":"daniela.bonato@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654263674/37c17ef106afc2c3b8a8d6cae50f0995-1730303266"
  },
  {
    "email":"martinolilau@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654198138/e2241980e6bc40f25430e0c4b0f40eb1-1730303266"
  },
  {
    "email":"monicamussini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654329210/fd6ff7bc435abe95311833b696e390ac-1730303266"
  },
  {
    "email":"elycarbo@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654394746/7d40bf573df2e59dde88e07d4bbfe90c-1730303266"
  },
  {
    "email":"manuela_mariani@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654460282/c254fa023d050ff976546afc069ee6c0-1730303266"
  },
  {
    "email":"raffyci23@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654493050/96b0fa9352636625c29a0342f364cf34-1730303267"
  },
  {
    "email":"manuelala@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654296442/23debc51283bceebeaac28f9b50a5099-1730303267"
  },
  {
    "email":"bezza88@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654525818/9d137ee9d2d2e673da415445c217f073-1730303267"
  },
  {
    "email":"ghidinisilvia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654427514/574934ba394d86721cb9dab1b538a73b-1730303267"
  },
  {
    "email":"silviacrisci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654558586/e5aebffe6e81549df1d3d69a4a26807e-1730303267"
  },
  {
    "email":"vespina88@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654591354/b2deb048242821450316208601c82398-1730303267"
  },
  {
    "email":"elisabettaksz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654689658/25788105a5f85f0ad1027b64ca6da58d-1730303267"
  },
  {
    "email":"mariavittoria.dallasta17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654722426/e0d6c2a0600c584461c7aa3c16ed81e9-1730303268"
  },
  {
    "email":"paciy@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654787962/105c1f79f62989f238d1f30bf1efa300-1730303268"
  },
  {
    "email":"cicerone.francesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654624122/58420abaf7f8736fbc796002a073c153-1730303268"
  },
  {
    "email":"themessl-huber@gmx.at",
    "url di attivazione":"https://verdissima.it/account/activate/22726654820730/d053f9e7be9fb811619a1865406d1ec1-1730303268"
  },
  {
    "email":"mariamaugeri0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654919034/7646ba6b00fa8671c728a691afd0d132-1730303268"
  },
  {
    "email":"67.steffy@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654886266/98bf790fa11beec80774c16d7a7bba28-1730303268"
  },
  {
    "email":"tilipopa@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654951802/e1c16d3594f5c34f1432b47ff43892a5-1730303268"
  },
  {
    "email":"chiaramusso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726654755194/8b296e5cedf9c9b1a31b912ed7cf5583-1730303268"
  },
  {
    "email":"fulvia.stra@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655017338/b53537352f6c830bbbc58cdb3f14c746-1730303269"
  },
  {
    "email":"cinziametalm@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655082874/69f644b9ca1ff0217fcb03190492ea1e-1730303269"
  },
  {
    "email":"farmaciamelfi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726654984570/ad50e38be911b7f5c54c7e109a9672b4-1730303269"
  },
  {
    "email":"rosabiancaripoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655181178/ef07a41783e9f71460c2687badacdeaa-1730303269"
  },
  {
    "email":"anna.selva90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655115642/686d60ebb394b149460bf92603ed6cc0-1730303269"
  },
  {
    "email":"monicagreco1974@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655050106/22ac4d95551950a7ad94d01c38c0c4e7-1730303269"
  },
  {
    "email":"mariagrazia@studiocentrella.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655148410/5b9672ff2c098cfc48f0d5307d340707-1730303269"
  },
  {
    "email":"afm.campani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655213946/5dc20f844ce0dc136d3e6a8a1b061662-1730303269"
  },
  {
    "email":"francypisani70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655246714/27a3cc8177fb91d3f2d52ebab93f610f-1730303269"
  },
  {
    "email":"monicabetelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655279482/1967ed03b5acfb929e35ca0037b46041-1730303269"
  },
  {
    "email":"gladysc206@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655345018/eab47bfa31e964f463cc3a46605be6f9-1730303269"
  },
  {
    "email":"giusycremonesi4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655377786/bd60959a5a8ad851fef85910c548da6d-1730303269"
  },
  {
    "email":"saracrepet@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655410554/926637ed239fe2f68f1b2c0a51f51988-1730303269"
  },
  {
    "email":"lory4ever@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655476090/74b4636b7c32d86d175e5b494470264f-1730303270"
  },
  {
    "email":"lara.raisi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655443322/b706d5dfaa8af285eebba1e30a58eca8-1730303270"
  },
  {
    "email":"manuelamusenga@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655508858/1a46babc928196985416ab43d7ffcc0b-1730303270"
  },
  {
    "email":"nicoletta_4@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655607162/a3fedef26771e2a59ca55996604d56e6-1730303270"
  },
  {
    "email":"victoriasalvador2011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655574394/1d68cc66e1d948d36a00999d9003be15-1730303270"
  },
  {
    "email":"elgiloca@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655541626/832f2ffea7a99618be44e756f7b8fa24-1730303270"
  },
  {
    "email":"lenamas@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655639930/22b47bf15847ede613f775aefc87fc51-1730303270"
  },
  {
    "email":"elenaambrosini1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655672698/4b49b2f50538c6526b844b5dbfe37f61-1730303270"
  },
  {
    "email":"giovyrusso1976@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655738234/c411b7c386e1bdd0148ee1a1a2da9810-1730303270"
  },
  {
    "email":"anamartinezrodriguez4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655771002/359cb0868156f93ed6db3de2605b15a1-1730303270"
  },
  {
    "email":"elvyretta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726655836538/22e65877fef3a31270031fc4c5a92336-1730303270"
  },
  {
    "email":"gpicchietto3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726655869306/777dbc7a6a7e28bff6d502eb7cf3c7e3-1730303271"
  },
  {
    "email":"monica.poisa@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656000378/6404cb24a59cba3aa840bdd83bc6a9ba-1730303271"
  },
  {
    "email":"daniarosin@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656098682/906015a596f91f07a2387934da7fc9bb-1730303271"
  },
  {
    "email":"ekoliou@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656131450/181d39406c89f01830852f7456dc91e1-1730303271"
  },
  {
    "email":"gloria.mugelli72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656164218/036be720e2a28d34d293f2435d723711-1730303271"
  },
  {
    "email":"mgrazia.cariglia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656229754/1d64bae68ba144f34fef658e17c31552-1730303271"
  },
  {
    "email":"c.manola@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656262522/f3df5f53818d5951c40fa2563298c772-1730303271"
  },
  {
    "email":"occhipinti.vale@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656295290/82a8f4011b82941fcbc3b3756178539a-1730303271"
  },
  {
    "email":"monicaiori66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656426362/824413d9ab57b4a5b147f225c0b1ce5e-1730303271"
  },
  {
    "email":"nako.artigrafiche@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656459130/f5ddedac82f7d989d402f2601ccd02b6-1730303271"
  },
  {
    "email":"maya9671@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656360826/0c7498ad4b270e02024c5af468a44db6-1730303271"
  },
  {
    "email":"eliana.mastrantuono@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656328058/b22d6895ea233c90601c3dc68e62f7f2-1730303271"
  },
  {
    "email":"marinasandri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656491898/55207105cb3dad298988ef37ce8a47e7-1730303272"
  },
  {
    "email":"annamariagiuntait@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656557434/125b23f09938a8ccffc0d24d5b483ad9-1730303272"
  },
  {
    "email":"teresa.truchan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656688506/e0db0487325db418ec1feddd0ab9b327-1730303272"
  },
  {
    "email":"marcianoanna@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656622970/2df2896c49c7034e59a8b0c661302bc3-1730303272"
  },
  {
    "email":"silviamarianifarm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656721274/521c3e0bc20a0fab62453bc6e09b0657-1730303272"
  },
  {
    "email":"valentina.patacca78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656524666/23ac9716678027b321ae4c4cbc0903dc-1730303272"
  },
  {
    "email":"cristina.torrini65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656655738/f23f34378192c31898312ff5d6b06b7b-1730303273"
  },
  {
    "email":"venturamaria1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656786810/c8b95f563ee3dbaca2778517abf11e3a-1730303273"
  },
  {
    "email":"vitalba@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656852346/2af0ea285a50705d348908717d256748-1730303273"
  },
  {
    "email":"ornellamoretti6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656885114/ea0550ed355ee738e1f5be133373d542-1730303273"
  },
  {
    "email":"mabo5760@alice.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656754042/69cdfe9d95b7da5ba96e6a87631458f0-1730303273"
  },
  {
    "email":"sibybra@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726656917882/b4e6793fef41bfa098fc08f023c14938-1730303273"
  },
  {
    "email":"patriciarod3011@yahoo.com.br",
    "url di attivazione":"https://verdissima.it/account/activate/22726656819578/d7d3395d017ef05cc0f01a022caa7ed9-1730303273"
  },
  {
    "email":"claudiacatania@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656950650/455307d27c29b0ae13d8c03c093c3d48-1730303273"
  },
  {
    "email":"erika.biagi85@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726656983418/67bcbd6f98fb7a6c65489419ee303aaa-1730303274"
  },
  {
    "email":"wendy@mirtilla.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657114490/4b9b38ace5d88d90d6091c93babad9c9-1730303274"
  },
  {
    "email":"crstnbs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657048954/784c8ddde898bb02c7bd30835cb0e3e1-1730303274"
  },
  {
    "email":"irina.roscs@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657147258/0e52b619c29ec288eb9bf1ce936f64f7-1730303274"
  },
  {
    "email":"giulianita1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657081722/5ea73ac6d77ac6e1ea77619d5837aab8-1730303274"
  },
  {
    "email":"sanzio66@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657180026/8ae74c814d0c3d18879300a12fbe09a4-1730303274"
  },
  {
    "email":"teresavescovi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657212794/39da1f03ce494556434ebab204301bdb-1730303274"
  },
  {
    "email":"morena.argazzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657245562/589e65ead3ee0dcbb3be549504534c97-1730303274"
  },
  {
    "email":"sasanelli.e@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657278330/0e77de079b5c230f662e8cf8f9defe9f-1730303274"
  },
  {
    "email":"paol.battistelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657311098/4ff73919c10b138285857dbcf317f3fb-1730303274"
  },
  {
    "email":"clarissa.zacconi93@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657343866/7d9659584076eba2776e4bb9f734787f-1730303274"
  },
  {
    "email":"tgiorgi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657442170/da0aae3fac86ce9df7e19c6046748e54-1730303275"
  },
  {
    "email":"annettavolante@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657474938/975248bbdbd1f53372054b3494fffc95-1730303275"
  },
  {
    "email":"simona.dallape@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657409402/551631a5b8b5f902620fe7b7b723efe5-1730303275"
  },
  {
    "email":"laurabianchini@virgikio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657671546/9705842fc693b10a913afb75aa06f7a2-1730303275"
  },
  {
    "email":"alessandracucuzza@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657606010/bbe936a03ad488b3e43e3c45350a9998-1730303275"
  },
  {
    "email":"seroby2002@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657507706/d429320548d061d6081b2e7f9fb4305b-1730303275"
  },
  {
    "email":"sabine.metzger1@googlemail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657573242/003748dad5570cebfcd6f978e33018d5-1730303276"
  },
  {
    "email":"laura.botta73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657704314/12137adcd6a811762d0dd17dac295339-1730303276"
  },
  {
    "email":"antonellabandiera72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657769850/d9849d67bb64a1280231100eacf472a2-1730303276"
  },
  {
    "email":"delfinoale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657835386/3c66e788fff2c6a9793a24a7acf322b7-1730303276"
  },
  {
    "email":"misstitti76@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726657900922/13c43060398d1c3fd4acd17855869668-1730303276"
  },
  {
    "email":"angela.losurdo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657868154/5fda58d637d87651ebc68dc18a1e5333-1730303276"
  },
  {
    "email":"tinaeffe73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657933690/46cfd542bd93e9254926ad5a1d517723-1730303276"
  },
  {
    "email":"rosasannino1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657999226/fbd84e2ad6e2cd0661e34118e9f9f60d-1730303276"
  },
  {
    "email":"eribi2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658064762/de5544218fce3d0a520bfb65c2784b9d-1730303276"
  },
  {
    "email":"peterlenadia@tahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658097530/006649d12539dc502a68cb53305b4bc9-1730303276"
  },
  {
    "email":"milvia@ducadivarese.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658130298/8fa9331dc02a32a3bd3e0e2e074a8d9b-1730303276"
  },
  {
    "email":"elenrico06@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658163066/a666a1cbee79ce49b8d22dca49ffba16-1730303277"
  },
  {
    "email":"aletomassetti74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726657802618/d0dc79e206b272717a4e5d29a129bcdf-1730303277"
  },
  {
    "email":"dicunzolomarmi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658195834/835bee8b3ec2bdf900cb0fc4c730b4e1-1730303277"
  },
  {
    "email":"raffaella.calvi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658228602/3681ab3b70d4c097500a425805be75d6-1730303277"
  },
  {
    "email":"donatella.melino@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658261370/3ed7fd3e798d22bcecf249a094f4fa65-1730303277"
  },
  {
    "email":"ornella2907@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658359674/ebf5b670c4a92e4ba4107c4ff47810cb-1730303277"
  },
  {
    "email":"elisabetta.capasso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658294138/9997865ff0e9d6682c880a11a4fc2906-1730303277"
  },
  {
    "email":"cinziamodesti@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658326906/6657af06a939d3f6aed49ec5dbbf6e12-1730303277"
  },
  {
    "email":"anna_aug1981@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22726658392442/f73fc6a18a72b92c025a6549399f4612-1730303277"
  },
  {
    "email":"desicir@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658457978/1449a757f59be4786ea5484953afd76c-1730303277"
  },
  {
    "email":"lanaflora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658490746/156ad2d7c8c7b8b7816665b7b2eb9427-1730303277"
  },
  {
    "email":"lorena.migliore@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658425210/35173a98f8d653ab165926ab84d18fea-1730303277"
  },
  {
    "email":"commerciale@generalserv.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658523514/a42493f5d73496b258b1bab1db25a6be-1730303277"
  },
  {
    "email":"laurottina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658556282/6398bab070613fc057335acc6ce5ba7c-1730303278"
  },
  {
    "email":"mussumecifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658687354/8d5be1f4f8a5cd4ee9e562f21cdba539-1730303278"
  },
  {
    "email":"annaritapagnotti@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658654586/1e58c092666a982fba56761ffa153bf8-1730303278"
  },
  {
    "email":"tintorikatia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658818426/7b7eda9285cbb48fdd5446e0f4b6d44a-1730303278"
  },
  {
    "email":"benedetta.poma@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658621818/bcadc3935067e2009038cf2e9f083e5a-1730303278"
  },
  {
    "email":"tittidanna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658883962/e662ac0b4eaa6766836b68a05a45540a-1730303278"
  },
  {
    "email":"marinacennamo@gmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726658982266/d6ccef82043650cf68dcaaebb6a850fa-1730303278"
  },
  {
    "email":"pincopallo500@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658851194/945556ec00247624164ef7bdcb78e5b8-1730303278"
  },
  {
    "email":"rizzolomara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658916730/0676641bbe76aedbbd9e0e7f44377893-1730303278"
  },
  {
    "email":"arch.ginevrarossi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726658949498/033aad059c70b80f533ef75d23ed879a-1730303279"
  },
  {
    "email":"luca_m2009@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659015034/6356e5b71be2a84b1e9d2fd4c0cfcfed-1730303279"
  },
  {
    "email":"pica.paola68@mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659113338/9c461e43ee2e37dfac9a41e480e4d533-1730303279"
  },
  {
    "email":"danielalopiccolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659080570/737e83f89b294bc7499b933eef836bd0-1730303279"
  },
  {
    "email":"tizianarusso1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659178874/6f600ac73346caaa30acedd5f0379f68-1730303279"
  },
  {
    "email":"giobarreca.3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659047802/21e83620b3b2d5d672d094f1150b2cf7-1730303279"
  },
  {
    "email":"m.c.palmieri33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659211642/7e8cfe8185cd522278b7569afd69f8f3-1730303279"
  },
  {
    "email":"rosannagiulitto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659244410/a1f16d695708986c2f37d588a010b9ae-1730303279"
  },
  {
    "email":"jun-marquez@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659277178/d1e54675b57e2dc9d114bad2f6c90646-1730303279"
  },
  {
    "email":"resena@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659375482/4d7a4edab70dfa8bb522f5e62be57c12-1730303279"
  },
  {
    "email":"pegorari.alessandro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659309946/100ac721931c185b3ae45c1c73d41fd2-1730303279"
  },
  {
    "email":"demartinialessandra@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659342714/8e5d72550172fbca741d3f90cb854585-1730303279"
  },
  {
    "email":"gmonia72@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659408250/86e6a1e17afd2bc1436fd9cb05064960-1730303280"
  },
  {
    "email":"elymerici@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659473786/5c1fb799cb5d2272fb0c649599372fe8-1730303280"
  },
  {
    "email":"francesca.07santoro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659441018/6a009eb36b9825f161fc0e0a4f2d0dab-1730303280"
  },
  {
    "email":"abbiati.marta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659539322/eec62031af8b68253afd35b7fd5b08e3-1730303280"
  },
  {
    "email":"forestianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659604858/4d58d47a8c94d92b2c22d41245fc4841-1730303280"
  },
  {
    "email":"mariaelisanoce@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659572090/08481683855ce54ae712c53605fb901a-1730303280"
  },
  {
    "email":"joaqui4321@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659506554/c43bbe6ba9a371f0182a33f40ba550e0-1730303280"
  },
  {
    "email":"luisa.fogolari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659703162/b10b5d3eb32ad6d3558e70b6564cdd88-1730303280"
  },
  {
    "email":"genoveseelena@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659735930/94efc23f599c00047d353571ad668204-1730303280"
  },
  {
    "email":"andrepirre0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659768698/666d5b81df2e7ed1fff2f39ea884a35d-1730303281"
  },
  {
    "email":"martedeluca005@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659637626/2f39807ca75a5218042ee6ea54280574-1730303281"
  },
  {
    "email":"fedigianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659670394/ae92bc52d469d63a92a0966a83b8cfc2-1730303281"
  },
  {
    "email":"annamariafragale2006@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659899770/d44736c6849443c782cda5ab0d8e5488-1730303281"
  },
  {
    "email":"marta.lantero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659867002/50409715d8dc1e12f4904177cdb8e21d-1730303281"
  },
  {
    "email":"anna.deluca@unirc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659801466/062d3d5db267f11c158cfc36a1e452f2-1730303281"
  },
  {
    "email":"irene73@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726659965306/f26b137ebe63381682335b983ca563e7-1730303282"
  },
  {
    "email":"paolaugenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659998074/ff3a0d0a1600785ed9327f2de33af900-1730303282"
  },
  {
    "email":"silviascaringella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726659834234/4bc71a1054d13cb636055e78a785823f-1730303282"
  },
  {
    "email":"vasilis3by57y91320@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660096378/b05814bf34b9a9776d61e1b8db80ed0e-1730303282"
  },
  {
    "email":"emanuele.guidotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660063610/2429adb30a64f5a726462b2bbb134b84-1730303282"
  },
  {
    "email":"olgica.jurkovic@ri.t-com.hr",
    "url di attivazione":"https://verdissima.it/account/activate/22726659932538/f4df85bf845de2a46449ae79487188c4-1730303282"
  },
  {
    "email":"erika.bonazzibonaca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660227450/7b16e5d67a14a270ab88f21db778c474-1730303282"
  },
  {
    "email":"viorica.tomescu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660161914/8a2e3518e3e7db637a813979a7cbe9ea-1730303282"
  },
  {
    "email":"alifas87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660129146/3ca5fcfe043a9685c983745b588cd7f4-1730303282"
  },
  {
    "email":"ninnibea@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660358522/f22161c8aa1994aa5dc0e888465f23b0-1730303282"
  },
  {
    "email":"terry.lazzaro30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660260218/a460572c61264d85c284110c72cfa80a-1730303283"
  },
  {
    "email":"grechi.matteo@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660456826/a35a2e33b3c59a3a556d89aec0eece84-1730303283"
  },
  {
    "email":"guendalina.bastioli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660424058/718cf5f5e378b38a5479735e6112df83-1730303283"
  },
  {
    "email":"basile.claudia6423@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660292986/5c77af6100cf40608ffe34e794b3be68-1730303283"
  },
  {
    "email":"studiofregoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660522362/82b363d9615ac160cc967129f5bb90f6-1730303283"
  },
  {
    "email":"degiorgi.milena@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660391290/a661d8a4f079ef2faabd7ad675cfcbda-1730303283"
  },
  {
    "email":"katynaty77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660587898/ee5ff2a7c2298b63f929bb392a5af8e8-1730303283"
  },
  {
    "email":"simona.prin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660555130/b404ffa67cd3a6e72bd1d50f34f2604b-1730303283"
  },
  {
    "email":"ciemmetp@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660489594/ad5a4dc651b5a76d602452ac1175e94a-1730303283"
  },
  {
    "email":"dedep1974@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660653434/bb1d6a448ce40217e67b329332f9233f-1730303284"
  },
  {
    "email":"b.patrignani@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660686202/be3867b710c922c6d07bddf904d0a060-1730303284"
  },
  {
    "email":"disarnoilenia@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660718970/1ed5aaf752ac00fe7214ac10e9d0a00c-1730303284"
  },
  {
    "email":"alessandra_meneghetti@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660751738/18092562387cba5c9c7c0c8471ee03eb-1730303284"
  },
  {
    "email":"antonella80.pirani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660784506/47f37a50a4f47a217cc37c44a4d73f66-1730303284"
  },
  {
    "email":"frmanes@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660817274/a3ebb1cc3b3a3f031a6e63180ad5bef0-1730303284"
  },
  {
    "email":"roberta.dagostino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660882810/e5caba8e808107e6bc5c08a8ff0e22cf-1730303284"
  },
  {
    "email":"elisabaroni1978@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660915578/db6d0315ad010d6ad3f44ae097b16bdd-1730303284"
  },
  {
    "email":"laura.lampa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726660948346/6a4767f5ad0f10763d7b5a3e26929e86-1730303284"
  },
  {
    "email":"palone.loredana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661013882/f83259fb42de310ad23e0bf57aa04bdc-1730303285"
  },
  {
    "email":"dott.antonelladellavolpe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726660850042/307a9f1a3ae180c0f1e150f4698ec63a-1730303285"
  },
  {
    "email":"tina@placer.si",
    "url di attivazione":"https://verdissima.it/account/activate/22726660981114/e51513b3213e9e74ee2231157dc3e0a1-1730303285"
  },
  {
    "email":"accion@accionavanza.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661112186/9dea5cb10bf255d4cd4053f0a4f7a793-1730303285"
  },
  {
    "email":"pascal.mourier07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661079418/f0980d36f221ec3428022558bec95017-1730303285"
  },
  {
    "email":"arianna.bertocchini@opbg.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726661046650/e4ade2fcb4be17a01c72258201b0942d-1730303285"
  },
  {
    "email":"condurso.tiziana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661243258/60ad7e2e2bc6aef4c924f041093cdef7-1730303285"
  },
  {
    "email":"maria.daniello1979@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661210490/cc465b30f9ee15971d0f32c272d8eb3b-1730303285"
  },
  {
    "email":"claudiabattaglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661308794/a34f17de608c7e2bacf5da83cfe1a671-1730303285"
  },
  {
    "email":"helene.acanfora@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661374330/a258d6499be83bfd5b97573a64dd9489-1730303286"
  },
  {
    "email":"samanthabarone77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661177722/7ca84a71fa6bd7a188b9fb05a6b4bd70-1730303286"
  },
  {
    "email":"59colmar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661341562/263b3393e451cbeca918b3e3aefc3239-1730303286"
  },
  {
    "email":"tarquinifrancesca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661407098/483934f09352db121ea0f27d7e990006-1730303286"
  },
  {
    "email":"luciacasciello1981@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661276026/37ac4dbda6b21204a076dd07f3efd651-1730303286"
  },
  {
    "email":"renata@clicky.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661505402/f28baab7ab9da14924593b3585c5abc2-1730303286"
  },
  {
    "email":"catebovo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661439866/32f95e2574a0ba88eed0909ebd36aa85-1730303286"
  },
  {
    "email":"adrianaorofino78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661636474/717e37d34c7715978121c96320ecb959-1730303287"
  },
  {
    "email":"tizianami@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661538170/531bc0f2835149b86673932bec306419-1730303287"
  },
  {
    "email":"marlindamarin@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661669242/bb7535a9d1b00ff0b5fa8b6448a5722e-1730303287"
  },
  {
    "email":"mariia883@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661702010/bf04227c7bafc5c30abe8d3805dcbbbd-1730303287"
  },
  {
    "email":"rosanna.jonckheere@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661767546/87ac8f2875f2bd3c06c437604b024cdc-1730303287"
  },
  {
    "email":"giuseppedicicco9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661734778/7637f72bbb119e36bf686d0cfe325265-1730303287"
  },
  {
    "email":"gattimonica1971@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661570938/3130d656331527555ff1b5910bd640d6-1730303287"
  },
  {
    "email":"marinolea77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661800314/bb3b5ff88b3deb9c2ee3e1ad7cc0a3af-1730303287"
  },
  {
    "email":"donna@nbinternational.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661898618/e9cceeff44ec09679fb362da6bb9c4ed-1730303288"
  },
  {
    "email":"carnevali.laura81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661833082/547e8bd13f0c61dc7de6618eb2b28164-1730303288"
  },
  {
    "email":"patrizia.marino62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726661865850/f381c57654c7a38d41db3a5bfb2e0f12-1730303288"
  },
  {
    "email":"gianluca.mutinelli@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22726661964154/070bb406edb76901a3e97a161329a0cd-1730303288"
  },
  {
    "email":"gmerlo@alteanet.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726661931386/a21f0710db17de7ecc77ed0cd5b19d6d-1730303288"
  },
  {
    "email":"martinadorigoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662062458/03b52a551ef60e75523a154865ca7a07-1730303288"
  },
  {
    "email":"giovanni.cesaro@h-en.me",
    "url di attivazione":"https://verdissima.it/account/activate/22726661996922/0c1fd14bf52de8933bdd13cd46ae9acd-1730303288"
  },
  {
    "email":"rivadossipao@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662029690/6a4b62d897fdf3aea30199c312fea040-1730303288"
  },
  {
    "email":"rgiusi15@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662095226/7ac994ea7bd3ba46350aba824360215a-1730303290"
  },
  {
    "email":"monica@termoidraulicazennari.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662193530/66bdf4f70f8ea09d49d4728b1d1e7a4b-1730303290"
  },
  {
    "email":"michelagambini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662127994/218a0530223a50f8c93a2a699a42f4cd-1730303290"
  },
  {
    "email":"lilianavenezia@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662160762/2be874d7a9885437a1c0fea8a07cc258-1730303290"
  },
  {
    "email":"fanny.kornmann@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662291834/a8623d1162a716e51f6eb913f4ecf5cf-1730303290"
  },
  {
    "email":"giorgia.accorinti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662259066/8f4421cd98d03b65479ba15a6b4a0460-1730303290"
  },
  {
    "email":"fabiana.favitta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662357370/c156faadbe3050a9f2d10a5d27c7214e-1730303290"
  },
  {
    "email":"roberta@curiousclouds.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662390138/3c9e5eeb8603677cf77580b6bd1ba5e8-1730303290"
  },
  {
    "email":"folies09@orange.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22726662226298/3d8bbd4ed2d22f05fd3cfd98a4e00ba9-1730303290"
  },
  {
    "email":"angela_cantelmi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662324602/5813bda75f3955a4f43982b06badc538-1730303290"
  },
  {
    "email":"stefaniacolleoni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662422906/3943bb8fbb8a7110868412ba5a25afad-1730303290"
  },
  {
    "email":"federica.cordone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662553978/7dedde5ddb3e3836cb52eb438b6146a5-1730303291"
  },
  {
    "email":"angelatumminia72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662455674/a3f25dbdc792f7732b98dd533088a8f1-1730303291"
  },
  {
    "email":"erika.zamboni1978@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662586746/7c2f05dd2ea3c9f93fe0abd9c4c1027c-1730303291"
  },
  {
    "email":"stedoldi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662619514/41eae7b1322a3973b69a1e2c51903c61-1730303291"
  },
  {
    "email":"annacavaliere89@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662652282/413dc884d2f39aaca12fb1dedf87e0e8-1730303291"
  },
  {
    "email":"toango@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662521210/4d5293977bc3aa977d3f524749bfb4d7-1730303291"
  },
  {
    "email":"katiagentile1977@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662783354/14f02d83e2e8f25d946fb26e25beeb76-1730303291"
  },
  {
    "email":"laura.pezza@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662750586/aa736ea72a72dca6e50e95ceba767bb0-1730303292"
  },
  {
    "email":"noeldupereau@orange.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22726662685050/332f825dd8f6abd7d14e7c27e2251483-1730303292"
  },
  {
    "email":"sdefranco69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662717818/bb10651f99138f2f579da6adbbfe7084-1730303292"
  },
  {
    "email":"cryedany@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662848890/55ad86af3f50988cb59c7bb648b55dad-1730303292"
  },
  {
    "email":"a.demeglio@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662816122/49073e0735849f9eebf90bf12f12defa-1730303292"
  },
  {
    "email":"laudavo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662947194/a9d7a75aa0b13201f98d2ae0a882c963-1730303292"
  },
  {
    "email":"adacataldi61@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663012730/949fd5ea3e52223e60b392ac63db0247-1730303292"
  },
  {
    "email":"fationah@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726662979962/2f1bea6face319e6dcf76abddeeacb16-1730303292"
  },
  {
    "email":"cpg.roberta@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726662881658/df164833f302ebc7bcbc2cba323ca1c5-1730303292"
  },
  {
    "email":"xfarooqix9y0au29y@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663045498/aac41f250a2c9adab13e10918dddf17c-1730303292"
  },
  {
    "email":"paolacat77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663111034/59a2aade48102ea57c1c6e70cac284d0-1730303292"
  },
  {
    "email":"dariia.mykh@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663242106/1687ab3d8514ec96a4f861bf427078bc-1730303292"
  },
  {
    "email":"flavia64turcato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663078266/a57acbc9a070413e32076f7a425371a2-1730303293"
  },
  {
    "email":"ivkre@seznam.cz",
    "url di attivazione":"https://verdissima.it/account/activate/22726663307642/25f201926329bb232a3b00752bf02d78-1730303293"
  },
  {
    "email":"claudiapizzardi@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663143802/b94a8992815da90ccd58f152ceba0158-1730303293"
  },
  {
    "email":"carmenriverditi@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663340410/12ace0a46736eaadfa17de3cce3383a3-1730303293"
  },
  {
    "email":"m-rivi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663405946/a06f689eff9a09d8ef2c9ff2ff3baf84-1730303293"
  },
  {
    "email":"manuelabatistini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663274874/5dd5a19e19baea488c7a5a4e4a04e1c2-1730303293"
  },
  {
    "email":"roberticlaudia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663438714/ae487b58be90d8ba4c5e8b0a9984b3fe-1730303293"
  },
  {
    "email":"roberticlaudia@libero.ir",
    "url di attivazione":"https://verdissima.it/account/activate/22726663373178/c3f5dc316cd703756f28540acc4feeb7-1730303293"
  },
  {
    "email":"simonettasaveri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663504250/27bd324132f1bb2547402d1650823e9c-1730303293"
  },
  {
    "email":"monica.biondini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663569786/48d4efd51fdc0b51782c24484f3be7ab-1730303293"
  },
  {
    "email":"n.stratila@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663635322/ab357bb727f4ff130e5bb119d0a08fcb-1730303294"
  },
  {
    "email":"andgiacomocriteo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663537018/dbd2ad46c1f9cf044515dc8ceeb7de79-1730303294"
  },
  {
    "email":"ricciardiines@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663602554/f2e1e33a4e6c37bf68cd2a8dbec740d5-1730303294"
  },
  {
    "email":"giusygalvano9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663668090/bcb284fa2a24d73caade6b29223ce963-1730303294"
  },
  {
    "email":"natalia.pianesi@eng.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663864698/a560468f4edd27e53cade15b8af2d32e-1730303294"
  },
  {
    "email":"martinaingletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663700858/6e94bbbe9885eef22c219f949caa6572-1730303294"
  },
  {
    "email":"m.ramacci@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726663897466/7b673a7a5e12ab8e46d3f18a01e66bf9-1730303294"
  },
  {
    "email":"claudia.schruefer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663831930/ec24d6dfc0503dc995c0e53471a76e09-1730303294"
  },
  {
    "email":"velia.olini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663963002/6ee598276db8ef607f5cbb80c1fdc850-1730303294"
  },
  {
    "email":"sestinamarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663995770/92ecc0b3e83f4028a59ef1ca602d37e3-1730303294"
  },
  {
    "email":"mtatr@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664061306/211a680966e16a67b000a1d9c6129b2b-1730303295"
  },
  {
    "email":"info@mioequilibrio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664028538/9c33059aaf38399e10c7ffa7fd5abfb3-1730303295"
  },
  {
    "email":"famerloni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664159610/99e088276a5a23060af56497a54ef53e-1730303295"
  },
  {
    "email":"guerraantonia98@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664126842/893f6bcbfcd676eac8978bd3e85a50e9-1730303295"
  },
  {
    "email":"annalisa.penzo11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664192378/150e8f1c03a549cfea3127b48c71c7a6-1730303295"
  },
  {
    "email":"nasernajjab@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726663930234/b54b29e32275757d3da007f292ea147b-1730303295"
  },
  {
    "email":"teclazanatta@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664225146/54aaeb59280dd092df08dd5a4673c760-1730303295"
  },
  {
    "email":"paolamarianolli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664257914/7b871a2aa4495f942503092332393181-1730303295"
  },
  {
    "email":"luisa.romano@vermeiren.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664323450/50fba75375020eb79dabf277e50bf33f-1730303295"
  },
  {
    "email":"manuela.contarino@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664290682/2ccdf997d089efe10031309675f5b05a-1730303295"
  },
  {
    "email":"florahyeraci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664454522/dc6b4b806b009e144bed27417b714fe2-1730303296"
  },
  {
    "email":"giovanna.gagliotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664421754/b07c7effbc911388a5b3e3e6163c3752-1730303296"
  },
  {
    "email":"teresa.galenda@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664388986/30dd0b268dc1cb4d893dd5cff806582e-1730303296"
  },
  {
    "email":"fiabaland@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664520058/49eca12351eb913ddc0393e70db10460-1730303296"
  },
  {
    "email":"tanburini.t@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664356218/a47d785030702b8240386c31b1204baf-1730303296"
  },
  {
    "email":"valerighe80@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664552826/da9ee1f27bc716dec49152f701866a14-1730303296"
  },
  {
    "email":"alfonsoamitrano2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664487290/dc67f504c9a02979fb6db85bf1122711-1730303296"
  },
  {
    "email":"caserta.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664585594/61479684dbbb526ef2a919cd6d72a1c2-1730303296"
  },
  {
    "email":"anne.struck@web.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726664618362/7433d5f66122bdf3ba474a5b727aaa2f-1730303296"
  },
  {
    "email":"manupas2001@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664683898/614c69910dc75dd07448b4d6c8d10414-1730303296"
  },
  {
    "email":"dan.cam.ch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664651130/c83fd07853401200e0d02dab235e35cc-1730303296"
  },
  {
    "email":"mteresa.savini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664716666/50ad43882d3f4113ba0625f6dd6ab407-1730303296"
  },
  {
    "email":"dimiliamaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664782202/0fa4012e87b0c4dd9e405019ecaf7abb-1730303297"
  },
  {
    "email":"marta.papela@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664814970/c74683d8c60daac6edcc41a7493212a1-1730303297"
  },
  {
    "email":"teresa83randazzo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726664913274/2e7481ab30ce846db8a005b49724a0ba-1730303297"
  },
  {
    "email":"romiefili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664847738/6d5c5f13bc1781e8b36ed51151011989-1730303297"
  },
  {
    "email":"mracarbone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664946042/03e08964a4484b20d7cb9c331e00c08c-1730303297"
  },
  {
    "email":"timea.mozolova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664749434/f4e9b26e8a8b8af689654e48e794f695-1730303297"
  },
  {
    "email":"luisellapozzi23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665011578/dba6548ea16f0b98124b4e3a388bfd04-1730303297"
  },
  {
    "email":"invidia.darbitrio91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665044346/d07aeac4813458a71e0c2c5e7c45f296-1730303298"
  },
  {
    "email":"m.paris64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665077114/eea029d41c408f7b13b36b5ec7b6ded6-1730303298"
  },
  {
    "email":"adinadumitru82@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726664978810/ed174a1595776a3620c12c57a7633f8f-1730303298"
  },
  {
    "email":"alexpata@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665109882/52e9eee6cdd97dfd67bf8afc32eac2a5-1730303298"
  },
  {
    "email":"gacy64@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665240954/da46a9fc16cc998227463bcc125b5b79-1730303298"
  },
  {
    "email":"gisella.estetica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665175418/746585c233a6bc1a930e91db9d3bae7b-1730303298"
  },
  {
    "email":"gargano_daniela@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665273722/87020b54fc34412c1e5404ec5a859719-1730303298"
  },
  {
    "email":"miriamtorselletti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665208186/95257e6a913f6cb2117b9143ac45e11c-1730303298"
  },
  {
    "email":"francesca.toccafondi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665339258/3d17b2e81f26f31a800fab4b4dadef96-1730303298"
  },
  {
    "email":"antonellacammarano@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665372026/96d8831e987741e93a1778b892ab8588-1730303298"
  },
  {
    "email":"laurabeatricesavini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665404794/5508bcb73d4f1df6b3e65465a0a911ae-1730303298"
  },
  {
    "email":"cristina.cuende@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665306490/5b2352fdb186ee2f2989928e0348b57a-1730303298"
  },
  {
    "email":"masunbf10@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665503098/029832d19aef0c1b34612edf0bdfcbc1-1730303299"
  },
  {
    "email":"maciocchibruna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665470330/c2314a6c8bd2ec3d076f506ea080e2b1-1730303299"
  },
  {
    "email":"vito.dichiara79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665535866/45a79c5d267127f66507694d8b55a75a-1730303299"
  },
  {
    "email":"clelia.son@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665437562/52fef571d40d7de1772a2d9943891a1e-1730303299"
  },
  {
    "email":"valentinadedona@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665601402/48806fb025a743336fc7f3499105df9c-1730303299"
  },
  {
    "email":"mariaconcettariggi17@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665634170/ab5eb634ac740ba2fab6219deb01bebb-1730303299"
  },
  {
    "email":"rachelematt76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665568634/5edc0ba28e55cec9abad47639385a5d0-1730303299"
  },
  {
    "email":"ambra.piermarini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665699706/512166e199a6be4693354f34a88fdbe8-1730303299"
  },
  {
    "email":"elenaspena69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665798010/823c0741ab5d9c5a5d7f9bc94d5b5026-1730303299"
  },
  {
    "email":"analagoag76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665830778/c9c6506a5a42d8d4de3923909948d956-1730303300"
  },
  {
    "email":"ilariaemarco@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665666938/200da7cef38a90d2c0a3be4e37dcd929-1730303300"
  },
  {
    "email":"palmieri.margherita00@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665896314/98f09fe48ae91fe006b4247fc6617091-1730303300"
  },
  {
    "email":"anastasia.simula@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665961850/8da1bc909cd68d67f1ab5becda79b836-1730303300"
  },
  {
    "email":"sabripantoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726665732474/74b0b84d2911c3cf110791ef162c8eec-1730303300"
  },
  {
    "email":"rainerianna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726665994618/90b8490431d841e5fb8bbf8f52a225ab-1730303300"
  },
  {
    "email":"cfascie@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666060154/be32c36e20f11e61dba11e6b1b3c47a4-1730303300"
  },
  {
    "email":"mete.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666027386/59715478382f6a46232432d4dc9bd6e2-1730303301"
  },
  {
    "email":"manieranera01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666191226/64f3a2b1ff691523428f86f5e5619c96-1730303301"
  },
  {
    "email":"gregni.rita@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666125690/41ab6ee1e69ffa85b3615894100b79e8-1730303301"
  },
  {
    "email":"mariaprof@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666158458/0607f678065d6b7ae63c8c29ff92addb-1730303301"
  },
  {
    "email":"margaret.risato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666223994/6157d3be1b86318c2d84602a99a8fe6c-1730303301"
  },
  {
    "email":"flocurr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666256762/dc78997cb54eeeec68bfc784c338a949-1730303301"
  },
  {
    "email":"adrianagilca80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666289530/fc50714a5530f0e15884f8c7ee78e2a7-1730303301"
  },
  {
    "email":"pascuzzi.carolina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666355066/9b5966df4d225530d3fae8a05e3154b9-1730303301"
  },
  {
    "email":"adriana.gilca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666322298/f58e26a73027e3de2eaa5bc1a46a6c26-1730303302"
  },
  {
    "email":"annamaria.trifiro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666387834/0bec0fa8fc21f617bb51fec21ac9ae48-1730303302"
  },
  {
    "email":"gabriella.difazio@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666453370/b5ad6157bf6944778173455291c6df50-1730303302"
  },
  {
    "email":"tittyb@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666551674/0f4bb81799563917df5f2640b8b6a80f-1730303302"
  },
  {
    "email":"kulewicz75@wp.pl",
    "url di attivazione":"https://verdissima.it/account/activate/22726666617210/5634da97b2421dd4f013944f3d3e2849-1730303302"
  },
  {
    "email":"alessiamollica@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666584442/2ae4d74abf292862999714d77fb23627-1730303302"
  },
  {
    "email":"barbaragrc@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666420602/fcd102335ff03a479cef24dd3ed27913-1730303303"
  },
  {
    "email":"beneb81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666486138/10bd8f37ccfca55667418b3c65d195f7-1730303303"
  },
  {
    "email":"chiara.totaro@gruppoforgesdavanzati.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666649978/99f0ad6ac474b262e97342c97e2c493d-1730303304"
  },
  {
    "email":"bragagnolo@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666715514/b36e6bcc94d22eb720f1035b54d2b6a7-1730303304"
  },
  {
    "email":"ssara.vicanovic87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666748282/017304de69264212c5f3645a3cac952e-1730303304"
  },
  {
    "email":"b.dellera@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666813818/fd8d9417be64287bc012c2d38f69976f-1730303304"
  },
  {
    "email":"mariapiadelvescovo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666682746/9ab94190592085a96aa6f142a4a45ac2-1730303304"
  },
  {
    "email":"rgabriellini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666879354/77a8463dd3344ee35e20479590c67d0c-1730303304"
  },
  {
    "email":"valentkna.liparoti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666944890/ffff0c1669e0c0d541ce4e74e5634435-1730303305"
  },
  {
    "email":"elemantoan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666781050/cba5c29fb0fce64ecf3295854c2ebed6-1730303305"
  },
  {
    "email":"celepom@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666977658/8191fd476c54057e1cd2efd274e84410-1730303305"
  },
  {
    "email":"sandradid@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726666846586/13ddd35b41d0e7621878d56edc6bd99a-1730303305"
  },
  {
    "email":"costante3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726666912122/5e2a468d0a7a20508b2e601a4a41c390-1730303305"
  },
  {
    "email":"angileri.patrizia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667043194/e14a7a6a88cc54ab8102e19aa13c6ec3-1730303305"
  },
  {
    "email":"valentinapieruccetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667075962/0f937ddc0569603355f11be7416af518-1730303305"
  },
  {
    "email":"jkornide@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667010426/c206552306796abd44539d91a0f74a0f-1730303305"
  },
  {
    "email":"marcella.calanca@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667207034/b235359370641be2450816387507f545-1730303306"
  },
  {
    "email":"rosa.sp75@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667141498/97033efa063e12835d6cffcd7d929297-1730303306"
  },
  {
    "email":"giovannadalmoro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667239802/5bde76642f352654f3db05e83d0a0c83-1730303306"
  },
  {
    "email":"mire.hu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667272570/ffb05130427b8bd989d05424dd82ffd6-1730303306"
  },
  {
    "email":"donataimmacolata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667305338/8dc53c4f3d5f20053775e415f71fbb42-1730303306"
  },
  {
    "email":"oucan2007@yahoo.es",
    "url di attivazione":"https://verdissima.it/account/activate/22726667338106/e8f964684614154893f62f4815a3ba30-1730303306"
  },
  {
    "email":"monicamazzotta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667370874/61d18dde46e2f297c2c5d81491c742cb-1730303306"
  },
  {
    "email":"kor.yulia26@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667108730/62b648dbbcaf62a57650a90f137e10fd-1730303306"
  },
  {
    "email":"francesca.bambini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667469178/80bec845bdcb18aff0b3c474abe43056-1730303306"
  },
  {
    "email":"ganialessia@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667567482/0d0ae083cc9cd02b3cb808ffe669bddd-1730303306"
  },
  {
    "email":"nvp_spb@mail.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22726667436410/19be5fa5f40194022d44af3ad00d697e-1730303306"
  },
  {
    "email":"melanie.wydler@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667534714/2c137814b5786ff9929004767a2d51d9-1730303306"
  },
  {
    "email":"martinavignola@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667600250/eaa9ea228a513c01015f912ffa0b237e-1730303307"
  },
  {
    "email":"daniel.battag@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667698554/4c06a8f92c1a5a2ed6585aba45f32528-1730303307"
  },
  {
    "email":"avv.emanuelacinelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667633018/e8675cc42bfa89f166ceb0389b6a7280-1730303307"
  },
  {
    "email":"carlotta.dorandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667764090/3fc0a21ddcb3df6918a74a45af17135f-1730303307"
  },
  {
    "email":"claudiababini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667895162/7cc65b17b6bb5dfb59605f31d7021003-1730303307"
  },
  {
    "email":"carmela.maestrini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667796858/992bd298a0a43194c1d1d7b344911364-1730303307"
  },
  {
    "email":"a.bolognesi4437a@ordpsicologier.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667829626/2840af33b9eb185450cd0d8c0140bbe5-1730303307"
  },
  {
    "email":"dimarcomarcella@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726667960698/10522173d43de947cfe6362a030be19f-1730303307"
  },
  {
    "email":"elenaroder77@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726667993466/e68dfc38efb951905bb63e91a9e11865-1730303307"
  },
  {
    "email":"letiziatrivelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668124538/069afeea0d2a20c422baf2d69b14f097-1730303307"
  },
  {
    "email":"acarrubba@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668157306/3309881dad075eb81bc79f4e67e5efc6-1730303308"
  },
  {
    "email":"mireilleblancardi64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668190074/c552f56eca19a18fbc1a2bc4df5c7edd-1730303308"
  },
  {
    "email":"patriziacalore@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668222842/916357b23175c0b8045145b7e9f7b399-1730303308"
  },
  {
    "email":"rossana.rr6@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668255610/0b9238d394ab31f07cdc384a8839e074-1730303308"
  },
  {
    "email":"ornestisara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668321146/440e356bde79c7f5192a90320250bf0d-1730303308"
  },
  {
    "email":"napolitanorosanna68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668353914/6e4b355d94de792769fc12b15d807feb-1730303308"
  },
  {
    "email":"francescacasella2@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668419450/71ff7ec3cbabbb72989b960ea31620d3-1730303308"
  },
  {
    "email":"anto.cardarelli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668386682/f1ab218823810b5df2eacf17398d2902-1730303308"
  },
  {
    "email":"barbara.vergnano@nuovaroveco.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668452218/36d1eeb22b16c940c94d97451e7f9c02-1730303308"
  },
  {
    "email":"gasparinimarika73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668484986/7368bdbce56158ecab19eb2d24ce0f8d-1730303308"
  },
  {
    "email":"valentina.acierno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668550522/6709dba52243ead155d2f6c60966862b-1730303308"
  },
  {
    "email":"rosy190570@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668583290/969c45562179284df3924fbe2ecd36ab-1730303308"
  },
  {
    "email":"marta.sostegni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668616058/5c71b1595b0d04b40593d409d15480df-1730303308"
  },
  {
    "email":"laura.carniel@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668648826/32d2053cff82f333366751e97a12fbe1-1730303309"
  },
  {
    "email":"damarioi38a07eq4b2g@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668681594/f3743d3d3066053d92e1b0d537da09ff-1730303309"
  },
  {
    "email":"alice_di_paolo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668714362/9159d08a55e4b53cadc38a62ecd3cdd0-1730303309"
  },
  {
    "email":"vicinibenedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668747130/e5c2fd4464b44c768e2e44d56afe2140-1730303309"
  },
  {
    "email":"moroninatalia@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668517754/0d14bde83d41f0b868a6c4f7b6cf09a1-1730303309"
  },
  {
    "email":"isabella.antonioli62@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668779898/81e79a5b636df4e8baa180764e27767e-1730303309"
  },
  {
    "email":"kayseflynn89@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668812666/d7fa65d8a8aabd2892f400a21223985c-1730303309"
  },
  {
    "email":"eva.caleno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668910970/1be02c3868f9b1192a8351acb7249b85-1730303309"
  },
  {
    "email":"chiarapasquini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668943738/32189e94e42f38b26e85f6a945905f1e-1730303309"
  },
  {
    "email":"irenemirabile@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668845434/9164d9fd6b6e83114b31619f6bdab3d5-1730303309"
  },
  {
    "email":"a.d.m-88@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669042042/ecf7251cf91aab2d5116a473d3eebff0-1730303310"
  },
  {
    "email":"caiti.garcia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726668976506/48f16e0da5327fb68fedee8791348445-1730303310"
  },
  {
    "email":"aannamaria.faccin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669009274/a5d1ea9ffb637f7baedb8acab134edc8-1730303310"
  },
  {
    "email":"roby95azzolina@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726668878202/e727300417945f9ffb8d5ff0d362658c-1730303310"
  },
  {
    "email":"rogerevaristo@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669140346/a72d430ffbdb04257d4c37fec7f1a159-1730303310"
  },
  {
    "email":"kiarabock@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669074810/a2649fda62dd1175a3dff5c2f9cd2347-1730303310"
  },
  {
    "email":"eduardochancay@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669107578/077d9c2654a93b4219f726dfaa6113fc-1730303310"
  },
  {
    "email":"melanyale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669173114/48d2b92c1f4dc4ef1ab20aee2deb8812-1730303310"
  },
  {
    "email":"angelavich@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669271418/fe240a0b857eafdae26c7baa8712e525-1730303310"
  },
  {
    "email":"annalisapignata@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669238650/eb4a42ceebebdb2a072d3feee4352774-1730303310"
  },
  {
    "email":"vania.busnardo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669336954/3e4e16c11d9ad6b435f8f0fe80e137eb-1730303311"
  },
  {
    "email":"danellhandly767@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669369722/424e2d46bf4b2578d1cd09be646b3fb5-1730303311"
  },
  {
    "email":"latayaobenshain53@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669205882/ee1160f6dec5fa7d63aebe2ca4757b13-1730303311"
  },
  {
    "email":"frenci24@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669304186/f7244911b417ada87584998af3fb0c65-1730303311"
  },
  {
    "email":"daddyzgurl8606@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669468026/fb152308c819bd342bfcaa2473d63d15-1730303311"
  },
  {
    "email":"jakadenfix@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669435258/632fcbd1cefbda4c0230122d48c12d20-1730303311"
  },
  {
    "email":"brojoeyatbbc@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669402490/3382072a9bb84cda437e54f1ede8016f-1730303311"
  },
  {
    "email":"greco.denise83@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669599098/c8ca94fa0c7f6f3d1018936d9f61940d-1730303311"
  },
  {
    "email":"martavaccarella@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669631866/9ee671891c4074cda6259fd3a016e5a1-1730303311"
  },
  {
    "email":"anna.baldissin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669730170/d645916562dcc057ec1f9816656d55d3-1730303312"
  },
  {
    "email":"cartermary2013@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669500794/e38d810fbc84d37e75bd38397273d7c9-1730303312"
  },
  {
    "email":"emmina.et@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669697402/685d968bf8e0e51782ef3510bb134337-1730303312"
  },
  {
    "email":"sandra.fadi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669664634/d31b97bd7dba2ce738fc613116968e79-1730303312"
  },
  {
    "email":"gemma_mar@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726669762938/8860c838b6c69eddca2b7b5051670d45-1730303312"
  },
  {
    "email":"lisarhogan@verizon.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726669795706/0160a58bef2aa6ac2d70e21544734a92-1730303312"
  },
  {
    "email":"kamrin2e57g7fhwo@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669828474/ae3c373628885f3ea2d1e8c80165f49f-1730303312"
  },
  {
    "email":"prayermt@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669894010/53a2b3a2e1e6f18075f3d2f74dcf83ca-1730303312"
  },
  {
    "email":"madhavestark@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669861242/b1bd0689f224949e5184791424533730-1730303312"
  },
  {
    "email":"74katiagiordano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669959546/5da1000ef93707753e6220a537dd77c4-1730303313"
  },
  {
    "email":"sarabarchi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726669926778/e5f7fdecb52e938228febe45cde9ab82-1730303313"
  },
  {
    "email":"mariafer8@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670057850/06999dddd69cd8229f9eb17c1daf20b7-1730303313"
  },
  {
    "email":"luisapellicani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670090618/1fab5f0711b5477ddda780c9eb5708d5-1730303313"
  },
  {
    "email":"racheljonas114@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670025082/b0775e8c0e5db9cd31eaee9718ed37c9-1730303313"
  },
  {
    "email":"yz250dirtbiker@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670156154/7c151a6ec50380094eb6de52fdade327-1730303313"
  },
  {
    "email":"direnzoadelaide@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670123386/7f7783fe97c07f6ff9cae022638122f0-1730303313"
  },
  {
    "email":"sorfinegi1980@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670188922/c47af36de2120077f32f9efa0b0cceac-1730303313"
  },
  {
    "email":"rajkonen10@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670352762/91f6b08c490c49f42343f609cd1612ee-1730303313"
  },
  {
    "email":"awilkins714@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670385530/b0140d8d317a79479662d7b9614aea2f-1730303313"
  },
  {
    "email":"louiskim92@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670418298/ad3568a4c8f22249e14c65ebf685f355-1730303314"
  },
  {
    "email":"eharding_23@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670319994/11b29a29c2bc3f9d122c4061f4dd4366-1730303314"
  },
  {
    "email":"hoss55@sbcglobal.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726670451066/ba7b612cf4b71f325564255db669d70f-1730303314"
  },
  {
    "email":"neilmulcahy83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670221690/7f3ef08b6ab0320bb8375bcbb96e29bc-1730303314"
  },
  {
    "email":"ashleygde13@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670516602/614e2bff0d5672ea5759d8d38af27ddf-1730303314"
  },
  {
    "email":"amandakinyon@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670483834/90cf1ad463a62c84ce7ebe34cb37eba6-1730303314"
  },
  {
    "email":"antonellagreco1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670647674/fb03895c6be73164d4ed1c42c96a8717-1730303314"
  },
  {
    "email":"fabiana.praitano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670582138/d0866f7b510a99c5cbc858ad08c73e65-1730303315"
  },
  {
    "email":"hflaharty2005@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670549370/fc95b881784ffa7b2cbf124a3c25cfcb-1730303315"
  },
  {
    "email":"ericebelly01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670614906/5ea081a47fab755491c086f4705dc2c4-1730303315"
  },
  {
    "email":"polirone@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670680442/4f28ead1cc00f29d8183d9615ee1e0b1-1730303315"
  },
  {
    "email":"ltgottula@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670778746/1ab0d2700d28aaf025af6f3b52faf826-1730303315"
  },
  {
    "email":"alessacappe@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726670713210/dd401dd495963c7336b5683521f2b5af-1730303315"
  },
  {
    "email":"hana.hrebickova@seznam.cz",
    "url di attivazione":"https://verdissima.it/account/activate/22726670811514/0f82e38f524a53925cf5d9ad3761ff16-1730303315"
  },
  {
    "email":"dylan2019rogers@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670877050/055e25067764782404980e3ffc5920c4-1730303315"
  },
  {
    "email":"ida.gallo83@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670745978/018ba8172bcaafa10ac47c92900b3e92-1730303316"
  },
  {
    "email":"martywatts@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670909818/6ec0d6ee8fe3cc3b32fb624191757a82-1730303316"
  },
  {
    "email":"erinmcdaniels@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670942586/3876ac62b3446bc0f72c4357af3a2f40-1730303316"
  },
  {
    "email":"julia_9246@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670975354/c1a8a7d5e4296a45eefb531e33d5340e-1730303316"
  },
  {
    "email":"nsurvaljodurch1978@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726670844282/596dc68a48499b0304651bab45f63152-1730303316"
  },
  {
    "email":"tomothyseargent456@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671073658/4354b9e60fa03d780f98f0a9a8535290-1730303316"
  },
  {
    "email":"annamartiescale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671008122/8473c9629bf5ae542b91c50c37b87e27-1730303316"
  },
  {
    "email":"jenikabostick@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671139194/d160159c69f733070f602255ed7b0baa-1730303316"
  },
  {
    "email":"robertadamico@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671204730/c2f8451f792b60c6721d5074b397d205-1730303316"
  },
  {
    "email":"chiaraandreini@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671040890/fbb819edd777e233a256a57fc0233231-1730303316"
  },
  {
    "email":"mallory.a.wasson@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671237498/c75e77111ec4b3536b8aeca09b1c1d75-1730303317"
  },
  {
    "email":"lgeorgetti@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671270266/461fbacc1db144d2872c028a0ff76777-1730303317"
  },
  {
    "email":"lim.michelle.d@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671434106/c8b177e0aaf3d0301d8d577f13e70dc8-1730303317"
  },
  {
    "email":"jesielaplauntbm@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671401338/09c6af91a62c87164ad553d5e6d05149-1730303317"
  },
  {
    "email":"hollisoose892@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671368570/28b4c9993c283dc13bdc9c7c02a784f2-1730303317"
  },
  {
    "email":"lia@spgbrindisi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671499642/edb5c40316ee62f3cbf6d5fc85f78d5c-1730303318"
  },
  {
    "email":"marialencioni1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671532410/b54de7f1f1e378c80ca98b3a3ff24ed9-1730303318"
  },
  {
    "email":"amyclymer@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671466874/ba1fb4ed20ef759f11952c4d5f60d356-1730303318"
  },
  {
    "email":"mohameddouhabi1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671565178/48a3baaa4e15444c6ffff7ea9ca3360b-1730303318"
  },
  {
    "email":"driordan2@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671597946/1f2b78aeceedab973e6d4368744def50-1730303318"
  },
  {
    "email":"slyenzer@cox.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726671303034/90befc636c0291ccde1898c43668226b-1730303318"
  },
  {
    "email":"liuping459@yahoo.ca",
    "url di attivazione":"https://verdissima.it/account/activate/22726671663482/a3fbd83981d5d65b0168e9ee8d729519-1730303318"
  },
  {
    "email":"simofren@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671696250/5cb9dd8de93d8a5a22a433d11f5f0e2a-1730303318"
  },
  {
    "email":"worltrakgebback1982@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671630714/c495791b1b211ee0fa1fd3155bb142f0-1730303318"
  },
  {
    "email":"michela.coltro@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671761786/26d36d8945d40e4c5374908ce3c08259-1730303318"
  },
  {
    "email":"unorlouwood1977@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671827322/33dfa4ee17065b9f2caa4ae52489a8cb-1730303319"
  },
  {
    "email":"anastadiabenedetta@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671794554/b52c5d833cdcb5e7b584ba88554a6097-1730303319"
  },
  {
    "email":"daniela.blasi@mps.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726671991162/85b622cd2c41cf78285c57f9964a6aca-1730303319"
  },
  {
    "email":"ppleggins@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672023930/9b254965a5549b7be4cfd4632f60adbc-1730303319"
  },
  {
    "email":"pocketslim@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672056698/40700aaaa273836bd83073758828b6a4-1730303319"
  },
  {
    "email":"krailert@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671958394/ba284988946125147e3ea9495d9bf9b6-1730303319"
  },
  {
    "email":"betsaidamcdonal630@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726671860090/aeb8b5f31404d016280c8ce10e73960f-1730303319"
  },
  {
    "email":"brianforseth77@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672089466/e569d253f05509447bf380f28dc45b72-1730303320"
  },
  {
    "email":"koraklosi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672122234/e9496d029c808e7f6ad8942caeb548e2-1730303320"
  },
  {
    "email":"b.vagaggini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726672187770/c00882d6ce4909119c79f39dc356d151-1730303320"
  },
  {
    "email":"amcoaclarma1979@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672253306/58a589bdb990862061732fb9d8623044-1730303320"
  },
  {
    "email":"kierra.willis@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672155002/d5347fe12e415791d89014509ebef070-1730303320"
  },
  {
    "email":"cate16@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672318842/38368b77d38ebfc571ff184240f5d77d-1730303320"
  },
  {
    "email":"javare33@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672220538/7ec85532ac2ddd561397ef31ecf4b0eb-1730303320"
  },
  {
    "email":"eleana.luraghi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672286074/cbb515cad41be5b2585319829373a167-1730303320"
  },
  {
    "email":"deandra4um6ru5167u@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672384378/532d5e973724c520fa8d73db4782f623-1730303321"
  },
  {
    "email":"ekali.pica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672449914/2d51ae82d1b30f961f50c4fdf5a2fe58-1730303321"
  },
  {
    "email":"angelarussano76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672417146/a87af883ae343a8cf21e70671c833b53-1730303321"
  },
  {
    "email":"magra.bo@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672515450/db43498b1ea7ffbf051d8106f2d261e6-1730303321"
  },
  {
    "email":"garyatch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672482682/e24879f17cd27f93247958e3a85cde03-1730303321"
  },
  {
    "email":"crenken100@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672548218/b47958f8d179c75ca899e13408866207-1730303321"
  },
  {
    "email":"jnewman29@att.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726672580986/de8a3148d9757633b35dba749a19ae9c-1730303321"
  },
  {
    "email":"ririk@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726672646522/83c62a1877ce805724e2107032b515fc-1730303321"
  },
  {
    "email":"chiaracascio75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672351610/9c43ddbfc7325e16e9edd6f2688b5076-1730303322"
  },
  {
    "email":"avv.benedettaroma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672712058/361e728a963212cc3762839328158a3f-1730303322"
  },
  {
    "email":"elyromano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672744826/edc037604c604fa8e26628f54026442d-1730303322"
  },
  {
    "email":"morris_gomas@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672613754/1c2aa98309bcdfe56fa7fd6add5d0fbc-1730303322"
  },
  {
    "email":"rmartin12121952@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672777594/d7277ee8fc8ce9637dcebb8b74e2bdde-1730303322"
  },
  {
    "email":"lesleymcc@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672679290/e4ec981df99db7d2c88852ff4e1471a7-1730303322"
  },
  {
    "email":"jpennington@iowafirm.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672843130/247dcf5eb6639ab81b624c37e5fbac23-1730303322"
  },
  {
    "email":"mdaloha@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672810362/276f7831a3024dde1bf19d725e98c94f-1730303322"
  },
  {
    "email":"jltdevelopment@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672875898/1518343305bd2168dccc0cfed2c385bf-1730303322"
  },
  {
    "email":"zscotts4@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726672908666/032a4a4362dcdcd3e2663b0a87594120-1730303322"
  },
  {
    "email":"rienakesrough1988@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673039738/fcceacd9a53dd360bc09b4ff2b04e260-1730303323"
  },
  {
    "email":"orsola.xhumari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673072506/e622a222430245dd7b6de560c6e03079-1730303323"
  },
  {
    "email":"michelemick4@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673105274/05b170f9d8b929a8ea0db0c8391b1cb5-1730303323"
  },
  {
    "email":"cavillonsylvie@orange.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22726673170810/ad7d3683a9bd1c8a8d57a0e59114a5a6-1730303323"
  },
  {
    "email":"giuseppina70.rovito@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726673138042/ec6cf2de0d82f38ca6a3a990de4a4c5c-1730303323"
  },
  {
    "email":"daw_kathy@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673006970/c0020b66fbf96fab76613767ee343012-1730303323"
  },
  {
    "email":"prietostudios54net@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673203578/c56d59681fabd8433193c537b95c3769-1730303323"
  },
  {
    "email":"sa.cheerio@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673236346/f333d9097147fc769543042910ea8fd7-1730303323"
  },
  {
    "email":"artanova8@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673301882/ccf232395e1c25515d143b63d869b210-1730303323"
  },
  {
    "email":"frmanue75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673334650/846a5d85d039f9b97d039ad8a219c662-1730303323"
  },
  {
    "email":"dobbsmr@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673367418/69f0bc9cc0d3b5852a708803e0f1f29b-1730303323"
  },
  {
    "email":"ippo.f@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726673465722/9942ad84d1e7de6bde932f9e3183aaf0-1730303324"
  },
  {
    "email":"memetiedlira@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673269114/02681af2456b11fa4d01220c7b6779a8-1730303324"
  },
  {
    "email":"dany2807@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673531258/57f4b3fb702af0125826a1034dff1a0d-1730303324"
  },
  {
    "email":"oscarchavez1010@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673400186/f174e2ea0ce70cecfcf137a65d409b24-1730303324"
  },
  {
    "email":"vizziello.m@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726673498490/71c97a9a063c493956fade2a763304ce-1730303324"
  },
  {
    "email":"bebba77@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726673564026/4eca585a535831654368e514103676a0-1730303324"
  },
  {
    "email":"juliouse7ae6xecp68i4@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673596794/7811a387d5a09db23a6c95d34ec45cc3-1730303324"
  },
  {
    "email":"tercosefi1986@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673695098/2fe14f410e149e1ea179c074fb0dc93d-1730303324"
  },
  {
    "email":"fire183704@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673662330/0b6549d32543719c66ea361bd913ed89-1730303325"
  },
  {
    "email":"federica651@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673727866/be85b067181f24a22d62130e96f4e42c-1730303325"
  },
  {
    "email":"tiggergrl1182@att.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726673629562/e3e8954849eea8038092616113a705e0-1730303325"
  },
  {
    "email":"pnuci@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726673891706/b3ba1aafaa4267072309a7add7f300f7-1730303325"
  },
  {
    "email":"frabb853@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673793402/41b5d8737cc769945069b6e56336f1c7-1730303325"
  },
  {
    "email":"vfilippini@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673760634/42e6705820c247a2bdc4a94fc424b4be-1730303325"
  },
  {
    "email":"schess43@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673990010/7950edfe703eed016e7f2027d940ae53-1730303325"
  },
  {
    "email":"rebecca123080@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673924474/d3d091246113936b790f5e5f33461afe-1730303325"
  },
  {
    "email":"reucreamdermend1977@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674055546/819a9158eb7205b4f3a11add9dc27e0b-1730303325"
  },
  {
    "email":"claudia.nigi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674088314/2aa876555f39c6430dde03f047b3e420-1730303325"
  },
  {
    "email":"monica.madonna71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674121082/0a0c22b5f6bb2e75a7b4238f74cf1e3e-1730303326"
  },
  {
    "email":"jgard01@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726673957242/824faa67b75183423107d21aa3be20ba-1730303326"
  },
  {
    "email":"isfreedoxnob1973@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674186618/616a6614d480969be307f2e1389d840c-1730303326"
  },
  {
    "email":"mariapia.ticino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674153850/a8d7657fde025f12bf715f54eb18a745-1730303326"
  },
  {
    "email":"olantiodi1979@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674219386/7211eb04a718ef792d8fe7831303d35c-1730303326"
  },
  {
    "email":"giusy7071.gm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674252154/e46bd104d82c73677e9181a906df604d-1730303326"
  },
  {
    "email":"chiaraetclemente@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674284922/7f03890d6457ecd5c5dba71aec016e6f-1730303326"
  },
  {
    "email":"mariellavinciguerra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674481530/e9f76f51f4417c9e3a996031316ef6cd-1730303326"
  },
  {
    "email":"iolandarotondaro1976@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674415994/22b5c9fc478fd109dbda147a4346e380-1730303326"
  },
  {
    "email":"mcgrawtim123@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674514298/e03569d31f103aa64cfe811d85545a83-1730303326"
  },
  {
    "email":"criseldabrevigvl@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674612602/70b9804ef55661635d97ef03dff8b3b1-1730303327"
  },
  {
    "email":"lucianellarusso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674579834/0e23b7623d19d9312db16782811bc861-1730303327"
  },
  {
    "email":"scottanddenise2003@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674547066/2d54af39929918b63d6afb22bed4e96e-1730303327"
  },
  {
    "email":"viejuz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674448762/05566b93fc82f5b854ac98fdd3496aab-1730303327"
  },
  {
    "email":"nondgratanig1970@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674678138/0b2c46336072d41ffbb649c912f9540a-1730303327"
  },
  {
    "email":"rashikaposkus903@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674645370/cf77931270d6c61f27bc31c073e24e8b-1730303327"
  },
  {
    "email":"francizak2001@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674809210/05dc3ac33309659196223a59e5f99e88-1730303327"
  },
  {
    "email":"kapercaso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726674743674/c624fd274a47aec78b3f3184838282c2-1730303327"
  },
  {
    "email":"ross.minelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674874746/a4e22a1563318c064b2ae4edca7bfcd7-1730303327"
  },
  {
    "email":"sieflustiomi1976@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674940282/d75ca141a286b693656242307e746eb6-1730303327"
  },
  {
    "email":"skorchagina712@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674907514/17f6157706171e124380e165a2de9425-1730303327"
  },
  {
    "email":"lallabai72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674973050/a70da2db615e62c4cf850568c9fbb1a5-1730303328"
  },
  {
    "email":"letalleyho@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726674841978/b4fd2f7da36cdeabd1fceb40d7d0aec7-1730303328"
  },
  {
    "email":"bracmagolle1978@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675005818/3db9707d023e0c1cd2ad490416aa5d5b-1730303328"
  },
  {
    "email":"wadeshaw13@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675038586/2a40d65933f331a3df26b72cfdf02c22-1730303328"
  },
  {
    "email":"santvalentina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675104122/0ea45fe0039be4969446f575eeeba4ed-1730303328"
  },
  {
    "email":"lacafawith1970@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675136890/c56c8294bd3e71d4a38533e5c70a5a77-1730303328"
  },
  {
    "email":"farazbown41@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675169658/41235592fe6853764f659116f31f478c-1730303328"
  },
  {
    "email":"sandragiro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675202426/df8a2c2daca1de6fbcf42ed0dab1aaeb-1730303328"
  },
  {
    "email":"lauren_gulick@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675267962/7fe60f405256266e62607e5361b68bc0-1730303328"
  },
  {
    "email":"nagoredominguezj@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675235194/b1f45f8e162034fe18b4c72a86335d06-1730303328"
  },
  {
    "email":"beachbum34243@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675071354/4976905714be7b216899a16577075402-1730303328"
  },
  {
    "email":"dicontrepdo1979@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675333498/2cc99448238af711e842658feba5406a-1730303329"
  },
  {
    "email":"jojocinco522@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675399034/ff5380f829138d48ab561bafc76787e6-1730303329"
  },
  {
    "email":"studiomargaretscavone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675431802/c996a8e8ad29df463294943faf72c55b-1730303329"
  },
  {
    "email":"joelocascio@att.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726675464570/3dc9859e3946c5cd5c3c67025cdc7df9-1730303329"
  },
  {
    "email":"anjali9a93v5@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675300730/20c8a14305927bf7ab943f81e8244c6b-1730303329"
  },
  {
    "email":"lulipicchioni@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726675497338/b015f5820e4758be2e9215ed27e2daf6-1730303329"
  },
  {
    "email":"jeff@bobandcarls.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675530106/ebe87eb08ac1feaa3f301f3be876fa43-1730303329"
  },
  {
    "email":"trad.archer@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675562874/38d7be1bb88f46136ed714982b6b73d9-1730303329"
  },
  {
    "email":"rhnguyen17@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675366266/eff1578f5edee2aa07ed27b8a90c1768-1730303329"
  },
  {
    "email":"semuii6530@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675661178/9a6fe14373495a7e84321e513de2130d-1730303330"
  },
  {
    "email":"urbanscarset911@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675628410/a00283b62732e2f55bccdde2326b62de-1730303330"
  },
  {
    "email":"cateperin72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675595642/a242d428de09b5c4fbc3fd8ba8a59864-1730303330"
  },
  {
    "email":"alexander.ly.tu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675693946/3a1acb088340f7b9284e9d16afaf9d63-1730303330"
  },
  {
    "email":"jamesnguyen1187@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675857786/a854f749eeebc21b2e67f728a1230a5e-1730303330"
  },
  {
    "email":"doggiestyleinoc@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675759482/f618ffcf9dce0b363beb9e6694ab84e9-1730303330"
  },
  {
    "email":"irene.brusaferri@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675726714/5eae935b010f6a66d48db2b96b48f96c-1730303330"
  },
  {
    "email":"stefania.bartolozzi3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675890554/897e6d568768ccbacf7c4a1691dda625-1730303330"
  },
  {
    "email":"ludosoul65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675923322/c703e3d8e49a134883c42460cf255d62-1730303331"
  },
  {
    "email":"derekdeleon@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726675988858/31bd353839ff1c5974630ff54c8cac0f-1730303331"
  },
  {
    "email":"jonathanweil53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676021626/7f989c7a74f17368dc70f026efb97a7e-1730303331"
  },
  {
    "email":"n-bektas@gmx.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726675956090/777e35d5b46eb84d056a662cf2e8843c-1730303331"
  },
  {
    "email":"mparsloe@gloucesterbuilders.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676054394/240ee718c98b53a89a99e95f260a9e79-1730303331"
  },
  {
    "email":"hausmjhaus@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676152698/624e6665fd72c8e22c33f38d59d94719-1730303331"
  },
  {
    "email":"ricky_e_31548@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676087162/5c15d27086863effd47a8fb521d0d815-1730303331"
  },
  {
    "email":"insweetmelody64@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676218234/846a789c4d10d3a34b56f463469d4a69-1730303331"
  },
  {
    "email":"matt@lewistonocc.org",
    "url di attivazione":"https://verdissima.it/account/activate/22726676316538/2205669e2fd12aa0ad729e3ca506fe5a-1730303331"
  },
  {
    "email":"ckc4937@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676283770/ebdff05cec80c7298f5ac75c58a39e5b-1730303331"
  },
  {
    "email":"compsempcita1978@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676349306/a894826fef707ecb845b0a1af1012978-1730303331"
  },
  {
    "email":"nicole.lopez0621@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676382074/8e7fb610765084bb059c4de11d0ad700-1730303331"
  },
  {
    "email":"kfinucane21@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676414842/7b4236fcc9226da2da2b9da4ae3e43fc-1730303332"
  },
  {
    "email":"cmwarr55584@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676447610/2fe051c6ab53a0008142cd9289428fb3-1730303332"
  },
  {
    "email":"adria.blake@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676251002/cd4df0bf0e9889f23a49b56cad025a0f-1730303332"
  },
  {
    "email":"rilettfamily@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676480378/21d1ecb51d67ab2a68af2e36c7d4c5ea-1730303332"
  },
  {
    "email":"bonardelli.valeria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676513146/5de6dbc8394f446e9061bec4d89e0e5d-1730303332"
  },
  {
    "email":"ames3469@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676545914/b707a795cd40051726603981089b55d1-1730303332"
  },
  {
    "email":"saimasupple97@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676578682/0079ddd31af195daed6993cc22ba6aed-1730303332"
  },
  {
    "email":"monica.mauroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676644218/a9e0b6d26849047d1de4517c17670b1a-1730303332"
  },
  {
    "email":"eleonora.valerio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676611450/f01c605d7d6ba6da42dc4a40783ed0c7-1730303332"
  },
  {
    "email":"alesuism@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676709754/616149a44b784d569a4f118f6f94d217-1730303332"
  },
  {
    "email":"johnthanstamm49@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676676986/cd48353517822ddf91ca1b294cbf6d01-1730303332"
  },
  {
    "email":"sandra-fargas@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676742522/21506196a9de85394fd609d6e8e383ff-1730303332"
  },
  {
    "email":"sallyrasmfh@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676775290/97f67166815766cc3f26a5a9169e82f6-1730303332"
  },
  {
    "email":"sparkocomputers@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676840826/fc5017fefa284483d941d41dbfb5e586-1730303333"
  },
  {
    "email":"trevor.lee.thomas@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676808058/1cafcc5348f41d6521c043b41bdc3cd9-1730303333"
  },
  {
    "email":"mhoffman215@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676873594/54eb3dba9323e92304889a84a932d188-1730303333"
  },
  {
    "email":"layspirliwel1985@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676906362/562bca3b24ae25a88f0b66a39c433c67-1730303333"
  },
  {
    "email":"swiper2016@att.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726676971898/ad7ac6dee7ca9b20e43477500a1f8ea6-1730303333"
  },
  {
    "email":"sharon.blevins52@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726676939130/eacf35560651e1015e1220260094872b-1730303333"
  },
  {
    "email":"sernamontda1979@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677037434/c55ef97c10e7bad89e88bd6d4b286559-1730303333"
  },
  {
    "email":"gbproenca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677004666/46bd4d2392ec090ec479ee2e2542dfe2-1730303333"
  },
  {
    "email":"tomtitasig1989@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677070202/59ff9a06a075c48f047f26c856b23195-1730303333"
  },
  {
    "email":"quicalgoakos1987@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677135738/57530c0970eabbf0e9f117afe3fd1f2b-1730303333"
  },
  {
    "email":"mni.m@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726677201274/b8526b46633ee9f017b4e16f75c0f338-1730303333"
  },
  {
    "email":"baccocri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726677234042/8c0d405cf57266842925ea90268072a8-1730303334"
  },
  {
    "email":"giuliana.cavallo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726677332346/5dca13949ce28f1d828ec45f9e39f573-1730303334"
  },
  {
    "email":"vsle08@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677365114/18505abe583a131ad0de1ffede49f771-1730303334"
  },
  {
    "email":"yechielslackqn@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677299578/8e3efafe5c6e6157fd25851f6daa64e2-1730303334"
  },
  {
    "email":"patrizia.13667@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726677397882/4331b90716a152c3aaa15d6e51d6b1dd-1730303334"
  },
  {
    "email":"mariaelenasoragni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677528954/40c563369ec139a936884074fbcc0d7e-1730303334"
  },
  {
    "email":"merch12@experience-bd.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677463418/27c81b18facf124e7dbf768eb29226c4-1730303334"
  },
  {
    "email":"worltilinkplan1987@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677561722/c01e1410f833708c232ff3e8d2e728df-1730303334"
  },
  {
    "email":"amandaford25@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677594490/66bff0705177131a63540c88bc2eb41c-1730303334"
  },
  {
    "email":"butlerbach@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677430650/095c6066ed4c245e4fee605ede3b6802-1730303335"
  },
  {
    "email":"koonce47@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677725562/4cca0a0aeb9b033bf4d99ac61ac5e7f3-1730303335"
  },
  {
    "email":"lukelencionimt@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677758330/29e74c574fad3329b84ab2c96f834ff1-1730303335"
  },
  {
    "email":"thomanila@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726677791098/ab88c03c86616cba1b85d3e2b3caea65-1730303335"
  },
  {
    "email":"alterteni1982@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677823866/9ba3d55fb8eebdbf6b0651039352a7a8-1730303335"
  },
  {
    "email":"brauntwl@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677856634/37ecfe7b778fba85cfb6cab5c8ab7fbc-1730303335"
  },
  {
    "email":"armadillo80@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677889402/932965518f3e007d796a06246c5a2b02-1730303335"
  },
  {
    "email":"filomenachiocca.63@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677922170/ab51addcf07f57a1c672155d21ec0f75-1730303335"
  },
  {
    "email":"thopirehal1982@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677954938/3cce95bb78a88cbb667f2c98c0dd847f-1730303335"
  },
  {
    "email":"mahalia17e75uoy@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677987706/62419ccea69d978b0b067421778d8f0b-1730303335"
  },
  {
    "email":"jaymikelballinger@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678086010/2a101ad3ae247108c1da9db0e49c20cc-1730303336"
  },
  {
    "email":"mendelgreenbergmmg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678020474/edb21e5b8d7fe246b6e73b52e794220a-1730303336"
  },
  {
    "email":"meagonjovich21@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726677627258/74b15f38aead429b54514ff02a7d369a-1730303336"
  },
  {
    "email":"paolalieto@mac.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678217082/6195efbe061c90177c587703f626459e-1730303336"
  },
  {
    "email":"silviadona@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726678118778/8401a9911b32657bb1eedc04ae913205-1730303336"
  },
  {
    "email":"valeria.brini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726678151546/3e271042656fbc8938be404720396e42-1730303336"
  },
  {
    "email":"mdismal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678184314/143cd7bfacb3a4bad0ad49df558efb8d-1730303336"
  },
  {
    "email":"office@ivanov.at",
    "url di attivazione":"https://verdissima.it/account/activate/22726678348154/a0f1a0782fd4f069d961ca78f87e8f36-1730303336"
  },
  {
    "email":"acarraro1972@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678249850/20cf99de1454527fa85d7a83117ae8c0-1730303336"
  },
  {
    "email":"danielxu822@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678282618/c1d0917ba103627cce0bd5db204a5e3e-1730303336"
  },
  {
    "email":"alexandeo3105@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678315386/38f5d19fdae9bde9791eaa83eae3cd72-1730303336"
  },
  {
    "email":"markandjanski@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678413690/9e7142b58a878d132d9ca17b03fd90a2-1730303336"
  },
  {
    "email":"1970holidaycoupe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678380922/2236dcc91ee603b69126f9e8fcf0adb6-1730303336"
  },
  {
    "email":"zf821029@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678446458/0a23770b0805511ba799b0bcac75fb0e-1730303336"
  },
  {
    "email":"datman5946@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678544762/3819fe2c86c3d3390cacefcbe07e4542-1730303337"
  },
  {
    "email":"soundreduckgent1982@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678577530/cba3aee21e2aecf4f17b670c660adfa0-1730303337"
  },
  {
    "email":"wjschram@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678479226/e85ceb561fa7608615cfa80a831ec80f-1730303337"
  },
  {
    "email":"francesca.magrini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726678643066/fd554c4a6d9297d40309bac7f26176da-1730303337"
  },
  {
    "email":"burchmoving@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678511994/e6243ca3851c01fba3f479119fd8e889-1730303337"
  },
  {
    "email":"ely_zip@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678675834/a9f3c4abc41b012fb05dce8f1dc897f9-1730303337"
  },
  {
    "email":"homesrusrealty@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678708602/ba17e4e48d1804f75b829a27c2f6cd96-1730303337"
  },
  {
    "email":"kapalda.simon@seznam.cz",
    "url di attivazione":"https://verdissima.it/account/activate/22726678774138/36b537cd55f4eefbe80ab223e2211f41-1730303337"
  },
  {
    "email":"fpmariani@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678741370/dfb20c845ed4289a90d108f452d18539-1730303338"
  },
  {
    "email":"dbijalci24d86@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678806906/c5ca226bc3cba460ab9b3258ae333252-1730303338"
  },
  {
    "email":"iloveeazy1931@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678839674/93595c6251657a446cfaffcb1d7899f7-1730303338"
  },
  {
    "email":"rimmie.queen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678872442/49a45605eb921b9ae1dcf726247ec4d1-1730303338"
  },
  {
    "email":"chris.brown47@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726678937978/0a8c08f6b05e352bb9cb3660ef4cf85f-1730303338"
  },
  {
    "email":"debora.nota@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726678970746/a7140d07fb56a1935289166bd79bef1e-1730303338"
  },
  {
    "email":"mehtajyoti43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679036282/28c97cec804cd54d20946ab7c442d40a-1730303338"
  },
  {
    "email":"soncao@u.boisestate.edu",
    "url di attivazione":"https://verdissima.it/account/activate/22726678905210/688c83c776eaff01909846cfb3e05546-1730303338"
  },
  {
    "email":"marketaghiuri@centrum.cz",
    "url di attivazione":"https://verdissima.it/account/activate/22726679003514/b7f69d55581c1b4293d76a599e0945f5-1730303338"
  },
  {
    "email":"steve.catapano@hlfg.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679069050/09d31a132f2192810b0bb8837807ad4b-1730303338"
  },
  {
    "email":"pjacobson81@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679134586/e64cdf41c289fbe3cbf45472d98d5c90-1730303339"
  },
  {
    "email":"stollmac12@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679232890/ab995ae2affa317a158d594c32861c94-1730303339"
  },
  {
    "email":"jdsharp19@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679200122/f5b712d28d54279cb02f3e80ccbc56f8-1730303339"
  },
  {
    "email":"skybird305@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679101818/410527f94ddaf0b5721608ae6a26813f-1730303339"
  },
  {
    "email":"rlorea289z7ujir@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679298426/88e7718b42b91556afd401c8a4ed977f-1730303339"
  },
  {
    "email":"vorovusvova@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679265658/908804785c76b1bc01960a877be7870d-1730303339"
  },
  {
    "email":"erodriguez@psd1.org",
    "url di attivazione":"https://verdissima.it/account/activate/22726679429498/d308fde4117a7f6e7c17d274b945d230-1730303339"
  },
  {
    "email":"ramseylz52@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679495034/521389f3271e429ca74282396ded82d7-1730303339"
  },
  {
    "email":"alexc50fan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679363962/0897163f44508b2320c45bd26138048f-1730303339"
  },
  {
    "email":"bryanez1991@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679527802/f662e449c8c993ad7c3d2f6402e0a7c4-1730303339"
  },
  {
    "email":"tffnymay24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679462266/fab7d717e0edb43fe85a42e329d4daa4-1730303340"
  },
  {
    "email":"ovsensidi1987@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679560570/09d4aff755a85798c81d93dc0daa6d28-1730303340"
  },
  {
    "email":"leighann23@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679626106/b5c9559eeb5a9a2e4c7e798c3215db3e-1730303340"
  },
  {
    "email":"lia.gherardi.ferrara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679593338/92ebf078b4761223c8ce889cd8c70e3b-1730303340"
  },
  {
    "email":"chiarafelicetti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726679691642/55772415a08d533445ab2a99b3c989d4-1730303340"
  },
  {
    "email":"telepotet123@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679757178/1b6de851073018adde07c100d60f0ae5-1730303340"
  },
  {
    "email":"gerencia@electricoscarlostriana.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679658874/adae7f1325c091d0e5b0edb44c31bc92-1730303340"
  },
  {
    "email":"sonny@ml-lawfirm.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679789946/99d76973f1ab4c0d7992486c434f5b67-1730303340"
  },
  {
    "email":"kaydegreenlief34@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679855482/164e59222ea71916ea5b10bf3a091375-1730303340"
  },
  {
    "email":"jjmarko33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679888250/3869a25bfa263c55a366f0cc7fe18c03-1730303341"
  },
  {
    "email":"brittneychiluiza@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679724410/e115cc50a8bf895772e3c8a7168710c1-1730303341"
  },
  {
    "email":"timkeller4@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679822714/74114f090cebf4b6f51b906f7326d40a-1730303341"
  },
  {
    "email":"kimwise20@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726679953786/4f1320cc652b6277a8ff161c52df8324-1730303341"
  },
  {
    "email":"madeo@delhi.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726679921018/c3fa725d9e4347cc9c82d9755189412a-1730303341"
  },
  {
    "email":"bilbeach@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680019322/a9b5f39ed8968a36bd8ee8fae1e3b000-1730303341"
  },
  {
    "email":"orrindesautels185@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680052090/9499709107c4299e5895a5cd55f16a3f-1730303341"
  },
  {
    "email":"afx420@cox.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726680117626/b8f9b7f74608a4bbb260d23d0618dcb3-1730303341"
  },
  {
    "email":"benjames.bb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680248698/3e4a37dec7e9cfc0aea8928adb7a1f4f-1730303341"
  },
  {
    "email":"jmugs@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680314234/8d3209e20b9ec5a261a726d36591d7fb-1730303342"
  },
  {
    "email":"lbertrando@vandale.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680347002/35d661c6cfd460de354bae4755ba97c4-1730303342"
  },
  {
    "email":"jaycobgalarza84@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680150394/7a27c49a2d583f384c1971d75d596a73-1730303342"
  },
  {
    "email":"neighorn4@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680281466/c48b03cd7320fe9d5cb3d112312d1c3a-1730303342"
  },
  {
    "email":"sadless7777@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680379770/42a22e6e854ae81493e6c3060c35f491-1730303342"
  },
  {
    "email":"terrancenill723@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680412538/8886e03db9c98b5163c0d1827438541e-1730303342"
  },
  {
    "email":"ashlei6v6o04own4@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680445306/97bfbbfb62148ff6274c949e73ede68e-1730303342"
  },
  {
    "email":"bertasaterry68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680478074/2df1ddb76278cbd9ba55749303e3f973-1730303342"
  },
  {
    "email":"tracenperca1988@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680576378/080a991efbf4ae5c5eaabcc8a4df7b61-1730303343"
  },
  {
    "email":"dardrachina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680674682/ca5bbd542720be64650c79d5ac6c0db0-1730303343"
  },
  {
    "email":"davidnunezdds@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680510842/e777b72d21495ebc2a4d9c72e23169d8-1730303343"
  },
  {
    "email":"nmateo1@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680772986/afc31a320a26e1971a53450493d047cd-1730303343"
  },
  {
    "email":"ser2prince@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680740218/2f3953f2077abece1cb8b57c765385c9-1730303343"
  },
  {
    "email":"lidiaruiz1984@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680641914/e8b4624d75840b4ff43699f9984148f3-1730303343"
  },
  {
    "email":"filocencha1977@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680805754/dc95cdcfed63b612b307683beea45153-1730303343"
  },
  {
    "email":"marianaralls147@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680838522/2c7ab34864d83a3a7b1a484f7b6ee264-1730303343"
  },
  {
    "email":"marklilred85@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680904058/cfe1f5599c22ecc861500b908dfa3726-1730303343"
  },
  {
    "email":"romainebernett704@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680969594/38cb85ba320e3682eeb3131b345b4f3e-1730303343"
  },
  {
    "email":"pyedibroru1989@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681067898/dc478abdc2c0298865a47295a6ff2394-1730303344"
  },
  {
    "email":"minhchau6198@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681133434/6bc2e0716f8a97619afdae1541b38cda-1730303344"
  },
  {
    "email":"ahmed.galal8@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726680871290/29e9fd57dce0debac8ef77a877d7980f-1730303344"
  },
  {
    "email":"mpres83@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681002362/21306525350c294f7992d3acd2cadd68-1730303344"
  },
  {
    "email":"evan1207@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681166202/fb0579d6601fdf7a811d84c6a1c1623b-1730303344"
  },
  {
    "email":"manuela.bendini72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681198970/610713161c2cafede44fd8674fcd8e59-1730303344"
  },
  {
    "email":"rones@rocketmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681231738/3dd544179b8ae34ba0d5da7fa61a82f5-1730303344"
  },
  {
    "email":"lilyvonne92@aim.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681264506/e8feb27d1a8b7fbf0d039acc933bf5e0-1730303344"
  },
  {
    "email":"ylindsee9v0bo46z7y2@outlook.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681330042/93a2bcd9196054909a192bd1b2d39eea-1730303344"
  },
  {
    "email":"satterthwaite_j@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681297274/d0ecc004c2139638c9f4f50fd6727a27-1730303344"
  },
  {
    "email":"chloride92@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681395578/9a996470da8781fc5b9deeec5b00b04c-1730303345"
  },
  {
    "email":"beccah8a@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681461114/1a05267d7d503cf18b3d76e07f149f5d-1730303345"
  },
  {
    "email":"laurieramos45@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681493882/d04c5c9ecb47e073d757c8e5632bbe48-1730303345"
  },
  {
    "email":"kylmceuen@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681526650/7ad33bdedbbeec6ed6334e3ceb41759a-1730303345"
  },
  {
    "email":"lluciac@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681428346/2037a6f3f42c9f0a8efb661886cba75a-1730303345"
  },
  {
    "email":"johnson90johnson@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681559418/046246537a13301104660683b3905ed1-1730303345"
  },
  {
    "email":"ashleymac7241@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681592186/b0174d19a11fccdbd2951411f7d185c0-1730303345"
  },
  {
    "email":"khill007@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681657722/7c34ed4cd5348f2571e62998b70d960e-1730303345"
  },
  {
    "email":"dwalker@power-brake.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681723258/48034caf917d6dfefd92098458c74f6e-1730303345"
  },
  {
    "email":"ctdavete@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681756026/c3578edda82c97625d49f3ded35aace4-1730303345"
  },
  {
    "email":"thepuddles2@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681624954/38ccef9e248544c53b3ee79b0a40b24f-1730303345"
  },
  {
    "email":"tbaplin@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681788794/213c11316ec443e4fa35ad0b03f203b1-1730303346"
  },
  {
    "email":"marieannrangitsch16@aol.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681821562/ede138c4460c36d35c4197e3ce99c060-1730303346"
  },
  {
    "email":"castilloedith888@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681690490/78b8e922bae55388581ba2f9242f1f11-1730303346"
  },
  {
    "email":"luciamira1990@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681854330/b892376693bdb95dd2b9ed9cd5879c8f-1730303346"
  },
  {
    "email":"raffaella.saverio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726681985402/74239c1154c786009ce9bc5170a07898-1730303346"
  },
  {
    "email":"sanja_supancic@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726681952634/c487838db72f3b1887483430032d1fcc-1730303346"
  },
  {
    "email":"christinamv@web.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726681887098/9789e4fa50411cab859ec2d7c5321cbe-1730303346"
  },
  {
    "email":"lorelaifitzgerald@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682050938/1d62d0c025f2dcf15fdde640ef037f37-1730303346"
  },
  {
    "email":"zironi73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682018170/8c46bb9756a3f348b61c6a692d06a144-1730303346"
  },
  {
    "email":"michele_de_padova@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682116474/1d2da9c09a4c978d8389ac81343c0640-1730303347"
  },
  {
    "email":"wuff@ashunas.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682247546/62ba167b3dec92fa292d2a2236f187ba-1730303347"
  },
  {
    "email":"valentina_zan@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682149242/aee984dab76477e41ece0202bb7c2e02-1730303347"
  },
  {
    "email":"rpen70.rp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682313082/3ee9e7792855e01db2c4611a70cb07f8-1730303347"
  },
  {
    "email":"erikaverna80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682280314/f794ce06a60bfe669cc43571f22d5c4e-1730303347"
  },
  {
    "email":"mattiafa91@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682182010/ce4b22bf82197afdccc3f33cc6d8c263-1730303347"
  },
  {
    "email":"iannozzi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682345850/6fb626a7c886c00e62b70dc3c4cdefb6-1730303347"
  },
  {
    "email":"stefano@enic.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682476922/6126914a4f18e16e0d31c7a927bda472-1730303347"
  },
  {
    "email":"marika.ehime.bis1129@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682378618/99ef39ed6f3626dbc86571280dcc9a5b-1730303347"
  },
  {
    "email":"ljepa@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682607994/ecd9ec920d47eca7d4919bf5c0a8cca9-1730303348"
  },
  {
    "email":"silviacampioni27@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682444154/abd3cb1037f20ed5046b3a8f236404d5-1730303348"
  },
  {
    "email":"robbimada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682575226/6719f08dd043acbdc4cda93b5669dfb8-1730303348"
  },
  {
    "email":"manuelalovo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682673530/963ce866e23146a297d4c0bdc4f1ef8e-1730303348"
  },
  {
    "email":"saura.gilioli@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682739066/ade746fc2dad1d7abcb00e1c19bffbaf-1730303348"
  },
  {
    "email":"jirina.beltrametti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682706298/938c3ccae3cfeda12647f9f0309f043e-1730303348"
  },
  {
    "email":"marusya.portugal@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682771834/10b7e0a590dd5223426e691810630cdf-1730303348"
  },
  {
    "email":"serena.tiberi@comune.tolentino.mc.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726682902906/224e56716f41edf6dbc50aea19c5715d-1730303348"
  },
  {
    "email":"c.bordino74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682411386/c3d0227e7af76b5a3e4723987381fb8b-1730303349"
  },
  {
    "email":"caterina.giovannitti66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682968442/95e01495778d340cc9bd23a93f52e6e6-1730303349"
  },
  {
    "email":"manfrincatia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682837370/0cb7159ed52e12b90eb1a5ee265863af-1730303349"
  },
  {
    "email":"mikyella03@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683099514/47a23c98e07d371679d67d30dfb2970b-1730303349"
  },
  {
    "email":"annamariagabriele457@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683033978/270d639f79849029c91afa2953ecf9da-1730303349"
  },
  {
    "email":"alessiapizzuti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726682935674/128449c93130a61176ef03960ddeb80a-1730303349"
  },
  {
    "email":"enrico.liberati@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683132282/43785c3f1723ba5d906cb1efa7cbeff4-1730303349"
  },
  {
    "email":"annateresa.maini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683001210/b5e52b903adb8ce1985b1f1b56b496c3-1730303349"
  },
  {
    "email":"johnbuss@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683165050/7e8dceb4b822cdab70279996d23b53db-1730303349"
  },
  {
    "email":"mauro.mazzokki@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683296122/e7d7536b050689fbb3114ca2909a1230-1730303350"
  },
  {
    "email":"lu.saleri@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683197818/b1862494cc633468749f0b30dbef1922-1730303350"
  },
  {
    "email":"ditodarodebora2069@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683263354/c1f1780e80ba3bd6b456cf19706cfa5f-1730303350"
  },
  {
    "email":"lauradalpozzolo21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683328890/95dfa2b841781ce9e05787372ad4ac0b-1730303350"
  },
  {
    "email":"giulyferrarelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683459962/bfe49ffe2b502f366e17fa39a55ebb63-1730303350"
  },
  {
    "email":"ceci.bess96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683361658/df810116567a5a1e378734cd90558ff6-1730303350"
  },
  {
    "email":"loryfo@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683525498/d22534c7b924e4b7a0e96c9f2a0f87d5-1730303350"
  },
  {
    "email":"tatiana.ruaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683492730/220bcf3dd2cd9ae6d7c493a2bd329590-1730303350"
  },
  {
    "email":"carbitri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683558266/4c847c9f006b24cc310ef6b0802ba231-1730303351"
  },
  {
    "email":"elena.boving@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683591034/382bfa431b875d258758df0e8b123c23-1730303351"
  },
  {
    "email":"dalsinco@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683656570/f35bbe4fc845491147f49ac1a2e5d0c8-1730303351"
  },
  {
    "email":"mdmdjc@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683689338/2283a175c80e23988b34b663ec2f7132-1730303351"
  },
  {
    "email":"palagigiuseppe14@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683853178/d70e7152a2a027c00da63c99a4f2f025-1730303351"
  },
  {
    "email":"f.carile@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683820410/5e8f7c6ab29caf0451876edd40f51e53-1730303351"
  },
  {
    "email":"elena.cecconi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683787642/90471c6ee59d214a25c21a6c0e2702d1-1730303351"
  },
  {
    "email":"l.soumya@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683754874/8ee92306c696d7df34ca6ce4df84c7f1-1730303351"
  },
  {
    "email":"glauco23@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684017018/8b6fbf3f63ddaade4bf3a74ad3f1f16c-1730303351"
  },
  {
    "email":"mmatute777@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683984250/ba3812cc3b875c5217625351e35e0d8f-1730303351"
  },
  {
    "email":"vanessapanighini80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726683885946/a17e4c87eaf1c15ee3c0360224ae9462-1730303352"
  },
  {
    "email":"marta.panzeri@tin.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684082554/aaa9d38ed4586cb0af4575071db63606-1730303352"
  },
  {
    "email":"lauravranken@live.nl",
    "url di attivazione":"https://verdissima.it/account/activate/22726684049786/df369a15e623c9140fc91e636758cca6-1730303352"
  },
  {
    "email":"silvana.conti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726683918714/4dcf0f0761f30332719193eb44c2d490-1730303352"
  },
  {
    "email":"kogelnik.maria@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684115322/998d54d81d8e10f892436ac07f78d7ce-1730303352"
  },
  {
    "email":"laura.pignalosa@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684148090/1d1ebc103e6395557066f25c91e8d274-1730303352"
  },
  {
    "email":"aklimeczak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684180858/784eaedeca1efee95fae5f1f6ced82a2-1730303352"
  },
  {
    "email":"claudia.vonhaacke@apontis-pharma.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726684246394/86cd41cb8cb1467cde2fe462c6e516c0-1730303352"
  },
  {
    "email":"cristina.breschi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684279162/67d8a8e482fe0781bda8e5e61704b074-1730303352"
  },
  {
    "email":"nikitripoli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684311930/cfa744bb25e83cc59c9a84457aa3450c-1730303352"
  },
  {
    "email":"lylhospital@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684213626/725e72a26816c45c97dca2e29e25d56a-1730303353"
  },
  {
    "email":"stefania.bertoletti@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684377466/5f994b4a714bf9183000d1e7cde9f7fe-1730303353"
  },
  {
    "email":"cinzia63-leone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684410234/85cac162e83d7863701ba7006e471383-1730303353"
  },
  {
    "email":"ricciars@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684443002/ff355b1bb0e1bd9138742e7bd88f59e4-1730303353"
  },
  {
    "email":"giusygufa@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684508538/353d80ac4feb35f1ba9e190af1079921-1730303353"
  },
  {
    "email":"simonettagiannangeli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684344698/73970e9401b0cb8e8f4452413c701994-1730303353"
  },
  {
    "email":"elenacolombo70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684606842/3b892a621f57c4b24c45ca3337646782-1730303353"
  },
  {
    "email":"cris.bina@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684639610/8f3dd445aaf791a07ca144a8fc7b6545-1730303353"
  },
  {
    "email":"vale.v66@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684672378/e4f60c43756bd6b3375eb3c52cff55e8-1730303354"
  },
  {
    "email":"naturaliasalerno@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684541306/bd2f81171d342a0d84bd4e7c2c67188f-1730303354"
  },
  {
    "email":"rpalandri@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684574074/5c471808b030cb3f154d3bd19870733a-1730303354"
  },
  {
    "email":"cristiano.rizzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684705146/bca7e7be2c7e0724a1691386a99c0e96-1730303354"
  },
  {
    "email":"sam.mes.1502@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684803450/34e4fe57a77ab8d73acc2f6c7b483944-1730303354"
  },
  {
    "email":"mjcampmajo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684737914/a970de585ec25259ba6d0cf05543f40c-1730303354"
  },
  {
    "email":"56mariangelacassia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684770682/c6b045a983923f80cf7170ca15d63ef5-1730303354"
  },
  {
    "email":"digital.halef@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684901754/7a0c15dffef044c6740a110c67a53fc9-1730303354"
  },
  {
    "email":"iva.bisso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726684934522/12034d28369b6497261e528204818b36-1730303354"
  },
  {
    "email":"mariadaniello89@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726684967290/d1d804842072a1936fdc4d094d6674dd-1730303354"
  },
  {
    "email":"pmassarelli69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685000058/22a851a62c10939f828190db77952374-1730303354"
  },
  {
    "email":"federicaguido@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726685032826/b2be9d389d436107ae90d8928a6be703-1730303355"
  },
  {
    "email":"marina.tomaasoli@gmail.xom",
    "url di attivazione":"https://verdissima.it/account/activate/22726684868986/a7baf6e8b915698eeeb97b166387bd3c-1730303355"
  },
  {
    "email":"maranopatrizia@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726685065594/075c485ba4e7c7b54b21197072395908-1730303355"
  },
  {
    "email":"federica210609@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685098362/70f95ab9b69ecb85b78692d1f53cf9a3-1730303355"
  },
  {
    "email":"brunipaola70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685131130/4c09a6de236d714b140cb4edb513be02-1730303355"
  },
  {
    "email":"giusymilone1973@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685163898/018fba7a878336523baa0a4aaa55bc3f-1730303355"
  },
  {
    "email":"robertomandolese@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726685196666/5ebc2c4dea532ab683d061c5fb635210-1730303355"
  },
  {
    "email":"claudio.rizzoli.2906@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685294970/535f3f30a2dc5bd921335a5886f8327a-1730303355"
  },
  {
    "email":"justi77.jk@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685262202/0eda350b8e6fc1a80929e1440e878f67-1730303355"
  },
  {
    "email":"bonucchif@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685393274/29b042578211eea208bdd630064e8d49-1730303356"
  },
  {
    "email":"claudiapinzauti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685229434/d6535d16ef2d6c999d00203121b4c59e-1730303356"
  },
  {
    "email":"salvesimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685524346/87e8f87c1ce4ffc9856f65a2305bd714-1730303357"
  },
  {
    "email":"gabriella.bertuletti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685557114/423330d80744a114eeb2b96e58a4df39-1730303357"
  },
  {
    "email":"monicadiotti@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685458810/22d803c60ae5e85e9e848f0257b57036-1730303357"
  },
  {
    "email":"alessandra04011@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685491578/2a60c3b735774d360a7343f34f9038a7-1730303357"
  },
  {
    "email":"ilary_monny@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726685622650/726d62e5d76433386ee02f020dd0eca9-1730303357"
  },
  {
    "email":"valeriaallinoro@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685655418/0f0a3fe53faab751f1013e6a819a4b44-1730303357"
  },
  {
    "email":"mastrangelomariaanna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685688186/9cbf60a534d853c00b260582fe06447d-1730303357"
  },
  {
    "email":"lanapeternel@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685753722/07b15bf7fc57204ef084d8c276c4d784-1730303357"
  },
  {
    "email":"amargiga@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685720954/3f81a47e274608b9a58dac2794e3706d-1730303357"
  },
  {
    "email":"palazzolo.glo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685589882/94aea5476184a46836954c26354cb998-1730303358"
  },
  {
    "email":"guerzonisabrina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685786490/b2733a9d7dc174d4e8230e66a2166066-1730303358"
  },
  {
    "email":"a.barrere.a@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685819258/f373d38050e95f0bebfd1838e76abb35-1730303358"
  },
  {
    "email":"gabriela.ch@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685917562/8c7043847bcfd71418f0f3cb6ef3e699-1730303358"
  },
  {
    "email":"michela.bega@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685950330/e4458e7c92acf8b1f3349c879b8747d3-1730303358"
  },
  {
    "email":"petrelladeborah199@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726685884794/b03887d0673e403a88731711eb7544fa-1730303358"
  },
  {
    "email":"christian.nemczak@online.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726685852026/4f8c5cdd1be7a9b271493e6d642ddd8f-1730303358"
  },
  {
    "email":"albibarbara@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726685983098/ef878a6fe6ef11dc1aefee1802e859f5-1730303358"
  },
  {
    "email":"manuela.roli@tim.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686081402/3958d3965735fc5bde0757edcce1166e-1730303359"
  },
  {
    "email":"saragozzi2@gmail.con",
    "url di attivazione":"https://verdissima.it/account/activate/22726686015866/19a20879445d35f4a64037d9d4c48a11-1730303359"
  },
  {
    "email":"confalonivanessa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686146938/291e460ce670eadea0a0d3d243574c74-1730303359"
  },
  {
    "email":"lorettacester@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686245242/fcef84ee6fae082412bdaab4a5089b26-1730303359"
  },
  {
    "email":"daniaccorsi53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686278010/1fcca3065e0a8ffc8cebe09e89a5d82d-1730303359"
  },
  {
    "email":"crisscp79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686114170/70b32533eeb5b2314ab26ac06e8f1e7a-1730303359"
  },
  {
    "email":"annaritatubiello@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686409082/3740c840bf6e30923567d2f4a6184413-1730303359"
  },
  {
    "email":"cristinavanea@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686376314/ab62798d66d748ec0cb01bc891a50a00-1730303359"
  },
  {
    "email":"paolo.borghesi1957@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686441850/b332c74c870474bbd50fd2d551c1a2bb-1730303359"
  },
  {
    "email":"monicaciteroni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686474618/2b4eb36aa66fc81159757c789c7e962d-1730303360"
  },
  {
    "email":"osandraf80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686507386/ae40c032c367875e00fff6a0e2070376-1730303360"
  },
  {
    "email":"panighinivanessa80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686343546/6546857eda12fb85a2da174d1beda12a-1730303360"
  },
  {
    "email":"pavisconti72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686540154/f90bfd14549413ad82263bab7e870502-1730303360"
  },
  {
    "email":"caterinalabanca87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686605690/2b00afbf4db2ed5337b1da98d79842e8-1730303360"
  },
  {
    "email":"ansaldi.lydia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686671226/cc7720123a8516e655ce8d95465db5d2-1730303360"
  },
  {
    "email":"svanni@sissa.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686703994/9e7ae3f8d660a51a78adfb63da12afd6-1730303360"
  },
  {
    "email":"gurrierivalentina@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686736762/863a36796243642d2fa40f2a18a7f3fb-1730303360"
  },
  {
    "email":"valentini78@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686572922/b949d0d01b847047726f005b1e420a90-1730303360"
  },
  {
    "email":"francosaglia1@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686769530/2c3a58ed077d06748ecf64267056a742-1730303360"
  },
  {
    "email":"elisabetta.giuffrida66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686802298/8034fca838d3c9099c99ed773d9fe7e9-1730303360"
  },
  {
    "email":"monjabonazzoli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686966138/8a9837bdb05272e4482f0a2cc949e9df-1730303361"
  },
  {
    "email":"giuffrida.elisabetta@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726686900602/fb660c4033cf29bd296f7412d7905937-1730303361"
  },
  {
    "email":"yolanda.eiriz@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686998906/f0da128429f9330b1591860cfb0aa2f1-1730303361"
  },
  {
    "email":"cristiana.talevi@csdtalevi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687064442/5cf0290f60a94b167711fee4504fcfc1-1730303361"
  },
  {
    "email":"nicopaniccia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687031674/83423dd887d0cb6b9cb71f5ba5e8bed1-1730303361"
  },
  {
    "email":"emanuelatosin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687097210/3e75f223495bc8de6646a28142f465a7-1730303361"
  },
  {
    "email":"salonialicio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726686867834/0f6c0d579632be14d770cd293d12024b-1730303361"
  },
  {
    "email":"vida_ao@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687162746/ba0b5a23a11aebf966b748977fcf4642-1730303361"
  },
  {
    "email":"simonetta2509@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687261050/6481d5aa7f63377a258f798fac3b7c25-1730303361"
  },
  {
    "email":"fffchicca2015@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687129978/9ca27f1ce78055bc69fea62f5470e63c-1730303361"
  },
  {
    "email":"giuly.bertini@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687228282/3f570e6b907b7ce6dd1eb250851df70d-1730303361"
  },
  {
    "email":"sabyrusso@infinito.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687293818/0a5ddd8adc25f64564c5e060407822ee-1730303361"
  },
  {
    "email":"cinzia67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687424890/4cad69ae233fe4b42356bf36e3e61a6c-1730303362"
  },
  {
    "email":"liudmila.roma2017@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687392122/b2062d45939099b58d18d171f3d7fb12-1730303362"
  },
  {
    "email":"margherita@leffese.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687359354/512812068e59cdc128d600f4b155916a-1730303362"
  },
  {
    "email":"valbosc66@yahoo.fr",
    "url di attivazione":"https://verdissima.it/account/activate/22726687457658/554b53ed40f648fc707cddde94abecf3-1730303362"
  },
  {
    "email":"genovesiraffaella9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687555962/a9f08727023a8067c0292473d6c809fe-1730303362"
  },
  {
    "email":"benedettaceron73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687523194/198326808d3c655a59fde7cb9c8203ab-1730303362"
  },
  {
    "email":"valeriabrunella@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687490426/baeaa453f3e1cf54215a420ddc1acd94-1730303362"
  },
  {
    "email":"flabott@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687621498/6cc150822be678ff3456da90c38f02a7-1730303362"
  },
  {
    "email":"francomacaroaida@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687588730/24d49667d5f6c72a6af583266d9e3014-1730303362"
  },
  {
    "email":"barby.gra@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687654266/53f70d9419d430b450618592e1ff5bb3-1730303362"
  },
  {
    "email":"giorgettianna@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687785338/e06337d9f7b55eb7c91940d64d083286-1730303363"
  },
  {
    "email":"mourgliamartina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687818106/30bbb2b8b4a6d1393132979145fdcd4b-1730303363"
  },
  {
    "email":"tizianavilone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687719802/17f808f3ccc395a38d9b623bdd030a0a-1730303363"
  },
  {
    "email":"elenasofia1923@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687752570/2b04b659b3e2fe0d8242867c14ddafac-1730303363"
  },
  {
    "email":"tatyana.speca@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687850874/7d96d4b13bffb9d58df3090eb5a16307-1730303363"
  },
  {
    "email":"elisabettapecchioli01@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687916410/f05863bc399babb6e2b67299de817a84-1730303363"
  },
  {
    "email":"stefy.conforti@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688014714/d488c346759f5d79d57ad08b57d9eb8d-1730303363"
  },
  {
    "email":"virginia.bottai@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688080250/014220c838d8a924e0f0a0b9f5bd4040-1730303363"
  },
  {
    "email":"micaela_micheli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726687949178/3a737115aa45b1c50ff4109bc0a4a87e-1730303363"
  },
  {
    "email":"linualaimo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726687981946/419ab82236b28bdc09e9ec04327fb448-1730303364"
  },
  {
    "email":"annalisamollo64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688113018/2c0a7c37d0c4a14b67646fe2040ebe98-1730303364"
  },
  {
    "email":"mtgiannone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688145786/596748a13a220e7c3c1571f12576b6ba-1730303364"
  },
  {
    "email":"lucia.ma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688047482/617827a6c2ee3af13a511c9ecbf29301-1730303364"
  },
  {
    "email":"gio.kira@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688178554/5d7fb8c6fc33c734ee38c98687fd4f72-1730303364"
  },
  {
    "email":"alessandra.bertulli29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688211322/cfefb4e993e6f45fe3f3df5a477a9384-1730303364"
  },
  {
    "email":"robyd83@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688342394/078892ea4a1d038ca65fd6aa8e98a6e1-1730303364"
  },
  {
    "email":"zambonmarta3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688375162/d5ce91190638bc34195dfd09a0db12e1-1730303364"
  },
  {
    "email":"marta.pensa75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688244090/3ce2e5ac5202035dc67751f9e9bc88be-1730303364"
  },
  {
    "email":"anna.baronio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688407930/1a361ccba3a724b2a55ad9ab61656574-1730303364"
  },
  {
    "email":"silvia.marianis02@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688440698/ff71cdfe47f4ad00e4ab8949d28b05db-1730303365"
  },
  {
    "email":"claudia.natalucci@bancaditalia.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688309626/9199d1b9665d2b8c304a498c479b6cf3-1730303365"
  },
  {
    "email":"malagasy72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688473466/0faee990b80779e99222f1420fb94edb-1730303365"
  },
  {
    "email":"l.goldoni@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688506234/e7fadf98ed3eb95c813f9fa894475769-1730303365"
  },
  {
    "email":"lollo.vizzardi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688604538/3567a5f859dd1a4298638bd6bc1b0ecc-1730303365"
  },
  {
    "email":"ale.vanz1993@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688571770/9f12de5c88b8304a86893bece495925b-1730303365"
  },
  {
    "email":"giuliamnt@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688637306/cb409453564fe9ebb82179af76ea47b0-1730303365"
  },
  {
    "email":"lonfrigorsrl@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688539002/05265f76e2cde882401631bb766d28e6-1730303365"
  },
  {
    "email":"sabrina.fabri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688670074/938763fc2d5e88dc8c8806e8785dae28-1730303365"
  },
  {
    "email":"teresarosato@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688702842/5f05665f6b75970d813659805f6de9a1-1730303365"
  },
  {
    "email":"rositaferrari@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688768378/676c7a96d7c2379024256b8440073134-1730303365"
  },
  {
    "email":"manueladimeglio@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688735610/05d35e687e94f2b691e97e0d07b17f98-1730303365"
  },
  {
    "email":"barbara.mar.bm@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688801146/8c1ddf99bdd49fc60b6a4cfc5f0ad2d7-1730303365"
  },
  {
    "email":"mirjam1975@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688833914/8334db0acdb0400985481f5f36651415-1730303366"
  },
  {
    "email":"beatrice.piccardi97@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688899450/0e19bc14cfcecb6a910fe6a8e4b2a858-1730303366"
  },
  {
    "email":"monica.galvan64@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726688866682/0db8e6a16df1100b866c2e7d8f5527d3-1730303366"
  },
  {
    "email":"rosanna.liparoto2020@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689030522/65f397ea0171f273f559dd9ef5768a1c-1730303366"
  },
  {
    "email":"floriana.buzzi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689096058/0463fdbe4a11d6d1ea0d2a942b8b0b6d-1730303366"
  },
  {
    "email":"danielabrognaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689063290/038901f5f2d9a1fedfc16cc9d7aebfdf-1730303366"
  },
  {
    "email":"vitaliy.loyek@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22726689161594/7de4e32e53ca8bdbca6947387abf86ea-1730303366"
  },
  {
    "email":"elisamancuso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726688964986/49eb2fada353f59652eaca05515b50b6-1730303366"
  },
  {
    "email":"spedizioni1@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22726689194362/4c7863e16abca06eba93ae9038b423ec-1730303366"
  },
  {
    "email":"gisella.studio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689128826/2550219501fdaf5e18ccb026c65480e9-1730303367"
  },
  {
    "email":"sales@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22726689259898/6e590a234460de7c96b6601c34f1e5c8-1730303367"
  },
  {
    "email":"cappaalessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689325434/eee8f44c0c80d5c9cea64ea4a109bf09-1730303367"
  },
  {
    "email":"vitali.lobanov@kronos.biz",
    "url di attivazione":"https://verdissima.it/account/activate/22726689227130/f2b1bd46cb4ebaa9a34ec3b0a3e5685d-1730303367"
  },
  {
    "email":"carlotalb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689292666/fa2fb44c8cdce1e8d784c2497dba74ba-1730303367"
  },
  {
    "email":"sope73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689489274/6e7817196f21103a0f9fad5c9132d64c-1730303367"
  },
  {
    "email":"lkelly12@live.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689423738/ac2d06585b0f41dfa29a70e74c60bb8f-1730303367"
  },
  {
    "email":"serenasalvadori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689456506/fdcab291b5c18b3c0c8336287a577ee5-1730303367"
  },
  {
    "email":"cavagnis.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689620346/5dbcdb119595db1dec42dfb2edd9041f-1730303368"
  },
  {
    "email":"tiziana.cocchi@tno.camcom.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726689522042/5b9464f44eefca74c6eb6dfa72f06693-1730303368"
  },
  {
    "email":"barbgorg68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689685882/415a5027a1bd8297ea7ea49a9db4aebd-1730303368"
  },
  {
    "email":"stefanomonag@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726689751418/29bbdb64a25782ec8d5253dd0864ccd9-1730303368"
  },
  {
    "email":"francy.chiapperino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689718650/ba7cb8f5d58170631c41e2646e60bf9f-1730303368"
  },
  {
    "email":"aoibheannansaloni2811@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689784186/2f65b30f155b638bd0f3b651fe0cb7dd-1730303368"
  },
  {
    "email":"milena.bambi@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726689587578/43b841b4571625ac4c96e510afa802f8-1730303368"
  },
  {
    "email":"giulianatravaglini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726689849722/bcd6928c3396fbaad7176af3030092d7-1730303368"
  },
  {
    "email":"valentinaa@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726689882490/638a90eb50b1a1d9771058e0ba906e0a-1730303368"
  },
  {
    "email":"simonaflamini2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689816954/651d7a2677a7cbb40b8140fc8c59735b-1730303368"
  },
  {
    "email":"paola.belcastro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689915258/5cf54d6d737e62f5d5407b9efd6ba64c-1730303368"
  },
  {
    "email":"cerasarochiara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689948026/7de249db640240949962e4c9deb7d2aa-1730303368"
  },
  {
    "email":"slapinska66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726689980794/5d475cb1b9893ccf8defa9414841fa5e-1730303368"
  },
  {
    "email":"mariagiambino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690013562/64913e30cc285655d443d133f4dec395-1730303369"
  },
  {
    "email":"eleonoralambibi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690079098/5aa8f66167aea19ed20fe24ed97a7a29-1730303369"
  },
  {
    "email":"camilla_cactus@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690111866/4078f6cecc271b522bfa0510efbe8a66-1730303369"
  },
  {
    "email":"sp.ark@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690144634/3d9ec3041f692d45b00bab6231862b76-1730303369"
  },
  {
    "email":"annalisaraguseo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690210170/b492582f13a14b276eabd3a0c22a68cf-1730303369"
  },
  {
    "email":"paolagozio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690046330/8f84e693cadde940f0068eca80b9a784-1730303369"
  },
  {
    "email":"goskapastusiak1979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690341242/42d3eda5c302d5a66023fa436bf7edd7-1730303370"
  },
  {
    "email":"nadiaceroni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690177402/1b403b119b4b2899ce14944766133c58-1730303370"
  },
  {
    "email":"alessandra.turli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690242938/8c9c06cef2b8f569a55cad729b6d7634-1730303370"
  },
  {
    "email":"barbaraspez@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690406778/ed399211586f968175c2aafef24293a9-1730303370"
  },
  {
    "email":"annamaria.ingrid.schmid@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690374010/53d90f2dddaf62b16a70a57dbd1a3537-1730303370"
  },
  {
    "email":"angelacerchiari@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690472314/194ec64e56abd516ae6c2daeeee62351-1730303370"
  },
  {
    "email":"klotilda1983@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690439546/d773549c6fd094c70c573586c892c7cc-1730303370"
  },
  {
    "email":"saiji.essia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690570618/5ae2f8d6337d452b96c097b7c5decf24-1730303371"
  },
  {
    "email":"ran2003@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690537850/ebf8596f6a4697649ceb3408a91e5853-1730303371"
  },
  {
    "email":"sebabarb71@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690505082/96ef0b7fccca278031c4cd9c3b0ff9d5-1730303371"
  },
  {
    "email":"gi.pzzo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690668922/70b8f818ce88e463fe308831a123ac42-1730303371"
  },
  {
    "email":"virgy4e@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690603386/a382952035cbb32d0bbc3e7b7a7e42f7-1730303371"
  },
  {
    "email":"essezeta72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690701690/1749df75cbbc50ea429933ae462f9eec-1730303371"
  },
  {
    "email":"jlesch@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690734458/ce87369a829ab10b2d2dd23277281e94-1730303371"
  },
  {
    "email":"martagil@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690636154/96904470d069ad526830829faecb0ef0-1730303371"
  },
  {
    "email":"amysala80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690832762/68cfe0c10b631f242000d732aa190065-1730303372"
  },
  {
    "email":"rosella.modaintima@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690898298/5a3dcd709363327ce778c4c30e60ddc9-1730303372"
  },
  {
    "email":"innakissw@ukr.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726690799994/a2c74ea25cb204e0a17b32fa232d7665-1730303372"
  },
  {
    "email":"tarta_ruga22@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726690963834/3dca550b3a9fb9bc5feb80fdb9409ab5-1730303372"
  },
  {
    "email":"federica.luppi84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690931066/94889209430f12c0957f98b3bf950c5e-1730303372"
  },
  {
    "email":"stecarmosino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726690996602/a2fe8a3e9a37ba93b9ecd13dba9c1975-1730303372"
  },
  {
    "email":"annalisa.mariti33@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691094906/0ea805adb9a180e6b39de5654f74f54a-1730303372"
  },
  {
    "email":"lellaprando@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691062138/d4ceb814c756e0a8142b17a2fe17d77b-1730303372"
  },
  {
    "email":"annalisacogliandro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691193210/907adc12401028b73a05cf527d56207c-1730303373"
  },
  {
    "email":"m.bertoni@cinestudio.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726691029370/0050b31274e3c32934dc22bcab5865bc-1730303373"
  },
  {
    "email":"ari-b@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691225978/e6fc48c6faf6aaa9bc84af99801243df-1730303373"
  },
  {
    "email":"ornella.innocenti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691291514/ba30c8d7b12a51593615ce1305de497e-1730303373"
  },
  {
    "email":"wonderw43@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691324282/2aa21b6f5548262b1d299f24093d792a-1730303373"
  },
  {
    "email":"cris.nicolussi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691127674/f6d6fb995b9cf02547cff261b5ed90d8-1730303373"
  },
  {
    "email":"c.gaudino60@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691258746/d47369778bdd1f54ee91f31f986fbde1-1730303373"
  },
  {
    "email":"donatellalberghina@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691389818/a0880ee2e4f4f5ad0f7c0c6f1811b25f-1730303373"
  },
  {
    "email":"r.iovine@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691422586/fdf496ed9279741ea2be02f67947360b-1730303373"
  },
  {
    "email":"cinziamachetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691488122/952946c8f8f2d5191ea9e258bf857d9a-1730303374"
  },
  {
    "email":"v.r.t.virginia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691357050/b18c97077788ce264676e9b6c894407e-1730303374"
  },
  {
    "email":"shutaleva94@inbox.ru",
    "url di attivazione":"https://verdissima.it/account/activate/22726691553658/8b4ef0ba96af34681d77af96b5f8ea65-1730303374"
  },
  {
    "email":"fabiana.onofri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691455354/df1a3f35bf9a69ccde1ed36755bcdc7b-1730303374"
  },
  {
    "email":"carmenzapp86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691717498/5d6c40d21c551f33f1f76e7fc7e8c4ad-1730303374"
  },
  {
    "email":"elena74fabbri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691684730/232be6dad4260d967d6661c6f0ca5698-1730303374"
  },
  {
    "email":"lizakachibaia05@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691619194/d3e4186e35f3cffdf111bc343e670792-1730303374"
  },
  {
    "email":"grazia.spagnolo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691651962/eb6fb592d263bf605a9780944c519eeb-1730303374"
  },
  {
    "email":"margiuchi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691815802/17bbe1613f2d17dd1abdde7081061067-1730303374"
  },
  {
    "email":"emanuelaporta3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691848570/cf31ff81085fe0cae6b06aa68673a444-1730303375"
  },
  {
    "email":"csodi941@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691881338/a63be0d93dd437188716ac7025522a4b-1730303375"
  },
  {
    "email":"m.marcuzzi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691783034/6cbf0a196da123918f9c14c87d3437e3-1730303375"
  },
  {
    "email":"roberta.pagliarino@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691914106/5058b5b50bff5f804639a2dfe3aebe54-1730303375"
  },
  {
    "email":"marinafanizzi933@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691750266/a0f1401dbd17ca25f4c0ae7d7100e2c3-1730303375"
  },
  {
    "email":"a.arianna@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726691946874/74154e703fb00829e11646a29b6cc25b-1730303375"
  },
  {
    "email":"katiagiavarini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726691979642/c4b312ddf7cb59733bb0f1887dfb9714-1730303375"
  },
  {
    "email":"mariarosaria.femiano@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692110714/b546b372bf72e019912b3a1a5148c62a-1730303375"
  },
  {
    "email":"donatellaper@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692143482/7fa3db29a4c4ea968572b5e33fd60832-1730303375"
  },
  {
    "email":"dottssairreramaria@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692045178/d98e93db7b0d0b5edab1a7aeb881e353-1730303376"
  },
  {
    "email":"angycostantin07@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692274554/0798a0f3ee1f83b475b33ee90f611c4f-1730303376"
  },
  {
    "email":"karoline.bussert@web.de",
    "url di attivazione":"https://verdissima.it/account/activate/22726692077946/7771285ee590860abf56cc27e4e166c0-1730303376"
  },
  {
    "email":"linda1mencuccetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692340090/0704d2412d556ad6f2cdba93b29e6ba4-1730303376"
  },
  {
    "email":"graziella.b2011@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692209018/c71c4fbca0f3d95c23f56754adb873b1-1730303376"
  },
  {
    "email":"barbara.cafiso72@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692372858/59876f9b3b8140b6a6f8b286425ec3b8-1730303376"
  },
  {
    "email":"milva.ratta@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692471162/435f83d260bc6ec173b00786999eb5f6-1730303376"
  },
  {
    "email":"stefania.maruzxi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692438394/1873b150dd33890d05069fb3dc8a4e07-1730303376"
  },
  {
    "email":"angel.cinzia@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692405626/7a3b53216772ea56f6746e04b6d8308c-1730303376"
  },
  {
    "email":"olvsovg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692569466/12987bf7bc20e638188f48467481166f-1730303376"
  },
  {
    "email":"gabriella.ghirlandini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692536698/462003309b746d37b52363939273e329-1730303376"
  },
  {
    "email":"margagio78@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692503930/03099ffd6866690ec4726fb6224b17cb-1730303377"
  },
  {
    "email":"familyfior@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692602234/5f26e8c6528cb58151dc23df16fbc3ad-1730303377"
  },
  {
    "email":"samanta.siria.mes@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692667770/302e211e54d04632d3ec41cc6fd1c02a-1730303377"
  },
  {
    "email":"laurapersi21@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692635002/056458c3a3e71157bf5a56af71fbd597-1730303377"
  },
  {
    "email":"vanessapanighini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692766074/b4ce2b0de50281764573f56d45fca0bd-1730303377"
  },
  {
    "email":"alice.franzoglio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692700538/17041bf91623e15a6a45a6ae443d8f05-1730303377"
  },
  {
    "email":"selmo.piera@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692798842/ebd5d3eba7220b38d5d40f9bdc10335a-1730303377"
  },
  {
    "email":"rigelblu@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692864378/dce3f7b9af63bb6de2a65e0adac466be-1730303377"
  },
  {
    "email":"ivanabaldori@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726692995450/f2739103ac033e493c6fdc53dcf65e6c-1730303377"
  },
  {
    "email":"paolavignoli@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693028218/f33338eeeabc719953eeb4e873507b32-1730303377"
  },
  {
    "email":"minutolijosea@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692962682/64eb5b434b47abfc4f9e749fcbaa81d1-1730303377"
  },
  {
    "email":"turtu.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726692831610/2e93028c7768110fdfdd0c940041c33e-1730303378"
  },
  {
    "email":"alessandra.parrotto@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693060986/3295ec5fc777dc2961893ca43e967dd1-1730303378"
  },
  {
    "email":"baby69@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693126522/21e3e61cc65a2e8ec02775a3d6d95459-1730303378"
  },
  {
    "email":"claudia.sanse@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693159290/04960aa8aad35a165fade30570538782-1730303378"
  },
  {
    "email":"sbirulitis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693224826/27ea52a9f52e7beac0c0fc97c44de32c-1730303378"
  },
  {
    "email":"annaoksa.info@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693192058/478749c66b11a2a889c2ca4d8b6c1ed6-1730303378"
  },
  {
    "email":"musaro.paola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693257594/353d174269bcab2dab3508bfd0f6a702-1730303378"
  },
  {
    "email":"dalmonte.mariairma@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693093754/7259e7e87a4664397a71131399b481a8-1730303378"
  },
  {
    "email":"f.ronchetti@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693323130/8690958cfa871b5b5d81dc45a7de0aa8-1730303378"
  },
  {
    "email":"barbara-frasca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693454202/3edf55c2f8b2d7d4b56cebdee1034030-1730303378"
  },
  {
    "email":"veronicacalcagno79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693388666/a9914e19bcc6555e4d6bf8239357bb99-1730303378"
  },
  {
    "email":"erikaradi3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693519738/1230752a1dd4b2dba6f077a4b41ceb24-1730303379"
  },
  {
    "email":"catiaweb9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693585274/e5bd6d58b32e7e10af2e1824fd89e029-1730303379"
  },
  {
    "email":"ingemaz@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693618042/43a4cbf83fb367fc139d5724b6b7550b-1730303379"
  },
  {
    "email":"barbymastel@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693552506/ca08d0064d5b3a6073da491a87520b19-1730303379"
  },
  {
    "email":"alessiamacca@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693290362/3341b984314c8f812a605c4024cd08a5-1730303379"
  },
  {
    "email":"marina.russo1983@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693650810/3ceba1d1a754002ce7428d906cb13949-1730303379"
  },
  {
    "email":"scalzini75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693749114/a3e7ad963aef8fcc1c7f872fdbfd7a4e-1730303379"
  },
  {
    "email":"emanuela.scarpaccini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693781882/6356204163b2855bcdbdc817e57aab9a-1730303380"
  },
  {
    "email":"anarghuer@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726693716346/15d86fe95b6824a079edb58ed3fb5eb1-1730303380"
  },
  {
    "email":"s.bono@sispi.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693945722/7f447c69d0912ca99cc47d8969856934-1730303380"
  },
  {
    "email":"michelatriacca@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693978490/7f1b1be0fd7d93dc207540e9f6fc003d-1730303380"
  },
  {
    "email":"claudia.voltolini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726693912954/79cfc16657974c330258048dcaed74b4-1730303380"
  },
  {
    "email":"mariannanobile@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694011258/a06e0fa14ac76d3182957c64a4cbe936-1730303380"
  },
  {
    "email":"rosamarra18@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694109562/314861d59c5a63bebf7ce8310bc34ca7-1730303380"
  },
  {
    "email":"teresatavellatt9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694044026/04bf437dce8dbbea5a077f4abf4081bb-1730303380"
  },
  {
    "email":"marinasalvi22@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694142330/ff2610f37d9988ae50ad6ea68ee7a22f-1730303380"
  },
  {
    "email":"valcasalialessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694240634/2d3a171c900d543a7b552e01854d3043-1730303381"
  },
  {
    "email":"l.deplano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694076794/905f2526d47ef37e7b6df443fc7ecf61-1730303381"
  },
  {
    "email":"claudiaricci777@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694273402/c7fe695bc78daa4561a93ca7ccbbed43-1730303381"
  },
  {
    "email":"s.usai@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726694306170/36f80e04645ca411570e314ac2f4fb6c-1730303381"
  },
  {
    "email":"francescarizzone@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726694371706/60ea9ffb5860acd7ece55b723ef72e01-1730303381"
  },
  {
    "email":"giuliana.pasotti67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694568314/af074c3a9a69380daee11117b5be4117-1730303381"
  },
  {
    "email":"bandelliscilla@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726694666618/3293f20d50f6c0dcdea0dc5b1efaf5ee-1730303382"
  },
  {
    "email":"adriana.comini@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726694601082/5e4b5a647feef20c80f8c8839a994f0a-1730303382"
  },
  {
    "email":"at.aleg@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694502778/50107f97ca3144c4dec3237da6605fcb-1730303382"
  },
  {
    "email":"1973can@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694633850/ff5ef6e7f37fdee03bbcc0e10c8359d5-1730303382"
  },
  {
    "email":"manu.eb68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694699386/6915ae60a1be1c4e2c50374cf8fcfbc8-1730303382"
  },
  {
    "email":"patticipu@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694732154/3ed594fa2925aea1010de8ed2f4a9000-1730303382"
  },
  {
    "email":"bartolettigina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694764922/17218843a2ac1163842b1dbe286e9ae7-1730303382"
  },
  {
    "email":"francescaflammia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694830458/eed2f4c43685304710f729a02c4a044b-1730303382"
  },
  {
    "email":"valentina.azzarone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694928762/377826a9feb145592a4057e6595cbf93-1730303383"
  },
  {
    "email":"scataldi@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694895994/e28975c0d7373680bffc0f8539ee9934-1730303383"
  },
  {
    "email":"robertabulgarini133@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695059834/cf7bdc765167bc242ffbc2d75ea847ff-1730303383"
  },
  {
    "email":"antonella.dantino@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726694994298/268e1c12cd182aab403d3eaf5b185db9-1730303383"
  },
  {
    "email":"francerri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726694863226/8ecfcd39df915d99eadfeef7d04efcb6-1730303383"
  },
  {
    "email":"silvia_gale@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695092602/23bdc4de54be100b402a614f166ad248-1730303383"
  },
  {
    "email":"cristinascalera80@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695125370/c753e0926a045f10a9a9c59733984bdb-1730303383"
  },
  {
    "email":"ilariacasamassima84@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695190906/074509a68a21a6217948372f6ccb59f7-1730303383"
  },
  {
    "email":"eli.anelli86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695256442/83d5a6cab736f14d652d801d22e837ce-1730303383"
  },
  {
    "email":"annagarofalo1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695158138/fc02ff40f3633d4a0cd0a647a7546875-1730303384"
  },
  {
    "email":"athinapapa.us@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695321978/4a4f18206df383bc54bb58d26f26663b-1730303384"
  },
  {
    "email":"ambra.ienina@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695223674/e34a3d11b9d291f71d146e7494ae1aa9-1730303384"
  },
  {
    "email":"robertadgr@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695289210/5d998d21beca5784785fabf64ce6396b-1730303384"
  },
  {
    "email":"palberio11@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695354746/15d5482eb20446134e571beb12d6be53-1730303384"
  },
  {
    "email":"cosiminamatulli@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695387514/7c4e004358414f48943a4ab2890f5934-1730303384"
  },
  {
    "email":"micheladone@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695453050/db7dea7179fe8398473f7949dc171658-1730303384"
  },
  {
    "email":"merya7674@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695420282/aa9b598578b293721d7bd91d0d52f0d2-1730303384"
  },
  {
    "email":"marialuisamete@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695518586/8a86f5c2836f291aa28d435d9ca95fab-1730303384"
  },
  {
    "email":"valeria.beeleno@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695485818/c14385af7d22b98bab53735897f51c74-1730303384"
  },
  {
    "email":"ilariamalorosi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695551354/484f9536605cfced4758af27a6505570-1730303384"
  },
  {
    "email":"matilde.maini7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695616890/70067f82b8bbbaef6b785bfd65812095-1730303385"
  },
  {
    "email":"sabina.mossi@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695682426/03e307fc23fb59b589eb4b78e02b0f62-1730303385"
  },
  {
    "email":"siltundo53@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695715194/3d41007874d4576e31f706e52094b79e-1730303385"
  },
  {
    "email":"elbalkimi2017@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695780730/c066449d60c4ebc38b02844ac6fcc669-1730303385"
  },
  {
    "email":"stefania.musso1@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695649658/c855f2268e97fc2e7ebc98403da94cd3-1730303385"
  },
  {
    "email":"nicola.pignalosa@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695846266/de03b665eee96e21bf646e81fee5f589-1730303385"
  },
  {
    "email":"malvale@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695747962/888e2db2fe7a351f0e21c1001686adaf-1730303385"
  },
  {
    "email":"jolerossetti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695879034/86f73c0987b56fc8e082090b22b3cbbc-1730303386"
  },
  {
    "email":"lored.arazi@gmai.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695911802/931130abd990eb59a134ffb33144d428-1730303386"
  },
  {
    "email":"aferdita.sadja@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695813498/1bed02dfe75a2c7835e8f8a7c9ee2d00-1730303386"
  },
  {
    "email":"rstgrieco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726695977338/aa93f6b7a93c2cd721a1763d2ea1960b-1730303386"
  },
  {
    "email":"ale_roller@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726695944570/fa82685945765a3bc4c2fc805a37e3a9-1730303386"
  },
  {
    "email":"babi.b0711@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696075642/367cd37d130e49b56f03be4eb540bb9e-1730303386"
  },
  {
    "email":"elisaletti.f@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696042874/c2f5ded73653bd25d70652bd23bb342e-1730303386"
  },
  {
    "email":"marcos.flavia2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696141178/57bc01dddceb650fbb80b6b0dfc272cc-1730303386"
  },
  {
    "email":"morena.sala@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696010106/f7ef712abda703e2985b1603204ff9b8-1730303387"
  },
  {
    "email":"rosetti.cri75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696239482/fa791a49ffd6713a939fc05bda3917a5-1730303387"
  },
  {
    "email":"spahnb@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696305018/a144ef4568c8cdc332928480bc96dc77-1730303387"
  },
  {
    "email":"baraccanimascia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696206714/4ffecefc4a77689022966b5dcc96a963-1730303387"
  },
  {
    "email":"mariateresabergamini0@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696272250/9c7432545d9e9f01a008a9cdb218dace-1730303387"
  },
  {
    "email":"panisilvia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696436090/8b6e32af4137ffff0e6e327814633941-1730303387"
  },
  {
    "email":"eglebellettini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696337786/590946d9100b26f3e157ec6e562e2f2c-1730303387"
  },
  {
    "email":"ariannasimoncini@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696370554/d2a10112af78fef2a00965f2b9140da8-1730303387"
  },
  {
    "email":"vvterribili@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696468858/8d5ace94b452d454873cca5e03322062-1730303387"
  },
  {
    "email":"fabianaven@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696599930/e51bbee367bf2b546c6dfb806f892e30-1730303388"
  },
  {
    "email":"virna.bonaventura2013@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696567162/5203e16875b1720b01aa2aeddb09c26a-1730303388"
  },
  {
    "email":"egle_55@inwind.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696534394/a5885362d92c78e32b97c0a3ac697137-1730303388"
  },
  {
    "email":"letiattala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696501626/53979d6514f7d1d2ca98ab3f8bc4fd63-1730303388"
  },
  {
    "email":"alessia.micol73@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696665466/60fd3df8dc2caea07190e40fb3612219-1730303388"
  },
  {
    "email":"porcedda78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696632698/d29204e3f0390aea8c03b3c80403b608-1730303388"
  },
  {
    "email":"loidevairo@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696698234/3bd9ef5e654bfe24f922f211804f1cfe-1730303388"
  },
  {
    "email":"valentina.simeone.76@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696731002/aac47e02d7c5198674bc47f2647c4929-1730303388"
  },
  {
    "email":"elisabeth.koller2@chello.at",
    "url di attivazione":"https://verdissima.it/account/activate/22726696763770/3c1b1d5c55e11c9d7534f6815b59c670-1730303388"
  },
  {
    "email":"federica.zuppi@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696796538/2a6ce006ac24af3a2d2fedef77e12e25-1730303388"
  },
  {
    "email":"simona.barassi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696960378/705d41ed21e2acf24dcbdd796864ebc7-1730303389"
  },
  {
    "email":"manolab2005@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696927610/e9d49a1f2ef1ca3d5f85a09afc58a25d-1730303389"
  },
  {
    "email":"solari.linda@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726696829306/f7606f8c1ab4a5701e4683bc6a64eb30-1730303389"
  },
  {
    "email":"marikamonzani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726696993146/7bf9a34e7bef136e95042847fde728bd-1730303389"
  },
  {
    "email":"saravitiello@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697058682/3c082b30e20d8e669e2585ae2d5ff883-1730303389"
  },
  {
    "email":"antonella.arnaboldi802@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697025914/70614ddeffce04ad86c1730aea252266-1730303389"
  },
  {
    "email":"mariv8080@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697124218/aa347dada8bbe746346f2109981064df-1730303389"
  },
  {
    "email":"veronica_rainone@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697156986/b1933d4b4c32dd6d660435619064ab02-1730303389"
  },
  {
    "email":"francescaz1975@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697189754/9a86050757c07a448477f2496fa8f1bb-1730303389"
  },
  {
    "email":"saragiaco2009@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697222522/cc6605b6da1310b0005b2e5683b159e3-1730303389"
  },
  {
    "email":"antonelladrago@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697255290/d0a977db08db01756879558c95f87706-1730303389"
  },
  {
    "email":"mariabuffa96@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697320826/b12521a395e2facb2b209a6c2f0a6ee3-1730303390"
  },
  {
    "email":"rita.acquarola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697386362/8d94663da425368abfeaa919f94ff8d5-1730303390"
  },
  {
    "email":"nivescui@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697451898/3bb4a329d5d26edc8afbf8fdb4cfa7c7-1730303390"
  },
  {
    "email":"erikablob10@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726697484666/5856e4f8d627af62c7a2cb51b4632400-1730303390"
  },
  {
    "email":"info@slompo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697419130/1be987cd5935f1297b5ecdd1a1c082cb-1730303390"
  },
  {
    "email":"lauramaria.perotti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697288058/cd1fb2b85c5c5aa0a8f76510171bff40-1730303390"
  },
  {
    "email":"danielaattanasio74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697550202/eadeb74021a1452d29af4868573a658f-1730303390"
  },
  {
    "email":"lilia4428@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697517434/7c9dbd1f5972a908fbd3d3c12a479f30-1730303390"
  },
  {
    "email":"eligat@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697615738/30769302f9ee87943a6478db7d3af9dd-1730303391"
  },
  {
    "email":"c.polverari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697714042/6b4a4ddab4628c28cf40a3980050045a-1730303391"
  },
  {
    "email":"rosanna.taglia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697648506/a2db69a645dc865b6c55e715adc4da51-1730303391"
  },
  {
    "email":"francescarosini78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697779578/922f31997de6b15c0e50c6ea6ad21d5a-1730303391"
  },
  {
    "email":"silvia.gariggio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697845114/df8a47d5e406c33e84ccf42e35006900-1730303391"
  },
  {
    "email":"lucia.goldin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697877882/2277f7d1949d5a8a3c0def96fd8432be-1730303391"
  },
  {
    "email":"fontanagaia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697910650/4bd6099a4bc5ea24e4e5d4d317109ae4-1730303391"
  },
  {
    "email":"alessandragesuiti82@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697812346/196222ae22ffcd33f601c5e21876519e-1730303391"
  },
  {
    "email":"celaemilia3@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698074490/78d0be256d99c47a5a7741a84f813fc2-1730303391"
  },
  {
    "email":"ellenika005@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698041722/e517cd580e418d6b97bc58de96fe66c3-1730303391"
  },
  {
    "email":"domenica.enza.chiurco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698107258/424c06710f47d457a69d817ff330bdbe-1730303391"
  },
  {
    "email":"benvenutisilvia78@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726697943418/9fb215b247c1bab1988f429c5323bfd4-1730303391"
  },
  {
    "email":"rosannadisanto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698140026/771471222d09ac2066153d8e820cb0e9-1730303392"
  },
  {
    "email":"piccolasue@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698172794/a613f7a6e83b24ec2b7990b121c3b3ed-1730303392"
  },
  {
    "email":"limonci87@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698238330/af1c2cd7a1a5f30faba8f437ce249f38-1730303392"
  },
  {
    "email":"magidec@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698271098/7fe69e1973b7c0da6bbb86fff9c4c15a-1730303392"
  },
  {
    "email":"serena.laurenti@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698303866/7d5933e599ec048f4663e8d2c1d3b1d7-1730303392"
  },
  {
    "email":"scifo.federica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698205562/d1994e485f7f796861712cd842167117-1730303392"
  },
  {
    "email":"lorellamazzagatti@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698336634/da8251063c05c0edfff6ebe5e99f99d6-1730303392"
  },
  {
    "email":"tatamoni@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698402170/a63cc3660132a32fd9387ada200e18e0-1730303392"
  },
  {
    "email":"mariannapugliese@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698533242/cdfe2a8898cb4420404ee2949aefb235-1730303393"
  },
  {
    "email":"raffaellagornati@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698500474/836d9239ab9afc68de9efb49ff95158a-1730303393"
  },
  {
    "email":"doriana.db@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698467706/992159844ad9135e8222a7738f4a52ae-1730303393"
  },
  {
    "email":"emy-b@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698434938/2e03c91eb35f25cc7a53ef695b4100a5-1730303393"
  },
  {
    "email":"stefaniamarinelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698631546/ddb66d2cb4fd0ea66e6c43f6fd7add03-1730303393"
  },
  {
    "email":"giulia91angeli@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698598778/e586f386295884e9cf8e015ee7aed450-1730303393"
  },
  {
    "email":"gabri81979@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698566010/b0e1b2ceffb6ad225daa50054618f98b-1730303393"
  },
  {
    "email":"pelusoannamariac@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698697082/bee7b761290c8deff0895e8e3f8c740d-1730303393"
  },
  {
    "email":"lorenza.garbari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698664314/10081e967482d09982e112cb68c8c6a4-1730303393"
  },
  {
    "email":"elena.dinucci@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698828154/10a6e4739758168981fa28cdb7ac4967-1730303393"
  },
  {
    "email":"monicafree21@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698795386/41f4ed5e7334ff9aefc5199b7270fe64-1730303394"
  },
  {
    "email":"arianna.sammarco@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698729850/b22f83a9ba60099ea481e1752d6cce6d-1730303394"
  },
  {
    "email":"stefania1570@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698860922/b37d9a0649cc2bf5916e9089c3733018-1730303394"
  },
  {
    "email":"francescapagliula@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698893690/58da35741d6d110bfc3d63c15181ee1b-1730303394"
  },
  {
    "email":"meita@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698926458/d25b0909764c63852ac43361ff7cd82d-1730303394"
  },
  {
    "email":"noemi.mauri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726698991994/7b58180cbef99aea9983acf63dd53193-1730303394"
  },
  {
    "email":"ciompo99@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726698959226/d96621b72e969962eb5b3e5f9c03e3d7-1730303394"
  },
  {
    "email":"danimilo99@g.mail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699057530/ec76ff392aa848ec102fdd4af589ae40-1730303394"
  },
  {
    "email":"raffaella.lachina@virgiluo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699155834/8ebd31c2780e336b65105a980985a38a-1730303394"
  },
  {
    "email":"c.claudiacappelli65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699090298/266425aa30c42239c6125cc2bcca2fd1-1730303394"
  },
  {
    "email":"lisotta90@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699123066/966a53175d0e3aca5ea9ec90be086941-1730303394"
  },
  {
    "email":"stefaniamascara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699188602/7082bf49d1f46cf78f778b5af7a90c58-1730303394"
  },
  {
    "email":"katiapisan@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699286906/b2b4dc340bf5df66810f9c631764e7f4-1730303395"
  },
  {
    "email":"stenfa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699254138/d9b882b1d1d52463755b1a3ecf4b4a7a-1730303395"
  },
  {
    "email":"paola.galli2@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699352442/0ef30f295187b0455d3bf42b76baa314-1730303395"
  },
  {
    "email":"enza.monte@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699319674/1bda5662a8c9fa9146200484346c3768-1730303395"
  },
  {
    "email":"mariarosariaconvertino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699385210/a097af7feb3a0eaea548888971bec5d5-1730303395"
  },
  {
    "email":"francescapagnanini79@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699483514/3944bb221864b3f1993dc2dcfd559aad-1730303395"
  },
  {
    "email":"valeria.montani@aslteramo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699450746/6f168308e6507538f37aad1056412b10-1730303395"
  },
  {
    "email":"daniela.campra@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699417978/4969a1af44e9d02a54fde273d181e7ff-1730303396"
  },
  {
    "email":"clerissa@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699549050/0e9616978e277b691b870edd8060ce86-1730303396"
  },
  {
    "email":"egger.vero@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699516282/2c8365fcb3caa52de25b14a597de2477-1730303396"
  },
  {
    "email":"valentinamattana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699647354/c46ad5dc9e664267dc04f340e5bd90c8-1730303396"
  },
  {
    "email":"fc.caty@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726699614586/4312fabb3fe6f734e28d34027e188572-1730303396"
  },
  {
    "email":"m.rizzi@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699581818/49e1b76471f3f641b5f6bfebf6d3df01-1730303396"
  },
  {
    "email":"maietta.monica@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699680122/75989dfc827f05eeeec4247934aa89cc-1730303396"
  },
  {
    "email":"jehdhdhhdhdududhdh@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699778426/895680aa32a5606125f5b7e043253aac-1730303396"
  },
  {
    "email":"marta.pisati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699843962/668978096f5aa29ab8db29f5f5e43cc2-1730303397"
  },
  {
    "email":"alessandra.salluce@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699876730/31878d39d2f2382267139588395def1c-1730303397"
  },
  {
    "email":"pallottina23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699712890/c020a5d76df8fba77304f73265128050-1730303397"
  },
  {
    "email":"eleto2014@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699909498/4ba99c1ed1b98c85171c502210dcdaac-1730303397"
  },
  {
    "email":"maraciaravola@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699811194/564aff06b5c6bc97c70ffc57477cf700-1730303397"
  },
  {
    "email":"enricasalvarani74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699975034/73ba85d0ecec808d5e486edd7b3609ee-1730303397"
  },
  {
    "email":"christl.pfeifer@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700073338/b66db47eaa6e041dde7657972ac60ec4-1730303397"
  },
  {
    "email":"meggyatwork@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726699942266/92e0f534a899f65828b981ca62763be1-1730303397"
  },
  {
    "email":"r.cencini7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700106106/18ea863f133837e6d8445d82fa72a14a-1730303397"
  },
  {
    "email":"eli75@email.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700171642/221f0f517002b4dfd905cd7f837263de-1730303398"
  },
  {
    "email":"fpaola@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700040570/c328de7ebb821824cba445aec230cb08-1730303398"
  },
  {
    "email":"rossana1cacchione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700237178/fa26913e005dc15468546937943d8e1a-1730303398"
  },
  {
    "email":"mariagraziadefeudis@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700138874/0c813df255ddcae5655e139b8a425747-1730303398"
  },
  {
    "email":"raffamasi29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700368250/94a9322b02f1f47a90190c6ba9f9a349-1730303398"
  },
  {
    "email":"maryg1977@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700269946/e60d0b37b3b2622a7aced6e093bced5f-1730303398"
  },
  {
    "email":"francescasarago@outlook.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700401018/329e2795e581f61caa29f2eb771cf0e9-1730303398"
  },
  {
    "email":"lady.france@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700335482/49c3898c63f628c056b4f9778a36a046-1730303398"
  },
  {
    "email":"jollybar.bar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700433786/467dfd94b8376d20e0bdb7a3fd153fc1-1730303398"
  },
  {
    "email":"mariacristinaflpp@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700466554/b96d06d3603a2420af0f51b742033072-1730303399"
  },
  {
    "email":"m.mino2005@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700597626/8f14505a546bad962ffe8cb0f98351be-1730303399"
  },
  {
    "email":"kykla.ada@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700499322/9835a63d3e575e681659e1e3a3c6f761-1730303399"
  },
  {
    "email":"eleonora.pieri@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700630394/760908a5d21bd57107218736c44ea08d-1730303399"
  },
  {
    "email":"giusi.mazzoleni69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700564858/4f6d5afc9c817d90790003b556115c8d-1730303399"
  },
  {
    "email":"ritarenaudi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700695930/b7c9ccc7f0c79cbafd33002ae0cfd346-1730303399"
  },
  {
    "email":"francesca.fonsidituri@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700761466/5bbb13a6646650f56a15fcdc6ca4a504-1730303399"
  },
  {
    "email":"adrianamariana30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700728698/34da08ac3a9698e4355ce5dfafec6eb6-1730303399"
  },
  {
    "email":"giusysangiovanni@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700794234/4d9adabbda2e37224466316d1aa99af7-1730303399"
  },
  {
    "email":"raffaellasun@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700859770/ebed0087d730e789c2de8de15adadc87-1730303400"
  },
  {
    "email":"saderiantonella@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700892538/fde87c2f77bf716ac6c8c2fb66b2577a-1730303400"
  },
  {
    "email":"mgraziacantini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700663162/427165e083be0fdeec2290253ed4a0c9-1730303400"
  },
  {
    "email":"borsettoantonella@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726700958074/2a6ab4f0757af918e1eb02e45bfb6d58-1730303400"
  },
  {
    "email":"magda.musidlak@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700827002/454b7080b59e3c55571b7c7087bcfbd7-1730303400"
  },
  {
    "email":"sarogena79@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726700925306/5ef2e71c41ec547a35226d619d03fd1c-1730303400"
  },
  {
    "email":"gassilvia@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701121914/859e3a1dd5bb43e612089fbb74f672f0-1730303400"
  },
  {
    "email":"squincy90@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701187450/73373a712db2b5c3e5c5d702dea9b8a6-1730303401"
  },
  {
    "email":"rosa.natale@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701154682/fa5da2d4c3901de8fc2fb66631786fe1-1730303401"
  },
  {
    "email":"vittorialimitone@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701023610/0ea36324aacb5b96e174b3d5aefbc3e7-1730303401"
  },
  {
    "email":"viviana.57@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701252986/18bd8dc4686a12791dea9b670badec6c-1730303401"
  },
  {
    "email":"silvia_bls@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701285754/8c2f531f8efe86115c7e874821833a0f-1730303401"
  },
  {
    "email":"daniela.c2212@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701318522/9beaa09bf2f4e62139123a79ce8cfc62-1730303401"
  },
  {
    "email":"angelaconte369@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701351290/a59fc8542ba7c6e64b408b073132cebb-1730303401"
  },
  {
    "email":"claudia.mel@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701416826/96ccf3bc76aaa597bb9a299d07e2e02b-1730303401"
  },
  {
    "email":"raffaello.giannecchini@bancobpm.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701449594/1181893df0968c2016785a8692306916-1730303401"
  },
  {
    "email":"m.ravaioli@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701220218/195ce6fc5dd7bad9a0bc8c3adf8152b3-1730303401"
  },
  {
    "email":"lapiferrara@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701515130/f88cc6c511542009924fc52705058c7f-1730303401"
  },
  {
    "email":"anto.zangrandi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701613434/a4901581965b375f27b6007dc22e2daa-1730303402"
  },
  {
    "email":"bellucci.laura.bo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701646202/1faa198fb76e1e812b42088e359e5f4a-1730303402"
  },
  {
    "email":"valentinadefazio87@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701482362/f478644f3e81de43efeb142920c7dc95-1730303402"
  },
  {
    "email":"laurafranzoi68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701678970/fdb53de01e2b432876d7c05dc2eafe8d-1730303402"
  },
  {
    "email":"benedettianna67@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701711738/828b344092a3e62c7901755fcb8fa25f-1730303402"
  },
  {
    "email":"marchesina23@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701744506/cc5884f8ed42e73a1f648c7dfe597ec8-1730303402"
  },
  {
    "email":"elisacch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701810042/8b5629aa31f73e577e8f18e9a5c97e3c-1730303402"
  },
  {
    "email":"tiziana.ravanelli@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701842810/c46459d92ec5e0ab18efaf96afc9cbec-1730303403"
  },
  {
    "email":"fralongo65@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701875578/10b7c66463178b8a04d4bd20e35c0bcd-1730303403"
  },
  {
    "email":"irene.russo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726701547898/6a94e313fccdd9d07f83f1e51600ef9e-1730303403"
  },
  {
    "email":"ri.lec@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701777274/18d3734c2eb3eb6d77a0e0cbee55850b-1730303403"
  },
  {
    "email":"christine.schweitzer@rolmail.net",
    "url di attivazione":"https://verdissima.it/account/activate/22726701941114/ced4c9d3e10126fe1d6e880cd8176bf9-1730303403"
  },
  {
    "email":"dona72.toso@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702072186/45cd8db0c4419b3b2f7a28a4960b54b3-1730303403"
  },
  {
    "email":"fabiola.graziani@tiscali.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726701908346/f34eb55af34066b495fcf1ab6f48c3b2-1730303403"
  },
  {
    "email":"angelaciardi13@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702170490/e1e61e57690595344bd9fec63a476b7b-1730303403"
  },
  {
    "email":"cristianasagradini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702203258/c9b7b5f618e283858d867f0b5c8de557-1730303403"
  },
  {
    "email":"fachini@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702104954/78116588279db157319909aa5b70f56d-1730303403"
  },
  {
    "email":"annalisadoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702236026/e6d52ae117e56b0cc39fcdb08db5002d-1730303404"
  },
  {
    "email":"simonarondinelli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702039418/37888c14695da01e48524c7b40773ded-1730303404"
  },
  {
    "email":"lorelladudine@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702334330/d879a6f789cd5ef9bf93e63772364ef8-1730303404"
  },
  {
    "email":"destro.elisabetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702301562/85891c045cf17dc3b72f8659c68fae26-1730303404"
  },
  {
    "email":"annasira1966@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702268794/f18518aa97726bfcd8f175f3e9883ca4-1730303404"
  },
  {
    "email":"deboratc70@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702399866/94170a54ded61bc1d03b800821ad8ff9-1730303404"
  },
  {
    "email":"elycarbo.90@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702465402/0c8e3a65fdbfc4f7a2a83caad2499204-1730303405"
  },
  {
    "email":"lux376@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702498170/93699febcf20747864f91faa8f3be4ae-1730303405"
  },
  {
    "email":"biffi64.liliana@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702432634/3363e3136e8e755910ae37b0fb925e15-1730303405"
  },
  {
    "email":"lega.roberta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702367098/0401f95e6cc7f210affcaae1fa2016c8-1730303405"
  },
  {
    "email":"sashakar@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702530938/b376eeb2c30d502503810e33ae26791e-1730303405"
  },
  {
    "email":"nicoleta.sandu@itsplanet.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702596474/d161793c5d031b38250dc9b375deaf24-1730303405"
  },
  {
    "email":"monibrugnoni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702563706/9f4aa70756dfb19fa116c0ff6f74452c-1730303405"
  },
  {
    "email":"cinzia0176@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702629242/993ba3d798c2c9d726c7bf331382ea77-1730303405"
  },
  {
    "email":"patriziacerroni68@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702727546/e80543ab9c9c09b725a20f784f53c7d8-1730303405"
  },
  {
    "email":"magnimonia@gnail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702760314/6e5a5dec61f8b60522ebe5871656eb7c-1730303405"
  },
  {
    "email":"beniclara@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702694778/737adf933f75d507b89c244259314462-1730303406"
  },
  {
    "email":"chiarafattori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702793082/5e291db13ed0645dbfd2fe3e50b0fea3-1730303406"
  },
  {
    "email":"galassinifrancesca88@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702891386/cb469bd32b55e89a9d3761dc3fd5e026-1730303406"
  },
  {
    "email":"patriziaripani@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702662010/afb51d8fe9e8b9caa8c47bf15ed7d6e2-1730303406"
  },
  {
    "email":"vale07exbomber@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702924154/338012a8d3b2b0353637f1fe42add19d-1730303406"
  },
  {
    "email":"slvgori@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726702956922/bfe3fbcef5dbd80ba6f548f1ad09e05a-1730303406"
  },
  {
    "email":"anna66.lascala@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703022458/bb0265e2662806fc62e5f493c9d39908-1730303406"
  },
  {
    "email":"anna.ruggiero66@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702858618/c8faf80f3519385c2a9d645f2acb762d-1730303406"
  },
  {
    "email":"lucia_medici@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703055226/fd6906d3465fa292ca0bb44e32b15823-1730303407"
  },
  {
    "email":"nardi.dona@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726702989690/49d1e4d63c2069804066f65ed1564816-1730303407"
  },
  {
    "email":"giuliaversa@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703120762/2c38340c362585d67a7019ad1ad86524-1730303407"
  },
  {
    "email":"micaela.deirossi69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703153530/2c1b863461d5b99e2a08e0c99fc011e6-1730303407"
  },
  {
    "email":"lauramadd@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703186298/030b4c19404614edd40c6f748a7673c8-1730303407"
  },
  {
    "email":"silvanaboccanfuso@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703284602/bb7baa1a6e0e3055a06b0380513ff5a7-1730303407"
  },
  {
    "email":"verodega@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703251834/8f9589d158d46ad553eecb6cd853d88c-1730303407"
  },
  {
    "email":"caterossi2003@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703087994/c614ec6feff7beeaedb94c97577cdaef-1730303408"
  },
  {
    "email":"m.cri93@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703350138/68a5eb6ee2615d207052ec912c68f967-1730303408"
  },
  {
    "email":"bi.ale.delonghi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703382906/59c098abf91802822bab9a7c236964a1-1730303408"
  },
  {
    "email":"elisabettamori66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703448442/96a3749d77d956430232d87beaf5206a-1730303408"
  },
  {
    "email":"arn59@live.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703317370/7b9ad3ba3ba6d437d2a16d14a04dcbb3-1730303408"
  },
  {
    "email":"cristinacatocci@alice.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703546746/210c2c9960e08f9765f004c607388091-1730303408"
  },
  {
    "email":"letizia.david@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703415674/9ab4c5995789e691c57f696a321f3a3e-1730303408"
  },
  {
    "email":"hamiltonkeatsbs5414@yahoo.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703481210/a41f298543634dac929a2e68931083e8-1730303408"
  },
  {
    "email":"barbyvin@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703612282/371d519c8fbdbdcace98c6d80219ffd1-1730303408"
  },
  {
    "email":"bona.miraka@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703677818/d54ae22a2e4b6509c4975bded21b6a7c-1730303408"
  },
  {
    "email":"giovannagregio.arch@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703710586/bf50e345e8381cf70dfc297148dfec28-1730303409"
  },
  {
    "email":"c.begliardi@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703645050/7b5518044262ffd7943ec195758d2d27-1730303409"
  },
  {
    "email":"chiara.menichini@ormesa.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703808890/de467805378aeb2ce915518d26de7063-1730303409"
  },
  {
    "email":"basile.b@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703841658/4054ba7cd5bfbce639121a91b40199a0-1730303409"
  },
  {
    "email":"giovannaortu1950@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703743354/5c10c6bda0e3ef3da1783e23069c8e12-1730303409"
  },
  {
    "email":"clara.cartia@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726703874426/1fa05f37e587a90bff5504d7ae87499d-1730303409"
  },
  {
    "email":"geply@msn.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704038266/2623df99ccc2640f27dcef3423883bc9-1730303409"
  },
  {
    "email":"mara.francois23@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703776122/0e7a799b8f2286420a03a7efbd395ce3-1730303410"
  },
  {
    "email":"borellie39@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726703972730/f843774025f3b59cb2ea23f4b5743dea-1730303410"
  },
  {
    "email":"alessiacammisa78@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704136570/9df289130c7cc1df3b1625f5f950f4b1-1730303410"
  },
  {
    "email":"silviobergna@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704103802/5e4d9c25f47b3bd9a3f0e6b938f24c09-1730303410"
  },
  {
    "email":"www.alessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704202106/6ed6d146d2db20af0aeb830d7d0472a7-1730303410"
  },
  {
    "email":"stetosoni@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704071034/3aa70a15ac4e371bfd005b3eb17de7c9-1730303411"
  },
  {
    "email":"chrislambert1199@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704234874/770c451b73ae926eaa2425f015bd95ca-1730303411"
  },
  {
    "email":"02091961carmen@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704300410/0bbe93197dac437c46f66433283c2681-1730303411"
  },
  {
    "email":"angelica.caruso@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704169338/5934455fc7ae7636c97cacfbcdf2d50f-1730303411"
  },
  {
    "email":"emmalambert8294@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704267642/ca9a6ad38e069bf19478f843376b5570-1730303411"
  },
  {
    "email":"fabiana.lovera@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704333178/3bd9c4230c4b4df19285bb2aa188ff8b-1730303411"
  },
  {
    "email":"giusi75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704464250/c3edb5912e1d7cb1c4f6269bc1c3d33c-1730303411"
  },
  {
    "email":"monia.oldor99@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704398714/cb4b07597fbe2194ac5a3e13909780ff-1730303411"
  },
  {
    "email":"roby.za74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704431482/a3a1d4d9e94477debddd057f4835ea28-1730303411"
  },
  {
    "email":"ba.mo@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704365946/428ca6564f0f8f28148b7bc1eee5beca-1730303411"
  },
  {
    "email":"scopecealessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704628090/2d569d00bb2d5969c540d3c863d288fc-1730303411"
  },
  {
    "email":"s.meris@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704595322/f5b18ea33654bcbcf63ded28f78cd0ff-1730303411"
  },
  {
    "email":"dunia.russi@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704562554/b0963a936189b005a9c27bc2c2a54237-1730303412"
  },
  {
    "email":"p.podda74@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704497018/ef5f8c34adcf9c16755ab8de4b7e4dde-1730303412"
  },
  {
    "email":"f.gambarati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704693626/3f6f805be66b5cd8723183750758ff91-1730303412"
  },
  {
    "email":"jennyeffe@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704660858/75458c3782ec86d73cec154e2b42ab2e-1730303412"
  },
  {
    "email":"rumanova@bellatavola.sk",
    "url di attivazione":"https://verdissima.it/account/activate/22726704726394/9cdd7f490a734c4751e5ad3c17a16a60-1730303412"
  },
  {
    "email":"l.falcone@intimamoda.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704759162/fdd45ab5da830173457e529a50a70064-1730303412"
  },
  {
    "email":"lugliogiuseppe9@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704824698/4956d638c793573b8829b25893388850-1730303412"
  },
  {
    "email":"benedetta.gimigliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704857466/4c8fd56c50ab8fadf8b325b701391694-1730303412"
  },
  {
    "email":"vvrani66@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704890234/434d764c5b88319b719e9d82a3ce6ead-1730303412"
  },
  {
    "email":"nivesbiosin@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704923002/f44efc2a8e8a20adea961b029f087d36-1730303412"
  },
  {
    "email":"rosabonucchi24@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705021306/e23740f068fd2e079134ce3de77556cf-1730303412"
  },
  {
    "email":"cri.bertolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726704988538/2ad03cefc9783568cb251f3ad664c4ab-1730303412"
  },
  {
    "email":"e.costa@iscotrans.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726704955770/0816d40a5e1433bd5b09fc6124eba164-1730303412"
  },
  {
    "email":"aikass@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705054074/ed78c34861cc3cad09caad7efc2ef0b7-1730303412"
  },
  {
    "email":"oceano.si@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705152378/0da0dbd1499c767eb0212715a4ca318d-1730303413"
  },
  {
    "email":"soniamagg@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705185146/705bd8fbffaac2c8104d69ac0830925a-1730303413"
  },
  {
    "email":"agnese.urbinati@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705086842/2b30f34b41f8ce1cc3febbd63a9e7194-1730303413"
  },
  {
    "email":"clachiudi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705217914/d433876edd724d7cf44600881de29289-1730303413"
  },
  {
    "email":"sara@rigazio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705316218/30b4608d56cd407a31037be96afdb0c7-1730303413"
  },
  {
    "email":"annabriga2000@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705381754/f0d8937ef1823ce16271d5d42ce8d481-1730303413"
  },
  {
    "email":"caffimargherita86@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705414522/cf05529f9c91bb895060d98d9aedfd3a-1730303413"
  },
  {
    "email":"liapep@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705250682/3da98f31822cc2c9b66c273fbc8fd619-1730303413"
  },
  {
    "email":"paola.miari@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705447290/e7ec5aa5bec6cf388f0614c5d3963f41-1730303413"
  },
  {
    "email":"pattygiacobazzi@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705348986/6d876505ff9589443f9408424e2996e2-1730303414"
  },
  {
    "email":"mariellavigliaturo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705480058/1f0838aeea2986163e1a286770fe4399-1730303414"
  },
  {
    "email":"avv.marisa.manfredi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705512826/5f712116697471794ebcc12f977aab34-1730303414"
  },
  {
    "email":"ben.iman@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705611130/706918906fa5cfe5c52d3a221ffd31ff-1730303414"
  },
  {
    "email":"ariannas77@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705545594/0c28b573870dfb41a56fec480d14341c-1730303414"
  },
  {
    "email":"valentina.pala@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705643898/32948275e367ce610409218966344788-1730303414"
  },
  {
    "email":"adadelliveneri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705676666/b878168f5608c28d64e624f9a0769451-1730303414"
  },
  {
    "email":"obarberio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705709434/015b2be53eb862c1dda30d13cd8858c6-1730303414"
  },
  {
    "email":"bettasaetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705774970/4952cf42aceeeaea7f9e76d920a0ad84-1730303414"
  },
  {
    "email":"sara_bonomi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705873274/21cae57f6c334f3f0ce6156709634da6-1730303414"
  },
  {
    "email":"beatrice.tioli.bt@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705906042/449f6703661d7ee99e37a8c5bf127991-1730303414"
  },
  {
    "email":"rominavizzotto@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705840506/a65f07072de7d82534f396677a97926b-1730303415"
  },
  {
    "email":"greta72e@hotmail.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705807738/c8495057db92f6cc6e8ce82287cd7b24-1730303415"
  },
  {
    "email":"b12rekord@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726705938810/f3118ce1b8bdb21170e7d30cd1d7476c-1730303415"
  },
  {
    "email":"roberta.lasagni@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706004346/a25d5c2bf574995d6b3a6252d1839d78-1730303415"
  },
  {
    "email":"nadia.pogliani@cardif.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706135418/49649e7c50c3adb1bab45682797c0efc-1730303415"
  },
  {
    "email":"saminic69@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706102650/0a8c92d7483a14cecc12d079c7f94062-1730303415"
  },
  {
    "email":"digiovannimariangela@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706168186/19185196473770965b7a0692fabfc5ff-1730303415"
  },
  {
    "email":"andrea.scuba@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706200954/5c1bc07401826b2e50630e8f2dd09a7c-1730303415"
  },
  {
    "email":"happyforever2018@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706233722/a4b27696421573e823648fcbcda1f601-1730303415"
  },
  {
    "email":"seri.alessandra@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706332026/4082fa2edb51adf207d416e8682bf871-1730303416"
  },
  {
    "email":"elfadiluce@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706299258/ae9738e4b65cf11121401649c0789506-1730303416"
  },
  {
    "email":"zorianakril@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726705971578/e4d84f5c5032defc66f96a0fa00ab0e3-1730303416"
  },
  {
    "email":"andreamecucci@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706266490/6e37961e0d762181c9eb79b8f1e82047-1730303416"
  },
  {
    "email":"silvias2005@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706397562/b4c79c56756487f1c699aedca6ffa61b-1730303416"
  },
  {
    "email":"vera_19@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706364794/d5d31389a91966d1eeda8c14eef5380c-1730303416"
  },
  {
    "email":"rquintigliano@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706430330/d085608e69cb04837da873ef1370fc1a-1730303416"
  },
  {
    "email":"raffaellafagiani@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706463098/7d8bd5e97ca683d76557b177a70afc3e-1730303416"
  },
  {
    "email":"apollonio763@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706528634/916ed12d31fa23f573715caae1dbd08d-1730303416"
  },
  {
    "email":"valerio.romolini@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706594170/0588bc01d6a733e7a7ae742bf8b5ee86-1730303416"
  },
  {
    "email":"raffaellasantoro29@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706626938/42dff371593228066fba2dfce7121b77-1730303416"
  },
  {
    "email":"mariagiacominan@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706725242/9826ef411158e5b7da92759cd98a7604-1730303417"
  },
  {
    "email":"annuelapaolillo@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706561402/50a76565b62ebc0e2f7a3fb80c821032-1730303417"
  },
  {
    "email":"lunadei.alessia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706692474/c75b7dfdd7f83c84b401c5ae8462bce5-1730303417"
  },
  {
    "email":"vincenzo.filice@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706790778/f55a5e24db2dc62ba8aa252168c6567c-1730303417"
  },
  {
    "email":"caterinapalmeri@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706758010/f0fdf3fe8d874bbbf7d16a7c510e531b-1730303417"
  },
  {
    "email":"valentina@hillbrand.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706823546/7c751432e7231c3eba36eb839e2c90f4-1730303417"
  },
  {
    "email":"mimi_1997@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726706659706/cde0dff2a09bf6adebf4ee224fbede4e-1730303417"
  },
  {
    "email":"f_brindisi@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706856314/d23b47c43e8e05187076067cb4890653-1730303417"
  },
  {
    "email":"dna.nutrizione@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706987386/1314cf8006d6b90ca51a3ceb30925eba-1730303417"
  },
  {
    "email":"parisefrancesca75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707020154/2ab55ed73eb33d64453cca3ad2b567a8-1730303418"
  },
  {
    "email":"ciccio147@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726706889082/4c8bd50bbc97af5538a205e44fa6aa7e-1730303418"
  },
  {
    "email":"fedeadgio@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707052922/d05ba216be33ff62e2421035cbbc266e-1730303418"
  },
  {
    "email":"laura-ruzza@virgilio.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707085690/3f5b3be81085dda9ac259bdcf112c3f4-1730303418"
  },
  {
    "email":"tizianarizzo1981@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707118458/40f719907b753e45501baaabbb848bad-1730303418"
  },
  {
    "email":"annalisa_menghini@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707183994/4c3198e6fb0abdc3729e4567fc9e8b00-1730303418"
  },
  {
    "email":"dexter.nocciolina@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707216762/e9771852a1774efe86f5629a58678c39-1730303418"
  },
  {
    "email":"16benedetta@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707282298/6708be57a5b1c532b98601eecf7b4ce8-1730303418"
  },
  {
    "email":"sama.b@me.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707249530/1e07e2fd1ff12de2ffa66bb2ffa61945-1730303418"
  },
  {
    "email":"rosanna.iscaro@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707315066/a31bafce4eb9fc08fc11989ae497cf24-1730303418"
  },
  {
    "email":"barbarabini51@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707380602/6cee846019816b118e86bfae7a157407-1730303419"
  },
  {
    "email":"lucaeroli@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707413370/892d13d7c2a56038579521c1d838c053-1730303419"
  },
  {
    "email":"jessicabarcellona1965@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707151226/10cea4ced9100a60210b8c13a9608cee-1730303419"
  },
  {
    "email":"ferragosto30@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707446138/4061312d1f72816d711dfb9d04c45711-1730303419"
  },
  {
    "email":"alesaulle1@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707609978/d3de1221095f00f2853f284de5251339-1730303419"
  },
  {
    "email":"giggia75@hotmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707544442/536fba127b3e5b2fbabf9350a5f0f3b7-1730303419"
  },
  {
    "email":"lilianagenna@libero.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707642746/b9679e1cf4e72011d91f11e91f777e0c-1730303419"
  },
  {
    "email":"daniela.barucco@blu.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726707675514/8e0762638f19effbf220ffda29ab92ec-1730303419"
  },
  {
    "email":"tamaramarini@ymail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707708282/a301172f6aaa73d693141a320a94df9c-1730303419"
  },
  {
    "email":"giovanna.scimia@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707773818/66a1f4f6ae6582c9ef3f49f2f2ae5ddd-1730303419"
  },
  {
    "email":"avvbarbaramascarino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707741050/5844dfda732f2ec64d3a14b1413640eb-1730303419"
  },
  {
    "email":"dsemeraro7@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707806586/dbb267fd7e5f21a483535c69e62878cd-1730303419"
  },
  {
    "email":"annareg75@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726707937658/9a7b1b984c200b8a45e585f24469addb-1730303420"
  },
  {
    "email":"anna.richiedei@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726708068730/99b2b2739e6f71274cb5c723ae5f3614-1730303420"
  },
  {
    "email":"susibordi@icloud.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726708003194/ca4d9effe0ca22015c077f1b26f1d911-1730303420"
  },
  {
    "email":"annagarbesi@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726708101498/a13aa641e42258a7b52d44aba22d888a-1730303420"
  },
  {
    "email":"patriziapoddighe@yahoo.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726708134266/a7996ee6d9705883cafea5741b2a26be-1730303420"
  },
  {
    "email":"barbara.mascolino@gmail.com",
    "url di attivazione":"https://verdissima.it/account/activate/22726708199802/880485e731e5bf71b753deae225b4847-1730303420"
  },
  {
    "email":"anna.silvestri@sermetra.it",
    "url di attivazione":"https://verdissima.it/account/activate/22726708232570/4ff307ce94810ddfe03d305d4148b5bf-1730303420"
  }
];